(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("JHSDK", [], factory);
	else if(typeof exports === 'object')
		exports["JHSDK"] = factory();
	else
		root["JHSDK"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 237);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AesCbcProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AesCmacProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AesCtrProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AesEcbProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AesGcmProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AesKwProvider; });
/* unused harmony export AesProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AlgorithmError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Crypto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CryptoError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CryptoKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DesProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EcCurves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EcUtils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EcdhEsProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return EcdhProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return EcdsaProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return Ed25519Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return EdDsaProvider; });
/* unused harmony export EllipticProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return HkdfProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return HmacProvider; });
/* unused harmony export JwkUtils */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return OperationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return Pbkdf2Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PemConverter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ProviderCrypto; });
/* unused harmony export ProviderStorage */
/* unused harmony export RequiredPropertyError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return RsaOaepProvider; });
/* unused harmony export RsaProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return RsaPssProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return RsaSsaProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return Shake128Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return Shake256Provider; });
/* unused harmony export ShakeProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SubtleCrypto; });
/* unused harmony export UnsupportedOperationError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return X25519Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return index$1; });
/* unused harmony export isJWK */
/* unused harmony export json */
/* harmony import */ var pvtsutils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var pvtsutils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pvtsutils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "h", function() { return pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"]; });

/* harmony import */ var _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
/* harmony import */ var _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
/* harmony import */ var asn1js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
/*!
 Copyright (c) Peculiar Ventures, LLC
*/








class CryptoError extends Error {
}

class AlgorithmError extends CryptoError {
}

class UnsupportedOperationError extends CryptoError {
    constructor(methodName) {
        super(`Unsupported operation: ${methodName ? `${methodName}` : ""}`);
    }
}

class OperationError extends CryptoError {
}

class RequiredPropertyError extends CryptoError {
    constructor(propName) {
        super(`${propName}: Missing required property`);
    }
}

class PemConverter {
    static toArrayBuffer(pem) {
        const base64 = pem
            .replace(/-{5}(BEGIN|END) .*-{5}/g, "")
            .replace("\r", "")
            .replace("\n", "");
        return pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].FromBase64(base64);
    }
    static toUint8Array(pem) {
        const bytes = this.toArrayBuffer(pem);
        return new Uint8Array(bytes);
    }
    static fromBufferSource(buffer, tag) {
        const base64 = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].ToBase64(buffer);
        let sliced;
        let offset = 0;
        const rows = [];
        while (offset < base64.length) {
            sliced = base64.slice(offset, offset + 64);
            if (sliced.length) {
                rows.push(sliced);
            }
            else {
                break;
            }
            offset += 64;
        }
        const upperCaseTag = tag.toUpperCase();
        return `-----BEGIN ${upperCaseTag}-----\n${rows.join("\n")}\n-----END ${upperCaseTag}-----`;
    }
    static isPEM(data) {
        return /-----BEGIN .+-----[A-Za-z0-9+/+=\s\n]+-----END .+-----/i.test(data);
    }
    static getTagName(pem) {
        if (!this.isPEM(pem)) {
            throw new Error("Bad parameter. Incoming data is not right PEM");
        }
        const res = /-----BEGIN (.+)-----/.exec(pem);
        if (!res) {
            throw new Error("Cannot get tag from PEM");
        }
        return res[1];
    }
    static hasTagName(pem, tagName) {
        const tag = this.getTagName(pem);
        return tagName.toLowerCase() === tag.toLowerCase();
    }
    static isCertificate(pem) {
        return this.hasTagName(pem, "certificate");
    }
    static isCertificateRequest(pem) {
        return this.hasTagName(pem, "certificate request");
    }
    static isCRL(pem) {
        return this.hasTagName(pem, "x509 crl");
    }
    static isPublicKey(pem) {
        return this.hasTagName(pem, "public key");
    }
}

function isJWK(data) {
    return typeof data === "object" && "kty" in data;
}

class ProviderCrypto {
    async digest(...args) {
        this.checkDigest.apply(this, args);
        return this.onDigest.apply(this, args);
    }
    checkDigest(algorithm, _data) {
        this.checkAlgorithmName(algorithm);
    }
    async onDigest(_algorithm, _data) {
        throw new UnsupportedOperationError("digest");
    }
    async generateKey(...args) {
        this.checkGenerateKey.apply(this, args);
        return this.onGenerateKey.apply(this, args);
    }
    checkGenerateKey(algorithm, _extractable, keyUsages, ..._args) {
        this.checkAlgorithmName(algorithm);
        this.checkGenerateKeyParams(algorithm);
        if (!(keyUsages && keyUsages.length)) {
            throw new TypeError(`Usages cannot be empty when creating a key.`);
        }
        let allowedUsages;
        if (Array.isArray(this.usages)) {
            allowedUsages = this.usages;
        }
        else {
            allowedUsages = this.usages.privateKey.concat(this.usages.publicKey);
        }
        this.checkKeyUsages(keyUsages, allowedUsages);
    }
    checkGenerateKeyParams(_algorithm) {
    }
    async onGenerateKey(_algorithm, _extractable, _keyUsages, ..._args) {
        throw new UnsupportedOperationError("generateKey");
    }
    async sign(...args) {
        this.checkSign.apply(this, args);
        return this.onSign.apply(this, args);
    }
    checkSign(algorithm, key, _data, ..._args) {
        this.checkAlgorithmName(algorithm);
        this.checkAlgorithmParams(algorithm);
        this.checkCryptoKey(key, "sign");
    }
    async onSign(_algorithm, _key, _data, ..._args) {
        throw new UnsupportedOperationError("sign");
    }
    async verify(...args) {
        this.checkVerify.apply(this, args);
        return this.onVerify.apply(this, args);
    }
    checkVerify(algorithm, key, _signature, _data, ..._args) {
        this.checkAlgorithmName(algorithm);
        this.checkAlgorithmParams(algorithm);
        this.checkCryptoKey(key, "verify");
    }
    async onVerify(_algorithm, _key, _signature, _data, ..._args) {
        throw new UnsupportedOperationError("verify");
    }
    async encrypt(...args) {
        this.checkEncrypt.apply(this, args);
        return this.onEncrypt.apply(this, args);
    }
    checkEncrypt(algorithm, key, _data, options = {}, ..._args) {
        this.checkAlgorithmName(algorithm);
        this.checkAlgorithmParams(algorithm);
        this.checkCryptoKey(key, options.keyUsage ? "encrypt" : void 0);
    }
    async onEncrypt(_algorithm, _key, _data, ..._args) {
        throw new UnsupportedOperationError("encrypt");
    }
    async decrypt(...args) {
        this.checkDecrypt.apply(this, args);
        return this.onDecrypt.apply(this, args);
    }
    checkDecrypt(algorithm, key, _data, options = {}, ..._args) {
        this.checkAlgorithmName(algorithm);
        this.checkAlgorithmParams(algorithm);
        this.checkCryptoKey(key, options.keyUsage ? "decrypt" : void 0);
    }
    async onDecrypt(_algorithm, _key, _data, ..._args) {
        throw new UnsupportedOperationError("decrypt");
    }
    async deriveBits(...args) {
        this.checkDeriveBits.apply(this, args);
        return this.onDeriveBits.apply(this, args);
    }
    checkDeriveBits(algorithm, baseKey, length, options = {}, ..._args) {
        this.checkAlgorithmName(algorithm);
        this.checkAlgorithmParams(algorithm);
        this.checkCryptoKey(baseKey, options.keyUsage ? "deriveBits" : void 0);
        if (length % 8 !== 0) {
            throw new OperationError("length: Is not multiple of 8");
        }
    }
    async onDeriveBits(_algorithm, _baseKey, _length, ..._args) {
        throw new UnsupportedOperationError("deriveBits");
    }
    async exportKey(...args) {
        this.checkExportKey.apply(this, args);
        return this.onExportKey.apply(this, args);
    }
    checkExportKey(format, key, ..._args) {
        this.checkKeyFormat(format);
        this.checkCryptoKey(key);
        if (!key.extractable) {
            throw new CryptoError("key: Is not extractable");
        }
    }
    async onExportKey(_format, _key, ..._args) {
        throw new UnsupportedOperationError("exportKey");
    }
    async importKey(...args) {
        this.checkImportKey.apply(this, args);
        return this.onImportKey.apply(this, args);
    }
    checkImportKey(format, keyData, algorithm, _extractable, keyUsages, ..._args) {
        this.checkKeyFormat(format);
        this.checkKeyData(format, keyData);
        this.checkAlgorithmName(algorithm);
        this.checkImportParams(algorithm);
        if (Array.isArray(this.usages)) {
            this.checkKeyUsages(keyUsages, this.usages);
        }
    }
    async onImportKey(_format, _keyData, _algorithm, _extractable, _keyUsages, ..._args) {
        throw new UnsupportedOperationError("importKey");
    }
    checkAlgorithmName(algorithm) {
        if (algorithm.name.toLowerCase() !== this.name.toLowerCase()) {
            throw new AlgorithmError("Unrecognized name");
        }
    }
    checkAlgorithmParams(_algorithm) {
    }
    checkDerivedKeyParams(_algorithm) {
    }
    checkKeyUsages(usages, allowed) {
        for (const usage of usages) {
            if (allowed.indexOf(usage) === -1) {
                throw new TypeError("Cannot create a key using the specified key usages");
            }
        }
    }
    checkCryptoKey(key, keyUsage) {
        this.checkAlgorithmName(key.algorithm);
        if (keyUsage && key.usages.indexOf(keyUsage) === -1) {
            throw new CryptoError(`key does not match that of operation`);
        }
    }
    checkRequiredProperty(data, propName) {
        if (!(propName in data)) {
            throw new RequiredPropertyError(propName);
        }
    }
    checkHashAlgorithm(algorithm, hashAlgorithms) {
        for (const item of hashAlgorithms) {
            if (item.toLowerCase() === algorithm.name.toLowerCase()) {
                return;
            }
        }
        throw new OperationError(`hash: Must be one of ${hashAlgorithms.join(", ")}`);
    }
    checkImportParams(_algorithm) {
    }
    checkKeyFormat(format) {
        switch (format) {
            case "raw":
            case "pkcs8":
            case "spki":
            case "jwk":
                break;
            default:
                throw new TypeError("format: Is invalid value. Must be 'jwk', 'raw', 'spki', or 'pkcs8'");
        }
    }
    checkKeyData(format, keyData) {
        if (!keyData) {
            throw new TypeError("keyData: Cannot be empty on empty on key importing");
        }
        if (format === "jwk") {
            if (!isJWK(keyData)) {
                throw new TypeError("keyData: Is not JsonWebToken");
            }
        }
        else if (!pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].isBufferSource(keyData)) {
            throw new TypeError("keyData: Is not ArrayBufferView or ArrayBuffer");
        }
    }
    prepareData(data) {
        return pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toArrayBuffer(data);
    }
}

class AesProvider extends ProviderCrypto {
    checkGenerateKeyParams(algorithm) {
        this.checkRequiredProperty(algorithm, "length");
        if (typeof algorithm.length !== "number") {
            throw new TypeError("length: Is not of type Number");
        }
        switch (algorithm.length) {
            case 128:
            case 192:
            case 256:
                break;
            default:
                throw new TypeError("length: Must be 128, 192, or 256");
        }
    }
    checkDerivedKeyParams(algorithm) {
        this.checkGenerateKeyParams(algorithm);
    }
}

class AesCbcProvider extends AesProvider {
    constructor() {
        super(...arguments);
        this.name = "AES-CBC";
        this.usages = ["encrypt", "decrypt", "wrapKey", "unwrapKey"];
    }
    checkAlgorithmParams(algorithm) {
        this.checkRequiredProperty(algorithm, "iv");
        if (!(algorithm.iv instanceof ArrayBuffer || ArrayBuffer.isView(algorithm.iv))) {
            throw new TypeError("iv: Is not of type '(ArrayBuffer or ArrayBufferView)'");
        }
        if (algorithm.iv.byteLength !== 16) {
            throw new TypeError("iv: Must have length 16 bytes");
        }
    }
}

class AesCmacProvider extends AesProvider {
    constructor() {
        super(...arguments);
        this.name = "AES-CMAC";
        this.usages = ["sign", "verify"];
    }
    checkAlgorithmParams(algorithm) {
        this.checkRequiredProperty(algorithm, "length");
        if (typeof algorithm.length !== "number") {
            throw new TypeError("length: Is not a Number");
        }
        if (algorithm.length < 1) {
            throw new OperationError("length: Must be more than 0");
        }
    }
}

class AesCtrProvider extends AesProvider {
    constructor() {
        super(...arguments);
        this.name = "AES-CTR";
        this.usages = ["encrypt", "decrypt", "wrapKey", "unwrapKey"];
    }
    checkAlgorithmParams(algorithm) {
        this.checkRequiredProperty(algorithm, "counter");
        if (!(algorithm.counter instanceof ArrayBuffer || ArrayBuffer.isView(algorithm.counter))) {
            throw new TypeError("counter: Is not of type '(ArrayBuffer or ArrayBufferView)'");
        }
        if (algorithm.counter.byteLength !== 16) {
            throw new TypeError("iv: Must have length 16 bytes");
        }
        this.checkRequiredProperty(algorithm, "length");
        if (typeof algorithm.length !== "number") {
            throw new TypeError("length: Is not a Number");
        }
        if (algorithm.length < 1) {
            throw new OperationError("length: Must be more than 0");
        }
    }
}

class AesEcbProvider extends AesProvider {
    constructor() {
        super(...arguments);
        this.name = "AES-ECB";
        this.usages = ["encrypt", "decrypt", "wrapKey", "unwrapKey"];
    }
}

class AesGcmProvider extends AesProvider {
    constructor() {
        super(...arguments);
        this.name = "AES-GCM";
        this.usages = ["encrypt", "decrypt", "wrapKey", "unwrapKey"];
    }
    checkAlgorithmParams(algorithm) {
        var _a;
        this.checkRequiredProperty(algorithm, "iv");
        if (!(algorithm.iv instanceof ArrayBuffer || ArrayBuffer.isView(algorithm.iv))) {
            throw new TypeError("iv: Is not of type '(ArrayBuffer or ArrayBufferView)'");
        }
        if (algorithm.iv.byteLength < 1) {
            throw new OperationError("iv: Must have length more than 0 and less than 2^64 - 1");
        }
        (_a = algorithm.tagLength) !== null && _a !== void 0 ? _a : (algorithm.tagLength = 128);
        switch (algorithm.tagLength) {
            case 32:
            case 64:
            case 96:
            case 104:
            case 112:
            case 120:
            case 128:
                break;
            default:
                throw new OperationError("tagLength: Must be one of 32, 64, 96, 104, 112, 120 or 128");
        }
    }
}

class AesKwProvider extends AesProvider {
    constructor() {
        super(...arguments);
        this.name = "AES-KW";
        this.usages = ["wrapKey", "unwrapKey"];
    }
}

class DesProvider extends ProviderCrypto {
    constructor() {
        super(...arguments);
        this.usages = ["encrypt", "decrypt", "wrapKey", "unwrapKey"];
    }
    checkAlgorithmParams(algorithm) {
        if (this.ivSize) {
            this.checkRequiredProperty(algorithm, "iv");
            if (!(algorithm.iv instanceof ArrayBuffer || ArrayBuffer.isView(algorithm.iv))) {
                throw new TypeError("iv: Is not of type '(ArrayBuffer or ArrayBufferView)'");
            }
            if (algorithm.iv.byteLength !== this.ivSize) {
                throw new TypeError(`iv: Must have length ${this.ivSize} bytes`);
            }
        }
    }
    checkGenerateKeyParams(algorithm) {
        this.checkRequiredProperty(algorithm, "length");
        if (typeof algorithm.length !== "number") {
            throw new TypeError("length: Is not of type Number");
        }
        if (algorithm.length !== this.keySizeBits) {
            throw new OperationError(`algorithm.length: Must be ${this.keySizeBits}`);
        }
    }
    checkDerivedKeyParams(algorithm) {
        this.checkGenerateKeyParams(algorithm);
    }
}

class RsaProvider extends ProviderCrypto {
    constructor() {
        super(...arguments);
        this.hashAlgorithms = ["SHA-1", "SHA-256", "SHA-384", "SHA-512"];
    }
    checkGenerateKeyParams(algorithm) {
        this.checkRequiredProperty(algorithm, "hash");
        this.checkHashAlgorithm(algorithm.hash, this.hashAlgorithms);
        this.checkRequiredProperty(algorithm, "publicExponent");
        if (!(algorithm.publicExponent && algorithm.publicExponent instanceof Uint8Array)) {
            throw new TypeError("publicExponent: Missing or not a Uint8Array");
        }
        const publicExponent = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].ToBase64(algorithm.publicExponent);
        if (!(publicExponent === "Aw==" || publicExponent === "AQAB")) {
            throw new TypeError("publicExponent: Must be [3] or [1,0,1]");
        }
        this.checkRequiredProperty(algorithm, "modulusLength");
        if (algorithm.modulusLength % 8
            || algorithm.modulusLength < 256
            || algorithm.modulusLength > 16384) {
            throw new TypeError("The modulus length must be a multiple of 8 bits and >= 256 and <= 16384");
        }
    }
    checkImportParams(algorithm) {
        this.checkRequiredProperty(algorithm, "hash");
        this.checkHashAlgorithm(algorithm.hash, this.hashAlgorithms);
    }
}

class RsaSsaProvider extends RsaProvider {
    constructor() {
        super(...arguments);
        this.name = "RSASSA-PKCS1-v1_5";
        this.usages = {
            privateKey: ["sign"],
            publicKey: ["verify"],
        };
    }
}

class RsaPssProvider extends RsaProvider {
    constructor() {
        super(...arguments);
        this.name = "RSA-PSS";
        this.usages = {
            privateKey: ["sign"],
            publicKey: ["verify"],
        };
    }
    checkAlgorithmParams(algorithm) {
        this.checkRequiredProperty(algorithm, "saltLength");
        if (typeof algorithm.saltLength !== "number") {
            throw new TypeError("saltLength: Is not a Number");
        }
        if (algorithm.saltLength < 0) {
            throw new RangeError("saltLength: Must be positive number");
        }
    }
}

class RsaOaepProvider extends RsaProvider {
    constructor() {
        super(...arguments);
        this.name = "RSA-OAEP";
        this.usages = {
            privateKey: ["decrypt", "unwrapKey"],
            publicKey: ["encrypt", "wrapKey"],
        };
    }
    checkAlgorithmParams(algorithm) {
        if (algorithm.label
            && !(algorithm.label instanceof ArrayBuffer || ArrayBuffer.isView(algorithm.label))) {
            throw new TypeError("label: Is not of type '(ArrayBuffer or ArrayBufferView)'");
        }
    }
}

class EllipticProvider extends ProviderCrypto {
    checkGenerateKeyParams(algorithm) {
        this.checkRequiredProperty(algorithm, "namedCurve");
        this.checkNamedCurve(algorithm.namedCurve);
    }
    checkNamedCurve(namedCurve) {
        for (const item of this.namedCurves) {
            if (item.toLowerCase() === namedCurve.toLowerCase()) {
                return;
            }
        }
        throw new OperationError(`namedCurve: Must be one of ${this.namedCurves.join(", ")}`);
    }
}

class EcdsaProvider extends EllipticProvider {
    constructor() {
        super(...arguments);
        this.name = "ECDSA";
        this.hashAlgorithms = ["SHA-1", "SHA-256", "SHA-384", "SHA-512"];
        this.usages = {
            privateKey: ["sign"],
            publicKey: ["verify"],
        };
        this.namedCurves = ["P-256", "P-384", "P-521", "K-256"];
    }
    checkAlgorithmParams(algorithm) {
        this.checkRequiredProperty(algorithm, "hash");
        this.checkHashAlgorithm(algorithm.hash, this.hashAlgorithms);
    }
}

const KEY_TYPES = ["secret", "private", "public"];
class CryptoKey {
    static create(algorithm, type, extractable, usages) {
        const key = new this();
        key.algorithm = algorithm;
        key.type = type;
        key.extractable = extractable;
        key.usages = usages;
        return key;
    }
    static isKeyType(data) {
        return KEY_TYPES.indexOf(data) !== -1;
    }
    get [Symbol.toStringTag]() {
        return "CryptoKey";
    }
}

class EcdhProvider extends EllipticProvider {
    constructor() {
        super(...arguments);
        this.name = "ECDH";
        this.usages = {
            privateKey: ["deriveBits", "deriveKey"],
            publicKey: [],
        };
        this.namedCurves = ["P-256", "P-384", "P-521", "K-256"];
    }
    checkAlgorithmParams(algorithm) {
        this.checkRequiredProperty(algorithm, "public");
        if (!(algorithm.public instanceof CryptoKey)) {
            throw new TypeError("public: Is not a CryptoKey");
        }
        if (algorithm.public.type !== "public") {
            throw new OperationError("public: Is not a public key");
        }
        if (algorithm.public.algorithm.name !== this.name) {
            throw new OperationError(`public: Is not ${this.name} key`);
        }
    }
}

class EcdhEsProvider extends EcdhProvider {
    constructor() {
        super(...arguments);
        this.name = "ECDH-ES";
        this.namedCurves = ["X25519", "X448"];
    }
}

class EdDsaProvider extends EllipticProvider {
    constructor() {
        super(...arguments);
        this.name = "EdDSA";
        this.usages = {
            privateKey: ["sign"],
            publicKey: ["verify"],
        };
        this.namedCurves = ["Ed25519", "Ed448"];
    }
}

let ObjectIdentifier = class ObjectIdentifier {
    constructor(value) {
        if (value) {
            this.value = value;
        }
    }
};
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].ObjectIdentifier })
], ObjectIdentifier.prototype, "value", void 0);
ObjectIdentifier = Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnType */ "g"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnTypeTypes */ "h"].Choice })
], ObjectIdentifier);

class AlgorithmIdentifier {
    constructor(params) {
        Object.assign(this, params);
    }
}
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({
        type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].ObjectIdentifier,
    })
], AlgorithmIdentifier.prototype, "algorithm", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({
        type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Any,
        optional: true,
    })
], AlgorithmIdentifier.prototype, "parameters", void 0);

class PrivateKeyInfo {
    constructor() {
        this.version = 0;
        this.privateKeyAlgorithm = new AlgorithmIdentifier();
        this.privateKey = new ArrayBuffer(0);
    }
}
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer })
], PrivateKeyInfo.prototype, "version", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: AlgorithmIdentifier })
], PrivateKeyInfo.prototype, "privateKeyAlgorithm", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].OctetString })
], PrivateKeyInfo.prototype, "privateKey", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Any, optional: true })
], PrivateKeyInfo.prototype, "attributes", void 0);

class PublicKeyInfo {
    constructor() {
        this.publicKeyAlgorithm = new AlgorithmIdentifier();
        this.publicKey = new ArrayBuffer(0);
    }
}
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: AlgorithmIdentifier })
], PublicKeyInfo.prototype, "publicKeyAlgorithm", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].BitString })
], PublicKeyInfo.prototype, "publicKey", void 0);

const JsonBase64UrlArrayBufferConverter = {
    fromJSON: (value) => pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].FromBase64Url(value),
    toJSON: (value) => pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].ToBase64Url(new Uint8Array(value)),
};

const AsnIntegerArrayBufferConverter = {
    fromASN: (value) => {
        const valueHex = value.valueBlock.valueHex;
        return !(new Uint8Array(valueHex)[0])
            ? value.valueBlock.valueHex.slice(1)
            : value.valueBlock.valueHex;
    },
    toASN: (value) => {
        const valueHex = new Uint8Array(value)[0] > 127
            ? Object(pvtsutils__WEBPACK_IMPORTED_MODULE_0__["combine"])(new Uint8Array([0]).buffer, value)
            : value;
        return new asn1js__WEBPACK_IMPORTED_MODULE_4__["Integer"]({ valueHex });
    },
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AsnIntegerArrayBufferConverter: AsnIntegerArrayBufferConverter,
  JsonBase64UrlArrayBufferConverter: JsonBase64UrlArrayBufferConverter
});

class RsaPrivateKey {
    constructor() {
        this.version = 0;
        this.modulus = new ArrayBuffer(0);
        this.publicExponent = new ArrayBuffer(0);
        this.privateExponent = new ArrayBuffer(0);
        this.prime1 = new ArrayBuffer(0);
        this.prime2 = new ArrayBuffer(0);
        this.exponent1 = new ArrayBuffer(0);
        this.exponent2 = new ArrayBuffer(0);
        this.coefficient = new ArrayBuffer(0);
    }
}
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnIntegerConverter */ "b"] })
], RsaPrivateKey.prototype, "version", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: AsnIntegerArrayBufferConverter }),
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__[/* JsonProp */ "b"])({ name: "n", converter: JsonBase64UrlArrayBufferConverter })
], RsaPrivateKey.prototype, "modulus", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: AsnIntegerArrayBufferConverter }),
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__[/* JsonProp */ "b"])({ name: "e", converter: JsonBase64UrlArrayBufferConverter })
], RsaPrivateKey.prototype, "publicExponent", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: AsnIntegerArrayBufferConverter }),
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__[/* JsonProp */ "b"])({ name: "d", converter: JsonBase64UrlArrayBufferConverter })
], RsaPrivateKey.prototype, "privateExponent", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: AsnIntegerArrayBufferConverter }),
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__[/* JsonProp */ "b"])({ name: "p", converter: JsonBase64UrlArrayBufferConverter })
], RsaPrivateKey.prototype, "prime1", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: AsnIntegerArrayBufferConverter }),
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__[/* JsonProp */ "b"])({ name: "q", converter: JsonBase64UrlArrayBufferConverter })
], RsaPrivateKey.prototype, "prime2", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: AsnIntegerArrayBufferConverter }),
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__[/* JsonProp */ "b"])({ name: "dp", converter: JsonBase64UrlArrayBufferConverter })
], RsaPrivateKey.prototype, "exponent1", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: AsnIntegerArrayBufferConverter }),
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__[/* JsonProp */ "b"])({ name: "dq", converter: JsonBase64UrlArrayBufferConverter })
], RsaPrivateKey.prototype, "exponent2", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: AsnIntegerArrayBufferConverter }),
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__[/* JsonProp */ "b"])({ name: "qi", converter: JsonBase64UrlArrayBufferConverter })
], RsaPrivateKey.prototype, "coefficient", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Any, optional: true })
], RsaPrivateKey.prototype, "otherPrimeInfos", void 0);

class RsaPublicKey {
    constructor() {
        this.modulus = new ArrayBuffer(0);
        this.publicExponent = new ArrayBuffer(0);
    }
}
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: AsnIntegerArrayBufferConverter }),
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__[/* JsonProp */ "b"])({ name: "n", converter: JsonBase64UrlArrayBufferConverter })
], RsaPublicKey.prototype, "modulus", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: AsnIntegerArrayBufferConverter }),
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__[/* JsonProp */ "b"])({ name: "e", converter: JsonBase64UrlArrayBufferConverter })
], RsaPublicKey.prototype, "publicExponent", void 0);

let EcPublicKey = class EcPublicKey {
    constructor(value) {
        this.value = new ArrayBuffer(0);
        if (value) {
            this.value = value;
        }
    }
    toJSON() {
        let bytes = new Uint8Array(this.value);
        if (bytes[0] !== 0x04) {
            throw new CryptoError("Wrong ECPoint. Current version supports only Uncompressed (0x04) point");
        }
        bytes = new Uint8Array(this.value.slice(1));
        const size = bytes.length / 2;
        const offset = 0;
        const json = {
            x: pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].ToBase64Url(bytes.buffer.slice(offset, offset + size)),
            y: pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].ToBase64Url(bytes.buffer.slice(offset + size, offset + size + size)),
        };
        return json;
    }
    fromJSON(json) {
        if (!("x" in json)) {
            throw new Error("x: Missing required property");
        }
        if (!("y" in json)) {
            throw new Error("y: Missing required property");
        }
        const x = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].FromBase64Url(json.x);
        const y = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].FromBase64Url(json.y);
        const value = Object(pvtsutils__WEBPACK_IMPORTED_MODULE_0__["combine"])(new Uint8Array([0x04]).buffer, x, y);
        this.value = new Uint8Array(value).buffer;
        return this;
    }
};
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].OctetString })
], EcPublicKey.prototype, "value", void 0);
EcPublicKey = Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnType */ "g"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnTypeTypes */ "h"].Choice })
], EcPublicKey);

class EcPrivateKey {
    constructor() {
        this.version = 1;
        this.privateKey = new ArrayBuffer(0);
    }
    fromJSON(json) {
        if (!("d" in json)) {
            throw new Error("d: Missing required property");
        }
        this.privateKey = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].FromBase64Url(json.d);
        if ("x" in json) {
            const publicKey = new EcPublicKey();
            publicKey.fromJSON(json);
            const asn = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnSerializer */ "f"].toASN(publicKey);
            if ("valueHex" in asn.valueBlock) {
                this.publicKey = asn.valueBlock.valueHex;
            }
        }
        return this;
    }
    toJSON() {
        const jwk = {};
        jwk.d = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].ToBase64Url(this.privateKey);
        if (this.publicKey) {
            Object.assign(jwk, new EcPublicKey(this.publicKey).toJSON());
        }
        return jwk;
    }
}
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnIntegerConverter */ "b"] })
], EcPrivateKey.prototype, "version", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].OctetString })
], EcPrivateKey.prototype, "privateKey", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ context: 0, type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Any, optional: true })
], EcPrivateKey.prototype, "parameters", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ context: 1, type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].BitString, optional: true })
], EcPrivateKey.prototype, "publicKey", void 0);

const AsnIntegerWithoutPaddingConverter = {
    fromASN: (value) => {
        const bytes = new Uint8Array(value.valueBlock.valueHex);
        return (bytes[0] === 0)
            ? bytes.buffer.slice(1)
            : bytes.buffer;
    },
    toASN: (value) => {
        const bytes = new Uint8Array(value);
        if (bytes[0] > 127) {
            const newValue = new Uint8Array(bytes.length + 1);
            newValue.set(bytes, 1);
            return new asn1js__WEBPACK_IMPORTED_MODULE_4__["Integer"]({ valueHex: newValue.buffer });
        }
        return new asn1js__WEBPACK_IMPORTED_MODULE_4__["Integer"]({ valueHex: value });
    },
};

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AsnIntegerWithoutPaddingConverter: AsnIntegerWithoutPaddingConverter
});

class EcUtils {
    static decodePoint(data, pointSize) {
        const view = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toUint8Array(data);
        if ((view.length === 0) || (view[0] !== 4)) {
            throw new Error("Only uncompressed point format supported");
        }
        const n = (view.length - 1) / 2;
        if (n !== (Math.ceil(pointSize / 8))) {
            throw new Error("Point does not match field size");
        }
        const xb = view.slice(1, n + 1);
        const yb = view.slice(n + 1, n + 1 + n);
        return { x: xb, y: yb };
    }
    static encodePoint(point, pointSize) {
        const size = Math.ceil(pointSize / 8);
        if (point.x.byteLength !== size || point.y.byteLength !== size) {
            throw new Error("X,Y coordinates don't match point size criteria");
        }
        const x = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toUint8Array(point.x);
        const y = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toUint8Array(point.y);
        const res = new Uint8Array(size * 2 + 1);
        res[0] = 4;
        res.set(x, 1);
        res.set(y, size + 1);
        return res;
    }
    static getSize(pointSize) {
        return Math.ceil(pointSize / 8);
    }
    static encodeSignature(signature, pointSize) {
        const size = this.getSize(pointSize);
        const r = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toUint8Array(signature.r);
        const s = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toUint8Array(signature.s);
        const res = new Uint8Array(size * 2);
        res.set(this.padStart(r, size));
        res.set(this.padStart(s, size), size);
        return res;
    }
    static decodeSignature(data, pointSize) {
        const size = this.getSize(pointSize);
        const view = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toUint8Array(data);
        if (view.length !== (size * 2)) {
            throw new Error("Incorrect size of the signature");
        }
        const r = view.slice(0, size);
        const s = view.slice(size);
        return {
            r: this.trimStart(r),
            s: this.trimStart(s),
        };
    }
    static trimStart(data) {
        let i = 0;
        while ((i < data.length - 1) && (data[i] === 0)) {
            i++;
        }
        if (i === 0) {
            return data;
        }
        return data.slice(i, data.length);
    }
    static padStart(data, size) {
        if (size === data.length) {
            return data;
        }
        const res = new Uint8Array(size);
        res.set(data, size - data.length);
        return res;
    }
}

class EcDsaSignature {
    constructor() {
        this.r = new ArrayBuffer(0);
        this.s = new ArrayBuffer(0);
    }
    static fromWebCryptoSignature(value) {
        const pointSize = value.byteLength / 2;
        const point = EcUtils.decodeSignature(value, pointSize * 8);
        const ecSignature = new EcDsaSignature();
        ecSignature.r = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toArrayBuffer(point.r);
        ecSignature.s = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toArrayBuffer(point.s);
        return ecSignature;
    }
    toWebCryptoSignature(pointSize) {
        if (!pointSize) {
            const maxPointLength = Math.max(this.r.byteLength, this.s.byteLength);
            if (maxPointLength <= 32) {
                pointSize = 256;
            }
            else if (maxPointLength <= 48) {
                pointSize = 384;
            }
            else {
                pointSize = 521;
            }
        }
        const signature = EcUtils.encodeSignature(this, pointSize);
        return signature.buffer;
    }
}
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: AsnIntegerWithoutPaddingConverter })
], EcDsaSignature.prototype, "r", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].Integer, converter: AsnIntegerWithoutPaddingConverter })
], EcDsaSignature.prototype, "s", void 0);

class OneAsymmetricKey extends PrivateKeyInfo {
}
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ context: 1, implicit: true, type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].BitString, optional: true })
], OneAsymmetricKey.prototype, "publicKey", void 0);

let EdPrivateKey = class EdPrivateKey {
    constructor() {
        this.value = new ArrayBuffer(0);
    }
    fromJSON(json) {
        if (!json.d) {
            throw new Error("d: Missing required property");
        }
        this.value = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].FromBase64Url(json.d);
        return this;
    }
    toJSON() {
        const jwk = {
            d: pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].ToBase64Url(this.value),
        };
        return jwk;
    }
};
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].OctetString })
], EdPrivateKey.prototype, "value", void 0);
EdPrivateKey = Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnType */ "g"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnTypeTypes */ "h"].Choice })
], EdPrivateKey);

let EdPublicKey = class EdPublicKey {
    constructor(value) {
        this.value = new ArrayBuffer(0);
        if (value) {
            this.value = value;
        }
    }
    toJSON() {
        const json = {
            x: pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].ToBase64Url(this.value),
        };
        return json;
    }
    fromJSON(json) {
        if (!("x" in json)) {
            throw new Error("x: Missing required property");
        }
        this.value = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].FromBase64Url(json.x);
        return this;
    }
};
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].BitString })
], EdPublicKey.prototype, "value", void 0);
EdPublicKey = Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnType */ "g"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnTypeTypes */ "h"].Choice })
], EdPublicKey);

let CurvePrivateKey = class CurvePrivateKey {
};
Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnProp */ "d"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnPropTypes */ "e"].OctetString }),
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__[/* JsonProp */ "b"])({ type: _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_3__[/* JsonPropTypes */ "c"].String, converter: JsonBase64UrlArrayBufferConverter })
], CurvePrivateKey.prototype, "d", void 0);
CurvePrivateKey = Object(tslib__WEBPACK_IMPORTED_MODULE_2__[/* __decorate */ "a"])([
    Object(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnType */ "g"])({ type: _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnTypeTypes */ "h"].Choice })
], CurvePrivateKey);

const idSecp256r1 = "1.2.840.10045.3.1.7";
const idEllipticCurve = "1.3.132.0";
const idSecp384r1 = `${idEllipticCurve}.34`;
const idSecp521r1 = `${idEllipticCurve}.35`;
const idSecp256k1 = `${idEllipticCurve}.10`;
const idVersionOne = "1.3.36.3.3.2.8.1.1";
const idBrainpoolP160r1 = `${idVersionOne}.1`;
const idBrainpoolP160t1 = `${idVersionOne}.2`;
const idBrainpoolP192r1 = `${idVersionOne}.3`;
const idBrainpoolP192t1 = `${idVersionOne}.4`;
const idBrainpoolP224r1 = `${idVersionOne}.5`;
const idBrainpoolP224t1 = `${idVersionOne}.6`;
const idBrainpoolP256r1 = `${idVersionOne}.7`;
const idBrainpoolP256t1 = `${idVersionOne}.8`;
const idBrainpoolP320r1 = `${idVersionOne}.9`;
const idBrainpoolP320t1 = `${idVersionOne}.10`;
const idBrainpoolP384r1 = `${idVersionOne}.11`;
const idBrainpoolP384t1 = `${idVersionOne}.12`;
const idBrainpoolP512r1 = `${idVersionOne}.13`;
const idBrainpoolP512t1 = `${idVersionOne}.14`;
const idX25519 = "1.3.101.110";
const idX448 = "1.3.101.111";
const idEd25519 = "1.3.101.112";
const idEd448 = "1.3.101.113";

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AlgorithmIdentifier: AlgorithmIdentifier,
  get CurvePrivateKey () { return CurvePrivateKey; },
  EcDsaSignature: EcDsaSignature,
  EcPrivateKey: EcPrivateKey,
  get EcPublicKey () { return EcPublicKey; },
  get EdPrivateKey () { return EdPrivateKey; },
  get EdPublicKey () { return EdPublicKey; },
  get ObjectIdentifier () { return ObjectIdentifier; },
  OneAsymmetricKey: OneAsymmetricKey,
  PrivateKeyInfo: PrivateKeyInfo,
  PublicKeyInfo: PublicKeyInfo,
  RsaPrivateKey: RsaPrivateKey,
  RsaPublicKey: RsaPublicKey,
  converters: index$2,
  idBrainpoolP160r1: idBrainpoolP160r1,
  idBrainpoolP160t1: idBrainpoolP160t1,
  idBrainpoolP192r1: idBrainpoolP192r1,
  idBrainpoolP192t1: idBrainpoolP192t1,
  idBrainpoolP224r1: idBrainpoolP224r1,
  idBrainpoolP224t1: idBrainpoolP224t1,
  idBrainpoolP256r1: idBrainpoolP256r1,
  idBrainpoolP256t1: idBrainpoolP256t1,
  idBrainpoolP320r1: idBrainpoolP320r1,
  idBrainpoolP320t1: idBrainpoolP320t1,
  idBrainpoolP384r1: idBrainpoolP384r1,
  idBrainpoolP384t1: idBrainpoolP384t1,
  idBrainpoolP512r1: idBrainpoolP512r1,
  idBrainpoolP512t1: idBrainpoolP512t1,
  idEd25519: idEd25519,
  idEd448: idEd448,
  idEllipticCurve: idEllipticCurve,
  idSecp256k1: idSecp256k1,
  idSecp256r1: idSecp256r1,
  idSecp384r1: idSecp384r1,
  idSecp521r1: idSecp521r1,
  idVersionOne: idVersionOne,
  idX25519: idX25519,
  idX448: idX448
});

class EcCurves {
    constructor() { }
    static register(item) {
        const oid = new ObjectIdentifier();
        oid.value = item.id;
        const raw = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_1__[/* AsnConvert */ "a"].serialize(oid);
        this.items.push({
            ...item,
            raw,
        });
        this.names.push(item.name);
    }
    static find(nameOrId) {
        nameOrId = nameOrId.toUpperCase();
        for (const item of this.items) {
            if (item.name.toUpperCase() === nameOrId || item.id.toUpperCase() === nameOrId) {
                return item;
            }
        }
        return null;
    }
    static get(nameOrId) {
        const res = this.find(nameOrId);
        if (!res) {
            throw new Error(`Unsupported EC named curve '${nameOrId}'`);
        }
        return res;
    }
}
EcCurves.items = [];
EcCurves.names = [];
EcCurves.register({ name: "P-256", id: idSecp256r1, size: 256 });
EcCurves.register({ name: "P-384", id: idSecp384r1, size: 384 });
EcCurves.register({ name: "P-521", id: idSecp521r1, size: 521 });
EcCurves.register({ name: "K-256", id: idSecp256k1, size: 256 });
EcCurves.register({ name: "brainpoolP160r1", id: idBrainpoolP160r1, size: 160 });
EcCurves.register({ name: "brainpoolP160t1", id: idBrainpoolP160t1, size: 160 });
EcCurves.register({ name: "brainpoolP192r1", id: idBrainpoolP192r1, size: 192 });
EcCurves.register({ name: "brainpoolP192t1", id: idBrainpoolP192t1, size: 192 });
EcCurves.register({ name: "brainpoolP224r1", id: idBrainpoolP224r1, size: 224 });
EcCurves.register({ name: "brainpoolP224t1", id: idBrainpoolP224t1, size: 224 });
EcCurves.register({ name: "brainpoolP256r1", id: idBrainpoolP256r1, size: 256 });
EcCurves.register({ name: "brainpoolP256t1", id: idBrainpoolP256t1, size: 256 });
EcCurves.register({ name: "brainpoolP320r1", id: idBrainpoolP320r1, size: 320 });
EcCurves.register({ name: "brainpoolP320t1", id: idBrainpoolP320t1, size: 320 });
EcCurves.register({ name: "brainpoolP384r1", id: idBrainpoolP384r1, size: 384 });
EcCurves.register({ name: "brainpoolP384t1", id: idBrainpoolP384t1, size: 384 });
EcCurves.register({ name: "brainpoolP512r1", id: idBrainpoolP512r1, size: 512 });
EcCurves.register({ name: "brainpoolP512t1", id: idBrainpoolP512t1, size: 512 });

class X25519Provider extends ProviderCrypto {
    constructor() {
        super(...arguments);
        this.name = "X25519";
        this.usages = {
            privateKey: ["deriveKey", "deriveBits"],
            publicKey: [],
        };
    }
    checkAlgorithmParams(algorithm) {
        this.checkRequiredProperty(algorithm, "public");
    }
}

class Ed25519Provider extends ProviderCrypto {
    constructor() {
        super(...arguments);
        this.name = "Ed25519";
        this.usages = {
            privateKey: ["sign"],
            publicKey: ["verify"],
        };
    }
}

class HmacProvider extends ProviderCrypto {
    constructor() {
        super(...arguments);
        this.name = "HMAC";
        this.hashAlgorithms = ["SHA-1", "SHA-256", "SHA-384", "SHA-512"];
        this.usages = ["sign", "verify"];
    }
    getDefaultLength(algName) {
        switch (algName.toUpperCase()) {
            case "SHA-1":
            case "SHA-256":
            case "SHA-384":
            case "SHA-512":
                return 512;
            default:
                throw new Error(`Unknown algorithm name '${algName}'`);
        }
    }
    checkGenerateKeyParams(algorithm) {
        this.checkRequiredProperty(algorithm, "hash");
        this.checkHashAlgorithm(algorithm.hash, this.hashAlgorithms);
        if ("length" in algorithm) {
            if (typeof algorithm.length !== "number") {
                throw new TypeError("length: Is not a Number");
            }
            if (algorithm.length < 1) {
                throw new RangeError("length: Number is out of range");
            }
        }
    }
    checkImportParams(algorithm) {
        this.checkRequiredProperty(algorithm, "hash");
        this.checkHashAlgorithm(algorithm.hash, this.hashAlgorithms);
    }
}

class Pbkdf2Provider extends ProviderCrypto {
    constructor() {
        super(...arguments);
        this.name = "PBKDF2";
        this.hashAlgorithms = ["SHA-1", "SHA-256", "SHA-384", "SHA-512"];
        this.usages = ["deriveBits", "deriveKey"];
    }
    checkAlgorithmParams(algorithm) {
        this.checkRequiredProperty(algorithm, "hash");
        this.checkHashAlgorithm(algorithm.hash, this.hashAlgorithms);
        this.checkRequiredProperty(algorithm, "salt");
        if (!(algorithm.salt instanceof ArrayBuffer || ArrayBuffer.isView(algorithm.salt))) {
            throw new TypeError("salt: Is not of type '(ArrayBuffer or ArrayBufferView)'");
        }
        this.checkRequiredProperty(algorithm, "iterations");
        if (typeof algorithm.iterations !== "number") {
            throw new TypeError("iterations: Is not a Number");
        }
        if (algorithm.iterations < 1) {
            throw new TypeError("iterations: Is less than 1");
        }
    }
    checkImportKey(format, keyData, algorithm, extractable, keyUsages, ...args) {
        super.checkImportKey(format, keyData, algorithm, extractable, keyUsages, ...args);
        if (extractable) {
            throw new SyntaxError("extractable: Must be 'false'");
        }
    }
}

class HkdfProvider extends ProviderCrypto {
    constructor() {
        super(...arguments);
        this.name = "HKDF";
        this.hashAlgorithms = ["SHA-1", "SHA-256", "SHA-384", "SHA-512"];
        this.usages = ["deriveKey", "deriveBits"];
    }
    checkAlgorithmParams(algorithm) {
        this.checkRequiredProperty(algorithm, "hash");
        this.checkHashAlgorithm(algorithm.hash, this.hashAlgorithms);
        this.checkRequiredProperty(algorithm, "salt");
        if (!pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].isBufferSource(algorithm.salt)) {
            throw new TypeError("salt: Is not of type '(ArrayBuffer or ArrayBufferView)'");
        }
        this.checkRequiredProperty(algorithm, "info");
        if (!pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].isBufferSource(algorithm.info)) {
            throw new TypeError("salt: Is not of type '(ArrayBuffer or ArrayBufferView)'");
        }
    }
    checkImportKey(format, keyData, algorithm, extractable, keyUsages, ...args) {
        super.checkImportKey(format, keyData, algorithm, extractable, keyUsages, ...args);
        if (extractable) {
            throw new SyntaxError("extractable: Must be 'false'");
        }
    }
}

class ShakeProvider extends ProviderCrypto {
    constructor() {
        super(...arguments);
        this.usages = [];
        this.defaultLength = 0;
    }
    digest(...args) {
        args[0] = { length: this.defaultLength, ...args[0] };
        return super.digest.apply(this, args);
    }
    checkDigest(algorithm, data) {
        super.checkDigest(algorithm, data);
        const length = algorithm.length || 0;
        if (typeof length !== "number") {
            throw new TypeError("length: Is not a Number");
        }
        if (length < 0) {
            throw new TypeError("length: Is negative");
        }
    }
}

class Shake128Provider extends ShakeProvider {
    constructor() {
        super(...arguments);
        this.name = "shake128";
        this.defaultLength = 16;
    }
}

class Shake256Provider extends ShakeProvider {
    constructor() {
        super(...arguments);
        this.name = "shake256";
        this.defaultLength = 32;
    }
}

class Crypto {
    get [Symbol.toStringTag]() {
        return "Crypto";
    }
    randomUUID() {
        const b = this.getRandomValues(new Uint8Array(16));
        b[6] = (b[6] & 0x0f) | 0x40;
        b[8] = (b[8] & 0x3f) | 0x80;
        const uuid = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].ToHex(b).toLowerCase();
        return `${uuid.substring(0, 8)}-${uuid.substring(8, 12)}-${uuid.substring(12, 16)}-${uuid.substring(16, 20)}-${uuid.substring(20)}`;
    }
}

class ProviderStorage {
    constructor() {
        this.items = {};
    }
    get(algorithmName) {
        return this.items[algorithmName.toLowerCase()] || null;
    }
    set(provider) {
        this.items[provider.name.toLowerCase()] = provider;
    }
    removeAt(algorithmName) {
        const provider = this.get(algorithmName.toLowerCase());
        if (provider) {
            delete this.items[algorithmName];
        }
        return provider;
    }
    has(name) {
        return !!this.get(name);
    }
    get length() {
        return Object.keys(this.items).length;
    }
    get algorithms() {
        const algorithms = [];
        for (const key in this.items) {
            const provider = this.items[key];
            algorithms.push(provider.name);
        }
        return algorithms.sort();
    }
}

const keyFormatMap = {
    "jwk": ["private", "public", "secret"],
    "pkcs8": ["private"],
    "spki": ["public"],
    "raw": ["secret", "public"]
};
const sourceBufferKeyFormats = ["pkcs8", "spki", "raw"];
class SubtleCrypto {
    constructor() {
        this.providers = new ProviderStorage();
    }
    static isHashedAlgorithm(data) {
        return data
            && typeof data === "object"
            && "name" in data
            && "hash" in data
            ? true
            : false;
    }
    get [Symbol.toStringTag]() {
        return "SubtleCrypto";
    }
    async digest(...args) {
        this.checkRequiredArguments(args, 2, "digest");
        const [algorithm, data, ...params] = args;
        const preparedAlgorithm = this.prepareAlgorithm(algorithm);
        const preparedData = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toArrayBuffer(data);
        const provider = this.getProvider(preparedAlgorithm.name);
        const result = await provider.digest(preparedAlgorithm, preparedData, ...params);
        return result;
    }
    async generateKey(...args) {
        this.checkRequiredArguments(args, 3, "generateKey");
        const [algorithm, extractable, keyUsages, ...params] = args;
        const preparedAlgorithm = this.prepareAlgorithm(algorithm);
        const provider = this.getProvider(preparedAlgorithm.name);
        const result = await provider.generateKey({ ...preparedAlgorithm, name: provider.name }, extractable, keyUsages, ...params);
        return result;
    }
    async sign(...args) {
        this.checkRequiredArguments(args, 3, "sign");
        const [algorithm, key, data, ...params] = args;
        this.checkCryptoKey(key);
        const preparedAlgorithm = this.prepareAlgorithm(algorithm);
        const preparedData = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toArrayBuffer(data);
        const provider = this.getProvider(preparedAlgorithm.name);
        const result = await provider.sign({ ...preparedAlgorithm, name: provider.name }, key, preparedData, ...params);
        return result;
    }
    async verify(...args) {
        this.checkRequiredArguments(args, 4, "verify");
        const [algorithm, key, signature, data, ...params] = args;
        this.checkCryptoKey(key);
        const preparedAlgorithm = this.prepareAlgorithm(algorithm);
        const preparedData = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toArrayBuffer(data);
        const preparedSignature = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toArrayBuffer(signature);
        const provider = this.getProvider(preparedAlgorithm.name);
        const result = await provider.verify({ ...preparedAlgorithm, name: provider.name }, key, preparedSignature, preparedData, ...params);
        return result;
    }
    async encrypt(...args) {
        this.checkRequiredArguments(args, 3, "encrypt");
        const [algorithm, key, data, ...params] = args;
        this.checkCryptoKey(key);
        const preparedAlgorithm = this.prepareAlgorithm(algorithm);
        const preparedData = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toArrayBuffer(data);
        const provider = this.getProvider(preparedAlgorithm.name);
        const result = await provider.encrypt({ ...preparedAlgorithm, name: provider.name }, key, preparedData, { keyUsage: true }, ...params);
        return result;
    }
    async decrypt(...args) {
        this.checkRequiredArguments(args, 3, "decrypt");
        const [algorithm, key, data, ...params] = args;
        this.checkCryptoKey(key);
        const preparedAlgorithm = this.prepareAlgorithm(algorithm);
        const preparedData = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toArrayBuffer(data);
        const provider = this.getProvider(preparedAlgorithm.name);
        const result = await provider.decrypt({ ...preparedAlgorithm, name: provider.name }, key, preparedData, { keyUsage: true }, ...params);
        return result;
    }
    async deriveBits(...args) {
        this.checkRequiredArguments(args, 3, "deriveBits");
        const [algorithm, baseKey, length, ...params] = args;
        this.checkCryptoKey(baseKey);
        const preparedAlgorithm = this.prepareAlgorithm(algorithm);
        const provider = this.getProvider(preparedAlgorithm.name);
        const result = await provider.deriveBits({ ...preparedAlgorithm, name: provider.name }, baseKey, length, { keyUsage: true }, ...params);
        return result;
    }
    async deriveKey(...args) {
        this.checkRequiredArguments(args, 5, "deriveKey");
        const [algorithm, baseKey, derivedKeyType, extractable, keyUsages, ...params] = args;
        const preparedDerivedKeyType = this.prepareAlgorithm(derivedKeyType);
        const importProvider = this.getProvider(preparedDerivedKeyType.name);
        importProvider.checkDerivedKeyParams(preparedDerivedKeyType);
        const preparedAlgorithm = this.prepareAlgorithm(algorithm);
        const provider = this.getProvider(preparedAlgorithm.name);
        provider.checkCryptoKey(baseKey, "deriveKey");
        const derivedBits = await provider.deriveBits({ ...preparedAlgorithm, name: provider.name }, baseKey, derivedKeyType.length || 512, { keyUsage: false }, ...params);
        return this.importKey("raw", derivedBits, derivedKeyType, extractable, keyUsages, ...params);
    }
    async exportKey(...args) {
        this.checkRequiredArguments(args, 2, "exportKey");
        const [format, key, ...params] = args;
        this.checkCryptoKey(key);
        if (!keyFormatMap[format]) {
            throw new TypeError("Invalid keyFormat argument");
        }
        if (!keyFormatMap[format].includes(key.type)) {
            throw new DOMException("The key is not of the expected type");
        }
        const provider = this.getProvider(key.algorithm.name);
        const result = await provider.exportKey(format, key, ...params);
        return result;
    }
    async importKey(...args) {
        this.checkRequiredArguments(args, 5, "importKey");
        const [format, keyData, algorithm, extractable, keyUsages, ...params] = args;
        const preparedAlgorithm = this.prepareAlgorithm(algorithm);
        const provider = this.getProvider(preparedAlgorithm.name);
        if (format === "jwk") {
            if (typeof keyData !== "object" || !keyData.kty) {
                throw new TypeError("Key data must be an object for JWK import");
            }
        }
        else if (sourceBufferKeyFormats.includes(format)) {
            if (!pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].isBufferSource(keyData)) {
                throw new TypeError("Key data must be a BufferSource for non-JWK formats");
            }
        }
        else {
            throw new TypeError("The provided value is not of type '(ArrayBuffer or ArrayBufferView or JsonWebKey)'");
        }
        return provider.importKey(format, keyData, { ...preparedAlgorithm, name: provider.name }, extractable, keyUsages, ...params);
    }
    async wrapKey(format, key, wrappingKey, wrapAlgorithm, ...args) {
        let keyData = await this.exportKey(format, key, ...args);
        if (format === "jwk") {
            const json = JSON.stringify(keyData);
            keyData = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].FromUtf8String(json);
        }
        const preparedAlgorithm = this.prepareAlgorithm(wrapAlgorithm);
        const preparedData = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toArrayBuffer(keyData);
        const provider = this.getProvider(preparedAlgorithm.name);
        return provider.encrypt({ ...preparedAlgorithm, name: provider.name }, wrappingKey, preparedData, { keyUsage: false }, ...args);
    }
    async unwrapKey(format, wrappedKey, unwrappingKey, unwrapAlgorithm, unwrappedKeyAlgorithm, extractable, keyUsages, ...args) {
        const preparedAlgorithm = this.prepareAlgorithm(unwrapAlgorithm);
        const preparedData = pvtsutils__WEBPACK_IMPORTED_MODULE_0__["BufferSourceConverter"].toArrayBuffer(wrappedKey);
        const provider = this.getProvider(preparedAlgorithm.name);
        let keyData = await provider.decrypt({ ...preparedAlgorithm, name: provider.name }, unwrappingKey, preparedData, { keyUsage: false }, ...args);
        if (format === "jwk") {
            try {
                keyData = JSON.parse(pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].ToUtf8String(keyData));
            }
            catch (e) {
                const error = new TypeError("wrappedKey: Is not a JSON");
                error.internal = e;
                throw error;
            }
        }
        return this.importKey(format, keyData, unwrappedKeyAlgorithm, extractable, keyUsages, ...args);
    }
    checkRequiredArguments(args, size, methodName) {
        if (args.length < size) {
            throw new TypeError(`Failed to execute '${methodName}' on 'SubtleCrypto': ${size} arguments required, but only ${args.length} present`);
        }
    }
    prepareAlgorithm(algorithm) {
        if (typeof algorithm === "string") {
            return {
                name: algorithm,
            };
        }
        if (SubtleCrypto.isHashedAlgorithm(algorithm)) {
            const preparedAlgorithm = { ...algorithm };
            preparedAlgorithm.hash = this.prepareAlgorithm(algorithm.hash);
            return preparedAlgorithm;
        }
        return { ...algorithm };
    }
    getProvider(name) {
        const provider = this.providers.get(name);
        if (!provider) {
            throw new AlgorithmError("Unrecognized name");
        }
        return provider;
    }
    checkCryptoKey(key) {
        if (!(key instanceof CryptoKey)) {
            throw new TypeError(`Key is not of type 'CryptoKey'`);
        }
    }
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  converters: index$3
});

const REQUIRED_FIELDS = ["crv", "e", "k", "kty", "n", "x", "y"];
class JwkUtils {
    static async thumbprint(hash, jwk, crypto) {
        const data = this.format(jwk, true);
        return crypto.subtle.digest(hash, pvtsutils__WEBPACK_IMPORTED_MODULE_0__["Convert"].FromBinary(JSON.stringify(data)));
    }
    static format(jwk, remove = false) {
        let res = Object.entries(jwk);
        if (remove) {
            res = res.filter(o => REQUIRED_FIELDS.includes(o[0]));
        }
        res = res.sort(([keyA], [keyB]) => keyA > keyB ? 1 : keyA < keyB ? -1 : 0);
        return Object.fromEntries(res);
    }
}




/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate, process) {/* harmony import */ var _helpers_bind_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(115);




// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = Object(_helpers_bind_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }

  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({source, data}) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);

    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    }
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === 'function',
  isFunction(_global.postMessage)
);

const asap = typeof queueMicrotask !== 'undefined' ?
  queueMicrotask.bind(_global) : ( typeof process !== 'undefined' && process.nextTick || _setImmediate);

// *********************

/* harmony default export */ __webpack_exports__["a"] = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
});

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(39), __webpack_require__(186).setImmediate, __webpack_require__(40)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ AsnIntegerConverter; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ AsnProp; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ AsnType; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* reexport */ AsnTypeTypes; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ AsnPropTypes; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ parser_AsnParser; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ serializer_AsnSerializer; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ convert_AsnConvert; });

// UNUSED EXPORTS: AsnAnyConverter, AsnEnumeratedConverter, AsnIntegerArrayBufferConverter, AsnIntegerBigIntConverter, AsnBitStringConverter, AsnObjectIdentifierConverter, AsnBooleanConverter, AsnOctetStringConverter, AsnConstructedOctetStringConverter, AsnUtf8StringConverter, AsnBmpStringConverter, AsnUniversalStringConverter, AsnNumericStringConverter, AsnPrintableStringConverter, AsnTeletexStringConverter, AsnVideotexStringConverter, AsnIA5StringConverter, AsnGraphicStringConverter, AsnVisibleStringConverter, AsnGeneralStringConverter, AsnCharacterStringConverter, AsnUTCTimeConverter, AsnGeneralizedTimeConverter, AsnNullConverter, defaultConverter, BitString, OctetString, AsnChoiceType, AsnSequenceType, AsnSetType, AsnSchemaValidationError, AsnArray

// EXTERNAL MODULE: ./node_modules/asn1js/build/index.es.js + 1 modules
var index_es = __webpack_require__(5);

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/enums.js
var AsnTypeTypes;
(function (AsnTypeTypes) {
    AsnTypeTypes[AsnTypeTypes["Sequence"] = 0] = "Sequence";
    AsnTypeTypes[AsnTypeTypes["Set"] = 1] = "Set";
    AsnTypeTypes[AsnTypeTypes["Choice"] = 2] = "Choice";
})(AsnTypeTypes || (AsnTypeTypes = {}));
var AsnPropTypes;
(function (AsnPropTypes) {
    AsnPropTypes[AsnPropTypes["Any"] = 1] = "Any";
    AsnPropTypes[AsnPropTypes["Boolean"] = 2] = "Boolean";
    AsnPropTypes[AsnPropTypes["OctetString"] = 3] = "OctetString";
    AsnPropTypes[AsnPropTypes["BitString"] = 4] = "BitString";
    AsnPropTypes[AsnPropTypes["Integer"] = 5] = "Integer";
    AsnPropTypes[AsnPropTypes["Enumerated"] = 6] = "Enumerated";
    AsnPropTypes[AsnPropTypes["ObjectIdentifier"] = 7] = "ObjectIdentifier";
    AsnPropTypes[AsnPropTypes["Utf8String"] = 8] = "Utf8String";
    AsnPropTypes[AsnPropTypes["BmpString"] = 9] = "BmpString";
    AsnPropTypes[AsnPropTypes["UniversalString"] = 10] = "UniversalString";
    AsnPropTypes[AsnPropTypes["NumericString"] = 11] = "NumericString";
    AsnPropTypes[AsnPropTypes["PrintableString"] = 12] = "PrintableString";
    AsnPropTypes[AsnPropTypes["TeletexString"] = 13] = "TeletexString";
    AsnPropTypes[AsnPropTypes["VideotexString"] = 14] = "VideotexString";
    AsnPropTypes[AsnPropTypes["IA5String"] = 15] = "IA5String";
    AsnPropTypes[AsnPropTypes["GraphicString"] = 16] = "GraphicString";
    AsnPropTypes[AsnPropTypes["VisibleString"] = 17] = "VisibleString";
    AsnPropTypes[AsnPropTypes["GeneralString"] = 18] = "GeneralString";
    AsnPropTypes[AsnPropTypes["CharacterString"] = 19] = "CharacterString";
    AsnPropTypes[AsnPropTypes["UTCTime"] = 20] = "UTCTime";
    AsnPropTypes[AsnPropTypes["GeneralizedTime"] = 21] = "GeneralizedTime";
    AsnPropTypes[AsnPropTypes["DATE"] = 22] = "DATE";
    AsnPropTypes[AsnPropTypes["TimeOfDay"] = 23] = "TimeOfDay";
    AsnPropTypes[AsnPropTypes["DateTime"] = 24] = "DateTime";
    AsnPropTypes[AsnPropTypes["Duration"] = 25] = "Duration";
    AsnPropTypes[AsnPropTypes["TIME"] = 26] = "TIME";
    AsnPropTypes[AsnPropTypes["Null"] = 27] = "Null";
})(AsnPropTypes || (AsnPropTypes = {}));

// EXTERNAL MODULE: ./node_modules/pvtsutils/build/index.js
var build = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/types/bit_string.js


class bit_string_BitString {
    constructor(params, unusedBits = 0) {
        this.unusedBits = 0;
        this.value = new ArrayBuffer(0);
        if (params) {
            if (typeof params === "number") {
                this.fromNumber(params);
            }
            else if (build["BufferSourceConverter"].isBufferSource(params)) {
                this.unusedBits = unusedBits;
                this.value = build["BufferSourceConverter"].toArrayBuffer(params);
            }
            else {
                throw TypeError("Unsupported type of 'params' argument for BitString");
            }
        }
    }
    fromASN(asn) {
        if (!(asn instanceof index_es["BitString"])) {
            throw new TypeError("Argument 'asn' is not instance of ASN.1 BitString");
        }
        this.unusedBits = asn.valueBlock.unusedBits;
        this.value = asn.valueBlock.valueHex;
        return this;
    }
    toASN() {
        return new index_es["BitString"]({ unusedBits: this.unusedBits, valueHex: this.value });
    }
    toSchema(name) {
        return new index_es["BitString"]({ name });
    }
    toNumber() {
        let res = "";
        const uintArray = new Uint8Array(this.value);
        for (const octet of uintArray) {
            res += octet.toString(2).padStart(8, "0");
        }
        res = res.split("").reverse().join("");
        if (this.unusedBits) {
            res = res.slice(this.unusedBits).padStart(this.unusedBits, "0");
        }
        return parseInt(res, 2);
    }
    fromNumber(value) {
        let bits = value.toString(2);
        const octetSize = (bits.length + 7) >> 3;
        this.unusedBits = (octetSize << 3) - bits.length;
        const octets = new Uint8Array(octetSize);
        bits = bits
            .padStart(octetSize << 3, "0")
            .split("")
            .reverse()
            .join("");
        let index = 0;
        while (index < octetSize) {
            octets[index] = parseInt(bits.slice(index << 3, (index << 3) + 8), 2);
            index++;
        }
        this.value = octets.buffer;
    }
}

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/types/octet_string.js


class octet_string_OctetString {
    get byteLength() {
        return this.buffer.byteLength;
    }
    get byteOffset() {
        return 0;
    }
    constructor(param) {
        if (typeof param === "number") {
            this.buffer = new ArrayBuffer(param);
        }
        else {
            if (build["BufferSourceConverter"].isBufferSource(param)) {
                this.buffer = build["BufferSourceConverter"].toArrayBuffer(param);
            }
            else if (Array.isArray(param)) {
                this.buffer = new Uint8Array(param);
            }
            else {
                this.buffer = new ArrayBuffer(0);
            }
        }
    }
    fromASN(asn) {
        if (!(asn instanceof index_es["OctetString"])) {
            throw new TypeError("Argument 'asn' is not instance of ASN.1 OctetString");
        }
        this.buffer = asn.valueBlock.valueHex;
        return this;
    }
    toASN() {
        return new index_es["OctetString"]({ valueHex: this.buffer });
    }
    toSchema(name) {
        return new index_es["OctetString"]({ name });
    }
}

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/types/index.js



// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/converters.js



const AsnAnyConverter = {
    fromASN: (value) => value instanceof index_es["Null"] ? null : value.valueBeforeDecodeView,
    toASN: (value) => {
        if (value === null) {
            return new index_es["Null"]();
        }
        const schema = index_es["fromBER"](value);
        if (schema.result.error) {
            throw new Error(schema.result.error);
        }
        return schema.result;
    },
};
const AsnIntegerConverter = {
    fromASN: (value) => value.valueBlock.valueHexView.byteLength >= 4
        ? value.valueBlock.toString()
        : value.valueBlock.valueDec,
    toASN: (value) => new index_es["Integer"]({ value: +value }),
};
const AsnEnumeratedConverter = {
    fromASN: (value) => value.valueBlock.valueDec,
    toASN: (value) => new index_es["Enumerated"]({ value }),
};
const AsnIntegerArrayBufferConverter = {
    fromASN: (value) => value.valueBlock.valueHexView,
    toASN: (value) => new index_es["Integer"]({ valueHex: value }),
};
const AsnIntegerBigIntConverter = {
    fromASN: (value) => value.toBigInt(),
    toASN: (value) => index_es["Integer"].fromBigInt(value),
};
const AsnBitStringConverter = {
    fromASN: (value) => value.valueBlock.valueHexView,
    toASN: (value) => new index_es["BitString"]({ valueHex: value }),
};
const AsnObjectIdentifierConverter = {
    fromASN: (value) => value.valueBlock.toString(),
    toASN: (value) => new index_es["ObjectIdentifier"]({ value }),
};
const AsnBooleanConverter = {
    fromASN: (value) => value.valueBlock.value,
    toASN: (value) => new index_es["Boolean"]({ value }),
};
const AsnOctetStringConverter = {
    fromASN: (value) => value.valueBlock.valueHexView,
    toASN: (value) => new index_es["OctetString"]({ valueHex: value }),
};
const AsnConstructedOctetStringConverter = {
    fromASN: (value) => new octet_string_OctetString(value.getValue()),
    toASN: (value) => value.toASN(),
};
function createStringConverter(Asn1Type) {
    return {
        fromASN: (value) => value.valueBlock.value,
        toASN: (value) => new Asn1Type({ value }),
    };
}
const AsnUtf8StringConverter = createStringConverter(index_es["Utf8String"]);
const AsnBmpStringConverter = createStringConverter(index_es["BmpString"]);
const AsnUniversalStringConverter = createStringConverter(index_es["UniversalString"]);
const AsnNumericStringConverter = createStringConverter(index_es["NumericString"]);
const AsnPrintableStringConverter = createStringConverter(index_es["PrintableString"]);
const AsnTeletexStringConverter = createStringConverter(index_es["TeletexString"]);
const AsnVideotexStringConverter = createStringConverter(index_es["VideotexString"]);
const AsnIA5StringConverter = createStringConverter(index_es["IA5String"]);
const AsnGraphicStringConverter = createStringConverter(index_es["GraphicString"]);
const AsnVisibleStringConverter = createStringConverter(index_es["VisibleString"]);
const AsnGeneralStringConverter = createStringConverter(index_es["GeneralString"]);
const AsnCharacterStringConverter = createStringConverter(index_es["CharacterString"]);
const AsnUTCTimeConverter = {
    fromASN: (value) => value.toDate(),
    toASN: (value) => new index_es["UTCTime"]({ valueDate: value }),
};
const AsnGeneralizedTimeConverter = {
    fromASN: (value) => value.toDate(),
    toASN: (value) => new index_es["GeneralizedTime"]({ valueDate: value }),
};
const AsnNullConverter = {
    fromASN: () => null,
    toASN: () => {
        return new index_es["Null"]();
    },
};
function converters_defaultConverter(type) {
    switch (type) {
        case AsnPropTypes.Any:
            return AsnAnyConverter;
        case AsnPropTypes.BitString:
            return AsnBitStringConverter;
        case AsnPropTypes.BmpString:
            return AsnBmpStringConverter;
        case AsnPropTypes.Boolean:
            return AsnBooleanConverter;
        case AsnPropTypes.CharacterString:
            return AsnCharacterStringConverter;
        case AsnPropTypes.Enumerated:
            return AsnEnumeratedConverter;
        case AsnPropTypes.GeneralString:
            return AsnGeneralStringConverter;
        case AsnPropTypes.GeneralizedTime:
            return AsnGeneralizedTimeConverter;
        case AsnPropTypes.GraphicString:
            return AsnGraphicStringConverter;
        case AsnPropTypes.IA5String:
            return AsnIA5StringConverter;
        case AsnPropTypes.Integer:
            return AsnIntegerConverter;
        case AsnPropTypes.Null:
            return AsnNullConverter;
        case AsnPropTypes.NumericString:
            return AsnNumericStringConverter;
        case AsnPropTypes.ObjectIdentifier:
            return AsnObjectIdentifierConverter;
        case AsnPropTypes.OctetString:
            return AsnOctetStringConverter;
        case AsnPropTypes.PrintableString:
            return AsnPrintableStringConverter;
        case AsnPropTypes.TeletexString:
            return AsnTeletexStringConverter;
        case AsnPropTypes.UTCTime:
            return AsnUTCTimeConverter;
        case AsnPropTypes.UniversalString:
            return AsnUniversalStringConverter;
        case AsnPropTypes.Utf8String:
            return AsnUtf8StringConverter;
        case AsnPropTypes.VideotexString:
            return AsnVideotexStringConverter;
        case AsnPropTypes.VisibleString:
            return AsnVisibleStringConverter;
        default:
            return null;
    }
}

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/helper.js
function isConvertible(target) {
    if (typeof target === "function" && target.prototype) {
        if (target.prototype.toASN && target.prototype.fromASN) {
            return true;
        }
        else {
            return isConvertible(target.prototype);
        }
    }
    else {
        return !!(target && typeof target === "object" && "toASN" in target && "fromASN" in target);
    }
}
function isTypeOfArray(target) {
    var _a;
    if (target) {
        const proto = Object.getPrototypeOf(target);
        if (((_a = proto === null || proto === void 0 ? void 0 : proto.prototype) === null || _a === void 0 ? void 0 : _a.constructor) === Array) {
            return true;
        }
        return isTypeOfArray(proto);
    }
    return false;
}
function isArrayEqual(bytes1, bytes2) {
    if (!(bytes1 && bytes2)) {
        return false;
    }
    if (bytes1.byteLength !== bytes2.byteLength) {
        return false;
    }
    const b1 = new Uint8Array(bytes1);
    const b2 = new Uint8Array(bytes2);
    for (let i = 0; i < bytes1.byteLength; i++) {
        if (b1[i] !== b2[i]) {
            return false;
        }
    }
    return true;
}

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/schema.js



class schema_AsnSchemaStorage {
    constructor() {
        this.items = new WeakMap();
    }
    has(target) {
        return this.items.has(target);
    }
    get(target, checkSchema = false) {
        const schema = this.items.get(target);
        if (!schema) {
            throw new Error(`Cannot get schema for '${target.prototype.constructor.name}' target`);
        }
        if (checkSchema && !schema.schema) {
            throw new Error(`Schema '${target.prototype.constructor.name}' doesn't contain ASN.1 schema. Call 'AsnSchemaStorage.cache'.`);
        }
        return schema;
    }
    cache(target) {
        const schema = this.get(target);
        if (!schema.schema) {
            schema.schema = this.create(target, true);
        }
    }
    createDefault(target) {
        const schema = {
            type: AsnTypeTypes.Sequence,
            items: {},
        };
        const parentSchema = this.findParentSchema(target);
        if (parentSchema) {
            Object.assign(schema, parentSchema);
            schema.items = Object.assign({}, schema.items, parentSchema.items);
        }
        return schema;
    }
    create(target, useNames) {
        const schema = this.items.get(target) || this.createDefault(target);
        const asn1Value = [];
        for (const key in schema.items) {
            const item = schema.items[key];
            const name = useNames ? key : "";
            let asn1Item;
            if (typeof item.type === "number") {
                const Asn1TypeName = AsnPropTypes[item.type];
                const Asn1Type = index_es[Asn1TypeName];
                if (!Asn1Type) {
                    throw new Error(`Cannot get ASN1 class by name '${Asn1TypeName}'`);
                }
                asn1Item = new Asn1Type({ name });
            }
            else if (isConvertible(item.type)) {
                const instance = new item.type();
                asn1Item = instance.toSchema(name);
            }
            else if (item.optional) {
                const itemSchema = this.get(item.type);
                if (itemSchema.type === AsnTypeTypes.Choice) {
                    asn1Item = new index_es["Any"]({ name });
                }
                else {
                    asn1Item = this.create(item.type, false);
                    asn1Item.name = name;
                }
            }
            else {
                asn1Item = new index_es["Any"]({ name });
            }
            const optional = !!item.optional || item.defaultValue !== undefined;
            if (item.repeated) {
                asn1Item.name = "";
                const Container = item.repeated === "set" ? index_es["Set"] : index_es["Sequence"];
                asn1Item = new Container({
                    name: "",
                    value: [
                        new index_es["Repeated"]({
                            name,
                            value: asn1Item,
                        }),
                    ],
                });
            }
            if (item.context !== null && item.context !== undefined) {
                if (item.implicit) {
                    if (typeof item.type === "number" || isConvertible(item.type)) {
                        const Container = item.repeated ? index_es["Constructed"] : index_es["Primitive"];
                        asn1Value.push(new Container({
                            name,
                            optional,
                            idBlock: {
                                tagClass: 3,
                                tagNumber: item.context,
                            },
                        }));
                    }
                    else {
                        this.cache(item.type);
                        const isRepeated = !!item.repeated;
                        let value = !isRepeated ? this.get(item.type, true).schema : asn1Item;
                        value =
                            "valueBlock" in value
                                ? value.valueBlock.value
                                : value.value;
                        asn1Value.push(new index_es["Constructed"]({
                            name: !isRepeated ? name : "",
                            optional,
                            idBlock: {
                                tagClass: 3,
                                tagNumber: item.context,
                            },
                            value: value,
                        }));
                    }
                }
                else {
                    asn1Value.push(new index_es["Constructed"]({
                        optional,
                        idBlock: {
                            tagClass: 3,
                            tagNumber: item.context,
                        },
                        value: [asn1Item],
                    }));
                }
            }
            else {
                asn1Item.optional = optional;
                asn1Value.push(asn1Item);
            }
        }
        switch (schema.type) {
            case AsnTypeTypes.Sequence:
                return new index_es["Sequence"]({ value: asn1Value, name: "" });
            case AsnTypeTypes.Set:
                return new index_es["Set"]({ value: asn1Value, name: "" });
            case AsnTypeTypes.Choice:
                return new index_es["Choice"]({ value: asn1Value, name: "" });
            default:
                throw new Error(`Unsupported ASN1 type in use`);
        }
    }
    set(target, schema) {
        this.items.set(target, schema);
        return this;
    }
    findParentSchema(target) {
        const parent = Object.getPrototypeOf(target);
        if (parent) {
            const schema = this.items.get(parent);
            return schema || this.findParentSchema(parent);
        }
        return null;
    }
}

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/storage.js

const schemaStorage = new schema_AsnSchemaStorage();

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/decorators.js



const AsnType = (options) => (target) => {
    let schema;
    if (!schemaStorage.has(target)) {
        schema = schemaStorage.createDefault(target);
        schemaStorage.set(target, schema);
    }
    else {
        schema = schemaStorage.get(target);
    }
    Object.assign(schema, options);
};
const AsnChoiceType = () => AsnType({ type: AsnTypeTypes.Choice });
const AsnSetType = (options) => AsnType({ type: AsnTypeTypes.Set, ...options });
const AsnSequenceType = (options) => AsnType({ type: AsnTypeTypes.Sequence, ...options });
const AsnProp = (options) => (target, propertyKey) => {
    let schema;
    if (!schemaStorage.has(target.constructor)) {
        schema = schemaStorage.createDefault(target.constructor);
        schemaStorage.set(target.constructor, schema);
    }
    else {
        schema = schemaStorage.get(target.constructor);
    }
    const copyOptions = Object.assign({}, options);
    if (typeof copyOptions.type === "number" && !copyOptions.converter) {
        const defaultConverter = converters_defaultConverter(options.type);
        if (!defaultConverter) {
            throw new Error(`Cannot get default converter for property '${propertyKey}' of ${target.constructor.name}`);
        }
        copyOptions.converter = defaultConverter;
    }
    schema.items[propertyKey] = copyOptions;
};

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/errors/schema_validation.js
class AsnSchemaValidationError extends Error {
    constructor() {
        super(...arguments);
        this.schemas = [];
    }
}

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/errors/index.js


// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/parser.js






class parser_AsnParser {
    static parse(data, target) {
        const asn1Parsed = index_es["fromBER"](data);
        if (asn1Parsed.result.error) {
            throw new Error(asn1Parsed.result.error);
        }
        const res = this.fromASN(asn1Parsed.result, target);
        return res;
    }
    static fromASN(asn1Schema, target) {
        var _a;
        try {
            if (isConvertible(target)) {
                const value = new target();
                return value.fromASN(asn1Schema);
            }
            const schema = schemaStorage.get(target);
            schemaStorage.cache(target);
            let targetSchema = schema.schema;
            if (asn1Schema.constructor === index_es["Constructed"] && schema.type !== AsnTypeTypes.Choice) {
                targetSchema = new index_es["Constructed"]({
                    idBlock: {
                        tagClass: 3,
                        tagNumber: asn1Schema.idBlock.tagNumber,
                    },
                    value: schema.schema.valueBlock.value,
                });
                for (const key in schema.items) {
                    delete asn1Schema[key];
                }
            }
            const asn1ComparedSchema = index_es["compareSchema"]({}, asn1Schema, targetSchema);
            if (!asn1ComparedSchema.verified) {
                throw new AsnSchemaValidationError(`Data does not match to ${target.name} ASN1 schema. ${asn1ComparedSchema.result.error}`);
            }
            const res = new target();
            if (isTypeOfArray(target)) {
                if (!("value" in asn1Schema.valueBlock && Array.isArray(asn1Schema.valueBlock.value))) {
                    throw new Error(`Cannot get items from the ASN.1 parsed value. ASN.1 object is not constructed.`);
                }
                const itemType = schema.itemType;
                if (typeof itemType === "number") {
                    const converter = converters_defaultConverter(itemType);
                    if (!converter) {
                        throw new Error(`Cannot get default converter for array item of ${target.name} ASN1 schema`);
                    }
                    return target.from(asn1Schema.valueBlock.value, (element) => converter.fromASN(element));
                }
                else {
                    return target.from(asn1Schema.valueBlock.value, (element) => this.fromASN(element, itemType));
                }
            }
            for (const key in schema.items) {
                const asn1SchemaValue = asn1ComparedSchema.result[key];
                if (!asn1SchemaValue) {
                    continue;
                }
                const schemaItem = schema.items[key];
                const schemaItemType = schemaItem.type;
                if (typeof schemaItemType === "number" || isConvertible(schemaItemType)) {
                    const converter = (_a = schemaItem.converter) !== null && _a !== void 0 ? _a : (isConvertible(schemaItemType)
                        ? new schemaItemType()
                        : null);
                    if (!converter) {
                        throw new Error("Converter is empty");
                    }
                    if (schemaItem.repeated) {
                        if (schemaItem.implicit) {
                            const Container = schemaItem.repeated === "sequence" ? index_es["Sequence"] : index_es["Set"];
                            const newItem = new Container();
                            newItem.valueBlock = asn1SchemaValue.valueBlock;
                            const newItemAsn = index_es["fromBER"](newItem.toBER(false));
                            if (newItemAsn.offset === -1) {
                                throw new Error(`Cannot parse the child item. ${newItemAsn.result.error}`);
                            }
                            if (!("value" in newItemAsn.result.valueBlock &&
                                Array.isArray(newItemAsn.result.valueBlock.value))) {
                                throw new Error("Cannot get items from the ASN.1 parsed value. ASN.1 object is not constructed.");
                            }
                            const value = newItemAsn.result.valueBlock.value;
                            res[key] = Array.from(value, (element) => converter.fromASN(element));
                        }
                        else {
                            res[key] = Array.from(asn1SchemaValue, (element) => converter.fromASN(element));
                        }
                    }
                    else {
                        let value = asn1SchemaValue;
                        if (schemaItem.implicit) {
                            let newItem;
                            if (isConvertible(schemaItemType)) {
                                newItem = new schemaItemType().toSchema("");
                            }
                            else {
                                const Asn1TypeName = AsnPropTypes[schemaItemType];
                                const Asn1Type = index_es[Asn1TypeName];
                                if (!Asn1Type) {
                                    throw new Error(`Cannot get '${Asn1TypeName}' class from asn1js module`);
                                }
                                newItem = new Asn1Type();
                            }
                            newItem.valueBlock = value.valueBlock;
                            value = index_es["fromBER"](newItem.toBER(false)).result;
                        }
                        res[key] = converter.fromASN(value);
                    }
                }
                else {
                    if (schemaItem.repeated) {
                        if (!Array.isArray(asn1SchemaValue)) {
                            throw new Error("Cannot get list of items from the ASN.1 parsed value. ASN.1 value should be iterable.");
                        }
                        res[key] = Array.from(asn1SchemaValue, (element) => this.fromASN(element, schemaItemType));
                    }
                    else {
                        res[key] = this.fromASN(asn1SchemaValue, schemaItemType);
                    }
                }
            }
            return res;
        }
        catch (error) {
            if (error instanceof AsnSchemaValidationError) {
                error.schemas.push(target.name);
            }
            throw error;
        }
    }
}

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/serializer.js





class serializer_AsnSerializer {
    static serialize(obj) {
        if (obj instanceof index_es["BaseBlock"]) {
            return obj.toBER(false);
        }
        return this.toASN(obj).toBER(false);
    }
    static toASN(obj) {
        if (obj && typeof obj === "object" && isConvertible(obj)) {
            return obj.toASN();
        }
        if (!(obj && typeof obj === "object")) {
            throw new TypeError("Parameter 1 should be type of Object.");
        }
        const target = obj.constructor;
        const schema = schemaStorage.get(target);
        schemaStorage.cache(target);
        let asn1Value = [];
        if (schema.itemType) {
            if (!Array.isArray(obj)) {
                throw new TypeError("Parameter 1 should be type of Array.");
            }
            if (typeof schema.itemType === "number") {
                const converter = converters_defaultConverter(schema.itemType);
                if (!converter) {
                    throw new Error(`Cannot get default converter for array item of ${target.name} ASN1 schema`);
                }
                asn1Value = obj.map((o) => converter.toASN(o));
            }
            else {
                asn1Value = obj.map((o) => this.toAsnItem({ type: schema.itemType }, "[]", target, o));
            }
        }
        else {
            for (const key in schema.items) {
                const schemaItem = schema.items[key];
                const objProp = obj[key];
                if (objProp === undefined ||
                    schemaItem.defaultValue === objProp ||
                    (typeof schemaItem.defaultValue === "object" &&
                        typeof objProp === "object" &&
                        isArrayEqual(this.serialize(schemaItem.defaultValue), this.serialize(objProp)))) {
                    continue;
                }
                const asn1Item = serializer_AsnSerializer.toAsnItem(schemaItem, key, target, objProp);
                if (typeof schemaItem.context === "number") {
                    if (schemaItem.implicit) {
                        if (!schemaItem.repeated &&
                            (typeof schemaItem.type === "number" || isConvertible(schemaItem.type))) {
                            const value = {};
                            value.valueHex =
                                asn1Item instanceof index_es["Null"]
                                    ? asn1Item.valueBeforeDecodeView
                                    : asn1Item.valueBlock.toBER();
                            asn1Value.push(new index_es["Primitive"]({
                                optional: schemaItem.optional,
                                idBlock: {
                                    tagClass: 3,
                                    tagNumber: schemaItem.context,
                                },
                                ...value,
                            }));
                        }
                        else {
                            asn1Value.push(new index_es["Constructed"]({
                                optional: schemaItem.optional,
                                idBlock: {
                                    tagClass: 3,
                                    tagNumber: schemaItem.context,
                                },
                                value: asn1Item.valueBlock.value,
                            }));
                        }
                    }
                    else {
                        asn1Value.push(new index_es["Constructed"]({
                            optional: schemaItem.optional,
                            idBlock: {
                                tagClass: 3,
                                tagNumber: schemaItem.context,
                            },
                            value: [asn1Item],
                        }));
                    }
                }
                else if (schemaItem.repeated) {
                    asn1Value = asn1Value.concat(asn1Item);
                }
                else {
                    asn1Value.push(asn1Item);
                }
            }
        }
        let asnSchema;
        switch (schema.type) {
            case AsnTypeTypes.Sequence:
                asnSchema = new index_es["Sequence"]({ value: asn1Value });
                break;
            case AsnTypeTypes.Set:
                asnSchema = new index_es["Set"]({ value: asn1Value });
                break;
            case AsnTypeTypes.Choice:
                if (!asn1Value[0]) {
                    throw new Error(`Schema '${target.name}' has wrong data. Choice cannot be empty.`);
                }
                asnSchema = asn1Value[0];
                break;
        }
        return asnSchema;
    }
    static toAsnItem(schemaItem, key, target, objProp) {
        let asn1Item;
        if (typeof schemaItem.type === "number") {
            const converter = schemaItem.converter;
            if (!converter) {
                throw new Error(`Property '${key}' doesn't have converter for type ${AsnPropTypes[schemaItem.type]} in schema '${target.name}'`);
            }
            if (schemaItem.repeated) {
                if (!Array.isArray(objProp)) {
                    throw new TypeError("Parameter 'objProp' should be type of Array.");
                }
                const items = Array.from(objProp, (element) => converter.toASN(element));
                const Container = schemaItem.repeated === "sequence" ? index_es["Sequence"] : index_es["Set"];
                asn1Item = new Container({
                    value: items,
                });
            }
            else {
                asn1Item = converter.toASN(objProp);
            }
        }
        else {
            if (schemaItem.repeated) {
                if (!Array.isArray(objProp)) {
                    throw new TypeError("Parameter 'objProp' should be type of Array.");
                }
                const items = Array.from(objProp, (element) => this.toASN(element));
                const Container = schemaItem.repeated === "sequence" ? index_es["Sequence"] : index_es["Set"];
                asn1Item = new Container({
                    value: items,
                });
            }
            else {
                asn1Item = this.toASN(objProp);
            }
        }
        return asn1Item;
    }
}

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/objects.js
class AsnArray extends Array {
    constructor(items = []) {
        if (typeof items === "number") {
            super(items);
        }
        else {
            super();
            for (const item of items) {
                this.push(item);
            }
        }
    }
}

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/convert.js




class convert_AsnConvert {
    static serialize(obj) {
        return serializer_AsnSerializer.serialize(obj);
    }
    static parse(data, target) {
        return parser_AsnParser.parse(data, target);
    }
    static toString(data) {
        const buf = build["BufferSourceConverter"].isBufferSource(data)
            ? build["BufferSourceConverter"].toArrayBuffer(data)
            : convert_AsnConvert.serialize(data);
        const asn = index_es["fromBER"](buf);
        if (asn.offset === -1) {
            throw new Error(`Cannot decode ASN.1 data. ${asn.result.error}`);
        }
        return asn.result.toString();
    }
}

// CONCATENATED MODULE: ./node_modules/@peculiar/asn1-schema/build/es2015/index.js











/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * MIT License
 * 
 * Copyright (c) 2017-2024 Peculiar Ventures, LLC
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * 
 */



const ARRAY_BUFFER_NAME = "[object ArrayBuffer]";
class BufferSourceConverter {
    static isArrayBuffer(data) {
        return Object.prototype.toString.call(data) === ARRAY_BUFFER_NAME;
    }
    static toArrayBuffer(data) {
        if (this.isArrayBuffer(data)) {
            return data;
        }
        if (data.byteLength === data.buffer.byteLength) {
            return data.buffer;
        }
        if (data.byteOffset === 0 && data.byteLength === data.buffer.byteLength) {
            return data.buffer;
        }
        return this.toUint8Array(data.buffer)
            .slice(data.byteOffset, data.byteOffset + data.byteLength)
            .buffer;
    }
    static toUint8Array(data) {
        return this.toView(data, Uint8Array);
    }
    static toView(data, type) {
        if (data.constructor === type) {
            return data;
        }
        if (this.isArrayBuffer(data)) {
            return new type(data);
        }
        if (this.isArrayBufferView(data)) {
            return new type(data.buffer, data.byteOffset, data.byteLength);
        }
        throw new TypeError("The provided value is not of type '(ArrayBuffer or ArrayBufferView)'");
    }
    static isBufferSource(data) {
        return this.isArrayBufferView(data)
            || this.isArrayBuffer(data);
    }
    static isArrayBufferView(data) {
        return ArrayBuffer.isView(data)
            || (data && this.isArrayBuffer(data.buffer));
    }
    static isEqual(a, b) {
        const aView = BufferSourceConverter.toUint8Array(a);
        const bView = BufferSourceConverter.toUint8Array(b);
        if (aView.length !== bView.byteLength) {
            return false;
        }
        for (let i = 0; i < aView.length; i++) {
            if (aView[i] !== bView[i]) {
                return false;
            }
        }
        return true;
    }
    static concat(...args) {
        let buffers;
        if (Array.isArray(args[0]) && !(args[1] instanceof Function)) {
            buffers = args[0];
        }
        else if (Array.isArray(args[0]) && args[1] instanceof Function) {
            buffers = args[0];
        }
        else {
            if (args[args.length - 1] instanceof Function) {
                buffers = args.slice(0, args.length - 1);
            }
            else {
                buffers = args;
            }
        }
        let size = 0;
        for (const buffer of buffers) {
            size += buffer.byteLength;
        }
        const res = new Uint8Array(size);
        let offset = 0;
        for (const buffer of buffers) {
            const view = this.toUint8Array(buffer);
            res.set(view, offset);
            offset += view.length;
        }
        if (args[args.length - 1] instanceof Function) {
            return this.toView(res, args[args.length - 1]);
        }
        return res.buffer;
    }
}

const STRING_TYPE = "string";
const HEX_REGEX = /^[0-9a-f\s]+$/i;
const BASE64_REGEX = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
const BASE64URL_REGEX = /^[a-zA-Z0-9-_]+$/;
class Utf8Converter {
    static fromString(text) {
        const s = unescape(encodeURIComponent(text));
        const uintArray = new Uint8Array(s.length);
        for (let i = 0; i < s.length; i++) {
            uintArray[i] = s.charCodeAt(i);
        }
        return uintArray.buffer;
    }
    static toString(buffer) {
        const buf = BufferSourceConverter.toUint8Array(buffer);
        let encodedString = "";
        for (let i = 0; i < buf.length; i++) {
            encodedString += String.fromCharCode(buf[i]);
        }
        const decodedString = decodeURIComponent(escape(encodedString));
        return decodedString;
    }
}
class Utf16Converter {
    static toString(buffer, littleEndian = false) {
        const arrayBuffer = BufferSourceConverter.toArrayBuffer(buffer);
        const dataView = new DataView(arrayBuffer);
        let res = "";
        for (let i = 0; i < arrayBuffer.byteLength; i += 2) {
            const code = dataView.getUint16(i, littleEndian);
            res += String.fromCharCode(code);
        }
        return res;
    }
    static fromString(text, littleEndian = false) {
        const res = new ArrayBuffer(text.length * 2);
        const dataView = new DataView(res);
        for (let i = 0; i < text.length; i++) {
            dataView.setUint16(i * 2, text.charCodeAt(i), littleEndian);
        }
        return res;
    }
}
class Convert {
    static isHex(data) {
        return typeof data === STRING_TYPE
            && HEX_REGEX.test(data);
    }
    static isBase64(data) {
        return typeof data === STRING_TYPE
            && BASE64_REGEX.test(data);
    }
    static isBase64Url(data) {
        return typeof data === STRING_TYPE
            && BASE64URL_REGEX.test(data);
    }
    static ToString(buffer, enc = "utf8") {
        const buf = BufferSourceConverter.toUint8Array(buffer);
        switch (enc.toLowerCase()) {
            case "utf8":
                return this.ToUtf8String(buf);
            case "binary":
                return this.ToBinary(buf);
            case "hex":
                return this.ToHex(buf);
            case "base64":
                return this.ToBase64(buf);
            case "base64url":
                return this.ToBase64Url(buf);
            case "utf16le":
                return Utf16Converter.toString(buf, true);
            case "utf16":
            case "utf16be":
                return Utf16Converter.toString(buf);
            default:
                throw new Error(`Unknown type of encoding '${enc}'`);
        }
    }
    static FromString(str, enc = "utf8") {
        if (!str) {
            return new ArrayBuffer(0);
        }
        switch (enc.toLowerCase()) {
            case "utf8":
                return this.FromUtf8String(str);
            case "binary":
                return this.FromBinary(str);
            case "hex":
                return this.FromHex(str);
            case "base64":
                return this.FromBase64(str);
            case "base64url":
                return this.FromBase64Url(str);
            case "utf16le":
                return Utf16Converter.fromString(str, true);
            case "utf16":
            case "utf16be":
                return Utf16Converter.fromString(str);
            default:
                throw new Error(`Unknown type of encoding '${enc}'`);
        }
    }
    static ToBase64(buffer) {
        const buf = BufferSourceConverter.toUint8Array(buffer);
        if (typeof btoa !== "undefined") {
            const binary = this.ToString(buf, "binary");
            return btoa(binary);
        }
        else {
            return Buffer.from(buf).toString("base64");
        }
    }
    static FromBase64(base64) {
        const formatted = this.formatString(base64);
        if (!formatted) {
            return new ArrayBuffer(0);
        }
        if (!Convert.isBase64(formatted)) {
            throw new TypeError("Argument 'base64Text' is not Base64 encoded");
        }
        if (typeof atob !== "undefined") {
            return this.FromBinary(atob(formatted));
        }
        else {
            return new Uint8Array(Buffer.from(formatted, "base64")).buffer;
        }
    }
    static FromBase64Url(base64url) {
        const formatted = this.formatString(base64url);
        if (!formatted) {
            return new ArrayBuffer(0);
        }
        if (!Convert.isBase64Url(formatted)) {
            throw new TypeError("Argument 'base64url' is not Base64Url encoded");
        }
        return this.FromBase64(this.Base64Padding(formatted.replace(/\-/g, "+").replace(/\_/g, "/")));
    }
    static ToBase64Url(data) {
        return this.ToBase64(data).replace(/\+/g, "-").replace(/\//g, "_").replace(/\=/g, "");
    }
    static FromUtf8String(text, encoding = Convert.DEFAULT_UTF8_ENCODING) {
        switch (encoding) {
            case "ascii":
                return this.FromBinary(text);
            case "utf8":
                return Utf8Converter.fromString(text);
            case "utf16":
            case "utf16be":
                return Utf16Converter.fromString(text);
            case "utf16le":
            case "usc2":
                return Utf16Converter.fromString(text, true);
            default:
                throw new Error(`Unknown type of encoding '${encoding}'`);
        }
    }
    static ToUtf8String(buffer, encoding = Convert.DEFAULT_UTF8_ENCODING) {
        switch (encoding) {
            case "ascii":
                return this.ToBinary(buffer);
            case "utf8":
                return Utf8Converter.toString(buffer);
            case "utf16":
            case "utf16be":
                return Utf16Converter.toString(buffer);
            case "utf16le":
            case "usc2":
                return Utf16Converter.toString(buffer, true);
            default:
                throw new Error(`Unknown type of encoding '${encoding}'`);
        }
    }
    static FromBinary(text) {
        const stringLength = text.length;
        const resultView = new Uint8Array(stringLength);
        for (let i = 0; i < stringLength; i++) {
            resultView[i] = text.charCodeAt(i);
        }
        return resultView.buffer;
    }
    static ToBinary(buffer) {
        const buf = BufferSourceConverter.toUint8Array(buffer);
        let res = "";
        for (let i = 0; i < buf.length; i++) {
            res += String.fromCharCode(buf[i]);
        }
        return res;
    }
    static ToHex(buffer) {
        const buf = BufferSourceConverter.toUint8Array(buffer);
        let result = "";
        const len = buf.length;
        for (let i = 0; i < len; i++) {
            const byte = buf[i];
            if (byte < 16) {
                result += "0";
            }
            result += byte.toString(16);
        }
        return result;
    }
    static FromHex(hexString) {
        let formatted = this.formatString(hexString);
        if (!formatted) {
            return new ArrayBuffer(0);
        }
        if (!Convert.isHex(formatted)) {
            throw new TypeError("Argument 'hexString' is not HEX encoded");
        }
        if (formatted.length % 2) {
            formatted = `0${formatted}`;
        }
        const res = new Uint8Array(formatted.length / 2);
        for (let i = 0; i < formatted.length; i = i + 2) {
            const c = formatted.slice(i, i + 2);
            res[i / 2] = parseInt(c, 16);
        }
        return res.buffer;
    }
    static ToUtf16String(buffer, littleEndian = false) {
        return Utf16Converter.toString(buffer, littleEndian);
    }
    static FromUtf16String(text, littleEndian = false) {
        return Utf16Converter.fromString(text, littleEndian);
    }
    static Base64Padding(base64) {
        const padCount = 4 - (base64.length % 4);
        if (padCount < 4) {
            for (let i = 0; i < padCount; i++) {
                base64 += "=";
            }
        }
        return base64;
    }
    static formatString(data) {
        return (data === null || data === void 0 ? void 0 : data.replace(/[\n\r\t ]/g, "")) || "";
    }
}
Convert.DEFAULT_UTF8_ENCODING = "utf8";

function assign(target, ...sources) {
    const res = arguments[0];
    for (let i = 1; i < arguments.length; i++) {
        const obj = arguments[i];
        for (const prop in obj) {
            res[prop] = obj[prop];
        }
    }
    return res;
}
function combine(...buf) {
    const totalByteLength = buf.map((item) => item.byteLength).reduce((prev, cur) => prev + cur);
    const res = new Uint8Array(totalByteLength);
    let currentPos = 0;
    buf.map((item) => new Uint8Array(item)).forEach((arr) => {
        for (const item2 of arr) {
            res[currentPos++] = item2;
        }
    });
    return res.buffer;
}
function isEqual(bytes1, bytes2) {
    if (!(bytes1 && bytes2)) {
        return false;
    }
    if (bytes1.byteLength !== bytes2.byteLength) {
        return false;
    }
    const b1 = new Uint8Array(bytes1);
    const b2 = new Uint8Array(bytes2);
    for (let i = 0; i < bytes1.byteLength; i++) {
        if (b1[i] !== b2[i]) {
            return false;
        }
    }
    return true;
}

exports.BufferSourceConverter = BufferSourceConverter;
exports.Convert = Convert;
exports.assign = assign;
exports.combine = combine;
exports.isEqual = isEqual;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(265)
var ieee754 = __webpack_require__(266)
var isArray = __webpack_require__(180)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(39)))

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Any", function() { return /* binding */ Any; });
__webpack_require__.d(__webpack_exports__, "BaseBlock", function() { return /* binding */ index_es_BaseBlock; });
__webpack_require__.d(__webpack_exports__, "BaseStringBlock", function() { return /* binding */ BaseStringBlock; });
__webpack_require__.d(__webpack_exports__, "BitString", function() { return /* binding */ BitString; });
__webpack_require__.d(__webpack_exports__, "BmpString", function() { return /* binding */ BmpString; });
__webpack_require__.d(__webpack_exports__, "Boolean", function() { return /* binding */ Boolean; });
__webpack_require__.d(__webpack_exports__, "CharacterString", function() { return /* binding */ CharacterString; });
__webpack_require__.d(__webpack_exports__, "Choice", function() { return /* binding */ Choice; });
__webpack_require__.d(__webpack_exports__, "Constructed", function() { return /* binding */ Constructed; });
__webpack_require__.d(__webpack_exports__, "DATE", function() { return /* binding */ DATE; });
__webpack_require__.d(__webpack_exports__, "DateTime", function() { return /* binding */ DateTime; });
__webpack_require__.d(__webpack_exports__, "Duration", function() { return /* binding */ Duration; });
__webpack_require__.d(__webpack_exports__, "EndOfContent", function() { return /* binding */ EndOfContent; });
__webpack_require__.d(__webpack_exports__, "Enumerated", function() { return /* binding */ Enumerated; });
__webpack_require__.d(__webpack_exports__, "GeneralString", function() { return /* binding */ GeneralString; });
__webpack_require__.d(__webpack_exports__, "GeneralizedTime", function() { return /* binding */ index_es_GeneralizedTime; });
__webpack_require__.d(__webpack_exports__, "GraphicString", function() { return /* binding */ GraphicString; });
__webpack_require__.d(__webpack_exports__, "HexBlock", function() { return /* binding */ HexBlock; });
__webpack_require__.d(__webpack_exports__, "IA5String", function() { return /* binding */ IA5String; });
__webpack_require__.d(__webpack_exports__, "Integer", function() { return /* binding */ index_es_Integer; });
__webpack_require__.d(__webpack_exports__, "Null", function() { return /* binding */ Null; });
__webpack_require__.d(__webpack_exports__, "NumericString", function() { return /* binding */ NumericString; });
__webpack_require__.d(__webpack_exports__, "ObjectIdentifier", function() { return /* binding */ ObjectIdentifier; });
__webpack_require__.d(__webpack_exports__, "OctetString", function() { return /* binding */ index_es_OctetString; });
__webpack_require__.d(__webpack_exports__, "Primitive", function() { return /* binding */ Primitive; });
__webpack_require__.d(__webpack_exports__, "PrintableString", function() { return /* binding */ PrintableString; });
__webpack_require__.d(__webpack_exports__, "RawData", function() { return /* binding */ index_es_RawData; });
__webpack_require__.d(__webpack_exports__, "RelativeObjectIdentifier", function() { return /* binding */ RelativeObjectIdentifier; });
__webpack_require__.d(__webpack_exports__, "Repeated", function() { return /* binding */ Repeated; });
__webpack_require__.d(__webpack_exports__, "Sequence", function() { return /* binding */ Sequence; });
__webpack_require__.d(__webpack_exports__, "Set", function() { return /* binding */ Set; });
__webpack_require__.d(__webpack_exports__, "TIME", function() { return /* binding */ TIME; });
__webpack_require__.d(__webpack_exports__, "TeletexString", function() { return /* binding */ TeletexString; });
__webpack_require__.d(__webpack_exports__, "TimeOfDay", function() { return /* binding */ TimeOfDay; });
__webpack_require__.d(__webpack_exports__, "UTCTime", function() { return /* binding */ index_es_UTCTime; });
__webpack_require__.d(__webpack_exports__, "UniversalString", function() { return /* binding */ UniversalString; });
__webpack_require__.d(__webpack_exports__, "Utf8String", function() { return /* binding */ Utf8String; });
__webpack_require__.d(__webpack_exports__, "ValueBlock", function() { return /* binding */ ValueBlock; });
__webpack_require__.d(__webpack_exports__, "VideotexString", function() { return /* binding */ VideotexString; });
__webpack_require__.d(__webpack_exports__, "ViewWriter", function() { return /* binding */ ViewWriter; });
__webpack_require__.d(__webpack_exports__, "VisibleString", function() { return /* binding */ VisibleString; });
__webpack_require__.d(__webpack_exports__, "compareSchema", function() { return /* binding */ compareSchema; });
__webpack_require__.d(__webpack_exports__, "fromBER", function() { return /* binding */ fromBER; });
__webpack_require__.d(__webpack_exports__, "verifySchema", function() { return /* binding */ verifySchema; });

// EXTERNAL MODULE: ./node_modules/pvtsutils/build/index.js
var build = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/pvutils/build/utils.es.js
/*!
 Copyright (c) Peculiar Ventures, LLC
*/

function getUTCDate(date) {
    return new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
}
function getParametersValue(parameters, name, defaultValue) {
    var _a;
    if ((parameters instanceof Object) === false) {
        return defaultValue;
    }
    return (_a = parameters[name]) !== null && _a !== void 0 ? _a : defaultValue;
}
function bufferToHexCodes(inputBuffer, inputOffset = 0, inputLength = (inputBuffer.byteLength - inputOffset), insertSpace = false) {
    let result = "";
    for (const item of (new Uint8Array(inputBuffer, inputOffset, inputLength))) {
        const str = item.toString(16).toUpperCase();
        if (str.length === 1) {
            result += "0";
        }
        result += str;
        if (insertSpace) {
            result += " ";
        }
    }
    return result.trim();
}
function checkBufferParams(baseBlock, inputBuffer, inputOffset, inputLength) {
    if (!(inputBuffer instanceof ArrayBuffer)) {
        baseBlock.error = "Wrong parameter: inputBuffer must be \"ArrayBuffer\"";
        return false;
    }
    if (!inputBuffer.byteLength) {
        baseBlock.error = "Wrong parameter: inputBuffer has zero length";
        return false;
    }
    if (inputOffset < 0) {
        baseBlock.error = "Wrong parameter: inputOffset less than zero";
        return false;
    }
    if (inputLength < 0) {
        baseBlock.error = "Wrong parameter: inputLength less than zero";
        return false;
    }
    if ((inputBuffer.byteLength - inputOffset - inputLength) < 0) {
        baseBlock.error = "End of input reached before message was fully decoded (inconsistent offset and length values)";
        return false;
    }
    return true;
}
function utilFromBase(inputBuffer, inputBase) {
    let result = 0;
    if (inputBuffer.length === 1) {
        return inputBuffer[0];
    }
    for (let i = (inputBuffer.length - 1); i >= 0; i--) {
        result += inputBuffer[(inputBuffer.length - 1) - i] * Math.pow(2, inputBase * i);
    }
    return result;
}
function utilToBase(value, base, reserved = (-1)) {
    const internalReserved = reserved;
    let internalValue = value;
    let result = 0;
    let biggest = Math.pow(2, base);
    for (let i = 1; i < 8; i++) {
        if (value < biggest) {
            let retBuf;
            if (internalReserved < 0) {
                retBuf = new ArrayBuffer(i);
                result = i;
            }
            else {
                if (internalReserved < i) {
                    return (new ArrayBuffer(0));
                }
                retBuf = new ArrayBuffer(internalReserved);
                result = internalReserved;
            }
            const retView = new Uint8Array(retBuf);
            for (let j = (i - 1); j >= 0; j--) {
                const basis = Math.pow(2, j * base);
                retView[result - j - 1] = Math.floor(internalValue / basis);
                internalValue -= (retView[result - j - 1]) * basis;
            }
            return retBuf;
        }
        biggest *= Math.pow(2, base);
    }
    return new ArrayBuffer(0);
}
function utilConcatBuf(...buffers) {
    let outputLength = 0;
    let prevLength = 0;
    for (const buffer of buffers) {
        outputLength += buffer.byteLength;
    }
    const retBuf = new ArrayBuffer(outputLength);
    const retView = new Uint8Array(retBuf);
    for (const buffer of buffers) {
        retView.set(new Uint8Array(buffer), prevLength);
        prevLength += buffer.byteLength;
    }
    return retBuf;
}
function utilConcatView(...views) {
    let outputLength = 0;
    let prevLength = 0;
    for (const view of views) {
        outputLength += view.length;
    }
    const retBuf = new ArrayBuffer(outputLength);
    const retView = new Uint8Array(retBuf);
    for (const view of views) {
        retView.set(view, prevLength);
        prevLength += view.length;
    }
    return retView;
}
function utilDecodeTC() {
    const buf = new Uint8Array(this.valueHex);
    if (this.valueHex.byteLength >= 2) {
        const condition1 = (buf[0] === 0xFF) && (buf[1] & 0x80);
        const condition2 = (buf[0] === 0x00) && ((buf[1] & 0x80) === 0x00);
        if (condition1 || condition2) {
            this.warnings.push("Needlessly long format");
        }
    }
    const bigIntBuffer = new ArrayBuffer(this.valueHex.byteLength);
    const bigIntView = new Uint8Array(bigIntBuffer);
    for (let i = 0; i < this.valueHex.byteLength; i++) {
        bigIntView[i] = 0;
    }
    bigIntView[0] = (buf[0] & 0x80);
    const bigInt = utilFromBase(bigIntView, 8);
    const smallIntBuffer = new ArrayBuffer(this.valueHex.byteLength);
    const smallIntView = new Uint8Array(smallIntBuffer);
    for (let j = 0; j < this.valueHex.byteLength; j++) {
        smallIntView[j] = buf[j];
    }
    smallIntView[0] &= 0x7F;
    const smallInt = utilFromBase(smallIntView, 8);
    return (smallInt - bigInt);
}
function utilEncodeTC(value) {
    const modValue = (value < 0) ? (value * (-1)) : value;
    let bigInt = 128;
    for (let i = 1; i < 8; i++) {
        if (modValue <= bigInt) {
            if (value < 0) {
                const smallInt = bigInt - modValue;
                const retBuf = utilToBase(smallInt, 8, i);
                const retView = new Uint8Array(retBuf);
                retView[0] |= 0x80;
                return retBuf;
            }
            let retBuf = utilToBase(modValue, 8, i);
            let retView = new Uint8Array(retBuf);
            if (retView[0] & 0x80) {
                const tempBuf = retBuf.slice(0);
                const tempView = new Uint8Array(tempBuf);
                retBuf = new ArrayBuffer(retBuf.byteLength + 1);
                retView = new Uint8Array(retBuf);
                for (let k = 0; k < tempBuf.byteLength; k++) {
                    retView[k + 1] = tempView[k];
                }
                retView[0] = 0x00;
            }
            return retBuf;
        }
        bigInt *= Math.pow(2, 8);
    }
    return (new ArrayBuffer(0));
}
function isEqualBuffer(inputBuffer1, inputBuffer2) {
    if (inputBuffer1.byteLength !== inputBuffer2.byteLength) {
        return false;
    }
    const view1 = new Uint8Array(inputBuffer1);
    const view2 = new Uint8Array(inputBuffer2);
    for (let i = 0; i < view1.length; i++) {
        if (view1[i] !== view2[i]) {
            return false;
        }
    }
    return true;
}
function padNumber(inputNumber, fullLength) {
    const str = inputNumber.toString(10);
    if (fullLength < str.length) {
        return "";
    }
    const dif = fullLength - str.length;
    const padding = new Array(dif);
    for (let i = 0; i < dif; i++) {
        padding[i] = "0";
    }
    const paddingString = padding.join("");
    return paddingString.concat(str);
}
const base64Template = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const base64UrlTemplate = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=";
function toBase64(input, useUrlTemplate = false, skipPadding = false, skipLeadingZeros = false) {
    let i = 0;
    let flag1 = 0;
    let flag2 = 0;
    let output = "";
    const template = (useUrlTemplate) ? base64UrlTemplate : base64Template;
    if (skipLeadingZeros) {
        let nonZeroPosition = 0;
        for (let i = 0; i < input.length; i++) {
            if (input.charCodeAt(i) !== 0) {
                nonZeroPosition = i;
                break;
            }
        }
        input = input.slice(nonZeroPosition);
    }
    while (i < input.length) {
        const chr1 = input.charCodeAt(i++);
        if (i >= input.length) {
            flag1 = 1;
        }
        const chr2 = input.charCodeAt(i++);
        if (i >= input.length) {
            flag2 = 1;
        }
        const chr3 = input.charCodeAt(i++);
        const enc1 = chr1 >> 2;
        const enc2 = ((chr1 & 0x03) << 4) | (chr2 >> 4);
        let enc3 = ((chr2 & 0x0F) << 2) | (chr3 >> 6);
        let enc4 = chr3 & 0x3F;
        if (flag1 === 1) {
            enc3 = enc4 = 64;
        }
        else {
            if (flag2 === 1) {
                enc4 = 64;
            }
        }
        if (skipPadding) {
            if (enc3 === 64) {
                output += `${template.charAt(enc1)}${template.charAt(enc2)}`;
            }
            else {
                if (enc4 === 64) {
                    output += `${template.charAt(enc1)}${template.charAt(enc2)}${template.charAt(enc3)}`;
                }
                else {
                    output += `${template.charAt(enc1)}${template.charAt(enc2)}${template.charAt(enc3)}${template.charAt(enc4)}`;
                }
            }
        }
        else {
            output += `${template.charAt(enc1)}${template.charAt(enc2)}${template.charAt(enc3)}${template.charAt(enc4)}`;
        }
    }
    return output;
}
function fromBase64(input, useUrlTemplate = false, cutTailZeros = false) {
    const template = (useUrlTemplate) ? base64UrlTemplate : base64Template;
    function indexOf(toSearch) {
        for (let i = 0; i < 64; i++) {
            if (template.charAt(i) === toSearch)
                return i;
        }
        return 64;
    }
    function test(incoming) {
        return ((incoming === 64) ? 0x00 : incoming);
    }
    let i = 0;
    let output = "";
    while (i < input.length) {
        const enc1 = indexOf(input.charAt(i++));
        const enc2 = (i >= input.length) ? 0x00 : indexOf(input.charAt(i++));
        const enc3 = (i >= input.length) ? 0x00 : indexOf(input.charAt(i++));
        const enc4 = (i >= input.length) ? 0x00 : indexOf(input.charAt(i++));
        const chr1 = (test(enc1) << 2) | (test(enc2) >> 4);
        const chr2 = ((test(enc2) & 0x0F) << 4) | (test(enc3) >> 2);
        const chr3 = ((test(enc3) & 0x03) << 6) | test(enc4);
        output += String.fromCharCode(chr1);
        if (enc3 !== 64) {
            output += String.fromCharCode(chr2);
        }
        if (enc4 !== 64) {
            output += String.fromCharCode(chr3);
        }
    }
    if (cutTailZeros) {
        const outputLength = output.length;
        let nonZeroStart = (-1);
        for (let i = (outputLength - 1); i >= 0; i--) {
            if (output.charCodeAt(i) !== 0) {
                nonZeroStart = i;
                break;
            }
        }
        if (nonZeroStart !== (-1)) {
            output = output.slice(0, nonZeroStart + 1);
        }
        else {
            output = "";
        }
    }
    return output;
}
function arrayBufferToString(buffer) {
    let resultString = "";
    const view = new Uint8Array(buffer);
    for (const element of view) {
        resultString += String.fromCharCode(element);
    }
    return resultString;
}
function stringToArrayBuffer(str) {
    const stringLength = str.length;
    const resultBuffer = new ArrayBuffer(stringLength);
    const resultView = new Uint8Array(resultBuffer);
    for (let i = 0; i < stringLength; i++) {
        resultView[i] = str.charCodeAt(i);
    }
    return resultBuffer;
}
const log2 = Math.log(2);
function nearestPowerOf2(length) {
    const base = (Math.log(length) / log2);
    const floor = Math.floor(base);
    const round = Math.round(base);
    return ((floor === round) ? floor : round);
}
function clearProps(object, propsArray) {
    for (const prop of propsArray) {
        delete object[prop];
    }
}



// CONCATENATED MODULE: ./node_modules/asn1js/build/index.es.js
/*!
 * Copyright (c) 2014, GMO GlobalSign
 * Copyright (c) 2015-2022, Peculiar Ventures
 * All rights reserved.
 * 
 * Author 2014-2019, Yury Strozhevsky
 * 
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 * 
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 * 
 * * Redistributions in binary form must reproduce the above copyright notice, this
 *   list of conditions and the following disclaimer in the documentation and/or
 *   other materials provided with the distribution.
 * 
 * * Neither the name of the copyright holder nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * 
 */




function assertBigInt() {
    if (typeof BigInt === "undefined") {
        throw new Error("BigInt is not defined. Your environment doesn't implement BigInt.");
    }
}
function concat(buffers) {
    let outputLength = 0;
    let prevLength = 0;
    for (let i = 0; i < buffers.length; i++) {
        const buffer = buffers[i];
        outputLength += buffer.byteLength;
    }
    const retView = new Uint8Array(outputLength);
    for (let i = 0; i < buffers.length; i++) {
        const buffer = buffers[i];
        retView.set(new Uint8Array(buffer), prevLength);
        prevLength += buffer.byteLength;
    }
    return retView.buffer;
}
function index_es_checkBufferParams(baseBlock, inputBuffer, inputOffset, inputLength) {
    if (!(inputBuffer instanceof Uint8Array)) {
        baseBlock.error = "Wrong parameter: inputBuffer must be 'Uint8Array'";
        return false;
    }
    if (!inputBuffer.byteLength) {
        baseBlock.error = "Wrong parameter: inputBuffer has zero length";
        return false;
    }
    if (inputOffset < 0) {
        baseBlock.error = "Wrong parameter: inputOffset less than zero";
        return false;
    }
    if (inputLength < 0) {
        baseBlock.error = "Wrong parameter: inputLength less than zero";
        return false;
    }
    if ((inputBuffer.byteLength - inputOffset - inputLength) < 0) {
        baseBlock.error = "End of input reached before message was fully decoded (inconsistent offset and length values)";
        return false;
    }
    return true;
}

class ViewWriter {
    constructor() {
        this.items = [];
    }
    write(buf) {
        this.items.push(buf);
    }
    final() {
        return concat(this.items);
    }
}

const powers2 = [new Uint8Array([1])];
const digitsString = "0123456789";
const NAME = "name";
const VALUE_HEX_VIEW = "valueHexView";
const IS_HEX_ONLY = "isHexOnly";
const ID_BLOCK = "idBlock";
const TAG_CLASS = "tagClass";
const TAG_NUMBER = "tagNumber";
const IS_CONSTRUCTED = "isConstructed";
const FROM_BER = "fromBER";
const TO_BER = "toBER";
const LOCAL = "local";
const EMPTY_STRING = "";
const EMPTY_BUFFER = new ArrayBuffer(0);
const EMPTY_VIEW = new Uint8Array(0);
const END_OF_CONTENT_NAME = "EndOfContent";
const OCTET_STRING_NAME = "OCTET STRING";
const BIT_STRING_NAME = "BIT STRING";

function HexBlock(BaseClass) {
    var _a;
    return _a = class Some extends BaseClass {
            constructor(...args) {
                var _a;
                super(...args);
                const params = args[0] || {};
                this.isHexOnly = (_a = params.isHexOnly) !== null && _a !== void 0 ? _a : false;
                this.valueHexView = params.valueHex ? build["BufferSourceConverter"].toUint8Array(params.valueHex) : EMPTY_VIEW;
            }
            get valueHex() {
                return this.valueHexView.slice().buffer;
            }
            set valueHex(value) {
                this.valueHexView = new Uint8Array(value);
            }
            fromBER(inputBuffer, inputOffset, inputLength) {
                const view = inputBuffer instanceof ArrayBuffer ? new Uint8Array(inputBuffer) : inputBuffer;
                if (!index_es_checkBufferParams(this, view, inputOffset, inputLength)) {
                    return -1;
                }
                const endLength = inputOffset + inputLength;
                this.valueHexView = view.subarray(inputOffset, endLength);
                if (!this.valueHexView.length) {
                    this.warnings.push("Zero buffer length");
                    return inputOffset;
                }
                this.blockLength = inputLength;
                return endLength;
            }
            toBER(sizeOnly = false) {
                if (!this.isHexOnly) {
                    this.error = "Flag 'isHexOnly' is not set, abort";
                    return EMPTY_BUFFER;
                }
                if (sizeOnly) {
                    return new ArrayBuffer(this.valueHexView.byteLength);
                }
                return (this.valueHexView.byteLength === this.valueHexView.buffer.byteLength)
                    ? this.valueHexView.buffer
                    : this.valueHexView.slice().buffer;
            }
            toJSON() {
                return {
                    ...super.toJSON(),
                    isHexOnly: this.isHexOnly,
                    valueHex: build["Convert"].ToHex(this.valueHexView),
                };
            }
        },
        _a.NAME = "hexBlock",
        _a;
}

class index_es_LocalBaseBlock {
    constructor({ blockLength = 0, error = EMPTY_STRING, warnings = [], valueBeforeDecode = EMPTY_VIEW, } = {}) {
        this.blockLength = blockLength;
        this.error = error;
        this.warnings = warnings;
        this.valueBeforeDecodeView = build["BufferSourceConverter"].toUint8Array(valueBeforeDecode);
    }
    static blockName() {
        return this.NAME;
    }
    get valueBeforeDecode() {
        return this.valueBeforeDecodeView.slice().buffer;
    }
    set valueBeforeDecode(value) {
        this.valueBeforeDecodeView = new Uint8Array(value);
    }
    toJSON() {
        return {
            blockName: this.constructor.NAME,
            blockLength: this.blockLength,
            error: this.error,
            warnings: this.warnings,
            valueBeforeDecode: build["Convert"].ToHex(this.valueBeforeDecodeView),
        };
    }
}
index_es_LocalBaseBlock.NAME = "baseBlock";

class ValueBlock extends index_es_LocalBaseBlock {
    fromBER(inputBuffer, inputOffset, inputLength) {
        throw TypeError("User need to make a specific function in a class which extends 'ValueBlock'");
    }
    toBER(sizeOnly, writer) {
        throw TypeError("User need to make a specific function in a class which extends 'ValueBlock'");
    }
}
ValueBlock.NAME = "valueBlock";

class index_es_LocalIdentificationBlock extends HexBlock(index_es_LocalBaseBlock) {
    constructor({ idBlock = {}, } = {}) {
        var _a, _b, _c, _d;
        super();
        if (idBlock) {
            this.isHexOnly = (_a = idBlock.isHexOnly) !== null && _a !== void 0 ? _a : false;
            this.valueHexView = idBlock.valueHex ? build["BufferSourceConverter"].toUint8Array(idBlock.valueHex) : EMPTY_VIEW;
            this.tagClass = (_b = idBlock.tagClass) !== null && _b !== void 0 ? _b : -1;
            this.tagNumber = (_c = idBlock.tagNumber) !== null && _c !== void 0 ? _c : -1;
            this.isConstructed = (_d = idBlock.isConstructed) !== null && _d !== void 0 ? _d : false;
        }
        else {
            this.tagClass = -1;
            this.tagNumber = -1;
            this.isConstructed = false;
        }
    }
    toBER(sizeOnly = false) {
        let firstOctet = 0;
        switch (this.tagClass) {
            case 1:
                firstOctet |= 0x00;
                break;
            case 2:
                firstOctet |= 0x40;
                break;
            case 3:
                firstOctet |= 0x80;
                break;
            case 4:
                firstOctet |= 0xC0;
                break;
            default:
                this.error = "Unknown tag class";
                return EMPTY_BUFFER;
        }
        if (this.isConstructed)
            firstOctet |= 0x20;
        if (this.tagNumber < 31 && !this.isHexOnly) {
            const retView = new Uint8Array(1);
            if (!sizeOnly) {
                let number = this.tagNumber;
                number &= 0x1F;
                firstOctet |= number;
                retView[0] = firstOctet;
            }
            return retView.buffer;
        }
        if (!this.isHexOnly) {
            const encodedBuf = utilToBase(this.tagNumber, 7);
            const encodedView = new Uint8Array(encodedBuf);
            const size = encodedBuf.byteLength;
            const retView = new Uint8Array(size + 1);
            retView[0] = (firstOctet | 0x1F);
            if (!sizeOnly) {
                for (let i = 0; i < (size - 1); i++)
                    retView[i + 1] = encodedView[i] | 0x80;
                retView[size] = encodedView[size - 1];
            }
            return retView.buffer;
        }
        const retView = new Uint8Array(this.valueHexView.byteLength + 1);
        retView[0] = (firstOctet | 0x1F);
        if (!sizeOnly) {
            const curView = this.valueHexView;
            for (let i = 0; i < (curView.length - 1); i++)
                retView[i + 1] = curView[i] | 0x80;
            retView[this.valueHexView.byteLength] = curView[curView.length - 1];
        }
        return retView.buffer;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        const inputView = build["BufferSourceConverter"].toUint8Array(inputBuffer);
        if (!index_es_checkBufferParams(this, inputView, inputOffset, inputLength)) {
            return -1;
        }
        const intBuffer = inputView.subarray(inputOffset, inputOffset + inputLength);
        if (intBuffer.length === 0) {
            this.error = "Zero buffer length";
            return -1;
        }
        const tagClassMask = intBuffer[0] & 0xC0;
        switch (tagClassMask) {
            case 0x00:
                this.tagClass = (1);
                break;
            case 0x40:
                this.tagClass = (2);
                break;
            case 0x80:
                this.tagClass = (3);
                break;
            case 0xC0:
                this.tagClass = (4);
                break;
            default:
                this.error = "Unknown tag class";
                return -1;
        }
        this.isConstructed = (intBuffer[0] & 0x20) === 0x20;
        this.isHexOnly = false;
        const tagNumberMask = intBuffer[0] & 0x1F;
        if (tagNumberMask !== 0x1F) {
            this.tagNumber = (tagNumberMask);
            this.blockLength = 1;
        }
        else {
            let count = 1;
            let intTagNumberBuffer = this.valueHexView = new Uint8Array(255);
            let tagNumberBufferMaxLength = 255;
            while (intBuffer[count] & 0x80) {
                intTagNumberBuffer[count - 1] = intBuffer[count] & 0x7F;
                count++;
                if (count >= intBuffer.length) {
                    this.error = "End of input reached before message was fully decoded";
                    return -1;
                }
                if (count === tagNumberBufferMaxLength) {
                    tagNumberBufferMaxLength += 255;
                    const tempBufferView = new Uint8Array(tagNumberBufferMaxLength);
                    for (let i = 0; i < intTagNumberBuffer.length; i++)
                        tempBufferView[i] = intTagNumberBuffer[i];
                    intTagNumberBuffer = this.valueHexView = new Uint8Array(tagNumberBufferMaxLength);
                }
            }
            this.blockLength = (count + 1);
            intTagNumberBuffer[count - 1] = intBuffer[count] & 0x7F;
            const tempBufferView = new Uint8Array(count);
            for (let i = 0; i < count; i++)
                tempBufferView[i] = intTagNumberBuffer[i];
            intTagNumberBuffer = this.valueHexView = new Uint8Array(count);
            intTagNumberBuffer.set(tempBufferView);
            if (this.blockLength <= 9)
                this.tagNumber = utilFromBase(intTagNumberBuffer, 7);
            else {
                this.isHexOnly = true;
                this.warnings.push("Tag too long, represented as hex-coded");
            }
        }
        if (((this.tagClass === 1)) &&
            (this.isConstructed)) {
            switch (this.tagNumber) {
                case 1:
                case 2:
                case 5:
                case 6:
                case 9:
                case 13:
                case 14:
                case 23:
                case 24:
                case 31:
                case 32:
                case 33:
                case 34:
                    this.error = "Constructed encoding used for primitive type";
                    return -1;
            }
        }
        return (inputOffset + this.blockLength);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            tagClass: this.tagClass,
            tagNumber: this.tagNumber,
            isConstructed: this.isConstructed,
        };
    }
}
index_es_LocalIdentificationBlock.NAME = "identificationBlock";

class index_es_LocalLengthBlock extends index_es_LocalBaseBlock {
    constructor({ lenBlock = {}, } = {}) {
        var _a, _b, _c;
        super();
        this.isIndefiniteForm = (_a = lenBlock.isIndefiniteForm) !== null && _a !== void 0 ? _a : false;
        this.longFormUsed = (_b = lenBlock.longFormUsed) !== null && _b !== void 0 ? _b : false;
        this.length = (_c = lenBlock.length) !== null && _c !== void 0 ? _c : 0;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        const view = build["BufferSourceConverter"].toUint8Array(inputBuffer);
        if (!index_es_checkBufferParams(this, view, inputOffset, inputLength)) {
            return -1;
        }
        const intBuffer = view.subarray(inputOffset, inputOffset + inputLength);
        if (intBuffer.length === 0) {
            this.error = "Zero buffer length";
            return -1;
        }
        if (intBuffer[0] === 0xFF) {
            this.error = "Length block 0xFF is reserved by standard";
            return -1;
        }
        this.isIndefiniteForm = intBuffer[0] === 0x80;
        if (this.isIndefiniteForm) {
            this.blockLength = 1;
            return (inputOffset + this.blockLength);
        }
        this.longFormUsed = !!(intBuffer[0] & 0x80);
        if (this.longFormUsed === false) {
            this.length = (intBuffer[0]);
            this.blockLength = 1;
            return (inputOffset + this.blockLength);
        }
        const count = intBuffer[0] & 0x7F;
        if (count > 8) {
            this.error = "Too big integer";
            return -1;
        }
        if ((count + 1) > intBuffer.length) {
            this.error = "End of input reached before message was fully decoded";
            return -1;
        }
        const lenOffset = inputOffset + 1;
        const lengthBufferView = view.subarray(lenOffset, lenOffset + count);
        if (lengthBufferView[count - 1] === 0x00)
            this.warnings.push("Needlessly long encoded length");
        this.length = utilFromBase(lengthBufferView, 8);
        if (this.longFormUsed && (this.length <= 127))
            this.warnings.push("Unnecessary usage of long length form");
        this.blockLength = count + 1;
        return (inputOffset + this.blockLength);
    }
    toBER(sizeOnly = false) {
        let retBuf;
        let retView;
        if (this.length > 127)
            this.longFormUsed = true;
        if (this.isIndefiniteForm) {
            retBuf = new ArrayBuffer(1);
            if (sizeOnly === false) {
                retView = new Uint8Array(retBuf);
                retView[0] = 0x80;
            }
            return retBuf;
        }
        if (this.longFormUsed) {
            const encodedBuf = utilToBase(this.length, 8);
            if (encodedBuf.byteLength > 127) {
                this.error = "Too big length";
                return (EMPTY_BUFFER);
            }
            retBuf = new ArrayBuffer(encodedBuf.byteLength + 1);
            if (sizeOnly)
                return retBuf;
            const encodedView = new Uint8Array(encodedBuf);
            retView = new Uint8Array(retBuf);
            retView[0] = encodedBuf.byteLength | 0x80;
            for (let i = 0; i < encodedBuf.byteLength; i++)
                retView[i + 1] = encodedView[i];
            return retBuf;
        }
        retBuf = new ArrayBuffer(1);
        if (sizeOnly === false) {
            retView = new Uint8Array(retBuf);
            retView[0] = this.length;
        }
        return retBuf;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            isIndefiniteForm: this.isIndefiniteForm,
            longFormUsed: this.longFormUsed,
            length: this.length,
        };
    }
}
index_es_LocalLengthBlock.NAME = "lengthBlock";

const typeStore = {};

class index_es_BaseBlock extends index_es_LocalBaseBlock {
    constructor({ name = EMPTY_STRING, optional = false, primitiveSchema, ...parameters } = {}, valueBlockType) {
        super(parameters);
        this.name = name;
        this.optional = optional;
        if (primitiveSchema) {
            this.primitiveSchema = primitiveSchema;
        }
        this.idBlock = new index_es_LocalIdentificationBlock(parameters);
        this.lenBlock = new index_es_LocalLengthBlock(parameters);
        this.valueBlock = valueBlockType ? new valueBlockType(parameters) : new ValueBlock(parameters);
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        const resultOffset = this.valueBlock.fromBER(inputBuffer, inputOffset, (this.lenBlock.isIndefiniteForm) ? inputLength : this.lenBlock.length);
        if (resultOffset === -1) {
            this.error = this.valueBlock.error;
            return resultOffset;
        }
        if (!this.idBlock.error.length)
            this.blockLength += this.idBlock.blockLength;
        if (!this.lenBlock.error.length)
            this.blockLength += this.lenBlock.blockLength;
        if (!this.valueBlock.error.length)
            this.blockLength += this.valueBlock.blockLength;
        return resultOffset;
    }
    toBER(sizeOnly, writer) {
        const _writer = writer || new ViewWriter();
        if (!writer) {
            prepareIndefiniteForm(this);
        }
        const idBlockBuf = this.idBlock.toBER(sizeOnly);
        _writer.write(idBlockBuf);
        if (this.lenBlock.isIndefiniteForm) {
            _writer.write(new Uint8Array([0x80]).buffer);
            this.valueBlock.toBER(sizeOnly, _writer);
            _writer.write(new ArrayBuffer(2));
        }
        else {
            const valueBlockBuf = this.valueBlock.toBER(sizeOnly);
            this.lenBlock.length = valueBlockBuf.byteLength;
            const lenBlockBuf = this.lenBlock.toBER(sizeOnly);
            _writer.write(lenBlockBuf);
            _writer.write(valueBlockBuf);
        }
        if (!writer) {
            return _writer.final();
        }
        return EMPTY_BUFFER;
    }
    toJSON() {
        const object = {
            ...super.toJSON(),
            idBlock: this.idBlock.toJSON(),
            lenBlock: this.lenBlock.toJSON(),
            valueBlock: this.valueBlock.toJSON(),
            name: this.name,
            optional: this.optional,
        };
        if (this.primitiveSchema)
            object.primitiveSchema = this.primitiveSchema.toJSON();
        return object;
    }
    toString(encoding = "ascii") {
        if (encoding === "ascii") {
            return this.onAsciiEncoding();
        }
        return build["Convert"].ToHex(this.toBER());
    }
    onAsciiEncoding() {
        return `${this.constructor.NAME} : ${build["Convert"].ToHex(this.valueBlock.valueBeforeDecodeView)}`;
    }
    isEqual(other) {
        if (this === other) {
            return true;
        }
        if (!(other instanceof this.constructor)) {
            return false;
        }
        const thisRaw = this.toBER();
        const otherRaw = other.toBER();
        return isEqualBuffer(thisRaw, otherRaw);
    }
}
index_es_BaseBlock.NAME = "BaseBlock";
function prepareIndefiniteForm(baseBlock) {
    if (baseBlock instanceof typeStore.Constructed) {
        for (const value of baseBlock.valueBlock.value) {
            if (prepareIndefiniteForm(value)) {
                baseBlock.lenBlock.isIndefiniteForm = true;
            }
        }
    }
    return !!baseBlock.lenBlock.isIndefiniteForm;
}

class BaseStringBlock extends index_es_BaseBlock {
    constructor({ value = EMPTY_STRING, ...parameters } = {}, stringValueBlockType) {
        super(parameters, stringValueBlockType);
        if (value) {
            this.fromString(value);
        }
    }
    getValue() {
        return this.valueBlock.value;
    }
    setValue(value) {
        this.valueBlock.value = value;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        const resultOffset = this.valueBlock.fromBER(inputBuffer, inputOffset, (this.lenBlock.isIndefiniteForm) ? inputLength : this.lenBlock.length);
        if (resultOffset === -1) {
            this.error = this.valueBlock.error;
            return resultOffset;
        }
        this.fromBuffer(this.valueBlock.valueHexView);
        if (!this.idBlock.error.length)
            this.blockLength += this.idBlock.blockLength;
        if (!this.lenBlock.error.length)
            this.blockLength += this.lenBlock.blockLength;
        if (!this.valueBlock.error.length)
            this.blockLength += this.valueBlock.blockLength;
        return resultOffset;
    }
    onAsciiEncoding() {
        return `${this.constructor.NAME} : '${this.valueBlock.value}'`;
    }
}
BaseStringBlock.NAME = "BaseStringBlock";

class LocalPrimitiveValueBlock extends HexBlock(ValueBlock) {
    constructor({ isHexOnly = true, ...parameters } = {}) {
        super(parameters);
        this.isHexOnly = isHexOnly;
    }
}
LocalPrimitiveValueBlock.NAME = "PrimitiveValueBlock";

var _a$w;
class Primitive extends index_es_BaseBlock {
    constructor(parameters = {}) {
        super(parameters, LocalPrimitiveValueBlock);
        this.idBlock.isConstructed = false;
    }
}
_a$w = Primitive;
(() => {
    typeStore.Primitive = _a$w;
})();
Primitive.NAME = "PRIMITIVE";

function localChangeType(inputObject, newType) {
    if (inputObject instanceof newType) {
        return inputObject;
    }
    const newObject = new newType();
    newObject.idBlock = inputObject.idBlock;
    newObject.lenBlock = inputObject.lenBlock;
    newObject.warnings = inputObject.warnings;
    newObject.valueBeforeDecodeView = inputObject.valueBeforeDecodeView;
    return newObject;
}
function localFromBER(inputBuffer, inputOffset = 0, inputLength = inputBuffer.length) {
    const incomingOffset = inputOffset;
    let returnObject = new index_es_BaseBlock({}, ValueBlock);
    const baseBlock = new index_es_LocalBaseBlock();
    if (!index_es_checkBufferParams(baseBlock, inputBuffer, inputOffset, inputLength)) {
        returnObject.error = baseBlock.error;
        return {
            offset: -1,
            result: returnObject
        };
    }
    const intBuffer = inputBuffer.subarray(inputOffset, inputOffset + inputLength);
    if (!intBuffer.length) {
        returnObject.error = "Zero buffer length";
        return {
            offset: -1,
            result: returnObject
        };
    }
    let resultOffset = returnObject.idBlock.fromBER(inputBuffer, inputOffset, inputLength);
    if (returnObject.idBlock.warnings.length) {
        returnObject.warnings.concat(returnObject.idBlock.warnings);
    }
    if (resultOffset === -1) {
        returnObject.error = returnObject.idBlock.error;
        return {
            offset: -1,
            result: returnObject
        };
    }
    inputOffset = resultOffset;
    inputLength -= returnObject.idBlock.blockLength;
    resultOffset = returnObject.lenBlock.fromBER(inputBuffer, inputOffset, inputLength);
    if (returnObject.lenBlock.warnings.length) {
        returnObject.warnings.concat(returnObject.lenBlock.warnings);
    }
    if (resultOffset === -1) {
        returnObject.error = returnObject.lenBlock.error;
        return {
            offset: -1,
            result: returnObject
        };
    }
    inputOffset = resultOffset;
    inputLength -= returnObject.lenBlock.blockLength;
    if (!returnObject.idBlock.isConstructed &&
        returnObject.lenBlock.isIndefiniteForm) {
        returnObject.error = "Indefinite length form used for primitive encoding form";
        return {
            offset: -1,
            result: returnObject
        };
    }
    let newASN1Type = index_es_BaseBlock;
    switch (returnObject.idBlock.tagClass) {
        case 1:
            if ((returnObject.idBlock.tagNumber >= 37) &&
                (returnObject.idBlock.isHexOnly === false)) {
                returnObject.error = "UNIVERSAL 37 and upper tags are reserved by ASN.1 standard";
                return {
                    offset: -1,
                    result: returnObject
                };
            }
            switch (returnObject.idBlock.tagNumber) {
                case 0:
                    if ((returnObject.idBlock.isConstructed) &&
                        (returnObject.lenBlock.length > 0)) {
                        returnObject.error = "Type [UNIVERSAL 0] is reserved";
                        return {
                            offset: -1,
                            result: returnObject
                        };
                    }
                    newASN1Type = typeStore.EndOfContent;
                    break;
                case 1:
                    newASN1Type = typeStore.Boolean;
                    break;
                case 2:
                    newASN1Type = typeStore.Integer;
                    break;
                case 3:
                    newASN1Type = typeStore.BitString;
                    break;
                case 4:
                    newASN1Type = typeStore.OctetString;
                    break;
                case 5:
                    newASN1Type = typeStore.Null;
                    break;
                case 6:
                    newASN1Type = typeStore.ObjectIdentifier;
                    break;
                case 10:
                    newASN1Type = typeStore.Enumerated;
                    break;
                case 12:
                    newASN1Type = typeStore.Utf8String;
                    break;
                case 13:
                    newASN1Type = typeStore.RelativeObjectIdentifier;
                    break;
                case 14:
                    newASN1Type = typeStore.TIME;
                    break;
                case 15:
                    returnObject.error = "[UNIVERSAL 15] is reserved by ASN.1 standard";
                    return {
                        offset: -1,
                        result: returnObject
                    };
                case 16:
                    newASN1Type = typeStore.Sequence;
                    break;
                case 17:
                    newASN1Type = typeStore.Set;
                    break;
                case 18:
                    newASN1Type = typeStore.NumericString;
                    break;
                case 19:
                    newASN1Type = typeStore.PrintableString;
                    break;
                case 20:
                    newASN1Type = typeStore.TeletexString;
                    break;
                case 21:
                    newASN1Type = typeStore.VideotexString;
                    break;
                case 22:
                    newASN1Type = typeStore.IA5String;
                    break;
                case 23:
                    newASN1Type = typeStore.UTCTime;
                    break;
                case 24:
                    newASN1Type = typeStore.GeneralizedTime;
                    break;
                case 25:
                    newASN1Type = typeStore.GraphicString;
                    break;
                case 26:
                    newASN1Type = typeStore.VisibleString;
                    break;
                case 27:
                    newASN1Type = typeStore.GeneralString;
                    break;
                case 28:
                    newASN1Type = typeStore.UniversalString;
                    break;
                case 29:
                    newASN1Type = typeStore.CharacterString;
                    break;
                case 30:
                    newASN1Type = typeStore.BmpString;
                    break;
                case 31:
                    newASN1Type = typeStore.DATE;
                    break;
                case 32:
                    newASN1Type = typeStore.TimeOfDay;
                    break;
                case 33:
                    newASN1Type = typeStore.DateTime;
                    break;
                case 34:
                    newASN1Type = typeStore.Duration;
                    break;
                default: {
                    const newObject = returnObject.idBlock.isConstructed
                        ? new typeStore.Constructed()
                        : new typeStore.Primitive();
                    newObject.idBlock = returnObject.idBlock;
                    newObject.lenBlock = returnObject.lenBlock;
                    newObject.warnings = returnObject.warnings;
                    returnObject = newObject;
                }
            }
            break;
        case 2:
        case 3:
        case 4:
        default: {
            newASN1Type = returnObject.idBlock.isConstructed
                ? typeStore.Constructed
                : typeStore.Primitive;
        }
    }
    returnObject = localChangeType(returnObject, newASN1Type);
    resultOffset = returnObject.fromBER(inputBuffer, inputOffset, returnObject.lenBlock.isIndefiniteForm ? inputLength : returnObject.lenBlock.length);
    returnObject.valueBeforeDecodeView = inputBuffer.subarray(incomingOffset, incomingOffset + returnObject.blockLength);
    return {
        offset: resultOffset,
        result: returnObject
    };
}
function fromBER(inputBuffer) {
    if (!inputBuffer.byteLength) {
        const result = new index_es_BaseBlock({}, ValueBlock);
        result.error = "Input buffer has zero length";
        return {
            offset: -1,
            result
        };
    }
    return localFromBER(build["BufferSourceConverter"].toUint8Array(inputBuffer).slice(), 0, inputBuffer.byteLength);
}

function checkLen(indefiniteLength, length) {
    if (indefiniteLength) {
        return 1;
    }
    return length;
}
class index_es_LocalConstructedValueBlock extends ValueBlock {
    constructor({ value = [], isIndefiniteForm = false, ...parameters } = {}) {
        super(parameters);
        this.value = value;
        this.isIndefiniteForm = isIndefiniteForm;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        const view = build["BufferSourceConverter"].toUint8Array(inputBuffer);
        if (!index_es_checkBufferParams(this, view, inputOffset, inputLength)) {
            return -1;
        }
        this.valueBeforeDecodeView = view.subarray(inputOffset, inputOffset + inputLength);
        if (this.valueBeforeDecodeView.length === 0) {
            this.warnings.push("Zero buffer length");
            return inputOffset;
        }
        let currentOffset = inputOffset;
        while (checkLen(this.isIndefiniteForm, inputLength) > 0) {
            const returnObject = localFromBER(view, currentOffset, inputLength);
            if (returnObject.offset === -1) {
                this.error = returnObject.result.error;
                this.warnings.concat(returnObject.result.warnings);
                return -1;
            }
            currentOffset = returnObject.offset;
            this.blockLength += returnObject.result.blockLength;
            inputLength -= returnObject.result.blockLength;
            this.value.push(returnObject.result);
            if (this.isIndefiniteForm && returnObject.result.constructor.NAME === END_OF_CONTENT_NAME) {
                break;
            }
        }
        if (this.isIndefiniteForm) {
            if (this.value[this.value.length - 1].constructor.NAME === END_OF_CONTENT_NAME) {
                this.value.pop();
            }
            else {
                this.warnings.push("No EndOfContent block encoded");
            }
        }
        return currentOffset;
    }
    toBER(sizeOnly, writer) {
        const _writer = writer || new ViewWriter();
        for (let i = 0; i < this.value.length; i++) {
            this.value[i].toBER(sizeOnly, _writer);
        }
        if (!writer) {
            return _writer.final();
        }
        return EMPTY_BUFFER;
    }
    toJSON() {
        const object = {
            ...super.toJSON(),
            isIndefiniteForm: this.isIndefiniteForm,
            value: [],
        };
        for (const value of this.value) {
            object.value.push(value.toJSON());
        }
        return object;
    }
}
index_es_LocalConstructedValueBlock.NAME = "ConstructedValueBlock";

var _a$v;
class Constructed extends index_es_BaseBlock {
    constructor(parameters = {}) {
        super(parameters, index_es_LocalConstructedValueBlock);
        this.idBlock.isConstructed = true;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        this.valueBlock.isIndefiniteForm = this.lenBlock.isIndefiniteForm;
        const resultOffset = this.valueBlock.fromBER(inputBuffer, inputOffset, (this.lenBlock.isIndefiniteForm) ? inputLength : this.lenBlock.length);
        if (resultOffset === -1) {
            this.error = this.valueBlock.error;
            return resultOffset;
        }
        if (!this.idBlock.error.length)
            this.blockLength += this.idBlock.blockLength;
        if (!this.lenBlock.error.length)
            this.blockLength += this.lenBlock.blockLength;
        if (!this.valueBlock.error.length)
            this.blockLength += this.valueBlock.blockLength;
        return resultOffset;
    }
    onAsciiEncoding() {
        const values = [];
        for (const value of this.valueBlock.value) {
            values.push(value.toString("ascii").split("\n").map(o => `  ${o}`).join("\n"));
        }
        const blockName = this.idBlock.tagClass === 3
            ? `[${this.idBlock.tagNumber}]`
            : this.constructor.NAME;
        return values.length
            ? `${blockName} :\n${values.join("\n")}`
            : `${blockName} :`;
    }
}
_a$v = Constructed;
(() => {
    typeStore.Constructed = _a$v;
})();
Constructed.NAME = "CONSTRUCTED";

class LocalEndOfContentValueBlock extends ValueBlock {
    fromBER(inputBuffer, inputOffset, inputLength) {
        return inputOffset;
    }
    toBER(sizeOnly) {
        return EMPTY_BUFFER;
    }
}
LocalEndOfContentValueBlock.override = "EndOfContentValueBlock";

var _a$u;
class EndOfContent extends index_es_BaseBlock {
    constructor(parameters = {}) {
        super(parameters, LocalEndOfContentValueBlock);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 0;
    }
}
_a$u = EndOfContent;
(() => {
    typeStore.EndOfContent = _a$u;
})();
EndOfContent.NAME = END_OF_CONTENT_NAME;

var _a$t;
class Null extends index_es_BaseBlock {
    constructor(parameters = {}) {
        super(parameters, ValueBlock);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 5;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        if (this.lenBlock.length > 0)
            this.warnings.push("Non-zero length of value block for Null type");
        if (!this.idBlock.error.length)
            this.blockLength += this.idBlock.blockLength;
        if (!this.lenBlock.error.length)
            this.blockLength += this.lenBlock.blockLength;
        this.blockLength += inputLength;
        if ((inputOffset + inputLength) > inputBuffer.byteLength) {
            this.error = "End of input reached before message was fully decoded (inconsistent offset and length values)";
            return -1;
        }
        return (inputOffset + inputLength);
    }
    toBER(sizeOnly, writer) {
        const retBuf = new ArrayBuffer(2);
        if (!sizeOnly) {
            const retView = new Uint8Array(retBuf);
            retView[0] = 0x05;
            retView[1] = 0x00;
        }
        if (writer) {
            writer.write(retBuf);
        }
        return retBuf;
    }
    onAsciiEncoding() {
        return `${this.constructor.NAME}`;
    }
}
_a$t = Null;
(() => {
    typeStore.Null = _a$t;
})();
Null.NAME = "NULL";

class index_es_LocalBooleanValueBlock extends HexBlock(ValueBlock) {
    constructor({ value, ...parameters } = {}) {
        super(parameters);
        if (parameters.valueHex) {
            this.valueHexView = build["BufferSourceConverter"].toUint8Array(parameters.valueHex);
        }
        else {
            this.valueHexView = new Uint8Array(1);
        }
        if (value) {
            this.value = value;
        }
    }
    get value() {
        for (const octet of this.valueHexView) {
            if (octet > 0) {
                return true;
            }
        }
        return false;
    }
    set value(value) {
        this.valueHexView[0] = value ? 0xFF : 0x00;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        const inputView = build["BufferSourceConverter"].toUint8Array(inputBuffer);
        if (!index_es_checkBufferParams(this, inputView, inputOffset, inputLength)) {
            return -1;
        }
        this.valueHexView = inputView.subarray(inputOffset, inputOffset + inputLength);
        if (inputLength > 1)
            this.warnings.push("Boolean value encoded in more then 1 octet");
        this.isHexOnly = true;
        utilDecodeTC.call(this);
        this.blockLength = inputLength;
        return (inputOffset + inputLength);
    }
    toBER() {
        return this.valueHexView.slice();
    }
    toJSON() {
        return {
            ...super.toJSON(),
            value: this.value,
        };
    }
}
index_es_LocalBooleanValueBlock.NAME = "BooleanValueBlock";

var _a$s;
class Boolean extends index_es_BaseBlock {
    constructor(parameters = {}) {
        super(parameters, index_es_LocalBooleanValueBlock);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 1;
    }
    getValue() {
        return this.valueBlock.value;
    }
    setValue(value) {
        this.valueBlock.value = value;
    }
    onAsciiEncoding() {
        return `${this.constructor.NAME} : ${this.getValue}`;
    }
}
_a$s = Boolean;
(() => {
    typeStore.Boolean = _a$s;
})();
Boolean.NAME = "BOOLEAN";

class LocalOctetStringValueBlock extends HexBlock(index_es_LocalConstructedValueBlock) {
    constructor({ isConstructed = false, ...parameters } = {}) {
        super(parameters);
        this.isConstructed = isConstructed;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        let resultOffset = 0;
        if (this.isConstructed) {
            this.isHexOnly = false;
            resultOffset = index_es_LocalConstructedValueBlock.prototype.fromBER.call(this, inputBuffer, inputOffset, inputLength);
            if (resultOffset === -1)
                return resultOffset;
            for (let i = 0; i < this.value.length; i++) {
                const currentBlockName = this.value[i].constructor.NAME;
                if (currentBlockName === END_OF_CONTENT_NAME) {
                    if (this.isIndefiniteForm)
                        break;
                    else {
                        this.error = "EndOfContent is unexpected, OCTET STRING may consists of OCTET STRINGs only";
                        return -1;
                    }
                }
                if (currentBlockName !== OCTET_STRING_NAME) {
                    this.error = "OCTET STRING may consists of OCTET STRINGs only";
                    return -1;
                }
            }
        }
        else {
            this.isHexOnly = true;
            resultOffset = super.fromBER(inputBuffer, inputOffset, inputLength);
            this.blockLength = inputLength;
        }
        return resultOffset;
    }
    toBER(sizeOnly, writer) {
        if (this.isConstructed)
            return index_es_LocalConstructedValueBlock.prototype.toBER.call(this, sizeOnly, writer);
        return sizeOnly
            ? new ArrayBuffer(this.valueHexView.byteLength)
            : this.valueHexView.slice().buffer;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            isConstructed: this.isConstructed,
        };
    }
}
LocalOctetStringValueBlock.NAME = "OctetStringValueBlock";

var _a$r;
class index_es_OctetString extends index_es_BaseBlock {
    constructor({ idBlock = {}, lenBlock = {}, ...parameters } = {}) {
        var _b, _c;
        (_b = parameters.isConstructed) !== null && _b !== void 0 ? _b : (parameters.isConstructed = !!((_c = parameters.value) === null || _c === void 0 ? void 0 : _c.length));
        super({
            idBlock: {
                isConstructed: parameters.isConstructed,
                ...idBlock,
            },
            lenBlock: {
                ...lenBlock,
                isIndefiniteForm: !!parameters.isIndefiniteForm,
            },
            ...parameters,
        }, LocalOctetStringValueBlock);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 4;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        this.valueBlock.isConstructed = this.idBlock.isConstructed;
        this.valueBlock.isIndefiniteForm = this.lenBlock.isIndefiniteForm;
        if (inputLength === 0) {
            if (this.idBlock.error.length === 0)
                this.blockLength += this.idBlock.blockLength;
            if (this.lenBlock.error.length === 0)
                this.blockLength += this.lenBlock.blockLength;
            return inputOffset;
        }
        if (!this.valueBlock.isConstructed) {
            const view = inputBuffer instanceof ArrayBuffer ? new Uint8Array(inputBuffer) : inputBuffer;
            const buf = view.subarray(inputOffset, inputOffset + inputLength);
            try {
                if (buf.byteLength) {
                    const asn = localFromBER(buf, 0, buf.byteLength);
                    if (asn.offset !== -1 && asn.offset === inputLength) {
                        this.valueBlock.value = [asn.result];
                    }
                }
            }
            catch (e) {
            }
        }
        return super.fromBER(inputBuffer, inputOffset, inputLength);
    }
    onAsciiEncoding() {
        if (this.valueBlock.isConstructed || (this.valueBlock.value && this.valueBlock.value.length)) {
            return Constructed.prototype.onAsciiEncoding.call(this);
        }
        return `${this.constructor.NAME} : ${build["Convert"].ToHex(this.valueBlock.valueHexView)}`;
    }
    getValue() {
        if (!this.idBlock.isConstructed) {
            return this.valueBlock.valueHexView.slice().buffer;
        }
        const array = [];
        for (const content of this.valueBlock.value) {
            if (content instanceof index_es_OctetString) {
                array.push(content.valueBlock.valueHexView);
            }
        }
        return build["BufferSourceConverter"].concat(array);
    }
}
_a$r = index_es_OctetString;
(() => {
    typeStore.OctetString = _a$r;
})();
index_es_OctetString.NAME = OCTET_STRING_NAME;

class index_es_LocalBitStringValueBlock extends HexBlock(index_es_LocalConstructedValueBlock) {
    constructor({ unusedBits = 0, isConstructed = false, ...parameters } = {}) {
        super(parameters);
        this.unusedBits = unusedBits;
        this.isConstructed = isConstructed;
        this.blockLength = this.valueHexView.byteLength;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        if (!inputLength) {
            return inputOffset;
        }
        let resultOffset = -1;
        if (this.isConstructed) {
            resultOffset = index_es_LocalConstructedValueBlock.prototype.fromBER.call(this, inputBuffer, inputOffset, inputLength);
            if (resultOffset === -1)
                return resultOffset;
            for (const value of this.value) {
                const currentBlockName = value.constructor.NAME;
                if (currentBlockName === END_OF_CONTENT_NAME) {
                    if (this.isIndefiniteForm)
                        break;
                    else {
                        this.error = "EndOfContent is unexpected, BIT STRING may consists of BIT STRINGs only";
                        return -1;
                    }
                }
                if (currentBlockName !== BIT_STRING_NAME) {
                    this.error = "BIT STRING may consists of BIT STRINGs only";
                    return -1;
                }
                const valueBlock = value.valueBlock;
                if ((this.unusedBits > 0) && (valueBlock.unusedBits > 0)) {
                    this.error = "Using of \"unused bits\" inside constructive BIT STRING allowed for least one only";
                    return -1;
                }
                this.unusedBits = valueBlock.unusedBits;
            }
            return resultOffset;
        }
        const inputView = build["BufferSourceConverter"].toUint8Array(inputBuffer);
        if (!index_es_checkBufferParams(this, inputView, inputOffset, inputLength)) {
            return -1;
        }
        const intBuffer = inputView.subarray(inputOffset, inputOffset + inputLength);
        this.unusedBits = intBuffer[0];
        if (this.unusedBits > 7) {
            this.error = "Unused bits for BitString must be in range 0-7";
            return -1;
        }
        if (!this.unusedBits) {
            const buf = intBuffer.subarray(1);
            try {
                if (buf.byteLength) {
                    const asn = localFromBER(buf, 0, buf.byteLength);
                    if (asn.offset !== -1 && asn.offset === (inputLength - 1)) {
                        this.value = [asn.result];
                    }
                }
            }
            catch (e) {
            }
        }
        this.valueHexView = intBuffer.subarray(1);
        this.blockLength = intBuffer.length;
        return (inputOffset + inputLength);
    }
    toBER(sizeOnly, writer) {
        if (this.isConstructed) {
            return index_es_LocalConstructedValueBlock.prototype.toBER.call(this, sizeOnly, writer);
        }
        if (sizeOnly) {
            return new ArrayBuffer(this.valueHexView.byteLength + 1);
        }
        if (!this.valueHexView.byteLength) {
            return EMPTY_BUFFER;
        }
        const retView = new Uint8Array(this.valueHexView.length + 1);
        retView[0] = this.unusedBits;
        retView.set(this.valueHexView, 1);
        return retView.buffer;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            unusedBits: this.unusedBits,
            isConstructed: this.isConstructed,
        };
    }
}
index_es_LocalBitStringValueBlock.NAME = "BitStringValueBlock";

var _a$q;
class BitString extends index_es_BaseBlock {
    constructor({ idBlock = {}, lenBlock = {}, ...parameters } = {}) {
        var _b, _c;
        (_b = parameters.isConstructed) !== null && _b !== void 0 ? _b : (parameters.isConstructed = !!((_c = parameters.value) === null || _c === void 0 ? void 0 : _c.length));
        super({
            idBlock: {
                isConstructed: parameters.isConstructed,
                ...idBlock,
            },
            lenBlock: {
                ...lenBlock,
                isIndefiniteForm: !!parameters.isIndefiniteForm,
            },
            ...parameters,
        }, index_es_LocalBitStringValueBlock);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 3;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        this.valueBlock.isConstructed = this.idBlock.isConstructed;
        this.valueBlock.isIndefiniteForm = this.lenBlock.isIndefiniteForm;
        return super.fromBER(inputBuffer, inputOffset, inputLength);
    }
    onAsciiEncoding() {
        if (this.valueBlock.isConstructed || (this.valueBlock.value && this.valueBlock.value.length)) {
            return Constructed.prototype.onAsciiEncoding.call(this);
        }
        else {
            const bits = [];
            const valueHex = this.valueBlock.valueHexView;
            for (const byte of valueHex) {
                bits.push(byte.toString(2).padStart(8, "0"));
            }
            const bitsStr = bits.join("");
            return `${this.constructor.NAME} : ${bitsStr.substring(0, bitsStr.length - this.valueBlock.unusedBits)}`;
        }
    }
}
_a$q = BitString;
(() => {
    typeStore.BitString = _a$q;
})();
BitString.NAME = BIT_STRING_NAME;

var _a$p;
function viewAdd(first, second) {
    const c = new Uint8Array([0]);
    const firstView = new Uint8Array(first);
    const secondView = new Uint8Array(second);
    let firstViewCopy = firstView.slice(0);
    const firstViewCopyLength = firstViewCopy.length - 1;
    const secondViewCopy = secondView.slice(0);
    const secondViewCopyLength = secondViewCopy.length - 1;
    let value = 0;
    const max = (secondViewCopyLength < firstViewCopyLength) ? firstViewCopyLength : secondViewCopyLength;
    let counter = 0;
    for (let i = max; i >= 0; i--, counter++) {
        switch (true) {
            case (counter < secondViewCopy.length):
                value = firstViewCopy[firstViewCopyLength - counter] + secondViewCopy[secondViewCopyLength - counter] + c[0];
                break;
            default:
                value = firstViewCopy[firstViewCopyLength - counter] + c[0];
        }
        c[0] = value / 10;
        switch (true) {
            case (counter >= firstViewCopy.length):
                firstViewCopy = utilConcatView(new Uint8Array([value % 10]), firstViewCopy);
                break;
            default:
                firstViewCopy[firstViewCopyLength - counter] = value % 10;
        }
    }
    if (c[0] > 0)
        firstViewCopy = utilConcatView(c, firstViewCopy);
    return firstViewCopy;
}
function power2(n) {
    if (n >= powers2.length) {
        for (let p = powers2.length; p <= n; p++) {
            const c = new Uint8Array([0]);
            let digits = (powers2[p - 1]).slice(0);
            for (let i = (digits.length - 1); i >= 0; i--) {
                const newValue = new Uint8Array([(digits[i] << 1) + c[0]]);
                c[0] = newValue[0] / 10;
                digits[i] = newValue[0] % 10;
            }
            if (c[0] > 0)
                digits = utilConcatView(c, digits);
            powers2.push(digits);
        }
    }
    return powers2[n];
}
function viewSub(first, second) {
    let b = 0;
    const firstView = new Uint8Array(first);
    const secondView = new Uint8Array(second);
    const firstViewCopy = firstView.slice(0);
    const firstViewCopyLength = firstViewCopy.length - 1;
    const secondViewCopy = secondView.slice(0);
    const secondViewCopyLength = secondViewCopy.length - 1;
    let value;
    let counter = 0;
    for (let i = secondViewCopyLength; i >= 0; i--, counter++) {
        value = firstViewCopy[firstViewCopyLength - counter] - secondViewCopy[secondViewCopyLength - counter] - b;
        switch (true) {
            case (value < 0):
                b = 1;
                firstViewCopy[firstViewCopyLength - counter] = value + 10;
                break;
            default:
                b = 0;
                firstViewCopy[firstViewCopyLength - counter] = value;
        }
    }
    if (b > 0) {
        for (let i = (firstViewCopyLength - secondViewCopyLength + 1); i >= 0; i--, counter++) {
            value = firstViewCopy[firstViewCopyLength - counter] - b;
            if (value < 0) {
                b = 1;
                firstViewCopy[firstViewCopyLength - counter] = value + 10;
            }
            else {
                b = 0;
                firstViewCopy[firstViewCopyLength - counter] = value;
                break;
            }
        }
    }
    return firstViewCopy.slice();
}
class index_es_LocalIntegerValueBlock extends HexBlock(ValueBlock) {
    constructor({ value, ...parameters } = {}) {
        super(parameters);
        this._valueDec = 0;
        if (parameters.valueHex) {
            this.setValueHex();
        }
        if (value !== undefined) {
            this.valueDec = value;
        }
    }
    setValueHex() {
        if (this.valueHexView.length >= 4) {
            this.warnings.push("Too big Integer for decoding, hex only");
            this.isHexOnly = true;
            this._valueDec = 0;
        }
        else {
            this.isHexOnly = false;
            if (this.valueHexView.length > 0) {
                this._valueDec = utilDecodeTC.call(this);
            }
        }
    }
    set valueDec(v) {
        this._valueDec = v;
        this.isHexOnly = false;
        this.valueHexView = new Uint8Array(utilEncodeTC(v));
    }
    get valueDec() {
        return this._valueDec;
    }
    fromDER(inputBuffer, inputOffset, inputLength, expectedLength = 0) {
        const offset = this.fromBER(inputBuffer, inputOffset, inputLength);
        if (offset === -1)
            return offset;
        const view = this.valueHexView;
        if ((view[0] === 0x00) && ((view[1] & 0x80) !== 0)) {
            this.valueHexView = view.subarray(1);
        }
        else {
            if (expectedLength !== 0) {
                if (view.length < expectedLength) {
                    if ((expectedLength - view.length) > 1)
                        expectedLength = view.length + 1;
                    this.valueHexView = view.subarray(expectedLength - view.length);
                }
            }
        }
        return offset;
    }
    toDER(sizeOnly = false) {
        const view = this.valueHexView;
        switch (true) {
            case ((view[0] & 0x80) !== 0):
                {
                    const updatedView = new Uint8Array(this.valueHexView.length + 1);
                    updatedView[0] = 0x00;
                    updatedView.set(view, 1);
                    this.valueHexView = updatedView;
                }
                break;
            case ((view[0] === 0x00) && ((view[1] & 0x80) === 0)):
                {
                    this.valueHexView = this.valueHexView.subarray(1);
                }
                break;
        }
        return this.toBER(sizeOnly);
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        const resultOffset = super.fromBER(inputBuffer, inputOffset, inputLength);
        if (resultOffset === -1) {
            return resultOffset;
        }
        this.setValueHex();
        return resultOffset;
    }
    toBER(sizeOnly) {
        return sizeOnly
            ? new ArrayBuffer(this.valueHexView.length)
            : this.valueHexView.slice().buffer;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            valueDec: this.valueDec,
        };
    }
    toString() {
        const firstBit = (this.valueHexView.length * 8) - 1;
        let digits = new Uint8Array((this.valueHexView.length * 8) / 3);
        let bitNumber = 0;
        let currentByte;
        const asn1View = this.valueHexView;
        let result = "";
        let flag = false;
        for (let byteNumber = (asn1View.byteLength - 1); byteNumber >= 0; byteNumber--) {
            currentByte = asn1View[byteNumber];
            for (let i = 0; i < 8; i++) {
                if ((currentByte & 1) === 1) {
                    switch (bitNumber) {
                        case firstBit:
                            digits = viewSub(power2(bitNumber), digits);
                            result = "-";
                            break;
                        default:
                            digits = viewAdd(digits, power2(bitNumber));
                    }
                }
                bitNumber++;
                currentByte >>= 1;
            }
        }
        for (let i = 0; i < digits.length; i++) {
            if (digits[i])
                flag = true;
            if (flag)
                result += digitsString.charAt(digits[i]);
        }
        if (flag === false)
            result += digitsString.charAt(0);
        return result;
    }
}
_a$p = index_es_LocalIntegerValueBlock;
index_es_LocalIntegerValueBlock.NAME = "IntegerValueBlock";
(() => {
    Object.defineProperty(_a$p.prototype, "valueHex", {
        set: function (v) {
            this.valueHexView = new Uint8Array(v);
            this.setValueHex();
        },
        get: function () {
            return this.valueHexView.slice().buffer;
        },
    });
})();

var _a$o;
class index_es_Integer extends index_es_BaseBlock {
    constructor(parameters = {}) {
        super(parameters, index_es_LocalIntegerValueBlock);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 2;
    }
    toBigInt() {
        assertBigInt();
        return BigInt(this.valueBlock.toString());
    }
    static fromBigInt(value) {
        assertBigInt();
        const bigIntValue = BigInt(value);
        const writer = new ViewWriter();
        const hex = bigIntValue.toString(16).replace(/^-/, "");
        const view = new Uint8Array(build["Convert"].FromHex(hex));
        if (bigIntValue < 0) {
            const first = new Uint8Array(view.length + (view[0] & 0x80 ? 1 : 0));
            first[0] |= 0x80;
            const firstInt = BigInt(`0x${build["Convert"].ToHex(first)}`);
            const secondInt = firstInt + bigIntValue;
            const second = build["BufferSourceConverter"].toUint8Array(build["Convert"].FromHex(secondInt.toString(16)));
            second[0] |= 0x80;
            writer.write(second);
        }
        else {
            if (view[0] & 0x80) {
                writer.write(new Uint8Array([0]));
            }
            writer.write(view);
        }
        const res = new index_es_Integer({
            valueHex: writer.final(),
        });
        return res;
    }
    convertToDER() {
        const integer = new index_es_Integer({ valueHex: this.valueBlock.valueHexView });
        integer.valueBlock.toDER();
        return integer;
    }
    convertFromDER() {
        return new index_es_Integer({
            valueHex: this.valueBlock.valueHexView[0] === 0
                ? this.valueBlock.valueHexView.subarray(1)
                : this.valueBlock.valueHexView,
        });
    }
    onAsciiEncoding() {
        return `${this.constructor.NAME} : ${this.valueBlock.toString()}`;
    }
}
_a$o = index_es_Integer;
(() => {
    typeStore.Integer = _a$o;
})();
index_es_Integer.NAME = "INTEGER";

var _a$n;
class Enumerated extends index_es_Integer {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 10;
    }
}
_a$n = Enumerated;
(() => {
    typeStore.Enumerated = _a$n;
})();
Enumerated.NAME = "ENUMERATED";

class index_es_LocalSidValueBlock extends HexBlock(ValueBlock) {
    constructor({ valueDec = -1, isFirstSid = false, ...parameters } = {}) {
        super(parameters);
        this.valueDec = valueDec;
        this.isFirstSid = isFirstSid;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        if (!inputLength) {
            return inputOffset;
        }
        const inputView = build["BufferSourceConverter"].toUint8Array(inputBuffer);
        if (!index_es_checkBufferParams(this, inputView, inputOffset, inputLength)) {
            return -1;
        }
        const intBuffer = inputView.subarray(inputOffset, inputOffset + inputLength);
        this.valueHexView = new Uint8Array(inputLength);
        for (let i = 0; i < inputLength; i++) {
            this.valueHexView[i] = intBuffer[i] & 0x7F;
            this.blockLength++;
            if ((intBuffer[i] & 0x80) === 0x00)
                break;
        }
        const tempView = new Uint8Array(this.blockLength);
        for (let i = 0; i < this.blockLength; i++) {
            tempView[i] = this.valueHexView[i];
        }
        this.valueHexView = tempView;
        if ((intBuffer[this.blockLength - 1] & 0x80) !== 0x00) {
            this.error = "End of input reached before message was fully decoded";
            return -1;
        }
        if (this.valueHexView[0] === 0x00)
            this.warnings.push("Needlessly long format of SID encoding");
        if (this.blockLength <= 8)
            this.valueDec = utilFromBase(this.valueHexView, 7);
        else {
            this.isHexOnly = true;
            this.warnings.push("Too big SID for decoding, hex only");
        }
        return (inputOffset + this.blockLength);
    }
    set valueBigInt(value) {
        assertBigInt();
        let bits = BigInt(value).toString(2);
        while (bits.length % 7) {
            bits = "0" + bits;
        }
        const bytes = new Uint8Array(bits.length / 7);
        for (let i = 0; i < bytes.length; i++) {
            bytes[i] = parseInt(bits.slice(i * 7, i * 7 + 7), 2) + (i + 1 < bytes.length ? 0x80 : 0);
        }
        this.fromBER(bytes.buffer, 0, bytes.length);
    }
    toBER(sizeOnly) {
        if (this.isHexOnly) {
            if (sizeOnly)
                return (new ArrayBuffer(this.valueHexView.byteLength));
            const curView = this.valueHexView;
            const retView = new Uint8Array(this.blockLength);
            for (let i = 0; i < (this.blockLength - 1); i++)
                retView[i] = curView[i] | 0x80;
            retView[this.blockLength - 1] = curView[this.blockLength - 1];
            return retView.buffer;
        }
        const encodedBuf = utilToBase(this.valueDec, 7);
        if (encodedBuf.byteLength === 0) {
            this.error = "Error during encoding SID value";
            return EMPTY_BUFFER;
        }
        const retView = new Uint8Array(encodedBuf.byteLength);
        if (!sizeOnly) {
            const encodedView = new Uint8Array(encodedBuf);
            const len = encodedBuf.byteLength - 1;
            for (let i = 0; i < len; i++)
                retView[i] = encodedView[i] | 0x80;
            retView[len] = encodedView[len];
        }
        return retView;
    }
    toString() {
        let result = "";
        if (this.isHexOnly)
            result = build["Convert"].ToHex(this.valueHexView);
        else {
            if (this.isFirstSid) {
                let sidValue = this.valueDec;
                if (this.valueDec <= 39)
                    result = "0.";
                else {
                    if (this.valueDec <= 79) {
                        result = "1.";
                        sidValue -= 40;
                    }
                    else {
                        result = "2.";
                        sidValue -= 80;
                    }
                }
                result += sidValue.toString();
            }
            else
                result = this.valueDec.toString();
        }
        return result;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            valueDec: this.valueDec,
            isFirstSid: this.isFirstSid,
        };
    }
}
index_es_LocalSidValueBlock.NAME = "sidBlock";

class LocalObjectIdentifierValueBlock extends ValueBlock {
    constructor({ value = EMPTY_STRING, ...parameters } = {}) {
        super(parameters);
        this.value = [];
        if (value) {
            this.fromString(value);
        }
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        let resultOffset = inputOffset;
        while (inputLength > 0) {
            const sidBlock = new index_es_LocalSidValueBlock();
            resultOffset = sidBlock.fromBER(inputBuffer, resultOffset, inputLength);
            if (resultOffset === -1) {
                this.blockLength = 0;
                this.error = sidBlock.error;
                return resultOffset;
            }
            if (this.value.length === 0)
                sidBlock.isFirstSid = true;
            this.blockLength += sidBlock.blockLength;
            inputLength -= sidBlock.blockLength;
            this.value.push(sidBlock);
        }
        return resultOffset;
    }
    toBER(sizeOnly) {
        const retBuffers = [];
        for (let i = 0; i < this.value.length; i++) {
            const valueBuf = this.value[i].toBER(sizeOnly);
            if (valueBuf.byteLength === 0) {
                this.error = this.value[i].error;
                return EMPTY_BUFFER;
            }
            retBuffers.push(valueBuf);
        }
        return concat(retBuffers);
    }
    fromString(string) {
        this.value = [];
        let pos1 = 0;
        let pos2 = 0;
        let sid = "";
        let flag = false;
        do {
            pos2 = string.indexOf(".", pos1);
            if (pos2 === -1)
                sid = string.substring(pos1);
            else
                sid = string.substring(pos1, pos2);
            pos1 = pos2 + 1;
            if (flag) {
                const sidBlock = this.value[0];
                let plus = 0;
                switch (sidBlock.valueDec) {
                    case 0:
                        break;
                    case 1:
                        plus = 40;
                        break;
                    case 2:
                        plus = 80;
                        break;
                    default:
                        this.value = [];
                        return;
                }
                const parsedSID = parseInt(sid, 10);
                if (isNaN(parsedSID))
                    return;
                sidBlock.valueDec = parsedSID + plus;
                flag = false;
            }
            else {
                const sidBlock = new index_es_LocalSidValueBlock();
                if (sid > Number.MAX_SAFE_INTEGER) {
                    assertBigInt();
                    const sidValue = BigInt(sid);
                    sidBlock.valueBigInt = sidValue;
                }
                else {
                    sidBlock.valueDec = parseInt(sid, 10);
                    if (isNaN(sidBlock.valueDec))
                        return;
                }
                if (!this.value.length) {
                    sidBlock.isFirstSid = true;
                    flag = true;
                }
                this.value.push(sidBlock);
            }
        } while (pos2 !== -1);
    }
    toString() {
        let result = "";
        let isHexOnly = false;
        for (let i = 0; i < this.value.length; i++) {
            isHexOnly = this.value[i].isHexOnly;
            let sidStr = this.value[i].toString();
            if (i !== 0)
                result = `${result}.`;
            if (isHexOnly) {
                sidStr = `{${sidStr}}`;
                if (this.value[i].isFirstSid)
                    result = `2.{${sidStr} - 80}`;
                else
                    result += sidStr;
            }
            else
                result += sidStr;
        }
        return result;
    }
    toJSON() {
        const object = {
            ...super.toJSON(),
            value: this.toString(),
            sidArray: [],
        };
        for (let i = 0; i < this.value.length; i++) {
            object.sidArray.push(this.value[i].toJSON());
        }
        return object;
    }
}
LocalObjectIdentifierValueBlock.NAME = "ObjectIdentifierValueBlock";

var _a$m;
class ObjectIdentifier extends index_es_BaseBlock {
    constructor(parameters = {}) {
        super(parameters, LocalObjectIdentifierValueBlock);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 6;
    }
    getValue() {
        return this.valueBlock.toString();
    }
    setValue(value) {
        this.valueBlock.fromString(value);
    }
    onAsciiEncoding() {
        return `${this.constructor.NAME} : ${this.valueBlock.toString() || "empty"}`;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            value: this.getValue(),
        };
    }
}
_a$m = ObjectIdentifier;
(() => {
    typeStore.ObjectIdentifier = _a$m;
})();
ObjectIdentifier.NAME = "OBJECT IDENTIFIER";

class index_es_LocalRelativeSidValueBlock extends HexBlock(index_es_LocalBaseBlock) {
    constructor({ valueDec = 0, ...parameters } = {}) {
        super(parameters);
        this.valueDec = valueDec;
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        if (inputLength === 0)
            return inputOffset;
        const inputView = build["BufferSourceConverter"].toUint8Array(inputBuffer);
        if (!index_es_checkBufferParams(this, inputView, inputOffset, inputLength))
            return -1;
        const intBuffer = inputView.subarray(inputOffset, inputOffset + inputLength);
        this.valueHexView = new Uint8Array(inputLength);
        for (let i = 0; i < inputLength; i++) {
            this.valueHexView[i] = intBuffer[i] & 0x7F;
            this.blockLength++;
            if ((intBuffer[i] & 0x80) === 0x00)
                break;
        }
        const tempView = new Uint8Array(this.blockLength);
        for (let i = 0; i < this.blockLength; i++)
            tempView[i] = this.valueHexView[i];
        this.valueHexView = tempView;
        if ((intBuffer[this.blockLength - 1] & 0x80) !== 0x00) {
            this.error = "End of input reached before message was fully decoded";
            return -1;
        }
        if (this.valueHexView[0] === 0x00)
            this.warnings.push("Needlessly long format of SID encoding");
        if (this.blockLength <= 8)
            this.valueDec = utilFromBase(this.valueHexView, 7);
        else {
            this.isHexOnly = true;
            this.warnings.push("Too big SID for decoding, hex only");
        }
        return (inputOffset + this.blockLength);
    }
    toBER(sizeOnly) {
        if (this.isHexOnly) {
            if (sizeOnly)
                return (new ArrayBuffer(this.valueHexView.byteLength));
            const curView = this.valueHexView;
            const retView = new Uint8Array(this.blockLength);
            for (let i = 0; i < (this.blockLength - 1); i++)
                retView[i] = curView[i] | 0x80;
            retView[this.blockLength - 1] = curView[this.blockLength - 1];
            return retView.buffer;
        }
        const encodedBuf = utilToBase(this.valueDec, 7);
        if (encodedBuf.byteLength === 0) {
            this.error = "Error during encoding SID value";
            return EMPTY_BUFFER;
        }
        const retView = new Uint8Array(encodedBuf.byteLength);
        if (!sizeOnly) {
            const encodedView = new Uint8Array(encodedBuf);
            const len = encodedBuf.byteLength - 1;
            for (let i = 0; i < len; i++)
                retView[i] = encodedView[i] | 0x80;
            retView[len] = encodedView[len];
        }
        return retView.buffer;
    }
    toString() {
        let result = "";
        if (this.isHexOnly)
            result = build["Convert"].ToHex(this.valueHexView);
        else {
            result = this.valueDec.toString();
        }
        return result;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            valueDec: this.valueDec,
        };
    }
}
index_es_LocalRelativeSidValueBlock.NAME = "relativeSidBlock";

class LocalRelativeObjectIdentifierValueBlock extends ValueBlock {
    constructor({ value = EMPTY_STRING, ...parameters } = {}) {
        super(parameters);
        this.value = [];
        if (value) {
            this.fromString(value);
        }
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        let resultOffset = inputOffset;
        while (inputLength > 0) {
            const sidBlock = new index_es_LocalRelativeSidValueBlock();
            resultOffset = sidBlock.fromBER(inputBuffer, resultOffset, inputLength);
            if (resultOffset === -1) {
                this.blockLength = 0;
                this.error = sidBlock.error;
                return resultOffset;
            }
            this.blockLength += sidBlock.blockLength;
            inputLength -= sidBlock.blockLength;
            this.value.push(sidBlock);
        }
        return resultOffset;
    }
    toBER(sizeOnly, writer) {
        const retBuffers = [];
        for (let i = 0; i < this.value.length; i++) {
            const valueBuf = this.value[i].toBER(sizeOnly);
            if (valueBuf.byteLength === 0) {
                this.error = this.value[i].error;
                return EMPTY_BUFFER;
            }
            retBuffers.push(valueBuf);
        }
        return concat(retBuffers);
    }
    fromString(string) {
        this.value = [];
        let pos1 = 0;
        let pos2 = 0;
        let sid = "";
        do {
            pos2 = string.indexOf(".", pos1);
            if (pos2 === -1)
                sid = string.substring(pos1);
            else
                sid = string.substring(pos1, pos2);
            pos1 = pos2 + 1;
            const sidBlock = new index_es_LocalRelativeSidValueBlock();
            sidBlock.valueDec = parseInt(sid, 10);
            if (isNaN(sidBlock.valueDec))
                return true;
            this.value.push(sidBlock);
        } while (pos2 !== -1);
        return true;
    }
    toString() {
        let result = "";
        let isHexOnly = false;
        for (let i = 0; i < this.value.length; i++) {
            isHexOnly = this.value[i].isHexOnly;
            let sidStr = this.value[i].toString();
            if (i !== 0)
                result = `${result}.`;
            if (isHexOnly) {
                sidStr = `{${sidStr}}`;
                result += sidStr;
            }
            else
                result += sidStr;
        }
        return result;
    }
    toJSON() {
        const object = {
            ...super.toJSON(),
            value: this.toString(),
            sidArray: [],
        };
        for (let i = 0; i < this.value.length; i++)
            object.sidArray.push(this.value[i].toJSON());
        return object;
    }
}
LocalRelativeObjectIdentifierValueBlock.NAME = "RelativeObjectIdentifierValueBlock";

var _a$l;
class RelativeObjectIdentifier extends index_es_BaseBlock {
    constructor(parameters = {}) {
        super(parameters, LocalRelativeObjectIdentifierValueBlock);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 13;
    }
    getValue() {
        return this.valueBlock.toString();
    }
    setValue(value) {
        this.valueBlock.fromString(value);
    }
    onAsciiEncoding() {
        return `${this.constructor.NAME} : ${this.valueBlock.toString() || "empty"}`;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            value: this.getValue(),
        };
    }
}
_a$l = RelativeObjectIdentifier;
(() => {
    typeStore.RelativeObjectIdentifier = _a$l;
})();
RelativeObjectIdentifier.NAME = "RelativeObjectIdentifier";

var _a$k;
class Sequence extends Constructed {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 16;
    }
}
_a$k = Sequence;
(() => {
    typeStore.Sequence = _a$k;
})();
Sequence.NAME = "SEQUENCE";

var _a$j;
class Set extends Constructed {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 17;
    }
}
_a$j = Set;
(() => {
    typeStore.Set = _a$j;
})();
Set.NAME = "SET";

class LocalStringValueBlock extends HexBlock(ValueBlock) {
    constructor({ ...parameters } = {}) {
        super(parameters);
        this.isHexOnly = true;
        this.value = EMPTY_STRING;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            value: this.value,
        };
    }
}
LocalStringValueBlock.NAME = "StringValueBlock";

class LocalSimpleStringValueBlock extends LocalStringValueBlock {
}
LocalSimpleStringValueBlock.NAME = "SimpleStringValueBlock";

class index_es_LocalSimpleStringBlock extends BaseStringBlock {
    constructor({ ...parameters } = {}) {
        super(parameters, LocalSimpleStringValueBlock);
    }
    fromBuffer(inputBuffer) {
        this.valueBlock.value = String.fromCharCode.apply(null, build["BufferSourceConverter"].toUint8Array(inputBuffer));
    }
    fromString(inputString) {
        const strLen = inputString.length;
        const view = this.valueBlock.valueHexView = new Uint8Array(strLen);
        for (let i = 0; i < strLen; i++)
            view[i] = inputString.charCodeAt(i);
        this.valueBlock.value = inputString;
    }
}
index_es_LocalSimpleStringBlock.NAME = "SIMPLE STRING";

class index_es_LocalUtf8StringValueBlock extends index_es_LocalSimpleStringBlock {
    fromBuffer(inputBuffer) {
        this.valueBlock.valueHexView = build["BufferSourceConverter"].toUint8Array(inputBuffer);
        try {
            this.valueBlock.value = build["Convert"].ToUtf8String(inputBuffer);
        }
        catch (ex) {
            this.warnings.push(`Error during "decodeURIComponent": ${ex}, using raw string`);
            this.valueBlock.value = build["Convert"].ToBinary(inputBuffer);
        }
    }
    fromString(inputString) {
        this.valueBlock.valueHexView = new Uint8Array(build["Convert"].FromUtf8String(inputString));
        this.valueBlock.value = inputString;
    }
}
index_es_LocalUtf8StringValueBlock.NAME = "Utf8StringValueBlock";

var _a$i;
class Utf8String extends index_es_LocalUtf8StringValueBlock {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 12;
    }
}
_a$i = Utf8String;
(() => {
    typeStore.Utf8String = _a$i;
})();
Utf8String.NAME = "UTF8String";

class index_es_LocalBmpStringValueBlock extends index_es_LocalSimpleStringBlock {
    fromBuffer(inputBuffer) {
        this.valueBlock.value = build["Convert"].ToUtf16String(inputBuffer);
        this.valueBlock.valueHexView = build["BufferSourceConverter"].toUint8Array(inputBuffer);
    }
    fromString(inputString) {
        this.valueBlock.value = inputString;
        this.valueBlock.valueHexView = new Uint8Array(build["Convert"].FromUtf16String(inputString));
    }
}
index_es_LocalBmpStringValueBlock.NAME = "BmpStringValueBlock";

var _a$h;
class BmpString extends index_es_LocalBmpStringValueBlock {
    constructor({ ...parameters } = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 30;
    }
}
_a$h = BmpString;
(() => {
    typeStore.BmpString = _a$h;
})();
BmpString.NAME = "BMPString";

class index_es_LocalUniversalStringValueBlock extends index_es_LocalSimpleStringBlock {
    fromBuffer(inputBuffer) {
        const copyBuffer = ArrayBuffer.isView(inputBuffer) ? inputBuffer.slice().buffer : inputBuffer.slice(0);
        const valueView = new Uint8Array(copyBuffer);
        for (let i = 0; i < valueView.length; i += 4) {
            valueView[i] = valueView[i + 3];
            valueView[i + 1] = valueView[i + 2];
            valueView[i + 2] = 0x00;
            valueView[i + 3] = 0x00;
        }
        this.valueBlock.value = String.fromCharCode.apply(null, new Uint32Array(copyBuffer));
    }
    fromString(inputString) {
        const strLength = inputString.length;
        const valueHexView = this.valueBlock.valueHexView = new Uint8Array(strLength * 4);
        for (let i = 0; i < strLength; i++) {
            const codeBuf = utilToBase(inputString.charCodeAt(i), 8);
            const codeView = new Uint8Array(codeBuf);
            if (codeView.length > 4)
                continue;
            const dif = 4 - codeView.length;
            for (let j = (codeView.length - 1); j >= 0; j--)
                valueHexView[i * 4 + j + dif] = codeView[j];
        }
        this.valueBlock.value = inputString;
    }
}
index_es_LocalUniversalStringValueBlock.NAME = "UniversalStringValueBlock";

var _a$g;
class UniversalString extends index_es_LocalUniversalStringValueBlock {
    constructor({ ...parameters } = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 28;
    }
}
_a$g = UniversalString;
(() => {
    typeStore.UniversalString = _a$g;
})();
UniversalString.NAME = "UniversalString";

var _a$f;
class NumericString extends index_es_LocalSimpleStringBlock {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 18;
    }
}
_a$f = NumericString;
(() => {
    typeStore.NumericString = _a$f;
})();
NumericString.NAME = "NumericString";

var _a$e;
class PrintableString extends index_es_LocalSimpleStringBlock {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 19;
    }
}
_a$e = PrintableString;
(() => {
    typeStore.PrintableString = _a$e;
})();
PrintableString.NAME = "PrintableString";

var _a$d;
class TeletexString extends index_es_LocalSimpleStringBlock {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 20;
    }
}
_a$d = TeletexString;
(() => {
    typeStore.TeletexString = _a$d;
})();
TeletexString.NAME = "TeletexString";

var _a$c;
class VideotexString extends index_es_LocalSimpleStringBlock {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 21;
    }
}
_a$c = VideotexString;
(() => {
    typeStore.VideotexString = _a$c;
})();
VideotexString.NAME = "VideotexString";

var _a$b;
class IA5String extends index_es_LocalSimpleStringBlock {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 22;
    }
}
_a$b = IA5String;
(() => {
    typeStore.IA5String = _a$b;
})();
IA5String.NAME = "IA5String";

var _a$a;
class GraphicString extends index_es_LocalSimpleStringBlock {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 25;
    }
}
_a$a = GraphicString;
(() => {
    typeStore.GraphicString = _a$a;
})();
GraphicString.NAME = "GraphicString";

var _a$9;
class VisibleString extends index_es_LocalSimpleStringBlock {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 26;
    }
}
_a$9 = VisibleString;
(() => {
    typeStore.VisibleString = _a$9;
})();
VisibleString.NAME = "VisibleString";

var _a$8;
class GeneralString extends index_es_LocalSimpleStringBlock {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 27;
    }
}
_a$8 = GeneralString;
(() => {
    typeStore.GeneralString = _a$8;
})();
GeneralString.NAME = "GeneralString";

var _a$7;
class CharacterString extends index_es_LocalSimpleStringBlock {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 29;
    }
}
_a$7 = CharacterString;
(() => {
    typeStore.CharacterString = _a$7;
})();
CharacterString.NAME = "CharacterString";

var _a$6;
class index_es_UTCTime extends VisibleString {
    constructor({ value, valueDate, ...parameters } = {}) {
        super(parameters);
        this.year = 0;
        this.month = 0;
        this.day = 0;
        this.hour = 0;
        this.minute = 0;
        this.second = 0;
        if (value) {
            this.fromString(value);
            this.valueBlock.valueHexView = new Uint8Array(value.length);
            for (let i = 0; i < value.length; i++)
                this.valueBlock.valueHexView[i] = value.charCodeAt(i);
        }
        if (valueDate) {
            this.fromDate(valueDate);
            this.valueBlock.valueHexView = new Uint8Array(this.toBuffer());
        }
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 23;
    }
    fromBuffer(inputBuffer) {
        this.fromString(String.fromCharCode.apply(null, build["BufferSourceConverter"].toUint8Array(inputBuffer)));
    }
    toBuffer() {
        const str = this.toString();
        const buffer = new ArrayBuffer(str.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < str.length; i++)
            view[i] = str.charCodeAt(i);
        return buffer;
    }
    fromDate(inputDate) {
        this.year = inputDate.getUTCFullYear();
        this.month = inputDate.getUTCMonth() + 1;
        this.day = inputDate.getUTCDate();
        this.hour = inputDate.getUTCHours();
        this.minute = inputDate.getUTCMinutes();
        this.second = inputDate.getUTCSeconds();
    }
    toDate() {
        return (new Date(Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second)));
    }
    fromString(inputString) {
        const parser = /(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})Z/ig;
        const parserArray = parser.exec(inputString);
        if (parserArray === null) {
            this.error = "Wrong input string for conversion";
            return;
        }
        const year = parseInt(parserArray[1], 10);
        if (year >= 50)
            this.year = 1900 + year;
        else
            this.year = 2000 + year;
        this.month = parseInt(parserArray[2], 10);
        this.day = parseInt(parserArray[3], 10);
        this.hour = parseInt(parserArray[4], 10);
        this.minute = parseInt(parserArray[5], 10);
        this.second = parseInt(parserArray[6], 10);
    }
    toString(encoding = "iso") {
        if (encoding === "iso") {
            const outputArray = new Array(7);
            outputArray[0] = padNumber(((this.year < 2000) ? (this.year - 1900) : (this.year - 2000)), 2);
            outputArray[1] = padNumber(this.month, 2);
            outputArray[2] = padNumber(this.day, 2);
            outputArray[3] = padNumber(this.hour, 2);
            outputArray[4] = padNumber(this.minute, 2);
            outputArray[5] = padNumber(this.second, 2);
            outputArray[6] = "Z";
            return outputArray.join("");
        }
        return super.toString(encoding);
    }
    onAsciiEncoding() {
        return `${this.constructor.NAME} : ${this.toDate().toISOString()}`;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            year: this.year,
            month: this.month,
            day: this.day,
            hour: this.hour,
            minute: this.minute,
            second: this.second,
        };
    }
}
_a$6 = index_es_UTCTime;
(() => {
    typeStore.UTCTime = _a$6;
})();
index_es_UTCTime.NAME = "UTCTime";

var _a$5;
class index_es_GeneralizedTime extends index_es_UTCTime {
    constructor(parameters = {}) {
        var _b;
        super(parameters);
        (_b = this.millisecond) !== null && _b !== void 0 ? _b : (this.millisecond = 0);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 24;
    }
    fromDate(inputDate) {
        super.fromDate(inputDate);
        this.millisecond = inputDate.getUTCMilliseconds();
    }
    toDate() {
        return (new Date(Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, this.millisecond)));
    }
    fromString(inputString) {
        let isUTC = false;
        let timeString = "";
        let dateTimeString = "";
        let fractionPart = 0;
        let parser;
        let hourDifference = 0;
        let minuteDifference = 0;
        if (inputString[inputString.length - 1] === "Z") {
            timeString = inputString.substring(0, inputString.length - 1);
            isUTC = true;
        }
        else {
            const number = new Number(inputString[inputString.length - 1]);
            if (isNaN(number.valueOf()))
                throw new Error("Wrong input string for conversion");
            timeString = inputString;
        }
        if (isUTC) {
            if (timeString.indexOf("+") !== -1)
                throw new Error("Wrong input string for conversion");
            if (timeString.indexOf("-") !== -1)
                throw new Error("Wrong input string for conversion");
        }
        else {
            let multiplier = 1;
            let differencePosition = timeString.indexOf("+");
            let differenceString = "";
            if (differencePosition === -1) {
                differencePosition = timeString.indexOf("-");
                multiplier = -1;
            }
            if (differencePosition !== -1) {
                differenceString = timeString.substring(differencePosition + 1);
                timeString = timeString.substring(0, differencePosition);
                if ((differenceString.length !== 2) && (differenceString.length !== 4))
                    throw new Error("Wrong input string for conversion");
                let number = parseInt(differenceString.substring(0, 2), 10);
                if (isNaN(number.valueOf()))
                    throw new Error("Wrong input string for conversion");
                hourDifference = multiplier * number;
                if (differenceString.length === 4) {
                    number = parseInt(differenceString.substring(2, 4), 10);
                    if (isNaN(number.valueOf()))
                        throw new Error("Wrong input string for conversion");
                    minuteDifference = multiplier * number;
                }
            }
        }
        let fractionPointPosition = timeString.indexOf(".");
        if (fractionPointPosition === -1)
            fractionPointPosition = timeString.indexOf(",");
        if (fractionPointPosition !== -1) {
            const fractionPartCheck = new Number(`0${timeString.substring(fractionPointPosition)}`);
            if (isNaN(fractionPartCheck.valueOf()))
                throw new Error("Wrong input string for conversion");
            fractionPart = fractionPartCheck.valueOf();
            dateTimeString = timeString.substring(0, fractionPointPosition);
        }
        else
            dateTimeString = timeString;
        switch (true) {
            case (dateTimeString.length === 8):
                parser = /(\d{4})(\d{2})(\d{2})/ig;
                if (fractionPointPosition !== -1)
                    throw new Error("Wrong input string for conversion");
                break;
            case (dateTimeString.length === 10):
                parser = /(\d{4})(\d{2})(\d{2})(\d{2})/ig;
                if (fractionPointPosition !== -1) {
                    let fractionResult = 60 * fractionPart;
                    this.minute = Math.floor(fractionResult);
                    fractionResult = 60 * (fractionResult - this.minute);
                    this.second = Math.floor(fractionResult);
                    fractionResult = 1000 * (fractionResult - this.second);
                    this.millisecond = Math.floor(fractionResult);
                }
                break;
            case (dateTimeString.length === 12):
                parser = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/ig;
                if (fractionPointPosition !== -1) {
                    let fractionResult = 60 * fractionPart;
                    this.second = Math.floor(fractionResult);
                    fractionResult = 1000 * (fractionResult - this.second);
                    this.millisecond = Math.floor(fractionResult);
                }
                break;
            case (dateTimeString.length === 14):
                parser = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/ig;
                if (fractionPointPosition !== -1) {
                    const fractionResult = 1000 * fractionPart;
                    this.millisecond = Math.floor(fractionResult);
                }
                break;
            default:
                throw new Error("Wrong input string for conversion");
        }
        const parserArray = parser.exec(dateTimeString);
        if (parserArray === null)
            throw new Error("Wrong input string for conversion");
        for (let j = 1; j < parserArray.length; j++) {
            switch (j) {
                case 1:
                    this.year = parseInt(parserArray[j], 10);
                    break;
                case 2:
                    this.month = parseInt(parserArray[j], 10);
                    break;
                case 3:
                    this.day = parseInt(parserArray[j], 10);
                    break;
                case 4:
                    this.hour = parseInt(parserArray[j], 10) + hourDifference;
                    break;
                case 5:
                    this.minute = parseInt(parserArray[j], 10) + minuteDifference;
                    break;
                case 6:
                    this.second = parseInt(parserArray[j], 10);
                    break;
                default:
                    throw new Error("Wrong input string for conversion");
            }
        }
        if (isUTC === false) {
            const tempDate = new Date(this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
            this.year = tempDate.getUTCFullYear();
            this.month = tempDate.getUTCMonth();
            this.day = tempDate.getUTCDay();
            this.hour = tempDate.getUTCHours();
            this.minute = tempDate.getUTCMinutes();
            this.second = tempDate.getUTCSeconds();
            this.millisecond = tempDate.getUTCMilliseconds();
        }
    }
    toString(encoding = "iso") {
        if (encoding === "iso") {
            const outputArray = [];
            outputArray.push(padNumber(this.year, 4));
            outputArray.push(padNumber(this.month, 2));
            outputArray.push(padNumber(this.day, 2));
            outputArray.push(padNumber(this.hour, 2));
            outputArray.push(padNumber(this.minute, 2));
            outputArray.push(padNumber(this.second, 2));
            if (this.millisecond !== 0) {
                outputArray.push(".");
                outputArray.push(padNumber(this.millisecond, 3));
            }
            outputArray.push("Z");
            return outputArray.join("");
        }
        return super.toString(encoding);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            millisecond: this.millisecond,
        };
    }
}
_a$5 = index_es_GeneralizedTime;
(() => {
    typeStore.GeneralizedTime = _a$5;
})();
index_es_GeneralizedTime.NAME = "GeneralizedTime";

var _a$4;
class DATE extends Utf8String {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 31;
    }
}
_a$4 = DATE;
(() => {
    typeStore.DATE = _a$4;
})();
DATE.NAME = "DATE";

var _a$3;
class TimeOfDay extends Utf8String {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 32;
    }
}
_a$3 = TimeOfDay;
(() => {
    typeStore.TimeOfDay = _a$3;
})();
TimeOfDay.NAME = "TimeOfDay";

var _a$2;
class DateTime extends Utf8String {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 33;
    }
}
_a$2 = DateTime;
(() => {
    typeStore.DateTime = _a$2;
})();
DateTime.NAME = "DateTime";

var _a$1;
class Duration extends Utf8String {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 34;
    }
}
_a$1 = Duration;
(() => {
    typeStore.Duration = _a$1;
})();
Duration.NAME = "Duration";

var index_es_a;
class TIME extends Utf8String {
    constructor(parameters = {}) {
        super(parameters);
        this.idBlock.tagClass = 1;
        this.idBlock.tagNumber = 14;
    }
}
index_es_a = TIME;
(() => {
    typeStore.TIME = index_es_a;
})();
TIME.NAME = "TIME";

class Any {
    constructor({ name = EMPTY_STRING, optional = false, } = {}) {
        this.name = name;
        this.optional = optional;
    }
}

class Choice extends Any {
    constructor({ value = [], ...parameters } = {}) {
        super(parameters);
        this.value = value;
    }
}

class Repeated extends Any {
    constructor({ value = new Any(), local = false, ...parameters } = {}) {
        super(parameters);
        this.value = value;
        this.local = local;
    }
}

class index_es_RawData {
    constructor({ data = EMPTY_VIEW } = {}) {
        this.dataView = build["BufferSourceConverter"].toUint8Array(data);
    }
    get data() {
        return this.dataView.slice().buffer;
    }
    set data(value) {
        this.dataView = build["BufferSourceConverter"].toUint8Array(value);
    }
    fromBER(inputBuffer, inputOffset, inputLength) {
        const endLength = inputOffset + inputLength;
        this.dataView = build["BufferSourceConverter"].toUint8Array(inputBuffer).subarray(inputOffset, endLength);
        return endLength;
    }
    toBER(sizeOnly) {
        return this.dataView.slice().buffer;
    }
}

function compareSchema(root, inputData, inputSchema) {
    if (inputSchema instanceof Choice) {
        for (let j = 0; j < inputSchema.value.length; j++) {
            const result = compareSchema(root, inputData, inputSchema.value[j]);
            if (result.verified) {
                return {
                    verified: true,
                    result: root
                };
            }
        }
        {
            const _result = {
                verified: false,
                result: {
                    error: "Wrong values for Choice type"
                },
            };
            if (inputSchema.hasOwnProperty(NAME))
                _result.name = inputSchema.name;
            return _result;
        }
    }
    if (inputSchema instanceof Any) {
        if (inputSchema.hasOwnProperty(NAME))
            root[inputSchema.name] = inputData;
        return {
            verified: true,
            result: root
        };
    }
    if ((root instanceof Object) === false) {
        return {
            verified: false,
            result: { error: "Wrong root object" }
        };
    }
    if ((inputData instanceof Object) === false) {
        return {
            verified: false,
            result: { error: "Wrong ASN.1 data" }
        };
    }
    if ((inputSchema instanceof Object) === false) {
        return {
            verified: false,
            result: { error: "Wrong ASN.1 schema" }
        };
    }
    if ((ID_BLOCK in inputSchema) === false) {
        return {
            verified: false,
            result: { error: "Wrong ASN.1 schema" }
        };
    }
    if ((FROM_BER in inputSchema.idBlock) === false) {
        return {
            verified: false,
            result: { error: "Wrong ASN.1 schema" }
        };
    }
    if ((TO_BER in inputSchema.idBlock) === false) {
        return {
            verified: false,
            result: { error: "Wrong ASN.1 schema" }
        };
    }
    const encodedId = inputSchema.idBlock.toBER(false);
    if (encodedId.byteLength === 0) {
        return {
            verified: false,
            result: { error: "Error encoding idBlock for ASN.1 schema" }
        };
    }
    const decodedOffset = inputSchema.idBlock.fromBER(encodedId, 0, encodedId.byteLength);
    if (decodedOffset === -1) {
        return {
            verified: false,
            result: { error: "Error decoding idBlock for ASN.1 schema" }
        };
    }
    if (inputSchema.idBlock.hasOwnProperty(TAG_CLASS) === false) {
        return {
            verified: false,
            result: { error: "Wrong ASN.1 schema" }
        };
    }
    if (inputSchema.idBlock.tagClass !== inputData.idBlock.tagClass) {
        return {
            verified: false,
            result: root
        };
    }
    if (inputSchema.idBlock.hasOwnProperty(TAG_NUMBER) === false) {
        return {
            verified: false,
            result: { error: "Wrong ASN.1 schema" }
        };
    }
    if (inputSchema.idBlock.tagNumber !== inputData.idBlock.tagNumber) {
        return {
            verified: false,
            result: root
        };
    }
    if (inputSchema.idBlock.hasOwnProperty(IS_CONSTRUCTED) === false) {
        return {
            verified: false,
            result: { error: "Wrong ASN.1 schema" }
        };
    }
    if (inputSchema.idBlock.isConstructed !== inputData.idBlock.isConstructed) {
        return {
            verified: false,
            result: root
        };
    }
    if (!(IS_HEX_ONLY in inputSchema.idBlock)) {
        return {
            verified: false,
            result: { error: "Wrong ASN.1 schema" }
        };
    }
    if (inputSchema.idBlock.isHexOnly !== inputData.idBlock.isHexOnly) {
        return {
            verified: false,
            result: root
        };
    }
    if (inputSchema.idBlock.isHexOnly) {
        if ((VALUE_HEX_VIEW in inputSchema.idBlock) === false) {
            return {
                verified: false,
                result: { error: "Wrong ASN.1 schema" }
            };
        }
        const schemaView = inputSchema.idBlock.valueHexView;
        const asn1View = inputData.idBlock.valueHexView;
        if (schemaView.length !== asn1View.length) {
            return {
                verified: false,
                result: root
            };
        }
        for (let i = 0; i < schemaView.length; i++) {
            if (schemaView[i] !== asn1View[1]) {
                return {
                    verified: false,
                    result: root
                };
            }
        }
    }
    if (inputSchema.name) {
        inputSchema.name = inputSchema.name.replace(/^\s+|\s+$/g, EMPTY_STRING);
        if (inputSchema.name)
            root[inputSchema.name] = inputData;
    }
    if (inputSchema instanceof typeStore.Constructed) {
        let admission = 0;
        let result = {
            verified: false,
            result: {
                error: "Unknown error",
            }
        };
        let maxLength = inputSchema.valueBlock.value.length;
        if (maxLength > 0) {
            if (inputSchema.valueBlock.value[0] instanceof Repeated) {
                maxLength = inputData.valueBlock.value.length;
            }
        }
        if (maxLength === 0) {
            return {
                verified: true,
                result: root
            };
        }
        if ((inputData.valueBlock.value.length === 0) &&
            (inputSchema.valueBlock.value.length !== 0)) {
            let _optional = true;
            for (let i = 0; i < inputSchema.valueBlock.value.length; i++)
                _optional = _optional && (inputSchema.valueBlock.value[i].optional || false);
            if (_optional) {
                return {
                    verified: true,
                    result: root
                };
            }
            if (inputSchema.name) {
                inputSchema.name = inputSchema.name.replace(/^\s+|\s+$/g, EMPTY_STRING);
                if (inputSchema.name)
                    delete root[inputSchema.name];
            }
            root.error = "Inconsistent object length";
            return {
                verified: false,
                result: root
            };
        }
        for (let i = 0; i < maxLength; i++) {
            if ((i - admission) >= inputData.valueBlock.value.length) {
                if (inputSchema.valueBlock.value[i].optional === false) {
                    const _result = {
                        verified: false,
                        result: root
                    };
                    root.error = "Inconsistent length between ASN.1 data and schema";
                    if (inputSchema.name) {
                        inputSchema.name = inputSchema.name.replace(/^\s+|\s+$/g, EMPTY_STRING);
                        if (inputSchema.name) {
                            delete root[inputSchema.name];
                            _result.name = inputSchema.name;
                        }
                    }
                    return _result;
                }
            }
            else {
                if (inputSchema.valueBlock.value[0] instanceof Repeated) {
                    result = compareSchema(root, inputData.valueBlock.value[i], inputSchema.valueBlock.value[0].value);
                    if (result.verified === false) {
                        if (inputSchema.valueBlock.value[0].optional)
                            admission++;
                        else {
                            if (inputSchema.name) {
                                inputSchema.name = inputSchema.name.replace(/^\s+|\s+$/g, EMPTY_STRING);
                                if (inputSchema.name)
                                    delete root[inputSchema.name];
                            }
                            return result;
                        }
                    }
                    if ((NAME in inputSchema.valueBlock.value[0]) && (inputSchema.valueBlock.value[0].name.length > 0)) {
                        let arrayRoot = {};
                        if ((LOCAL in inputSchema.valueBlock.value[0]) && (inputSchema.valueBlock.value[0].local))
                            arrayRoot = inputData;
                        else
                            arrayRoot = root;
                        if (typeof arrayRoot[inputSchema.valueBlock.value[0].name] === "undefined")
                            arrayRoot[inputSchema.valueBlock.value[0].name] = [];
                        arrayRoot[inputSchema.valueBlock.value[0].name].push(inputData.valueBlock.value[i]);
                    }
                }
                else {
                    result = compareSchema(root, inputData.valueBlock.value[i - admission], inputSchema.valueBlock.value[i]);
                    if (result.verified === false) {
                        if (inputSchema.valueBlock.value[i].optional)
                            admission++;
                        else {
                            if (inputSchema.name) {
                                inputSchema.name = inputSchema.name.replace(/^\s+|\s+$/g, EMPTY_STRING);
                                if (inputSchema.name)
                                    delete root[inputSchema.name];
                            }
                            return result;
                        }
                    }
                }
            }
        }
        if (result.verified === false) {
            const _result = {
                verified: false,
                result: root
            };
            if (inputSchema.name) {
                inputSchema.name = inputSchema.name.replace(/^\s+|\s+$/g, EMPTY_STRING);
                if (inputSchema.name) {
                    delete root[inputSchema.name];
                    _result.name = inputSchema.name;
                }
            }
            return _result;
        }
        return {
            verified: true,
            result: root
        };
    }
    if (inputSchema.primitiveSchema &&
        (VALUE_HEX_VIEW in inputData.valueBlock)) {
        const asn1 = localFromBER(inputData.valueBlock.valueHexView);
        if (asn1.offset === -1) {
            const _result = {
                verified: false,
                result: asn1.result
            };
            if (inputSchema.name) {
                inputSchema.name = inputSchema.name.replace(/^\s+|\s+$/g, EMPTY_STRING);
                if (inputSchema.name) {
                    delete root[inputSchema.name];
                    _result.name = inputSchema.name;
                }
            }
            return _result;
        }
        return compareSchema(root, asn1.result, inputSchema.primitiveSchema);
    }
    return {
        verified: true,
        result: root
    };
}
function verifySchema(inputBuffer, inputSchema) {
    if ((inputSchema instanceof Object) === false) {
        return {
            verified: false,
            result: { error: "Wrong ASN.1 schema type" }
        };
    }
    const asn1 = localFromBER(build["BufferSourceConverter"].toUint8Array(inputBuffer));
    if (asn1.offset === -1) {
        return {
            verified: false,
            result: asn1.result
        };
    }
    return compareSchema(asn1.result, asn1.result, inputSchema);
}




/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// eslint-disable-next-line no-multi-assign
exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(79);

// eslint-disable-next-line no-multi-assign
exports.createHash = exports.Hash = __webpack_require__(90);

// eslint-disable-next-line no-multi-assign
exports.createHmac = exports.Hmac = __webpack_require__(190);

var algos = __webpack_require__(283);
var algoKeys = Object.keys(algos);
var hashes = [
	'sha1',
	'sha224',
	'sha256',
	'sha384',
	'sha512',
	'md5',
	'rmd160'
].concat(algoKeys);

exports.getHashes = function () {
	return hashes;
};

var p = __webpack_require__(193);
exports.pbkdf2 = p.pbkdf2;
exports.pbkdf2Sync = p.pbkdf2Sync;

var aes = __webpack_require__(285);

exports.Cipher = aes.Cipher;
exports.createCipher = aes.createCipher;
exports.Cipheriv = aes.Cipheriv;
exports.createCipheriv = aes.createCipheriv;
exports.Decipher = aes.Decipher;
exports.createDecipher = aes.createDecipher;
exports.Decipheriv = aes.Decipheriv;
exports.createDecipheriv = aes.createDecipheriv;
exports.getCiphers = aes.getCiphers;
exports.listCiphers = aes.listCiphers;

var dh = __webpack_require__(300);

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup;
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup;
exports.getDiffieHellman = dh.getDiffieHellman;
exports.createDiffieHellman = dh.createDiffieHellman;
exports.DiffieHellman = dh.DiffieHellman;

var sign = __webpack_require__(307);

exports.createSign = sign.createSign;
exports.Sign = sign.Sign;
exports.createVerify = sign.createVerify;
exports.Verify = sign.Verify;

exports.createECDH = __webpack_require__(345);

var publicEncrypt = __webpack_require__(348);

exports.publicEncrypt = publicEncrypt.publicEncrypt;
exports.privateEncrypt = publicEncrypt.privateEncrypt;
exports.publicDecrypt = publicEncrypt.publicDecrypt;
exports.privateDecrypt = publicEncrypt.privateDecrypt;

// the least I can do is make error messages for the rest of the node.js/crypto api.
// [
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error('sorry, ' + name + ' is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
//   };
// });

var rf = __webpack_require__(352);

exports.randomFill = rf.randomFill;
exports.randomFillSync = rf.randomFillSync;

exports.createCredentials = function () {
	throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};

exports.constants = {
	DH_CHECK_P_NOT_SAFE_PRIME: 2,
	DH_CHECK_P_NOT_PRIME: 1,
	DH_UNABLE_TO_CHECK_GENERATOR: 4,
	DH_NOT_SUITABLE_GENERATOR: 8,
	NPN_ENABLED: 1,
	ALPN_ENABLED: 1,
	RSA_PKCS1_PADDING: 1,
	RSA_SSLV23_PADDING: 2,
	RSA_NO_PADDING: 3,
	RSA_PKCS1_OAEP_PADDING: 4,
	RSA_X931_PADDING: 5,
	RSA_PKCS1_PSS_PADDING: 6,
	POINT_CONVERSION_COMPRESSED: 2,
	POINT_CONVERSION_UNCOMPRESSED: 4,
	POINT_CONVERSION_HYBRID: 6
};


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export JsonError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JsonParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return JsonProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return JsonPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return JsonSerializer; });
/* unused harmony export KeyError */
/* unused harmony export ParserError */
/* unused harmony export SerializerError */
/* unused harmony export TransformError */
/* unused harmony export ValidationError */
/**
 * Copyright (c) 2020, Peculiar Ventures, All rights reserved.
 */

class JsonError extends Error {
    constructor(message, innerError) {
        super(innerError
            ? `${message}. See the inner exception for more details.`
            : message);
        this.message = message;
        this.innerError = innerError;
    }
}

class TransformError extends JsonError {
    constructor(schema, message, innerError) {
        super(message, innerError);
        this.schema = schema;
    }
}

class ParserError extends TransformError {
    constructor(schema, message, innerError) {
        super(schema, `JSON doesn't match to '${schema.target.name}' schema. ${message}`, innerError);
    }
}

class ValidationError extends JsonError {
}

class SerializerError extends JsonError {
    constructor(schemaName, message, innerError) {
        super(`Cannot serialize by '${schemaName}' schema. ${message}`, innerError);
        this.schemaName = schemaName;
    }
}

class KeyError extends ParserError {
    constructor(schema, keys, errors = {}) {
        super(schema, "Some keys doesn't match to schema");
        this.keys = keys;
        this.errors = errors;
    }
}

var JsonPropTypes;
(function (JsonPropTypes) {
    JsonPropTypes[JsonPropTypes["Any"] = 0] = "Any";
    JsonPropTypes[JsonPropTypes["Boolean"] = 1] = "Boolean";
    JsonPropTypes[JsonPropTypes["Number"] = 2] = "Number";
    JsonPropTypes[JsonPropTypes["String"] = 3] = "String";
})(JsonPropTypes || (JsonPropTypes = {}));

function checkType(value, type) {
    switch (type) {
        case JsonPropTypes.Boolean:
            return typeof value === "boolean";
        case JsonPropTypes.Number:
            return typeof value === "number";
        case JsonPropTypes.String:
            return typeof value === "string";
    }
    return true;
}
function throwIfTypeIsWrong(value, type) {
    if (!checkType(value, type)) {
        throw new TypeError(`Value must be ${JsonPropTypes[type]}`);
    }
}
function isConvertible(target) {
    if (target && target.prototype) {
        if (target.prototype.toJSON && target.prototype.fromJSON) {
            return true;
        }
        else {
            return isConvertible(target.prototype);
        }
    }
    else {
        return !!(target && target.toJSON && target.fromJSON);
    }
}

class JsonSchemaStorage {
    constructor() {
        this.items = new Map();
    }
    has(target) {
        return this.items.has(target) || !!this.findParentSchema(target);
    }
    get(target) {
        const schema = this.items.get(target) || this.findParentSchema(target);
        if (!schema) {
            throw new Error("Cannot get schema for current target");
        }
        return schema;
    }
    create(target) {
        const schema = { names: {} };
        const parentSchema = this.findParentSchema(target);
        if (parentSchema) {
            Object.assign(schema, parentSchema);
            schema.names = {};
            for (const name in parentSchema.names) {
                schema.names[name] = Object.assign({}, parentSchema.names[name]);
            }
        }
        schema.target = target;
        return schema;
    }
    set(target, schema) {
        this.items.set(target, schema);
        return this;
    }
    findParentSchema(target) {
        const parent = target.__proto__;
        if (parent) {
            const schema = this.items.get(parent);
            return schema || this.findParentSchema(parent);
        }
        return null;
    }
}

const DEFAULT_SCHEMA = "default";
const schemaStorage = new JsonSchemaStorage();

class PatternValidation {
    constructor(pattern) {
        this.pattern = new RegExp(pattern);
    }
    validate(value) {
        const pattern = new RegExp(this.pattern.source, this.pattern.flags);
        if (typeof value !== "string") {
            throw new ValidationError("Incoming value must be string");
        }
        if (!pattern.exec(value)) {
            throw new ValidationError(`Value doesn't match to pattern '${pattern.toString()}'`);
        }
    }
}

class InclusiveValidation {
    constructor(min = Number.MIN_VALUE, max = Number.MAX_VALUE) {
        this.min = min;
        this.max = max;
    }
    validate(value) {
        throwIfTypeIsWrong(value, JsonPropTypes.Number);
        if (!(this.min <= value && value <= this.max)) {
            const min = this.min === Number.MIN_VALUE ? "MIN" : this.min;
            const max = this.max === Number.MAX_VALUE ? "MAX" : this.max;
            throw new ValidationError(`Value doesn't match to diapason [${min},${max}]`);
        }
    }
}

class ExclusiveValidation {
    constructor(min = Number.MIN_VALUE, max = Number.MAX_VALUE) {
        this.min = min;
        this.max = max;
    }
    validate(value) {
        throwIfTypeIsWrong(value, JsonPropTypes.Number);
        if (!(this.min < value && value < this.max)) {
            const min = this.min === Number.MIN_VALUE ? "MIN" : this.min;
            const max = this.max === Number.MAX_VALUE ? "MAX" : this.max;
            throw new ValidationError(`Value doesn't match to diapason (${min},${max})`);
        }
    }
}

class LengthValidation {
    constructor(length, minLength, maxLength) {
        this.length = length;
        this.minLength = minLength;
        this.maxLength = maxLength;
    }
    validate(value) {
        if (this.length !== undefined) {
            if (value.length !== this.length) {
                throw new ValidationError(`Value length must be exactly ${this.length}.`);
            }
            return;
        }
        if (this.minLength !== undefined) {
            if (value.length < this.minLength) {
                throw new ValidationError(`Value length must be more than ${this.minLength}.`);
            }
        }
        if (this.maxLength !== undefined) {
            if (value.length > this.maxLength) {
                throw new ValidationError(`Value length must be less than ${this.maxLength}.`);
            }
        }
    }
}

class EnumerationValidation {
    constructor(enumeration) {
        this.enumeration = enumeration;
    }
    validate(value) {
        throwIfTypeIsWrong(value, JsonPropTypes.String);
        if (!this.enumeration.includes(value)) {
            throw new ValidationError(`Value must be one of ${this.enumeration.map((v) => `'${v}'`).join(", ")}`);
        }
    }
}

class JsonTransform {
    static checkValues(data, schemaItem) {
        const values = Array.isArray(data) ? data : [data];
        for (const value of values) {
            for (const validation of schemaItem.validations) {
                if (validation instanceof LengthValidation && schemaItem.repeated) {
                    validation.validate(data);
                }
                else {
                    validation.validate(value);
                }
            }
        }
    }
    static checkTypes(value, schemaItem) {
        if (schemaItem.repeated && !Array.isArray(value)) {
            throw new TypeError("Value must be Array");
        }
        if (typeof schemaItem.type === "number") {
            const values = Array.isArray(value) ? value : [value];
            for (const v of values) {
                throwIfTypeIsWrong(v, schemaItem.type);
            }
        }
    }
    static getSchemaByName(schema, name = DEFAULT_SCHEMA) {
        return { ...schema.names[DEFAULT_SCHEMA], ...schema.names[name] };
    }
}

class JsonSerializer extends JsonTransform {
    static serialize(obj, options, replacer, space) {
        const json = this.toJSON(obj, options);
        return JSON.stringify(json, replacer, space);
    }
    static toJSON(obj, options = {}) {
        let res;
        let targetSchema = options.targetSchema;
        const schemaName = options.schemaName || DEFAULT_SCHEMA;
        if (isConvertible(obj)) {
            return obj.toJSON();
        }
        if (Array.isArray(obj)) {
            res = [];
            for (const item of obj) {
                res.push(this.toJSON(item, options));
            }
        }
        else if (typeof obj === "object") {
            if (targetSchema && !schemaStorage.has(targetSchema)) {
                throw new JsonError("Cannot get schema for `targetSchema` param");
            }
            targetSchema = (targetSchema || obj.constructor);
            if (schemaStorage.has(targetSchema)) {
                const schema = schemaStorage.get(targetSchema);
                res = {};
                const namedSchema = this.getSchemaByName(schema, schemaName);
                for (const key in namedSchema) {
                    try {
                        const item = namedSchema[key];
                        const objItem = obj[key];
                        let value;
                        if ((item.optional && objItem === undefined)
                            || (item.defaultValue !== undefined && objItem === item.defaultValue)) {
                            continue;
                        }
                        if (!item.optional && objItem === undefined) {
                            throw new SerializerError(targetSchema.name, `Property '${key}' is required.`);
                        }
                        if (typeof item.type === "number") {
                            if (item.converter) {
                                if (item.repeated) {
                                    value = objItem.map((el) => item.converter.toJSON(el, obj));
                                }
                                else {
                                    value = item.converter.toJSON(objItem, obj);
                                }
                            }
                            else {
                                value = objItem;
                            }
                        }
                        else {
                            if (item.repeated) {
                                value = objItem.map((el) => this.toJSON(el, { schemaName }));
                            }
                            else {
                                value = this.toJSON(objItem, { schemaName });
                            }
                        }
                        this.checkTypes(value, item);
                        this.checkValues(value, item);
                        res[item.name || key] = value;
                    }
                    catch (e) {
                        if (e instanceof SerializerError) {
                            throw e;
                        }
                        else {
                            throw new SerializerError(schema.target.name, `Property '${key}' is wrong. ${e.message}`, e);
                        }
                    }
                }
            }
            else {
                res = {};
                for (const key in obj) {
                    res[key] = this.toJSON(obj[key], { schemaName });
                }
            }
        }
        else {
            res = obj;
        }
        return res;
    }
}

class JsonParser extends JsonTransform {
    static parse(data, options) {
        const obj = JSON.parse(data);
        return this.fromJSON(obj, options);
    }
    static fromJSON(target, options) {
        const targetSchema = options.targetSchema;
        const schemaName = options.schemaName || DEFAULT_SCHEMA;
        const obj = new targetSchema();
        if (isConvertible(obj)) {
            return obj.fromJSON(target);
        }
        const schema = schemaStorage.get(targetSchema);
        const namedSchema = this.getSchemaByName(schema, schemaName);
        const keyErrors = {};
        if (options.strictProperty && !Array.isArray(target)) {
            JsonParser.checkStrictProperty(target, namedSchema, schema);
        }
        for (const key in namedSchema) {
            try {
                const item = namedSchema[key];
                const name = item.name || key;
                const value = target[name];
                if (value === undefined && (item.optional || item.defaultValue !== undefined)) {
                    continue;
                }
                if (!item.optional && value === undefined) {
                    throw new ParserError(schema, `Property '${name}' is required.`);
                }
                this.checkTypes(value, item);
                this.checkValues(value, item);
                if (typeof (item.type) === "number") {
                    if (item.converter) {
                        if (item.repeated) {
                            obj[key] = value.map((el) => item.converter.fromJSON(el, obj));
                        }
                        else {
                            obj[key] = item.converter.fromJSON(value, obj);
                        }
                    }
                    else {
                        obj[key] = value;
                    }
                }
                else {
                    const newOptions = {
                        ...options,
                        targetSchema: item.type,
                        schemaName,
                    };
                    if (item.repeated) {
                        obj[key] = value.map((el) => this.fromJSON(el, newOptions));
                    }
                    else {
                        obj[key] = this.fromJSON(value, newOptions);
                    }
                }
            }
            catch (e) {
                if (!(e instanceof ParserError)) {
                    e = new ParserError(schema, `Property '${key}' is wrong. ${e.message}`, e);
                }
                if (options.strictAllKeys) {
                    keyErrors[key] = e;
                }
                else {
                    throw e;
                }
            }
        }
        const keys = Object.keys(keyErrors);
        if (keys.length) {
            throw new KeyError(schema, keys, keyErrors);
        }
        return obj;
    }
    static checkStrictProperty(target, namedSchema, schema) {
        const jsonProps = Object.keys(target);
        const schemaProps = Object.keys(namedSchema);
        const keys = [];
        for (const key of jsonProps) {
            if (schemaProps.indexOf(key) === -1) {
                keys.push(key);
            }
        }
        if (keys.length) {
            throw new KeyError(schema, keys);
        }
    }
}

function getValidations(item) {
    const validations = [];
    if (item.pattern) {
        validations.push(new PatternValidation(item.pattern));
    }
    if (item.type === JsonPropTypes.Number || item.type === JsonPropTypes.Any) {
        if (item.minInclusive !== undefined || item.maxInclusive !== undefined) {
            validations.push(new InclusiveValidation(item.minInclusive, item.maxInclusive));
        }
        if (item.minExclusive !== undefined || item.maxExclusive !== undefined) {
            validations.push(new ExclusiveValidation(item.minExclusive, item.maxExclusive));
        }
        if (item.enumeration !== undefined) {
            validations.push(new EnumerationValidation(item.enumeration));
        }
    }
    if (item.type === JsonPropTypes.String || item.repeated || item.type === JsonPropTypes.Any) {
        if (item.length !== undefined || item.minLength !== undefined || item.maxLength !== undefined) {
            validations.push(new LengthValidation(item.length, item.minLength, item.maxLength));
        }
    }
    return validations;
}
const JsonProp = (options = {}) => (target, propertyKey) => {
    const errorMessage = `Cannot set type for ${propertyKey} property of ${target.constructor.name} schema`;
    let schema;
    if (!schemaStorage.has(target.constructor)) {
        schema = schemaStorage.create(target.constructor);
        schemaStorage.set(target.constructor, schema);
    }
    else {
        schema = schemaStorage.get(target.constructor);
        if (schema.target !== target.constructor) {
            schema = schemaStorage.create(target.constructor);
            schemaStorage.set(target.constructor, schema);
        }
    }
    const defaultSchema = {
        type: JsonPropTypes.Any,
        validations: [],
    };
    const copyOptions = Object.assign(defaultSchema, options);
    copyOptions.validations = getValidations(copyOptions);
    if (typeof copyOptions.type !== "number") {
        if (!schemaStorage.has(copyOptions.type) && !isConvertible(copyOptions.type)) {
            throw new Error(`${errorMessage}. Assigning type doesn't have schema.`);
        }
    }
    let schemaNames;
    if (Array.isArray(options.schema)) {
        schemaNames = options.schema;
    }
    else {
        schemaNames = [options.schema || DEFAULT_SCHEMA];
    }
    for (const schemaName of schemaNames) {
        if (!schema.names[schemaName]) {
            schema.names[schemaName] = {};
        }
        const namedSchema = schema.names[schemaName];
        namedSchema[propertyKey] = copyOptions;
    }
};




/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}

_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});

const prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype);

  _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ __webpack_exports__["a"] = (AxiosError);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* unused harmony export __assign */
/* unused harmony export __rest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __decorate; });
/* unused harmony export __param */
/* unused harmony export __esDecorate */
/* unused harmony export __runInitializers */
/* unused harmony export __propKey */
/* unused harmony export __setFunctionName */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/* unused harmony export __addDisposableResource */
/* unused harmony export __disposeResources */
/* unused harmony export __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
        var ar = [];
        for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
        env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
        env.stack.push({ async: true });
    }
    return value;

}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while (r = env.stack.pop()) {
            try {
                if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
                if (r.dispose) {
                    var result = r.dispose.call(r.value);
                    if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
                }
                else s |= 1;
            }
            catch (e) {
                fail(e);
            }
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) {
        return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
            return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
        });
    }
    return path;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension,
});


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(4)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(85);
var step = __webpack_require__(157);
var Iterators = __webpack_require__(68);
var toIObject = __webpack_require__(45);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(117)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(154)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(117)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(84);
var test = {};
test[__webpack_require__(20)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(37)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(12);
var getKeys = __webpack_require__(62);
var redefine = __webpack_require__(37);
var global = __webpack_require__(19);
var hide = __webpack_require__(36);
var Iterators = __webpack_require__(68);
var wks = __webpack_require__(20);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(19);
var has = __webpack_require__(41);
var DESCRIPTORS = __webpack_require__(25);
var $export = __webpack_require__(18);
var redefine = __webpack_require__(37);
var META = __webpack_require__(87).KEY;
var $fails = __webpack_require__(24);
var shared = __webpack_require__(97);
var setToStringTag = __webpack_require__(70);
var uid = __webpack_require__(61);
var wks = __webpack_require__(20);
var wksExt = __webpack_require__(164);
var wksDefine = __webpack_require__(165);
var enumKeys = __webpack_require__(246);
var isArray = __webpack_require__(158);
var anObject = __webpack_require__(22);
var isObject = __webpack_require__(23);
var toObject = __webpack_require__(38);
var toIObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(82);
var createDesc = __webpack_require__(66);
var _create = __webpack_require__(69);
var gOPNExt = __webpack_require__(247);
var $GOPD = __webpack_require__(72);
var $GOPS = __webpack_require__(98);
var $DP = __webpack_require__(28);
var $keys = __webpack_require__(62);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(73).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(86).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(59)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(36)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var has = __webpack_require__(41);
var cof = __webpack_require__(54);
var inheritIfRequired = __webpack_require__(163);
var toPrimitive = __webpack_require__(82);
var fails = __webpack_require__(24);
var gOPN = __webpack_require__(73).f;
var gOPD = __webpack_require__(72).f;
var dP = __webpack_require__(28).f;
var $trim = __webpack_require__(244).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(69)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(25) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(37)(global, NUMBER, $Number);
}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var core = __webpack_require__(60);
var hide = __webpack_require__(36);
var redefine = __webpack_require__(37);
var ctx = __webpack_require__(44);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(97)('wks');
var uid = __webpack_require__(61);
var Symbol = __webpack_require__(19).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(23);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(24)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);
__webpack_require__(12);
__webpack_require__(15);
__webpack_require__(77);
__webpack_require__(31);
__webpack_require__(48);
__webpack_require__(49);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(30);
__webpack_require__(21);
__webpack_require__(33);
__webpack_require__(17);
__webpack_require__(14);
__webpack_require__(42);
__webpack_require__(102);
__webpack_require__(255);
__webpack_require__(105);
__webpack_require__(55);
__webpack_require__(29);
__webpack_require__(16);
var _protocolConfig = _interopRequireDefault(__webpack_require__(32));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var CAE_STREAM_DELIMITER_MAGICWORD = 0x5a5a;
var PACKAGE_HEADER_LENGTH = 8;
var Util = exports.default = /*#__PURE__*/function () {
  function Util(containerId) {
    var _this = this;
    _classCallCheck(this, Util);
    _defineProperty(this, "createCanvas", function (isMobile, ratio, innerWidth, canvsId) {
      // const parentContainer = document.getElementById('container');
      // const parentContainer = document.getElementById(
      //   this.containerId || 'container'
      // )

      var _this$getRect = _this.getRect(ratio, innerWidth),
        dpr = _this$getRect.dpr,
        playerWidth = _this$getRect.playerWidth,
        playerHeight = _this$getRect.playerHeight;
      var $ele = _this.createEl('canvas');
      $ele.style.display = 'block';
      // $ele.width = playerWidth
      // $ele.height = playerHeight
      $ele.id = canvsId || 'playCanvas';
      $ele.style.width = "".concat(playerWidth, "px");
      $ele.style.height = "".concat(playerHeight, "px");
      $ele.width = playerWidth * dpr;
      $ele.height = playerHeight * dpr;
      // let ctx = $ele.getContext('2d')
      // if (ctx) ctx.scale(DPR, DPR)

      return $ele;
    });
    this.bindEvents = [];
    this.containerId = containerId;
  }

  /**
   * 监听事件
   * @param {object} target 监听目标对象
   * @param {string} name 事件名称
   * @return {object} fn 事件处理函数
   */
  return _createClass(Util, [{
    key: "bind",
    value: function bind() {
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
      var name = arguments.length > 1 ? arguments[1] : undefined;
      var fn = arguments.length > 2 ? arguments[2] : undefined;
      if (!target || !target.addEventListener || !name || !fn) {
        return false;
      }
      this.bindEvents.push({
        target: target,
        name: name,
        fn: fn
      });
      target.addEventListener(name, fn, false);
      return true;
    }
    /**
     * 转json
     * @param {} params 
     * @returns 
     */
  }, {
    key: "unbind",
    value:
    /**
     * 解除事件监听
     * @param {object} target 监听目标对象，可选
     * @param {string} name 事件名称，可选
     */
    function unbind(target, name) {
      for (var i = this.bindEvents.length - 1; i >= 0; i--) {
        var item = this.bindEvents[i];
        if (item.target.removeEventListener && (target && target === item.target || !target) && (name && name === item.name || !name)) {
          item.target.removeEventListener(item.name, item.fn, false);
          this.bindEvents.splice(i, 1);
        }
      }
    }
  }, {
    key: "throttle",
    value:
    /**
     * 节流
     * @param {function} fn 要执行的方法
     * @param {number} delay 间隔时间
     */
    function throttle(fn, delay, context) {
      var prev = Date.now();
      return function () {
        var args = arguments;
        if (Date.now() - prev >= delay) {
          fn.apply(context, args);
          prev = Date.now();
        }
      };
    }
    /**
       *
       * @param {object} bodyBuf 8位无符号整型数组Uint8Array 媒体消息类的body体
       * @param {string} bodyType 消息类型：CAMERA、MICROPHONE
       * @returns
       */
  }, {
    key: "encodeUTF8",
    value: function encodeUTF8(textStr) {
      var encodedStr = encodeURIComponent(textStr);
      var encodedArray = [];
      for (var i = 0; i < encodedStr.length; i++) {
        var cur = encodedStr.charAt(i);
        if (cur === '%') {
          var code = encodedStr.charAt(i + 1) + encodedStr.charAt(i + 2);
          encodedArray.push(parseInt(code, 16));
          i += 2;
        } else {
          encodedArray.push(cur.charCodeAt(0));
        }
      }
      return encodedArray;
    }
  }, {
    key: "decodeUTF8",
    value: function decodeUTF8(utf8Array, start, end) {
      var decoder = new TextDecoder('utf-8');
      var str = decoder.decode(new Uint8Array(utf8Array.slice(start, end))); // 调用decode()方法将数组转换为字符串
      return str;
    }
  }, {
    key: "createEl",
    value: function createEl() {
      var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
      var options = arguments.length > 1 ? arguments[1] : undefined;
      if (typeof tagName != 'string') {
        return null;
      }
      var el = document.createElement(tagName, options);
      return el;
    }
  }, {
    key: "getRect",
    value: function getRect(ratio) {
      var innerWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.innerWidth;
      var playerHeight = window.innerHeight;

      // playerWidth =
      // }
      // alert('isMobile' + isMobile)

      var playerWidth = Number((playerHeight * ratio).toFixed(0));
      if (playerWidth > innerWidth) {
        var rate = playerWidth / innerWidth;
        playerWidth = innerWidth;
        playerHeight /= rate;
      }
      return {
        dpr: window.devicePixelRatio,
        playerWidth: playerWidth,
        playerHeight: playerHeight
      };
    }
  }, {
    key: "loadWasm",
    value: function loadWasm(url) {
      return new Promise(function (resolve, reject) {
        var wasmXHR = new XMLHttpRequest();
        wasmXHR.open('GET', url, true);
        wasmXHR.responseType = 'arraybuffer';
        wasmXHR.onload = function () {
          resolve(wasmXHR.response);
        };
        wasmXHR.onerror = function () {
          reject("error".concat(wasmXHR.status));
        };
        wasmXHR.send(null);
      });
    }
  }, {
    key: "convertImageDataToYUV420",
    value: function convertImageDataToYUV420(imageData) {
      var imageWidth = imageData.width;
      var imageHeight = imageData.height;
      var originData = imageData.data;
      var yuv420Data = new Uint8Array(imageWidth * imageHeight * 3 / 2);
      var yData = yuv420Data.subarray(0, imageWidth * imageHeight);
      var uData = yuv420Data.subarray(yData.length, yData.length + imageWidth * imageHeight / 4);
      var vData = yuv420Data.subarray(yData.length + uData.length);
      for (var i = 0; i < imageHeight; i++) {
        for (var j = 0; j < imageWidth; j++) {
          var index = (i * imageWidth + j) * 4;
          var r = originData[index];
          var g = originData[index + 1];
          var b = originData[index + 2];
          var y = 0.299 * r + 0.587 * g + 0.114 * b;
          var u = -0.169 * r - 0.331 * g + 0.5 * b + 128;
          var v = 0.5 * r - 0.419 * g - 0.081 * b + 128;
          yData[i * imageWidth + j] = y;
          if (i % 2 === 0 && j % 2 === 0) {
            uData[i / 2 * imageWidth / 2 + j / 2] = u;
            vData[i / 2 * imageWidth / 2 + j / 2] = v;
          }
        }
      }
      return yuv420Data;
    }

    /**
     *
     * @param {object} array Unit8Array数组
     * @param {number} index 要取出的unit16在数组中的起始位置
     * @returns
     */
  }, {
    key: "changeToMultipleOfEight",
    value:
    /**
     * @param {number} num 需要转换的数字
     * @returns 能被8整除的数
     */
    function changeToMultipleOfEight(num) {
      if (num % 8 === 0) {
        return num;
      } else {
        return Math.ceil(num / 8) * 8;
      }
    }

    /**
     * 自定义Interval(处理原生interval中可能会出现的时间差问题)
     * @param {*} callback 回调函数
     * @param {*} interval 执行间隔时间
     * @param {*} execute 是否在调用时执行
     */
  }], [{
    key: "params2JSON",
    value: function params2JSON() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var json = {};
      params.split('&').forEach(function (kv) {
        var _kv$split = kv.split('='),
          _kv$split2 = _slicedToArray(_kv$split, 2),
          key = _kv$split2[0],
          val = _kv$split2[1];
        json[key] = val;
      });
      return json;
    }
  }, {
    key: "getUrlSearchVal",
    value: function getUrlSearchVal(key) {
      var search = window.location.search.substr(1);
      var kv = search.split('&').map(function (kvs) {
        var _kvs$split = kvs.split('='),
          _kvs$split2 = _slicedToArray(_kvs$split, 2),
          k = _kvs$split2[0],
          v = _kvs$split2[1];
        return {
          k: k,
          v: v
        };
      }).find(function (item) {
        return item.k === key;
      });
      return kv && decodeURIComponent(kv.v);
    }
  }, {
    key: "getMsgBody",
    value: function getMsgBody(bodyBuf, bodyType) {
      var startIdx = {};
      var bodyObj = {};
      if (bodyType === 'CAMERA') {
        startIdx.width = 0;
        startIdx.height = 2;
        startIdx.fps = 4;
        bodyObj.width = 720;
        bodyObj.height = 1280;
        bodyObj.fps = 30;
      }
      if (bodyType === 'MICROPHONE') {
        startIdx.maxFrameSize = 0;
        startIdx.foramt = 2;
        startIdx.channel = 6;
        bodyObj.maxFrameSize = 7680;
        bodyObj.foramt = 1;
        bodyObj.channel = 1;
      }
      for (var keyName in bodyObj) {
        bodyObj[keyName] = this.getUnit16FromArray(bodyBuf, startIdx[keyName]);
      }
      return bodyObj;
    }

    /**
     *
     * @param {object} buf 8位无符号整型数组Uint8Array
     * @returns 消息头信息，除len(unit32)占4位，其他均占两位(unit16)
     */
  }, {
    key: "getMsgHeader",
    value: function getMsgHeader(buf) {
      var strStartIdx = {
        version: 0,
        optType: 2,
        devType: 4,
        devId: 6,
        len: 8,
        nextProto: 12,
        hopLimits: 14
      };
      var headerObj = {
        version: 0,
        optType: 0,
        devType: 0,
        devId: 0,
        len: 0,
        nextProto: 0,
        hopLimits: 0
      };
      for (var keyName in headerObj) {
        if (keyName === 'len') {
          headerObj[keyName] = this.getUnit32FromArray(buf, strStartIdx[keyName]);
        } else {
          headerObj[keyName] = this.getUnit16FromArray(buf, strStartIdx[keyName]);
        }
      }
      return headerObj;
    }
  }, {
    key: "getUnit16FromArray",
    value: function getUnit16FromArray(array, index) {
      return array[index] << 8 | array[index + 1];
    }

    /**
     *
     * @param {object} array Unit8Array数组
     * @param {number} index 要取出的unit32在数组中的起始位置
     * @returns
     */
  }, {
    key: "getUnit32FromArray",
    value: function getUnit32FromArray(array, index) {
      return array[index] << 24 | array[index + 1] << 16 | array[index + 2] << 8 | array[index + 3];
    }
  }, {
    key: "setInterval",
    value: function setInterval(callback) {
      var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
      var execute = arguments.length > 2 ? arguments[2] : undefined;
      var timeState = {
          time: 0,
          clear: function clear() {
            clearTimeout(timeState.time);
          }
        },
        nextInterval = interval;
      if (execute) callback();
      (function func() {
        var date = Date.now();
        timeState.time = setTimeout(function () {
          var resp = callback();
          if (resp === false) return;
          nextInterval = interval - (nextInterval - (Date.now() - date));
          func();
        }, nextInterval);
      })();
      return timeState;
    }
  }, {
    key: "getCheckSum",
    value: function getCheckSum(msgType) {
      return msgType + (CAE_STREAM_DELIMITER_MAGICWORD >> 8 & 0xff) + (CAE_STREAM_DELIMITER_MAGICWORD & 0xff) & 0xff;
    }
  }, {
    key: "setMsgHeader",
    value: function setMsgHeader(typedBuf, msgType, msgBodyLen) {
      typedBuf[0] = 90;
      typedBuf[1] = 90;
      typedBuf[2] = this.getCheckSum(_protocolConfig.default.MSG_TYPE[msgType]);
      typedBuf[3] = _protocolConfig.default.MSG_TYPE[msgType];
      typedBuf[4] = msgBodyLen >> 24;
      typedBuf[5] = msgBodyLen >> 16;
      typedBuf[6] = msgBodyLen >> 8;
      typedBuf[7] = msgBodyLen;
    }
  }, {
    key: "paramsSerialize",
    value: function paramsSerialize(params) {
      if (params) {
        var kvs = Object.keys(params).map(function (key) {
          var value = params[key];
          if (key === 'ticket') {
            return [key, value].join('=');
          }
          if (_typeof(value) === 'object') {
            value = Object.keys(value).map(function (subKey) {
              return [subKey, encodeURIComponent(value[subKey])].join('=');
            }).join(':');
            return [key, value].join('=');
          }
          return [key, encodeURIComponent(value)].join('=');
        });
        return kvs.join('&');
      }
      return '';
    }
  }, {
    key: "makeActionMsg",
    value: function makeActionMsg(msgType, msgCmd) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var MSG_CMD_MAP = _objectSpread({}, _protocolConfig.default.CMD_TYPE);
      var msgBody = this.paramsSerialize(_objectSpread({
        command: MSG_CMD_MAP[msgCmd]
      }, params));
      var msgBodyLen = msgBody.length;
      var typedBuf = new Uint8Array(PACKAGE_HEADER_LENGTH + msgBodyLen);
      for (var i = 0; i < msgBodyLen; i++) {
        typedBuf[PACKAGE_HEADER_LENGTH + i] = msgBody.charCodeAt(i);
      }
      this.setMsgHeader(typedBuf, msgType, msgBodyLen);
      return typedBuf;
    }

    /**
     * 判断是否为I帧
     * @param {*} buffer
     * @returns
     */
  }, {
    key: "isKeyFrame",
    value: function isKeyFrame(buffer) {
      if (buffer.length < 5) {
        return false;
      }

      //00 00 00 01
      if (buffer[0] == 0 && buffer[1] == 0 && buffer[2] == 0 && buffer[3] == 1) {
        var nalType = buffer[4] & 0x1f;
        if (nalType == 0x07 || nalType == 0x05 || nalType == 0x08) {
          return true;
        }
      }

      //00 00 01
      if (buffer[0] == 0 && buffer[1] == 0 && buffer[2] == 1) {
        var _nalType = buffer[3] & 0x1f;
        if (_nalType == 0x07 || _nalType == 0x05 || _nalType == 0x08) {
          return true;
        }
      }
      return false;
    }
  }]);
}();
_defineProperty(Util, "getConfig", {
  get basePath() {
    // let path = window.location.origin
    // let pathname = window.location.pathname
    // let demoIdx = pathname.lastIndexOf('/demo')
    // let indexIdx = pathname.lastIndexOf('/index')
    // if (demoIdx !== -1) {
    //   return path + pathname.substr(0, demoIdx)
    // } else if (indexIdx !== -1) {
    //   return path + pathname.substr(0, indexIdx)
    // } else {
    //   return path
    // }
    return window.location.origin;
  },
  get libPath() {
    return this.basePath + '/lib/';
  }
});
Util.saveAsFile = function () {
  var size = 50 * 1024 * 1024;
  var fileBuf = null;
  var pos = 0;
  var downloadOver = false;
  var needHeader = false;
  var headerLength = 8;
  return function (frame) {
    fileBuf = fileBuf || new Uint8Array(size);
    if (!downloadOver && frame) {
      var pkgLen = frame.length + (needHeader ? headerLength : 0);
      if (pos + pkgLen < size) {
        var pkg = new Uint8Array(pkgLen);
        if (needHeader) {
          var header = Uint8Array.from([0x00, 0x00, 0x00, 0x03, frame.length >> 24 & 0xff, frame.length >> 16 & 0xff, frame.length >> 8 & 0xff, frame.length & 0xff]);
          pkg.set(header);
          pkg.set(frame, headerLength);
        } else {
          pkg.set(frame);
        }
        fileBuf.set(pkg, pos);
        pos += pkg.length;
      } else {
        var data = new Blob([fileBuf.buffer], {
          type: 'application/octet-stream'
        });
        var downloadUrl = window.URL.createObjectURL(data);
        var anchor = document.createElement('a');
        anchor.href = downloadUrl;
        anchor.download = 'casVideo.h264';
        document.body.appendChild(anchor);
        anchor.click();
        // 然后移除
        document.body.removeChild(anchor);
        window.URL.revokeObjectURL(data);
        downloadOver = true;
      }
    }
  };
}();

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(52);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(22);
var IE8_DOM_DEFINE = __webpack_require__(155);
var toPrimitive = __webpack_require__(82);
var dP = Object.defineProperty;

exports.f = __webpack_require__(25) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(38);
var $keys = __webpack_require__(62);

__webpack_require__(125)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(28).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(25) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $filter = __webpack_require__(71)(2);

$export($export.P + $export.F * !__webpack_require__(159)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var PROTOCOL_CONFIG = {
  MSG_TYPE: {
    INVALID: 0,
    // 无效
    VERIFY: 1,
    // 认证
    AUDIO: 2,
    // 音频数据
    VIDEO: 3,
    // 视频编码后数据
    CHANNEL: 4,
    //双向数据通道
    TOUCH: 6,
    // 触摸数据
    CMD_CONTROL: 7,
    // 控制指令
    HEART_BEAT: 8,
    // 心跳数据
    ORIENTATION: 9,
    // 旋转
    ORIENTATION_TimeStamp: 10,
    // 旋转与出帧时间
    KEYBOARD_INPUT: 14,
    // 远程输入法
    KEY_EVENT_EVENT: 15,
    CAMERA: 21,
    // 摄相头
    MICROPHONE: 22,
    // 麦克风
    SENSOR: 23,
    // 传感器
    GpsLocation: 24 // gps
  },
  CAMERA_MESSAGE_TYPE: {
    OPT_CAMERA_GET_PARAM_REQ: 0x1,
    OPT_CAMERA_GET_PARAM_RSP: 0x1001,
    OPT_CAMERA_SET_PARAM_REQ: 0x2,
    OPT_CAMERA_SET_PARAM_RSP: 0x1002,
    OPT_CAMERA_GET_INFO_REQ: 0x3,
    OPT_CAMERA_SET_INFO_RSP: 0x1003,
    OPT_CAMERA_START_PREVIEW_REQ: 0x4,
    OPT_CAMERA_START_PREVIEW_RSP: 0x1004,
    OPT_CAMERA_STOP_PREVIEW_REQ: 0x5,
    OPT_CAMERA_STOP_PREVIEW_RSP: 0x1005,
    OPT_CAMERA_IS_SUPPORT_H264_REQ: 0x6,
    OPT_CAMERA_IS_SUPPORT_H264_RSP: 0x1006,
    OPT_CAMERA_GET_SIZE_REQ: 0x7,
    OPT_CAMERA_GET_SIZE_RSP: 0x1007,
    OPT_CAMERA_FRAME: 0x8,
    OPT_INVALID: 0x9
  },
  MICROPHONE_MESSAGE_TYPE: {
    OPT_MIC_START_RECORD_REQ: 0x1,
    OPT_MIC_STOP_RECOED_REQ: 0x2,
    OPT_MIC_SET_PARAM_REQ: 0x3,
    OPT_MIC_AUDIO_FRAME: 0x10,
    OPT_MIC_START_RECORD_RSP: 0x1001,
    OPT_MIC_STOP_RECOED_RSP: 0x1002,
    OPT_MIC_SET_PARAM_RSP: 0x1003
  },
  SENSOR_MESSAGE_TYPE: {
    OPT_SENDOR_ENABLE_REQ: 0x1,
    OPT_SENSOR_ENABLE_RSP: 0x1001,
    OPT_SENSOR_DISABLE_REQ: 0x2,
    OPT_SENSOR_DISABLE_RSP: 0x1002,
    OPT_SENSOR_DATA: 0x10,
    TYPE_ACCELEROMETER: 0,
    TYPE_GYROSCOPE: 1
  },
  GPS_LOCATION_MESSAGE_TYPE: {
    OPT_LOCATION_OPEN_REQ: 0x0,
    OPT_LOCATION_CLOSE_REQ: 0x1,
    OPT_LOCATION_DATA: 0x2
  },
  CMD_TYPE: {
    VERIFY: '0',
    START: '1',
    STOP: '2',
    RECONNECT: '3',
    PAUSE: '4',
    RESUME: '5',
    REQUEST_I_FRAME: '6',
    SET_MEDIA_CONFIG: '7'
  },
  CMD_RESULT: {
    FAIL: '0',
    SUC: '1'
  },
  CMD_RESP_TYPE: {
    CONNECT_FAILED: 0x0301,
    VERIFY_FAILED: 0x0606,
    START_FAILED: 0x0904,
    PAUSE_TIMEOUT: 0x1000,
    PLAY_TIMEOUT: 0x0e00,
    TOUCH_TIMEOUT: 0x0f00,
    MEDIA_CONFIG_SUCCESS: 0x2100,
    START_SUCCESS: 0x0800,
    RECONNECT_PARAMETER_INVALID: 0x0d01,
    RECONNECT_SERVER_UNREACHABLE: 0x0d02,
    RECONNECT_ENGING_START_ERROR: 0x0d03,
    H265_NOT_SUPPORT: 0x1102,
    VERIFY_SESSION_ID_INVALID: 0x0607,
    INVALID_OPERATION: 0xffff,
    PHONE_CONNECTED: 0x2300
  },
  ACTIONS_TYPE: {
    DOWN: 0,
    UP: 1,
    MOVE: 2,
    POINTER_DOWN: 5,
    POINTER_UP: 6
  },
  HEADER_LENGTH: 8,
  ORIENTATION: {
    0: 'PORTRAIT',
    1: 'LANDSCAPE',
    // 从竖屏逆时针旋转90度
    8: 'REVERSE_LANDSCAPE',
    24: 'LANDSCAPE',
    16: 'REVERSE_PORTRAIT'
  },
  RESOLUTIONS: {
    DISPLAY_480P: {
      width: 480,
      height: 848
    },
    DISPLAY_540P: {
      width: 544,
      height: 960
    },
    DISPLAY_720P: {
      width: 720,
      height: 1280
    },
    DISPLAY_1080P: {
      width: 1080,
      height: 1920
    }
  },
  UHD: {
    quality: 'best'
  },
  HD: {
    quality: 'main'
  },
  SD: {
    quality: 'basic'
  },
  DEFAULT_RESOLUTION: {
    width: 720,
    height: 1280
  },
  KEYBOARD_INPUT_MSG_TYPE: {
    INPUT_EVENT: 0x00,
    HIDE_KEYBOARD_EVENT: 0x01,
    TEXT_UPDATE: 0x02,
    IME_PASTE_TO_SDK: 6,
    // PC|移动端 云机到本地
    IME_PASTE_FROM_SDK: 7,
    // 移动端 本地到云机
    IME_PASTE_FROM_PC_SDK: 8 // PC端 本地到云机
  },
  KEYBOARD_INPUT_HEADER_LENGTH: 3,
  REMOTE_IME: {
    CLOUD_PHONE_KEYBOARD: '0',
    CLIENT_KEYBOARD: '1'
  },
  PHONE_CONNECTION_STATE: {
    1: {
      state: 1,
      message: 'The Phone has been connected by other user.'
    },
    2: {
      state: 2,
      message: 'Connection number exceeds the limit.'
    },
    3: {
      state: 3,
      message: 'Connection to phone failed.'
    },
    4: {
      state: 4,
      message: 'No operations for a long time.'
    },
    5: {
      state: 5,
      message: 'Please log in to the cloud phone again.'
    }
  },
  KEYEVENT_KEYCODE_TYPE: {
    ACTION_DOWN: 0,
    ACTION_UP: 1,
    KEYCODE_HOME: 3,
    KEYCODE_BACK: 4,
    KEYCODE_APP_SWITCH: 187,
    VOLUME_UP: 24,
    // 音量+
    VOLUME_DOWN: 25,
    // 音量-
    SCRIPT_VOLUME_UP: 115,
    // 音量+ 解決按键精灵音量+没有触发脚本启动
    SCRIPT_VOLUME_DOWN: 114 // 音量- 解決按键精灵音量-没有触发脚本停止
  },
  PC_KEY_MAP: {
    8: 67,
    // 退格
    32: 62,
    // 空格
    13: 66,
    // 回车
    27: 4,
    // ESC
    38: 19,
    // 上
    40: 20,
    // 下
    39: 22,
    // 右
    37: 21,
    // 左
    20: 115,
    // 大写锁定

    46: 112,
    // delete按键
    36: 122,
    // home键
    35: 123,
    // end键

    33: 92,
    34: 93
  },
  PC_KEY_PRESS_MAP: {
    // A-Z
    65: 29,
    66: 30,
    67: 31,
    68: 32,
    69: 33,
    70: 34,
    71: 35,
    72: 36,
    73: 37,
    74: 38,
    75: 39,
    76: 40,
    77: 41,
    78: 42,
    79: 43,
    80: 44,
    81: 45,
    82: 46,
    83: 47,
    84: 48,
    85: 49,
    86: 50,
    87: 51,
    88: 52,
    89: 53,
    90: 54,
    // a-z
    97: 29,
    98: 30,
    99: 31,
    100: 32,
    101: 33,
    102: 34,
    103: 35,
    104: 36,
    105: 37,
    106: 38,
    107: 39,
    108: 40,
    109: 41,
    110: 42,
    111: 43,
    112: 44,
    113: 45,
    114: 46,
    115: 47,
    116: 48,
    117: 49,
    118: 50,
    119: 51,
    120: 52,
    121: 53,
    122: 54,
    // 0-9
    48: 7,
    49: 8,
    50: 9,
    51: 10,
    52: 11,
    53: 12,
    54: 13,
    55: 14,
    56: 15,
    57: 16,
    44: 55,
    // ,
    46: 56,
    // .
    47: 76,
    // /
    59: 74,
    // ;
    39: 75,
    // ''
    96: 68,
    // 反引号
    45: 69,
    // -
    61: 70,
    // =
    91: 71,
    // [
    93: 72,
    // ]
    92: 73,
    // \
    35: 18,
    // #
    64: 77,
    // @
    42: 155,
    // *
    43: 157,
    // +
    40: 162,
    // (
    41: 163 // )
  },
  PC_INUPT_MAP: {
    8: 67,
    // 退格
    13: 66,
    // 回车
    39: 22,
    // 右
    37: 21 // 左
  },
  KEYBOARD_TYPE_MAP: {
    PC_INPUT: 1,
    // 常规键盘输入
    KEYCODE_INPUT: 2 // keycode输入
  }
};
var _default = exports.default = PROTOCOL_CONFIG;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var html = __webpack_require__(123);
var cof = __webpack_require__(54);
var toAbsoluteIndex = __webpack_require__(83);
var toLength = __webpack_require__(27);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(24)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(50);
var minAssert = __webpack_require__(34);
var minUtils = __webpack_require__(208);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  var i;
  for (i = 0; i < naf.length; i += 1) {
    naf[i] = 0;
  }

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    [],
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  var m8;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
      this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(28);
var createDesc = __webpack_require__(66);
module.exports = __webpack_require__(25) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var hide = __webpack_require__(36);
var has = __webpack_require__(41);
var SRC = __webpack_require__(61)('src');
var $toString = __webpack_require__(238);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(60).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(53);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 41 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(59);
var global = __webpack_require__(19);
var ctx = __webpack_require__(44);
var classof = __webpack_require__(84);
var $export = __webpack_require__(18);
var isObject = __webpack_require__(23);
var aFunction = __webpack_require__(67);
var anInstance = __webpack_require__(76);
var forOf = __webpack_require__(101);
var speciesConstructor = __webpack_require__(129);
var task = __webpack_require__(170).set;
var microtask = __webpack_require__(250)();
var newPromiseCapabilityModule = __webpack_require__(172);
var perform = __webpack_require__(251);
var userAgent = __webpack_require__(173);
var promiseResolve = __webpack_require__(252);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(20)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(75)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(70)($Promise, PROMISE);
__webpack_require__(130)(PROMISE);
Wrapper = __webpack_require__(60)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(100)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(34);
var inherits = __webpack_require__(11);

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(67);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(119);
var defined = __webpack_require__(53);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(18);
var $includes = __webpack_require__(120)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(85)('includes');


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(25)) {
  var LIBRARY = __webpack_require__(59);
  var global = __webpack_require__(19);
  var fails = __webpack_require__(24);
  var $export = __webpack_require__(18);
  var $typed = __webpack_require__(166);
  var $buffer = __webpack_require__(249);
  var ctx = __webpack_require__(44);
  var anInstance = __webpack_require__(76);
  var propertyDesc = __webpack_require__(66);
  var hide = __webpack_require__(36);
  var redefineAll = __webpack_require__(75);
  var toInteger = __webpack_require__(52);
  var toLength = __webpack_require__(27);
  var toIndex = __webpack_require__(167);
  var toAbsoluteIndex = __webpack_require__(83);
  var toPrimitive = __webpack_require__(82);
  var has = __webpack_require__(41);
  var classof = __webpack_require__(84);
  var isObject = __webpack_require__(23);
  var toObject = __webpack_require__(38);
  var isArrayIter = __webpack_require__(127);
  var create = __webpack_require__(69);
  var getPrototypeOf = __webpack_require__(124);
  var gOPN = __webpack_require__(73).f;
  var getIterFn = __webpack_require__(128);
  var uid = __webpack_require__(61);
  var wks = __webpack_require__(20);
  var createArrayMethod = __webpack_require__(71);
  var createArrayIncludes = __webpack_require__(120);
  var speciesConstructor = __webpack_require__(129);
  var ArrayIterators = __webpack_require__(12);
  var Iterators = __webpack_require__(68);
  var $iterDetect = __webpack_require__(100);
  var setSpecies = __webpack_require__(130);
  var arrayFill = __webpack_require__(126);
  var arrayCopyWithin = __webpack_require__(168);
  var $DP = __webpack_require__(28);
  var $GOPD = __webpack_require__(72);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(45);
var $getOwnPropertyDescriptor = __webpack_require__(72).f;

__webpack_require__(125)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(18);
var ownKeys = __webpack_require__(253);
var toIObject = __webpack_require__(45);
var gOPD = __webpack_require__(72);
var createProperty = __webpack_require__(174);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(311).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(65)(module)))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PC_CAMERA_MAX_HEIGHT = exports.PACKAGE_HEADER_LENGTH = exports.MOBILE_CAMERA_MODE_MAP = exports.MIC_START_RECORD_RSP_LEN = exports.MICROPHONE_RSP_LEN = exports.MEDIA_MSG_HEADER_COUNT = exports.FRAME_TYPE_MAP = exports.DEVICE_ORIENTATION_ANGLES = exports.DEFAULT_DEFINITION = exports.DECODER_TYPE_MAP = exports.CLOUD_STATUS_CODE = exports.CLOUD_PHONE_RATIO = exports.CAMERA_RSP_LEN = exports.CAMERA_COMMON_MODE_MAP = void 0;
// Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var DECODER_TYPE_MAP = exports.DECODER_TYPE_MAP = {
  H264: 0,
  H265: 1
};
var MOBILE_CAMERA_MODE_MAP = exports.MOBILE_CAMERA_MODE_MAP = {
  1: 'user',
  // 前置
  0: 'environment' // 后置
};
var CAMERA_COMMON_MODE_MAP = exports.CAMERA_COMMON_MODE_MAP = {
  USER: 1,
  // 前置
  ENVIRONMENT: 0 // 后置
};
var FRAME_TYPE_MAP = exports.FRAME_TYPE_MAP = {
  TYPE265: 'h265',
  TYPE264: 'h264'
};
// 后续CAE优化后，从CAE获取云手机宽高比
var CLOUD_PHONE_RATIO = exports.CLOUD_PHONE_RATIO = 9 / 16;
var PACKAGE_HEADER_LENGTH = exports.PACKAGE_HEADER_LENGTH = 8;
// 媒体类req消息头长度
var MEDIA_MSG_HEADER_COUNT = exports.MEDIA_MSG_HEADER_COUNT = 16;
// 相机rsp长度
var CAMERA_RSP_LEN = exports.CAMERA_RSP_LEN = MEDIA_MSG_HEADER_COUNT + 2;
// 麦克风rsp长度
var MICROPHONE_RSP_LEN = exports.MICROPHONE_RSP_LEN = MEDIA_MSG_HEADER_COUNT + 2;
// 麦克风音频流rsp长度
var MIC_START_RECORD_RSP_LEN = exports.MIC_START_RECORD_RSP_LEN = MEDIA_MSG_HEADER_COUNT + 4;
// pc场景摄像头最大高度
var PC_CAMERA_MAX_HEIGHT = exports.PC_CAMERA_MAX_HEIGHT = 720;
// 默认画质
var DEFAULT_DEFINITION = exports.DEFAULT_DEFINITION = 'HD';
// 设备旋转角度
var DEVICE_ORIENTATION_ANGLES = exports.DEVICE_ORIENTATION_ANGLES = {
  PORTRAIT: 0,
  REVERSE_PORTRAIT: 180,
  LANDSCAPE: 90,
  REVERSE_LANDSCAPE: 270
};

// 云手机状态码
var CLOUD_STATUS_CODE = exports.CLOUD_STATUS_CODE = {
  CAS_CONNECTING: 0x0100,
  CAS_CONNECT_SUCCESS: 0x0200,
  // 512
  CAS_SERVER_UNREACHABLE: 0x0301,
  // 769
  CAS_RESOURCE_IN_USING: 0x0302,
  // 770
  CAS_VERIFYING: 0x0400,
  CAS_VERIFY_SUCCESS: 0x0500,
  // 验证成功
  CAS_VERIFY_PARAMETER_MISSING: 0x0601,
  CAS_VERIFY_PARAMETER_INVALID: 0x0602,
  CAS_VERIFY_AESKEY_QUERY_FAILED: 0x0603,
  CAS_VERIFY_AESKEY_INVALID: 0x0604,
  CAS_VERIFY_DECRYPT_FAILED: 0x0605,
  CAS_VERIFY_FAILED: 0x0606,
  CAE_VERIFY_SESSION_ID_INVALID: 0x0607,
  CAS_START_SUCCESS: 0x0800,
  // 2048
  CAS_PARAMETER_MISSING: 0x0904,
  CAS_CONNECT_LOST: 0x0a00,
  // 2560
  CAS_RECONNECTING: 0x0b00,
  // 重新连接 2816
  CAS_RECONNECT_SUCCESS: 0x0c00,
  // 3072
  CAS_RECONNECT_PARAMETER_INVALID: 0x0d01,
  CAS_RECONNECT_SERVER_UNREACHABLE: 0x0d02,
  CAS_RECONNECT_ENGING_START_ERROR: 0x0d03,
  CAS_CONNECTION_LOST: 0x0d04,
  CAS_TRAIL_PLAY_TIMEOUT: 0x0e00,
  CAS_NOTOUCH_TIMEOUT: 0x0f00,
  CAS_HOME_TIMEOUT: 0x1000,
  CAS_ENCODE_ERROR: 0x1100,
  CAS_ENGINE_START_FAILED: 0x1101,
  CAS_H265_NOT_SUPPORT: 0x1102,
  CAS_SWITCH_BACKGROUND_SUCCESS: 0x1200,
  CAS_SWITCH_BACKGROUND_ERROR: 0x1301,
  CAS_SWITCH_FOREGROUND_SUCCESS: 0x1400,
  CAS_SWITCH_FOREGROUND_ERROR: 0x1501,
  CAS_ORIENTATION: 0x1600
};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(18);
var $map = __webpack_require__(71)(1);

$export($export.P + $export.F * !__webpack_require__(159)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(18);
var context = __webpack_require__(160);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(162)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(10).Buffer;
var Transform = __webpack_require__(182).Transform;
var StringDecoder = __webpack_require__(141).StringDecoder;
var inherits = __webpack_require__(11);

function CipherBase(hashMode) {
	Transform.call(this);
	this.hashMode = typeof hashMode === 'string';
	if (this.hashMode) {
		this[hashMode] = this._finalOrDigest;
	} else {
		this['final'] = this._finalOrDigest;
	}
	if (this._final) {
		this.__final = this._final;
		this._final = null;
	}
	this._decoder = null;
	this._encoding = null;
}
inherits(CipherBase, Transform);

var useUint8Array = typeof Uint8Array !== 'undefined';
var useArrayBuffer = typeof ArrayBuffer !== 'undefined'
	&& typeof Uint8Array !== 'undefined'
	&& ArrayBuffer.isView
	&& (Buffer.prototype instanceof Uint8Array || Buffer.TYPED_ARRAY_SUPPORT);

function toBuffer(data, encoding) {
	/*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */
	if (data instanceof Buffer) {
		return data;
	}

	// Convert strings to Buffer
	if (typeof data === 'string') {
		return Buffer.from(data, encoding);
	}

	/*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */
	if (useArrayBuffer && ArrayBuffer.isView(data)) {
		// Bug in Node.js <6.3.1, which treats this as out-of-bounds
		if (data.byteLength === 0) {
			return Buffer.alloc(0);
		}

		var res = Buffer.from(data.buffer, data.byteOffset, data.byteLength);
		/*
		 * Recheck result size, as offset/length doesn't work on Node.js <5.10
		 * We just go to Uint8Array case if this fails
		 */
		if (res.byteLength === data.byteLength) {
			return res;
		}
	}

	/*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */
	if (useUint8Array && data instanceof Uint8Array) {
		return Buffer.from(data);
	}

	/*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */
	if (
		Buffer.isBuffer(data)
			&& data.constructor
			&& typeof data.constructor.isBuffer === 'function'
			&& data.constructor.isBuffer(data)
	) {
		return Buffer.from(data);
	}

	throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
	var bufferData = toBuffer(data, inputEnc); // asserts correct input type
	var outData = this._update(bufferData);
	if (this.hashMode) {
		return this;
	}

	if (outputEnc) {
		outData = this._toString(outData, outputEnc);
	}

	return outData;
};

CipherBase.prototype.setAutoPadding = function () {};
CipherBase.prototype.getAuthTag = function () {
	throw new Error('trying to get auth tag in unsupported state');
};

CipherBase.prototype.setAuthTag = function () {
	throw new Error('trying to set auth tag in unsupported state');
};

CipherBase.prototype.setAAD = function () {
	throw new Error('trying to set aad in unsupported state');
};

CipherBase.prototype._transform = function (data, _, next) {
	var err;
	try {
		if (this.hashMode) {
			this._update(data);
		} else {
			this.push(this._update(data));
		}
	} catch (e) {
		err = e;
	} finally {
		next(err);
	}
};
CipherBase.prototype._flush = function (done) {
	var err;
	try {
		this.push(this.__final());
	} catch (e) {
		err = e;
	}

	done(err);
};
CipherBase.prototype._finalOrDigest = function (outputEnc) {
	var outData = this.__final() || Buffer.alloc(0);
	if (outputEnc) {
		outData = this._toString(outData, outputEnc, true);
	}
	return outData;
};

CipherBase.prototype._toString = function (value, enc, fin) {
	if (!this._decoder) {
		this._decoder = new StringDecoder(enc);
		this._encoding = enc;
	}

	if (this._encoding !== enc) {
		throw new Error('can’t switch encodings');
	}

	var out = this._decoder.write(value);
	if (fin) {
		out += this._decoder.end();
	}

	return out;
};

module.exports = CipherBase;


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
/* harmony import */ var _platform_node_classes_FormData_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(116);




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isPlainObject(thing) || _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isArray(arr) && !arr.some(isVisitable);
}

const predicates = _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].toFlatObject(_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"], {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (_platform_node_classes_FormData_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"] || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isSpecCompliantForm(formData);

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isBlob(value)) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]('Blob is not supported. Use a Buffer instead.');
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isArrayBuffer(value) || _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isArray(value) && isFlatArray(value)) ||
        ((_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isFileList(value) || _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].endsWith(key, '[]')) && (arr = _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].forEach(value, function each(el, key) {
      const result = !(_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isUndefined(el) || el === null) && visitor.call(
        formData, el, _utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ __webpack_exports__["a"] = (toFormData);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 61 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(156);
var enumBugKeys = __webpack_require__(122);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

function webpackBootstrapFunc (modules) {
/******/  // The module cache
/******/  var installedModules = {};

/******/  // The require function
/******/  function __webpack_require__(moduleId) {

/******/    // Check if module is in cache
/******/    if(installedModules[moduleId])
/******/      return installedModules[moduleId].exports;

/******/    // Create a new module (and put it into the cache)
/******/    var module = installedModules[moduleId] = {
/******/      i: moduleId,
/******/      l: false,
/******/      exports: {}
/******/    };

/******/    // Execute the module function
/******/    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/    // Flag the module as loaded
/******/    module.l = true;

/******/    // Return the exports of the module
/******/    return module.exports;
/******/  }

/******/  // expose the modules object (__webpack_modules__)
/******/  __webpack_require__.m = modules;

/******/  // expose the module cache
/******/  __webpack_require__.c = installedModules;

/******/  // identity function for calling harmony imports with the correct context
/******/  __webpack_require__.i = function(value) { return value; };

/******/  // define getter function for harmony exports
/******/  __webpack_require__.d = function(exports, name, getter) {
/******/    if(!__webpack_require__.o(exports, name)) {
/******/      Object.defineProperty(exports, name, {
/******/        configurable: false,
/******/        enumerable: true,
/******/        get: getter
/******/      });
/******/    }
/******/  };

/******/  // define __esModule on exports
/******/  __webpack_require__.r = function(exports) {
/******/    Object.defineProperty(exports, '__esModule', { value: true });
/******/  };

/******/  // getDefaultExport function for compatibility with non-harmony modules
/******/  __webpack_require__.n = function(module) {
/******/    var getter = module && module.__esModule ?
/******/      function getDefault() { return module['default']; } :
/******/      function getModuleExports() { return module; };
/******/    __webpack_require__.d(getter, 'a', getter);
/******/    return getter;
/******/  };

/******/  // Object.prototype.hasOwnProperty.call
/******/  __webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/  // __webpack_public_path__
/******/  __webpack_require__.p = "/";

/******/  // on error function for async loading
/******/  __webpack_require__.oe = function(err) { console.error(err); throw err; };

  var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE)
  return f.default || f // try to call default if defined to also support babel esmodule exports
}

var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+'
var dependencyRegExp = '\\(\\s*(\/\\*.*?\\*\/)?\\s*.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true

// http://stackoverflow.com/a/2593661/130442
function quoteRegExp (str) {
  return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&')
}

function isNumeric(n) {
  return !isNaN(1 * n); // 1 * n converts integers, integers as string ("123"), 1e3 and "1e3" to integers and strings to NaN
}

function getModuleDependencies (sources, module, queueName) {
  var retval = {}
  retval[queueName] = []

  var fnString = module.toString()
  var wrapperSignature = fnString.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/)
  if (!wrapperSignature) return retval
  var webpackRequireName = wrapperSignature[1]

  // main bundle deps
  var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g')
  var match
  while ((match = re.exec(fnString))) {
    if (match[3] === 'dll-reference') continue
    retval[queueName].push(match[3])
  }

  // dll deps
  re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g')
  while ((match = re.exec(fnString))) {
    if (!sources[match[2]]) {
      retval[queueName].push(match[1])
      sources[match[2]] = __webpack_require__(match[1]).m
    }
    retval[match[2]] = retval[match[2]] || []
    retval[match[2]].push(match[4])
  }

  // convert 1e3 back to 1000 - this can be important after uglify-js converted 1000 to 1e3
  var keys = Object.keys(retval);
  for (var i = 0; i < keys.length; i++) {
    for (var j = 0; j < retval[keys[i]].length; j++) {
      if (isNumeric(retval[keys[i]][j])) {
        retval[keys[i]][j] = 1 * retval[keys[i]][j];
      }
    }
  }

  return retval
}

function hasValuesInQueues (queues) {
  var keys = Object.keys(queues)
  return keys.reduce(function (hasValues, key) {
    return hasValues || queues[key].length > 0
  }, false)
}

function getRequiredModules (sources, moduleId) {
  var modulesQueue = {
    main: [moduleId]
  }
  var requiredModules = {
    main: []
  }
  var seenModules = {
    main: {}
  }

  while (hasValuesInQueues(modulesQueue)) {
    var queues = Object.keys(modulesQueue)
    for (var i = 0; i < queues.length; i++) {
      var queueName = queues[i]
      var queue = modulesQueue[queueName]
      var moduleToCheck = queue.pop()
      seenModules[queueName] = seenModules[queueName] || {}
      if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue
      seenModules[queueName][moduleToCheck] = true
      requiredModules[queueName] = requiredModules[queueName] || []
      requiredModules[queueName].push(moduleToCheck)
      var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName)
      var newModulesKeys = Object.keys(newModules)
      for (var j = 0; j < newModulesKeys.length; j++) {
        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || []
        modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]])
      }
    }
  }

  return requiredModules
}

module.exports = function (moduleId, options) {
  options = options || {}
  var sources = {
    main: __webpack_require__.m
  }

  var requiredModules = options.all ? { main: Object.keys(sources.main) } : getRequiredModules(sources, moduleId)

  var src = ''

  Object.keys(requiredModules).filter(function (m) { return m !== 'main' }).forEach(function (module) {
    var entryModule = 0
    while (requiredModules[module][entryModule]) {
      entryModule++
    }
    requiredModules[module].push(entryModule)
    sources[module][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })'
    src = src + 'var ' + module + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module].map(function (id) { return '' + JSON.stringify(id) + ': ' + sources[module][id].toString() }).join(',') + '});\n'
  })

  src = src + 'new ((' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function (id) { return '' + JSON.stringify(id) + ': ' + sources.main[id].toString() }).join(',') + '}))(self);'

  var blob = new window.Blob([src], { type: 'text/javascript' })
  if (options.bare) { return blob }

  var URL = window.URL || window.webkitURL || window.mozURL || window.msURL

  var workerUrl = URL.createObjectURL(blob)
  var worker = new window.Worker(workerUrl)
  worker.objectURL = workerUrl

  return worker
}


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(109);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__(91));
util.inherits = __webpack_require__(11);
/*</replacement>*/

var Readable = __webpack_require__(183);
var Writable = __webpack_require__(140);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(22);
var dPs = __webpack_require__(240);
var enumBugKeys = __webpack_require__(122);
var IE_PROTO = __webpack_require__(121)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(118)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(123).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(28).f;
var has = __webpack_require__(41);
var TAG = __webpack_require__(20)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(44);
var IObject = __webpack_require__(119);
var toObject = __webpack_require__(38);
var toLength = __webpack_require__(27);
var asc = __webpack_require__(241);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(86);
var createDesc = __webpack_require__(66);
var toIObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(82);
var has = __webpack_require__(41);
var IE8_DOM_DEFINE = __webpack_require__(155);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(25) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(156);
var hiddenKeys = __webpack_require__(122).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(38);
var $getPrototypeOf = __webpack_require__(124);

__webpack_require__(125)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(37);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(44);
var $export = __webpack_require__(18);
var toObject = __webpack_require__(38);
var call = __webpack_require__(169);
var isArrayIter = __webpack_require__(127);
var toLength = __webpack_require__(27);
var createProperty = __webpack_require__(174);
var getIterFn = __webpack_require__(128);

$export($export.S + $export.F * !__webpack_require__(100)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(260);
var anObject = __webpack_require__(22);
var $flags = __webpack_require__(133);
var DESCRIPTORS = __webpack_require__(25);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(37)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(24)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(10).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(39), __webpack_require__(40)))

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(23);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(52);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(54);
var TAG = __webpack_require__(20)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(20)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(36)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(61)('meta');
var isObject = __webpack_require__(23);
var has = __webpack_require__(41);
var setDesc = __webpack_require__(28).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(24)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(16);
__webpack_require__(17);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var Subscribe = exports.default = /*#__PURE__*/function () {
  function Subscribe(eventNames) {
    var _this = this;
    _classCallCheck(this, Subscribe);
    this._events = {};
    (eventNames || []).forEach(function (name) {
      _this._events[name] = [];
    });
  }
  return _createClass(Subscribe, [{
    key: "trigger",
    value: function trigger(eventName, data) {
      var _this2 = this;
      var events = this._events[eventName];
      events && events.forEach(function (fn) {
        fn && fn.call(_this2, {
          name: eventName
        }, data);
      });
    }
  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (eventName in this._events) {
        this._events[eventName].push(callback);
      }
    }
  }, {
    key: "off",
    value: function off(eventName, callback) {
      var events = this._events[eventName];
      if (events && callback) {
        for (var idx = events.length - 1; idx >= 0; idx--) {
          if (events[idx] === callback) {
            events.splice(idx, 1);
          }
        }
      }
    }
  }]);
}();

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(175);
__webpack_require__(56);
__webpack_require__(46);
__webpack_require__(105);
__webpack_require__(135);
__webpack_require__(31);
__webpack_require__(55);
__webpack_require__(29);
__webpack_require__(17);
__webpack_require__(33);
__webpack_require__(16);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var Logger = /*#__PURE__*/function () {
  function Logger() {
    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Logger.level.warn;
    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
    var isSilent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    _classCallCheck(this, Logger);
    this.level = level;
    this.tags = tags;
    this.size = size;
    this.isSilent = isSilent;
    this.timeline = [];
  }
  return _createClass(Logger, [{
    key: "echo",
    value: function echo(level, tags) {
      var logLevel = Logger.level[level];
      // 生产环境非最高级别错误日志直接退出
      /*global __IS_DEBUG__*/
      if ( true && logLevel < Logger.level.error) {
        return;
      }

      // 允许不传递 tags，此时 tag 用各个 level 对应的默认值
      for (var _len = arguments.length, message = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        message[_key - 2] = arguments[_key];
      }
      if (typeof tags === 'string') {
        message.unshift(tags);
        tags = [Logger.tag[level]];
      }
      if (logLevel >= this.level && this.match(tags, this.tags)) {
        var now = performance && performance.now();
        this.cache.apply(this, [now, tags].concat(message));
        if (!this.isSilent) {
          this.triggerLogCallback(logLevel, now, tags, message);
        }
      }
    }
  }, {
    key: "match",
    value: function match() {
      var tags1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var tags2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      for (var i = 0, len = tags1.length; i < len; i++) {
        if (tags2.includes(tags1[i])) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "reset",
    value: function reset() {
      Logger.cache = [];
      Logger.callbacks = [];
    }
  }, {
    key: "cache",
    value: function cache(timestamp, tags) {
      if (Logger.cache.length >= this.size) {
        Logger.cache.shift();
      }
      for (var _len2 = arguments.length, message = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        message[_key2 - 2] = arguments[_key2];
      }
      Logger.cache.push({
        timestamp: timestamp,
        tags: tags,
        message: message.join('| ')
      });
    }
  }, {
    key: "ana",
    value: function ana() {
      var logs = Logger.cache;
      var tmp = {};
      logs.forEach(function (item) {
        var tags = item.tags || [];
        var traceId = tags.find && tags.find(function (tag) {
          return tag.startsWith('trace_');
        });
        var name = tags.filter && tags.filter(function (tag) {
          return !tag.startsWith('trace_');
        }).join(', ');
        if (traceId) {
          !tmp[traceId] && (tmp[traceId] = {
            id: traceId
          });
          tmp[traceId][name] = item.timestamp;
        }
      });
      var allTotal = 0;
      var allDecode = 0;
      var allRender = 0;
      var allOther = 0;
      var result = Object.keys(tmp).map(function (trace) {
        var total = tmp[trace]['decode, end'] - tmp[trace]['package, begin'];
        var decode = tmp[trace]['decode, end'] - tmp[trace]['decode, begin'];
        var render = tmp[trace]['render, end'] - tmp[trace]['render, begin'];
        var other = total - decode;
        allTotal += total;
        allDecode += decode;
        allRender += render;
        allOther += other;
        tmp[trace]['other/render/decode/total'] = "".concat(other, "/").concat(render, "/").concat(decode, "/").concat(total);
        return tmp[trace];
      });
      var len = result.length;
      result.unshift({
        id: '平均',
        'other/render/decode/total': "".concat(allOther / len, "/").concat(allRender / len, "/").concat(allDecode / len, "/").concat(allTotal / len)
      });
      result.unshift({
        id: '总计',
        'other/render/decode/total': "".concat(allOther, "/").concat(allRender, "/").concat(allDecode, "/").concat(allTotal)
      });
      this.debug([Logger.tag.debug], result);
    }
  }, {
    key: "analysis",
    value: function analysis() {
      var logs = Logger.cache;
      var result = [];
      var start;
      var recv = [];
      var video = [];
      logs.forEach(function (item) {
        if (item.tags.includes('delay')) {
          if (start) {
            result.push({
              start: start,
              end: item,
              recv: recv,
              video: video,
              period: item.timestamp - start.timestamp + 'ms',
              delayChange: (Number(item.message) - Number(start.message)) * 1000 + 'ms',
              recvLen: recv.length + '帧',
              videoLen: video.length + '帧'
            });
            recv = [];
            video = [];
          }
          start = item;
        } else if (item.tags.includes('video')) {
          video.push(item);
        } else if (item.tags.includes('recv')) {
          recv.push(item);
        }
      });
      this.debug([Logger.tag.debug], result);
      return result;
    }
  }, {
    key: "videoAna",
    value: function videoAna() {
      var logs = Logger.cache;
      var tmp = {};
      logs.forEach(function (item) {
        var tags = item.tags || [];
        var traceId = tags.find && tags.find(function (tag) {
          return tag.startsWith('trace_');
        });
        var name = tags.filter && tags.filter(function (tag) {
          return !tag.startsWith('trace_');
        }).join(', ');
        if (traceId) {
          !tmp[traceId] && (tmp[traceId] = {
            id: traceId
          });
          // 'event, appending, buffer' 用于查看video缓存信息
          // 'recv, diffT' 用于计算接收视频数据间隔
          if (name === 'event, appending, buffer' || name === 'recv, diffT') {
            tmp[traceId][name] = item.message;
          } else {
            tmp[traceId][name] = item.timestamp;
          }
        }
      });
      var allTotal = 0;
      var allFormat = 0;
      var allAppending1 = 0;
      var allAppending2 = 0;
      var allToBuffer = 0;
      var maxTotal = 0;
      var maxFormat = 0;
      var maxAppending1 = 0;
      var maxAppending2 = 0;
      var maxToBuffer = 0;
      var result = Object.keys(tmp).map(function (trace) {
        var total = Number((tmp[trace]['event, appendBuffer, 1'] - tmp[trace]['analysis, end']).toFixed(3));
        // let analysis = (tmp[trace]['analysis, end'] - tmp[trace]['event, recv']).toFixed(3));
        var format = Number((tmp[trace]['format, end'] - tmp[trace]['analysis, end']).toFixed(3));
        var appending1 = Number((tmp[trace]['event, appendBuffer, 0'] - tmp[trace]['format, end']).toFixed(3));
        var appending2 = Number((tmp[trace]['event, appendBuffer, 1'] - tmp[trace]['event, appendBuffer, 0']).toFixed(3));
        var formatToBuffer = Number((tmp[trace]['event, appendBuffer, 1'] - tmp[trace]['format, end']).toFixed(3));
        maxTotal = Math.max(maxTotal, total);
        maxFormat = Math.max(maxFormat, format);
        maxAppending1 = Math.max(maxAppending1, appending1);
        maxAppending2 = Math.max(maxAppending2, appending2);
        maxToBuffer = Math.max(maxToBuffer, formatToBuffer);
        allTotal += total;
        allFormat += format;
        allAppending1 += appending1;
        allAppending2 += appending2;
        allToBuffer += formatToBuffer;
        tmp[trace]['format/appending1/appending2/formatToBuffer/total'] = "".concat(format, "/").concat(appending1, "/").concat(appending2, "/").concat(formatToBuffer, "/").concat(total);
        return tmp[trace];
      });
      var resultLen = result.length;
      result.unshift({
        id: '最大值',
        'format/appending1/appending2/formatToBuffer/total': "".concat(maxFormat, "/").concat(maxAppending1, "/").concat(maxAppending2, "/").concat(maxToBuffer, "/").concat(maxTotal)
      });
      result.unshift({
        id: '平均',
        'format/appending1/appending2/formatToBuffer/total': "".concat((allFormat / resultLen).toFixed(3), "/").concat((allAppending1 / resultLen).toFixed(3), "/").concat((allAppending2 / resultLen).toFixed(3), "/").concat((allToBuffer / resultLen).toFixed(3), "/").concat((allTotal / resultLen).toFixed(3))
      });
      result.unshift({
        id: '总计',
        'format/appending1/appending2/formatToBuffer/total': "".concat(allFormat.toFixed(3), "/").concat(allAppending1.toFixed(3), "/").concat(allAppending2.toFixed(3), "/").concat(allToBuffer.toFixed(3), "/").concat(allTotal.toFixed(3))
      });
      this.debug([Logger.tag.debug], result);
      this.debug([Logger.tag.debug], '接收视频帧间隔时间大于70', result.filter(function (item) {
        return item['recv, diffT'] && Number(item['recv, diffT']) > 70;
      }));
      // 计算帧率
      var videoResult = result.filter(function (item) {
        return Boolean(item['analysis, end']);
      });
      var videoResultLen = videoResult.length;
      if (videoResultLen > 0) {
        var firstTime = videoResult[0] && Number(videoResult[0].id.slice(6));
        var lastTime = videoResult[videoResultLen - 1] && Number(videoResult[videoResultLen - 1].id.slice(6));
        this.debug([Logger.tag.debug], 'fps: ' + (videoResultLen - 1) * 1000 / (lastTime - firstTime));
      }
    }
  }, {
    key: "table",
    value: function table(tags) {
      var _this = this;
      var list = Logger.cache;
      if (tags && tags.length) {
        list = Logger.cache.filter(function (item) {
          return _this.match(tags, item.tags);
        });
      }
      this.debug([Logger.tag.debug], list);
    }
  }, {
    key: "toCSV",
    value: function toCSV() {
      var list = Logger.cache.map(function (item) {
        return "".concat(String(item.timestamp), ",").concat(item.tags, ",").concat(item.message);
      });
      list.unshift('timestamp,tags,message');
      return [list.join('\n')];
    }
  }, {
    key: "export",
    value: function _export() {
      var data = new Blob(this.toCSV(), {
        type: 'application/octet-stream'
      });
      var anchor = document.createElement('a');
      anchor.href = window.URL.createObjectURL(data);
      anchor.download = "log-".concat(Date.now(), ".csv");
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(data);
    }
  }, {
    key: "debug",
    value: function debug(tags) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      this.echo.apply(this, ['debug', tags].concat(args));
    }
  }, {
    key: "info",
    value: function info(tags) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      this.echo.apply(this, ['info', tags].concat(args));
    }
  }, {
    key: "warn",
    value: function warn(tags) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }
      this.echo.apply(this, ['warn', tags].concat(args));
    }
  }, {
    key: "error",
    value: function error(tags) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      this.echo.apply(this, ['error', tags].concat(args));
    }
  }, {
    key: "triggerLogCallback",
    value: function triggerLogCallback(echoLevel, time, tags, message) {
      var _this2 = this;
      Logger.callbacks.forEach(function (item) {
        // 触发级别等于或低于 echoLevel 的所有事件，高级别消息通知可以触发低级别事件，低级别消息通知不能触发高级别事件
        if (echoLevel >= item.level && _this2.match(item.tags, tags)) {
          item.func({
            time: time,
            tags: tags,
            message: message
          });
        }
      });
    }
  }, {
    key: "onLogReceived",
    value: function onLogReceived(func) {
      if (typeof func === 'function') {
        Logger.callbacks.push({
          level: this.level,
          tags: this.tags,
          func: func
        });
      }
    }
  }]);
}();
Logger.cache = [];
Logger.callbacks = [];
Logger.level = {
  debug: 1,
  info: 2,
  warn: 3,
  error: 4
};
Logger.tag = {
  debug: 'DEBUG',
  info: 'INFO',
  warn: 'WARN',
  error: 'ERROR'
};

// 生产环境限制日志级别为最高级，用户只能获取错误日志
var logLevel = Logger.level.error;
var logTags = [Logger.tag.error];
/*global __IS_DEBUG__*/
if (false) {}
var logger = new Logger(logLevel, logTags);
var _default = exports.default = logger;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(11)
var MD5 = __webpack_require__(137)
var RIPEMD160 = __webpack_require__(142)
var sha = __webpack_require__(143)
var Base = __webpack_require__(57)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(4).Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);
var assert = __webpack_require__(34);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(330);

asn1.define = __webpack_require__(332).define;
asn1.base = __webpack_require__(95);
asn1.constants = __webpack_require__(214);
asn1.decoders = __webpack_require__(337);
asn1.encoders = __webpack_require__(339);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(334).Reporter;
base.DecoderBuffer = __webpack_require__(213).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(213).EncoderBuffer;
base.Node = __webpack_require__(335);


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(23);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(60);
var global = __webpack_require__(19);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(59) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 98 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(165)('asyncIterator');


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(20)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(44);
var call = __webpack_require__(169);
var isArrayIter = __webpack_require__(127);
var anObject = __webpack_require__(22);
var toLength = __webpack_require__(27);
var getIterFn = __webpack_require__(128);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(161);
var anObject = __webpack_require__(22);
var speciesConstructor = __webpack_require__(129);
var advanceStringIndex = __webpack_require__(131);
var toLength = __webpack_require__(27);
var callRegExpExec = __webpack_require__(103);
var regexpExec = __webpack_require__(132);
var fails = __webpack_require__(24);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(104)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(84);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(254);
var redefine = __webpack_require__(37);
var hide = __webpack_require__(36);
var fails = __webpack_require__(24);
var defined = __webpack_require__(53);
var wks = __webpack_require__(20);
var regexpExec = __webpack_require__(132);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(18);
var $find = __webpack_require__(71)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(85)(KEY);


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESPONSE_CODE = exports.REQUEST_CODE = exports.MAX_CONNCENT_COUNT = exports.LINK_METHOD = exports.HEART_BEAT_INTERVAL = exports.CUSTOM_CLOUD_STATUS = exports.CLOUD_STATUS_CODE = void 0;
var MAX_CONNCENT_COUNT = exports.MAX_CONNCENT_COUNT = 3; // 最大重连次数
var HEART_BEAT_INTERVAL = exports.HEART_BEAT_INTERVAL = 1000; // 心跳包间隔

// 发送到截图服务的信息类型
var REQUEST_CODE = exports.REQUEST_CODE = {
  HEART_BEAT: 'heart_beat',
  // 心跳包
  CONNECT: 'connect',
  // 连接云手机
  REQUEST_I_FRAME: 'request_i_frame',
  // 获取I帧
  DISCONNECT: 'disconnect',
  // 断开云手机
  CLOUD_HANDLE: 'cloud_handle',
  // 操作设备
  EASY_LINK: 'easy_link' // 简易连接(通过token和phoneId)
};
//链接方式
var LINK_METHOD = exports.LINK_METHOD = {
  DIRECT: '0',
  // 直连
  NODE: '1' // Node连接
};
// 响应给客户端的信息类型
var RESPONSE_CODE = exports.RESPONSE_CODE = {
  HEART_BEAT: 'heart_beat',
  // 心跳包
  UPDATE_STATUS: 'update_status',
  // 更新状态
  SEND_SCREENSHOT: 'send_screenshot',
  // 发送截图
  SEND_FRAME: 'send_frame',
  // 发送帧数据
  CLOUD_DISCONNECT: 'cloud_disconnect',
  // 云手机断开连接(已被占用)
  CLOUD_SUCCESS_DISCONNECT: 'cloud_success_disconnect',
  // 云手机主动断开断开连接成功

  CLOUD_COPY_TEXT: 'cloud_copy_text',
  // 云手机复制内容到剪切板
  CLOUD_CAMERA_PKG: 'cloud_camera_pkg',
  // camera包
  CLOUD_AUDIO_PKG: 'cloud_audio_pkg',
  // 云手机音频
  CLOUD_ORIENTATION_PKG: 'cloud_orientation_pkg',
  // 云手机方向
  CLOUD_SENSOR_PKG: 'cloud_sensor_pkg',
  // 传感器包
  CLOUD_MICROPHONE_PKG: 'cloud_microPhone_pkg',
  // 麦克风
  CLOUD_HEARTBEAT_PKG: 'cloud_heartBeat_pkg',
  // 时延
  CLOUD_HEARTBEAT_RSP: 'cloud_heartBeat_rsp',
  // 服务端心跳响应包
  AUTH_FAILURE: 'auth_failure',
  // 鉴权失效
  ULTRA_VIRES: 'ultra_vires' // 越权操作(没有权限对云手机进行操作)
};

// 云手机状态码
var CLOUD_STATUS_CODE = exports.CLOUD_STATUS_CODE = {
  CAS_CONNECTING: 0x0100,
  CAS_CONNECT_SUCCESS: 0x0200,
  // 512
  CAS_SERVER_UNREACHABLE: 0x0301,
  // 769
  CAS_RESOURCE_IN_USING: 0x0302,
  // 770
  CAS_VERIFYING: 0x0400,
  CAS_VERIFY_SUCCESS: 0x0500,
  // 验证成功
  CAS_VERIFY_PARAMETER_MISSING: 0x0601,
  CAS_VERIFY_PARAMETER_INVALID: 0x0602,
  CAS_VERIFY_AESKEY_QUERY_FAILED: 0x0603,
  CAS_VERIFY_AESKEY_INVALID: 0x0604,
  CAS_VERIFY_DECRYPT_FAILED: 0x0605,
  CAS_VERIFY_FAILED: 0x0606,
  CAE_VERIFY_SESSION_ID_INVALID: 0x0607,
  CAS_START_SUCCESS: 0x0800,
  // 2048
  CAS_PARAMETER_MISSING: 0x0904,
  CAS_CONNECT_LOST: 0x0a00,
  // 2560
  CAS_RECONNECTING: 0x0b00,
  // 重新连接 2816
  CAS_RECONNECT_SUCCESS: 0x0c00,
  // 3072
  CAS_RECONNECT_PARAMETER_INVALID: 0x0d01,
  CAS_RECONNECT_SERVER_UNREACHABLE: 0x0d02,
  CAS_RECONNECT_ENGING_START_ERROR: 0x0d03,
  CAS_CONNECTION_LOST: 0x0d04,
  CAS_TRAIL_PLAY_TIMEOUT: 0x0e00,
  CAS_NOTOUCH_TIMEOUT: 0x0f00,
  CAS_HOME_TIMEOUT: 0x1000,
  CAS_ENCODE_ERROR: 0x1100,
  CAS_ENGINE_START_FAILED: 0x1101,
  CAS_H265_NOT_SUPPORT: 0x1102,
  CAS_SWITCH_BACKGROUND_SUCCESS: 0x1200,
  CAS_SWITCH_BACKGROUND_ERROR: 0x1301,
  CAS_SWITCH_FOREGROUND_SUCCESS: 0x1400,
  CAS_SWITCH_FOREGROUND_ERROR: 0x1501,
  CAS_ORIENTATION: 0x1600
};

// 自定义云手机连接状态
var CUSTOM_CLOUD_STATUS = exports.CUSTOM_CLOUD_STATUS = {
  UN_CONNECT: 0,
  // 未连接
  CONNECTED: 1,
  // 已连接
  DIS_CONNECTED: 2,
  //2断开连接
  CONNECTING: 3,
  //3连接中
  DIS_CONNECTING: 4,
  //4断开连接
  CONNECT_READY: 5,
  //连接就绪
  START_CONNECTING: 6 //开始连接
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(18);
var $values = __webpack_require__(258)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(183);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(140);
exports.Duplex = __webpack_require__(64);
exports.Transform = __webpack_require__(187);
exports.PassThrough = __webpack_require__(273);


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(40)))

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(10).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer
var MD5 = __webpack_require__(137)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(50);
var utils = __webpack_require__(35);
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  var j;
  var nafW;
  for (j = 0; j < naf.length; j += doubles.step) {
    nafW = 0;
    for (var l = j + doubles.step - 1; l >= j; l--)
      nafW = (nafW << 1) + naf[l];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (j = 0; j < repr.length; j++) {
      nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var l = 0; i >= 0 && naf[i] === 0; i--)
      l++;
    if (i >= 0)
      l++;
    acc = acc.dblp(l);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
  points,
  coeffs,
  len,
  jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  var i;
  var j;
  var p;
  for (i = 0; i < len; i++) {
    p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b], /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3,  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (j = 0; j < len; j++) {
      var z = tmp[j];
      p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
      bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null,
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles,
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res,
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asn1 = __webpack_require__(329);
var aesid = __webpack_require__(342);
var fixProc = __webpack_require__(343);
var ciphers = __webpack_require__(145);
var compat = __webpack_require__(193);
var Buffer = __webpack_require__(10).Buffer;

function decrypt(data, password) {
	var salt = data.algorithm.decrypt.kde.kdeparams.salt;
	var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
	var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')];
	var iv = data.algorithm.decrypt.cipher.iv;
	var cipherText = data.subjectPrivateKey;
	var keylen = parseInt(algo.split('-')[1], 10) / 8;
	var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
	var cipher = ciphers.createDecipheriv(algo, key, iv);
	var out = [];
	out.push(cipher.update(cipherText));
	out.push(cipher['final']());
	return Buffer.concat(out);
}

function parseKeys(buffer) {
	var password;
	if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
		password = buffer.passphrase;
		buffer = buffer.key;
	}
	if (typeof buffer === 'string') {
		buffer = Buffer.from(buffer);
	}

	var stripped = fixProc(buffer, password);

	var type = stripped.tag;
	var data = stripped.data;
	var subtype, ndata;
	switch (type) {
		case 'CERTIFICATE':
			ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
			// falls through
		case 'PUBLIC KEY':
			if (!ndata) {
				ndata = asn1.PublicKey.decode(data, 'der');
			}
			subtype = ndata.algorithm.algorithm.join('.');
			switch (subtype) {
				case '1.2.840.113549.1.1.1':
					return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
				case '1.2.840.10045.2.1':
					ndata.subjectPrivateKey = ndata.subjectPublicKey;
					return {
						type: 'ec',
						data: ndata
					};
				case '1.2.840.10040.4.1':
					ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
					return {
						type: 'dsa',
						data: ndata.algorithm.params
					};
				default: throw new Error('unknown key id ' + subtype);
			}
			// throw new Error('unknown key type ' + type)
		case 'ENCRYPTED PRIVATE KEY':
			data = asn1.EncryptedPrivateKey.decode(data, 'der');
			data = decrypt(data, password);
			// falls through
		case 'PRIVATE KEY':
			ndata = asn1.PrivateKey.decode(data, 'der');
			subtype = ndata.algorithm.algorithm.join('.');
			switch (subtype) {
				case '1.2.840.113549.1.1.1':
					return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
				case '1.2.840.10045.2.1':
					return {
						curve: ndata.algorithm.curve,
						privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
					};
				case '1.2.840.10040.4.1':
					ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der');
					return {
						type: 'dsa',
						params: ndata.algorithm.params
					};
				default: throw new Error('unknown key id ' + subtype);
			}
			// throw new Error('unknown key type ' + type)
		case 'RSA PUBLIC KEY':
			return asn1.RSAPublicKey.decode(data, 'der');
		case 'RSA PRIVATE KEY':
			return asn1.RSAPrivateKey.decode(data, 'der');
		case 'DSA PRIVATE KEY':
			return {
				type: 'dsa',
				params: asn1.DSAPrivateKey.decode(data, 'der')
			};
		case 'EC PRIVATE KEY':
			data = asn1.ECPrivateKey.decode(data, 'der');
			return {
				curve: data.parameters.value,
				privateKey: data.privateKey
			};
		default: throw new Error('unknown key type ' + type);
	}
}
parseKeys.signature = asn1.signature;

module.exports = parseKeys;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bind; });


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// eslint-disable-next-line strict
/* harmony default export */ __webpack_exports__["a"] = (null);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(59);
var $export = __webpack_require__(18);
var redefine = __webpack_require__(37);
var hide = __webpack_require__(36);
var Iterators = __webpack_require__(68);
var $iterCreate = __webpack_require__(239);
var setToStringTag = __webpack_require__(70);
var getPrototypeOf = __webpack_require__(124);
var ITERATOR = __webpack_require__(20)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(23);
var document = __webpack_require__(19).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(54);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(45);
var toLength = __webpack_require__(27);
var toAbsoluteIndex = __webpack_require__(83);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(97)('keys');
var uid = __webpack_require__(61);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(19).document;
module.exports = document && document.documentElement;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(41);
var toObject = __webpack_require__(38);
var IE_PROTO = __webpack_require__(121)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(18);
var core = __webpack_require__(60);
var fails = __webpack_require__(24);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(38);
var toAbsoluteIndex = __webpack_require__(83);
var toLength = __webpack_require__(27);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(68);
var ITERATOR = __webpack_require__(20)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(84);
var ITERATOR = __webpack_require__(20)('iterator');
var Iterators = __webpack_require__(68);
module.exports = __webpack_require__(60).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(22);
var aFunction = __webpack_require__(67);
var SPECIES = __webpack_require__(20)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var dP = __webpack_require__(28);
var DESCRIPTORS = __webpack_require__(25);
var SPECIES = __webpack_require__(20)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(154)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(133);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(22);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(21);
__webpack_require__(16);
__webpack_require__(17);
var _Logger = _interopRequireDefault(__webpack_require__(89));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var CAE_STREAM_DELIMITER_MAGICWORD = 0x5a5a;
var WEBSOCKET_OPEN_STATE = 1;
var HEART_BEAT_INTERVAL = 500;
var PACKAGE_HEADER_LENGTH = 8;
var MSG_TYPE_MAP = {
  cmdControl: 7,
  heartBeat: 8
};
var MSG_CMD_MAP = {
  start: '0',
  stop: '1',
  heartBeat: '2',
  reconnect: '4',
  pause: '5',
  recover: '6'
};
var SocketWorker = /*#__PURE__*/function () {
  function SocketWorker() {
    _classCallCheck(this, SocketWorker);
    this.ws = null;
    this.heartBeatTimer = null;
  }
  return _createClass(SocketWorker, [{
    key: "getCheckSum",
    value: function getCheckSum(msgType) {
      return msgType + (CAE_STREAM_DELIMITER_MAGICWORD >> 8 & 0xff) + (CAE_STREAM_DELIMITER_MAGICWORD & 0xff) & 0xff;
    }
  }, {
    key: "makeActionMsg",
    value: function makeActionMsg(msgType, msgCmd, paramStr) {
      var msgBody = 'command=' + MSG_CMD_MAP[msgCmd];
      paramStr && (msgBody += '&' + paramStr);
      var cmdBuf = new Uint8Array(PACKAGE_HEADER_LENGTH + msgBody.length);
      cmdBuf[0] = 90;
      cmdBuf[1] = 90;
      cmdBuf[2] = this.getCheckSum(MSG_TYPE_MAP[msgType]);
      cmdBuf[3] = MSG_TYPE_MAP[msgType];
      cmdBuf[4] = 0;
      cmdBuf[5] = 0;
      cmdBuf[6] = 0;
      cmdBuf[7] = msgBody.length;
      for (var i = 0, len = msgBody.length; i < len; i++) {
        cmdBuf[PACKAGE_HEADER_LENGTH + i] = msgBody.charCodeAt(i);
      }
      return cmdBuf.buffer;
    }
  }, {
    key: "startHeartbeat",
    value: function startHeartbeat() {
      var _this = this;
      var buf = this.makeActionMsg('heartBeat', 'heartBeat');
      buf && this.ws.send(buf);
      this.heartBeatTimer && clearInterval(this.heartBeatTimer);
      this.heartBeatTimer = setInterval(function () {
        if (WEBSOCKET_OPEN_STATE === _this.ws.readyState) {
          var _buf = _this.makeActionMsg('heartBeat', 'heartBeat');
          _this.ws.send(_buf);

          // 心跳发送数据数量超过maxCount则停止发送，避免异常断网等导致未及时收到响应导致数组过大。
          _this.onHeartbeatSended && _this.onHeartbeatSended(Date.now());
        } else {
          _this.stopHeartbeat();
        }
      }, HEART_BEAT_INTERVAL);
    }
  }, {
    key: "stopHeartbeat",
    value: function stopHeartbeat() {
      clearInterval(this.heartBeatTimer);
      _Logger.default.debug('Stop sending heartbeat.');
    }
  }, {
    key: "init",
    value: function init(options) {
      var _this2 = this;
      this.ws = new WebSocket(options.protocol + '://' + options.connectURI);
      // this.options = options

      if (options.binaryType != 'string') this.ws.binaryType = 'arraybuffer';
      this.ws.onopen = function () {
        _this2.onOpen && _this2.onOpen(_this2.ws.readyState);
        if (options.needHeatBeat) {
          _this2.startHeartbeat();
        }
      };
      this.ws.onmessage = function (evt) {
        // console.log('socket recv: ', date)
        _this2.onMessage && _this2.onMessage(evt.data);
      };
      this.ws.onerror = function (evt) {
        _Logger.default.debug('ws error: ', evt);
        _this2.onError && _this2.onError();
      };
      this.ws.onclose = function () {
        _this2.onClose && _this2.onClose(_this2.ws.readyState);
      };
    }
  }, {
    key: "send",
    value: function send(buf) {
      var _this$ws;
      (_this$ws = this.ws) === null || _this$ws === void 0 || _this$ws.send(buf);
    }
  }, {
    key: "processReq",
    value: function processReq(req) {
      switch (req.cmd) {
        case 'initReq':
          this.init(req.options);
          break;
        case 'sendReq':
          this.send(req.data);
          break;
        case 'startHeartbeatReq':
          this.startHeartbeat();
          break;
        case 'stopHeartbeatReq':
          this.stopHeartbeat();
          break;
        case 'closeReq':
          this.destroy();
          break;
        case 'socketStateReq':
          this.onState(this.ws.readyState);
          break;
        default:
          _Logger.default.debug('Unknown command socket worker received.');
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.ws && this.ws.close();
    }
  }]);
}();
if (typeof self !== 'undefined') {
  self.socket = new SocketWorker();
  self.socket.onOpen = function (state) {
    self.postMessage({
      cmd: 'openRsp',
      state: state
    });
  };
  self.socket.onError = function () {
    self.postMessage({
      cmd: 'errorRsp'
    });
  };
  self.socket.onMessage = function (data) {
    // if (self.socket.options?.binaryType === 'string')
    //   console.log('socketNe', Date.now())
    self.postMessage({
      cmd: 'recvRsp',
      buf: data,
      time: Date.now()
    });
  };
  self.socket.onHeartbeatSended = function (time) {
    self.postMessage({
      cmd: 'heartbeatRsp',
      time: time
    });
  };
  self.socket.onClose = function (state) {
    self.postMessage({
      cmd: 'closeRsp',
      state: state
    });
  };
  self.socket.onState = function (state) {
    self.postMessage({
      cmd: 'socketStateRsp',
      state: state
    });
  };
  self.addEventListener('message', function (evt) {
    var req = evt.data;
    self.socket.processReq(req);
  }, false);
}
var _default = exports.default = SocketWorker;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(18);
var toLength = __webpack_require__(27);
var context = __webpack_require__(160);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(162)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(22);
var toObject = __webpack_require__(38);
var toLength = __webpack_require__(27);
var toInteger = __webpack_require__(52);
var advanceStringIndex = __webpack_require__(131);
var regExpExec = __webpack_require__(103);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(104)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(11)
var HashBase = __webpack_require__(181)
var Buffer = __webpack_require__(10).Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(4)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(109);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__(91));
util.inherits = __webpack_require__(11);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(271)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(184);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(139).Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(185);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(64);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(64);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(40), __webpack_require__(186).setImmediate, __webpack_require__(39)))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(272).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(4).Buffer
var inherits = __webpack_require__(11)
var HashBase = __webpack_require__(181)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(278)
exports.sha1 = __webpack_require__(279)
exports.sha224 = __webpack_require__(280)
exports.sha256 = __webpack_require__(188)
exports.sha384 = __webpack_require__(281)
exports.sha512 = __webpack_require__(189)


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(34);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
  this.padding = options.padding !== false
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(290)
var deciphers = __webpack_require__(298)
var modes = __webpack_require__(202)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(291),
  CBC: __webpack_require__(292),
  CFB: __webpack_require__(293),
  CFB8: __webpack_require__(294),
  CFB1: __webpack_require__(295),
  OFB: __webpack_require__(296),
  CTR: __webpack_require__(200),
  GCM: __webpack_require__(200)
}

var modes = __webpack_require__(202)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(304);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(149);
var randomBytes = __webpack_require__(79);
var Buffer = __webpack_require__(10).Buffer;

function getr(priv) {
	var len = priv.modulus.byteLength();
	var r;
	do {
		r = new BN(randomBytes(len));
	} while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
	return r;
}

function blind(priv) {
	var r = getr(priv);
	var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed();
	return { blinder: blinder, unblinder: r.invm(priv.modulus) };
}

function crt(msg, priv) {
	var blinds = blind(priv);
	var len = priv.modulus.byteLength();
	var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus);
	var c1 = blinded.toRed(BN.mont(priv.prime1));
	var c2 = blinded.toRed(BN.mont(priv.prime2));
	var qinv = priv.coefficient;
	var p = priv.prime1;
	var q = priv.prime2;
	var m1 = c1.redPow(priv.exponent1).fromRed();
	var m2 = c2.redPow(priv.exponent2).fromRed();
	var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
	return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len);
}
crt.getr = getr;

module.exports = crt;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(309).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this._strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // '0' - '9'
    if (c >= 48 && c <= 57) {
      return c - 48;
    // 'A' - 'F'
    } else if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    } else {
      assert(false, 'Invalid character in ' + string);
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this._strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var b = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        b = c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }
      assert(c >= 0 && b < mul, 'Invalid character');
      r += b;
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this._strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  function move (dest, src) {
    dest.words = src.words;
    dest.length = src.length;
    dest.negative = src.negative;
    dest.red = src.red;
  }

  BN.prototype._move = function _move (dest) {
    move(dest, this);
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype._strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  // Check Symbol.for because not everywhere where Symbol defined
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
    try {
      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
      BN.prototype.inspect = inspect;
    }
  } else {
    BN.prototype.inspect = inspect;
  }

  function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  }

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modrn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16, 2);
  };

  if (Buffer) {
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      return this.toArrayLike(Buffer, endian, length);
    };
  }

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  var allocate = function allocate (ArrayType, size) {
    if (ArrayType.allocUnsafe) {
      return ArrayType.allocUnsafe(size);
    }
    return new ArrayType(size);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    this._strip();

    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    var res = allocate(ArrayType, reqLength);
    var postfix = endian === 'le' ? 'LE' : 'BE';
    this['_toArrayLike' + postfix](res, byteLength);
    return res;
  };

  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
    var position = 0;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position++] = word & 0xff;
      if (position < res.length) {
        res[position++] = (word >> 8) & 0xff;
      }
      if (position < res.length) {
        res[position++] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position < res.length) {
          res[position++] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position < res.length) {
      res[position++] = carry;

      while (position < res.length) {
        res[position++] = 0;
      }
    }
  };

  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
    var position = res.length - 1;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position--] = word & 0xff;
      if (position >= 0) {
        res[position--] = (word >> 8) & 0xff;
      }
      if (position >= 0) {
        res[position--] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position >= 0) {
          res[position--] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position >= 0) {
      res[position--] = carry;

      while (position >= 0) {
        res[position--] = 0;
      }
    }
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] >>> wbit) & 0x01;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this._strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this._strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this._strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this._strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this._strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this._strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out._strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out._strip();
  }

  function jumboMulTo (self, num, out) {
    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
    // var fftm = new FFTM();
    // return fftm.mulp(self, num, out);
    return bigMulTo(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out._strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this._strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this._strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) <= num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this._strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this._strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this._strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q._strip();
    }
    a._strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modrn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modrn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modrn = function modrn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return isNegNum ? -acc : acc;
  };

  // WARNING: DEPRECATED
  BN.prototype.modn = function modn (num) {
    return this.modrn(num);
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    this._strip();
    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this._strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is a BN v4 instance
        r.strip();
      } else {
        // r is a BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

    move(a, a.umod(this.m)._forceRed(this));
    return a;
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(65)(module)))

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(310).version;
elliptic.utils = __webpack_require__(35);
elliptic.rand = __webpack_require__(147);
elliptic.curve = __webpack_require__(209);
elliptic.curves = __webpack_require__(151);

// Protocols
elliptic.ec = __webpack_require__(322);
elliptic.eddsa = __webpack_require__(326);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(152);
var curve = __webpack_require__(209);
var utils = __webpack_require__(35);

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve,
      });
      return curve;
    },
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
  ],
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
  ],
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
  ],
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
  ],
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
  ],
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9',
  ],
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658',
  ],
});

var pre;
try {
  pre = __webpack_require__(321);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3',
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15',
    },
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre,
  ],
});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(43);
hash.common = __webpack_require__(93);
hash.sha = __webpack_require__(315);
hash.ripemd = __webpack_require__(319);
hash.hmac = __webpack_require__(320);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(350).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(65)(module)))

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(52);
var defined = __webpack_require__(53);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(25) && !__webpack_require__(24)(function () {
  return Object.defineProperty(__webpack_require__(118)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(41);
var toIObject = __webpack_require__(45);
var arrayIndexOf = __webpack_require__(120)(false);
var IE_PROTO = __webpack_require__(121)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(54);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(24);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(161);
var defined = __webpack_require__(53);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(23);
var cof = __webpack_require__(54);
var MATCH = __webpack_require__(20)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(20)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(23);
var setPrototypeOf = __webpack_require__(243).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(20);


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var core = __webpack_require__(60);
var LIBRARY = __webpack_require__(59);
var wksExt = __webpack_require__(164);
var defineProperty = __webpack_require__(28).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var hide = __webpack_require__(36);
var uid = __webpack_require__(61);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(52);
var toLength = __webpack_require__(27);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(38);
var toAbsoluteIndex = __webpack_require__(83);
var toLength = __webpack_require__(27);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(22);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(44);
var invoke = __webpack_require__(171);
var html = __webpack_require__(123);
var cel = __webpack_require__(118);
var global = __webpack_require__(19);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(54)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 171 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(67);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(28);
var createDesc = __webpack_require__(66);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(22);
var toLength = __webpack_require__(27);
var advanceStringIndex = __webpack_require__(131);
var regExpExec = __webpack_require__(103);

// @@match logic
__webpack_require__(104)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():undefined}(this,function(){"use strict";function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function n(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function o(e,t,r){return t&&n(e.prototype,t),r&&n(e,r),e}function r(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function e(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&i(e,t)}function u(e){return(u=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function i(e,t){return(i=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function c(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function s(a){var s=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],function(){})),!0}catch(e){return!1}}();return function(){var e,t,r,n,i=u(a);return t=s?(e=u(this).constructor,Reflect.construct(i,arguments,e)):i.apply(this,arguments),r=this,!(n=t)||"object"!=typeof n&&"function"!=typeof n?c(r):n}}function f(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function k(e,t){var r;if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(r=function(e,t){if(e){if("string"==typeof e)return f(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?f(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var n=0,i=function(){};return{s:i,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:i}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,s=!0,o=!1;return{s:function(){r=e[Symbol.iterator]()},n:function(){var e=r.next();return s=e.done,e},e:function(e){o=!0,a=e},f:function(){try{s||null==r.return||r.return()}finally{if(o)throw a}}}}var l,d;function g(e){if(l){for(var t=arguments.length,r=new Array(1<t?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];l.apply(void 0,[e].concat(r))}}function h(e){if(d){for(var t=arguments.length,r=new Array(1<t?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];d.apply(void 0,[e].concat(r))}}var y,p=function(){function t(e){a(this,t),this.payload=e,this.nri=(96&this.payload[0])>>5,this.ntype=31&this.payload[0],this.isvcl=1==this.ntype||5==this.ntype,this.stype="",this.isfmb=!1}return o(t,null,[{key:"type",value:function(e){return e.ntype in t.TYPES?t.TYPES[e.ntype]:"UNKNOWN"}},{key:"NDR",get:function(){return 1}},{key:"IDR",get:function(){return 5}},{key:"SEI",get:function(){return 6}},{key:"SPS",get:function(){return 7}},{key:"PPS",get:function(){return 8}},{key:"AUD",get:function(){return 9}},{key:"TYPES",get:function(){var e={};return r(e,t.IDR,"IDR"),r(e,t.SEI,"SEI"),r(e,t.SPS,"SPS"),r(e,t.PPS,"PPS"),r(e,t.NDR,"NDR"),r(e,t.AUD,"AUD"),e}}]),o(t,[{key:"toString",value:function(){return"".concat(t.type(this),": NRI: ").concat(this.getNri())}},{key:"getNri",value:function(){return this.nri}},{key:"type",value:function(){return this.ntype}},{key:"isKeyframe",value:function(){return this.ntype===t.IDR||7===this.stype}},{key:"getPayload",value:function(){return this.payload}},{key:"getPayloadSize",value:function(){return this.payload.byteLength}},{key:"getSize",value:function(){return 4+this.getPayloadSize()}},{key:"getData",value:function(){var e=new Uint8Array(this.getSize());return new DataView(e.buffer).setUint32(0,this.getSize()-4),e.set(this.getPayload(),4),e}}]),t}(),b=function(){function t(e){a(this,t),this.data=e,this.index=0,this.bitLength=8*e.byteLength}return o(t,[{key:"skipBits",value:function(e){if(this.bitsAvailable<e)return!1;this.index+=e}},{key:"readBits",value:function(e,t){var r=!(1<arguments.length&&void 0!==t)||t;return this.getBits(e,this.index,r)}},{key:"getBits",value:function(e,t,r){var n=!(2<arguments.length&&void 0!==r)||r;if(this.bitsAvailable<e)return 0;var i=t%8,a=this.data[t/8|0]&255>>>i,s=8-i;if(e<=s)return n&&(this.index+=e),a>>s-e;n&&(this.index+=s);var o=e-s;return a<<o|this.getBits(o,t+s,n)}},{key:"skipLZ",value:function(){for(var e=0;e<this.bitLength-this.index;++e)if(0!==this.getBits(1,this.index+e,!1))return this.index+=e,e;return e}},{key:"skipUEG",value:function(){this.skipBits(1+this.skipLZ())}},{key:"skipEG",value:function(){this.skipBits(1+this.skipLZ())}},{key:"readUEG",value:function(){var e=this.skipLZ();return this.readBits(e+1)-1}},{key:"readEG",value:function(){var e=this.readUEG();return 1&e?1+e>>>1:-1*(e>>>1)}},{key:"readBoolean",value:function(){return 1===this.readBits(1)}},{key:"readUByte",value:function(e){var t=0<arguments.length&&void 0!==e?e:1;return this.readBits(8*t)}},{key:"readUShort",value:function(){return this.readBits(16)}},{key:"readUInt",value:function(){return this.readBits(32)}},{key:"bitsAvailable",get:function(){return this.bitLength-this.index}}]),t}(),v=function(){function m(e){a(this,m),this.remuxer=e,this.track=e.mp4track}return o(m,null,[{key:"extractNALu",value:function(e){for(var t,r,n=0,i=e.byteLength,a=0,s=[];n<i;)switch(t=e[n++],a){case 0:0===t&&(a=1);break;case 1:a=0===t?2:0;break;case 2:case 3:a=0===t?3:(1===t&&n<i&&(r&&s.push(e.subarray(r,n-a-1)),r=n),0)}return r&&s.push(e.subarray(r,i)),s}},{key:"skipScalingList",value:function(e,t){for(var r=8,n=8,i=0;i<t;i++)0!==n&&(n=(r+e.readEG()+256)%256),r=0===n?r:n}},{key:"readSPS",value:function(e){var t,r,n,i,a,s,o=new b(e),u=0,c=0,f=0,l=0,d=1;if(o.readUByte(),t=o.readUByte(),o.readBits(5),o.skipBits(3),o.readUByte(),o.skipUEG(),100===t||110===t||122===t||244===t||44===t||83===t||86===t||118===t||128===t){var h=o.readUEG();if(3===h&&o.skipBits(1),o.skipUEG(),o.skipUEG(),o.skipBits(1),o.readBoolean()){s=3!==h?8:12;for(var y=0;y<s;++y)o.readBoolean()&&m.skipScalingList(o,y<6?16:64)}}o.skipUEG();var p,v=o.readUEG();if(0===v)o.readUEG();else if(1===v){o.skipBits(1),o.skipEG(),o.skipEG(),r=o.readUEG();for(var k=0;k<r;++k)o.skipEG()}if(o.skipUEG(),o.skipBits(1),n=o.readUEG(),i=o.readUEG(),0===(a=o.readBits(1))&&o.skipBits(1),o.skipBits(1),o.readBoolean()&&(u=o.readUEG(),c=o.readUEG(),f=o.readUEG(),l=o.readUEG()),o.readBoolean()){if(o.readBoolean()){switch(o.readUByte()){case 1:p=[1,1];break;case 2:p=[12,11];break;case 3:p=[10,11];break;case 4:p=[16,11];break;case 5:p=[40,33];break;case 6:p=[24,11];break;case 7:p=[20,11];break;case 8:p=[32,11];break;case 9:p=[80,33];break;case 10:p=[18,11];break;case 11:p=[15,11];break;case 12:p=[64,33];break;case 13:p=[160,99];break;case 14:p=[4,3];break;case 15:p=[3,2];break;case 16:p=[2,1];break;case 255:p=[o.readUByte()<<8|o.readUByte(),o.readUByte()<<8|o.readUByte()]}p&&(d=p[0]/p[1])}o.readBoolean()&&o.skipBits(1),o.readBoolean()&&(o.skipBits(4),o.readBoolean()&&o.skipBits(24)),o.readBoolean()&&(o.skipUEG(),o.skipUEG()),o.readBoolean()&&(o.readUInt(),o.readUInt(),o.readBoolean())}return{width:Math.ceil((16*(n+1)-2*u-2*c)*d),height:(2-a)*(i+1)*16-(a?2:4)*(f+l)}}},{key:"parseHeader",value:function(e){var t=new b(e.getPayload());t.readUByte(),e.isfmb=0===t.readUEG(),e.stype=t.readUEG()}}]),o(m,[{key:"parseSPS",value:function(e){var t=m.readSPS(new Uint8Array(e));this.track.width=t.width,this.track.height=t.height,this.track.sps=[new Uint8Array(e)],this.track.codec="avc1.";for(var r=new DataView(e.buffer,e.byteOffset+1,4),n=0;n<3;++n){var i=r.getUint8(n).toString(16);i.length<2&&(i="0"+i),this.track.codec+=i}}},{key:"parsePPS",value:function(e){this.track.pps=[new Uint8Array(e)]}},{key:"parseNAL",value:function(e){if(!e)return!1;var t=!1;switch(e.type()){case p.IDR:case p.NDR:t=!0;break;case p.PPS:this.track.pps||(this.parsePPS(e.getPayload()),!this.remuxer.readyToDecode&&this.track.pps&&this.track.sps&&(this.remuxer.readyToDecode=!0)),t=!0;break;case p.SPS:this.track.sps||(this.parseSPS(e.getPayload()),!this.remuxer.readyToDecode&&this.track.pps&&this.track.sps&&(this.remuxer.readyToDecode=!0)),t=!0;break;case p.AUD:g("AUD - ignoing");break;case p.SEI:g("SEI - ignoing")}return t}}]),m}(),m=function(){function s(e){a(this,s),this.remuxer=e,this.track=e.mp4track}return o(s,null,[{key:"getHeaderLength",value:function(e){return 1&e[1]?7:9}},{key:"getFrameLength",value:function(e){return(3&e[3])<<11|e[4]<<3|(224&e[5])>>>5}},{key:"isAACPattern",value:function(e){return 255===e[0]&&240==(240&e[1])&&0==(6&e[1])}},{key:"extractAAC",value:function(e){var t,r,n=0,i=e.byteLength,a=[];if(!s.isAACPattern(e))return h("Invalid ADTS audio format"),a;for(t=s.getHeaderLength(e),y=y||e.subarray(0,t);n<i;)r=s.getFrameLength(e),a.push(e.subarray(t,r)),e=e.slice(r),n+=r;return a}},{key:"samplingRateMap",get:function(){return[96e3,88200,64e3,48e3,44100,32e3,24e3,22050,16e3,12e3,11025,8e3,7350]}},{key:"getAACHeaderData",get:function(){return y}}]),o(s,[{key:"setAACConfig",value:function(){var e,t,r,n=new Uint8Array(2),i=s.getAACHeaderData;i&&(e=1+((192&i[2])>>>6),t=(60&i[2])>>>2,r=(1&i[2])<<2,r|=(192&i[3])>>>6,n[0]=e<<3,n[0]|=(14&t)>>1,n[1]|=(1&t)<<7,n[1]|=r<<3,this.track.codec="mp4a.40."+e,this.track.channelCount=r,this.track.config=n,this.remuxer.readyToDecode=!0)}}]),s}(),t=function(){function t(e){a(this,t),this.listener={},this.type=""|e}return o(t,[{key:"on",value:function(e,t){return this.listener[e]||(this.listener[e]=[]),this.listener[e].push(t),!0}},{key:"off",value:function(e,t){if(this.listener[e]){var r=this.listener[e].indexOf(t);return-1<r&&this.listener[e].splice(r,1),!0}return!1}},{key:"offAll",value:function(){this.listener={}}},{key:"dispatch",value:function(e,t){return!!this.listener[e]&&(this.listener[e].map(function(e){e.apply(null,[t])}),!0)}}]),t}(),S=function(){function d(){a(this,d)}return o(d,null,[{key:"init",value:function(){var e;for(e in d.types={avc1:[],avcC:[],btrt:[],dinf:[],dref:[],esds:[],ftyp:[],hdlr:[],mdat:[],mdhd:[],mdia:[],mfhd:[],minf:[],moof:[],moov:[],mp4a:[],mvex:[],mvhd:[],sdtp:[],stbl:[],stco:[],stsc:[],stsd:[],stsz:[],stts:[],tfdt:[],tfhd:[],traf:[],trak:[],trun:[],trex:[],tkhd:[],vmhd:[],smhd:[]})d.types.hasOwnProperty(e)&&(d.types[e]=[e.charCodeAt(0),e.charCodeAt(1),e.charCodeAt(2),e.charCodeAt(3)]);var t=new Uint8Array([0,0,0,0,0,0,0,0,118,105,100,101,0,0,0,0,0,0,0,0,0,0,0,0,86,105,100,101,111,72,97,110,100,108,101,114,0]),r=new Uint8Array([0,0,0,0,0,0,0,0,115,111,117,110,0,0,0,0,0,0,0,0,0,0,0,0,83,111,117,110,100,72,97,110,100,108,101,114,0]);d.HDLR_TYPES={video:t,audio:r};var n=new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,12,117,114,108,32,0,0,0,1]),i=new Uint8Array([0,0,0,0,0,0,0,0]);d.STTS=d.STSC=d.STCO=i,d.STSZ=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0]),d.VMHD=new Uint8Array([0,0,0,1,0,0,0,0,0,0,0,0]),d.SMHD=new Uint8Array([0,0,0,0,0,0,0,0]),d.STSD=new Uint8Array([0,0,0,0,0,0,0,1]);var a=new Uint8Array([105,115,111,109]),s=new Uint8Array([97,118,99,49]),o=new Uint8Array([0,0,0,1]);d.FTYP=d.box(d.types.ftyp,a,o,a,s),d.DINF=d.box(d.types.dinf,d.box(d.types.dref,n))}},{key:"box",value:function(e){for(var t=arguments.length,r=new Array(1<t?t-1:0),n=1;n<t;n++)r[n-1]=arguments[n];for(var i,a=8,s=r.length,o=s;s--;)a+=r[s].byteLength;for((i=new Uint8Array(a))[0]=a>>24&255,i[1]=a>>16&255,i[2]=a>>8&255,i[3]=255&a,i.set(e,4),s=0,a=8;s<o;++s)i.set(r[s],a),a+=r[s].byteLength;return i}},{key:"hdlr",value:function(e){return d.box(d.types.hdlr,d.HDLR_TYPES[e])}},{key:"mdat",value:function(e){return d.box(d.types.mdat,e)}},{key:"mdhd",value:function(e,t){return d.box(d.types.mdhd,new Uint8Array([0,0,0,0,0,0,0,2,0,0,0,3,e>>24&255,e>>16&255,e>>8&255,255&e,t>>24,t>>16&255,t>>8&255,255&t,85,196,0,0]))}},{key:"mdia",value:function(e){return d.box(d.types.mdia,d.mdhd(e.timescale,e.duration),d.hdlr(e.type),d.minf(e))}},{key:"mfhd",value:function(e){return d.box(d.types.mfhd,new Uint8Array([0,0,0,0,e>>24,e>>16&255,e>>8&255,255&e]))}},{key:"minf",value:function(e){return"audio"===e.type?d.box(d.types.minf,d.box(d.types.smhd,d.SMHD),d.DINF,d.stbl(e)):d.box(d.types.minf,d.box(d.types.vmhd,d.VMHD),d.DINF,d.stbl(e))}},{key:"moof",value:function(e,t,r){return d.box(d.types.moof,d.mfhd(e),d.traf(r,t))}},{key:"moov",value:function(e,t,r){for(var n=e.length,i=[];n--;)i[n]=d.trak(e[n]);return d.box.apply(null,[d.types.moov,d.mvhd(r,t)].concat(i).concat(d.mvex(e)))}},{key:"mvex",value:function(e){for(var t=e.length,r=[];t--;)r[t]=d.trex(e[t]);return d.box.apply(null,[d.types.mvex].concat(r))}},{key:"mvhd",value:function(e,t){var r=new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,2,e>>24&255,e>>16&255,e>>8&255,255&e,t>>24&255,t>>16&255,t>>8&255,255&t,0,1,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,255,255,255]);return d.box(d.types.mvhd,r)}},{key:"sdtp",value:function(e){for(var t,r=e.samples||[],n=new Uint8Array(4+r.length),i=0;i<r.length;i++)t=r[i].flags,n[i+4]=t.dependsOn<<4|t.isDependedOn<<2|t.hasRedundancy;return d.box(d.types.sdtp,n)}},{key:"stbl",value:function(e){return d.box(d.types.stbl,d.stsd(e),d.box(d.types.stts,d.STTS),d.box(d.types.stsc,d.STSC),d.box(d.types.stsz,d.STSZ),d.box(d.types.stco,d.STCO))}},{key:"avc1",value:function(e){for(var t,r,n=[],i=[],a=0;a<e.sps.length;a++)r=(t=e.sps[a]).byteLength,n.push(r>>>8&255),n.push(255&r),n=n.concat(Array.prototype.slice.call(t));for(a=0;a<e.pps.length;a++)r=(t=e.pps[a]).byteLength,i.push(r>>>8&255),i.push(255&r),i=i.concat(Array.prototype.slice.call(t));var s=d.box(d.types.avcC,new Uint8Array([1,n[3],n[4],n[5],255,224|e.sps.length].concat(n).concat([e.pps.length]).concat(i))),o=e.width,u=e.height;return d.box(d.types.avc1,new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,o>>8&255,255&o,u>>8&255,255&u,0,72,0,0,0,72,0,0,0,0,0,0,0,1,18,98,105,110,101,108,112,114,111,46,114,117,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,24,17,17]),s,d.box(d.types.btrt,new Uint8Array([0,28,156,128,0,45,198,192,0,45,198,192])))}},{key:"esds",value:function(e){var t=e.config.byteLength,r=new Uint8Array(26+t+3);return r.set([0,0,0,0,3,23+t,0,1,0,4,15+t,64,21,0,0,0,0,0,0,0,0,0,0,0,5,t]),r.set(e.config,26),r.set([6,1,2],26+t),r}},{key:"mp4a",value:function(e){var t=e.audiosamplerate;return d.box(d.types.mp4a,new Uint8Array([0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,e.channelCount,0,16,0,0,0,0,t>>8&255,255&t,0,0]),d.box(d.types.esds,d.esds(e)))}},{key:"stsd",value:function(e){return"audio"===e.type?d.box(d.types.stsd,d.STSD,d.mp4a(e)):d.box(d.types.stsd,d.STSD,d.avc1(e))}},{key:"tkhd",value:function(e){var t=e.id,r=e.duration,n=e.width,i=e.height,a=e.volume;return d.box(d.types.tkhd,new Uint8Array([0,0,0,7,0,0,0,0,0,0,0,0,t>>24&255,t>>16&255,t>>8&255,255&t,0,0,0,0,r>>24,r>>16&255,r>>8&255,255&r,0,0,0,0,0,0,0,0,0,0,0,0,a>>0&255,a%1*10>>0&255,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,64,0,0,0,n>>8&255,255&n,0,0,i>>8&255,255&i,0,0]))}},{key:"traf",value:function(e,t){var r=d.sdtp(e),n=e.id;return d.box(d.types.traf,d.box(d.types.tfhd,new Uint8Array([0,0,0,0,n>>24,n>>16&255,n>>8&255,255&n])),d.box(d.types.tfdt,new Uint8Array([0,0,0,0,t>>24,t>>16&255,t>>8&255,255&t])),d.trun(e,r.length+16+16+8+16+8+8),r)}},{key:"trak",value:function(e){return e.duration=e.duration||4294967295,d.box(d.types.trak,d.tkhd(e),d.mdia(e))}},{key:"trex",value:function(e){var t=e.id;return d.box(d.types.trex,new Uint8Array([0,0,0,0,t>>24,t>>16&255,t>>8&255,255&t,0,0,0,1,0,0,0,0,0,0,0,0,0,1,0,1]))}},{key:"trun",value:function(e,t){var r,n,i,a,s,o,u=e.samples||[],c=u.length,f=12+16*c,l=new Uint8Array(f);for(t+=8+f,l.set([0,0,15,1,c>>>24&255,c>>>16&255,c>>>8&255,255&c,t>>>24&255,t>>>16&255,t>>>8&255,255&t],0),r=0;r<c;r++)i=(n=u[r]).duration,a=n.size,s=n.flags,o=n.cts,l.set([i>>>24&255,i>>>16&255,i>>>8&255,255&i,a>>>24&255,a>>>16&255,a>>>8&255,255&a,s.isLeading<<2|s.dependsOn,s.isDependedOn<<6|s.hasRedundancy<<4|s.paddingValue<<1|s.isNonSync,61440&s.degradPrio,15&s.degradPrio,o>>>24&255,o>>>16&255,o>>>8&255,255&o],12+16*r);return d.box(d.types.trun,l)}},{key:"initSegment",value:function(e,t,r){d.types||d.init();var n=d.moov(e,t,r),i=new Uint8Array(d.FTYP.byteLength+n.byteLength);return i.set(d.FTYP),i.set(n,d.FTYP.byteLength),i}}]),d}(),w=1,x=function(){function e(){a(this,e),this.seq=1}return o(e,null,[{key:"getTrackID",value:function(){return w++}}]),o(e,[{key:"flush",value:function(){this.seq++,this.mp4track.len=0,this.mp4track.samples=[]}},{key:"isReady",value:function(){return!(!this.readyToDecode||!this.samples.length)||null}}]),e}(),A=function(){e(r,x);var t=s(r);function r(){var e;return a(this,r),(e=t.call(this)).readyToDecode=!1,e.nextDts=0,e.dts=0,e.timescale=1e3,e.mp4track={id:x.getTrackID(),type:"audio",channelCount:0,len:0,fragmented:!0,timescale:e.timescale,duration:e.timescale,samples:[],config:"",codec:""},e.samples=[],e.aac=new m(c(e)),e}return o(r,[{key:"resetTrack",value:function(){this.readyToDecode=!1,this.mp4track.codec="",this.mp4track.channelCount="",this.mp4track.config="",this.mp4track.timescale=this.timescale}},{key:"remux",value:function(e){if(0<e.length)for(var t=0;t<e.length;t++){var r=e[t],n=r.units,i=n.byteLength;this.samples.push({units:n,size:i,duration:r.duration}),this.mp4track.len+=i,this.readyToDecode||this.aac.setAACConfig()}}},{key:"getPayload",value:function(){if(!this.isReady())return null;var e,t=new Uint8Array(this.mp4track.len),r=0,n=this.mp4track.samples;for(this.dts=this.nextDts;this.samples.length;){var i,a=this.samples.shift();a.units;(i=a.duration)<=0?(g("remuxer: invalid sample duration at DTS: ".concat(this.nextDts," :").concat(i)),this.mp4track.len-=a.size):(this.nextDts+=i,e={size:a.size,duration:i,cts:0,flags:{isLeading:0,isDependedOn:0,hasRedundancy:0,degradPrio:0,dependsOn:1}},t.set(a.units,r),r+=a.size,n.push(e))}return n.length?new Uint8Array(t.buffer,0,this.mp4track.len):null}}]),r}(),B=function(){e(r,x);var t=s(r);function r(){var e;return a(this,r),(e=t.call(this)).readyToDecode=!1,e.nextDts=0,e.dts=0,e.timescale=1e3,e.mp4track={id:x.getTrackID(),type:"video",len:0,fragmented:!0,sps:"",pps:"",width:0,height:0,timescale:e.timescale,duration:e.timescale,samples:[]},e.samples=[],e.h264=new v(c(e)),e}return o(r,[{key:"resetTrack",value:function(){this.readyToDecode=!1,this.mp4track.sps="",this.mp4track.pps=""}},{key:"remux",value:function(e){var t,r=k(e);try{for(r.s();!(t=r.n()).done;){var n,i=t.value,a=[],s=0,o=k(i.units);try{for(o.s();!(n=o.n()).done;){var u=n.value;this.h264.parseNAL(u)&&(a.push(u),s+=u.getSize())}}catch(e){o.e(e)}finally{o.f()}0<a.length&&this.readyToDecode&&(this.mp4track.len+=s,this.samples.push({units:a,size:s,keyFrame:i.keyFrame,duration:i.duration}))}}catch(e){r.e(e)}finally{r.f()}}},{key:"getPayload",value:function(){if(!this.isReady())return null;var e,t=new Uint8Array(this.mp4track.len),r=0,n=this.mp4track.samples;for(this.dts=this.nextDts;this.samples.length;){var i,a=this.samples.shift(),s=a.units;if((i=a.duration)<=0)g("remuxer: invalid sample duration at DTS: ".concat(this.nextDts," :").concat(i)),this.mp4track.len-=a.size;else{this.nextDts+=i,e={size:a.size,duration:i,cts:0,flags:{isLeading:0,isDependedOn:0,hasRedundancy:0,degradPrio:0,isNonSync:a.keyFrame?0:1,dependsOn:a.keyFrame?2:1}};var o,u=k(s);try{for(u.s();!(o=u.n()).done;){var c=o.value;t.set(c.getData(),r),r+=c.getSize()}}catch(e){u.e(e)}finally{u.f()}n.push(e)}}return n.length?new Uint8Array(t.buffer,0,this.mp4track.len):null}}]),r}();function U(e,t){var r=new Uint8Array((0|e.byteLength)+(0|t.byteLength));return r.set(e,0),r.set(t,0|e.byteLength),r}var C=function(){e(n,t);var r=s(n);function n(e){var t;return a(this,n),(t=r.call(this,"remuxer")).initialized=!1,t.trackTypes=[],t.tracks={},t.mediaDuration=e?1/0:1e3,t}return o(n,[{key:"addTrack",value:function(e){"video"!==e&&"both"!==e||(this.tracks.video=new B,this.trackTypes.push("video")),"audio"!==e&&"both"!==e||(this.tracks.audio=new A,this.trackTypes.push("audio"))}},{key:"reset",value:function(){var e,t=k(this.trackTypes);try{for(t.s();!(e=t.n()).done;){var r=e.value;this.tracks[r].resetTrack()}}catch(e){t.e(e)}finally{t.f()}this.initialized=!1}},{key:"destroy",value:function(){this.tracks={},this.offAll()}},{key:"flush",value:function(){if(this.initialized){var e,t=k(this.trackTypes);try{for(t.s();!(e=t.n()).done;){var r,n,i=e.value,a=this.tracks[i],s=a.getPayload();s&&s.byteLength&&(r={type:i,payload:U(S.moof(a.seq,a.dts,a.mp4track),S.mdat(s)),dts:a.dts},this.dispatch("buffer",r),d=a.dts/1e3,v=p=y=h=void 0,h="",y=Math.floor(d),p=parseInt(y/3600,10)%24,v=parseInt(y/60,10)%60,0<p&&(h+=(p<10?"0"+p:p)+":"),n=h+=(v<10?"0"+v:v)+":"+((y=y<0?0:y%60)<10?"0"+y:y),g("put segment (".concat(i,"): ").concat(a.seq," dts: ").concat(a.dts," gop: ").concat(a.mp4track.samples.length," second: ").concat(n)),a.flush())}}catch(e){t.e(e)}finally{t.f()}}else if(this.isReady()){this.dispatch("ready");var o,u=k(this.trackTypes);try{for(u.s();!(o=u.n()).done;){var c=o.value,f=this.tracks[c],l={type:c,payload:S.initSegment([f.mp4track],this.mediaDuration,f.mp4track.timescale)};this.dispatch("buffer",l)}}catch(e){u.e(e)}finally{u.f()}g("Initial segment generated."),this.initialized=!0,this.flush()}var d,h,y,p,v}},{key:"isReady",value:function(){var e,t=k(this.trackTypes);try{for(t.s();!(e=t.n()).done;){var r=e.value;if(!this.tracks[r].readyToDecode||!this.tracks[r].samples.length)return!1}}catch(e){t.e(e)}finally{t.f()}return!0}},{key:"remux",value:function(e){var t,r=k(this.trackTypes);try{for(r.s();!(t=r.n()).done;){var n=t.value,i=e[n];"audio"===n&&this.tracks.video&&!this.tracks.video.readyToDecode||0<i.length&&this.tracks[n].remux(i)}}catch(e){r.e(e)}finally{r.f()}this.flush()}}]),n}(),D=function(){e(i,t);var n=s(i);function i(e,t){var r;return a(this,i),(r=n.call(this,"buffer")).type=t,r.queue=new Uint8Array,r.cleaning=!1,r.pendingCleaning=0,r.cleanOffset=30,r.cleanRanges=[],r.sourceBuffer=e,r.sourceBuffer.addEventListener("updateend",function(){0<r.pendingCleaning&&(r.initCleanup(r.pendingCleaning),r.pendingCleaning=0),r.cleaning=!1,r.cleanRanges.length&&r.doCleanup()}),r.sourceBuffer.addEventListener("error",function(){r.dispatch("error",{type:r.type,name:"buffer",error:"buffer error"})}),r}return o(i,[{key:"destroy",value:function(){this.queue=null,this.sourceBuffer=null,this.offAll()}},{key:"doCleanup",value:function(){var e;this.cleanRanges.length?(e=this.cleanRanges.shift(),g("".concat(this.type," remove range [").concat(e[0]," - ").concat(e[1],")")),this.cleaning=!0,this.sourceBuffer.remove(e[0],e[1])):this.cleaning=!1}},{key:"initCleanup",value:function(e){if(this.sourceBuffer.updating)this.pendingCleaning=e;else if(this.sourceBuffer.buffered&&this.sourceBuffer.buffered.length&&!this.cleaning){for(var t=0;t<this.sourceBuffer.buffered.length;++t){var r=this.sourceBuffer.buffered.start(t),n=this.sourceBuffer.buffered.end(t);e-r>this.cleanOffset&&r<(n=e-this.cleanOffset)&&this.cleanRanges.push([r,n])}this.doCleanup()}}},{key:"doAppend",value:function(){if(this.queue.length&&!this.sourceBuffer.updating)try{this.sourceBuffer.appendBuffer(this.queue),this.queue=new Uint8Array}catch(e){if("QuotaExceededError"===e.name)return g("".concat(this.type," buffer quota full")),void this.dispatch("error",{type:this.type,name:"QuotaExceeded",error:"buffer error"});h("Error occured while appending ".concat(this.type," buffer -  ").concat(e.name,": ").concat(e.message)),this.dispatch("error",{type:this.type,name:"unexpectedError",error:"buffer error"})}}},{key:"feed",value:function(e){this.queue=U(this.queue,e)}}]),i}();return window.MediaSource=window.MediaSource||window.WebKitMediaSource,function(){e(n,t);var r=s(n);function n(e){var t;a(this,n),t=r.call(this,"jmuxer"),window.MediaSource=window.MediaSource||window.WebKitMediaSource;if(t.options=Object.assign({},{node:"",mode:"both",flushingTime:1500,clearBuffer:!0,onReady:null,fps:30,debug:!1},e),t.options.debug&&(l=console.log,d=console.error),"string"==typeof t.options.node&&""==t.options.node&&h("no video element were found to render, provide a valid video element"),t.options.fps||(t.options.fps=30),t.frameDuration=1e3/t.options.fps|0,t.node="string"==typeof t.options.node?document.getElementById(t.options.node):t.options.node,t.sourceBuffers={},t.isMSESupported=!!window.MediaSource,!t.isMSESupported)throw"Oops! Browser does not support media source extension.";return t.setupMSE(),t.remuxController=new C(t.options.clearBuffer),t.remuxController.addTrack(t.options.mode),t.mseReady=!1,t.lastCleaningTime=Date.now(),t.kfPosition=[],t.kfCounter=0,t.remuxController.on("buffer",t.onBuffer.bind(c(t))),t.remuxController.on("ready",t.createBuffer.bind(c(t))),t.startInterval(),t}return o(n,null,[{key:"isSupported",value:function(e){return window.MediaSource&&window.MediaSource.isTypeSupported(e)}}]),o(n,[{key:"setupMSE",value:function(){this.mediaSource=new MediaSource,this.node.src=URL.createObjectURL(this.mediaSource),this.mediaSource.addEventListener("sourceopen",this.onMSEOpen.bind(this)),this.mediaSource.addEventListener("sourceclose",this.onMSEClose.bind(this)),this.mediaSource.addEventListener("webkitsourceopen",this.onMSEOpen.bind(this)),this.mediaSource.addEventListener("webkitsourceclose",this.onMSEClose.bind(this))}},{key:"feed",value:function(e){var t,r,n=!1,i={video:[],audio:[]};e&&this.remuxController&&(r=e.duration?parseInt(e.duration):0,e.video&&0<(t=v.extractNALu(e.video)).length&&(i.video=this.getVideoFrames(t,r),n=!0),e.audio&&0<(t=m.extractAAC(e.audio)).length&&(i.audio=this.getAudioFrames(t,r),n=!0),n?this.remuxController.remux(i):h("Input object must have video and/or audio property. Make sure it is a valid typed array"))}},{key:"getVideoFrames",value:function(e,t){var r,n,i,a=this,s=[],o=[],u=0,c=!1,f=!1,l=k(e);try{for(l.s();!(n=l.n()).done;){var d=n.value,h=new p(d);h.type()!==p.IDR&&h.type()!==p.NDR||v.parseHeader(h),s.length&&f&&(h.isfmb||!h.isvcl)&&(o.push({units:s,keyFrame:c}),f=c=!(s=[])),s.push(h),c=c||h.isKeyframe(),f=f||h.isvcl}}catch(e){l.e(e)}finally{l.f()}return s.length&&(f||!o.length?o.push({units:s,keyFrame:c}):o[i=o.length-1].units=o[i].units.concat(s)),r=t?t/o.length|0:this.frameDuration,u=t?t-r*o.length:0,o.map(function(e){e.duration=r,0<u&&(e.duration++,u--),a.kfCounter++,e.keyFrame&&a.options.clearBuffer&&a.kfPosition.push(a.kfCounter*r/1e3)}),g("jmuxer: No. of frames of the last chunk: ".concat(o.length)),o}},{key:"getAudioFrames",value:function(e,t){var r,n,i=[],a=0,s=k(e);try{for(s.s();!(n=s.n()).done;){var o=n.value;i.push({units:o})}}catch(e){s.e(e)}finally{s.f()}return r=t?t/i.length|0:this.frameDuration,a=t?t-r*i.length:0,i.map(function(e){e.duration=r,0<a&&(e.duration++,a--)}),i}},{key:"destroy",value:function(){if(this.stopInterval(),this.mediaSource){try{this.bufferControllers&&this.mediaSource.endOfStream()}catch(e){h("mediasource is not available to end ".concat(e.message))}this.mediaSource=null}if(this.remuxController&&(this.remuxController.destroy(),this.remuxController=null),this.bufferControllers){for(var e in this.bufferControllers)this.bufferControllers[e].destroy();this.bufferControllers=null}this.node=!1,this.mseReady=!1,this.videoStarted=!1}},{key:"createBuffer",value:function(){if(this.mseReady&&this.remuxController&&this.remuxController.isReady()&&!this.bufferControllers)for(var e in this.bufferControllers={},this.remuxController.tracks){var t=this.remuxController.tracks[e];if(!n.isSupported("".concat(e,'/mp4; codecs="').concat(t.mp4track.codec,'"')))return h("Browser does not support codec"),!1;var r=this.mediaSource.addSourceBuffer("".concat(e,'/mp4; codecs="').concat(t.mp4track.codec,'"'));this.bufferControllers[e]=new D(r,e),this.sourceBuffers[e]=r,this.bufferControllers[e].on("error",this.onBufferError.bind(this))}}},{key:"startInterval",value:function(){var e=this;this.interval=setInterval(function(){e.bufferControllers&&(e.releaseBuffer(),e.clearBuffer())},this.options.flushingTime)}},{key:"stopInterval",value:function(){this.interval&&clearInterval(this.interval)}},{key:"releaseBuffer",value:function(){for(var e in this.bufferControllers)this.bufferControllers[e].doAppend()}},{key:"getSafeClearOffsetOfBuffer",value:function(e){for(var t,r="audio"===this.options.mode&&e||0,n=0;n<this.kfPosition.length&&!(this.kfPosition[n]>=e);n++)t=this.kfPosition[n];return t&&(this.kfPosition=this.kfPosition.filter(function(e){return e<t&&(r=e),t<=e})),r}},{key:"clearBuffer",value:function(){if(this.options.clearBuffer&&1e4<Date.now()-this.lastCleaningTime){for(var e in this.bufferControllers){var t=this.getSafeClearOffsetOfBuffer(this.node.currentTime);this.bufferControllers[e].initCleanup(t)}this.lastCleaningTime=Date.now()}}},{key:"onBuffer",value:function(e){this.bufferControllers&&this.bufferControllers[e.type]&&this.bufferControllers[e.type].feed(e.payload)}},{key:"onMSEOpen",value:function(){this.mseReady=!0,"function"==typeof this.options.onReady&&(this.options.onReady(),this.options.onReady=null),this.createBuffer()}},{key:"onMSEClose",value:function(){this.mseReady=!1,this.videoStarted=!1}},{key:"onBufferError",value:function(e){if("QuotaExceeded"!=e.name){if(0<this.mediaSource.sourceBuffers.length&&this.sourceBuffers[e.type]&&this.mediaSource.removeSourceBuffer(this.sourceBuffers[e.type]),0==this.mediaSource.sourceBuffers.length)try{this.mediaSource.endOfStream()}catch(e){h("mediasource is not available to end")}}else this.bufferControllers[e.type].initCleanup(this.node.currentTime)}}]),n}()});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(13);
__webpack_require__(12);
__webpack_require__(15);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(178);
__webpack_require__(55);
__webpack_require__(21);
__webpack_require__(261);
__webpack_require__(14);
__webpack_require__(78);
__webpack_require__(136);
__webpack_require__(42);
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var _require = __webpack_require__(264),
  Crypto = _require.Crypto;
var crypto = new Crypto();
var AESGCMCrypto = /*#__PURE__*/function () {
  function AESGCMCrypto() {
    _classCallCheck(this, AESGCMCrypto);
    this._init();
  }
  return _createClass(AESGCMCrypto, [{
    key: "_init",
    value: function _init() {
      Object.assign(this, AESGCMCrypto._base());
      if (!this.subtle) {
        throw new Error('请使用HTTPS协议。');
      }
      if (!this.crypto) {
        throw new Error('浏览器版本太低, 建议使用最新的chrome浏览器。');
      }
    }
  }, {
    key: "buf2hex",
    value: function buf2hex(buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (x) {
        return x.toString(16).padStart(2, '0');
      }).join('');
    }
  }, {
    key: "hex2buf",
    value: function hex2buf(str) {
      var len = str.length % 2 + str.length;
      var buf = new Uint8Array(len / 2);
      str = str.padStart(len, '0');
      for (var i = 0; i < len; i += 2) {
        buf[i / 2] = parseInt(str.substr(i, 2), 16);
      }
      return buf;
    }
  }, {
    key: "str2buf",
    value: function str2buf(str) {
      var buf = new Uint8Array(str.length);
      for (var i = 0, strLen = str.length; i < strLen; i++) {
        buf[i] = str.charCodeAt(i);
      }
      return buf;
    }
  }, {
    key: "iv",
    value: function iv() {
      var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;
      var iv = '';
      do {
        iv += AESGCMCrypto.getRandomValue().toString(16).replace('.', '');
      } while (iv.length < len);
      return iv.substr(0, len);
    }
  }, {
    key: "abstract",
    value: function abstract(text) {
      var self = this;
      var subtle = this.subtle;
      return new Promise(function (resolve, reject) {
        subtle.digest('SHA-256', self.str2buf(text)).then(function (buf) {
          resolve(self.buf2hex(buf));
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "encrypt",
    value: function encrypt(text, key, iv) {
      var self = this;
      var subtle = this.subtle;
      return new Promise(function (resolve, reject) {
        subtle.importKey('raw', self.hex2buf(key), {
          name: 'AES-GCM'
        }, false, ['encrypt', 'decrypt']).then(function (cryptoKey) {
          subtle.encrypt({
            name: 'AES-GCM',
            iv: self.hex2buf(iv)
          }, cryptoKey, self.str2buf(text)).then(function (buf) {
            resolve(self.buf2hex(buf));
          }, function (err) {
            reject(err);
          });
        }, function (err) {
          reject(err);
        });
      });
    }
  }], [{
    key: "_base",
    value: function _base() {
      var subtle = crypto.subtle;
      return {
        crypto: crypto,
        subtle: subtle
      };
    }
  }, {
    key: "isSupport",
    value: function isSupport() {
      var _AESGCMCrypto$_base = AESGCMCrypto._base(),
        subtle = _AESGCMCrypto$_base.subtle;
      return subtle;
    }
  }, {
    key: "getRandomValue",
    value: function getRandomValue() {
      return crypto.getRandomValues(new Uint8Array(1)) * 0.001;
    }
  }]);
}();
var _default = exports.default = AESGCMCrypto;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(18);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(179) });


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(25);
var getKeys = __webpack_require__(62);
var gOPS = __webpack_require__(98);
var pIE = __webpack_require__(86);
var toObject = __webpack_require__(38);
var IObject = __webpack_require__(119);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(24)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(10).Buffer
var Transform = __webpack_require__(182).Transform
var inherits = __webpack_require__(11)

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

var useUint8Array = typeof Uint8Array !== 'undefined'
var useArrayBuffer = typeof ArrayBuffer !== 'undefined' &&
  typeof Uint8Array !== 'undefined' &&
  ArrayBuffer.isView &&
  (Buffer.prototype instanceof Uint8Array || Buffer.TYPED_ARRAY_SUPPORT)

function toBuffer (data, encoding) {
  // No need to do anything for exact instance
  // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
  if (data instanceof Buffer) return data

  // Convert strings to Buffer
  if (typeof data === 'string') return Buffer.from(data, encoding)

  /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */
  if (useArrayBuffer && ArrayBuffer.isView(data)) {
    if (data.byteLength === 0) return Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
    var res = Buffer.from(data.buffer, data.byteOffset, data.byteLength)
    // Recheck result size, as offset/length doesn't work on Node.js <5.10
    // We just go to Uint8Array case if this fails
    if (res.byteLength === data.byteLength) return res
  }

  /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */
  if (useUint8Array && data instanceof Uint8Array) return Buffer.from(data)

  /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */
  if (
    Buffer.isBuffer(data) &&
    data.constructor &&
    typeof data.constructor.isBuffer === 'function' &&
    data.constructor.isBuffer(data)
  ) {
    return Buffer.from(data)
  }

  throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.')
}

HashBase.prototype.update = function (data, encoding) {
  if (this._finalized) throw new Error('Digest already called')

  data = toBuffer(data, encoding) // asserts correct input type

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(138).EventEmitter;
var inherits = __webpack_require__(11);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(108);
Stream.Writable = __webpack_require__(274);
Stream.Duplex = __webpack_require__(275);
Stream.Transform = __webpack_require__(276);
Stream.PassThrough = __webpack_require__(277);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(109);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(180);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(138).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(184);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(139).Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__(91));
util.inherits = __webpack_require__(11);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(267);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(268);
var destroyImpl = __webpack_require__(185);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(64);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(141).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(64);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(141).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, { hasUnpiped: false });
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(39), __webpack_require__(40)))

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(138).EventEmitter;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(109);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        pna.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, this, err);
      }
    }

    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        pna.nextTick(emitErrorNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, _this, err);
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(270);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(39)))

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(64);

/*<replacement>*/
var util = Object.create(__webpack_require__(91));
util.inherits = __webpack_require__(11);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(11)
var Hash = __webpack_require__(80)
var Buffer = __webpack_require__(10).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11)
var Hash = __webpack_require__(80)
var Buffer = __webpack_require__(10).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(11)
var Legacy = __webpack_require__(282)
var Base = __webpack_require__(57)
var Buffer = __webpack_require__(10).Buffer
var md5 = __webpack_require__(191)
var RIPEMD160 = __webpack_require__(142)

var sha = __webpack_require__(143)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(137)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),
/* 192 */
/***/ (function(module) {

module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(284)
exports.pbkdf2Sync = __webpack_require__(196)


/***/ }),
/* 194 */
/***/ (function(module, exports) {

var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

module.exports = function (iterations, keylen) {
  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var defaultEncoding
/* istanbul ignore next */
if (global.process && global.process.browser) {
  defaultEncoding = 'utf-8'
} else if (global.process && global.process.version) {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
} else {
  defaultEncoding = 'utf-8'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(39), __webpack_require__(40)))

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(191)
var RIPEMD160 = __webpack_require__(142)
var sha = __webpack_require__(143)
var Buffer = __webpack_require__(10).Buffer

var checkParameters = __webpack_require__(194)
var defaultEncoding = __webpack_require__(195)
var toBuffer = __webpack_require__(197)

var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer

module.exports = function (thing, encoding, name) {
  if (Buffer.isBuffer(thing)) {
    return thing
  } else if (typeof thing === 'string') {
    return Buffer.from(thing, encoding)
  } else if (ArrayBuffer.isView(thing)) {
    return Buffer.from(thing.buffer)
  } else {
    throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView')
  }
}


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(34);
var inherits = __webpack_require__(11);

var utils = __webpack_require__(198);
var Cipher = __webpack_require__(144);

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  if (this.padding === false) {
    return false;
  }

  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  if (this.padding === false) {
    return buffer;
  }

  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(92)
var Buffer = __webpack_require__(10).Buffer
var incr32 = __webpack_require__(201)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),
/* 201 */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),
/* 202 */
/***/ (function(module) {

module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(110)
var Buffer = __webpack_require__(10).Buffer
var Transform = __webpack_require__(57)
var inherits = __webpack_require__(11)
var GHASH = __webpack_require__(297)
var xor = __webpack_require__(92)
var incr32 = __webpack_require__(201)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(110)
var Buffer = __webpack_require__(10).Buffer
var Transform = __webpack_require__(57)
var inherits = __webpack_require__(11)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(79);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(206);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(207);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(301).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(65)(module)))

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(302);
var brorand = __webpack_require__(147);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(112);
curve.short = __webpack_require__(312);
curve.mont = __webpack_require__(313);
curve.edwards = __webpack_require__(314);


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);
var common = __webpack_require__(93);
var shaCommon = __webpack_require__(210);
var assert = __webpack_require__(34);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);
var common = __webpack_require__(93);
var assert = __webpack_require__(34);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);
var Reporter = __webpack_require__(95).Reporter;
var Buffer = __webpack_require__(4).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(336);


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);

var asn1 = __webpack_require__(94);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);
var Buffer = __webpack_require__(4).Buffer;

var asn1 = __webpack_require__(94);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 217 */
/***/ (function(module) {

module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(90)
var Buffer = __webpack_require__(10).Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(153)
var Buffer = __webpack_require__(10).Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(81);
__webpack_require__(16);
__webpack_require__(17);
var _webworkifyWebpack = _interopRequireDefault(__webpack_require__(63));
var _Subscribe = _interopRequireDefault(__webpack_require__(88));
var _Util = _interopRequireDefault(__webpack_require__(26));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var SAMPLE_RATE = 48000;
var MAX_VOLUME_VALUE = 100;
var DEFAULT_VALUME_VALUE = 50;
var DEFAULT_CACHE_LENGTH = 10; // 音频缓存长度默认为 10，即 100ms 的音频缓存
var MAX_PLAY_DELAY_S = 0.4; //播放最大时延，单位秒
var AudioPlayer = /*#__PURE__*/function () {
  function AudioPlayer(_ref) {
    var _this = this;
    var channels = _ref.channels,
      videoPlayer = _ref.videoPlayer,
      volume = _ref.volume;
    _classCallCheck(this, AudioPlayer);
    this.channels = channels || 1;
    this.playerTimer = null;
    this.penddingBuffer = new Float32Array();
    this.nextTime = 0;
    this._volume = volume || DEFAULT_VALUME_VALUE;
    this.cacheLength = 0;
    this.util = new _Util.default();

    // 判断是否为iOS设备
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    this.audioDecoderWorker = (0, _webworkifyWebpack.default)(/*require.resolve*/(353));
    this.audioDecoderWorker.addEventListener('message', this.messageHandler.bind(this));
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    this.context = new AudioContext();
    if (this.context.createGain) {
      this.gainNode = this.context.createGain();
      this.gainNode && (this.gainNode.gain.value = this._volume / MAX_VOLUME_VALUE);
    }
    if (this.isIOS) {
      // 在iOS设备上，创建隐藏的音频元素和MediaStreamDestination，用于绕过静音模式限制
      this.audioElement = document.createElement('audio');
      this.audioElement.style.display = 'none';
      this.audioElement.setAttribute('playsinline', 'true');
      this.audioElement.setAttribute('x5-playsinline', 'true');
      this.audioElement.setAttribute('preload', 'auto');
      document.body.appendChild(this.audioElement);

      // 将Web Audio API的输出连接到Audio元素，绕过iOS静音模式限制
      this.destination = this.context.createMediaStreamDestination();
      if (this.gainNode) {
        this.gainNode.connect(this.destination);
      }

      // 将MediaStream连接到Audio元素
      this.audioElement.srcObject = this.destination.stream;
    }
    this.subscribe = new _Subscribe.default(['audioStateChange']);
    this.util.bind(this.context, 'statechange', function () {
      _this.subscribe.trigger('audioStateChange', _this.context.state);
    });
    this.videoPlayer = videoPlayer;
    // iOS和chrome上需用户操作里 resume 才能播放音频，不然 audioContext 一直 suspend
    if (this.videoPlayer) {
      this.util.bind(this.videoPlayer, 'touchstart', this.resume.bind(this));
      this.util.bind(this.videoPlayer, 'mousedown', this.resume.bind(this));
      this.util.bind(this.videoPlayer, 'click', this.resume.bind(this));
    }
  }
  return _createClass(AudioPlayer, [{
    key: "initAfterSubscribe",
    value: function initAfterSubscribe(eventName) {
      if (eventName === 'audioStateChange' && this.context) {
        this.subscribe.trigger('audioStateChange', this.context.state);
      }
    }

    /**
     * 监听事件，如监听audioStateChange事件
     * @param {string} eventName 事件名称
     * @param {object} callback 回调函数
     **/
  }, {
    key: "on",
    value: function on(eventName, callback) {
      this.subscribe.on(eventName, callback);
      this.initAfterSubscribe(eventName);
    }

    /**
     * 解除事件监听
     * @param {string} eventName 事件名称
     * @param {object} callback 回调函数
     **/
  }, {
    key: "off",
    value: function off(eventName, callback) {
      this.subscribe.off(eventName, callback);
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this._volume;
    }

    // 音量设置范围为 0 ~ 100
  }, {
    key: "setVolume",
    value: function setVolume(value) {
      this._volume = value;
      if (this.gainNode) {
        this.gainNode.gain.value = value / MAX_VOLUME_VALUE;
      }
    }
  }, {
    key: "messageHandler",
    value: function messageHandler(evt) {
      var message = evt.data;
      if (!Object.prototype.hasOwnProperty.call(message, 'type')) {
        return;
      }
      switch (message.type) {
        case 'decodeResult':
          {
            this.cacheLength++;
            var decodeBuffer = message.data;
            var pcmTmp = new Float32Array(decodeBuffer);
            var tmp = new Float32Array(this.penddingBuffer.length + pcmTmp.length);
            tmp.set(this.penddingBuffer, 0);
            tmp.set(pcmTmp, this.penddingBuffer.length);
            this.penddingBuffer = null;
            this.penddingBuffer = tmp;
            if (this.cacheLength >= DEFAULT_CACHE_LENGTH) {
              this.play();
            }
            break;
          }
        default:
        // do nothing
      }
    }
  }, {
    key: "resume",
    value: function resume() {
      if (this.context.state !== 'running') {
        this.context.resume();
      }

      // 只在iOS设备上处理Audio元素，触发音频会话，绕过静音模式限制
      if (this.isIOS && this.audioElement && this.audioElement.paused) {
        this.audioElement.play().catch(function (e) {
          console.log('Audio element play failed:', e);
        });
      }
      if (this.context.state === 'running') {
        // 在非iOS设备上，取消事件监听；在iOS设备上，保持事件监听
        if (!this.isIOS && this.videoPlayer) {
          this.util.unbind(this.videoPlayer, 'touchstart');
          this.util.unbind(this.videoPlayer, 'mousedown');
          this.util.unbind(this.videoPlayer, 'click');
        }
      }
    }
  }, {
    key: "feed",
    value: function feed(data) {
      this.audioDecoderWorker.postMessage({
        type: 'decode',
        data: data.buffer
      }, [data.buffer]);
    }
  }, {
    key: "play",
    value: function play() {
      if (!this.penddingBuffer.length) {
        return;
      }

      // audio播放器状态未ready且还未开始播放的情况下，丢掉audio数据，规避iOS下audio播放延迟问题（用户点击后才开始播放，且从头开始播放，故有延迟）；超时最大时延将丢掉。
      if (this.context.state !== 'running' && !this.context.currentTime || this.nextTime - (this.context.currentTime || 0) > MAX_PLAY_DELAY_S) {
        this.penddingBuffer = new Float32Array();
        return;
      }
      this.cacheLength = 0;
      var channels = this.channels;
      var frameCount = Math.floor(this.penddingBuffer.length / channels);
      var source = this.context.createBufferSource();
      var audioBuffer = this.context.createBuffer(channels, frameCount, SAMPLE_RATE);
      var fadeCount = Math.min(frameCount / 2, 100);
      for (var channelCount = 0; channelCount < channels; channelCount++) {
        var channelData = audioBuffer.getChannelData(channelCount);
        for (var i = 0; i < frameCount; i++) {
          channelData[i] = this.penddingBuffer[i * channels + channelCount];
          if (i < fadeCount) {
            channelData[i] = channelData[i] * i / fadeCount; // fade in
          }
          if (i >= frameCount - fadeCount) {
            channelData[i] = channelData[i] * (frameCount - i - 1) / fadeCount; // fade out
          }
        }
      }
      source.buffer = audioBuffer;
      if (this.isIOS) {
        // 在iOS设备上，连接到gainNode，gainNode已经连接到MediaStreamDestination
        if (this.gainNode) {
          source.connect(this.gainNode);
        } else {
          // 如果没有gainNode，直接连接到MediaStreamDestination
          source.connect(this.destination);
        }
      } else {
        // 在非iOS设备上，使用原来的逻辑，直接连接到AudioContext的destination
        if (this.gainNode) {
          source.connect(this.gainNode);
          this.gainNode.connect(this.context.destination);
        } else {
          source.connect(this.context.destination);
        }
      }
      this.nextTime = Math.max(this.nextTime, this.context.currentTime);
      source.start(this.nextTime);
      this.nextTime += source.buffer.duration;
      this.penddingBuffer = new Float32Array();
      // console.log("播放声音")
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.playerTimer && clearInterval(this.playerTimer);
      this.audioDecoderWorker.terminate();
      this.util.unbind(this.videoPlayer, 'touchstart');
      this.util.unbind(this.videoPlayer, 'mousedown');
      this.util.unbind(this.videoPlayer, 'click');
      this.util.unbind(this.context, 'statechange');

      // 只在iOS设备上清理Audio元素
      if (this.isIOS && this.audioElement) {
        this.audioElement.pause();
        if (this.audioElement.srcObject) {
          this.audioElement.srcObject.getTracks().forEach(function (track) {
            return track.stop();
          });
        }
        document.body.removeChild(this.audioElement);
        this.audioElement = null;
      }
      this.context && this.context.close();
      this.videoPlayer = null;
      this.context = null;
    }
  }]);
}();
var _default = exports.default = AudioPlayer;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpusEncoder = exports.OpusDecoder = void 0;
__webpack_require__(21);
__webpack_require__(114);
__webpack_require__(81);
var _libopus = _interopRequireDefault(__webpack_require__(354));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
///<reference path="d.ts/asm.d.ts" />
///<reference path="d.ts/libopus.d.ts" />

var allocate = _libopus.default.allocate;
var _malloc = _libopus.default._malloc;
var _free = _libopus.default._free;
var getValue = _libopus.default.getValue;
var _opus_decoder_create = _libopus.default._opus_decoder_create;
var _opus_decode = _libopus.default._opus_decode;
var _opus_decode_float = _libopus.default._opus_decode_float;
var _opus_decoder_destroy = _libopus.default._opus_decoder_destroy;
var ALLOC_STACK = _libopus.default.ALLOC_STACK;
var HEAPU8 = _libopus.default.HEAPU8;
var HEAP16 = _libopus.default.HEAP16;
var HEAPF32 = _libopus.default.HEAPF32;
var _opus_encoder_create = _libopus.default._opus_encoder_create;
var _opus_encode_float = _libopus.default._opus_encode_float;
var _opus_decode = _libopus.default._opus_decode;
var OpusApplication;
(function (OpusApplication) {
  OpusApplication[OpusApplication["VoIP"] = 2048] = "VoIP";
  OpusApplication[OpusApplication["Audio"] = 2049] = "Audio";
  OpusApplication[OpusApplication["RestrictedLowDelay"] = 2051] = "RestrictedLowDelay";
})(OpusApplication || (OpusApplication = {}));
var OpusError;
(function (OpusError) {
  OpusError[OpusError["OK"] = 0] = "OK";
  OpusError[OpusError["BadArgument"] = -1] = "BadArgument";
  OpusError[OpusError["BufferTooSmall"] = -2] = "BufferTooSmall";
  OpusError[OpusError["InternalError"] = -3] = "InternalError";
  OpusError[OpusError["InvalidPacket"] = -4] = "InvalidPacket";
  OpusError[OpusError["Unimplemented"] = -5] = "Unimplemented";
  OpusError[OpusError["InvalidState"] = -6] = "InvalidState";
  OpusError[OpusError["AllocFail"] = -7] = "AllocFail";
})(OpusError || (OpusError = {}));
var Opus = function () {
  function Opus() {}
  Opus.getVersion = function () {
    var ptr = _opus_get_version_string();
    return Pointer_stringify(ptr);
  };
  Opus.getMaxFrameSize = function (numberOfStreams) {
    if (numberOfStreams === void 0) {
      numberOfStreams = 1;
    }
    return (1275 * 3 + 7) * numberOfStreams;
  };
  Opus.getMinFrameDuration = function () {
    return 2.5;
  };
  Opus.getMaxFrameDuration = function () {
    return 60;
  };
  Opus.validFrameDuration = function (x) {
    return [2.5, 5, 10, 20, 40, 60].some(function (element) {
      return element == x;
    });
  };
  Opus.getMaxSamplesPerChannel = function (sampling_rate) {
    return sampling_rate / 1000 * Opus.getMaxFrameDuration();
  };
  return Opus;
}();
var OpusEncoder = exports.OpusEncoder = function () {
  function OpusEncoder(sampling_rate, channels, app, frame_duration) {
    if (frame_duration === void 0) {
      frame_duration = 20;
    }
    this.handle = 0;
    this.frame_size = 0;
    this.in_ptr = 0;
    this.in_off = 0;
    this.out_ptr = 0;
    if (!Opus.validFrameDuration(frame_duration)) throw 'invalid frame duration';
    this.frame_size = sampling_rate * frame_duration / 1000;
    var err_ptr = allocate(4, 'i32', ALLOC_STACK);
    this.handle = _opus_encoder_create(sampling_rate, channels, app, err_ptr);
    if (getValue(err_ptr, 'i32') != 0 /* OK */) throw 'opus_encoder_create failed: ' + getValue(err_ptr, 'i32');
    this.in_ptr = _malloc(this.frame_size * channels * 4);
    this.in_len = this.frame_size * channels;
    this.in_i16 = HEAP16.subarray(this.in_ptr >> 1, (this.in_ptr >> 1) + this.in_len);
    this.in_f32 = HEAPF32.subarray(this.in_ptr >> 2, (this.in_ptr >> 2) + this.in_len);
    this.out_bytes = Opus.getMaxFrameSize();
    this.out_ptr = _malloc(this.out_bytes);
    this.out_buf = HEAPU8.subarray(this.out_ptr, this.out_ptr + this.out_bytes);
  }
  OpusEncoder.prototype.encode = function (pcm) {
    var output = [];
    var pcm_off = 0;
    while (pcm.length - pcm_off >= this.in_len - this.in_off) {
      if (this.in_off > 0) {
        this.in_i16.set(pcm.subarray(pcm_off, pcm_off + this.in_len - this.in_off), this.in_off);
        pcm_off += this.in_len - this.in_off;
        this.in_off = 0;
      } else {
        this.in_i16.set(pcm.subarray(pcm_off, pcm_off + this.in_len));
        pcm_off += this.in_len;
      }
      var ret = _opus_encode(this.handle, this.in_ptr, this.frame_size, this.out_ptr, this.out_bytes);
      if (ret <= 0) throw 'opus_encode failed: ' + ret;
      var packet = new ArrayBuffer(ret);
      new Uint8Array(packet).set(this.out_buf.subarray(0, ret));
      output.push(packet);
    }
    if (pcm_off < pcm.length) {
      this.in_i16.set(pcm.subarray(pcm_off));
      this.in_off = pcm.length - pcm_off;
    }
    return output;
  };
  OpusEncoder.prototype.encode_float = function (pcm) {
    var output = [];
    var pcm_off = 0;
    while (pcm.length - pcm_off >= this.in_len - this.in_off) {
      if (this.in_off > 0) {
        this.in_f32.set(pcm.subarray(pcm_off, pcm_off + this.in_len - this.in_off), this.in_off);
        pcm_off += this.in_len - this.in_off;
        this.in_off = 0;
      } else {
        this.in_f32.set(pcm.subarray(pcm_off, pcm_off + this.in_len));
        pcm_off += this.in_len;
      }
      var ret = _opus_encode_float(this.handle, this.in_ptr, this.frame_size, this.out_ptr, this.out_bytes);
      if (ret <= 0) throw 'opus_encode failed: ' + ret;
      var packet = new ArrayBuffer(ret);
      new Uint8Array(packet).set(this.out_buf.subarray(0, ret));
      output.push(packet);
    }
    if (pcm_off < pcm.length) {
      this.in_f32.set(pcm.subarray(pcm_off));
      this.in_off = pcm.length - pcm_off;
    }
    return output;
  };
  OpusEncoder.prototype.encode_final = function () {
    if (this.in_off == 0) return new ArrayBuffer(0);
    for (var i = this.in_off; i < this.in_len; ++i) this.in_i16[i] = 0;
    var ret = _opus_encode(this.handle, this.in_ptr, this.frame_size, this.out_ptr, this.out_bytes);
    if (ret <= 0) throw 'opus_encode failed: ' + ret;
    var packet = new ArrayBuffer(ret);
    new Uint8Array(packet).set(this.out_buf.subarray(0, ret));
    return packet;
  };
  OpusEncoder.prototype.encode_float_final = function () {
    if (this.in_off == 0) return new ArrayBuffer(0);
    for (var i = this.in_off; i < this.in_len; ++i) this.in_f32[i] = 0;
    var ret = _opus_encode_float(this.handle, this.in_ptr, this.frame_size, this.out_ptr, this.out_bytes);
    if (ret <= 0) throw 'opus_encode failed: ' + ret;
    var packet = new ArrayBuffer(ret);
    new Uint8Array(packet).set(this.out_buf.subarray(0, ret));
    return packet;
  };
  OpusEncoder.prototype.destroy = function () {
    if (!this.handle) return;
    _opus_encoder_destroy(this.handle);
    _free(this.in_ptr);
    this.handle = this.in_ptr = 0;
  };
  return OpusEncoder;
}();
var OpusDecoder = exports.OpusDecoder = function () {
  function OpusDecoder(sampling_rate, channels) {
    this.handle = 0;
    this.in_ptr = 0;
    this.out_ptr = 0;
    this.channels = channels;
    var err_ptr = allocate(4, 'i32', ALLOC_STACK);
    this.handle = _opus_decoder_create(sampling_rate, channels, err_ptr);
    if (getValue(err_ptr, 'i32') != 0 /* OK */) throw 'opus_decoder_create failed: ' + getValue(err_ptr, 'i32');
    this.in_ptr = _malloc(Opus.getMaxFrameSize(channels));
    this.in_buf = HEAPU8.subarray(this.in_ptr, this.in_ptr + Opus.getMaxFrameSize(channels));
    this.out_len = Opus.getMaxSamplesPerChannel(sampling_rate);
    var out_bytes = this.out_len * channels * 4;
    this.out_ptr = _malloc(out_bytes);
    this.out_i16 = HEAP16.subarray(this.out_ptr >> 1, this.out_ptr + out_bytes >> 1);
    this.out_f32 = HEAPF32.subarray(this.out_ptr >> 2, this.out_ptr + out_bytes >> 2);
  }
  OpusDecoder.prototype.decode = function (packet) {
    this.in_buf.set(new Uint8Array(packet));
    var ret = _opus_decode(this.handle, this.in_ptr, packet.byteLength, this.out_ptr, this.out_len, 0);
    if (ret < 0) throw 'opus_decode failed: ' + ret;
    var samples = new Int16Array(ret * this.channels);
    samples.set(this.out_i16.subarray(0, samples.length));
    return samples;
  };
  OpusDecoder.prototype.decode_float = function (packet) {
    this.in_buf.set(new Uint8Array(packet));
    var ret = _opus_decode_float(this.handle, this.in_ptr, packet.byteLength, this.out_ptr, this.out_len, 0);
    if (ret < 0) throw 'opus_decode failed: ' + ret;
    var samples = new Float32Array(ret * this.channels);
    samples.set(this.out_f32.subarray(0, samples.length));
    return samples;
  };
  OpusDecoder.prototype.destroy = function () {
    if (!this.handle) return;
    _opus_decoder_destroy(this.handle);
    _free(this.in_ptr);
    _free(this.out_ptr);
    this.handle = this.in_ptr = this.out_ptr = 0;
  };
  return OpusDecoder;
}();

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(56);
__webpack_require__(46);
__webpack_require__(16);
__webpack_require__(17);
var _Util = _interopRequireDefault(__webpack_require__(26));
var _commonConfig = __webpack_require__(51);
var _protocolConfig = _interopRequireDefault(__webpack_require__(32));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var ORIENTATION_DEGRESS = {
  'PORTRAIT': 0,
  'LANDSCAPE': 90,
  'REVERSE_LANDSCAPE': -90,
  'REVERSE_PORTRAIT': 180
};
var FULLSCREEN_CHANGE = ['webkitfullscreenchange', 'mozfullscreenchange', 'fullscreenchange', 'msFullscreenChange'];
var AutoRotation = exports.default = /*#__PURE__*/function () {
  function AutoRotation(videoContainerId, orientation, isMobile, keepRatio, callbackAfterRotate) {
    _classCallCheck(this, AutoRotation);
    this.viewportOrientation = window.orientation || 0;
    this.orientation = orientation;
    this.videoContainerId = videoContainerId;
    this.videoContainer = document.getElementById(videoContainerId);
    this.originStyle = this.videoContainer && this.videoContainer.cssText || '';
    this.callbackAfterRotate = callbackAfterRotate;
    this.util = new _Util.default();
    this.resizeTimer = null;
    this.isMobile = isMobile;
    this.keepRatio = keepRatio;
  }
  return _createClass(AutoRotation, [{
    key: "resize",
    value: function resize() {
      this.viewportOrientation = window.orientation || 0;
      this.rotatePlayer();
    }
  }, {
    key: "adjustVideoSize",
    value: function adjustVideoSize() {
      var container = this.videoContainer || document.getElementById(this.videoContainerId);
      if (!container) {
        return;
      }
      var video = container.querySelector('video');
      if (!video) {
        return;
      }
      var containerWidth = video.parentElement.offsetWidth;
      var containerHeight = video.parentElement.offsetHeight;
      if (containerWidth / containerHeight > _commonConfig.CLOUD_PHONE_RATIO) {
        video.style.width = 'auto';
        video.style.height = '100%';
      } else {
        video.style.width = '100%';
        video.style.height = 'auto';
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this = this;
      if (!this.isMobile) {
        return;
      }
      // 若监听orientationChange事件，真机旋转后，需延时才能获取到真机旋转后屏幕宽高；监听resize事件，可立即获取旋转后的宽高。
      this.util.bind(window, 'resize', this.resize.bind(this));
      this.util.bind(window, 'orientationchange', this.resize.bind(this));
      FULLSCREEN_CHANGE.forEach(function (evt) {
        _this.util.bind(document, evt, function () {
          setTimeout(function () {
            _this.rotatePlayer();
          }, 300);
        });
      });
    }
  }, {
    key: "updateOrientation",
    value: function updateOrientation(orientation, displayBox, directionHandler) {
      this.orientation = orientation;
      this.directionHandler = directionHandler;
      this.displayBox = displayBox;
      this.rotatePlayer();
    }
  }, {
    key: "rotatePlayer",
    value: function rotatePlayer() {
      window.scrollTo(0, 0);
      var width = document.documentElement.clientWidth;
      var height = document.documentElement.clientHeight;
      var container = this.videoContainer || document.getElementById(this.videoContainerId);
      if (!container) {
        return;
      }
      var rect = container.parentNode && container.parentNode.getClientRects()[0];
      var style = '';
      var rotateDegrees = 0;
      var playerWidth = 0;
      var playerHeight = 0;
      if (rect) {
        if (this.isMobile) {
          var deviceOrientation = this.getDeviceOrientation();
          if ([_commonConfig.DEVICE_ORIENTATION_ANGLES.PORTRAIT, _commonConfig.DEVICE_ORIENTATION_ANGLES.REVERSE_PORTRAIT].includes(deviceOrientation)) {
            if (this.orientation === _protocolConfig.default.ORIENTATION[0]) {
              if (this.keepRatio) {
                playerWidth = width;
                playerHeight = width / _commonConfig.CLOUD_PHONE_RATIO;
                // playerHeight = height;
                //  playerWidth = height * CLOUD_PHONE_RATIO;
                if (playerHeight > height) {
                  playerWidth = height * _commonConfig.CLOUD_PHONE_RATIO;
                  playerHeight = height;
                }
              } else {
                playerWidth = width;
                playerHeight = height;
              }
              style = "\n                            -webkit-transform: none;\n                            -moz-transform: none;\n                            -ms-transform: none;\n                            transform: none;\n                            width: ".concat(playerWidth, "px;\n                            height: ").concat(playerHeight, "px;\n                            position: relative;\n                            top: 0px;\n                            left: 0px;\n                            margin: 0 auto;\n                        ");
            } else if (this.orientation === _protocolConfig.default.ORIENTATION[16]) {
              if (this.keepRatio) {
                playerWidth = width;
                playerHeight = width / _commonConfig.CLOUD_PHONE_RATIO;
                if (playerHeight > height) {
                  playerWidth = height * _commonConfig.CLOUD_PHONE_RATIO;
                  playerHeight = height;
                }
              } else {
                playerWidth = width;
                playerHeight = height;
              }
              rotateDegrees = ORIENTATION_DEGRESS[this.orientation];
              style = "\n                            -webkit-transform: rotate(".concat(rotateDegrees, "deg);\n                            -moz-transform: rotate(").concat(rotateDegrees, "deg);\n                            -ms-transform: rotate(").concat(rotateDegrees, "deg);\n                            transform: rotate(").concat(rotateDegrees, "deg);\n                            width: ").concat(playerWidth, "px;\n                            height: ").concat(playerHeight, "px;\n                            position: relative;\n                            top: 0px;\n                            left: 0px;\n                        ");
            } else if (this.orientation === _protocolConfig.default.ORIENTATION[8]) {
              playerWidth = width * _commonConfig.CLOUD_PHONE_RATIO;
              playerHeight = width;
              rotateDegrees = ORIENTATION_DEGRESS[this.orientation];
              style = "\n                            -webkit-transform: rotate(".concat(rotateDegrees, "deg);\n                            -moz-transform: rotate(").concat(rotateDegrees, "deg);\n                            -ms-transform: rotate(").concat(rotateDegrees, "deg);\n                            transform: rotate(").concat(rotateDegrees, "deg);\n                            -webkit-transform-origin: left;\n                            -moz-transform-origin: left;\n                            -ms-transform-origin: left;\n                            transform-origin: left;\n                            width: ").concat(playerWidth, "px;\n                            height: ").concat(playerHeight, "px;\n                            position: relative;\n                            top: ").concat(playerWidth / 2, "px;\n                            left: ").concat(playerHeight / 2, "px;\n                        ");
            } else if (this.orientation === _protocolConfig.default.ORIENTATION[24]) {
              playerWidth = width * _commonConfig.CLOUD_PHONE_RATIO;
              playerHeight = width;
              rotateDegrees = ORIENTATION_DEGRESS[this.orientation];
              style = "\n                            -webkit-transform: rotate(".concat(rotateDegrees, "deg);\n                            -moz-transform: rotate(").concat(rotateDegrees, "deg);\n                            -ms-transform: rotate(").concat(rotateDegrees, "deg);\n                            transform: rotate(").concat(rotateDegrees, "deg);\n                            -webkit-transform-origin: top;\n                            -moz-transform-origin: top;\n                            -ms-transform-origin: top;\n                            transform-origin: top;\n                            width: ").concat(playerHeight, "px;\n                            height: ").concat(playerWidth, "px;\n                            position: relative;\n                            top: ").concat((height - playerHeight) / 2 + playerHeight / 2, "px;\n                            left: ").concat(playerWidth - playerHeight / 2, "px;\n                        ");
            }
          } else if ([_commonConfig.DEVICE_ORIENTATION_ANGLES.LANDSCAPE, _commonConfig.DEVICE_ORIENTATION_ANGLES.REVERSE_LANDSCAPE].includes(deviceOrientation)) {
            if (this.orientation === _protocolConfig.default.ORIENTATION[0]) {
              playerHeight = height;
              playerWidth = height * _commonConfig.CLOUD_PHONE_RATIO;
              style = "\n                            -webkit-transform: none;\n                            -moz-transform: none;\n                            -ms-transform: none;\n                            transform: none;\n                            width: ".concat(playerWidth, "px;\n                            height: ").concat(playerHeight, "px;\n                            position: relative;\n                            top: 0px;\n                            left: ").concat((width - playerWidth) / 2, "px;\n                        ");
            } else if (this.orientation === _protocolConfig.default.ORIENTATION[16]) {
              playerHeight = height;
              playerWidth = height * _commonConfig.CLOUD_PHONE_RATIO;
              rotateDegrees = ORIENTATION_DEGRESS[this.orientation];
              style = "\n                            -webkit-transform: rotate(".concat(rotateDegrees, "deg);\n                            -moz-transform: rotate(").concat(rotateDegrees, "deg);\n                            -ms-transform: rotate(").concat(rotateDegrees, "deg);\n                            transform: rotate(").concat(rotateDegrees, "deg);\n                            width: ").concat(playerWidth, "px;\n                            height: ").concat(playerHeight, "px;\n                            position: relative;\n                            top: 0px;\n                            left: ").concat((width - playerWidth) / 2, "px;\n                        ");
            } else if (this.orientation === _protocolConfig.default.ORIENTATION[8]) {
              rotateDegrees = ORIENTATION_DEGRESS[this.orientation];
              if (this.keepRatio) {
                playerHeight = width;
                playerWidth = height * _commonConfig.CLOUD_PHONE_RATIO;
              } else {
                playerHeight = width;
                playerWidth = height;
              }
              style = "\n                            -webkit-transform: rotate(".concat(rotateDegrees, "deg);\n                            -moz-transform: rotate(").concat(rotateDegrees, "deg);\n                            -ms-transform: rotate(").concat(rotateDegrees, "deg);\n                            transform: rotate(").concat(rotateDegrees, "deg);\n                            -webkit-transform-origin: left;\n                            -moz-transform-origin: left;\n                            -ms-transform-origin: left;\n                            transform-origin: left;\n                            width: ").concat(playerWidth, "px;\n                            height: ").concat(playerHeight, "px;\n                            position: relative;\n                            top: ").concat(playerWidth / 2, "px;\n                            left: ").concat(width / 2, "px;\n                        ");
            } else if (this.orientation === _protocolConfig.default.ORIENTATION[24]) {
              if (this.keepRatio) {
                playerHeight = width;
                playerWidth = width * _commonConfig.CLOUD_PHONE_RATIO;
              } else {
                playerHeight = width;
                playerWidth = height;
              }
              rotateDegrees = ORIENTATION_DEGRESS[this.orientation];
              style = "\n                            -webkit-transform: rotate(".concat(rotateDegrees, "deg);\n                            -moz-transform: rotate(").concat(rotateDegrees, "deg);\n                            -ms-transform: rotate(").concat(rotateDegrees, "deg);\n                            transform: rotate(").concat(rotateDegrees, "deg);\n                            -webkit-transform-origin: top;\n                            -moz-transform-origin: top;\n                            -ms-transform-origin: top;\n                            transform-origin: top;\n                            width: ").concat(playerHeight, "px;\n                            height: ").concat(playerWidth, "px;\n                            position: relative;\n                            top: ").concat(height / 2, "px;\n                            left: ").concat(width - height / 2, "px;\n                        ");
            }
          }
        } else {
          //console.log("width",this.isMobile)
          width = Math.max(width - Math.max(rect.left * 2, 0), 0);
          height = Math.min(height - Math.max(rect.top * 2, 0), rect.height);
          //width = 405;
          // height = 720;
          // 根据本地视口方向和云手机方向判断播放器dom的旋转方向，将播放器旋转至视口方向。顺时针为正数，逆时针为负数
          if (this.orientation === 'PORTRAIT') {
            style = "\n                        -webkit-transform: none;\n                        -moz-transform: none;\n                        -ms-transform: none;\n                        transform: none;\n                        width: ".concat(width, "px;\n                        height: ").concat(height, "px;\n                        position: relative;\n                        top: 0px;\n                        left: 0px;\n                    ");
          } else if (this.orientation === 'REVERSE_PORTRAIT') {
            rotateDegrees = ORIENTATION_DEGRESS[this.orientation];
            style = "\n                        -webkit-transform: rotate(".concat(rotateDegrees, "deg);\n                        -moz-transform: rotate(").concat(rotateDegrees, "deg);\n                        -ms-transform: rotate(").concat(rotateDegrees, "deg);\n                        transform: rotate(").concat(rotateDegrees, "deg);\n                        -webkit-transform-origin: '50% 50%';\n                        -moz-transform-origin: '50% 50%';\n                        -ms-transform-origin: '50% 50%';\n                        transform-origin: '50% 50%';\n                        width: ").concat(width, "px;\n                        height: ").concat(height, "px;\n                        position: relative;\n                        top: 0px;\n                        left: 0px;\n                    ");
          } else {
            // 云手机横屏时顺时针旋转，竖屏时逆时针旋转
            rotateDegrees = ORIENTATION_DEGRESS[this.orientation];
            //width = 720;
            //height = 405;
            style = "\n                        -webkit-transform: rotate(".concat(rotateDegrees, "deg);\n                        -moz-transform: rotate(").concat(rotateDegrees, "deg);\n                        -ms-transform: rotate(").concat(rotateDegrees, "deg);\n                        transform: rotate(").concat(rotateDegrees, "deg);\n                        -webkit-transform-origin: '50% 50%';\n                        -moz-transform-origin: '50% 50%';\n                        -ms-transform-origin: '50% 50%';\n                        transform-origin: '50% 50%';\n                        width: ").concat(height, "px;\n                        height: ").concat(width, "px;\n                        position: relative;\n                        top: ").concat((height - width) / 2, "px;\n                        left: ").concat(0 - (height - width) / 2, "px;\n                    ");
          }
        }
      }
      container.style.cssText = this.originStyle + style;

      // 旋转后通过getClientRects()立即获取宽高可能会获取到旋转前的宽高
      // this.callbackAfterRotate && setTimeout(() => {
      //     this.callbackAfterRotate(rotateDegrees);
      // }, 300);

      if (this.directionHandler) {
        var _keyboardEle$style;
        var keyboardEle = document.getElementById('keyboardInputContent');
        var currentDisplay = keyboardEle === null || keyboardEle === void 0 || (_keyboardEle$style = keyboardEle.style) === null || _keyboardEle$style === void 0 ? void 0 : _keyboardEle$style.display;
        this.directionHandler.update(this.orientation, this.displayBox, currentDisplay);
      }
      this.adjustVideoSize();
      //console.log("更新视频方向")
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this2 = this;
      var container = this.videoContainer || document.getElementById(this.videoContainerId);
      container && (container.style.cssText = this.originStyle);
      if (this.isMobile) {
        this.util.unbind(window, 'resize');
        this.util.unbind(window, 'orientationchange');
        FULLSCREEN_CHANGE.forEach(function (evt) {
          _this2.util.unbind(document, evt);
        });
      }
    }
  }, {
    key: "getDeviceOrientation",
    value: function getDeviceOrientation() {
      var _window;
      return ((_window = window) === null || _window === void 0 || (_window = _window.screen) === null || _window === void 0 || (_window = _window.orientation) === null || _window === void 0 ? void 0 : _window.angle) || window.orientation;
    }
  }]);
}();

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
__webpack_require__(74);
__webpack_require__(359);
__webpack_require__(16);
__webpack_require__(17);
__webpack_require__(29);
__webpack_require__(31);
__webpack_require__(48);
__webpack_require__(49);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(21);
var _webworkifyWebpack = _interopRequireDefault(__webpack_require__(63));
var _Logger = _interopRequireDefault(__webpack_require__(89));
var _event = _interopRequireDefault(__webpack_require__(230));
var _Util = _interopRequireDefault(__webpack_require__(26));
var _baseClass = _interopRequireDefault(__webpack_require__(361));
var _WebglRenderer = _interopRequireDefault(__webpack_require__(362));
var _commonConfig = __webpack_require__(51);
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); } // Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var CanvasPlayer = /*#__PURE__*/function (_BaseClass) {
  function CanvasPlayer(options) {
    var _this;
    _classCallCheck(this, CanvasPlayer);
    _this = _callSuper(this, CanvasPlayer, [options]);
    _this.options = _objectSpread({}, options);
    _this.moduleInit = false;
    _this.streamList = [];
    _this.document = document;
    _this.tinyH264Worker = null;
    _this.videoStreamId = 1;
    // this.util = new Util();
    _this.util = new _Util.default(options.containerId);
    _this.canvasId = "".concat(options.containerId, "-canvas");
    _this.options.events = (0, _event.default)();
    _this.setCanvas(options.innerWidth);
    _this.setImagerPlayer();

    //将本行代码放主线程执行
    _this.tinyH264Worker = (0, _webworkifyWebpack.default)(/*require.resolve*/(364));
    _this.tinyH264Worker.addEventListener('message', function (e) {
      var message = /** @type {{type:string, width:number, height:number, data:ArrayBuffer, renderStateId:number}} */e.data;
      switch (message.type) {
        case 'pictureReady':
          var width = message.width,
            height = message.height,
            _data = message.data;
          /**self.postMessage({
            type: 'decoded',
            data: {
              data,
              width,
              height
            }
          })*/
          _this.onRenderImage({
            data: _data,
            width: width,
            height: height
          });
          break;
        case 'decoderReady':
          _this.moduleInit = true;
          break;
      }
    });
    return _this;
  }
  _inherits(CanvasPlayer, _BaseClass);
  return _createClass(CanvasPlayer, [{
    key: "setCanvas",
    value: function setCanvas(innerWidth) {
      var $canvas = this.util.createCanvas(this.options.isMobile, _commonConfig.CLOUD_PHONE_RATIO, innerWidth, this.canvasId);
      // 放入元素内部
      // let parentNode = document.getElementById('container');
      var parentNode = document.getElementById(this.options.containerId);
      parentNode.appendChild($canvas);
      this.canvas = $canvas;
    }
  }, {
    key: "setImagerPlayer",
    value: function setImagerPlayer() {
      var canvas = this.canvas || document.getElementById('playCanvas');
      this.webglPlayer = new _WebglRenderer.default(canvas, {
        preserveDrawingBuffer: false
      });
    }
  }, {
    key: "resize",
    value: function resize() {
      var _this$util$getRect = this.util.getRect(_commonConfig.CLOUD_PHONE_RATIO),
        dpr = _this$util$getRect.dpr,
        playerWidth = _this$util$getRect.playerWidth,
        playerHeight = _this$util$getRect.playerHeight;
      var ele = this.canvas;
      ele.style.width = "".concat(playerWidth, "px");
      ele.style.height = "".concat(playerHeight, "px");
      ele.width = playerWidth * dpr;
      ele.height = playerHeight * dpr;
    }
  }, {
    key: "onRenderImage",
    value: function onRenderImage(obj) {
      var unData = new Uint8Array(obj.data);
      var width = obj.width;
      var height = obj.height;
      var yLength = width * height;
      var uvLength = width / 2 * (height / 2);
      if (!this.webglPlayer) {
        this.setImagerPlayer();
      }
      this.webglPlayer.renderFrame(unData, width, height, yLength, uvLength);
      // this.options.topSubscribe &&
      //   this.options.topSubscribe.trigger('onVideo', {
      //     phoneId: this.options.deviceId,
      //     msg: this.canvas.toDataURL('image/png')
      //   })
      // this.options.topSubscribe.trigger('onMessage', {
      //   phoneId: this.options.deviceId,
      //   msg: this.canvas.toDataURL('image/png')
      //   // msg: 'data:image/png;base64,' + btoa(String.fromCharCode(...unData))
      // })
    }
  }, {
    key: "startDecod",
    value: function startDecod() {
      var streamData = this.streamList.shift();
      if (streamData && streamData.buffer) {
        this.tinyH264Worker.postMessage({
          type: 'decode',
          data: streamData.buffer,
          offset: streamData.byteOffset,
          length: streamData.byteLength,
          renderStateId: this.videoStreamId
        }, [streamData.buffer]);
      } else {
        _Logger.default.error('startDecode', 'data is null', 'data:', data);
      }
    }
  }, {
    key: "decode",
    value: function decode(data) {
      /*global __IS_DEBUG__*/
      // if (__IS_DEBUG__) {
      //   let traceId = window.delayAnalysis.shiftTraceId('receive') || ''
      //   window.delayAnalysis.cacheTraceId('decode', traceId)
      //   window.delayAnalysis.record(['decode', 'start', traceId])
      // }

      // 暂存流数据，等解码器准备好后开始解码
      this.streamList.push(data);
      if (this.moduleInit) {
        this.startDecod();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.tinyH264Worker.postMessage({
        type: 'release',
        renderStateId: this.videoStreamId
      });
      this.tinyH264Worker.terminate();
    }
  }]);
}(_baseClass.default);
var _default = exports.default = CanvasPlayer;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(33);
__webpack_require__(14);
__webpack_require__(30);
__webpack_require__(77);
__webpack_require__(13);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.events = exports.default = exports.Events = void 0;
__webpack_require__(56);
__webpack_require__(46);
__webpack_require__(16);
__webpack_require__(17);
var _Logger = _interopRequireDefault(__webpack_require__(89));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var Events = exports.Events = /*#__PURE__*/function () {
  function Events(target) {
    _classCallCheck(this, Events);
    _defineProperty(this, "eventsQueue", {});
    _defineProperty(this, "target", {});
    _defineProperty(this, "disallowRepeat", false);
    this.target = target;
  }
  return _createClass(Events, [{
    key: "add",
    value: function add() {
      var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var fn = arguments.length > 1 ? arguments[1] : undefined;
      var once = arguments.length > 2 ? arguments[2] : undefined;
      var _iterator = _createForOfIteratorHelper(types),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var type = _step.value;
          this.on(type, fn, once);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "on",
    value: function on(type, fn, once) {
      if (this.eventsQueue[type] === undefined) {
        this.eventsQueue[type] = {
          methods: [],
          once: false
        };
      }
      if (typeof fn !== 'function') {
        _Logger.default.error('on', 'the argument is not function.', fn);
        return;
      }
      // disallow repeat bind
      if (this.disallowRepeat && this.eventsQueue[type]['methods'].includes(fn)) {
        return;
      }
      this.eventsQueue[type].methods.push(fn);
      if (once !== undefined) {
        this.eventsQueue[type].once = once;
      }
      return this.target;
    }
  }, {
    key: "once",
    value: function once(type, fn) {
      this.on(type, fn, true);
    }
    /**
     * 
     * @param {string} type 
     * @param {Function} [fn] be removed function, default all
     */
  }, {
    key: "off",
    value: function off(type, fn) {
      var event = this.eventsQueue[type];
      if (!event) {
        return;
      }
      var methods = event.methods;
      if (!fn) {
        delete this.eventsQueue[type];
      } else {
        var len = methods.length;
        while (len--) {
          if (methods[len] === fn) {
            methods.splice(len, 1);
          }
        }
      }
      return this.target;
    }
  }, {
    key: "emit",
    value: function emit(type) {
      var _this = this;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var event = this.eventsQueue[type];
      if (!event) {
        return;
      }
      var methods = event.methods;
      methods.forEach(function (method) {
        method.apply(_this.target, args);
      });
      // remove the event after first called
      if (event.once) {
        this.off(type);
      }
      return this.target;
    }
  }, {
    key: "clear",
    value: function clear(type) {
      delete this.eventsQueue[type];
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this.eventsQueue = {};
    }
  }]);
}();
var events = exports.events = function events(obj) {
  return new Events(obj);
};
var getEvents = function getEvents(obj) {
  var instance = new Events(obj);
  return function (obj) {
    instance.target = obj;
    return instance;
  };
};
var _default = exports.default = getEvents;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var CANVAS_WHITE_LIST = {
  mate20: 'HMA-',
  mate20Pro: 'LYA-',
  mate20RS: 'LYA-AL00P',
  mate20X: 'EVR-',
  mate20X5G: 'EVR-AN00',
  mate30: 'TAS-',
  mate305G: 'TAS-AN00',
  mate30Pro: 'LIO-',
  mate30Pro5G: 'LIO-AN00',
  mateX: 'TAH-AN00',
  mate40_an00: 'OCE-AN00',
  mate40_an01: 'OCE-AN01',
  mate40_an10: 'OCE-AN10',
  mate40Pro_an00: 'NOH-AN00',
  mate40Pro_an01: 'NOH-AN01',
  mate40ProPlus: 'NOP-AN00',
  p30: 'ELE-',
  p30Pro: 'VOG-',
  P40_an: 'ANA-AN00',
  P40_al: 'ANA-AL00',
  P40_tn: 'ANA-TN00',
  p40Pro_an: 'ELS-AN00',
  p40Pro_tn: 'ELS-TN00',
  p40ProPlus_an: 'ELS-AN10',
  p40ProPlus_tn: 'ELS-TN10',
  nova5: 'SEA-AL00',
  nova5Pro: 'SEA-AL10',
  nova5iPro: 'SPN-',
  nova5z: 'SPN-AL00',
  nova6: 'WLZ-AL10',
  nova65G: 'WLZ-AN00',
  nova6SE: 'JNY-AL10',
  nova75G_an0: 'JEF-AN00',
  nova75G_tn0: 'JEF-TN00',
  nova75G_an2: 'JEF-AN20',
  nova75G_tn2: 'JEF-TN20',
  nova7Pro5G_an0: 'JER-AN10',
  nova7Pro5G_tn0: 'JER-TN10',
  nova7Pro5G_an2: 'JER-AN20',
  nova7Pro5G_tn2: 'JER-TN20',
  honorMagic2: 'TNY-',
  honor20: 'YAL-AL00',
  honor20Pro: 'YAL-AL10',
  honor30: 'BMH-AN10',
  honor30Pro: 'EBG-AN00',
  honor30ProPlus: 'EBG-AN10',
  honor20S: 'YAL-AL50',
  honor30S: 'CDY-AN90',
  honorPlay4TPro: 'AQM-AL10',
  honor9X: 'HLK-AL00',
  honor9XPro: 'HLK-AL10',
  honorV20: 'PCT-',
  honorV30: 'OXF-AN00',
  honorV30Pro: 'OXF-AN10',
  honorX10: 'TEL-',
  // 各子型号后缀不同，故判断前缀
  m6_10_8: 'SCM-',
  m6_8_4: 'VRD-',
  matePadPro: 'MRX-',
  vivo: 'VivoBrowser',
  qqApp: 'QQ/',
  wechat: 'MicroMessenger'
};
var _default = exports.default = CANVAS_WHITE_LIST;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(21);
__webpack_require__(16);
__webpack_require__(17);
var _Logger = _interopRequireDefault(__webpack_require__(89));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var FRAME_TYPE_MAP = {
  2: 'Audio',
  3: 'Video',
  8: 'HeartBeat',
  7: 'CmdControl',
  9: 'Orientation',
  10: 'Snapshot',
  14: 'KeyboardInput',
  60: 'PhoneControl',
  21: 'Camera',
  22: 'MicroPhone',
  23: 'Sensor',
  24: 'GpsLocation'
};
var INVALID_FRAME_TYPE = 'Invalid';
// 限制数据包缓存的长度，避免过多占用资源
var MAX_PKG_NUMBER = 300;
var PACKAGE_HEADER_LENGTH = 8;
var FrameParser = /*#__PURE__*/function () {
  function FrameParser(supportAudio) {
    _classCallCheck(this, FrameParser);
    this.pkgList = {
      Audio: [],
      Video: [],
      HeartBeat: [],
      CmdControl: [],
      Orientation: [],
      KeyboardInput: [],
      PhoneControl: [],
      Camera: [],
      MicroPhone: [],
      Channel: [],
      Sensor: [],
      GpsLocation: [],
      Snapshot: []
    };
    this.lastBuf = null;
    // 完整数据包length，含header
    this.completePkgLen = 0;
    this.supportAudio = supportAudio;
  }
  return _createClass(FrameParser, [{
    key: "getSizeFromPackage",
    value: function getSizeFromPackage(typeBuf, pkgStart) {
      pkgStart = pkgStart || 0;
      if (typeBuf.length < pkgStart + PACKAGE_HEADER_LENGTH) {
        _Logger.default.debug('The package is invalid.');
        return 0;
      }
      return typeBuf[pkgStart + 4] << 24 | typeBuf[pkgStart + 5] << 16 | typeBuf[pkgStart + 6] << 8 | typeBuf[pkgStart + 7];
    }
  }, {
    key: "getTypeFromPackage",
    value: function getTypeFromPackage(typeBuf, pkgStart) {
      pkgStart = pkgStart || 0;
      if (typeBuf.length < pkgStart + PACKAGE_HEADER_LENGTH) {
        _Logger.default.debug('The package is invalid.');
        return INVALID_FRAME_TYPE;
      }
      return FRAME_TYPE_MAP[typeBuf[pkgStart + 3]] || INVALID_FRAME_TYPE;
    }
  }, {
    key: "getSubTypeBuffer",
    value: function getSubTypeBuffer(typeBuf, start, end) {
      end = end || typeBuf.length;
      var subBuf = typeBuf.subarray(start, end);
      var newBuf = new Uint8Array(subBuf.length);
      newBuf.set(subBuf);
      return newBuf;
    }
  }, {
    key: "readPackage",
    value: function readPackage(recvdBuf) {
      if (!recvdBuf || recvdBuf.byteLength < 1) {
        return;
      }

      // 已经接收到的数据（包含本次和之前数据包剩下的）
      var allDataBuf = null;
      var recvdTypeBuf = new Uint8Array(recvdBuf);
      if (this.lastBuf) {
        allDataBuf = new Uint8Array(this.lastBuf.length + recvdBuf.byteLength);
        allDataBuf.set(this.lastBuf);
        allDataBuf.set(recvdTypeBuf, this.lastBuf.length);
      } else {
        // 忽略心跳响应包
        var pkgType = this.getTypeFromPackage(recvdTypeBuf);
        if (pkgType === INVALID_FRAME_TYPE || !this.supportAudio && pkgType === FRAME_TYPE_MAP[2] /* Audio */) {
          recvdTypeBuf = null;
          return;
        }
        allDataBuf = recvdTypeBuf;
      }

      // 需要的组成一整包的数据，包含header
      if (!this.completePkgLen) {
        this.completePkgLen = this.getSizeFromPackage(allDataBuf) + PACKAGE_HEADER_LENGTH;
      }

      // 已有数据和需要的数据length比较
      if (allDataBuf.length === this.completePkgLen) {
        var type = this.getTypeFromPackage(allDataBuf);
        this.pushPackage(type, this.getSubTypeBuffer(allDataBuf, PACKAGE_HEADER_LENGTH));
        this.lastBuf = null;
        this.completePkgLen = 0;
      } else if (allDataBuf.length < this.completePkgLen) {
        this.lastBuf = allDataBuf;
      } else {
        var pkgStart = 0;
        var pkgLen = 0;
        var allDataLen = allDataBuf.length;
        while (allDataLen - pkgStart >= PACKAGE_HEADER_LENGTH) {
          pkgLen = this.getSizeFromPackage(allDataBuf, pkgStart) + PACKAGE_HEADER_LENGTH;
          if (allDataLen - pkgStart >= pkgLen) {
            var _type = this.getTypeFromPackage(allDataBuf, pkgStart);
            this.pushPackage(_type, this.getSubTypeBuffer(allDataBuf, pkgStart + PACKAGE_HEADER_LENGTH, pkgStart + pkgLen));
            pkgStart += pkgLen;
          } else {
            break;
          }
        }

        // 仍剩下不完整包的数据，存储至lastBuf
        if (allDataLen > pkgStart) {
          this.lastBuf = this.getSubTypeBuffer(allDataBuf, pkgStart);
        }
        this.completePkgLen = 0;
      }
    }
  }, {
    key: "pushPackage",
    value: function pushPackage(type, pkg) {
      if (!this.pkgList[type]) {
        return;
      }
      if (this.pkgList[type].length >= MAX_PKG_NUMBER) {
        this.pkgList[type] = [];
      }
      this.pkgList[type].push(pkg);
    }
  }, {
    key: "shiftPackage",
    value: function shiftPackage(type) {
      return this.pkgList[type] && this.pkgList[type].shift();
    }
  }, {
    key: "clearPackageCache",
    value: function clearPackageCache(type) {
      this.pkgList[type] && (this.pkgList[type] = []);
    }
  }, {
    key: "getPackageCacheNum",
    value: function getPackageCacheNum(type) {
      return this.pkgList[type] && this.pkgList[type].length;
    }
  }]);
}();
var _default = exports.default = FrameParser;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var hw_0x6f0a=['writable','resolution','_mouseAction','includes','isMobile','mousedown','unbind','touchmove','defineProperty','log','onTouchMove','onTouchEnd','sendTouchMsg','secondary','find','objectFit','push','getScale','REVERSE_LANDSCAPE','userAgent','__esModule','touchListKey','pressure','innerHeight','bind','pageY','Set','getElementById','Invalid\x20attempt\x20to\x20spread\x20non-iterable\x20instance.\x0aIn\x20order\x20to\x20be\x20iterable,\x20non-array\x20objects\x20must\x20have\x20a\x20[Symbol.iterator]()\x20method.','primary','keyup','round','changedTouches','autoRotate','object','mouseCode','containerId','keepRatio','event','POINTER_','getMsgBuf','orientationchange','updateOrientation','keyboardMode','test','apply','isArray','contextmenu','keyboard','length','touchcancel','freeVirtualTouchId','filter','PORTRAIT','left','sendHandler','isSameOrientation','clearTouchAndMouse','onMouseLeave','containerId为空,不绑定ResizeObserver','getOwnPropertyDescriptors','phoenix_keyboard_','getOwnPropertySymbols','moveTimer','focus','KEYBOARD_INPUT','phone','button','onMouseDown','keys','preventDefault','touch','observe','dragMode','function','from','defineProperties','player','allocVirtualTouchId','constructor','keycode','innerWidth','touchCb','getKeyCodeEventMsgBuf','Object','viewportOrientation','getTouchAction','destroy','displayDom','onMouseMove','forEach','updateContainBox','ACTIONS_TYPE','key','resizeObserver','isDebug','top','getClientRects','onMouseUp','scale','throttle','LANDSCAPE','displayKeyboardMap','height','action','getCurrentMousePos','identifier','Arguments','getOwnPropertyDescriptor','displayBox','removeChild','name','lastMouseAction','touchend','REVERSE_PORTRAIT','updateScale','DEFAULT_RESOLUTION','vId','enumerable','item','prototype','pageX','orientation','style','stopPropagation','string','assist','configurable','time','iterator','MOVE','width','symbol','Cannot\x20call\x20a\x20class\x20as\x20a\x20function','DOWN','parentNode','mouse','call','util','sendKeyCodeEventMsg','posTracker','isApple','keydown','default','virtualTouchIds','value','simulationState','concat','updateResolution','KEYBOARD_MAP','resize','map'];(function(_0x5dc7ad,_0x6f0a1e){var _0x4a7405=function(_0x5dec9d){while(--_0x5dec9d){_0x5dc7ad['push'](_0x5dc7ad['shift']());}};_0x4a7405(++_0x6f0a1e);}(hw_0x6f0a,0x1ee));var hw_0x4a74=function(_0x5dc7ad,_0x6f0a1e){_0x5dc7ad=_0x5dc7ad-0x0;var _0x4a7405=hw_0x6f0a[_0x5dc7ad];return _0x4a7405;};'use strict';/* javascript-obfuscator:disable */
__webpack_require__(31);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(48);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(49);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(77);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(33);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(30);var hw_0x5dec9d={};hw_0x5dec9d[hw_0x4a74('0x6b')]=!![];/* javascript-obfuscator:enable */
Object[hw_0x4a74('0x7a')](exports,hw_0x4a74('0x86'),hw_0x5dec9d);exports[hw_0x4a74('0x69')]=void 0x0;/* javascript-obfuscator:disable */
__webpack_require__(21);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(29);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(366);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(13);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(14);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(12);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(15);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(107);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(105);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(46);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(55);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(16);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(17);/* javascript-obfuscator:enable */
var _protocolConfig=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(32));/* javascript-obfuscator:enable */
var _Util=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(26));/* javascript-obfuscator:enable */
var _commonConfig=/* javascript-obfuscator:disable */
__webpack_require__(51);/* javascript-obfuscator:enable */
function _interopRequireDefault(_0x478dd7){return _0x478dd7&&_0x478dd7[hw_0x4a74('0x86')]?_0x478dd7:{'default':_0x478dd7};}function _typeof(_0x6395a3){'@babel/helpers\x20-\x20typeof';return _typeof='function'==typeof Symbol&&hw_0x4a74('0x5e')==typeof Symbol[hw_0x4a74('0x5b')]?function(_0x241d3d){return typeof _0x241d3d;}:function(_0xe025e7){return _0xe025e7&&hw_0x4a74('0x24')==typeof Symbol&&_0xe025e7[hw_0x4a74('0x29')]===Symbol&&_0xe025e7!==Symbol[hw_0x4a74('0x52')]?'symbol':typeof _0xe025e7;},_typeof(_0x6395a3);}function _toConsumableArray(_0x3f250d){return _arrayWithoutHoles(_0x3f250d)||_iterableToArray(_0x3f250d)||_unsupportedIterableToArray(_0x3f250d)||_nonIterableSpread();}function _nonIterableSpread(){throw new TypeError(hw_0x4a74('0x8e'));}function _unsupportedIterableToArray(_0x115cde,_0x55e8d6){if(_0x115cde){if('string'==typeof _0x115cde)return _arrayLikeToArray(_0x115cde,_0x55e8d6);var _0x1309bb={}['toString'][hw_0x4a74('0x63')](_0x115cde)['slice'](0x8,-0x1);return hw_0x4a74('0x2e')===_0x1309bb&&_0x115cde[hw_0x4a74('0x29')]&&(_0x1309bb=_0x115cde[hw_0x4a74('0x29')][hw_0x4a74('0x49')]),'Map'===_0x1309bb||hw_0x4a74('0x8c')===_0x1309bb?Array[hw_0x4a74('0x25')](_0x115cde):hw_0x4a74('0x45')===_0x1309bb||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/[hw_0x4a74('0x6')](_0x1309bb)?_arrayLikeToArray(_0x115cde,_0x55e8d6):void 0x0;}}function _iterableToArray(_0x579c71){if('undefined'!=typeof Symbol&&null!=_0x579c71[Symbol[hw_0x4a74('0x5b')]]||null!=_0x579c71['@@iterator'])return Array['from'](_0x579c71);}function _arrayWithoutHoles(_0x4fa3c6){if(Array[hw_0x4a74('0x8')](_0x4fa3c6))return _arrayLikeToArray(_0x4fa3c6);}function _arrayLikeToArray(_0x59e171,_0xc33aa7){(null==_0xc33aa7||_0xc33aa7>_0x59e171['length'])&&(_0xc33aa7=_0x59e171[hw_0x4a74('0xb')]);for(var _0x13d05a=0x0,_0x1a0141=Array(_0xc33aa7);_0x13d05a<_0xc33aa7;_0x13d05a++)_0x1a0141[_0x13d05a]=_0x59e171[_0x13d05a];return _0x1a0141;}function ownKeys(_0x3b6a17,_0x51239b){var _0x370305=Object[hw_0x4a74('0x1f')](_0x3b6a17);if(Object[hw_0x4a74('0x18')]){var _0x118c93=Object['getOwnPropertySymbols'](_0x3b6a17);_0x51239b&&(_0x118c93=_0x118c93[hw_0x4a74('0xe')](function(_0x2765e1){return Object[hw_0x4a74('0x46')](_0x3b6a17,_0x2765e1)[hw_0x4a74('0x50')];})),_0x370305['push'][hw_0x4a74('0x7')](_0x370305,_0x118c93);}return _0x370305;}function _objectSpread(_0x4b1f29){for(var _0x31483a=0x1;_0x31483a<arguments[hw_0x4a74('0xb')];_0x31483a++){var _0x6557f=null!=arguments[_0x31483a]?arguments[_0x31483a]:{};_0x31483a%0x2?ownKeys(Object(_0x6557f),!0x0)['forEach'](function(_0x1848ea){_defineProperty(_0x4b1f29,_0x1848ea,_0x6557f[_0x1848ea]);}):Object[hw_0x4a74('0x16')]?Object[hw_0x4a74('0x26')](_0x4b1f29,Object['getOwnPropertyDescriptors'](_0x6557f)):ownKeys(Object(_0x6557f))['forEach'](function(_0x27fba3){Object[hw_0x4a74('0x7a')](_0x4b1f29,_0x27fba3,Object[hw_0x4a74('0x46')](_0x6557f,_0x27fba3));});}return _0x4b1f29;}function _defineProperty(_0x40d92d,_0x1a4b0d,_0x3b18dc){var _0x5f37ee={};_0x5f37ee[hw_0x4a74('0x6b')]=_0x3b18dc;_0x5f37ee[hw_0x4a74('0x50')]=!0x0;_0x5f37ee[hw_0x4a74('0x59')]=!0x0;_0x5f37ee[hw_0x4a74('0x72')]=!0x0;return(_0x1a4b0d=_toPropertyKey(_0x1a4b0d))in _0x40d92d?Object['defineProperty'](_0x40d92d,_0x1a4b0d,_0x5f37ee):_0x40d92d[_0x1a4b0d]=_0x3b18dc,_0x40d92d;}function _classCallCheck(_0xeac1cc,_0x4fa7cc){if(!(_0xeac1cc instanceof _0x4fa7cc))throw new TypeError(hw_0x4a74('0x5f'));}function _defineProperties(_0x219ae3,_0xd94d70){for(var _0x24fd1e=0x0;_0x24fd1e<_0xd94d70['length'];_0x24fd1e++){var _0x383c70=_0xd94d70[_0x24fd1e];_0x383c70['enumerable']=_0x383c70[hw_0x4a74('0x50')]||!0x1,_0x383c70['configurable']=!0x0,hw_0x4a74('0x6b')in _0x383c70&&(_0x383c70[hw_0x4a74('0x72')]=!0x0),Object[hw_0x4a74('0x7a')](_0x219ae3,_toPropertyKey(_0x383c70[hw_0x4a74('0x37')]),_0x383c70);}}function _createClass(_0x58782f,_0x22246b,_0x4049c8){var _0x4839de={};_0x4839de[hw_0x4a74('0x72')]=!0x1;return _0x22246b&&_defineProperties(_0x58782f[hw_0x4a74('0x52')],_0x22246b),_0x4049c8&&_defineProperties(_0x58782f,_0x4049c8),Object['defineProperty'](_0x58782f,hw_0x4a74('0x52'),_0x4839de),_0x58782f;}function _toPropertyKey(_0x39bae0){var _0x3bc40d=_toPrimitive(_0x39bae0,hw_0x4a74('0x57'));return hw_0x4a74('0x5e')==_typeof(_0x3bc40d)?_0x3bc40d:_0x3bc40d+'';}function _toPrimitive(_0x186877,_0x45bd38){if(hw_0x4a74('0x94')!=_typeof(_0x186877)||!_0x186877)return _0x186877;var _0x18c1d8=_0x186877[Symbol['toPrimitive']];if(void 0x0!==_0x18c1d8){var _0x1449f0=_0x18c1d8['call'](_0x186877,_0x45bd38||'default');if(hw_0x4a74('0x94')!=_typeof(_0x1449f0))return _0x1449f0;throw new TypeError('@@toPrimitive\x20must\x20return\x20a\x20primitive\x20value.');}return(hw_0x4a74('0x57')===_0x45bd38?String:Number)(_0x186877);}var MOVE_THROTTLE_DELAY=16.6;var ORIENTATION_PORTRAIT=hw_0x4a74('0xf');var ORIENTATION_REVERSE_PORTRAIT='REVERSE_PORTRAIT';var ORIENTATION_LANDSCAPE=hw_0x4a74('0x3f');var ORIENTATION_REVERSE_LANDSCAPE='REVERSE_LANDSCAPE';var KEYBOARD_ID_PREFIX=hw_0x4a74('0x17');var hw_0x324b0a={};hw_0x324b0a[hw_0x4a74('0xf')]=0x0;hw_0x324b0a[hw_0x4a74('0x3f')]=0x5a;hw_0x324b0a['REVERSE_LANDSCAPE']=-0x5a;hw_0x324b0a[hw_0x4a74('0x4c')]=0xb4;var ORIENTATION_DEGRESS=hw_0x324b0a;var hw_0x866e42={};hw_0x866e42[hw_0x4a74('0xf')]=0x0;hw_0x866e42[hw_0x4a74('0x3f')]=0x3;hw_0x866e42[hw_0x4a74('0x84')]=0x3;hw_0x866e42['REVERSE_PORTRAIT']=0x2;var ORIENTATION_ORIGIN=hw_0x866e42;var hw_0x369e31={};hw_0x369e31[hw_0x4a74('0xf')]=0x0;hw_0x369e31['LANDSCAPE']=0x3;hw_0x369e31['REVERSE_LANDSCAPE']=0x1;hw_0x369e31[hw_0x4a74('0x4c')]=0x2;var ORIENTATION_ORIGIN_MOBILE=hw_0x369e31;var hw_0xcde0ee={};hw_0xcde0ee[hw_0x4a74('0x6f')]=hw_0x4a74('0x6f');hw_0xcde0ee[hw_0x4a74('0x1b')]=hw_0x4a74('0x1b');var KEYBOARD_MODE=hw_0xcde0ee;var TouchHandler=exports[hw_0x4a74('0x69')]=function(){function _0x40a5ec(_0x493bbf){var _0x6fd85d=_0x493bbf[hw_0x4a74('0x27')],_0x430153=_0x493bbf[hw_0x4a74('0x76')],_0x5d8dd8=_0x493bbf[hw_0x4a74('0x11')],_0x4866cb=_0x493bbf[hw_0x4a74('0x39')],_0x315131=_0x493bbf[hw_0x4a74('0x93')],_0xb6cce2=_0x493bbf[hw_0x4a74('0x96')],_0x5a6000=_0x493bbf[hw_0x4a74('0x97')],_0x54a541=_0x493bbf[hw_0x4a74('0x2c')];_classCallCheck(this,_0x40a5ec);this['lastMouseAction']='';this[hw_0x4a74('0x96')]=_0xb6cce2;this[hw_0x4a74('0x32')]=_0x6fd85d;this[hw_0x4a74('0x11')]=_0x5d8dd8;this[hw_0x4a74('0x76')]=_0x430153;this['isDebug']=_0x4866cb;this[hw_0x4a74('0x93')]=_0x315131;this[hw_0x4a74('0x97')]=_0x5a6000;this[hw_0x4a74('0x1c')]=_objectSpread({},_protocolConfig['default'][hw_0x4a74('0x4e')]);this[hw_0x4a74('0x73')]=_objectSpread({},_protocolConfig[hw_0x4a74('0x69')][hw_0x4a74('0x4e')]);if(this[hw_0x4a74('0x76')]){var _0x17e8ff={};_0x17e8ff['width']=window[hw_0x4a74('0x2b')];_0x17e8ff[hw_0x4a74('0x41')]=window[hw_0x4a74('0x89')];this[hw_0x4a74('0x73')]=_0x17e8ff;}this[hw_0x4a74('0x2c')]=_0x54a541;this[hw_0x4a74('0x54')]=ORIENTATION_PORTRAIT;var _0x101464={};_0x101464[hw_0x4a74('0x3a')]=0x0;_0x101464[hw_0x4a74('0x10')]=0x0;this[hw_0x4a74('0x47')]=_objectSpread(_0x101464,_protocolConfig[hw_0x4a74('0x69')][hw_0x4a74('0x4e')]);var _0x567853={};_0x567853['x']=0x1;_0x567853['y']=0x1;this[hw_0x4a74('0x3d')]=_0x567853;this[hw_0x4a74('0x5')]=KEYBOARD_MODE[hw_0x4a74('0x6f')];var _0x4a0bb0={};_0x4a0bb0[hw_0x4a74('0x62')]={};_0x4a0bb0['touch']={};this['simulationState']=_0x4a0bb0;this[hw_0x4a74('0x6a')]=new Uint8Array(0x14);var _0x5eccb8={};_0x5eccb8[hw_0x4a74('0x8f')]=0x0;_0x5eccb8[hw_0x4a74('0x58')]=0x1;_0x5eccb8[hw_0x4a74('0x7f')]=0x2;this[hw_0x4a74('0x95')]=_0x5eccb8;this[hw_0x4a74('0x23')]=!![];this[hw_0x4a74('0x64')]=new _Util[(hw_0x4a74('0x69'))]();this[hw_0x4a74('0x87')]=hw_0x4a74('0x92');this[hw_0x4a74('0x19')]={};this[hw_0x4a74('0x2f')]=window['orientation'];this[hw_0x4a74('0x67')]=/(iPhone|iPad|iPod|iOS|Macintosh)/i[hw_0x4a74('0x6')](navigator&&navigator[hw_0x4a74('0x85')]||'');}var _0x2139b4={};_0x2139b4[hw_0x4a74('0x37')]='start';_0x2139b4[hw_0x4a74('0x6b')]=function _0x59ddd4(){this[hw_0x4a74('0x4d')]();this[hw_0x4a74('0x70')]();this[hw_0x4a74('0x64')]['bind'](window,hw_0x4a74('0x70'),this['resize'][hw_0x4a74('0x8a')](this));this[hw_0x4a74('0x38')]();if(this[hw_0x4a74('0x32')]){if(this[hw_0x4a74('0x76')]){this[hw_0x4a74('0x64')]['bind'](this[hw_0x4a74('0x32')],'touchstart',this['onTouchStart'][hw_0x4a74('0x8a')](this));this['util'][hw_0x4a74('0x8a')](this['displayDom'],hw_0x4a74('0x4b'),this[hw_0x4a74('0x7d')][hw_0x4a74('0x8a')](this));this['util'][hw_0x4a74('0x8a')](this[hw_0x4a74('0x32')],hw_0x4a74('0x79'),this[hw_0x4a74('0x7c')][hw_0x4a74('0x8a')](this));this[hw_0x4a74('0x64')]['bind'](this['displayDom'],hw_0x4a74('0xc'),this[hw_0x4a74('0x7d')][hw_0x4a74('0x8a')](this));}else{this[hw_0x4a74('0x64')]['bind'](this[hw_0x4a74('0x32')],hw_0x4a74('0x77'),this[hw_0x4a74('0x1e')]['bind'](this));this[hw_0x4a74('0x64')]['bind'](this[hw_0x4a74('0x32')],'mouseup',this[hw_0x4a74('0x3c')][hw_0x4a74('0x8a')](this));this[hw_0x4a74('0x64')][hw_0x4a74('0x8a')](this[hw_0x4a74('0x32')],'mousemove',this[hw_0x4a74('0x64')][hw_0x4a74('0x3e')](this['onMouseMove'][hw_0x4a74('0x8a')](this),MOVE_THROTTLE_DELAY,this)[hw_0x4a74('0x8a')](this));this['util'][hw_0x4a74('0x8a')](this['displayDom'],'mouseleave',this[hw_0x4a74('0x14')][hw_0x4a74('0x8a')](this));this['util'][hw_0x4a74('0x8a')](this[hw_0x4a74('0x32')],hw_0x4a74('0x9'),function(){return![];});}this[hw_0x4a74('0x32')][hw_0x4a74('0x1a')]();this[hw_0x4a74('0x93')]&&this[hw_0x4a74('0x64')]['bind'](window,hw_0x4a74('0x3'),this['viewportOrientationChange'][hw_0x4a74('0x8a')](this));}};var _0x9ccdf4={};_0x9ccdf4[hw_0x4a74('0x37')]=hw_0x4a74('0x38');_0x9ccdf4[hw_0x4a74('0x6b')]=function _0x14d026(){var _0x44dc76=this;var _0x5a74dc=document[hw_0x4a74('0x8d')](this[hw_0x4a74('0x96')]);if(_0x5a74dc){var _0x52c3a1=new ResizeObserver(function(){clearTimeout(_0x52c3a1['_t']);_0x52c3a1['_t']=setTimeout(function(){_0x44dc76[hw_0x4a74('0x70')]();console['log']('容器尺寸变化，已refreshTouch');},0x32);});_0x52c3a1[hw_0x4a74('0x22')](_0x5a74dc);}else{console[hw_0x4a74('0x7b')](hw_0x4a74('0x15'));}};var _0x132293={};_0x132293[hw_0x4a74('0x37')]='viewportOrientationChange';_0x132293['value']=function _0xfa15eb(){this[hw_0x4a74('0x2f')]=window[hw_0x4a74('0x54')];};var _0x5a3e3a={};_0x5a3e3a[hw_0x4a74('0x37')]=hw_0x4a74('0x4');_0x5a3e3a[hw_0x4a74('0x6b')]=function _0x1afd3d(_0x506186){this[hw_0x4a74('0x54')]=_0x506186;this[hw_0x4a74('0x70')]();};var _0x583f67={};_0x583f67[hw_0x4a74('0x37')]=hw_0x4a74('0x6e');_0x583f67['value']=function _0x3429f9(_0x29b012,_0x3176ee){var _0x18c2fe={};_0x18c2fe['width']=_0x29b012;_0x18c2fe[hw_0x4a74('0x41')]=_0x3176ee;this[hw_0x4a74('0x73')]=_0x18c2fe;this[hw_0x4a74('0x70')]();};var _0x5cf82a={};_0x5cf82a['key']='updateKeyBoardMode';_0x5cf82a['value']=function _0x3862d1(_0x39d48a){if(!KEYBOARD_MODE[_0x39d48a]){return;}this[hw_0x4a74('0x5')]=_0x39d48a;};var _0x235865={};_0x235865[hw_0x4a74('0x37')]=hw_0x4a74('0x30');_0x235865[hw_0x4a74('0x6b')]=function _0x4a5c2f(_0x1c0583,_0x18fcbe){var _0x295986=_0x18fcbe[hw_0x4a74('0x62')]&&Object[hw_0x4a74('0x1f')](_0x18fcbe[hw_0x4a74('0x62')])[hw_0x4a74('0xb')]||0x0;var _0x58e423=_0x18fcbe[hw_0x4a74('0x21')]&&Object[hw_0x4a74('0x1f')](_0x18fcbe[hw_0x4a74('0x21')])[hw_0x4a74('0xb')]||0x0;var _0x36358c=_toConsumableArray(new Set(_0x18fcbe['keyboard']&&Object['values'](_0x18fcbe[hw_0x4a74('0xa')])||[]))['length'];var _0x4c972e=_0x295986+_0x58e423+_0x36358c;var _0x8b0f2b='';if(_0x1c0583==='UP'&&_0x4c972e||_0x1c0583===hw_0x4a74('0x60')&&_0x4c972e>0x1){_0x8b0f2b=hw_0x4a74('0x1');}return _0x8b0f2b+_0x1c0583;};var _0x30344c={};_0x30344c[hw_0x4a74('0x37')]=hw_0x4a74('0x20');_0x30344c[hw_0x4a74('0x6b')]=function _0x1afbe4(_0x2feb43){_0x2feb43[hw_0x4a74('0x56')]();_0x2feb43[hw_0x4a74('0x20')]();};var _0x417dcc={};_0x417dcc[hw_0x4a74('0x37')]='onTouchStart';_0x417dcc[hw_0x4a74('0x6b')]=function _0x4ccdff(_0x221070){_0x221070=_0x221070||window[hw_0x4a74('0x0')];this['preventDefault'](_0x221070);this[hw_0x4a74('0x2c')]&&this[hw_0x4a74('0x2c')]();var _0x398347={};_0x398347[hw_0x4a74('0xb')]=0x0;var _0x4e8ea7=_0x221070[this[hw_0x4a74('0x87')]]||_0x398347;for(var _0x922fac=_0x4e8ea7[hw_0x4a74('0xb')],_0x57b99b=0x0;_0x57b99b<_0x922fac;_0x57b99b++){var _0x13af30=_0x4e8ea7[hw_0x4a74('0x51')](_0x57b99b)||{};var _0x4152c6=this[hw_0x4a74('0x6c')][hw_0x4a74('0x21')][_0x13af30[hw_0x4a74('0x44')]];if(_0x4152c6){this[hw_0x4a74('0x7e')](_0x4152c6,'UP');this[hw_0x4a74('0xd')](_0x4152c6[hw_0x4a74('0x4f')]);delete this[hw_0x4a74('0x6c')]['touch'][_0x13af30[hw_0x4a74('0x44')]];}_0x13af30[hw_0x4a74('0x4f')]=this[hw_0x4a74('0x28')]();this['simulationState'][hw_0x4a74('0x21')][_0x13af30['identifier']]=_0x13af30;var _0x51ff96=this[hw_0x4a74('0x43')](_0x13af30);var _0x50e4ad={};_0x50e4ad['vId']=_0x13af30[hw_0x4a74('0x4f')];this[hw_0x4a74('0x7e')](_objectSpread(_objectSpread({},_0x51ff96),{},_0x50e4ad),this[hw_0x4a74('0x30')](hw_0x4a74('0x60'),this[hw_0x4a74('0x6c')]));}};var _0x562471={};_0x562471[hw_0x4a74('0x37')]=hw_0x4a74('0x7c');_0x562471[hw_0x4a74('0x6b')]=function _0x4d8d33(_0x2ad7f5){_0x2ad7f5=_0x2ad7f5||window[hw_0x4a74('0x0')];this[hw_0x4a74('0x20')](_0x2ad7f5);var _0x22e9ee={};_0x22e9ee['length']=0x0;var _0x30dacb=_0x2ad7f5[this['touchListKey']]||_0x22e9ee;for(var _0x189fde=_0x30dacb[hw_0x4a74('0xb')],_0x171fa4=0x0;_0x171fa4<_0x189fde;_0x171fa4++){var _0x316a0b=_0x30dacb[hw_0x4a74('0x51')](_0x171fa4)||{};var _0x3eacee=this[hw_0x4a74('0x6c')][hw_0x4a74('0x21')][_0x316a0b[hw_0x4a74('0x44')]];var _0x57382e=this[hw_0x4a74('0x43')](_0x316a0b);var _0x4c80ea={};_0x4c80ea[hw_0x4a74('0x4f')]=_0x3eacee&&_0x3eacee[hw_0x4a74('0x4f')]||0x0;this[hw_0x4a74('0x7e')](_objectSpread(_objectSpread({},_0x57382e),{},_0x4c80ea),hw_0x4a74('0x5c'));if(_0x57382e['x']>this['displayBox'][hw_0x4a74('0x5d')]||_0x57382e['x']<0x0||_0x57382e['y']<0x0||_0x57382e['y']>this[hw_0x4a74('0x47')]['height']){this[hw_0x4a74('0x13')]();}}};var _0x42dbbc={};_0x42dbbc[hw_0x4a74('0x37')]=hw_0x4a74('0x7d');_0x42dbbc['value']=function _0x2eaa22(_0xabc160){_0xabc160=_0xabc160||window[hw_0x4a74('0x0')];this[hw_0x4a74('0x20')](_0xabc160);var _0x1187b1={};_0x1187b1[hw_0x4a74('0xb')]=0x0;var _0x31888b=_0xabc160[this[hw_0x4a74('0x87')]]||_0x1187b1;for(var _0x105dee=_0x31888b[hw_0x4a74('0xb')],_0x2b57ae=0x0;_0x2b57ae<_0x105dee;_0x2b57ae++){var _0x4ddfb4=_0x31888b[hw_0x4a74('0x51')](_0x2b57ae)||{};var _0x553f6d=this[hw_0x4a74('0x6c')]['touch'][_0x4ddfb4['identifier']];if(_0x553f6d){this['freeVirtualTouchId'](_0x553f6d[hw_0x4a74('0x4f')]);delete this[hw_0x4a74('0x6c')][hw_0x4a74('0x21')][_0x4ddfb4[hw_0x4a74('0x44')]];}var _0x4a5712=this[hw_0x4a74('0x43')](_0x4ddfb4);var _0x5416ce={};_0x5416ce[hw_0x4a74('0x4f')]=_0x553f6d&&_0x553f6d[hw_0x4a74('0x4f')]||0x0;this[hw_0x4a74('0x7e')](_objectSpread(_objectSpread({},_0x4a5712),{},_0x5416ce),this['getTouchAction']('UP',this[hw_0x4a74('0x6c')]));}};var _0xaf80c4={};_0xaf80c4[hw_0x4a74('0x37')]=hw_0x4a74('0x74');_0xaf80c4[hw_0x4a74('0x6b')]=function _0x473553(_0x206356,_0x21514c){this[hw_0x4a74('0x4a')]=_0x21514c;var _0x5b00f5=_0x206356[hw_0x4a74('0x1d')];var _0x1dbcb8=this[hw_0x4a74('0x43')](_0x206356);var _0x11bb9c=this['simulationState'][hw_0x4a74('0x62')];var _0x47e64f=_0x11bb9c[_0x5b00f5];if(_0x21514c==='UP'){this[hw_0x4a74('0xd')](_0x47e64f);delete _0x11bb9c[_0x5b00f5];}else{_0x47e64f=this['allocVirtualTouchId']();_0x11bb9c[_0x5b00f5]=_0x47e64f;}var _0x46f916={};_0x46f916[hw_0x4a74('0x4f')]=_0x47e64f;this[hw_0x4a74('0x7e')](_objectSpread(_objectSpread({},_0x1dbcb8),{},_0x46f916),this[hw_0x4a74('0x30')](_0x21514c,this['simulationState']));};var _0x1ed101={};_0x1ed101[hw_0x4a74('0x37')]=hw_0x4a74('0x1e');_0x1ed101[hw_0x4a74('0x6b')]=function _0x45c39a(_0x424de2){_0x424de2=_0x424de2||window[hw_0x4a74('0x0')];this[hw_0x4a74('0x20')](_0x424de2);this[hw_0x4a74('0x2c')]&&this[hw_0x4a74('0x2c')]();if(_0x424de2['button']===this[hw_0x4a74('0x95')][hw_0x4a74('0x58')]){this[hw_0x4a74('0x23')]=!this['dragMode'];if(!this[hw_0x4a74('0x23')]){this[hw_0x4a74('0x74')](_0x424de2,'DOWN');}else{this[hw_0x4a74('0x74')](_0x424de2,'UP');}}else{this['_mouseAction'](_0x424de2,'DOWN');}};var _0x2867ae={};_0x2867ae[hw_0x4a74('0x37')]=hw_0x4a74('0x33');_0x2867ae[hw_0x4a74('0x6b')]=function _0x1c9cca(_0x1b25e8){var _0x63555a=this;_0x1b25e8=_0x1b25e8||window[hw_0x4a74('0x0')];this[hw_0x4a74('0x20')](_0x1b25e8);var _0x40a28d=Object[hw_0x4a74('0x1f')](this[hw_0x4a74('0x6c')][hw_0x4a74('0x62')]);var _0x1a64bb=_0x40a28d[hw_0x4a74('0x80')](function(_0x5223e4){return _0x5223e4 in _0x63555a[hw_0x4a74('0x6c')]['mouse'];});if(_0x1a64bb!==undefined){var _0x43950d=this[hw_0x4a74('0x43')](_0x1b25e8);var _0x597e6a={};_0x597e6a[hw_0x4a74('0x4f')]=this[hw_0x4a74('0x6c')]['mouse'][_0x1a64bb];this[hw_0x4a74('0x7e')](_objectSpread(_objectSpread({},_0x43950d),{},_0x597e6a),hw_0x4a74('0x5c'));}};var _0x5e4c2c={};_0x5e4c2c['key']=hw_0x4a74('0x14');_0x5e4c2c['value']=function _0x5eddef(){if(this[hw_0x4a74('0x4a')]===hw_0x4a74('0x60')){this[hw_0x4a74('0x4a')]='UP';this[hw_0x4a74('0x13')]();}};var _0x2bf260={};_0x2bf260[hw_0x4a74('0x37')]=hw_0x4a74('0x3c');_0x2bf260[hw_0x4a74('0x6b')]=function _0x218065(_0x2105dd){_0x2105dd=_0x2105dd||window[hw_0x4a74('0x0')];this[hw_0x4a74('0x20')](_0x2105dd);if(_0x2105dd[hw_0x4a74('0x1d')]!==this[hw_0x4a74('0x95')][hw_0x4a74('0x58')]){this['_mouseAction'](_0x2105dd,'UP');}};var _0x3c2cc5={};_0x3c2cc5[hw_0x4a74('0x37')]=hw_0x4a74('0x12');_0x3c2cc5[hw_0x4a74('0x6b')]=function _0x1bac20(){if(!this['isMobile']){return![hw_0x4a74('0x3f'),ORIENTATION_REVERSE_LANDSCAPE][hw_0x4a74('0x75')](this['orientation']);}return!this[hw_0x4a74('0x93')]&&this['orientation']===ORIENTATION_PORTRAIT||this['autoRotate']&&(this[hw_0x4a74('0x2f')]===ORIENTATION_DEGRESS['PORTRAIT']||this[hw_0x4a74('0x2f')]===ORIENTATION_DEGRESS[hw_0x4a74('0x4c')]);};var _0xc0aa1b={};_0xc0aa1b['key']=hw_0x4a74('0x83');_0xc0aa1b[hw_0x4a74('0x6b')]=function _0x37e7b9(_0x5c436c,_0x2e5d2b){if(this[hw_0x4a74('0x12')]()){var _0x3640eb={};_0x3640eb['x']=_0x5c436c['width']?_0x2e5d2b[hw_0x4a74('0x5d')]/_0x5c436c[hw_0x4a74('0x5d')]:0x1;_0x3640eb['y']=_0x5c436c['height']?_0x2e5d2b[hw_0x4a74('0x41')]/_0x5c436c[hw_0x4a74('0x41')]:0x1;return _0x3640eb;}var _0x3126c5={};_0x3126c5['x']=_0x5c436c[hw_0x4a74('0x41')]?_0x2e5d2b[hw_0x4a74('0x5d')]/_0x5c436c[hw_0x4a74('0x41')]:0x1;_0x3126c5['y']=_0x5c436c[hw_0x4a74('0x5d')]?_0x2e5d2b[hw_0x4a74('0x41')]/_0x5c436c[hw_0x4a74('0x5d')]:0x1;return _0x3126c5;};var _0x10d1c7={};_0x10d1c7[hw_0x4a74('0x37')]=hw_0x4a74('0x4d');_0x10d1c7[hw_0x4a74('0x6b')]=function _0x3814ad(){this[hw_0x4a74('0x3d')]=this[hw_0x4a74('0x83')](this[hw_0x4a74('0x47')],this['phone']);};var _0x4c3393={};_0x4c3393['key']='updateContainBox';_0x4c3393['value']=function _0x17285a(_0x28d400){if(this[hw_0x4a74('0x76')]&&!this['keepRatio']){if(this['isSameOrientation']()){this[hw_0x4a74('0x47')][hw_0x4a74('0x5d')]=_0x28d400['width'];this[hw_0x4a74('0x47')]['height']=_0x28d400[hw_0x4a74('0x41')];}else{this[hw_0x4a74('0x47')]['width']=_0x28d400['width'];this[hw_0x4a74('0x47')][hw_0x4a74('0x41')]=_0x28d400[hw_0x4a74('0x41')];}}else{var _0x5484f5,_0x1a0dc6;if(this['isSameOrientation']()){_0x5484f5=this['phone'][hw_0x4a74('0x5d')];_0x1a0dc6=this[hw_0x4a74('0x1c')]['height'];}else{_0x5484f5=this[hw_0x4a74('0x1c')]['height'];_0x1a0dc6=this['phone'][hw_0x4a74('0x5d')];}var _0xba305a=_0x5484f5/_0x1a0dc6;var _0x398a9b=_0x28d400['width']/_0x28d400['height'];var _0x247329,_0x2f8c86;if(_0x398a9b>_0xba305a){_0x2f8c86=_0x28d400[hw_0x4a74('0x41')];_0x247329=_0x2f8c86*_0xba305a;}else{_0x247329=_0x28d400['width'];_0x2f8c86=_0x247329/_0xba305a;}this[hw_0x4a74('0x47')][hw_0x4a74('0x5d')]=Math[hw_0x4a74('0x91')](Math['min'](_0x247329,_0x28d400[hw_0x4a74('0x5d')]));this[hw_0x4a74('0x47')][hw_0x4a74('0x41')]=Math[hw_0x4a74('0x91')](Math['min'](_0x2f8c86,_0x28d400[hw_0x4a74('0x41')]));}this['displayBox']['left']=Math[hw_0x4a74('0x91')]((_0x28d400['width']-this[hw_0x4a74('0x47')]['width'])/0x2);this['displayBox'][hw_0x4a74('0x3a')]=Math[hw_0x4a74('0x91')]((_0x28d400[hw_0x4a74('0x41')]-this[hw_0x4a74('0x47')][hw_0x4a74('0x41')])/0x2);};var _0x5776a2={};_0x5776a2[hw_0x4a74('0x37')]=hw_0x4a74('0x70');_0x5776a2[hw_0x4a74('0x6b')]=function _0xbe23c4(_0x1d2331,_0x15ff1a){if(!this[hw_0x4a74('0x32')]){return;}if(_0x1d2331&&_0x15ff1a){this[hw_0x4a74('0x47')]['width']=_0x1d2331;this[hw_0x4a74('0x47')][hw_0x4a74('0x41')]=_0x15ff1a;}else{var _0x126e71=this[hw_0x4a74('0x32')][hw_0x4a74('0x3b')]();this[hw_0x4a74('0x47')][hw_0x4a74('0x5d')]=_0x126e71&&_0x126e71[0x0]&&_0x126e71[0x0][hw_0x4a74('0x5d')];this[hw_0x4a74('0x47')][hw_0x4a74('0x41')]=_0x126e71&&_0x126e71[0x0]&&_0x126e71[0x0][hw_0x4a74('0x41')];}this[hw_0x4a74('0x47')][hw_0x4a74('0x3a')]=0x0;this[hw_0x4a74('0x47')][hw_0x4a74('0x10')]=0x0;if(this[hw_0x4a74('0x32')][hw_0x4a74('0x55')][hw_0x4a74('0x81')]==='contain'){this[hw_0x4a74('0x35')](_objectSpread({},this[hw_0x4a74('0x47')]));}this['updateScale']();};var _0x5cf923={};_0x5cf923['key']='getCurrentMousePos';_0x5cf923['value']=function _0x45a2ec(_0x3bba16){var _0x4346b1=document['documentElement'][hw_0x4a74('0x3b')]()[0x0];var _0x9cf04f=this['displayDom']['getClientRects']()[0x0];var _0x6c2713=_0x3bba16[hw_0x4a74('0x53')]-_0x9cf04f[hw_0x4a74('0x10')]-this[hw_0x4a74('0x47')][hw_0x4a74('0x10')];var _0x4f8ef7=_0x3bba16[hw_0x4a74('0x8b')]-_0x9cf04f[hw_0x4a74('0x3a')]-this[hw_0x4a74('0x47')][hw_0x4a74('0x3a')]+_0x4346b1[hw_0x4a74('0x3a')];if(this[hw_0x4a74('0x54')]!==ORIENTATION_REVERSE_LANDSCAPE){var _0x4cab88={};_0x4cab88['x']=_0x6c2713;_0x4cab88['y']=_0x4f8ef7;return _0x4cab88;}else{var _0x233602={};_0x233602['x']=this[hw_0x4a74('0x76')]?_0x6c2713:this[hw_0x4a74('0x47')][hw_0x4a74('0x5d')]-_0x6c2713;_0x233602['y']=this[hw_0x4a74('0x76')]?_0x4f8ef7:this[hw_0x4a74('0x47')][hw_0x4a74('0x41')]-_0x4f8ef7;return _0x233602;}};var _0x551769={};_0x551769[hw_0x4a74('0x37')]=hw_0x4a74('0x28');_0x551769[hw_0x4a74('0x6b')]=function _0x58edb9(){var _0x4f5149=this[hw_0x4a74('0x6a')]['indexOf'](0x0);if(_0x4f5149===-0x1){this[hw_0x4a74('0x6a')][hw_0x4a74('0x71')](function(){return 0x0;});this[hw_0x4a74('0x6a')][0x0]=0x1;return 0x0;}this['virtualTouchIds'][_0x4f5149]=0x1;return _0x4f5149;};var _0x2aa79f={};_0x2aa79f[hw_0x4a74('0x37')]=hw_0x4a74('0xd');_0x2aa79f[hw_0x4a74('0x6b')]=function _0x21b785(_0x3e77d8){this[hw_0x4a74('0x6a')][_0x3e77d8]=0x0;};var _0x435242={};_0x435242['key']=hw_0x4a74('0x2');_0x435242[hw_0x4a74('0x6b')]=function _0x57936c(_0xa1333d){if(!this[hw_0x4a74('0x11')]){return;}var _0x193b08=0x8;var _0x3f20a3=0x11;var _0x2b66aa=0x6;var _0x11f265=new Uint8Array(_0x193b08+_0x3f20a3);_0x11f265[0x0]=0x5a;_0x11f265[0x1]=0x5a;_0x11f265[0x2]=0xb4+_0x2b66aa;_0x11f265[0x3]=_0x2b66aa;_0x11f265[0x7]=_0x3f20a3;_0x11f265[0x8]=_0xa1333d['id'];_0x11f265[0x9]=_0xa1333d[hw_0x4a74('0x42')];_0x11f265[0xa]=_0xa1333d['x']>>0x8&0xff;_0x11f265[0xb]=_0xa1333d['x']&0xff;_0x11f265[0xc]=_0xa1333d['y']>>0x8&0xff;_0x11f265[0xd]=_0xa1333d['y']&0xff;_0x11f265[0xe]=_0xa1333d[hw_0x4a74('0x88')]>>0x8&0xff;_0x11f265[0xf]=_0xa1333d[hw_0x4a74('0x88')]&0xff;_0x11f265[0x10]=(_0xa1333d[hw_0x4a74('0x5a')]&0xff000000)>>0x18;_0x11f265[0x11]=(_0xa1333d['time']&0xff0000)>>0x10;_0x11f265[0x12]=(_0xa1333d['time']&0xff00)>>0x8;_0x11f265[0x13]=_0xa1333d['time']&0xff;_0x11f265[0x14]=_0xa1333d['orientation'];_0x11f265[0x15]=_0xa1333d[hw_0x4a74('0x41')]>>0x8&0xff;_0x11f265[0x16]=_0xa1333d[hw_0x4a74('0x41')]&0xff;_0x11f265[0x17]=_0xa1333d[hw_0x4a74('0x5d')]>>0x8&0xff;_0x11f265[0x18]=_0xa1333d['width']&0xff;return _0x11f265;};var _0x24a893={};_0x24a893[hw_0x4a74('0x37')]=hw_0x4a74('0x2d');_0x24a893['value']=function _0x403a43(_0x393aed){if(!this['sendHandler']){return;}var _0x145ae1=0x8;var _0x22b999=0x4;var _0xc1ada7=0xf;var _0x31f611=new Uint8Array(_0x145ae1+_0x22b999);_0x31f611[0x0]=0x5a;_0x31f611[0x1]=0x5a;_0x31f611[0x2]=0xb4+_0xc1ada7;_0x31f611[0x3]=_0xc1ada7;_0x31f611[0x7]=_0x22b999;_0x31f611[0x8]=_0x393aed[hw_0x4a74('0x2a')]>>0x8&0xff;_0x31f611[0x9]=_0x393aed[hw_0x4a74('0x2a')]&0xff;_0x31f611[0xa]=_0x393aed[hw_0x4a74('0x42')]>>0x8&0xff;_0x31f611[0xb]=_0x393aed[hw_0x4a74('0x42')]&0xff;return _0x31f611;};var _0x519fef={};_0x519fef[hw_0x4a74('0x37')]=hw_0x4a74('0x7e');_0x519fef[hw_0x4a74('0x6b')]=function _0x596038(_0x281429,_0xbd9e97){if(_0x281429['x']>this['displayBox'][hw_0x4a74('0x5d')]||_0x281429['x']<0x0||_0x281429['y']<0x0||_0x281429['y']>this[hw_0x4a74('0x47')]['height']){return;}var _0x4cdfc2;if(this[hw_0x4a74('0x76')]){_0x4cdfc2=ORIENTATION_ORIGIN_MOBILE[this[hw_0x4a74('0x54')]];}else{_0x4cdfc2=ORIENTATION_ORIGIN[this[hw_0x4a74('0x54')]];}var _0x20b079=_objectSpread(_objectSpread({},_0x281429),{},{'action':_protocolConfig['default'][hw_0x4a74('0x36')][_0xbd9e97],'id':_0x281429['vId'],'pressure':0x81,'time':-0x1,'orientation':_0x4cdfc2,'height':this['displayBox']['height'],'width':this[hw_0x4a74('0x47')]['width']});var _0x390c69=this[hw_0x4a74('0x2')](_0x20b079);this['sendHandler'](_0x390c69);};var _0x1089f0={};_0x1089f0['key']=hw_0x4a74('0x65');_0x1089f0[hw_0x4a74('0x6b')]=function _0x1d30df(_0x354a14,_0x44d579){var _0x23e2e1={};_0x23e2e1['keycode']=_0x44d579;_0x23e2e1['action']=_0x354a14;var _0x350c8b=_0x23e2e1;var _0x17e424=this[hw_0x4a74('0x2d')](_0x350c8b);this[hw_0x4a74('0x11')](_0x17e424);};var _0x9c626f={};_0x9c626f['key']=hw_0x4a74('0x13');_0x9c626f[hw_0x4a74('0x6b')]=function _0x20b23d(){this[hw_0x4a74('0xd')](0x0);this[hw_0x4a74('0x6c')][hw_0x4a74('0x21')]={};this[hw_0x4a74('0x6c')][hw_0x4a74('0x62')]={};var _0x14882c={};_0x14882c['x']=0x0;_0x14882c['y']=0x0;_0x14882c['vId']=0x0;this[hw_0x4a74('0x7e')](_0x14882c,'UP');};var _0xd05dc9={};_0xd05dc9['key']=hw_0x4a74('0x31');_0xd05dc9['value']=function _0x1da88b(){var _0x4c687c=this;this['util']['unbind'](window,hw_0x4a74('0x70'));this[hw_0x4a74('0x64')][hw_0x4a74('0x78')](window,hw_0x4a74('0x68'));this[hw_0x4a74('0x64')]['unbind'](window,hw_0x4a74('0x90'));this[hw_0x4a74('0x64')][hw_0x4a74('0x78')](this['displayDom']);this['autoRotate']&&this[hw_0x4a74('0x64')][hw_0x4a74('0x78')](window,hw_0x4a74('0x3'));Object[hw_0x4a74('0x1f')](this[hw_0x4a74('0x19')])[hw_0x4a74('0x34')](function(_0x7620ee){_0x4c687c[hw_0x4a74('0x19')][_0x7620ee]&&clearInterval(_0x4c687c[hw_0x4a74('0x19')][_0x7620ee]);});if(this['displayDom']&&this[hw_0x4a74('0x32')]['parentNode']){var _0x5b94b8=this[hw_0x4a74('0x32')][hw_0x4a74('0x61')]['children']||[];var _0x415612=this[hw_0x4a74('0x40')]&&Object[hw_0x4a74('0x1f')](this[hw_0x4a74('0x40')])||[];var _0x4d6554=_0x415612[hw_0x4a74('0x71')](function(_0x5d449c){return''[hw_0x4a74('0x6d')](KEYBOARD_ID_PREFIX)[hw_0x4a74('0x6d')](_0x5d449c);});_0x4d6554[hw_0x4a74('0x82')](hw_0x4a74('0x66'));var _0x2add18=[];for(var _0x3fae58=0x0,_0x54c922=_0x5b94b8[hw_0x4a74('0xb')];_0x3fae58<_0x54c922;_0x3fae58++){if(_0x4d6554['indexOf'](_0x5b94b8[_0x3fae58]['id'])>-0x1){_0x2add18['push'](_0x5b94b8[_0x3fae58]);}}_0x2add18[hw_0x4a74('0x34')](function(_0x2a363e){return _0x4c687c['displayDom'][hw_0x4a74('0x61')][hw_0x4a74('0x48')](_0x2a363e);});}this[hw_0x4a74('0x32')]=null;};return _createClass(_0x40a5ec,[_0x2139b4,_0x9ccdf4,_0x132293,_0x5a3e3a,_0x583f67,_0x5cf82a,_0x235865,_0x30344c,_0x417dcc,_0x562471,_0x42dbbc,_0xaf80c4,_0x1ed101,_0x2867ae,_0x5e4c2c,_0x2bf260,_0x3c2cc5,_0xc0aa1b,_0x10d1c7,_0x4c3393,_0x5776a2,_0x5cf923,_0x551769,_0x2aa79f,_0x435242,_0x24a893,_0x519fef,_0x1089f0,_0x9c626f,_0xd05dc9]);}();

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var $export = __webpack_require__(18);
var redefine = __webpack_require__(37);
var redefineAll = __webpack_require__(75);
var meta = __webpack_require__(87);
var forOf = __webpack_require__(101);
var anInstance = __webpack_require__(76);
var isObject = __webpack_require__(23);
var fails = __webpack_require__(24);
var $iterDetect = __webpack_require__(100);
var setToStringTag = __webpack_require__(70);
var inheritIfRequired = __webpack_require__(163);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);
__webpack_require__(31);
__webpack_require__(48);
__webpack_require__(49);
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(17);
__webpack_require__(102);
__webpack_require__(56);
__webpack_require__(46);
__webpack_require__(16);
var _protocolConfig = _interopRequireDefault(__webpack_require__(32));
var _commonConfig = __webpack_require__(51);
var _Util = _interopRequireDefault(__webpack_require__(26));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var normalCssText = "\n    display: none;\n    width: 300px;\n    height: 200px;\n    position: absolute;\n    z-index: 999;\n    top: 50%;\n    left: 50%;\n    background-color: #fff;\n    border: 1px solid #dfe1e6;\n    border-radius: 5px;\n    transform: translate(-50%, -50%);\n";
var DOM_ORIENTATION_ANGLES = {
  'PORTRAIT': 0,
  'REVERSE_PORTRAIT': 180,
  'LANDSCAPE': -90,
  'REVERSE_LANDSCAPE': 90
};
var DirectionHandler = /*#__PURE__*/function () {
  function DirectionHandler(options) {
    _classCallCheck(this, DirectionHandler);
    this.options = _objectSpread({}, options);
    this.util = new _Util.default();
    this.orientation = null;
    this.displayBox = null;
    this.touchHandler = this.options.touchHandler;
    this.containerEle = document.getElementById(this.options.containerId);
    if (true) {
      this.netWorkInfo = {
        clientHeight: 0,
        clientWidth: 0
      };
      this.messageModal = {
        width: '0px',
        height: '0px'
      };
      this.buttonModal = {
        width: '0px',
        height: '0px'
      };
      this.ctrlEle = {
        clientHeight: 0,
        clientWidth: 0
      };
    } else {}
    if (this.options.isMobile) {
      this.keyboardInputContent = {
        width: '0px',
        height: '0px'
      };
    } else {
      this.keyboardInputContent = document.getElementById('keyboardInputContent');
    }
  }
  return _createClass(DirectionHandler, [{
    key: "init",
    value: function init() {
      this.util.bind(window, 'orientationchange', this.patchChange.bind(this));
    }
  }, {
    key: "portraitPc",
    value: function portraitPc() {
      switch (this.orientation) {
        case _protocolConfig.default.ORIENTATION[0]:
          var ctrlEleLeft = (this.containerEle.clientWidth - this.displayBox.width) / 2 + this.ctrlEle.clientWidth / 2;
          var ctrlEleTop = (this.containerEle.clientHeight - this.displayBox.height) / 2 + this.netWorkInfo.clientHeight * 2.5;
          this.portraitAndportrait(ctrlEleLeft, ctrlEleTop);
          if (this.keyboardInputContent) {
            this.keyboardInputContent.style.cssText = "\n                    display:  ".concat(this.currentDisplay ? this.currentDisplay : 'none', ";\n                    position: absolute;\n                    bottom: 5px;\n                    left: 0px;\n                    height: 0px;\n                    width: 10px;\n                    ");
          }
          break;
        case _protocolConfig.default.ORIENTATION[16]:
          var keyboardInputLeft = this.containerEle.clientWidth;
          var keyboardInputTop = 0;
          this.portraitAndReversePortrait(keyboardInputLeft, keyboardInputTop, _protocolConfig.default.ORIENTATION[16]);
          break;
        case _protocolConfig.default.ORIENTATION[8]:
          this.portraitAndReverseLandscapePc(_protocolConfig.default.ORIENTATION[8]);
          break;
        case _protocolConfig.default.ORIENTATION[24]:
          this.portraitAndLandscapePc(_protocolConfig.default.ORIENTATION[24]);
          break;
        default:
          break;
      }
    }

    // 手机竖屏场景，根据流方向适配
  }, {
    key: "portraitMobile",
    value: function portraitMobile() {
      switch (this.orientation) {
        case _protocolConfig.default.ORIENTATION[0]:
          var ctrlEleLeft = this.ctrlEle.clientWidth / 2;
          var ctrlEleTop = this.netWorkInfo.clientHeight * 2.5;
          this.portraitAndportrait(ctrlEleLeft, ctrlEleTop);
          break;
        case _protocolConfig.default.ORIENTATION[16]:
          var keyboardInputLeft = this.containerEle.clientWidth;
          var keyboardInputTop = this.containerEle.clientHeight / 2 - this.keyboardInputContent.clientHeight;
          this.portraitAndReversePortrait(keyboardInputLeft, keyboardInputTop, _protocolConfig.default.ORIENTATION[16]);
          break;
        case _protocolConfig.default.ORIENTATION[8]:
          this.portraitAndReverseLandscapeMobile(_protocolConfig.default.ORIENTATION[8]);
          break;
        case _protocolConfig.default.ORIENTATION[24]:
          this.portraitAndLandscapeMobile(_protocolConfig.default.ORIENTATION[24]);
          break;
        default:
          break;
      }
    }
  }, {
    key: "setDomElementPosition",
    value: function setDomElementPosition(positionParams) {
      var transformCssText = "\n            display: none;\n            width: 300px;\n            height: 200px;\n            position: absolute;\n            z-index: 999;\n            top: ".concat(positionParams.commonTop, "px;\n            left: ").concat(positionParams.commonLeft, "px;\n            background-color: #fff;\n            border: 1px solid #dfe1e6;\n            border-radius: 5px;\n            -webkit-transform: rotate(").concat(positionParams.transformAngle, "deg);\n            -moz-transform: rotate(").concat(positionParams.transformAngle, "deg);\n            -ms-transform: rotate(").concat(positionParams.transformAngle, "deg);\n            -o-transform: rotate(").concat(positionParams.transformAngle, "deg);\n            transform: rotate(").concat(positionParams.transformAngle, "deg);\n            transform-origin: left top;\n        ");
      if (this.keyboardInputContent && !this.options.isMobile) {
        this.keyboardInputContent.style.cssText = "\n              display:  ".concat(this.currentDisplay ? this.currentDisplay : 'none', ";\n              -webkit-transform: rotate(").concat(positionParams.transformAngle, "deg);\n              -moz-transform: rotate(").concat(positionParams.transformAngle, "deg);\n              -ms-transform: rotate(").concat(positionParams.transformAngle, "deg);\n              -o-transform: rotate(").concat(positionParams.transformAngle, "deg);\n              transform-origin: left;\n              transform: rotate(").concat(positionParams.transformAngle, "deg);\n              position: absolute;\n              top: ").concat(positionParams.keyboardInputTop, "px;\n              left: ").concat(positionParams.keyboardInputLeft, "px;\n              height: 0px;\n              width: 10px;\n          ");
      }
      if (true) {
        return;
      }
      this.messageModal.style.cssText = transformCssText;
      this.exitModal.style.cssText = transformCssText;
      this.netWorkInfo.style.cssText = "\n            transform-origin: left;\n            -webkit-transform: rotate(".concat(positionParams.transformAngle, "deg);\n            -moz-transform: rotate(").concat(positionParams.transformAngle, "deg);\n            -ms-transform: rotate(").concat(positionParams.transformAngle, "deg);\n            -o-transform: rotate(").concat(positionParams.transformAngle, "deg);\n            transform: rotate(").concat(positionParams.transformAngle, "deg);\n            pointer-events: none;\n            position: absolute;\n            left: ").concat(positionParams.netWorkInfoLeft, "px;\n            top: ").concat(positionParams.netWorkInfoTop, "px;\n            height: 40px;\n            line-height: 40px;\n            text-align: center;\n            width: ").concat(positionParams.netWorkInfoWidth, "px;\n            color: #3AC295;\n        ");
      this.buttonModal.style.cssText = "\n            -webkit-transform: rotate(".concat(positionParams.transformAngle, "deg);\n            -moz-transform: rotate(").concat(positionParams.transformAngle, "deg);\n            -ms-transform: rotate(").concat(positionParams.transformAngle, "deg);\n            -o-transform: rotate(").concat(positionParams.transformAngle, "deg);\n            transform-origin: left top;\n            transform: rotate(").concat(positionParams.transformAngle, "deg);\n            display: none;\n            width: 255px;\n            height: 175px;\n            position: absolute;\n            z-index: 999;\n            top: ").concat(positionParams.buttonModalTop, "px;\n            left: ").concat(positionParams.buttonModalLeft, "px;\n            background-color: rgba(0, 0, 0, 0.4);\n            border-radius: 5px;\n        ");
      this.ctrlEle.style.top = "".concat(positionParams.ctrlEleTop, "px");
      this.ctrlEle.style.left = "".concat(positionParams.ctrlEleLeft, "px");
      this.ctrlEle.style.transform = "rotate(".concat(positionParams.transformAngle, "deg)");
      this.ctrlEle.style.transformOrigin = 'top';
    }

    // 设备不旋转，流不旋转
  }, {
    key: "portraitAndportrait",
    value: function portraitAndportrait(ctrlEleLeft, ctrlEleTop) {
      if (true) {
        return;
      }
      this.messageModal.style.cssText = normalCssText;
      this.exitModal.style.cssText = normalCssText;
      this.netWorkInfo.style.cssText = "\n            pointer-events: none;\n            position: absolute;\n            top: 0px;\n            height: 40px;\n            line-height: 40px;\n            text-align: center;\n            width: 100%;\n            color: #3AC295;\n        ";
      this.buttonModal.style.cssText = "\n            display: none;\n            width: 255px;\n            height: 175px;\n            position: absolute;\n            z-index: 999;\n            top: 50%;\n            left: 50%;\n            background-color: rgba(0, 0, 0, 0.4);\n            border-radius: 5px;\n            transform: translate(-50%, -50%);\n        ";
      this.ctrlEle.style.top = "".concat(ctrlEleTop, "px");
      this.ctrlEle.style.left = "".concat(ctrlEleLeft, "px");
      this.ctrlEle.style.transform = 'none';
    }

    // 设备不旋转，流旋转180
  }, {
    key: "portraitAndReversePortrait",
    value: function portraitAndReversePortrait(keyboardInputLeft, keyboardInputTop, orientationStr) {
      var transformAngle = DOM_ORIENTATION_ANGLES[orientationStr];
      var netWorkInfoLeft = (this.containerEle.clientWidth - this.netWorkInfo.clientWidth) / 2 + this.netWorkInfo.clientWidth;
      var netWorkInfoTop = this.containerEle.clientHeight - this.netWorkInfo.clientHeight;
      var commonLeft, commonTop, buttonModalLeft, buttonModalTop;
      if (true) {
        commonLeft = (this.containerEle.clientWidth - this.displayBox.width) / 2 + Number(this.messageModal.width.split('px')[0]) + (this.displayBox.width - Number(this.messageModal.width.split('px')[0])) / 2;
        commonTop = this.containerEle.clientHeight / 2 + Number(this.messageModal.height.split('px')[0]) / 2;
        buttonModalLeft = (this.containerEle.clientWidth - this.displayBox.width) / 2 + Number(this.buttonModal.width.split('px')[0]) + (this.displayBox.width - Number(this.buttonModal.width.split('px')[0])) / 2;
        buttonModalTop = this.containerEle.clientHeight / 2 + Number(this.messageModal.height.split('px')[0]) / 2;
      } else {}
      var ctrlEleTop = this.containerEle.clientHeight - this.netWorkInfo.clientHeight * 2.5;
      var ctrlEleLeft = (this.containerEle.clientWidth - this.displayBox.width) / 2 + this.displayBox.width - this.ctrlEle.clientWidth * 1.5;
      var netWorkInfoWidth = this.containerEle.clientWidth;
      var keyboardInputWidth = this.containerEle.clientWidth;
      var positionParams = {
        transformAngle: transformAngle,
        netWorkInfoLeft: netWorkInfoLeft,
        netWorkInfoTop: netWorkInfoTop,
        commonLeft: commonLeft,
        commonTop: commonTop,
        buttonModalLeft: buttonModalLeft,
        buttonModalTop: buttonModalTop,
        ctrlEleTop: ctrlEleTop,
        ctrlEleLeft: ctrlEleLeft,
        netWorkInfoWidth: netWorkInfoWidth,
        keyboardInputLeft: keyboardInputLeft,
        keyboardInputTop: keyboardInputTop,
        keyboardInputWidth: keyboardInputWidth
      };
      this.setDomElementPosition(positionParams);
    }

    // 设备不旋转，流旋转-90
  }, {
    key: "portraitAndReverseLandscapePc",
    value: function portraitAndReverseLandscapePc(orientationStr) {
      var transformAngle = DOM_ORIENTATION_ANGLES[orientationStr];
      var netWorkInfoLeft = this.containerEle.clientWidth - this.netWorkInfo.clientHeight;
      var netWorkInfoTop = -this.netWorkInfo.clientHeight / 2;
      var commonLeft, commonTop, buttonModalLeft, buttonModalTop;
      if (true) {
        commonLeft = this.containerEle.clientWidth - Number(this.messageModal.height.split('px')[0]);
        commonTop = (this.containerEle.clientHeight - Number(this.messageModal.width.split('px')[0])) / 2;
        buttonModalLeft = this.containerEle.clientWidth - Number(this.buttonModal.height.split('px')[0]);
        buttonModalTop = (this.containerEle.clientHeight - Number(this.buttonModal.width.split('px')[0])) / 2;
      } else {}
      var ctrlEleTop = (this.containerEle.clientHeight - this.displayBox.width) / 2 + this.netWorkInfo.clientHeight;
      var ctrlEleLeft = this.containerEle.clientWidth - this.ctrlEle.clientHeight * 2.5;
      var netWorkInfoWidth = this.containerEle.clientHeight;
      var keyboardInputLeft;
      var keyboardInputTop;
      if (this.keyboardInputContent) {
        keyboardInputLeft = Number(window.getComputedStyle(this.keyboardInputContent).height.split('px')[0]) / 2;
        keyboardInputTop = -Number(window.getComputedStyle(this.keyboardInputContent).height.split('px')[0]) / 2;
      } else {
        keyboardInputLeft = 0;
        keyboardInputTop = 0;
      }
      var keyboardInputWidth = this.containerEle.clientHeight;
      var positionParams = {
        transformAngle: transformAngle,
        netWorkInfoLeft: netWorkInfoLeft,
        netWorkInfoTop: netWorkInfoTop,
        commonLeft: commonLeft,
        commonTop: commonTop,
        buttonModalLeft: buttonModalLeft,
        buttonModalTop: buttonModalTop,
        ctrlEleTop: ctrlEleTop,
        ctrlEleLeft: ctrlEleLeft,
        netWorkInfoWidth: netWorkInfoWidth,
        keyboardInputLeft: keyboardInputLeft,
        keyboardInputTop: keyboardInputTop,
        keyboardInputWidth: keyboardInputWidth
      };
      this.setDomElementPosition(positionParams);
    }

    // 设备不旋转，流旋转-90
  }, {
    key: "portraitAndReverseLandscapeMobile",
    value: function portraitAndReverseLandscapeMobile(orientationStr) {
      var transformAngle = DOM_ORIENTATION_ANGLES[orientationStr];
      var windowHeight = document.documentElement.clientHeight;
      var netWorkInfoLeft = (windowHeight - this.containerEle.clientWidth) / 2 + this.containerEle.clientWidth - this.netWorkInfo.clientHeight;
      var netWorkInfoTop = -this.netWorkInfo.clientHeight / 2;
      var commonLeft = this.containerEle.clientWidth;
      var commonTop, buttonModalTop;
      if (true) {
        commonTop = (this.containerEle.clientHeight - Number(this.messageModal.width.split('px')[0])) / 2;
        buttonModalTop = (this.containerEle.clientHeight - Number(this.buttonModal.width.split('px')[0])) / 2;
      } else {}
      var buttonModalLeft = this.containerEle.clientWidth;
      var ctrlEleTop = this.ctrlEle.clientHeight;
      var ctrlEleLeft = (windowHeight - this.containerEle.clientWidth) / 2 + this.containerEle.clientWidth - this.netWorkInfo.clientHeight * 3.5;
      var netWorkInfoWidth = this.containerEle.clientHeight;
      var keyboardInputLeft = 0;
      var keyboardInputTop = 0;
      var keyboardInputWidth = this.containerEle.clientHeight;
      var positionParams = {
        transformAngle: transformAngle,
        netWorkInfoLeft: netWorkInfoLeft,
        netWorkInfoTop: netWorkInfoTop,
        commonLeft: commonLeft,
        commonTop: commonTop,
        buttonModalLeft: buttonModalLeft,
        buttonModalTop: buttonModalTop,
        ctrlEleTop: ctrlEleTop,
        ctrlEleLeft: ctrlEleLeft,
        netWorkInfoWidth: netWorkInfoWidth,
        keyboardInputLeft: keyboardInputLeft,
        keyboardInputTop: keyboardInputTop,
        keyboardInputWidth: keyboardInputWidth
      };
      this.setDomElementPosition(positionParams);
    }

    // 设备不旋转，流旋转90
  }, {
    key: "portraitAndLandscapePc",
    value: function portraitAndLandscapePc(orientationStr) {
      var transformAngle = DOM_ORIENTATION_ANGLES[orientationStr];
      var netWorkInfoLeft = this.netWorkInfo.clientHeight;
      var netWorkInfoTop = this.containerEle.clientHeight - this.netWorkInfo.clientHeight / 2;
      var commonLeft, commonTop, buttonModalTop, buttonModalLeft;
      if (true) {
        commonLeft = (this.displayBox.height - Number(this.messageModal.height.split('px')[0])) / 2;
        commonTop = "".concat((this.containerEle.clientHeight - Number(this.messageModal.width.split('px')[0])) / 2 + Number(this.messageModal.width.split('px')[0]));
        buttonModalTop = "".concat((this.containerEle.clientHeight - Number(this.buttonModal.width.split('px')[0])) / 2 + Number(this.buttonModal.width.split('px')[0]));
        buttonModalLeft = (this.displayBox.height - Number(this.buttonModal.height.split('px')[0])) / 2;
      } else {}
      var ctrlEleTop = (this.containerEle.clientHeight - this.displayBox.width) / 2 + this.displayBox.width - this.ctrlEle.clientHeight;
      var ctrlEleLeft = this.netWorkInfo.clientHeight * 1.5;
      var netWorkInfoWidth = this.containerEle.clientHeight;
      var keyboardInputLeft = this.containerEle.clientWidth - Number(window.getComputedStyle(this.keyboardInputContent).height.split('px')[0]) / 2;
      var keyboardInputTop = this.containerEle.clientHeight - Number(window.getComputedStyle(this.keyboardInputContent).height.split('px')[0]) / 2;
      var keyboardInputWidth = this.containerEle.clientHeight;
      var positionParams = {
        transformAngle: transformAngle,
        netWorkInfoLeft: netWorkInfoLeft,
        netWorkInfoTop: netWorkInfoTop,
        commonLeft: commonLeft,
        commonTop: commonTop,
        buttonModalLeft: buttonModalLeft,
        buttonModalTop: buttonModalTop,
        ctrlEleTop: ctrlEleTop,
        ctrlEleLeft: ctrlEleLeft,
        netWorkInfoWidth: netWorkInfoWidth,
        keyboardInputLeft: keyboardInputLeft,
        keyboardInputTop: keyboardInputTop,
        keyboardInputWidth: keyboardInputWidth
      };
      this.setDomElementPosition(positionParams);
    }

    // 设备不旋转，流旋转90
  }, {
    key: "portraitAndLandscapeMobile",
    value: function portraitAndLandscapeMobile(orientationStr) {
      var transformAngle = DOM_ORIENTATION_ANGLES[orientationStr];
      var windowHeight = document.documentElement.clientHeight;
      var netWorkInfoLeft = -((windowHeight - this.containerEle.clientWidth) / 2 - this.netWorkInfo.clientHeight / 2);
      var netWorkInfoTop = this.containerEle.clientHeight - this.netWorkInfo.clientHeight / 2;
      var commonTop, buttonModalTop;
      if (true) {
        buttonModalTop = "".concat((this.containerEle.clientHeight - Number(this.buttonModal.width.split('px')[0])) / 2 + Number(this.buttonModal.width.split('px')[0]));
        commonTop = "".concat((this.containerEle.clientHeight - Number(this.messageModal.width.split('px')[0])) / 2 + Number(this.messageModal.width.split('px')[0]));
      } else {}
      var buttonModalLeft = 0;
      var commonLeft = 0;
      var ctrlEleTop = this.containerEle.clientHeight - this.ctrlEle.clientHeight;
      var ctrlEleLeft = -((windowHeight - this.containerEle.clientWidth) / 2 - this.netWorkInfo.clientHeight * 2);
      var netWorkInfoWidth = this.containerEle.clientHeight;
      var keyboardInputLeft = this.containerEle.clientWidth / 2 - this.keyboardInputContent.clientHeight;
      var keyboardInputTop = this.containerEle.clientHeight - Number(window.getComputedStyle(this.keyboardInputContent).height.split('px')[0]) / 2;
      var keyboardInputWidth = this.containerEle.clientHeight;
      var positionParams = {
        transformAngle: transformAngle,
        netWorkInfoLeft: netWorkInfoLeft,
        netWorkInfoTop: netWorkInfoTop,
        commonLeft: commonLeft,
        commonTop: commonTop,
        buttonModalLeft: buttonModalLeft,
        buttonModalTop: buttonModalTop,
        ctrlEleTop: ctrlEleTop,
        ctrlEleLeft: ctrlEleLeft,
        netWorkInfoWidth: netWorkInfoWidth,
        keyboardInputLeft: keyboardInputLeft,
        keyboardInputTop: keyboardInputTop,
        keyboardInputWidth: keyboardInputWidth
      };
      this.setDomElementPosition(positionParams);
    }

    // 手机横屏场景，根据流方向适配
  }, {
    key: "landscapeMobile",
    value: function landscapeMobile() {
      switch (this.orientation) {
        case _protocolConfig.default.ORIENTATION[0]:
          this.landscapeAndPortrait();
          break;
        case _protocolConfig.default.ORIENTATION[8]:
          this.landscapeAndReserveLandscape(_protocolConfig.default.ORIENTATION[8]);
          break;
        case _protocolConfig.default.ORIENTATION[24]:
          this.landscapeAndLandscape(_protocolConfig.default.ORIENTATION[24]);
          break;
        default:
          break;
      }
    }

    // 设备横屏，流旋转0
  }, {
    key: "landscapeAndPortrait",
    value: function landscapeAndPortrait() {
      var clientWidth = document.documentElement.clientWidth;
      if (true) {
        return;
      }
      this.messageModal.style.cssText = normalCssText;
      this.exitModal.style.cssText = normalCssText;
      this.netWorkInfo.style.cssText = "\n            pointer-events: none;\n            position: absolute;\n            top: 0px;\n            left: ".concat(-(document.documentElement.clientWidth - this.containerEle.clientWidth) / 2, "px;\n            height: 40px;\n            line-height: 40px;\n            text-align: center;\n            width: ").concat(document.documentElement.clientWidth, "px;\n            color: #3AC295;\n        ");
      this.buttonModal.style.cssText = "\n            display: none;\n            width: 255px;\n            height: 175px;\n            position: absolute;\n            z-index: 999;\n            top: 50%;\n            left: 50%;\n            background-color: rgba(0, 0, 0, 0.4);\n            border-radius: 5px;\n            transform: translate(-50%, -50%);\n        ";
      if (this.keyboardInputContent && !this.options.isMobile) {
        this.keyboardInputContent.style.cssText = "\n          display:  ".concat(this.currentDisplay ? this.currentDisplay : 'none', ";\n          position: absolute;\n          top: 0px;\n          left: ").concat(-(clientWidth - this.containerEle.clientWidth) / 2, "px;\n          height: 40px;\n          width: ").concat(clientWidth, "px;\n          ");
      }
      var left = this.ctrlEle.clientWidth / 2;
      var top = this.netWorkInfo.clientHeight * 2.5;
      this.ctrlEle.style.top = "".concat(top, "px");
      this.ctrlEle.style.left = "".concat(left, "px");
      this.ctrlEle.style.transform = 'none';
    }

    // 设备横屏，流旋转-90
  }, {
    key: "landscapeAndReserveLandscape",
    value: function landscapeAndReserveLandscape(orientationStr) {
      var transformAngle = DOM_ORIENTATION_ANGLES[orientationStr];
      var windowWidth = document.documentElement.clientWidth;
      var windowHeight = document.documentElement.clientHeight;
      var netWorkInfoLeft = (windowHeight - this.containerEle.clientWidth) / 2 + this.containerEle.clientWidth - this.netWorkInfo.clientHeight / 2;
      var netWorkInfoTop = -this.netWorkInfo.clientHeight / 2;
      var ctrlEleTop = this.ctrlEle.clientHeight;
      var ctrlEleLeft = (windowHeight - this.containerEle.clientWidth) / 2 + this.containerEle.clientWidth - this.netWorkInfo.clientHeight * 2.5;
      var commonLeft, commonTop, buttonModalTop, buttonModalLeft, keyboardInputLeft, keyboardInputTop;
      if (true) {
        commonLeft = (this.containerEle.clientWidth - Number(this.messageModal.height.split('px')[0])) / 2 + Number(this.messageModal.height.split('px')[0]);
        commonTop = (this.containerEle.clientHeight - Number(this.messageModal.width.split('px')[0])) / 2;
        buttonModalTop = (this.containerEle.clientHeight - Number(this.buttonModal.width.split('px')[0])) / 2;
        buttonModalLeft = (this.containerEle.clientWidth - Number(this.buttonModal.height.split('px')[0])) / 2 + Number(this.buttonModal.height.split('px')[0]);
        keyboardInputLeft = (windowHeight - this.containerEle.clientWidth) / 2 + this.containerEle.clientWidth - Number(this.keyboardInputContent.height.split('px')[0] / 2);
        keyboardInputTop = -Number(this.keyboardInputContent.height.split('px')[0]) / 2;
      } else {}
      var netWorkInfoWidth = this.containerEle.clientHeight;
      var keyboardInputWidth = windowWidth;
      var positionParams = {
        transformAngle: transformAngle,
        netWorkInfoLeft: netWorkInfoLeft,
        netWorkInfoTop: netWorkInfoTop,
        commonLeft: commonLeft,
        commonTop: commonTop,
        buttonModalLeft: buttonModalLeft,
        buttonModalTop: buttonModalTop,
        ctrlEleTop: ctrlEleTop,
        ctrlEleLeft: ctrlEleLeft,
        netWorkInfoWidth: netWorkInfoWidth,
        keyboardInputLeft: keyboardInputLeft,
        keyboardInputTop: keyboardInputTop,
        keyboardInputWidth: keyboardInputWidth
      };
      this.setDomElementPosition(positionParams);
    }

    // 设备横屏，流旋转90
  }, {
    key: "landscapeAndLandscape",
    value: function landscapeAndLandscape(orientationStr) {
      var transformAngle = DOM_ORIENTATION_ANGLES[orientationStr];
      var windowWidth = document.documentElement.clientWidth;
      var windowHeight = document.documentElement.clientHeight;
      var netWorkInfoLeft = -((windowHeight - this.containerEle.clientWidth) / 2 - this.netWorkInfo.clientHeight / 2);
      var netWorkInfoTop = this.containerEle.clientHeight - this.netWorkInfo.clientHeight / 2;
      var ctrlEleTop = this.containerEle.clientHeight - this.ctrlEle.clientHeight;
      var ctrlEleLeft = -((windowHeight - this.containerEle.clientWidth) / 2 - this.ctrlEle.clientWidth);
      var commonLeft, commonTop, buttonModalTop, buttonModalLeft, keyboardInputLeft, keyboardInputTop;
      if (true) {
        commonLeft = (this.containerEle.clientWidth - Number(this.messageModal.height.split('px')[0])) / 2;
        commonTop = (this.containerEle.clientHeight - Number(this.messageModal.width.split('px')[0])) / 2 + Number(this.messageModal.width.split('px')[0]);
        buttonModalTop = (this.containerEle.clientHeight - Number(this.buttonModal.width.split('px')[0])) / 2 + Number(this.buttonModal.width.split('px')[0]);
        buttonModalLeft = (this.containerEle.clientWidth - Number(this.buttonModal.height.split('px')[0])) / 2;
        keyboardInputLeft = Number(this.keyboardInputContent.height.split('px')[0]) / 2;
        keyboardInputTop = windowWidth - Number(this.keyboardInputContent.height.split('px')[0]) / 2;
      } else {}
      var netWorkInfoWidth = this.containerEle.clientHeight;
      var keyboardInputWidth = windowWidth;
      var positionParams = {
        transformAngle: transformAngle,
        netWorkInfoLeft: netWorkInfoLeft,
        netWorkInfoTop: netWorkInfoTop,
        commonLeft: commonLeft,
        commonTop: commonTop,
        buttonModalLeft: buttonModalLeft,
        buttonModalTop: buttonModalTop,
        ctrlEleTop: ctrlEleTop,
        ctrlEleLeft: ctrlEleLeft,
        netWorkInfoWidth: netWorkInfoWidth,
        keyboardInputLeft: keyboardInputLeft,
        keyboardInputTop: keyboardInputTop,
        keyboardInputWidth: keyboardInputWidth
      };
      this.setDomElementPosition(positionParams);
    }
  }, {
    key: "update",
    value: function update(orientation, displayBox, currentDisplay) {
      this.orientation = orientation;
      this.displayBox = displayBox;
      this.currentDisplay = currentDisplay;
      this.change();
    }
  }, {
    key: "change",
    value: function change() {
      if (!this.orientation || !this.displayBox) {
        return;
      }

      // 旋转前需要先取消旋转，避免叠加旋转
      this.cancelTransform();
      if (this.options.isMobile) {
        var _window;
        var deviceOrientation = ((_window = window) === null || _window === void 0 || (_window = _window.screen) === null || _window === void 0 || (_window = _window.orientation) === null || _window === void 0 ? void 0 : _window.angle) || window.orientation;
        if ([_commonConfig.DEVICE_ORIENTATION_ANGLES.PORTRAIT, _commonConfig.DEVICE_ORIENTATION_ANGLES.REVERSE_PORTRAIT].includes(deviceOrientation)) {
          this.portraitMobile();
        } else if ([_commonConfig.DEVICE_ORIENTATION_ANGLES.LANDSCAPE, _commonConfig.DEVICE_ORIENTATION_ANGLES.REVERSE_LANDSCAPE].includes(deviceOrientation)) {
          this.landscapeMobile();
        }
      } else {
        this.portraitPc();
      }
    }
  }, {
    key: "patchChange",
    value: function patchChange() {
      var _this = this;
      this.displayBox = this.touchHandler.displayBox;
      setTimeout(function () {
        _this.change();
        // 更新mobile时canvas画面
        _this.changeMobileCanvas();
      }, 100);
    }
  }, {
    key: "cancelTransform",
    value: function cancelTransform() {
      if (this.keyboardInputContent && !this.options.isMobile) {
        this.keyboardInputContent.style.cssText = "\n          display: none;\n          position: absolute;\n          bottom: 5px;\n          left: 0px;\n          height: 40px;\n          width: 100%;\n          ";
      }
      if (true) {
        return;
      }
      this.messageModal.style.cssText = normalCssText;
      this.exitModal.style.cssText = normalCssText;
      this.netWorkInfo.style.cssText = "\n            pointer-events: none;\n            position: absolute;\n            top: 0px;\n            height: 40px;\n            line-height: 40px;\n            text-align: center;\n            width: 100%;\n            color: #3AC295;\n        ";
      this.buttonModal.style.cssText = "\n            display: none;\n            width: 255px;\n            height: 175px;\n            position: absolute;\n            z-index: 999;\n            top: 50%;\n            left: 50%;\n            background-color: rgba(0, 0, 0, 0.4);\n            border-radius: 5px;\n            transform: translate(-50%, -50%);\n        ";
      var left = (this.containerEle.clientWidth - this.displayBox.width) / 2 + this.ctrlEle.clientWidth / 2;
      var top = (this.containerEle.clientHeight - this.displayBox.height) / 2 + this.netWorkInfo.clientHeight * 2.5;
      this.ctrlEle.style.top = "".concat(top, "px");
      this.ctrlEle.style.left = "".concat(left, "px");
      this.ctrlEle.style.transform = 'none';
    }
  }, {
    key: "updateCanvasSize",
    value: function updateCanvasSize(orientation, isMSE) {
      var _this$options$mediaCo, _this$options$mediaCo2;
      console.log(isMSE, this.options.isMobile);
      if (isMSE || this.options.isMobile) {
        return;
      }

      // PC上canvas大小需要调整
      var containerEle = document.getElementById(this.options.containerId);
      var playContainerEle = document.getElementById("".concat(this.options.playerContainerId));
      playContainerEle.style.display = 'inline-block';
      var canvasElement = playContainerEle.shadowRoot.querySelector('#playCanvas');
      var playerHeight = null;
      var playerWidth = null;
      var innerHeight = window.innerHeight;
      if (orientation === _protocolConfig.default.ORIENTATION[0]) {
        // 竖屏
        playerHeight = containerEle && containerEle.clientHeight;
        if (playerHeight > innerHeight * 0.8) {
          playerHeight = containerEle && containerEle.clientWidth;
        }
        playerWidth = playerHeight * _commonConfig.CLOUD_PHONE_RATIO;
        canvasElement.style.margin = '0 auto';
      } else {
        // 如果画面已经显示正常，就不执行
        var currentTop = parseInt(window.getComputedStyle(canvasElement).marginTop);
        if (currentTop > 0) {
          return;
        }
        // 横屏
        playerWidth = containerEle && containerEle.clientHeight;
        playerHeight = playerWidth / _commonConfig.CLOUD_PHONE_RATIO;
      }
      var playContainer = document.querySelector('article');
      canvasElement.style.height = playContainer.style.height;
      canvasElement.width = ((_this$options$mediaCo = this.options.mediaConfig) === null || _this$options$mediaCo === void 0 ? void 0 : _this$options$mediaCo.width) || 720;
      canvasElement.height = ((_this$options$mediaCo2 = this.options.mediaConfig) === null || _this$options$mediaCo2 === void 0 ? void 0 : _this$options$mediaCo2.height) || 1280;
    }
  }, {
    key: "updateMobileCanvasSize",
    value: function updateMobileCanvasSize(orientation, isMSE) {
      this.orientation = orientation;
      this.isMSE = isMSE;
      this.changeMobileCanvas();
    }
  }, {
    key: "changeMobileCanvas",
    value: function changeMobileCanvas() {
      var _this2 = this;
      if (!this.orientation || this.isMSE) {
        return;
      }
      var playContainerEle = document.getElementById("".concat(this.options.playerContainerId));
      playContainerEle.style.display = 'inline-block';
      if (!playContainerEle.shadowRoot) {
        return;
      }
      var canvasElement = playContainerEle.shadowRoot.querySelector('#playCanvas');
      var playerHeight = null;
      var playerWidth = null;
      setTimeout(function () {
        var _window2, _this2$options$mediaC, _this2$options$mediaC2;
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;
        var deviceOrientation = ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.screen) === null || _window2 === void 0 || (_window2 = _window2.orientation) === null || _window2 === void 0 ? void 0 : _window2.angle) || window.orientation;
        if ([_commonConfig.DEVICE_ORIENTATION_ANGLES.PORTRAIT, _commonConfig.DEVICE_ORIENTATION_ANGLES.REVERSE_PORTRAIT].includes(deviceOrientation)) {
          if ([_protocolConfig.default.ORIENTATION[0], _protocolConfig.default.ORIENTATION[16]].includes(_this2.orientation)) {
            if (_this2.options.keepRatio) {
              playerWidth = width;
              playerHeight = width / _commonConfig.CLOUD_PHONE_RATIO;
              if (playerHeight > height) {
                playerWidth = height * _commonConfig.CLOUD_PHONE_RATIO;
                playerHeight = height;
              }
            } else {
              playerWidth = width;
              playerHeight = height;
            }
          } else if ([_protocolConfig.default.ORIENTATION[8], _protocolConfig.default.ORIENTATION[24]].includes(_this2.orientation)) {
            playerWidth = width * _commonConfig.CLOUD_PHONE_RATIO;
            playerHeight = width;
          }
        } else if ([_commonConfig.DEVICE_ORIENTATION_ANGLES.LANDSCAPE, _commonConfig.DEVICE_ORIENTATION_ANGLES.REVERSE_LANDSCAPE].includes(deviceOrientation)) {
          if ([_protocolConfig.default.ORIENTATION[0], _protocolConfig.default.ORIENTATION[16]].includes(_this2.orientation)) {
            playerHeight = height;
            playerWidth = height * _commonConfig.CLOUD_PHONE_RATIO;
          } else if ([_protocolConfig.default.ORIENTATION[8], _protocolConfig.default.ORIENTATION[24]].includes(_this2.orientation)) {
            if (_this2.options.keepRatio) {
              playerHeight = width;
              playerWidth = width * _commonConfig.CLOUD_PHONE_RATIO;
            } else {
              playerHeight = width;
              playerWidth = height;
            }
          }
        }
        canvasElement.style.width = playerWidth + 'px';
        canvasElement.style.height = playerHeight + 'px';
        canvasElement.width = ((_this2$options$mediaC = _this2.options.mediaConfig) === null || _this2$options$mediaC === void 0 ? void 0 : _this2$options$mediaC.width) || 720;
        canvasElement.height = ((_this2$options$mediaC2 = _this2.options.mediaConfig) === null || _this2$options$mediaC2 === void 0 ? void 0 : _this2$options$mediaC2.height) || 1280;
      }, 200);
    }
  }]);
}();
var _default = exports.default = DirectionHandler;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(14);
__webpack_require__(42);
__webpack_require__(13);
__webpack_require__(12);
__webpack_require__(15);
__webpack_require__(99);
__webpack_require__(74);
__webpack_require__(30);
__webpack_require__(33);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(21);
__webpack_require__(16);
__webpack_require__(17);
var _Util = _interopRequireDefault(__webpack_require__(26));
var _protocolConfig = _interopRequireDefault(__webpack_require__(32));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var KeyboardListener = exports.default = /*#__PURE__*/function () {
  function KeyboardListener(containerId, msgHandler) {
    _classCallCheck(this, KeyboardListener);
    this.containerId = containerId;
    this.msgHandler = msgHandler;
    this.keyEventCodeType = _protocolConfig.default.KEYEVENT_KEYCODE_TYPE;
    this.util = new _Util.default();
    this.touchHandler = null;
  }
  return _createClass(KeyboardListener, [{
    key: "start",
    value: function start(touchHandler) {
      this.touchHandler = touchHandler;
      this.util.bind(this.input, 'keydown', this.onKeydown.bind(this));
      this.util.bind(this.input, 'keypress', this.onKeypress.bind(this));
    }

    // 粘贴内容到云手机
  }, {
    key: "pasteToCloud",
    value: function () {
      var _pasteToCloud = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var clipboardData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return navigator.clipboard.readText();
            case 2:
              clipboardData = _context.sent;
              if (clipboardData) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              this.sendClipboardData(clipboardData);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function pasteToCloud() {
        return _pasteToCloud.apply(this, arguments);
      }
      return pasteToCloud;
    }()
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      // 触发subscribe的keydown事件，用于重置无操作计时器
      if (this.subscribe) {
        this.subscribe.trigger('keydown');
      }
      var isCtrlOrCommandPressed = event.ctrlKey || event.metaKey;
      if (isCtrlOrCommandPressed) {
        // 判断是否按下了V键
        var isVPressed = event.key === 'v' || event.key === 'V';
        if (isVPressed) {
          this.pasteToCloud();
          return;
        }

        // const isCopy = event.key === 'c' || event.key === 'C'
        // if (isCopy) {
        //   this.touchHandler.sendKeyCodeEventMsg(
        //     PROTOCOL_CONFIG.KEYEVENT_KEYCODE_TYPE.ACTION_DOWN,
        //     113
        //   )
        //   this.touchHandler.sendKeyCodeEventMsg(
        //     PROTOCOL_CONFIG.KEYEVENT_KEYCODE_TYPE.ACTION_UP,
        //     113
        //   )

        //   return
        // }
      }
      if (_protocolConfig.default.PC_KEY_MAP[event.keyCode]) {
        this.touchHandler.sendKeyCodeEventMsg(_protocolConfig.default.KEYEVENT_KEYCODE_TYPE.ACTION_DOWN, _protocolConfig.default.PC_KEY_MAP[event.keyCode]);
        this.touchHandler.sendKeyCodeEventMsg(_protocolConfig.default.KEYEVENT_KEYCODE_TYPE.ACTION_UP, _protocolConfig.default.PC_KEY_MAP[event.keyCode]);
      }
    }
  }, {
    key: "onKeypress",
    value: function onKeypress(event) {
      // 触发subscribe的keydown事件，用于重置无操作计时器
      if (this.subscribe) {
        this.subscribe.trigger('keydown');
      }
      if (_protocolConfig.default.PC_KEY_PRESS_MAP[event.keyCode]) {
        this.touchHandler.sendKeyCodeEventMsg(_protocolConfig.default.KEYEVENT_KEYCODE_TYPE.ACTION_DOWN, _protocolConfig.default.PC_KEY_PRESS_MAP[event.keyCode]);
        this.touchHandler.sendKeyCodeEventMsg(_protocolConfig.default.KEYEVENT_KEYCODE_TYPE.ACTION_UP, _protocolConfig.default.PC_KEY_PRESS_MAP[event.keyCode]);
      }
    }
  }, {
    key: "sendClipboardData",
    value: function sendClipboardData(clipboardData) {
      var textType = _protocolConfig.default.KEYBOARD_INPUT_MSG_TYPE.IME_PASTE_FROM_PC_SDK;
      var msgType = 'KEYBOARD_INPUT';
      var PACKAGE_HEADER_LENGTH = 8;
      var INPUT_HEADER_LENGTH = 3;
      var msgData = this.util.encodeUTF8(clipboardData);
      var cmdBuf = new Uint8Array(PACKAGE_HEADER_LENGTH + INPUT_HEADER_LENGTH + msgData.length);
      cmdBuf[0] = 90;
      cmdBuf[1] = 90;
      cmdBuf[2] = 180 + _protocolConfig.default.MSG_TYPE[msgType];
      cmdBuf[3] = _protocolConfig.default.MSG_TYPE[msgType];
      cmdBuf[4] = INPUT_HEADER_LENGTH + msgData.length >> 24;
      cmdBuf[5] = INPUT_HEADER_LENGTH + msgData.length >> 16;
      cmdBuf[6] = INPUT_HEADER_LENGTH + msgData.length >> 8;
      cmdBuf[7] = INPUT_HEADER_LENGTH + msgData.length;
      cmdBuf[8] = textType;
      cmdBuf[9] = msgData.length >> 8;
      cmdBuf[10] = msgData.length;
      cmdBuf.set(msgData, PACKAGE_HEADER_LENGTH + INPUT_HEADER_LENGTH);
      this.msgHandler(cmdBuf);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.util.unbind(this.input, 'keydown');
      this.util.unbind(this.input, 'keypress');
    }
  }]);
}();

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var hw_0x1931=['defaultCameraId','touchstart','microPhoneOutputType','cloudView.play\x20方法不存在','close','onSensorPkg','serverCenter','keydown','onUltraVires','setCameraDevice','destroy','msg','orientation','sendKeyFrameCallback','symbol','push','prototype','log','onOrientationPkg','netStateChange','defineProperty','CAMERA_MESSAGE_TYPE','topSubscribe','feed','onConnectFail','length','send','/phonemanager-api','onAudioPkg','key','DIS_CONNECTED','linkMethod','object','cloudView','sendInputClipper','VOLUME_UP','setScreenOrientation','cameraMsgHeader','sendKeyCodeMsg','isMobile','clientDelayReps','play','cloudMap','__esModule','_listenPhoneEvent','subscribe','delay','writable','linkCount','callbacks','constructor','status','getCloudsByPhoneIds','onInitSuccess','SCRIPT_VOLUME_UP','disconnectPhone','sessionCreate','_handleNoOperationTimeout','CONNECTING','keys','call','noOperationTimeout','clipboardDataChange','isAutoRotate','KEYCODE_BACK','stopMicroStream','audioPlayer','CONNECTED','sendShakeData','NODE','sessionRefresh','getClouds','onNoOperationTimeout','CUSTOM_CLOUD_STATUS','menu','isMSE','connectPhone','sensorProcessResp','default','handleStartPreviewReq','map','LINK_METHOD','setToken','setMicroDevice','value','setVolume','KEYCODE_APP_SWITCH','_resetNoOperationTimer','toPrimitive','sendMsg','updateResolutionAndTouch','setDefaultCamera','authUri','includes','Cannot\x20call\x20a\x20class\x20as\x20a\x20function','initPlayer','function','phoneId','volumeDown','onInitFail','sendAccelerometerData','isKeyFrame','onConnectSuccess','reduce','onClientDelayReps','containerId','createSession','hasMax','autoRotate','iterator','handleSensorEnable','setServerToken','onHeartBeatPkg','trigger','onRenderedFirstFrame','requestIFrame','noOperationTimer','onRotatePlayer','stopPhone','startPhone','microPhoneProcessResp','libPath','volumeUp','handleSensorDisable','refreshTouch','media_config','string','handleStopPreviewReq','sendGyroscopeData','stopCameraStream','CMD_CONTROL','serverToken','home','onStoped','sendInputString','onHeartBeatReps','onAuthFailure','onUpdateStatus','deviceHardwareHandler','updateStatus','forEach','OPUS','makeActionMsg','options','pkgBody','cameraPlayer','now'];(function(_0x548d36,_0x19317d){var _0x22689f=function(_0x45806d){while(--_0x45806d){_0x548d36['push'](_0x548d36['shift']());}};_0x22689f(++_0x19317d);}(hw_0x1931,0x1c7));var hw_0x2268=function(_0x548d36,_0x19317d){_0x548d36=_0x548d36-0x0;var _0x22689f=hw_0x1931[_0x548d36];return _0x22689f;};'use strict';/* javascript-obfuscator:disable */
__webpack_require__(13);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(14);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(12);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(15);var hw_0x45806d={};hw_0x45806d[hw_0x2268('0x46')]=!![];/* javascript-obfuscator:enable */
Object['defineProperty'](exports,'__esModule',hw_0x45806d);exports[hw_0x2268('0x40')]=void 0x0;/* javascript-obfuscator:disable */
__webpack_require__(29);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(55);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(56);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(46);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(17);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(16);/* javascript-obfuscator:enable */
var _ServerCenter=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(248));/* javascript-obfuscator:enable */
var _DirectCenter=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(257));/* javascript-obfuscator:enable */
var _Subscribe=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(88));/* javascript-obfuscator:enable */
var _nodeServerConfig=/* javascript-obfuscator:disable */
__webpack_require__(106);/* javascript-obfuscator:enable */
var _cloud=/* javascript-obfuscator:disable */
__webpack_require__(369);/* javascript-obfuscator:enable */
var _Util=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(26));/* javascript-obfuscator:enable */
var _protocolConfig=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(32));/* javascript-obfuscator:enable */
var _CloudView=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(370));/* javascript-obfuscator:enable */
function _interopRequireDefault(_0x596a4b){return _0x596a4b&&_0x596a4b[hw_0x2268('0x1d')]?_0x596a4b:{'default':_0x596a4b};}function _typeof(_0x34ef7f){'@babel/helpers\x20-\x20typeof';return _typeof=hw_0x2268('0x52')==typeof Symbol&&hw_0x2268('0x0')==typeof Symbol[hw_0x2268('0x5f')]?function(_0x5a255a){return typeof _0x5a255a;}:function(_0x32abb6){return _0x32abb6&&'function'==typeof Symbol&&_0x32abb6[hw_0x2268('0x24')]===Symbol&&_0x32abb6!==Symbol[hw_0x2268('0x2')]?hw_0x2268('0x0'):typeof _0x32abb6;},_typeof(_0x34ef7f);}function _classCallCheck(_0xe29bf2,_0x5b94db){if(!(_0xe29bf2 instanceof _0x5b94db))throw new TypeError(hw_0x2268('0x50'));}function _defineProperties(_0x3f2bc6,_0x15741e){for(var _0x427eb3=0x0;_0x427eb3<_0x15741e[hw_0x2268('0xb')];_0x427eb3++){var _0x1ca515=_0x15741e[_0x427eb3];_0x1ca515['enumerable']=_0x1ca515['enumerable']||!0x1,_0x1ca515['configurable']=!0x0,hw_0x2268('0x46')in _0x1ca515&&(_0x1ca515[hw_0x2268('0x21')]=!0x0),Object[hw_0x2268('0x6')](_0x3f2bc6,_toPropertyKey(_0x1ca515['key']),_0x1ca515);}}function _createClass(_0x94afc6,_0x347c27,_0x95a321){var _0x5c8dd1={};_0x5c8dd1[hw_0x2268('0x21')]=!0x1;return _0x347c27&&_defineProperties(_0x94afc6[hw_0x2268('0x2')],_0x347c27),_0x95a321&&_defineProperties(_0x94afc6,_0x95a321),Object[hw_0x2268('0x6')](_0x94afc6,hw_0x2268('0x2'),_0x5c8dd1),_0x94afc6;}function _toPropertyKey(_0xf109a8){var _0x7bc0d8=_toPrimitive(_0xf109a8,hw_0x2268('0x70'));return'symbol'==_typeof(_0x7bc0d8)?_0x7bc0d8:_0x7bc0d8+'';}function _toPrimitive(_0x44e25a,_0x1551bb){if(hw_0x2268('0x12')!=_typeof(_0x44e25a)||!_0x44e25a)return _0x44e25a;var _0x3dd328=_0x44e25a[Symbol[hw_0x2268('0x4a')]];if(void 0x0!==_0x3dd328){var _0x18c758=_0x3dd328[hw_0x2268('0x2e')](_0x44e25a,_0x1551bb||'default');if(hw_0x2268('0x12')!=_typeof(_0x18c758))return _0x18c758;throw new TypeError('@@toPrimitive\x20must\x20return\x20a\x20primitive\x20value.');}return(hw_0x2268('0x70')===_0x1551bb?String:Number)(_0x44e25a);}var cameraMsgType=_protocolConfig[hw_0x2268('0x40')][hw_0x2268('0x7')];var JhSdk=function(){function _0x5625ad(_0x572526){_classCallCheck(this,_0x5625ad);this[hw_0x2268('0x81')]=_0x572526;this[hw_0x2268('0x1c')]={};this[hw_0x2268('0x92')]=![];this['options'][hw_0x2268('0x6b')]=this[hw_0x2268('0x81')][hw_0x2268('0x6b')]||_Util['default']['getConfig'][hw_0x2268('0x6b')];this['options'][hw_0x2268('0x4e')]=this[hw_0x2268('0x81')][hw_0x2268('0x4e')]||hw_0x2268('0xd');this[hw_0x2268('0x81')]['linkMethod']=this[hw_0x2268('0x81')]['linkMethod']||_nodeServerConfig[hw_0x2268('0x43')]['NODE'];this[hw_0x2268('0x66')]=null;this['_init']();}var _0xef3487={};_0xef3487['key']='_init';_0xef3487['value']=function _0x1506c6(){var _0x348089=this;var _0x189609=this[hw_0x2268('0x81')];this[hw_0x2268('0x1f')]=new _Subscribe[(hw_0x2268('0x40'))]([hw_0x2268('0x27'),hw_0x2268('0x55'),hw_0x2268('0x58'),hw_0x2268('0xa'),hw_0x2268('0x65'),hw_0x2268('0x7a'),hw_0x2268('0x8d'),hw_0x2268('0x67'),hw_0x2268('0x5'),'clipboardDataChange','onUpdateStatus',hw_0x2268('0x64'),hw_0x2268('0x86'),'keydown']);this[hw_0x2268('0x81')][hw_0x2268('0x8')]=this[hw_0x2268('0x1f')];this[hw_0x2268('0x49')]=function(){if(_0x348089[hw_0x2268('0x66')]){clearTimeout(_0x348089[hw_0x2268('0x66')]);}if(_0x348089['options'][hw_0x2268('0x2f')]<=0x0){return;}_0x348089[hw_0x2268('0x66')]=setTimeout(function(){_0x348089[hw_0x2268('0x2b')]();},_0x348089[hw_0x2268('0x81')][hw_0x2268('0x2f')]);};this[hw_0x2268('0x2b')]=function(){var _0x246ceb=Object['keys'](_0x348089[hw_0x2268('0x1c')]);if(_0x246ceb['length']>0x0){_0x348089[hw_0x2268('0x68')](_0x246ceb);var _0x435c6d=_0x189609['callbacks'];if('onNoOperationTimeout'in _0x435c6d){_0x435c6d===null||_0x435c6d===void 0x0||_0x435c6d[hw_0x2268('0x3a')]();}}};this[hw_0x2268('0x1f')]['on'](hw_0x2268('0x86'),function(){_0x348089[hw_0x2268('0x49')]();});this[hw_0x2268('0x1f')]['on'](hw_0x2268('0x8c'),function(){_0x348089[hw_0x2268('0x49')]();});this[hw_0x2268('0x1f')]['on']('onConnectSuccess',function(_0x11714f){var _0x160b20=_0x189609[hw_0x2268('0x23')];if(hw_0x2268('0x58')in _0x160b20){_0x160b20===null||_0x160b20===void 0x0||_0x160b20[hw_0x2268('0x58')]();}_0x348089[hw_0x2268('0x49')]();});this['subscribe']['on'](hw_0x2268('0x67'),function(_0x1fafc4,_0x204aed){var _0xd3d7ab=_0x204aed['orientation'];var _0x1ec675=_0x189609[hw_0x2268('0x23')];if(hw_0x2268('0x67')in _0x1ec675){_0x1ec675===null||_0x1ec675===void 0x0||_0x1ec675['onRotatePlayer'](_0xd3d7ab);}});this[hw_0x2268('0x1f')]['on']('clipboardDataChange',function(_0x258083,_0x5b97af){var _0xbbebb6=_0x189609['callbacks'];if(hw_0x2268('0x30')in _0xbbebb6){_0xbbebb6===null||_0xbbebb6===void 0x0||_0xbbebb6[hw_0x2268('0x30')](_0x5b97af);}});this['subscribe']['on'](hw_0x2268('0x27'),function(_0x4e3331){var _0x2ef527=_0x189609[hw_0x2268('0x23')];if(hw_0x2268('0x27')in _0x2ef527){_0x2ef527===null||_0x2ef527===void 0x0||_0x2ef527[hw_0x2268('0x27')]();}});this[hw_0x2268('0x1f')]['on'](hw_0x2268('0x55'),function(_0x4c9a9c){var _0x4e1abb=_0x189609[hw_0x2268('0x23')];if('onInitFail'in _0x4e1abb){_0x4e1abb===null||_0x4e1abb===void 0x0||_0x4e1abb[hw_0x2268('0x55')]();}});this[hw_0x2268('0x1f')]['on'](hw_0x2268('0xa'),function(_0x5b3ebc,_0x483d1e){var _0x1b54ba=_0x483d1e[hw_0x2268('0x22')],_0x4a39b7=_0x483d1e[hw_0x2268('0x5d')];var _0x9b8d6d=_0x189609['callbacks'];if(hw_0x2268('0xa')in _0x9b8d6d){_0x9b8d6d===null||_0x9b8d6d===void 0x0||_0x9b8d6d[hw_0x2268('0xa')](_0x1b54ba,_0x4a39b7);}});this[hw_0x2268('0x1f')]['on'](hw_0x2268('0x65'),function(_0x1a8b77,_0x215c48){var _0x35c738=_0x215c48[hw_0x2268('0x53')];_0x348089[hw_0x2268('0x8b')]['requestIFrame'](_0x35c738);});this[hw_0x2268('0x1f')]['on'](hw_0x2268('0x7a'),function(_0x519ed0){var _0x51f1d2=_0x189609['callbacks'];if(hw_0x2268('0x7a')in _0x51f1d2){_0x51f1d2===null||_0x51f1d2===void 0x0||_0x51f1d2[hw_0x2268('0x7a')]();}var _0x4899a8=Object['keys'](_0x348089[hw_0x2268('0x1c')])[hw_0x2268('0x42')](function(_0xf73d71){return _0xf73d71;});_0x348089[hw_0x2268('0x8b')][hw_0x2268('0x29')](_0x4899a8);_0x348089[hw_0x2268('0x8b')][hw_0x2268('0x89')]();if(hw_0x2268('0x77')in _0x51f1d2){_0x51f1d2===null||_0x51f1d2===void 0x0||_0x51f1d2[hw_0x2268('0x77')]();}});this[hw_0x2268('0x1f')]['on'](hw_0x2268('0x8d'),function(_0x376028,_0x408467){var _0x57c269=_0x408467['phoneIds'],_0x4aa6ac=_0x408467[hw_0x2268('0x90')];var _0x2c560a=_0x189609[hw_0x2268('0x23')];if('onUltraVires'in _0x2c560a){_0x2c560a===null||_0x2c560a===void 0x0||_0x2c560a['onUltraVires'](_0x57c269,_0x4aa6ac);}});this[hw_0x2268('0x1f')]['on'](hw_0x2268('0x5'),function(_0x117afe,_0x452bb6){var _0x159c74=_0x452bb6[hw_0x2268('0x20')],_0x330411=_0x452bb6['bitrate'];var _0x5edbf5=_0x189609[hw_0x2268('0x23')];if(hw_0x2268('0x5')in _0x5edbf5){_0x5edbf5===null||_0x5edbf5===void 0x0||_0x5edbf5['netStateChange'](_0x159c74,_0x330411);}});this[hw_0x2268('0x1f')]['on'](hw_0x2268('0x64'),function(_0x12edb8){var _0x2eecfe=_0x189609[hw_0x2268('0x23')];if(hw_0x2268('0x64')in _0x2eecfe){_0x2eecfe===null||_0x2eecfe===void 0x0||_0x2eecfe[hw_0x2268('0x64')]();}});this['subscribe']['on'](hw_0x2268('0x7b'),function(_0x1b657a,_0x1464ba){var _0x2c4dec=_0x1464ba['phoneId'],_0x40376a=_0x1464ba['status'];var _0xfa2423=_0x189609['callbacks'];if(hw_0x2268('0x7b')in _0xfa2423){_0xfa2423===null||_0xfa2423===void 0x0||_0xfa2423[hw_0x2268('0x7b')](_0x2c4dec,_0x40376a);}});if(this['options'][hw_0x2268('0x11')]==_nodeServerConfig[hw_0x2268('0x43')][hw_0x2268('0x37')]){this['serverCenter']=new _ServerCenter[(hw_0x2268('0x40'))](_0x189609);this[hw_0x2268('0x61')](_0x189609[hw_0x2268('0x75')]);}else{this[hw_0x2268('0x8b')]=new _DirectCenter[(hw_0x2268('0x40'))](_0x189609);}};var _0x45497b={};_0x45497b[hw_0x2268('0xf')]=hw_0x2268('0x39');_0x45497b[hw_0x2268('0x46')]=function _0x5c6666(_0x5da23b){var _0x5e79a8=this;return Object[hw_0x2268('0x2d')](this[hw_0x2268('0x1c')])[hw_0x2268('0x59')](function(_0x384949,_0x56bc8c){if(!_0x5da23b||_0x5da23b===_0x56bc8c)_0x384949[hw_0x2268('0x1')](_0x5e79a8[hw_0x2268('0x1c')][_0x56bc8c][hw_0x2268('0x13')]);return _0x384949;},[]);};var _0x107b90={};_0x107b90['key']=hw_0x2268('0x26');_0x107b90['value']=function _0x10be71(_0x27ab4){var _0x3a302b=this;return Object['keys'](this[hw_0x2268('0x1c')])['reduce'](function(_0x39720d,_0x47c2a0){if(!_0x27ab4||_0x27ab4[hw_0x2268('0x4f')](_0x47c2a0))_0x39720d[hw_0x2268('0x1')](_0x3a302b[hw_0x2268('0x1c')][_0x47c2a0][hw_0x2268('0x13')]);return _0x39720d;},[]);};var _0x39dfef={};_0x39dfef['key']=hw_0x2268('0x61');_0x39dfef['value']=function _0x5aeb12(_0xe5e4ba){this[hw_0x2268('0x8b')][hw_0x2268('0x44')](_0xe5e4ba);};var _0x885340={};_0x885340['key']=hw_0x2268('0x1e');_0x885340[hw_0x2268('0x46')]=function _0x5af89f(_0x490d99){var _0x3a4104,_0xadb161=this;var _0x4342af=(_0x3a4104=this[hw_0x2268('0x1c')][_0x490d99])===null||_0x3a4104===void 0x0?void 0x0:_0x3a4104[hw_0x2268('0x13')];if(!_0x4342af)return;this['serverCenter'][hw_0x2268('0x7d')](function(_0x964134,_0x1054af){if(_0x490d99!=_0x964134)return;var _0x39a652={};_0x39a652[hw_0x2268('0x53')]=_0x964134;_0x39a652[hw_0x2268('0x25')]=_0x1054af;_0xadb161['subscribe'][hw_0x2268('0x63')](hw_0x2268('0x7b'),_0x39a652);switch(_0x1054af){case _nodeServerConfig[hw_0x2268('0x3b')][hw_0x2268('0x35')]:_0x4342af[hw_0x2268('0x51')]();_0x4342af['bindAction']();break;case _nodeServerConfig[hw_0x2268('0x3b')][hw_0x2268('0x10')]:break;case _nodeServerConfig[hw_0x2268('0x3b')][hw_0x2268('0x2c')]:break;case _nodeServerConfig[hw_0x2268('0x3b')]['DIS_CONNECTING']:}});var _0x264755=Date[hw_0x2268('0x84')]();this[hw_0x2268('0x8b')]['onMsg'](function(_0x58cf7e,_0x57b42f){if(_0x490d99!=_0x58cf7e)return;if(_0x4342af&&typeof _0x4342af[hw_0x2268('0x1b')]===hw_0x2268('0x52')){_0x4342af[hw_0x2268('0x1b')](_0x57b42f);if(!_0xadb161[hw_0x2268('0x92')]&&!_Util[hw_0x2268('0x40')][hw_0x2268('0x57')](_0x57b42f)){_0xadb161['options'][hw_0x2268('0x8')][hw_0x2268('0x63')]('onRenderedFirstFrame');_0xadb161[hw_0x2268('0x92')]=!![];}}else{console[hw_0x2268('0x3')](hw_0x2268('0x88'));}});var _0x1a34c2=function _0x6f4925(_0x197938,_0x51c358){if(_0x490d99!=_0x197938)return;var _0x4ac475=_0x51c358[hw_0x2268('0x17')],_0x199d84=_0x51c358['cameraMsgBody'];switch(_0x4ac475['optType']){case cameraMsgType['OPT_CAMERA_START_PREVIEW_REQ']:_0x4342af['deviceHardwareHandler'][hw_0x2268('0x41')](_0x199d84,_0x4ac475);break;case cameraMsgType['OPT_CAMERA_STOP_PREVIEW_REQ']:_0x4342af['deviceHardwareHandler'][hw_0x2268('0x71')](_0x4ac475);break;}};this[hw_0x2268('0x8b')]['onCameraPkg'](function(_0xe8fdd1,_0x116ebe){_0x1a34c2(_0xe8fdd1,_0x116ebe);});this[hw_0x2268('0x8b')][hw_0x2268('0xe')](function(_0x29b98b,_0x1606ed){if(_0x490d99!=_0x29b98b)return;_0x1606ed&&_0x4342af[hw_0x2268('0x34')][hw_0x2268('0x9')](_0x1606ed);});var _0x367318=!![];this[hw_0x2268('0x8b')][hw_0x2268('0x4')](function(_0x441ce1,_0x3a7eb0){if(_0x490d99!=_0x441ce1)return;var _0x3d709a=_0x3a7eb0[hw_0x2268('0x91')],_0x50811b=_0x3a7eb0[hw_0x2268('0x82')];if(_0x4342af[hw_0x2268('0x81')][hw_0x2268('0x31')]){_0x4342af[hw_0x2268('0x4c')](_0x3d709a);}var _0x238ea8={};_0x238ea8[hw_0x2268('0x91')]=_0x3d709a;_0xadb161[hw_0x2268('0x1f')]['trigger'](hw_0x2268('0x67'),_0x238ea8);});this['serverCenter'][hw_0x2268('0x8a')](function(_0x433a4a,_0x54d6ed){if(_0x490d99!=_0x433a4a)return;_0x54d6ed&&_0x4342af[hw_0x2268('0x3f')](_0x54d6ed);});this[hw_0x2268('0x8b')]['onMicroPhonePkg'](function(_0x35be1c,_0x385a5c){if(_0x490d99!=_0x35be1c)return;_0x385a5c&&_0x4342af[hw_0x2268('0x6a')](_0x385a5c);});this[hw_0x2268('0x8b')][hw_0x2268('0x62')](function(_0x30041d,_0x3ac058,_0x16631a){if(_0x490d99!=_0x30041d)return;_0x3ac058&&_0x4342af['heartBeatPkgResp'](_0x3ac058,_0x16631a);});this[hw_0x2268('0x8b')][hw_0x2268('0x79')](function(_0x35fafe,_0xf03f95){if(_0x490d99!=_0x35fafe)return;_0x4342af['heartBeatReps'](_0xf03f95);});this[hw_0x2268('0x8b')][hw_0x2268('0x5a')](function(_0x2426c1){_0x4342af[hw_0x2268('0x1a')](_0x2426c1);});this[hw_0x2268('0x8b')]['onKeyboardInputPkg'](function(_0x41e99c,_0x4665e7,_0x5bfccf){if(_0x490d99!=_0x41e99c)return;_0x4665e7&&_0x4342af['keyboardInputPkgResp'](_0x4665e7,_0x5bfccf);});};var _0x24918b={};_0x24918b[hw_0x2268('0xf')]=hw_0x2268('0x16');_0x24918b[hw_0x2268('0x46')]=function _0xd90cee(_0x53115d,_0x3c87f9){var _0x2d7ba2=this[hw_0x2268('0x26')](_0x53115d);_0x2d7ba2[hw_0x2268('0x7e')](function(_0x3338bc){_0x3338bc[hw_0x2268('0x4c')](_0x3c87f9);});};var _0xa0e5a1={};_0xa0e5a1[hw_0x2268('0xf')]=hw_0x2268('0x69');_0xa0e5a1[hw_0x2268('0x46')]=function _0x2943ef(_0x3dc2e0,_0x199bb1){var _0x457042,_0x4afce6,_0x240ce7=this;this[hw_0x2268('0x8b')][hw_0x2268('0x3e')]([_0x199bb1],![]);this['isMSE']=![];var _0xba95c2={};_0xba95c2[hw_0x2268('0x5b')]=_0x3dc2e0;_0xba95c2[hw_0x2268('0x53')]=_0x199bb1[hw_0x2268('0x53')];_0xba95c2[hw_0x2268('0x6b')]=this[hw_0x2268('0x81')][hw_0x2268('0x6b')];_0xba95c2[hw_0x2268('0x87')]=hw_0x2268('0x7f');_0xba95c2[hw_0x2268('0x3d')]=this[hw_0x2268('0x3d')];_0xba95c2[hw_0x2268('0x8')]=this[hw_0x2268('0x1f')];_0xba95c2[hw_0x2268('0x5e')]=_0x199bb1['autoRotate'];_0xba95c2[hw_0x2268('0x31')]=(_0x457042=_0x199bb1[hw_0x2268('0x31')])!==null&&_0x457042!==void 0x0?_0x457042:!![];_0xba95c2['keepRatio']=(_0x4afce6=_0x199bb1['keepRatio'])!==null&&_0x4afce6!==void 0x0?_0x4afce6:![];_0xba95c2[hw_0x2268('0x19')]=/(iPhone|iPad|iPod|iOS|Android)/i['test'](navigator['userAgent']);_0xba95c2[hw_0x2268('0x11')]=this[hw_0x2268('0x81')][hw_0x2268('0x11')];_0xba95c2[hw_0x2268('0xc')]=function _0x5c9e54(_0x575727){_0x240ce7['serverCenter'][hw_0x2268('0x4b')](_0x199bb1['phoneId'],_0x575727);};var _0x12a013=_0xba95c2;this[hw_0x2268('0x1c')][_0x199bb1[hw_0x2268('0x53')]]={'cloudView':new _CloudView[(hw_0x2268('0x40'))](_0x12a013),'connectInfo':_0x199bb1};this[hw_0x2268('0x1e')](_0x199bb1[hw_0x2268('0x53')]);if(_0x199bb1['hasOwnProperty'](hw_0x2268('0x2f'))){this[hw_0x2268('0x81')]['noOperationTimeout']=Number(_0x199bb1[hw_0x2268('0x2f')])*0x3e8;}else{this[hw_0x2268('0x81')][hw_0x2268('0x2f')]=0x0;}this[hw_0x2268('0x49')]();};var _0x4ab927={};_0x4ab927[hw_0x2268('0xf')]=hw_0x2268('0x68');_0x4ab927[hw_0x2268('0x46')]=function _0x5dd6af(_0x3a8c1b){var _0x276491=this;var _0x142be3=this[hw_0x2268('0x26')](_0x3a8c1b);this[hw_0x2268('0x8b')][hw_0x2268('0x29')](_0x3a8c1b);_0x142be3[hw_0x2268('0x7e')](function(_0x40f4ae){_0x40f4ae[hw_0x2268('0x8f')]();if(_0x276491[hw_0x2268('0x1c')][_0x40f4ae[hw_0x2268('0x81')][hw_0x2268('0x53')]]){delete _0x276491[hw_0x2268('0x1c')][_0x40f4ae['options'][hw_0x2268('0x53')]];}});if(Object[hw_0x2268('0x2d')](this['cloudMap'])[hw_0x2268('0xb')]===0x0){if(this[hw_0x2268('0x66')]){clearTimeout(this['noOperationTimer']);this[hw_0x2268('0x66')]=null;console['log'](this['options']['noOperationTimeout']/0x3e8+'秒无操作,主动断开连接');}this[hw_0x2268('0x8b')][hw_0x2268('0x89')]();}};var _0x94b653={};_0x94b653[hw_0x2268('0xf')]=hw_0x2268('0x76');_0x94b653[hw_0x2268('0x46')]=function _0x44eae5(_0x5b2f9d){var _0x5acac0=this[hw_0x2268('0x26')](_0x5b2f9d);_0x5acac0[hw_0x2268('0x7e')](function(_0x454d8b){_0x454d8b[hw_0x2268('0x18')]('KEYCODE_HOME');});};var _0x45dbd2={};_0x45dbd2[hw_0x2268('0xf')]=hw_0x2268('0x6c');_0x45dbd2['value']=function _0x4dacf6(_0x34b1ea){var _0x162166=this['getCloudsByPhoneIds'](_0x34b1ea);_0x162166[hw_0x2268('0x7e')](function(_0x3ce82f){_0x3ce82f[hw_0x2268('0x18')](hw_0x2268('0x15'));_0x3ce82f[hw_0x2268('0x18')](hw_0x2268('0x28'));});};var _0x27c708={};_0x27c708['key']=hw_0x2268('0x54');_0x27c708[hw_0x2268('0x46')]=function _0x41ab9a(_0x15ea1a){var _0x282382=this[hw_0x2268('0x26')](_0x15ea1a);_0x282382[hw_0x2268('0x7e')](function(_0x3cf96a){_0x3cf96a[hw_0x2268('0x18')]('VOLUME_DOWN');_0x3cf96a[hw_0x2268('0x18')]('SCRIPT_VOLUME_DOWN');});};var _0x296726={};_0x296726[hw_0x2268('0xf')]=hw_0x2268('0x60');_0x296726[hw_0x2268('0x46')]=function _0x57ee97(_0x363b53){var _0x389cc6=this['getCloudsByPhoneIds'](_0x363b53);_0x389cc6[hw_0x2268('0x7e')](function(_0x4a05f2){_0x4a05f2['handleSensorEnable']();});};var _0x3a9d10={};_0x3a9d10[hw_0x2268('0xf')]=hw_0x2268('0x6d');_0x3a9d10[hw_0x2268('0x46')]=function _0x47adc5(_0x5333e0){var _0x1f4b72=this['getCloudsByPhoneIds'](_0x5333e0);_0x1f4b72[hw_0x2268('0x7e')](function(_0x50a117){_0x50a117[hw_0x2268('0x6d')]();});};var _0x5bfc5f={};_0x5bfc5f[hw_0x2268('0xf')]=hw_0x2268('0x36');_0x5bfc5f[hw_0x2268('0x46')]=function _0x4e24ef(_0x2fca18,_0x20b207){var _0x55ad09=this[hw_0x2268('0x26')](_0x2fca18);_0x55ad09[hw_0x2268('0x7e')](function(_0xd2e1d8){_0xd2e1d8[hw_0x2268('0x36')](_0x20b207);});};var _0x548042={};_0x548042[hw_0x2268('0xf')]=hw_0x2268('0x56');_0x548042[hw_0x2268('0x46')]=function _0x3d4dbe(_0x2ee462,_0x30e4af){var _0x5695a5=this['getCloudsByPhoneIds'](_0x2ee462);_0x5695a5[hw_0x2268('0x7e')](function(_0x50ef67){_0x50ef67[hw_0x2268('0x56')](_0x30e4af);});};var _0x2cd6a3={};_0x2cd6a3['key']=hw_0x2268('0x72');_0x2cd6a3[hw_0x2268('0x46')]=function _0x30f52b(_0x22ec4b,_0x1032b7){var _0x3b22bb=this[hw_0x2268('0x26')](_0x22ec4b);_0x3b22bb[hw_0x2268('0x7e')](function(_0x4a94a9){_0x4a94a9[hw_0x2268('0x72')](_0x1032b7);});};var _0x53613f={};_0x53613f[hw_0x2268('0xf')]='back';_0x53613f[hw_0x2268('0x46')]=function _0x1abca8(_0x2ecfa5){var _0x4d93f2=this['getCloudsByPhoneIds'](_0x2ecfa5);_0x4d93f2[hw_0x2268('0x7e')](function(_0x294627){_0x294627['sendKeyCodeMsg'](hw_0x2268('0x32'));});};var _0x4d147b={};_0x4d147b[hw_0x2268('0xf')]=hw_0x2268('0x3c');_0x4d147b[hw_0x2268('0x46')]=function _0x481ab1(_0x2c8bc5){var _0x4c9960=this[hw_0x2268('0x26')](_0x2c8bc5);_0x4c9960['forEach'](function(_0x2ef96a){_0x2ef96a[hw_0x2268('0x18')](hw_0x2268('0x48'));});};var _0x3a7d35={};_0x3a7d35[hw_0x2268('0xf')]=hw_0x2268('0x78');_0x3a7d35[hw_0x2268('0x46')]=function _0x201949(_0x5e7d92,_0x1ffdf1){var _0x33e14b=this[hw_0x2268('0x39')](_0x1ffdf1);_0x33e14b[hw_0x2268('0x7e')](function(_0x1690d0){_0x1690d0[hw_0x2268('0x78')](_0x5e7d92);});};var _0x3a22a8={};_0x3a22a8[hw_0x2268('0xf')]='setStreamConfig';_0x3a22a8[hw_0x2268('0x46')]=function _0x3ed1fc(_0x30bd37,_0x237723){var _0xc51959={};_0xc51959[hw_0x2268('0x6f')]=_0x30bd37;var _0x4a2932=_Util[hw_0x2268('0x40')][hw_0x2268('0x80')](hw_0x2268('0x74'),'SET_MEDIA_CONFIG',_0xc51959);var _0x4608ec=this['getClouds'](_0x237723);_0x4608ec[hw_0x2268('0x7e')](function(_0x10dca1){_0x10dca1[hw_0x2268('0x81')][hw_0x2268('0xc')](_0x4a2932);});};var _0xd5b9f4={};_0xd5b9f4[hw_0x2268('0xf')]=hw_0x2268('0x8e');_0xd5b9f4[hw_0x2268('0x46')]=function _0x9aabd(_0x45a512,_0x2e40df){var _0xe51128=this[hw_0x2268('0x39')](_0x2e40df);_0xe51128['forEach'](function(_0x26be12){var _0x11b4c6;(_0x11b4c6=_0x26be12[hw_0x2268('0x7c')])===null||_0x11b4c6===void 0x0||_0x11b4c6[hw_0x2268('0x4d')](_0x45a512);});};var _0x20dcfc={};_0x20dcfc['key']=hw_0x2268('0x73');_0x20dcfc[hw_0x2268('0x46')]=function _0x62f97b(_0x356d73){var _0x36cf88=this[hw_0x2268('0x39')](_0x356d73);_0x36cf88[hw_0x2268('0x7e')](function(_0x1a2ed6){if(_0x1a2ed6[hw_0x2268('0x7c')]){var _0x11e7a4;_0x1a2ed6[hw_0x2268('0x7c')][hw_0x2268('0x85')]='';(_0x11e7a4=_0x1a2ed6['deviceHardwareHandler'][hw_0x2268('0x83')])===null||_0x11e7a4===void 0x0||_0x11e7a4['stopCameraVideo']();}});};var _0x525259={};_0x525259[hw_0x2268('0xf')]=hw_0x2268('0x47');_0x525259[hw_0x2268('0x46')]=function _0x3e9111(_0x33478f,_0x209ba5){var _0x5f716c=this[hw_0x2268('0x26')](_0x33478f);_0x5f716c[hw_0x2268('0x7e')](function(_0x5c79cd){_0x5c79cd[hw_0x2268('0x47')](_0x209ba5);});};var _0x313d48={};_0x313d48[hw_0x2268('0xf')]='refreshTouch';_0x313d48[hw_0x2268('0x46')]=function _0x41790b(_0x5065ab){var _0x58d065=this['getCloudsByPhoneIds'](_0x5065ab);_0x58d065['forEach'](function(_0x302b06){_0x302b06[hw_0x2268('0x6e')]();});};var _0x4c985b={};_0x4c985b[hw_0x2268('0xf')]=hw_0x2268('0x14');_0x4c985b['value']=function _0x198a9d(){};var _0x5dbaa5={};_0x5dbaa5['key']='audioPauseOrResume';_0x5dbaa5[hw_0x2268('0x46')]=function _0x16025f(_0x2c427c){};var _0x365cd1={};_0x365cd1[hw_0x2268('0xf')]=hw_0x2268('0x45');_0x365cd1[hw_0x2268('0x46')]=function _0x401d69(_0x32bfb0){};var _0x8f6835={};_0x8f6835[hw_0x2268('0xf')]=hw_0x2268('0x33');_0x8f6835[hw_0x2268('0x46')]=function _0x3d2fb2(){};var _0x376093={};_0x376093[hw_0x2268('0xf')]=hw_0x2268('0x5c');_0x376093[hw_0x2268('0x46')]=function _0x3e091c(_0x5de540){return(0x0,_cloud[hw_0x2268('0x2a')])(_0x5de540);};var _0x3079ff={};_0x3079ff[hw_0x2268('0xf')]=hw_0x2268('0x38');_0x3079ff['value']=function _0x36aca2(_0x3a5360){return(0x0,_cloud[hw_0x2268('0x38')])(_0x3a5360);};return _createClass(_0x5625ad,[_0xef3487,_0x45497b,_0x107b90,_0x39dfef,_0x885340,_0x24918b,_0xa0e5a1,_0x4ab927,_0x94b653,_0x45dbd2,_0x27c708,_0x296726,_0x3a9d10,_0x5bfc5f,_0x548042,_0x2cd6a3,_0x53613f,_0x4d147b,_0x3a7d35,_0x3a22a8,_0xd5b9f4,_0x20dcfc,_0x525259,_0x313d48,_0x4c985b,_0x5dbaa5,_0x365cd1,_0x8f6835],[_0x376093,_0x3079ff]);}();var _default=exports[hw_0x2268('0x40')]=JhSdk;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(97)('native-function-to-string', Function.toString);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(69);
var descriptor = __webpack_require__(66);
var setToStringTag = __webpack_require__(70);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(36)(IteratorPrototype, __webpack_require__(20)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(28);
var anObject = __webpack_require__(22);
var getKeys = __webpack_require__(62);

module.exports = __webpack_require__(25) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(242);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(23);
var isArray = __webpack_require__(158);
var SPECIES = __webpack_require__(20)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(23);
var anObject = __webpack_require__(22);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(44)(Function.call, __webpack_require__(72).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(18);
var defined = __webpack_require__(53);
var fails = __webpack_require__(24);
var spaces = __webpack_require__(245);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(62);
var gOPS = __webpack_require__(98);
var pIE = __webpack_require__(86);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(45);
var gOPN = __webpack_require__(73).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var hw_0x1e42=['protocol','CONNECTED','hasOwnProperty','iterator','root','Generator\x20is\x20already\x20running','onTouch','type','pop','values','symbol','object','_sent','push','onMsg','serverMap','cmd','fps','CAS_CONNECT_SUCCESS','exit','reset','mainPhoneId','phoneId','onMicroPhonePkg','onOrientationPkg','value','CAS_RECONNECTING','appController','CLOUD_HEARTBEAT_RSP','heartBeatPkgCbs','UN_CONNECT','decode','tryEntries','CLOUD_ORIENTATION_PKG','arg','stop','screenshotLinkFailCb','call','subarray','snapshotCbs','toPrimitive','_disconnectSnapshot','h264','onHeartBeatReps','afterLoc','_spreadScreenshot','subscribe','CONNECTING','hasTransfer','CAS_CONNECT_LOST','stringify','onVideo','media_config','default','delegate','suspendedStart','cloudDisconnectCb','enumerable','next','clientDelayRspCbs','AsyncIterator','charAt','code','complete','reduce','updateStatusCbs','wrap','RESPONSE_CODE','bitRate','MAX_CONNCENT_COUNT','CAS_RECONNECT_SUCCESS','microPhonePkgCbs','apply','clientNetworkInfo','completion','onAuthFailure','CONNECT','serverToken','length','@@iterator','name','mark','mute','updateStatus','delay','recvRsp','__await','screenshotLinkCb','ULTRA_VIRES','CUSTOM_CLOUD_STATUS','data','connectURI','asyncIterator','connectCount','DIS_CONNECTED','onSensorPkg','closeReq','unMsg','easyLink','setToken','timestamp','_spreadStatus','__proto__','sensorPkgCbs','writable','CAS_RESOURCE_IN_USING','@@asyncIterator','linkCount','onClientDelayReps','token','illegal\x20catch\x20attempt','string','then','SEND_SCREENSHOT','sessionId','clear','wss','kbitCount','screenshotStatus','time','REQUEST_I_FRAME','function','createSocket','onConnectFail','channel','onUpdateStatus','CLOUD_STATUS_CODE','heartbeatRspCbs','displayName','phoneIds','prototype','onUltraVires','configurable','shift','tryLoc','SEND_FRAME','finallyLoc','_onScreenshotMessage','rval','appStateChange','slice','CLOUD_COPY_TEXT','sendTimesMaxCount','status','normal','demo.jinhaokj.com.cn/sdk-ws','toStringTag','UPDATE_STATUS','orientationPkgCbs','defineProperty','onInitSuccess','sendReq','DISCONNECT','HEART_BEAT','closeRsp','pkg','catchLoc','topSubscribe','nextLoc','sendHeartBeat','CLOUD_HANDLE','msgCbs','onHeartBeatPkg','done','resolve','CLOUD_DISCONNECT','return','close','onCameraPkg','options','[object\x20Generator]','getUint32','sendSnapshot','audioPkgCbs','requestIFrame','parse','connectPhone','create','suspendedYield','dispatchException','bitrate','CAS_SERVER_UNREACHABLE','_invoke','Cannot\x20call\x20a\x20class\x20as\x20a\x20function','@@toPrimitive\x20must\x20return\x20a\x20primitive\x20value.','postMessage','GeneratorFunction','isInitStage','terminate','sendMsg','setGroupPhone','now','addEventListener','stream_width','base64','@babel/helpers\x20-\x20typeof','keys','buffer','throw','iterator\x20result\x20is\x20not\x20an\x20object','frame','onSnapshot','forEach','initReq','continue','openRsp','state','onConnectSuccess','CLOUD_MICROPHONE_PKG','msg','onInitFail','isGeneratorFunction','\x20is\x20not\x20iterable','try\x20statement\x20without\x20catch\x20or\x20finally','sent','CLOUD_AUDIO_PKG','clipboardDataChange','reverse','snapshotMap','method','buf','accessIp','prev','onMessage','frame_type','heartBeatSendTimes','keyboardInputPkgCbs','trigger','constructor','abrupt','REQUEST_CODE','CLOUD_HEARTBEAT_PKG','needHeatBeat','key','end','awrap','screenshotWs','resultName','physical_height','getPrototypeOf','async','cameraPkgCbs'];(function(_0x4fcf85,_0x1e428c){var _0x2b2f15=function(_0xb77640){while(--_0xb77640){_0x4fcf85['push'](_0x4fcf85['shift']());}};_0x2b2f15(++_0x1e428c);}(hw_0x1e42,0x1b3));var hw_0x2b2f=function(_0x4fcf85,_0x1e428c){_0x4fcf85=_0x4fcf85-0x0;var _0x2b2f15=hw_0x1e42[_0x4fcf85];return _0x2b2f15;};'use strict';/* javascript-obfuscator:disable */
__webpack_require__(13);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(12);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(15);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(99);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(74);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(30);var hw_0xb77640={};hw_0xb77640[hw_0x2b2f('0x4a')]=!![];/* javascript-obfuscator:enable */
Object['defineProperty'](exports,'__esModule',hw_0xb77640);exports['default']=void 0x0;/* javascript-obfuscator:disable */
__webpack_require__(21);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(33);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(14);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(42);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(29);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(31);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(16);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(17);/* javascript-obfuscator:enable */
var _Util=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(26));/* javascript-obfuscator:enable */
var _Subscribe=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(88));/* javascript-obfuscator:enable */
var _webworkifyWebpack=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(63));/* javascript-obfuscator:enable */
var _nodeServerConfig=/* javascript-obfuscator:disable */
__webpack_require__(106);/* javascript-obfuscator:enable */
function _interopRequireDefault(_0x294b45){return _0x294b45&&_0x294b45['__esModule']?_0x294b45:{'default':_0x294b45};}function _typeof(_0x33c0e4){hw_0x2b2f('0x2');return _typeof=hw_0x2b2f('0xaa')==typeof Symbol&&hw_0x2b2f('0x3b')==typeof Symbol[hw_0x2b2f('0x34')]?function(_0x3c8030){return typeof _0x3c8030;}:function(_0x35577a){return _0x35577a&&hw_0x2b2f('0xaa')==typeof Symbol&&_0x35577a['constructor']===Symbol&&_0x35577a!==Symbol[hw_0x2b2f('0xb3')]?hw_0x2b2f('0x3b'):typeof _0x35577a;},_typeof(_0x33c0e4);}function _regeneratorRuntime(){'use strict';_regeneratorRuntime=function _0xaf5018(){return _0x10f959;};var _0x48ef46,_0x10f959={},_0x335917=Object[hw_0x2b2f('0xb3')],_0x2fac52=_0x335917[hw_0x2b2f('0x33')],_0x5c3daa=Object[hw_0x2b2f('0xc6')]||function(_0x2d6d1a,_0x1301f6,_0x347bfa){_0x2d6d1a[_0x1301f6]=_0x347bfa['value'];},_0x22fa98=hw_0x2b2f('0xaa')==typeof Symbol?Symbol:{},_0x2f34fc=_0x22fa98[hw_0x2b2f('0x34')]||hw_0x2b2f('0x80'),_0x3205a1=_0x22fa98[hw_0x2b2f('0x8d')]||hw_0x2b2f('0x9b'),_0x97bab8=_0x22fa98[hw_0x2b2f('0xc3')]||'@@toStringTag';function _0x44340a(_0x382fc5,_0x2f6024,_0x30b92e){var _0x3976b5={};_0x3976b5['value']=_0x30b92e;_0x3976b5[hw_0x2b2f('0x6a')]=!0x0;_0x3976b5[hw_0x2b2f('0xb5')]=!0x0;_0x3976b5[hw_0x2b2f('0x99')]=!0x0;return Object[hw_0x2b2f('0xc6')](_0x382fc5,_0x2f6024,_0x3976b5),_0x382fc5[_0x2f6024];}try{_0x44340a({},'');}catch(_0x72e7a){_0x44340a=function _0x1d5dc5(_0x30b37a,_0x551fcc,_0x4b6fb1){return _0x30b37a[_0x551fcc]=_0x4b6fb1;};}function _0x4106ab(_0x40567b,_0x5ce6bd,_0x135f6a,_0x3cdb00){var _0x278e6c=_0x5ce6bd&&_0x5ce6bd[hw_0x2b2f('0xb3')]instanceof _0x21e9b0?_0x5ce6bd:_0x21e9b0,_0x238480=Object[hw_0x2b2f('0xe2')](_0x278e6c[hw_0x2b2f('0xb3')]),_0x2213cc=new _0x4e57b9(_0x3cdb00||[]);var _0x53da2c={};_0x53da2c[hw_0x2b2f('0x4a')]=_0x476c03(_0x40567b,_0x135f6a,_0x2213cc);return _0x5c3daa(_0x238480,hw_0x2b2f('0xe7'),_0x53da2c),_0x238480;}function _0x1f7e35(_0x4d2d4b,_0x475261,_0x136165){try{var _0x24fb68={};_0x24fb68[hw_0x2b2f('0x38')]=hw_0x2b2f('0xc1');_0x24fb68[hw_0x2b2f('0x53')]=_0x4d2d4b[hw_0x2b2f('0x56')](_0x475261,_0x136165);return _0x24fb68;}catch(_0x8f1f91){var _0x453601={};_0x453601[hw_0x2b2f('0x38')]='throw';_0x453601['arg']=_0x8f1f91;return _0x453601;}}_0x10f959[hw_0x2b2f('0x73')]=_0x4106ab;var _0x38805e=hw_0x2b2f('0x68'),_0x4bfca5=hw_0x2b2f('0xe3'),_0x4f15c5='executing',_0x286487='completed',_0x30a7f7={};function _0x21e9b0(){}function _0x2d298c(){}function _0x3b1ccb(){}var _0x4dbdb3={};_0x44340a(_0x4dbdb3,_0x2f34fc,function(){return this;});var _0x119a81=Object[hw_0x2b2f('0x2e')],_0x2750d4=_0x119a81&&_0x119a81(_0x119a81(_0x44c9ee([])));_0x2750d4&&_0x2750d4!==_0x335917&&_0x2fac52[hw_0x2b2f('0x56')](_0x2750d4,_0x2f34fc)&&(_0x4dbdb3=_0x2750d4);var _0x3e31c3=_0x3b1ccb['prototype']=_0x21e9b0['prototype']=Object[hw_0x2b2f('0xe2')](_0x4dbdb3);function _0x5ca70d(_0xab0119){['next','throw',hw_0x2b2f('0xd7')][hw_0x2b2f('0x9')](function(_0x5e5e4b){_0x44340a(_0xab0119,_0x5e5e4b,function(_0x31ebdc){return this[hw_0x2b2f('0xe7')](_0x5e5e4b,_0x31ebdc);});});}function _0x3287fe(_0x5d1a33,_0x17481a){function _0x54388d(_0x2c7fc3,_0x4bfe5c,_0x38b8db,_0x5bb973){var _0x59b4fa=_0x1f7e35(_0x5d1a33[_0x2c7fc3],_0x5d1a33,_0x4bfe5c);if(hw_0x2b2f('0x5')!==_0x59b4fa[hw_0x2b2f('0x38')]){var _0x143a0e=_0x59b4fa[hw_0x2b2f('0x53')],_0x35160b=_0x143a0e[hw_0x2b2f('0x4a')];return _0x35160b&&hw_0x2b2f('0x3c')==_typeof(_0x35160b)&&_0x2fac52['call'](_0x35160b,hw_0x2b2f('0x87'))?_0x17481a['resolve'](_0x35160b[hw_0x2b2f('0x87')])[hw_0x2b2f('0xa1')](function(_0x32e017){_0x54388d(hw_0x2b2f('0x6b'),_0x32e017,_0x38b8db,_0x5bb973);},function(_0x495899){_0x54388d('throw',_0x495899,_0x38b8db,_0x5bb973);}):_0x17481a[hw_0x2b2f('0xd5')](_0x35160b)['then'](function(_0x2986a2){_0x143a0e[hw_0x2b2f('0x4a')]=_0x2986a2,_0x38b8db(_0x143a0e);},function(_0x44b008){return _0x54388d('throw',_0x44b008,_0x38b8db,_0x5bb973);});}_0x5bb973(_0x59b4fa['arg']);}var _0x4dfbfe;var _0x327ecc={};_0x327ecc[hw_0x2b2f('0x4a')]=function _0x2004ac(_0x5237fd,_0x1d39ce){function _0x33d39e(){return new _0x17481a(function(_0x27e2c6,_0x34aee1){_0x54388d(_0x5237fd,_0x1d39ce,_0x27e2c6,_0x34aee1);});}return _0x4dfbfe=_0x4dfbfe?_0x4dfbfe['then'](_0x33d39e,_0x33d39e):_0x33d39e();};_0x5c3daa(this,hw_0x2b2f('0xe7'),_0x327ecc);}function _0x476c03(_0x45a504,_0x540720,_0x1d8124){var _0x4ff156=_0x38805e;return function(_0xe41f31,_0x178ed8){if(_0x4ff156===_0x4f15c5)throw Error(hw_0x2b2f('0x36'));if(_0x4ff156===_0x286487){if(hw_0x2b2f('0x5')===_0xe41f31)throw _0x178ed8;var _0x383a35={};_0x383a35[hw_0x2b2f('0x4a')]=_0x48ef46;_0x383a35['done']=!0x0;return _0x383a35;}for(_0x1d8124[hw_0x2b2f('0x1a')]=_0xe41f31,_0x1d8124['arg']=_0x178ed8;;){var _0x5c7587=_0x1d8124[hw_0x2b2f('0x67')];if(_0x5c7587){var _0x57c3d7=_0x46f0d0(_0x5c7587,_0x1d8124);if(_0x57c3d7){if(_0x57c3d7===_0x30a7f7)continue;return _0x57c3d7;}}if('next'===_0x1d8124['method'])_0x1d8124[hw_0x2b2f('0x15')]=_0x1d8124[hw_0x2b2f('0x3d')]=_0x1d8124[hw_0x2b2f('0x53')];else if(hw_0x2b2f('0x5')===_0x1d8124[hw_0x2b2f('0x1a')]){if(_0x4ff156===_0x38805e)throw _0x4ff156=_0x286487,_0x1d8124['arg'];_0x1d8124[hw_0x2b2f('0xe4')](_0x1d8124['arg']);}else hw_0x2b2f('0xd7')===_0x1d8124['method']&&_0x1d8124['abrupt'](hw_0x2b2f('0xd7'),_0x1d8124[hw_0x2b2f('0x53')]);_0x4ff156=_0x4f15c5;var _0x1cac69=_0x1f7e35(_0x45a504,_0x540720,_0x1d8124);if(hw_0x2b2f('0xc1')===_0x1cac69[hw_0x2b2f('0x38')]){if(_0x4ff156=_0x1d8124[hw_0x2b2f('0xd4')]?_0x286487:_0x4bfca5,_0x1cac69['arg']===_0x30a7f7)continue;var _0x237eb9={};_0x237eb9[hw_0x2b2f('0x4a')]=_0x1cac69[hw_0x2b2f('0x53')];_0x237eb9[hw_0x2b2f('0xd4')]=_0x1d8124['done'];return _0x237eb9;}'throw'===_0x1cac69[hw_0x2b2f('0x38')]&&(_0x4ff156=_0x286487,_0x1d8124[hw_0x2b2f('0x1a')]='throw',_0x1d8124[hw_0x2b2f('0x53')]=_0x1cac69[hw_0x2b2f('0x53')]);}};}function _0x46f0d0(_0x58c2fc,_0x1640ab){var _0x1a3df4=_0x1640ab[hw_0x2b2f('0x1a')],_0x5d9055=_0x58c2fc[hw_0x2b2f('0x34')][_0x1a3df4];if(_0x5d9055===_0x48ef46)return _0x1640ab[hw_0x2b2f('0x67')]=null,hw_0x2b2f('0x5')===_0x1a3df4&&_0x58c2fc[hw_0x2b2f('0x34')]['return']&&(_0x1640ab[hw_0x2b2f('0x1a')]=hw_0x2b2f('0xd7'),_0x1640ab[hw_0x2b2f('0x53')]=_0x48ef46,_0x46f0d0(_0x58c2fc,_0x1640ab),hw_0x2b2f('0x5')===_0x1640ab[hw_0x2b2f('0x1a')])||'return'!==_0x1a3df4&&(_0x1640ab[hw_0x2b2f('0x1a')]=hw_0x2b2f('0x5'),_0x1640ab['arg']=new TypeError('The\x20iterator\x20does\x20not\x20provide\x20a\x20\x27'+_0x1a3df4+'\x27\x20method')),_0x30a7f7;var _0x11c792=_0x1f7e35(_0x5d9055,_0x58c2fc['iterator'],_0x1640ab[hw_0x2b2f('0x53')]);if(hw_0x2b2f('0x5')===_0x11c792[hw_0x2b2f('0x38')])return _0x1640ab[hw_0x2b2f('0x1a')]=hw_0x2b2f('0x5'),_0x1640ab[hw_0x2b2f('0x53')]=_0x11c792[hw_0x2b2f('0x53')],_0x1640ab[hw_0x2b2f('0x67')]=null,_0x30a7f7;var _0xb6e7db=_0x11c792[hw_0x2b2f('0x53')];return _0xb6e7db?_0xb6e7db[hw_0x2b2f('0xd4')]?(_0x1640ab[_0x58c2fc['resultName']]=_0xb6e7db[hw_0x2b2f('0x4a')],_0x1640ab['next']=_0x58c2fc[hw_0x2b2f('0xcf')],hw_0x2b2f('0xd7')!==_0x1640ab[hw_0x2b2f('0x1a')]&&(_0x1640ab[hw_0x2b2f('0x1a')]=hw_0x2b2f('0x6b'),_0x1640ab['arg']=_0x48ef46),_0x1640ab[hw_0x2b2f('0x67')]=null,_0x30a7f7):_0xb6e7db:(_0x1640ab[hw_0x2b2f('0x1a')]=hw_0x2b2f('0x5'),_0x1640ab[hw_0x2b2f('0x53')]=new TypeError(hw_0x2b2f('0x6')),_0x1640ab[hw_0x2b2f('0x67')]=null,_0x30a7f7);}function _0x459fc6(_0x332c77){var _0x3772c2={};_0x3772c2[hw_0x2b2f('0xb7')]=_0x332c77[0x0];var _0xd8f18d=_0x3772c2;0x1 in _0x332c77&&(_0xd8f18d[hw_0x2b2f('0xcd')]=_0x332c77[0x1]),0x2 in _0x332c77&&(_0xd8f18d[hw_0x2b2f('0xb9')]=_0x332c77[0x2],_0xd8f18d[hw_0x2b2f('0x5d')]=_0x332c77[0x3]),this[hw_0x2b2f('0x51')][hw_0x2b2f('0x3e')](_0xd8f18d);}function _0x462adc(_0x52aeab){var _0x57140c=_0x52aeab[hw_0x2b2f('0x7b')]||{};_0x57140c[hw_0x2b2f('0x38')]=hw_0x2b2f('0xc1'),delete _0x57140c[hw_0x2b2f('0x53')],_0x52aeab['completion']=_0x57140c;}function _0x4e57b9(_0x500e8a){var _0x33fef2={};_0x33fef2[hw_0x2b2f('0xb7')]=hw_0x2b2f('0x35');this[hw_0x2b2f('0x51')]=[_0x33fef2],_0x500e8a[hw_0x2b2f('0x9')](_0x459fc6,this),this[hw_0x2b2f('0x45')](!0x0);}function _0x44c9ee(_0x2a037d){if(_0x2a037d||''===_0x2a037d){var _0x5bc444=_0x2a037d[_0x2f34fc];if(_0x5bc444)return _0x5bc444['call'](_0x2a037d);if(hw_0x2b2f('0xaa')==typeof _0x2a037d[hw_0x2b2f('0x6b')])return _0x2a037d;if(!isNaN(_0x2a037d[hw_0x2b2f('0x7f')])){var _0x58eac4=-0x1,_0x510c3c=function _0x402fee(){for(;++_0x58eac4<_0x2a037d[hw_0x2b2f('0x7f')];)if(_0x2fac52[hw_0x2b2f('0x56')](_0x2a037d,_0x58eac4))return _0x402fee[hw_0x2b2f('0x4a')]=_0x2a037d[_0x58eac4],_0x402fee[hw_0x2b2f('0xd4')]=!0x1,_0x402fee;return _0x402fee['value']=_0x48ef46,_0x402fee[hw_0x2b2f('0xd4')]=!0x0,_0x402fee;};return _0x510c3c[hw_0x2b2f('0x6b')]=_0x510c3c;}}throw new TypeError(_typeof(_0x2a037d)+hw_0x2b2f('0x13'));}return _0x2d298c[hw_0x2b2f('0xb3')]=_0x3b1ccb,_0x5c3daa(_0x3e31c3,hw_0x2b2f('0x23'),{'value':_0x3b1ccb,'configurable':!0x0}),_0x5c3daa(_0x3b1ccb,hw_0x2b2f('0x23'),{'value':_0x2d298c,'configurable':!0x0}),_0x2d298c['displayName']=_0x44340a(_0x3b1ccb,_0x97bab8,hw_0x2b2f('0xeb')),_0x10f959[hw_0x2b2f('0x12')]=function(_0x5733b5){var _0xf88062=hw_0x2b2f('0xaa')==typeof _0x5733b5&&_0x5733b5[hw_0x2b2f('0x23')];return!!_0xf88062&&(_0xf88062===_0x2d298c||hw_0x2b2f('0xeb')===(_0xf88062[hw_0x2b2f('0xb1')]||_0xf88062[hw_0x2b2f('0x81')]));},_0x10f959[hw_0x2b2f('0x82')]=function(_0x1159bd){return Object['setPrototypeOf']?Object['setPrototypeOf'](_0x1159bd,_0x3b1ccb):(_0x1159bd[hw_0x2b2f('0x97')]=_0x3b1ccb,_0x44340a(_0x1159bd,_0x97bab8,hw_0x2b2f('0xeb'))),_0x1159bd['prototype']=Object[hw_0x2b2f('0xe2')](_0x3e31c3),_0x1159bd;},_0x10f959[hw_0x2b2f('0x2a')]=function(_0x29a2b8){var _0x46f4c0={};_0x46f4c0[hw_0x2b2f('0x87')]=_0x29a2b8;return _0x46f4c0;},_0x5ca70d(_0x3287fe['prototype']),_0x44340a(_0x3287fe[hw_0x2b2f('0xb3')],_0x3205a1,function(){return this;}),_0x10f959[hw_0x2b2f('0x6d')]=_0x3287fe,_0x10f959[hw_0x2b2f('0x2f')]=function(_0x3ed360,_0x5a97fe,_0x30148b,_0x117c70,_0x48ec16){void 0x0===_0x48ec16&&(_0x48ec16=Promise);var _0x2f14b3=new _0x3287fe(_0x4106ab(_0x3ed360,_0x5a97fe,_0x30148b,_0x117c70),_0x48ec16);return _0x10f959[hw_0x2b2f('0x12')](_0x5a97fe)?_0x2f14b3:_0x2f14b3[hw_0x2b2f('0x6b')]()[hw_0x2b2f('0xa1')](function(_0x47832f){return _0x47832f[hw_0x2b2f('0xd4')]?_0x47832f['value']:_0x2f14b3[hw_0x2b2f('0x6b')]();});},_0x5ca70d(_0x3e31c3),_0x44340a(_0x3e31c3,_0x97bab8,'Generator'),_0x44340a(_0x3e31c3,_0x2f34fc,function(){return this;}),_0x44340a(_0x3e31c3,'toString',function(){return hw_0x2b2f('0xdb');}),_0x10f959['keys']=function(_0x19ba47){var _0x56a1a7=Object(_0x19ba47),_0x1bd1d3=[];for(var _0x5cadff in _0x56a1a7)_0x1bd1d3[hw_0x2b2f('0x3e')](_0x5cadff);return _0x1bd1d3[hw_0x2b2f('0x18')](),function _0x226c58(){for(;_0x1bd1d3['length'];){var _0x433065=_0x1bd1d3[hw_0x2b2f('0x39')]();if(_0x433065 in _0x56a1a7)return _0x226c58[hw_0x2b2f('0x4a')]=_0x433065,_0x226c58['done']=!0x1,_0x226c58;}return _0x226c58[hw_0x2b2f('0xd4')]=!0x0,_0x226c58;};},_0x10f959[hw_0x2b2f('0x3a')]=_0x44c9ee,_0x4e57b9[hw_0x2b2f('0xb3')]={'constructor':_0x4e57b9,'reset':function _0xc05ebe(_0x187a71){if(this[hw_0x2b2f('0x1d')]=0x0,this[hw_0x2b2f('0x6b')]=0x0,this[hw_0x2b2f('0x15')]=this[hw_0x2b2f('0x3d')]=_0x48ef46,this[hw_0x2b2f('0xd4')]=!0x1,this[hw_0x2b2f('0x67')]=null,this['method']=hw_0x2b2f('0x6b'),this['arg']=_0x48ef46,this[hw_0x2b2f('0x51')]['forEach'](_0x462adc),!_0x187a71)for(var _0x5136c3 in this)'t'===_0x5136c3[hw_0x2b2f('0x6e')](0x0)&&_0x2fac52[hw_0x2b2f('0x56')](this,_0x5136c3)&&!isNaN(+_0x5136c3[hw_0x2b2f('0xbd')](0x1))&&(this[_0x5136c3]=_0x48ef46);},'stop':function _0x49417f(){this['done']=!0x0;var _0xa5604a=this[hw_0x2b2f('0x51')][0x0][hw_0x2b2f('0x7b')];if('throw'===_0xa5604a['type'])throw _0xa5604a['arg'];return this['rval'];},'dispatchException':function _0x1bd431(_0x1d7220){if(this['done'])throw _0x1d7220;var _0x5105b2=this;function _0x250598(_0x1bfe5c,_0x3d4bb3){return _0x49a489[hw_0x2b2f('0x38')]=hw_0x2b2f('0x5'),_0x49a489['arg']=_0x1d7220,_0x5105b2['next']=_0x1bfe5c,_0x3d4bb3&&(_0x5105b2['method']=hw_0x2b2f('0x6b'),_0x5105b2[hw_0x2b2f('0x53')]=_0x48ef46),!!_0x3d4bb3;}for(var _0x578308=this[hw_0x2b2f('0x51')][hw_0x2b2f('0x7f')]-0x1;_0x578308>=0x0;--_0x578308){var _0x480292=this[hw_0x2b2f('0x51')][_0x578308],_0x49a489=_0x480292[hw_0x2b2f('0x7b')];if(hw_0x2b2f('0x35')===_0x480292[hw_0x2b2f('0xb7')])return _0x250598(hw_0x2b2f('0x29'));if(_0x480292[hw_0x2b2f('0xb7')]<=this[hw_0x2b2f('0x1d')]){var _0x4c63f6=_0x2fac52[hw_0x2b2f('0x56')](_0x480292,hw_0x2b2f('0xcd')),_0x409b42=_0x2fac52[hw_0x2b2f('0x56')](_0x480292,hw_0x2b2f('0xb9'));if(_0x4c63f6&&_0x409b42){if(this[hw_0x2b2f('0x1d')]<_0x480292[hw_0x2b2f('0xcd')])return _0x250598(_0x480292[hw_0x2b2f('0xcd')],!0x0);if(this[hw_0x2b2f('0x1d')]<_0x480292[hw_0x2b2f('0xb9')])return _0x250598(_0x480292[hw_0x2b2f('0xb9')]);}else if(_0x4c63f6){if(this['prev']<_0x480292['catchLoc'])return _0x250598(_0x480292[hw_0x2b2f('0xcd')],!0x0);}else{if(!_0x409b42)throw Error(hw_0x2b2f('0x14'));if(this[hw_0x2b2f('0x1d')]<_0x480292['finallyLoc'])return _0x250598(_0x480292['finallyLoc']);}}}},'abrupt':function _0x373262(_0x211c4a,_0x1cecc0){for(var _0x161f0d=this[hw_0x2b2f('0x51')][hw_0x2b2f('0x7f')]-0x1;_0x161f0d>=0x0;--_0x161f0d){var _0xd16a67=this[hw_0x2b2f('0x51')][_0x161f0d];if(_0xd16a67[hw_0x2b2f('0xb7')]<=this[hw_0x2b2f('0x1d')]&&_0x2fac52[hw_0x2b2f('0x56')](_0xd16a67,hw_0x2b2f('0xb9'))&&this[hw_0x2b2f('0x1d')]<_0xd16a67[hw_0x2b2f('0xb9')]){var _0xe499bc=_0xd16a67;break;}}_0xe499bc&&('break'===_0x211c4a||hw_0x2b2f('0xb')===_0x211c4a)&&_0xe499bc[hw_0x2b2f('0xb7')]<=_0x1cecc0&&_0x1cecc0<=_0xe499bc[hw_0x2b2f('0xb9')]&&(_0xe499bc=null);var _0x3b5606=_0xe499bc?_0xe499bc[hw_0x2b2f('0x7b')]:{};return _0x3b5606[hw_0x2b2f('0x38')]=_0x211c4a,_0x3b5606[hw_0x2b2f('0x53')]=_0x1cecc0,_0xe499bc?(this[hw_0x2b2f('0x1a')]='next',this['next']=_0xe499bc['finallyLoc'],_0x30a7f7):this[hw_0x2b2f('0x70')](_0x3b5606);},'complete':function _0x4ca88e(_0x5b4437,_0x5ed850){if('throw'===_0x5b4437[hw_0x2b2f('0x38')])throw _0x5b4437[hw_0x2b2f('0x53')];return'break'===_0x5b4437[hw_0x2b2f('0x38')]||'continue'===_0x5b4437['type']?this[hw_0x2b2f('0x6b')]=_0x5b4437[hw_0x2b2f('0x53')]:'return'===_0x5b4437['type']?(this[hw_0x2b2f('0xbb')]=this[hw_0x2b2f('0x53')]=_0x5b4437['arg'],this[hw_0x2b2f('0x1a')]=hw_0x2b2f('0xd7'),this['next']='end'):hw_0x2b2f('0xc1')===_0x5b4437[hw_0x2b2f('0x38')]&&_0x5ed850&&(this['next']=_0x5ed850),_0x30a7f7;},'finish':function _0x42718e(_0x5d8eb5){for(var _0x126b83=this['tryEntries'][hw_0x2b2f('0x7f')]-0x1;_0x126b83>=0x0;--_0x126b83){var _0x4e1c83=this[hw_0x2b2f('0x51')][_0x126b83];if(_0x4e1c83[hw_0x2b2f('0xb9')]===_0x5d8eb5)return this[hw_0x2b2f('0x70')](_0x4e1c83[hw_0x2b2f('0x7b')],_0x4e1c83[hw_0x2b2f('0x5d')]),_0x462adc(_0x4e1c83),_0x30a7f7;}},'catch':function _0x38e724(_0x21771c){for(var _0x62f13e=this[hw_0x2b2f('0x51')]['length']-0x1;_0x62f13e>=0x0;--_0x62f13e){var _0x178a06=this[hw_0x2b2f('0x51')][_0x62f13e];if(_0x178a06[hw_0x2b2f('0xb7')]===_0x21771c){var _0x3ef7c9=_0x178a06[hw_0x2b2f('0x7b')];if(hw_0x2b2f('0x5')===_0x3ef7c9[hw_0x2b2f('0x38')]){var _0xa0f716=_0x3ef7c9['arg'];_0x462adc(_0x178a06);}return _0xa0f716;}}throw Error(hw_0x2b2f('0x9f'));},'delegateYield':function _0x3d9fcb(_0xd6a07d,_0x438004,_0x2efde5){var _0x57dd2a={};_0x57dd2a[hw_0x2b2f('0x34')]=_0x44c9ee(_0xd6a07d);_0x57dd2a[hw_0x2b2f('0x2c')]=_0x438004;_0x57dd2a['nextLoc']=_0x2efde5;return this[hw_0x2b2f('0x67')]=_0x57dd2a,hw_0x2b2f('0x6b')===this[hw_0x2b2f('0x1a')]&&(this['arg']=_0x48ef46),_0x30a7f7;}},_0x10f959;}function asyncGeneratorStep(_0x24960a,_0x4ec236,_0x3061f4,_0xee90ee,_0x553716,_0xebe588,_0xf3e325){try{var _0x59c2dd=_0x24960a[_0xebe588](_0xf3e325),_0x1fcfa4=_0x59c2dd[hw_0x2b2f('0x4a')];}catch(_0x556c39){return void _0x3061f4(_0x556c39);}_0x59c2dd[hw_0x2b2f('0xd4')]?_0x4ec236(_0x1fcfa4):Promise[hw_0x2b2f('0xd5')](_0x1fcfa4)[hw_0x2b2f('0xa1')](_0xee90ee,_0x553716);}function _asyncToGenerator(_0x2314a4){return function(){var _0x47d323=this,_0x1f0cbc=arguments;return new Promise(function(_0x4b6e14,_0xc71d74){var _0x31706f=_0x2314a4['apply'](_0x47d323,_0x1f0cbc);function _0x5cf1b8(_0x5292e5){asyncGeneratorStep(_0x31706f,_0x4b6e14,_0xc71d74,_0x5cf1b8,_0x3f4e52,hw_0x2b2f('0x6b'),_0x5292e5);}function _0x3f4e52(_0xfab538){asyncGeneratorStep(_0x31706f,_0x4b6e14,_0xc71d74,_0x5cf1b8,_0x3f4e52,hw_0x2b2f('0x5'),_0xfab538);}_0x5cf1b8(void 0x0);});};}function _classCallCheck(_0x1a47f1,_0x5dec55){if(!(_0x1a47f1 instanceof _0x5dec55))throw new TypeError(hw_0x2b2f('0xe8'));}function _defineProperties(_0x1dcc9e,_0x1a42af){for(var _0x5e3084=0x0;_0x5e3084<_0x1a42af[hw_0x2b2f('0x7f')];_0x5e3084++){var _0x4b41b4=_0x1a42af[_0x5e3084];_0x4b41b4[hw_0x2b2f('0x6a')]=_0x4b41b4[hw_0x2b2f('0x6a')]||!0x1,_0x4b41b4[hw_0x2b2f('0xb5')]=!0x0,hw_0x2b2f('0x4a')in _0x4b41b4&&(_0x4b41b4[hw_0x2b2f('0x99')]=!0x0),Object[hw_0x2b2f('0xc6')](_0x1dcc9e,_toPropertyKey(_0x4b41b4[hw_0x2b2f('0x28')]),_0x4b41b4);}}function _createClass(_0x4efb7c,_0x35d868,_0x5b555d){var _0x1891ea={};_0x1891ea['writable']=!0x1;return _0x35d868&&_defineProperties(_0x4efb7c[hw_0x2b2f('0xb3')],_0x35d868),_0x5b555d&&_defineProperties(_0x4efb7c,_0x5b555d),Object[hw_0x2b2f('0xc6')](_0x4efb7c,hw_0x2b2f('0xb3'),_0x1891ea),_0x4efb7c;}function _toPropertyKey(_0x3aeee6){var _0x527bdc=_toPrimitive(_0x3aeee6,'string');return hw_0x2b2f('0x3b')==_typeof(_0x527bdc)?_0x527bdc:_0x527bdc+'';}function _toPrimitive(_0x1e1a11,_0xdcf8c6){if(hw_0x2b2f('0x3c')!=_typeof(_0x1e1a11)||!_0x1e1a11)return _0x1e1a11;var _0x266fae=_0x1e1a11[Symbol[hw_0x2b2f('0x59')]];if(void 0x0!==_0x266fae){var _0x3063c0=_0x266fae[hw_0x2b2f('0x56')](_0x1e1a11,_0xdcf8c6||hw_0x2b2f('0x66'));if(hw_0x2b2f('0x3c')!=_typeof(_0x3063c0))return _0x3063c0;throw new TypeError(hw_0x2b2f('0xe9'));}return(hw_0x2b2f('0xa0')===_0xdcf8c6?String:Number)(_0x1e1a11);}var heartBeatInerval;var hw_0x1d98cd={};hw_0x1d98cd['protocol']=hw_0x2b2f('0xa5');hw_0x1d98cd[hw_0x2b2f('0x8c')]=hw_0x2b2f('0xc2');var defaultOptions=hw_0x1d98cd;var date=Date[hw_0x2b2f('0xf0')]();var ServerCenter=function(){function _0x214b7c(){var _0x4f0dee=this;var _0x47e216=arguments[hw_0x2b2f('0x7f')]>0x0&&arguments[0x0]!==undefined?arguments[0x0]:defaultOptions;_classCallCheck(this,_0x214b7c);this[hw_0x2b2f('0xda')]=_0x47e216;_0x47e216['protocol']=_0x47e216['protocol']||defaultOptions['protocol'];_0x47e216[hw_0x2b2f('0x8c')]=_0x47e216[hw_0x2b2f('0x8c')]||defaultOptions[hw_0x2b2f('0x8c')];this['mainPhoneId']='';this[hw_0x2b2f('0x40')]={};this[hw_0x2b2f('0xd2')]=[];this[hw_0x2b2f('0x72')]=[];this[hw_0x2b2f('0x58')]=[];this[hw_0x2b2f('0x30')]=[];this[hw_0x2b2f('0xde')]=[];this['orientationPkgCbs']=[];this[hw_0x2b2f('0x98')]=[];this[hw_0x2b2f('0x78')]=[];this[hw_0x2b2f('0x4e')]=[];this[hw_0x2b2f('0xb0')]=[];this[hw_0x2b2f('0x6c')]=[];this[hw_0x2b2f('0x21')]=[];this[hw_0x2b2f('0x2b')]=null;this[hw_0x2b2f('0xa7')]=_nodeServerConfig[hw_0x2b2f('0x8a')][hw_0x2b2f('0x4f')];this['screenshotLinkCb']=[];this[hw_0x2b2f('0x55')]=[];this[hw_0x2b2f('0x8e')]=0x0;var _0x56c2fe={};_0x56c2fe[hw_0x2b2f('0x20')]=[];_0x56c2fe[hw_0x2b2f('0xbf')]=0x4;_0x56c2fe[hw_0x2b2f('0x85')]=0x0;_0x56c2fe[hw_0x2b2f('0x75')]=0x0;_0x56c2fe[hw_0x2b2f('0xa6')]=0x0;_0x56c2fe['lastRefreshTime']=0x0;this[hw_0x2b2f('0x7a')]=_0x56c2fe;this['lastClientReceivingTime']=null;this['snapshotMap']={};this['cloudDisconnectCb']={};this[hw_0x2b2f('0x5f')]=new _Subscribe[(hw_0x2b2f('0x66'))]([hw_0x2b2f('0x1e'),hw_0x2b2f('0x37'),hw_0x2b2f('0xae'),hw_0x2b2f('0x64'),hw_0x2b2f('0xbc'),hw_0x2b2f('0x8'),hw_0x2b2f('0x17')]);this[hw_0x2b2f('0x5f')]['on'](hw_0x2b2f('0x64'),function(_0x3136d7,_0x43bdf3){var _0x197068=_0x43bdf3[hw_0x2b2f('0x47')],_0x4dd731=_0x43bdf3[hw_0x2b2f('0x10')];_0x4f0dee['msgCbs'][hw_0x2b2f('0x9')](function(_0x22a092){_0x22a092(_0x197068,_0x4dd731);});});this['subscribe']['on'](hw_0x2b2f('0xbc'),function(_0x11e78f,_0x69638a){var _0xfc7351=_0x69638a[hw_0x2b2f('0xd')];_0x4f0dee[hw_0x2b2f('0x96')](_0x69638a['phoneId'],_0xfc7351);});this[hw_0x2b2f('0xab')]();}var _0x1af882={};_0x1af882['key']=hw_0x2b2f('0xab');_0x1af882[hw_0x2b2f('0x4a')]=function _0xf7793f(){var _0x2190b5=this;if(this['screenshotWs']||this[hw_0x2b2f('0x8e')]>=_nodeServerConfig[hw_0x2b2f('0x76')])return;this['connectCount']++;this[hw_0x2b2f('0xec')]=!![];/* javascript-obfuscator:disable */
this.screenshotWs=(0,_webworkifyWebpack.default)(/*require.resolve*/(134));var socket=this.screenshotWs;var _0xb333ee={};_0xb333ee[hw_0x2b2f('0x31')]=this[hw_0x2b2f('0xda')][hw_0x2b2f('0x31')];_0xb333ee[hw_0x2b2f('0x8c')]=this['options']['connectURI'];_0xb333ee[hw_0x2b2f('0x27')]=![];var _0x4e6e15={};_0x4e6e15['cmd']=hw_0x2b2f('0xa');_0x4e6e15[hw_0x2b2f('0xda')]=_0xb333ee;/* javascript-obfuscator:enable */
socket['postMessage'](_0x4e6e15);socket[hw_0x2b2f('0xf1')]('message',function(_0x5ea2aa){var _0xf109d1=_0x5ea2aa[hw_0x2b2f('0x8b')];switch(_0xf109d1[hw_0x2b2f('0x41')]){case hw_0x2b2f('0xc'):_0x2190b5['screenshotStatus']=_nodeServerConfig[hw_0x2b2f('0x8a')][hw_0x2b2f('0x32')];_0x2190b5[hw_0x2b2f('0x8e')]=0x0;_0x2190b5[hw_0x2b2f('0xda')]['topSubscribe'][hw_0x2b2f('0x22')](hw_0x2b2f('0xc7'));_0x2190b5[hw_0x2b2f('0xec')]=![];_0x2190b5[hw_0x2b2f('0xd0')]();_0x2190b5['_screenshotLinkSuccess']();break;case'errorRsp':case hw_0x2b2f('0xcb'):if(heartBeatInerval)heartBeatInerval[hw_0x2b2f('0xa4')]();if(_0x2190b5['screenshotWs']){_0x2190b5[hw_0x2b2f('0x2b')][hw_0x2b2f('0xed')]();_0x2190b5[hw_0x2b2f('0x2b')]=null;}_0x2190b5[hw_0x2b2f('0xa7')]=_nodeServerConfig[hw_0x2b2f('0x8a')]['DIS_CONNECTED'];var _0x46c9b1=_0x2190b5['connectCount']>=_nodeServerConfig[hw_0x2b2f('0x76')];if(_0x2190b5['options']['linkMethod']==0x0&&!_0x46c9b1){_0x2190b5['screenshotStatus']=_nodeServerConfig[hw_0x2b2f('0x8a')][hw_0x2b2f('0x4f')];_0x2190b5[hw_0x2b2f('0xab')]();}else{_0x2190b5[hw_0x2b2f('0x55')][hw_0x2b2f('0x9')](function(_0x9ad62f){return _0x9ad62f();});_0x2190b5['screenshotLinkFailCb']=[];}if(_0x2190b5['isInitStage']){_0x2190b5[hw_0x2b2f('0xda')][hw_0x2b2f('0xce')]['trigger'](hw_0x2b2f('0x11'));}break;case hw_0x2b2f('0x86'):_0x2190b5[hw_0x2b2f('0xba')](_0xf109d1[hw_0x2b2f('0x1b')],_0xf109d1[hw_0x2b2f('0xa8')]);break;}});};var _0x16e2b6={};_0x16e2b6[hw_0x2b2f('0x28')]=hw_0x2b2f('0xdf');_0x16e2b6['value']=function _0x1eb9b8(_0x5025d9){var _0x4e0c6d=this[hw_0x2b2f('0x40')][_0x5025d9];if(_0x4e0c6d){_0x4e0c6d[hw_0x2b2f('0xad')][hw_0x2b2f('0x4c')]['requestIFrame']();return;}_0x4e0c6d=this[hw_0x2b2f('0x19')][_0x5025d9];if(_0x4e0c6d){var _0x13b740={};_0x13b740['code']=_nodeServerConfig[hw_0x2b2f('0x25')][hw_0x2b2f('0xa9')];_0x13b740[hw_0x2b2f('0x8b')]=_0x5025d9;this[hw_0x2b2f('0xdd')](_0x13b740);}};var _0x230f53={};_0x230f53[hw_0x2b2f('0x28')]=hw_0x2b2f('0x94');_0x230f53[hw_0x2b2f('0x4a')]=function _0x116020(_0x576e5c){this['token']=_0x576e5c;};var _0xb87a5a={};_0xb87a5a['key']='_screenshotLinkSuccess';_0xb87a5a[hw_0x2b2f('0x4a')]=function _0x3b0e80(){this[hw_0x2b2f('0x88')][hw_0x2b2f('0x9')](function(_0x1e9d35){return _0x1e9d35();});this['screenshotLinkCb']=[];};var _0x48675e={};_0x48675e[hw_0x2b2f('0x28')]=hw_0x2b2f('0xba');_0x48675e['value']=function _0x5d0618(_0x3bcc7f,_0x2cc047){var _0x3b32dc=this;try{_0x3bcc7f=JSON[hw_0x2b2f('0xe0')](_0x3bcc7f);}catch(_0x1f261b){var _0x2a7db7=new Uint8Array(_0x3bcc7f);var _0x51e5e7=new DataView(_0x2a7db7['buffer']);var _0x158d76=_0x51e5e7[hw_0x2b2f('0xdc')](0x0,![]);var _0x5ee266=_0x158d76+0x4;var _0x217c3b=_0x2a7db7[hw_0x2b2f('0x57')](0x4,_0x5ee266);var _0x4d4fc0=new TextDecoder()[hw_0x2b2f('0x50')](_0x217c3b);_0x3bcc7f=JSON[hw_0x2b2f('0xe0')](_0x4d4fc0);if(_0x2a7db7[hw_0x2b2f('0x7f')]>_0x5ee266){var _0x1cb4f5=_0x2a7db7[hw_0x2b2f('0x57')](_0x5ee266);var _0xfe8cc9=_0x1cb4f5[hw_0x2b2f('0x4')][hw_0x2b2f('0xbd')](_0x1cb4f5['byteOffset'],_0x1cb4f5['byteOffset']+_0x1cb4f5['byteLength']);_0x3bcc7f['data']['frame']=new Uint8Array(_0xfe8cc9);}}switch(_0x3bcc7f[hw_0x2b2f('0x6f')]){case _nodeServerConfig[hw_0x2b2f('0x74')]['HEART_BEAT']:if(this[hw_0x2b2f('0x7a')]['heartBeatSendTimes'][hw_0x2b2f('0x7f')]>0x0){var _0x3b2973=_0x2cc047-this['clientNetworkInfo']['heartBeatSendTimes'][hw_0x2b2f('0xb6')]();this[hw_0x2b2f('0x6c')]['forEach'](function(_0x2753d3){_0x2753d3(_0x3b2973);});}break;case _nodeServerConfig[hw_0x2b2f('0x74')]['AUTH_FAILURE']:this[hw_0x2b2f('0xda')][hw_0x2b2f('0xce')]['trigger'](hw_0x2b2f('0x7c'));break;case _nodeServerConfig[hw_0x2b2f('0x74')][hw_0x2b2f('0x89')]:{var _0x3b9d1c={};_0x3b9d1c[hw_0x2b2f('0xb2')]=_0x3bcc7f[hw_0x2b2f('0x8b')];_0x3b9d1c[hw_0x2b2f('0x10')]=_0x3bcc7f['msg'];this[hw_0x2b2f('0xda')]['topSubscribe'][hw_0x2b2f('0x22')](hw_0x2b2f('0xb4'),_0x3b9d1c);break;}case _nodeServerConfig[hw_0x2b2f('0x74')][hw_0x2b2f('0xc4')]:var _0x3ff4ae=_0x3bcc7f[hw_0x2b2f('0x8b')],_0x312af5=_0x3ff4ae[hw_0x2b2f('0x47')],_0x147505=_0x3ff4ae[hw_0x2b2f('0xc0')];this[hw_0x2b2f('0x96')](_0x312af5,_0x147505);break;case _nodeServerConfig[hw_0x2b2f('0x74')][hw_0x2b2f('0xa2')]:var _0x4f7f27=_0x3bcc7f[hw_0x2b2f('0x8b')]||[];_0x4f7f27[hw_0x2b2f('0x9')](function(_0x1ce1e5){_0x3b32dc[hw_0x2b2f('0x5e')](_0x1ce1e5[hw_0x2b2f('0x47')],_0x1ce1e5[hw_0x2b2f('0x1')]);});break;case _nodeServerConfig[hw_0x2b2f('0x74')][hw_0x2b2f('0xb8')]:{var _0x3624b5=_0x3bcc7f[hw_0x2b2f('0x8b')]||{},_0x53b305=_0x3624b5[hw_0x2b2f('0x47')],_0x3879d0=_0x3624b5[hw_0x2b2f('0x7')],_0x266e7d=_0x3624b5[hw_0x2b2f('0xa8')];this['msgCbs'][hw_0x2b2f('0x9')](function(_0x1e6a15){_0x1e6a15(_0x53b305,_0x3879d0);});break;}case _nodeServerConfig[hw_0x2b2f('0x74')][hw_0x2b2f('0xd6')]:this[hw_0x2b2f('0x96')](_0x312af5,_nodeServerConfig[hw_0x2b2f('0xaf')][hw_0x2b2f('0x9a')]);break;case _nodeServerConfig[hw_0x2b2f('0x74')]['CLOUD_SUCCESS_DISCONNECT']:var _0xcb0d10=this['cloudDisconnectCb'][_0x3bcc7f[hw_0x2b2f('0x8b')]];if(_0xcb0d10)_0xcb0d10[hw_0x2b2f('0x9')](function(_0x34f365){return _0x34f365();});this['cloudDisconnectCb'][_0x3bcc7f[hw_0x2b2f('0x8b')]]=[];break;case _nodeServerConfig['RESPONSE_CODE'][hw_0x2b2f('0xbe')]:{var _0x2a0d35=_0x3bcc7f[hw_0x2b2f('0x8b')],_0x1bfaa9=_0x2a0d35[hw_0x2b2f('0x47')],_0x311805=_0x2a0d35[hw_0x2b2f('0x7')];this[hw_0x2b2f('0x21')][hw_0x2b2f('0x9')](function(_0x5912e1){_0x5912e1(_0x1bfaa9,_0x311805);});break;}case _nodeServerConfig[hw_0x2b2f('0x74')]['CLOUD_CAMERA_PKG']:{var _0x265368=_0x3bcc7f[hw_0x2b2f('0x8b')],_0xe4b4e1=_0x265368['phoneId'],_0x554108=_0x265368[hw_0x2b2f('0xcc')];this['cameraPkgCbs'][hw_0x2b2f('0x9')](function(_0x3a0264){_0x3a0264(_0xe4b4e1,_0x554108);});break;}case _nodeServerConfig[hw_0x2b2f('0x74')][hw_0x2b2f('0x52')]:{var _0x50951d=_0x3bcc7f[hw_0x2b2f('0x8b')],_0x5eeabf=_0x50951d[hw_0x2b2f('0x47')],_0xf060e9=_0x50951d['pkg'];this[hw_0x2b2f('0xc5')][hw_0x2b2f('0x9')](function(_0x2e21a7){_0x2e21a7(_0x5eeabf,_0xf060e9);});break;}case _nodeServerConfig[hw_0x2b2f('0x74')][hw_0x2b2f('0x16')]:{var _0x9fe7a6=_0x3bcc7f[hw_0x2b2f('0x8b')],_0x305466=_0x9fe7a6['phoneId'],_0x274280=_0x9fe7a6[hw_0x2b2f('0x7')];this[hw_0x2b2f('0xde')][hw_0x2b2f('0x9')](function(_0x37eb9e){_0x37eb9e(_0x305466,_0x274280);});break;}case _nodeServerConfig[hw_0x2b2f('0x74')]['CLOUD_SENSOR_PKG']:{var _0x57b78a=_0x3bcc7f[hw_0x2b2f('0x8b')],_0x3a4a27=_0x57b78a[hw_0x2b2f('0x47')],_0x5c9adc=_0x57b78a[hw_0x2b2f('0x7')];this[hw_0x2b2f('0x98')]['forEach'](function(_0x1092f7){_0x1092f7(_0x3a4a27,_0x5c9adc);});break;}case _nodeServerConfig[hw_0x2b2f('0x74')][hw_0x2b2f('0xf')]:{var _0xf84122=_0x3bcc7f[hw_0x2b2f('0x8b')],_0x10f5a1=_0xf84122['phoneId'],_0x5ddede=_0xf84122[hw_0x2b2f('0x7')];this['microPhonePkgCbs'][hw_0x2b2f('0x9')](function(_0x55dce6){_0x55dce6(_0x10f5a1,_0x5ddede);});break;}case _nodeServerConfig[hw_0x2b2f('0x74')][hw_0x2b2f('0x26')]:{var _0x540eb9=_0x3bcc7f['data'],_0x24dbbe=_0x540eb9['phoneId'],_0xa89c9=_0x540eb9[hw_0x2b2f('0xcc')],_0x5050a6=_0x540eb9['time'];this[hw_0x2b2f('0x4e')]['forEach'](function(_0x2e38ad){_0x2e38ad(_0x24dbbe,_0xa89c9,_0x5050a6);});break;}case _nodeServerConfig['RESPONSE_CODE'][hw_0x2b2f('0x4d')]:{var _0x467ef6=_0x3bcc7f[hw_0x2b2f('0x8b')],_0x453f38=_0x467ef6[hw_0x2b2f('0x47')],_0x7ef6b6=_0x467ef6['time'];this['heartbeatRspCbs'][hw_0x2b2f('0x9')](function(_0x41fe3e){_0x41fe3e(_0x453f38,_0x7ef6b6);});break;}}};var _0xf46c7={};_0xf46c7[hw_0x2b2f('0x28')]='_spreadScreenshot';_0xf46c7[hw_0x2b2f('0x4a')]=function _0x2a6629(_0x227cdd,_0x270c80){this[hw_0x2b2f('0x58')]['forEach'](function(_0x472437){_0x472437(_0x227cdd,_0x270c80);});};var _0x5b2575={};_0x5b2575[hw_0x2b2f('0x28')]=hw_0x2b2f('0xdd');_0x5b2575[hw_0x2b2f('0x4a')]=function _0x814048(_0x1385b){var _0x809536;if(this[hw_0x2b2f('0xa7')]!==_nodeServerConfig[hw_0x2b2f('0x8a')]['CONNECTED'])return;_0x1385b['token']=this[hw_0x2b2f('0x9e')];_0x1385b=JSON[hw_0x2b2f('0x63')](_0x1385b);var _0x3a6095=new TextEncoder();var _0x168cae=_0x3a6095['encode'](_0x1385b);var _0x326cce={};_0x326cce['cmd']=hw_0x2b2f('0xc8');_0x326cce[hw_0x2b2f('0x8b')]=_0x168cae;var _0x44d123=_0x326cce;(_0x809536=this['screenshotWs'])===null||_0x809536===void 0x0||_0x809536['postMessage'](_0x44d123);};var _0x4121ab={};_0x4121ab[hw_0x2b2f('0x28')]=hw_0x2b2f('0xd0');_0x4121ab[hw_0x2b2f('0x4a')]=function _0x565a49(){var _0x319fe9=this;if(heartBeatInerval)clearInterval(heartBeatInerval);heartBeatInerval=_Util['default']['setInterval'](function(){var _0x5631e8={};_0x5631e8[hw_0x2b2f('0x6f')]=_nodeServerConfig[hw_0x2b2f('0x25')][hw_0x2b2f('0xca')];_0x319fe9['sendSnapshot'](_0x5631e8);_0x319fe9['clientNetworkInfo'][hw_0x2b2f('0x20')]['push'](Date[hw_0x2b2f('0xf0')]());},_nodeServerConfig['HEART_BEAT_INTERVAL']);};var _0x411064={};_0x411064[hw_0x2b2f('0x28')]='connectPhone';_0x411064['value']=function(){var _0x3e1236=_asyncToGenerator(_regeneratorRuntime()[hw_0x2b2f('0x82')](function _0x2f4e5c(_0x221fd4){var _0x2f2d9c=this;var _0x46119c,_0x23f2c4,_0x213298,_0x58f686,_0x2fba73=arguments;return _regeneratorRuntime()['wrap'](function _0x1608f6(_0x2757d3){while(0x1)switch(_0x2757d3[hw_0x2b2f('0x1d')]=_0x2757d3[hw_0x2b2f('0x6b')]){case 0x0:_0x46119c=_0x2fba73[hw_0x2b2f('0x7f')]>0x1&&_0x2fba73[0x1]!==undefined?_0x2fba73[0x1]:!![];if(!(!_0x221fd4||!_0x221fd4[hw_0x2b2f('0x7f')])){_0x2757d3[hw_0x2b2f('0x6b')]=0x3;break;}return _0x2757d3[hw_0x2b2f('0x24')](hw_0x2b2f('0xd7'));case 0x3:_0x23f2c4=[];_0x221fd4=_0x221fd4[hw_0x2b2f('0x71')](function(_0x2ac5bf,_0x2cc178){var _0x5924bb=_0x2f2d9c[hw_0x2b2f('0x19')][_0x2cc178[hw_0x2b2f('0x47')]];var _0x434d26={};_0x434d26['ip']=_0x2cc178[hw_0x2b2f('0x1c')];_0x434d26['port']=_0x2cc178['accessPort'];_0x434d26[hw_0x2b2f('0xa3')]=_0x2cc178['sessionId'];_0x434d26[hw_0x2b2f('0x95')]=_0x2cc178[hw_0x2b2f('0x95')];_0x434d26[hw_0x2b2f('0x47')]=_0x2cc178[hw_0x2b2f('0x47')];_0x434d26['protocol']=_0x2cc178[hw_0x2b2f('0x31')]||'ws';_0x434d26[hw_0x2b2f('0x61')]=!_0x46119c;_0x434d26[hw_0x2b2f('0x7e')]=_0x2cc178['serverToken'];_0x434d26['autoRotate']=_0x2cc178['autoRotate']||![];_0x434d26[hw_0x2b2f('0x65')]={};_0x434d26[hw_0x2b2f('0x65')][hw_0x2b2f('0x42')]=_0x2cc178['media_config'][hw_0x2b2f('0x42')]||0x1e;_0x434d26[hw_0x2b2f('0x65')]['mute']=_0x2cc178['media_config'][hw_0x2b2f('0x83')]||0x0;_0x434d26[hw_0x2b2f('0x65')][hw_0x2b2f('0x1f')]=hw_0x2b2f('0x5b');_0x434d26[hw_0x2b2f('0x65')]['quality']='main';_0x434d26[hw_0x2b2f('0x65')]['physical_width']=_0x2cc178[hw_0x2b2f('0x65')][hw_0x2b2f('0x0')]||0x2d0;_0x434d26[hw_0x2b2f('0x65')][hw_0x2b2f('0x2d')]=_0x2cc178[hw_0x2b2f('0x65')]['stream_height']||0x500;var _0xcc36f7=_0x434d26;if(_0x2cc178['media_config'][hw_0x2b2f('0xe5')]){_0xcc36f7[hw_0x2b2f('0x65')][hw_0x2b2f('0xe5')]=_0x2cc178[hw_0x2b2f('0x65')][hw_0x2b2f('0xe5')];}if(!_0x2f2d9c['serverMap'][_0x2cc178['phoneId']]&&!_0x5924bb){_0x2f2d9c[hw_0x2b2f('0x19')][_0x2cc178[hw_0x2b2f('0x47')]]=_0xcc36f7;_0x2ac5bf[hw_0x2b2f('0x3e')](_0xcc36f7);}else if(_0x5924bb&&!_0x5924bb[hw_0x2b2f('0x61')]&&_0xcc36f7[hw_0x2b2f('0x61')]){_0x23f2c4[hw_0x2b2f('0x3e')](_0xcc36f7);}return _0x2ac5bf;},[]);_0x213298=function _0x172f33(_0x24e544){var _0xabd602={};_0xabd602[hw_0x2b2f('0x6f')]=_nodeServerConfig['REQUEST_CODE'][hw_0x2b2f('0x7d')];_0xabd602['data']=_0x24e544;var _0x525b29=_0xabd602;_0x2f2d9c[hw_0x2b2f('0xdd')](_0x525b29);};_0x58f686=function _0x5128b9(){_0x213298(_0x221fd4);_0x23f2c4[hw_0x2b2f('0x9')](function(_0x466fde){_0x2f2d9c[hw_0x2b2f('0x5a')](_0x466fde[hw_0x2b2f('0x47')])[hw_0x2b2f('0xa1')](function(){setTimeout(function(){_0x2f2d9c[hw_0x2b2f('0x19')][_0x466fde[hw_0x2b2f('0x47')]]=_0x466fde;_0x213298([_0x466fde]);});});});};if(!(this[hw_0x2b2f('0xa7')]!=_nodeServerConfig['CUSTOM_CLOUD_STATUS'][hw_0x2b2f('0x32')])){_0x2757d3[hw_0x2b2f('0x6b')]=0xd;break;}this[hw_0x2b2f('0x8e')]=0x0;this[hw_0x2b2f('0xab')]();this[hw_0x2b2f('0x88')][hw_0x2b2f('0x3e')](_0x58f686);this[hw_0x2b2f('0x55')][hw_0x2b2f('0x3e')](function(){_0x221fd4[hw_0x2b2f('0x9')](function(_0x5d3aa8){_0x2f2d9c[hw_0x2b2f('0x96')](_0x5d3aa8['phoneId'],_nodeServerConfig[hw_0x2b2f('0xaf')][hw_0x2b2f('0xe6')]);});});return _0x2757d3['abrupt'](hw_0x2b2f('0xd7'));case 0xd:_0x58f686();case 0xe:case'end':return _0x2757d3[hw_0x2b2f('0x54')]();}},_0x2f4e5c,this);}));function _0x410021(_0x733b3a){return _0x3e1236['apply'](this,arguments);}return _0x410021;}();var _0x58624b={};_0x58624b[hw_0x2b2f('0x28')]='disconnectPhone';_0x58624b[hw_0x2b2f('0x4a')]=function _0x240d36(_0x29d39d){var _0x42ef9a=this;_0x29d39d[hw_0x2b2f('0x9')](function(_0x506c71){var _0x500b35;if(!_0x506c71)return;var _0x1c7ddb=_0x42ef9a[hw_0x2b2f('0x19')][_0x506c71];if(_0x1c7ddb){_0x42ef9a['_disconnectSnapshot'](_0x506c71);return;}(_0x500b35=_0x42ef9a[hw_0x2b2f('0x40')][_0x506c71])===null||_0x500b35===void 0x0||_0x500b35[hw_0x2b2f('0x44')]();delete _0x42ef9a['serverMap'][_0x506c71];});};var _0x419b72={};_0x419b72[hw_0x2b2f('0x28')]=hw_0x2b2f('0x5a');_0x419b72[hw_0x2b2f('0x4a')]=function _0x2c6b45(_0x31350d){var _0x373607=this;return new Promise(function(_0x1fc7cc,_0x413680){var _0x487cbf={};_0x487cbf[hw_0x2b2f('0x6f')]=_nodeServerConfig[hw_0x2b2f('0x25')][hw_0x2b2f('0xc9')];_0x487cbf[hw_0x2b2f('0x8b')]=[_0x31350d];_0x373607[hw_0x2b2f('0xdd')](_0x487cbf);delete _0x373607[hw_0x2b2f('0x19')][_0x31350d];var _0x5d311b=_0x373607['cloudDisconnectCb'][_0x31350d];if(!_0x5d311b)_0x5d311b=_0x373607[hw_0x2b2f('0x69')][_0x31350d]=[];_0x5d311b[hw_0x2b2f('0x3e')](function(){return setTimeout(function(){return _0x1fc7cc();},0x0);});});};var _0x52f72b={};_0x52f72b[hw_0x2b2f('0x28')]=hw_0x2b2f('0xee');_0x52f72b[hw_0x2b2f('0x4a')]=function _0x325924(_0x32aeaa,_0xc0a268){var _0x6f1b5e=this;var _0x15183e=this[hw_0x2b2f('0x40')];var _0x18c392=_0x15183e[_0x32aeaa];if(!_0x18c392&&!this['snapshotMap'][_0x32aeaa])return;var _0x439bfd=[];var _0x462894=[];if(this[hw_0x2b2f('0x46')]&&this[hw_0x2b2f('0x46')]===_0x32aeaa){_0x439bfd=Object[hw_0x2b2f('0x3')](_0x15183e);_0x462894=Object[hw_0x2b2f('0x3')](this[hw_0x2b2f('0x19')]);}else{var _0x5d6ee5=this['serverMap'][_0x32aeaa];if(_0x5d6ee5)_0x439bfd=[_0x32aeaa];else _0x462894=[_0x32aeaa];}_0x439bfd[hw_0x2b2f('0x7f')]&&_0x439bfd[hw_0x2b2f('0x9')](function(_0xabd3ec){var _0x4cfd93=_0x6f1b5e[hw_0x2b2f('0x40')][_0xabd3ec];_0x4cfd93['channel']['appController']['send'](_0xc0a268);});_0x462894[hw_0x2b2f('0x7f')]&&this[hw_0x2b2f('0xdd')]({'code':_nodeServerConfig[hw_0x2b2f('0x25')][hw_0x2b2f('0xd1')],'data':{'phoneIds':_0x462894,'msg':_0xc0a268}});};var _0x177631={};_0x177631[hw_0x2b2f('0x28')]=hw_0x2b2f('0x96');_0x177631[hw_0x2b2f('0x4a')]=function _0x39db88(_0x3cd07d,_0x2a19a1){var _0xa5fb75;switch(_0x2a19a1){case _nodeServerConfig[hw_0x2b2f('0xaf')][hw_0x2b2f('0xe6')]:_0xa5fb75=_nodeServerConfig[hw_0x2b2f('0x8a')][hw_0x2b2f('0x8f')];break;case _nodeServerConfig['CLOUD_STATUS_CODE'][hw_0x2b2f('0x9a')]:_0xa5fb75=_nodeServerConfig[hw_0x2b2f('0x8a')][hw_0x2b2f('0x8f')];break;case _nodeServerConfig[hw_0x2b2f('0xaf')][hw_0x2b2f('0x62')]:_0xa5fb75=_nodeServerConfig[hw_0x2b2f('0x8a')][hw_0x2b2f('0x8f')];break;case _nodeServerConfig['CLOUD_STATUS_CODE']['CAS_START_SUCCESS']:_0xa5fb75=_nodeServerConfig[hw_0x2b2f('0x8a')][hw_0x2b2f('0x32')];break;case _nodeServerConfig[hw_0x2b2f('0xaf')][hw_0x2b2f('0x77')]:_0xa5fb75=_nodeServerConfig[hw_0x2b2f('0x8a')]['CONNECTED'];break;case _nodeServerConfig['CLOUD_STATUS_CODE'][hw_0x2b2f('0x43')]:_0xa5fb75=_nodeServerConfig[hw_0x2b2f('0x8a')][hw_0x2b2f('0x60')];this[hw_0x2b2f('0xda')]['topSubscribe']['trigger'](hw_0x2b2f('0xe'));break;case _nodeServerConfig[hw_0x2b2f('0xaf')][hw_0x2b2f('0x4b')]:_0xa5fb75=_nodeServerConfig[hw_0x2b2f('0x8a')][hw_0x2b2f('0x60')];break;case 0xffff:_0xa5fb75=_nodeServerConfig[hw_0x2b2f('0x8a')][hw_0x2b2f('0x8f')];break;}if(_0xa5fb75==_nodeServerConfig['CUSTOM_CLOUD_STATUS'][hw_0x2b2f('0x8f')]){var _0x5f3f19={};_0x5f3f19[hw_0x2b2f('0x9c')]=0x0;_0x5f3f19['hasMax']=!![];this[hw_0x2b2f('0xda')][hw_0x2b2f('0xce')][hw_0x2b2f('0x22')](hw_0x2b2f('0xac'),_0x5f3f19);}if(!_0xa5fb75&&_0xa5fb75!==0x0)return;this[hw_0x2b2f('0x72')]['forEach'](function(_0x48d254){_0x48d254(_0x3cd07d,_0xa5fb75);});};var _0x2eb8ab={};_0x2eb8ab[hw_0x2b2f('0x28')]=hw_0x2b2f('0xef');_0x2eb8ab[hw_0x2b2f('0x4a')]=function _0x39f68b(_0x46ddcd){var _0x5b90a7=_0x46ddcd[hw_0x2b2f('0x47')],_0x306acb=_0x46ddcd['action'];if(_0x306acb===0x1){this[hw_0x2b2f('0x46')]=_0x5b90a7;}else if(_0x306acb===0x0||_0x306acb===0x2&&this[hw_0x2b2f('0x46')]===_0x5b90a7){this[hw_0x2b2f('0x46')]='';}};var _0x20724f={};_0x20724f[hw_0x2b2f('0x28')]='syncOperatePhone';_0x20724f['value']=function _0x432bb5(_0x202e38,_0x22870d){if(_0x202e38[hw_0x2b2f('0x47')])this[hw_0x2b2f('0x46')]=_0x202e38[hw_0x2b2f('0x47')];this[hw_0x2b2f('0xe1')](_0x22870d);};var _0x2c4e95={};_0x2c4e95[hw_0x2b2f('0x28')]='cancelBatchPhone';_0x2c4e95['value']=function _0x33a68d(_0x393f50){if(this[hw_0x2b2f('0x46')]===_0x393f50)this[hw_0x2b2f('0x46')]='';};var _0x5119ec={};_0x5119ec[hw_0x2b2f('0x28')]=hw_0x2b2f('0x3f');_0x5119ec[hw_0x2b2f('0x4a')]=function _0x12da29(_0x5118f6){this['msgCbs'][hw_0x2b2f('0x3e')](_0x5118f6);return _0x5118f6['id']=Date['now']();};var _0x44e1b2={};_0x44e1b2['key']=hw_0x2b2f('0x92');_0x44e1b2['value']=function _0x1cb6f4(_0x12cbb8){this[hw_0x2b2f('0xd2')]=this['msgCbs']['filter'](function(_0x26869a){return _0x26869a['id']!==_0x12cbb8;});};var _0x5813fb={};_0x5813fb[hw_0x2b2f('0x28')]=hw_0x2b2f('0xd9');_0x5813fb[hw_0x2b2f('0x4a')]=function _0x4989d4(_0x263c7f){this['cameraPkgCbs']['push'](_0x263c7f);return _0x263c7f['id']=Date[hw_0x2b2f('0xf0')]();};var _0x46bcc1={};_0x46bcc1[hw_0x2b2f('0x28')]=hw_0x2b2f('0x90');_0x46bcc1[hw_0x2b2f('0x4a')]=function _0xfd761e(_0x77724d){this[hw_0x2b2f('0x98')][hw_0x2b2f('0x3e')](_0x77724d);return _0x77724d['id']=Date[hw_0x2b2f('0xf0')]();};var _0x265c9b={};_0x265c9b['key']=hw_0x2b2f('0x48');_0x265c9b['value']=function _0x2aa322(_0x354a86){this[hw_0x2b2f('0x78')][hw_0x2b2f('0x3e')](_0x354a86);return _0x354a86['id']=Date[hw_0x2b2f('0xf0')]();};var _0x41744e={};_0x41744e['key']=hw_0x2b2f('0xd3');_0x41744e['value']=function _0x193556(_0x4fc6c9){this[hw_0x2b2f('0x4e')]['push'](_0x4fc6c9);return _0x4fc6c9['id']=Date[hw_0x2b2f('0xf0')]();};var _0x501074={};_0x501074[hw_0x2b2f('0x28')]=hw_0x2b2f('0x5c');_0x501074[hw_0x2b2f('0x4a')]=function _0x156be6(_0x3db28b){this[hw_0x2b2f('0xb0')][hw_0x2b2f('0x3e')](_0x3db28b);return _0x3db28b['id']=Date[hw_0x2b2f('0xf0')]();};var _0x1696c1={};_0x1696c1[hw_0x2b2f('0x28')]=hw_0x2b2f('0x9d');_0x1696c1[hw_0x2b2f('0x4a')]=function _0x49970e(_0x520cc0){this[hw_0x2b2f('0x6c')][hw_0x2b2f('0x3e')](_0x520cc0);return _0x520cc0['id']=Date['now']();};var _0x3cca42={};_0x3cca42[hw_0x2b2f('0x28')]='onAudioPkg';_0x3cca42['value']=function _0x2791e5(_0x2e3038){this[hw_0x2b2f('0xde')][hw_0x2b2f('0x3e')](_0x2e3038);return _0x2e3038['id']=Date[hw_0x2b2f('0xf0')]();};var _0x24c754={};_0x24c754['key']=hw_0x2b2f('0x49');_0x24c754[hw_0x2b2f('0x4a')]=function _0x34acd5(_0x2630de){this['orientationPkgCbs']['push'](_0x2630de);return _0x2630de['id']=Date[hw_0x2b2f('0xf0')]();};var _0x3bccd6={};_0x3bccd6['key']='onKeyboardInputPkg';_0x3bccd6['value']=function _0x5aefcd(_0x20edda){this[hw_0x2b2f('0x21')][hw_0x2b2f('0x3e')](_0x20edda);return _0x20edda['id']=Date[hw_0x2b2f('0xf0')]();};var _0x37d63e={};_0x37d63e[hw_0x2b2f('0x28')]=hw_0x2b2f('0x84');_0x37d63e[hw_0x2b2f('0x4a')]=function _0x48d109(_0x4610c2){this['updateStatusCbs'][hw_0x2b2f('0x3e')](_0x4610c2);};var _0x4aebf0={};_0x4aebf0[hw_0x2b2f('0x28')]='onSnapshot';_0x4aebf0['value']=function _0x5895b3(_0xb5e4c4){this['snapshotCbs'][hw_0x2b2f('0x3e')](_0xb5e4c4);return _0xb5e4c4['id']=Date[hw_0x2b2f('0xf0')]();};var _0x247952={};_0x247952[hw_0x2b2f('0x28')]=hw_0x2b2f('0x93');_0x247952['value']=function(){var _0x3a0946=_asyncToGenerator(_regeneratorRuntime()[hw_0x2b2f('0x82')](function _0xdc28ad(_0x48b54a,_0x2529cd){var _0x1405f5=this;var _0x12af1f,_0x5bef6d;return _regeneratorRuntime()[hw_0x2b2f('0x73')](function _0x3642e6(_0x386e97){while(0x1)switch(_0x386e97['prev']=_0x386e97['next']){case 0x0:_0x2529cd=_0x2529cd[hw_0x2b2f('0x71')](function(_0x3d1eff,_0x401be2){var _0xa7a7f8=_0x1405f5['snapshotMap'][_0x401be2];if(!_0xa7a7f8){_0x1405f5['snapshotMap'][_0x401be2]=_0x401be2;_0x3d1eff[hw_0x2b2f('0x3e')](_0x401be2);}return _0x3d1eff;},[]);_0x12af1f=function _0x3dee87(_0x10985e){var _0x1a4961={};_0x1a4961[hw_0x2b2f('0x9e')]=_0x48b54a;_0x1a4961[hw_0x2b2f('0xb2')]=_0x10985e;var _0x38aaad={};_0x38aaad[hw_0x2b2f('0x6f')]=_nodeServerConfig[hw_0x2b2f('0x25')]['EASY_LINK'];_0x38aaad['data']=_0x1a4961;var _0x1f3f68=_0x38aaad;_0x1405f5[hw_0x2b2f('0xdd')](_0x1f3f68);};_0x5bef6d=function _0x119ce0(){_0x12af1f(_0x2529cd);};if(!(this['screenshotStatus']!=_nodeServerConfig[hw_0x2b2f('0x8a')][hw_0x2b2f('0x32')])){_0x386e97[hw_0x2b2f('0x6b')]=0x9;break;}this[hw_0x2b2f('0x8e')]=0x0;this[hw_0x2b2f('0xab')]();this[hw_0x2b2f('0x88')][hw_0x2b2f('0x3e')](_0x5bef6d);this[hw_0x2b2f('0x55')][hw_0x2b2f('0x3e')](function(){connectInfos[hw_0x2b2f('0x9')](function(_0x5009ff){_0x1405f5[hw_0x2b2f('0x96')](_0x5009ff[hw_0x2b2f('0x47')],_nodeServerConfig[hw_0x2b2f('0xaf')][hw_0x2b2f('0xe6')]);});});return _0x386e97[hw_0x2b2f('0x24')]('return');case 0x9:_0x5bef6d();case 0xa:case hw_0x2b2f('0x29'):return _0x386e97['stop']();}},_0xdc28ad,this);}));function _0x5e7b59(_0x74913a,_0x2b60e2){return _0x3a0946[hw_0x2b2f('0x79')](this,arguments);}return _0x5e7b59;}();var _0x5006c1={};_0x5006c1[hw_0x2b2f('0x28')]=hw_0x2b2f('0xd8');_0x5006c1[hw_0x2b2f('0x4a')]=function _0x5a1a9c(){var _0x3d476a={};_0x3d476a[hw_0x2b2f('0x41')]=hw_0x2b2f('0x91');this[hw_0x2b2f('0x2b')][hw_0x2b2f('0xea')](_0x3d476a);this[hw_0x2b2f('0x2b')][hw_0x2b2f('0xed')]();this[hw_0x2b2f('0x2b')]=null;if(heartBeatInerval)heartBeatInerval['clear']();};return _createClass(_0x214b7c,[_0x1af882,_0x16e2b6,_0x230f53,_0xb87a5a,_0x48675e,_0xf46c7,_0x5b2575,_0x4121ab,_0x411064,_0x58624b,_0x419b72,_0x52f72b,_0x177631,_0x2eb8ab,_0x20724f,_0x2c4e95,_0x5119ec,_0x44e1b2,_0x5813fb,_0x46bcc1,_0x265c9b,_0x41744e,_0x501074,_0x1696c1,_0x3cca42,_0x24c754,_0x3bccd6,_0x37d63e,_0x4aebf0,_0x247952,_0x5006c1]);}();var _default=exports[hw_0x2b2f('0x66')]=ServerCenter;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var DESCRIPTORS = __webpack_require__(25);
var LIBRARY = __webpack_require__(59);
var $typed = __webpack_require__(166);
var hide = __webpack_require__(36);
var redefineAll = __webpack_require__(75);
var fails = __webpack_require__(24);
var anInstance = __webpack_require__(76);
var toInteger = __webpack_require__(52);
var toLength = __webpack_require__(27);
var toIndex = __webpack_require__(167);
var gOPN = __webpack_require__(73).f;
var dP = __webpack_require__(28).f;
var arrayFill = __webpack_require__(126);
var setToStringTag = __webpack_require__(70);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var macrotask = __webpack_require__(170).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(54)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(22);
var isObject = __webpack_require__(23);
var newPromiseCapability = __webpack_require__(172);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(73);
var gOPS = __webpack_require__(98);
var anObject = __webpack_require__(22);
var Reflect = __webpack_require__(19).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(132);
__webpack_require__(18)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(22);
var sameValue = __webpack_require__(256);
var regExpExec = __webpack_require__(103);

// @@search logic
__webpack_require__(104)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 256 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);
__webpack_require__(48);
__webpack_require__(49);
__webpack_require__(30);
__webpack_require__(77);
__webpack_require__(99);
__webpack_require__(74);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(12);
__webpack_require__(15);
__webpack_require__(42);
__webpack_require__(107);
__webpack_require__(21);
__webpack_require__(33);
__webpack_require__(17);
__webpack_require__(31);
__webpack_require__(16);
var _Util = _interopRequireDefault(__webpack_require__(26));
var _Subscribe = _interopRequireDefault(__webpack_require__(88));
var _AppController = _interopRequireDefault(__webpack_require__(259));
var _webworkifyWebpack = _interopRequireDefault(__webpack_require__(63));
var _FrameParser = _interopRequireDefault(__webpack_require__(232));
var _protocolConfig = _interopRequireDefault(__webpack_require__(32));
var _AESGCMCrypto = _interopRequireDefault(__webpack_require__(177));
var _nodeServerConfig = __webpack_require__(106);
var _commonConfig = __webpack_require__(51);
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var heartBeatInerval;
var date = Date.now();

/**
 * 声明控制中心实例
 * @param {String} options.topSubscribe - 上层时间监听器
 * @param {String} options.protocol - 协议类型(默认wss)
 * @param {String} options.connectURI - 连接地址(默认demo.jinhaokj.com.cn/ws)
 */
var DirectCenter = /*#__PURE__*/function () {
  function DirectCenter(options) {
    var _this = this;
    _classCallCheck(this, DirectCenter);
    this.options = options;

    // 主控机器
    this.appState = '';
    this.phoneId = '';
    this.startParams = {};
    this.isFirst = true;
    this.audioPkgCbs = []; // 音频相关动作接收回调
    // 返回消息回调函数
    this.msgCbs = []; // 消息接收回调
    this.updateStatusCbs = []; // 云手机状态接收回调
    this.cameraPkgCbs = []; // 云手机摄像头相关动作接收回调
    this.orientationPkgCbs = []; // 云手机发送屏幕方向包回调
    this.sensorPkgCbs = []; //传感器数据包接收回调
    this.microPhonePkgCbs = []; //麦克风数据包接收回调
    this.heartBeatPkgCbs = []; //服务端心跳响应包
    this.heartbeatRspCbs = []; //已发送心跳包到服务端
    this.keyboardInputPkgCbs = []; // 云机内复制回调
    this.wsClient = null;
    this.status = _nodeServerConfig.CUSTOM_CLOUD_STATUS.UN_CONNECT; // 截图服务连接状态(默认未连接)
    this.connectCount = 0;
    // 初始化包解析器
    this.frameParser = new _FrameParser.default(true);
    // 注册事件监听
    this.subscribe = new _Subscribe.default(['onMessage', 'onTouch', 'onUpdateStatus', 'onVideo', 'appStateChange', 'clipboardDataChange']);

    // 监听画面帧返回
    this.subscribe.on('onVideo', function (eventName, _ref) {
      var phoneId = _ref.phoneId,
        msg = _ref.msg;
      _this.msgCbs.forEach(function (cb) {
        cb(phoneId, msg);
      });
    });

    // 监听状态变更
    this.subscribe.on('appStateChange', function (eventName, data) {
      var state = data.state;
      _this._spreadStatus(state);
    });
  }
  return _createClass(DirectCenter, [{
    key: "getVerifiedData",
    value: function getVerifiedData(connectInfo) {
      var verifiedData = {
        //   ip: connectInfo.ip,
        //   port: String(connectInfo.port + 1),
        session_id: connectInfo.sessionId,
        backgroundTimeout: '60',
        available_playtime: '6000',
        user_id: ''
      };
      return verifiedData;
    }

    /**
     * 直连服务器
     */
  }, {
    key: "createSocket",
    value: function createSocket(connectInfos) {
      var _this2 = this;
      // 初始化参数
      var crypt = new _AESGCMCrypto.default();
      var iv = crypt.iv();
      var verifiedData = this.getVerifiedData(connectInfos);
      var encryptedData = _objectSpread(_objectSpread({}, verifiedData), {}, {
        touch_timeout: 0
      });
      Promise.all([crypt.encrypt(JSON.stringify(encryptedData), connectInfos.phoneId, iv), crypt.abstract(Object.values(verifiedData).join(''))]).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          cipherText = _ref3[0],
          verifyText = _ref3[1];
        _this2.startParams = {
          ticket: connectInfos.ticket,
          session_id: connectInfos.sessionId,
          auth_ts: connectInfos.timestamp,
          verify_data: verifyText,
          encrypted_data: cipherText,
          aes_iv: iv,
          sdk_version: '24.3.1',
          protocol_version: 'v2',
          client_type: '3',
          channelType: 'WebSocket',
          client_mode: 'direct',
          server_token: connectInfos.serverToken,
          media_config: {
            fps: connectInfos.media_config.fps || 30,
            mute: connectInfos.media_config.mute || 0,
            frame_type: 'h264',
            quality: 'main',
            physical_width: connectInfos.media_config.stream_width || 720,
            physical_height: connectInfos.media_config.stream_height || 1280
          }
        };
        if (connectInfos.media_config.bitrate) {
          _this2.startParams.media_config.bitrate = connectInfos.media_config.bitrate;
        }
        _this2.createConnect(connectInfos);
      });
    }
  }, {
    key: "createConnect",
    value: function createConnect(connectInfos) {
      var _this3 = this;
      /* javascript-obfuscator:disable */
      this.wsClient = (0, _webworkifyWebpack.default)(/*require.resolve*/(134));
      var socket = this.wsClient;
      var extParam = '';
      if (connectInfos.extParam) {
        extParam = '?' + connectInfos.extParam;
      }
      var connectURI = "".concat(connectInfos.ip, ":").concat(connectInfos.port + 1).concat(extParam);
      if (connectInfos.accessHost) {
        connectURI = "".concat(connectInfos.accessHost).concat(extParam);
      }
      this.phoneId = connectInfos.phoneId;

      /* javascript-obfuscator:enable */
      socket.postMessage({
        cmd: 'initReq',
        options: {
          protocol: connectInfos.protocol,
          connectURI: connectURI,
          needHeatBeat: true // binaryType: 'string'
        }
      });
      socket.addEventListener('message', function (evt) {
        var objData = evt.data;
        switch (objData.cmd) {
          case 'openRsp':
            // 连接成功后将ws连接状态编辑为连接成功,并重置连接次数和开始发送心跳包
            _this3.status = _nodeServerConfig.CUSTOM_CLOUD_STATUS.CONNECTED;
            _this3.connectCount = 0;

            //this.options.topSubscribe.trigger('onConnectSuccess')

            _this3.options.topSubscribe.trigger('appStateChange', _objectSpread({
              phoneId: _this3.phoneId
            }, _AppController.default.connected));
            // 连接
            _this3.startCloudPhone();
            // this.deviceHardwareHandler = new DeviceHardwareHandler()
            break;
          case 'heartbeatRsp':
            _this3.heartbeatRspCbs.forEach(function (cb) {
              cb(_this3.phoneId, objData.time);
            });
            break;
          case 'errorRsp':
          case 'closeRsp':
            // 取消心跳包发送
            if (heartBeatInerval) heartBeatInerval.clear();
            if (_this3.wsClient) {
              _this3.wsClient.terminate();
              _this3.wsClient = null;
            }
            break;
          case 'recvRsp':
            // 接收到消息
            _this3.messageProcess(objData.buf, objData.time);
            break;
        }
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect(callbackFn) {
      var _this4 = this;
      // client自动断连场景不重连
      this.stopCloudPhone();
      if (heartBeatInerval) heartBeatInerval.clear();
      // 延迟关闭socket，避免CAE在关闭前接收不到stop cmd
      setTimeout(function () {
        _this4.close();
      }, 1000);
    }
  }, {
    key: "stopCloudPhone",
    value: function stopCloudPhone() {
      var arrayBuf = _Util.default.makeActionMsg('CMD_CONTROL', 'STOP');
      arrayBuf && this.send(arrayBuf);
    }

    // 发送关键帧数
  }, {
    key: "requestIFrame",
    value: function requestIFrame() {
      var arrayBuf = _Util.default.makeActionMsg('CMD_CONTROL', 'REQUEST_I_FRAME');
      arrayBuf && this.send(arrayBuf);
    }
  }, {
    key: "send",
    value: function send(data) {
      var options = {
        cmd: 'sendReq',
        data: data
      };
      if (this.wsClient) {
        this.wsClient.postMessage(options);
      } else {
        console.log('已断开连接');
      }
    }

    /**
     * 监听服务发送消息过来
     * @param {*} res
     */
  }, {
    key: "messageProcess",
    value: function messageProcess(data, time) {
      var _this5 = this;
      this.frameParser.readPackage(data);
      var videoFrame = this.frameParser.shiftPackage('Video');
      if (videoFrame) {
        if (this.isFirst) {
          this.requestIFrame();
          this.isFirst = false;
        } else {
          this.msgCbs.forEach(function (cb) {
            cb(_this5.phoneId, videoFrame);
          });
        }
      }
      //如果是音频
      var frame = this.frameParser.shiftPackage('Audio');
      this.audioProcessResp(frame);

      //对应更新状态的处理
      var cmdControlPkg = this.frameParser.shiftPackage('CmdControl');
      this.processCmdControlResp(cmdControlPkg);
      var phoneControlPkg = this.frameParser.shiftPackage('PhoneControl');
      this.processPhoneControlResp(phoneControlPkg);
      var cameraPkg = this.frameParser.shiftPackage('Camera');
      this.cameraProcessResp(cameraPkg);

      // 方向包 若启动竖屏，CAE不发送旋转msg
      var orientationPkg = this.frameParser.shiftPackage('Orientation');
      if (orientationPkg) {
        var pkgBody = orientationPkg & 0xff;
        var orientation = _protocolConfig.default.ORIENTATION[pkgBody];
        console.log('Orientation change：' + orientation);
        this.processOrientation(orientation, pkgBody);
      }

      // 传感器数据
      var sensorPkg = this.frameParser.shiftPackage('Sensor');
      this.processSensor(sensorPkg);

      // 传感器数据
      var microPhonePkg = this.frameParser.shiftPackage('MicroPhone');
      this.processMicroPhonePkg(microPhonePkg);

      // 心跳响应包
      var heartBeatPkg = this.frameParser.shiftPackage('HeartBeat');
      this.processHeartBeatPkg(heartBeatPkg, time);

      // 云机内复制回调
      var keyboardInputPkg = this.frameParser.shiftPackage('KeyboardInput');
      this.processKeyboardInput(keyboardInputPkg);
    }

    // 方向包
  }, {
    key: "processOrientation",
    value: function processOrientation(orientation, pkgBody) {
      var _this6 = this;
      var pkg = {
        orientation: orientation,
        pkgBody: pkgBody
      };
      this.orientationPkgCbs.forEach(function (cb) {
        cb(_this6.phoneId, pkg);
      });
    }
    // 传感器
  }, {
    key: "processSensor",
    value: function processSensor(pkg) {
      var _this7 = this;
      if (!pkg) {
        return;
      }
      this.sensorPkgCbs.forEach(function (cb) {
        cb(_this7.phoneId, pkg);
      });
    }
    // 麦克风
  }, {
    key: "processMicroPhonePkg",
    value: function processMicroPhonePkg(pkg) {
      var _this8 = this;
      if (!pkg) {
        return;
      }
      this.microPhonePkgCbs.forEach(function (cb) {
        cb(_this8.phoneId, pkg);
      });
    }
    // 处理时延包
  }, {
    key: "processHeartBeatPkg",
    value: function processHeartBeatPkg(heartBeatPkg, time) {
      var _this9 = this;
      if (!heartBeatPkg) {
        return;
      }
      this.heartBeatPkgCbs.forEach(function (cb) {
        cb(_this9.phoneId, heartBeatPkg, time);
      });
    }

    // 云手机复制回调
  }, {
    key: "processKeyboardInput",
    value: function processKeyboardInput(keyboardInputPkg) {
      var _this10 = this;
      if (!keyboardInputPkg) {
        return;
      }
      this.keyboardInputPkgCbs.forEach(function (cb) {
        cb(_this10.phoneId, keyboardInputPkg);
      });
    }

    // 音频
  }, {
    key: "audioProcessResp",
    value: function audioProcessResp(pkg) {
      var _this11 = this;
      if (!pkg) {
        return;
      }
      // console.log("音频数据",pkg)
      this.audioPkgCbs.forEach(function (cb) {
        cb(_this11.phoneId, pkg);
      });
    }
  }, {
    key: "cameraProcessResp",
    value: function cameraProcessResp(pkg) {
      var _this12 = this;
      if (!pkg) {
        return;
      }
      var buf = new Uint8Array(pkg);
      var cameraMsgHeader = _Util.default.getMsgHeader(buf);
      var cameraMsgBody = null;
      if (buf.length > _commonConfig.MEDIA_MSG_HEADER_COUNT) {
        cameraMsgBody = _Util.default.getMsgBody(buf.slice(_commonConfig.MEDIA_MSG_HEADER_COUNT), 'CAMERA');
      }
      var cameraPkg = {
        cameraMsgHeader: cameraMsgHeader,
        cameraMsgBody: cameraMsgBody
      };
      this.cameraPkgCbs.forEach(function (cb) {
        cb(_this12.phoneId, cameraPkg);
      });
    }
  }, {
    key: "processPhoneControlResp",
    value: function processPhoneControlResp(pkg) {
      if (!pkg) {
        return;
      }
      var buf = new Uint8Array(pkg);
      if (!buf.length) {
        return;
      }
      var code = buf[0];
      var stateConfig = _protocolConfig.default.PHONE_CONNECTION_STATE[code];
      if (stateConfig) {
        //   Logger.debug(stateConfig.message)
        this.appState = stateConfig;
        // this.subscribe.trigger('appStateChange', { ...this.appState })
        this.options.topSubscribe.trigger('appStateChange', _objectSpread({
          phoneId: this.phoneId
        }, this.appState));
      }
    }
  }, {
    key: "processCmdControlResp",
    value: function processCmdControlResp(cmdControlPkg) {
      if (cmdControlPkg) {
        var buf = new Uint8Array(cmdControlPkg);
        var text = '';
        buf.forEach(function (c) {
          text += String.fromCharCode(c);
        });
        var resp = _Util.default.params2JSON(text);
        var status = Number(resp.code);

        //console.log(status, '>>>>>>')
        this._spreadStatus(status);
      }
    }
  }, {
    key: "isMSEMode",
    value: function isMSEMode() {
      var frameType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _commonConfig.FRAME_TYPE_MAP.TYPE265;
      // 使用 MSE 前提：
      // (1) 支持 MediaSource
      // (2) 支持 avc1.42c020 编码
      // (3) 不在 canvas 白名单
      // 前两条判断包含在 JMuxer.isSupported 方法中
      var isMSE = true;
      if (frameType === _commonConfig.FRAME_TYPE_MAP.TYPE264) {
        isMSE = Boolean(JMuxer.isSupported('video/mp4; codecs="avc1.42c020"')) && !this.isCanvasPriority();
      } else {
        isMSE = Boolean(JMuxer.isSupported('video/mp4; codecs="hev1"')) && !this.isCanvasPriority();
      }

      /*global __IS_DEBUG__*/
      if (false) { var framework; }

      // isMSE = false

      return isMSE;
    }

    /**
     * 连接云手机
     * @param {Array} connectInfos 需要连接的手机
     * @param {Number} fps 音视频帧率
     */
  }, {
    key: "connectPhone",
    value: (function () {
      var _connectPhone = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(connectInfos) {
        var hasImage,
          connect,
          options,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              hasImage = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
              if (!(!connectInfos || !connectInfos.length)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              connect = connectInfos[0];
              options = {
                // ip: linkInfo.intranet_ip,
                ip: connect.accessIp,
                accessHost: connect.accessHost,
                port: connect.accessPort,
                sessionId: connect.sessionId,
                timestamp: connect.timestamp,
                phoneId: connect.phoneId,
                ticket: connect.ticket,
                extParam: connect.extParam,
                protocol: connect.protocol || 'ws',
                media_config: connect.media_config,
                serverToken: connect.serverToken
              };
              if (!options.media_config) {
                options.media_config = {
                  fps: 30,
                  stream_width: 720,
                  stream_height: 1280
                };
              }
              this.createSocket(options);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connectPhone(_x) {
        return _connectPhone.apply(this, arguments);
      }
      return connectPhone;
    }()
    /**
     * 断开连接
     * @param {Array} deviceList 需要断开连接的手机列表
     */
    )
  }, {
    key: "disconnectPhone",
    value: function disconnectPhone(phoneIdList) {
      this.disconnect();
    }

    /**
     * 发送操作消息
     * @param {*} phoneId
     * @param {*} buf
     */
  }, {
    key: "sendMsg",
    value: function sendMsg(phoneId, buf) {
      this.send(buf);
    }

    /**
     * 广播云手机连接状态
     * @param {*} phoneId
     * @param {*} status
     */
  }, {
    key: "_spreadStatus",
    value: function _spreadStatus(status) {
      var _this13 = this;
      var connectstatus;
      switch (status) {
        case _nodeServerConfig.CLOUD_STATUS_CODE.CAS_SERVER_UNREACHABLE:
          connectstatus = _nodeServerConfig.CUSTOM_CLOUD_STATUS.DIS_CONNECTED;
          break;
        case _nodeServerConfig.CLOUD_STATUS_CODE.CAS_RESOURCE_IN_USING:
          connectstatus = _nodeServerConfig.CUSTOM_CLOUD_STATUS.DIS_CONNECTED;
          break;
        case _nodeServerConfig.CLOUD_STATUS_CODE.CAS_CONNECT_LOST:
          connectstatus = _nodeServerConfig.CUSTOM_CLOUD_STATUS.DIS_CONNECTED;
          break;
        case _nodeServerConfig.CLOUD_STATUS_CODE.CAS_START_SUCCESS:
          connectstatus = _nodeServerConfig.CUSTOM_CLOUD_STATUS.CONNECTED;
          break;
        case _nodeServerConfig.CLOUD_STATUS_CODE.CAS_RECONNECT_SUCCESS:
          connectstatus = _nodeServerConfig.CUSTOM_CLOUD_STATUS.CONNECTED;
          break;
        case _nodeServerConfig.CLOUD_STATUS_CODE.CAS_CONNECT_SUCCESS:
          connectstatus = _nodeServerConfig.CUSTOM_CLOUD_STATUS.CONNECTING;
          break;
        case _nodeServerConfig.CLOUD_STATUS_CODE.CAS_RECONNECTING:
          connectstatus = _nodeServerConfig.CUSTOM_CLOUD_STATUS.CONNECTING;
          break;
        case _nodeServerConfig.CLOUD_STATUS_CODE.CAS_VERIFY_PARAMETER_INVALID:
          connectstatus = _nodeServerConfig.CUSTOM_CLOUD_STATUS.DIS_CONNECTED;
        case 0xffff:
          connectstatus = _nodeServerConfig.CUSTOM_CLOUD_STATUS.DIS_CONNECTED;
          break;
      }
      if (connectstatus == _nodeServerConfig.CUSTOM_CLOUD_STATUS.DIS_CONNECTED) {
        this.options.topSubscribe.trigger('onConnectFail', {
          linkCount: this.connectCount,
          hasMax: true
        });
      }
      if (connectstatus == _nodeServerConfig.CUSTOM_CLOUD_STATUS.CONNECTED) {
        this.options.topSubscribe.trigger('onConnectSuccess');
      }
      if (!connectstatus && connectstatus !== 0) return;
      this.updateStatusCbs.forEach(function (cb) {
        cb(_this13.phoneId, connectstatus);
      });
    }

    /**
     * 监听消息返回
     * @param {*} cb 回调的函数
     */
  }, {
    key: "onMsg",
    value: function onMsg(cb) {
      this.msgCbs.push(cb);
      return cb.id = Date.now();
    }

    /**
     * 删除消息监听
     * @param {*} id
     */
  }, {
    key: "unMsg",
    value: function unMsg(id) {
      this.msgCbs = this.msgCbs.filter(function (cb) {
        return cb.id !== id;
      });
    }

    /**
     * 监听摄像头相关动作回调
     * @param {*} cb 回调函数
     */
  }, {
    key: "onCameraPkg",
    value: function onCameraPkg(cb) {
      this.cameraPkgCbs.push(cb);
      return cb.id = Date.now();
    }
  }, {
    key: "onAudioPkg",
    value: function onAudioPkg(cb) {
      this.audioPkgCbs.push(cb);
      return cb.id = Date.now();
    }
  }, {
    key: "onSensorPkg",
    value: function onSensorPkg(cb) {
      this.sensorPkgCbs.push(cb);
      return cb.id = Date.now();
    }
  }, {
    key: "onMicroPhonePkg",
    value: function onMicroPhonePkg(cb) {
      this.microPhonePkgCbs.push(cb);
      return cb.id = Date.now();
    }
  }, {
    key: "onOrientationPkg",
    value: function onOrientationPkg(cb) {
      this.orientationPkgCbs.push(cb);
      return cb.id = Date.now();
    }
    // 心跳处理包
  }, {
    key: "onHeartBeatPkg",
    value: function onHeartBeatPkg(cb) {
      this.heartBeatPkgCbs.push(cb);
      return cb.id = Date.now();
    }
    // 心跳响应包
  }, {
    key: "onHeartBeatReps",
    value: function onHeartBeatReps(cb) {
      this.heartbeatRspCbs.push(cb);
      return cb.id = Date.now();
    }

    // 云机复制内容回调
  }, {
    key: "onKeyboardInputPkg",
    value: function onKeyboardInputPkg(cb) {
      this.keyboardInputPkgCbs.push(cb);
      return cb.id = Date.now();
    }

    // 客户端时延
  }, {
    key: "onClientDelayReps",
    value: function onClientDelayReps() {}

    /**
     * 添加到监听更新链接状态队列中
     * @param {*} cb
     */
  }, {
    key: "updateStatus",
    value: function updateStatus(cb) {
      this.updateStatusCbs.push(cb);
    }
  }, {
    key: "close",
    value: function close() {
      if (this.wsClient) {
        this.wsClient.postMessage({
          cmd: 'closeReq'
        });
        this.wsClient.terminate();
        this.wsClient = null;
      }
    }

    // 发送启动命令获取音视频数据
  }, {
    key: "startCloudPhone",
    value: function startCloudPhone() {
      //console.log('发送启动命令', this.startParams)
      var arrayBuf = _Util.default.makeActionMsg('CMD_CONTROL', 'START', this.startParams);
      arrayBuf && this.send(arrayBuf);
      //arrayBuf && this.wsClient.postMessage({ cmd: 'sendReq', data: arrayBuf })
    }
  }]);
}();
var _default = exports.default = DirectCenter;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(25);
var getKeys = __webpack_require__(62);
var toIObject = __webpack_require__(45);
var isEnum = __webpack_require__(86).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var hw_0xa842=['KEYBOARD_INPUT_HEADER_LENGTH','已退出','fromCharCode','feed','aesKey','attributes','cameraMsgType','Map','processKeyboardInput','MICROPHONE_MESSAGE_TYPE','reduce','getOwnPropertyDescriptor','MicroPhone','Pause\x20timeout,\x20disconnect','directionHandler','decode','firstIFrame','认证失败','connecting','OppoWebPage','socketWorkerState','OPT_CAMERA_GET_INFO_REQ','touchTimeout','kbitCount','init','video','constructor','Cannot\x20call\x20a\x20class\x20as\x20a\x20function','authTimeStamp','MutationObserver','configurable','Video','recordHeartbeat','value','maxTimes','socketState','microPhoneProcessResp','updateCanvasSize','count','sensorProcessResp','round','devicemotion','done','removeEventListener','media_config','terminate','avc','2308','webkitURL','physical_width','CLOSED','setMediaConfig','parse','curResolution','KEYEVENT_KEYCODE_TYPE','pauseCloudPhone','OPT_MIC_START_RECORD_REQ','startHeartbeatReq','setResolution','RECONNECT_ENGING_START_ERROR','MEDIA_MSG_HEADER_COUNT','player','isMobile','Invalid\x20attempt\x20to\x20destructure\x20non-iterable\x20instance.\x0aIn\x20order\x20to\x20be\x20iterable,\x20non-array\x20objects\x20must\x20have\x20a\x20[Symbol.iterator]()\x20method.','getMsgHeader','encrypt','available_playtime','TYPE_GYROSCOPE','verify_data','START','wsState','listenPlayerSizeChange','onOpenSocket','Sensor','CMD_RESP_TYPE','messageModalId','enumerable','770','userAgent','onClose','createSocket','Camera','xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx','sendKeyCodeMsg','PAUSE','canplaythrough','getPackageCacheNum','object','4096','isCanvasPriority','ticket','framework','sensorMsgHeader','setVolume','closeRsp','util','autoRotation','socketWorker','createElement','_resumeCloudPhone','state','loadedmetadata','videoEleId','1539','touchHandler','audioPlayer','getVolume','forEach','name','shift','nextResolution','time','string','Phone\x20has\x20connected,\x20disconnect','getDeviceMotion','sendTimesMaxCount','RESUME','port','CONNECTING','CLOSING','toLowerCase','errorRsp','allocTraceId','cameraMsgHeader','bind','makeActionMsg','gpsLocationMsgType','terminateSocketWorker','IME_PASTE_TO_SDK','appState','PLAY_TIMEOUT','_reconnect','phoenixCanvas','Play\x20timeout,\x20disconnect','remove','split','oppoErrorPage','cmd','REQUEST_I_FRAME','CHANNEL','charCodeAt','KEYBOARD_INPUT_MSG_TYPE','can','sendDataToCloudApp','querySelector','phoneId','arrayBufferToBase64','frame_type','4353','prototype','jmuxer','__canvasPlay','onUpdateStatus','buffered','play','VERIFY_FAILED','1538','isMSE','resumeCloudPhone','toLastest','reconnection','processCmdControlResp','deviceId','OPT_LOCATION_CLOSE_REQ','defineProperty','bitRate','登录信息失效，请重新登录','render','currentTime','visibilitychange','RECONNECT_PARAMETER_INVALID','orientation','socketHasOpenned','socketCloseEvent','Socket\x20worker\x20error.','Connecting','GpsLocation','client_type','OPT_CAMERA_GET_PARAM_REQ','connectURI','启动失败','Connect\x20success','reconnecting','msHidden','onError','TYPE264','OPEN','ORIENTATION','listenPageVisibility','canvasObserver','gpsLocationMsgHeader','appStateChange','startHeartbeat','1540','stopHeartbeatReq','CAMERA','phoneIp','CMD_CONTROL','MEDIA_CONFIG_SUCCESS','networkInfo','session_id','START_FAILED','values','destroy','RECONNECT_SERVER_UNREACHABLE','hidden','5888','Audio','initSocket','OPT_CAMERA_START_PREVIEW_REQ','stopLocationWatch','msg','FRAME_TYPE_MAP','startPlay','addEventListener','buttonModalId','试玩时间已到','keyboardInputContentId','handleStartPreviewReq','OPT_CAMERA_SET_PARAM_REQ','sdkVersion','makeSensorHeaderBuf','MICROPHONE','abstract','initParams','切换后台超时','ACTION_DOWN','test','OPT_CAMERA_STOP_PREVIEW_REQ','发送启动命令','record','linkOverTime','listenPageShow','requestIFrame','Orientation\x20change：','toPrimitive','webkitAudioContext','Page\x20visibility,\x20resume','MSG_TYPE','msvisibilitychange','sensorMsgType','Server\x20unreachable','getOwnPropertySymbols','videoResizeCallback','exit','Page\x20hidden,\x20pause','frameParser','shiftTraceId','START_SUCCESS','Setting\x20media\x20config\x20success','controls','updateResolution','__calcNetworkState','video/mp4;\x20codecs=\x22avc1.42c020\x22','physical_height','readPackage','muted','reconnectTimes','receive','onMessage','closeSocket','TOUCH_TIMEOUT','makeDataMsg','isSocketAvailable','OPT_MIC_STOP_RECOED_REQ','PACKAGE_HEADER_LENGTH','parentNode','microPhoneMsgType','containerId','CAMERA_MESSAGE_TYPE','769','RECONNECT','1543','timerHander','startCloudPhone','call','isSupport','writable','resumeDeviceHardware','volume','defineProperties','onVideo','pauseDevice','subscribe','checkAndRecoverSocket','filter','lastReceivingTime','startParams','join','sendKeyCodeEventMsg','slice','pagehide','loadedmetadataCallback','由于您长时间未操作游戏，服务断开','@@iterator','OPT_CAMERA_IS_SUPPORT_H264_REQ','worker','availablePlayTime','touch_timeout','isSupportURL','initReq','getMsgBody','云机在其他设备上被连接，本次连接退出','Websocket\x20close.\x20Triggered\x20by\x20','next','visibilityChange','handleStopRecordReq','phonePort','webkitvisibilitychange','disconnect','AudioContext','buf','virtual_height','timerDelay','GPS_LOCATION_MESSAGE_TYPE','SET_MEDIA_CONFIG','autoplay','连接服务器失败，请稍后重试','iterator','deviceHardwareHandler','useSocketWorker','socket','verifiedData','reconnect','webkitHidden','length','handleVisibilityChange','controlBtnId','makeLocationHeaderBuf','trigger','video/mp4;\x20codecs=\x22hev1\x22','pauseDeviceHardware','sessionId','lastRefreshTime','OPT_CAMERA_GET_SIZE_REQ','symbol','apply','tip','bitrate','push','handleSetRecordParam','Object','debug','byteLength','generateGUID','deviceorientation','createObjectURL','clearPackageCache','keycodeInput','Set','socketStateRsp','concat','unreachable','CHECKING','error','updateResolutionAndTouch','checkSocketWorkerState','send','pkgBody','makeCommonHeaderBuf','resize','与服务器连接出现异常','toString','playerContainerId','getUserLocation','stopHeartbeat','phoenixVideo','HeartBeat','workerState','initPlyerAndStart','3840','unbind','width','includes','end','getDeviceOrientation','networkInfoId','keyboardInput','OPT_SENSOR_ENABLE_RSP','exitModalId','processChannelData','key','topSubscribe','params2JSON','start','playsinline','optType','getOwnPropertyDescriptors','recMediaConfig','closeReq','handleSensorDisable','setMsgHeader','TYPE265','资源正在使用中，请稍后','attributeName','PORTRAIT','ACTION_UP','3584','virtual_width','isArray','shiftPackage','buffer','return','observe','机器连接成功','max_disconnect_duration','delayAnalysis','cameraMsgBody','heartBeatInterval','isMSEMode','command','makeMediaData','cloudAppData','data','off','connected','decoderType','map','recoverAfterWorkerDead','INVALID_OPERATION','_action','delay','heartbeatRsp','OPT_LOCATION_OPEN_REQ','sdk_version','playing','netStateChange','processPhoneControlResp','Touch\x20timeout,\x20disconnect','keyEventCodeType','quality','DEFAULT_DEFINITION','PHONE_CONNECTION_STATE','LIVE','gpsLocationProcessResp','heartBeatSendTimes','Receive\x20failed\x20response,\x20disconnect','1537','STOP','paramsSerialize','message','log','canvas','undefined','clipboardDataChange','height','H265_NOT_SUPPORT','postMessage','sendClipboardData','default','1541','isSupported','getCheckSum','options','backgroundTimeout','microPhoneMsgBody','microPhoneMsgHeader','CmdControl','startParams\x20<<<<<<<<<<','Reconnect\x20faild,\x20disconnect','DEFAULT_RESOLUTION','keys','connect','pageshow','updateSocketWorkerState','OppoFlow','keyboardListener','cameraProcessResp','__msePlay'];(function(_0x49b45d,_0xa84203){var _0x287009=function(_0x57d61b){while(--_0x57d61b){_0x49b45d['push'](_0x49b45d['shift']());}};_0x287009(++_0xa84203);}(hw_0xa842,0x77));var hw_0x2870=function(_0x49b45d,_0xa84203){_0x49b45d=_0x49b45d-0x0;var _0x287009=hw_0xa842[_0x49b45d];return _0x287009;};'use strict';/* javascript-obfuscator:disable */
__webpack_require__(31);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(48);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(49);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(77);var hw_0x57d61b={};hw_0x57d61b[hw_0x2870('0x17f')]=!![];/* javascript-obfuscator:enable */
Object[hw_0x2870('0x2d')](exports,'__esModule',hw_0x57d61b);exports[hw_0x2870('0x14a')]=void 0x0;/* javascript-obfuscator:disable */
__webpack_require__(30);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(21);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(33);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(17);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(55);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(29);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(102);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(13);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(14);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(12);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(15);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(42);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(107);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(78);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(56);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(46);/* javascript-obfuscator:enable */
/* javascript-obfuscator:disable */
__webpack_require__(16);/* javascript-obfuscator:enable */
var _jmuxer=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(176));/* javascript-obfuscator:enable */
var _webworkifyWebpack=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(63));/* javascript-obfuscator:enable */
var _AESGCMCrypto=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(177));/* javascript-obfuscator:enable */
var _AudioPlayer=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(221));/* javascript-obfuscator:enable */
var _AutoRotation=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(228));/* javascript-obfuscator:enable */
var _CanvasPlayer=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(229));/* javascript-obfuscator:enable */
var _Subscribe=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(88));/* javascript-obfuscator:enable */
var _canvasWhiteList=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(231));/* javascript-obfuscator:enable */
var _protocolConfig=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(32));/* javascript-obfuscator:enable */
var _DelayAnalysis=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(365));/* javascript-obfuscator:enable */
var _FrameParser=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(232));/* javascript-obfuscator:enable */
var _Logger=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(89));/* javascript-obfuscator:enable */
var _TouchHandler=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(233));/* javascript-obfuscator:enable */
var _Util=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(26));/* javascript-obfuscator:enable */
var _KeyboardInput=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(368));/* javascript-obfuscator:enable */
var _DirectionHandler=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(235));/* javascript-obfuscator:enable */
var _commonConfig=/* javascript-obfuscator:disable */
__webpack_require__(51);/* javascript-obfuscator:enable */
var _KeyboardListener=_interopRequireDefault(/* javascript-obfuscator:disable */
__webpack_require__(236));/* javascript-obfuscator:enable */
function _interopRequireDefault(_0x17ccb5){return _0x17ccb5&&_0x17ccb5['__esModule']?_0x17ccb5:{'default':_0x17ccb5};}function _typeof(_0x177208){'@babel/helpers\x20-\x20typeof';return _typeof='function'==typeof Symbol&&hw_0x2870('0xd8')==typeof Symbol['iterator']?function(_0x4d86c8){return typeof _0x4d86c8;}:function(_0x36bb75){return _0x36bb75&&'function'==typeof Symbol&&_0x36bb75['constructor']===Symbol&&_0x36bb75!==Symbol['prototype']?'symbol':typeof _0x36bb75;},_typeof(_0x177208);}function _slicedToArray(_0x46dea9,_0x100376){return _arrayWithHoles(_0x46dea9)||_iterableToArrayLimit(_0x46dea9,_0x100376)||_unsupportedIterableToArray(_0x46dea9,_0x100376)||_nonIterableRest();}function _nonIterableRest(){throw new TypeError(hw_0x2870('0x19d'));}function _unsupportedIterableToArray(_0x110ae8,_0x4c7d52){if(_0x110ae8){if(hw_0x2870('0x1ce')==typeof _0x110ae8)return _arrayLikeToArray(_0x110ae8,_0x4c7d52);var _0x170866={}[hw_0x2870('0xf3')][hw_0x2870('0x9c')](_0x110ae8)[hw_0x2870('0xab')](0x8,-0x1);return hw_0x2870('0xde')===_0x170866&&_0x110ae8[hw_0x2870('0x178')]&&(_0x170866=_0x110ae8[hw_0x2870('0x178')][hw_0x2870('0x1ca')]),hw_0x2870('0x165')===_0x170866||hw_0x2870('0xe6')===_0x170866?Array['from'](_0x110ae8):'Arguments'===_0x170866||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/[hw_0x2870('0x6c')](_0x170866)?_arrayLikeToArray(_0x110ae8,_0x4c7d52):void 0x0;}}function _arrayLikeToArray(_0x16af42,_0x34ad40){(null==_0x34ad40||_0x34ad40>_0x16af42['length'])&&(_0x34ad40=_0x16af42['length']);for(var _0x1ed4e4=0x0,_0x304ed9=Array(_0x34ad40);_0x1ed4e4<_0x34ad40;_0x1ed4e4++)_0x304ed9[_0x1ed4e4]=_0x16af42[_0x1ed4e4];return _0x304ed9;}function _iterableToArrayLimit(_0xf9b0fc,_0x67e7aa){var _0xe8ede8=null==_0xf9b0fc?null:'undefined'!=typeof Symbol&&_0xf9b0fc[Symbol[hw_0x2870('0xc7')]]||_0xf9b0fc[hw_0x2870('0xaf')];if(null!=_0xe8ede8){var _0x5c5428,_0x230331,_0x316e83,_0x3f8ca7,_0x2132ba=[],_0x56745a=!0x0,_0x3d01f7=!0x1;try{if(_0x316e83=(_0xe8ede8=_0xe8ede8[hw_0x2870('0x9c')](_0xf9b0fc))[hw_0x2870('0xb9')],0x0===_0x67e7aa){if(Object(_0xe8ede8)!==_0xe8ede8)return;_0x56745a=!0x1;}else for(;!(_0x56745a=(_0x5c5428=_0x316e83[hw_0x2870('0x9c')](_0xe8ede8))[hw_0x2870('0x188')])&&(_0x2132ba['push'](_0x5c5428['value']),_0x2132ba[hw_0x2870('0xce')]!==_0x67e7aa);_0x56745a=!0x0);}catch(_0x4fd467){_0x3d01f7=!0x0,_0x230331=_0x4fd467;}finally{try{if(!_0x56745a&&null!=_0xe8ede8[hw_0x2870('0x11b')]&&(_0x3f8ca7=_0xe8ede8['return'](),Object(_0x3f8ca7)!==_0x3f8ca7))return;}finally{if(_0x3d01f7)throw _0x230331;}}return _0x2132ba;}}function _arrayWithHoles(_0x5641ca){if(Array[hw_0x2870('0x118')](_0x5641ca))return _0x5641ca;}function ownKeys(_0x30a30b,_0x14cdd9){var _0xf94e24=Object[hw_0x2870('0x156')](_0x30a30b);if(Object[hw_0x2870('0x7b')]){var _0x386dd8=Object[hw_0x2870('0x7b')](_0x30a30b);_0x14cdd9&&(_0x386dd8=_0x386dd8[hw_0x2870('0xa6')](function(_0x4da67c){return Object[hw_0x2870('0x169')](_0x30a30b,_0x4da67c)[hw_0x2870('0x1aa')];})),_0xf94e24[hw_0x2870('0xdc')][hw_0x2870('0xd9')](_0xf94e24,_0x386dd8);}return _0xf94e24;}function _objectSpread(_0x43191c){for(var _0x1d6c14=0x1;_0x1d6c14<arguments[hw_0x2870('0xce')];_0x1d6c14++){var _0x195dcd=null!=arguments[_0x1d6c14]?arguments[_0x1d6c14]:{};_0x1d6c14%0x2?ownKeys(Object(_0x195dcd),!0x0)[hw_0x2870('0x1c9')](function(_0x184a4c){_defineProperty(_0x43191c,_0x184a4c,_0x195dcd[_0x184a4c]);}):Object['getOwnPropertyDescriptors']?Object[hw_0x2870('0xa1')](_0x43191c,Object[hw_0x2870('0x10c')](_0x195dcd)):ownKeys(Object(_0x195dcd))[hw_0x2870('0x1c9')](function(_0x1a7f54){Object['defineProperty'](_0x43191c,_0x1a7f54,Object[hw_0x2870('0x169')](_0x195dcd,_0x1a7f54));});}return _0x43191c;}function _defineProperty(_0x1df755,_0x425720,_0x15a4d2){var _0x68c39b={};_0x68c39b[hw_0x2870('0x17f')]=_0x15a4d2;_0x68c39b[hw_0x2870('0x1aa')]=!0x0;_0x68c39b['configurable']=!0x0;_0x68c39b[hw_0x2870('0x9e')]=!0x0;return(_0x425720=_toPropertyKey(_0x425720))in _0x1df755?Object[hw_0x2870('0x2d')](_0x1df755,_0x425720,_0x68c39b):_0x1df755[_0x425720]=_0x15a4d2,_0x1df755;}function _classCallCheck(_0x5bda47,_0x53ee04){if(!(_0x5bda47 instanceof _0x53ee04))throw new TypeError(hw_0x2870('0x179'));}function _defineProperties(_0x502c81,_0x489b30){for(var _0x3fac22=0x0;_0x3fac22<_0x489b30['length'];_0x3fac22++){var _0x2cb97b=_0x489b30[_0x3fac22];_0x2cb97b[hw_0x2870('0x1aa')]=_0x2cb97b['enumerable']||!0x1,_0x2cb97b[hw_0x2870('0x17c')]=!0x0,hw_0x2870('0x17f')in _0x2cb97b&&(_0x2cb97b['writable']=!0x0),Object[hw_0x2870('0x2d')](_0x502c81,_toPropertyKey(_0x2cb97b[hw_0x2870('0x106')]),_0x2cb97b);}}function _createClass(_0x24ea9d,_0x5b4d26,_0x150030){var _0x3efbce={};_0x3efbce[hw_0x2870('0x9e')]=!0x1;return _0x5b4d26&&_defineProperties(_0x24ea9d[hw_0x2870('0x1e')],_0x5b4d26),_0x150030&&_defineProperties(_0x24ea9d,_0x150030),Object[hw_0x2870('0x2d')](_0x24ea9d,hw_0x2870('0x1e'),_0x3efbce),_0x24ea9d;}function _toPropertyKey(_0x2eba31){var _0x494b80=_toPrimitive(_0x2eba31,'string');return hw_0x2870('0xd8')==_typeof(_0x494b80)?_0x494b80:_0x494b80+'';}function _toPrimitive(_0x2bb164,_0x17cc82){if(hw_0x2870('0x1b5')!=_typeof(_0x2bb164)||!_0x2bb164)return _0x2bb164;var _0xf5d300=_0x2bb164[Symbol[hw_0x2870('0x74')]];if(void 0x0!==_0xf5d300){var _0x446562=_0xf5d300['call'](_0x2bb164,_0x17cc82||hw_0x2870('0x14a'));if(hw_0x2870('0x1b5')!=_typeof(_0x446562))return _0x446562;throw new TypeError('@@toPrimitive\x20must\x20return\x20a\x20primitive\x20value.');}return(hw_0x2870('0x1ce')===_0x17cc82?String:Number)(_0x2bb164);}if(false){}var CAE_STREAM_DELIMITER_MAGICWORD=0x5a5a;var K_UNIT=0x3e8;var K_BIT_UNIT=0x1f40;var DEFAULT_ORIENTATION=hw_0x2870('0x114');var hw_0x17b399={};hw_0x17b399[hw_0x2870('0x1c2')]=0x100;hw_0x17b399[hw_0x2870('0x141')]=hw_0x2870('0x38');var hw_0x2965fe={};hw_0x2965fe[hw_0x2870('0x1c2')]=0x200;hw_0x2965fe['message']=hw_0x2870('0x3e');var hw_0x1eb038={};hw_0x1eb038[hw_0x2870('0x1c2')]=0x301;hw_0x1eb038['message']=hw_0x2870('0x7a');hw_0x1eb038[hw_0x2870('0xda')]=hw_0x2870('0xc6');var hw_0x1f9532={};hw_0x1f9532[hw_0x2870('0x1c2')]=0xb00;hw_0x1f9532[hw_0x2870('0x141')]='Reconnecting';var hw_0x5af2fd={};hw_0x5af2fd[hw_0x2870('0x1c2')]=0x1700;hw_0x5af2fd[hw_0x2870('0x141')]='Cloud\x20Phone\x20exit';hw_0x5af2fd[hw_0x2870('0xda')]='已退出';var hw_0x243618={};hw_0x243618[hw_0x2870('0x170')]=hw_0x17b399;hw_0x243618['connected']=hw_0x2965fe;hw_0x243618[hw_0x2870('0xe9')]=hw_0x1eb038;hw_0x243618[hw_0x2870('0x3f')]=hw_0x1f9532;hw_0x243618[hw_0x2870('0x7d')]=hw_0x5af2fd;var APP_STATE_FROM_CLIENT=hw_0x243618;var hw_0x431736={};hw_0x431736[hw_0x2870('0x57')]=hw_0x2870('0x15f');hw_0x431736[hw_0x2870('0x97')]=hw_0x2870('0xc6');hw_0x431736[hw_0x2870('0x18d')]=hw_0x2870('0x3d');hw_0x431736[hw_0x2870('0x1d')]=hw_0x2870('0x3d');hw_0x431736[hw_0x2870('0x1ab')]=hw_0x2870('0x112');hw_0x431736['65535']=hw_0x2870('0xf2');hw_0x431736[hw_0x2870('0x13e')]='认证失败';hw_0x431736[hw_0x2870('0x25')]=hw_0x2870('0x16f');hw_0x431736[hw_0x2870('0x1c5')]=hw_0x2870('0x16f');hw_0x431736[hw_0x2870('0x4a')]=hw_0x2870('0x16f');hw_0x431736[hw_0x2870('0x14b')]=hw_0x2870('0x16f');hw_0x431736['1542']=hw_0x2870('0x16f');hw_0x431736[hw_0x2870('0x99')]=hw_0x2870('0x2f');hw_0x431736[hw_0x2870('0x116')]=hw_0x2870('0x61');hw_0x431736['2560']=hw_0x2870('0xf2');hw_0x431736[hw_0x2870('0xfb')]=hw_0x2870('0xae');hw_0x431736[hw_0x2870('0x1b6')]=hw_0x2870('0x6a');hw_0x431736['8960']=hw_0x2870('0xb7');var APP_STATE_ERROR_CODE_TIP=hw_0x431736;var DEFAULT_VALUME_VALUE=0x32;var hw_0x2246a0={};hw_0x2246a0[hw_0x2870('0x1d4')]=0x0;hw_0x2246a0[hw_0x2870('0x43')]=0x1;hw_0x2246a0[hw_0x2870('0x0')]=0x2;hw_0x2246a0[hw_0x2870('0x190')]=0x3;var WEBSOCKET_READY_STATE=hw_0x2246a0;var hw_0x21402a={};hw_0x21402a[hw_0x2870('0xea')]=0x0;hw_0x21402a[hw_0x2870('0x13a')]=0x1;var WORKER_STATE=hw_0x21402a;var lastTime;var limit=0x0;var AppController=function(){function _0x258663(_0x55f501){_classCallCheck(this,_0x258663);this[hw_0x2870('0x16e')]=!![];var _0x17347c={};_0x17347c[hw_0x2870('0xa0')]=DEFAULT_VALUME_VALUE;this[hw_0x2870('0x14e')]=_objectSpread(_0x17347c,_0x55f501);this['util']=new _Util['default']();this[hw_0x2870('0x30')]=!![];this['player']=null;this[hw_0x2870('0xf4')]=undefined;this[hw_0x2870('0x1c4')]=hw_0x2870('0xf7');this['canvasEleId']=hw_0x2870('0xd');this[hw_0x2870('0xa4')]=new _Subscribe[(hw_0x2870('0x14a'))]([hw_0x2870('0x133'),hw_0x2870('0x48'),'audioStateChange',hw_0x2870('0x125'),hw_0x2870('0x145')]);this[hw_0x2870('0x4')]=null;this[hw_0x2870('0x151')]=null;this[hw_0x2870('0x120')]=null;this[hw_0x2870('0x150')]=null;this[hw_0x2870('0x1ba')]=null;this['gpsLocationMsgHeader']=null;this['cameraMsgType']=_protocolConfig['default'][hw_0x2870('0x96')];this[hw_0x2870('0x94')]=_protocolConfig[hw_0x2870('0x14a')][hw_0x2870('0x167')];this[hw_0x2870('0x79')]=_protocolConfig[hw_0x2870('0x14a')]['SENSOR_MESSAGE_TYPE'];this[hw_0x2870('0x7')]=_protocolConfig[hw_0x2870('0x14a')][hw_0x2870('0xc3')];this[hw_0x2870('0x136')]=_protocolConfig[hw_0x2870('0x14a')][hw_0x2870('0x194')];this[hw_0x2870('0xc9')]=_0x258663['isSupportURL']();this[hw_0x2870('0x1a4')]=undefined;this[hw_0x2870('0xd5')]=this[hw_0x2870('0x14e')]['sessionId']||this[hw_0x2870('0xe1')]();var _0x1580d0={};_0x1580d0[hw_0x2870('0x17')]=!![];_0x1580d0[hw_0x2870('0x180')]=this[hw_0x2870('0x14e')][hw_0x2870('0x8a')];_0x1580d0['count']=0x0;_0x1580d0[hw_0x2870('0xc2')]=0x3e8;_0x1580d0[hw_0x2870('0x9a')]=null;_0x1580d0[hw_0x2870('0x3f')]=![];_0x1580d0[hw_0x2870('0xd2')]='';this[hw_0x2870('0x29')]=_0x1580d0;var _0x3350ce={};_0x3350ce[hw_0x2870('0x13c')]=[];_0x3350ce['sendTimesMaxCount']=0x32;_0x3350ce[hw_0x2870('0x12e')]=0x0;_0x3350ce[hw_0x2870('0x2e')]=0x0;_0x3350ce[hw_0x2870('0x175')]=0x0;_0x3350ce[hw_0x2870('0xd6')]=0x0;this['networkInfo']=_0x3350ce;this[hw_0x2870('0xa7')]=null;this[hw_0x2870('0x121')]=0x3e8;this[hw_0x2870('0x70')]=0xfa0;this['frameParser']=new _FrameParser[(hw_0x2870('0x14a'))](this['options']['supportAudio']);this[hw_0x2870('0x1be')]=null;this[hw_0x2870('0x193')]=_objectSpread({},_protocolConfig['default'][hw_0x2870('0x155')]);this[hw_0x2870('0x1cc')]=_objectSpread({},_protocolConfig[hw_0x2870('0x14a')][hw_0x2870('0x155')]);this[hw_0x2870('0x1ae')]();var _0x3bcd95={};_0x3bcd95['worker']=null;_0x3bcd95['socket']=null;this[hw_0x2870('0x172')]=_0x3bcd95;this[hw_0x2870('0xa')]=null;this[hw_0x2870('0x35')]=![];}var _0x2060ba={};_0x2060ba[hw_0x2870('0x106')]=hw_0x2870('0x1b1');_0x2060ba[hw_0x2870('0x17f')]=function _0x5e203b(_0x39ba83){if(!_0x39ba83){return;}this[hw_0x2870('0x1c6')][hw_0x2870('0xaa')](this[hw_0x2870('0x136')][hw_0x2870('0x6b')],this[hw_0x2870('0x136')][_0x39ba83]);this['touchHandler'][hw_0x2870('0xaa')](this[hw_0x2870('0x136')][hw_0x2870('0x115')],this[hw_0x2870('0x136')][_0x39ba83]);};var _0x33534f={};_0x33534f[hw_0x2870('0x106')]=hw_0x2870('0x1c8');_0x33534f[hw_0x2870('0x17f')]=function _0x1c393e(){return this['options'][hw_0x2870('0xa0')];};var _0x19fe1b={};_0x19fe1b[hw_0x2870('0x106')]=hw_0x2870('0x1bb');_0x19fe1b[hw_0x2870('0x17f')]=function _0x2c0cff(_0x16dc46){this['options']['volume']=_0x16dc46;if(this[hw_0x2870('0x1c7')]){this[hw_0x2870('0x1c7')][hw_0x2870('0x1bb')](_0x16dc46);}};var _0x1e6afa={};_0x1e6afa['key']='createSocket';_0x1e6afa[hw_0x2870('0x17f')]=function _0x1f58da(){var _0x2ddd5d=this;/* javascript-obfuscator:disable */
this.socketWorker=(0,_webworkifyWebpack.default)(/*require.resolve*/(134));/* javascript-obfuscator:enable */
this[hw_0x2870('0x1bf')][hw_0x2870('0x5f')]('message',function(_0xa1e326){var _0x25f6c6=_0xa1e326[hw_0x2870('0x126')];switch(_0x25f6c6['cmd']){case'openRsp':console['log'](hw_0x2870('0x11d'),_0x2ddd5d['options'][hw_0x2870('0x2b')]);_0x2ddd5d[hw_0x2870('0x1a6')](_0x25f6c6[hw_0x2870('0x1c2')]);break;case hw_0x2870('0x2'):_0x2ddd5d[hw_0x2870('0x41')]();break;case'recvRsp':_0x2ddd5d[hw_0x2870('0x8c')](_0x25f6c6[hw_0x2870('0xc0')],_0x25f6c6[hw_0x2870('0x1cd')]);break;case hw_0x2870('0x12f'):_0x2ddd5d['recordHeartbeat'](_0x25f6c6[hw_0x2870('0x1cd')]);break;case hw_0x2870('0x1bc'):if(_0x2ddd5d[hw_0x2870('0x29')][hw_0x2870('0x3f')]&&_0x2ddd5d[hw_0x2870('0x29')][hw_0x2870('0xd2')]===hw_0x2870('0x36')||!_0x2ddd5d[hw_0x2870('0x29')][hw_0x2870('0x3f')]){_0x2ddd5d['onClose'](_0x25f6c6[hw_0x2870('0x1c2')],'socketCloseEvent');}if(_0x2ddd5d['reconnection'][hw_0x2870('0x17')]){_0x2ddd5d[hw_0x2870('0x14e')]['topSubscribe'][hw_0x2870('0xd2')](hw_0x2870('0x21'),{'phoneId':_0x2ddd5d[hw_0x2870('0x14e')][hw_0x2870('0x2b')],'socketState':0x2});}break;case hw_0x2870('0xe7'):_0x2ddd5d[hw_0x2870('0x159')](WORKER_STATE[hw_0x2870('0x13a')],_0x25f6c6[hw_0x2870('0x1c2')]);break;default:_Logger[hw_0x2870('0x14a')][hw_0x2870('0xdf')]('Unknown\x20command\x20from\x20socket\x20worker.');}});this[hw_0x2870('0x1bf')][hw_0x2870('0x5f')](hw_0x2870('0xeb'),function(){_Logger[hw_0x2870('0x14a')][hw_0x2870('0xdf')](hw_0x2870('0x37'));});this[hw_0x2870('0x59')]=function(_0x5c2fc4){_0x2ddd5d[hw_0x2870('0x1bf')][hw_0x2870('0x148')]({'cmd':hw_0x2870('0xb5'),'options':{'protocol':'ws','connectURI':_0x5c2fc4,'needHeatBeat':_0x2ddd5d['options']['needHeatBeat']}});};this[hw_0x2870('0xee')]=function(_0x19c5cb){var _0x5dbd95={};_0x5dbd95[hw_0x2870('0x12')]='sendReq';_0x5dbd95[hw_0x2870('0x126')]=_0x19c5cb;var _0x3fc6af=_0x5dbd95;_0x2ddd5d[hw_0x2870('0x1bf')][hw_0x2870('0x148')](_0x3fc6af);};this[hw_0x2870('0x49')]=function(){var _0x1db1eb={};_0x1db1eb['cmd']=hw_0x2870('0x197');_0x2ddd5d[hw_0x2870('0x1bf')][hw_0x2870('0x148')](_0x1db1eb);};this[hw_0x2870('0xf6')]=function(){var _0x394c68={};_0x394c68[hw_0x2870('0x12')]=hw_0x2870('0x4b');_0x2ddd5d[hw_0x2870('0x1bf')]['postMessage'](_0x394c68);};this[hw_0x2870('0x8d')]=function(){var _0x193a32={};_0x193a32[hw_0x2870('0x12')]=hw_0x2870('0x10e');_0x2ddd5d['socketWorker'][hw_0x2870('0x148')](_0x193a32);};this[hw_0x2870('0xed')]=function(){_0x2ddd5d['updateSocketWorkerState'](WORKER_STATE['CHECKING'],null);var _0x5e645b={};_0x5e645b[hw_0x2870('0x12')]='socketStateReq';_0x2ddd5d[hw_0x2870('0x1bf')][hw_0x2870('0x148')](_0x5e645b);};};var _0x59fb10={};_0x59fb10['key']=hw_0x2870('0x1a6');_0x59fb10['value']=function _0x53537f(_0x1bbd01){this['socketHasOpenned']=!![];this['wsState']=_0x1bbd01;this[hw_0x2870('0x159')](WORKER_STATE['LIVE'],_0x1bbd01);this[hw_0x2870('0x29')]['can']=!![];this['reconnection']['count']=0x0;this['reconnection'][hw_0x2870('0x3f')]=![];switch(this[hw_0x2870('0x12d')]){case hw_0x2870('0xcc'):this[hw_0x2870('0xc')]();break;default:this[hw_0x2870('0xa')]=APP_STATE_FROM_CLIENT[hw_0x2870('0x128')];var _0x2ecb7f={};_0x2ecb7f[hw_0x2870('0x1a')]=this['options'][hw_0x2870('0x2b')];this[hw_0x2870('0x14e')][hw_0x2870('0x107')]['trigger'](hw_0x2870('0x48'),_objectSpread(_0x2ecb7f,this[hw_0x2870('0xa')]));this[hw_0x2870('0x9b')]();this[hw_0x2870('0x45')]();this[hw_0x2870('0x71')]();}};var _0x4bcfec={};_0x4bcfec[hw_0x2870('0x106')]=hw_0x2870('0xfa');_0x4bcfec[hw_0x2870('0x17f')]=function _0x55fdaf(){this['initPlayer']();if(this['player']){if(this[hw_0x2870('0x14e')][hw_0x2870('0xe5')]||this[hw_0x2870('0x19c')]){this[hw_0x2870('0x15b')]=new _KeyboardListener['default'](this[hw_0x2870('0x14e')][hw_0x2870('0x95')],this[hw_0x2870('0xee')]);}else{this[hw_0x2870('0x102')]=new _KeyboardInput['default'](this[hw_0x2870('0x14e')]['keyboardInputContentId'],this[hw_0x2870('0x14e')]['containerId'],this['send'],this[hw_0x2870('0x14e')][hw_0x2870('0x19c')]);this[hw_0x2870('0x102')][hw_0x2870('0x176')]();}var _0x526969={};_0x526969[hw_0x2870('0x95')]=this[hw_0x2870('0x14e')][hw_0x2870('0x95')];_0x526969[hw_0x2870('0x101')]=this[hw_0x2870('0x14e')][hw_0x2870('0x101')];_0x526969[hw_0x2870('0x1a9')]=this[hw_0x2870('0x14e')][hw_0x2870('0x1a9')];_0x526969[hw_0x2870('0x104')]=this[hw_0x2870('0x14e')][hw_0x2870('0x104')];_0x526969[hw_0x2870('0x60')]=this['options'][hw_0x2870('0x60')];_0x526969[hw_0x2870('0xd0')]=this[hw_0x2870('0x14e')][hw_0x2870('0xd0')];_0x526969['keyboardInputContentId']=this[hw_0x2870('0x14e')][hw_0x2870('0x62')];_0x526969[hw_0x2870('0x19c')]=this['options'][hw_0x2870('0x19c')];_0x526969[hw_0x2870('0xf4')]=this[hw_0x2870('0xf4')];this[hw_0x2870('0x16c')]=new _DirectionHandler['default'](_0x526969);this['directionHandler'][hw_0x2870('0x176')]();this[hw_0x2870('0x1a5')]();this[hw_0x2870('0x1be')]=new _AutoRotation[(hw_0x2870('0x14a'))](this[hw_0x2870('0x14e')]['keyboardInputContentId'],this[hw_0x2870('0x14e')][hw_0x2870('0x95')],DEFAULT_ORIENTATION,this['options'][hw_0x2870('0x19c')],function(_0xb816e6){});this[hw_0x2870('0x1be')]['init']();this[hw_0x2870('0xec')]();}};var _0x5b27d7={};_0x5b27d7[hw_0x2870('0x106')]='triggerSubscribe';_0x5b27d7[hw_0x2870('0x17f')]=function _0x16a9cb(_0x137135,_0xca2375){this[hw_0x2870('0xa4')][hw_0x2870('0xd2')](_0x137135[hw_0x2870('0x1ca')],_0xca2375);};var _0x3990cb={};_0x3990cb[hw_0x2870('0x106')]=hw_0x2870('0x1a5');_0x3990cb['value']=function _0x4316e0(){var _0x5bd042=this;if(this[hw_0x2870('0x26')]){this[hw_0x2870('0xad')]=function(){_0x5bd042['player'][hw_0x2870('0x189')](hw_0x2870('0x1c3'),_0x5bd042[hw_0x2870('0xad')]);_0x5bd042['loadedmetadataCallback']=null;};this[hw_0x2870('0x19b')][hw_0x2870('0x5f')](hw_0x2870('0x1c3'),this[hw_0x2870('0xad')]);this[hw_0x2870('0x7c')]=function(){};this[hw_0x2870('0x19b')][hw_0x2870('0x5f')](hw_0x2870('0xf1'),this['videoResizeCallback']);}else{var _0x2123c2=window[hw_0x2870('0x17b')];this[hw_0x2870('0x46')]=new _0x2123c2(function(_0x2b4828){_0x2b4828['forEach'](function(_0x321645){if(_0x321645[hw_0x2870('0x113')]===hw_0x2870('0xfd')||_0x321645[hw_0x2870('0x113')]===hw_0x2870('0x146')){}});});var _0x890e5a={};_0x890e5a[hw_0x2870('0x163')]=!![];this[hw_0x2870('0x46')][hw_0x2870('0x11c')](this[hw_0x2870('0x19b')],_0x890e5a);}};var _0x3bc74c={};_0x3bc74c['key']=hw_0x2870('0x1b');_0x3bc74c[hw_0x2870('0x17f')]=function _0x383da3(_0x3e0fca){var _0x1ffcab=new Uint8Array(_0x3e0fca);var _0x5b0fee=_0x1ffcab[hw_0x2870('0x168')](function(_0x2d544c,_0x5630e9){return _0x2d544c+=String[hw_0x2870('0x160')][hw_0x2870('0xd9')](null,[_0x5630e9]);},'');return _0x5b0fee;};var _0x12a542={};_0x12a542['key']='onMessage';_0x12a542[hw_0x2870('0x17f')]=function _0x3816c7(_0x33e1f0,_0x57a8c3){this['lastReceivingTime']=_0x57a8c3;var _0x2b1b71=0x0;var _0x58e701=0x0;if(false){}this[hw_0x2870('0x7f')][hw_0x2870('0x88')](_0x33e1f0);if(false){ var _0x183419; }var _0x597046=this['frameParser'][hw_0x2870('0x119')](hw_0x2870('0x17d'));if(_0x597046&&this['playing']){var _0x2247f1={};_0x2247f1[hw_0x2870('0x1a')]=this['options'][hw_0x2870('0x2b')];_0x2247f1[hw_0x2870('0x5c')]=_0x597046;this[hw_0x2870('0x14e')][hw_0x2870('0x107')][hw_0x2870('0xd2')](hw_0x2870('0xa2'),_0x2247f1);this['play'](_0x597046);}var _0x4a96d7=this[hw_0x2870('0x50')];_0x4a96d7['kbitCount']+=(_0x33e1f0||[])['byteLength']/K_UNIT;if(this[hw_0x2870('0x7f')][hw_0x2870('0x119')](hw_0x2870('0xf8'))){this[hw_0x2870('0x85')]();}if(this['options']['supportAudio']&&this[hw_0x2870('0x132')]&&this['audioPlayer']){var _0x2387af=this[hw_0x2870('0x7f')][hw_0x2870('0x119')](hw_0x2870('0x58'));_0x2387af&&this['audioPlayer'][hw_0x2870('0x161')](_0x2387af);}var _0x531101=this[hw_0x2870('0x7f')][hw_0x2870('0x119')](hw_0x2870('0x152'));this['processCmdControlResp'](_0x531101);var _0x25b946=this[hw_0x2870('0x7f')][hw_0x2870('0x119')]('PhoneControl');this[hw_0x2870('0x134')](_0x25b946);var _0x50274b=this[hw_0x2870('0x7f')][hw_0x2870('0x119')](hw_0x2870('0x1af'));this[hw_0x2870('0x15c')](_0x50274b);var _0x3bfe2f=this['frameParser'][hw_0x2870('0x119')](hw_0x2870('0x16a'));this[hw_0x2870('0x182')](_0x3bfe2f);var _0x4f19ff=this['frameParser'][hw_0x2870('0x119')](hw_0x2870('0x1a7'));this[hw_0x2870('0x185')](_0x4f19ff);var _0x1bdaae=this[hw_0x2870('0x7f')][hw_0x2870('0x119')](hw_0x2870('0x39'));this[hw_0x2870('0x13b')](_0x1bdaae);var _0x46635e=this[hw_0x2870('0x7f')][hw_0x2870('0x119')]('Orientation');if(_0x46635e){var _0x2e9e62=_0x46635e&0xff;var _0x11ffa3=_protocolConfig[hw_0x2870('0x14a')][hw_0x2870('0x44')][_0x2e9e62];_Logger['default'][hw_0x2870('0xdf')](hw_0x2870('0x73')+_0x11ffa3);this[hw_0x2870('0xef')]=_0x2e9e62;this[hw_0x2870('0x34')]=_0x11ffa3;this[hw_0x2870('0xec')]();}var _0x197a0a=this[hw_0x2870('0x7f')][hw_0x2870('0x119')]('Channel');if(_0x197a0a){this[hw_0x2870('0x105')](_0x197a0a);}if(this['keyboardInput']&&!this[hw_0x2870('0x14e')][hw_0x2870('0xe5')]){this[hw_0x2870('0x102')][hw_0x2870('0x109')]();}var _0x306045=this[hw_0x2870('0x7f')]['shiftPackage']('KeyboardInput');if(_0x306045){this['processKeyboardInput'](_0x306045);}};var _0x4ce64e={};_0x4ce64e[hw_0x2870('0x106')]=hw_0x2870('0xec');_0x4ce64e[hw_0x2870('0x17f')]=function _0x304ef2(){if(this[hw_0x2870('0x19b')]&&this[hw_0x2870('0x34')]){if(this[hw_0x2870('0x14e')][hw_0x2870('0x19c')]){this['directionHandler']['updateMobileCanvasSize'](this[hw_0x2870('0x34')],this['isMSE']);}else{this[hw_0x2870('0x16c')][hw_0x2870('0x183')](this[hw_0x2870('0x34')],this[hw_0x2870('0x26')]);}}};var _0x18113a={};_0x18113a[hw_0x2870('0x106')]=hw_0x2870('0x85');_0x18113a['value']=function _0x29c29b(){if(this[hw_0x2870('0x50')][hw_0x2870('0x13c')]['length']>0x0){this[hw_0x2870('0x50')][hw_0x2870('0x12e')]=this[hw_0x2870('0xa7')]-this['networkInfo'][hw_0x2870('0x13c')][hw_0x2870('0x1cb')]();}if(this[hw_0x2870('0xa7')]!==this[hw_0x2870('0x50')][hw_0x2870('0xd6')]){this['networkInfo']['bitRate']=Math[hw_0x2870('0x186')](this[hw_0x2870('0x50')]['kbitCount']*K_BIT_UNIT/(this[hw_0x2870('0xa7')]-this[hw_0x2870('0x50')]['lastRefreshTime']));this['networkInfo'][hw_0x2870('0xd6')]=this[hw_0x2870('0xa7')];this[hw_0x2870('0x50')][hw_0x2870('0x175')]=0x0;}var _0x42e4e5={};_0x42e4e5['delay']=this[hw_0x2870('0x50')]['delay'];_0x42e4e5[hw_0x2870('0xdb')]=this[hw_0x2870('0x50')][hw_0x2870('0x2e')];this[hw_0x2870('0xa4')]['trigger'](hw_0x2870('0x133'),_0x42e4e5);};var _0x28021e={};_0x28021e[hw_0x2870('0x106')]='onError';_0x28021e[hw_0x2870('0x17f')]=function _0x375909(){this[hw_0x2870('0xa')]=APP_STATE_FROM_CLIENT[hw_0x2870('0xe9')];var _0x3bc416={};_0x3bc416[hw_0x2870('0x1a')]=this['options']['deviceId'];this[hw_0x2870('0x14e')][hw_0x2870('0x107')][hw_0x2870('0xd2')](hw_0x2870('0x48'),_objectSpread(_0x3bc416,this['appState']));};var _0x479cff={};_0x479cff[hw_0x2870('0x106')]=hw_0x2870('0x84');_0x479cff['value']=function _0xfce83e(){if(this[hw_0x2870('0x193')][hw_0x2870('0xfd')]===this[hw_0x2870('0x1cc')][hw_0x2870('0xfd')]&&this['curResolution'][hw_0x2870('0x146')]===this['nextResolution'][hw_0x2870('0x146')]){return;}this[hw_0x2870('0x193')]=this[hw_0x2870('0x1cc')];};var _0xa8475d={};_0xa8475d['key']=hw_0x2870('0x182');_0xa8475d[hw_0x2870('0x17f')]=function _0x43046e(_0x43cab3){var _0x118c82,_0x57af3d,_0x19bf65,_0xb5723b;if(!_0x43cab3){return;}var _0x2a85dc=new Uint8Array(_0x43cab3);this['microPhoneMsgHeader']=(_0x118c82=this[hw_0x2870('0xc8')])===null||_0x118c82===void 0x0?void 0x0:_0x118c82['getMsgHeader'](_0x2a85dc);if(_0x2a85dc[hw_0x2870('0xce')]>_commonConfig['MEDIA_MSG_HEADER_COUNT']){var _0x4ae18d;this[hw_0x2870('0x150')]=(_0x4ae18d=this[hw_0x2870('0xc8')])===null||_0x4ae18d===void 0x0?void 0x0:_0x4ae18d[hw_0x2870('0xb6')](_0x2a85dc[hw_0x2870('0xab')](_commonConfig['MEDIA_MSG_HEADER_COUNT']),hw_0x2870('0x67'));}var _0x2d488f=this['microPhoneMsgHeader'][hw_0x2870('0x10b')];switch(_0x2d488f){case this[hw_0x2870('0x94')]['OPT_MIC_SET_PARAM_REQ']:(_0x57af3d=this['deviceHardwareHandler'])===null||_0x57af3d===void 0x0||_0x57af3d[hw_0x2870('0xdd')](this[hw_0x2870('0x151')]);break;case this[hw_0x2870('0x94')][hw_0x2870('0x196')]:(_0x19bf65=this[hw_0x2870('0xc8')])===null||_0x19bf65===void 0x0||_0x19bf65['handleStartRecordReq'](this[hw_0x2870('0x150')]);break;case this[hw_0x2870('0x94')][hw_0x2870('0x91')]:(_0xb5723b=this['deviceHardwareHandler'])===null||_0xb5723b===void 0x0||_0xb5723b[hw_0x2870('0xbb')]();break;default:break;}};var _0x1b1e34={};_0x1b1e34['key']='cameraProcessResp';_0x1b1e34[hw_0x2870('0x17f')]=function _0x1594f8(_0xb4f306){var _0x107393,_0x533b03,_0x45eb54;if(!_0xb4f306){return;}var _0x138f76=new Uint8Array(_0xb4f306);this[hw_0x2870('0x4')]=(_0x107393=this[hw_0x2870('0xc8')])===null||_0x107393===void 0x0?void 0x0:_0x107393[hw_0x2870('0x19e')](_0x138f76);if(_0x138f76[hw_0x2870('0xce')]>_commonConfig['MEDIA_MSG_HEADER_COUNT']){var _0x207347;this[hw_0x2870('0x120')]=(_0x207347=this[hw_0x2870('0xc8')])===null||_0x207347===void 0x0?void 0x0:_0x207347[hw_0x2870('0xb6')](_0x138f76[hw_0x2870('0xab')](_commonConfig[hw_0x2870('0x19a')]),hw_0x2870('0x4c'));}var _0x1dbae2=this[hw_0x2870('0x4')][hw_0x2870('0x10b')];switch(_0x1dbae2){case this[hw_0x2870('0x164')][hw_0x2870('0x3b')]:break;case this[hw_0x2870('0x164')][hw_0x2870('0x64')]:break;case this[hw_0x2870('0x164')][hw_0x2870('0x173')]:break;case this['cameraMsgType'][hw_0x2870('0x5a')]:(_0x533b03=this[hw_0x2870('0xc8')])===null||_0x533b03===void 0x0||_0x533b03[hw_0x2870('0x63')](this['cameraMsgBody'],this[hw_0x2870('0x4')]);break;case this[hw_0x2870('0x164')][hw_0x2870('0x6d')]:(_0x45eb54=this[hw_0x2870('0xc8')])===null||_0x45eb54===void 0x0||_0x45eb54['handleStopPreviewReq'](this[hw_0x2870('0x4')]);break;case this[hw_0x2870('0x164')][hw_0x2870('0xb0')]:break;case this[hw_0x2870('0x164')][hw_0x2870('0xd7')]:break;default:break;}};var _0x42b3a7={};_0x42b3a7[hw_0x2870('0x106')]='sensorProcessResp';_0x42b3a7[hw_0x2870('0x17f')]=function _0x4008a2(_0x50c0ff){var _0x47b671,_0x2d598f,_0x472f6a;if(!_0x50c0ff){return;}var _0x24c38f=new Uint8Array(_0x50c0ff);this[hw_0x2870('0x1ba')]=(_0x47b671=this[hw_0x2870('0xc8')])===null||_0x47b671===void 0x0?void 0x0:_0x47b671['getMsgHeader'](_0x24c38f);var _0x48ef29=this[hw_0x2870('0x1ba')][hw_0x2870('0x10b')];switch(_0x48ef29){case this['sensorMsgType'][hw_0x2870('0x103')]:this[hw_0x2870('0x1bd')][hw_0x2870('0x5')](window,hw_0x2870('0x187'),(_0x2d598f=this[hw_0x2870('0xc8')])===null||_0x2d598f===void 0x0?void 0x0:_0x2d598f[hw_0x2870('0x1d0')][hw_0x2870('0x5')](this));this[hw_0x2870('0x1bd')]['bind'](window,hw_0x2870('0xe2'),(_0x472f6a=this[hw_0x2870('0xc8')])===null||_0x472f6a===void 0x0?void 0x0:_0x472f6a[hw_0x2870('0x100')][hw_0x2870('0x5')](this));break;case this[hw_0x2870('0x79')]['OPT_SENSOR_DISABLE_RSP']:this[hw_0x2870('0x1bd')][hw_0x2870('0xfc')](window,hw_0x2870('0x187'));this[hw_0x2870('0x1bd')][hw_0x2870('0xfc')](window,hw_0x2870('0xe2'));break;default:break;}};var _0x2336e4={};_0x2336e4['key']=hw_0x2870('0x13b');_0x2336e4[hw_0x2870('0x17f')]=function _0x26deb3(_0x43c5f8){var _0x25bdec,_0x135716,_0x5656e4;if(!_0x43c5f8){return;}var _0x3523f0=new Uint8Array(_0x43c5f8);this['gpsLocationMsgHeader']=(_0x25bdec=this[hw_0x2870('0xc8')])===null||_0x25bdec===void 0x0?void 0x0:_0x25bdec['getMsgHeader'](_0x3523f0);var _0xe31e98=this[hw_0x2870('0x47')][hw_0x2870('0x10b')];switch(_0xe31e98){case this[hw_0x2870('0x7')][hw_0x2870('0x130')]:(_0x135716=this[hw_0x2870('0xc8')])===null||_0x135716===void 0x0||_0x135716[hw_0x2870('0xf5')]();break;case this[hw_0x2870('0x7')][hw_0x2870('0x2c')]:(_0x5656e4=this[hw_0x2870('0xc8')])===null||_0x5656e4===void 0x0||_0x5656e4[hw_0x2870('0x5b')]();break;default:break;}};var _0x53cc5e={};_0x53cc5e[hw_0x2870('0x106')]=hw_0x2870('0x2a');_0x53cc5e[hw_0x2870('0x17f')]=function _0x36239f(_0x5e754b){if(!_0x5e754b){return;}var _0x5387a0=new Uint8Array(_0x5e754b);var _0x108879='';_0x5387a0[hw_0x2870('0x1c9')](function(_0x3cb7dc){_0x108879+=String[hw_0x2870('0x160')](_0x3cb7dc);});var _0x17bec6=this['params2JSON'](_0x108879);var _0xc74ed8=Number(_0x17bec6['code']);var _0x2dae53=_protocolConfig[hw_0x2870('0x14a')][hw_0x2870('0x1a8')];var _0x425be7=![];switch(_0xc74ed8){case _0x2dae53['CONNECT_FAILED']:case _0x2dae53[hw_0x2870('0x24')]:case _0x2dae53[hw_0x2870('0x52')]:_Logger['default'][hw_0x2870('0xdf')](hw_0x2870('0x13d'));this[hw_0x2870('0xbe')]();break;case _0x2dae53['PHONE_CONNECTED']:_Logger[hw_0x2870('0x14a')][hw_0x2870('0xdf')](hw_0x2870('0x1cf'));this[hw_0x2870('0xbe')]();break;case _0x2dae53[hw_0x2870('0xb')]:_Logger[hw_0x2870('0x14a')][hw_0x2870('0xdf')](hw_0x2870('0xe'));this['disconnect']();break;case _0x2dae53[hw_0x2870('0x8e')]:_Logger['default'][hw_0x2870('0xdf')](hw_0x2870('0x135'));this[hw_0x2870('0xbe')]();break;case _0x2dae53['PAUSE_TIMEOUT']:_Logger[hw_0x2870('0x14a')][hw_0x2870('0xdf')](hw_0x2870('0x16b'));this['disconnect']();break;case _0x2dae53[hw_0x2870('0x4f')]:_Logger[hw_0x2870('0x14a')][hw_0x2870('0xdf')](hw_0x2870('0x82'));this['updateResolution']();break;case _0x2dae53[hw_0x2870('0x81')]:this[hw_0x2870('0x5e')]();try{this[hw_0x2870('0x10d')]=JSON['parse'](_0x17bec6['msg']);}catch(_0x131184){this['recMediaConfig']={};}this[hw_0x2870('0x26')]=this[hw_0x2870('0x122')](this['recMediaConfig']['frame_type']);this[hw_0x2870('0xfa')]();this['updateResolution']();break;case _0x2dae53[hw_0x2870('0x12c')]:case _0x2dae53[hw_0x2870('0x33')]:case _0x2dae53[hw_0x2870('0x55')]:case _0x2dae53[hw_0x2870('0x199')]:if(this[hw_0x2870('0xa')][hw_0x2870('0x1c2')]===APP_STATE_FROM_CLIENT['reconnecting'][hw_0x2870('0x1c2')]){_Logger[hw_0x2870('0x14a')][hw_0x2870('0xdf')](hw_0x2870('0x154'));this[hw_0x2870('0xbe')]();_0x425be7=!![];}break;case _0x2dae53[hw_0x2870('0x147')]:this[hw_0x2870('0xa8')][hw_0x2870('0x18a')][hw_0x2870('0x1c')]=_commonConfig[hw_0x2870('0x5d')]['TYPE264'];this[hw_0x2870('0x9b')]();break;default:break;}var _0x4da753=APP_STATE_ERROR_CODE_TIP[_0x17bec6['code']];var _0x136127={};_0x136127['state']=Number(_0x17bec6['code']);_0x136127[hw_0x2870('0x141')]=_0x17bec6['msg'];_0x136127[hw_0x2870('0xda')]=_0x4da753;this['appState']=_0x136127;var _0x31f511={};_0x31f511['phoneId']=this['options'][hw_0x2870('0x2b')];this[hw_0x2870('0x14e')][hw_0x2870('0x107')][hw_0x2870('0xd2')](hw_0x2870('0x48'),_objectSpread(_0x31f511,this[hw_0x2870('0xa')]));if(_0x425be7){this[hw_0x2870('0xa')]=APP_STATE_FROM_CLIENT[hw_0x2870('0x7d')];var _0x4647cb={};_0x4647cb[hw_0x2870('0x1a')]=this[hw_0x2870('0x14e')][hw_0x2870('0x2b')];this[hw_0x2870('0x14e')]['topSubscribe'][hw_0x2870('0xd2')](hw_0x2870('0x48'),_objectSpread(_0x4647cb,this[hw_0x2870('0xa')]));}};var _0x584d82={};_0x584d82[hw_0x2870('0x106')]=hw_0x2870('0x134');_0x584d82[hw_0x2870('0x17f')]=function _0x588e0a(_0x2272f9){if(!_0x2272f9){return;}var _0x1f7139=new Uint8Array(_0x2272f9);if(!_0x1f7139['length']){return;}var _0x3de7b5=_0x1f7139[0x0];var _0x5523f0=_protocolConfig[hw_0x2870('0x14a')][hw_0x2870('0x139')][_0x3de7b5];if(_0x5523f0){_Logger[hw_0x2870('0x14a')][hw_0x2870('0xdf')](_0x5523f0[hw_0x2870('0x141')]);this[hw_0x2870('0xa')]=_0x5523f0;var _0x306e3d={};_0x306e3d[hw_0x2870('0x1a')]=this[hw_0x2870('0x14e')][hw_0x2870('0x2b')];this[hw_0x2870('0x14e')][hw_0x2870('0x107')]['trigger'](hw_0x2870('0x48'),_objectSpread(_0x306e3d,this[hw_0x2870('0xa')]));}};var _0x2527b0={};_0x2527b0[hw_0x2870('0x106')]=hw_0x2870('0x105');_0x2527b0[hw_0x2870('0x17f')]=function _0x599fd4(_0x514ca6){this['subscribe'][hw_0x2870('0xd2')]('cloudAppData',_0x514ca6[hw_0x2870('0x11a')]);};var _0x4c03cc={};_0x4c03cc[hw_0x2870('0x106')]=hw_0x2870('0x166');_0x4c03cc[hw_0x2870('0x17f')]=function _0x1235d8(_0x33878e){if((_0x33878e===null||_0x33878e===void 0x0?void 0x0:_0x33878e['length'])<_protocolConfig[hw_0x2870('0x14a')][hw_0x2870('0x15e')]){return;}var _0x39304e=_slicedToArray(_0x33878e,0x3),_0x149246=_0x39304e[0x0],_0x1381d4=_0x39304e[0x1],_0x255240=_0x39304e[0x2];if(_0x149246===_protocolConfig[hw_0x2870('0x14a')][hw_0x2870('0x16')][hw_0x2870('0x9')]){var _0x488d20=(_0x1381d4<<0x8)+_0x255240;var _0x3cb708=_0x488d20>0x0?this[hw_0x2870('0x1bd')]['decodeUTF8'](_0x33878e,_protocolConfig['default'][hw_0x2870('0x15e')],_protocolConfig[hw_0x2870('0x14a')][hw_0x2870('0x15e')]+_0x488d20):'';this[hw_0x2870('0xa4')]['trigger'](hw_0x2870('0x145'),_0x3cb708);}};var _0x5a31e3={};_0x5a31e3[hw_0x2870('0x106')]=hw_0x2870('0x17e');_0x5a31e3['value']=function _0x29c1de(_0x40f083){this['networkInfo']['heartBeatSendTimes'][hw_0x2870('0xce')]<=this[hw_0x2870('0x50')][hw_0x2870('0x1d1')]&&this[hw_0x2870('0x50')][hw_0x2870('0x13c')][hw_0x2870('0xdc')](_0x40f083);};var _0x13fa7b={};_0x13fa7b['key']='tryReconnect';_0x13fa7b[hw_0x2870('0x17f')]=function _0x52c89a(_0x10b493){var _0x198d38=this;var _0x4ba191=this[hw_0x2870('0x29')];_0x4ba191[hw_0x2870('0x3f')]=!![];_0x4ba191[hw_0x2870('0xd2')]=_0x10b493;if(_0x4ba191['can']&&_0x4ba191[hw_0x2870('0x184')]<_0x4ba191[hw_0x2870('0x180')]){_0x4ba191['count']++;_0x4ba191[hw_0x2870('0x9a')]&&clearTimeout(_0x4ba191[hw_0x2870('0x9a')]);this[hw_0x2870('0xa')]=this['socketHasOpenned']?APP_STATE_FROM_CLIENT[hw_0x2870('0x3f')]:APP_STATE_FROM_CLIENT[hw_0x2870('0x170')];var _0x20cb79={};_0x20cb79[hw_0x2870('0x1a')]=this[hw_0x2870('0x14e')]['deviceId'];this[hw_0x2870('0x14e')]['topSubscribe'][hw_0x2870('0xd2')]('appStateChange',_objectSpread(_0x20cb79,this[hw_0x2870('0xa')]));_0x4ba191[hw_0x2870('0x9a')]=setTimeout(function(){_0x198d38[hw_0x2870('0xcc')]();},_0x4ba191[hw_0x2870('0xc2')]);}if(_0x4ba191['maxTimes']===0x0&&this[hw_0x2870('0xa')][hw_0x2870('0x1c2')]===APP_STATE_FROM_CLIENT[hw_0x2870('0x128')][hw_0x2870('0x1c2')]){this['appState']=APP_STATE_FROM_CLIENT[hw_0x2870('0x7d')];var _0x24b3db={};_0x24b3db['phoneId']=this[hw_0x2870('0x14e')][hw_0x2870('0x2b')];this[hw_0x2870('0x14e')][hw_0x2870('0x107')][hw_0x2870('0xd2')](hw_0x2870('0x48'),_objectSpread(_0x24b3db,this[hw_0x2870('0xa')]));}};var _0x22b639={};_0x22b639[hw_0x2870('0x106')]=hw_0x2870('0x1ad');_0x22b639[hw_0x2870('0x17f')]=function _0x40ab3a(_0x5c3f37,_0x352c89){this[hw_0x2870('0x1a4')]=_0x5c3f37;this[hw_0x2870('0x50')][hw_0x2870('0x13c')]=[];_Logger[hw_0x2870('0x14a')][hw_0x2870('0xdf')](hw_0x2870('0xb8')+_0x352c89);this['tryReconnect'](_0x352c89);if(this['keyboardInput']){this[hw_0x2870('0x102')]['blurInput']();}};var _0xe3af96={};_0xe3af96['key']=hw_0x2870('0x14d');_0xe3af96[hw_0x2870('0x17f')]=function _0x554145(_0x4658bd){return _0x4658bd+(CAE_STREAM_DELIMITER_MAGICWORD>>0x8&0xff)+(CAE_STREAM_DELIMITER_MAGICWORD&0xff)&0xff;};var _0xbdc244={};_0xbdc244['key']='paramsSerialize';_0xbdc244[hw_0x2870('0x17f')]=function _0x41a0d1(_0x53daf5){if(_0x53daf5){var _0x51f485=Object['keys'](_0x53daf5)[hw_0x2870('0x12a')](function(_0x2f3162){var _0x3d8fd2=_0x53daf5[_0x2f3162];if(_0x2f3162===hw_0x2870('0x1b8')){return[_0x2f3162,_0x3d8fd2]['join']('=');}if(_typeof(_0x3d8fd2)===hw_0x2870('0x1b5')){_0x3d8fd2=Object[hw_0x2870('0x156')](_0x3d8fd2)[hw_0x2870('0x12a')](function(_0x36398e){return[_0x36398e,encodeURIComponent(_0x3d8fd2[_0x36398e])]['join']('=');})[hw_0x2870('0xa9')](':');return[_0x2f3162,_0x3d8fd2][hw_0x2870('0xa9')]('=');}return[_0x2f3162,encodeURIComponent(_0x3d8fd2)][hw_0x2870('0xa9')]('=');});return _0x51f485[hw_0x2870('0xa9')]('&');}return'';};var _0x46a1e1={};_0x46a1e1[hw_0x2870('0x106')]=hw_0x2870('0x108');_0x46a1e1[hw_0x2870('0x17f')]=function _0x2d293c(){var _0x22d5a8=arguments['length']>0x0&&arguments[0x0]!==undefined?arguments[0x0]:'';var _0x4445d4={};_0x22d5a8[hw_0x2870('0x10')]('&')['forEach'](function(_0x5b4787){var _0x57db57=_0x5b4787[hw_0x2870('0x10')]('='),_0x1cb626=_slicedToArray(_0x57db57,0x2),_0x3f99fc=_0x1cb626[0x0],_0x201029=_0x1cb626[0x1];_0x4445d4[_0x3f99fc]=_0x201029;});return _0x4445d4;};var _0x2cd558={};_0x2cd558[hw_0x2870('0x106')]='sendMediaData';_0x2cd558[hw_0x2870('0x17f')]=function _0x4a798e(_0x376b48,_0x52101c,_0x41636a){var _0x1c95b0=arguments[hw_0x2870('0xce')]>0x3&&arguments[0x3]!==undefined?arguments[0x3]:null;var _0x2cf91e=this[hw_0x2870('0x124')](_0x52101c,_0x41636a,_0x376b48,_0x1c95b0);var _0x3bff35=this[hw_0x2870('0x8f')](_0x376b48,_0x2cf91e);_0x3bff35&&this[hw_0x2870('0xee')](_0x3bff35);};var _0x56cefc={};_0x56cefc[hw_0x2870('0x106')]=hw_0x2870('0x110');_0x56cefc['value']=function _0x28fc01(_0x4b1019,_0x30be60,_0x854154){_0x4b1019[0x0]=0x5a;_0x4b1019[0x1]=0x5a;_0x4b1019[0x2]=this[hw_0x2870('0x14d')](_protocolConfig[hw_0x2870('0x14a')][hw_0x2870('0x77')][_0x30be60]);_0x4b1019[0x3]=_protocolConfig[hw_0x2870('0x14a')]['MSG_TYPE'][_0x30be60];_0x4b1019[0x4]=_0x854154>>0x18;_0x4b1019[0x5]=_0x854154>>0x10;_0x4b1019[0x6]=_0x854154>>0x8;_0x4b1019[0x7]=_0x854154;};var _0xb034e={};_0xb034e[hw_0x2870('0x106')]='makeMediaData';_0xb034e[hw_0x2870('0x17f')]=function _0x3c8841(_0x26f1d8,_0x2dac32,_0x3b4bdc){var _0x3f8f83=arguments[hw_0x2870('0xce')]>0x3&&arguments[0x3]!==undefined?arguments[0x3]:null;var _0x31c9c2=_0x2dac32[hw_0x2870('0xe0')];var _0x385853=new Uint8Array(_commonConfig[hw_0x2870('0x19a')]+_0x31c9c2);_0x385853['set'](new Uint8Array(_0x2dac32),_commonConfig['MEDIA_MSG_HEADER_COUNT']);if(_0x3b4bdc==='SENSOR'){var _0x165bfb;(_0x165bfb=this[hw_0x2870('0xc8')])===null||_0x165bfb===void 0x0||_0x165bfb[hw_0x2870('0x66')](_0x385853,_0x26f1d8,_0x385853[hw_0x2870('0xce')],_0x3f8f83);}else if(_0x3b4bdc===hw_0x2870('0x39')){var _0x339169;(_0x339169=this['deviceHardwareHandler'])===null||_0x339169===void 0x0||_0x339169[hw_0x2870('0xd1')](_0x385853,_0x26f1d8,_0x385853[hw_0x2870('0xce')]);}else{var _0x358e4c;(_0x358e4c=this[hw_0x2870('0xc8')])===null||_0x358e4c===void 0x0||_0x358e4c[hw_0x2870('0xf0')](_0x385853,_0x26f1d8,_0x385853[hw_0x2870('0xce')],_0x3b4bdc);}return _0x385853;};var _0x2cac86={};_0x2cac86[hw_0x2870('0x106')]=hw_0x2870('0x6');_0x2cac86[hw_0x2870('0x17f')]=function _0xa44efb(_0x3845be,_0x252f9c){var _0x38a7a0=arguments[hw_0x2870('0xce')]>0x2&&arguments[0x2]!==undefined?arguments[0x2]:{};var _0x240f0e=_objectSpread({},_protocolConfig[hw_0x2870('0x14a')]['CMD_TYPE']);var _0x4177a6={};_0x4177a6[hw_0x2870('0x123')]=_0x240f0e[_0x252f9c];var _0x2ff414=this[hw_0x2870('0x140')](_objectSpread(_0x4177a6,_0x38a7a0));var _0x30a714=_0x2ff414[hw_0x2870('0xce')];var _0x25c3e3=new Uint8Array(_commonConfig[hw_0x2870('0x92')]+_0x30a714);for(var _0x24006c=0x0;_0x24006c<_0x30a714;_0x24006c++){_0x25c3e3[_commonConfig[hw_0x2870('0x92')]+_0x24006c]=_0x2ff414[hw_0x2870('0x15')](_0x24006c);}this[hw_0x2870('0x110')](_0x25c3e3,_0x3845be,_0x30a714);return _0x25c3e3[hw_0x2870('0x11a')];};var _0x1cc0f6={};_0x1cc0f6[hw_0x2870('0x106')]=hw_0x2870('0x8f');_0x1cc0f6[hw_0x2870('0x17f')]=function _0x472bcc(_0x3fc708,_0xc2830c){var _0x4714fc=_0xc2830c[hw_0x2870('0xe0')];var _0x38495b=new Uint8Array(_commonConfig[hw_0x2870('0x92')]+_0x4714fc);_0x38495b['set'](new Uint8Array(_0xc2830c),_commonConfig[hw_0x2870('0x92')]);this[hw_0x2870('0x110')](_0x38495b,_0x3fc708,_0x4714fc);return _0x38495b[hw_0x2870('0x11a')];};var _0x2c9ea8={};_0x2c9ea8[hw_0x2870('0x106')]=hw_0x2870('0x16d');_0x2c9ea8['value']=function _0x3242d1(_0x3becd1){this[hw_0x2870('0x18c')]['decode'](_0x3becd1);};var _0x204097={};_0x204097[hw_0x2870('0x106')]='verifiedData';_0x204097[hw_0x2870('0x17f')]=function _0x356605(){var _0x16b604=this['options'];var _0x50a892={};_0x50a892['ip']=_0x16b604[hw_0x2870('0x4d')];_0x50a892[hw_0x2870('0x1d3')]=_0x16b604[hw_0x2870('0xbc')];_0x50a892[hw_0x2870('0x51')]=this[hw_0x2870('0xd5')];_0x50a892['backgroundTimeout']=_0x16b604['backgroundTimeout'];_0x50a892[hw_0x2870('0x1a0')]=_0x16b604[hw_0x2870('0xb2')];_0x50a892['user_id']=_0x16b604['userId'];return _0x50a892;};var _0x1d762a={};_0x1d762a[hw_0x2870('0x106')]=hw_0x2870('0x69');_0x1d762a[hw_0x2870('0x17f')]=function _0xbb420f(_0x39558b,_0x298ebe,_0xfbec66){var _0x5a0b41={};_0x5a0b41['fps']=0xa;_0x5a0b41[hw_0x2870('0x1c')]=this['options'][hw_0x2870('0x129')]?this['options']['decoderType'][hw_0x2870('0x1')]():_commonConfig[hw_0x2870('0x5d')][hw_0x2870('0x42')];_0x5a0b41[hw_0x2870('0x137')]=_protocolConfig[hw_0x2870('0x14a')][_commonConfig[hw_0x2870('0x138')]]['quality'];var _0x1a4805={};_0x1a4805[hw_0x2870('0x1b8')]=this[hw_0x2870('0x14e')]['ticket'];_0x1a4805[hw_0x2870('0x51')]=this['sessionId'];_0x1a4805['auth_ts']=this['options'][hw_0x2870('0x17a')];_0x1a4805[hw_0x2870('0x1a2')]=_0x298ebe;_0x1a4805['encrypted_data']=_0x39558b;_0x1a4805['aes_iv']=_0xfbec66;_0x1a4805[hw_0x2870('0x131')]=this[hw_0x2870('0x14e')][hw_0x2870('0x65')];_0x1a4805['protocol_version']='v2';_0x1a4805[hw_0x2870('0x3a')]=this['options'][hw_0x2870('0x19c')]&&!this[hw_0x2870('0x1b7')]()?'4':'3';_0x1a4805[hw_0x2870('0x18a')]=_objectSpread(_objectSpread({},this[hw_0x2870('0x14e')]['mediaConfig']),{},_0x5a0b41);this[hw_0x2870('0xa8')]=_0x1a4805;console[hw_0x2870('0x142')](this[hw_0x2870('0xa8')],hw_0x2870('0x153'));if(this[hw_0x2870('0x14e')][hw_0x2870('0x19c')]){this[hw_0x2870('0xa8')][hw_0x2870('0x11e')]=this[hw_0x2870('0x14e')][hw_0x2870('0x14f')];}if(this[hw_0x2870('0xa8')][hw_0x2870('0x18a')][hw_0x2870('0x18f')]&&this[hw_0x2870('0xa8')]['media_config'][hw_0x2870('0x87')]){var _0x10506b={};_0x10506b[hw_0x2870('0xfd')]=this['startParams'][hw_0x2870('0x18a')]['physical_width'];_0x10506b['height']=this[hw_0x2870('0xa8')][hw_0x2870('0x18a')]['physical_height'];this[hw_0x2870('0x1cc')]=_0x10506b;}};var _0x5bdf46={};_0x5bdf46[hw_0x2870('0x106')]=hw_0x2870('0x109');_0x5bdf46[hw_0x2870('0x17f')]=function _0x190272(){var _0xf00248=this;var _0x27f609=new _AESGCMCrypto[(hw_0x2870('0x14a'))]();var _0x6c98e3=_0x27f609['iv']();var _0x8e4dcf=this[hw_0x2870('0xcb')]();var _0x598cb7={};_0x598cb7[hw_0x2870('0xb3')]=this[hw_0x2870('0x14e')][hw_0x2870('0x174')];var _0xff6ea9=_objectSpread(_objectSpread({},_0x8e4dcf),{},_0x598cb7);Promise['all']([_0x27f609[hw_0x2870('0x19f')](JSON['stringify'](_0xff6ea9),this[hw_0x2870('0x14e')][hw_0x2870('0x162')],_0x6c98e3),_0x27f609[hw_0x2870('0x68')](Object['values'](_0x8e4dcf)[hw_0x2870('0xa9')](''))])['then'](function(_0x5e3267){var _0x3710d8=_slicedToArray(_0x5e3267,0x2),_0x2911bf=_0x3710d8[0x0],_0x94762a=_0x3710d8[0x1];_0xf00248[hw_0x2870('0x69')](_0x2911bf,_0x94762a,_0x6c98e3);if(_0x2911bf){_0xf00248[hw_0x2870('0xa')]=APP_STATE_FROM_CLIENT[hw_0x2870('0x170')];_0xf00248['options'][hw_0x2870('0x107')][hw_0x2870('0xd2')](hw_0x2870('0x48'),_objectSpread({'phoneId':_0xf00248[hw_0x2870('0x14e')][hw_0x2870('0x2b')]},_0xf00248[hw_0x2870('0xa')]));_0xf00248['connect']();}});};var _0xb45940={};_0xb45940[hw_0x2870('0x106')]='connect';_0xb45940[hw_0x2870('0x17f')]=function _0x3f5bf4(){if(!this[hw_0x2870('0x14e')]['connectURI']){return;}this[hw_0x2870('0x59')](this['options'][hw_0x2870('0x3c')]);};var _0x51439b={};_0x51439b[hw_0x2870('0x106')]=hw_0x2870('0x5e');_0x51439b[hw_0x2870('0x17f')]=function _0x1c4948(){this[hw_0x2870('0x132')]=!![];};var _0x3588d8={};_0x3588d8[hw_0x2870('0x106')]='stopPlay';_0x3588d8['value']=function _0x1f5681(){this['playing']=![];};var _0x16b304={};_0x16b304[hw_0x2870('0x106')]='initPlayer';_0x16b304[hw_0x2870('0x17f')]=function _0x459b2e(){if(this[hw_0x2870('0x26')]){var _0x5b6030=document[hw_0x2870('0x1c0')](hw_0x2870('0x177'));_0x5b6030['id']=this[hw_0x2870('0x1c4')];_0x5b6030[hw_0x2870('0x89')]=!![];_0x5b6030[hw_0x2870('0x10a')]=!![];_0x5b6030[hw_0x2870('0xc5')]=!![];_0x5b6030[hw_0x2870('0x83')]=![];this[hw_0x2870('0x19b')]=_0x5b6030;}else{this[hw_0x2870('0x18c')]=new _CanvasPlayer['default'](this['options']);this['player']=this[hw_0x2870('0x18c')][hw_0x2870('0x143')];}if(this[hw_0x2870('0x26')]){this[hw_0x2870('0x23')]=this[hw_0x2870('0x15d')];this[hw_0x2870('0x28')]();}else{this[hw_0x2870('0x23')]=this[hw_0x2870('0x20')];}};var _0x732d6d={};_0x732d6d['key']='__msePlay';_0x732d6d[hw_0x2870('0x17f')]=function _0x57242c(_0x2de187){if(false){ var _0x791b6e, _0x276ea8; }if(this['firstIFrame']){this[hw_0x2870('0x72')]();this[hw_0x2870('0x16e')]=![];return;}};var _0x3cef25={};_0x3cef25[hw_0x2870('0x106')]=hw_0x2870('0x20');_0x3cef25[hw_0x2870('0x17f')]=function _0xf572e4(_0x5b74eb){this[hw_0x2870('0x16d')](_0x5b74eb);};var _0x582a88={};_0x582a88[hw_0x2870('0x106')]=hw_0x2870('0x28');_0x582a88[hw_0x2870('0x17f')]=function _0x1c04b9(){var _0x988fb7=this['player'];var _0x48a0c9=function _0x3b25e5(){if(_0x988fb7[hw_0x2870('0x22')]&&_0x988fb7[hw_0x2870('0x22')][hw_0x2870('0xce')]&&_0x988fb7[hw_0x2870('0x22')][hw_0x2870('0xff')](0x0)){_0x988fb7[hw_0x2870('0x31')]=_0x988fb7['buffered'][hw_0x2870('0xff')](0x0);}_0x988fb7[hw_0x2870('0x189')](hw_0x2870('0x1b3'),_0x48a0c9);};_0x988fb7[hw_0x2870('0x5f')](hw_0x2870('0x1b3'),_0x48a0c9);};var _0x236196={};_0x236196[hw_0x2870('0x106')]=hw_0x2870('0xbe');_0x236196[hw_0x2870('0x17f')]=function _0x513b96(_0x5bea7b){var _0x21d89f=this;this[hw_0x2870('0x29')][hw_0x2870('0x17')]=![];this['stopCloudPhone']();this[hw_0x2870('0xf6')]();setTimeout(function(){_0x21d89f[hw_0x2870('0x8d')]();if(_0x5bea7b){_0x5bea7b();}},0x3e8);};var _0x294f44={};_0x294f44[hw_0x2870('0x106')]=hw_0x2870('0xcc');_0x294f44[hw_0x2870('0x17f')]=function _0x117906(){this[hw_0x2870('0x12d')]=this['socketHasOpenned']?hw_0x2870('0xcc'):hw_0x2870('0x157');this[hw_0x2870('0x157')]();};var _0x29d6f4={};_0x29d6f4[hw_0x2870('0x106')]='_reconnect';_0x29d6f4[hw_0x2870('0x17f')]=function _0x1c2775(){var _0x14fb81={};_0x14fb81[hw_0x2870('0x51')]=this['sessionId'];var _0x37ef2d=this['makeActionMsg'](hw_0x2870('0x4e'),hw_0x2870('0x98'),_0x14fb81);_0x37ef2d&&this[hw_0x2870('0xee')](_0x37ef2d);};var _0x2bc42e={};_0x2bc42e[hw_0x2870('0x106')]=hw_0x2870('0x9b');_0x2bc42e['value']=function _0x4df960(){console['log'](hw_0x2870('0x6e'));var _0x22bbd4=this[hw_0x2870('0x6')](hw_0x2870('0x4e'),hw_0x2870('0x1a3'),this['startParams']);_0x22bbd4&&this[hw_0x2870('0xee')](_0x22bbd4);};var _0x572a0d={};_0x572a0d[hw_0x2870('0x106')]='stopCloudPhone';_0x572a0d['value']=function _0x3476da(){var _0x4686e2=this[hw_0x2870('0x6')](hw_0x2870('0x4e'),hw_0x2870('0x13f'));_0x4686e2&&this[hw_0x2870('0xee')](_0x4686e2);};var _0x4eca3e={};_0x4eca3e[hw_0x2870('0x106')]=hw_0x2870('0xd4');_0x4eca3e['value']=function _0x41c48a(){var _0x228709;(_0x228709=this[hw_0x2870('0xc8')])===null||_0x228709===void 0x0||_0x228709[hw_0x2870('0xa3')]();};var _0xbeb770={};_0xbeb770[hw_0x2870('0x106')]=hw_0x2870('0x9f');_0xbeb770[hw_0x2870('0x17f')]=function _0x26fb08(){var _0xaee351;(_0xaee351=this[hw_0x2870('0xc8')])===null||_0xaee351===void 0x0||_0xaee351['resumeDevice']();};var _0x1a02dc={};_0x1a02dc[hw_0x2870('0x106')]=hw_0x2870('0x195');_0x1a02dc[hw_0x2870('0x17f')]=function _0x4456db(){var _0xd81ba6=this[hw_0x2870('0x6')](hw_0x2870('0x4e'),hw_0x2870('0x1b2'));_0xd81ba6&&this[hw_0x2870('0xee')](_0xd81ba6);};var _0x1c3d2b={};_0x1c3d2b[hw_0x2870('0x106')]='requestIFrame';_0x1c3d2b['value']=function _0x4f24bd(){var _0x5aa4dc=this[hw_0x2870('0x6')]('CMD_CONTROL',hw_0x2870('0x13'));_0x5aa4dc&&this[hw_0x2870('0xee')](_0x5aa4dc);};var _0x14a298={};_0x14a298[hw_0x2870('0x106')]=hw_0x2870('0x27');_0x14a298[hw_0x2870('0x17f')]=function _0x3d8cec(){this[hw_0x2870('0x7f')][hw_0x2870('0xe4')](hw_0x2870('0x17d'));if(this[hw_0x2870('0x26')]&&this[hw_0x2870('0x19b')]['buffered']&&this['player'][hw_0x2870('0x22')][hw_0x2870('0xce')]&&this[hw_0x2870('0x19b')][hw_0x2870('0x22')]['end'](0x0)){this[hw_0x2870('0x19b')]['currentTime']=this['player'][hw_0x2870('0x22')][hw_0x2870('0xff')](0x0);}this[hw_0x2870('0x1c1')]();};var _0x305cb3={};_0x305cb3[hw_0x2870('0x106')]=hw_0x2870('0x1c1');_0x305cb3[hw_0x2870('0x17f')]=function _0x1f353d(){var _0x4a90dc={};_0x4a90dc['session_id']=this[hw_0x2870('0xd5')];var _0x2652be=this[hw_0x2870('0x6')](hw_0x2870('0x4e'),hw_0x2870('0x1d2'),_0x4a90dc);_0x2652be&&this[hw_0x2870('0xee')](_0x2652be);};var _0x3affb8={};_0x3affb8[hw_0x2870('0x106')]=hw_0x2870('0x198');_0x3affb8['value']=function _0x53fc1e(_0x42faea){var _0x652683=_protocolConfig[hw_0x2870('0x14a')][_0x42faea];if(this[hw_0x2870('0xa8')][hw_0x2870('0x18a')]&&this[hw_0x2870('0xa8')]['media_config'][hw_0x2870('0xdb')]){_0x652683[hw_0x2870('0xdb')]=this['startParams'][hw_0x2870('0x18a')]['bitrate'];}this['setMediaConfig'](_0x652683);};var _0x121fa5={};_0x121fa5[hw_0x2870('0x106')]=hw_0x2870('0x191');_0x121fa5[hw_0x2870('0x17f')]=function _0x127e34(){var _0x18095a=arguments['length']>0x0&&arguments[0x0]!==undefined?arguments[0x0]:{};var _0x43f1aa={};_0x43f1aa['media_config']=_0x18095a;var _0xcefb5b=this[hw_0x2870('0x6')](hw_0x2870('0x4e'),hw_0x2870('0xc4'),_0x43f1aa);console['log'](hw_0x2870('0x191'),_0x18095a);_0xcefb5b&&this[hw_0x2870('0xee')](_0xcefb5b);if(_0x18095a[hw_0x2870('0x117')]&&_0x18095a['virtual_height']){var _0x4f3db0={};_0x4f3db0['width']=_0x18095a['virtual_width'];_0x4f3db0['height']=_0x18095a[hw_0x2870('0xc1')];this[hw_0x2870('0x1cc')]=_0x4f3db0;}};var _0x2e3ca7={};_0x2e3ca7[hw_0x2870('0x106')]=hw_0x2870('0x12b');_0x2e3ca7[hw_0x2870('0x17f')]=function _0x3e19a0(_0x36dd3a){this[hw_0x2870('0x1bf')]&&this[hw_0x2870('0x1bf')]['terminate']();this[hw_0x2870('0x1ae')]();this['onClose'](WEBSOCKET_READY_STATE[hw_0x2870('0x190')],_0x36dd3a);};var _0x3baa3f={};_0x3baa3f[hw_0x2870('0x106')]='checkAndRecoverSocket';_0x3baa3f[hw_0x2870('0x17f')]=function _0x475639(_0x147288){var _0xf280c1=this;this[hw_0x2870('0xed')]();setTimeout(function(){if(!_0xf280c1[hw_0x2870('0x29')][hw_0x2870('0x3f')]&&!_0xf280c1[hw_0x2870('0x90')]()){_0xf280c1[hw_0x2870('0x12b')](_0x147288);}},0xc8);};var _0x47731e={};_0x47731e[hw_0x2870('0x106')]='listenPageVisibility';_0x47731e[hw_0x2870('0x17f')]=function _0x51045e(){var _0x307321=this;var _0xdc8f9;if(typeof document[hw_0x2870('0x56')]!=='undefined'){_0xdc8f9=hw_0x2870('0x56');this[hw_0x2870('0xba')]=hw_0x2870('0x32');}else if(typeof document[hw_0x2870('0x40')]!==hw_0x2870('0x144')){_0xdc8f9=hw_0x2870('0x40');this[hw_0x2870('0xba')]=hw_0x2870('0x78');}else if(typeof document[hw_0x2870('0xcd')]!==hw_0x2870('0x144')){_0xdc8f9=hw_0x2870('0xcd');this[hw_0x2870('0xba')]=hw_0x2870('0xbd');}this[hw_0x2870('0xcf')]=function(){if(document[_0xdc8f9]){_Logger[hw_0x2870('0x14a')]['debug'](hw_0x2870('0x7e'));_0x307321[hw_0x2870('0xd4')]();_0x307321[hw_0x2870('0x195')]();}else if(_0x307321[hw_0x2870('0x1a4')]===WEBSOCKET_READY_STATE[hw_0x2870('0x43')]){_Logger[hw_0x2870('0x14a')][hw_0x2870('0xdf')](hw_0x2870('0x76'));_0x307321[hw_0x2870('0x9f')]();_0x307321[hw_0x2870('0x27')]();_0x307321[hw_0x2870('0xa5')](hw_0x2870('0xba'));}};if(typeof document[_0xdc8f9]!==hw_0x2870('0x144')){}};var _0x194240={};_0x194240['key']=hw_0x2870('0x71');_0x194240[hw_0x2870('0x17f')]=function _0x2ef955(){var _0x3a1245=this;var _0x36d305=![];window[hw_0x2870('0x5f')](hw_0x2870('0x158'),function(){if(_0x36d305){_0x36d305=![];_0x3a1245[hw_0x2870('0xa5')](hw_0x2870('0x158'));}});window[hw_0x2870('0x5f')](hw_0x2870('0xac'),function(){_0x36d305=!![];});};var _0x2f3173={};_0x2f3173[hw_0x2870('0x106')]='on';_0x2f3173[hw_0x2870('0x17f')]=function _0x1245f5(_0x40874b,_0xbb6cf4){this[hw_0x2870('0xa4')]['on'](_0x40874b,_0xbb6cf4);};var _0x17c1ac={};_0x17c1ac[hw_0x2870('0x106')]=hw_0x2870('0x127');_0x17c1ac[hw_0x2870('0x17f')]=function _0x4460b4(_0x6505d,_0x432bb8){this[hw_0x2870('0xa4')][hw_0x2870('0x127')](_0x6505d,_0x432bb8);};var _0x21434e={};_0x21434e[hw_0x2870('0x106')]=hw_0x2870('0xe1');_0x21434e[hw_0x2870('0x17f')]=function _0x149ffe(){return hw_0x2870('0x1b0')['replace'](/[xy]/g,function(_0x2d7736){var _0x25f472=_AESGCMCrypto[hw_0x2870('0x14a')]['getRandomValue']()*0x10|0x0;var _0x48b3c9=_0x2d7736==='x'?_0x25f472:_0x25f472&0x3|0x8;return _0x48b3c9[hw_0x2870('0xf3')](0x10);});};var _0x2fdb32={};_0x2fdb32[hw_0x2870('0x106')]=hw_0x2870('0x1b7');_0x2fdb32[hw_0x2870('0x17f')]=function _0x151ae2(){var _0x3a4637=navigator&&navigator[hw_0x2870('0x1ac')]||'';var _0xc2a9af=Object[hw_0x2870('0x53')](_canvasWhiteList[hw_0x2870('0x14a')])['some'](function(_0x3c5b0d){return _0x3a4637[hw_0x2870('0xfe')](_0x3c5b0d);});var _0x27c46a=Boolean(window[hw_0x2870('0x171')]||window[hw_0x2870('0x15a')]||window[hw_0x2870('0x11')]||window['oppoUrlQuery']);return _0xc2a9af||_0x27c46a;};var _0x9fa5a7={};_0x9fa5a7[hw_0x2870('0x106')]=hw_0x2870('0x122');_0x9fa5a7['value']=function _0x2feadf(){var _0x505a85=arguments['length']>0x0&&arguments[0x0]!==undefined?arguments[0x0]:_commonConfig['FRAME_TYPE_MAP'][hw_0x2870('0x111')];var _0x5220c8=!![];if(_0x505a85===_commonConfig[hw_0x2870('0x5d')]['TYPE264']){_0x5220c8=Boolean(_jmuxer[hw_0x2870('0x14a')][hw_0x2870('0x14c')](hw_0x2870('0x86')))&&!this[hw_0x2870('0x1b7')]();}else{_0x5220c8=Boolean(_jmuxer[hw_0x2870('0x14a')][hw_0x2870('0x14c')](hw_0x2870('0xd3')))&&!this[hw_0x2870('0x1b7')]();}if(false){ var _0x24d19b; }return _0x5220c8;};var _0x591f3e={};_0x591f3e[hw_0x2870('0x106')]=hw_0x2870('0x18');_0x591f3e['value']=function _0xd5258d(_0x343e5e){if(!this['playing']){return;}var _0x279cca=this[hw_0x2870('0x8f')](hw_0x2870('0x14'),_0x343e5e);this['send'](_0x279cca);};var _0x768737={};_0x768737['key']='sendClipboardData';_0x768737[hw_0x2870('0x17f')]=function _0x3f1a2e(_0xaedd03){if(this[hw_0x2870('0x15b')]){this[hw_0x2870('0x15b')][hw_0x2870('0x149')](_0xaedd03);}if(this['keyboardInput']){this['keyboardInput']['sendClipboardData'](_0xaedd03);}};var _0x47804d={};_0x47804d[hw_0x2870('0x106')]=hw_0x2870('0x7d');_0x47804d[hw_0x2870('0x17f')]=function _0x1cb9eb(){this[hw_0x2870('0xbe')](this[hw_0x2870('0x8')][hw_0x2870('0x5')](this));this[hw_0x2870('0x54')](!![]);};var _0x1f8eef={};_0x1f8eef[hw_0x2870('0x106')]='terminateSocketWorker';_0x1f8eef[hw_0x2870('0x17f')]=function _0x19ee6c(){this[hw_0x2870('0x1bf')]&&this[hw_0x2870('0x1bf')][hw_0x2870('0x18b')]();this[hw_0x2870('0x1bf')]=null;this[hw_0x2870('0xca')]=null;};var _0x19a77e={};_0x19a77e[hw_0x2870('0x106')]='updateSocketWorkerState';_0x19a77e[hw_0x2870('0x17f')]=function _0x4b4b6b(_0x314000,_0x562381){this[hw_0x2870('0x172')]['worker']=_0x314000;this[hw_0x2870('0x172')][hw_0x2870('0xca')]=_0x562381;var _0xbb2205={};_0xbb2205['phoneId']=this[hw_0x2870('0x14e')]['deviceId'];_0xbb2205[hw_0x2870('0xf9')]=_0x314000;_0xbb2205[hw_0x2870('0x181')]=_0x562381;this[hw_0x2870('0x14e')]['topSubscribe'][hw_0x2870('0xd2')]('onUpdateStatus',_0xbb2205);};var _0x46f3ee={};_0x46f3ee[hw_0x2870('0x106')]=hw_0x2870('0x90');_0x46f3ee[hw_0x2870('0x17f')]=function _0x49ad9d(){return this[hw_0x2870('0x172')][hw_0x2870('0xb1')]===WORKER_STATE[hw_0x2870('0x13a')]&&this[hw_0x2870('0x172')][hw_0x2870('0xca')]!==WEBSOCKET_READY_STATE[hw_0x2870('0x0')]&&this['socketWorkerState'][hw_0x2870('0xca')]!==WEBSOCKET_READY_STATE[hw_0x2870('0x190')];};var _0x251427={};_0x251427[hw_0x2870('0x106')]=hw_0x2870('0x54');_0x251427['value']=function _0x1c7c9d(_0x41bfaa){var _0x358f72,_0x5021e3;this['stopPlay']();this[hw_0x2870('0x1f')]&&this['jmuxer'][hw_0x2870('0x54')]();this['avc']&&this['avc'][hw_0x2870('0x54')]();this[hw_0x2870('0x1c7')]&&this[hw_0x2870('0x1c7')]['destroy']();this[hw_0x2870('0x1be')]&&this[hw_0x2870('0x1be')][hw_0x2870('0x54')]();this[hw_0x2870('0x102')]&&this['keyboardInput'][hw_0x2870('0x54')]();this[hw_0x2870('0x15b')]&&this['keyboardListener']['destroy']();this[hw_0x2870('0xc8')]&&((_0x358f72=this[hw_0x2870('0xc8')])===null||_0x358f72===void 0x0?void 0x0:_0x358f72[hw_0x2870('0x10f')](this[hw_0x2870('0x79')]['TYPE_ACCELEROMETER']));this[hw_0x2870('0xc8')]&&((_0x5021e3=this[hw_0x2870('0xc8')])===null||_0x5021e3===void 0x0?void 0x0:_0x5021e3[hw_0x2870('0x10f')](this[hw_0x2870('0x79')][hw_0x2870('0x1a1')]));this[hw_0x2870('0x1f')]=null;this['avc']=null;this[hw_0x2870('0x1c7')]=null;this[hw_0x2870('0x1be')]=null;this[hw_0x2870('0x102')]=null;this[hw_0x2870('0xc8')]=null;if(this[hw_0x2870('0x19b')]&&this['player'][hw_0x2870('0x93')]){var _0x3bf7df;if(this['videoResizeCallback']){this[hw_0x2870('0x19b')][hw_0x2870('0x189')](hw_0x2870('0xf1'),this[hw_0x2870('0x7c')]);}if(this[hw_0x2870('0x46')]){this[hw_0x2870('0x46')]['disconnect']();this['canvasObserver']=null;}(_0x3bf7df=document[hw_0x2870('0x19')]('#'[hw_0x2870('0xe8')](this[hw_0x2870('0xf4')])))===null||_0x3bf7df===void 0x0||_0x3bf7df[hw_0x2870('0xf')]();this[hw_0x2870('0xf4')]=undefined;this[hw_0x2870('0x19b')]=null;}if(!_0x41bfaa){this['terminateSocketWorker']();}this[hw_0x2870('0x1bd')][hw_0x2870('0xfc')](null,this[hw_0x2870('0xba')]);};var _0x5ce991={};_0x5ce991[hw_0x2870('0x106')]=hw_0x2870('0x9d');_0x5ce991[hw_0x2870('0x17f')]=function _0x535350(){var _0x5b7989=window[hw_0x2870('0xbf')]||window[hw_0x2870('0x75')];var _0x19a805=window['WebSocket'];return Boolean(_AESGCMCrypto[hw_0x2870('0x14a')][hw_0x2870('0x9d')]()&&_0x5b7989&&_0x19a805);};var _0x4853a3={};_0x4853a3[hw_0x2870('0x106')]=hw_0x2870('0xb4');_0x4853a3[hw_0x2870('0x17f')]=function _0x40a935(){var _0xb8d94e=window['URL']||window[hw_0x2870('0x18e')];return Boolean(_0xb8d94e[hw_0x2870('0xe3')]);};return _createClass(_0x258663,[_0x2060ba,_0x33534f,_0x19fe1b,_0x1e6afa,_0x59fb10,_0x4bcfec,_0x5b27d7,_0x3990cb,_0x3bc74c,_0x12a542,_0x4ce64e,_0x18113a,_0x28021e,_0x479cff,_0xa8475d,_0x1b1e34,_0x42b3a7,_0x2336e4,_0x53cc5e,_0x584d82,_0x2527b0,_0x4c03cc,_0x5a31e3,_0x13fa7b,_0x22b639,_0xe3af96,_0xbdc244,_0x46a1e1,_0x2cd558,_0x56cefc,_0xb034e,_0x2cac86,_0x1cc0f6,_0x2c9ea8,_0x204097,_0x1d762a,_0x5bdf46,_0xb45940,_0x51439b,_0x3588d8,_0x16b304,_0x732d6d,_0x3cef25,_0x582a88,_0x236196,_0x294f44,_0x29d6f4,_0x2bc42e,_0x572a0d,_0x4eca3e,_0xbeb770,_0x1a02dc,_0x1c3d2b,_0x14a298,_0x305cb3,_0x3affb8,_0x121fa5,_0x2e3ca7,_0x3baa3f,_0x47731e,_0x194240,_0x2f3173,_0x17c1ac,_0x21434e,_0x2fdb32,_0x9fa5a7,_0x591f3e,_0x768737,_0x47804d,_0x1f8eef,_0x19a77e,_0x46f3ee,_0x251427],[_0x5ce991,_0x4853a3]);}();var _default=exports[hw_0x2870('0x14a')]=AppController;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(25) && /./g.flags != 'g') __webpack_require__(28).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(133)
});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(18);
var $pad = __webpack_require__(262);
var userAgent = __webpack_require__(173);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(27);
var repeat = __webpack_require__(263);
var defined = __webpack_require__(53);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(52);
var defined = __webpack_require__(53);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Crypto", function() { return Crypto; });
/* harmony import */ var webcrypto_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CryptoKey", function() { return webcrypto_core__WEBPACK_IMPORTED_MODULE_0__["k"]; });

/* harmony import */ var buffer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var buffer__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(buffer__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var crypto__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(crypto__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var process__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40);
/* harmony import */ var process__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(process__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9);
/* harmony import */ var _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7);
/* harmony import */ var pvtsutils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3);
/* harmony import */ var pvtsutils__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(pvtsutils__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2);
/*!
 Copyright (c) Peculiar Ventures, LLC
*/












const JsonBase64UrlConverter = {
    fromJSON: (value) => buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(pvtsutils__WEBPACK_IMPORTED_MODULE_6__["Convert"].FromBase64Url(value)),
    toJSON: (value) => pvtsutils__WEBPACK_IMPORTED_MODULE_6__["Convert"].ToBase64Url(value),
};

class CryptoKey extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* CryptoKey */ "k"] {
    constructor() {
        super(...arguments);
        this.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].alloc(0);
        this.algorithm = { name: "" };
        this.extractable = false;
        this.type = "secret";
        this.usages = [];
        this.kty = "oct";
        this.alg = "";
    }
}
Object(tslib__WEBPACK_IMPORTED_MODULE_4__[/* __decorate */ "a"])([
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonProp */ "b"])({ name: "ext", type: _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonPropTypes */ "c"].Boolean, optional: true })
], CryptoKey.prototype, "extractable", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_4__[/* __decorate */ "a"])([
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonProp */ "b"])({ name: "key_ops", type: _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonPropTypes */ "c"].String, repeated: true, optional: true })
], CryptoKey.prototype, "usages", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_4__[/* __decorate */ "a"])([
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonProp */ "b"])({ type: _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonPropTypes */ "c"].String })
], CryptoKey.prototype, "kty", void 0);
Object(tslib__WEBPACK_IMPORTED_MODULE_4__[/* __decorate */ "a"])([
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonProp */ "b"])({ type: _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonPropTypes */ "c"].String, optional: true })
], CryptoKey.prototype, "alg", void 0);

class SymmetricKey extends CryptoKey {
    constructor() {
        super(...arguments);
        this.kty = "oct";
        this.type = "secret";
    }
}

class AsymmetricKey extends CryptoKey {
}

class AesCryptoKey extends SymmetricKey {
    get alg() {
        switch (this.algorithm.name.toUpperCase()) {
            case "AES-CBC":
                return `A${this.algorithm.length}CBC`;
            case "AES-CTR":
                return `A${this.algorithm.length}CTR`;
            case "AES-GCM":
                return `A${this.algorithm.length}GCM`;
            case "AES-KW":
                return `A${this.algorithm.length}KW`;
            case "AES-CMAC":
                return `A${this.algorithm.length}CMAC`;
            case "AES-ECB":
                return `A${this.algorithm.length}ECB`;
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* AlgorithmError */ "g"]("Unsupported algorithm name");
        }
    }
    set alg(value) {
    }
}
Object(tslib__WEBPACK_IMPORTED_MODULE_4__[/* __decorate */ "a"])([
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonProp */ "b"])({ name: "k", converter: JsonBase64UrlConverter })
], AesCryptoKey.prototype, "data", void 0);

class AesCrypto {
    static async generateKey(algorithm, extractable, keyUsages) {
        const key = new AesCryptoKey();
        key.algorithm = algorithm;
        key.extractable = extractable;
        key.usages = keyUsages;
        key.data = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.randomBytes(algorithm.length >> 3);
        return key;
    }
    static async exportKey(format, key) {
        if (!(key instanceof AesCryptoKey)) {
            throw new Error("key: Is not AesCryptoKey");
        }
        switch (format.toLowerCase()) {
            case "jwk":
                return _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonSerializer */ "d"].toJSON(key);
            case "raw":
                return new Uint8Array(key.data).buffer;
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk' or 'raw'");
        }
    }
    static async importKey(format, keyData, algorithm, extractable, keyUsages) {
        let key;
        switch (format.toLowerCase()) {
            case "jwk":
                key = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(keyData, { targetSchema: AesCryptoKey });
                break;
            case "raw":
                key = new AesCryptoKey();
                key.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(keyData);
                break;
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk' or 'raw'");
        }
        key.algorithm = algorithm;
        key.algorithm.length = key.data.length << 3;
        key.extractable = extractable;
        key.usages = keyUsages;
        switch (key.algorithm.length) {
            case 128:
            case 192:
            case 256:
                break;
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("keyData: Is wrong key length");
        }
        return key;
    }
    static async encrypt(algorithm, key, data) {
        switch (algorithm.name.toUpperCase()) {
            case "AES-CBC":
                return this.encryptAesCBC(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            case "AES-CTR":
                return this.encryptAesCTR(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            case "AES-GCM":
                return this.encryptAesGCM(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            case "AES-KW":
                return this.encryptAesKW(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            case "AES-ECB":
                return this.encryptAesECB(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("algorithm: Is not recognized");
        }
    }
    static async decrypt(algorithm, key, data) {
        if (!(key instanceof AesCryptoKey)) {
            throw new Error("key: Is not AesCryptoKey");
        }
        switch (algorithm.name.toUpperCase()) {
            case "AES-CBC":
                return this.decryptAesCBC(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            case "AES-CTR":
                return this.decryptAesCTR(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            case "AES-GCM":
                return this.decryptAesGCM(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            case "AES-KW":
                return this.decryptAesKW(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            case "AES-ECB":
                return this.decryptAesECB(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("algorithm: Is not recognized");
        }
    }
    static async encryptAesCBC(algorithm, key, data) {
        const cipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createCipheriv(`aes-${key.algorithm.length}-cbc`, key.data, new Uint8Array(algorithm.iv));
        let enc = cipher.update(data);
        enc = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([enc, cipher.final()]);
        const res = new Uint8Array(enc).buffer;
        return res;
    }
    static async decryptAesCBC(algorithm, key, data) {
        const decipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createDecipheriv(`aes-${key.algorithm.length}-cbc`, key.data, new Uint8Array(algorithm.iv));
        let dec = decipher.update(data);
        dec = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([dec, decipher.final()]);
        return new Uint8Array(dec).buffer;
    }
    static async encryptAesCTR(algorithm, key, data) {
        const cipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createCipheriv(`aes-${key.algorithm.length}-ctr`, key.data, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(algorithm.counter));
        let enc = cipher.update(data);
        enc = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([enc, cipher.final()]);
        const res = new Uint8Array(enc).buffer;
        return res;
    }
    static async decryptAesCTR(algorithm, key, data) {
        const decipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createDecipheriv(`aes-${key.algorithm.length}-ctr`, key.data, new Uint8Array(algorithm.counter));
        let dec = decipher.update(data);
        dec = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([dec, decipher.final()]);
        return new Uint8Array(dec).buffer;
    }
    static async encryptAesGCM(algorithm, key, data) {
        const cipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createCipheriv(`aes-${key.algorithm.length}-gcm`, key.data, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(algorithm.iv), {
            authTagLength: (algorithm.tagLength || 128) >> 3,
        });
        if (algorithm.additionalData) {
            cipher.setAAD(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(algorithm.additionalData));
        }
        let enc = cipher.update(data);
        enc = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([enc, cipher.final(), cipher.getAuthTag()]);
        const res = new Uint8Array(enc).buffer;
        return res;
    }
    static async decryptAesGCM(algorithm, key, data) {
        const tagLength = (algorithm.tagLength || 128) >> 3;
        const decipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createDecipheriv(`aes-${key.algorithm.length}-gcm`, key.data, new Uint8Array(algorithm.iv), {
            authTagLength: tagLength,
        });
        const enc = data.slice(0, data.length - tagLength);
        const tag = data.slice(data.length - tagLength);
        if (algorithm.additionalData) {
            decipher.setAAD(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(algorithm.additionalData));
        }
        decipher.setAuthTag(tag);
        let dec = decipher.update(enc);
        dec = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([dec, decipher.final()]);
        return new Uint8Array(dec).buffer;
    }
    static async encryptAesKW(algorithm, key, data) {
        const cipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createCipheriv(`id-aes${key.algorithm.length}-wrap`, key.data, this.AES_KW_IV);
        let enc = cipher.update(data);
        enc = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([enc, cipher.final()]);
        return new Uint8Array(enc).buffer;
    }
    static async decryptAesKW(algorithm, key, data) {
        const decipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createDecipheriv(`id-aes${key.algorithm.length}-wrap`, key.data, this.AES_KW_IV);
        let dec = decipher.update(data);
        dec = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([dec, decipher.final()]);
        return new Uint8Array(dec).buffer;
    }
    static async encryptAesECB(algorithm, key, data) {
        const cipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createCipheriv(`aes-${key.algorithm.length}-ecb`, key.data, new Uint8Array(0));
        let enc = cipher.update(data);
        enc = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([enc, cipher.final()]);
        const res = new Uint8Array(enc).buffer;
        return res;
    }
    static async decryptAesECB(algorithm, key, data) {
        const decipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createDecipheriv(`aes-${key.algorithm.length}-ecb`, key.data, new Uint8Array(0));
        let dec = decipher.update(data);
        dec = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([dec, decipher.final()]);
        return new Uint8Array(dec).buffer;
    }
}
AesCrypto.AES_KW_IV = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from("A6A6A6A6A6A6A6A6", "hex");

const keyStorage = new WeakMap();
function getCryptoKey(key) {
    const res = keyStorage.get(key);
    if (!res) {
        throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("Cannot get CryptoKey from secure storage");
    }
    return res;
}
function setCryptoKey(value) {
    const key = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* CryptoKey */ "k"].create(value.algorithm, value.type, value.extractable, value.usages);
    Object.freeze(key);
    keyStorage.set(key, value);
    return key;
}

class AesCbcProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* AesCbcProvider */ "a"] {
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const key = await AesCrypto.generateKey({
            name: this.name,
            length: algorithm.length,
        }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    async onEncrypt(algorithm, key, data) {
        return AesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onDecrypt(algorithm, key, data) {
        return AesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onExportKey(format, key) {
        return AesCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const key = await AesCrypto.importKey(format, keyData, { name: algorithm.name }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        if (!(getCryptoKey(key) instanceof AesCryptoKey)) {
            throw new TypeError("key: Is not a AesCryptoKey");
        }
    }
}

const zero = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
const rb = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 135]);
const blockSize = 16;
function bitShiftLeft(buffer) {
    const shifted = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].alloc(buffer.length);
    const last = buffer.length - 1;
    for (let index = 0; index < last; index++) {
        shifted[index] = buffer[index] << 1;
        if (buffer[index + 1] & 0x80) {
            shifted[index] += 0x01;
        }
    }
    shifted[last] = buffer[last] << 1;
    return shifted;
}
function xor(a, b) {
    const length = Math.min(a.length, b.length);
    const output = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].alloc(length);
    for (let index = 0; index < length; index++) {
        output[index] = a[index] ^ b[index];
    }
    return output;
}
function aes(key, message) {
    const cipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createCipheriv(`aes${key.length << 3}`, key, zero);
    const result = cipher.update(message);
    cipher.final();
    return result;
}
function getMessageBlock(message, blockIndex) {
    const block = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].alloc(blockSize);
    const start = blockIndex * blockSize;
    const end = start + blockSize;
    message.copy(block, 0, start, end);
    return block;
}
function getPaddedMessageBlock(message, blockIndex) {
    const block = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].alloc(blockSize);
    const start = blockIndex * blockSize;
    const end = message.length;
    block.fill(0);
    message.copy(block, 0, start, end);
    block[end - start] = 0x80;
    return block;
}
function generateSubkeys(key) {
    const l = aes(key, zero);
    let subkey1 = bitShiftLeft(l);
    if (l[0] & 0x80) {
        subkey1 = xor(subkey1, rb);
    }
    let subkey2 = bitShiftLeft(subkey1);
    if (subkey1[0] & 0x80) {
        subkey2 = xor(subkey2, rb);
    }
    return { subkey1, subkey2 };
}
function aesCmac(key, message) {
    const subkeys = generateSubkeys(key);
    let blockCount = Math.ceil(message.length / blockSize);
    let lastBlockCompleteFlag;
    let lastBlock;
    if (blockCount === 0) {
        blockCount = 1;
        lastBlockCompleteFlag = false;
    }
    else {
        lastBlockCompleteFlag = (message.length % blockSize === 0);
    }
    const lastBlockIndex = blockCount - 1;
    if (lastBlockCompleteFlag) {
        lastBlock = xor(getMessageBlock(message, lastBlockIndex), subkeys.subkey1);
    }
    else {
        lastBlock = xor(getPaddedMessageBlock(message, lastBlockIndex), subkeys.subkey2);
    }
    let x = zero;
    let y;
    for (let index = 0; index < lastBlockIndex; index++) {
        y = xor(x, getMessageBlock(message, index));
        x = aes(key, y);
    }
    y = xor(lastBlock, x);
    return aes(key, y);
}
class AesCmacProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* AesCmacProvider */ "b"] {
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const key = await AesCrypto.generateKey({
            name: this.name,
            length: algorithm.length,
        }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    async onSign(algorithm, key, data) {
        const result = aesCmac(getCryptoKey(key).data, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
        return new Uint8Array(result).buffer;
    }
    async onVerify(algorithm, key, signature, data) {
        const signature2 = await this.sign(algorithm, key, data);
        return buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(signature).compare(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(signature2)) === 0;
    }
    async onExportKey(format, key) {
        return AesCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const res = await AesCrypto.importKey(format, keyData, { name: algorithm.name }, extractable, keyUsages);
        return setCryptoKey(res);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        if (!(getCryptoKey(key) instanceof AesCryptoKey)) {
            throw new TypeError("key: Is not a AesCryptoKey");
        }
    }
}

class AesCtrProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* AesCtrProvider */ "c"] {
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const key = await AesCrypto.generateKey({
            name: this.name,
            length: algorithm.length,
        }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    async onEncrypt(algorithm, key, data) {
        return AesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onDecrypt(algorithm, key, data) {
        return AesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onExportKey(format, key) {
        return AesCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const res = await AesCrypto.importKey(format, keyData, { name: algorithm.name }, extractable, keyUsages);
        return setCryptoKey(res);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        if (!(getCryptoKey(key) instanceof AesCryptoKey)) {
            throw new TypeError("key: Is not a AesCryptoKey");
        }
    }
}

class AesGcmProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* AesGcmProvider */ "e"] {
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const key = await AesCrypto.generateKey({
            name: this.name,
            length: algorithm.length,
        }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    async onEncrypt(algorithm, key, data) {
        return AesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onDecrypt(algorithm, key, data) {
        return AesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onExportKey(format, key) {
        return AesCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const res = await AesCrypto.importKey(format, keyData, { name: algorithm.name }, extractable, keyUsages);
        return setCryptoKey(res);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        if (!(getCryptoKey(key) instanceof AesCryptoKey)) {
            throw new TypeError("key: Is not a AesCryptoKey");
        }
    }
}

class AesKwProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* AesKwProvider */ "f"] {
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const res = await AesCrypto.generateKey({
            name: this.name,
            length: algorithm.length,
        }, extractable, keyUsages);
        return setCryptoKey(res);
    }
    async onExportKey(format, key) {
        return AesCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const res = await AesCrypto.importKey(format, keyData, { name: algorithm.name }, extractable, keyUsages);
        return setCryptoKey(res);
    }
    async onEncrypt(algorithm, key, data) {
        return AesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onDecrypt(algorithm, key, data) {
        return AesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        if (!(getCryptoKey(key) instanceof AesCryptoKey)) {
            throw new TypeError("key: Is not a AesCryptoKey");
        }
    }
}

class AesEcbProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* AesEcbProvider */ "d"] {
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const key = await AesCrypto.generateKey({
            name: this.name,
            length: algorithm.length,
        }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    async onEncrypt(algorithm, key, data) {
        return AesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onDecrypt(algorithm, key, data) {
        return AesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onExportKey(format, key) {
        return AesCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const res = await AesCrypto.importKey(format, keyData, { name: algorithm.name }, extractable, keyUsages);
        return setCryptoKey(res);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        if (!(getCryptoKey(key) instanceof AesCryptoKey)) {
            throw new TypeError("key: Is not a AesCryptoKey");
        }
    }
}

class DesCryptoKey extends SymmetricKey {
    get alg() {
        switch (this.algorithm.name.toUpperCase()) {
            case "DES-CBC":
                return `DES-CBC`;
            case "DES-EDE3-CBC":
                return `3DES-CBC`;
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* AlgorithmError */ "g"]("Unsupported algorithm name");
        }
    }
    set alg(value) {
    }
}
Object(tslib__WEBPACK_IMPORTED_MODULE_4__[/* __decorate */ "a"])([
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonProp */ "b"])({ name: "k", converter: JsonBase64UrlConverter })
], DesCryptoKey.prototype, "data", void 0);

class DesCrypto {
    static async generateKey(algorithm, extractable, keyUsages) {
        const key = new DesCryptoKey();
        key.algorithm = algorithm;
        key.extractable = extractable;
        key.usages = keyUsages;
        key.data = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.randomBytes(algorithm.length >> 3);
        return key;
    }
    static async exportKey(format, key) {
        switch (format.toLowerCase()) {
            case "jwk":
                return _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonSerializer */ "d"].toJSON(key);
            case "raw":
                return new Uint8Array(key.data).buffer;
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk' or 'raw'");
        }
    }
    static async importKey(format, keyData, algorithm, extractable, keyUsages) {
        let key;
        switch (format.toLowerCase()) {
            case "jwk":
                key = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(keyData, { targetSchema: DesCryptoKey });
                break;
            case "raw":
                key = new DesCryptoKey();
                key.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(keyData);
                break;
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk' or 'raw'");
        }
        key.algorithm = algorithm;
        key.extractable = extractable;
        key.usages = keyUsages;
        return key;
    }
    static async encrypt(algorithm, key, data) {
        switch (algorithm.name.toUpperCase()) {
            case "DES-CBC":
                return this.encryptDesCBC(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            case "DES-EDE3-CBC":
                return this.encryptDesEDE3CBC(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("algorithm: Is not recognized");
        }
    }
    static async decrypt(algorithm, key, data) {
        if (!(key instanceof DesCryptoKey)) {
            throw new Error("key: Is not DesCryptoKey");
        }
        switch (algorithm.name.toUpperCase()) {
            case "DES-CBC":
                return this.decryptDesCBC(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            case "DES-EDE3-CBC":
                return this.decryptDesEDE3CBC(algorithm, key, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("algorithm: Is not recognized");
        }
    }
    static async encryptDesCBC(algorithm, key, data) {
        const cipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createCipheriv(`des-cbc`, key.data, new Uint8Array(algorithm.iv));
        let enc = cipher.update(data);
        enc = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([enc, cipher.final()]);
        const res = new Uint8Array(enc).buffer;
        return res;
    }
    static async decryptDesCBC(algorithm, key, data) {
        const decipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createDecipheriv(`des-cbc`, key.data, new Uint8Array(algorithm.iv));
        let dec = decipher.update(data);
        dec = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([dec, decipher.final()]);
        return new Uint8Array(dec).buffer;
    }
    static async encryptDesEDE3CBC(algorithm, key, data) {
        const cipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createCipheriv(`des-ede3-cbc`, key.data, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(algorithm.iv));
        let enc = cipher.update(data);
        enc = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([enc, cipher.final()]);
        const res = new Uint8Array(enc).buffer;
        return res;
    }
    static async decryptDesEDE3CBC(algorithm, key, data) {
        const decipher = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createDecipheriv(`des-ede3-cbc`, key.data, new Uint8Array(algorithm.iv));
        let dec = decipher.update(data);
        dec = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([dec, decipher.final()]);
        return new Uint8Array(dec).buffer;
    }
}

class DesCbcProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* DesProvider */ "l"] {
    constructor() {
        super(...arguments);
        this.keySizeBits = 64;
        this.ivSize = 8;
        this.name = "DES-CBC";
    }
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const key = await DesCrypto.generateKey({
            name: this.name,
            length: this.keySizeBits,
        }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    async onEncrypt(algorithm, key, data) {
        return DesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onDecrypt(algorithm, key, data) {
        return DesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onExportKey(format, key) {
        return DesCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const key = await DesCrypto.importKey(format, keyData, { name: this.name, length: this.keySizeBits }, extractable, keyUsages);
        if (key.data.length !== (this.keySizeBits >> 3)) {
            throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("keyData: Wrong key size");
        }
        return setCryptoKey(key);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        if (!(getCryptoKey(key) instanceof DesCryptoKey)) {
            throw new TypeError("key: Is not a DesCryptoKey");
        }
    }
}

class DesEde3CbcProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* DesProvider */ "l"] {
    constructor() {
        super(...arguments);
        this.keySizeBits = 192;
        this.ivSize = 8;
        this.name = "DES-EDE3-CBC";
    }
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const key = await DesCrypto.generateKey({
            name: this.name,
            length: this.keySizeBits,
        }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    async onEncrypt(algorithm, key, data) {
        return DesCrypto.encrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onDecrypt(algorithm, key, data) {
        return DesCrypto.decrypt(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onExportKey(format, key) {
        return DesCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const key = await DesCrypto.importKey(format, keyData, { name: this.name, length: this.keySizeBits }, extractable, keyUsages);
        if (key.data.length !== (this.keySizeBits >> 3)) {
            throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("keyData: Wrong key size");
        }
        return setCryptoKey(key);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        if (!(getCryptoKey(key) instanceof DesCryptoKey)) {
            throw new TypeError("key: Is not a DesCryptoKey");
        }
    }
}

function getJwkAlgorithm(algorithm) {
    switch (algorithm.name.toUpperCase()) {
        case "RSA-OAEP": {
            const mdSize = /(\d+)$/.exec(algorithm.hash.name)[1];
            return `RSA-OAEP${mdSize !== "1" ? `-${mdSize}` : ""}`;
        }
        case "RSASSA-PKCS1-V1_5":
            return `RS${/(\d+)$/.exec(algorithm.hash.name)[1]}`;
        case "RSA-PSS":
            return `PS${/(\d+)$/.exec(algorithm.hash.name)[1]}`;
        case "RSA-PKCS1":
            return `RS1`;
        default:
            throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("algorithm: Is not recognized");
    }
}

class RsaPrivateKey extends AsymmetricKey {
    constructor() {
        super(...arguments);
        this.type = "private";
    }
    getKey() {
        const keyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(this.data, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo);
        return _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(keyInfo.privateKey, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].RsaPrivateKey);
    }
    toJSON() {
        const key = this.getKey();
        const json = {
            kty: "RSA",
            alg: getJwkAlgorithm(this.algorithm),
            key_ops: this.usages,
            ext: this.extractable,
        };
        return Object.assign(json, _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonSerializer */ "d"].toJSON(key));
    }
    fromJSON(json) {
        const key = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(json, { targetSchema: webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].RsaPrivateKey });
        const keyInfo = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo();
        keyInfo.privateKeyAlgorithm.algorithm = "1.2.840.113549.1.1.1";
        keyInfo.privateKeyAlgorithm.parameters = null;
        keyInfo.privateKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(key);
        this.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(keyInfo));
    }
}

class RsaPublicKey extends AsymmetricKey {
    constructor() {
        super(...arguments);
        this.type = "public";
    }
    getKey() {
        const keyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(this.data, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo);
        return _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(keyInfo.publicKey, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].RsaPublicKey);
    }
    toJSON() {
        const key = this.getKey();
        const json = {
            kty: "RSA",
            alg: getJwkAlgorithm(this.algorithm),
            key_ops: this.usages,
            ext: this.extractable,
        };
        return Object.assign(json, _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonSerializer */ "d"].toJSON(key));
    }
    fromJSON(json) {
        const key = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(json, { targetSchema: webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].RsaPublicKey });
        const keyInfo = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo();
        keyInfo.publicKeyAlgorithm.algorithm = "1.2.840.113549.1.1.1";
        keyInfo.publicKeyAlgorithm.parameters = null;
        keyInfo.publicKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(key);
        this.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(keyInfo));
    }
}

class RsaCrypto {
    static async generateKey(algorithm, extractable, keyUsages) {
        const privateKey = new RsaPrivateKey();
        privateKey.algorithm = algorithm;
        privateKey.extractable = extractable;
        privateKey.usages = keyUsages.filter((usage) => this.privateKeyUsages.indexOf(usage) !== -1);
        const publicKey = new RsaPublicKey();
        publicKey.algorithm = algorithm;
        publicKey.extractable = true;
        publicKey.usages = keyUsages.filter((usage) => this.publicKeyUsages.indexOf(usage) !== -1);
        const publicExponent = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([
            buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].alloc(4 - algorithm.publicExponent.byteLength, 0),
            buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(algorithm.publicExponent),
        ]).readInt32BE(0);
        const keys = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.generateKeyPairSync("rsa", {
            modulusLength: algorithm.modulusLength,
            publicExponent,
            publicKeyEncoding: {
                format: "der",
                type: "spki",
            },
            privateKeyEncoding: {
                format: "der",
                type: "pkcs8",
            },
        });
        privateKey.data = keys.privateKey;
        publicKey.data = keys.publicKey;
        const res = {
            privateKey,
            publicKey,
        };
        return res;
    }
    static async exportKey(format, key) {
        switch (format.toLowerCase()) {
            case "jwk":
                return _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonSerializer */ "d"].toJSON(key);
            case "pkcs8":
            case "spki":
                return new Uint8Array(key.data).buffer;
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk', 'pkcs8' or 'spki'");
        }
    }
    static async importKey(format, keyData, algorithm, extractable, keyUsages) {
        switch (format.toLowerCase()) {
            case "jwk": {
                const jwk = keyData;
                if (jwk.d) {
                    const asnKey = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(keyData, { targetSchema: webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].RsaPrivateKey });
                    return this.importPrivateKey(asnKey, algorithm, extractable, keyUsages);
                }
                else {
                    const asnKey = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(keyData, { targetSchema: webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].RsaPublicKey });
                    return this.importPublicKey(asnKey, algorithm, extractable, keyUsages);
                }
            }
            case "spki": {
                const keyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(new Uint8Array(keyData), webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo);
                const asnKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(keyInfo.publicKey, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].RsaPublicKey);
                return this.importPublicKey(asnKey, algorithm, extractable, keyUsages);
            }
            case "pkcs8": {
                const keyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(new Uint8Array(keyData), webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo);
                const asnKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(keyInfo.privateKey, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].RsaPrivateKey);
                return this.importPrivateKey(asnKey, algorithm, extractable, keyUsages);
            }
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk', 'pkcs8' or 'spki'");
        }
    }
    static async sign(algorithm, key, data) {
        switch (algorithm.name.toUpperCase()) {
            case "RSA-PSS":
            case "RSASSA-PKCS1-V1_5":
                return this.signRsa(algorithm, key, data);
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("algorithm: Is not recognized");
        }
    }
    static async verify(algorithm, key, signature, data) {
        switch (algorithm.name.toUpperCase()) {
            case "RSA-PSS":
            case "RSASSA-PKCS1-V1_5":
                return this.verifySSA(algorithm, key, data, signature);
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("algorithm: Is not recognized");
        }
    }
    static async encrypt(algorithm, key, data) {
        switch (algorithm.name.toUpperCase()) {
            case "RSA-OAEP":
                return this.encryptOAEP(algorithm, key, data);
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("algorithm: Is not recognized");
        }
    }
    static async decrypt(algorithm, key, data) {
        switch (algorithm.name.toUpperCase()) {
            case "RSA-OAEP":
                return this.decryptOAEP(algorithm, key, data);
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("algorithm: Is not recognized");
        }
    }
    static importPrivateKey(asnKey, algorithm, extractable, keyUsages) {
        const keyInfo = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo();
        keyInfo.privateKeyAlgorithm.algorithm = "1.2.840.113549.1.1.1";
        keyInfo.privateKeyAlgorithm.parameters = null;
        keyInfo.privateKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(asnKey);
        const key = new RsaPrivateKey();
        key.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(keyInfo));
        key.algorithm = Object.assign({}, algorithm);
        key.algorithm.publicExponent = new Uint8Array(asnKey.publicExponent);
        key.algorithm.modulusLength = asnKey.modulus.byteLength << 3;
        key.extractable = extractable;
        key.usages = keyUsages;
        return key;
    }
    static importPublicKey(asnKey, algorithm, extractable, keyUsages) {
        const keyInfo = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo();
        keyInfo.publicKeyAlgorithm.algorithm = "1.2.840.113549.1.1.1";
        keyInfo.publicKeyAlgorithm.parameters = null;
        keyInfo.publicKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(asnKey);
        const key = new RsaPublicKey();
        key.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(keyInfo));
        key.algorithm = Object.assign({}, algorithm);
        key.algorithm.publicExponent = new Uint8Array(asnKey.publicExponent);
        key.algorithm.modulusLength = asnKey.modulus.byteLength << 3;
        key.extractable = extractable;
        key.usages = keyUsages;
        return key;
    }
    static getCryptoAlgorithm(alg) {
        switch (alg.hash.name.toUpperCase()) {
            case "SHA-1":
                return "RSA-SHA1";
            case "SHA-256":
                return "RSA-SHA256";
            case "SHA-384":
                return "RSA-SHA384";
            case "SHA-512":
                return "RSA-SHA512";
            case "SHA3-256":
                return "RSA-SHA3-256";
            case "SHA3-384":
                return "RSA-SHA3-384";
            case "SHA3-512":
                return "RSA-SHA3-512";
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("algorithm.hash: Is not recognized");
        }
    }
    static signRsa(algorithm, key, data) {
        const cryptoAlg = this.getCryptoAlgorithm(key.algorithm);
        const signer = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createSign(cryptoAlg);
        signer.update(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
        if (!key.pem) {
            key.pem = `-----BEGIN PRIVATE KEY-----\n${key.data.toString("base64")}\n-----END PRIVATE KEY-----`;
        }
        const options = {
            key: key.pem,
        };
        if (algorithm.name.toUpperCase() === "RSA-PSS") {
            options.padding = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.constants.RSA_PKCS1_PSS_PADDING;
            options.saltLength = algorithm.saltLength;
        }
        const signature = signer.sign(options);
        return new Uint8Array(signature).buffer;
    }
    static verifySSA(algorithm, key, data, signature) {
        const cryptoAlg = this.getCryptoAlgorithm(key.algorithm);
        const signer = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createVerify(cryptoAlg);
        signer.update(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
        if (!key.pem) {
            key.pem = `-----BEGIN PUBLIC KEY-----\n${key.data.toString("base64")}\n-----END PUBLIC KEY-----`;
        }
        const options = {
            key: key.pem,
        };
        if (algorithm.name.toUpperCase() === "RSA-PSS") {
            options.padding = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.constants.RSA_PKCS1_PSS_PADDING;
            options.saltLength = algorithm.saltLength;
        }
        const ok = signer.verify(options, signature);
        return ok;
    }
    static encryptOAEP(algorithm, key, data) {
        const options = {
            key: `-----BEGIN PUBLIC KEY-----\n${key.data.toString("base64")}\n-----END PUBLIC KEY-----`,
            padding: crypto__WEBPACK_IMPORTED_MODULE_2___default.a.constants.RSA_PKCS1_OAEP_PADDING,
        };
        if (algorithm.label) ;
        return new Uint8Array(crypto__WEBPACK_IMPORTED_MODULE_2___default.a.publicEncrypt(options, data)).buffer;
    }
    static decryptOAEP(algorithm, key, data) {
        const options = {
            key: `-----BEGIN PRIVATE KEY-----\n${key.data.toString("base64")}\n-----END PRIVATE KEY-----`,
            padding: crypto__WEBPACK_IMPORTED_MODULE_2___default.a.constants.RSA_PKCS1_OAEP_PADDING,
        };
        if (algorithm.label) ;
        return new Uint8Array(crypto__WEBPACK_IMPORTED_MODULE_2___default.a.privateDecrypt(options, data)).buffer;
    }
}
RsaCrypto.publicKeyUsages = ["verify", "encrypt", "wrapKey"];
RsaCrypto.privateKeyUsages = ["sign", "decrypt", "unwrapKey"];

class RsaSsaProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* RsaSsaProvider */ "B"] {
    constructor() {
        super(...arguments);
        this.hashAlgorithms = [
            "SHA-1", "SHA-256", "SHA-384", "SHA-512",
            "shake128", "shake256",
            "SHA3-256", "SHA3-384", "SHA3-512"
        ];
    }
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const keys = await RsaCrypto.generateKey({
            ...algorithm,
            name: this.name,
        }, extractable, keyUsages);
        return {
            privateKey: setCryptoKey(keys.privateKey),
            publicKey: setCryptoKey(keys.publicKey),
        };
    }
    async onSign(algorithm, key, data) {
        return RsaCrypto.sign(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onVerify(algorithm, key, signature, data) {
        return RsaCrypto.verify(algorithm, getCryptoKey(key), new Uint8Array(signature), new Uint8Array(data));
    }
    async onExportKey(format, key) {
        return RsaCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const key = await RsaCrypto.importKey(format, keyData, { ...algorithm, name: this.name }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        const internalKey = getCryptoKey(key);
        if (!(internalKey instanceof RsaPrivateKey || internalKey instanceof RsaPublicKey)) {
            throw new TypeError("key: Is not RSA CryptoKey");
        }
    }
}

class RsaPssProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* RsaPssProvider */ "A"] {
    constructor() {
        super(...arguments);
        this.hashAlgorithms = [
            "SHA-1", "SHA-256", "SHA-384", "SHA-512",
            "shake128", "shake256",
            "SHA3-256", "SHA3-384", "SHA3-512"
        ];
    }
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const keys = await RsaCrypto.generateKey({
            ...algorithm,
            name: this.name,
        }, extractable, keyUsages);
        return {
            privateKey: setCryptoKey(keys.privateKey),
            publicKey: setCryptoKey(keys.publicKey),
        };
    }
    async onSign(algorithm, key, data) {
        return RsaCrypto.sign(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onVerify(algorithm, key, signature, data) {
        return RsaCrypto.verify(algorithm, getCryptoKey(key), new Uint8Array(signature), new Uint8Array(data));
    }
    async onExportKey(format, key) {
        return RsaCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const key = await RsaCrypto.importKey(format, keyData, { ...algorithm, name: this.name }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        const internalKey = getCryptoKey(key);
        if (!(internalKey instanceof RsaPrivateKey || internalKey instanceof RsaPublicKey)) {
            throw new TypeError("key: Is not RSA CryptoKey");
        }
    }
}

class ShaCrypto {
    static size(algorithm) {
        switch (algorithm.name.toUpperCase()) {
            case "SHA-1":
                return 160;
            case "SHA-256":
            case "SHA3-256":
                return 256;
            case "SHA-384":
            case "SHA3-384":
                return 384;
            case "SHA-512":
            case "SHA3-512":
                return 512;
            default:
                throw new Error("Unrecognized name");
        }
    }
    static getAlgorithmName(algorithm) {
        switch (algorithm.name.toUpperCase()) {
            case "SHA-1":
                return "sha1";
            case "SHA-256":
                return "sha256";
            case "SHA-384":
                return "sha384";
            case "SHA-512":
                return "sha512";
            case "SHA3-256":
                return "sha3-256";
            case "SHA3-384":
                return "sha3-384";
            case "SHA3-512":
                return "sha3-512";
            default:
                throw new Error("Unrecognized name");
        }
    }
    static digest(algorithm, data) {
        const hashAlg = this.getAlgorithmName(algorithm);
        const hash = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createHash(hashAlg)
            .update(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data)).digest();
        return new Uint8Array(hash).buffer;
    }
}

class RsaOaepProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* RsaOaepProvider */ "z"] {
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const keys = await RsaCrypto.generateKey({
            ...algorithm,
            name: this.name,
        }, extractable, keyUsages);
        return {
            privateKey: setCryptoKey(keys.privateKey),
            publicKey: setCryptoKey(keys.publicKey),
        };
    }
    async onEncrypt(algorithm, key, data) {
        const internalKey = getCryptoKey(key);
        const dataView = new Uint8Array(data);
        const keySize = Math.ceil(internalKey.algorithm.modulusLength >> 3);
        const hashSize = ShaCrypto.size(internalKey.algorithm.hash) >> 3;
        const dataLength = dataView.byteLength;
        const psLength = keySize - dataLength - 2 * hashSize - 2;
        if (dataLength > keySize - 2 * hashSize - 2) {
            throw new Error("Data too large");
        }
        const message = new Uint8Array(keySize);
        const seed = message.subarray(1, hashSize + 1);
        const dataBlock = message.subarray(hashSize + 1);
        dataBlock.set(dataView, hashSize + psLength + 1);
        const labelHash = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createHash(internalKey.algorithm.hash.name.replace("-", ""))
            .update(webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* BufferSourceConverter */ "h"].toUint8Array(algorithm.label || new Uint8Array(0)))
            .digest();
        dataBlock.set(labelHash, 0);
        dataBlock[hashSize + psLength] = 1;
        crypto__WEBPACK_IMPORTED_MODULE_2___default.a.randomFillSync(seed);
        const dataBlockMask = this.mgf1(internalKey.algorithm.hash, seed, dataBlock.length);
        for (let i = 0; i < dataBlock.length; i++) {
            dataBlock[i] ^= dataBlockMask[i];
        }
        const seedMask = this.mgf1(internalKey.algorithm.hash, dataBlock, seed.length);
        for (let i = 0; i < seed.length; i++) {
            seed[i] ^= seedMask[i];
        }
        if (!internalKey.pem) {
            internalKey.pem = `-----BEGIN PUBLIC KEY-----\n${internalKey.data.toString("base64")}\n-----END PUBLIC KEY-----`;
        }
        const pkcs0 = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.publicEncrypt({
            key: internalKey.pem,
            padding: crypto__WEBPACK_IMPORTED_MODULE_2___default.a.constants.RSA_NO_PADDING,
        }, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(message));
        return new Uint8Array(pkcs0).buffer;
    }
    async onDecrypt(algorithm, key, data) {
        const internalKey = getCryptoKey(key);
        const keySize = Math.ceil(internalKey.algorithm.modulusLength >> 3);
        const hashSize = ShaCrypto.size(internalKey.algorithm.hash) >> 3;
        const dataLength = data.byteLength;
        if (dataLength !== keySize) {
            throw new Error("Bad data");
        }
        if (!internalKey.pem) {
            internalKey.pem = `-----BEGIN PRIVATE KEY-----\n${internalKey.data.toString("base64")}\n-----END PRIVATE KEY-----`;
        }
        let pkcs0 = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.privateDecrypt({
            key: internalKey.pem,
            padding: crypto__WEBPACK_IMPORTED_MODULE_2___default.a.constants.RSA_NO_PADDING,
        }, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
        const z = pkcs0[0];
        const seed = pkcs0.subarray(1, hashSize + 1);
        const dataBlock = pkcs0.subarray(hashSize + 1);
        if (z !== 0) {
            throw new Error("Decryption failed");
        }
        const seedMask = this.mgf1(internalKey.algorithm.hash, dataBlock, seed.length);
        for (let i = 0; i < seed.length; i++) {
            seed[i] ^= seedMask[i];
        }
        const dataBlockMask = this.mgf1(internalKey.algorithm.hash, seed, dataBlock.length);
        for (let i = 0; i < dataBlock.length; i++) {
            dataBlock[i] ^= dataBlockMask[i];
        }
        const labelHash = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createHash(internalKey.algorithm.hash.name.replace("-", ""))
            .update(webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* BufferSourceConverter */ "h"].toUint8Array(algorithm.label || new Uint8Array(0)))
            .digest();
        for (let i = 0; i < hashSize; i++) {
            if (labelHash[i] !== dataBlock[i]) {
                throw new Error("Decryption failed");
            }
        }
        let psEnd = hashSize;
        for (; psEnd < dataBlock.length; psEnd++) {
            const psz = dataBlock[psEnd];
            if (psz === 1) {
                break;
            }
            if (psz !== 0) {
                throw new Error("Decryption failed");
            }
        }
        if (psEnd === dataBlock.length) {
            throw new Error("Decryption failed");
        }
        pkcs0 = dataBlock.subarray(psEnd + 1);
        return new Uint8Array(pkcs0).buffer;
    }
    async onExportKey(format, key) {
        return RsaCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const key = await RsaCrypto.importKey(format, keyData, { ...algorithm, name: this.name }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        const internalKey = getCryptoKey(key);
        if (!(internalKey instanceof RsaPrivateKey || internalKey instanceof RsaPublicKey)) {
            throw new TypeError("key: Is not RSA CryptoKey");
        }
    }
    mgf1(algorithm, seed, length = 0) {
        const hashSize = ShaCrypto.size(algorithm) >> 3;
        const mask = new Uint8Array(length);
        const counter = new Uint8Array(4);
        const chunks = Math.ceil(length / hashSize);
        for (let i = 0; i < chunks; i++) {
            counter[0] = i >>> 24;
            counter[1] = (i >>> 16) & 255;
            counter[2] = (i >>> 8) & 255;
            counter[3] = i & 255;
            const submask = mask.subarray(i * hashSize);
            let chunk = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createHash(algorithm.name.replace("-", ""))
                .update(seed)
                .update(counter)
                .digest();
            if (chunk.length > submask.length) {
                chunk = chunk.subarray(0, submask.length);
            }
            submask.set(chunk);
        }
        return mask;
    }
}

class RsaEsProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* ProviderCrypto */ "y"] {
    constructor() {
        super(...arguments);
        this.name = "RSAES-PKCS1-v1_5";
        this.usages = {
            publicKey: ["encrypt", "wrapKey"],
            privateKey: ["decrypt", "unwrapKey"],
        };
    }
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const keys = await RsaCrypto.generateKey({
            ...algorithm,
            name: this.name,
        }, extractable, keyUsages);
        return {
            privateKey: setCryptoKey(keys.privateKey),
            publicKey: setCryptoKey(keys.publicKey),
        };
    }
    checkGenerateKeyParams(algorithm) {
        this.checkRequiredProperty(algorithm, "publicExponent");
        if (!(algorithm.publicExponent && algorithm.publicExponent instanceof Uint8Array)) {
            throw new TypeError("publicExponent: Missing or not a Uint8Array");
        }
        const publicExponent = pvtsutils__WEBPACK_IMPORTED_MODULE_6__["Convert"].ToBase64(algorithm.publicExponent);
        if (!(publicExponent === "Aw==" || publicExponent === "AQAB")) {
            throw new TypeError("publicExponent: Must be [3] or [1,0,1]");
        }
        this.checkRequiredProperty(algorithm, "modulusLength");
        switch (algorithm.modulusLength) {
            case 1024:
            case 2048:
            case 4096:
                break;
            default:
                throw new TypeError("modulusLength: Must be 1024, 2048, or 4096");
        }
    }
    async onEncrypt(algorithm, key, data) {
        const options = this.toCryptoOptions(key);
        const enc = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.publicEncrypt(options, new Uint8Array(data));
        return new Uint8Array(enc).buffer;
    }
    async onDecrypt(algorithm, key, data) {
        const options = this.toCryptoOptions(key);
        const dec = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.privateDecrypt(options, new Uint8Array(data));
        return new Uint8Array(dec).buffer;
    }
    async onExportKey(format, key) {
        return RsaCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const key = await RsaCrypto.importKey(format, keyData, { ...algorithm, name: this.name }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        const internalKey = getCryptoKey(key);
        if (!(internalKey instanceof RsaPrivateKey || internalKey instanceof RsaPublicKey)) {
            throw new TypeError("key: Is not RSA CryptoKey");
        }
    }
    toCryptoOptions(key) {
        const type = key.type.toUpperCase();
        return {
            key: `-----BEGIN ${type} KEY-----\n${getCryptoKey(key).data.toString("base64")}\n-----END ${type} KEY-----`,
            padding: crypto__WEBPACK_IMPORTED_MODULE_2___default.a.constants.RSA_PKCS1_PADDING,
        };
    }
}

const namedOIDs = {
    "1.2.840.10045.3.1.7": "P-256",
    "P-256": "1.2.840.10045.3.1.7",
    "1.3.132.0.34": "P-384",
    "P-384": "1.3.132.0.34",
    "1.3.132.0.35": "P-521",
    "P-521": "1.3.132.0.35",
    "1.3.132.0.10": "K-256",
    "K-256": "1.3.132.0.10",
    "brainpoolP160r1": "1.3.36.3.3.2.8.1.1.1",
    "1.3.36.3.3.2.8.1.1.1": "brainpoolP160r1",
    "brainpoolP160t1": "1.3.36.3.3.2.8.1.1.2",
    "1.3.36.3.3.2.8.1.1.2": "brainpoolP160t1",
    "brainpoolP192r1": "1.3.36.3.3.2.8.1.1.3",
    "1.3.36.3.3.2.8.1.1.3": "brainpoolP192r1",
    "brainpoolP192t1": "1.3.36.3.3.2.8.1.1.4",
    "1.3.36.3.3.2.8.1.1.4": "brainpoolP192t1",
    "brainpoolP224r1": "1.3.36.3.3.2.8.1.1.5",
    "1.3.36.3.3.2.8.1.1.5": "brainpoolP224r1",
    "brainpoolP224t1": "1.3.36.3.3.2.8.1.1.6",
    "1.3.36.3.3.2.8.1.1.6": "brainpoolP224t1",
    "brainpoolP256r1": "1.3.36.3.3.2.8.1.1.7",
    "1.3.36.3.3.2.8.1.1.7": "brainpoolP256r1",
    "brainpoolP256t1": "1.3.36.3.3.2.8.1.1.8",
    "1.3.36.3.3.2.8.1.1.8": "brainpoolP256t1",
    "brainpoolP320r1": "1.3.36.3.3.2.8.1.1.9",
    "1.3.36.3.3.2.8.1.1.9": "brainpoolP320r1",
    "brainpoolP320t1": "1.3.36.3.3.2.8.1.1.10",
    "1.3.36.3.3.2.8.1.1.10": "brainpoolP320t1",
    "brainpoolP384r1": "1.3.36.3.3.2.8.1.1.11",
    "1.3.36.3.3.2.8.1.1.11": "brainpoolP384r1",
    "brainpoolP384t1": "1.3.36.3.3.2.8.1.1.12",
    "1.3.36.3.3.2.8.1.1.12": "brainpoolP384t1",
    "brainpoolP512r1": "1.3.36.3.3.2.8.1.1.13",
    "1.3.36.3.3.2.8.1.1.13": "brainpoolP512r1",
    "brainpoolP512t1": "1.3.36.3.3.2.8.1.1.14",
    "1.3.36.3.3.2.8.1.1.14": "brainpoolP512t1",
};
function getOidByNamedCurve$1(namedCurve) {
    const oid = namedOIDs[namedCurve];
    if (!oid) {
        throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"](`Cannot convert WebCrypto named curve '${namedCurve}' to OID`);
    }
    return oid;
}

class EcPrivateKey extends AsymmetricKey {
    constructor() {
        super(...arguments);
        this.type = "private";
    }
    getKey() {
        const keyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(this.data, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo);
        return _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(keyInfo.privateKey, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EcPrivateKey);
    }
    toJSON() {
        const key = this.getKey();
        const json = {
            kty: "EC",
            crv: this.algorithm.namedCurve,
            key_ops: this.usages,
            ext: this.extractable,
        };
        return Object.assign(json, _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonSerializer */ "d"].toJSON(key));
    }
    fromJSON(json) {
        if (!json.crv) {
            throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"](`Cannot get named curve from JWK. Property 'crv' is required`);
        }
        const keyInfo = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo();
        keyInfo.privateKeyAlgorithm.algorithm = "1.2.840.10045.2.1";
        keyInfo.privateKeyAlgorithm.parameters = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].ObjectIdentifier(getOidByNamedCurve$1(json.crv)));
        const key = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(json, { targetSchema: webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EcPrivateKey });
        keyInfo.privateKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(key);
        this.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(keyInfo));
        return this;
    }
}

class EcPublicKey extends AsymmetricKey {
    constructor() {
        super(...arguments);
        this.type = "public";
    }
    getKey() {
        const keyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(this.data, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo);
        return new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EcPublicKey(keyInfo.publicKey);
    }
    toJSON() {
        const key = this.getKey();
        const json = {
            kty: "EC",
            crv: this.algorithm.namedCurve,
            key_ops: this.usages,
            ext: this.extractable,
        };
        return Object.assign(json, _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonSerializer */ "d"].toJSON(key));
    }
    fromJSON(json) {
        if (!json.crv) {
            throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"](`Cannot get named curve from JWK. Property 'crv' is required`);
        }
        const key = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(json, { targetSchema: webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EcPublicKey });
        const keyInfo = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo();
        keyInfo.publicKeyAlgorithm.algorithm = "1.2.840.10045.2.1";
        keyInfo.publicKeyAlgorithm.parameters = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].ObjectIdentifier(getOidByNamedCurve$1(json.crv)));
        keyInfo.publicKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].toASN(key).valueHex;
        this.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(keyInfo));
        return this;
    }
}

class Sha1Provider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* ProviderCrypto */ "y"] {
    constructor() {
        super(...arguments);
        this.name = "SHA-1";
        this.usages = [];
    }
    async onDigest(algorithm, data) {
        return ShaCrypto.digest(algorithm, data);
    }
}

class Sha256Provider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* ProviderCrypto */ "y"] {
    constructor() {
        super(...arguments);
        this.name = "SHA-256";
        this.usages = [];
    }
    async onDigest(algorithm, data) {
        return ShaCrypto.digest(algorithm, data);
    }
}

class Sha384Provider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* ProviderCrypto */ "y"] {
    constructor() {
        super(...arguments);
        this.name = "SHA-384";
        this.usages = [];
    }
    async onDigest(algorithm, data) {
        return ShaCrypto.digest(algorithm, data);
    }
}

class Sha512Provider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* ProviderCrypto */ "y"] {
    constructor() {
        super(...arguments);
        this.name = "SHA-512";
        this.usages = [];
    }
    async onDigest(algorithm, data) {
        return ShaCrypto.digest(algorithm, data);
    }
}

class Sha3256Provider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* ProviderCrypto */ "y"] {
    constructor() {
        super(...arguments);
        this.name = "SHA3-256";
        this.usages = [];
    }
    async onDigest(algorithm, data) {
        return ShaCrypto.digest(algorithm, data);
    }
}

class Sha3384Provider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* ProviderCrypto */ "y"] {
    constructor() {
        super(...arguments);
        this.name = "SHA3-384";
        this.usages = [];
    }
    async onDigest(algorithm, data) {
        return ShaCrypto.digest(algorithm, data);
    }
}

class Sha3512Provider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* ProviderCrypto */ "y"] {
    constructor() {
        super(...arguments);
        this.name = "SHA3-512";
        this.usages = [];
    }
    async onDigest(algorithm, data) {
        return ShaCrypto.digest(algorithm, data);
    }
}

class EcCrypto {
    static async generateKey(algorithm, extractable, keyUsages) {
        const privateKey = new EcPrivateKey();
        privateKey.algorithm = algorithm;
        privateKey.extractable = extractable;
        privateKey.usages = keyUsages.filter((usage) => this.privateKeyUsages.indexOf(usage) !== -1);
        const publicKey = new EcPublicKey();
        publicKey.algorithm = algorithm;
        publicKey.extractable = true;
        publicKey.usages = keyUsages.filter((usage) => this.publicKeyUsages.indexOf(usage) !== -1);
        const keys = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.generateKeyPairSync("ec", {
            namedCurve: this.getOpenSSLNamedCurve(algorithm.namedCurve),
            publicKeyEncoding: {
                format: "der",
                type: "spki",
            },
            privateKeyEncoding: {
                format: "der",
                type: "pkcs8",
            },
        });
        privateKey.data = keys.privateKey;
        publicKey.data = keys.publicKey;
        const res = {
            privateKey,
            publicKey,
        };
        return res;
    }
    static async sign(algorithm, key, data) {
        const cryptoAlg = ShaCrypto.getAlgorithmName(algorithm.hash);
        const signer = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createSign(cryptoAlg);
        signer.update(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
        if (!key.pem) {
            key.pem = `-----BEGIN PRIVATE KEY-----\n${key.data.toString("base64")}\n-----END PRIVATE KEY-----`;
        }
        const options = {
            key: key.pem,
        };
        const signature = signer.sign(options);
        const ecSignature = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(signature, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EcDsaSignature);
        const signatureRaw = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* EcUtils */ "n"].encodeSignature(ecSignature, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* EcCurves */ "m"].get(key.algorithm.namedCurve).size);
        return signatureRaw.buffer;
    }
    static async verify(algorithm, key, signature, data) {
        const cryptoAlg = ShaCrypto.getAlgorithmName(algorithm.hash);
        const signer = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createVerify(cryptoAlg);
        signer.update(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data));
        if (!key.pem) {
            key.pem = `-----BEGIN PUBLIC KEY-----\n${key.data.toString("base64")}\n-----END PUBLIC KEY-----`;
        }
        const options = {
            key: key.pem,
        };
        const ecSignature = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EcDsaSignature();
        const namedCurve = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* EcCurves */ "m"].get(key.algorithm.namedCurve);
        const signaturePoint = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* EcUtils */ "n"].decodeSignature(signature, namedCurve.size);
        ecSignature.r = pvtsutils__WEBPACK_IMPORTED_MODULE_6__["BufferSourceConverter"].toArrayBuffer(signaturePoint.r);
        ecSignature.s = pvtsutils__WEBPACK_IMPORTED_MODULE_6__["BufferSourceConverter"].toArrayBuffer(signaturePoint.s);
        const ecSignatureRaw = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(ecSignature));
        const ok = signer.verify(options, ecSignatureRaw);
        return ok;
    }
    static async deriveBits(algorithm, baseKey, length) {
        const cryptoAlg = this.getOpenSSLNamedCurve(baseKey.algorithm.namedCurve);
        const ecdh = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createECDH(cryptoAlg);
        const asnPrivateKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(baseKey.data, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo);
        const asnEcPrivateKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(asnPrivateKey.privateKey, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EcPrivateKey);
        ecdh.setPrivateKey(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(asnEcPrivateKey.privateKey));
        const asnPublicKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(algorithm.public.data, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo);
        const bits = ecdh.computeSecret(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(asnPublicKey.publicKey));
        if (length === null) {
            return bits;
        }
        return new Uint8Array(bits).buffer.slice(0, length >> 3);
    }
    static async exportKey(format, key) {
        switch (format.toLowerCase()) {
            case "jwk":
                return _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonSerializer */ "d"].toJSON(key);
            case "pkcs8":
            case "spki":
                return new Uint8Array(key.data).buffer;
            case "raw": {
                const publicKeyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(key.data, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo);
                return publicKeyInfo.publicKey;
            }
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk', 'raw', pkcs8' or 'spki'");
        }
    }
    static async importKey(format, keyData, algorithm, extractable, keyUsages) {
        switch (format.toLowerCase()) {
            case "jwk": {
                const jwk = keyData;
                if (jwk.d) {
                    const asnKey = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(keyData, { targetSchema: webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EcPrivateKey });
                    return this.importPrivateKey(asnKey, algorithm, extractable, keyUsages);
                }
                else {
                    const asnKey = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(keyData, { targetSchema: webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EcPublicKey });
                    return this.importPublicKey(asnKey, algorithm, extractable, keyUsages);
                }
            }
            case "raw": {
                const asnKey = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EcPublicKey(keyData);
                return this.importPublicKey(asnKey, algorithm, extractable, keyUsages);
            }
            case "spki": {
                const keyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(new Uint8Array(keyData), webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo);
                const asnKey = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EcPublicKey(keyInfo.publicKey);
                this.assertKeyParameters(keyInfo.publicKeyAlgorithm.parameters, algorithm.namedCurve);
                return this.importPublicKey(asnKey, algorithm, extractable, keyUsages);
            }
            case "pkcs8": {
                const keyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(new Uint8Array(keyData), webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo);
                const asnKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(keyInfo.privateKey, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EcPrivateKey);
                this.assertKeyParameters(keyInfo.privateKeyAlgorithm.parameters, algorithm.namedCurve);
                return this.importPrivateKey(asnKey, algorithm, extractable, keyUsages);
            }
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk', 'raw', 'pkcs8' or 'spki'");
        }
    }
    static assertKeyParameters(parameters, namedCurve) {
        if (!parameters) {
            throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* CryptoError */ "j"]("Key info doesn't have required parameters");
        }
        let namedCurveIdentifier = "";
        try {
            namedCurveIdentifier = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(parameters, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].ObjectIdentifier).value;
        }
        catch (e) {
            throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* CryptoError */ "j"]("Cannot read key info parameters");
        }
        if (getOidByNamedCurve$1(namedCurve) !== namedCurveIdentifier) {
            throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* CryptoError */ "j"]("Key info parameter doesn't match to named curve");
        }
    }
    static async importPrivateKey(asnKey, algorithm, extractable, keyUsages) {
        const keyInfo = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo();
        keyInfo.privateKeyAlgorithm.algorithm = "1.2.840.10045.2.1";
        keyInfo.privateKeyAlgorithm.parameters = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].ObjectIdentifier(getOidByNamedCurve$1(algorithm.namedCurve)));
        keyInfo.privateKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(asnKey);
        const key = new EcPrivateKey();
        key.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(keyInfo));
        key.algorithm = Object.assign({}, algorithm);
        key.extractable = extractable;
        key.usages = keyUsages;
        return key;
    }
    static async importPublicKey(asnKey, algorithm, extractable, keyUsages) {
        const keyInfo = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo();
        keyInfo.publicKeyAlgorithm.algorithm = "1.2.840.10045.2.1";
        const namedCurve = getOidByNamedCurve$1(algorithm.namedCurve);
        keyInfo.publicKeyAlgorithm.parameters = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].ObjectIdentifier(namedCurve));
        keyInfo.publicKey = asnKey.value;
        const key = new EcPublicKey();
        key.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(keyInfo));
        key.algorithm = Object.assign({}, algorithm);
        key.extractable = extractable;
        key.usages = keyUsages;
        return key;
    }
    static getOpenSSLNamedCurve(curve) {
        switch (curve.toUpperCase()) {
            case "P-256":
                return "prime256v1";
            case "K-256":
                return "secp256k1";
            case "P-384":
                return "secp384r1";
            case "P-521":
                return "secp521r1";
            default:
                return curve;
        }
    }
}
EcCrypto.publicKeyUsages = ["verify"];
EcCrypto.privateKeyUsages = ["sign", "deriveKey", "deriveBits"];

class EcdsaProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* EcdsaProvider */ "q"] {
    constructor() {
        super(...arguments);
        this.namedCurves = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* EcCurves */ "m"].names;
        this.hashAlgorithms = [
            "SHA-1", "SHA-256", "SHA-384", "SHA-512",
            "shake128", "shake256",
            "SHA3-256", "SHA3-384", "SHA3-512"
        ];
    }
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const keys = await EcCrypto.generateKey({
            ...algorithm,
            name: this.name,
        }, extractable, keyUsages);
        return {
            privateKey: setCryptoKey(keys.privateKey),
            publicKey: setCryptoKey(keys.publicKey),
        };
    }
    async onSign(algorithm, key, data) {
        return EcCrypto.sign(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onVerify(algorithm, key, signature, data) {
        return EcCrypto.verify(algorithm, getCryptoKey(key), new Uint8Array(signature), new Uint8Array(data));
    }
    async onExportKey(format, key) {
        return EcCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const key = await EcCrypto.importKey(format, keyData, { ...algorithm, name: this.name }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        const internalKey = getCryptoKey(key);
        if (!(internalKey instanceof EcPrivateKey || internalKey instanceof EcPublicKey)) {
            throw new TypeError("key: Is not EC CryptoKey");
        }
    }
}

class EcdhProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* EcdhProvider */ "p"] {
    constructor() {
        super(...arguments);
        this.namedCurves = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* EcCurves */ "m"].names;
    }
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const keys = await EcCrypto.generateKey({
            ...algorithm,
            name: this.name,
        }, extractable, keyUsages);
        return {
            privateKey: setCryptoKey(keys.privateKey),
            publicKey: setCryptoKey(keys.publicKey),
        };
    }
    async onExportKey(format, key) {
        return EcCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const key = await EcCrypto.importKey(format, keyData, { ...algorithm, name: this.name }, extractable, keyUsages);
        return setCryptoKey(key);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        const internalKey = getCryptoKey(key);
        if (!(internalKey instanceof EcPrivateKey || internalKey instanceof EcPublicKey)) {
            throw new TypeError("key: Is not EC CryptoKey");
        }
    }
    async onDeriveBits(algorithm, baseKey, length) {
        const bits = await EcCrypto.deriveBits({ ...algorithm, public: getCryptoKey(algorithm.public) }, getCryptoKey(baseKey), length);
        return bits;
    }
}

const edOIDs = {
    [webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].idEd448]: "Ed448",
    "ed448": webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].idEd448,
    [webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].idX448]: "X448",
    "x448": webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].idX448,
    [webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].idEd25519]: "Ed25519",
    "ed25519": webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].idEd25519,
    [webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].idX25519]: "X25519",
    "x25519": webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].idX25519,
};
function getOidByNamedCurve(namedCurve) {
    const oid = edOIDs[namedCurve.toLowerCase()];
    if (!oid) {
        throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"](`Cannot convert WebCrypto named curve '${namedCurve}' to OID`);
    }
    return oid;
}

class EdPrivateKey extends AsymmetricKey {
    constructor() {
        super(...arguments);
        this.type = "private";
    }
    getKey() {
        const keyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(this.data, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo);
        return _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(keyInfo.privateKey, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].CurvePrivateKey);
    }
    toJSON() {
        const key = this.getKey();
        const json = {
            kty: "OKP",
            crv: this.algorithm.namedCurve,
            key_ops: this.usages,
            ext: this.extractable,
        };
        return Object.assign(json, _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonSerializer */ "d"].toJSON(key));
    }
    fromJSON(json) {
        if (!json.crv) {
            throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"](`Cannot get named curve from JWK. Property 'crv' is required`);
        }
        const keyInfo = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo();
        keyInfo.privateKeyAlgorithm.algorithm = getOidByNamedCurve(json.crv);
        const key = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(json, { targetSchema: webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].CurvePrivateKey });
        keyInfo.privateKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(key);
        this.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(keyInfo));
        return this;
    }
}

class EdPublicKey extends AsymmetricKey {
    constructor() {
        super(...arguments);
        this.type = "public";
    }
    getKey() {
        const keyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(this.data, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo);
        return keyInfo.publicKey;
    }
    toJSON() {
        const key = this.getKey();
        const json = {
            kty: "OKP",
            crv: this.algorithm.namedCurve,
            key_ops: this.usages,
            ext: this.extractable,
        };
        return Object.assign(json, {
            x: pvtsutils__WEBPACK_IMPORTED_MODULE_6__["Convert"].ToBase64Url(key)
        });
    }
    fromJSON(json) {
        if (!json.crv) {
            throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"](`Cannot get named curve from JWK. Property 'crv' is required`);
        }
        if (!json.x) {
            throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"](`Cannot get property from JWK. Property 'x' is required`);
        }
        const keyInfo = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo();
        keyInfo.publicKeyAlgorithm.algorithm = getOidByNamedCurve(json.crv);
        keyInfo.publicKey = pvtsutils__WEBPACK_IMPORTED_MODULE_6__["Convert"].FromBase64Url(json.x);
        this.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(_peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnSerializer */ "f"].serialize(keyInfo));
        return this;
    }
}

class EdCrypto {
    static async generateKey(algorithm, extractable, keyUsages) {
        const privateKey = new EdPrivateKey();
        privateKey.algorithm = algorithm;
        privateKey.extractable = extractable;
        privateKey.usages = keyUsages.filter((usage) => this.privateKeyUsages.indexOf(usage) !== -1);
        const publicKey = new EdPublicKey();
        publicKey.algorithm = algorithm;
        publicKey.extractable = true;
        publicKey.usages = keyUsages.filter((usage) => this.publicKeyUsages.indexOf(usage) !== -1);
        const type = algorithm.namedCurve.toLowerCase();
        const keys = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.generateKeyPairSync(type, {
            publicKeyEncoding: {
                format: "der",
                type: "spki",
            },
            privateKeyEncoding: {
                format: "der",
                type: "pkcs8",
            },
        });
        privateKey.data = keys.privateKey;
        publicKey.data = keys.publicKey;
        const res = {
            privateKey,
            publicKey,
        };
        return res;
    }
    static async sign(algorithm, key, data) {
        if (!key.pem) {
            key.pem = `-----BEGIN PRIVATE KEY-----\n${key.data.toString("base64")}\n-----END PRIVATE KEY-----`;
        }
        const options = {
            key: key.pem,
        };
        const signature = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.sign(null, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data), options);
        return webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* BufferSourceConverter */ "h"].toArrayBuffer(signature);
    }
    static async verify(algorithm, key, signature, data) {
        if (!key.pem) {
            key.pem = `-----BEGIN PUBLIC KEY-----\n${key.data.toString("base64")}\n-----END PUBLIC KEY-----`;
        }
        const options = {
            key: key.pem,
        };
        const ok = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.verify(null, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data), options, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(signature));
        return ok;
    }
    static async deriveBits(algorithm, baseKey, length) {
        const publicKey = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createPublicKey({
            key: algorithm.public.data,
            format: "der",
            type: "spki",
        });
        const privateKey = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createPrivateKey({
            key: baseKey.data,
            format: "der",
            type: "pkcs8",
        });
        const bits = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.diffieHellman({
            publicKey,
            privateKey,
        });
        return new Uint8Array(bits).buffer.slice(0, length >> 3);
    }
    static async exportKey(format, key) {
        switch (format.toLowerCase()) {
            case "jwk":
                return _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonSerializer */ "d"].toJSON(key);
            case "pkcs8":
            case "spki":
                return new Uint8Array(key.data).buffer;
            case "raw": {
                const publicKeyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(key.data, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo);
                return publicKeyInfo.publicKey;
            }
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk', 'raw', pkcs8' or 'spki'");
        }
    }
    static async importKey(format, keyData, algorithm, extractable, keyUsages) {
        switch (format.toLowerCase()) {
            case "jwk": {
                const jwk = keyData;
                if (jwk.d) {
                    const asnKey = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(keyData, { targetSchema: webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].CurvePrivateKey });
                    return this.importPrivateKey(asnKey, algorithm, extractable, keyUsages);
                }
                else {
                    if (!jwk.x) {
                        throw new TypeError("keyData: Cannot get required 'x' filed");
                    }
                    return this.importPublicKey(pvtsutils__WEBPACK_IMPORTED_MODULE_6__["Convert"].FromBase64Url(jwk.x), algorithm, extractable, keyUsages);
                }
            }
            case "raw": {
                return this.importPublicKey(keyData, algorithm, extractable, keyUsages);
            }
            case "spki": {
                const keyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(new Uint8Array(keyData), webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PublicKeyInfo);
                return this.importPublicKey(keyInfo.publicKey, algorithm, extractable, keyUsages);
            }
            case "pkcs8": {
                const keyInfo = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(new Uint8Array(keyData), webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo);
                const asnKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnParser */ "c"].parse(keyInfo.privateKey, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].CurvePrivateKey);
                return this.importPrivateKey(asnKey, algorithm, extractable, keyUsages);
            }
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk', 'raw', 'pkcs8' or 'spki'");
        }
    }
    static importPrivateKey(asnKey, algorithm, extractable, keyUsages) {
        const key = new EdPrivateKey();
        key.fromJSON({
            crv: algorithm.namedCurve,
            d: pvtsutils__WEBPACK_IMPORTED_MODULE_6__["Convert"].ToBase64Url(asnKey.d),
        });
        key.algorithm = Object.assign({}, algorithm);
        key.extractable = extractable;
        key.usages = keyUsages;
        return key;
    }
    static async importPublicKey(asnKey, algorithm, extractable, keyUsages) {
        const key = new EdPublicKey();
        key.fromJSON({
            crv: algorithm.namedCurve,
            x: pvtsutils__WEBPACK_IMPORTED_MODULE_6__["Convert"].ToBase64Url(asnKey),
        });
        key.algorithm = Object.assign({}, algorithm);
        key.extractable = extractable;
        key.usages = keyUsages;
        return key;
    }
}
EdCrypto.publicKeyUsages = ["verify"];
EdCrypto.privateKeyUsages = ["sign", "deriveKey", "deriveBits"];

class EdDsaProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* EdDsaProvider */ "s"] {
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const keys = await EdCrypto.generateKey({
            name: this.name,
            namedCurve: algorithm.namedCurve.replace(/^ed/i, "Ed"),
        }, extractable, keyUsages);
        return {
            privateKey: setCryptoKey(keys.privateKey),
            publicKey: setCryptoKey(keys.publicKey),
        };
    }
    async onSign(algorithm, key, data) {
        return EdCrypto.sign(algorithm, getCryptoKey(key), new Uint8Array(data));
    }
    async onVerify(algorithm, key, signature, data) {
        return EdCrypto.verify(algorithm, getCryptoKey(key), new Uint8Array(signature), new Uint8Array(data));
    }
    async onExportKey(format, key) {
        return EdCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const key = await EdCrypto.importKey(format, keyData, { ...algorithm, name: this.name }, extractable, keyUsages);
        return setCryptoKey(key);
    }
}

class EcdhEsProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* EcdhEsProvider */ "o"] {
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const keys = await EdCrypto.generateKey({
            name: this.name,
            namedCurve: algorithm.namedCurve.toUpperCase(),
        }, extractable, keyUsages);
        return {
            privateKey: setCryptoKey(keys.privateKey),
            publicKey: setCryptoKey(keys.publicKey),
        };
    }
    async onDeriveBits(algorithm, baseKey, length) {
        const bits = await EdCrypto.deriveBits({ ...algorithm, public: getCryptoKey(algorithm.public) }, getCryptoKey(baseKey), length);
        return bits;
    }
    async onExportKey(format, key) {
        return EdCrypto.exportKey(format, getCryptoKey(key));
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const key = await EdCrypto.importKey(format, keyData, { ...algorithm, name: this.name }, extractable, keyUsages);
        return setCryptoKey(key);
    }
}

class Ed25519CryptoKey extends CryptoKey {
    constructor(algorithm, extractable, usages, data) {
        super();
        this.algorithm = algorithm;
        this.extractable = extractable;
        this.usages = usages;
        this.data = Buffer.from(data);
    }
    toJWK() {
        return {
            kty: "OKP",
            crv: this.algorithm.name,
            key_ops: this.usages,
            ext: this.extractable,
        };
    }
}

class Ed25519PrivateKey extends Ed25519CryptoKey {
    constructor() {
        super(...arguments);
        this.type = "private";
    }
    toJWK() {
        const pubJwk = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createPublicKey({
            key: this.data,
            format: "pem",
        }).export({ format: "jwk" });
        const raw = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* PemConverter */ "x"].toUint8Array(this.data.toString());
        const pkcs8 = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnConvert */ "a"].parse(raw, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo);
        const d = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnConvert */ "a"].parse(pkcs8.privateKey, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EdPrivateKey).value;
        return {
            ...super.toJWK(),
            ...pubJwk,
            d: Buffer.from(new Uint8Array(d)).toString("base64url"),
        };
    }
}

class Ed25519PublicKey extends Ed25519CryptoKey {
    constructor() {
        super(...arguments);
        this.type = "public";
    }
    toJWK() {
        const jwk = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createPublicKey({
            key: this.data,
            format: "pem",
        }).export({ format: "jwk" });
        return {
            ...super.toJWK(),
            ...jwk,
        };
    }
}

class Ed25519Crypto {
    static async generateKey(algorithm, extractable, keyUsages) {
        const type = algorithm.name.toLowerCase();
        const keys = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.generateKeyPairSync(type, {
            publicKeyEncoding: {
                format: "pem",
                type: "spki",
            },
            privateKeyEncoding: {
                format: "pem",
                type: "pkcs8",
            },
        });
        const keyAlg = {
            name: type === "ed25519" ? "Ed25519" : "X25519",
        };
        const privateKeyUsages = keyUsages.filter((usage) => this.privateKeyUsages.includes(usage));
        const publicKeyUsages = keyUsages.filter((usage) => this.publicKeyUsages.includes(usage));
        return {
            privateKey: new Ed25519PrivateKey(keyAlg, extractable, privateKeyUsages, keys.privateKey),
            publicKey: new Ed25519PublicKey(keyAlg, true, publicKeyUsages, keys.publicKey),
        };
    }
    static async sign(algorithm, key, data) {
        const signature = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.sign(null, Buffer.from(data), key.data);
        return webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* BufferSourceConverter */ "h"].toArrayBuffer(signature);
    }
    static async verify(algorithm, key, signature, data) {
        return crypto__WEBPACK_IMPORTED_MODULE_2___default.a.verify(null, Buffer.from(data), key.data, signature);
    }
    static async exportKey(format, key) {
        switch (format) {
            case "jwk":
                return key.toJWK();
            case "pkcs8": {
                return webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* PemConverter */ "x"].toArrayBuffer(key.data.toString());
            }
            case "spki": {
                return webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* PemConverter */ "x"].toArrayBuffer(key.data.toString());
            }
            case "raw": {
                const jwk = key.toJWK();
                return pvtsutils__WEBPACK_IMPORTED_MODULE_6__["Convert"].FromBase64Url(jwk.x);
            }
            default:
                return Promise.reject(new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk', 'raw', pkcs8' or 'spki'"));
        }
    }
    static async importKey(format, keyData, algorithm, extractable, keyUsages) {
        switch (format) {
            case "jwk": {
                const jwk = keyData;
                if (jwk.d) {
                    const privateData = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].EdPrivateKey();
                    privateData.value = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* BufferSourceConverter */ "h"].toArrayBuffer(Buffer.from(jwk.d, "base64url"));
                    const pkcs8 = new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].PrivateKeyInfo();
                    pkcs8.privateKeyAlgorithm.algorithm = algorithm.name.toLowerCase() === "ed25519"
                        ? webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].idEd25519
                        : webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* asn1 */ "G"].idX25519;
                    pkcs8.privateKey = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnConvert */ "a"].serialize(privateData);
                    const raw = _peculiar_asn1_schema__WEBPACK_IMPORTED_MODULE_7__[/* AsnConvert */ "a"].serialize(pkcs8);
                    const pem = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* PemConverter */ "x"].fromBufferSource(raw, "PRIVATE KEY");
                    return new Ed25519PrivateKey(algorithm, extractable, keyUsages, pem);
                }
                else if (jwk.x) {
                    const pubKey = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createPublicKey({
                        format: "jwk",
                        key: jwk,
                    });
                    const pem = pubKey.export({ format: "pem", type: "spki" });
                    return new Ed25519PublicKey(algorithm, extractable, keyUsages, pem);
                }
                else {
                    throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("keyData: Cannot import JWK. 'd' or 'x' must be presented");
                }
            }
            case "pkcs8": {
                const pem = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* PemConverter */ "x"].fromBufferSource(keyData, "PRIVATE KEY");
                return new Ed25519PrivateKey(algorithm, extractable, keyUsages, pem);
            }
            case "spki": {
                const pem = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* PemConverter */ "x"].fromBufferSource(keyData, "PUBLIC KEY");
                return new Ed25519PublicKey(algorithm, extractable, keyUsages, pem);
            }
            case "raw": {
                const raw = keyData;
                const key = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createPublicKey({
                    format: "jwk",
                    key: {
                        kty: "OKP",
                        crv: algorithm.name.toLowerCase() === "ed25519" ? "Ed25519" : "X25519",
                        x: pvtsutils__WEBPACK_IMPORTED_MODULE_6__["Convert"].ToBase64Url(raw),
                    },
                });
                const pem = key.export({ format: "pem", type: "spki" });
                return new Ed25519PublicKey(algorithm, extractable, keyUsages, pem);
            }
            default:
                return Promise.reject(new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk', 'raw', pkcs8' or 'spki'"));
        }
    }
}
Ed25519Crypto.privateKeyUsages = ["sign", "deriveBits", "deriveKey"];
Ed25519Crypto.publicKeyUsages = ["verify"];

class Ed25519Provider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* Ed25519Provider */ "r"] {
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const keys = await Ed25519Crypto.generateKey(algorithm, extractable, keyUsages);
        return {
            privateKey: setCryptoKey(keys.privateKey),
            publicKey: setCryptoKey(keys.publicKey),
        };
    }
    async onSign(algorithm, key, data) {
        const internalKey = getCryptoKey(key);
        const signature = Ed25519Crypto.sign(algorithm, internalKey, new Uint8Array(data));
        return signature;
    }
    onVerify(algorithm, key, signature, data) {
        const internalKey = getCryptoKey(key);
        return Ed25519Crypto.verify(algorithm, internalKey, new Uint8Array(signature), new Uint8Array(data));
    }
    async onExportKey(format, key) {
        const internalKey = getCryptoKey(key);
        return Ed25519Crypto.exportKey(format, internalKey);
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const internalKey = await Ed25519Crypto.importKey(format, keyData, algorithm, extractable, keyUsages);
        return setCryptoKey(internalKey);
    }
}

class X25519Provider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* X25519Provider */ "F"] {
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const keys = await Ed25519Crypto.generateKey(algorithm, extractable, keyUsages);
        return {
            privateKey: setCryptoKey(keys.privateKey),
            publicKey: setCryptoKey(keys.publicKey),
        };
    }
    async onDeriveBits(algorithm, baseKey, length) {
        const internalBaseKey = getCryptoKey(baseKey);
        const internalPublicKey = getCryptoKey(algorithm.public);
        const publicKey = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createPublicKey({
            key: internalPublicKey.data.toString(),
            format: "pem",
            type: "spki",
        });
        const privateKey = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createPrivateKey({
            key: internalBaseKey.data.toString(),
            format: "pem",
            type: "pkcs8",
        });
        const bits = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.diffieHellman({
            publicKey,
            privateKey,
        });
        return new Uint8Array(bits).buffer.slice(0, length >> 3);
    }
    async onExportKey(format, key) {
        const internalKey = getCryptoKey(key);
        return Ed25519Crypto.exportKey(format, internalKey);
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        const key = await Ed25519Crypto.importKey(format, keyData, algorithm, extractable, keyUsages);
        return setCryptoKey(key);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        if (!(getCryptoKey(key) instanceof Ed25519CryptoKey)) {
            throw new TypeError("key: Is not a Ed25519CryptoKey");
        }
    }
}

class PbkdfCryptoKey extends CryptoKey {
}

class Pbkdf2Provider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* Pbkdf2Provider */ "w"] {
    async onDeriveBits(algorithm, baseKey, length) {
        return new Promise((resolve, reject) => {
            const salt = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* BufferSourceConverter */ "h"].toArrayBuffer(algorithm.salt);
            const hash = algorithm.hash.name.replace("-", "");
            crypto__WEBPACK_IMPORTED_MODULE_2___default.a.pbkdf2(getCryptoKey(baseKey).data, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(salt), algorithm.iterations, length >> 3, hash, (err, derivedBits) => {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(new Uint8Array(derivedBits).buffer);
                }
            });
        });
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        if (format === "raw") {
            const key = new PbkdfCryptoKey();
            key.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(keyData);
            key.algorithm = { name: this.name };
            key.extractable = false;
            key.usages = keyUsages;
            return setCryptoKey(key);
        }
        throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'raw'");
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        if (!(getCryptoKey(key) instanceof PbkdfCryptoKey)) {
            throw new TypeError("key: Is not PBKDF CryptoKey");
        }
    }
}

class HmacCryptoKey extends CryptoKey {
    get alg() {
        const hash = this.algorithm.hash.name.toUpperCase();
        return `HS${hash.replace("SHA-", "")}`;
    }
    set alg(value) {
    }
}
Object(tslib__WEBPACK_IMPORTED_MODULE_4__[/* __decorate */ "a"])([
    Object(_peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonProp */ "b"])({ name: "k", converter: JsonBase64UrlConverter })
], HmacCryptoKey.prototype, "data", void 0);

class HmacProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* HmacProvider */ "u"] {
    async onGenerateKey(algorithm, extractable, keyUsages) {
        const length = (algorithm.length || this.getDefaultLength(algorithm.hash.name)) >> 3 << 3;
        const key = new HmacCryptoKey();
        key.algorithm = {
            ...algorithm,
            length,
            name: this.name,
        };
        key.extractable = extractable;
        key.usages = keyUsages;
        key.data = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.randomBytes(length >> 3);
        return setCryptoKey(key);
    }
    async onSign(algorithm, key, data) {
        const cryptoAlg = ShaCrypto.getAlgorithmName(key.algorithm.hash);
        const hmac = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createHmac(cryptoAlg, getCryptoKey(key).data)
            .update(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data)).digest();
        return new Uint8Array(hmac).buffer;
    }
    async onVerify(algorithm, key, signature, data) {
        const cryptoAlg = ShaCrypto.getAlgorithmName(key.algorithm.hash);
        const hmac = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createHmac(cryptoAlg, getCryptoKey(key).data)
            .update(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data)).digest();
        return hmac.compare(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(signature)) === 0;
    }
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        let key;
        switch (format.toLowerCase()) {
            case "jwk":
                key = _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonParser */ "a"].fromJSON(keyData, { targetSchema: HmacCryptoKey });
                break;
            case "raw":
                key = new HmacCryptoKey();
                key.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(keyData);
                break;
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk' or 'raw'");
        }
        key.algorithm = {
            hash: { name: algorithm.hash.name },
            name: this.name,
            length: key.data.length << 3,
        };
        key.extractable = extractable;
        key.usages = keyUsages;
        return setCryptoKey(key);
    }
    async onExportKey(format, key) {
        switch (format.toLowerCase()) {
            case "jwk":
                return _peculiar_json_schema__WEBPACK_IMPORTED_MODULE_5__[/* JsonSerializer */ "d"].toJSON(getCryptoKey(key));
            case "raw":
                return new Uint8Array(getCryptoKey(key).data).buffer;
            default:
                throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("format: Must be 'jwk' or 'raw'");
        }
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        if (!(getCryptoKey(key) instanceof HmacCryptoKey)) {
            throw new TypeError("key: Is not HMAC CryptoKey");
        }
    }
}

class HkdfCryptoKey extends CryptoKey {
}

class HkdfProvider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* HkdfProvider */ "t"] {
    async onImportKey(format, keyData, algorithm, extractable, keyUsages) {
        if (format.toLowerCase() !== "raw") {
            throw new webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* OperationError */ "v"]("Operation not supported");
        }
        const key = new HkdfCryptoKey();
        key.data = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(keyData);
        key.algorithm = { name: this.name };
        key.extractable = extractable;
        key.usages = keyUsages;
        return setCryptoKey(key);
    }
    async onDeriveBits(params, baseKey, length) {
        const hash = params.hash.name.replace("-", "");
        const hashLength = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createHash(hash).digest().length;
        const byteLength = length / 8;
        const info = webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* BufferSourceConverter */ "h"].toUint8Array(params.info);
        const PRK = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createHmac(hash, webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* BufferSourceConverter */ "h"].toUint8Array(params.salt))
            .update(webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* BufferSourceConverter */ "h"].toUint8Array(getCryptoKey(baseKey).data))
            .digest();
        const blocks = [buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].alloc(0)];
        const blockCount = Math.ceil(byteLength / hashLength) + 1;
        for (let i = 1; i < blockCount; ++i) {
            blocks.push(crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createHmac(hash, PRK)
                .update(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat([blocks[i - 1], info, buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from([i])]))
                .digest());
        }
        return buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].concat(blocks).slice(0, byteLength);
    }
    checkCryptoKey(key, keyUsage) {
        super.checkCryptoKey(key, keyUsage);
        if (!(getCryptoKey(key) instanceof HkdfCryptoKey)) {
            throw new TypeError("key: Is not HKDF CryptoKey");
        }
    }
}

class ShakeCrypto {
    static digest(algorithm, data) {
        const hash = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.createHash(algorithm.name.toLowerCase(), { outputLength: algorithm.length })
            .update(buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(data)).digest();
        return new Uint8Array(hash).buffer;
    }
}

class Shake128Provider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* Shake128Provider */ "C"] {
    async onDigest(algorithm, data) {
        return ShakeCrypto.digest(algorithm, data);
    }
}

class Shake256Provider extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* Shake256Provider */ "D"] {
    async onDigest(algorithm, data) {
        return ShakeCrypto.digest(algorithm, data);
    }
}

class SubtleCrypto extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* SubtleCrypto */ "E"] {
    constructor() {
        var _a;
        super();
        this.providers.set(new AesCbcProvider());
        this.providers.set(new AesCtrProvider());
        this.providers.set(new AesGcmProvider());
        this.providers.set(new AesCmacProvider());
        this.providers.set(new AesKwProvider());
        this.providers.set(new AesEcbProvider());
        const ciphers = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.getCiphers();
        if (ciphers.includes("des-cbc")) {
            this.providers.set(new DesCbcProvider());
        }
        this.providers.set(new DesEde3CbcProvider());
        this.providers.set(new RsaSsaProvider());
        this.providers.set(new RsaPssProvider());
        this.providers.set(new RsaOaepProvider());
        this.providers.set(new RsaEsProvider());
        this.providers.set(new EcdsaProvider());
        this.providers.set(new EcdhProvider());
        this.providers.set(new Sha1Provider());
        this.providers.set(new Sha256Provider());
        this.providers.set(new Sha384Provider());
        this.providers.set(new Sha512Provider());
        this.providers.set(new Pbkdf2Provider());
        this.providers.set(new HmacProvider());
        this.providers.set(new HkdfProvider());
        const nodeMajorVersion = (_a = /^v(\d+)/.exec(process__WEBPACK_IMPORTED_MODULE_3__["version"])) === null || _a === void 0 ? void 0 : _a[1];
        if (nodeMajorVersion && parseInt(nodeMajorVersion, 10) >= 12) {
            this.providers.set(new Shake128Provider());
            this.providers.set(new Shake256Provider());
        }
        const hashes = crypto__WEBPACK_IMPORTED_MODULE_2___default.a.getHashes();
        if (hashes.includes("sha3-256")) {
            this.providers.set(new Sha3256Provider());
        }
        if (hashes.includes("sha3-384")) {
            this.providers.set(new Sha3384Provider());
        }
        if (hashes.includes("sha3-512")) {
            this.providers.set(new Sha3512Provider());
        }
        if (nodeMajorVersion && parseInt(nodeMajorVersion, 10) >= 14) {
            this.providers.set(new EdDsaProvider());
            this.providers.set(new EcdhEsProvider());
            this.providers.set(new Ed25519Provider());
            this.providers.set(new X25519Provider());
        }
    }
}

class Crypto extends webcrypto_core__WEBPACK_IMPORTED_MODULE_0__[/* Crypto */ "i"] {
    constructor() {
        super(...arguments);
        this.subtle = new SubtleCrypto();
    }
    getRandomValues(array) {
        if (!ArrayBuffer.isView(array)) {
            throw new TypeError("Failed to execute 'getRandomValues' on 'Crypto': parameter 1 is not of type 'ArrayBufferView'");
        }
        const buffer = buffer__WEBPACK_IMPORTED_MODULE_1__["Buffer"].from(array.buffer, array.byteOffset, array.byteLength);
        crypto__WEBPACK_IMPORTED_MODULE_2___default.a.randomFillSync(buffer);
        return array;
    }
}



/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 266 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 267 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(139).Buffer;
var util = __webpack_require__(269);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 269 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(39), __webpack_require__(40)))

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(39)))

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(4)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(187);

/*<replacement>*/
var util = Object.create(__webpack_require__(91));
util.inherits = __webpack_require__(11);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(140);


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(64);


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(108).Transform


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(108).PassThrough


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(11)
var Hash = __webpack_require__(80)
var Buffer = __webpack_require__(10).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(11)
var Hash = __webpack_require__(80)
var Buffer = __webpack_require__(10).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(11)
var Sha256 = __webpack_require__(188)
var Hash = __webpack_require__(80)
var Buffer = __webpack_require__(10).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11)
var SHA512 = __webpack_require__(189)
var Hash = __webpack_require__(80)
var Buffer = __webpack_require__(10).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(11)
var Buffer = __webpack_require__(10).Buffer

var Base = __webpack_require__(57)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(192);


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var Buffer = __webpack_require__(10).Buffer

var checkParameters = __webpack_require__(194)
var defaultEncoding = __webpack_require__(195)
var sync = __webpack_require__(196)
var toBuffer = __webpack_require__(197)

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  sha: 'SHA-1',
  'sha-1': 'SHA-1',
  sha1: 'SHA-1',
  sha256: 'SHA-256',
  'sha-256': 'SHA-256',
  sha384: 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  sha512: 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}
var nextTick
function getNextTick () {
  if (nextTick) {
    return nextTick
  }
  if (global.process && global.process.nextTick) {
    nextTick = global.process.nextTick
  } else if (global.queueMicrotask) {
    nextTick = global.queueMicrotask
  } else if (global.setImmediate) {
    nextTick = global.setImmediate
  } else {
    nextTick = global.setTimeout
  }
  return nextTick
}
function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, { name: 'PBKDF2' }, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    getNextTick()(function () {
      callback(null, out)
    })
  }, function (e) {
    getNextTick()(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    getNextTick()(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
    return
  }

  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(39)))

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(286)
var aes = __webpack_require__(145)
var aesModes = __webpack_require__(146)
var desModes = __webpack_require__(299)
var ebtk = __webpack_require__(111)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(57)
var des = __webpack_require__(287)
var inherits = __webpack_require__(11)
var Buffer = __webpack_require__(10).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(198);
exports.Cipher = __webpack_require__(144);
exports.DES = __webpack_require__(199);
exports.CBC = __webpack_require__(288);
exports.EDE = __webpack_require__(289);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(34);
var inherits = __webpack_require__(11);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(34);
var inherits = __webpack_require__(11);

var Cipher = __webpack_require__(144);
var DES = __webpack_require__(199);

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(146)
var AuthCipher = __webpack_require__(203)
var Buffer = __webpack_require__(10).Buffer
var StreamCipher = __webpack_require__(204)
var Transform = __webpack_require__(57)
var aes = __webpack_require__(110)
var ebtk = __webpack_require__(111)
var inherits = __webpack_require__(11)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),
/* 291 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(92)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer
var xor = __webpack_require__(92)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(92)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(10).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(203)
var Buffer = __webpack_require__(10).Buffer
var MODES = __webpack_require__(146)
var StreamCipher = __webpack_require__(204)
var Transform = __webpack_require__(57)
var aes = __webpack_require__(110)
var ebtk = __webpack_require__(111)
var inherits = __webpack_require__(11)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),
/* 299 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(205)
var primes = __webpack_require__(305)

var DH = __webpack_require__(306)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 301 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(303).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(65)(module)))

/***/ }),
/* 303 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 304 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 305 */
/***/ (function(module) {

module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff\"}}");

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(206);
var MillerRabin = __webpack_require__(207);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(205);
var randomBytes = __webpack_require__(79);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(10).Buffer;
var createHash = __webpack_require__(90);
var stream = __webpack_require__(108);
var inherits = __webpack_require__(11);
var sign = __webpack_require__(308);
var verify = __webpack_require__(344);

var algorithms = __webpack_require__(192);
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = Buffer.from(algorithms[key].id, 'hex');
  algorithms[key.toLowerCase()] = algorithms[key];
});

function Sign(algorithm) {
  stream.Writable.call(this);

  var data = algorithms[algorithm];
  if (!data) { throw new Error('Unknown message digest'); }

  this._hashType = data.hash;
  this._hash = createHash(data.hash);
  this._tag = data.id;
  this._signType = data.sign;
}
inherits(Sign, stream.Writable);

Sign.prototype._write = function _write(data, _, done) {
  this._hash.update(data);
  done();
};

Sign.prototype.update = function update(data, enc) {
  this._hash.update(typeof data === 'string' ? Buffer.from(data, enc) : data);

  return this;
};

Sign.prototype.sign = function signMethod(key, enc) {
  this.end();
  var hash = this._hash.digest();
  var sig = sign(hash, key, this._hashType, this._signType, this._tag);

  return enc ? sig.toString(enc) : sig;
};

function Verify(algorithm) {
  stream.Writable.call(this);

  var data = algorithms[algorithm];
  if (!data) { throw new Error('Unknown message digest'); }

  this._hash = createHash(data.hash);
  this._tag = data.id;
  this._signType = data.sign;
}
inherits(Verify, stream.Writable);

Verify.prototype._write = function _write(data, _, done) {
  this._hash.update(data);
  done();
};

Verify.prototype.update = function update(data, enc) {
  this._hash.update(typeof data === 'string' ? Buffer.from(data, enc) : data);

  return this;
};

Verify.prototype.verify = function verifyMethod(key, sig, enc) {
  var sigBuffer = typeof sig === 'string' ? Buffer.from(sig, enc) : sig;

  this.end();
  var hash = this._hash.digest();
  return verify(sigBuffer, hash, key, this._signType, this._tag);
};

function createSign(algorithm) {
  return new Sign(algorithm);
}

function createVerify(algorithm) {
  return new Verify(algorithm);
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = __webpack_require__(10).Buffer;
var createHmac = __webpack_require__(190);
var crt = __webpack_require__(148);
var EC = __webpack_require__(150).ec;
var BN = __webpack_require__(149);
var parseKeys = __webpack_require__(113);
var curves = __webpack_require__(217);

var RSA_PKCS1_PADDING = 1;

function sign(hash, key, hashType, signType, tag) {
  var priv = parseKeys(key);
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong private key type'); }
    return ecSign(hash, priv);
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') { throw new Error('wrong private key type'); }
    return dsaSign(hash, priv, hashType);
  }
  if (signType !== 'rsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong private key type'); }
  if (key.padding !== undefined && key.padding !== RSA_PKCS1_PADDING) { throw new Error('illegal or unsupported padding mode'); }

  hash = Buffer.concat([tag, hash]);
  var len = priv.modulus.byteLength();
  var pad = [0, 1];
  while (hash.length + pad.length + 1 < len) { pad.push(0xff); }
  pad.push(0x00);
  var i = -1;
  while (++i < hash.length) { pad.push(hash[i]); }

  var out = crt(pad, priv);
  return out;
}

function ecSign(hash, priv) {
  var curveId = curves[priv.curve.join('.')];
  if (!curveId) { throw new Error('unknown curve ' + priv.curve.join('.')); }

  var curve = new EC(curveId);
  var key = curve.keyFromPrivate(priv.privateKey);
  var out = key.sign(hash);

  return Buffer.from(out.toDER());
}

function dsaSign(hash, priv, algo) {
  var x = priv.params.priv_key;
  var p = priv.params.p;
  var q = priv.params.q;
  var g = priv.params.g;
  var r = new BN(0);
  var k;
  var H = bits2int(hash, q).mod(q);
  var s = false;
  var kv = getKey(x, q, hash, algo);
  while (s === false) {
    k = makeKey(q, kv, algo);
    r = makeR(g, k, p, q);
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
    if (s.cmpn(0) === 0) {
      s = false;
      r = new BN(0);
    }
  }
  return toDER(r, s);
}

function toDER(r, s) {
  r = r.toArray();
  s = s.toArray();

  // Pad values
  if (r[0] & 0x80) { r = [0].concat(r); }
  if (s[0] & 0x80) { s = [0].concat(s); }

  var total = r.length + s.length + 4;
  var res = [
    0x30, total, 0x02, r.length
  ];
  res = res.concat(r, [0x02, s.length], s);
  return Buffer.from(res);
}

function getKey(x, q, hash, algo) {
  x = Buffer.from(x.toArray());
  if (x.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - x.length);
    x = Buffer.concat([zeros, x]);
  }
  var hlen = hash.length;
  var hbits = bits2octets(hash, q);
  var v = Buffer.alloc(hlen);
  v.fill(1);
  var k = Buffer.alloc(hlen);
  k = createHmac(algo, k).update(v).update(Buffer.from([0])).update(x).update(hbits).digest();
  v = createHmac(algo, k).update(v).digest();
  k = createHmac(algo, k).update(v).update(Buffer.from([1])).update(x).update(hbits).digest();
  v = createHmac(algo, k).update(v).digest();
  return { k: k, v: v };
}

function bits2int(obits, q) {
  var bits = new BN(obits);
  var shift = (obits.length << 3) - q.bitLength();
  if (shift > 0) { bits.ishrn(shift); }
  return bits;
}

function bits2octets(bits, q) {
  bits = bits2int(bits, q);
  bits = bits.mod(q);
  var out = Buffer.from(bits.toArray());
  if (out.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - out.length);
    out = Buffer.concat([zeros, out]);
  }
  return out;
}

function makeKey(q, kv, algo) {
  var t;
  var k;

  do {
    t = Buffer.alloc(0);

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest();
      t = Buffer.concat([t, kv.v]);
    }

    k = bits2int(t, q);
    kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([0])).digest();
    kv.v = createHmac(algo, kv.k).update(kv.v).digest();
  } while (k.cmp(q) !== -1);

  return k;
}

function makeR(g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q);
}

module.exports = sign;
module.exports.getKey = getKey;
module.exports.makeKey = makeKey;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 310 */
/***/ (function(module) {

module.exports = JSON.parse("{\"_from\":\"elliptic@^6.5.5\",\"_id\":\"elliptic@6.6.1\",\"_inBundle\":false,\"_integrity\":\"sha512-RaddvvMatK2LJHqFJ+YA4WysVN5Ita9E35botqIYspQ4TkRAlCicdzKOjlyv/1Za5RyTNn7di//eEV0uTAfe3g==\",\"_location\":\"/elliptic\",\"_phantomChildren\":{},\"_requested\":{\"type\":\"range\",\"registry\":true,\"raw\":\"elliptic@^6.5.5\",\"name\":\"elliptic\",\"escapedName\":\"elliptic\",\"rawSpec\":\"^6.5.5\",\"saveSpec\":null,\"fetchSpec\":\"^6.5.5\"},\"_requiredBy\":[\"/browserify-sign\",\"/create-ecdh\"],\"_resolved\":\"https://registry.npmmirror.com/elliptic/-/elliptic-6.6.1.tgz\",\"_shasum\":\"3b8ffb02670bf69e382c7f65bf524c97c5405c06\",\"_spec\":\"elliptic@^6.5.5\",\"_where\":\"D:\\\\Project\\\\jhsdk\\\\node_modules\\\\browserify-sign\",\"author\":{\"name\":\"Fedor Indutny\",\"email\":\"fedor@indutny.com\"},\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"bundleDependencies\":false,\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"},\"deprecated\":false,\"description\":\"EC cryptography\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"files\":[\"lib\"],\"homepage\":\"https://github.com/indutny/elliptic\",\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"license\":\"MIT\",\"main\":\"lib/elliptic.js\",\"name\":\"elliptic\",\"repository\":{\"type\":\"git\",\"url\":\"git+ssh://git@github.com/indutny/elliptic.git\"},\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"test\":\"npm run lint && npm run unit\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"version\":\"grunt dist && git add dist/\"},\"version\":\"6.6.1\"}");

/***/ }),
/* 311 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var BN = __webpack_require__(50);
var inherits = __webpack_require__(11);
var Base = __webpack_require__(112);

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16),
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis,
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 },
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
      var npoints = this._endoWnafT1;
      var ncoeffs = this._endoWnafT2;
      for (var i = 0; i < points.length; i++) {
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();

        if (split.k1.negative) {
          split.k1.ineg();
          p = p.neg(true);
        }
        if (split.k2.negative) {
          split.k2.ineg();
          beta = beta.neg(true);
        }

        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
      }
      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

      // Clean-up references to points and coefficients
      for (var j = 0; j < i * 2; j++) {
        npoints[j] = null;
        ncoeffs[j] = null;
      }
      return res;
    };

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul),
      },
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1),
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1),
    },
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point)),
    },
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate),
      },
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(50);
var inherits = __webpack_require__(11);
var Base = __webpack_require__(112);

var utils = __webpack_require__(35);

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var BN = __webpack_require__(50);
var inherits = __webpack_require__(11);
var Base = __webpack_require__(112);

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  var e;
  var h;
  var j;
  if (this.curve.twisted) {
    // E = a * C
    e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      h = this.z.redSqr();
      // J = F - 2 * H
      j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    e = c.redAdd(d);
    // H = (c * Z1)^2
    h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(316);
exports.sha224 = __webpack_require__(317);
exports.sha256 = __webpack_require__(211);
exports.sha384 = __webpack_require__(318);
exports.sha512 = __webpack_require__(212);


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);
var common = __webpack_require__(93);
var shaCommon = __webpack_require__(210);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);
var SHA256 = __webpack_require__(211);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);

var SHA512 = __webpack_require__(212);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);
var common = __webpack_require__(93);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(43);
var assert = __webpack_require__(34);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
      ],
    ],
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
      ],
    ],
  },
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(50);
var HmacDRBG = __webpack_require__(323);
var utils = __webpack_require__(35);
var curves = __webpack_require__(151);
var rand = __webpack_require__(147);
var assert = utils.assert;

var KeyPair = __webpack_require__(324);
var Signature = __webpack_require__(325);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(Object.prototype.hasOwnProperty.call(curves, options),
      'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray(),
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  for (;;) {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  }
};

EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
  var byteLength;
  if (BN.isBN(msg) || typeof msg === 'number') {
    msg = new BN(msg, 16);
    byteLength = msg.byteLength();
  } else if (typeof msg === 'object') {
    // BN assumes an array-like input and asserts length
    byteLength = msg.length;
    msg = new BN(msg, 16);
  } else {
    // BN converts the value to string
    var str = msg.toString();
    // HEX encoding
    byteLength = (str.length + 1) >>> 1;
    msg = new BN(str, 16);
  }
  // Allow overriding
  if (typeof bitLength !== 'number') {
    bitLength = byteLength * 8;
  }
  var delta = bitLength - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  if (typeof msg !== 'string' && typeof msg !== 'number' && !BN.isBN(msg)) {
    assert(typeof msg === 'object' && msg && typeof msg.length === 'number',
      'Expected message to be an array-like, a hex string, or a BN instance');
    assert((msg.length >>> 0) === msg.length); // non-negative 32-bit integer
    for (var i = 0; i < msg.length; i++) assert((msg[i] & 255) === msg[i]);
  }

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(msg, false, options.msgBitLength);

  // Would fail further checks, but let's make the error message clear
  assert(!msg.isNeg(), 'Can not sign a negative message');

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Recheck nonce to be bijective to msg
  assert((new BN(nonce)).eq(msg), 'Can not sign message');

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; ; iter++) {
    var k = options.k ?
      options.k(iter) :
      new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc, options) {
  if (!options)
    options = {};

  msg = this._truncateToN(msg, false, options.msgBitLength);
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);
  var p;

  if (!this.curve._maxwellTrick) {
    p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(152);
var utils = __webpack_require__(208);
var assert = __webpack_require__(34);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(50);
var utils = __webpack_require__(35);
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc,
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc,
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  if(!pub.validate()) {
    assert(pub.validate(), 'public point not validated');
  }
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature, options) {
  return this.ec.verify(msg, signature, this, undefined, options);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(50);

var utils = __webpack_require__(35);
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  if(buf[p.place] === 0x00) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  if ((data[p.place] & 128) !== 0) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  if ((data[p.place] & 128) !== 0) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(152);
var curves = __webpack_require__(151);
var utils = __webpack_require__(35);
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(327);
var Signature = __webpack_require__(328);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
    .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) {
    return false;
  }
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(35);
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(50);
var utils = __webpack_require__(35);
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength),
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.



var asn1 = __webpack_require__(94);

exports.certificate = __webpack_require__(341);

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('modulus')['int'](),
		this.key('publicExponent')['int'](),
		this.key('privateExponent')['int'](),
		this.key('prime1')['int'](),
		this.key('prime2')['int'](),
		this.key('exponent1')['int'](),
		this.key('exponent2')['int'](),
		this.key('coefficient')['int']()
	);
});
exports.RSAPrivateKey = RSAPrivateKey;

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
	this.seq().obj(
		this.key('modulus')['int'](),
		this.key('publicExponent')['int']()
	);
});
exports.RSAPublicKey = RSAPublicKey;

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
	this.seq().obj(
		this.key('algorithm').objid(),
		this.key('none').null_().optional(),
		this.key('curve').objid().optional(),
		this.key('params').seq().obj(
			this.key('p')['int'](),
			this.key('q')['int'](),
			this.key('g')['int']()
		).optional()
	);
});

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
	this.seq().obj(
		this.key('algorithm').use(AlgorithmIdentifier),
		this.key('subjectPublicKey').bitstr()
	);
});
exports.PublicKey = PublicKey;

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('algorithm').use(AlgorithmIdentifier),
		this.key('subjectPrivateKey').octstr()
	);
});
exports.PrivateKey = PrivateKeyInfo;
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
	this.seq().obj(
		this.key('algorithm').seq().obj(
			this.key('id').objid(),
			this.key('decrypt').seq().obj(
				this.key('kde').seq().obj(
					this.key('id').objid(),
					this.key('kdeparams').seq().obj(
						this.key('salt').octstr(),
						this.key('iters')['int']()
					)
				),
				this.key('cipher').seq().obj(
					this.key('algo').objid(),
					this.key('iv').octstr()
				)
			)
		),
		this.key('subjectPrivateKey').octstr()
	);
});

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo;

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('p')['int'](),
		this.key('q')['int'](),
		this.key('g')['int'](),
		this.key('pub_key')['int'](),
		this.key('priv_key')['int']()
	);
});
exports.DSAPrivateKey = DSAPrivateKey;

exports.DSAparam = asn1.define('DSAparam', function () {
	this['int']();
});

var ECParameters = asn1.define('ECParameters', function () {
	this.choice({
		namedCurve: this.objid()
	});
});

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
	this.seq().obj(
		this.key('version')['int'](),
		this.key('privateKey').octstr(),
		this.key('parameters').optional().explicit(0).use(ECParameters),
		this.key('publicKey').optional().explicit(1).bitstr()
	);
});
exports.ECPrivateKey = ECPrivateKey;

exports.signature = asn1.define('signature', function () {
	this.seq().obj(
		this.key('r')['int'](),
		this.key('s')['int']()
	);
});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(331).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(65)(module)))

/***/ }),
/* 331 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(94);
var inherits = __webpack_require__(11);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(333).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 333 */
/***/ (function(module, exports) {

var indexOf = function (xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for (var i = 0; i < xs.length; i++) {
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.isContext = function (context) {
    return context instanceof Context;
};

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(95).Reporter;
var EncoderBuffer = __webpack_require__(95).EncoderBuffer;
var DecoderBuffer = __webpack_require__(95).DecoderBuffer;
var assert = __webpack_require__(34);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(214);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(215);
decoders.pem = __webpack_require__(338);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);
var Buffer = __webpack_require__(4).Buffer;

var DERDecoder = __webpack_require__(215);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(216);
encoders.pem = __webpack_require__(340);


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(11);

var DEREncoder = __webpack_require__(216);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(94);

var Time = asn.define('Time', function () {
	this.choice({
		utcTime: this.utctime(),
		generalTime: this.gentime()
	});
});

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
	this.seq().obj(
		this.key('type').objid(),
		this.key('value').any()
	);
});

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
	this.seq().obj(
		this.key('algorithm').objid(),
		this.key('parameters').optional(),
		this.key('curve').objid().optional()
	);
});

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
	this.seq().obj(
		this.key('algorithm').use(AlgorithmIdentifier),
		this.key('subjectPublicKey').bitstr()
	);
});

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
	this.setof(AttributeTypeValue);
});

var RDNSequence = asn.define('RDNSequence', function () {
	this.seqof(RelativeDistinguishedName);
});

var Name = asn.define('Name', function () {
	this.choice({
		rdnSequence: this.use(RDNSequence)
	});
});

var Validity = asn.define('Validity', function () {
	this.seq().obj(
		this.key('notBefore').use(Time),
		this.key('notAfter').use(Time)
	);
});

var Extension = asn.define('Extension', function () {
	this.seq().obj(
		this.key('extnID').objid(),
		this.key('critical').bool().def(false),
		this.key('extnValue').octstr()
	);
});

var TBSCertificate = asn.define('TBSCertificate', function () {
	this.seq().obj(
		this.key('version').explicit(0)['int']().optional(),
		this.key('serialNumber')['int'](),
		this.key('signature').use(AlgorithmIdentifier),
		this.key('issuer').use(Name),
		this.key('validity').use(Validity),
		this.key('subject').use(Name),
		this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
		this.key('issuerUniqueID').implicit(1).bitstr().optional(),
		this.key('subjectUniqueID').implicit(2).bitstr().optional(),
		this.key('extensions').explicit(3).seqof(Extension).optional()
	);
});

var X509Certificate = asn.define('X509Certificate', function () {
	this.seq().obj(
		this.key('tbsCertificate').use(TBSCertificate),
		this.key('signatureAlgorithm').use(AlgorithmIdentifier),
		this.key('signatureValue').bitstr()
	);
});

module.exports = X509Certificate;


/***/ }),
/* 342 */
/***/ (function(module) {

module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;
var evp = __webpack_require__(111);
var ciphers = __webpack_require__(145);
var Buffer = __webpack_require__(10).Buffer;
module.exports = function (okey, password) {
	var key = okey.toString();
	var match = key.match(findProc);
	var decrypted;
	if (!match) {
		var match2 = key.match(fullRegex);
		decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
	} else {
		var suite = 'aes' + match[1];
		var iv = Buffer.from(match[2], 'hex');
		var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
		var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
		var out = [];
		var cipher = ciphers.createDecipheriv(suite, cipherKey, iv);
		out.push(cipher.update(cipherText));
		out.push(cipher['final']());
		decrypted = Buffer.concat(out);
	}
	var tag = key.match(startRegex)[1];
	return {
		tag: tag,
		data: decrypted
	};
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = __webpack_require__(10).Buffer;
var BN = __webpack_require__(149);
var EC = __webpack_require__(150).ec;
var parseKeys = __webpack_require__(113);
var curves = __webpack_require__(217);

function verify(sig, hash, key, signType, tag) {
  var pub = parseKeys(key);
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong public key type'); }
    return ecVerify(sig, hash, pub);
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') { throw new Error('wrong public key type'); }
    return dsaVerify(sig, hash, pub);
  }
  if (signType !== 'rsa' && signType !== 'ecdsa/rsa') { throw new Error('wrong public key type'); }

  hash = Buffer.concat([tag, hash]);
  var len = pub.modulus.byteLength();
  var pad = [1];
  var padNum = 0;
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff);
    padNum += 1;
  }
  pad.push(0x00);
  var i = -1;
  while (++i < hash.length) {
    pad.push(hash[i]);
  }
  pad = Buffer.from(pad);
  var red = BN.mont(pub.modulus);
  sig = new BN(sig).toRed(red);

  sig = sig.redPow(new BN(pub.publicExponent));
  sig = Buffer.from(sig.fromRed().toArray());
  var out = padNum < 8 ? 1 : 0;
  len = Math.min(sig.length, pad.length);
  if (sig.length !== pad.length) { out = 1; }

  i = -1;
  while (++i < len) { out |= sig[i] ^ pad[i]; }
  return out === 0;
}

function ecVerify(sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')];
  if (!curveId) { throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.')); }

  var curve = new EC(curveId);
  var pubkey = pub.data.subjectPrivateKey.data;

  return curve.verify(hash, sig, pubkey);
}

function dsaVerify(sig, hash, pub) {
  var p = pub.data.p;
  var q = pub.data.q;
  var g = pub.data.g;
  var y = pub.data.pub_key;
  var unpacked = parseKeys.signature.decode(sig, 'der');
  var s = unpacked.s;
  var r = unpacked.r;
  checkValue(s, q);
  checkValue(r, q);
  var montp = BN.mont(p);
  var w = s.invm(q);
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q);
  return v.cmp(r) === 0;
}

function checkValue(b, q) {
  if (b.cmpn(0) <= 0) { throw new Error('invalid sig'); }
  if (b.cmp(q) >= 0) { throw new Error('invalid sig'); }
}

module.exports = verify;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(150)
var BN = __webpack_require__(346)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4).Buffer))

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(347).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(65)(module)))

/***/ }),
/* 347 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(349)
exports.privateDecrypt = __webpack_require__(351)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(113)
var randomBytes = __webpack_require__(79)
var createHash = __webpack_require__(90)
var mgf = __webpack_require__(218)
var xor = __webpack_require__(219)
var BN = __webpack_require__(153)
var withPublic = __webpack_require__(220)
var crt = __webpack_require__(148)
var Buffer = __webpack_require__(10).Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),
/* 350 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(113)
var mgf = __webpack_require__(218)
var xor = __webpack_require__(219)
var BN = __webpack_require__(153)
var crt = __webpack_require__(148)
var createHash = __webpack_require__(90)
var withPublic = __webpack_require__(220)
var Buffer = __webpack_require__(10).Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(10)
var randombytes = __webpack_require__(79)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(39), __webpack_require__(40)))

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _opus = __webpack_require__(222);
// Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var decoder = new _opus.OpusDecoder(48000, 2);
self.addEventListener('message', function (evt) {
  var message = evt.data;
  switch (message.type) {
    case 'decode':
      {
        var pcmData = decoder.decode_float(message.data);
        self.postMessage({
          type: 'decodeResult',
          data: pcmData.buffer
        }, [pcmData.buffer]);
        break;
      }
      ;
    default:
    // do nothing
  }
});
function _default() {}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;__webpack_require__(21);__webpack_require__(33);__webpack_require__(175);__webpack_require__(14);__webpack_require__(78);__webpack_require__(55);__webpack_require__(136);__webpack_require__(223);__webpack_require__(224);__webpack_require__(225);__webpack_require__(114);__webpack_require__(226);__webpack_require__(227);__webpack_require__(81);__webpack_require__(355);__webpack_require__(356);__webpack_require__(30);__webpack_require__(16);__webpack_require__(13);__webpack_require__(12);__webpack_require__(15);function _typeof(o){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o;}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol&&o!==Symbol.prototype?"symbol":typeof o;},_typeof(o);}var Module;if(!Module)Module=(typeof Module!=="undefined"?Module:null)||{};var moduleOverrides={};for(var key in Module){if(Module.hasOwnProperty(key)){moduleOverrides[key]=Module[key];}}var ENVIRONMENT_IS_NODE=false;var ENVIRONMENT_IS_WEB=(typeof window==="undefined"?"undefined":_typeof(window))==="object";var ENVIRONMENT_IS_WORKER=typeof importScripts==="function";var ENVIRONMENT_IS_SHELL=!ENVIRONMENT_IS_WEB&&!ENVIRONMENT_IS_NODE&&!ENVIRONMENT_IS_WORKER;console.log(ENVIRONMENT_IS_NODE);if(ENVIRONMENT_IS_SHELL){if(!Module["print"])Module["print"]=print;if(typeof printErr!="undefined")Module["printErr"]=printErr;if(typeof read!="undefined"){Module["read"]=read;}else{Module["read"]=function read(){throw"no read() available (jsc?)";};}Module["readBinary"]=function readBinary(f){if(typeof readbuffer==="function"){return new Uint8Array(readbuffer(f));}var data=read(f,"binary");assert(_typeof(data)==="object");return data;};if(typeof scriptArgs!="undefined"){Module["arguments"]=scriptArgs;}else if(typeof arguments!="undefined"){Module["arguments"]=arguments;}(void 0)["Module"]=Module;}else if(ENVIRONMENT_IS_WEB||ENVIRONMENT_IS_WORKER){Module["read"]=function read(url){var xhr=new XMLHttpRequest();xhr.open("GET",url,false);xhr.send(null);return xhr.responseText;};if(typeof arguments!="undefined"){Module["arguments"]=arguments;}if(typeof console!=="undefined"){if(!Module["print"])Module["print"]=function print(x){console.log(x);};if(!Module["printErr"])Module["printErr"]=function printErr(x){console.log(x);};}else{var TRY_USE_DUMP=false;if(!Module["print"])Module["print"]=TRY_USE_DUMP&&typeof dump!=="undefined"?function(x){dump(x);}:function(x){};}if(ENVIRONMENT_IS_WEB){window["Module"]=Module;}else{Module["load"]=importScripts;}}else{throw"Unknown runtime environment. Where are we?";}function globalEval(x){eval.call(null,x);}if(!Module["load"]&&Module["read"]){Module["load"]=function load(f){globalEval(Module["read"](f));};}if(!Module["print"]){Module["print"]=function(){};}if(!Module["printErr"]){Module["printErr"]=Module["print"];}if(!Module["arguments"]){Module["arguments"]=[];}if(!Module["thisProgram"]){Module["thisProgram"]="./this.program";}Module.print=Module["print"];Module.printErr=Module["printErr"];Module["preRun"]=[];Module["postRun"]=[];for(var key in moduleOverrides){if(moduleOverrides.hasOwnProperty(key)){Module[key]=moduleOverrides[key];}}var Runtime={setTempRet0:function setTempRet0(value){tempRet0=value;},getTempRet0:function getTempRet0(){return tempRet0;},stackSave:function stackSave(){return STACKTOP;},stackRestore:function stackRestore(stackTop){STACKTOP=stackTop;},getNativeTypeSize:function getNativeTypeSize(type){switch(type){case"i1":case"i8":return 1;case"i16":return 2;case"i32":return 4;case"i64":return 8;case"float":return 4;case"double":return 8;default:{if(type[type.length-1]==="*"){return Runtime.QUANTUM_SIZE;}else if(type[0]==="i"){var bits=parseInt(type.substr(1));assert(bits%8===0);return bits/8;}else{return 0;}}}},getNativeFieldSize:function getNativeFieldSize(type){return Math.max(Runtime.getNativeTypeSize(type),Runtime.QUANTUM_SIZE);},STACK_ALIGN:16,getAlignSize:function getAlignSize(type,size,vararg){if(!vararg&&(type=="i64"||type=="double"))return 8;if(!type)return Math.min(size,8);return Math.min(size||(type?Runtime.getNativeFieldSize(type):0),Runtime.QUANTUM_SIZE);},dynCall:function dynCall(sig,ptr,args){if(args&&args.length){if(!args.splice)args=Array.prototype.slice.call(args);args.splice(0,0,ptr);return Module["dynCall_"+sig].apply(null,args);}else{return Module["dynCall_"+sig].call(null,ptr);}},functionPointers:[],addFunction:function addFunction(func){for(var i=0;i<Runtime.functionPointers.length;i++){if(!Runtime.functionPointers[i]){Runtime.functionPointers[i]=func;return 2*(1+i);}}throw"Finished up all reserved function pointers. Use a higher value for RESERVED_FUNCTION_POINTERS.";},removeFunction:function removeFunction(index){Runtime.functionPointers[(index-2)/2]=null;},getAsmConst:function getAsmConst(code,numArgs){if(!Runtime.asmConstCache)Runtime.asmConstCache={};var func=Runtime.asmConstCache[code];if(func)return func;var args=[];for(var i=0;i<numArgs;i++){args.push(String.fromCharCode(36)+i);}var source=Pointer_stringify(code);if(source[0]==='"'){if(source.indexOf('"',1)===source.length-1){source=source.substr(1,source.length-2);}else{abort("invalid EM_ASM input |"+source+"|. Please use EM_ASM(..code..) (no quotes) or EM_ASM({ ..code($0).. }, input) (to input values)");}}try{var evalled=eval("(function(Module, FS) { return function("+args.join(",")+"){ "+source+" } })")(Module,typeof FS!=="undefined"?FS:null);}catch(e){Module.printErr("error in executing inline EM_ASM code: "+e+" on: \n\n"+source+"\n\nwith args |"+args+"| (make sure to use the right one out of EM_ASM, EM_ASM_ARGS, etc.)");throw e;}return Runtime.asmConstCache[code]=evalled;},warnOnce:function warnOnce(text){if(!Runtime.warnOnce.shown)Runtime.warnOnce.shown={};if(!Runtime.warnOnce.shown[text]){Runtime.warnOnce.shown[text]=1;Module.printErr(text);}},funcWrappers:{},getFuncWrapper:function getFuncWrapper(func,sig){assert(sig);if(!Runtime.funcWrappers[sig]){Runtime.funcWrappers[sig]={};}var sigCache=Runtime.funcWrappers[sig];if(!sigCache[func]){sigCache[func]=function dynCall_wrapper(){return Runtime.dynCall(sig,func,arguments);};}return sigCache[func];},UTF8Processor:function UTF8Processor(){var buffer=[];var needed=0;this.processCChar=function(code){code=code&255;if(buffer.length==0){if((code&128)==0){return String.fromCharCode(code);}buffer.push(code);if((code&224)==192){needed=1;}else if((code&240)==224){needed=2;}else{needed=3;}return"";}if(needed){buffer.push(code);needed--;if(needed>0)return"";}var c1=buffer[0];var c2=buffer[1];var c3=buffer[2];var c4=buffer[3];var ret;if(buffer.length==2){ret=String.fromCharCode((c1&31)<<6|c2&63);}else if(buffer.length==3){ret=String.fromCharCode((c1&15)<<12|(c2&63)<<6|c3&63);}else{var codePoint=(c1&7)<<18|(c2&63)<<12|(c3&63)<<6|c4&63;ret=String.fromCharCode(((codePoint-65536)/1024|0)+55296,(codePoint-65536)%1024+56320);}buffer.length=0;return ret;};this.processJSString=function processJSString(string){string=unescape(encodeURIComponent(string));var ret=[];for(var i=0;i<string.length;i++){ret.push(string.charCodeAt(i));}return ret;};},getCompilerSetting:function getCompilerSetting(name){throw"You must build with -s RETAIN_COMPILER_SETTINGS=1 for Runtime.getCompilerSetting or emscripten_get_compiler_setting to work";},stackAlloc:function stackAlloc(size){var ret=STACKTOP;STACKTOP=STACKTOP+size|0;STACKTOP=STACKTOP+15&-16;return ret;},staticAlloc:function staticAlloc(size){var ret=STATICTOP;STATICTOP=STATICTOP+size|0;STATICTOP=STATICTOP+15&-16;return ret;},dynamicAlloc:function dynamicAlloc(size){var ret=DYNAMICTOP;DYNAMICTOP=DYNAMICTOP+size|0;DYNAMICTOP=DYNAMICTOP+15&-16;if(DYNAMICTOP>=TOTAL_MEMORY)enlargeMemory();return ret;},alignMemory:function alignMemory(size,quantum){var ret=size=Math.ceil(size/(quantum?quantum:16))*(quantum?quantum:16);return ret;},makeBigInt:function makeBigInt(low,high,unsigned){var ret=unsigned?+(low>>>0)+ +(high>>>0)*+4294967296:+(low>>>0)+ +(high|0)*+4294967296;return ret;},GLOBAL_BASE:8,QUANTUM_SIZE:4,__dummy__:0};Module["Runtime"]=Runtime;var __THREW__=0;var ABORT=false;var EXITSTATUS=0;var undef=0;var tempValue,tempInt,tempBigInt,tempInt2,tempBigInt2,tempPair,tempBigIntI,tempBigIntR,tempBigIntS,tempBigIntP,tempBigIntD,tempDouble,tempFloat;var tempI64,tempI64b;var tempRet0,tempRet1,tempRet2,tempRet3,tempRet4,tempRet5,tempRet6,tempRet7,tempRet8,tempRet9;function assert(condition,text){if(!condition){abort("Assertion failed: "+text);}}var globalScope=void 0;function getCFunc(ident){var func=Module["_"+ident];if(!func){try{func=eval("_"+ident);}catch(e){}}assert(func,"Cannot call unknown function "+ident+" (perhaps LLVM optimizations or closure removed it?)");return func;}var cwrap,ccall;(function(){var stack=0;var JSfuncs={"stackSave":function stackSave(){stack=Runtime.stackSave();},"stackRestore":function stackRestore(){Runtime.stackRestore(stack);},"arrayToC":function arrayToC(arr){var ret=Runtime.stackAlloc(arr.length);writeArrayToMemory(arr,ret);return ret;},"stringToC":function stringToC(str){var ret=0;if(str!==null&&str!==undefined&&str!==0){ret=Runtime.stackAlloc((str.length<<2)+1);writeStringToMemory(str,ret);}return ret;}};var toC={"string":JSfuncs["stringToC"],"array":JSfuncs["arrayToC"]};ccall=function ccallFunc(ident,returnType,argTypes,args){var func=getCFunc(ident);var cArgs=[];if(args){for(var i=0;i<args.length;i++){var converter=toC[argTypes[i]];if(converter){if(stack===0)stack=Runtime.stackSave();cArgs[i]=converter(args[i]);}else{cArgs[i]=args[i];}}}var ret=func.apply(null,cArgs);if(returnType==="string")ret=Pointer_stringify(ret);if(stack!==0)JSfuncs["stackRestore"]();return ret;};var sourceRegex=/^function\s*\(([^)]*)\)\s*{\s*([^*]*?)[\s;]*(?:return\s*(.*?)[;\s]*)?}$/;function parseJSFunc(jsfunc){var _jsfunc$toString$matc;var parsed=(_jsfunc$toString$matc=jsfunc.toString().match(sourceRegex))===null||_jsfunc$toString$matc===void 0?void 0:_jsfunc$toString$matc.slice(1);return{arguments:parsed===null||parsed===void 0?void 0:parsed[0],body:parsed===null||parsed===void 0?void 0:parsed[1],returnValue:parsed===null||parsed===void 0?void 0:parsed[2]};}var JSsource={};for(var fun in JSfuncs){if(JSfuncs.hasOwnProperty(fun)){JSsource[fun]=parseJSFunc(JSfuncs[fun]);}}cwrap=function cwrap(ident,returnType,argTypes){argTypes=argTypes||[];var cfunc=getCFunc(ident);var numericArgs=argTypes.every(function(type){return type==="number";});var numericRet=returnType!=="string";if(numericRet&&numericArgs){return cfunc;}var argNames=argTypes.map(function(x,i){return"$"+i;});var funcstr="(function("+argNames.join(",")+") {";var nargs=argTypes.length;if(!numericArgs){funcstr+=JSsource["stackSave"].body+";";for(var i=0;i<nargs;i++){var arg=argNames[i],type=argTypes[i];if(type==="number")continue;var convertCode=JSsource[type+"ToC"];funcstr+="var "+convertCode.arguments+" = "+arg+";";funcstr+=convertCode.body+";";funcstr+=arg+"="+convertCode.returnValue+";";}}var cfuncname=parseJSFunc(function(){return cfunc;}).returnValue;funcstr+="var ret = "+cfuncname+"("+argNames.join(",")+");";if(!numericRet){var strgfy=parseJSFunc(function(){return Pointer_stringify;}).returnValue;funcstr+="ret = "+strgfy+"(ret);";}if(!numericArgs){funcstr+=JSsource["stackRestore"].body+";";}funcstr+="return ret})";return eval(funcstr);};})();Module["cwrap"]=cwrap;Module["ccall"]=ccall;function setValue(ptr,value,type,noSafe){type=type||"i8";if(type.charAt(type.length-1)==="*")type="i32";switch(type){case"i1":HEAP8[ptr>>0]=value;break;case"i8":HEAP8[ptr>>0]=value;break;case"i16":HEAP16[ptr>>1]=value;break;case"i32":HEAP32[ptr>>2]=value;break;case"i64":tempI64=[value>>>0,(tempDouble=value,+Math_abs(tempDouble)>=+1?tempDouble>+0?(Math_min(+Math_floor(tempDouble/+4294967296),+4294967295)|0)>>>0:~~+Math_ceil((tempDouble-+(~~tempDouble>>>0))/+4294967296)>>>0:0)],HEAP32[ptr>>2]=tempI64[0],HEAP32[ptr+4>>2]=tempI64[1];break;case"float":HEAPF32[ptr>>2]=value;break;case"double":HEAPF64[ptr>>3]=value;break;default:abort("invalid type for setValue: "+type);}}Module["setValue"]=setValue;function getValue(ptr,type,noSafe){type=type||"i8";if(type.charAt(type.length-1)==="*")type="i32";switch(type){case"i1":return HEAP8[ptr>>0];case"i8":return HEAP8[ptr>>0];case"i16":return HEAP16[ptr>>1];case"i32":return HEAP32[ptr>>2];case"i64":return HEAP32[ptr>>2];case"float":return HEAPF32[ptr>>2];case"double":return HEAPF64[ptr>>3];default:abort("invalid type for setValue: "+type);}return null;}Module["getValue"]=getValue;var ALLOC_NORMAL=0;var ALLOC_STACK=1;var ALLOC_STATIC=2;var ALLOC_DYNAMIC=3;var ALLOC_NONE=4;Module["ALLOC_NORMAL"]=ALLOC_NORMAL;Module["ALLOC_STACK"]=ALLOC_STACK;Module["ALLOC_STATIC"]=ALLOC_STATIC;Module["ALLOC_DYNAMIC"]=ALLOC_DYNAMIC;Module["ALLOC_NONE"]=ALLOC_NONE;function allocate(slab,types,allocator,ptr){var zeroinit,size;if(typeof slab==="number"){zeroinit=true;size=slab;}else{zeroinit=false;size=slab.length;}var singleType=typeof types==="string"?types:null;var ret;if(allocator==ALLOC_NONE){ret=ptr;}else{ret=[_malloc,Runtime.stackAlloc,Runtime.staticAlloc,Runtime.dynamicAlloc][allocator===undefined?ALLOC_STATIC:allocator](Math.max(size,singleType?1:types.length));}if(zeroinit){var ptr=ret,stop;assert((ret&3)==0);stop=ret+(size&~3);for(;ptr<stop;ptr+=4){HEAP32[ptr>>2]=0;}stop=ret+size;while(ptr<stop){HEAP8[ptr++>>0]=0;}return ret;}if(singleType==="i8"){if(slab.subarray||slab.slice){HEAPU8.set(slab,ret);}else{HEAPU8.set(new Uint8Array(slab),ret);}return ret;}var i=0,type,typeSize,previousType;while(i<size){var curr=slab[i];if(typeof curr==="function"){curr=Runtime.getFunctionIndex(curr);}type=singleType||types[i];if(type===0){i++;continue;}if(type=="i64")type="i32";setValue(ret+i,curr,type);if(previousType!==type){typeSize=Runtime.getNativeTypeSize(type);previousType=type;}i+=typeSize;}return ret;}Module["allocate"]=allocate;function Pointer_stringify(ptr,length){if(length===0)return"";var hasUtf=false;var t;var i=0;while(1){t=HEAPU8[ptr+i>>0];if(t>=128)hasUtf=true;else if(t==0&&!length)break;i++;if(length&&i==length)break;}if(!length)length=i;var ret="";if(!hasUtf){var MAX_CHUNK=1024;var curr;while(length>0){curr=String.fromCharCode.apply(String,HEAPU8.subarray(ptr,ptr+Math.min(length,MAX_CHUNK)));ret=ret?ret+curr:curr;ptr+=MAX_CHUNK;length-=MAX_CHUNK;}return ret;}var utf8=new Runtime.UTF8Processor();for(i=0;i<length;i++){t=HEAPU8[ptr+i>>0];ret+=utf8.processCChar(t);}return ret;}Module["Pointer_stringify"]=Pointer_stringify;function UTF16ToString(ptr){var i=0;var str="";while(1){var codeUnit=HEAP16[ptr+i*2>>1];if(codeUnit==0)return str;++i;str+=String.fromCharCode(codeUnit);}}Module["UTF16ToString"]=UTF16ToString;function stringToUTF16(str,outPtr){for(var i=0;i<str.length;++i){var codeUnit=str.charCodeAt(i);HEAP16[outPtr+i*2>>1]=codeUnit;}HEAP16[outPtr+str.length*2>>1]=0;}Module["stringToUTF16"]=stringToUTF16;function UTF32ToString(ptr){var i=0;var str="";while(1){var utf32=HEAP32[ptr+i*4>>2];if(utf32==0)return str;++i;if(utf32>=65536){var ch=utf32-65536;str+=String.fromCharCode(55296|ch>>10,56320|ch&1023);}else{str+=String.fromCharCode(utf32);}}}Module["UTF32ToString"]=UTF32ToString;function stringToUTF32(str,outPtr){var iChar=0;for(var iCodeUnit=0;iCodeUnit<str.length;++iCodeUnit){var codeUnit=str.charCodeAt(iCodeUnit);if(codeUnit>=55296&&codeUnit<=57343){var trailSurrogate=str.charCodeAt(++iCodeUnit);codeUnit=65536+((codeUnit&1023)<<10)|trailSurrogate&1023;}HEAP32[outPtr+iChar*4>>2]=codeUnit;++iChar;}HEAP32[outPtr+iChar*4>>2]=0;}Module["stringToUTF32"]=stringToUTF32;function demangle(func){var hasLibcxxabi=!!Module["___cxa_demangle"];if(hasLibcxxabi){try{var buf=_malloc(func.length);writeStringToMemory(func.substr(1),buf);var status=_malloc(4);var ret=Module["___cxa_demangle"](buf,0,0,status);if(getValue(status,"i32")===0&&ret){return Pointer_stringify(ret);}}catch(e){}finally{if(buf)_free(buf);if(status)_free(status);if(ret)_free(ret);}}var i=3;var basicTypes={"v":"void","b":"bool","c":"char","s":"short","i":"int","l":"long","f":"float","d":"double","w":"wchar_t","a":"signed char","h":"unsigned char","t":"unsigned short","j":"unsigned int","m":"unsigned long","x":"long long","y":"unsigned long long","z":"..."};var subs=[];var first=true;function dump(x){if(x)Module.print(x);Module.print(func);var pre="";for(var a=0;a<i;a++)pre+=" ";Module.print(pre+"^");}function parseNested(){i++;if(func[i]==="K")i++;var parts=[];while(func[i]!=="E"){if(func[i]==="S"){i++;var next=func.indexOf("_",i);var num=func.substring(i,next)||0;parts.push(subs[num]||"?");i=next+1;continue;}if(func[i]==="C"){parts.push(parts[parts.length-1]);i+=2;continue;}var size=parseInt(func.substr(i));var pre=size.toString().length;if(!size||!pre){i--;break;}var curr=func.substr(i+pre,size);parts.push(curr);subs.push(curr);i+=pre+size;}i++;return parts;}function parse(rawList,limit,allowVoid){limit=limit||Infinity;var ret="",list=[];function flushList(){return"("+list.join(", ")+")";}var name;if(func[i]==="N"){name=parseNested().join("::");limit--;if(limit===0)return rawList?[name]:name;}else{if(func[i]==="K"||first&&func[i]==="L")i++;var size=parseInt(func.substr(i));if(size){var pre=size.toString().length;name=func.substr(i+pre,size);i+=pre+size;}}first=false;if(func[i]==="I"){i++;var iList=parse(true);var iRet=parse(true,1,true);ret+=iRet[0]+" "+name+"<"+iList.join(", ")+">";}else{ret=name;}paramLoop:while(i<func.length&&limit-->0){var c=func[i++];if(c in basicTypes){list.push(basicTypes[c]);}else{switch(c){case"P":list.push(parse(true,1,true)[0]+"*");break;case"R":list.push(parse(true,1,true)[0]+"&");break;case"L":{i++;var end=func.indexOf("E",i);var size=end-i;list.push(func.substr(i,size));i+=size+2;break;};case"A":{var size=parseInt(func.substr(i));i+=size.toString().length;if(func[i]!=="_")throw"?";i++;list.push(parse(true,1,true)[0]+" ["+size+"]");break;};case"E":break paramLoop;default:ret+="?"+c;break paramLoop;}}}if(!allowVoid&&list.length===1&&list[0]==="void")list=[];if(rawList){if(ret){list.push(ret+"?");}return list;}else{return ret+flushList();}}var final=func;try{if(func=="Object._main"||func=="_main"){return"main()";}if(typeof func==="number")func=Pointer_stringify(func);if(func[0]!=="_")return func;if(func[1]!=="_")return func;if(func[2]!=="Z")return func;switch(func[3]){case"n":return"operator new()";case"d":return"operator delete()";}final=parse();}catch(e){final+="?";}if(final.indexOf("?")>=0&&!hasLibcxxabi){Runtime.warnOnce("warning: a problem occurred in builtin C++ name demangling; build with  -s DEMANGLE_SUPPORT=1  to link in libcxxabi demangling");}return final;}function demangleAll(text){return text.replace(/__Z[\w\d_]+/g,function(x){var y=demangle(x);return x===y?x:x+" ["+y+"]";});}function jsStackTrace(){var err=new Error();if(!err.stack){try{throw new Error(0);}catch(e){err=e;}if(!err.stack){return"(no stack trace available)";}}return err.stack.toString();}function stackTrace(){return demangleAll(jsStackTrace());}Module["stackTrace"]=stackTrace;var PAGE_SIZE=4096;function alignMemoryPage(x){return x+4095&-4096;}var HEAP;var HEAP8,HEAPU8,HEAP16,HEAPU16,HEAP32,HEAPU32,HEAPF32,HEAPF64;var STATIC_BASE=0,STATICTOP=0,staticSealed=false;var STACK_BASE=0,STACKTOP=0,STACK_MAX=0;var DYNAMIC_BASE=0,DYNAMICTOP=0;function enlargeMemory(){abort("Cannot enlarge memory arrays. Either (1) compile with -s TOTAL_MEMORY=X with X higher than the current value "+TOTAL_MEMORY+", (2) compile with ALLOW_MEMORY_GROWTH which adjusts the size at runtime but prevents some optimizations, or (3) set Module.TOTAL_MEMORY before the program runs.");}var TOTAL_STACK=Module["TOTAL_STACK"]||5242880;var TOTAL_MEMORY=Module["TOTAL_MEMORY"]||16777216;var FAST_MEMORY=Module["FAST_MEMORY"]||2097152;var totalMemory=64*1024;while(totalMemory<TOTAL_MEMORY||totalMemory<2*TOTAL_STACK){if(totalMemory<16*1024*1024){totalMemory*=2;}else{totalMemory+=16*1024*1024;}}if(totalMemory!==TOTAL_MEMORY){Module.printErr("increasing TOTAL_MEMORY to "+totalMemory+" to be compliant with the asm.js spec");TOTAL_MEMORY=totalMemory;}assert(typeof Int32Array!=="undefined"&&typeof Float64Array!=="undefined"&&!!new Int32Array(1)["subarray"]&&!!new Int32Array(1)["set"],"JS engine does not provide full typed array support");var buffer=new ArrayBuffer(TOTAL_MEMORY);HEAP8=new Int8Array(buffer);HEAP16=new Int16Array(buffer);HEAP32=new Int32Array(buffer);HEAPU8=new Uint8Array(buffer);HEAPU16=new Uint16Array(buffer);HEAPU32=new Uint32Array(buffer);HEAPF32=new Float32Array(buffer);HEAPF64=new Float64Array(buffer);HEAP32[0]=255;assert(HEAPU8[0]===255&&HEAPU8[3]===0,"Typed arrays 2 must be run on a little-endian system");Module["HEAP"]=HEAP;Module["buffer"]=buffer;Module["HEAP8"]=HEAP8;Module["HEAP16"]=HEAP16;Module["HEAP32"]=HEAP32;Module["HEAPU8"]=HEAPU8;Module["HEAPU16"]=HEAPU16;Module["HEAPU32"]=HEAPU32;Module["HEAPF32"]=HEAPF32;Module["HEAPF64"]=HEAPF64;function callRuntimeCallbacks(callbacks){while(callbacks.length>0){var callback=callbacks.shift();if(typeof callback=="function"){callback();continue;}var func=callback.func;if(typeof func==="number"){if(callback.arg===undefined){Runtime.dynCall("v",func);}else{Runtime.dynCall("vi",func,[callback.arg]);}}else{func(callback.arg===undefined?null:callback.arg);}}}var __ATPRERUN__=[];var __ATINIT__=[];var __ATMAIN__=[];var __ATEXIT__=[];var __ATPOSTRUN__=[];var runtimeInitialized=false;var runtimeExited=false;function preRun(){if(Module["preRun"]){if(typeof Module["preRun"]=="function")Module["preRun"]=[Module["preRun"]];while(Module["preRun"].length){addOnPreRun(Module["preRun"].shift());}}callRuntimeCallbacks(__ATPRERUN__);}function ensureInitRuntime(){if(runtimeInitialized)return;runtimeInitialized=true;callRuntimeCallbacks(__ATINIT__);}function preMain(){callRuntimeCallbacks(__ATMAIN__);}function exitRuntime(){callRuntimeCallbacks(__ATEXIT__);runtimeExited=true;}function postRun(){if(Module["postRun"]){if(typeof Module["postRun"]=="function")Module["postRun"]=[Module["postRun"]];while(Module["postRun"].length){addOnPostRun(Module["postRun"].shift());}}callRuntimeCallbacks(__ATPOSTRUN__);}function addOnPreRun(cb){__ATPRERUN__.unshift(cb);}Module["addOnPreRun"]=Module.addOnPreRun=addOnPreRun;function addOnInit(cb){__ATINIT__.unshift(cb);}Module["addOnInit"]=Module.addOnInit=addOnInit;function addOnPreMain(cb){__ATMAIN__.unshift(cb);}Module["addOnPreMain"]=Module.addOnPreMain=addOnPreMain;function addOnExit(cb){__ATEXIT__.unshift(cb);}Module["addOnExit"]=Module.addOnExit=addOnExit;function addOnPostRun(cb){__ATPOSTRUN__.unshift(cb);}Module["addOnPostRun"]=Module.addOnPostRun=addOnPostRun;function intArrayFromString(stringy,dontAddNull,length){var ret=new Runtime.UTF8Processor().processJSString(stringy);if(length){ret.length=length;}if(!dontAddNull){ret.push(0);}return ret;}Module["intArrayFromString"]=intArrayFromString;function intArrayToString(array){var ret=[];for(var i=0;i<array.length;i++){var chr=array[i];if(chr>255){chr&=255;}ret.push(String.fromCharCode(chr));}return ret.join("");}Module["intArrayToString"]=intArrayToString;function writeStringToMemory(string,buffer,dontAddNull){var array=intArrayFromString(string,dontAddNull);var i=0;while(i<array.length){var chr=array[i];HEAP8[buffer+i>>0]=chr;i=i+1;}}Module["writeStringToMemory"]=writeStringToMemory;function writeArrayToMemory(array,buffer){for(var i=0;i<array.length;i++){HEAP8[buffer+i>>0]=array[i];}}Module["writeArrayToMemory"]=writeArrayToMemory;function writeAsciiToMemory(str,buffer,dontAddNull){for(var i=0;i<str.length;i++){HEAP8[buffer+i>>0]=str.charCodeAt(i);}if(!dontAddNull)HEAP8[buffer+str.length>>0]=0;}Module["writeAsciiToMemory"]=writeAsciiToMemory;function unSign(value,bits,ignore){if(value>=0){return value;}return bits<=32?2*Math.abs(1<<bits-1)+value:Math.pow(2,bits)+value;}function reSign(value,bits,ignore){if(value<=0){return value;}var half=bits<=32?Math.abs(1<<bits-1):Math.pow(2,bits-1);if(value>=half&&(bits<=32||value>half)){value=-2*half+value;}return value;}if(!Math["imul"]||Math["imul"](4294967295,5)!==-5)Math["imul"]=function imul(a,b){var ah=a>>>16;var al=a&65535;var bh=b>>>16;var bl=b&65535;return al*bl+(ah*bl+al*bh<<16)|0;};Math.imul=Math["imul"];var Math_abs=Math.abs;var Math_cos=Math.cos;var Math_sin=Math.sin;var Math_tan=Math.tan;var Math_acos=Math.acos;var Math_asin=Math.asin;var Math_atan=Math.atan;var Math_atan2=Math.atan2;var Math_exp=Math.exp;var Math_log=Math.log;var Math_sqrt=Math.sqrt;var Math_ceil=Math.ceil;var Math_floor=Math.floor;var Math_pow=Math.pow;var Math_imul=Math.imul;var Math_fround=Math.fround;var Math_min=Math.min;var runDependencies=0;var runDependencyWatcher=null;var dependenciesFulfilled=null;function addRunDependency(id){runDependencies++;if(Module["monitorRunDependencies"]){Module["monitorRunDependencies"](runDependencies);}}Module["addRunDependency"]=addRunDependency;function removeRunDependency(id){runDependencies--;if(Module["monitorRunDependencies"]){Module["monitorRunDependencies"](runDependencies);}if(runDependencies==0){if(runDependencyWatcher!==null){clearInterval(runDependencyWatcher);runDependencyWatcher=null;}if(dependenciesFulfilled){var callback=dependenciesFulfilled;dependenciesFulfilled=null;callback();}}}Module["removeRunDependency"]=removeRunDependency;Module["preloadedImages"]={};Module["preloadedAudios"]={};var memoryInitializer=null;STATIC_BASE=8;STATICTOP=STATIC_BASE+31120;__ATINIT__.push();allocate([0,64,202,69,27,76,255,82,130,90,179,98,162,107,96,117,0,1,1,1,2,3,3,3,2,3,3,3,2,3,3,3,0,3,12,15,48,51,60,63,192,195,204,207,240,243,252,255,1,0,0,0,0,0,0,0,3,0,0,0,0,0,0,0,2,0,0,0,1,0,0,0,7,0,0,0,0,0,0,0,4,0,0,0,3,0,0,0,6,0,0,0,1,0,0,0,5,0,0,0,2,0,0,0,15,0,0,0,0,0,0,0,8,0,0,0,7,0,0,0,12,0,0,0,3,0,0,0,11,0,0,0,4,0,0,0,14,0,0,0,1,0,0,0,9,0,0,0,6,0,0,0,13,0,0,0,2,0,0,0,10,0,0,0,5,0,0,0,0,0,157,62,0,64,94,62,0,192,4,62,0,128,237,62,0,64,137,62,0,0,0,0,0,192,76,63,0,0,205,61,0,0,0,0,0,0,0,0,0,255,0,255,0,255,0,255,0,255,0,254,1,0,1,255,0,254,0,253,2,0,1,255,0,254,0,253,3,0,1,255,108,105,98,111,112,117,115,32,49,46,49,46,49,45,98,101,116,97,0,0,0,0,0,0,2,1,0,0,0,0,0,0,25,23,2,0,0,0,0,0,126,124,119,109,87,41,19,9,4,2,0,0,0,0,0,0,2,1,0,0,0,0,0,0,25,23,2,0,0,0,0,0,0,0,128,63,0,0,0,64,0,0,64,64,0,0,128,64,0,0,160,64,0,0,192,64,0,0,224,64,0,0,0,65,0,0,128,65,0,0,192,65,0,0,16,66,0,0,48,66,0,0,72,66,0,0,96,66,0,0,120,66,0,0,134,66,0,0,144,66,0,0,158,66,0,0,176,66,0,0,212,66,0,0,6,67,0,0,0,0,0,0,128,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,0,64,0,0,0,64,0,0,0,64,0,0,0,64,0,0,0,64,0,0,0,64,0,0,0,64,0,0,64,64,0,0,64,64,0,0,128,64,0,0,160,64,0,0,192,64,0,0,0,65,0,0,0,65,0,0,0,0,126,124,119,109,87,41,19,9,4,2,0,0,0,0,0,0,255,255,156,110,86,70,59,51,45,40,37,33,31,28,26,25,23,22,21,20,19,18,17,16,16,15,15,14,13,13,12,12,12,12,11,11,11,10,10,10,9,9,9,9,9,9,8,8,8,8,8,7,7,7,7,7,7,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,2,192,2,0,0,128,5,0,0,60,8,0,0,244,10,0,0,168,13,0,0,88,16,0,0,4,19,0,0,108,20,0,0,40,21,0,0,156,21,0,0,232,21,0,0,32,22,0,0,64,22,0,0,88,22,0,0,100,22,0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,1,0,0,0,3,0,0,0,5,0,0,0,7,0,0,0,9,0,0,0,11,0,0,0,13,0,0,0,15,0,0,0,17,0,0,0,19,0,0,0,21,0,0,0,23,0,0,0,25,0,0,0,27,0,0,0,29,0,0,0,31,0,0,0,33,0,0,0,35,0,0,0,37,0,0,0,39,0,0,0,41,0,0,0,43,0,0,0,45,0,0,0,47,0,0,0,49,0,0,0,51,0,0,0,53,0,0,0,55,0,0,0,57,0,0,0,59,0,0,0,61,0,0,0,63,0,0,0,65,0,0,0,67,0,0,0,69,0,0,0,71,0,0,0,73,0,0,0,75,0,0,0,77,0,0,0,79,0,0,0,81,0,0,0,83,0,0,0,85,0,0,0,87,0,0,0,89,0,0,0,91,0,0,0,93,0,0,0,95,0,0,0,97,0,0,0,99,0,0,0,101,0,0,0,103,0,0,0,105,0,0,0,107,0,0,0,109,0,0,0,111,0,0,0,113,0,0,0,115,0,0,0,117,0,0,0,119,0,0,0,121,0,0,0,123,0,0,0,125,0,0,0,127,0,0,0,129,0,0,0,131,0,0,0,133,0,0,0,135,0,0,0,137,0,0,0,139,0,0,0,141,0,0,0,143,0,0,0,145,0,0,0,147,0,0,0,149,0,0,0,151,0,0,0,153,0,0,0,155,0,0,0,157,0,0,0,159,0,0,0,161,0,0,0,163,0,0,0,165,0,0,0,167,0,0,0,169,0,0,0,171,0,0,0,173,0,0,0,175,0,0,0,177,0,0,0,179,0,0,0,181,0,0,0,183,0,0,0,185,0,0,0,187,0,0,0,189,0,0,0,191,0,0,0,193,0,0,0,195,0,0,0,197,0,0,0,199,0,0,0,201,0,0,0,203,0,0,0,205,0,0,0,207,0,0,0,209,0,0,0,211,0,0,0,213,0,0,0,215,0,0,0,217,0,0,0,219,0,0,0,221,0,0,0,223,0,0,0,225,0,0,0,227,0,0,0,229,0,0,0,231,0,0,0,233,0,0,0,235,0,0,0,237,0,0,0,239,0,0,0,241,0,0,0,243,0,0,0,245,0,0,0,247,0,0,0,249,0,0,0,251,0,0,0,253,0,0,0,255,0,0,0,1,1,0,0,3,1,0,0,5,1,0,0,7,1,0,0,9,1,0,0,11,1,0,0,13,1,0,0,15,1,0,0,17,1,0,0,19,1,0,0,21,1,0,0,23,1,0,0,25,1,0,0,27,1,0,0,29,1,0,0,31,1,0,0,33,1,0,0,35,1,0,0,37,1,0,0,39,1,0,0,41,1,0,0,43,1,0,0,45,1,0,0,47,1,0,0,49,1,0,0,51,1,0,0,53,1,0,0,55,1,0,0,57,1,0,0,59,1,0,0,61,1,0,0,63,1,0,0,65,1,0,0,67,1,0,0,69,1,0,0,71,1,0,0,73,1,0,0,75,1,0,0,77,1,0,0,79,1,0,0,81,1,0,0,83,1,0,0,85,1,0,0,87,1,0,0,89,1,0,0,91,1,0,0,93,1,0,0,95,1,0,0,13,0,0,0,25,0,0,0,41,0,0,0,61,0,0,0,85,0,0,0,113,0,0,0,145,0,0,0,181,0,0,0,221,0,0,0,9,1,0,0,57,1,0,0,109,1,0,0,165,1,0,0,225,1,0,0,33,2,0,0,101,2,0,0,173,2,0,0,249,2,0,0,73,3,0,0,157,3,0,0,245,3,0,0,81,4,0,0,177,4,0,0,21,5,0,0,125,5,0,0,233,5,0,0,89,6,0,0,205,6,0,0,69,7,0,0,193,7,0,0,65,8,0,0,197,8,0,0,77,9,0,0,217,9,0,0,105,10,0,0,253,10,0,0,149,11,0,0,49,12,0,0,209,12,0,0,117,13,0,0,29,14,0,0,201,14,0,0,121,15,0,0,45,16,0,0,229,16,0,0,161,17,0,0,97,18,0,0,37,19,0,0,237,19,0,0,185,20,0,0,137,21,0,0,93,22,0,0,53,23,0,0,17,24,0,0,241,24,0,0,213,25,0,0,189,26,0,0,169,27,0,0,153,28,0,0,141,29,0,0,133,30,0,0,129,31,0,0,129,32,0,0,133,33,0,0,141,34,0,0,153,35,0,0,169,36,0,0,189,37,0,0,213,38,0,0,241,39,0,0,17,41,0,0,53,42,0,0,93,43,0,0,137,44,0,0,185,45,0,0,237,46,0,0,37,48,0,0,97,49,0,0,161,50,0,0,229,51,0,0,45,53,0,0,121,54,0,0,201,55,0,0,29,57,0,0,117,58,0,0,209,59,0,0,49,61,0,0,149,62,0,0,253,63,0,0,105,65,0,0,217,66,0,0,77,68,0,0,197,69,0,0,65,71,0,0,193,72,0,0,69,74,0,0,205,75,0,0,89,77,0,0,233,78,0,0,125,80,0,0,21,82,0,0,177,83,0,0,81,85,0,0,245,86,0,0,157,88,0,0,73,90,0,0,249,91,0,0,173,93,0,0,101,95,0,0,33,97,0,0,225,98,0,0,165,100,0,0,109,102,0,0,57,104,0,0,9,106,0,0,221,107,0,0,181,109,0,0,145,111,0,0,113,113,0,0,85,115,0,0,61,117,0,0,41,119,0,0,25,121,0,0,13,123,0,0,5,125,0,0,1,127,0,0,1,129,0,0,5,131,0,0,13,133,0,0,25,135,0,0,41,137,0,0,61,139,0,0,85,141,0,0,113,143,0,0,145,145,0,0,181,147,0,0,221,149,0,0,9,152,0,0,57,154,0,0,109,156,0,0,165,158,0,0,225,160,0,0,33,163,0,0,101,165,0,0,173,167,0,0,249,169,0,0,73,172,0,0,157,174,0,0,245,176,0,0,81,179,0,0,177,181,0,0,21,184,0,0,125,186,0,0,233,188,0,0,89,191,0,0,205,193,0,0,69,196,0,0,193,198,0,0,65,201,0,0,197,203,0,0,77,206,0,0,217,208,0,0,105,211,0,0,253,213,0,0,149,216,0,0,49,219,0,0,209,221,0,0,117,224,0,0,29,227,0,0,201,229,0,0,121,232,0,0,45,235,0,0,229,237,0,0,161,240,0,0,63,0,0,0,129,0,0,0,231,0,0,0,121,1,0,0,63,2,0,0,65,3,0,0,135,4,0,0,25,6,0,0,255,7,0,0,65,10,0,0,231,12,0,0,249,15,0,0,127,19,0,0,129,23,0,0,7,28,0,0,25,33,0,0,191,38,0,0,1,45,0,0,231,51,0,0,121,59,0,0,191,67,0,0,193,76,0,0,135,86,0,0,25,97,0,0,127,108,0,0,193,120,0,0,231,133,0,0,249,147,0,0,255,162,0,0,1,179,0,0,7,196,0,0,25,214,0,0,63,233,0,0,129,253,0,0,231,18,1,0,121,41,1,0,63,65,1,0,65,90,1,0,135,116,1,0,25,144,1,0,255,172,1,0,65,203,1,0,231,234,1,0,249,11,2,0,127,46,2,0,129,82,2,0,7,120,2,0,25,159,2,0,191,199,2,0,1,242,2,0,231,29,3,0,121,75,3,0,191,122,3,0,193,171,3,0,135,222,3,0,25,19,4,0,127,73,4,0,193,129,4,0,231,187,4,0,249,247,4,0,255,53,5,0,1,118,5,0,7,184,5,0,25,252,5,0,63,66,6,0,129,138,6,0,231,212,6,0,121,33,7,0,63,112,7,0,65,193,7,0,135,20,8,0,25,106,8,0,255,193,8,0,65,28,9,0,231,120,9,0,249,215,9,0,127,57,10,0,129,157,10,0,7,4,11,0,25,109,11,0,191,216,11,0,1,71,12,0,231,183,12,0,121,43,13,0,191,161,13,0,193,26,14,0,135,150,14,0,25,21,15,0,127,150,15,0,193,26,16,0,231,161,16,0,249,43,17,0,255,184,17,0,1,73,18,0,7,220,18,0,25,114,19,0,63,11,20,0,129,167,20,0,231,70,21,0,121,233,21,0,63,143,22,0,65,56,23,0,135,228,23,0,25,148,24,0,255,70,25,0,65,253,25,0,231,182,26,0,249,115,27,0,127,52,28,0,129,248,28,0,7,192,29,0,25,139,30,0,191,89,31,0,1,44,32,0,231,1,33,0,121,219,33,0,191,184,34,0,193,153,35,0,135,126,36,0,25,103,37,0,127,83,38,0,193,67,39,0,231,55,40,0,249,47,41,0,255,43,42,0,1,44,43,0,7,48,44,0,25,56,45,0,63,68,46,0,129,84,47,0,231,104,48,0,121,129,49,0,63,158,50,0,65,191,51,0,135,228,52,0,25,14,54,0,255,59,55,0,65,110,56,0,231,164,57,0,249,223,58,0,127,31,60,0,129,99,61,0,7,172,62,0,25,249,63,0,191,74,65,0,1,161,66,0,231,251,67,0,121,91,69,0,191,191,70,0,193,40,72,0,135,150,73,0,25,9,75,0,127,128,76,0,193,252,77,0,231,125,79,0,249,3,81,0,255,142,82,0,1,31,84,0,7,180,85,0,25,78,87,0,63,237,88,0,129,145,90,0,231,58,92,0,121,233,93,0,63,157,95,0,65,86,97,0,135,20,99,0,25,216,100,0,255,160,102,0,65,111,104,0,231,66,106,0,249,27,108,0,127,250,109,0,65,1,0,0,169,2,0,0,9,5,0,0,193,8,0,0,65,14,0,0,9,22,0,0,169,32,0,0,193,46,0,0,1,65,0,0,41,88,0,0,9,117,0,0,129,152,0,0,129,195,0,0,9,247,0,0,41,52,1,0,1,124,1,0,193,207,1,0,169,48,2,0,9,160,2,0,65,31,3,0,193,175,3,0,9,83,4,0,169,10,5,0,65,216,5,0,129,189,6,0,41,188,7,0,9,214,8,0,1,13,10,0,1,99,11,0,9,218,12,0,41,116,14,0,129,51,16,0,65,26,18,0,169,42,20,0,9,103,22,0,193,209,24,0,65,109,27,0,9,60,30,0,169,64,33,0,193,125,36,0,1,246,39,0,41,172,43,0,9,163,47,0,129,221,51,0,129,94,56,0,9,41,61,0,41,64,66,0,1,167,71,0,193,96,77,0,169,112,83,0,9,218,89,0,65,160,96,0,193,198,103,0,9,81,111,0,169,66,119,0,65,159,127,0,129,106,136,0,41,168,145,0,9,92,155,0,1,138,165,0,1,54,176,0,9,100,187,0,41,24,199,0,129,86,211,0,65,35,224,0,169,130,237,0,9,121,251,0,193,10,10,1,65,60,25,1,9,18,41,1,169,144,57,1,193,188,74,1,1,155,92,1,41,48,111,1,9,129,130,1,129,146,150,1,129,105,171,1,9,11,193,1,41,124,215,1,1,194,238,1,193,225,6,2,169,224,31,2,9,196,57,2,65,145,84,2,193,77,112,2,9,255,140,2,169,170,170,2,65,86,201,2,129,7,233,2,41,196,9,3,9,146,43,3,1,119,78,3,1,121,114,3,9,158,151,3,41,236,189,3,129,105,229,3,65,28,14,4,169,10,56,4,9,59,99,4,193,179,143,4,65,123,189,4,9,152,236,4,169,16,29,5,193,235,78,5,1,48,130,5,41,228,182,5,9,15,237,5,129,183,36,6,129,228,93,6,9,157,152,6,41,232,212,6,1,205,18,7,193,82,82,7,169,128,147,7,9,94,214,7,65,242,26,8,193,68,97,8,9,93,169,8,169,66,243,8,65,253,62,9,129,148,140,9,41,16,220,9,9,120,45,10,1,212,128,10,1,44,214,10,9,136,45,11,41,240,134,11,129,108,226,11,65,5,64,12,169,194,159,12,9,173,1,13,193,204,101,13,65,42,204,13,9,206,52,14,169,192,159,14,193,10,13,15,1,181,124,15,41,200,238,15,9,77,99,16,129,76,218,16,129,207,83,17,9,223,207,17,41,132,78,18,1,200,207,18,193,179,83,19,169,80,218,19,9,168,99,20,65,195,239,20,193,171,126,21,9,107,16,22,169,10,165,22,65,148,60,23,129,17,215,23,41,140,116,24,9,14,21,25,1,161,184,25,1,79,95,26,9,34,9,27,41,36,182,27,129,95,102,28,65,222,25,29,169,170,208,29,9,207,138,30,193,85,72,31,65,73,9,32,9,180,205,32,169,160,149,33,193,25,97,34,1,42,48,35,41,220,2,36,9,59,217,36,129,81,179,37,147,6,0,0,69,14,0,0,15,28,0,0,17,51,0,0,91,87,0,0,13,142,0,0,119,221,0,0,57,77,1,0,99,230,1,0,149,179,2,0,31,193,3,0,33,29,5,0,171,215,6,0,221,2,9,0,7,179,11,0,201,254,14,0,51,255,18,0,229,207,23,0,47,143,29,0,49,94,36,0,251,96,44,0,173,190,53,0,151,161,64,0,89,55,77,0,3,177,91,0,53,67,108,0,63,38,127,0,65,150,148,0,75,211,172,0,125,33,200,0,39,201,230,0,233,22,9,1,211,91,47,1,133,237,89,1,79,38,137,1,81,101,189,1,155,14,247,1,77,139,54,2,183,73,124,2,121,189,200,2,163,95,28,3,213,174,119,3,95,47,219,3,97,107,71,4,235,242,188,4,29,92,60,5,71,67,198,5,9,75,91,6,115,28,252,6,37,103,169,7,111,225,99,8,113,72,44,9,59,96,3,10,237,243,233,10,215,213,224,11,153,223,232,12,67,242,2,14,117,246,47,15,127,220,112,16,129,156,198,17,139,54,50,19,189,178,180,20,103,33,79,22,41,155,2,24,19,65,208,25,197,60,185,27,143,192,190,29,145,7,226,31,219,85,36,34,141,248,134,36,247,69,11,39,185,157,178,41,227,104,126,44,21,26,112,47,159,45,137,50,161,41,203,53,43,158,55,57,93,37,208,60,135,99,150,64,73,7,140,68,179,201,178,72,101,110,12,77,175,195,154,81,177,162,95,86,123,239,92,91,45,153,148,96,23,154,8,102,217,247,186,107,131,195,173,113,181,25,227,119,191,34,93,126,29,35,0,0,113,77,0,0,145,156,0,0,253,38,1,0,101,12,2,0,233,119,3,0,153,162,5,0,53,214,8,0,45,112,13,0,225,228,19,0,33,195,28,0,237,183,40,0,117,146,56,0,89,72,77,0,41,250,103,0,37,248,137,0,61,199,180,0,81,38,234,0,177,19,44,1,221,210,124,1,133,242,222,1,201,82,85,2,185,43,227,2,21,20,140,3,77,8,84,4,193,113,63,5,65,46,83,6,205,151,148,7,149,140,9,9,57,119,184,10,73,87,168,12,5,202,224,14,93,19,106,17,49,39,77,20,209,178,147,23,189,38,72,27,165,192,117,31,169,149,40,36,217,156,109,41,245,185,82,47,109,200,230,53,161,166,57,61,97,65,92,69,173,159,96,78,181,238,89,88,25,142,92,99,105,28,126,111,229,131,213,124,255,189,0,0,1,168,1,0,143,107,3,0,241,158,6,0,63,35,12,0,193,61,21,0,143,182,35,0,241,252,57,0,255,81,91,0,1,250,139,0,15,117,209,0,113,191,50,1,63,154,184,1,193,220,109,2,15,207,95,3,113,142,158,4,255,123,61,6,1,182,83,8,143,156,252,10,241,97,88,14,63,167,140,18,193,37,197,23,143,101,52,30,241,129,20,38,255,251,167,47,1,156,58,59,15,98,34,73,113,134,192,89,63,138,130,109,193,88,227,132,1,14,4,0,145,33,9,0,17,44,19,0,65,238,37,0,65,79,71,0,145,67,128,0,17,247,221,0,1,70,115,1,1,146,90,2,17,1,184,3,145,53,188,5,65,143,167,8,65,6,206,12,17,178,155,18,145,15,154,26,1,26,118,37,1,76,7,52,145,158,87,71,17,157,172,96,65,166,145,129,35,81,22,0,197,158,50,0,23,185,107,0,153,246,216,0,107,137,160,1,13,196,254,2,31,1,80,5,33,217,29,9,51,108,48,15,213,162,164,24,167,103,8,39,41,253,125,60,123,181,231,91,29,119,29,137,175,160,45,201,173,142,123,0,137,230,25,1,57,150,94,2,61,22,216,4,181,99,119,9,225,40,198,17,33,3,52,32,117,72,130,56,125,87,87,96,191,91,175,2,129,216,39,6,247,132,94,13,233,254,173,27,127,139,235,54,129,183,229,104,23,3,156,193,193,12,255,14,57,106,133,34,25,238,145,75,129,120,43,158,51,225,9,84,149,139,0,0,55,152,0,0,255,165,0,0,4,181,0,0,103,197,0,0,69,215,0,0,193,234,0,0,255,255,0,0,200,22,0,0,0,0,0,0,128,187,0,0,120,0,0,0,21,0,0,0,21,0,0,0,0,154,89,63,0,0,0,0,0,0,128,63,0,0,128,63,56,23,0,0,3,0,0,0,8,0,0,0,120,0,0,0,11,0,0,0,104,23,0,0,80,24,0,0,128,24,0,0,128,7,0,0,3,0,0,0,96,26,0,0,152,26,0,0,208,26,0,0,8,27,0,0,64,27,0,0,136,1,0,0,96,55,0,0,56,56,0,0,192,57,0,0,0,0,0,0,0,0,1,0,2,0,3,0,4,0,5,0,6,0,7,0,8,0,10,0,12,0,14,0,16,0,20,0,24,0,28,0,34,0,40,0,48,0,60,0,78,0,100,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,90,80,75,69,63,56,49,40,34,29,20,18,10,0,0,0,0,0,0,0,0,110,100,90,84,78,71,65,58,51,45,39,32,26,20,12,0,0,0,0,0,0,118,110,103,93,86,80,75,70,65,59,53,47,40,31,23,15,4,0,0,0,0,126,119,112,104,95,89,83,78,72,66,60,54,47,39,32,25,17,12,1,0,0,134,127,120,114,103,97,91,85,78,72,66,60,54,47,41,35,29,23,16,10,1,144,137,130,124,113,107,101,95,88,82,76,70,64,57,51,45,39,33,26,15,1,152,145,138,132,123,117,111,105,98,92,86,80,74,67,61,55,49,43,36,20,1,162,155,148,142,133,127,121,115,108,102,96,90,84,77,71,65,59,53,46,30,1,172,165,158,152,143,137,131,125,118,112,106,100,94,87,81,75,69,63,56,45,20,200,200,200,200,200,200,200,200,198,193,188,183,178,173,168,163,158,153,148,129,104,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8,0,8,0,8,0,8,0,16,0,16,0,16,0,21,0,21,0,24,0,29,0,34,0,36,0,0,0,0,0,0,0,106,28,141,56,82,187,30,58,8,105,220,58,130,237,87,59,137,99,178,59,3,42,5,60,48,220,57,60,180,62,119,60,28,163,158,60,209,242,197,60,254,134,241,60,155,171,16,61,5,173,42,61,132,194,70,61,83,230,100,61,17,137,130,61,135,159,147,61,203,178,165,61,209,190,184,61,58,191,204,61,84,175,225,61,20,138,247,61,14,37,7,62,217,244,18,62,95,49,31,62,104,215,43,62,138,227,56,62,48,82,70,62,148,31,84,62,191,71,98,62,142,198,112,62,176,151,127,62,82,91,135,62,96,15,143,62,152,229,150,62,121,219,158,62,112,238,166,62,216,27,175,62,251,96,183,62,17,187,191,62,70,39,200,62,183,162,208,62,120,42,217,62,148,187,225,62,12,83,234,62,222,237,242,62,6,137,251,62,190,16,2,63,31,90,6,63,36,159,10,63,80,222,14,63,43,22,19,63,65,69,23,63,37,106,27,63,115,131,31,63,206,143,35,63,230,141,39,63,116,124,43,63,63,90,47,63,25,38,51,63,231,222,54,63,153,131,58,63,51,19,62,63,197,140,65,63,119,239,68,63,127,58,72,63,39,109,75,63,206,134,78,63,229,134,81,63,241,108,84,63,142,56,87,63,105,233,89,63,69,127,92,63,250,249,94,63,115,89,97,63,175,157,99,63,193,198,101,63,207,212,103,63,17,200,105,63,210,160,107,63,110,95,109,63,80,4,111,63,244,143,112,63,230,2,114,63,189,93,115,63,31,161,116,63,191,205,117,63,87,228,118,63,176,229,119,63,151,210,120,63,227,171,121,63,115,114,122,63,39,39,123,63,231,202,123,63,157,94,124,63,53,227,124,63,156,89,125,63,189,194,125,63,134,31,126,63,222,112,126,63,171,183,126,63,207,244,126,63,38,41,127,63,134,85,127,63,190,122,127,63,150,153,127,63,204,178,127,63,20,199,127,63,28,215,127,63,130,227,127,63,221,236,127,63,182,243,127,63,138,248,127,63,200,251,127,63,214,253,127,63,7,255,127,63,165,255,127,63,232,255,127,63,253,255,127,63,0,0,128,63,224,1,0,0,135,136,8,59,255,255,255,255,5,0,96,0,3,0,32,0,4,0,8,0,2,0,4,0,4,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,176,76,0,0,224,58,0,0,0,0,0,0,240,0,0,0,137,136,136,59,1,0,0,0,5,0,48,0,3,0,16,0,4,0,4,0,4,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,208,74,0,0,224,58,0,0,0,0,0,0,120,0,0,0,136,136,8,60,2,0,0,0,5,0,24,0,3,0,8,0,2,0,4,0,4,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,224,73,0,0,224,58,0,0,0,0,0,0,60,0,0,0,137,136,136,60,3,0,0,0,5,0,12,0,3,0,4,0,4,0,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,104,58,0,0,224,58,0,0,0,0,0,0,255,255,127,63,142,255,127,63,106,254,127,63,147,252,127,63,7,250,127,63,200,246,127,63,214,242,127,63,48,238,127,63,214,232,127,63,200,226,127,63,7,220,127,63,147,212,127,63,107,204,127,63,143,195,127,63,0,186,127,63,189,175,127,63,199,164,127,63,29,153,127,63,192,140,127,63,176,127,127,63,236,113,127,63,118,99,127,63,75,84,127,63,110,68,127,63,222,51,127,63,154,34,127,63,163,16,127,63,250,253,126,63,157,234,126,63,141,214,126,63,203,193,126,63,86,172,126,63,46,150,126,63,83,127,126,63,198,103,126,63,134,79,126,63,148,54,126,63,239,28,126,63,152,2,126,63,143,231,125,63,211,203,125,63,102,175,125,63,70,146,125,63,116,116,125,63,241,85,125,63,188,54,125,63,213,22,125,63,60,246,124,63,242,212,124,63,246,178,124,63,73,144,124,63,235,108,124,63,219,72,124,63,27,36,124,63,169,254,123,63,135,216,123,63,180,177,123,63,48,138,123,63,252,97,123,63,23,57,123,63,130,15,123,63,61,229,122,63,72,186,122,63,162,142,122,63,77,98,122,63,72,53,122,63,148,7,122,63,48,217,121,63,29,170,121,63,90,122,121,63,233,73,121,63,200,24,121,63,249,230,120,63,123,180,120,63,78,129,120,63,115,77,120,63,234,24,120,63,178,227,119,63,205,173,119,63,58,119,119,63,249,63,119,63,10,8,119,63,110,207,118,63,37,150,118,63,47,92,118,63,140,33,118,63,60,230,117,63,64,170,117,63,151,109,117,63,66,48,117,63,65,242,116,63,148,179,116,63,59,116,116,63,55,52,116,63,135,243,115,63,44,178,115,63,38,112,115,63,118,45,115,63,26,234,114,63,20,166,114,63,100,97,114,63,10,28,114,63,5,214,113,63,87,143,113,63,0,72,113,63,255,255,112,63,85,183,112,63,2,110,112,63,6,36,112,63,98,217,111,63,21,142,111,63,32,66,111,63,132,245,110,63,63,168,110,63,83,90,110,63,192,11,110,63,134,188,109,63,165,108,109,63,29,28,109,63,239,202,108,63,27,121,108,63,161,38,108,63,128,211,107,63,187,127,107,63,80,43,107,63,64,214,106,63,140,128,106,63,50,42,106,63,53,211,105,63,147,123,105,63,77,35,105,63,100,202,104,63,216,112,104,63,168,22,104,63,213,187,103,63,96,96,103,63,72,4,103,63,143,167,102,63,51,74,102,63,54,236,101,63,151,141,101,63,87,46,101,63,119,206,100,63,245,109,100,63,212,12,100,63,18,171,99,63,177,72,99,63,176,229,98,63,16,130,98,63,209,29,98,63,243,184,97,63,119,83,97,63,92,237,96,63,164,134,96,63,78,31,96,63,91,183,95,63,203,78,95,63,158,229,94,63,213,123,94,63,112,17,94,63,110,166,93,63,210,58,93,63,154,206,92,63,198,97,92,63,89,244,91,63,81,134,91,63,174,23,91,63,114,168,90,63,157,56,90,63,46,200,89,63,39,87,89,63,135,229,88,63,79,115,88,63,127,0,88,63,23,141,87,63,24,25,87,63,130,164,86,63,86,47,86,63,147,185,85,63,58,67,85,63,75,204,84,63,199,84,84,63,174,220,83,63,1,100,83,63,191,234,82,63,233,112,82,63,127,246,81,63,130,123,81,63,242,255,80,63,207,131,80,63,26,7,80,63,210,137,79,63,250,11,79,63,144,141,78,63,148,14,78,63,9,143,77,63,237,14,77,63,65,142,76,63,5,13,76,63,59,139,75,63,225,8,75,63,249,133,74,63,131,2,74,63,127,126,73,63,238,249,72,63,207,116,72,63,36,239,71,63,237,104,71,63,41,226,70,63,218,90,70,63,0,211,69,63,155,74,69,63,172,193,68,63,50,56,68,63,47,174,67,63,162,35,67,63,141,152,66,63,239,12,66,63,200,128,65,63,26,244,64,63,229,102,64,63,40,217,63,63,229,74,63,63,27,188,62,63,204,44,62,63,247,156,61,63,157,12,61,63,190,123,60,63,92,234,59,63,117,88,59,63,10,198,58,63,29,51,58,63,173,159,57,63,187,11,57,63,71,119,56,63,81,226,55,63,218,76,55,63,227,182,54,63,107,32,54,63,116,137,53,63,253,241,52,63,7,90,52,63,147,193,51,63,160,40,51,63,48,143,50,63,66,245,49,63,216,90,49,63,241,191,48,63,142,36,48,63,175,136,47,63,85,236,46,63,129,79,46,63,50,178,45,63,105,20,45,63,39,118,44,63,107,215,43,63,55,56,43,63,139,152,42,63,103,248,41,63,204,87,41,63,186,182,40,63,50,21,40,63,51,115,39,63,191,208,38,63,214,45,38,63,121,138,37,63,167,230,36,63,97,66,36,63,169,157,35,63,125,248,34,63,223,82,34,63,207,172,33,63,77,6,33,63,91,95,32,63,248,183,31,63,37,16,31,63,226,103,30,63,48,191,29,63,16,22,29,63,129,108,28,63,132,194,27,63,26,24,27,63,67,109,26,63,0,194,25,63,81,22,25,63,54,106,24,63,177,189,23,63,193,16,23,63,103,99,22,63,163,181,21,63,118,7,21,63,225,88,20,63,228,169,19,63,127,250,18,63,179,74,18,63,128,154,17,63,231,233,16,63,232,56,16,63,132,135,15,63,187,213,14,63,142,35,14,63,254,112,13,63,10,190,12,63,179,10,12,63,250,86,11,63,223,162,10,63,99,238,9,63,134,57,9,63,73,132,8,63,172,206,7,63,175,24,7,63,84,98,6,63,155,171,5,63,131,244,4,63,15,61,4,63,61,133,3,63,15,205,2,63,134,20,2,63,161,91,1,63,97,162,0,63,143,209,255,62,167,93,254,62,14,233,252,62,194,115,251,62,198,253,249,62,27,135,248,62,193,15,247,62,186,151,245,62,6,31,244,62,168,165,242,62,158,43,241,62,236,176,239,62,145,53,238,62,144,185,236,62,232,60,235,62,154,191,233,62,169,65,232,62,21,195,230,62,223,67,229,62,8,196,227,62,145,67,226,62,124,194,224,62,200,64,223,62,120,190,221,62,140,59,220,62,6,184,218,62,230,51,217,62,46,175,215,62,223,41,214,62,249,163,212,62,125,29,211,62,110,150,209,62,204,14,208,62,151,134,206,62,210,253,204,62,125,116,203,62,153,234,201,62,39,96,200,62,40,213,198,62,159,73,197,62,138,189,195,62,236,48,194,62,198,163,192,62,25,22,191,62,230,135,189,62,45,249,187,62,241,105,186,62,50,218,184,62,241,73,183,62,47,185,181,62,238,39,180,62,47,150,178,62,242,3,177,62,57,113,175,62,4,222,173,62,86,74,172,62,47,182,170,62,144,33,169,62,122,140,167,62,239,246,165,62,239,96,164,62,124,202,162,62,151,51,161,62,64,156,159,62,122,4,158,62,68,108,156,62,161,211,154,62,145,58,153,62,22,161,151,62,48,7,150,62,225,108,148,62,41,210,146,62,11,55,145,62,135,155,143,62,158,255,141,62,81,99,140,62,162,198,138,62,145,41,137,62,32,140,135,62,80,238,133,62,34,80,132,62,151,177,130,62,176,18,129,62,222,230,126,62,169,167,123,62,195,103,120,62,47,39,117,62,238,229,113,62,4,164,110,62,115,97,107,62,60,30,104,62,98,218,100,62,232,149,97,62,207,80,94,62,26,11,91,62,204,196,87,62,230,125,84,62,107,54,81,62,93,238,77,62,191,165,74,62,146,92,71,62,218,18,68,62,151,200,64,62,206,125,61,62,128,50,58,62,174,230,54,62,93,154,51,62,141,77,48,62,66,0,45,62,125,178,41,62,66,100,38,62,145,21,35,62,110,198,31,62,219,118,28,62,218,38,25,62,109,214,21,62,152,133,18,62,91,52,15,62,186,226,11,62,183,144,8,62,84,62,5,62,148,235,1,62,240,48,253,61,6,138,246,61,113,226,239,61,51,58,233,61,79,145,226,61,207,231,219,61,181,61,213,61,3,147,206,61,192,231,199,61,242,59,193,61,156,143,186,61,195,226,179,61,108,53,173,61,155,135,166,61,85,217,159,61,159,42,153,61,126,123,146,61,246,203,139,61,11,28,133,61,135,215,124,61,70,118,111,61,93,20,98,61,214,177,84,61,185,78,71,61,16,235,57,61,229,134,44,61,64,34,31,61,44,189,17,61,178,87,4,61,181,227,237,60,96,23,211,60,118,74,184,60,11,125,157,60,50,175,130,60,250,193,79,60,254,36,26,60,42,15,201,59,153,167,59,59,46,125,214,185,210,70,113,187,171,222,227,187,166,140,39,188,129,41,93,188,225,98,137,188,160,48,164,188,236,253,190,188,179,202,217,188,224,150,244,188,49,177,7,189,147,22,21,189,140,123,34,189,19,224,47,189,30,68,61,189,165,167,74,189,157,10,88,189,254,108,101,189,190,206,114,189,234,23,128,189,27,200,134,189,237,119,141,189,92,39,148,189,99,214,154,189,253,132,161,189,38,51,168,189,217,224,174,189,17,142,181,189,202,58,188,189,254,230,194,189,170,146,201,189,200,61,208,189,84,232,214,189,74,146,221,189,164,59,228,189,93,228,234,189,114,140,241,189,221,51,248,189,154,218,254,189,82,192,2,190,252,18,6,190,71,101,9,190,50,183,12,190,186,8,16,190,221,89,19,190,152,170,22,190,234,250,25,190,208,74,29,190,71,154,32,190,78,233,35,190,225,55,39,190,0,134,42,190,166,211,45,190,211,32,49,190,131,109,52,190,181,185,55,190,101,5,59,190,147,80,62,190,58,155,65,190,90,229,68,190,240,46,72,190,249,119,75,190,116,192,78,190,93,8,82,190,179,79,85,190,115,150,88,190,156,220,91,190,42,34,95,190,27,103,98,190,109,171,101,190,31,239,104,190,44,50,108,190,148,116,111,190,84,182,114,190,106,247,117,190,211,55,121,190,141,119,124,190,150,182,127,190,117,122,129,190,69,25,131,190,185,183,132,190,208,85,134,190,136,243,135,190,225,144,137,190,218,45,139,190,112,202,140,190,164,102,142,190,116,2,144,190,223,157,145,190,228,56,147,190,129,211,148,190,182,109,150,190,129,7,152,190,226,160,153,190,215,57,155,190,95,210,156,190,121,106,158,190,35,2,160,190,94,153,161,190,38,48,163,190,125,198,164,190,96,92,166,190,206,241,167,190,198,134,169,190,71,27,171,190,80,175,172,190,224,66,174,190,245,213,175,190,143,104,177,190,173,250,178,190,77,140,180,190,110,29,182,190,16,174,183,190,48,62,185,190,207,205,186,190,234,92,188,190,130,235,189,190,148,121,191,190,31,7,193,190,35,148,194,190,159,32,196,190,145,172,197,190,248,55,199,190,211,194,200,190,34,77,202,190,226,214,203,190,19,96,205,190,181,232,206,190,197,112,208,190,66,248,209,190,45,127,211,190,131,5,213,190,67,139,214,190,109,16,216,190,255,148,217,190,249,24,219,190,89,156,220,190,29,31,222,190,70,161,223,190,211,34,225,190,193,163,226,190,16,36,228,190,190,163,229,190,204,34,231,190,56,161,232,190,0,31,234,190,36,156,235,190,162,24,237,190,122,148,238,190,171,15,240,190,51,138,241,190,18,4,243,190,70,125,244,190,207,245,245,190,170,109,247,190,217,228,248,190,88,91,250,190,40,209,251,190,71,70,253,190,181,186,254,190,56,23,0,191,187,208,0,191,228,137,1,191,178,66,2,191,37,251,2,191,59,179,3,191,246,106,4,191,83,34,5,191,83,217,5,191,245,143,6,191,56,70,7,191,29,252,7,191,162,177,8,191,199,102,9,191,140,27,10,191,240,207,10,191,243,131,11,191,147,55,12,191,209,234,12,191,172,157,13,191,36,80,14,191,56,2,15,191,232,179,15,191,50,101,16,191,24,22,17,191,151,198,17,191,176,118,18,191,99,38,19,191,174,213,19,191,145,132,20,191,13,51,21,191,31,225,21,191,200,142,22,191,8,60,23,191,221,232,23,191,72,149,24,191,72,65,25,191,220,236,25,191,4,152,26,191,192,66,27,191,15,237,27,191,240,150,28,191,99,64,29,191,104,233,29,191,254,145,30,191,37,58,31,191,220,225,31,191,35,137,32,191,250,47,33,191,95,214,33,191,82,124,34,191,212,33,35,191,227,198,35,191,127,107,36,191,167,15,37,191,92,179,37,191,157,86,38,191,104,249,38,191,191,155,39,191,160,61,40,191,11,223,40,191,255,127,41,191,125,32,42,191,131,192,42,191,17,96,43,191,39,255,43,191,196,157,44,191,232,59,45,191,146,217,45,191,195,118,46,191,121,19,47,191,180,175,47,191,115,75,48,191,183,230,48,191,127,129,49,191,203,27,50,191,153,181,50,191,234,78,51,191,189,231,51,191,18,128,52,191,232,23,53,191,63,175,53,191,22,70,54,191,110,220,54,191,69,114,55,191,156,7,56,191,113,156,56,191,197,48,57,191,150,196,57,191,230,87,58,191,178,234,58,191,252,124,59,191,194,14,60,191,3,160,60,191,193,48,61,191,250,192,61,191,173,80,62,191,219,223,62,191,131,110,63,191,165,252,63,191,64,138,64,191,83,23,65,191,224,163,65,191,228,47,66,191,96,187,66,191,83,70,67,191,190,208,67,191,158,90,68,191,246,227,68,191,194,108,69,191,5,245,69,191,188,124,70,191,232,3,71,191,137,138,71,191,157,16,72,191,37,150,72,191,32,27,73,191,142,159,73,191,111,35,74,191,193,166,74,191,134,41,75,191,188,171,75,191,99,45,76,191,122,174,76,191,2,47,77,191,250,174,77,191,98,46,78,191,57,173,78,191,126,43,79,191,51,169,79,191,85,38,80,191,230,162,80,191,228,30,81,191,80,154,81,191,40,21,82,191,109,143,82,191,30,9,83,191,59,130,83,191,195,250,83,191,183,114,84,191,22,234,84,191,223,96,85,191,18,215,85,191,176,76,86,191,183,193,86,191,39,54,87,191,0,170,87,191,66,29,88,191,236,143,88,191,254,1,89,191,120,115,89,191,89,228,89,191,162,84,90,191,81,196,90,191,102,51,91,191,226,161,91,191,195,15,92,191,10,125,92,191,183,233,92,191,200,85,93,191,62,193,93,191,24,44,94,191,87,150,94,191,249,255,94,191,255,104,95,191,104,209,95,191,51,57,96,191,98,160,96,191,243,6,97,191,229,108,97,191,58,210,97,191,240,54,98,191,8,155,98,191,128,254,98,191,89,97,99,191,146,195,99,191,44,37,100,191,37,134,100,191],"i8",ALLOC_NONE,Runtime.GLOBAL_BASE);allocate([126,230,100,191,55,70,101,191,78,165,101,191,197,3,102,191,154,97,102,191,205,190,102,191,94,27,103,191,77,119,103,191,154,210,103,191,68,45,104,191,75,135,104,191,174,224,104,191,111,57,105,191,139,145,105,191,4,233,105,191,217,63,106,191,9,150,106,191,148,235,106,191,123,64,107,191,188,148,107,191,89,232,107,191,79,59,108,191,160,141,108,191,75,223,108,191,79,48,109,191,173,128,109,191,101,208,109,191,117,31,110,191,223,109,110,191,161,187,110,191,187,8,111,191,46,85,111,191,248,160,111,191,27,236,111,191,149,54,112,191,103,128,112,191,144,201,112,191,15,18,113,191,230,89,113,191,19,161,113,191,151,231,113,191,113,45,114,191,160,114,114,191,38,183,114,191,1,251,114,191,50,62,115,191,184,128,115,191,148,194,115,191,196,3,116,191,73,68,116,191,34,132,116,191,80,195,116,191,210,1,117,191,168,63,117,191,210,124,117,191,80,185,117,191,33,245,117,191,69,48,118,191,189,106,118,191,136,164,118,191,166,221,118,191,22,22,119,191,217,77,119,191,239,132,119,191,87,187,119,191,17,241,119,191,29,38,120,191,122,90,120,191,42,142,120,191,43,193,120,191,125,243,120,191,33,37,121,191,22,86,121,191,92,134,121,191,242,181,121,191,218,228,121,191,18,19,122,191,154,64,122,191,115,109,122,191,157,153,122,191,22,197,122,191,223,239,122,191,248,25,123,191,97,67,123,191,26,108,123,191,34,148,123,191,122,187,123,191,32,226,123,191,23,8,124,191,92,45,124,191,240,81,124,191,211,117,124,191,5,153,124,191,134,187,124,191,85,221,124,191,115,254,124,191,223,30,125,191,154,62,125,191,163,93,125,191,250,123,125,191,159,153,125,191,146,182,125,191,211,210,125,191,98,238,125,191,63,9,126,191,105,35,126,191,225,60,126,191,167,85,126,191,186,109,126,191,27,133,126,191,201,155,126,191,196,177,126,191,13,199,126,191,162,219,126,191,133,239,126,191,181,2,127,191,50,21,127,191,252,38,127,191,19,56,127,191,118,72,127,191,39,88,127,191,36,103,127,191,110,117,127,191,5,131,127,191,232,143,127,191,25,156,127,191,149,167,127,191,95,178,127,191,116,188,127,191,215,197,127,191,133,206,127,191,129,214,127,191,200,221,127,191,93,228,127,191,61,234,127,191,106,239,127,191,227,243,127,191,169,247,127,191,187,250,127,191,25,253,127,191,196,254,127,191,187,255,127,191,250,255,127,63,57,254,127,63,169,249,127,63,75,242,127,63,30,232,127,63,35,219,127,63,89,203,127,63,193,184,127,63,91,163,127,63,40,139,127,63,39,112,127,63,90,82,127,63,191,49,127,63,88,14,127,63,37,232,126,63,38,191,126,63,92,147,126,63,200,100,126,63,105,51,126,63,65,255,125,63,79,200,125,63,150,142,125,63,20,82,125,63,203,18,125,63,188,208,124,63,231,139,124,63,77,68,124,63,239,249,123,63,205,172,123,63,233,92,123,63,67,10,123,63,221,180,122,63,182,92,122,63,209,1,122,63,46,164,121,63,206,67,121,63,178,224,120,63,220,122,120,63,76,18,120,63,4,167,119,63,4,57,119,63,79,200,118,63,228,84,118,63,198,222,117,63,246,101,117,63,117,234,116,63,68,108,116,63,101,235,115,63,218,103,115,63,163,225,114,63,194,88,114,63,57,205,113,63,9,63,113,63,52,174,112,63,187,26,112,63,160,132,111,63,228,235,110,63,138,80,110,63,147,178,109,63,1,18,109,63,213,110,108,63,17,201,107,63,183,32,107,63,201,117,106,63,73,200,105,63,57,24,105,63,155,101,104,63,111,176,103,63,186,248,102,63,124,62,102,63,184,129,101,63,111,194,100,63,164,0,100,63,90,60,99,63,145,117,98,63,76,172,97,63,142,224,96,63,89,18,96,63,174,65,95,63,145,110,94,63,3,153,93,63,8,193,92,63,160,230,91,63,207,9,91,63,152,42,90,63,251,72,89,63,253,100,88,63,159,126,87,63,229,149,86,63,208,170,85,63,99,189,84,63,161,205,83,63,140,219,82,63,39,231,81,63,117,240,80,63,121,247,79,63,52,252,78,63,171,254,77,63,223,254,76,63,212,252,75,63,140,248,74,63,10,242,73,63,82,233,72,63,101,222,71,63,71,209,70,63,251,193,69,63,132,176,68,63,229,156,67,63,32,135,66,63,58,111,65,63,52,85,64,63,19,57,63,63,216,26,62,63,136,250,60,63,38,216,59,63,180,179,58,63,54,141,57,63,175,100,56,63,34,58,55,63,147,13,54,63,5,223,52,63,124,174,51,63,249,123,50,63,130,71,49,63,25,17,48,63,194,216,46,63,127,158,45,63,86,98,44,63,72,36,43,63,90,228,41,63,144,162,40,63,235,94,39,63,113,25,38,63,37,210,36,63,9,137,35,63,35,62,34,63,117,241,32,63,4,163,31,63,210,82,30,63,228,0,29,63,61,173,27,63,225,87,26,63,211,0,25,63,25,168,23,63,180,77,22,63,170,241,20,63,253,147,19,63,178,52,18,63,204,211,16,63,80,113,15,63,66,13,14,63,164,167,12,63,124,64,11,63,205,215,9,63,154,109,8,63,233,1,7,63,189,148,5,63,25,38,4,63,3,182,2,63,126,68,1,63,28,163,255,62,110,186,252,62,250,206,249,62,202,224,246,62,228,239,243,62,81,252,240,62,26,6,238,62,71,13,235,62,224,17,232,62,237,19,229,62,119,19,226,62,135,16,223,62,36,11,220,62,88,3,217,62,42,249,213,62,164,236,210,62,205,221,207,62,175,204,204,62,82,185,201,62,191,163,198,62,254,139,195,62,24,114,192,62,22,86,189,62,0,56,186,62,224,23,183,62,189,245,179,62,161,209,176,62,149,171,173,62,162,131,170,62,207,89,167,62,39,46,164,62,178,0,161,62,121,209,157,62,133,160,154,62,223,109,151,62,143,57,148,62,160,3,145,62,26,204,141,62,5,147,138,62,107,88,135,62,86,28,132,62,205,222,128,62,182,63,123,62,16,191,116,62,187,59,110,62,201,181,103,62,77,45,97,62,89,162,90,62,255,20,84,62,81,133,77,62,99,243,70,62,70,95,64,62,13,201,57,62,202,48,51,62,144,150,44,62,114,250,37,62,130,92,31,62,210,188,24,62,118,27,18,62,127,120,11,62,1,212,4,62,29,92,252,61,114,13,239,61,41,188,225,61,102,104,212,61,78,18,199,61,8,186,185,61,184,95,172,61,132,3,159,61,146,165,145,61,7,70,132,61,18,202,109,61,122,5,83,61,145,62,56,61,164,117,29,61,252,170,2,61,202,189,207,60,86,35,154,60,97,14,73,60,197,167,187,59,61,122,86,186,9,70,241,187,18,221,99,188,80,138,167,188,65,36,221,188,227,93,9,189,35,40,36,189,150,240,62,189,242,182,89,189,234,122,116,189,26,158,135,189,66,253,148,189,200,90,162,189,134,182,175,189,87,16,189,189,22,104,202,189,155,189,215,189,195,16,229,189,105,97,242,189,101,175,255,189,74,125,6,190,104,33,13,190,250,195,19,190,237,100,26,190,46,4,33,190,172,161,39,190,83,61,46,190,16,215,52,190,210,110,59,190,134,4,66,190,25,152,72,190,121,41,79,190,148,184,85,190,86,69,92,190,174,207,98,190,137,87,105,190,214,220,111,190,128,95,118,190,120,223,124,190,84,174,129,190,129,235,132,190,56,39,136,190,114,97,139,190,36,154,142,190,69,209,145,190,205,6,149,190,179,58,152,190,238,108,155,190,116,157,158,190,61,204,161,190,64,249,164,190,115,36,168,190,207,77,171,190,73,117,174,190,218,154,177,190,120,190,180,190,27,224,183,190,186,255,186,190,75,29,190,190,199,56,193,190,37,82,196,190,91,105,199,190,97,126,202,190,48,145,205,190,188,161,208,190,0,176,211,190,241,187,214,190,135,197,217,190,186,204,220,190,129,209,223,190,211,211,226,190,169,211,229,190,250,208,232,190,189,203,235,190,234,195,238,190,120,185,241,190,96,172,244,190,154,156,247,190,28,138,250,190,223,116,253,190,109,46,0,191,3,161,1,191,45,18,3,191,230,129,4,191,44,240,5,191,250,92,7,191,76,200,8,191,30,50,10,191,108,154,11,191,50,1,13,191,108,102,14,191,23,202,15,191,45,44,17,191,172,140,18,191,144,235,19,191,213,72,21,191,118,164,22,191,113,254,23,191,192,86,25,191,98,173,26,191,81,2,28,191,138,85,29,191,9,167,30,191,203,246,31,191,204,68,33,191,9,145,34,191,124,219,35,191,36,36,37,191,253,106,38,191,2,176,39,191,48,243,40,191,132,52,42,191,250,115,43,191,143,177,44,191,63,237,45,191,7,39,47,191,227,94,48,191,208,148,49,191,202,200,50,191,206,250,51,191,218,42,53,191,232,88,54,191,247,132,55,191,2,175,56,191,7,215,57,191,3,253,58,191,241,32,60,191,207,66,61,191,154,98,62,191,79,128,63,191,233,155,64,191,104,181,65,191,198,204,66,191,1,226,67,191,23,245,68,191,3,6,70,191,196,20,71,191,86,33,72,191,182,43,73,191,225,51,74,191,212,57,75,191,141,61,76,191,9,63,77,191,68,62,78,191,61,59,79,191,240,53,80,191,90,46,81,191,121,36,82,191,74,24,83,191,202,9,84,191,247,248,84,191,206,229,85,191,77,208,86,191,112,184,87,191,55,158,88,191,156,129,89,191,160,98,90,191,62,65,91,191,117,29,92,191,65,247,92,191,162,206,93,191,148,163,94,191,20,118,95,191,34,70,96,191,186,19,97,191,217,222,97,191,127,167,98,191,169,109,99,191,84,49,100,191,126,242,100,191,38,177,101,191,73,109,102,191,229,38,103,191,248,221,103,191,128,146,104,191,123,68,105,191,232,243,105,191,195,160,106,191,12,75,107,191,192,242,107,191,222,151,108,191,100,58,109,191,80,218,109,191,160,119,110,191,83,18,111,191,102,170,111,191,217,63,112,191,169,210,112,191,213,98,113,191,91,240,113,191,58,123,114,191,113,3,115,191,253,136,115,191,222,11,116,191,17,140,116,191,150,9,117,191,107,132,117,191,143,252,117,191,0,114,118,191,189,228,118,191,198,84,119,191,24,194,119,191,178,44,120,191,147,148,120,191,187,249,120,191,40,92,121,191,217,187,121,191,205,24,122,191,2,115,122,191,121,202,122,191,47,31,123,191,36,113,123,191,88,192,123,191,201,12,124,191,118,86,124,191,95,157,124,191,130,225,124,191,224,34,125,191,119,97,125,191,71,157,125,191,79,214,125,191,142,12,126,191,4,64,126,191,176,112,126,191,146,158,126,191,169,201,126,191,245,241,126,191,117,23,127,191,41,58,127,191,16,90,127,191,43,119,127,191,120,145,127,191,248,168,127,191,170,189,127,191,143,207,127,191,165,222,127,191,237,234,127,191,102,244,127,191,17,251,127,191,237,254,127,191,234,255,127,63,229,248,127,63,166,230,127,63,45,201,127,63,124,160,127,63,149,108,127,63,121,45,127,63,44,227,126,63,177,141,126,63,11,45,126,63,63,193,125,63,82,74,125,63,72,200,124,63,40,59,124,63,247,162,123,63,189,255,122,63,128,81,122,63,72,152,121,63,30,212,120,63,9,5,120,63,19,43,119,63,70,70,118,63,172,86,117,63,78,92,116,63,56,87,115,63,118,71,114,63,19,45,113,63,28,8,112,63,158,216,110,63,165,158,109,63,64,90,108,63,126,11,107,63,107,178,105,63,25,79,104,63,150,225,102,63,242,105,101,63,62,232,99,63,139,92,98,63,234,198,96,63,109,39,95,63,38,126,93,63,40,203,91,63,133,14,90,63,83,72,88,63,163,120,86,63,139,159,84,63,32,189,82,63,118,209,80,63,163,220,78,63,189,222,76,63,219,215,74,63,19,200,72,63,124,175,70,63,46,142,68,63,65,100,66,63,206,49,64,63,236,246,61,63,180,179,59,63,66,104,57,63,173,20,55,63,16,185,52,63,134,85,50,63,41,234,47,63,21,119,45,63,101,252,42,63,53,122,40,63,161,240,37,63,198,95,35,63,192,199,32,63,172,40,30,63,169,130,27,63,212,213,24,63,74,34,22,63,42,104,19,63,147,167,16,63,164,224,13,63,123,19,11,63,57,64,8,63,253,102,5,63,231,135,2,63,45,70,255,62,91,113,249,62,151,145,243,62,36,167,237,62,69,178,231,62,60,179,225,62,76,170,219,62,186,151,213,62,201,123,207,62,190,86,201,62,223,40,195,62,112,242,188,62,183,179,182,62,251,108,176,62,129,30,170,62,146,200,163,62,115,107,157,62,108,7,151,62,197,156,144,62,199,43,138,62,185,180,131,62,199,111,122,62,33,107,109,62,17,92,96,62,41,67,83,62,253,32,70,62,32,246,56,62,38,195,43,62,164,136,30,62,45,71,17,62,87,255,3,62,110,99,237,61,194,189,210,61,218,14,184,61,222,87,157,61,251,153,130,61,188,172,79,61,101,28,26,61,153,10,201,60,42,167,59,60,193,120,214,186,45,68,113,188,87,215,227,188,76,129,39,189,148,15,93,189,21,74,137,189,90,6,164,189,109,187,190,189,34,104,217,189,78,11,244,189,227,81,7,190,47,152,20,190,247,215,33,190,165,16,47,190,166,65,60,190,100,106,73,190,77,138,86,190,205,160,99,190,80,173,112,190,69,175,125,190,13,83,133,190,158,200,139,190,13,56,146,190,18,161,152,190,102,3,159,190,191,94,165,190,216,178,171,190,105,255,177,190,43,68,184,190,216,128,190,190,42,181,196,190,219,224,202,190,165,3,209,190,69,29,215,190,117,45,221,190,241,51,227,190,118,48,233,190,192,34,239,190,141,10,245,190,155,231,250,190,211,92,0,191,56,64,3,191,219,29,6,191,155,245,8,191,90,199,11,191,247,146,14,191,84,88,17,191,80,23,20,191,205,207,22,191,172,129,25,191,208,44,28,191,26,209,30,191,109,110,33,191,171,4,36,191,183,147,38,191,116,27,41,191,199,155,43,191,147,20,46,191,187,133,48,191,38,239,50,191,183,80,53,191,85,170,55,191,227,251,57,191,74,69,60,191,110,134,62,191,55,191,64,191,139,239,66,191,83,23,69,191,117,54,71,191,218,76,73,191,107,90,75,191,16,95,77,191,179,90,79,191,62,77,81,191,154,54,83,191,179,22,85,191,114,237,86,191,197,186,88,191,149,126,90,191,208,56,92,191,98,233,93,191,56,144,95,191,64,45,97,191,103,192,98,191,156,73,100,191,206,200,101,191,235,61,103,191,227,168,104,191,167,9,106,191,39,96,107,191,84,172,108,191,31,238,109,191,122,37,111,191,88,82,112,191,171,116,113,191,103,140,114,191,127,153,115,191,231,155,116,191,149,147,117,191,126,128,118,191,150,98,119,191,212,57,120,191,47,6,121,191,158,199,121,191,23,126,122,191,148,41,123,191,13,202,123,191,122,95,124,191,213,233,124,191,24,105,125,191,62,221,125,191,64,70,126,191,28,164,126,191,204,246,126,191,77,62,127,191,156,122,127,191,182,171,127,191,153,209,127,191,67,236,127,191,180,251,127,191,166,255,127,63,148,227,127,63,156,154,127,63,204,36,127,63,56,130,126,63,253,178,125,63,63,183,124,63,42,143,123,63,243,58,122,63,212,186,120,63,17,15,119,63,246,55,117,63,213,53,115,63,8,9,113,63,241,177,110,63,249,48,108,63,144,134,105,63,47,179,102,63,83,183,99,63,132,147,96,63,78,72,93,63,69,214,89,63,3,62,86,63,43,128,82,63,101,157,78,63,94,150,74,63,204,107,70,63,106,30,66,63,249,174,61,63,64,30,57,63,13,109,52,63,50,156,47,63,135,172,42,63,235,158,37,63,63,116,32,63,109,45,27,63,97,203,21,63,13,79,16,63,104,185,10,63,107,11,5,63,46,140,254,62,221,212,242,62,241,242,230,62,127,232,218,62,166,183,206,62,136,98,194,62,78,235,181,62,42,84,169,62,81,159,156,62,253,206,143,62,109,229,130,62,206,201,107,62,98,159,81,62,48,80,55,62,211,224,28,62,241,85,2,62,98,104,207,61,124,0,154,61,36,251,72,61,27,164,187,60,243,119,86,187,100,61,241,188,187,192,99,189,103,93,167,189,20,189,220,189,3,251,8,190,115,127,35,190,52,231,61,190,164,45,88,190,38,78,114,190,18,34,134,190,137,5,147,190,52,207,159,190,213,124,172,190,51,12,185,190,26,123,197,190,91,199,209,190,205,238,221,190,80,239,233,190,199,198,245,190,144,185,0,191,38,121,6,191,36,33,12,191,141,176,17,191,102,38,23,191,186,129,28,191,152,193,33,191,21,229,38,191,74,235,43,191,86,211,48,191,91,156,53,191,131,69,58,191,253,205,62,191,252,52,67,191,188,121,71,191,125,155,75,191,132,153,79,191,31,115,83,191,161,39,87,191,99,182,90,191,198,30,94,191,48,96,97,191,15,122,100,191,216,107,103,191,7,53,106,191,31,213,108,191,169,75,111,191,55,152,113,191,98,186,115,191,201,177,117,191,22,126,119,191,246,30,121,191,33,148,122,191,85,221,123,191,89,250,124,191,250,234,125,191,14,175,126,191,116,70,127,191,15,177,127,191,206,238,127,191,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,255,0,0,0,0,0,0,0,0,41,0,41,0,41,0,82,0,82,0,123,0,164,0,200,0,222,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,41,0,41,0,41,0,41,0,123,0,123,0,123,0,164,0,164,0,240,0,10,1,27,1,39,1,41,0,41,0,41,0,41,0,41,0,41,0,41,0,41,0,123,0,123,0,123,0,123,0,240,0,240,0,240,0,10,1,10,1,49,1,62,1,72,1,80,1,123,0,123,0,123,0,123,0,123,0,123,0,123,0,123,0,240,0,240,0,240,0,240,0,49,1,49,1,49,1,62,1,62,1,87,1,95,1,102,1,108,1,240,0,240,0,240,0,240,0,240,0,240,0,240,0,240,0,49,1,49,1,49,1,49,1,87,1,87,1,87,1,95,1,95,1,114,1,120,1,126,1,131,1,0,0,0,0,0,0,40,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,40,15,23,28,31,34,36,38,39,41,42,43,44,45,46,47,47,49,50,51,52,53,54,55,55,57,58,59,60,61,62,63,63,65,66,67,68,69,70,71,71,40,20,33,41,48,53,57,61,64,66,69,71,73,75,76,78,80,82,85,87,89,91,92,94,96,98,101,103,105,107,108,110,112,114,117,119,121,123,124,126,128,40,23,39,51,60,67,73,79,83,87,91,94,97,100,102,105,107,111,115,118,121,124,126,129,131,135,139,142,145,148,150,153,155,159,163,166,169,172,174,177,179,35,28,49,65,78,89,99,107,114,120,126,132,136,141,145,149,153,159,165,171,176,180,185,189,192,199,205,211,216,220,225,229,232,239,245,251,21,33,58,79,97,112,125,137,148,157,166,174,182,189,195,201,207,217,227,235,243,251,17,35,63,86,106,123,139,152,165,177,187,197,206,214,222,230,237,250,25,31,55,75,91,105,117,128,138,146,154,161,168,174,180,185,190,200,208,215,222,229,235,240,245,255,16,36,65,89,110,128,144,159,173,185,196,207,217,226,234,242,250,11,41,74,103,128,151,172,191,209,225,241,255,9,43,79,110,138,163,186,207,227,246,12,39,71,99,123,144,164,182,198,214,228,241,253,9,44,81,113,142,168,192,214,235,255,7,49,90,127,160,191,220,247,6,51,95,134,170,203,234,7,47,87,123,155,184,212,237,6,52,97,137,174,208,240,5,57,106,151,192,231,5,59,111,158,202,243,5,55,103,147,187,224,5,60,113,161,206,248,4,65,122,175,224,4,67,127,182,234,224,224,224,224,224,224,224,224,160,160,160,160,185,185,185,178,178,168,134,61,37,224,224,224,224,224,224,224,224,240,240,240,240,207,207,207,198,198,183,144,66,40,160,160,160,160,160,160,160,160,185,185,185,185,193,193,193,183,183,172,138,64,38,240,240,240,240,240,240,240,240,207,207,207,207,204,204,204,193,193,180,143,66,40,185,185,185,185,185,185,185,185,193,193,193,193,193,193,193,183,183,172,138,65,39,207,207,207,207,207,207,207,207,204,204,204,204,201,201,201,188,188,176,141,66,40,193,193,193,193,193,193,193,193,193,193,193,193,194,194,194,184,184,173,139,65,39,204,204,204,204,204,204,204,204,201,201,201,201,198,198,198,187,187,175,140,66,40,0,0,12,0,24,0,36,0,48,0,4,0,16,0,28,0,40,0,52,0,8,0,20,0,32,0,44,0,56,0,1,0,13,0,25,0,37,0,49,0,5,0,17,0,29,0,41,0,53,0,9,0,21,0,33,0,45,0,57,0,2,0,14,0,26,0,38,0,50,0,6,0,18,0,30,0,42,0,54,0,10,0,22,0,34,0,46,0,58,0,3,0,15,0,27,0,39,0,51,0,7,0,19,0,31,0,43,0,55,0,11,0,23,0,35,0,47,0,59,0,0,0,128,63,0,0,0,128,99,250,127,63,191,117,86,188,139,233,127,63,10,113,214,188,121,205,127,63,231,206,32,189,47,166,127,63,58,94,86,189,175,115,127,63,19,242,133,189,249,53,127,63,42,175,160,189,18,237,126,63,51,101,187,189,253,152,126,63,4,19,214,189,188,57,126,63,115,183,240,189,85,207,125,63,168,168,5,190,203,89,125,63,187,239,18,190,37,217,124,63,92,48,32,190,103,77,124,63,245,105,45,190,152,182,123,63,243,155,58,190,190,20,123,63,194,197,71,190,226,103,122,63,205,230,84,190,9,176,121,63,130,254,97,190,60,237,120,63,77,12,111,190,132,31,120,63,156,15,124,190,234,70,119,63,238,131,132,190,119,99,118,63,62,250,138,190,54,117,117,63,117,106,145,190,48,124,116,63,76,212,151,190,113,120,115,63,122,55,158,190,3,106,114,63,183,147,164,190,244,80,113,63,188,232,170,190,79,45,112,63,65,54,177,190,33,255,110,63,1,124,183,190,118,198,109,63,180,185,189,190,94,131,108,63,21,239,195,190,231,53,107,63,222,27,202,190,30,222,105,63,201,63,208,190,18,124,104,63,146,90,214,190,212,15,103,63,243,107,220,190,116,153,101,63,170,115,226,190,1,25,100,63,113,113,232,190,141,142,98,63,7,101,238,190,40,250,96,63,39,78,244,190,230,91,95,63,144,44,250,190,215,179,93,63,0,0,0,191,15,2,92,63,27,228,2,191,160,70,90,63,119,194,5,191,158,129,88,63,246,154,8,191,29,179,86,63,119,109,11,191,49,219,84,63,218,57,14,191,239,249,82,63,0,0,17,191,108,15,81,63,202,191,19,191,189,27,79,63,24,121,22,191,248,30,77,63,205,43,25,191,52,25,75,63,202,215,27,191,136,10,73,63,241,124,30,191,10,243,70,63,36,27,33,191,209,210,68,63,70,178,35,191,247,169,66,63,58,66,38,191,147,120,64,63,227,202,40,191,189,62,62,63,37,76,43,191,143,252,59,63,227,197,45,191,34,178,57,63,1,56,48,191,144,95,55,63,101,162,50,191,243,4,53,63,243,4,53,191,101,162,50,63,144,95,55,191,1,56,48,63,34,178,57,191,227,197,45,63,143,252,59,191,37,76,43,63,189,62,62,191,227,202,40,63,147,120,64,191,58,66,38,63,247,169,66,191,70,178,35,63,209,210,68,191,36,27,33,63,10,243,70,191,241,124,30,63,136,10,73,191,202,215,27,63,52,25,75,191,205,43,25,63,248,30,77,191,24,121,22,63,189,27,79,191,202,191,19,63,108,15,81,191,0,0,17,63,239,249,82,191,218,57,14,63,49,219,84,191,119,109,11,63,29,179,86,191,246,154,8,63,158,129,88,191,119,194,5,63,160,70,90,191,27,228,2,63,15,2,92,191,0,0,0,63,215,179,93,191,144,44,250,62,230,91,95,191,39,78,244,62,40,250,96,191,7,101,238,62,141,142,98,191,113,113,232,62,1,25,100,191,170,115,226,62,116,153,101,191,243,107,220,62,212,15,103,191,146,90,214,62,18,124,104,191,201,63,208,62,30,222,105,191,222,27,202,62,231,53,107,191,21,239,195,62,94,131,108,191,180,185,189,62,118,198,109,191,1,124,183,62,33,255,110,191,65,54,177,62,79,45,112,191,188,232,170,62,244,80,113,191,183,147,164,62,3,106,114,191,122,55,158,62,113,120,115,191,76,212,151,62,48,124,116,191,117,106,145,62,54,117,117,191,62,250,138,62,119,99,118,191,238,131,132,62,234,70,119,191,156,15,124,62,132,31,120,191,77,12,111,62,60,237,120,191,130,254,97,62,9,176,121,191,205,230,84,62,226,103,122,191,194,197,71,62,190,20,123,191,243,155,58,62,152,182,123,191,245,105,45,62,103,77,124,191,92,48,32,62,37,217,124,191,187,239,18,62,203,89,125,191,168,168,5,62,85,207,125,191,115,183,240,61,188,57,126,191,4,19,214,61,253,152,126,191,51,101,187,61,18,237,126,191,42,175,160,61,249,53,127,191,19,242,133,61,175,115,127,191,58,94,86,61,47,166,127,191,231,206,32,61,121,205,127,191,10,113,214,60,139,233,127,191,191,117,86,60,99,250,127,191,0,48,141,36,0,0,128,191,191,117,86,188,99,250,127,191,10,113,214,188,139,233,127,191,231,206,32,189,121,205,127,191,58,94,86,189,47,166,127,191,19,242,133,189,175,115,127,191,42,175,160,189,249,53,127,191,51,101,187,189,18,237,126,191,4,19,214,189,253,152,126,191,115,183,240,189,188,57,126,191,168,168,5,190,85,207,125,191,187,239,18,190,203,89,125,191,92,48,32,190,37,217,124,191,245,105,45,190,103,77,124,191,243,155,58,190,152,182,123,191,194,197,71,190,190,20,123,191,205,230,84,190,226,103,122,191,130,254,97,190,9,176,121,191,77,12,111,190,60,237,120,191,156,15,124,190,132,31,120,191,238,131,132,190,234,70,119,191,62,250,138,190,119,99,118,191,117,106,145,190,54,117,117,191,76,212,151,190,48,124,116,191,122,55,158,190,113,120,115,191,183,147,164,190,3,106,114,191,188,232,170,190,244,80,113,191,65,54,177,190,79,45,112,191,1,124,183,190,33,255,110,191,180,185,189,190,118,198,109,191,21,239,195,190,94,131,108,191,222,27,202,190,231,53,107,191,201,63,208,190,30,222,105,191,146,90,214,190,18,124,104,191,243,107,220,190,212,15,103,191,170,115,226,190,116,153,101,191,113,113,232,190,1,25,100,191,7,101,238,190,141,142,98,191,39,78,244,190,40,250,96,191,144,44,250,190,230,91,95,191,0,0,0,191,215,179,93,191,27,228,2,191,15,2,92,191,119,194,5,191,160,70,90,191,246,154,8,191,158,129,88,191,119,109,11,191,29,179,86,191,218,57,14,191,49,219,84,191,0,0,17,191,239,249,82,191,202,191,19,191,108,15,81,191,24,121,22,191,189,27,79,191,205,43,25,191,248,30,77,191,202,215,27,191,52,25,75,191,241,124,30,191,136,10,73,191,36,27,33,191,10,243,70,191,70,178,35,191,209,210,68,191,58,66,38,191,247,169,66,191,227,202,40,191,147,120,64,191,37,76,43,191,189,62,62,191,227,197,45,191,143,252,59,191,1,56,48,191,34,178,57,191,101,162,50,191,144,95,55,191,243,4,53,191,243,4,53,191,144,95,55,191,101,162,50,191,34,178,57,191,1,56,48,191,143,252,59,191,227,197,45,191,189,62,62,191,37,76,43,191,147,120,64,191,227,202,40,191,247,169,66,191,58,66,38,191,209,210,68,191,70,178,35,191,10,243,70,191,36,27,33,191,136,10,73,191,241,124,30,191,52,25,75,191,202,215,27,191,248,30,77,191,205,43,25,191,189,27,79,191,24,121,22,191,108,15,81,191,202,191,19,191,239,249,82,191,0,0,17,191,49,219,84,191,218,57,14,191,29,179,86,191,119,109,11,191,158,129,88,191,246,154,8,191,160,70,90,191,119,194,5,191,15,2,92,191,27,228,2,191,215,179,93,191,0,0,0,191,230,91,95,191,144,44,250,190,40,250,96,191,39,78,244,190,141,142,98,191,7,101,238,190,1,25,100,191,113,113,232,190,116,153,101,191,170,115,226,190,212,15,103,191,243,107,220,190,18,124,104,191,146,90,214,190,30,222,105,191,201,63,208,190,231,53,107,191,222,27,202,190,94,131,108,191,21,239,195,190,118,198,109,191,180,185,189,190,33,255,110,191,1,124,183,190,79,45,112,191,65,54,177,190,244,80,113,191,188,232,170,190,3,106,114,191,183,147,164,190,113,120,115,191,122,55,158,190,48,124,116,191,76,212,151,190,54,117,117,191,117,106,145,190,119,99,118,191,62,250,138,190,234,70,119,191,238,131,132,190,132,31,120,191,156,15,124,190,60,237,120,191,77,12,111,190,9,176,121,191,130,254,97,190,226,103,122,191,205,230,84,190,190,20,123,191,194,197,71,190,152,182,123,191,243,155,58,190,103,77,124,191,245,105,45,190,37,217,124,191,92,48,32,190,203,89,125,191,187,239,18,190,85,207,125,191,168,168,5,190,188,57,126,191,115,183,240,189,253,152,126,191,4,19,214,189,18,237,126,191,51,101,187,189,249,53,127,191,42,175,160,189,175,115,127,191,19,242,133,189,47,166,127,191,58,94,86,189,121,205,127,191,231,206,32,189,139,233,127,191,10,113,214,188,99,250,127,191,191,117,86,188,0,0,128,191,0,48,13,165,99,250,127,191,191,117,86,60,139,233,127,191,10,113,214,60,121,205,127,191,231,206,32,61,47,166,127,191,58,94,86,61,175,115,127,191,19,242,133,61,249,53,127,191,42,175,160,61,18,237,126,191,51,101,187,61,253,152,126,191,4,19,214,61,188,57,126,191,115,183,240,61,85,207,125,191,168,168,5,62,203,89,125,191,187,239,18,62,37,217,124,191,92,48,32,62,103,77,124,191,245,105,45,62,152,182,123,191,243,155,58,62,190,20,123,191,194,197,71,62,226,103,122,191,205,230,84,62,9,176,121,191,130,254,97,62,60,237,120,191,77,12,111,62,132,31,120,191,156,15,124,62,234,70,119,191,238,131,132,62,119,99,118,191,62,250,138,62,54,117,117,191,117,106,145,62,48,124,116,191,76,212,151,62,113,120,115,191,122,55,158,62,3,106,114,191,183,147,164,62,244,80,113,191,188,232,170,62,79,45,112,191,65,54,177,62,33,255,110,191,1,124,183,62,118,198,109,191,180,185,189,62,94,131,108,191,21,239,195,62,231,53,107,191,222,27,202,62,30,222,105,191,201,63,208,62,18,124,104,191,146,90,214,62,212,15,103,191,243,107,220,62,116,153,101,191,170,115,226,62,1,25,100,191,113,113,232,62,141,142,98,191,7,101,238,62,40,250,96,191,39,78,244,62,230,91,95,191,144,44,250,62,215,179,93,191,0,0,0,63,15,2,92,191,27,228,2,63,160,70,90,191,119,194,5,63,158,129,88,191,246,154,8,63,29,179,86,191,119,109,11,63,49,219,84,191,218,57,14,63,239,249,82,191,0,0,17,63,108,15,81,191,202,191,19,63,189,27,79,191,24,121,22,63,248,30,77,191,205,43,25,63,52,25,75,191,202,215,27,63,136,10,73,191,241,124,30,63,10,243,70,191,36,27,33,63,209,210,68,191,70,178,35,63,247,169,66,191,58,66,38,63,147,120,64,191,227,202,40,63,189,62,62,191,37,76,43,63,143,252,59,191,227,197,45,63,34,178,57,191,1,56,48,63,144,95,55,191,101,162,50,63,243,4,53,191,243,4,53,63,101,162,50,191,144,95,55,63,1,56,48,191,34,178,57,63,227,197,45,191,143,252,59,63,37,76,43,191,189,62,62,63,227,202,40,191,147,120,64,63,58,66,38,191,247,169,66,63,70,178,35,191,209,210,68,63,36,27,33,191,10,243,70,63,241,124,30,191,136,10,73,63,202,215,27,191,52,25,75,63,205,43,25,191,248,30,77,63,24,121,22,191,189,27,79,63,202,191,19,191,108,15,81,63,0,0,17,191,239,249,82,63,218,57,14,191,49,219,84,63,119,109,11,191,29,179,86,63,246,154,8,191,158,129,88,63,119,194,5,191,160,70,90,63,27,228,2,191,15,2,92,63,0,0,0,191,215,179,93,63,144,44,250,190,230,91,95,63,39,78,244,190,40,250,96,63,7,101,238,190,141,142,98,63,113,113,232,190,1,25,100,63,170,115,226,190,116,153,101,63,243,107,220,190,212,15,103,63,146,90,214,190,18,124,104,63,201,63,208,190,30,222,105,63,222,27,202,190,231,53,107,63,21,239,195,190,94,131,108,63,180,185,189,190,118,198,109,63,1,124,183,190,33,255,110,63,65,54,177,190,79,45,112,63,188,232,170,190,244,80,113,63,183,147,164,190,3,106,114,63,122,55,158,190,113,120,115,63,76,212,151,190,48,124,116,63,117,106,145,190,54,117,117,63,62,250,138,190,119,99,118,63,238,131,132,190,234,70,119,63,156,15,124,190,132,31,120,63,77,12,111,190,60,237,120,63,130,254,97,190,9,176,121,63,205,230,84,190,226,103,122,63,194,197,71,190,190,20,123,63,243,155,58,190,152,182,123,63,245,105,45,190,103,77,124,63,92,48,32,190,37,217,124,63,187,239,18,190,203,89,125,63,168,168,5,190,85,207,125,63,115,183,240,189,188,57,126,63,4,19,214,189,253,152,126,63,51,101,187,189,18,237,126,63,42,175,160,189,249,53,127,63,19,242,133,189,175,115,127,63,58,94,86,189,47,166,127,63,231,206,32,189,121,205,127,63,10,113,214,188,139,233,127,63,191,117,86,188,99,250,127,63,0,200,83,165,0,0,128,63,191,117,86,60,99,250,127,63,10,113,214,60,139,233,127,63,231,206,32,61,121,205,127,63,58,94,86,61,47,166,127,63,19,242,133,61,175,115,127,63,42,175,160,61,249,53,127,63,51,101,187,61,18,237,126,63,4,19,214,61,253,152,126,63,115,183,240,61,188,57,126,63,168,168,5,62,85,207,125,63,187,239,18,62,203,89,125,63,92,48,32,62,37,217,124,63,245,105,45,62,103,77,124,63,243,155,58,62,152,182,123,63,194,197,71,62,190,20,123,63,205,230,84,62,226,103,122,63,130,254,97,62,9,176,121,63,77,12,111,62,60,237,120,63,156,15,124,62,132,31,120,63,238,131,132,62,234,70,119,63,62,250,138,62,119,99,118,63,117,106,145,62,54,117,117,63,76,212,151,62,48,124,116,63,122,55,158,62,113,120,115,63,183,147,164,62,3,106,114,63,188,232,170,62,244,80,113,63,65,54,177,62,79,45,112,63,1,124,183,62,33,255,110,63,180,185,189,62,118,198,109,63,21,239,195,62,94,131,108,63,222,27,202,62,231,53,107,63,201,63,208,62,30,222,105,63,146,90,214,62,18,124,104,63,243,107,220,62,212,15,103,63,170,115,226,62,116,153,101,63,113,113,232,62,1,25,100,63,7,101,238,62,141,142,98,63,39,78,244,62,40,250,96,63,144,44,250,62,230,91,95,63,0,0,0,63,215,179,93,63,27,228,2,63,15,2,92,63,119,194,5,63,160,70,90,63,246,154,8,63,158,129,88,63,119,109,11,63,29,179,86,63,218,57,14,63,49,219,84,63,0,0,17,63,239,249,82,63,202,191,19,63,108,15,81,63,24,121,22,63,189,27,79,63,205,43,25,63,248,30,77,63,202,215,27,63,52,25,75,63,241,124,30,63,136,10,73,63,36,27,33,63,10,243,70,63,70,178,35,63,209,210,68,63,58,66,38,63,247,169,66,63,227,202,40,63,147,120,64,63,37,76,43,63,189,62,62,63,227,197,45,63,143,252,59,63,1,56,48,63,34,178,57,63,101,162,50,63,144,95,55,63,243,4,53,63,243,4,53,63,144,95,55,63,101,162,50,63,34,178,57,63,1,56,48,63,143,252,59,63,227,197,45,63,189,62,62,63,37,76,43,63,147,120,64,63,227,202,40,63,247,169,66,63,58,66,38,63,209,210,68,63,70,178,35,63,10,243,70,63,36,27,33,63,136,10,73,63,241,124,30,63,52,25,75,63,202,215,27,63,248,30,77,63,205,43,25,63,189,27,79,63,24,121,22,63,108,15,81,63,202,191,19,63,239,249,82,63,0,0,17,63,49,219,84,63,218,57,14,63,29,179,86,63,119,109,11,63,158,129,88,63,246,154,8,63,160,70,90,63,119,194,5,63,15,2,92,63,27,228,2,63,215,179,93,63,0,0,0,63,230,91,95,63,144,44,250,62,40,250,96,63,39,78,244,62,141,142,98,63,7,101,238,62,1,25,100,63,113,113,232,62,116,153,101,63,170,115,226,62,212,15,103,63,243,107,220,62,18,124,104,63,146,90,214,62,30,222,105,63,201,63,208,62,231,53,107,63,222,27,202,62,94,131,108,63,21,239,195,62,118,198,109,63,180,185,189,62,33,255,110,63,1,124,183,62,79,45,112,63,65,54,177,62,244,80,113,63,188,232,170,62,3,106,114,63,183,147,164,62,113,120,115,63,122,55,158,62,48,124,116,63,76,212,151,62,54,117,117,63,117,106,145,62,119,99,118,63,62,250,138,62,234,70,119,63,238,131,132,62,132,31,120,63,156,15,124,62,60,237,120,63,77,12,111,62,9,176,121,63,130,254,97,62,226,103,122,63,205,230,84,62,190,20,123,63,194,197,71,62,152,182,123,63,243,155,58,62,103,77,124,63,245,105,45,62,37,217,124,63,92,48,32,62,203,89,125,63,187,239,18,62,85,207,125,63,168,168,5,62,188,57,126,63,115,183,240,61,253,152,126,63,4,19,214,61,18,237,126,63,51,101,187,61,249,53,127,63,42,175,160,61,175,115,127,63,19,242,133,61,47,166,127,63,58,94,86,61,121,205,127,63,231,206,32,61,139,233,127,63,10,113,214,60,99,250,127,63,191,117,86,60,0,0,24,0,48,0,72,0,96,0,8,0,32,0,56,0,80,0,104,0,16,0,40,0,64,0,88,0,112,0,4,0,28,0,52,0,76,0,100,0,12,0,36,0,60,0,84,0,108,0,20,0,44,0,68,0,92,0,116,0,1,0,25,0,49,0,73,0,97,0,9,0,33,0,57,0,81,0,105,0,17,0,41,0,65,0,89,0,113,0,5,0,29,0,53,0,77,0,101,0,13,0,37,0,61,0,85,0,109,0,21,0,45,0,69,0,93,0,117,0,2,0,26,0,50,0,74,0,98,0,10,0,34,0,58,0,82,0,106,0,18,0,42,0,66,0,90,0,114,0,6,0,30,0,54,0,78,0,102,0,14,0,38,0,62,0,86,0,110,0,22,0,46,0,70,0,94,0,118,0,3,0,27,0,51,0,75,0,99,0,11,0,35,0,59,0,83,0,107,0,19,0,43,0,67,0,91,0,115,0,7,0,31,0,55,0,79,0,103,0,15,0,39,0,63,0,87,0,111,0,23,0,47,0,71,0,95,0,119,0,0,0,48,0,96,0,144,0,192,0,16,0,64,0,112,0,160,0,208,0,32,0,80,0,128,0,176,0,224,0,4,0,52,0,100,0,148,0,196,0,20,0,68,0,116,0,164,0,212,0,36,0,84,0,132,0,180,0,228,0,8,0,56,0,104,0,152,0,200,0,24,0,72,0,120,0,168,0,216,0,40,0,88,0,136,0,184,0,232,0,12,0,60,0,108,0,156,0,204,0,28,0,76,0,124,0,172,0,220,0,44,0,92,0,140,0,188,0,236,0,1,0,49,0,97,0,145,0,193,0,17,0,65,0,113,0,161,0,209,0,33,0,81,0,129,0,177,0,225,0,5,0,53,0,101,0,149,0,197,0,21,0,69,0,117,0,165,0,213,0,37,0,85,0,133,0,181,0,229,0,9,0,57,0,105,0,153,0,201,0,25,0,73,0,121,0,169,0,217,0,41,0,89,0,137,0,185,0,233,0,13,0,61,0,109,0,157,0,205,0,29,0,77,0,125,0,173,0,221,0,45,0,93,0,141,0,189,0,237,0,2,0,50,0,98,0,146,0,194,0,18,0,66,0,114,0,162,0,210,0,34,0,82,0,130,0,178,0,226,0,6,0,54,0,102,0,150,0,198,0,22,0,70,0,118,0,166,0,214,0,38,0,86,0,134,0,182,0,230,0,10,0,58,0,106,0,154,0,202,0,26,0,74,0,122,0,170,0,218,0,42,0,90,0,138,0,186,0,234,0,14,0,62,0,110,0,158,0,206,0,30,0,78,0,126,0,174,0,222,0,46,0,94,0,142,0,190,0,238,0,3,0,51,0,99,0,147,0,195,0,19,0,67,0,115,0,163,0,211,0,35,0,83,0,131,0,179,0,227,0,7,0,55,0,103,0,151,0,199,0,23,0,71,0,119,0,167,0,215,0,39,0,87,0,135,0,183,0,231,0,11,0,59,0,107,0,155,0,203,0,27,0,75,0,123,0,171,0,219,0,43,0,91,0,139,0,187,0,235,0,15,0,63,0,111,0,159,0,207,0,31,0,79,0,127,0,175,0,223,0,47,0,95,0,143,0,191,0,239,0,0,0,96,0,192,0,32,1,128,1,32,0,128,0,224,0,64,1,160,1,64,0,160,0,0,1,96,1,192,1,8,0,104,0,200,0,40,1,136,1,40,0,136,0,232,0,72,1,168,1,72,0,168,0,8,1,104,1,200,1,16,0,112,0,208,0,48,1,144,1,48,0,144,0,240,0,80,1,176,1,80,0,176,0,16,1,112,1,208,1,24,0,120,0,216,0,56,1,152,1,56,0,152,0,248,0,88,1,184,1,88,0,184,0,24,1,120,1,216,1,4,0,100,0,196,0,36,1,132,1,36,0,132,0,228,0,68,1,164,1,68,0,164,0,4,1,100,1,196,1,12,0,108,0,204,0,44,1,140,1,44,0,140,0,236,0,76,1,172,1,76,0,172,0,12,1,108,1,204,1,20,0,116,0,212,0,52,1,148,1,52,0,148,0,244,0,84,1,180,1,84,0,180,0,20,1,116,1,212,1,28,0,124,0,220,0,60,1,156,1,60,0,156,0,252,0,92,1,188,1,92,0,188,0,28,1,124,1,220,1,1,0,97,0,193,0,33,1,129,1,33,0,129,0,225,0,65,1,161,1,65,0,161,0,1,1,97,1,193,1,9,0,105,0,201,0,41,1,137,1,41,0,137,0,233,0,73,1,169,1,73,0,169,0,9,1,105,1,201,1,17,0,113,0,209,0,49,1,145,1,49,0,145,0,241,0,81,1,177,1,81,0,177,0,17,1,113,1,209,1,25,0,121,0,217,0,57,1,153,1,57,0,153,0,249,0,89,1,185,1,89,0,185,0,25,1,121,1,217,1,5,0,101,0,197,0,37,1,133,1,37,0,133,0,229,0,69,1,165,1,69,0,165,0,5,1,101,1,197,1,13,0,109,0,205,0,45,1,141,1,45,0,141,0,237,0,77,1,173,1,77,0,173,0,13,1,109,1,205,1,21,0,117,0,213,0,53,1,149,1,53,0,149,0,245,0,85,1,181,1,85,0,181,0,21,1,117,1,213,1,29,0,125,0,221,0,61,1,157,1,61,0,157,0,253,0,93,1,189,1,93,0,189,0,29,1,125,1,221,1,2,0,98,0,194,0,34,1,130,1,34,0,130,0,226,0,66,1,162,1,66,0,162,0,2,1,98,1,194,1,10,0,106,0,202,0,42,1,138,1,42,0,138,0,234,0,74,1,170,1,74,0,170,0,10,1,106,1,202,1,18,0,114,0,210,0,50,1,146,1,50,0,146,0,242,0,82,1,178,1,82,0,178,0,18,1,114,1,210,1,26,0,122,0,218,0,58,1,154,1,58,0,154,0,250,0,90,1,186,1,90,0,186,0,26,1,122,1,218,1,6,0,102,0,198,0,38,1,134,1,38,0,134,0,230,0,70,1,166,1,70,0,166,0,6,1,102,1,198,1,14,0,110,0,206,0,46,1,142,1,46,0,142,0,238,0,78,1,174,1,78,0,174,0,14,1,110,1,206,1,22,0,118,0,214,0,54,1,150,1,54,0,150,0,246,0,86,1,182,1,86,0,182,0,22,1,118,1,214,1,30,0,126,0,222,0,62,1,158,1,62,0,158,0,254,0,94,1,190,1,94,0,190,0,30,1,126,1,222,1,3,0,99,0,195,0,35,1,131,1,35,0,131,0,227,0,67,1,163,1,67,0,163,0,3,1,99,1,195,1,11,0,107,0,203,0,43,1,139,1,43,0,139,0,235,0,75,1,171,1,75,0,171,0,11,1,107,1,203,1,19,0,115,0,211,0,51,1,147,1,51,0,147,0,243,0,83,1,179,1,83,0,179,0,19,1,115,1,211,1,27,0,123,0,219,0,59,1,155,1,59,0,155,0,251,0,91,1,187,1,91,0,187,0,27,1,123,1,219,1,7,0,103,0,199,0,39,1,135,1,39,0,135,0,231],"i8",ALLOC_NONE,Runtime.GLOBAL_BASE+10240);allocate([71,1,167,1,71,0,167,0,7,1,103,1,199,1,15,0,111,0,207,0,47,1,143,1,47,0,143,0,239,0,79,1,175,1,79,0,175,0,15,1,111,1,207,1,23,0,119,0,215,0,55,1,151,1,55,0,151,0,247,0,87,1,183,1,87,0,183,0,23,1,119,1,215,1,31,0,127,0,223,0,63,1,159,1,63,0,159,0,255,0,95,1,191,1,95,0,191,0,31,1,127,1,223,1,0,0,0,0,0,0,0,0,3,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,5,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,5,0,0,0,2,0,0,0,3,0,0,0,2,0,0,0,0,0,206,64,0,0,200,64,0,0,184,64,0,0,170,64,0,0,162,64,0,0,154,64,0,0,144,64,0,0,140,64,0,0,156,64,0,0,150,64,0,0,146,64,0,0,142,64,0,0,156,64,0,0,148,64,0,0,138,64,0,0,144,64,0,0,140,64,0,0,148,64,0,0,152,64,0,0,142,64,0,0,112,64,0,0,112,64,0,0,112,64,0,0,112,64,0,0,112,64,0,0,0,0,72,127,65,129,66,128,65,128,64,128,62,128,64,128,64,128,92,78,92,79,92,78,90,79,116,41,115,40,114,40,132,26,132,26,145,17,161,12,176,10,177,11,24,179,48,138,54,135,54,132,53,134,56,133,55,132,55,132,61,114,70,96,74,88,75,88,87,74,89,66,91,67,100,59,108,50,120,40,122,37,97,43,78,50,83,78,84,81,88,75,86,74,87,71,90,73,93,74,93,74,109,40,114,36,117,34,117,34,143,17,145,18,146,19,162,12,165,10,178,7,189,6,190,8,177,9,23,178,54,115,63,102,66,98,69,99,74,89,71,91,73,91,78,89,86,80,92,66,93,64,102,59,103,60,104,60,117,52,123,44,138,35,133,31,97,38,77,45,61,90,93,60,105,42,107,41,110,45,116,38,113,38,112,38,124,26,132,27,136,19,140,20,155,14,159,16,158,18,170,13,177,10,187,8,192,6,175,9,159,10,21,178,59,110,71,86,75,85,84,83,91,66,88,73,87,72,92,75,98,72,105,58,107,54,115,52,114,55,112,56,129,51,132,40,150,33,140,29,98,35,77,42,42,121,96,66,108,43,111,40,117,44,123,32,120,36,119,33,127,33,134,34,139,21,147,23,152,20,158,25,154,26,166,21,173,16,184,13,184,10,150,13,139,15,22,178,63,114,74,82,84,83,92,82,103,62,96,72,96,67,101,73,107,72,113,55,118,52,125,52,118,52,117,55,135,49,137,39,157,32,145,29,97,33,77,40,0,0,102,63,0,0,76,63,0,0,38,63,0,0,0,63,0,134,107,63,0,20,46,63,0,112,189,62,0,208,76,62,2,1,0,0,0,0,0,0,0,8,13,16,19,21,23,24,26,27,28,29,30,31,32,32,33,34,34,35,36,36,37,37,15,0,0,0,10,0,0,0,5,0,0,0,0,0,0,0,0,15,8,7,4,11,12,3,2,13,10,5,6,9,14,1,0,9,6,3,4,5,8,1,2,7,0,0,0,0,0,0,184,126,154,121,0,0,0,0,154,121,102,102,0,0,0,0,184,126,51,115,0,0,0,0,48,117,0,0,112,23,0,0,32,209,255,255,32,209,255,255,6,0,0,0,4,0,0,0,3,0,0,0,0,0,0,0,0,1,0,0,0,1,0,0,0,0,1,255,1,255,2,254,2,254,3,253,0,1,0,1,255,2,255,2,254,3,254,3,253,7,254,7,0,0,0,0,0,2,255,255,255,0,0,1,1,0,1,0,1,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,1,0,0,0,0,0,255,2,1,0,1,1,0,0,255,255,0,0,0,0,0,0,1,255,0,1,255,0,255,1,254,2,254,254,2,253,2,3,253,252,3,252,4,4,251,5,250,251,6,249,6,5,8,247,0,0,1,0,0,0,0,0,0,0,255,1,0,0,1,255,0,1,255,255,1,255,2,1,255,2,254,254,2,254,2,2,3,253,0,1,0,0,0,0,0,0,1,0,1,0,0,1,255,1,0,0,2,1,255,2,255,255,2,255,2,2,255,3,254,254,254,3,0,1,0,0,1,0,1,255,2,255,2,255,2,3,254,3,254,254,4,4,253,5,253,252,6,252,6,5,251,8,250,251,249,9,251,8,255,6,255,6,252,10,250,10,254,6,255,6,251,10,247,12,253,7,254,7,249,13,16,24,34,0,0,0,0,0,6,0,3,0,7,3,0,1,10,0,2,6,18,10,12,0,4,0,2,0,0,0,9,4,7,4,0,3,12,7,7,0,42,175,213,201,207,255,64,0,17,0,99,255,97,1,16,254,163,0,39,43,189,86,217,255,6,0,91,0,86,255,186,0,23,0,128,252,192,24,216,77,237,255,220,255,102,0,167,255,232,255,72,1,73,252,8,10,37,62,0,0,0,0,0,0,135,199,61,201,64,0,128,0,134,255,36,0,54,1,0,253,72,2,51,36,69,69,12,0,128,0,18,0,114,255,32,1,139,255,159,252,27,16,123,56,104,2,13,200,246,255,39,0,58,0,210,255,172,255,120,0,184,0,197,254,227,253,4,5,4,21,64,35,0,0,0,0,230,62,198,196,243,255,0,0,20,0,26,0,5,0,225,255,213,255,252,255,65,0,90,0,7,0,99,255,8,255,212,255,81,2,47,6,52,10,199,12,228,87,5,197,3,0,242,255,236,255,241,255,2,0,25,0,37,0,25,0,240,255,185,255,149,255,177,255,50,0,36,1,111,2,214,3,8,5,184,5,148,107,103,196,17,0,12,0,8,0,1,0,246,255,234,255,226,255,224,255,234,255,3,0,44,0,100,0,168,0,243,0,61,1,125,1,173,1,199,1,19,245,149,230,89,18,243,41,31,6,84,32,0,0,0,0,189,0,168,253,105,2,103,119,117,0,97,255,210,251,8,116,52,0,221,0,168,246,116,110,252,255,17,2,234,242,229,102,208,255,246,2,140,240,165,93,176,255,137,3,117,239,6,83,157,255,204,3,130,239,102,71,149,255,199,3,139,240,39,59,153,255,128,3,97,242,174,46,165,255,5,3,207,244,94,34,185,255,99,2,161,247,152,22,210,255,169,1,161,250,180,11,0,64,0,0,108,34,0,0,66,15,0,0,18,6,0,0,77,2,0,0,219,0,0,0,237,0,0,0,153,0,0,0,73,0,0,0,30,0,0,0,12,0,0,0,7,0,0,0,0,64,0,0,147,93,0,0,189,112,0,0,237,121,0,0,178,125,0,0,36,127,0,0,0,32,254,31,246,31,234,31,216,31,194,31,168,31,136,31,98,31,58,31,10,31,216,30,160,30,98,30,34,30,220,29,144,29,66,29,238,28,150,28,58,28,216,27,114,27,10,27,156,26,42,26,180,25,58,25,188,24,60,24,182,23,46,23,160,22,16,22,126,21,232,20,78,20,176,19,16,19,110,18,200,17,30,17,116,16,198,15,22,15,100,14,174,13,248,12,64,12,132,11,200,10,10,10,74,9,138,8,198,7,2,7,62,6,120,5,178,4,234,3,34,3,90,2,146,1,202,0,0,0,54,255,110,254,166,253,222,252,22,252,78,251,136,250,194,249,254,248,58,248,118,247,182,246,246,245,56,245,124,244,192,243,8,243,82,242,156,241,234,240,58,240,140,239,226,238,56,238,146,237,240,236,80,236,178,235,24,235,130,234,240,233,96,233,210,232,74,232,196,231,68,231,198,230,76,230,214,229,100,229,246,228,142,228,40,228,198,227,106,227,18,227,190,226,112,226,36,226,222,225,158,225,96,225,40,225,246,224,198,224,158,224,120,224,88,224,62,224,40,224,22,224,10,224,2,224,0,224,0,0,0,0,0,0,179,99,0,0,0,0,0,0,71,56,43,30,21,12,6,0,199,165,144,124,109,96,84,71,61,51,42,32,23,15,8,0,241,225,211,199,187,175,164,153,142,132,123,114,105,96,88,80,72,64,57,50,44,38,33,29,24,20,16,12,9,5,2,0,248,86,0,0,0,87,0,0,16,87,0,0,0,0,0,0,15,131,138,138,155,155,173,173,69,93,115,118,131,138,141,138,150,150,155,150,155,160,166,160,131,128,134,141,141,141,145,145,145,150,155,155,155,155,160,160,160,160,166,166,173,173,182,192,182,192,192,192,205,192,205,224,64,87,0,0,72,87,0,0,88,87,0,0,0,0,0,0,4,6,24,7,5,0,0,2,0,0,12,28,41,13,252,247,15,42,25,14,1,254,62,41,247,246,37,65,252,3,250,4,66,7,248,16,14,38,253,33,13,22,39,23,12,255,36,64,27,250,249,10,55,43,17,1,1,8,1,1,6,245,74,53,247,244,55,76,244,8,253,3,93,27,252,26,39,59,3,248,2,0,77,11,9,248,22,44,250,7,40,9,26,3,9,249,20,101,249,4,3,248,42,26,0,241,33,68,2,23,254,55,46,254,15,3,255,21,16,41,250,27,61,39,5,245,42,88,4,1,254,60,65,6,252,255,251,73,56,1,247,19,94,29,247,0,12,99,6,4,8,237,102,46,243,3,2,13,3,2,9,235,84,72,238,245,46,104,234,8,18,38,48,23,0,240,70,83,235,11,5,245,117,22,248,250,23,117,244,3,3,248,95,28,4,246,15,77,60,241,255,4,124,2,252,3,38,84,24,231,2,13,42,13,31,21,252,56,46,255,255,35,79,243,19,249,65,88,247,242,20,4,81,49,227,20,0,75,3,239,5,247,44,92,248,1,253,22,69,31,250,95,41,244,5,39,67,16,252,1,0,250,120,55,220,243,44,122,4,232,81,5,11,3,7,2,0,9,10,88,136,87,0,0,176,87,0,0,0,88,0,0,0,0,0,0,46,2,90,87,93,91,82,98,109,120,118,12,113,115,117,119,99,59,87,111,63,111,112,80,126,124,125,124,129,121,126,23,132,127,127,127,126,127,122,133,130,134,101,118,119,145,126,86,124,120,123,119,170,173,107,109,176,88,0,0,184,88,0,0,200,88,0,0,0,0,0,0,8,16,32,0,0,0,0,0,12,35,60,83,108,132,157,180,206,228,15,32,55,77,101,125,151,175,201,225,19,42,66,89,114,137,162,184,209,230,12,25,50,72,97,120,147,172,200,223,26,44,69,90,114,135,159,180,205,225,13,22,53,80,106,130,156,180,205,228,15,25,44,64,90,115,142,168,196,222,19,24,62,82,100,120,145,168,190,214,22,31,50,79,103,120,151,170,203,227,21,29,45,65,106,124,150,171,196,224,30,49,75,97,121,142,165,186,209,229,19,25,52,70,93,116,143,166,192,219,26,34,62,75,97,118,145,167,194,217,25,33,56,70,91,113,143,165,196,223,21,34,51,72,97,117,145,171,196,222,20,29,50,67,90,117,144,168,197,221,22,31,48,66,95,117,146,168,196,222,24,33,51,77,116,134,158,180,200,224,21,28,70,87,106,124,149,170,194,217,26,33,53,64,83,117,152,173,204,225,27,34,65,95,108,129,155,174,210,225,20,26,72,99,113,131,154,176,200,219,34,43,61,78,93,114,155,177,205,229,23,29,54,97,124,138,163,179,209,229,30,38,56,89,118,129,158,178,200,231,21,29,49,63,85,111,142,163,193,222,27,48,77,103,133,158,179,196,215,232,29,47,74,99,124,151,176,198,220,237,33,42,61,76,93,121,155,174,207,225,29,53,87,112,136,154,170,188,208,227,24,30,52,84,131,150,166,186,203,229,37,48,64,84,104,118,156,177,201,230,212,178,148,129,108,96,85,82,79,77,61,59,57,56,51,49,48,45,42,41,40,38,36,34,31,30,21,12,10,3,1,0,255,245,244,236,233,225,217,203,190,176,175,161,149,136,125,114,102,91,81,71,60,52,43,35,28,20,19,18,12,11,5,0,179,138,140,148,151,149,153,151,163,116,67,82,59,92,72,100,89,92,0,0,0,0,0,0,16,0,0,0,0,99,66,36,36,34,36,34,34,34,34,83,69,36,52,34,116,102,70,68,68,176,102,68,68,34,65,85,68,84,36,116,141,152,139,170,132,187,184,216,137,132,249,168,185,139,104,102,100,68,68,178,218,185,185,170,244,216,187,187,170,244,187,187,219,138,103,155,184,185,137,116,183,155,152,136,132,217,184,184,170,164,217,171,155,139,244,169,184,185,170,164,216,223,218,138,214,143,188,218,168,244,141,136,155,170,168,138,220,219,139,164,219,202,216,137,168,186,246,185,139,116,185,219,185,138,100,100,134,100,102,34,68,68,100,68,168,203,221,218,168,167,154,136,104,70,164,246,171,137,139,137,155,218,219,139,255,254,253,238,14,3,2,1,0,255,254,252,218,35,3,2,1,0,255,254,250,208,59,4,2,1,0,255,254,246,194,71,10,2,1,0,255,252,236,183,82,8,2,1,0,255,252,235,180,90,17,2,1,0,255,248,224,171,97,30,4,1,0,255,254,236,173,95,37,7,1,0,255,255,255,131,6,145,255,255,255,255,255,236,93,15,96,255,255,255,255,255,194,83,25,71,221,255,255,255,255,162,73,34,66,162,255,255,255,210,126,73,43,57,173,255,255,255,201,125,71,48,58,130,255,255,255,166,110,73,57,62,104,210,255,255,251,123,65,55,68,100,171,255,250,0,3,0,6,0,3,0,3,0,3,0,4,0,3,0,3,0,3,0,205,1,0,0,32,0,10,0,20,46,100,1,0,89,0,0,64,90,0,0,128,90,0,0,152,90,0,0,56,91,0,0,128,91,0,0,200,91,0,0,0,0,0,0,7,23,38,54,69,85,100,116,131,147,162,178,193,208,223,239,13,25,41,55,69,83,98,112,127,142,157,171,187,203,220,236,15,21,34,51,61,78,92,106,126,136,152,167,185,205,225,240,10,21,36,50,63,79,95,110,126,141,157,173,189,205,221,237,17,20,37,51,59,78,89,107,123,134,150,164,184,205,224,240,10,15,32,51,67,81,96,112,129,142,158,173,189,204,220,236,8,21,37,51,65,79,98,113,126,138,155,168,179,192,209,218,12,15,34,55,63,78,87,108,118,131,148,167,185,203,219,236,16,19,32,36,56,79,91,108,118,136,154,171,186,204,220,237,11,28,43,58,74,89,105,120,135,150,165,180,196,211,226,241,6,16,33,46,60,75,92,107,123,137,156,169,185,199,214,225,11,19,30,44,57,74,89,105,121,135,152,169,186,202,218,234,12,19,29,46,57,71,88,100,120,132,148,165,182,199,216,233,17,23,35,46,56,77,92,106,123,134,152,167,185,204,222,237,14,17,45,53,63,75,89,107,115,132,151,171,188,206,221,240,9,16,29,40,56,71,88,103,119,137,154,171,189,205,222,237,16,19,36,48,57,76,87,105,118,132,150,167,185,202,218,236,12,17,29,54,71,81,94,104,126,136,149,164,182,201,221,237,15,28,47,62,79,97,115,129,142,155,168,180,194,208,223,238,8,14,30,45,62,78,94,111,127,143,159,175,192,207,223,239,17,30,49,62,79,92,107,119,132,145,160,174,190,204,220,235,14,19,36,45,61,76,91,108,121,138,154,172,189,205,222,238,12,18,31,45,60,76,91,107,123,138,154,171,187,204,221,236,13,17,31,43,53,70,83,103,114,131,149,167,185,203,220,237,17,22,35,42,58,78,93,110,125,139,155,170,188,206,224,240,8,15,34,50,67,83,99,115,131,146,162,178,193,209,224,239,13,16,41,66,73,86,95,111,128,137,150,163,183,206,225,241,17,25,37,52,63,75,92,102,119,132,144,160,175,191,212,231,19,31,49,65,83,100,117,133,147,161,174,187,200,213,227,242,18,31,52,68,88,103,117,126,138,149,163,177,192,207,223,239,16,29,47,61,76,90,106,119,133,147,161,176,193,209,224,240,15,21,35,50,61,73,86,97,110,119,129,141,175,198,218,237,225,204,201,184,183,175,158,154,153,135,119,115,113,110,109,99,98,95,79,68,52,50,48,45,43,32,31,27,18,10,3,0,255,251,235,230,212,201,196,182,167,166,163,151,138,124,110,104,90,78,76,70,69,57,45,34,24,21,11,6,5,4,3,0,175,148,160,176,178,173,174,164,177,174,196,182,198,192,182,68,62,66,60,72,117,85,90,118,136,151,142,160,142,155,0,0,0,0,0,0,0,0,0,1,100,102,102,68,68,36,34,96,164,107,158,185,180,185,139,102,64,66,36,34,34,0,1,32,208,139,141,191,152,185,155,104,96,171,104,166,102,102,102,132,1,0,0,0,0,16,16,0,80,109,78,107,185,139,103,101,208,212,141,139,173,153,123,103,36,0,0,0,0,0,0,1,48,0,0,0,0,0,0,32,68,135,123,119,119,103,69,98,68,103,120,118,118,102,71,98,134,136,157,184,182,153,139,134,208,168,248,75,189,143,121,107,32,49,34,34,34,0,17,2,210,235,139,123,185,137,105,134,98,135,104,182,100,183,171,134,100,70,68,70,66,66,34,131,64,166,102,68,36,2,1,0,134,166,102,68,34,34,66,132,212,246,158,139,107,107,87,102,100,219,125,122,137,118,103,132,114,135,137,105,171,106,50,34,164,214,141,143,185,151,121,103,192,34,0,0,0,0,0,1,208,109,74,187,134,249,159,137,102,110,154,118,87,101,119,101,0,2,0,36,36,66,68,35,96,164,102,100,36,0,2,33,167,138,174,102,100,84,2,2,100,107,120,119,36,197,24,0,255,254,253,244,12,3,2,1,0,255,254,252,224,38,3,2,1,0,255,254,251,209,57,4,2,1,0,255,254,244,195,69,4,2,1,0,255,251,232,184,84,7,2,1,0,255,254,240,186,86,14,2,1,0,255,254,239,178,91,30,5,1,0,255,248,227,177,100,19,2,1,0,255,255,255,156,4,154,255,255,255,255,255,227,102,15,92,255,255,255,255,255,213,83,24,72,236,255,255,255,255,150,76,33,63,214,255,255,255,190,121,77,43,55,185,255,255,255,245,137,71,43,59,139,255,255,255,255,131,66,50,66,107,194,255,255,166,116,76,55,53,125,255,255,100,0,3,0,40,0,3,0,3,0,3,0,5,0,14,0,14,0,10,0,11,0,3,0,8,0,9,0,7,0,3,0,91,1,0,0,0,0,0,0,32,0,16,0,102,38,171,1,8,92,0,0,8,94,0,0,72,94,0,0,104,94,0,0,104,95,0,0,176,95,0,0,248,95,0,0,0,0,0,0,224,112,44,15,3,2,1,0,254,237,192,132,70,23,4,0,255,252,226,155,61,11,2,0,250,245,234,203,71,50,42,38,35,33,31,29,28,27,26,25,24,23,22,21,20,19,18,17,16,15,14,13,12,11,10,9,8,7,6,5,4,3,2,1,0,0,0,0,0,0,0,0,0,0,0,0,64,31,0,0,184,36,0,0,236,44,0,0,188,52,0,0,92,68,0,0,168,97,0,0,128,56,1,0,0,0,0,0,40,35,0,0,224,46,0,0,164,56,0,0,68,72,0,0,180,95,0,0,172,138,0,0,128,56,1,0,0,0,0,0,4,41,0,0,176,54,0,0,104,66,0,0,252,83,0,0,84,111,0,0,16,164,0,0,128,56,1,0,18,0,29,0,38,0,40,0,46,0,52,0,62,0,84,0,92,202,190,216,182,223,154,226,156,230,120,236,122,244,204,252,52,3,134,11,136,19,100,25,102,29,74,32,66,39,164,53,249,247,246,245,244,234,210,202,201,200,197,174,82,59,56,55,54,46,22,12,11,10,9,7,0,0,0,0,0,0,0,0,64,0,0,0,0,0,0,0,203,150,0,0,0,0,0,0,215,195,166,125,110,82,0,0,72,97,0,0,80,97,0,0,120,0,0,0,0,0,0,0,128,64,0,0,0,0,0,0,232,158,10,0,0,0,0,0,230,0,0,0,0,0,0,0,243,221,192,181,0,0,0,0,100,0,240,0,32,0,100,0,205,60,0,48,0,32,0,0,171,85,0,0,0,0,0,0,192,128,64,0,0,0,0,0,205,154,102,51,0,0,0,0,213,171,128,85,43,0,0,0,224,192,160,128,96,64,32,0,100,40,16,7,3,1,0,0,10,103,242,14,86,205,228,29,10,103,242,14,117,82,130,12,89,154,4,25,117,82,130,12,70,17,49,10,237,3,98,20,70,17,49,10,218,2,215,7,249,198,173,15,218,2,215,7,34,182,82,5,218,250,164,10,34,182,82,5,0,0,0,0,70,243,46,30,43,227,75,14,31,102,128,24,28,44,29,10,218,97,72,18,237,156,244,6,236,48,19,11,227,144,165,4,237,164,29,2,10,223,107,3,253,250,244,233,212,182,150,131,120,110,98,85,72,60,49,40,32,25,19,15,13,11,9,8,7,6,5,4,3,2,1,0,210,208,206,203,199,193,183,168,142,104,74,52,37,27,20,14,10,6,4,2,0,0,0,0,223,201,183,167,152,138,124,111,98,88,79,70,62,56,50,44,39,35,31,27,24,21,18,16,14,12,10,8,6,4,3,2,1,0,0,0,0,0,0,0,188,176,155,138,119,97,67,43,26,10,0,0,0,0,0,0,165,119,80,61,47,35,27,20,14,9,4,0,0,0,0,0,113,63,0,0,0,0,0,0,125,51,26,18,15,12,11,10,9,8,7,6,5,4,3,2,1,0,198,105,45,22,15,12,11,10,9,8,7,6,5,4,3,2,1,0,213,162,116,83,59,43,32,24,18,15,12,9,7,6,5,3,2,0,239,187,116,59,28,16,11,10,9,8,7,6,5,4,3,2,1,0,250,229,188,135,86,51,30,19,13,10,8,6,5,4,3,2,1,0,249,235,213,185,156,128,103,83,66,53,42,33,26,21,17,13,10,0,254,249,235,206,164,118,77,46,27,16,10,7,5,4,3,2,1,0,255,253,249,239,220,191,156,119,85,57,37,23,15,10,6,4,2,0,255,253,251,246,237,223,203,179,152,124,98,75,55,40,29,21,15,0,255,254,253,247,220,162,106,67,42,28,18,12,9,6,4,3,2,0,0,0,0,0,31,57,107,160,205,205,255,255,255,255,255,255,255,255,255,255,255,255,69,47,67,111,166,205,255,255,255,255,255,255,255,255,255,255,255,255,82,74,79,95,109,128,145,160,173,205,205,205,224,255,255,224,255,224,125,74,59,69,97,141,182,255,255,255,255,255,255,255,255,255,255,255,173,115,85,73,76,92,115,145,173,205,224,224,255,255,255,255,255,255,166,134,113,102,101,102,107,118,125,138,145,155,166,182,192,192,205,150,224,182,134,101,83,79,85,97,120,145,173,205,224,255,255,255,255,255,255,224,192,150,120,101,92,89,93,102,118,134,160,182,192,224,224,224,255,224,224,182,155,134,118,109,104,102,106,111,118,131,145,160,173,131,0,0,0,0,0,0,241,190,178,132,87,74,41,14,0,223,193,157,140,106,57,39,18,0,0,0,0,0,0,0,131,74,141,79,80,138,95,104,134,95,99,91,125,93,76,123,115,123,0,0,0,0,0,0,128,0,214,42,0,235,128,21,0,244,184,72,11,0,248,214,128,42,7,0,248,225,170,80,25,5,0,251,236,198,126,54,18,3,0,250,238,211,159,82,35,15,5,0,250,231,203,168,128,88,53,25,6,0,252,238,216,185,148,108,71,40,18,4,0,253,243,225,199,166,128,90,57,31,13,3,0,254,246,233,212,183,147,109,73,44,23,10,2,0,255,250,240,223,198,166,128,90,58,33,16,6,1,0,255,251,244,231,210,181,146,110,75,46,25,12,5,1,0,255,253,248,238,221,196,164,128,92,60,35,18,8,3,1,0,255,253,249,242,229,208,180,146,110,76,48,27,14,7,3,1,0,129,0,207,50,0,236,129,20,0,245,185,72,10,0,249,213,129,42,6,0,250,226,169,87,27,4,0,251,233,194,130,62,20,4,0,250,236,207,160,99,47,17,3,0,255,240,217,182,131,81,41,11,1,0,255,254,233,201,159,107,61,20,2,1,0,255,249,233,206,170,128,86,50,23,7,1,0,255,250,238,217,186,148,108,70,39,18,6,1,0,255,252,243,226,200,166,128,90,56,30,13,4,1,0,255,252,245,231,209,180,146,110,76,47,25,11,4,1,0,255,253,248,237,219,194,163,128,93,62,37,19,8,3,1,0,255,254,250,241,226,205,177,145,111,79,51,30,15,6,2,1,0,129,0,203,54,0,234,129,23,0,245,184,73,10,0,250,215,129,41,5,0,252,232,173,86,24,3,0,253,240,200,129,56,15,2,0,253,244,217,164,94,38,10,1,0,253,245,226,189,132,71,27,7,1,0,253,246,231,203,159,105,56,23,6,1,0,255,248,235,213,179,133,85,47,19,5,1,0,255,254,243,221,194,159,117,70,37,12,2,1,0,255,254,248,234,208,171,128,85,48,22,8,2,1,0,255,254,250,240,220,189,149,107,67,36,16,6,2,1,0,255,254,251,243,227,201,166,128,90,55,29,13,5,2,1,0,255,254,252,246,234,213,183,147,109,73,43,22,10,4,2,1,0,130,0,200,58,0,231,130,26,0,244,184,76,12,0,249,214,130,43,6,0,252,232,173,87,24,3,0,253,241,203,131,56,14,2,0,254,246,221,167,94,35,8,1,0,254,249,232,193,130,65,23,5,1,0,255,251,239,211,162,99,45,15,4,1,0,255,251,243,223,186,131,74,33,11,3,1,0,255,252,245,230,202,158,105,57,24,8,2,1,0,255,253,247,235,214,179,132,84,44,19,7,2,1,0,255,254,250,240,223,196,159,112,69,36,15,6,2,1,0,255,254,253,245,231,209,176,136,93,55,27,11,3,2,1,0,255,254,253,252,239,221,194,158,117,76,42,18,4,3,2,1,0,0,0,2,5,9,14,20,27,35,44,54,65,77,90,104,119,135,0,0,0,0,0,0,0,254,49,67,77,82,93,99,198,11,18,24,31,36,45,255,46,66,78,87,94,104,208,14,21,32,42,51,66,255,94,104,109,112,115,118,248,53,69,80,88,95,102,0,0,0,0,0,0,230,90,52,56,119,78,51,57,211,217,201,57,146,145,51,58,204,96,140,58,97,251,201,58,153,126,9,59,203,128,51,59,213,37,99,59,119,46,140,59,168,138,169,59,69,184,201,59,135,166,236,59,232,46,9,60,174,102,29,60,247,2,51,60,147,255,73,60,79,88,98,60,94,17,124,60,46,145,139,60,189,199,153,60,92,172,168,60,243,60,184,60,129,121,200,60,238,95,217,60,57,240,234,60,99,42,253,60,53,7,8,61,16,204,17,61,205,228,27,61,97,80,38,61,203,14,49,61,0,31,60,61,254,128,71,61,198,52,83,61,63,56,95,61,105,139,107,61,69,46,120,61,105,144,130,61,123,48,137,61,224,247,143,61,138,229,150,61,123,249,157,61,177,51,165,61,33,147,172,61,80,24,180,61,51,194,187,61,79,145,195,61,18,132,203,61,2,155,211,61,31,214,219,61,215,51,228,61,175,180,236,61,33,88,245,61,168,29,254,61,161,130,3,62,242,6,8,62,199,155,12,62,221,64,17,62,52,246,21,62,69,187,26,62,17,144,31,62,84,116,36,62,203,103,41,62,51,106,46,62,141,123,51,62,82,155,56,62,197,201,61,62,28,6,67,62,89,80,72,62,122,168,77,62,183,13,83,62,82,128,88,62,8,0,94,62,84,140,99,62,242,36,105,62,37,202,110,62,36,123,116,62,172,55,122,62,0,0,128,62,171,233,130,62,249,216,133,62,133,205,136,62,80,199,139,62,55,198,142,62,247,201,145,62,179,210,148,62,38,224,151,62,15,242,154,62,108,8,158,62,28,35,161,62,255,65,164,62,208,100,167,62,177,139,170,62,28,182,173,62,84,228,176,62,211,21,180,62,186,74,183,62,232,130,186,62,249,189,189,62,13,252,192,62,226,60,196,62,86,128,199,62,71,198,202,62,149,14,206,62,251,88,209,62,122,165,212,62,241,243,215,62,28,68,219,62,217,149,222,62,8,233,225,62,167,61,229,62,83,147,232,62,12,234,235,62,175,65,239,62,28,154,242,62,14,243,245,62,136,76,249,62,34,166,252,62,0,0,0,63,239,172,1,63,188,89,3,63,121,6,5,63,242,178,6,63,41,95,8,63,250,10,10,63,86,182,11,63,44,97,13,63,124,11,15,63,19,181,16,63,242,93,18,63,8,6,20,63,67,173,21,63,130,83,23,63,182,248,24,63,220,156,26,63,213,63,28,63,143,225,29,63,249,129,31,63,4,33,33,63,140,190,34,63,163,90,36,63,23,245,37,63,214,141,39,63,242,36,41,63,40,186,42,63,152,77,44,63,1,223,45,63,114,110,47,63,202,251,48,63,249,134,50,63,237,15,52,63,167,150,53,63,4,27,55,63,229,156,56,63,88,28,58,63,61,153,59,63,131,19,61,63,42,139,62,63,0,0,64,63,21,114,65,63,55,225,66,63,119,77,68,63,195,182,69,63,235,28,71,63,254,127,72,63,236,223,73,63,146,60,75,63,225,149,76,63,234,235,77,63,121,62,79,63,143,141,80,63,43,217,81,63,29,33,83,63,115,101,84,63,13,166,85,63,235,226,86,63,252,27,88,63,47,81,89,63,115,130,90,63,201,175,91,63,14,217,92,63,67,254,93,63,88,31,95,63,75,60,96,63,252,84,97,63,106,105,98,63,133,121,99,63,60,133,100,63,160,140,101,63,126,143,102,63,214,141,103,63,186,135,104,63,246,124,105,63,156,109,106,63,138,89,107,63,209,64,108,63,79,35,109,63,4,1,110,63,241,217,110,63,243,173,111,63,28,125,112,63,73,71,113,63,124,12,114,63,180,204,114,63,240,135,115,63,16,62,116,63,19,239,116,63,250,154,117,63,179,65,118,63,63,227,118,63,141,127,119,63,173,22,120,63,126,168,120,63,1,53,121,63,52,188,121,63,24,62,122,63,157,186,122,63,194,49,123,63,119,163,123,63,187,15,124,63,159,118,124,63,2,216,124,63,244,51,125,63,101,138,125,63,68,219,125,63,179,38,126,63,143,108,126,63,235,172,126,63,163,231,126,63,218,28,127,63,127,76,127,63,129,118,127,63,2,155,127,63,208,185,127,63,28,211,127,63,197,230,127,63,203,244,127,63,47,253,127,63,0,0,128,63,2,0,0,0,4,0,0,0,6,0,0,0,8,0,0,0,10,0,0,0,12,0,0,0,14,0,0,0,16,0,0,0,20,0,0,0,24,0,0,0,28,0,0,0,32,0,0,0,40,0,0,0,48,0,0,0,56,0,0,0,68,0,0,0,80,0,0,0,96,0,0,0,120,0,0,0,0,0,0,0,1,0,0,0,2,0,0,0,4,0,0,0,6,0,0,0,8,0,0,0,10,0,0,0,12,0,0,0,14,0,0,0,16,0,0,0,20,0,0,0,24,0,0,0,28,0,0,0,32,0,0,0,40,0,0,0,48,0,0,0,56,0,0,0,68,0,0,0,80,0,0,0,96,0,0,0,120,0,0,0,160,0,0,0,200,0,0,0,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,0,0,128,62,208,37,180,62,151,57,173,62,9,165,159,62,250,237,139,62,205,172,101,62,248,169,42,62,52,48,210,61,90,241,13,61,90,241,13,189,52,48,210,189,248,169,42,190,205,172,101,190,250,237,139,190,9,165,159,190,151,57,173,190,208,37,180,190,135,138,177,62,27,131,150,62,96,35,73,62,196,66,141,61,196,66,141,189,96,35,73,190,27,131,150,190,135,138,177,190,135,138,177,190,27,131,150,190,96,35,73,190,196,66,141,189,196,66,141,61,96,35,73,62,27,131,150,62,135,138,177,62,151,57,173,62,205,172,101,62,90,241,13,61,248,169,42,190,9,165,159,190,208,37,180,190,250,237,139,190,52,48,210,189,52,48,210,61,250,237,139,62,208,37,180,62,9,165,159,62,248,169,42,62,90,241,13,189,205,172,101,190,151,57,173,190,125,61,167,62,210,139,10,62,210,139,10,190,125,61,167,190,125,61,167,190,210,139,10,190,210,139,10,62,125,61,167,62,125,61,167,62,210,139,10,62,210,139,10,190,125,61,167,190,125,61,167,190,210,139,10,190,210,139,10,62,125,61,167,62,9,165,159,62,90,241,13,61,250,237,139,190,151,57,173,190,52,48,210,189,205,172,101,62,208,37,180,62,248,169,42,62,248,169,42,190,208,37,180,190,205,172,101,190,52,48,210,61,151,57,173,62,250,237,139,62,90,241,13,189,9,165,159,190,27,131,150,62,196,66,141,189,135,138,177,190,96,35,73,190,96,35,73,62,135,138,177,62,196,66,141,61,27,131,150,190,27,131,150,190,196,66,141,61,135,138,177,62,96,35,73,62,96,35,73,190,135,138,177,190,196,66,141,189,27,131,150,62,250,237,139,62,248,169,42,190,151,57,173,190,90,241,13,61,208,37,180,62,52,48,210,61,9,165,159,190,205,172,101,190,205,172,101,62,9,165,159,62,52,48,210,189,208,37,180,190,90,241,13,189,151,57,173,62,248,169,42,62,250,237,139,190,0,0,0,0,5,193,35,61,233,125,163,61,37,150,244,61,226,116,34,62,172,28,74,62,221,37,113,62,52,186,139,62,180,119,158,62,228,191,176,62,173,136,194,62,37,201,211,62,24,122,228,62,24,149,244,62,200,10,2,63,28,124,9,63,73,157,16,63,202,109,23,63,192,237,29,63,159,29,36,63,84,254,41,63,46,145,47,63,224,215,52,63,99,212,57,63,240,136,62,63,211,247,66,63,171,35,71,63,23,15,75,63,216,188,78,63,173,47,82,63,106,106,85,63,206,111,88,63,154,66,91,63,142,229,93,63,75,91,96,63,110,166,98,63,100,201,100,63,155,198,102,63,111,160,104,63,247,88,106,63,128,242,107,63,223,110,109,63,11,208,110,63,202,23,112,63,224,71,113,63,225,97,114,63,77,103,115,63,150,89,116,63,12,58,117,63,255,9,118,63,138,202,118,63,187,124,119,63,192,33,120,63,98,186,120,63,157,71,121,63,75,202,121,63,36,67,122,63,242,178,122,63,59,26,123,63,200,121,123,63,32,210,123,63,200,35,124,63,55,111,124,63,242,180,124,63,94,245,124,63,224,48,125,63,236,103,125,63,183,154,125,63,180,201,125,63,6,245,125,63,17,29,126,63,24,66,126,63,78,100,126,63,211,131,126,63,253,160,126,63,237,187,126,63,195,212,126,63,179,235,126,63,239,0,127,63,135,20,127,63,141,38,127,63,67,55,127,63,170,70,127,63,227,84,127,63,15,98,127,63,47,110,127,63,100,121,127,63,190,131,127,63,63,141,127,63,24,150,127,63,56,158,127,63,194,165,127,63,163,172,127,63,16,179,127,63,245,184,127,63,119,190,127,63,114,195,127,63,25,200,127,63,108,204,127,63,91,208,127,63,6,212,127,63,111,215,127,63,131,218,127,63,102,221,127,63,21,224,127,63,130,226,127,63,205,228,127,63,230,230,127,63,205,232,127,63,146,234,127,63,70,236,127,63,200,237,127,63,40,239,127,63,120,240,127,63,166,241,127,63,195,242,127,63,191,243,127,63,186,244,127,63,148,245,127,63,94,246,127,63,39,247,127,63,207,247,127,63,119,248,127,63,253,248,127,63,148,249,127,63,9,250,127,63,127,250,127,63,244,250,127,63,89,251,127,63,173,251,127,63,1,252,127,63,84,252,127,63,152,252,127,63,219,252,127,63,30,253,127,63,80,253,127,63,130,253,127,63,181,253,127,63,231,253,127,63,9,254,127,63,59,254,127,63,93,254,127,63,126,254,127,63,143,254,127,63,176,254,127,63,210,254,127,63,227,254,127,63,244,254,127,63,21,255,127,63,38,255,127,63,55,255,127,63,71,255,127,63,88,255,127,63,88,255,127,63,105,255,127,63,122,255,127,63,122,255,127,63,139,255,127,63,155,255,127,63,155,255,127,63,155,255,127,63,172,255,127,63,172,255,127,63,189,255,127,63,189,255,127,63,189,255,127,63,206,255,127,63,206,255,127,63,206,255,127,63,206,255,127,63,206,255,127,63,222,255,127,63,222,255,127,63,222,255,127,63,222,255,127,63,222,255,127,63,222,255,127,63,239,255,127,63,239,255,127,63,239,255,127,63,239,255,127,63,239,255,127,63,239,255,127,63,239,255,127,63,239,255,127,63,239,255,127,63,239,255,127,63,239,255,127,63,239,255,127,63,239,255,127,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,128,63,0,0,0,0,14,190,192,189,172,31,155,190,149,130,26,191,150,149,70,190,84,114,62,190,146,3,26,191,6,152,62,189,2,160,234,189,182,43,212,189,185,114,30,191,106,190,162,190,28,7,46,190,107,243,143,189,90,158,23,62,33,173,209,62,10,102,12,63,125,60,188,62,20,33,253,190,143,169,67,63,8,119,235,191,10,243,46,62,117,147,76,65,80,83,139,191,108,236,162,191,181,21,130,193,28,107,193,65,162,98,178,192,255,231,48,190,47,79,39,190,158,206,101,190,255,87,194,189,155,60,149,189,203,248,135,190,44,97,205,189,203,33,83,189,64,166,21,190,238,35,247,189,160,253,56,190,219,167,3,62,233,95,226,62,213,202,252,190,29,203,43,62,231,168,83,62,1,79,74,190,247,3,214,62,71,119,192,63,173,249,69,191,64,164,32,193,43,194,205,62,192,178,62,64,201,118,115,65,100,204,241,191,39,165,152,191,23,204,233,60,134,193,132,187,201,232,144,61,84,72,7,60,154,231,189,189,103,71,42,188,59,137,140,187,159,122,160,187,88,90,145,189,85,196,39,187,169,11,34,61,177,219,103,62,241,54,5,61,52,17,38,62,170,10,205,189,86,185,248,62,108,4,2,62,86,102,146,62,228,254,126,60,106,251,215,61,159,142,67,64,136,70,147,63,57,40,129,191,71,90,234,191,139,84,84,64,210,53,91,192,13,253,243,189,232,39,38,189,25,31,226,59,241,90,147,60,171,170,28,189,237,238,195,59,5,106,150,188,246,141,249,58,37,201,19,190,106,115,50,189,210,214,129,58,161,100,98,62,158,210,17,62,128,215,247,62,221,12,207,62,124,15,3,63,250,242,114,190,55,139,119,62,47,110,179,62,183,13,51,191,136,99,38,65,18,165,41,64,83,208,27,192,53,7,134,192,125,150,135,63,60,247,218,63,12,212,218,59,186,186,147,189,191,192,34,189,69,144,20,61,38,112,235,189,208,37,193,188,210,156,6,60,124,58,104,188,114,11,7,189,31,26,17,189,171,204,53,59,154,208,148,190,218,230,146,191,140,104,163,190,89,193,47,191,163,233,188,62,64,50,245,62,253,245,58,62,163,119,210,190,8,144,97,63,39,107,147,192,33,31,188,63,224,243,171,62,161,214,232,191,245,91,241,193,8,172,177,64,252,177,255,58,106,21,253,189,37,245,148,189,41,102,131,189,252,233,90,189,35,134,221,189,20,249,191,189,43,237,142,189,75,171,225,188,167,236,68,190,122,110,225,189,172,28,146,62,105,170,207,190,7,203,189,61,35,101,147,190,201,231,89,191,252,194,203,189,212,95,111,190,111,129,164,191,13,108,145,63,155,201,71,64,187,39,143,189,66,91,238,191,113,201,41,64,120,238,233,192,26,168,28,64,135,138,146,186,54,152,129,189,127,33,26,189,138,114,25,190,229,100,18,62,247,202,60,62,113,202,252,61,117,220,154,61,70,65,240,61,200,40,191,61,71,193,141,61,22,144,172,61,175,81,144,61,27,166,113,61,173,246,192,61,61,209,229,190,92,47,215,60,148,107,138,62,106,78,134,190,98,186,48,62,49,37,0,64,133,9,35,190,99,96,29,61,26,81,35,65,182,248,132,64,7,206,21,192,120,99,97,189,79,18,30,60,98,186,16,190,8,223,224,60,187,222,12,61,136,166,71,189,97,152,194,61,35,245,253,187,158,146,24,189,185,155,179,187,187,236,135,189,45,182,196,61,230,206,76,190,12,24,41,189,251,87,22,63,48,68,83,61,142,172,172,62,218,226,90,63,93,26,43,63,202,82,235,189,178,75,104,192,37,89,239,190,177,164,92,190,57,98,39,64,145,238,207,62,180,142,174,191,203,61,46,61,20,5,250,61,210,98,191,61,67,4,252,61,160,165,11,61,155,226,17,190,245,130,15,61,15,250,72,189,55,41,150,61,113,52,108,61,83,235,253,61,185,215,83,189,147,139,129,190,69,47,23,63,113,89,21,62,238,95,161,62,207,217,98,62,177,168,24,190,79,89,93,62,127,251,178,190,253,135,196,65,161,131,126,191,11,66,29,63,242,82,150,193,27,76,53,192,69,128,55,191,84,196,177,190,253,130,245,62,128,238,123,190,215,96,155,61,137,150,12,62,211,19,54,190,185,51,243,61,46,253,141,186,175,7,115,190,129,34,182,62,33,7,5,190,218,78,96,189,101,28,163,190,21,171,166,190,107,211,56,62,171,31,128,189,183,155,16,62,40,41,176,62,24,207,192,62,95,126,23,191,102,247,186,64,170,241,194,190,46,56,99,62,239,172,181,191,48,108,229,201,122,170,171,63,218,31,232,60,27,113,55,189,162,59,173,188,127,121,210,188,9,192,100,60,236,86,170,60,101,102,48,188,198,207,53,60,202,13,112,61,62,180,207,188,178,134,6,189,121,35,243,61,78,38,94,190,247,62,21,62,230,93,245,61,106,111,187,189,198,21,247,189,41,83,161,189,106,23,19,190,134,89,24,191,188,116,147,191,198,109,160,191,181,224,149,191,42,227,138,64,64,26,110,201,249,102,175,191,204,76,36,189,13,168,87,62,141,239,11,190,159,57,11,62,64,87,86,189,28,28,54,61,199,207,107,60,239,56,135,59,170,27,158,188,226,177,95,62,162,178,225,189,236,163,1,192,165,17,107,63,28,8,29,192,134,3,153,63,184,86,123,189,48,18,246,191,186,192,157,62,172,202,254,62,42,144,105,63,102,75,86,62,147,24,22,192,95,94,12,64,39,20,207,192,144,78,217,63,169,161,57,191,112,218,66,60,77,206,26,61,109,235,98,61,109,130,185,60,243,67,144,189,93,3,246,188,182,124,73,60,72,233,136,187,62,158,140,189,125,64,0,61,219,50,32,61,194,108,186,62,242,165,193,189,126,80,188,60,194,81,50,190,228,218,168,62,44,239,234,61,112,182,153,62,62,33,219,61,18,136,7,62,8,148,185,64,125,118,104,63,80,195,103,191,88,202,86,192,248,56,67,62,207,161,60,62,50,116,44,191,208,94,109,62,213,29,112,189,65,74,108,62,216,101,224,190,240,193,123,62,23,72,48,190,182,123,179,61,121,115,56,191,85,106,38,62,85,187,139,60,143,114,208,61,117,230,198,62,213,38,170,63,2,241,138,63,108,177,111,191,51,167,23,192,66,9,215,192,144,102,92,192,241,215,8,64,116,181,99,65,82,68,157,64,20,203,69,192,16,18,27,193,252,170,68,191,164,228,229,63,75,35,97,61,17,82,39,62,16,59,163,61,253,223,12,61,211,175,99,189,237,178,165,187,217,102,153,60,110,201,5,61,34,162,189,60,175,119,31,62,154,15,67,61,75,120,130,190,151,255,204,63,210,28,77,191,119,132,35,64,65,213,60,63,19,102,174,191,221,9,50,191,71,90,28,192,62,174,221,191,131,250,124,64,205,1,242,63,101,224,248,62,75,89,53,193,128,147,112,74,249,75,195,190,126,29,248,61,94,44,104,191,249,20,60,64,51,196,209,63,231,255,97,63,2,213,95,63,45,207,155,63,46,226,95,191,166,182,164,62,93,249,72,63,160,81,114,63,134,55,19,191,62,203,93,192,34,137,98,63,173,62,189,61,144,131,30,193,116,93,200,62,10,242,35,62,170,43,3,192,240,167,132,64,210,22,140,61,58,60,20,190,123,16,146,190,69,44,194,62,116,70,148,191,167,29,227,188,154,153,29,193,16,93,154,192,51,167,109,64,139,224,119,64,26,163,97,64,248,42,0,0,232,3,0,0,176,54,0,0,232,3,0,0,8,82,0,0,208,7,0,0,96,109,0,0,208,7,0,0,224,46,0,0,232,3,0,0,80,70,0,0,208,7,0,0,8,82,0,0,208,7,0,0,48,117,0,0,208,7,0,0,248,42,0,0,232,3,0,0,176,54,0,0,232,3,0,0,104,66,0,0,232,3,0,0,8,82,0,0,208,7,0,0,224,46,0,0,232,3,0,0,152,58,0,0,232,3,0,0,80,70,0,0,208,7,0,0,240,85,0,0,208,7],"i8",ALLOC_NONE,Runtime.GLOBAL_BASE+20480);var tempDoublePtr=Runtime.alignMemory(allocate(12,"i8",ALLOC_STATIC),8);assert(tempDoublePtr%8==0);function copyTempFloat(ptr){HEAP8[tempDoublePtr]=HEAP8[ptr];HEAP8[tempDoublePtr+1]=HEAP8[ptr+1];HEAP8[tempDoublePtr+2]=HEAP8[ptr+2];HEAP8[tempDoublePtr+3]=HEAP8[ptr+3];}function copyTempDouble(ptr){HEAP8[tempDoublePtr]=HEAP8[ptr];HEAP8[tempDoublePtr+1]=HEAP8[ptr+1];HEAP8[tempDoublePtr+2]=HEAP8[ptr+2];HEAP8[tempDoublePtr+3]=HEAP8[ptr+3];HEAP8[tempDoublePtr+4]=HEAP8[ptr+4];HEAP8[tempDoublePtr+5]=HEAP8[ptr+5];HEAP8[tempDoublePtr+6]=HEAP8[ptr+6];HEAP8[tempDoublePtr+7]=HEAP8[ptr+7];}Module["_bitshift64Ashr"]=_bitshift64Ashr;Module["_bitshift64Lshr"]=_bitshift64Lshr;var _fabsf=Math_abs;var ___errno_state=0;function ___setErrNo(value){HEAP32[___errno_state>>2]=value;return value;}var ERRNO_CODES={EPERM:1,ENOENT:2,ESRCH:3,EINTR:4,EIO:5,ENXIO:6,E2BIG:7,ENOEXEC:8,EBADF:9,ECHILD:10,EAGAIN:11,EWOULDBLOCK:11,ENOMEM:12,EACCES:13,EFAULT:14,ENOTBLK:15,EBUSY:16,EEXIST:17,EXDEV:18,ENODEV:19,ENOTDIR:20,EISDIR:21,EINVAL:22,ENFILE:23,EMFILE:24,ENOTTY:25,ETXTBSY:26,EFBIG:27,ENOSPC:28,ESPIPE:29,EROFS:30,EMLINK:31,EPIPE:32,EDOM:33,ERANGE:34,ENOMSG:42,EIDRM:43,ECHRNG:44,EL2NSYNC:45,EL3HLT:46,EL3RST:47,ELNRNG:48,EUNATCH:49,ENOCSI:50,EL2HLT:51,EDEADLK:35,ENOLCK:37,EBADE:52,EBADR:53,EXFULL:54,ENOANO:55,EBADRQC:56,EBADSLT:57,EDEADLOCK:35,EBFONT:59,ENOSTR:60,ENODATA:61,ETIME:62,ENOSR:63,ENONET:64,ENOPKG:65,EREMOTE:66,ENOLINK:67,EADV:68,ESRMNT:69,ECOMM:70,EPROTO:71,EMULTIHOP:72,EDOTDOT:73,EBADMSG:74,ENOTUNIQ:76,EBADFD:77,EREMCHG:78,ELIBACC:79,ELIBBAD:80,ELIBSCN:81,ELIBMAX:82,ELIBEXEC:83,ENOSYS:38,ENOTEMPTY:39,ENAMETOOLONG:36,ELOOP:40,EOPNOTSUPP:95,EPFNOSUPPORT:96,ECONNRESET:104,ENOBUFS:105,EAFNOSUPPORT:97,EPROTOTYPE:91,ENOTSOCK:88,ENOPROTOOPT:92,ESHUTDOWN:108,ECONNREFUSED:111,EADDRINUSE:98,ECONNABORTED:103,ENETUNREACH:101,ENETDOWN:100,ETIMEDOUT:110,EHOSTDOWN:112,EHOSTUNREACH:113,EINPROGRESS:115,EALREADY:114,EDESTADDRREQ:89,EMSGSIZE:90,EPROTONOSUPPORT:93,ESOCKTNOSUPPORT:94,EADDRNOTAVAIL:99,ENETRESET:102,EISCONN:106,ENOTCONN:107,ETOOMANYREFS:109,EUSERS:87,EDQUOT:122,ESTALE:116,ENOTSUP:95,ENOMEDIUM:123,EILSEQ:84,EOVERFLOW:75,ECANCELED:125,ENOTRECOVERABLE:131,EOWNERDEAD:130,ESTRPIPE:86};function _sysconf(name){switch(name){case 30:return PAGE_SIZE;case 132:case 133:case 12:case 137:case 138:case 15:case 235:case 16:case 17:case 18:case 19:case 20:case 149:case 13:case 10:case 236:case 153:case 9:case 21:case 22:case 159:case 154:case 14:case 77:case 78:case 139:case 80:case 81:case 79:case 82:case 68:case 67:case 164:case 11:case 29:case 47:case 48:case 95:case 52:case 51:case 46:return 200809;case 27:case 246:case 127:case 128:case 23:case 24:case 160:case 161:case 181:case 182:case 242:case 183:case 184:case 243:case 244:case 245:case 165:case 178:case 179:case 49:case 50:case 168:case 169:case 175:case 170:case 171:case 172:case 97:case 76:case 32:case 173:case 35:return-1;case 176:case 177:case 7:case 155:case 8:case 157:case 125:case 126:case 92:case 93:case 129:case 130:case 131:case 94:case 91:return 1;case 74:case 60:case 69:case 70:case 4:return 1024;case 31:case 42:case 72:return 32;case 87:case 26:case 33:return 2147483647;case 34:case 1:return 47839;case 38:case 36:return 99;case 43:case 37:return 2048;case 0:return 2097152;case 3:return 65536;case 28:return 32768;case 44:return 32767;case 75:return 16384;case 39:return 1e3;case 89:return 700;case 71:return 256;case 40:return 255;case 2:return 100;case 180:return 64;case 25:return 20;case 5:return 16;case 6:return 6;case 73:return 4;case 84:{if((typeof navigator==="undefined"?"undefined":_typeof(navigator))==="object")return navigator["hardwareConcurrency"]||1;return 1;}}___setErrNo(ERRNO_CODES.EINVAL);return-1;}var ctlz_i8=allocate([8,7,6,6,5,5,5,5,4,4,4,4,4,4,4,4,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,3,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"i8",ALLOC_STATIC);Module["_llvm_ctlz_i32"]=_llvm_ctlz_i32;Module["_memset"]=_memset;function _llvm_stackrestore(p){var self=_llvm_stacksave;var ret=self.LLVM_SAVEDSTACKS[p];self.LLVM_SAVEDSTACKS.splice(p,1);Runtime.stackRestore(ret);}var _floorf=Math_floor;function _abort(){Module["abort"]();}var _sqrtf=Math_sqrt;var _log=Math_log;var _cos=Math_cos;Module["_i64Add"]=_i64Add;function _sbrk(bytes){var self=_sbrk;if(!self.called){DYNAMICTOP=alignMemoryPage(DYNAMICTOP);self.called=true;assert(Runtime.dynamicAlloc);self.alloc=Runtime.dynamicAlloc;Runtime.dynamicAlloc=function(){abort("cannot dynamically allocate, sbrk now has control");};}var ret=DYNAMICTOP;if(bytes!=0)self.alloc(bytes);return ret;}var _floor=Math_floor;function _exp2(x){return Math.pow(2,x);}function _rint(x){if(Math.abs(x%1)!==.5)return Math.round(x);return x+x%2+(x<0?1:-1);}function _lrintf(){return _rint.apply(null,arguments);}function ___errno_location(){return ___errno_state;}var _sqrt=Math_sqrt;function _emscripten_memcpy_big(dest,src,num){HEAPU8.set(HEAPU8.subarray(src,src+num),dest);return dest;}Module["_memcpy"]=_memcpy;var _atan2=Math_atan2;function _llvm_stacksave(){var self=_llvm_stacksave;if(!self.LLVM_SAVEDSTACKS){self.LLVM_SAVEDSTACKS=[];}self.LLVM_SAVEDSTACKS.push(Runtime.stackSave());return self.LLVM_SAVEDSTACKS.length-1;}function _time(ptr){var ret=Date.now()/1e3|0;if(ptr){HEAP32[ptr>>2]=ret;}return ret;}var _exp=Math_exp;var _llvm_pow_f64=Math_pow;Module["_memmove"]=_memmove;function _log10(x){return Math.log(x)/Math.LN10;}___errno_state=Runtime.staticAlloc(4);HEAP32[___errno_state>>2]=0;STACK_BASE=STACKTOP=Runtime.alignMemory(STATICTOP);staticSealed=true;STACK_MAX=STACK_BASE+TOTAL_STACK;DYNAMIC_BASE=DYNAMICTOP=Runtime.alignMemory(STACK_MAX);assert(DYNAMIC_BASE<TOTAL_MEMORY,"TOTAL_MEMORY not big enough for stack");var cttz_i8=allocate([8,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,5,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,6,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,5,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,7,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,5,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,6,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,5,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0,4,0,1,0,2,0,1,0,3,0,1,0,2,0,1,0],"i8",ALLOC_DYNAMIC);function invoke_viiiiiii(index,a1,a2,a3,a4,a5,a6,a7){try{Module["dynCall_viiiiiii"](index,a1,a2,a3,a4,a5,a6,a7);}catch(e){if(typeof e!=="number"&&e!=="longjmp")throw e;asm["setThrew"](1,0);}}Module.asmGlobalArg={"Math":Math,"Int8Array":Int8Array,"Int16Array":Int16Array,"Int32Array":Int32Array,"Uint8Array":Uint8Array,"Uint16Array":Uint16Array,"Uint32Array":Uint32Array,"Float32Array":Float32Array,"Float64Array":Float64Array};Module.asmLibraryArg={"abort":abort,"assert":assert,"min":Math_min,"invoke_viiiiiii":invoke_viiiiiii,"_exp":_exp,"_llvm_pow_f64":_llvm_pow_f64,"_sqrtf":_sqrtf,"_atan2":_atan2,"___setErrNo":___setErrNo,"_llvm_stackrestore":_llvm_stackrestore,"_floor":_floor,"_log10":_log10,"_fabsf":_fabsf,"_sbrk":_sbrk,"_emscripten_memcpy_big":_emscripten_memcpy_big,"_exp2":_exp2,"_sysconf":_sysconf,"_cos":_cos,"_lrintf":_lrintf,"_llvm_stacksave":_llvm_stacksave,"_floorf":_floorf,"_log":_log,"___errno_location":___errno_location,"_abort":_abort,"_time":_time,"_rint":_rint,"_sqrt":_sqrt,"STACKTOP":STACKTOP,"STACK_MAX":STACK_MAX,"tempDoublePtr":tempDoublePtr,"ABORT":ABORT,"cttz_i8":cttz_i8,"ctlz_i8":ctlz_i8,"NaN":NaN,"Infinity":Infinity};// EMSCRIPTEN_START_ASM
var asm=function(global,env,buffer){"use asm";var a=new global.Int8Array(buffer);var b=new global.Int16Array(buffer);var c=new global.Int32Array(buffer);var d=new global.Uint8Array(buffer);var e=new global.Uint16Array(buffer);var f=new global.Uint32Array(buffer);var g=new global.Float32Array(buffer);var h=new global.Float64Array(buffer);var i=env.STACKTOP|0;var j=env.STACK_MAX|0;var k=env.tempDoublePtr|0;var l=env.ABORT|0;var m=env.cttz_i8|0;var n=env.ctlz_i8|0;var o=0;var p=0;var q=0;var r=0;var s=+env.NaN,t=+env.Infinity;var u=0,v=0,w=0,x=0,y=0.0,z=0,A=0,B=0,C=0.0;var D=0;var E=0;var F=0;var G=0;var H=0;var I=0;var J=0;var K=0;var L=0;var M=0;var N=global.Math.floor;var O=global.Math.abs;var P=global.Math.sqrt;var Q=global.Math.pow;var R=global.Math.cos;var S=global.Math.sin;var T=global.Math.tan;var U=global.Math.acos;var V=global.Math.asin;var W=global.Math.atan;var X=global.Math.atan2;var Y=global.Math.exp;var Z=global.Math.log;var _=global.Math.ceil;var $=global.Math.imul;var aa=env.abort;var ba=env.assert;var ca=env.min;var da=env.invoke_viiiiiii;var ea=env._exp;var fa=env._llvm_pow_f64;var ga=env._sqrtf;var ha=env._atan2;var ia=env.___setErrNo;var ja=env._llvm_stackrestore;var ka=env._floor;var la=env._log10;var ma=env._fabsf;var na=env._sbrk;var oa=env._emscripten_memcpy_big;var pa=env._exp2;var qa=env._sysconf;var ra=env._cos;var sa=env._lrintf;var ta=env._llvm_stacksave;var ua=env._floorf;var va=env._log;var wa=env.___errno_location;var xa=env._abort;var ya=env._time;var za=env._rint;var Aa=env._sqrt;var Ba=0.0;// EMSCRIPTEN_START_FUNCS
function Da(a){a=a|0;var b=0;b=i;i=i+a|0;i=i+15&-16;return b|0;}function Ea(){return i|0;}function Fa(a){a=a|0;i=a;}function Ga(a,b){a=a|0;b=b|0;if(!o){o=a;p=b;}}function Ha(b){b=b|0;a[k>>0]=a[b>>0];a[k+1>>0]=a[b+1>>0];a[k+2>>0]=a[b+2>>0];a[k+3>>0]=a[b+3>>0];}function Ia(b){b=b|0;a[k>>0]=a[b>>0];a[k+1>>0]=a[b+1>>0];a[k+2>>0]=a[b+2>>0];a[k+3>>0]=a[b+3>>0];a[k+4>>0]=a[b+4>>0];a[k+5>>0]=a[b+5>>0];a[k+6>>0]=a[b+6>>0];a[k+7>>0]=a[b+7>>0];}function Ja(a){a=a|0;D=a;}function Ka(){return D|0;}function La(a,b){a=+a;b=b|0;var c=0,d=0,e=0;c=i;d=0;while(1){if((d|0)>=21)break;if(+g[320+(d<<2)>>2]>a)break;d=d+1|0;}if((d|0)>(b|0)?+g[320+(b<<2)>>2]+ +g[408+(b<<2)>>2]>a:0){d=b;i=c;return d|0;}if((d|0)>=(b|0)){i=c;return d|0;}e=b+-1|0;if(!(+g[320+(e<<2)>>2]-+g[408+(e<<2)>>2]<a)){e=d;i=c;return e|0;}e=b;i=c;return e|0;}function Ma(a){a=a|0;a=($(a,1664525)|0)+1013904223|0;return a|0;}function Na(a,d,e,f,h,j){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0.0,s=0,t=0;m=i;k=c[a+32>>2]|0;l=c[a+44>>2]<<j;n=a+8|0;a=0;do{o=$(a,l)|0;p=0;while(1){if((p|0)>=(f|0))break;s=b[k+(p<<1)>>1]|0;t=d+(o+(s<<j)<<2)|0;q=p+1|0;r=+P(+(+Oa(t,t,(b[k+(q<<1)>>1]|0)-s<<j)+1.0000000272452012e-27));g[e+(p+($(a,c[n>>2]|0)|0)<<2)>>2]=r;p=q;}a=a+1|0;}while((a|0)<(h|0));i=m;return;}function Oa(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0.0,f=0,h=0.0;d=i;f=0;e=0.0;while(1){if((f|0)>=(c|0))break;h=e+ +g[a+(f<<2)>>2]*+g[b+(f<<2)>>2];f=f+1|0;e=h;}i=d;return+e;}function Pa(a,d,e,f,h,j,k){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,o=0,p=0,q=0.0,r=0,s=0,t=0,u=0;n=i;l=c[a+32>>2]|0;m=$(c[a+44>>2]|0,k)|0;o=a+8|0;a=0;while(1){p=$(a,m)|0;r=0;a:while(1){if((r|0)>=(h|0))break;q=1.0/(+g[f+(r+($(a,c[o>>2]|0)|0)<<2)>>2]+1.0000000272452012e-27);t=$(b[l+(r<<1)>>1]|0,k)|0;r=r+1|0;s=$(b[l+(r<<1)>>1]|0,k)|0;while(1){if((t|0)>=(s|0))continue a;u=t+p|0;g[e+(u<<2)>>2]=+g[d+(u<<2)>>2]*q;t=t+1|0;}}a=a+1|0;if((a|0)>=(j|0))break;}i=n;return;}function Qa(a,d,e,f,h,j,k,l,m){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;var n=0,o=0,p=0.0,q=0,r=0,s=0,t=0;o=i;n=c[a+32>>2]|0;a=$(c[a+44>>2]|0,k)|0;q=$(b[n+(j<<1)>>1]|0,k)|0;if((l|0)!=1){t=(a|0)/(l|0)|0;q=(q|0)<(t|0)?q:t;}r=(m|0)==0;m=r?q:0;j=r?j:0;h=r?h:0;r=n+(h<<1)|0;s=b[r>>1]|0;l=d+(($(s<<16>>16,k)|0)<<2)|0;q=e;d=0;while(1){if((d|0)>=($(s<<16>>16,k)|0)){r=h;break;}g[q>>2]=0.0;s=b[r>>1]|0;q=q+4|0;d=d+1|0;}a:while(1){if((r|0)>=(j|0))break;s=$(b[n+(r<<1)>>1]|0,k)|0;d=r+1|0;h=$(b[n+(d<<1)>>1]|0,k)|0;p=+Y(+((+g[f+(r<<2)>>2]+ +g[20656+(r<<2)>>2])*.6931471805599453));t=l;while(1){l=t+4|0;r=q+4|0;g[q>>2]=+g[t>>2]*p;s=s+1|0;if((s|0)<(h|0)){q=r;t=l;}else{q=r;r=d;continue a;}}}wj(e+(m<<2)|0,0,a-m<<2|0)|0;i=o;return;}function Ra(a,e,f,h,j,k,l,m,n,o,p,q,r,s){a=a|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=r|0;s=s|0;var t=0,u=0,v=0,w=0,x=0,y=0,z=0.0,A=0.0,B=0,C=0,D=0,E=0,F=0,G=0.0,H=0.0,I=0,J=0,K=0,L=0,M=0.0,N=0;u=i;t=a+32|0;w=a+8|0;v=(j|0)==1;x=(h|0)==3;a=1<<h;a:while(1){if((l|0)>=(m|0))break;C=l+1|0;B=c[t>>2]|0;B=(b[B+(C<<1)>>1]|0)-(b[B+(l<<1)>>1]|0)|0;A=+Y(+(+((Sa((c[q+(l<<2)>>2]|0)+1|0,B)|0)>>>h|0)*-.125*.6931471805599453))*.5;D=B<<h;z=1.0/+P(+ +(D|0));y=$(l,j)|0;E=0;while(1){I=c[w>>2]|0;F=($(E,I)|0)+l|0;M=+g[o+(F<<2)>>2];G=+g[p+(F<<2)>>2];if(v){L=I+l|0;H=+g[o+(L<<2)>>2];M=M>H?M:H;H=+g[p+(L<<2)>>2];if(!(G>H))G=H;}G=+g[n+(F<<2)>>2]-(M<G?M:G);G=+Y(+(-(G<0.0?0.0:G)*.6931471805599453))*2.0;if(x)G=G*1.4142135381698608;G=(A<G?A:G)*z;F=$(E,k)|0;F=F+(b[(c[t>>2]|0)+(l<<1)>>1]<<h)|0;J=e+(F<<2)|0;I=f+(y+E)|0;H=-G;L=0;K=0;while(1){if((K|0)>=(a|0))break;b:do if(!(d[I>>0]&1<<K)){L=0;while(1){if((L|0)>=(B|0)){L=1;break b;}N=Ma(r)|0;g[e+(F+((L<<h)+K)<<2)>>2]=(N&32768|0)==0?H:G;r=N;L=L+1|0;}}while(0);K=K+1|0;}if(L)Ad(J,D,1.0,s);E=E+1|0;if((E|0)>=(j|0)){l=C;continue a;}}}i=u;return;}function Sa(a,b){a=a|0;b=b|0;return(a>>>0)/(b>>>0)|0|0;}function Ta(a,d,e,f,h,j,k,l,m,n){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;var o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0.0,D=0,E=0.0;o=i;q=c[a+32>>2]|0;r=$(c[a+44>>2]|0,n)|0;if(($((b[q+(l<<1)>>1]|0)-(b[q+(l+-1<<1)>>1]|0)|0,n)|0)<9){D=0;i=o;return D|0;}s=a+8|0;z=0;x=0;p=0;y=0;a=0;a:while(1){A=y;while(1){if((A|0)<(l|0))break;z=z+1|0;if((z|0)<(m|0))A=0;else break a;}w=b[q+(A<<1)>>1]|0;B=($(w,n)|0)+($(z,r)|0)|0;y=A+1|0;w=$((b[q+(y<<1)>>1]|0)-w|0,n)|0;if((w|0)<9)continue;C=+(w|0);D=0;u=0;v=0;t=0;while(1){if((D|0)>=(w|0))break;E=+g[d+(B+D<<2)>>2];E=E*E*C;D=D+1|0;u=E<.25?u+1|0:u;v=E<.0625?v+1|0:v;t=E<.015625?t+1|0:t;}if((A|0)>((c[s>>2]|0)+-4|0))x=x+(Sa(v+u<<5,w)|0)|0;p=p+1|0;a=a+(((t<<1|0)>=(w|0)&1)+((v<<1|0)>=(w|0)&1)+((u<<1|0)>=(w|0)&1)<<8)|0;}do if(k){if(!x)k=0;else k=Sa(x,$(4-(c[s>>2]|0)+l|0,m)|0)|0;k=(c[h>>2]|0)+k>>1;c[h>>2]=k;h=c[j>>2]|0;if((h|0)==2)k=k+4|0;else if(!h)k=k+-4|0;if((k|0)>22){c[j>>2]=2;break;}if((k|0)>18){c[j>>2]=1;break;}else{c[j>>2]=0;break;}}while(0);D=Sa(a,p)|0;D=D+(c[e>>2]|0)>>1;c[e>>2]=D;f=(D*3|0)+(3-f<<7|64)+2>>2;if((f|0)<80){D=3;i=o;return D|0;}if((f|0)<256){D=2;i=o;return D|0;}else{i=o;return((f|0)<384?1:0)|0;}return 0;}function Ua(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,h=0,j=0,k=0.0,l=0.0,m=0;d=i;b=b>>1;f=c<<1;e=0;while(1){if((e|0)<(c|0))h=0;else break;while(1){if((h|0)>=(b|0))break;m=a+(($(f,h)|0)+e<<2)|0;l=+g[m>>2]*.7071067690849304;j=a+(($(h<<1|1,c)|0)+e<<2)|0;k=+g[j>>2]*.7071067690849304;g[m>>2]=l+k;g[j>>2]=l-k;h=h+1|0;}e=e+1|0;}i=d;return;}function Va(e,f,h,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A){e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=r|0;s=s|0;t=t|0;u=u|0;v=v|0;w=w|0;x=x|0;y=y|0;z=z|0;A=A|0;var B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0;B=i;i=i+48|0;F=B;D=c[f+32>>2]|0;H=(l|0)!=0?2:1;E=(e|0)==0;L=(p|0)==0?1:1<<x;I=D+(h<<1)|0;p=b[I>>1]<<x;aa=b[D+((c[f+8>>2]|0)+-1<<1)>>1]|0;K=$(H,(aa<<16>>16<<x)-p|0)|0;J=i;i=i+((4*K|0)+15&-16)|0;aa=aa<<16>>16<<x;K=aa-p|0;c[F+32>>2]=n;c[F+24>>2]=w;c[F>>2]=e;c[F+12>>2]=s;c[F+4>>2]=f;e=F+36|0;c[e>>2]=c[z>>2];c[F+16>>2]=q;c[F+40>>2]=A;P=F+8|0;A=j+-1|0;N=(l|0)==0;O=F+28|0;Q=y+-1|0;n=F+20|0;f=f+12|0;R=(1<<L)+-1|0;q=(q|0)==3;S=(L|0)>1;Y=0;aa=k+(aa<<2)|0;T=h;da=1;while(1){if((T|0)>=(j|0))break;c[P>>2]=T;Z=(T|0)==(A|0);_=D+(T<<1)|0;V=b[_>>1]<<x;ca=k+(V<<2)|0;if(N)ba=0;else ba=l+(V<<2)|0;U=T+1|0;W=(b[D+(U<<1)>>1]<<x)-V|0;V=jc(w)|0;v=(T|0)==(h|0)?v:v-V|0;X=u-V|0;c[O>>2]=X+-1;if((T|0)<=(Q|0)?(C=y-T|0,C=Wa(v,(C|0)>3?3:C)|0,C=(c[o+(T<<2)>>2]|0)+C|0,G=(X|0)<(C|0),!(((G?X:C)|0)<=16383&((G?X:C)|0)<0)):0){if(((G?X:C)|0)>16383)X=16383;else X=G?X:C;}else X=0;if(E?((b[_>>1]<<x)-W|0)>=(b[I>>1]<<x|0):0)Y=(da|0)!=0|(Y|0)==0?T:Y;da=c[t+(T<<2)>>2]|0;c[n>>2]=da;if((T|0)>=(c[f>>2]|0)){ca=J;ba=N?ba:J;aa=0;}aa=Z?0:aa;if((Y|0)!=0?q^1|S|(da|0)<0:0){fa=(b[D+(Y<<1)>>1]<<x)-p-W|0;fa=(fa|0)<0?0:fa;da=fa+p|0;ha=Y;do ha=ha+-1|0;while((b[D+(ha<<1)>>1]<<x|0)>(da|0));da=da+W|0;ga=Y+-1|0;do ga=ga+1|0;while((b[D+(ga<<1)>>1]<<x|0)<(da|0));ea=0;da=0;do{ja=$(ha,H)|0;ea=ea|d[m+ja>>0];da=da|d[m+(ja+H+-1)>>0];ha=ha+1|0;}while((ha|0)<(ga|0));}else{fa=-1;ea=R;da=R;}a:do if(r){if((T|0)==(s|0)){if(!E){M=37;break;}r=D+(s<<1)|0;M=0;while(1){if((M|0)>=((b[r>>1]<<x)-p|0)){M=37;break a;}ja=J+(M<<2)|0;g[ja>>2]=(+g[ja>>2]+ +g[J+(K+M<<2)>>2])*.5;M=M+1|0;}}if(r){ga=(X|0)/2|0;ha=(fa|0)==-1;if(ha)ia=0;else ia=J+(fa<<2)|0;if(Z)ja=0;else ja=J+((b[_>>1]<<x)-p<<2)|0;ca=Xa(F,ca,W,ga,L,ia,x,ja,1.0,aa,ea)|0;if(ha)ea=0;else ea=J+(K+fa<<2)|0;if(Z)Z=0;else Z=J+(K+((b[_>>1]<<x)-p)<<2)|0;Z=Xa(F,ba,W,ga,L,ea,x,Z,1.0,aa,da)|0;}else M=37;}else M=37;while(0);do if((M|0)==37){M=0;r=(fa|0)==-1;if(!ba){if(r)ba=0;else ba=J+(fa<<2)|0;if(Z)Z=0;else Z=J+((b[_>>1]<<x)-p<<2)|0;ca=Xa(F,ca,W,X,L,ba,x,Z,1.0,aa,ea|da)|0;r=0;Z=ca;break;}else{if(r)r=0;else r=J+(fa<<2)|0;if(Z)Z=0;else Z=J+((b[_>>1]<<x)-p<<2)|0;ca=Ya(F,ca,ba,W,X,L,r,x,Z,aa,ea|da)|0;r=0;Z=ca;break;}}while(0);da=$(T,H)|0;a[m+da>>0]=ca;a[m+(da+H+-1)>>0]=Z;v=v+((c[o+(T<<2)>>2]|0)+V)|0;T=U;da=(X|0)>(W<<3|0)&1;}c[z>>2]=c[e>>2];i=B;return;}function Wa(a,b){a=a|0;b=b|0;return(a|0)/(b|0)|0|0;}function Xa(a,b,e,f,h,j,k,l,m,n,o){a=a|0;b=b|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=+m;n=n|0;o=o|0;var p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;p=i;s=(c[a>>2]|0)==0;t=c[a+20>>2]|0;r=(h|0)==1&1;u=Sa(e,h)|0;if((e|0)==1){Za(a,b,0,f,l);o=1;i=p;return o|0;}q=(t|0)>0?t:0;do if(n)if(!j)j=0;else{if((q|0)==0?!((u&1|0)==0&(t|0)<0|(h|0)>1):0)break;yj(n|0,j|0,e<<2|0)|0;j=n;}while(0);n=(j|0)==0;v=0;while(1){if((v|0)>=(q|0))break;if(!s)Ua(b,e>>v,1<<v);if(!n)Ua(j,e>>v,1<<v);o=d[24+(o&15)>>0]|0|(d[24+(o>>4)>>0]|0)<<2;v=v+1|0;}h=h>>q;v=u<<q;u=0;while(1){if(!((v&1|0)==0&(t|0)<0))break;if(!s)Ua(b,v,h);if(!n)Ua(j,v,h);w=o|o<<h;h=h<<1;o=w;v=v>>1;t=t+1|0;u=u+1|0;}t=(h|0)>1;if(t){if(!s)gb(b,v>>q,h<<q,r);if(!n)gb(j,v>>q,h<<q,r);}a=hb(a,b,e,f,h,j,k,m,o)|0;if(!s){w=a;i=p;return w|0;}if(t){ib(b,v>>q,h<<q,r);r=0;}else r=0;while(1){if((r|0)>=(u|0)){r=0;break;}w=h>>1;o=v<<1;Ua(b,o,w);h=w;v=o;a=a|a>>>w;r=r+1|0;}while(1){if((r|0)>=(q|0))break;w=d[40+a>>0]|0;Ua(b,e>>r,1<<r);a=w;r=r+1|0;}q=h<<q;a:do if(l){m=+P(+ +(e|0));r=0;while(1){if((r|0)>=(e|0))break a;g[l+(r<<2)>>2]=m*+g[b+(r<<2)>>2];r=r+1|0;}}while(0);w=a&(1<<q)+-1;i=p;return w|0;}function Ya(a,b,d,e,f,h,j,k,l,m,n){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;var o=0,p=0,q=0.0,r=0,s=0.0,t=0,u=0,v=0,w=0,x=0,y=0,z=0.0;o=i;i=i+32|0;y=o+28|0;u=o+24|0;x=o;c[y>>2]=f;c[u>>2]=n;p=(c[a>>2]|0)==0;w=c[a+24>>2]|0;if((e|0)==1){Za(a,b,d,f,l);y=1;i=o;return y|0;}_a(a,x,b,d,e,y,h,h,k,1,u);r=c[x>>2]|0;t=c[x+16>>2]|0;v=c[x+20>>2]|0;q=+(c[x+4>>2]|0)*30517578125.0e-15;s=+(c[x+8>>2]|0)*30517578125.0e-15;f=(e|0)==2;do if(f){if((t|0)==16384|(t|0)==0)u=0;else u=8;x=(c[y>>2]|0)-u|0;t=(t|0)>8192;y=a+28|0;c[y>>2]=(c[y>>2]|0)-(v+u);v=t?d:b;t=t?b:d;do if(u){if(p){u=uc(w,1)|0;break;}else{u=+g[v>>2]*+g[t+4>>2]-+g[v+4>>2]*+g[t>>2]<0.0&1;Ec(w,u,1);break;}}else u=0;while(0);y=1-(u<<1)|0;h=Xa(a,v,2,x,h,j,k,l,1.0,m,n)|0;g[t>>2]=+(0-y|0)*+g[v+4>>2];g[t+4>>2]=+(y|0)*+g[v>>2];if(p){g[b>>2]=q*+g[b>>2];x=b+4|0;g[x>>2]=q*+g[x>>2];z=s*+g[d>>2];g[d>>2]=z;y=d+4|0;g[y>>2]=s*+g[y>>2];s=+g[b>>2];g[b>>2]=s-z;g[d>>2]=s+ +g[d>>2];s=+g[x>>2];g[x>>2]=s-+g[y>>2];g[y>>2]=s+ +g[y>>2];break;}else{y=h;i=o;return y|0;}}else{w=c[y>>2]|0;x=(w-(c[x+12>>2]|0)|0)/2|0;n=(w|0)<(x|0);if(((n?w:x)|0)<0)n=0;else n=n?w:x;w=w-n|0;x=a+28|0;v=(c[x>>2]|0)-v|0;c[x>>2]=v;u=c[u>>2]|0;if((n|0)<(w|0)){y=Xa(a,d,e,w,h,0,k,0,s,0,u>>h)|0;v=w+((c[x>>2]|0)-v)|0;if(!((v|0)<=24|(t|0)==16384))n=n+(v+-24)|0;h=y|(Xa(a,b,e,n,h,j,k,l,1.0,m,u)|0);}else{m=Xa(a,b,e,n,h,j,k,l,1.0,m,u)|0;j=n+((c[x>>2]|0)-v)|0;if(!((j|0)<=24|(t|0)==0))w=w+(j+-24)|0;h=m|(Xa(a,d,e,w,h,0,k,0,s,0,u>>h)|0);}if(!p){y=h;i=o;return y|0;}}while(0);if(!f)$a(b,d,q,e);if(!r){y=h;i=o;return y|0;}else b=0;while(1){if((b|0)>=(e|0))break;y=d+(b<<2)|0;g[y>>2]=-+g[y>>2];b=b+1|0;}i=o;return h|0;}function Za(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0;l=i;j=(c[a>>2]|0)==0;k=c[a+24>>2]|0;h=(d|0)!=0&1;a=a+28|0;m=0;n=b;while(1){if((c[a>>2]|0)>7){if(j)o=uc(k,1)|0;else{o=+g[n>>2]<0.0&1;Ec(k,o,1);}c[a>>2]=(c[a>>2]|0)+-8;e=e+-8|0;}else o=0;if(j)g[n>>2]=(o|0)!=0?-1.0:1.0;if((m|0)>=(h|0))break;m=m+1|0;n=d;}if(!f){i=l;return;}g[f>>2]=+g[b>>2];i=l;return;}function _a(a,d,e,f,h,j,k,l,m,n,o){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;var p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;p=i;u=c[a>>2]|0;s=c[a+4>>2]|0;t=c[a+8>>2]|0;v=c[a+12>>2]|0;q=c[a+24>>2]|0;r=c[a+32>>2]|0;z=(b[(c[s+56>>2]|0)+(t<<1)>>1]|0)+(m<<3)|0;y=z>>1;m=(n|0)==0;if(m){v=c[j>>2]|0;x=v;v=bb(h,v,y-4|0,z,n)|0;}else{x=c[j>>2]|0;z=bb(h,x,y-((h|0)==2?16:4)|0,z,n)|0;v=(t|0)<(v|0)?z:1;}u=(u|0)==0;if(u)y=0;else y=Cd(e,f,n,h,c[a+40>>2]|0)|0;n=jc(q)|0;a:do if((v|0)==1){if(!m){if(u)m=0;else{z=(y|0)>8192;m=z&1;b:do if(z){v=0;while(1){if((v|0)>=(h|0))break b;z=f+(v<<2)|0;g[z>>2]=-+g[z>>2];v=v+1|0;}}while(0);cb(s,e,f,r,t,h);x=c[j>>2]|0;}if((x|0)>16?(c[a+28>>2]|0)>16:0){if(u){m=rc(q,2)|0;y=0;break;}else{Bc(q,m,2);y=0;break;}}else{m=0;y=0;}}else m=0;}else{if(u)a=y;else a=($(y,v)|0)+8192>>14;do if(!((m^1)&(h|0)>2)){if((l|0)>1|m^1){l=v+1|0;if(u){m=0;y=Sa((tc(q,l)|0)<<14,v)|0;break a;}else{Dc(q,a,l);y=Sa(a<<14,v)|0;break;}}x=v>>1;l=x+1|0;w=$(l,l)|0;if(u){a=nc(q,w)|0;if((a|0)<(($(x,l)|0)>>1|0)){z=((Uc(a<<3|1)|0)+-1|0)>>>1;x=z+1|0;l=x;a=z;x=($(z,x)|0)>>>1;}else{x=((v<<1)+2-(Uc((w-a<<3)+-7|0)|0)|0)>>>1;z=v+1-x|0;l=z;a=x;x=w-(($(z,v+2-x|0)|0)>>1)|0;}qc(q,x,x+l|0,w);w=35;break;}else{if((a|0)>(x|0)){l=v+1-a|0;x=w-(($(v+1-a|0,v+2-a|0)|0)>>1)|0;}else{l=a+1|0;x=($(a,a+1|0)|0)>>1;}xc(q,x,x+l|0,w);w=35;break;}}else{l=(v|0)/2|0;w=(l*3|0)+3+l|0;if(!u){if((a|0)>(l|0)){x=a+-1-l+((l*3|0)+3)|0;l=a-l+((l*3|0)+3)|0;}else{x=a*3|0;l=(a*3|0)+3|0;}xc(q,x,l,w);w=35;break;}y=nc(q,w)|0;a=l+1|0;x=a*3|0;if((y|0)<(x|0))a=(y|0)/3|0;else a=a+(y-x)|0;if((a|0)>(l|0)){y=a+-1-l+x|0;l=a-l+x|0;}else{y=a*3|0;l=(a*3|0)+3|0;}qc(q,y,l,w);w=35;}while(0);if((w|0)==35){y=Sa(a<<14,v)|0;if(u){m=0;break;}}if(!m){if(!y){cb(s,e,f,r,t,h);m=0;y=0;break;}else{db(e,f,h);m=0;break;}}else m=0;}while(0);q=(jc(q)|0)-n|0;c[j>>2]=(c[j>>2]|0)-q;if(!y){c[o>>2]=c[o>>2]&(1<<k)+-1;w=32767;l=0;x=-16384;c[d>>2]=m;z=d+4|0;c[z>>2]=w;z=d+8|0;c[z>>2]=l;z=d+12|0;c[z>>2]=x;z=d+16|0;c[z>>2]=y;z=d+20|0;c[z>>2]=q;i=p;return;}else if((y|0)==16384){c[o>>2]=c[o>>2]&(1<<k)+-1<<k;w=0;l=32767;x=16384;c[d>>2]=m;z=d+4|0;c[z>>2]=w;z=d+8|0;c[z>>2]=l;z=d+12|0;c[z>>2]=x;z=d+16|0;c[z>>2]=y;z=d+20|0;c[z>>2]=q;i=p;return;}else{x=(eb(y&65535)|0)<<16>>16;z=(eb(16384-y&65535)|0)<<16>>16;w=x;l=z;x=($((h<<23)+-8388608>>16,(fb(z,x)|0)<<16>>16)|0)+16384>>15;c[d>>2]=m;z=d+4|0;c[z>>2]=w;z=d+8|0;c[z>>2]=l;z=d+12|0;c[z>>2]=x;z=d+16|0;c[z>>2]=y;z=d+20|0;c[z>>2]=q;i=p;return;}}function $a(a,b,c,d){a=a|0;b=b|0;c=+c;d=d|0;var e=0,f=0.0,h=0.0,j=0,k=0.0,l=0,m=0.0,n=0;e=i;i=i+16|0;l=e+4|0;j=e;g[l>>2]=0.0;g[j>>2]=0.0;ab(b,a,b,d,l,j);h=+g[l>>2]*c;g[l>>2]=h;k=c*c+ +g[j>>2];h=h*2.0;f=k-h;h=k+h;if(h<.0006000000284984708|f<.0006000000284984708){yj(b|0,a|0,d<<2|0)|0;i=e;return;}f=1.0/+P(+f);h=1.0/+P(+h);j=0;while(1){if((j|0)>=(d|0))break;n=a+(j<<2)|0;m=+g[n>>2]*c;l=b+(j<<2)|0;k=+g[l>>2];g[n>>2]=f*(m-k);g[l>>2]=h*(m+k);j=j+1|0;}i=e;return;}function ab(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;var h=0.0,j=0.0,k=0,l=0,m=0.0,n=0.0;k=i;l=0;h=0.0;j=0.0;while(1){if((l|0)>=(d|0))break;m=+g[a+(l<<2)>>2];n=h+m*+g[b+(l<<2)>>2];m=j+m*+g[c+(l<<2)>>2];l=l+1|0;h=n;j=m;}g[e>>2]=h;g[f>>2]=j;i=k;return;}function bb(a,c,d,e,f){a=a|0;c=c|0;d=d|0;e=e|0;f=f|0;var g=0,h=0;g=i;h=a<<1;f=(f|0)!=0&(a|0)==2?h+-2|0:h+-1|0;f=Wa(($(f,d)|0)+c|0,f)|0;e=c-e+-32|0;e=(e|0)<(f|0)?e:f;if((e|0)<=64){if((e|0)<4){h=1;i=g;return h|0;}}else e=64;h=(b[8+((e&7)<<1)>>1]>>14-(e>>3))+1&-2;i=g;return h|0;}function cb(a,b,d,e,f,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0.0,l=0.0,m=0.0;j=i;k=+g[e+(f<<2)>>2];m=+g[e+((c[a+8>>2]|0)+f<<2)>>2];l=+P(+(k*k+1.0000000036274937e-15+m*m))+1.0000000036274937e-15;k=k/l;l=m/l;f=0;while(1){if((f|0)>=(h|0))break;e=b+(f<<2)|0;g[e>>2]=k*+g[e>>2]+l*+g[d+(f<<2)>>2];f=f+1|0;}i=j;return;}function db(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,h=0.0,j=0.0,k=0;d=i;e=0;while(1){if((e|0)>=(c|0))break;k=a+(e<<2)|0;h=+g[k>>2]*.7071067690849304;f=b+(e<<2)|0;j=+g[f>>2]*.7071067690849304;g[k>>2]=h+j;g[f>>2]=j-h;e=e+1|0;}i=d;return;}function eb(a){a=a|0;var b=0;a=a<<16>>16;a=(($(a,a)|0)+4096|0)>>>13;b=a<<16>>16;a=32767-a+((($(b,((($(b,((($(a<<16>>16,-626)|0)+16384|0)>>>15<<16)+542441472>>16)|0)+16384|0)>>>15<<16)+-501415936>>16)|0)+16384|0)>>>15)+1&65535;return a|0;}function fb(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,f=0;c=i;e=32-(vj(b|0)|0)|0;f=32-(vj(a|0)|0)|0;d=a<<15-f<<16>>16;a=b<<15-e<<16>>16;a=(f-e<<11)+(($(d,((($(d,-2597)|0)+16384|0)>>>15<<16)+519831552>>16)|0)+16384>>15)-(($(a,((($(a,-2597)|0)+16384|0)>>>15<<16)+519831552>>16)|0)+16384>>15)|0;i=c;return a|0;}function gb(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,h=0,j=0,k=0,l=0,m=0,n=0.0;h=i;j=$(b,d)|0;f=i;i=i+((4*j|0)+15&-16)|0;if(!e){l=0;while(1){if((l|0)>=(d|0))break;k=$(l,b)|0;e=0;while(1){if((e|0)>=(b|0))break;g[f+(k+e<<2)>>2]=+g[a+(($(e,d)|0)+l<<2)>>2];e=e+1|0;}l=l+1|0;}m=j<<2;yj(a|0,f|0,m|0)|0;i=h;return;}l=d+-2|0;m=0;while(1){if((m|0)>=(d|0))break;k=56+(l+m<<2)|0;e=0;while(1){if((e|0)>=(b|0))break;n=+g[a+(($(e,d)|0)+m<<2)>>2];g[f+(($(c[k>>2]|0,b)|0)+e<<2)>>2]=n;e=e+1|0;}m=m+1|0;}m=j<<2;yj(a|0,f|0,m|0)|0;i=h;return;}function hb(a,e,f,h,j,k,l,m,n){a=a|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=+m;n=n|0;var o=0,p=0,q=0,r=0,s=0,t=0.0,u=0.0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0;o=i;i=i+32|0;v=o+28|0;p=o+24|0;w=o;c[v>>2]=h;c[p>>2]=n;s=(c[a>>2]|0)==0;x=c[a+4>>2]|0;y=c[a+8>>2]|0;r=c[a+16>>2]|0;q=c[a+24>>2]|0;A=c[x+100>>2]|0;z=($(l+1|0,c[x+8>>2]|0)|0)+y|0;z=b[(c[x+96>>2]|0)+(z<<1)>>1]|0;if((l|0)!=-1?(f|0)>2?((d[A+(z+(d[A+z>>0]|0))>>0]|0)+12|0)<(h|0):0:0){f=f>>1;s=e+(f<<2)|0;q=l+-1|0;if((j|0)==1)c[p>>2]=n&1|n<<1;n=j+1>>1;_a(a,w,e,s,f,v,n,j,q,0,p);y=c[w+12>>2]|0;r=c[w+16>>2]|0;x=c[w+20>>2]|0;t=+(c[w+4>>2]|0)*30517578125.0e-15;u=+(c[w+8>>2]|0)*30517578125.0e-15;do if((j|0)>1?(r&16383|0)!=0:0)if((r|0)>8192){y=y-(y>>5-l)|0;break;}else{y=y+(f<<3>>6-l)|0;y=(y|0)>0?0:y;break;}while(0);v=c[v>>2]|0;l=(v-y|0)/2|0;w=(v|0)<(l|0);if(((w?v:l)|0)<0)l=0;else l=w?v:l;v=v-l|0;y=a+28|0;x=(c[y>>2]|0)-x|0;c[y>>2]=x;if(!k)w=0;else w=k+(f<<2)|0;if((l|0)<(v|0)){p=c[p>>2]|0;j=(hb(a,s,f,v,n,w,q,u*m,p>>n)|0)<<(j>>1);s=v+((c[y>>2]|0)-x)|0;if(!((s|0)<=24|(r|0)==16384))l=l+(s+-24)|0;A=j|(hb(a,e,f,l,n,k,q,t*m,p)|0);i=o;return A|0;}else{p=c[p>>2]|0;e=hb(a,e,f,l,n,k,q,t*m,p)|0;k=l+((c[y>>2]|0)-x)|0;if(!((k|0)<=24|(r|0)==0))v=v+(k+-24)|0;A=e|(hb(a,s,f,v,n,w,q,u*m,p>>n)|0)<<(j>>1);i=o;return A|0;}}z=jb(x,y,l,h)|0;w=kb(x,y,l,z)|0;h=a+28|0;v=w;w=(c[h>>2]|0)-w|0;while(1){c[h>>2]=w;if(!((w|0)<0&(z|0)>0))break;B=w+v|0;c[h>>2]=B;C=z+-1|0;A=kb(x,y,l,C)|0;v=A;z=C;w=B-A|0;}if(z){a=lb(z)|0;if(s){C=yd(e,f,a,r,j,q,m)|0;i=o;return C|0;}else{C=vd(e,f,a,r,j,q)|0;i=o;return C|0;}}if(!s){C=0;i=o;return C|0;}j=(1<<j)+-1|0;q=j&n;c[p>>2]=q;if(!q){wj(e|0,0,f<<2|0)|0;C=0;i=o;return C|0;}p=a+36|0;a:do if(!k){k=0;while(1){if((k|0)>=(f|0))break a;C=Ma(c[p>>2]|0)|0;c[p>>2]=C;g[e+(k<<2)>>2]=+(C>>20|0);k=k+1|0;}}else{j=0;while(1){if((j|0)>=(f|0)){j=q;break a;}C=Ma(c[p>>2]|0)|0;c[p>>2]=C;g[e+(j<<2)>>2]=+g[k+(j<<2)>>2]+((C&32768|0)==0?-.00390625:.00390625);j=j+1|0;}}while(0);Ad(e,f,m,c[a+40>>2]|0);C=j;i=o;return C|0;}function ib(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,h=0,j=0,k=0,l=0,m=0;h=i;j=$(b,d)|0;f=i;i=i+((4*j|0)+15&-16)|0;if(!e){l=0;while(1){if((l|0)>=(d|0))break;e=$(l,b)|0;k=0;while(1){if((k|0)>=(b|0))break;g[f+(($(k,d)|0)+l<<2)>>2]=+g[a+(e+k<<2)>>2];k=k+1|0;}l=l+1|0;}m=j<<2;yj(a|0,f|0,m|0)|0;i=h;return;}l=d+-2|0;m=0;while(1){if((m|0)>=(d|0))break;e=56+(l+m<<2)|0;k=0;while(1){if((k|0)>=(b|0))break;g[f+(($(k,d)|0)+m<<2)>>2]=+g[a+(($(c[e>>2]|0,b)|0)+k<<2)>>2];k=k+1|0;}m=m+1|0;}m=j<<2;yj(a|0,f|0,m|0)|0;i=h;return;}function jb(a,e,f,g){a=a|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;j=i;h=c[a+100>>2]|0;e=($(f+1|0,c[a+8>>2]|0)|0)+e|0;e=b[(c[a+96>>2]|0)+(e<<1)>>1]|0;a=g+-1|0;f=d[h+e>>0]|0;g=0;k=0;while(1){if((k|0)>=6)break;l=g+f+1>>1;m=(d[h+(e+l)>>0]|0)<(a|0);f=m?f:l;g=m?l:g;k=k+1|0;}if(!g)k=-1;else k=d[h+(e+g)>>0]|0;i=j;return((a-k|0)>((d[h+(e+f)>>0]|0)-a|0)?f:g)|0;}function kb(a,e,f,g){a=a|0;e=e|0;f=f|0;g=g|0;var h=0;h=i;if(!g){g=0;i=h;return g|0;}f=$(f+1|0,c[a+8>>2]|0)|0;g=(d[(c[a+100>>2]|0)+((b[(c[a+96>>2]|0)+(f+e<<1)>>1]|0)+g)>>0]|0)+1|0;i=h;return g|0;}function lb(a){a=a|0;if((a|0)>=8)a=(a&7|8)<<(a>>3)+-1;return a|0;}function mb(a){a=a|0;var b=0;b=i;if((a|0)==8e3)a=6;else if((a|0)==48e3)a=1;else if((a|0)==24e3)a=2;else if((a|0)==16e3)a=3;else if((a|0)==12e3)a=4;else a=0;i=b;return a|0;}function nb(a,b,c,d,e,f,h,j,k,l,m){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=+f;h=+h;j=j|0;k=k|0;l=l|0;m=m|0;var n=0.0,o=0,p=0.0,q=0.0,r=0.0,s=0.0,t=0.0,u=0.0,v=0.0,w=0.0,x=0.0,y=0.0,z=0.0;o=i;if(f==0.0&h==0.0){if((b|0)==(a|0)){i=o;return;}zj(a|0,b|0,e<<2|0)|0;i=o;return;}s=+g[176+(j*12|0)>>2]*f;t=+g[180+(j*12|0)>>2]*f;n=+g[184+(j*12|0)>>2]*f;p=+g[176+(k*12|0)>>2]*h;q=+g[180+(k*12|0)>>2]*h;r=+g[184+(k*12|0)>>2]*h;m=f==h&(c|0)==(d|0)&(j|0)==(k|0)?0:m;k=0;w=+g[b+(1-d<<2)>>2];f=+g[b+(0-d<<2)>>2];v=+g[b+(~d<<2)>>2];u=+g[b+(-2-d<<2)>>2];while(1){if((k|0)>=(m|0))break;y=+g[b+(k-d+2<<2)>>2];x=+g[l+(k<<2)>>2];x=x*x;z=1.0-x;j=k-c|0;g[a+(k<<2)>>2]=+g[b+(k<<2)>>2]+z*s*+g[b+(j<<2)>>2]+z*t*(+g[b+(j+1<<2)>>2]+ +g[b+(j+-1<<2)>>2])+z*n*(+g[b+(j+2<<2)>>2]+ +g[b+(j+-2<<2)>>2])+x*p*f+x*q*(w+v)+x*r*(y+u);x=w;k=k+1|0;w=y;u=v;v=f;f=x;}if(!(h==0.0)){ob(a+(k<<2)|0,b+(k<<2)|0,d,e-k|0,p,q,r);i=o;return;}if((b|0)==(a|0)){i=o;return;}zj(a+(m<<2)|0,b+(m<<2)|0,e-m<<2|0)|0;i=o;return;}function ob(a,b,c,d,e,f,h){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=+f;h=+h;var j=0.0,k=0,l=0.0,m=0.0,n=0.0,o=0,p=0.0,q=0.0;o=i;k=0;m=+g[b+(1-c<<2)>>2];l=+g[b+(0-c<<2)>>2];n=+g[b+(~c<<2)>>2];j=+g[b+(-2-c<<2)>>2];while(1){if((k|0)>=(d|0))break;q=+g[b+(k-c+2<<2)>>2];g[a+(k<<2)>>2]=+g[b+(k<<2)>>2]+l*e+(m+n)*f+(q+j)*h;p=m;k=k+1|0;m=q;j=n;n=l;l=p;}i=o;return;}function pb(a,e,f,g){a=a|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;l=i;j=a+8|0;k=a+32|0;h=(f<<1)+g+-1|0;a=a+104|0;m=0;while(1){n=c[j>>2]|0;if((m|0)>=(n|0))break;o=m+1|0;p=c[k>>2]|0;n=($(n,h)|0)+m|0;c[e+(m<<2)>>2]=($($((d[(c[a>>2]|0)+n>>0]|0)+64|0,g)|0,(b[p+(o<<1)>>1]|0)-(b[p+(m<<1)>>1]|0)<<f)|0)>>2;m=o;}i=l;return;}function qb(){return 248;}function rb(a){a=a|0;var b=0;b=i;a=sb(Xc()|0,a)|0;i=b;return a|0;}function sb(a,b){a=a|0;b=b|0;b=(($((c[a+4>>2]|0)+2048|0,b)|0)<<2)+84+(b*96|0)|0;return b+(c[a+8>>2]<<5)|0;}function tb(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;e=i;d=ub(a,Xc()|0,d)|0;if(!d){d=mb(b)|0;c[a+16>>2]=d;i=e;return((d|0)==0?-1:0)|0;}else{i=e;return d|0;}return 0;}function ub(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;e=i;i=i+16|0;if((d|0)<0|(d|0)>2){d=-1;i=e;return d|0;}if(!a){d=-7;i=e;return d|0;}wj(a|0,0,sb(b,d)|0)|0;c[a>>2]=b;c[a+4>>2]=c[b+4>>2];c[a+8>>2]=d;c[a+12>>2]=d;c[a+16>>2]=1;c[a+20>>2]=0;c[a+24>>2]=c[b+12>>2];c[a+28>>2]=1;c[a+32>>2]=0;c[a+48>>2]=0;Cb(a,4028,e);d=0;i=e;return d|0;}function vb(a,d,e,f,h,j,k){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0.0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ka=0,la=0.0,ma=0.0;l=i;i=i+80|0;A=l+32|0;O=l+24|0;p=l+16|0;M=l+8|0;L=l+4|0;K=l;m=c[a+8>>2]|0;c[M>>2]=0;c[L>>2]=0;J=c[a+12>>2]|0;n=c[a>>2]|0;o=c[n+8>>2]|0;z=c[n+4>>2]|0;V=c[n+32>>2]|0;q=c[a+20>>2]|0;r=c[a+24>>2]|0;s=a+16|0;v=$(c[s>>2]|0,h)|0;u=$(z+2072|0,m)|0;D=a+(u<<2)+84|0;x=o<<1;h=u+x|0;B=a+(h<<2)+84|0;t=h+x|0;F=a+(t<<2)+84|0;y=t+x|0;C=n+44|0;w=c[n+36>>2]|0;H=0;while(1){if((H|0)>(w|0)){m=-1;P=85;break;}if((c[C>>2]<<H|0)==(v|0))break;H=H+1|0;}if((P|0)==85){i=l;return m|0;}G=1<<H;if((e|0)<0|(e|0)>1275|(f|0)==0){ka=-1;i=l;return ka|0;}w=c[C>>2]<<H;I=z+2048|0;S=2048-w|0;E=0;do{ka=$(E,I)|0;c[O+(E<<2)>>2]=a+(ka<<2)+84;c[p+(E<<2)>>2]=a+(ka+S<<2)+84;E=E+1|0;}while((E|0)<(m|0));N=c[n+12>>2]|0;N=(r|0)>(N|0)?N:r;if((d|0)==0|(e|0)<2){wb(a,w,H);xb(p,f,w,m,c[s>>2]|0,+g[n+16>>2],a+76|0,k);ka=(v|0)/(c[s>>2]|0)|0;i=l;return ka|0;}if(!j)kc(A,d,e);else A=j;I=(J|0)==1;a:do if(I){j=0;while(1){if((j|0)>=(o|0))break a;ka=a+(u+j<<2)+84|0;la=+g[ka>>2];R=+g[a+(u+(o+j)<<2)+84>>2];g[ka>>2]=la>R?la:R;j=j+1|0;}}while(0);d=e<<3;E=A+20|0;Q=c[E>>2]|0;j=A+28|0;T=c[j>>2]|0;W=yb(Q,T)|0;if((W|0)<(d|0)){if((W|0)==1){U=rc(A,15)|0;if(!U){U=0;W=1;}else{Q=c[E>>2]|0;T=c[j>>2]|0;P=19;}}else U=0;}else{U=1;P=19;}if((P|0)==19){c[E>>2]=Q+(d-(yb(Q,T)|0));W=d;}if((q|0)==0?(W+16|0)<=(d|0):0){if(!(rc(A,1)|0)){R=0.0;Q=0;T=0;}else{Q=tc(A,6)|0;Q=(16<<Q)+(uc(A,Q+4|0)|0)+-1|0;P=uc(A,3)|0;if(((yb(c[E>>2]|0,c[j>>2]|0)|0)+2|0)>(d|0))T=0;else T=sc(A,272,2)|0;R=+(P+1|0)*.09375;}P=yb(c[E>>2]|0,c[j>>2]|0)|0;}else{Q=0;R=0.0;T=0;P=W;}if((H|0)>0?(P+3|0)<=(d|0):0){W=rc(A,3)|0;P=yb(c[E>>2]|0,c[j>>2]|0)|0;X=(W|0)==0;W=X?0:W;X=X?0:G;}else{W=0;X=0;}if((P+3|0)>(d|0))P=0;else P=rc(A,3)|0;od(n,q,r,D,P,A,J,H);P=ta()|0;Y=i;i=i+((4*o|0)+15&-16)|0;zb(q,r,W,Y,H,A);if(((yb(c[E>>2]|0,c[j>>2]|0)|0)+4|0)>(d|0))Z=2;else Z=sc(A,280,5)|0;aa=i;i=i+((4*o|0)+15&-16)|0;pb(n,aa,H,J);_=i;i=i+((4*o|0)+15&-16)|0;da=6;ca=q;ea=jc(A)|0;fa=e<<6;while(1){if((ca|0)>=(r|0))break;ba=ca+1|0;ha=($(J,(b[V+(ba<<1)>>1]|0)-(b[V+(ca<<1)>>1]|0)|0)|0)<<H;ia=ha<<3;ga=(ha|0)<48;if((ia|0)>=((ga?48:ha)|0))ia=ga?48:ha;ka=aa+(ca<<2)|0;ga=0;ha=da;while(1){if((ea+(ha<<3)|0)>=(fa|0))break;if((ga|0)>=(c[ka>>2]|0))break;ha=rc(A,ha)|0;ea=jc(A)|0;if(!ha)break;ga=ga+ia|0;ha=1;fa=fa-ia|0;}c[_+(ca<<2)>>2]=ga;if((ga|0)<=0){ca=ba;continue;}da=(da|0)<3?2:da+-1|0;ca=ba;}V=i;i=i+((4*o|0)+15&-16)|0;if((ea+48|0)>(fa|0))fa=5;else fa=sc(A,288,7)|0;ca=e<<6;da=ca-(jc(A)|0)+-1|0;e=(W|0)==0;if((e^1)&(H|0)>1)ba=(da|0)>=((H<<3)+16|0)?8:0;else ba=0;ka=da-ba|0;ea=i;i=i+((4*o|0)+15&-16)|0;da=i;i=i+((4*o|0)+15&-16)|0;_=sd(n,q,r,_,aa,fa,M,L,ka,K,ea,V,da,J,H,A,0,0,0)|0;pd(n,q,r,D,V,A,J);aa=S+((z|0)/2|0)<<2;S=0;do{ka=c[O+(S<<2)>>2]|0;zj(ka|0,ka+(w<<2)|0,aa|0)|0;S=S+1|0;}while((S|0)<(m|0));S=$(J,o)|0;fa=i;i=i+((1*S|0)+15&-16)|0;ka=$(J,w)|0;aa=i;i=i+((4*ka|0)+15&-16)|0;if((J|0)==2)ga=aa+(w<<2)|0;else ga=0;O=a+36|0;ha=a+32|0;Va(0,n,q,r,aa,ga,fa,0,ea,X,Z,c[L>>2]|0,c[M>>2]|0,Y,ca-ba|0,c[K>>2]|0,A,H,_,O,c[ha>>2]|0);if(ba){ka=(uc(A,1)|0)==0;qd(n,q,r,D,V,da,d-(yb(c[E>>2]|0,c[j>>2]|0)|0)|0,A,J);if(!ka)Ra(n,aa,fa,H,J,w,q,r,D,B,F,ea,c[O>>2]|0,c[ha>>2]|0);}else qd(n,q,r,D,V,da,d-(yb(c[E>>2]|0,c[j>>2]|0)|0)|0,A,J);b:do if(U){K=0;while(1){if((K|0)>=(S|0))break b;g[a+(u+K<<2)+84>>2]=-28.0;K=K+1|0;}}while(0);Ab(n,aa,p,D,q,N,J,m,W,H,c[s>>2]|0,U);K=a+52|0;S=a+56|0;M=a+64|0;L=a+60|0;U=a+72|0;N=a+68|0;J=n+60|0;H=(H|0)==0;V=0;do{ka=c[K>>2]|0;ka=(ka|0)>15?ka:15;c[K>>2]=ka;ia=c[S>>2]|0;ia=(ia|0)>15?ia:15;c[S>>2]=ia;W=c[p+(V<<2)>>2]|0;nb(W,W,ia,ka,c[C>>2]|0,+g[M>>2],+g[L>>2],c[U>>2]|0,c[N>>2]|0,c[J>>2]|0,z);if(!H){ka=c[C>>2]|0;ia=W+(ka<<2)|0;nb(ia,ia,c[K>>2]|0,Q,w-ka|0,+g[L>>2],R,c[N>>2]|0,T,c[J>>2]|0,z);}V=V+1|0;}while((V|0)<(m|0));c[S>>2]=c[K>>2];g[M>>2]=+g[L>>2];c[U>>2]=c[N>>2];c[K>>2]=Q;g[L>>2]=R;c[N>>2]=T;if(!H){c[S>>2]=Q;g[M>>2]=R;c[U>>2]=T;}if(I)yj(a+(u+o<<2)+84|0,D|0,o<<2|0)|0;c:do if(e){z=o<<3;yj(F|0,B|0,z|0)|0;yj(B|0,D|0,z|0)|0;R=+(G|0)*.0010000000474974513;z=0;while(1){if((z|0)>=(x|0)){x=0;break c;}ka=a+(y+z<<2)+84|0;ma=+g[ka>>2]+R;la=+g[a+(u+z<<2)+84>>2];g[ka>>2]=ma<la?ma:la;z=z+1|0;}}else{y=0;while(1){if((y|0)>=(x|0)){x=0;break c;}ka=a+(h+y<<2)+84|0;la=+g[ka>>2];ma=+g[a+(u+y<<2)+84>>2];g[ka>>2]=la<ma?la:ma;y=y+1|0;}}while(0);do{y=$(x,o)|0;z=0;while(1){if((z|0)>=(q|0)){z=r;break;}ka=y+z|0;g[a+(u+ka<<2)+84>>2]=0.0;g[a+(t+ka<<2)+84>>2]=-28.0;g[a+(h+ka<<2)+84>>2]=-28.0;z=z+1|0;}while(1){if((z|0)>=(o|0))break;ka=y+z|0;g[a+(u+ka<<2)+84>>2]=0.0;g[a+(t+ka<<2)+84>>2]=-28.0;g[a+(h+ka<<2)+84>>2]=-28.0;z=z+1|0;}x=x+1|0;}while((x|0)<2);c[O>>2]=c[j>>2];xb(p,f,w,m,c[s>>2]|0,+g[n+16>>2],a+76|0,k);c[a+48>>2]=0;if((yb(c[E>>2]|0,c[j>>2]|0)|0)>(d|0))m=-3;else{if(Bb(c[A+44>>2]|0)|0)c[a+40>>2]=1;m=(v|0)/(c[s>>2]|0)|0;}ja(P|0);ka=m;i=l;return ka|0;}function wb(a,d,e){a=a|0;d=d|0;e=e|0;var f=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0.0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0.0,Q=0.0,R=0,S=0,T=0,U=0,V=0.0,W=0.0;j=i;i=i+4416|0;f=j+4400|0;t=j+4392|0;q=j+296|0;r=j+192|0;p=j+96|0;o=j;h=c[a+8>>2]|0;y=c[a>>2]|0;x=c[y+8>>2]|0;n=c[y+4>>2]|0;u=c[y+32>>2]|0;l=n+2048|0;m=2048-d|0;k=0;do{U=$(k,l)|0;c[f+(k<<2)>>2]=a+(U<<2)+84;c[t+(k<<2)>>2]=a+(U+m<<2)+84;k=k+1|0;}while((k|0)<(h|0));s=$(l,h)|0;z=$(h,n+2072|0)|0;B=x<<1;B=z+B+B+B|0;k=a+48|0;l=c[k>>2]|0;w=c[a+20>>2]|0;A=(l|0)>4;if(!((A^1)&(w|0)==0)){r=c[a+24>>2]|0;p=c[y+12>>2]|0;o=(r|0)<(p|0);if((w|0)>((o?r:p)|0))p=w;else p=o?r:p;U=$(h,d)|0;o=ta()|0;q=i;i=i+((4*U|0)+15&-16)|0;if(A)z=B;else{v=(l|0)==0?1.5:.5;A=0;do{B=$(A,x)|0;s=w;while(1){if((s|0)>=(r|0))break;U=a+(z+(B+s)<<2)+84|0;g[U>>2]=+g[U>>2]-v;s=s+1|0;}A=A+1|0;}while((A|0)<(h|0));}r=a+(z<<2)+84|0;A=a+36|0;z=a+32|0;E=c[A>>2]|0;x=0;while(1){if((x|0)>=(h|0))break;s=$(x,d)|0;D=w;while(1){if((D|0)>=(p|0))break;C=b[u+(D<<1)>>1]|0;B=s+(C<<e)|0;D=D+1|0;C=(b[u+(D<<1)>>1]|0)-C<<e;F=0;while(1){if((F|0)>=(C|0))break;U=Ma(E)|0;g[q+(B+F<<2)>>2]=+(U>>20|0);E=U;F=F+1|0;}Ad(q+(B<<2)|0,C,1.0,c[z>>2]|0);}x=x+1|0;}c[A>>2]=E;m=m+(n>>>1)<<2;n=0;do{U=c[f+(n<<2)>>2]|0;zj(U|0,U+(d<<2)|0,m|0)|0;n=n+1|0;}while((n|0)<(h|0));Ab(y,q,t,r,w,p,h,h,0,e,c[a+16>>2]|0,0);ja(o|0);U=l+1|0;c[k>>2]=U;i=j;return;}u=(l|0)==0;if(u){e=a+32|0;w=Db(f,h,c[e>>2]|0)|0;c[a+44>>2]=w;v=1.0;}else{e=a+32|0;v=.800000011920929;w=c[a+44>>2]|0;}t=ta()|0;x=i;i=i+((4*n|0)+15&-16)|0;B=c[y+60>>2]|0;J=w<<1;L=(J|0)<1024;K=m<<2;A=1024-w|0;F=n+d|0;I=1024-d+A|0;z=m+-1|0;H=a+52|0;E=a+60|0;G=a+68|0;C=(n|0)/2|0;y=n+-1|0;D=0;do{M=c[f+(D<<2)>>2]|0;N=0;while(1){if((N|0)>=1024)break;g[q+(N<<2)>>2]=+g[M+(N+1024<<2)>>2];N=N+1|0;}if(u){ec(q,r,B,n,24,1024,c[e>>2]|0);g[r>>2]=+g[r>>2]*1.000100016593933;N=1;while(1){if((N|0)>=25)break;U=r+(N<<2)|0;Q=+g[U>>2];V=+(N|0);g[U>>2]=Q-Q*6400000711437315.0e-20*V*V;N=N+1|0;}ac(a+(s+(D*24|0)<<2)+84|0,r,24);}T=L?J:1024;N=2048-T+-1|0;R=0;while(1){if((R|0)>=24)break;g[p+(R<<2)>>2]=+g[M+(N-R<<2)>>2];R=R+1|0;}R=q+(1024-T<<2)|0;N=a+(s+(D*24|0)<<2)+84|0;bc(R,N,R,T,p,c[e>>2]|0);R=T>>1;S=1024-R|0;T=1024-T|0;Q=1.0;O=1.0;U=0;while(1){if((U|0)>=(R|0))break;W=+g[q+(S+U<<2)>>2];V=+g[q+(T+U<<2)>>2];Q=Q+W*W;O=O+V*V;U=U+1|0;}Q=+P(+((Q<O?Q:O)/O));zj(M|0,M+(d<<2)|0,K|0)|0;O=0.0;V=v*Q;R=0;S=0;while(1){if((R|0)>=(F|0)){R=0;break;}if((S|0)>=(w|0)){V=V*Q;S=S-w|0;}g[M+(m+R<<2)>>2]=V*+g[q+(A+S<<2)>>2];W=+g[M+(I+S<<2)>>2];O=O+W*W;R=R+1|0;S=S+1|0;}while(1){if((R|0)>=24)break;g[o+(R<<2)>>2]=+g[M+(z-R<<2)>>2];R=R+1|0;}U=M+(m<<2)|0;dc(U,N,U,F,o,c[e>>2]|0);Q=0.0;N=0;while(1){if((N|0)>=(F|0))break;W=+g[M+(m+N<<2)>>2];Q=Q+W*W;N=N+1|0;}a:do if(O>Q*.20000000298023224){if(O<Q){O=+P(+((O+1.0)/(Q+1.0)));Q=1.0-O;N=0;while(1){if((N|0)>=(n|0)){N=n;break;}U=M+(m+N<<2)|0;g[U>>2]=(1.0-+g[B+(N<<2)>>2]*Q)*+g[U>>2];N=N+1|0;}while(1){if((N|0)>=(F|0))break a;U=M+(m+N<<2)|0;g[U>>2]=O*+g[U>>2];N=N+1|0;}}}else{N=0;while(1){if((N|0)>=(F|0))break a;g[M+(m+N<<2)>>2]=0.0;N=N+1|0;}}while(0);U=c[H>>2]|0;W=-+g[E>>2];N=c[G>>2]|0;nb(x,M+8192|0,U,U,n,W,W,N,N,0,0);N=0;while(1){if((N|0)>=(C|0))break;g[M+(N+2048<<2)>>2]=+g[B+(N<<2)>>2]*+g[x+(y-N<<2)>>2]+ +g[B+(n-N+-1<<2)>>2]*+g[x+(N<<2)>>2];N=N+1|0;}D=D+1|0;}while((D|0)<(h|0));ja(t|0);U=l+1|0;c[k>>2]=U;i=j;return;}function xb(a,b,d,e,f,h,j,k){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=+h;j=j|0;k=k|0;var l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0.0,u=0,v=0.0;k=i;n=i;i=i+((4*d|0)+15&-16)|0;l=(d|0)/(f|0)|0;m=(f|0)>1;s=0;o=0;do{q=j+(o<<2)|0;t=+g[q>>2];r=c[a+(o<<2)>>2]|0;if(!m){u=0;while(1){if((u|0)>=(d|0))break;v=+g[r+(u<<2)>>2]+t+1.0000000031710769e-30;g[b+(o+($(u,e)|0)<<2)>>2]=v*30517578125.0e-15;t=v*h;u=u+1|0;}g[q>>2]=t;if(s)p=9;}else{p=0;while(1){if((p|0)>=(d|0))break;v=+g[r+(p<<2)>>2]+t+1.0000000031710769e-30;g[n+(p<<2)>>2]=v;t=v*h;p=p+1|0;}g[q>>2]=t;s=1;p=9;}a:do if((p|0)==9){p=0;q=0;while(1){if((q|0)>=(l|0))break a;g[b+(o+($(q,e)|0)<<2)>>2]=+g[n+(($(q,f)|0)<<2)>>2]*30517578125.0e-15;q=q+1|0;}}while(0);o=o+1|0;}while((o|0)<(e|0));i=k;return;}function yb(a,b){a=a|0;b=b|0;var c=0;c=i;b=(vj(b|0)|0)+-32+a|0;i=c;return b|0;}function zb(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0;j=i;n=c[h+4>>2]<<3;l=h+20|0;m=h+28|0;s=yb(c[l>>2]|0,c[m>>2]|0)|0;o=(e|0)!=0;r=o?2:4;if((g|0)>0)k=(s+r+1|0)>>>0<=n>>>0;else k=0;n=n-(k&1)|0;o=o?4:5;q=0;p=b;t=s;s=0;while(1){if((p|0)>=(d|0))break;if((t+r|0)>>>0<=n>>>0){r=q^(rc(h,r)|0);q=r;t=yb(c[l>>2]|0,c[m>>2]|0)|0;s=s|r;}c[f+(p<<2)>>2]=q;r=o;p=p+1|0;}l=e<<2;if(k?(a[l+s+(216+(g<<3))>>0]|0)!=(a[(l|2)+s+(216+(g<<3))>>0]|0):0)h=(rc(h,1)|0)<<1;else h=0;h=l+h|0;while(1){if((b|0)>=(d|0))break;t=f+(b<<2)|0;c[t>>2]=a[h+(c[t>>2]|0)+(216+(g<<3))>>0];b=b+1|0;}i=j;return;}function Ab(a,b,d,e,f,h,j,k,l,m,n,o){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;var p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0;p=i;r=c[a+4>>2]|0;u=c[a+8>>2]|0;s=c[a+44>>2]|0;t=s<<m;q=i;i=i+((4*t|0)+15&-16)|0;v=1<<m;y=(l|0)==0;z=c[a+36>>2]|0;l=y?t:s;s=y?1:v;m=y?z-m|0:z;if((k|0)==2){if((j|0)==1){Qa(a,b,q,e,f,h,v,n,o);u=d+4|0;e=c[u>>2]|0;b=(r|0)/2|0;yj(e+(b<<2)|0,q|0,t<<2|0)|0;t=a+64|0;a=a+60|0;v=0;while(1){if((v|0)>=(s|0)){d=0;break;}z=(c[d>>2]|0)+(($(l,v)|0)<<2)|0;Wc(t,e+(b+v<<2)|0,z,c[a>>2]|0,r,m,s);v=v+1|0;}while(1){if((d|0)>=(s|0))break;z=(c[u>>2]|0)+(($(l,d)|0)<<2)|0;Wc(t,q+(d<<2)|0,z,c[a>>2]|0,r,m,s);d=d+1|0;}i=p;return;}}else if((k|0)==1&(j|0)==2){k=c[d>>2]|0;j=(r|0)/2|0;Qa(a,b,q,e,f,h,v,n,o);Qa(a,b+(t<<2)|0,k+(j<<2)|0,e+(u<<2)|0,f,h,v,n,o);u=0;while(1){if((u|0)>=(t|0))break;z=q+(u<<2)|0;g[z>>2]=(+g[z>>2]+ +g[k+(j+u<<2)>>2])*.5;u=u+1|0;}t=a+64|0;u=a+60|0;a=0;while(1){if((a|0)>=(s|0))break;z=(c[d>>2]|0)+(($(l,a)|0)<<2)|0;Wc(t,q+(a<<2)|0,z,c[u>>2]|0,r,m,s);a=a+1|0;}i=p;return;}y=a+64|0;z=a+60|0;x=0;do{Qa(a,b+(($(x,t)|0)<<2)|0,q,e+(($(x,u)|0)<<2)|0,f,h,v,n,o);j=d+(x<<2)|0;w=0;while(1){if((w|0)>=(s|0))break;A=(c[j>>2]|0)+(($(l,w)|0)<<2)|0;Wc(y,q+(w<<2)|0,A,c[z>>2]|0,r,m,s);w=w+1|0;}x=x+1|0;}while((x|0)<(k|0));i=p;return;}function Bb(a){a=a|0;return a|0;}function Cb(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,h=0,j=0;e=i;i=i+16|0;f=e;c[f>>2]=d;a:do switch(b|0){case 10008:{h=c[f>>2]|0;b=c[h>>2]|0;c[f>>2]=h+4;if((b|0)<1|(b|0)>2)a=25;else{c[a+12>>2]=b;a=24;}break;};case 10016:{d=c[f>>2]|0;h=c[d>>2]|0;c[f>>2]=d+4;c[a+28>>2]=h;a=24;break;};case 4027:{h=c[f>>2]|0;b=c[h>>2]|0;c[f>>2]=h+4;if(!b)a=25;else{c[b>>2]=(c[a+4>>2]|0)/(c[a+16>>2]|0)|0;a=24;}break;};case 10007:{h=c[f>>2]|0;b=c[h>>2]|0;c[f>>2]=h+4;if(!b)a=25;else{a=a+40|0;c[b>>2]=c[a>>2];c[a>>2]=0;a=24;}break;};case 10012:{h=c[f>>2]|0;b=c[h>>2]|0;c[f>>2]=h+4;if((b|0)>=1?(b|0)<=(c[(c[a>>2]|0)+8>>2]|0):0){c[a+24>>2]=b;a=24;}else a=25;break;};case 4033:{h=c[f>>2]|0;b=c[h>>2]|0;c[f>>2]=h+4;if(!b)a=25;else{c[b>>2]=c[a+52>>2];a=24;}break;};case 10015:{h=c[f>>2]|0;b=c[h>>2]|0;c[f>>2]=h+4;if(!b)a=25;else{c[b>>2]=c[a>>2];a=24;}break;};case 10010:{h=c[f>>2]|0;b=c[h>>2]|0;c[f>>2]=h+4;if((b|0)>=0?(b|0)<(c[(c[a>>2]|0)+8>>2]|0):0){c[a+20>>2]=b;a=24;}else a=25;break;};case 4031:{h=c[f>>2]|0;b=c[h>>2]|0;c[f>>2]=h+4;if(!b)a=25;else{c[b>>2]=c[a+36>>2];a=24;}break;};case 4028:{f=c[a+8>>2]|0;b=$((c[a+4>>2]|0)+2072|0,f)|0;j=c[a>>2]|0;h=c[j+8>>2]|0;d=h<<1;b=b+d|0;d=b+d|0;wj(a+36|0,0,(sb(j,f)|0)+-36|0)|0;f=0;while(1){if((f|0)>=(h<<1|0)){a=24;break a;}g[a+(d+f<<2)+84>>2]=-28.0;g[a+(b+f<<2)+84>>2]=-28.0;h=c[(c[a>>2]|0)+8>>2]|0;f=f+1|0;}};default:{i=e;return;}}while(0);if((a|0)==24){i=e;return;}else if((a|0)==25){i=e;return;}}function Db(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;f=i;i=i+4112|0;e=f+4096|0;g=f;Yc(a,g,2048,b,d);bd(g+1440|0,g,1328,620,e,d);i=f;return 720-(c[e>>2]|0)|0;}function Eb(a){a=a|0;var b=0;b=i;a=Fb(Xc()|0,a)|0;i=b;return a|0;}function Fb(a,b){a=a|0;b=b|0;var d=0;d=(($(c[a+4>>2]|0,b)|0)<<2)+200+(b<<12)|0;b=d+(($(b*3|0,c[a+8>>2]|0)|0)<<2)|0;return b|0;}function Gb(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0;f=i;e=Hb(a,Xc()|0,d,e)|0;if(e){d=e;i=f;return d|0;}c[a+28>>2]=mb(b)|0;d=0;i=f;return d|0;}function Hb(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0;f=i;i=i+16|0;if((d|0)<0|(d|0)>2){e=-1;i=f;return e|0;}if((a|0)==0|(b|0)==0){e=-7;i=f;return e|0;}wj(a|0,0,Fb(b,d)|0)|0;c[a>>2]=b;c[a+4>>2]=d;c[a+8>>2]=d;c[a+28>>2]=1;c[a+32>>2]=0;c[a+36>>2]=c[b+12>>2];c[a+48>>2]=1;c[a+72>>2]=e;c[a+52>>2]=1;c[a+16>>2]=1;c[a+40>>2]=-1;c[a+44>>2]=0;c[a+12>>2]=0;c[a+24>>2]=5;c[a+60>>2]=24;Xb(a,4028,f)|0;e=0;i=f;return e|0;}function Ib(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;var f=0,h=0,j=0.0,k=0,l=0.0,m=0.0,n=0.0,o=0,p=0;h=i;i=i+112|0;f=h;j=+g[b>>2];a:do if((e|0)==1){g[f>>2]=j;c=1;while(1){if((c|0)>=(d|0))break a;m=j+-1.0;l=+g[b+(c<<2)>>2];l=m>l?m:l;g[f+(c<<2)>>2]=l;j=l;c=c+1|0;}}else{m=+g[b+(c<<2)>>2];j=j>m?j:m;g[f>>2]=j;k=1;while(1){if((k|0)>=(d|0))break a;n=j+-1.0;l=+g[b+(k<<2)>>2];m=+g[b+(k+c<<2)>>2];p=l>m;o=n>(p?l:m);m=o|p?o?n:l:m;g[f+(k<<2)>>2]=m;j=m;k=k+1|0;}}while(0);b=d+-2|0;while(1){if((b|0)<=-1)break;p=f+(b<<2)|0;m=+g[p>>2];n=+g[f+(b+1<<2)>>2]+-1.0;g[p>>2]=m>n?m:n;b=b+-1|0;}b=d+-1|0;c=0;j=0.0;k=2;b:while(1){while(1){if((k|0)<(b|0))break;c=c+1|0;if((c|0)<(e|0))k=2;else break b;}m=+g[a+(k<<2)>>2];n=+g[f+(k<<2)>>2];n=(m<0.0?0.0:m)-(n<0.0?0.0:n);j=j+(n<0.0?0.0:n);k=k+1|0;}p=j/+($(d+-3|0,e)|0)>1.0&1;i=h;return p|0;}function Jb(a,b,c,d,e,f,h,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0,l=0.0,m=0.0,n=0,o=0.0;k=i;l=+g[f>>2];m=+g[h>>2];do if(!(+g[f+4>>2]==0.0)){f=(c|0)/(e|0)|0;if((e|0)!=1)n=9;}else{if((e|0)!=1){f=(c|0)/(e|0)|0;n=9;break;}if(!j)e=0;else{f=(c|0)/(e|0)|0;break;}while(1){if((e|0)>=(c|0))break;o=+g[a+(($(e,d)|0)<<2)>>2]*32768.0;g[b+(e<<2)>>2]=o-m;m=l*o;e=e+1|0;}g[h>>2]=m;i=k;return;}while(0);if((n|0)==9)wj(b|0,0,c<<2|0)|0;n=0;while(1){if((n|0)>=(f|0))break;g[b+(($(n,e)|0)<<2)>>2]=+g[a+(($(n,d)|0)<<2)>>2]*32768.0;n=n+1|0;}a:do if(!j)e=0;else{d=0;while(1){if((d|0)>=(f|0)){e=0;break a;}a=b+(($(d,e)|0)<<2)|0;o=+g[a>>2];if(!(o>65536.0)){if(o<-65536.0)o=-65536.0;}else o=65536.0;g[a>>2]=o;d=d+1|0;}}while(0);while(1){if((e|0)>=(c|0))break;n=b+(e<<2)|0;o=+g[n>>2];g[n>>2]=o-m;m=l*o;e=e+1|0;}g[h>>2]=m;i=k;return;}function Kb(a,d,e,f,h,j){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0.0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ka=0,la=0,ma=0,na=0.0,oa=0.0,pa=0,qa=0,ra=0,sa=0,ua=0.0,va=0,wa=0,xa=0.0,ya=0,za=0,Aa=0,Ba=0,Ca=0,Da=0.0,Ea=0.0,Fa=0;k=i;i=i+96|0;C=k+40|0;V=k+32|0;s=k+28|0;P=k+24|0;v=k+20|0;t=k+16|0;U=k+12|0;F=k+8|0;G=k+4|0;N=k;o=c[a+4>>2]|0;r=c[a+8>>2]|0;c[s>>2]=15;g[P>>2]=0.0;c[v>>2]=0;c[U>>2]=0;u=c[a>>2]|0;n=c[u+8>>2]|0;M=c[u+4>>2]|0;L=c[u+32>>2]|0;l=c[a+32>>2]|0;m=c[a+36>>2]|0;g[F>>2]=0.0;if((h|0)<2|(d|0)==0){Ca=-1;i=k;return Ca|0;}W=a+28|0;O=$(c[W>>2]|0,e)|0;e=u+44|0;I=u+36|0;p=c[I>>2]|0;x=0;while(1){if((x|0)>(p|0)){a=-1;X=217;break;}if((c[e>>2]<<x|0)==(O|0))break;x=x+1|0;}if((X|0)==217){i=k;return a|0;}T=1<<x;B=c[e>>2]<<x;Q=a+(($(o,M)|0)<<2)+200|0;p=M+1024|0;e=$(o,p)|0;y=a+(e<<2)+200|0;w=$(o,n)|0;p=p+n|0;q=$(o,p)|0;z=a+(q<<2)+200|0;p=$(o,p+n|0)|0;A=a+(p<<2)+200|0;Z=(j|0)==0;if(Z){E=0;R=1;}else{R=Lb(c[j+20>>2]|0,c[j+28>>2]|0)|0;E=R+4>>3;}J=(h|0)<1275?h:1275;Y=J-E|0;S=a+44|0;h=c[a+40>>2]|0;if(c[S>>2]|0){if((h|0)==-1){h=-1;X=11;}else{X=c[u>>2]|0;X=(($(h,O)|0)+(X>>4)|0)/(X>>3|0)|0;O=J;_=X>>6;J=X;X=15;}}else X=11;if((X|0)==11){O=$(h,O)|0;if((h|0)!=-1){aa=c[u>>2]|0;aa=(((aa<<2)+((R|0)>1?O+R|0:O)|0)/(aa<<3|0)|0)-((c[a+48>>2]|0)!=0&1)|0;_=(J|0)<(aa|0);if(((_?J:aa)|0)<2){O=2;_=2;}else{O=_?J:aa;_=_?J:aa;}if((h|0)==-1){h=51e4;J=0;}else{J=0;X=15;}}else{O=J;h=51e4;_=J;J=0;}}if((X|0)==15)h=h-($((r*40|0)+20|0,(400>>>x)+-50|0)|0)|0;if(Z)wc(C,f,O);else C=j;j=(J|0)>0;if(((j?(c[a+52>>2]|0)!=0:0)?(H=(R|0)==1?2:0,D=c[a+164>>2]|0,Ca=(J<<1)-D>>6,(((H|0)>(Ca|0)?H:Ca)|0)<(Y|0)):0)?(ba=(J<<1)-D>>6,ba=(H|0)>(ba|0)?H:ba,(ba|0)<(Y|0)):0){O=E+ba|0;Hc(C,O);}else ba=Y;aa=O<<3;Z=c[u+12>>2]|0;Z=(m|0)>(Z|0)?Z:m;ha=B+M|0;Y=$(o,ha)|0;D=ta()|0;da=i;i=i+((4*Y|0)+15&-16)|0;Y=a+180|0;K=+g[Y>>2];H=$(r,B-M|0)|0;f=c[W>>2]|0;H=(H|0)/(f|0)|0;Ea=+Mb(d,H);Ea=K>Ea?K:Ea;K=+Mb(d+(H<<2)|0,($(r,M)|0)/(f|0)|0);g[Y>>2]=K;K=Ea>K?Ea:K;Y=a+60|0;f=K<=1.0/+(1<<c[Y>>2]|0);H=f&1;if((R|0)==1){Bc(C,H,15);if(f){if(j){aa=E+2|0;aa=(O|0)<(aa|0)?O:aa;Hc(C,aa);O=aa;_=aa;ba=2;aa=aa<<3;}R=O<<3;Ca=C+20|0;Ba=c[Ca>>2]|0;c[Ca>>2]=Ba+(R-(Lb(Ba,c[C+28>>2]|0)|0));}else{H=0;R=1;}}else H=0;f=a+16|0;ea=u+16|0;ga=K>65536.0;fa=0;do{Ca=da+(($(fa,ha)|0)+M<<2)|0;Jb(d+(fa<<2)|0,Ca,B,o,c[W>>2]|0,ea,a+(fa<<2)+148|0,((c[f>>2]|0)==0?0:ga)&1);fa=fa+1|0;}while((fa|0)<(o|0));M=a+68|0;if((c[M>>2]|0)!=0&(ba|0)>3){if((l|0)==0&(H|0)==0)X=33;else f=0;}else if((ba|0)>(r*12|0)&(l|0)==0&(H|0)==0)X=33;else f=0;if((X|0)==33)if((c[a+20>>2]|0)==0?(c[a+24>>2]|0)>4:0){if((c[a+116>>2]|0)==0|(x|0)==3)f=1;else f=(c[a+64>>2]|0)!=5010;}else f=0;ea=a+100|0;d=c[ea>>2]|0;Q=Nb(a,da,Q,o,B,d,s,P,N,f&1,ba)|0;K=+g[P>>2];if(!(K>.4000000059604645)?!(+g[a+108>>2]>.4000000059604645):0)f=0;else X=39;do if((X|0)==39){if((c[a+120>>2]|0)!=0?!(+g[a+124>>2]>.3):0){f=0;break;}Da=+(c[s>>2]|0);Ea=+(c[a+104>>2]|0);f=Da>Ea*1.26|Da<Ea*.79?1:0;}while(0);fa=(Q|0)==0;if(fa){if((l|0)==0?(R+16|0)<=(aa|0):0)Bc(C,0,1);}else{Bc(C,1,1);Aa=(c[s>>2]|0)+1|0;Ca=32-(vj(Aa|0)|0)|0;Ba=Ca+-5|0;Dc(C,Ba,6);Ec(C,Aa-(16<<Ba)|0,Ca+-1|0);Ec(C,c[N>>2]|0,3);Cc(C,d,304,2);}ga=a+24|0;if((c[ga>>2]|0)>0?(c[M>>2]|0)==0:0)pa=Ob(da,ha,o,F,U)|0;else pa=0;la=(x|0)>0;a:do if(la?((Lb(c[C+20>>2]|0,c[C+28>>2]|0)|0)+3|0)<=(aa|0):0){if(pa){R=$(o,B)|0;ka=i;i=i+((4*R|0)+15&-16)|0;R=i;i=i+((4*w|0)+15&-16)|0;ra=i;i=i+((4*w|0)+15&-16)|0;va=(T|0)==0;if(!va){Ca=(c[ga>>2]|0)>7;sa=Ca&1;P=$(r,n)|0;ha=i;i=i+((4*P|0)+15&-16)|0;if(Ca){Pb(u,0,da,ka,r,o,x,c[W>>2]|0);Na(u,ka,R,Z,r,x);rd(u,Z,m,R,ha,r);na=+(x|0)*.5;N=0;while(1){if((N|0)>=(P|0)){qa=T;N=0;break a;}Ca=ha+(N<<2)|0;g[Ca>>2]=+g[Ca>>2]+na;N=N+1|0;}}else{qa=T;N=0;}}else{qa=T;N=0;X=55;}}else{N=0;X=53;}}else{N=1;X=53;}while(0);if((X|0)==53){R=$(o,B)|0;ka=i;i=i+((4*R|0)+15&-16)|0;R=i;i=i+((4*w|0)+15&-16)|0;ra=i;i=i+((4*w|0)+15&-16)|0;va=1;pa=0;qa=0;X=55;}if((X|0)==55){sa=$(r,n)|0;ha=i;i=i+((4*sa|0)+15&-16)|0;sa=0;}Pb(u,qa,da,ka,r,o,x,c[W>>2]|0);P=(o|0)==2;if(P&(r|0)==1)c[U>>2]=0;Na(u,ka,R,Z,r,x);b:do if(c[M>>2]|0){Q=2;while(1){if((Q|0)>=(m|0))break b;Ca=R+(Q<<2)|0;Da=+g[Ca>>2];Ea=+g[R>>2]*9999999747378752.0e-20;Ea=Da<Ea?Da:Ea;g[Ca>>2]=Ea;g[Ca>>2]=Ea>1.0000000036274937e-15?Ea:1.0000000036274937e-15;Q=Q+1|0;}}while(0);rd(u,Z,m,R,ra,r);Q=$(r,n)|0;ia=i;i=i+((4*Q|0)+15&-16)|0;wj(ia|0,0,m<<2|0)|0;ma=(l|0)==0;do if(ma?(ca=c[a+192>>2]|0,(ca|0)!=0):0){wa=c[M>>2]|0;if(wa){ca=(wa|0)==0;na=0.0;ua=0.0;oa=0.0;break;}wa=c[a+92>>2]|0;wa=(wa|0)<2?2:wa;Aa=0;ua=0.0;oa=0.0;za=0;while(1){if((za|0)>=(r|0))break;ya=$(n,za)|0;na=ua;Ba=0;while(1){if((Ba|0)>=(wa|0))break;ua=+g[ca+(ya+Ba<<2)>>2];do if(ua<.25){if(!(ua>-2.0)){ua=-2.0;break;}if(ua>0.0)X=76;}else{ua=.25;X=76;}while(0);if((X|0)==76){X=0;ua=ua*.5;}Ca=Ba+1|0;Fa=(b[L+(Ca<<1)>>1]|0)-(b[L+(Ba<<1)>>1]|0)|0;Aa=Aa+Fa|0;na=na+ua*+((Ba<<1|1)-wa|0);oa=oa+ua*+(Fa|0);Ba=Ca;}ua=na;za=za+1|0;}na=oa/+(Aa|0)+.20000000298023224;oa=ua*6.0/+($($($(r,wa+-1|0)|0,wa+1|0)|0,wa)|0)*.5;if(oa<.03099999949336052){if(!(oa>-.03099999949336052))oa=-.03099999949336052;}else oa=.03099999949336052;za=(b[L+(wa<<1)>>1]|0)/2|0;X=0;while(1){ya=X+1|0;if((b[L+(ya<<1)>>1]|0)<(za|0))X=ya;else break;}ya=(r|0)==2;Aa=0;za=0;while(1){if((za|0)>=(wa|0))break;ua=na+oa*+(za-X|0);Ca=ca+(za<<2)|0;do if(ya){Ba=ca+(n+za<<2)|0;if(+g[Ca>>2]>+g[Ba>>2]){Ba=Ca;break;}}else Ba=Ca;while(0);Ea=+g[Ba>>2];ua=(Ea<0.0?Ea:0.0)-ua;if(ua>.25){g[ia+(za<<2)>>2]=ua+-.25;Aa=Aa+1|0;}za=za+1|0;}c:do if((Aa|0)>2){na=na+.25;if(na>0.0){wj(ia|0,0,wa<<2|0)|0;oa=0.0;na=0.0;break;}else X=0;while(1){if((X|0)>=(wa|0))break c;Fa=ia+(X<<2)|0;Ea=+g[Fa>>2]+-.25;g[Fa>>2]=Ea<0.0?0.0:Ea;X=X+1|0;}}while(0);na=na+.20000000298023224;ua=oa*64.0;X=98;}else{na=0.0;ua=0.0;X=98;}while(0);if((X|0)==98){ca=(c[M>>2]|0)==0;if(ca){if(va)xa=0.0;else xa=+(x|0)*.5;wa=(r|0)==2;Ea=-10.0;oa=0.0;va=l;while(1){if((va|0)>=(m|0))break;Ea=Ea+-1.0;Da=+g[ra+(va<<2)>>2]-xa;Da=Ea>Da?Ea:Da;do if(wa){Ea=+g[ra+(va+n<<2)>>2]-xa;if(Da>Ea)break;Da=Ea;}while(0);Ea=Da;oa=oa+Da;va=va+1|0;}va=a+196|0;xa=+g[va>>2];oa=oa/+(m-l|0)-xa;if(!(oa<-1.5)){if(oa>3.0)oa=3.0;}else oa=-1.5;g[va>>2]=xa+oa*.019999999552965164;}else oa=0.0;}if(!sa)yj(ha|0,ra|0,Q<<2|0)|0;if(la){va=C+20|0;sa=C+28|0;do if(((Lb(c[va>>2]|0,c[sa>>2]|0)|0)+3|0)<=(aa|0)&(pa|0)==0){if((c[ga>>2]|0)>4^1|ca^1){la=0;W=qa;}else{if(!(Ib(ra,y,n,m,r)|0)){la=0;W=qa;break;}Pb(u,T,da,ka,r,o,x,c[W>>2]|0);Na(u,ka,R,Z,r,x);rd(u,Z,m,R,ra,r);xa=+(x|0)*.5;W=0;while(1){if((W|0)>=(Q|0))break;Fa=ha+(W<<2)|0;g[Fa>>2]=+g[Fa>>2]+xa;W=W+1|0;}g[F>>2]=.20000000298023224;la=1;W=T;}}else{la=pa;W=qa;}while(0);if(((Lb(c[va>>2]|0,c[sa>>2]|0)|0)+3|0)<=(aa|0))Bc(C,la,3);}else{la=pa;W=qa;}da=$(r,B)|0;ca=i;i=i+((4*da|0)+15&-16)|0;Pa(u,ka,ca,R,Z,r,T);da=i;i=i+((4*n|0)+15&-16)|0;d:do if((!((_|0)<(r*15|0)|ma^1)?(c[ga>>2]|0)>1:0)?(c[M>>2]|0)==0:0){do if((_|0)<40)ka=24;else{if((_|0)<60){ka=12;break;}ka=(_|0)<100?8:6;}while(0);U=Qb(u,Z,la,da,ka,ca,B,x,V,+g[F>>2],c[U>>2]|0)|0;V=da+(Z+-1<<2)|0;ka=Z;while(1){if((ka|0)>=(m|0))break d;c[da+(ka<<2)>>2]=c[V>>2];ka=ka+1|0;}}else X=132;while(0);e:do if((X|0)==132){c[V>>2]=0;U=0;while(1){if((U|0)>=(m|0)){U=0;break e;}c[da+(U<<2)>>2]=la;U=U+1|0;}}while(0);V=i;i=i+((4*Q|0)+15&-16)|0;gd(u,l,m,Z,ra,y,aa,V,C,r,x,ba,c[a+12>>2]|0,a+84|0,(c[ga>>2]|0)>3&1,c[a+56>>2]|0,c[M>>2]|0);Rb(l,m,la,da,x,U,C);ka=C+20|0;U=C+28|0;if(((Lb(c[ka>>2]|0,c[U>>2]|0)|0)+4|0)<=(aa|0)){f:do if(!(c[M>>2]|0)){ga=c[ga>>2]|0;do if((W|0)!=0|(ga|0)<3)X=141;else{if((ba|0)<(r*10|0))break;if(!ma){X=141;break;}Fa=a+80|0;T=Ta(u,ca,a+88|0,c[Fa>>2]|0,a+96|0,ea,fa?0:1,Z,r,T)|0;c[Fa>>2]=T;break f;}while(0);do if((X|0)==141){if(ga)break;c[a+80>>2]=0;T=0;break f;}while(0);c[a+80>>2]=2;T=2;}else{c[ea>>2]=0;c[a+80>>2]=2;T=2;}while(0);Cc(C,T,312,5);}T=i;i=i+((4*n|0)+15&-16)|0;X=a+52|0;xa=+Sb(ra,ha,n,l,m,r,T,c[Y>>2]|0,c[u+56>>2]|0,la,c[S>>2]|0,c[X>>2]|0,L,x,_,G,c[M>>2]|0,ia);if(c[M>>2]|0){if((_|0)>26)S=8;else S=(_|0)/3|0;c[T>>2]=S;}S=i;i=i+((4*n|0)+15&-16)|0;pb(u,S,x,r);Y=aa<<3;ba=6;ea=l;_=jc(C)|0;Z=0;while(1){if((ea|0)>=(m|0))break;aa=ea+1|0;ga=($(r,(b[L+(aa<<1)>>1]|0)-(b[L+(ea<<1)>>1]|0)|0)|0)<<x;ha=ga<<3;fa=(ga|0)<48;if((ha|0)>=((fa?48:ga)|0))ha=fa?48:ga;ia=S+(ea<<2)|0;fa=T+(ea<<2)|0;ea=0;ma=ba;ga=0;while(1){if((_+(ma<<3)|0)>=(Y-Z|0))break;if((ea|0)>=(c[ia>>2]|0))break;Fa=(ga|0)<(c[fa>>2]|0);Bc(C,Fa&1,ma);_=jc(C)|0;if(!Fa)break;ea=ea+ha|0;ma=1;ga=ga+1|0;Z=Z+ha|0;}if(ga)ba=(ba|0)<3?2:ba+-1|0;c[fa>>2]=ea;ea=aa;}L=(r|0)==2;if(L){if(x)c[v>>2]=Tb(u,ca,x,B)|0;aa=a+188|0;ea=La(+((h|0)/1e3|0|0),c[aa>>2]|0)|0;c[aa>>2]=ea;ba=(l|0)>(ea|0);if((m|0)<((ba?l:ea)|0))ba=m;else ba=ba?l:ea;c[aa>>2]=ba;}if((_+48|0)>(Y-Z|0))Y=5;else{if(!(c[M>>2]|0))Y=Ub(u,ca,ra,m,x,r,B,a+120|0,a+184|0,+g[F>>2],c[a+188>>2]|0,ua,c[a+72>>2]|0)|0;else Y=5;Cc(C,Y,496,7);_=jc(C)|0;}if(j){j=(c[I>>2]|0)-x|0;I=1275>>>(3-x|0);I=(O|0)<(I|0)?O:I;aa=J-((r*320|0)+160)|0;X=c[X>>2]|0;O=(X|0)==0;if(!O)aa=aa+(c[a+172>>2]>>j)|0;f=(Vb(u,a+120|0,aa,x,h,c[a+92>>2]|0,r,c[a+188>>2]|0,X,+g[a+184>>2],c[G>>2]|0,+g[F>>2],f,xa,c[a+64>>2]|0,c[M>>2]|0,(c[a+192>>2]|0)!=0&1,na,oa)|0)+_|0;G=(_+Z+63>>6)+2-E|0;X=f+32>>6;X=((G|0)>(X|0)?G:X)+E|0;X=((I|0)<(X|0)?I:X)-E|0;G=(H|0)==0;F=G?X:2;Z=a+176|0;_=c[Z>>2]|0;if((_|0)<970){c[Z>>2]=_+1;na=1.0/+(_+21|0);}else na=.0010000000474974513;do if(!O){Fa=a+164|0;c[Fa>>2]=(c[Fa>>2]|0)+((G?X<<6:128)-J);Fa=a+172|0;Ca=a+168|0;Ba=c[Ca>>2]|0;J=Ba+~~(na*+(((G?f-J|0:0)<<j)-(c[Fa>>2]|0)-Ba|0))|0;c[Ca>>2]=J;c[Fa>>2]=0-J;J=a+164|0;j=c[J>>2]|0;if((j|0)>=0)break;if(G)G=(j|0)/-64|0;else G=0;c[J>>2]=0;F=F+G|0;}while(0);O=F+E|0;O=(I|0)<(O|0)?I:O;Hc(C,O);}F=i;i=i+((4*n|0)+15&-16)|0;G=i;i=i+((4*n|0)+15&-16)|0;J=i;i=i+((4*n|0)+15&-16)|0;I=O<<6;f=I-(jc(C)|0)+-1|0;E=(la|0)==0;if((E^1)&(x|0)>1)j=(f|0)>=((x<<3)+16|0)?8:0;else j=0;X=f-j|0;if(!(c[a+120>>2]|0))Z=m+-1|0;else{do if((h|0)<(r*32e3|0))h=13;else{if((h|0)<(r*48e3|0)){h=16;break;}if((h|0)<(r*6e4|0)){h=18;break;}h=(h|0)<(r*8e4|0)?19:20;}while(0);Z=c[a+144>>2]|0;Z=(Z|0)>(h|0)?Z:h;}h=a+188|0;f=a+92|0;M=sd(u,l,m,T,S,Y,h,v,X,t,G,F,J,r,x,C,1,c[f>>2]|0,(c[M>>2]|0)==0?Z:1)|0;T=c[f>>2]|0;do if(!T)S=M;else{S=T+1|0;T=T+-1|0;X=(T|0)>(M|0);if((S|0)<((X?T:M)|0))break;S=X?T:M;}while(0);c[f>>2]=S;md(u,l,m,y,V,F,C,r);S=i;i=i+((1*Q|0)+15&-16)|0;if(L)L=ca+(B<<2)|0;else L=0;B=a+76|0;Va(1,u,l,m,ca,L,S,R,G,W,c[a+80>>2]|0,c[v>>2]|0,c[h>>2]|0,da,I-j|0,c[t>>2]|0,C,x,M,B,c[a+72>>2]|0);if(j)Ec(C,(c[a+116>>2]|0)<2&1,1);nd(u,l,m,y,V,F,J,(O<<3)-(Lb(c[ka>>2]|0,c[U>>2]|0)|0)|0,C,r);g:do if(H){t=0;while(1){if((t|0)>=(Q|0))break g;g[a+(e+t<<2)+200>>2]=-28.0;t=t+1|0;}}while(0);c[a+104>>2]=c[s>>2];g[a+108>>2]=K;c[a+112>>2]=d;if(P&(r|0)==1)yj(a+(e+n<<2)+200|0,y|0,n<<2|0)|0;h:do if(E){r=w<<2;yj(A|0,z|0,r|0)|0;yj(z|0,y|0,r|0)|0;r=0;}else{r=0;while(1){if((r|0)>=(w|0)){r=0;break h;}Fa=a+(q+r<<2)+200|0;Da=+g[Fa>>2];Ea=+g[a+(e+r<<2)+200>>2];g[Fa>>2]=Da<Ea?Da:Ea;r=r+1|0;}}while(0);do{s=$(r,n)|0;t=0;while(1){if((t|0)>=(l|0)){t=m;break;}Fa=s+t|0;g[a+(e+Fa<<2)+200>>2]=0.0;g[a+(p+Fa<<2)+200>>2]=-28.0;g[a+(q+Fa<<2)+200>>2]=-28.0;t=t+1|0;}while(1){if((t|0)>=(n|0))break;Fa=s+t|0;g[a+(e+Fa<<2)+200>>2]=0.0;g[a+(p+Fa<<2)+200>>2]=-28.0;g[a+(q+Fa<<2)+200>>2]=-28.0;t=t+1|0;}r=r+1|0;}while((r|0)<(o|0));a=a+116|0;if(E&(N|0)==0)c[a>>2]=0;else c[a>>2]=(c[a>>2]|0)+1;c[B>>2]=c[U>>2];Ic(C);Fa=(Wb(c[C+44>>2]|0)|0)==0;ja(D|0);Fa=Fa?O:-3;i=k;return Fa|0;}function Lb(a,b){a=a|0;b=b|0;var c=0;c=i;b=(vj(b|0)|0)+-32+a|0;i=c;return b|0;}function Mb(a,b){a=a|0;b=b|0;var c=0.0,d=0,e=0.0,f=0,h=0.0;d=i;e=0.0;c=0.0;f=0;while(1){if((f|0)>=(b|0))break;h=+g[a+(f<<2)>>2];e=e>h?e:h;c=c<h?c:h;f=f+1|0;}h=-c;i=d;return+(e>h?e:h);}function Nb(a,b,d,e,f,h,j,k,l,m,n){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;var o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0.0,y=0,z=0.0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0.0,L=0,M=0;r=i;i=i+16|0;o=r+8|0;w=r;u=c[a>>2]|0;s=c[u+4>>2]|0;t=f+1024|0;p=$(t,e)|0;v=i;i=i+((4*p|0)+15&-16)|0;c[o>>2]=v;c[o+4>>2]=v+(t<<2);p=s+f|0;q=f<<2;y=0;while(1){yj(v|0,d+(y<<10<<2)|0,4096)|0;yj(v+4096|0,b+(($(y,p)|0)+s<<2)|0,q|0)|0;y=y+1|0;if((y|0)>=(e|0))break;v=c[o+(y<<2)>>2]|0;}if(!m){c[w>>2]=15;t=a+104|0;m=15;x=0.0;}else{v=ta()|0;J=i;i=i+((4*(t>>1)|0)+15&-16)|0;m=a+72|0;Yc(o,J,t,e,c[m>>2]|0);bd(J+2048|0,J,f,979,w,c[m>>2]|0);c[w>>2]=1024-(c[w>>2]|0);t=a+104|0;x=+dd(J,f,w,c[t>>2]|0,+g[a+108>>2],c[m>>2]|0);m=c[w>>2]|0;if((m|0)>1022){c[w>>2]=1022;m=1022;}x=x*.699999988079071;w=c[a+56>>2]|0;if((w|0)>2){x=x*.5;if((w|0)>4)x=(w|0)>8?0.0:x*.5;}ja(v|0);}v=c[t>>2]|0;J=m-v|0;K=(((J|0)>-1?J:0-J|0)*10|0)>(m|0)?.4000000059604645:.20000000298023224;if((n|0)<25)K=K+.10000000149011612;if((n|0)<35)K=K+.10000000149011612;n=a+108|0;z=+g[n>>2];if(z>.4000000059604645)K=K+-.10000000149011612;if(z>.550000011920929)K=K+-.10000000149011612;if(x<(K>.20000000298023224?K:.20000000298023224)){x=0.0;w=0;y=0;}else{w=+O(+(x-z))<.10000000149011612;w=~~+N(+((w?z:x)*32.0/3.0+.5));y=w+-1|0;if((y|0)>7)y=7;else y=(w|0)<1?0:y;x=+(y+1|0)*.09375;w=1;}A=u+44|0;C=s<<2;z=-x;B=a+112|0;u=u+60|0;E=(f|0)>1024;D=1024-f<<2;F=0;while(1){H=c[A>>2]|0;G=H-s|0;c[t>>2]=(v|0)>15?v:15;J=$(F,p)|0;I=a+(($(F,s)|0)<<2)+200|0;yj(b+(J<<2)|0,I|0,C|0)|0;if((H|0)==(s|0)){H=J+s|0;v=c[o+(F<<2)>>2]|0;}else{H=J+s|0;v=c[o+(F<<2)>>2]|0;M=c[t>>2]|0;K=-+g[n>>2];L=c[B>>2]|0;nb(b+(H<<2)|0,v+4096|0,M,M,G,K,K,L,L,0,0);}nb(b+(H+G<<2)|0,v+(G+1024<<2)|0,c[t>>2]|0,m,f-G|0,-+g[n>>2],z,c[B>>2]|0,h,c[u>>2]|0,s);yj(I|0,b+(J+f<<2)|0,C|0)|0;H=F<<10;G=d+(H<<2)|0;if(E)zj(G|0,v+(f<<2)|0,4096)|0;else{zj(G|0,d+(H+f<<2)|0,D|0)|0;zj(d+(H+1024-f<<2)|0,v+4096|0,q|0)|0;}F=F+1|0;if((F|0)>=(e|0))break;v=c[t>>2]|0;}g[k>>2]=x;c[j>>2]=m;c[l>>2]=y;i=r;return w|0;}function Ob(a,b,e,f,h){a=a|0;b=b|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0.0,n=0.0,o=0,p=0,q=0,r=0,s=0,t=0.0,u=0.0,v=0,w=0,x=0.0,y=0,z=0.0;k=i;l=i;i=i+((4*b|0)+15&-16)|0;s=(b|0)/2|0;n=+(s|0);m=+(s|0);o=s+-5|0;p=(s*6|0)+-102|0;r=0;q=0;while(1){if((q|0)>=(e|0))break;v=$(q,b)|0;t=0.0;u=0.0;w=0;while(1){if((w|0)>=(b|0))break;z=+g[a+(w+v<<2)>>2];x=t+z;g[l+(w<<2)>>2]=x;t=u+x-z*2.0;u=z-x*.5;w=w+1|0;}v=l+0|0;w=v+48|0;do{c[v>>2]=0;v=v+4|0;}while((v|0)<(w|0));t=0.0;u=0.0;v=0;while(1){if((v|0)>=(s|0)){u=0.0;x=0.0;w=s;break;}y=v<<1;z=+g[l+(y<<2)>>2];x=+g[l+((y|1)<<2)>>2];x=z*z+x*x;z=u+(x-u)*.0625;g[l+(v<<2)>>2]=z;t=t+x;u=z;v=v+1|0;}while(1){v=w+-1|0;if((w|0)<=0)break;y=l+(v<<2)|0;x=x+(+g[y>>2]-x)*.125;g[y>>2]=x;if(u>x){w=v;continue;}u=x;w=v;}t=m/(+P(+(t*u*.5*n))+1.0000000036274937e-15)*64.0;v=12;w=0;while(1){if((v|0)>=(o|0))break;y=~~+N(+(t*+g[l+(v<<2)>>2]));if((y|0)>127)y=127;else y=(y|0)<0?0:y;v=v+4|0;w=w+(d[512+y>>0]|0)|0;}v=(w<<8|0)/(p|0)|0;if((v|0)>(r|0)){c[h>>2]=q;r=v;}q=q+1|0;}l=(r|0)>200&1;m=+P(+ +(r*27|0))+-42.0;if(!(m<0.0)){if(!(m>163.0))j=22;}else{m=0.0;j=22;}if((j|0)==22)if(m*.006899999920278788+-.139<0.0){z=0.0;z=+P(+z);g[f>>2]=z;i=k;return l|0;}if(m>163.0){z=.9856999502182007;z=+P(+z);g[f>>2]=z;i=k;return l|0;}z=m*.006899999920278788+-.139;z=+P(+z);g[f>>2]=z;i=k;return l|0;}function Pb(a,b,d,e,f,h,j,k){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0.0,w=0;l=i;n=c[a+4>>2]|0;m=c[a+44>>2]|0;if(!b){b=1;m=m<<j;p=(c[a+36>>2]|0)-j|0;}else p=c[a+36>>2]|0;q=a+64|0;j=$(b,m)|0;o=j+n|0;s=a+60|0;u=0;do{r=$(u,o)|0;t=$($(u,m)|0,b)|0;a=0;while(1){if((a|0)>=(b|0))break;w=d+(r+($(a,m)|0)<<2)|0;Vc(q,w,e+(a+t<<2)|0,c[s>>2]|0,n,p,b);a=a+1|0;}u=u+1|0;}while((u|0)<(h|0));a:do if((h|0)==2&(f|0)==1){d=0;while(1){if((d|0)>=(j|0))break a;w=e+(d<<2)|0;g[w>>2]=+g[w>>2]*.5+ +g[e+(j+d<<2)>>2]*.5;d=d+1|0;}}while(0);if((k|0)==1){i=l;return;}d=(j|0)/(k|0)|0;v=+(k|0);k=j-d<<2;n=0;do{j=$($(n,b)|0,m)|0;h=0;while(1){if((h|0)>=(d|0))break;w=e+(j+h<<2)|0;g[w>>2]=+g[w>>2]*v;h=h+1|0;}wj(e+(j+d<<2)|0,0,k|0)|0;n=n+1|0;}while((n|0)<(f|0));i=l;return;}function Qb(d,e,f,g,h,j,k,l,m,n,o){d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=+n;o=o|0;var p=0,q=0,r=0,s=0,t=0,u=0,v=0.0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0.0,I=0,J=0,K=0.0;p=i;i=i+16|0;u=p;n=.5-n;if(n<-.25)n=-.009999999776482582;else n=n*.03999999910593033;r=i;i=i+((4*e|0)+15&-16)|0;y=d+32|0;q=c[y>>2]|0;s=e+-1|0;q=(b[q+(e<<1)>>1]|0)-(b[q+(s<<1)>>1]|0)<<l;x=i;i=i+((4*q|0)+15&-16)|0;w=i;i=i+((4*q|0)+15&-16)|0;q=i;i=i+((4*e|0)+15&-16)|0;d=i;i=i+((4*e|0)+15&-16)|0;c[m>>2]=0;A=$(o,k)|0;k=(f|0)==0;B=$(l,-2)|0;o=1<<l;z=l+1|0;E=0;while(1){if((E|0)>=(e|0))break;C=E+1|0;D=c[y>>2]|0;J=b[D+(E<<1)>>1]|0;D=(b[D+(C<<1)>>1]|0)-J|0;F=D<<l;D=(D|0)==1;G=F<<2;yj(x|0,j+(A+(J<<l)<<2)|0,G|0)|0;if(!k){H=+$b(x,F,l,n);if(!D?(yj(w|0,x|0,G|0)|0,Ua(w,F>>l,o),v=+$b(w,F,z,n),v<H):0){H=v;G=-1;J=0;t=10;}else{G=0;J=0;t=10;}}else{I=1;H=+$b(x,F,0,n);G=0;J=0;}while(1){if((t|0)==10){t=0;I=(f|0)==0;}if((J|0)>=(((I?D^1:0)&1)+l|0))break;if(k)t=J+1|0;else t=l-J+-1|0;Ua(x,F>>J,1<<J);K=+$b(x,F,t,n);t=K<H;J=J+1|0;H=t?K:H;G=t?J:G;t=10;}if(k){G=$(G,-2)|0;c[r+(E<<2)>>2]=G;F=0;}else{G=G<<1;c[r+(E<<2)>>2]=G;F=l;}E=r+(E<<2)|0;c[m>>2]=(c[m>>2]|0)+(F-((G|0)/2|0));if(!D){E=C;continue;}if(G){if((G|0)==(B|0))D=B;else{E=C;continue;}}else D=0;c[E>>2]=D+-1;E=C;}j=f<<2;y=0;while(1){if((y|0)>=2)break;w=j+(y<<1)|0;f=216+(l<<3)+w|0;w=(w|1)+(216+(l<<3))|0;o=0;m=k?h:0;x=1;while(1){if((x|0)>=(e|0))break;F=m+h|0;I=o+h|0;J=c[r+(x<<2)>>2]|0;G=J-(a[f>>0]<<1)|0;J=J-(a[w>>0]<<1)|0;o=((o|0)<(F|0)?o:F)+((G|0)>-1?G:0-G|0)|0;m=((I|0)<(m|0)?I:m)+((J|0)>-1?J:0-J|0)|0;x=x+1|0;}c[u+(y<<2)>>2]=(o|0)<(m|0)?o:m;y=y+1|0;}if((c[u+4>>2]|0)<(c[u>>2]|0)){if(k){u=0;t=32;}else{k=0;u=1;}}else{u=0;if(k)t=32;else k=0;}if((t|0)==32)k=h;m=j+(u<<1)|0;t=216+(l<<3)+m|0;l=(m|1)+(216+(l<<3))|0;m=0;j=k;k=1;while(1){if((k|0)>=(e|0))break;f=j+h|0;w=q+(k<<2)|0;if((m|0)<(f|0)){c[w>>2]=0;f=m;}else c[w>>2]=1;m=m+h|0;w=d+(k<<2)|0;if((m|0)<(j|0)){c[w>>2]=0;j=m;}else c[w>>2]=1;J=c[r+(k<<2)>>2]|0;m=J-(a[t>>0]<<1)|0;J=J-(a[l>>0]<<1)|0;m=f+((m|0)>-1?m:0-m|0)|0;j=j+((J|0)>-1?J:0-J|0)|0;k=k+1|0;}h=(m|0)>=(j|0)&1;c[g+(s<<2)>>2]=h;e=e+-2|0;while(1){if((e|0)<=-1)break;r=e+1|0;if((h|0)==1){h=c[d+(r<<2)>>2]|0;c[g+(e<<2)>>2]=h;}else{h=c[q+(r<<2)>>2]|0;c[g+(e<<2)>>2]=h;}e=e+-1|0;}i=p;return u|0;}function Rb(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;k=i;o=c[j+4>>2]<<3;m=j+20|0;n=j+28|0;u=Lb(c[m>>2]|0,c[n>>2]|0)|0;p=(e|0)!=0;t=p?2:4;if((g|0)>0)l=(u+t+1|0)>>>0<=o>>>0;else l=0;o=o-(l&1)|0;p=p?4:5;r=0;q=b;s=0;while(1){if((q|0)>=(d|0))break;v=f+(q<<2)|0;if((u+t|0)>>>0>o>>>0)c[v>>2]=r;else{Bc(j,c[v>>2]^r,t);u=Lb(c[m>>2]|0,c[n>>2]|0)|0;v=c[v>>2]|0;r=v;s=s|v;}t=p;q=q+1|0;}m=e<<2;if(l?(a[m+s+(216+(g<<3))>>0]|0)!=(a[(m|2)+s+(216+(g<<3))>>0]|0):0){Bc(j,h,1);l=h<<1;}else l=0;l=m+l|0;while(1){if((b|0)>=(d|0))break;v=f+(b<<2)|0;c[v>>2]=a[l+(c[v>>2]|0)+(216+(g<<3))>>0];b=b+1|0;}i=k;return;}function Sb(a,d,e,f,h,j,k,l,m,n,o,p,q,r,s,t,u,v){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=r|0;s=s|0;t=t|0;u=u|0;v=v|0;var w=0,x=0,y=0,z=0.0,A=0,B=0,C=0,D=0,E=0,F=0.0,G=0,H=0,I=0.0,J=0.0,K=0,L=0,M=0;x=i;H=$(j,e)|0;y=i;i=i+((4*H|0)+15&-16)|0;A=i;i=i+((4*H|0)+15&-16)|0;wj(k|0,0,e<<2|0)|0;z=+(9-l|0);l=0;while(1){if((l|0)>=(h|0)){m=0;z=-31.899999618530273;l=0;break;}H=l+5|0;g[A+(l<<2)>>2]=+(b[m+(l<<1)>>1]|0)*.0625+.5+z-+g[20656+(l<<2)>>2]+ +($(H,H)|0)*.006200000178068876;l=l+1|0;}a:while(1){while(1){if((l|0)<(h|0))break;m=m+1|0;if((m|0)<(j|0))l=0;else break a;}F=+g[a+(($(m,e)|0)+l<<2)>>2];F=F-+g[A+(l<<2)>>2];z=z>F?z:F;l=l+1|0;}if(!((s|0)>50&(r|0)>0&(u|0)==0)){H=0;c[t>>2]=H;i=x;return+z;}m=h+-2|0;B=h+-1|0;u=0;D=0;do{l=$(u,e)|0;C=y+(l<<2)|0;E=d+(l<<2)|0;F=+g[E>>2];g[C>>2]=F;G=1;while(1){if((G|0)>=(h|0)){H=D;break;}H=l+G|0;I=+g[d+(H<<2)>>2];H=I>+g[d+(H+-1<<2)>>2]+.5?G:D;J=F+1.5;I=J<I?J:I;g[y+(l+G<<2)>>2]=I;F=I;D=H;G=G+1|0;}while(1){G=H+-1|0;if((H|0)<=0){G=2;break;}K=y+(l+G<<2)|0;F=+g[K>>2];I=+g[y+(l+H<<2)>>2]+2.0;J=+g[d+(l+G<<2)>>2];M=I<J;L=F<(M?I:J);g[K>>2]=L|M?L?F:I:J;H=G;}while(1){if((G|0)>=(m|0))break;M=y+(l+G<<2)|0;I=+g[M>>2];J=+Zb(d+(l+G+-2<<2)|0)+-1.0;g[M>>2]=I>J?I:J;G=G+1|0;}J=+_b(E)+-1.0;I=+g[C>>2];g[C>>2]=I>J?I:J;C=y+(l+1<<2)|0;I=+g[C>>2];g[C>>2]=I>J?I:J;J=+_b(d+(l+h+-3<<2)|0)+-1.0;C=y+(l+m<<2)|0;I=+g[C>>2];g[C>>2]=I>J?I:J;C=y+(l+B<<2)|0;I=+g[C>>2];g[C>>2]=I>J?I:J;C=0;while(1){if((C|0)>=(h|0))break;M=y+(l+C<<2)|0;I=+g[M>>2];J=+g[A+(C<<2)>>2];g[M>>2]=I>J?I:J;C=C+1|0;}u=u+1|0;}while((u|0)<(j|0));b:do if((j|0)==2){d=f;while(1){if((d|0)>=(h|0)){a=f;break b;}K=d+e|0;L=y+(K<<2)|0;J=+g[L>>2];M=y+(d<<2)|0;I=+g[M>>2]+-4.0;I=J>I?J:I;g[L>>2]=I;J=+g[M>>2];I=I+-4.0;I=J>I?J:I;g[M>>2]=I;I=+g[a+(d<<2)>>2]-I;J=+g[a+(K<<2)>>2]-+g[L>>2];g[M>>2]=((I<0.0?0.0:I)+(J<0.0?0.0:J))*.5;d=d+1|0;}}else{e=f;while(1){if((e|0)>=(h|0)){a=f;break b;}M=y+(e<<2)|0;J=+g[a+(e<<2)>>2]-+g[M>>2];g[M>>2]=J<0.0?0.0:J;e=e+1|0;}}while(0);while(1){if((a|0)>=(h|0))break;M=y+(a<<2)|0;I=+g[M>>2];J=+g[v+(a<<2)>>2];g[M>>2]=I>J?I:J;a=a+1|0;}o=(o|0)==0;c:do if(((o^1)&(p|0)==0^1)&(n|0)==0){v=f;while(1){if((v|0)>=(h|0))break c;M=y+(v<<2)|0;g[M>>2]=+g[M>>2]*.5;v=v+1|0;}}while(0);s=(s|0)/4|0;p=(p|0)==0;n=(n|0)==0;v=0;while(1){if((f|0)>=(h|0)){w=48;break;}if((f|0)>=8){if((f|0)>11){M=y+(f<<2)|0;F=+g[M>>2]*.5;g[M>>2]=F;}else w=36;}else{w=y+(f<<2)|0;g[w>>2]=+g[w>>2]*2.0;w=36;}if((w|0)==36){w=0;F=+g[y+(f<<2)>>2];}F=F<4.0?F:4.0;g[y+(f<<2)>>2]=F;a=f+1|0;d=($((b[q+(a<<1)>>1]|0)-(b[q+(f<<1)>>1]|0)|0,j)|0)<<r;do if((d|0)>=6){if((d|0)>48){M=~~(F*8.0);e=M;d=(($(M,d)|0)<<3|0)/8|0;break;}else{d=~~(F*+(d|0)/6.0);e=d;d=d*48|0;break;}}else{M=~~F;e=M;d=($(M,d)|0)<<3;}while(0);if(!(!o?p|n^1:0))w=45;if((w|0)==45?(w=0,(v+d>>6|0)>(s|0)):0)break;c[k+(f<<2)>>2]=e;f=a;v=v+d|0;}if((w|0)==48){c[t>>2]=v;i=x;return+z;}M=s<<6;c[k+(f<<2)>>2]=M-v;c[t>>2]=M;i=x;return+z;}function Tb(a,d,e,f){a=a|0;d=d|0;e=e|0;f=f|0;var h=0,j=0,k=0,l=0.0,m=0,n=0.0,o=0,p=0.0,q=0.0;h=i;a=a+32|0;m=0;l=1.0000000036274937e-15;n=1.0000000036274937e-15;a:while(1){if((m|0)>=13)break;o=c[a>>2]|0;j=m+1|0;k=b[o+(j<<1)>>1]<<e;m=b[o+(m<<1)>>1]<<e;while(1){if((m|0)>=(k|0)){m=j;continue a;}q=+g[d+(m<<2)>>2];p=+g[d+(m+f<<2)>>2];m=m+1|0;l=l+(+O(+q)+ +O(+p));n=n+(+O(+(q+p))+ +O(+(q-p)));}}o=b[(c[a>>2]|0)+26>>1]<<e+1;i=h;return+(o+((e|0)<2?5:13)|0)*n*.7071070075035095>+(o|0)*l|0;}function Ub(a,d,e,f,h,j,k,l,m,n,o,p,q){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=+n;o=o|0;p=+p;q=q|0;var r=0,s=0.0,t=0.0,u=0.0,v=0,w=0,x=0,y=0,z=0,A=0.0,B=0.0;q=i;if((j|0)==2){r=a+32|0;v=0;s=0.0;while(1){if((v|0)>=8)break;y=c[r>>2]|0;w=b[y+(v<<1)>>1]|0;z=w<<h;x=v+1|0;v=x;s=s+ +Yb(d+(z<<2)|0,d+(z+k<<2)|0,(b[y+(x<<1)>>1]|0)-w<<h);}t=+O(+(s*.125));t=t>1.0?1.0:t;s=t;v=8;while(1){if((v|0)>=(o|0))break;y=c[r>>2]|0;z=b[y+(v<<1)>>1]|0;x=z<<h;v=v+1|0;u=+O(+ +Yb(d+(x<<2)|0,d+(x+k<<2)|0,(b[y+(v<<1)>>1]|0)-z<<h));if(s<u)continue;s=u;}A=+O(+s);A=A>1.0?1.0:A;s=+Z(+(1.0010000467300415-t*t))*1.4426950408889634;u=s*.5;t=+Z(+(1.0010000467300415-A*A))*1.4426950408889634;s=s*.75;if(s<-4.0)s=1.0;else s=s+5.0;B=+g[m>>2]+.25;A=-((u>t?u:t)*.5);g[m>>2]=B<A?B:A;}else s=5.0;m=f+-1|0;a=a+8|0;d=0;t=0.0;do{k=0;while(1){if((k|0)>=(m|0))break;t=t+ +g[e+(k+($(d,c[a>>2]|0)|0)<<2)>>2]*+((k<<1)+2-f|0);k=k+1|0;}d=d+1|0;}while((d|0)<(j|0));t=(t/+($(m,j)|0)+1.0)/6.0;if(!(t>2.0)){if(t<-2.0)t=-2.0;}else t=2.0;p=s-t-p-n*2.0;if(c[l>>2]|0){n=(+g[l+8>>2]+.05000000074505806)*2.0;if(!(n>2.0)){if(n<-2.0)n=-2.0;}else n=2.0;p=p-n;}l=~~+N(+(p+.5));if((l|0)>10){i=q;return 10;}else{i=q;return((l|0)<0?0:l)|0;}return 0;}function Vb(a,d,e,f,h,j,k,l,m,n,o,p,q,r,s,t,u,v,w){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=+n;o=o|0;p=+p;q=q|0;r=+r;s=s|0;t=t|0;u=u|0;v=+v;w=+w;var x=0,y=0,z=0,A=0.0,B=0,C=0,D=0,E=0,F=0.0;x=i;y=c[a+8>>2]|0;a=c[a+32>>2]|0;C=(j|0)==0?y:j;E=b[a+(C<<1)>>1]|0;j=E<<16>>16<<f;D=(k|0)==2;if(D){if((C|0)>(l|0))z=b[a+(l<<1)>>1]|0;else z=E;j=j+(z<<16>>16<<f)|0;}z=(c[d>>2]|0)==0;if(!z?(A=+g[d+16>>2],A<.4):0)B=e-~~(+(j<<3|0)*(.4000000059604645-A))|0;else B=e;if(D){if((C|0)>(l|0))E=b[a+(l<<1)>>1]|0;else l=C;l=(E<<16>>16<<f)-l|0;if(n<1.0)n=n+-.10000000149011612;else n=.8999999761581421;F=+(l|0)*.800000011920929/+(j|0)*+(B|0);A=n*+(l<<3|0);B=B-~~(F<A?F:A)|0;}o=B+(o-(16<<f))|0;o=o+~~((p-((s|0)==5010?.019999999552965164:.03999999910593033))*+(o|0))|0;if((z^1)&(t|0)==0){n=+g[d+4>>2]+-.15000000596046448;if(n<0.0)A=-.09000000357627869;else A=n+-.09000000357627869;n=+(j<<3|0);o=o+~~(n*1.2000000476837158*A)|0;if(q)o=o+~~(n*.800000011920929)|0;}u=(u|0)==0;if((u^1)&(t|0)==0){E=o+~~(+(j<<3|0)*v)|0;o=(o|0)/4|0;o=(o|0)>(E|0)?o:E;}E=~~(+(($(b[a+(y+-2<<1)>>1]<<f,k)|0)<<3|0)*r);y=o>>2;y=(E|0)>(y|0)?E:y;y=(o|0)<(y|0)?o:y;if((u^1)&(t|0)==0){E=y;D=e<<1;C=(D|0)<(E|0);E=C?D:E;i=x;return E|0;}t=(m|0)==0;if(t^1|(h|0)<64e3){r=+(h+-32e3|0)*30517578125.0e-15;r=r<0.0?0.0:r;if(!t?!(r<.6700000166893005):0)r=.6700000166893005;y=~~(r*+(y-e|0))+e|0;}if(!(u&p<.20000000298023224)){E=y;D=e<<1;C=(D|0)<(E|0);E=C?D:E;i=x;return E|0;}h=96e3-h|0;if((h|0)<=32e3){if((h|0)<0)p=0.0;else p=+(h|0)*3099999958067201.0e-21;}else p=.09919999539852142;E=y+~~(p*w*+(y|0))|0;D=e<<1;C=(D|0)<(E|0);E=C?D:E;i=x;return E|0;}function Wb(a){a=a|0;return a|0;}function Xb(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,h=0,j=0,k=0;e=i;i=i+16|0;f=e;c[f>>2]=d;do switch(b|0){case 4020:{j=c[f>>2]|0;k=c[j>>2]|0;c[f>>2]=j+4;c[a+52>>2]=k;a=37;break;};case 10012:{k=c[f>>2]|0;b=c[k>>2]|0;c[f>>2]=k+4;if((b|0)>=1?(b|0)<=(c[(c[a>>2]|0)+8>>2]|0):0){c[a+36>>2]=b;a=37;}else a=38;break;};case 4037:{j=c[f>>2]|0;k=c[j>>2]|0;c[f>>2]=j+4;c[k>>2]=c[a+60>>2];a=37;break;};case 4010:{k=c[f>>2]|0;b=c[k>>2]|0;c[f>>2]=k+4;if((b|0)<0|(b|0)>10)a=38;else{c[a+24>>2]=b;a=37;}break;};case 4036:{k=c[f>>2]|0;b=c[k>>2]|0;c[f>>2]=k+4;if((b|0)<8|(b|0)>24)a=38;else{c[a+60>>2]=b;a=37;}break;};case 4040:{j=c[f>>2]|0;k=c[j>>2]|0;c[f>>2]=j+4;c[a+64>>2]=k;a=37;break;};case 4006:{j=c[f>>2]|0;k=c[j>>2]|0;c[f>>2]=j+4;c[a+44>>2]=k;a=37;break;};case 10008:{k=c[f>>2]|0;b=c[k>>2]|0;c[f>>2]=k+4;if((b|0)<1|(b|0)>2)a=38;else{c[a+8>>2]=b;a=37;}break;};case 10015:{k=c[f>>2]|0;b=c[k>>2]|0;c[f>>2]=k+4;if(!b)a=38;else{c[b>>2]=c[a>>2];a=37;}break;};case 4028:{h=a+4|0;f=c[h>>2]|0;b=c[a>>2]|0;k=c[b+8>>2]|0;d=(c[b+4>>2]|0)+1024+k|0;j=$(f,d)|0;k=$(f,d+k|0)|0;wj(a+76|0,0,(Fb(b,f)|0)+-76|0)|0;d=0;while(1){if((d|0)>=($(f,c[b+8>>2]|0)|0))break;g[a+(k+d<<2)+200>>2]=-28.0;g[a+(j+d<<2)+200>>2]=-28.0;b=c[a>>2]|0;f=c[h>>2]|0;d=d+1|0;}c[a+172>>2]=0;g[a+84>>2]=1.0;c[a+80>>2]=2;c[a+88>>2]=256;c[a+96>>2]=0;c[a+100>>2]=0;a=37;break;};case 10010:{k=c[f>>2]|0;b=c[k>>2]|0;c[f>>2]=k+4;if((b|0)>=0?(b|0)<(c[(c[a>>2]|0)+8>>2]|0):0){c[a+32>>2]=b;a=37;}else a=38;break;};case 4014:{k=c[f>>2]|0;b=c[k>>2]|0;c[f>>2]=k+4;if((b|0)<0|(b|0)>100)a=38;else{c[a+56>>2]=b;a=37;}break;};case 10022:{k=c[f>>2]|0;b=c[k>>2]|0;c[f>>2]=k+4;if(!b)a=37;else{a=a+120|0;c[a+0>>2]=c[b+0>>2];c[a+4>>2]=c[b+4>>2];c[a+8>>2]=c[b+8>>2];c[a+12>>2]=c[b+12>>2];c[a+16>>2]=c[b+16>>2];c[a+20>>2]=c[b+20>>2];c[a+24>>2]=c[b+24>>2];a=37;}break;};case 10024:{j=c[f>>2]|0;k=c[j>>2]|0;c[f>>2]=j+4;c[a+68>>2]=k;a=37;break;};case 10026:{j=c[f>>2]|0;k=c[j>>2]|0;c[f>>2]=j+4;c[a+192>>2]=k;a=37;break;};case 10002:{k=c[f>>2]|0;b=c[k>>2]|0;c[f>>2]=k+4;if((b|0)<0|(b|0)>2)a=38;else{c[a+20>>2]=(b|0)<2&1;c[a+12>>2]=(b|0)==0&1;a=37;}break;};case 4031:{k=c[f>>2]|0;b=c[k>>2]|0;c[f>>2]=k+4;if(!b)a=38;else{c[b>>2]=c[a+76>>2];a=37;}break;};case 10016:{j=c[f>>2]|0;k=c[j>>2]|0;c[f>>2]=j+4;c[a+48>>2]=k;a=37;break;};case 4002:{k=c[f>>2]|0;b=c[k>>2]|0;c[f>>2]=k+4;if((b|0)>=501|(b|0)==-1){k=(c[a+4>>2]|0)*26e4|0;c[a+40>>2]=(b|0)<(k|0)?b:k;a=37;}else a=38;break;};default:{k=-5;i=e;return k|0;}}while(0);if((a|0)==37){k=0;i=e;return k|0;}else if((a|0)==38){k=-1;i=e;return k|0;}return 0;}function Yb(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0.0,f=0,h=0.0;d=i;f=0;e=0.0;while(1){if((f|0)>=(c|0))break;h=e+ +g[a+(f<<2)>>2]*+g[b+(f<<2)>>2];f=f+1|0;e=h;}i=d;return+e;}function Zb(a){a=a|0;var b=0,c=0.0,d=0.0,e=0.0,f=0.0,h=0.0,j=0.0,k=0;b=i;c=+g[a+8>>2];j=+g[a>>2];d=+g[a+4>>2];k=j>d;h=k?j:d;j=k?d:j;d=+g[a+12>>2];f=+g[a+16>>2];a=d>f;e=a?d:f;d=a?f:d;a=j>d;f=a?e:h;d=a?j:d;e=a?h:e;do if(c>f){if(f<d){if(c<d)break;c=d;break;}else{if(e<f){c=e;break;}c=f;break;}}else if(c<d){if(f<d){c=f;break;}c=d;break;}else{if(c<e)break;c=e;break;}while(0);i=b;return+c;}function _b(a){a=a|0;var b=0,c=0.0,d=0.0,e=0.0,f=0;b=i;c=+g[a>>2];e=+g[a+4>>2];f=c>e;d=f?c:e;c=f?e:c;e=+g[a+8>>2];if(!(d<e)){if(c<e)c=e;}else c=d;i=b;return+c;}function $b(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;var e=0,f=0.0,h=0;e=i;f=0.0;h=0;while(1){if((h|0)>=(b|0))break;f=f+ +O(+ +g[a+(h<<2)>>2]);h=h+1|0;}i=e;return+(f+ +(c|0)*d*f);}function ac(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0.0,f=0,h=0,j=0.0,k=0,l=0,m=0.0,n=0,o=0.0,p=0.0,q=0;d=i;e=+g[b>>2];f=0;while(1){if((f|0)>=(c|0))break;g[a+(f<<2)>>2]=0.0;f=f+1|0;}if(+g[b>>2]!=0.0)f=0;else{i=d;return;}while(1){if((f|0)<(c|0)){j=0.0;h=0;}else{b=12;break;}while(1){if((h|0)>=(f|0))break;j=j+ +g[a+(h<<2)>>2]*+g[b+(f-h<<2)>>2];h=h+1|0;}k=f;f=f+1|0;m=(j+ +g[b+(f<<2)>>2])/e;j=-m;g[a+(k<<2)>>2]=j;l=f>>1;k=k+-1|0;h=0;while(1){if((h|0)>=(l|0))break;q=a+(h<<2)|0;o=+g[q>>2];n=a+(k-h<<2)|0;p=+g[n>>2];g[q>>2]=o+p*j;g[n>>2]=p+o*j;h=h+1|0;}e=e-m*m*e;if(e<+g[b>>2]*.0010000000474974513){b=12;break;}}if((b|0)==12){i=d;return;}}function bc(a,b,d,e,f,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0.0,q=0,r=0.0;k=i;i=i+112|0;l=k+96|0;h=k;j=i;i=i+((4*(e+24|0)|0)+15&-16)|0;m=0;while(1){if((m|0)>=24){b=0;break;}g[h+(m<<2)>>2]=+g[b+(24-m+-1<<2)>>2];m=m+1|0;}while(1){if((b|0)>=24){b=0;break;}g[j+(b<<2)>>2]=+g[f+(24-b+-1<<2)>>2];b=b+1|0;}while(1){if((b|0)>=(e|0)){b=0;break;}g[j+(b+24<<2)>>2]=+g[a+(b<<2)>>2];b=b+1|0;}while(1){if((b|0)>=24)break;g[f+(b<<2)>>2]=+g[a+(e-b+-1<<2)>>2];b=b+1|0;}b=e+-3|0;m=l+4|0;n=l+8|0;o=l+12|0;f=0;while(1){if((f|0)>=(b|0))break;c[l+0>>2]=0;c[l+4>>2]=0;c[l+8>>2]=0;c[l+12>>2]=0;cc(h,j+(f<<2)|0,l,24);g[d+(f<<2)>>2]=+g[a+(f<<2)>>2]+ +g[l>>2];q=f|1;g[d+(q<<2)>>2]=+g[a+(q<<2)>>2]+ +g[m>>2];q=f|2;g[d+(q<<2)>>2]=+g[a+(q<<2)>>2]+ +g[n>>2];q=f|3;g[d+(q<<2)>>2]=+g[a+(q<<2)>>2]+ +g[o>>2];f=f+4|0;}while(1){if((f|0)<(e|0)){l=0;p=0.0;}else break;while(1){if((l|0)>=24)break;r=p+ +g[h+(l<<2)>>2]*+g[j+(f+l<<2)>>2];l=l+1|0;p=r;}g[d+(f<<2)>>2]=+g[a+(f<<2)>>2]+p;f=f+1|0;}i=k;return;}function cc(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,h=0,j=0,k=0.0,l=0.0,m=0,n=0.0,o=0.0,p=0,q=0,r=0.0,s=0.0,t=0.0,u=0.0,v=0.0,w=0.0,x=0.0,y=0.0;j=i;m=d+-3|0;e=c+4|0;f=c+8|0;h=c+12|0;p=b+12|0;q=0;k=+g[b>>2];n=+g[b+4>>2];l=+g[b+8>>2];o=0.0;while(1){if((q|0)>=(m|0))break;v=+g[a>>2];o=+g[p>>2];y=+g[c>>2]+v*k;g[c>>2]=y;x=+g[e>>2]+v*n;g[e>>2]=x;w=+g[f>>2]+v*l;g[f>>2]=w;v=+g[h>>2]+v*o;g[h>>2]=v;u=+g[a+4>>2];t=+g[p+4>>2];y=y+u*n;g[c>>2]=y;x=x+u*l;g[e>>2]=x;w=w+u*o;g[f>>2]=w;u=v+u*t;g[h>>2]=u;v=+g[a+8>>2];s=+g[p+8>>2];y=y+v*l;g[c>>2]=y;x=x+v*o;g[e>>2]=x;w=w+v*t;g[f>>2]=w;v=u+v*s;g[h>>2]=v;u=+g[a+12>>2];r=+g[p+12>>2];g[c>>2]=y+u*o;g[e>>2]=x+u*t;g[f>>2]=w+u*s;g[h>>2]=v+u*r;a=a+16|0;p=p+16|0;q=q+4|0;k=t;n=s;l=r;}m=q|1;if((q|0)<(d|0)){y=+g[a>>2];o=+g[p>>2];g[c>>2]=+g[c>>2]+y*k;g[e>>2]=+g[e>>2]+y*n;g[f>>2]=+g[f>>2]+y*l;g[h>>2]=+g[h>>2]+y*o;a=a+4|0;p=p+4|0;}if((m|0)<(d|0)){y=+g[a>>2];k=+g[p>>2];g[c>>2]=+g[c>>2]+y*n;g[e>>2]=+g[e>>2]+y*l;g[f>>2]=+g[f>>2]+y*o;g[h>>2]=+g[h>>2]+y*k;a=a+4|0;p=p+4|0;}if((m+1|0)>=(d|0)){i=j;return;}x=+g[a>>2];y=+g[p>>2];g[c>>2]=+g[c>>2]+x*l;g[e>>2]=+g[e>>2]+x*o;g[f>>2]=+g[f>>2]+x*k;g[h>>2]=+g[h>>2]+x*y;i=j;return;}function dc(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0.0,t=0,u=0.0,v=0.0,w=0,x=0.0,y=0;f=i;i=i+112|0;k=f+96|0;j=f;l=d+24|0;h=i;i=i+((4*l|0)+15&-16)|0;m=0;while(1){if((m|0)>=24){m=0;break;}g[j+(m<<2)>>2]=+g[b+(24-m+-1<<2)>>2];m=m+1|0;}while(1){if((m|0)>=24)break;g[h+(m<<2)>>2]=-+g[e+(24-m+-1<<2)>>2];m=m+1|0;}while(1){if((m|0)>=(l|0))break;g[h+(m<<2)>>2]=0.0;m=m+1|0;}o=d+-3|0;p=k+4|0;q=k+8|0;r=k+12|0;m=b+4|0;n=b+8|0;l=0;while(1){if((l|0)>=(o|0))break;g[k>>2]=+g[a+(l<<2)>>2];y=l|1;g[p>>2]=+g[a+(y<<2)>>2];w=l|2;g[q>>2]=+g[a+(w<<2)>>2];t=l|3;g[r>>2]=+g[a+(t<<2)>>2];cc(j,h+(l<<2)|0,k,24);x=+g[k>>2];s=-x;g[h+(l+24<<2)>>2]=s;g[c+(l<<2)>>2]=x;x=+g[p>>2]+ +g[b>>2]*s;g[p>>2]=x;u=-x;g[h+(l+25<<2)>>2]=u;g[c+(y<<2)>>2]=x;x=+g[q>>2]+ +g[b>>2]*u+ +g[m>>2]*s;g[q>>2]=x;v=-x;g[h+(l+26<<2)>>2]=v;g[c+(w<<2)>>2]=x;s=+g[r>>2]+ +g[b>>2]*v+ +g[m>>2]*u+ +g[n>>2]*s;g[r>>2]=s;g[h+(l+27<<2)>>2]=-s;g[c+(t<<2)>>2]=s;l=l+4|0;}while(1){if((l|0)>=(d|0)){a=0;break;}b=0;s=+g[a+(l<<2)>>2];while(1){if((b|0)>=24)break;x=s-+g[j+(b<<2)>>2]*+g[h+(l+b<<2)>>2];b=b+1|0;s=x;}g[h+(l+24<<2)>>2]=s;g[c+(l<<2)>>2]=s;l=l+1|0;}while(1){if((a|0)>=24)break;g[e+(a<<2)>>2]=+g[c+(d-a+-1<<2)>>2];a=a+1|0;}i=f;return;}function ec(a,b,c,d,e,f,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0.0,o=0;k=i;j=f-e|0;l=i;i=i+((4*f|0)+15&-16)|0;a:do if(d){m=0;while(1){if((m|0)>=(f|0)){m=0;break;}g[l+(m<<2)>>2]=+g[a+(m<<2)>>2];m=m+1|0;}while(1){if((m|0)>=(d|0)){a=l;break a;}n=+g[c+(m<<2)>>2];g[l+(m<<2)>>2]=+g[a+(m<<2)>>2]*n;o=f-m+-1|0;g[l+(o<<2)>>2]=+g[a+(o<<2)>>2]*n;m=m+1|0;}}while(0);_c(a,a,b,j,e+1|0,h);h=0;while(1){if((h|0)>(e|0))break;n=0.0;d=h+j|0;while(1){if((d|0)>=(f|0))break;n=n+ +g[a+(d<<2)>>2]*+g[a+(d-h<<2)>>2];d=d+1|0;}o=b+(h<<2)|0;g[o>>2]=+g[o>>2]+n;h=h+1|0;}i=k;return;}function fc(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0;f=i;g=gc(b,a)|0;a=d+1|0;Dc(e,g,(c[(c[640+(((b|0)<(d|0)?b:d)<<2)>>2]|0)+(((b|0)>(d|0)?b:d)<<2)>>2]|0)+(c[(c[640+(((d|0)<(b|0)?a:b)<<2)>>2]|0)+(((a|0)<(b|0)?b:a)<<2)>>2]|0)|0);i=f;return;}function gc(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;d=i;f=a+-1|0;e=c[b+(f<<2)>>2]|0;h=e>>>31;e=(e|0)>-1?e:0-e|0;do{f=f+-1|0;g=a-f|0;h=h+(c[(c[640+(((g|0)<(e|0)?g:e)<<2)>>2]|0)+(((g|0)>(e|0)?g:e)<<2)>>2]|0)|0;j=c[b+(f<<2)>>2]|0;e=e+((j|0)>-1?j:0-j|0)|0;if((j|0)<0){j=e+1|0;h=h+(c[(c[640+(((g|0)<(j|0)?g:j)<<2)>>2]|0)+(((g|0)>(j|0)?g:j)<<2)>>2]|0)|0;}}while((f|0)>0);i=d;return h|0;}function hc(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0.0,g=0,h=0;g=i;h=d+1|0;f=+ic(b,d,tc(e,(c[(c[640+(((b|0)<(d|0)?b:d)<<2)>>2]|0)+(((b|0)>(d|0)?b:d)<<2)>>2]|0)+(c[(c[640+(((d|0)<(b|0)?h:b)<<2)>>2]|0)+(((h|0)<(b|0)?b:h)<<2)>>2]|0)|0)|0,a);i=g;return+f;}function ic(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0.0,h=0,j=0,k=0,l=0,m=0.0;f=i;g=0.0;while(1){if((a|0)<=2)break;do if((b|0)<(a|0)){h=c[(c[640+(b<<2)>>2]|0)+(a<<2)>>2]|0;j=c[(c[640+(b+1<<2)>>2]|0)+(a<<2)>>2]|0;if(h>>>0<=d>>>0&d>>>0<j>>>0){c[e>>2]=0;d=d-h|0;break;}l=d>>>0>=j>>>0;h=l<<31>>31;d=d-(l?j:0)|0;j=b;do{j=j+-1|0;k=c[(c[640+(j<<2)>>2]|0)+(a<<2)>>2]|0;}while(k>>>0>d>>>0);b=b-j+h^h;c[e>>2]=b<<16>>16;m=+((b&65535)<<16>>16);d=d-k|0;b=j;g=g+m*m;}else{k=c[640+(a<<2)>>2]|0;l=c[k+(b+1<<2)>>2]|0;j=d>>>0>=l>>>0;h=j<<31>>31;d=d-(j?l:0)|0;a:do if((c[k+(a<<2)>>2]|0)>>>0>d>>>0){j=a;do{j=j+-1|0;l=c[(c[640+(j<<2)>>2]|0)+(a<<2)>>2]|0;}while(l>>>0>d>>>0);}else{j=b;while(1){l=c[k+(j<<2)>>2]|0;if(l>>>0<=d>>>0)break a;j=j+-1|0;}}while(0);b=b-j+h^h;c[e>>2]=b<<16>>16;m=+((b&65535)<<16>>16);d=d-l|0;b=j;g=g+m*m;}while(0);a=a+-1|0;e=e+4|0;}h=b<<1|1;l=d>>>0>=h>>>0;a=l<<31>>31;h=d-(l?h:0)|0;d=(h+1|0)>>>1;if(!d){l=h;h=b-d|0;h=h+a|0;h=h^a;j=h&65535;h=h<<16;h=h>>16;k=e+4|0;c[e>>2]=h;m=+(j<<16>>16);m=m*m;g=g+m;j=0-l|0;l=d-l|0;j=l^j;l=j&65535;j=j<<16;j=j>>16;c[k>>2]=j;m=+(l<<16>>16);m=m*m;m=g+m;i=f;return+m;}l=h-((d<<1)+-1)|0;h=b-d|0;h=h+a|0;h=h^a;j=h&65535;h=h<<16;h=h>>16;k=e+4|0;c[e>>2]=h;m=+(j<<16>>16);m=m*m;g=g+m;j=0-l|0;l=d-l|0;j=l^j;l=j&65535;j=j<<16;j=j>>16;c[k>>2]=j;m=+(l<<16>>16);m=m*m;m=g+m;i=f;return+m;}function jc(a){a=a|0;var b=0,d=0,e=0,f=0;f=i;e=c[a+20>>2]<<3;b=c[a+28>>2]|0;d=32-(vj(b|0)|0)|0;b=b>>>(d+-16|0);a=(b>>>12)+-8|0;i=f;return e-((d<<3)+(a+(b>>>0>(c[5792+(a<<2)>>2]|0)>>>0&1)))|0;}function kc(a,b,d){a=a|0;b=b|0;d=d|0;var e=0;e=i;c[a>>2]=b;c[a+4>>2]=d;c[a+8>>2]=0;c[a+12>>2]=0;c[a+16>>2]=0;c[a+20>>2]=9;c[a+24>>2]=0;d=a+28|0;c[d>>2]=128;b=lc(a)|0;c[a+40>>2]=b;c[a+32>>2]=(c[d>>2]|0)+-1-(b>>1);c[a+44>>2]=0;mc(a);i=e;return;}function lc(a){a=a|0;var b=0,e=0,f=0;b=i;f=a+24|0;e=c[f>>2]|0;if(e>>>0>=(c[a+4>>2]|0)>>>0){f=0;i=b;return f|0;}c[f>>2]=e+1;f=d[(c[a>>2]|0)+e>>0]|0;i=b;return f|0;}function mc(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0;b=i;d=a+28|0;e=a+20|0;f=a+40|0;g=a+32|0;while(1){h=c[d>>2]|0;if(h>>>0>=8388609)break;c[e>>2]=(c[e>>2]|0)+8;c[d>>2]=h<<8;j=c[f>>2]|0;h=lc(a)|0;c[f>>2]=h;c[g>>2]=((j<<8|h)>>>1&255|c[g>>2]<<8&2147483392)^255;}i=b;return;}function nc(a,b){a=a|0;b=b|0;var d=0,e=0;d=i;e=oc(c[a+28>>2]|0,b)|0;c[a+36>>2]=e;a=(((c[a+32>>2]|0)>>>0)/(e>>>0)|0)+1|0;i=d;return b-(a>>>0>b>>>0?b:a)|0;}function oc(a,b){a=a|0;b=b|0;return(a>>>0)/(b>>>0)|0|0;}function pc(a){a=a|0;var b=0;b=(c[a+28>>2]|0)>>>15;c[a+36>>2]=b;a=((c[a+32>>2]|0)>>>0)/(b>>>0)|0;b=a+1|0;return 32768-(b+(b>>>0>32768?32767-a|0:0))|0;}function qc(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0;f=i;g=c[a+36>>2]|0;e=$(g,e-d|0)|0;h=a+32|0;c[h>>2]=(c[h>>2]|0)-e;if(!b){d=a+28|0;h=d;e=(c[d>>2]|0)-e|0;c[h>>2]=e;mc(a);i=f;return;}else{h=a+28|0;e=$(g,d-b|0)|0;c[h>>2]=e;mc(a);i=f;return;}}function rc(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;d=i;e=a+28|0;f=c[e>>2]|0;g=a+32|0;h=c[g>>2]|0;j=f>>>b;b=h>>>0<j>>>0;if(!b){c[g>>2]=h-j;j=f-j|0;}c[e>>2]=j;mc(a);i=d;return b&1|0;}function sc(a,b,e){a=a|0;b=b|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0;f=i;h=a+28|0;l=c[h>>2]|0;g=a+32|0;j=c[g>>2]|0;e=l>>>e;k=-1;while(1){k=k+1|0;m=$(e,d[b+k>>0]|0)|0;if(j>>>0>=m>>>0)break;else l=m;}c[g>>2]=j-m;c[h>>2]=l-m;mc(a);i=f;return k|0;}function tc(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;d=i;e=b+-1|0;f=32-(vj(e|0)|0)|0;if((f|0)<=8){f=nc(a,b)|0;qc(a,f,f+1|0,b);b=f;i=d;return b|0;}f=f+-8|0;g=(e>>>f)+1|0;b=nc(a,g)|0;qc(a,b,b+1|0,g);f=b<<f|(uc(a,f)|0);if(f>>>0<=e>>>0){g=f;i=d;return g|0;}c[a+44>>2]=1;g=e;i=d;return g|0;}function uc(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0;e=i;f=a+12|0;g=c[f>>2]|0;d=a+16|0;h=c[d>>2]|0;if(h>>>0<b>>>0)do{g=g|(vc(a)|0)<<h;h=h+8|0;}while((h|0)<25);c[f>>2]=g>>>b;c[d>>2]=h-b;h=a+20|0;c[h>>2]=(c[h>>2]|0)+b;i=e;return g&(1<<b)+-1|0;}function vc(a){a=a|0;var b=0,e=0,f=0,g=0;b=i;f=a+8|0;e=c[f>>2]|0;g=c[a+4>>2]|0;if(e>>>0>=g>>>0){g=0;i=b;return g|0;}e=e+1|0;c[f>>2]=e;g=d[(c[a>>2]|0)+(g-e)>>0]|0;i=b;return g|0;}function wc(a,b,d){a=a|0;b=b|0;d=d|0;c[a>>2]=b;c[a+8>>2]=0;c[a+12>>2]=0;c[a+16>>2]=0;c[a+20>>2]=33;c[a+24>>2]=0;c[a+28>>2]=-2147483648;c[a+40>>2]=-1;c[a+32>>2]=0;c[a+36>>2]=0;c[a+4>>2]=d;c[a+44>>2]=0;return;}function xc(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0;f=i;g=a+28|0;j=c[g>>2]|0;h=yc(j,e)|0;if(!b){b=j-($(h,e-d|0)|0)|0;c[g>>2]=b;zc(a);i=f;return;}else{j=j-($(h,e-b|0)|0)|0;e=a+32|0;c[e>>2]=(c[e>>2]|0)+j;b=$(h,d-b|0)|0;c[g>>2]=b;zc(a);i=f;return;}}function yc(a,b){a=a|0;b=b|0;return(a>>>0)/(b>>>0)|0|0;}function zc(a){a=a|0;var b=0,d=0,e=0,f=0,g=0;b=i;e=a+28|0;d=a+32|0;f=a+20|0;g=c[e>>2]|0;while(1){if(g>>>0>=8388609)break;Jc(a,(c[d>>2]|0)>>>23);c[d>>2]=c[d>>2]<<8&2147483392;g=c[e>>2]<<8;c[e>>2]=g;c[f>>2]=(c[f>>2]|0)+8;}i=b;return;}function Ac(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0;e=i;f=a+28|0;h=c[f>>2]|0;g=h>>>15;if(!b){b=h-($(g,32768-d|0)|0)|0;c[f>>2]=b;zc(a);i=e;return;}else{j=h-($(g,32768-b|0)|0)|0;h=a+32|0;c[h>>2]=(c[h>>2]|0)+j;b=$(g,d-b|0)|0;c[f>>2]=b;zc(a);i=e;return;}}function Bc(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0;e=i;f=a+28|0;j=c[f>>2]|0;g=a+32|0;h=j>>>d;d=j-h|0;if(b){c[g>>2]=(c[g>>2]|0)+d;d=h;}c[f>>2]=d;zc(a);i=e;return;}function Cc(a,b,e,f){a=a|0;b=b|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0;g=i;h=a+28|0;j=c[h>>2]|0;f=j>>>f;if((b|0)>0){k=e+(b+-1)|0;l=j-($(f,d[k>>0]|0)|0)|0;j=a+32|0;c[j>>2]=(c[j>>2]|0)+l;f=$(f,(d[k>>0]|0)-(d[e+b>>0]|0)|0)|0;c[h>>2]=f;zc(a);i=g;return;}else{l=j-($(f,d[e+b>>0]|0)|0)|0;c[h>>2]=l;zc(a);i=g;return;}}function Dc(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0;d=i;e=c+-1|0;f=32-(vj(e|0)|0)|0;if((f|0)>8){c=f+-8|0;f=b>>>c;xc(a,f,f+1|0,(e>>>c)+1|0);Ec(a,(1<<c)+-1&b,c);i=d;return;}else{xc(a,b,b+1|0,c);i=d;return;}}function Ec(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0;f=i;g=a+12|0;j=c[g>>2]|0;e=a+16|0;k=c[e>>2]|0;if((k+d|0)>>>0>32){h=a+44|0;do{l=Fc(a,j&255)|0;c[h>>2]=c[h>>2]|l;j=j>>>8;k=k+-8|0;}while((k|0)>7);}c[g>>2]=j|b<<k;c[e>>2]=k+d;l=a+20|0;c[l>>2]=(c[l>>2]|0)+d;i=f;return;}function Fc(b,d){b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=i;g=b+8|0;f=c[g>>2]|0;h=c[b+4>>2]|0;if(((c[b+24>>2]|0)+f|0)>>>0>=h>>>0){b=-1;i=e;return b|0;}f=f+1|0;c[g>>2]=f;a[(c[b>>2]|0)+(h-f)>>0]=d;b=0;i=e;return b|0;}function Gc(b,e,f){b=b|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0;g=i;h=8-f|0;j=(1<<f)+-1<<h;if(c[b+24>>2]|0){l=c[b>>2]|0;a[l>>0]=(d[l>>0]|0)&(j^255)|e<<h;i=g;return;}k=b+40|0;l=c[k>>2]|0;if((l|0)>-1){c[k>>2]=l&~j|e<<h;i=g;return;}if((c[b+28>>2]|0)>>>0>-2147483648>>>f>>>0){c[b+44>>2]=-1;i=g;return;}else{l=b+32|0;c[l>>2]=c[l>>2]&~(j<<23)|e<<h+23;i=g;return;}}function Hc(a,b){a=a|0;b=b|0;var d=0,e=0,f=0;d=i;f=c[a>>2]|0;e=c[a+8>>2]|0;a=a+4|0;zj(f+(b-e)|0,f+((c[a>>2]|0)-e)|0,e|0)|0;c[a>>2]=b;i=d;return;}function Ic(b){b=b|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0;e=i;m=c[b+28>>2]|0;l=vj(m|0)|0;f=2147483647>>>l;g=c[b+32>>2]|0;h=g+f&~f;if((h|f)>>>0>=(g+m|0)>>>0){h=f>>>1;h=g+h&~h;l=l+1|0;}while(1){if((l|0)<=0)break;Jc(b,h>>>23);h=h<<8&2147483392;l=l+-8|0;}if(!((c[b+40>>2]|0)<=-1?(c[b+36>>2]|0)==0:0))Jc(b,0);k=b+44|0;h=c[b+16>>2]|0;j=c[b+12>>2]|0;while(1){if((h|0)<=7)break;m=Fc(b,j&255)|0;c[k>>2]=c[k>>2]|m;h=h+-8|0;j=j>>>8;}if(c[k>>2]|0){i=e;return;}g=b+24|0;n=c[g>>2]|0;m=b+4|0;f=b+8|0;wj((c[b>>2]|0)+n|0,0,(c[m>>2]|0)-n-(c[f>>2]|0)|0)|0;if((h|0)<=0){i=e;return;}f=c[f>>2]|0;m=c[m>>2]|0;if(f>>>0>=m>>>0){c[k>>2]=-1;i=e;return;}l=0-l|0;if((h|0)>(l|0)?((c[g>>2]|0)+f|0)>>>0>=m>>>0:0){c[k>>2]=-1;j=j&(1<<l)+-1;}n=(c[b>>2]|0)+(m-f+-1)|0;a[n>>0]=d[n>>0]|0|j;i=e;return;}function Jc(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;d=i;if((b|0)==255){h=a+36|0;c[h>>2]=(c[h>>2]|0)+1;i=d;return;}g=b>>8;e=a+40|0;f=c[e>>2]|0;if((f|0)>-1){f=Kc(a,f+g|0)|0;h=a+44|0;c[h>>2]=c[h>>2]|f;}f=a+36|0;if(c[f>>2]|0){g=g+255&255;h=a+44|0;do{j=Kc(a,g)|0;c[h>>2]=c[h>>2]|j;j=(c[f>>2]|0)+-1|0;c[f>>2]=j;}while((j|0)!=0);}c[e>>2]=b&255;i=d;return;}function Kc(b,d){b=b|0;d=d|0;var e=0,f=0,g=0;e=i;g=b+24|0;f=c[g>>2]|0;if((f+(c[b+8>>2]|0)|0)>>>0>=(c[b+4>>2]|0)>>>0){b=-1;i=e;return b|0;}c[g>>2]=f+1;a[(c[b>>2]|0)+f>>0]=d;b=0;i=e;return b|0;}function Lc(a,d){a=a|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0;g=i;i=i+32|0;e=g;f=c[a+8>>2]|0;f=(f|0)>0?f:0;c[e>>2]=1;h=1;j=0;do{k=j<<1;l=b[a+((k|1)<<1)+12>>1]|0;h=$(h,b[a+(k<<1)+12>>1]|0)|0;j=j+1|0;c[e+(j<<2)>>2]=h;}while(l<<16>>16!=1);h=b[a+((j<<1)+-1<<1)+12>>1]|0;k=j;while(1){j=k+-1|0;if((k|0)<=0)break;l=j<<1;if(!j)k=1;else k=b[a+(l+-1<<1)+12>>1]|0;l=b[a+(l<<1)+12>>1]|0;if((l|0)==3){l=c[e+(j<<2)>>2]|0;Oc(d,l<<f,a,h,l,k);h=k;k=j;continue;}else if((l|0)==5){l=c[e+(j<<2)>>2]|0;Pc(d,l<<f,a,h,l,k);h=k;k=j;continue;}else if((l|0)==2){Mc(d,h,c[e+(j<<2)>>2]|0);h=k;k=j;continue;}else if((l|0)==4){l=c[e+(j<<2)>>2]|0;Nc(d,l<<f,a,h,l,k);h=k;k=j;continue;}else{h=k;k=j;continue;}}i=g;return;}function Mc(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0.0,h=0.0,j=0,k=0.0,l=0.0,m=0;b=i;d=0;while(1){if((d|0)>=(c|0))break;j=a+32|0;e=j;h=+g[e>>2];k=+g[e+4>>2];l=+g[a>>2];g[j>>2]=l-h;j=a+4|0;f=+g[j>>2];g[a+36>>2]=f-k;g[a>>2]=l+h;g[j>>2]=f+k;j=a+40|0;k=+g[j>>2];e=a+44|0;f=+g[e>>2];h=(k+f)*.7071067690849304;k=(f-k)*.7071067690849304;m=a+8|0;f=+g[m>>2];g[j>>2]=f-h;j=a+12|0;l=+g[j>>2];g[e>>2]=l-k;g[m>>2]=f+h;g[j>>2]=l+k;j=a+52|0;k=+g[j>>2];m=a+48|0;l=+g[m>>2];e=a+16|0;h=+g[e>>2];g[m>>2]=h-k;m=a+20|0;f=+g[m>>2];g[j>>2]=f+l;g[e>>2]=h+k;g[m>>2]=f-l;m=a+60|0;l=+g[m>>2];e=a+56|0;f=+g[e>>2];k=(l-f)*.7071067690849304;f=(-l-f)*.7071067690849304;j=a+24|0;l=+g[j>>2];g[e>>2]=l-k;e=a+28|0;h=+g[e>>2];g[m>>2]=h-f;g[j>>2]=l+k;g[e>>2]=h+f;a=a+64|0;d=d+1|0;}i=b;return;}function Nc(a,b,d,e,f,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0.0,v=0.0,w=0.0,x=0.0,y=0.0,z=0.0,A=0.0,B=0.0,C=0.0,D=0.0,E=0,F=0,G=0,H=0,I=0,J=0,K=0;j=i;if((e|0)==1){h=0;while(1){if((h|0)>=(f|0))break;u=+g[a>>2];n=a+16|0;D=+g[n>>2];x=u-D;p=a+4|0;z=+g[p>>2];o=a+20|0;B=+g[o>>2];v=z-B;D=u+D;B=z+B;q=a+8|0;z=+g[q>>2];s=a+24|0;u=+g[s>>2];C=z+u;r=a+12|0;y=+g[r>>2];t=a+28|0;w=+g[t>>2];A=y+w;g[n>>2]=D-C;g[o>>2]=B-A;g[a>>2]=D+C;g[p>>2]=B+A;u=z-u;w=y-w;g[q>>2]=x+w;g[r>>2]=v-u;g[s>>2]=x-w;g[t>>2]=v+u;a=a+32|0;h=h+1|0;}i=j;return;}k=e<<1;l=e*3|0;m=d+48|0;q=b<<1;r=b*3|0;t=0;while(1){if((t|0)>=(f|0))break;s=a+(($(t,h)|0)<<3)|0;n=c[m>>2]|0;o=0;d=n;p=n;while(1){if((o|0)>=(e|0))break;H=s+(e<<3)|0;y=+g[H>>2];v=+g[d>>2];G=s+(e<<3)+4|0;z=+g[G>>2];x=+g[d+4>>2];u=y*v-z*x;v=y*x+z*v;K=s+(k<<3)|0;z=+g[K>>2];x=+g[p>>2];J=s+(k<<3)+4|0;y=+g[J>>2];B=+g[p+4>>2];w=z*x-y*B;x=z*B+y*x;F=s+(l<<3)|0;y=+g[F>>2];B=+g[n>>2];E=s+(l<<3)+4|0;z=+g[E>>2];A=+g[n+4>>2];D=y*B-z*A;B=y*A+z*B;z=+g[s>>2];A=z-w;I=s+4|0;y=+g[I>>2];C=y-x;w=z+w;g[s>>2]=w;x=y+x;g[I>>2]=x;y=u+D;z=v+B;D=u-D;B=v-B;g[K>>2]=w-y;g[J>>2]=x-z;g[s>>2]=+g[s>>2]+y;g[I>>2]=+g[I>>2]+z;g[H>>2]=A+B;g[G>>2]=C-D;g[F>>2]=A-B;g[E>>2]=C+D;s=s+8|0;o=o+1|0;d=d+(b<<3)|0;p=p+(q<<3)|0;n=n+(r<<3)|0;}t=t+1|0;}i=j;return;}function Oc(a,b,d,e,f,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0.0,o=0,p=0,q=0,r=0,s=0,t=0.0,u=0,v=0.0,w=0,x=0,y=0,z=0.0,A=0.0,B=0.0,C=0.0,D=0.0;k=i;j=e<<1;l=$(b,e)|0;m=d+48|0;n=+g[(c[m>>2]|0)+(l<<3)+4>>2];d=b<<1;l=0;while(1){if((l|0)>=(f|0))break;o=a+(($(l,h)|0)<<3)|0;q=c[m>>2]|0;r=e;p=q;while(1){u=o+(e<<3)|0;A=+g[u>>2];B=+g[p>>2];s=o+(e<<3)+4|0;D=+g[s>>2];v=+g[p+4>>2];C=A*B-D*v;B=A*v+D*B;x=o+(j<<3)|0;D=+g[x>>2];v=+g[q>>2];w=o+(j<<3)+4|0;A=+g[w>>2];z=+g[q+4>>2];t=D*v-A*z;v=D*z+A*v;A=C+t;z=B+v;g[u>>2]=+g[o>>2]-A*.5;y=o+4|0;g[s>>2]=+g[y>>2]-z*.5;t=(C-t)*n;v=(B-v)*n;g[o>>2]=+g[o>>2]+A;g[y>>2]=+g[y>>2]+z;g[x>>2]=+g[u>>2]+v;g[w>>2]=+g[s>>2]-t;g[u>>2]=+g[u>>2]-v;g[s>>2]=+g[s>>2]+t;r=r+-1|0;if(!r)break;else{o=o+8|0;p=p+(b<<3)|0;q=q+(d<<3)|0;}}l=l+1|0;}i=k;return;}function Pc(a,b,d,e,f,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0.0,m=0.0,n=0.0,o=0,p=0,q=0,r=0.0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0.0,A=0.0,B=0.0,C=0.0,D=0,E=0.0,F=0.0,G=0.0,H=0.0,I=0.0,J=0.0,K=0,L=0.0,M=0.0,N=0.0,O=0.0,P=0,Q=0;j=i;q=$(b,e)|0;k=c[d+48>>2]|0;d=k+(q<<3)|0;r=+g[d>>2];m=+g[d+4>>2];d=k+(($(b<<1,e)|0)<<3)|0;l=+g[d>>2];n=+g[d+4>>2];d=e<<1;q=e*3|0;p=e<<2;o=0;while(1){if((o|0)>=(f|0))break;x=$(o,h)|0;t=a+(x<<3)|0;u=a+(x+e<<3)|0;w=a+(x+d<<3)|0;s=a+(x+q<<3)|0;x=a+(x+p<<3)|0;v=0;while(1){if((v|0)>=(e|0))break;Q=t;J=+g[Q>>2];H=+g[Q+4>>2];I=+g[u>>2];Q=$(v,b)|0;C=+g[k+(Q<<3)>>2];P=u+4|0;N=+g[P>>2];O=+g[k+(Q<<3)+4>>2];A=I*C-N*O;C=I*O+N*C;N=+g[w>>2];Q=$(v<<1,b)|0;O=+g[k+(Q<<3)>>2];D=w+4|0;I=+g[D>>2];F=+g[k+(Q<<3)+4>>2];M=N*O-I*F;O=N*F+I*O;I=+g[s>>2];Q=$(v*3|0,b)|0;F=+g[k+(Q<<3)>>2];y=s+4|0;N=+g[y>>2];B=+g[k+(Q<<3)+4>>2];z=I*F-N*B;F=I*B+N*F;N=+g[x>>2];Q=$(v<<2,b)|0;B=+g[k+(Q<<3)>>2];K=x+4|0;I=+g[K>>2];G=+g[k+(Q<<3)+4>>2];E=N*B-I*G;B=N*G+I*B;I=A+E;G=C+B;E=A-E;B=C-B;C=M+z;A=O+F;z=M-z;F=O-F;g[t>>2]=J+(I+C);Q=t+4|0;g[Q>>2]=+g[Q>>2]+(G+A);O=J+I*r+C*l;M=H+G*r+A*l;N=B*m+F*n;L=-(E*m)-z*n;g[u>>2]=O-N;g[P>>2]=M-L;g[x>>2]=O+N;g[K>>2]=M+L;C=J+I*l+C*r;A=H+G*l+A*r;B=F*m-B*n;z=E*n-z*m;g[w>>2]=C+B;g[D>>2]=A+z;g[s>>2]=C-B;g[y>>2]=A-z;t=t+8|0;u=u+8|0;w=w+8|0;s=s+8|0;x=x+8|0;v=v+1|0;}o=o+1|0;}i=j;return;}function Qc(a,d,e){a=a|0;d=d|0;e=e|0;var f=0,h=0,j=0.0,k=0,l=0.0,m=0.0,n=0;f=i;j=+g[a+4>>2];k=a+44|0;h=0;while(1){if((h|0)>=(c[a>>2]|0))break;n=d+(h<<3)|0;m=+g[n>>2];l=+g[n+4>>2];g[e+(b[(c[k>>2]|0)+(h<<1)>>1]<<3)>>2]=j*m;g[e+(b[(c[k>>2]|0)+(h<<1)>>1]<<3)+4>>2]=j*l;h=h+1|0;}Lc(a,e);i=f;return;}function Rc(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0;g=i;h=c[b>>2]|0;if(!h){k=0;d=k+d|0;Ac(a,k,d);i=g;return;}f=h>>31;j=h+f^f;h=Sc(d,e)|0;k=1;while(1){if(!((h|0)!=0&(k|0)<(j|0)))break;l=h<<1;h=($(l,e)|0)>>>15;d=d+(l+2)|0;k=k+1|0;}if(!h){l=j-k|0;j=(32768-d-f>>1)+-1|0;j=(l|0)<(j|0)?l:j;d=d+((j<<1|1)+f)|0;l=32768-d|0;c[b>>2]=k+j+f^f;l=l>>>0>1?1:l;l=d+l|0;Ac(a,d,l);i=g;return;}else{k=h+1|0;l=k;d=d+(k&~f)|0;l=d+l|0;Ac(a,d,l);i=g;return;}}function Sc(a,b){a=a|0;b=b|0;a=($(32736-a|0,16384-b|0)|0)>>>15;return a|0;}function Tc(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,g=0,h=0,j=0;f=i;d=pc(a)|0;if(d>>>0<b>>>0){h=b;b=0;j=0;h=b+h|0;g=h>>>0<32768;h=g?h:32768;qc(a,b,h,32768);i=f;return j|0;}e=(Sc(b,c)|0)+1|0;g=1;while(1){if(e>>>0<=1)break;j=e<<1;h=b+j|0;if(d>>>0<h>>>0)break;e=(($(j+-2|0,c)|0)>>>15)+1|0;b=h;g=g+1|0;}if(e>>>0<2){j=(d-b|0)>>>1;b=b+(j<<1)|0;g=g+j|0;}c=b+e|0;j=d>>>0<c>>>0;h=e;b=j?b:c;j=j?0-g|0:g;h=b+h|0;g=h>>>0<32768;h=g?h:32768;qc(a,b,h,32768);i=f;return j|0;}function Uc(a){a=a|0;var b=0,c=0,d=0,e=0,f=0;b=i;d=32-(vj(a|0)|0)+-1>>1;c=1<<d;e=0;while(1){f=(e<<1)+c<<d;if(f>>>0<=a>>>0){a=a-f|0;e=e+c|0;}if((d|0)>0){c=c>>>1;d=d+-1|0;}else break;}i=b;return e|0;}function Vc(a,d,e,f,h,j,k){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0.0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0.0,A=0.0,B=0.0,C=0.0,D=0.0;l=i;o=c[a+(j<<2)+8>>2]|0;n=+g[o+4>>2];m=c[a>>2]|0;p=0;a=c[a+24>>2]|0;while(1){q=m>>1;if((p|0)>=(j|0))break;m=q;p=p+1|0;a=a+(q<<2)|0;}j=m>>2;r=i;i=i+((4*q|0)+15&-16)|0;p=i;i=i+((8*j|0)+15&-16)|0;u=h>>1;m=q+-1|0;w=h+3>>2;s=0-q|0;v=0;x=f+(u<<2)|0;y=f+(u+-1<<2)|0;t=d+(u<<2)|0;u=d+(m+u<<2)|0;d=r;while(1){if((v|0)>=(w|0))break;z=+g[y>>2];A=+g[x>>2];g[d>>2]=z*+g[t+(q<<2)>>2]+A*+g[u>>2];g[d+4>>2]=A*+g[t>>2]-z*+g[u+(s<<2)>>2];v=v+1|0;x=x+8|0;y=y+-8|0;t=t+8|0;u=u+-8|0;d=d+8|0;}h=f+(h+-1<<2)|0;w=j-w|0;while(1){if((v|0)>=(w|0))break;g[d>>2]=+g[u>>2];g[d+4>>2]=+g[t>>2];v=v+1|0;t=t+8|0;u=u+-8|0;d=d+8|0;}while(1){if((v|0)>=(j|0))break;g[d>>2]=+g[h>>2]*+g[u>>2]-+g[f>>2]*+g[t+(s<<2)>>2];g[d+4>>2]=+g[h>>2]*+g[t>>2]+ +g[f>>2]*+g[u+(q<<2)>>2];v=v+1|0;f=f+8|0;h=h+-8|0;t=t+8|0;u=u+-8|0;d=d+8|0;}q=o+44|0;s=0;while(1){if((s|0)>=(j|0))break;C=+g[a+(s<<2)>>2];A=+g[a+(j+s<<2)>>2];B=+g[r>>2];D=+g[r+4>>2];z=+(n*(B*C-D*A));A=+(n*(D*C+B*A));y=p+(b[(c[q>>2]|0)+(s<<1)>>1]<<3)|0;g[y>>2]=z;g[y+4>>2]=A;s=s+1|0;r=r+8|0;}Lc(o,p);q=k<<1;o=0-q|0;r=0;s=e;k=e+(($(m,k)|0)<<2)|0;while(1){if((r|0)>=(j|0))break;C=+g[p+4>>2];B=+g[a+(j+r<<2)>>2];A=+g[p>>2];D=+g[a+(r<<2)>>2];g[s>>2]=C*B-A*D;g[k>>2]=A*B+C*D;p=p+8|0;r=r+1|0;s=s+(q<<2)|0;k=k+(o<<2)|0;}i=l;return;}function Wc(a,d,e,f,h,j,k){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0.0,w=0.0,x=0.0,y=0.0,z=0.0,A=0.0;l=i;p=c[a>>2]|0;o=0;n=c[a+24>>2]|0;while(1){m=p>>1;if((o|0)>=(j|0))break;p=m;o=o+1|0;n=n+(m<<2)|0;}o=p>>2;t=d+(($(m+-1|0,k)|0)<<2)|0;p=h>>1;q=e+(p<<2)|0;j=c[a+(j<<2)+8>>2]|0;r=k<<1;a=0-r|0;s=c[j+44>>2]|0;k=0;while(1){if((k|0)>=(o|0))break;w=+g[t>>2];x=+g[n+(k<<2)>>2];y=+g[d>>2];v=+g[n+(o+k<<2)>>2];u=b[s>>1]<<1;g[e+(p+(u|1)<<2)>>2]=w*x+y*v;g[e+(p+u<<2)>>2]=y*x-w*v;s=s+2|0;k=k+1|0;d=d+(r<<2)|0;t=t+(a<<2)|0;}Lc(j,q);d=o+1>>1;j=0;p=e+(p+m+-2<<2)|0;while(1){if((j|0)>=(d|0))break;u=q+4|0;A=+g[u>>2];w=+g[q>>2];y=+g[n+(j<<2)>>2];z=+g[n+(o+j<<2)>>2];t=p+4|0;v=+g[t>>2];x=+g[p>>2];g[q>>2]=A*y+w*z;g[t>>2]=A*z-w*y;y=+g[n+(o-j+-1<<2)>>2];w=+g[n+(m-j+-1<<2)>>2];g[p>>2]=v*y+x*w;g[u>>2]=v*w-x*y;j=j+1|0;q=q+8|0;p=p+-8|0;}u=h+-1|0;h=(h|0)/2|0;n=0;m=f;o=f+(u<<2)|0;f=e+(u<<2)|0;while(1){if((n|0)>=(h|0))break;A=+g[f>>2];y=+g[e>>2];z=+g[o>>2];x=+g[m>>2];g[e>>2]=z*y-x*A;g[f>>2]=x*y+z*A;n=n+1|0;m=m+4|0;o=o+-4|0;f=f+-4|0;e=e+4|0;}i=l;return;}function Xc(){var a=0,b=0,d=0,e=0,f=0;a=i;b=0;a:while(1){if((b|0)>=1){f=0;b=9;break;}d=5824+(b<<2)|0;e=0;while(1){if((e|0)>=4)break;f=c[d>>2]|0;if((c[f>>2]|0)==48e3?(960<<e|0)==($(c[f+44>>2]|0,c[f+40>>2]|0)|0):0){b=9;break a;}e=e+1|0;}b=b+1|0;}if((b|0)==9){i=a;return f|0;}return 0;}function Yc(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0.0,p=0,q=0,r=0.0;k=i;i=i+80|0;m=k+56|0;l=k+40|0;j=k+20|0;h=k;c[j+0>>2]=0;c[j+4>>2]=0;c[j+8>>2]=0;c[j+12>>2]=0;c[j+16>>2]=0;d=d>>1;n=1;while(1){if((n|0)>=(d|0))break;p=n<<1;q=c[a>>2]|0;g[b+(n<<2)>>2]=((+g[q+(p+-1<<2)>>2]+ +g[q+((p|1)<<2)>>2])*.5+ +g[q+(p<<2)>>2])*.5;n=n+1|0;}q=c[a>>2]|0;g[b>>2]=(+g[q+4>>2]*.5+ +g[q>>2])*.5;if((e|0)==2){a=a+4|0;e=1;while(1){if((e|0)>=(d|0))break;p=e<<1;n=c[a>>2]|0;q=b+(e<<2)|0;g[q>>2]=+g[q>>2]+((+g[n+(p+-1<<2)>>2]+ +g[n+((p|1)<<2)>>2])*.5+ +g[n+(p<<2)>>2])*.5;e=e+1|0;}q=c[a>>2]|0;g[b>>2]=+g[b>>2]+(+g[q+4>>2]*.5+ +g[q>>2])*.5;}ec(b,m,0,0,4,d,f);g[m>>2]=+g[m>>2]*1.000100016593933;f=1;while(1){if((f|0)>=5)break;q=m+(f<<2)|0;r=+g[q>>2];o=+(f|0)*.00800000037997961;g[q>>2]=r-r*o*o;f=f+1|0;}ac(l,m,4);m=0;o=1.0;while(1){if((m|0)>=4)break;r=o*.8999999761581421;q=l+(m<<2)|0;g[q>>2]=+g[q>>2]*r;m=m+1|0;o=r;}o=+g[l>>2];g[h>>2]=o+.800000011920929;r=+g[l+4>>2];g[h+4>>2]=r+o*.800000011920929;o=+g[l+8>>2];g[h+8>>2]=o+r*.800000011920929;r=+g[l+12>>2];g[h+12>>2]=r+o*.800000011920929;g[h+16>>2]=r*.800000011920929;Zc(b,h,b,d,j);i=k;return;}function Zc(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;var f=0,h=0.0,j=0.0,k=0.0,l=0.0,m=0,n=0,o=0.0,p=0,q=0.0,r=0.0,s=0.0,t=0.0,u=0,v=0.0,w=0.0,x=0.0;f=i;l=+g[b>>2];k=+g[b+4>>2];j=+g[b+8>>2];h=+g[b+12>>2];s=+g[b+16>>2];u=e+4|0;b=e+8|0;p=e+12|0;m=e+16|0;r=+g[e>>2];v=+g[u>>2];t=+g[b>>2];q=+g[p>>2];o=+g[m>>2];n=0;while(1){if((n|0)>=(d|0))break;x=+g[a+(n<<2)>>2];g[c+(n<<2)>>2]=x+l*r+k*v+j*t+h*q+s*o;w=r;r=x;n=n+1|0;o=q;q=t;t=v;v=w;}g[e>>2]=r;g[u>>2]=v;g[b>>2]=t;g[p>>2]=q;g[m>>2]=o;i=f;return;}function _c(a,b,d,e,f,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0;h=i;i=i+16|0;n=h;m=f+-3|0;o=n+4|0;j=n+8|0;k=n+12|0;l=0;while(1){if((l|0)>=(m|0))break;c[n+0>>2]=0;c[n+4>>2]=0;c[n+8>>2]=0;c[n+12>>2]=0;$c(a,b+(l<<2)|0,n,e);g[d+(l<<2)>>2]=+g[n>>2];g[d+((l|1)<<2)>>2]=+g[o>>2];g[d+((l|2)<<2)>>2]=+g[j>>2];g[d+((l|3)<<2)>>2]=+g[k>>2];l=l+4|0;}while(1){if((l|0)>=(f|0))break;g[d+(l<<2)>>2]=+ad(a,b+(l<<2)|0,e);l=l+1|0;}i=h;return;}function $c(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,h=0,j=0,k=0.0,l=0.0,m=0,n=0.0,o=0.0,p=0,q=0,r=0.0,s=0.0,t=0.0,u=0.0,v=0.0,w=0.0,x=0.0,y=0.0;j=i;m=d+-3|0;e=c+4|0;f=c+8|0;h=c+12|0;p=b+12|0;q=0;k=+g[b>>2];n=+g[b+4>>2];l=+g[b+8>>2];o=0.0;while(1){if((q|0)>=(m|0))break;v=+g[a>>2];o=+g[p>>2];y=+g[c>>2]+v*k;g[c>>2]=y;x=+g[e>>2]+v*n;g[e>>2]=x;w=+g[f>>2]+v*l;g[f>>2]=w;v=+g[h>>2]+v*o;g[h>>2]=v;u=+g[a+4>>2];t=+g[p+4>>2];y=y+u*n;g[c>>2]=y;x=x+u*l;g[e>>2]=x;w=w+u*o;g[f>>2]=w;u=v+u*t;g[h>>2]=u;v=+g[a+8>>2];s=+g[p+8>>2];y=y+v*l;g[c>>2]=y;x=x+v*o;g[e>>2]=x;w=w+v*t;g[f>>2]=w;v=u+v*s;g[h>>2]=v;u=+g[a+12>>2];r=+g[p+12>>2];g[c>>2]=y+u*o;g[e>>2]=x+u*t;g[f>>2]=w+u*s;g[h>>2]=v+u*r;a=a+16|0;p=p+16|0;q=q+4|0;k=t;n=s;l=r;}m=q|1;if((q|0)<(d|0)){y=+g[a>>2];o=+g[p>>2];g[c>>2]=+g[c>>2]+y*k;g[e>>2]=+g[e>>2]+y*n;g[f>>2]=+g[f>>2]+y*l;g[h>>2]=+g[h>>2]+y*o;a=a+4|0;p=p+4|0;}if((m|0)<(d|0)){y=+g[a>>2];k=+g[p>>2];g[c>>2]=+g[c>>2]+y*n;g[e>>2]=+g[e>>2]+y*l;g[f>>2]=+g[f>>2]+y*o;g[h>>2]=+g[h>>2]+y*k;a=a+4|0;p=p+4|0;}if((m+1|0)>=(d|0)){i=j;return;}x=+g[a>>2];y=+g[p>>2];g[c>>2]=+g[c>>2]+x*l;g[e>>2]=+g[e>>2]+x*o;g[f>>2]=+g[f>>2]+x*k;g[h>>2]=+g[h>>2]+x*y;i=j;return;}function ad(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0.0,f=0,h=0.0;d=i;f=0;e=0.0;while(1){if((f|0)>=(c|0))break;h=e+ +g[a+(f<<2)>>2]*+g[b+(f<<2)>>2];f=f+1|0;e=h;}i=d;return+e;}function bd(a,b,d,e,f,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0.0,t=0.0,u=0.0;j=i;i=i+16|0;m=j;n=m;c[n>>2]=0;c[n+4>>2]=0;n=d+e|0;q=d>>2;o=i;i=i+((4*q|0)+15&-16)|0;n=n>>2;p=i;i=i+((4*n|0)+15&-16)|0;l=e>>1;k=i;i=i+((4*l|0)+15&-16)|0;r=0;while(1){if((r|0)>=(q|0)){r=0;break;}g[o+(r<<2)>>2]=+g[a+(r<<1<<2)>>2];r=r+1|0;}while(1){if((r|0)>=(n|0))break;g[p+(r<<2)>>2]=+g[b+(r<<1<<2)>>2];r=r+1|0;}n=e>>2;_c(o,p,k,q,n,h);cd(k,p,q,n,m);n=m+4|0;d=d>>1;e=0;while(1){if((e|0)>=(l|0))break;o=k+(e<<2)|0;g[o>>2]=0.0;r=e-(c[m>>2]<<1)|0;if(!((((r|0)>-1?r:0-r|0)|0)>2?(r=e-(c[n>>2]<<1)|0,(((r|0)>-1?r:0-r|0)|0)>2):0)){u=+ad(a,b+(e<<2)|0,d);g[o>>2]=u<-1.0?-1.0:u;}e=e+1|0;}cd(k,b,d,l,m);m=c[m>>2]|0;if((m|0)<=0){r=0;h=m<<1;r=h-r|0;c[f>>2]=r;i=j;return;}if((m|0)>=(l+-1|0)){r=0;h=m<<1;r=h-r|0;c[f>>2]=r;i=j;return;}s=+g[k+(m+-1<<2)>>2];t=+g[k+(m<<2)>>2];u=+g[k+(m+1<<2)>>2];if(u-s>(t-s)*.699999988079071){r=1;h=m<<1;r=h-r|0;c[f>>2]=r;i=j;return;}if(s-u>(t-u)*.699999988079071){r=-1;h=m<<1;r=h-r|0;c[f>>2]=r;i=j;return;}r=0;h=m<<1;r=h-r|0;c[f>>2]=r;i=j;return;}function cd(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var h=0,j=0.0,k=0,l=0.0,m=0.0,n=0,o=0.0,p=0,q=0.0,r=0.0,s=0.0,t=0.0;k=i;c[f>>2]=0;h=f+4|0;c[h>>2]=1;l=1.0;n=0;while(1){if((n|0)>=(d|0)){p=0;o=0.0;q=0.0;m=-1.0;r=-1.0;n=0;break;}t=+g[b+(n<<2)>>2];l=l+t*t;n=n+1|0;}while(1){if((n|0)>=(e|0))break;s=+g[a+(n<<2)>>2];do if(s>0.0?(j=s*9.999999960041972e-13,j=j*j,j*q>r*l):0){if(j*o>m*l){c[h>>2]=p;c[f>>2]=n;p=n;t=l;q=o;s=j;r=m;break;}else{c[h>>2]=n;t=o;q=l;s=m;r=j;break;}}else{t=o;s=m;}while(0);m=+g[b+(n+d<<2)>>2];o=+g[b+(n<<2)>>2];o=l+(m*m-o*o);l=o<1.0?1.0:o;o=t;m=s;n=n+1|0;}i=k;return;}function dd(a,b,d,e,f,h){a=a|0;b=b|0;d=d|0;e=e|0;f=+f;h=h|0;var j=0,k=0,l=0.0,m=0,n=0,o=0,p=0,q=0,r=0,s=0.0,t=0.0,u=0.0,v=0,w=0.0,x=0.0,y=0.0,z=0.0,A=0,B=0.0,C=0.0,D=0.0,E=0.0,F=0;h=i;i=i+2080|0;m=h+2072|0;k=h+2068|0;n=h+2064|0;j=h+2052|0;F=c[d>>2]|0;q=(F|0)/2|0;o=(e|0)/2|0;e=(b|0)/2|0;b=a+2048|0;F=(F|0)<1024;p=F?q:511;c[d>>2]=F?q:511;q=h;ed(b,b,a+(512-p<<2)|0,e,k,m);l=+g[k>>2];g[q>>2]=l;k=1;s=l;while(1){if((k|0)>512)break;D=+g[a+(512-k<<2)>>2];E=+g[a+(e-k+512<<2)>>2];E=s+D*D-E*E;g[q+(k<<2)>>2]=E<0.0?0.0:E;k=k+1|0;s=E;}x=+g[q+(p<<2)>>2];y=+g[m>>2];E=y/+P(+(l*x+1.0));r=p<<1;s=l*2.0;t=E*.699999988079071;u=E*.8500000238418579;w=f*.5;k=p;l=E;v=2;while(1){if((v|0)>=16)break;F=v<<1;A=fd(r+v|0,F)|0;if((A|0)<7)break;if((v|0)==2){F=A+p|0;F=(F|0)>512?p:F;}else F=fd(($(c[20592+(v<<2)>>2]<<1,p)|0)+v|0,F)|0;ed(b,a+(512-A<<2)|0,a+(512-F<<2)|0,e,m,n);C=+g[m>>2]+ +g[n>>2];g[m>>2]=C;B=+g[q+(A<<2)>>2]+ +g[q+(F<<2)>>2];z=C/+P(+(s*B+1.0));F=A-o|0;F=(F|0)>-1?F:0-F|0;if((F|0)>=2){if((F|0)<3){F=($(v*5|0,v)|0)<(p|0);E=F?w:0.0;}else E=0.0;}else E=f;D=t-E;D=D<.30000001192092896?.30000001192092896:D;if((A|0)<21){D=u-E;if(D<.4000000059604645)D=.4000000059604645;}if(z>D){k=A;y=C;x=B;l=z;}v=v+1|0;}f=y<0.0?0.0:y;if(!(x<=f))f=f/(x+1.0);else f=1.0;m=0;while(1){if((m|0)>=3)break;g[j+(m<<2)>>2]=+ad(b,a+(1-(k+m)+512<<2)|0,e);m=m+1|0;}t=+g[j+8>>2];s=+g[j>>2];u=+g[j+4>>2];if(t-s>(u-s)*.699999988079071){F=1;A=f>l;E=A?l:f;A=k<<1;F=A+F|0;A=(F|0)<15;F=A?15:F;c[d>>2]=F;i=h;return+E;}if(s-t>(u-t)*.699999988079071){F=-1;A=f>l;E=A?l:f;A=k<<1;F=A+F|0;A=(F|0)<15;F=A?15:F;c[d>>2]=F;i=h;return+E;}F=0;A=f>l;E=A?l:f;A=k<<1;F=A+F|0;A=(F|0)<15;F=A?15:F;c[d>>2]=F;i=h;return+E;}function ed(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;var h=0.0,j=0.0,k=0,l=0,m=0.0,n=0.0;k=i;l=0;h=0.0;j=0.0;while(1){if((l|0)>=(d|0))break;m=+g[a+(l<<2)>>2];n=h+m*+g[b+(l<<2)>>2];m=j+m*+g[c+(l<<2)>>2];l=l+1|0;h=n;j=m;}g[e>>2]=h;g[f>>2]=j;i=k;return;}function fd(a,b){a=a|0;b=b|0;return(a>>>0)/(b>>>0)|0|0;}function gd(a,b,d,e,f,h,j,k,l,m,n,o,p,q,r,s,t){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=r|0;s=s|0;t=t|0;var u=0,v=0,w=0,x=0,y=0,z=0.0,A=0,B=0,C=0.0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0;u=i;i=i+96|0;x=u+72|0;y=u+48|0;w=u+24|0;v=u;if(!p){if((r|0)==0?(A=d-b|0,+g[q>>2]>+($(m<<1,A)|0)):0)B=($(A,m)|0)<(o|0);else B=0;}else B=1;s=~~(+(j>>>0)*+g[q>>2]*+(s|0)/+(m<<9|0));p=a+8|0;D=c[p>>2]|0;z=+hd(f,h,b,e,D,m);e=l+28|0;A=id(c[l+20>>2]|0,c[e>>2]|0)|0;F=(A+3|0)>>>0>j>>>0;B=F?0:B&1;F=F?0:r;if(!((d-b|0)>10?(C=+(o|0)*.125,!(C>16.0)):0))C=16.0;C=(t|0)==0?C:3.0;c[x+0>>2]=c[l+0>>2];c[x+4>>2]=c[l+4>>2];c[x+8>>2]=c[l+8>>2];c[x+12>>2]=c[l+12>>2];c[x+16>>2]=c[l+16>>2];c[x+20>>2]=c[l+20>>2];o=l+24|0;r=c[o>>2]|0;c[y+0>>2]=c[e+0>>2];c[y+4>>2]=c[e+4>>2];c[y+8>>2]=c[e+8>>2];c[y+12>>2]=c[e+12>>2];c[y+16>>2]=c[e+16>>2];G=$(D,m)|0;D=i;i=i+((4*G|0)+15&-16)|0;E=i;i=i+((4*G|0)+15&-16)|0;yj(D|0,h|0,G<<2|0)|0;G=(F|0)==0;if(G){if(!B){F=r;H=0;I=13;}else{jd(a,b,d,f,D,j,A,20802+(n*84|0)|0,E,l,m,n,1,C,t)|0;I=19;}}else{H=jd(a,b,d,f,D,j,A,20802+(n*84|0)|0,E,l,m,n,1,C,t)|0;if(!B){F=c[o>>2]|0;I=13;}else I=19;}if((I|0)==13){O=jc(l)|0;N=c[l>>2]|0;M=l+4|0;c[w+0>>2]=c[M+0>>2];c[w+4>>2]=c[M+4>>2];c[w+8>>2]=c[M+8>>2];c[w+12>>2]=c[M+12>>2];c[w+16>>2]=c[M+16>>2];c[v+0>>2]=c[e+0>>2];c[v+4>>2]=c[e+4>>2];c[v+8>>2]=c[e+8>>2];c[v+12>>2]=c[e+12>>2];c[v+16>>2]=c[e+16>>2];P=kd(r)|0;Q=kd(F)|0;J=(ld(N)|0)+P|0;L=Q-P|0;I=ta()|0;K=i;i=i+((1*((Q|0)==(P|0)?1:L)|0)+15&-16)|0;yj(K|0,J|0,L|0)|0;c[l+0>>2]=c[x+0>>2];c[l+4>>2]=c[x+4>>2];c[l+8>>2]=c[x+8>>2];c[l+12>>2]=c[x+12>>2];c[l+16>>2]=c[x+16>>2];c[l+20>>2]=c[x+20>>2];c[o>>2]=r;c[e+0>>2]=c[y+0>>2];c[e+4>>2]=c[y+4>>2];c[e+8>>2]=c[y+8>>2];c[e+12>>2]=c[y+12>>2];c[e+16>>2]=c[y+16>>2];x=jd(a,b,d,f,h,j,A,20760+(n*84|0)+(B*42|0)|0,k,l,m,n,0,C,t)|0;do if(!G){if((H|0)>=(x|0)){if((H|0)!=(x|0))break;if(((jc(l)|0)+s|0)<=(O|0))break;}c[l>>2]=N;c[M+0>>2]=c[w+0>>2];c[M+4>>2]=c[w+4>>2];c[M+8>>2]=c[w+8>>2];c[M+12>>2]=c[w+12>>2];c[M+16>>2]=c[w+16>>2];c[o>>2]=F;c[e+0>>2]=c[v+0>>2];c[e+4>>2]=c[v+4>>2];c[e+8>>2]=c[v+8>>2];c[e+12>>2]=c[v+12>>2];c[e+16>>2]=c[v+16>>2];yj(J|0,K|0,L|0)|0;yj(h|0,D|0,($(c[p>>2]|0,m)|0)<<2|0)|0;yj(k|0,E|0,($(c[p>>2]|0,m)|0)<<2|0)|0;B=1;}while(0);ja(I|0);}else if((I|0)==19){yj(h|0,D|0,($(c[p>>2]|0,m)|0)<<2|0)|0;yj(k|0,E|0,($(c[p>>2]|0,m)|0)<<2|0)|0;}if(B){C=z;g[q>>2]=C;i=u;return;}C=+g[21096+(n<<2)>>2];C=C*C*+g[q>>2]+z;g[q>>2]=C;i=u;return;}function hd(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;var h=0,j=0,k=0,l=0.0,m=0,n=0.0,o=0;k=i;h=0;l=0.0;do{j=$(h,e)|0;m=c;while(1){if((m|0)>=(d|0))break;o=m+j|0;n=+g[a+(o<<2)>>2]-+g[b+(o<<2)>>2];l=l+n*n;m=m+1|0;}h=h+1|0;}while((h|0)<(f|0));i=k;return+(l>200.0?200.0:l);}function id(a,b){a=a|0;b=b|0;var c=0;c=i;b=(vj(b|0)|0)+-32+a|0;i=c;return b|0;}function jd(a,b,e,f,h,j,k,l,m,n,o,p,q,r,s){a=a|0;b=b|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=+r;s=s|0;var t=0,u=0,v=0,w=0.0,x=0.0,y=0,z=0,A=0,B=0,C=0,D=0,E=0.0,F=0,G=0,H=0.0,I=0.0,J=0,K=0,L=0,M=0,O=0,P=0.0,Q=0.0;v=i;i=i+16|0;t=v;u=v+8|0;O=t;c[O>>2]=0;c[O+4>>2]=0;if((k+3|0)<=(j|0))Bc(n,q,3);if(!q){w=+g[21112+(p<<2)>>2];x=+g[21096+(p<<2)>>2];}else{w=.149993896484375;x=0.0;}p=a+8|0;a=n+20|0;k=n+28|0;q=o*3|0;A=(s|0)==0;J=0;z=b;while(1){if((z|0)>=(e|0))break;B=$(q,e-z|0)|0;y=(z|0)!=(b|0);D=(z|0)<20;C=z<<1;s=(z|0)>1;F=0;do{G=z+($(F,c[p>>2]|0)|0)|0;P=+g[f+(G<<2)>>2];Q=+g[h+(G<<2)>>2];I=x*(Q<-9.0?-9.0:Q);G=t+(F<<2)|0;H=+g[G>>2];E=P-I-H;K=~~+N(+(E+.5));c[u>>2]=K;Q=(Q<-28.0?-28.0:Q)-r;if((K|0)<0&P<Q){K=K+~~(Q-P)|0;K=(K|0)>0?0:K;c[u>>2]=K;}L=j-(id(c[a>>2]|0,c[k>>2]|0)|0)|0;O=L-B|0;if(y&(O|0)<30&(O|0)<24){M=(K|0)>1?1:K;c[u>>2]=M;if((O|0)<16){M=(M|0)<-1?-1:M;c[u>>2]=M;}}else M=K;if(!(A|s^1)){M=(M|0)<0?M:0;c[u>>2]=M;}do if((L|0)<=14){if((L|0)<=1){if((L|0)>0){O=(M|0)>0?0:M;c[u>>2]=O;Bc(n,0-O|0,1);break;}else{c[u>>2]=-1;break;}}else{if((M|0)<1)L=(M|0)<-1?-1:M;else L=1;c[u>>2]=L;Cc(n,L<<1^L>>31,21128,2);break;}}else{O=D?C:40;Rc(n,u,(d[l+O>>0]|0)<<7,(d[l+(O|1)>>0]|0)<<6);}while(0);O=c[u>>2]|0;Q=+(O|0);g[m+(z+($(F,c[p>>2]|0)|0)<<2)>>2]=E-Q;O=K-O|0;J=J+((O|0)>-1?O:0-O|0)|0;g[h+(z+($(F,c[p>>2]|0)|0)<<2)>>2]=I+H+Q;g[G>>2]=H+Q-w*Q;F=F+1|0;}while((F|0)<(o|0));z=z+1|0;}i=v;return(A?J:0)|0;}function kd(a){a=a|0;return a|0;}function ld(a){a=a|0;return a|0;}function md(a,b,d,e,f,h,j,k){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0.0,o=0,p=0,q=0,r=0.0,s=0;l=i;a=a+8|0;while(1){if((b|0)>=(d|0))break;m=h+(b<<2)|0;p=c[m>>2]|0;o=1<<p;if((p|0)>=1){n=+((o&65535)<<16>>16);o=(o<<16>>16)+-1|0;p=0;do{q=~~+N(+((+g[f+(b+($(p,c[a>>2]|0)|0)<<2)>>2]+.5)*n));s=(q|0)>(o|0);q=((s?o:q)|0)<0?0:s?o:q;Ec(j,q,c[m>>2]|0);r=(+(q|0)+.5)*+(1<<14-(c[m>>2]|0)|0)*6103515625.0e-14+-.5;q=e+(b+($(p,c[a>>2]|0)|0)<<2)|0;g[q>>2]=+g[q>>2]+r;q=f+(b+($(p,c[a>>2]|0)|0)<<2)|0;g[q>>2]=+g[q>>2]-r;p=p+1|0;}while((p|0)<(k|0));}b=b+1|0;}i=l;return;}function nd(a,b,d,e,f,h,j,k,l,m){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;var n=0,o=0,p=0,q=0,r=0,s=0,t=0;n=i;a=a+8|0;o=0;while(1){if((o|0)<2)p=b;else break;while(1){if(!((p|0)<(d|0)&(k|0)>=(m|0)))break;q=h+(p<<2)|0;if((c[q>>2]|0)<=7?(c[j+(p<<2)>>2]|0)==(o|0):0){r=0;do{t=!(+g[f+(p+($(r,c[a>>2]|0)|0)<<2)>>2]<0.0)&1;Ec(l,t,1);s=e+(p+($(r,c[a>>2]|0)|0)<<2)|0;g[s>>2]=+g[s>>2]+(+(t|0)+-.5)*+(1<<14-(c[q>>2]|0)+-1|0)*6103515625.0e-14;k=k+-1|0;r=r+1|0;}while((r|0)<(m|0));}p=p+1|0;}o=o+1|0;}i=n;return;}function od(a,b,e,f,h,j,k,l){a=a|0;b=b|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;var m=0.0,n=0,o=0,p=0,q=0.0,r=0,s=0,t=0,u=0,v=0,w=0,x=0.0,y=0.0,z=0;r=i;i=i+16|0;n=r;w=n;c[w>>2]=0;c[w+4>>2]=0;if(!h){m=+g[21112+(l<<2)>>2];q=+g[21096+(l<<2)>>2];}else{m=.149993896484375;q=0.0;}s=c[j+4>>2]<<3;p=j+20|0;o=j+28|0;a=a+8|0;while(1){if((b|0)>=(e|0))break;t=(b|0)<20;u=b<<1;v=0;do{w=s-(id(c[p>>2]|0,c[o>>2]|0)|0)|0;do if((w|0)<=14){if((w|0)>1){w=sc(j,21128,2)|0;w=w>>1^0-(w&1);break;}if((w|0)>0)w=0-(rc(j,1)|0)|0;else w=-1;}else{w=t?u:40;w=Tc(j,(d[20760+(l*84|0)+(h*42|0)+w>>0]|0)<<7,(d[(w|1)+(20760+(l*84|0)+(h*42|0))>>0]|0)<<6)|0;}while(0);x=+(w|0);z=f+(b+($(v,c[a>>2]|0)|0)<<2)|0;y=+g[z>>2];g[z>>2]=y<-9.0?-9.0:y;z=f+(b+($(v,c[a>>2]|0)|0)<<2)|0;w=n+(v<<2)|0;y=+g[w>>2];g[z>>2]=q*+g[z>>2]+y+x;g[w>>2]=y+x-m*x;v=v+1|0;}while((v|0)<(k|0));b=b+1|0;}i=r;return;}function pd(a,b,d,e,f,h,j){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0.0;k=i;a=a+8|0;while(1){if((b|0)>=(d|0))break;l=f+(b<<2)|0;m=c[l>>2]|0;a:do if((m|0)>=1){n=0;while(1){o=+(uc(h,m)|0)+.5;m=e+(b+($(n,c[a>>2]|0)|0)<<2)|0;g[m>>2]=+g[m>>2]+(o*+(1<<14-(c[l>>2]|0)|0)*6103515625.0e-14+-.5);n=n+1|0;if((n|0)>=(j|0))break a;m=c[l>>2]|0;}}while(0);b=b+1|0;}i=k;return;}function qd(a,b,d,e,f,h,j,k,l){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;var m=0,n=0,o=0,p=0,q=0,r=0,s=0.0;m=i;a=a+8|0;n=0;while(1){if((n|0)<2)o=b;else break;while(1){if(!((o|0)<(d|0)&(j|0)>=(l|0)))break;p=f+(o<<2)|0;if((c[p>>2]|0)<=7?(c[h+(o<<2)>>2]|0)==(n|0):0){q=0;do{s=+(uc(k,1)|0)+-.5;r=e+(o+($(q,c[a>>2]|0)|0)<<2)|0;g[r>>2]=+g[r>>2]+s*+(1<<14-(c[p>>2]|0)+-1|0)*6103515625.0e-14;j=j+-1|0;q=q+1|0;}while((q|0)<(l|0));}o=o+1|0;}n=n+1|0;}i=m;return;}function rd(a,b,d,e,f,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0.0;j=i;a=a+8|0;k=0;do{l=0;while(1){if((l|0)>=(b|0)){l=b;break;}m=l+($(k,c[a>>2]|0)|0)|0;n=+Z(+ +g[e+(m<<2)>>2])*1.4426950408889634;g[f+(m<<2)>>2]=n-+g[20656+(l<<2)>>2];l=l+1|0;}while(1){if((l|0)>=(d|0))break;g[f+(($(k,c[a>>2]|0)|0)+l<<2)>>2]=-14.0;l=l+1|0;}k=k+1|0;}while((k|0)<(h|0));i=j;return;}function sd(a,e,f,g,h,j,k,l,m,n,o,p,q,r,s,t,u,v,w){a=a|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=r|0;s=s|0;t=t|0;u=u|0;v=v|0;w=w|0;var x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0;x=i;y=(m|0)>0?m:0;I=c[a+8>>2]|0;m=(y|0)>7?8:0;y=y-m|0;if((r|0)==2?(A=d[21136+(f-e)>>0]|0,(A|0)<=(y|0)):0){y=y-A|0;z=(y|0)>7?8:0;y=y-z|0;}else{z=0;A=0;}F=i;i=i+((4*I|0)+15&-16)|0;D=i;i=i+((4*I|0)+15&-16)|0;E=i;i=i+((4*I|0)+15&-16)|0;C=i;i=i+((4*I|0)+15&-16)|0;J=r<<3;B=a+32|0;j=j+-5-s|0;H=s+3|0;G=e;while(1){if((G|0)>=(f|0))break;Q=G+1|0;O=c[B>>2]|0;O=(b[O+(Q<<1)>>1]|0)-(b[O+(G<<1)>>1]|0)|0;P=O*3<<s<<3>>4;c[E+(G<<2)>>2]=(J|0)>(P|0)?J:P;P=($($($(O,r)|0,j)|0,f-G+-1|0)|0)<<H>>6;c[C+(G<<2)>>2]=(O<<s|0)==1?P-J|0:P;G=Q;}G=c[a+48>>2]|0;j=a+52|0;K=G+-1|0;H=1;do{L=H+K>>1;M=$(L,I)|0;N=1;P=f;O=0;a:while(1){b:while(1){do{Q=P;P=P+-1|0;if((Q|0)<=(e|0))break a;R=c[B>>2]|0;Q=$((b[R+(Q<<1)>>1]|0)-(b[R+(P<<1)>>1]|0)|0,r)|0;Q=($(Q,d[(c[j>>2]|0)+(M+P)>>0]|0)|0)<<s>>2;if((Q|0)>0){Q=Q+(c[C+(P<<2)>>2]|0)|0;Q=(Q|0)<0?0:Q;}Q=Q+(c[g+(P<<2)>>2]|0)|0;if((Q|0)<(c[E+(P<<2)>>2]|0)^1|N^1)break b;}while((Q|0)<(J|0));O=O+J|0;}R=c[h+(P<<2)>>2]|0;N=0;O=O+((Q|0)<(R|0)?Q:R)|0;}R=(O|0)>(y|0);K=R?L+-1|0:K;H=R?H:L+1|0;}while((H|0)<=(K|0));L=H+-1|0;J=$(L,I)|0;N=$(H,I)|0;L=(L|0)>0;I=e;K=e;while(1){if((K|0)>=(f|0))break;M=K+1|0;Q=c[B>>2]|0;Q=$((b[Q+(M<<1)>>1]|0)-(b[Q+(K<<1)>>1]|0)|0,r)|0;P=c[j>>2]|0;O=($(Q,d[P+(J+K)>>0]|0)|0)<<s>>2;if((H|0)<(G|0))P=($(Q,d[P+(N+K)>>0]|0)|0)<<s>>2;else P=c[h+(K<<2)>>2]|0;if((O|0)>0){O=O+(c[C+(K<<2)>>2]|0)|0;O=(O|0)<0?0:O;}if((P|0)>0){P=P+(c[C+(K<<2)>>2]|0)|0;P=(P|0)<0?0:P;}R=c[g+(K<<2)>>2]|0;O=L?O+R|0:O;Q=P+R-O|0;c[F+(K<<2)>>2]=O;c[D+(K<<2)>>2]=(Q|0)<0?0:Q;I=(R|0)>0?K:I;K=M;}R=td(a,e,f,I,F,D,E,h,y,n,m,k,A,l,z,o,p,q,r,s,t,u,v,w)|0;i=x;return R|0;}function td(a,e,f,g,h,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B){a=a|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=r|0;s=s|0;t=t|0;u=u|0;v=v|0;w=w|0;x=x|0;y=y|0;z=z|0;A=A|0;B=B|0;var C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0;D=i;E=w<<3;G=(w|0)>1;C=G&1;F=x<<3;J=64;I=0;K=0;while(1){if((K|0)>=6){K=0;M=f;L=0;break;}M=I+J>>1;L=1;P=f;N=0;a:while(1){b:while(1){do{O=P;P=P+-1|0;if((O|0)<=(e|0))break a;O=(c[h+(P<<2)>>2]|0)+(($(M,c[j+(P<<2)>>2]|0)|0)>>6)|0;if((O|0)<(c[k+(P<<2)>>2]|0)^1|L^1)break b;}while((O|0)<(E|0));N=N+E|0;}Q=c[l+(P<<2)>>2]|0;L=0;N=N+((O|0)<(Q|0)?O:Q)|0;}Q=(N|0)>(m|0);J=Q?M:J;I=Q?I:M;K=K+1|0;}while(1){J=M+-1|0;if((M|0)<=(e|0))break;M=(c[h+(J<<2)>>2]|0)+(($(I,c[j+(J<<2)>>2]|0)|0)>>6)|0;if((K|0)==0?(M|0)<(c[k+(J<<2)>>2]|0):0){K=0;M=(M|0)<(E|0)?0:E;}else K=1;Q=c[l+(J<<2)>>2]|0;Q=(M|0)<(Q|0)?M:Q;c[t+(J<<2)>>2]=Q;M=J;L=L+Q|0;}h=a+32|0;j=E+8|0;z=(z|0)==0;K=e+2|0;J=q;I=L;q=f;while(1){M=q+-1|0;if((M|0)<=(g|0)){H=18;break;}R=m-I|0;O=c[h>>2]|0;L=b[O+(q<<1)>>1]|0;N=b[O+(e<<1)>>1]|0;P=L-N|0;Q=ud(R,P)|0;P=R-($(P,Q)|0)|0;O=b[O+(M<<1)>>1]|0;N=P+(N-O)|0;O=L-O|0;L=t+(M<<2)|0;P=c[L>>2]|0;N=P+($(Q,O)|0)+((N|0)>0?N:0)|0;Q=c[k+(M<<2)>>2]|0;if((N|0)<(((Q|0)>(j|0)?Q:j)|0))q=P;else{if(z){if(rc(y,1)|0)break;}else{if((q|0)<=(K|0)){H=23;break;}if(!((M|0)>(B|0)?1:(N|0)<=(($((q|0)<=(A|0)?7:9,O)|0)<<x<<3>>4|0))){H=23;break;}Bc(y,0,1);}q=c[L>>2]|0;N=N+-8|0;I=I+8|0;}if((J|0)>0)O=d[21136+(M-e)>>0]|0;else O=J;I=I-(q+J)+O|0;q=(N|0)<(E|0);c[L>>2]=q?0:E;J=O;I=q?I:I+E|0;q=M;}if((H|0)==18)m=m+o|0;else if((H|0)==23)Bc(y,1,1);do if((J|0)>0){if(z){k=(tc(y,q+1-e|0)|0)+e|0;c[p>>2]=k;break;}else{k=c[p>>2]|0;k=(k|0)<(q|0)?k:q;c[p>>2]=k;Dc(y,k-e|0,q+1-e|0);k=c[p>>2]|0;break;}}else{c[p>>2]=0;k=0;}while(0);do if((k|0)>(e|0)){if((s|0)>0){if(z){c[r>>2]=rc(y,1)|0;break;}else{Bc(y,c[r>>2]|0,1);break;}}else H=41;}else{m=m+s|0;H=41;}while(0);if((H|0)==41)c[r>>2]=0;H=m-I|0;y=c[h>>2]|0;y=(b[y+(q<<1)>>1]|0)-(b[y+(e<<1)>>1]|0)|0;s=ud(H,y)|0;y=H-($(y,s)|0)|0;H=e;while(1){if((H|0)>=(q|0)){H=e;break;}R=H+1|0;P=c[h>>2]|0;P=$(s,(b[P+(R<<1)>>1]|0)-(b[P+(H<<1)>>1]|0)|0)|0;Q=t+(H<<2)|0;c[Q>>2]=(c[Q>>2]|0)+P;H=R;}while(1){if((H|0)>=(q|0))break;R=H+1|0;Q=c[h>>2]|0;Q=(b[Q+(R<<1)>>1]|0)-(b[Q+(H<<1)>>1]|0)|0;Q=(y|0)<(Q|0)?y:Q;P=t+(H<<2)|0;c[P>>2]=(c[P>>2]|0)+Q;y=y-Q|0;H=R;}H=(w|0)==2;a=a+56|0;y=G?4:3;G=0;while(1){if((e|0)>=(q|0))break;s=e+1|0;g=c[h>>2]|0;g=(b[g+(s<<1)>>1]|0)-(b[g+(e<<1)>>1]|0)<<x;B=t+(e<<2)|0;A=(c[B>>2]|0)+G|0;if((g|0)>1){k=A-(c[l+(e<<2)>>2]|0)|0;k=(k|0)>0?k:0;m=A-k|0;c[B>>2]=m;o=$(g,w)|0;if(H&(g|0)>2?(c[r>>2]|0)==0:0)A=(e|0)<(c[p>>2]|0);else A=0;A=o+(A&1)|0;o=$(A,(b[(c[a>>2]|0)+(e<<1)>>1]|0)+F|0)|0;z=(o>>1)+($(A,-21)|0)|0;if((g|0)==2)g=z+(A<<3>>2)|0;else g=z;z=m+g|0;if((z|0)>=(A<<4|0)){if((z|0)<(A*24|0))g=g+(o>>3)|0;}else g=g+(o>>2)|0;o=m+g+(A<<2)|0;m=u+(e<<2)|0;o=(ud((o|0)<0?0:o,A)|0)>>>3;c[m>>2]=o;R=$(o,w)|0;z=c[B>>2]|0;if((R|0)>(z>>3|0)){o=z>>C>>3;c[m>>2]=o;}R=(o|0)<8?o:8;c[m>>2]=R;R=$(R,A<<3)|0;c[v+(e<<2)>>2]=(R|0)>=((c[B>>2]|0)+g|0)&1;R=($(c[m>>2]|0,w)|0)<<3;c[B>>2]=(c[B>>2]|0)-R;}else{k=A-E|0;k=(k|0)<0?0:k;c[B>>2]=A-k;c[u+(e<<2)>>2]=0;c[v+(e<<2)>>2]=1;}if((k|0)<=0){G=k;e=s;continue;}O=k>>y;Q=u+(e<<2)|0;P=c[Q>>2]|0;R=8-P|0;R=(O|0)<(R|0)?O:R;c[Q>>2]=P+R;R=($(R,w)|0)<<3;c[v+(e<<2)>>2]=(R|0)>=(k-G|0)&1;G=k-R|0;e=s;}c[n>>2]=G;while(1){if((e|0)>=(f|0))break;Q=t+(e<<2)|0;R=u+(e<<2)|0;c[R>>2]=c[Q>>2]>>C>>3;c[Q>>2]=0;c[v+(e<<2)>>2]=(c[R>>2]|0)<1&1;e=e+1|0;}i=D;return q|0;}function ud(a,b){a=a|0;b=b|0;return(a>>>0)/(b>>>0)|0|0;}function vd(a,b,d,e,f,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0.0,p=0,q=0.0,r=0.0,s=0.0,t=0.0,u=0,v=0.0,w=0;k=i;m=i;i=i+((4*b|0)+15&-16)|0;j=i;i=i+((4*b|0)+15&-16)|0;l=i;i=i+((4*b|0)+15&-16)|0;wd(a,b,1,f,d,e);e=0;do{n=a+(e<<2)|0;o=+g[n>>2];p=l+(e<<2)|0;if(o>0.0)g[p>>2]=1.0;else{g[p>>2]=-1.0;g[n>>2]=-o;}c[j+(e<<2)>>2]=0;g[m+(e<<2)>>2]=0.0;e=e+1|0;}while((e|0)<(b|0));if((b>>1|0)<(d|0)){e=0;o=0.0;do{o=o+ +g[a+(e<<2)>>2];e=e+1|0;}while((e|0)<(b|0));if(!(o>1.0000000036274937e-15&o<64.0)){g[a>>2]=1.0;e=1;do{g[a+(e<<2)>>2]=0.0;e=e+1|0;}while((e|0)<(b|0));o=1.0;}r=+(d+-1|0)*(1.0/o);n=0;e=d;o=0.0;q=0.0;do{t=+g[a+(n<<2)>>2];w=~~+N(+(r*t));c[j+(n<<2)>>2]=w;v=+(w|0);q=q+v*v;o=o+t*v;g[m+(n<<2)>>2]=v*2.0;e=e-w|0;n=n+1|0;}while((n|0)<(b|0));}else{e=d;o=0.0;q=0.0;}if((e|0)>(b+3|0)){v=+(e|0);q=q+v*v+v*+g[m>>2];c[j>>2]=(c[j>>2]|0)+e;e=0;}n=0;while(1){if((n|0)>=(e|0)){m=0;break;}s=q+1.0;r=0.0;w=0;q=-999999986991104.0;p=0;while(1){v=o+ +g[a+(p<<2)>>2];t=s+ +g[m+(p<<2)>>2];v=v*v;u=r*v>t*q;w=u?p:w;p=p+1|0;if((p|0)>=(b|0))break;else{r=u?t:r;q=u?v:q;}}v=o+ +g[a+(w<<2)>>2];u=m+(w<<2)|0;q=+g[u>>2];g[u>>2]=q+2.0;w=j+(w<<2)|0;c[w>>2]=(c[w>>2]|0)+1;n=n+1|0;o=v;q=s+q;}do{v=+g[l+(m<<2)>>2];w=a+(m<<2)|0;g[w>>2]=v*+g[w>>2];if(v<0.0){w=j+(m<<2)|0;c[w>>2]=0-(c[w>>2]|0);}m=m+1|0;}while((m|0)<(b|0));fc(j,b,d,h);w=xd(j,b,f)|0;i=k;return w|0;}function wd(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0.0,k=0.0,l=0.0,m=0.0,n=0,o=0;h=i;if((f<<1|0)>=(b|0)|(g|0)==0){i=h;return;}k=+(b|0)/+(($(c[21160+(g+-1<<2)>>2]|0,f)|0)+b|0);k=k*k*.5;j=+R(+(k*1.5707963705062866));k=+R(+((1.0-k)*1.5707963705062866));a:do if((e<<3|0)>(b|0))g=0;else{f=e>>2;g=1;while(1){if((($(($(g,g)|0)+g|0,e)|0)+f|0)>=(b|0))break a;g=g+1|0;}}while(0);b=Dd(b,e)|0;d=(d|0)<0;n=(g|0)==0;m=-k;l=-j;o=0;while(1){if((o|0)>=(e|0))break;f=a+(($(o,b)|0)<<2)|0;if(!d){Ed(f,b,1,j,m);if(!n)Ed(f,b,g,k,l);}else{if(!n)Ed(f,b,g,k,j);Ed(f,b,1,j,k);}o=o+1|0;}i=h;return;}function xd(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0;e=i;if((d|0)<2){k=1;i=e;return k|0;}b=Dd(b,d)|0;g=0;f=0;do{h=$(f,b)|0;j=0;k=0;do{k=k|c[a+(h+j<<2)>>2];j=j+1|0;}while((j|0)<(b|0));g=g|((k|0)!=0&1)<<f;f=f+1|0;}while((f|0)<(d|0));i=e;return g|0;}function yd(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=+g;var h=0,j=0;h=i;j=i;i=i+((4*b|0)+15&-16)|0;zd(j,a,b,+hc(j,b,c,f),g);wd(a,b,-1,e,c,d);f=xd(j,b,e)|0;i=h;return f|0;}function zd(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=+e;f=+f;var h=0,j=0;h=i;f=1.0/+P(+e)*f;j=0;do{g[b+(j<<2)>>2]=f*+(c[a+(j<<2)>>2]|0);j=j+1|0;}while((j|0)<(d|0));i=h;return;}function Ad(a,b,c,d){a=a|0;b=b|0;c=+c;d=d|0;var e=0;d=i;c=1.0/+P(+(+Bd(a,a,b)+1.0000000036274937e-15))*c;e=0;while(1){if((e|0)>=(b|0))break;g[a>>2]=c*+g[a>>2];e=e+1|0;a=a+4|0;}i=d;return;}function Bd(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0.0,f=0,h=0.0;d=i;f=0;e=0.0;while(1){if((f|0)>=(c|0))break;h=e+ +g[a+(f<<2)>>2]*+g[b+(f<<2)>>2];f=f+1|0;e=h;}i=d;return+e;}function Cd(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;var f=0.0,h=0.0,j=0.0,k=0.0,l=0.0;e=i;a:do if(!c){h=+Bd(a,a,d)+1.0000000036274937e-15;f=+Bd(b,b,d)+1.0000000036274937e-15;}else{h=1.0000000036274937e-15;f=1.0000000036274937e-15;c=0;while(1){if((c|0)>=(d|0))break a;l=+g[a+(c<<2)>>2];j=+g[b+(c<<2)>>2];k=l+j;j=l-j;h=h+k*k;f=f+j*j;c=c+1|0;}}while(0);c=~~+N(+(+X(+ +P(+f),+ +P(+h))*10430.3818359375+.5));i=e;return c|0;}function Dd(a,b){a=a|0;b=b|0;return(a>>>0)/(b>>>0)|0|0;}function Ed(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=+d;e=+e;var f=0.0,h=0,j=0,k=0,l=0,m=0.0,n=0.0,o=0;h=i;f=-e;k=b-c|0;l=a;j=0;while(1){if((j|0)>=(k|0))break;n=+g[l>>2];o=l+(c<<2)|0;m=+g[o>>2];g[o>>2]=m*d+n*e;g[l>>2]=n*d+m*f;l=l+4|0;j=j+1|0;}b=b-(c<<1)|0;j=a+(b+-1<<2)|0;while(1){if((b|0)<=0)break;m=+g[j>>2];o=j+(c<<2)|0;n=+g[o>>2];g[o>>2]=n*d+m*e;g[j>>2]=m*d+n*f;j=j+-4|0;b=b+-1|0;}i=h;return;}function Fd(a,d,e){a=a|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0;f=i;i=i+80|0;l=f+44|0;j=f+8|0;m=f;c[m>>2]=l;c[m+4>>2]=j;h=e>>1;Gd(d,l,j,h);w=Hd(l,8192,h)|0;if((w|0)<0){b[a>>1]=0;g=0;o=j;n=1;w=Hd(j,8192,h)|0;}else{g=0;o=l;n=0;}a:while(1){r=1;q=0;u=8192;b:while(1){p=r;while(1){t=b[21992+(p<<1)>>1]|0;v=Hd(o,t,h)|0;if((w|0)<1){if((v|0)>=(q|0))break;if((w|0)>-1)k=8;}else k=8;if((k|0)==8?(k=0,(v|0)<=(0-q|0)):0)break;if((p|0)>127)break b;else{p=p+1|0;q=0;u=t;w=v;}}q=(v|0)==0?1:0;r=-256;s=0;while(1){if((s|0)>=3)break;y=u+t|0;y=(y>>1)+(y&1)|0;x=Hd(o,y,h)|0;if((w|0)<1){if((x|0)<=-1?!((w|0)>-1&(x|0)<1):0)k=15;else{t=y;v=x;}}else if((x|0)<1){t=y;v=x;}else k=15;if((k|0)==15){k=0;r=r+(128>>>s)|0;u=y;w=x;}s=s+1|0;}o=w-v|0;if((((w|0)>0?w:0-w|0)|0)<65536){if((w|0)!=(v|0))r=r+(((w<<5)+(o>>1)|0)/(o|0)|0)|0;}else r=r+((w|0)/(o>>5|0)|0)|0;b[a+(n<<1)>>1]=Id((p<<8)+r|0)|0;s=n+1|0;if((s|0)>=(e|0)){k=30;break a;}r=p;o=c[m+((s&1)<<2)>>2]|0;n=s;u=b[21992+(p+-1<<1)>>1]|0;w=1-(s&2)<<12;}n=g+1|0;if((g|0)>29)break;w=n<<16;jf(d,e,65536-($(w+655360>>16,w>>16)|0)|0);Gd(d,l,j,h);w=Hd(l,8192,h)|0;if((w|0)>=0){g=n;o=l;n=0;continue;}b[a>>1]=0;g=n;o=j;n=1;w=Hd(j,8192,h)|0;}if((k|0)==30){i=f;return;}b[a>>1]=32768/(e+1|0)|0;g=1;while(1){if((g|0)>=(e|0))break;b[a+(g<<1)>>1]=$((g<<16)+65536>>16,b[a>>1]|0)|0;g=g+1|0;}i=f;return;}function Gd(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0;f=i;c[b+(e<<2)>>2]=65536;c[d+(e<<2)>>2]=65536;g=0;while(1){if((g|0)>=(e|0)){g=e;break;}h=a+(e-g+-1<<2)|0;j=a+(g+e<<2)|0;c[b+(g<<2)>>2]=0-(c[h>>2]|0)-(c[j>>2]|0);c[d+(g<<2)>>2]=(c[j>>2]|0)-(c[h>>2]|0);g=g+1|0;}while(1){if((g|0)<=0)break;j=g+-1|0;h=b+(j<<2)|0;c[h>>2]=(c[h>>2]|0)-(c[b+(g<<2)>>2]|0);h=d+(j<<2)|0;c[h>>2]=(c[h>>2]|0)+(c[d+(g<<2)>>2]|0);g=j;}Jd(b,e);Jd(d,e);i=f;return;}function Hd(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0;e=i;f=c[a+(d<<2)>>2]|0;g=b<<4;if((d|0)==8|0){b=b<<20>>16;h=(g>>15)+1>>1;d=(c[a+28>>2]|0)+(($(f>>16,b)|0)+(($(f&65535,b)|0)>>16))+($(f,h)|0)|0;d=(c[a+24>>2]|0)+(($(d>>16,b)|0)+(($(d&65535,b)|0)>>16))+($(d,h)|0)|0;d=(c[a+20>>2]|0)+(($(d>>16,b)|0)+(($(d&65535,b)|0)>>16))+($(d,h)|0)|0;d=(c[a+16>>2]|0)+(($(d>>16,b)|0)+(($(d&65535,b)|0)>>16))+($(d,h)|0)|0;d=(c[a+12>>2]|0)+(($(d>>16,b)|0)+(($(d&65535,b)|0)>>16))+($(d,h)|0)|0;d=(c[a+8>>2]|0)+(($(d>>16,b)|0)+(($(d&65535,b)|0)>>16))+($(d,h)|0)|0;d=(c[a+4>>2]|0)+(($(d>>16,b)|0)+(($(d&65535,b)|0)>>16))+($(d,h)|0)|0;h=(c[a>>2]|0)+(($(d>>16,b)|0)+(($(d&65535,b)|0)>>16))+($(d,h)|0)|0;i=e;return h|0;}b=b<<20>>16;g=(g>>15)+1>>1;while(1){h=d+-1|0;if((d|0)<=0)break;d=h;f=(c[a+(h<<2)>>2]|0)+(($(f>>16,b)|0)+(($(f&65535,b)|0)>>16))+($(f,g)|0)|0;}i=e;return f|0;}function Id(a){a=a|0;return((a|0)<32767?a:32767)|0;}function Jd(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;d=i;e=2;while(1){if((e|0)>(b|0))break;else f=b;while(1){if((f|0)<=(e|0))break;g=a+(f+-2<<2)|0;c[g>>2]=(c[g>>2]|0)-(c[a+(f<<2)>>2]|0);f=f+-1|0;}g=a+(e+-2<<2)|0;c[g>>2]=(c[g>>2]|0)-(c[a+(e<<2)>>2]<<1);e=e+1|0;}i=d;return;}function Kd(a){a=a|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0;d=i;h=a+2340|0;j=c[h>>2]|0;f=32767/(j+1|0)|0;e=0;g=0;while(1){if((g|0)>=(j|0))break;k=e+f|0;b[a+(g<<1)+4052>>1]=k;j=c[h>>2]|0;e=k;g=g+1|0;}c[a+4148>>2]=0;c[a+4152>>2]=3176576;i=d;return;}function Ld(a,d,e,f){a=a|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0;g=i;i=i+32|0;h=g;k=a+2772|0;j=a+2316|0;if((c[j>>2]|0)!=(c[a+4156>>2]|0)){Kd(a);c[a+4156>>2]=c[j>>2];}j=a+4160|0;do if(!(c[j>>2]|0)){if(!(c[a+4164>>2]|0)){m=a+2340|0;l=0;while(1){if((l|0)>=(c[m>>2]|0))break;A=b[a+(l<<1)+2344>>1]|0;C=a+(l<<1)+4052|0;z=b[C>>1]|0;B=z&65535;b[C>>1]=B+((((A<<16>>16)-(z<<16>>16)>>16)*16348|0)+((((A&65535)-B&65535)*16348|0)>>>16));l=l+1|0;}l=a+2324|0;o=c[l>>2]|0;p=0;n=0;m=0;while(1){if((n|0)>=(o|0))break;B=c[d+(n<<2)+16>>2]|0;A=(B|0)>(p|0);C=A?n:m;p=A?B:p;n=n+1|0;m=C;}n=a+2332|0;C=c[n>>2]|0;zj(a+(C<<2)+2772|0,k|0,($(o+-1|0,C)|0)<<2|0)|0;n=c[n>>2]|0;yj(k|0,a+(($(m,n)|0)<<2)+4|0,n<<2|0)|0;m=a+4148|0;l=c[l>>2]|0;n=0;while(1){if((n|0)>=(l|0))break;B=c[m>>2]|0;C=(c[d+(n<<2)+16>>2]|0)-B|0;c[m>>2]=B+(((C>>16)*4634|0)+(((C&65535)*4634|0)>>>16));n=n+1|0;}if(c[j>>2]|0)break;}wj(a+4084|0,0,c[a+2340>>2]<<2|0)|0;i=g;return;}while(0);d=ta()|0;j=i;i=i+((4*(f+16|0)|0)+15&-16)|0;C=b[a+4224>>1]|0;m=C<<16>>16;n=c[a+4244>>2]|0;l=n<<16>>16;n=($(m>>16,l)|0)+(($(C&65535,l)|0)>>16)+($(m,(n>>15)+1>>1)|0)|0;m=c[a+4148>>2]|0;l=n>>16;if((n|0)>2097151|(m|0)>8388608){C=m>>16;l=(Md(($(C,C)|0)-(($(l,l)|0)<<5)|0)|0)<<16;}else{C=n<<16>>16;B=m<<16>>16;l=(Md(($(m>>16,B)|0)+(($(m&65535,B)|0)>>16)+($(m,(m>>15)+1>>1)|0)-(($(l,C)|0)+(($(n&65535,C)|0)>>16)+($(n,(n>>15)+1>>1)|0)<<5)|0)|0)<<8;}Nd(j+64|0,k,l,f,a+4152|0);k=a+2340|0;Zd(h,a+4052|0,c[k>>2]|0);a=a+4084|0;m=j+0|0;n=a+0|0;l=m+64|0;do{c[m>>2]=c[n>>2];m=m+4|0;n=n+4|0;}while((m|0)<(l|0));x=b[h>>1]|0;w=b[h+2>>1]|0;v=b[h+4>>1]|0;l=b[h+6>>1]|0;t=b[h+8>>1]|0;s=b[h+10>>1]|0;r=b[h+12>>1]|0;q=b[h+14>>1]|0;p=b[h+16>>1]|0;o=b[h+18>>1]|0;m=b[h+20>>1]|0;z=b[h+22>>1]|0;n=b[h+24>>1]|0;u=b[h+26>>1]|0;y=b[h+28>>1]|0;h=b[h+30>>1]|0;A=0;while(1){if((A|0)>=(f|0))break;C=c[j+(A+15<<2)>>2]|0;C=(c[k>>2]>>1)+(($(C>>16,x)|0)+(($(C&65535,x)|0)>>16))|0;B=c[j+(A+14<<2)>>2]|0;B=C+(($(B>>16,w)|0)+(($(B&65535,w)|0)>>16))|0;C=c[j+(A+13<<2)>>2]|0;C=B+(($(C>>16,v)|0)+(($(C&65535,v)|0)>>16))|0;B=c[j+(A+12<<2)>>2]|0;B=C+(($(B>>16,l)|0)+(($(B&65535,l)|0)>>16))|0;C=c[j+(A+11<<2)>>2]|0;C=B+(($(C>>16,t)|0)+(($(C&65535,t)|0)>>16))|0;B=c[j+(A+10<<2)>>2]|0;B=C+(($(B>>16,s)|0)+(($(B&65535,s)|0)>>16))|0;C=c[j+(A+9<<2)>>2]|0;C=B+(($(C>>16,r)|0)+(($(C&65535,r)|0)>>16))|0;B=c[j+(A+8<<2)>>2]|0;B=C+(($(B>>16,q)|0)+(($(B&65535,q)|0)>>16))|0;C=c[j+(A+7<<2)>>2]|0;C=B+(($(C>>16,p)|0)+(($(C&65535,p)|0)>>16))|0;B=c[j+(A+6<<2)>>2]|0;B=C+(($(B>>16,o)|0)+(($(B&65535,o)|0)>>16))|0;if((c[k>>2]|0)==16){C=c[j+(A+5<<2)>>2]|0;C=B+(($(C>>16,m)|0)+(($(C&65535,m)|0)>>16))|0;B=c[j+(A+4<<2)>>2]|0;B=C+(($(B>>16,z)|0)+(($(B&65535,z)|0)>>16))|0;C=c[j+(A+3<<2)>>2]|0;C=B+(($(C>>16,n)|0)+(($(C&65535,n)|0)>>16))|0;B=c[j+(A+2<<2)>>2]|0;B=C+(($(B>>16,u)|0)+(($(B&65535,u)|0)>>16))|0;C=c[j+(A+1<<2)>>2]|0;C=B+(($(C>>16,y)|0)+(($(C&65535,y)|0)>>16))|0;B=c[j+(A<<2)>>2]|0;B=C+(($(B>>16,h)|0)+(($(B&65535,h)|0)>>16))|0;}D=j+(A+16<<2)|0;C=(c[D>>2]|0)+(B<<4)|0;c[D>>2]=C;B=e+(A<<1)|0;C=(b[B>>1]|0)+((C>>9)+1>>1)|0;if((C|0)>32767)C=32767;else C=(C|0)<-32768?-32768:C&65535;b[B>>1]=C;A=A+1|0;}m=a+0|0;n=j+(f<<2)+0|0;l=m+64|0;do{c[m>>2]=c[n>>2];m=m+4|0;n=n+4|0;}while((m|0)<(l|0));ja(d|0);i=g;return;}function Md(a){a=a|0;var b=0,d=0,e=0;b=i;i=i+16|0;d=b+4|0;e=b;if((a|0)<1){e=0;i=b;return e|0;}Od(a,d,e);d=c[d>>2]|0;d=((d&1|0)==0?46214:32768)>>>(d>>1);e=($(c[e>>2]<<16>>16,13959168)|0)>>16;e=d+(($(d>>16,e)|0)+(($(d&65535,e)|0)>>16))|0;i=b;return e|0;}function Nd(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0;h=i;g=255;while(1){if((g|0)<=(e|0))break;g=g>>1;}j=d<<12>>16;d=(d>>19)+1>>1;l=c[f>>2]|0;k=0;while(1){if((k|0)>=(e|0))break;l=($(l,196314165)|0)+907633515|0;m=c[b+((l>>24&g)<<2)>>2]|0;m=($(m>>16,j)|0)+(($(m&65535,j)|0)>>16)+($(m,d)|0)|0;if((m|0)<=32767){if((m|0)<-32768)m=-32768;else m=m<<16>>16;}else m=32767;c[a+(k<<2)>>2]=m;k=k+1|0;}c[f>>2]=l;i=h;return;}function Od(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=i;f=Pd(a)|0;c[b>>2]=f;c[d>>2]=(Qd(a,24-f|0)|0)&127;i=e;return;}function Pd(a){a=a|0;var b=0;b=i;if(!a)a=32;else a=vj(a|0)|0;i=b;return a|0;}function Qd(a,b){a=a|0;b=b|0;var c=0,d=0;c=i;d=0-b|0;do if(b)if((b|0)<0){a=a<<d|a>>>(b+32|0);break;}else{a=a<<32-b|a>>>b;break;}while(0);i=c;return a|0;}function Rd(b){b=b|0;var d=0,e=0,f=0,g=0,h=0;d=i;if((a[b+4565>>0]|0)!=2){i=d;return;}g=$(c[b+4600>>2]|0,65536e3)|0;g=(oh((g|0)/(c[b+4568>>2]|0)|0)|0)+-2048|0;e=c[b+4728>>2]|0;h=0-e<<2;e=e<<16>>16;f=$(h>>16,e)|0;e=$(h&65532,e)|0;h=$(f+(e>>16)>>16,g-((oh(3932160)|0)+63488)<<16>>16)|0;g=g+(h+(($(f+(e>>>16)&65535,g-((oh(3932160)|0)+63488)<<16>>16)|0)>>16))|0;e=b+8|0;f=c[e>>2]|0;g=g-(f>>8)|0;if((g|0)<0)g=g*3|0;if((g|0)>51)g=51;else g=(g|0)<-51?-51:g;h=$(c[b+4556>>2]<<16>>16,g<<16>>16)|0;c[e>>2]=f+(((h>>16)*6554|0)+(((h&65535)*6554|0)>>>16));h=(oh(60)|0)<<8;h=(h|0)>((oh(100)|0)<<8|0);b=c[e>>2]|0;do if(h){if((b|0)>((oh(60)|0)<<8|0)){b=(oh(60)|0)<<8;break;}h=c[e>>2]|0;if((h|0)<((oh(100)|0)<<8|0)){b=(oh(100)|0)<<8;break;}else{b=c[e>>2]|0;break;}}else{if((b|0)>((oh(100)|0)<<8|0)){b=(oh(100)|0)<<8;break;}h=c[e>>2]|0;if((h|0)<((oh(60)|0)<<8|0)){b=(oh(60)|0)<<8;break;}else{b=c[e>>2]|0;break;}}while(0);c[e>>2]=b;i=d;return;}function Sd(a,c,d,e,f,g){a=a|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;l=i;g=d+2|0;m=d+4|0;k=d+6|0;h=d+8|0;n=d+10|0;j=f;while(1){if((j|0)>=(e|0))break;p=j+-1|0;o=$(b[c+(p<<1)>>1]|0,b[d>>1]|0)|0;o=o+($(b[c+(j+-2<<1)>>1]|0,b[g>>1]|0)|0)|0;o=o+($(b[c+(j+-3<<1)>>1]|0,b[m>>1]|0)|0)|0;o=o+($(b[c+(j+-4<<1)>>1]|0,b[k>>1]|0)|0)|0;o=o+($(b[c+(j+-5<<1)>>1]|0,b[h>>1]|0)|0)|0;o=o+($(b[c+(j+-6<<1)>>1]|0,b[n>>1]|0)|0)|0;q=6;while(1){if((q|0)>=(f|0))break;r=o+($(b[c+(p-q<<1)>>1]|0,b[d+(q<<1)>>1]|0)|0)|0;o=r+($(b[c+(p+~q<<1)>>1]|0,b[d+((q|1)<<1)>>1]|0)|0)|0;q=q+2|0;}o=((b[c+(j<<1)>>1]<<12)-o>>11)+1>>1;if((o|0)>32767)o=32767;else o=(o|0)<-32768?-32768:o&65535;b[a+(j<<1)>>1]=o;j=j+1|0;}wj(a|0,0,f<<1|0)|0;i=l;return;}function Td(a,d){a=a|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0;e=i;i=i+128|0;f=e;h=d&1;g=0;j=0;while(1){if((j|0)>=(d|0))break;k=b[a+(j<<1)>>1]|0;c[f+(h<<6)+(j<<2)>>2]=k<<12;g=g+k|0;j=j+1|0;}if((g|0)>4095){k=0;i=e;return k|0;}k=Ud(f,d)|0;i=e;return k|0;}function Ud(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0;d=i;f=b&1;l=1073741824;k=0;while(1){b=b+-1|0;if((b|0)<=0)break;g=c[a+(f<<6)+(b<<2)>>2]|0;if((g|0)>16773022|(g|0)<-16773022){a=0;e=13;break;}j=0-(g<<7)|0;h=((j|0)<0)<<31>>31;Gj(j|0,h|0,j|0,h|0)|0;o=1073741824-D|0;m=32-(Vd((o|0)>0?o:0-o|0)|0)|0;g=Wd(o,m+30|0)|0;k=Gj(l|0,k|0,o|0,((o|0)<0)<<31>>31|0)|0;k=uj(k|0,D|0,30)|0;k=k&-4;l=b&1;o=(m|0)==1;n=((g|0)<0)<<31>>31;m=m+-1|0;p=0;while(1){if((p|0)>=(b|0))break;q=c[a+(f<<6)+(p<<2)>>2]|0;r=c[a+(f<<6)+(b-p+-1<<2)>>2]|0;r=Gj(r|0,((r|0)<0)<<31>>31|0,j|0,h|0)|0;r=uj(r|0,D|0,30)|0;r=xj(r|0,D|0,1,0)|0;r=uj(r|0,D|0,1)|0;r=q-r|0;r=Gj(r|0,((r|0)<0)<<31>>31|0,g|0,n|0)|0;q=D;if(o){q=uj(r|0,q|0,1)|0;q=xj(q|0,D|0,r&1|0,0)|0;}else{q=tj(r|0,q|0,m|0)|0;q=xj(q|0,D|0,1,0)|0;q=uj(q|0,D|0,1)|0;}c[a+(l<<6)+(p<<2)>>2]=q;p=p+1|0;}f=l;l=k;k=((k|0)<0)<<31>>31;}if((e|0)==13){i=d;return a|0;}e=c[a+(f<<6)>>2]|0;if((e|0)>16773022|(e|0)<-16773022){r=0;i=d;return r|0;}q=0-(e<<7)|0;r=((q|0)<0)<<31>>31;Gj(q|0,r|0,q|0,r|0)|0;r=1073741824-D|0;r=Gj(l|0,k|0,r|0,((r|0)<0)<<31>>31|0)|0;r=uj(r|0,D|0,30)|0;r=r&-4;i=d;return r|0;}function Vd(a){a=a|0;var b=0;b=i;if(!a)a=32;else a=vj(a|0)|0;i=b;return a|0;}function Wd(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,f=0,g=0,h=0;c=i;e=Vd((a|0)>0?a:0-a|0)|0;d=a<<e+-1;h=d>>16;a=536870911/(h|0)|0;g=a<<16;f=g>>16;d=536870912-(($(h,f)|0)+(($(d&65535,f)|0)>>16))<<3;a=g+(($(d>>16,f)|0)+(($(d&65528,f)|0)>>16))+($(d,(a>>15)+1>>1)|0)|0;b=62-e-b|0;if((b|0)>=1){i=c;return((b|0)<32?a>>b:0)|0;}b=0-b|0;d=-2147483648>>b;e=2147483647>>>b;if((d|0)>(e|0)){if((a|0)>(d|0)){h=d;h=h<<b;i=c;return h|0;}h=(a|0)<(e|0)?e:a;h=h<<b;i=c;return h|0;}else{if((a|0)>(e|0)){h=e;h=h<<b;i=c;return h|0;}h=(a|0)<(d|0)?d:a;h=h<<b;i=c;return h|0;}return 0;}function Xd(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0;e=i;i=i+32|0;f=e+8|0;g=e;j=a+12|0;if(!(c[j>>2]|0)){i=e;return;}h=a+8|0;l=256-(c[h>>2]|0)<<10;k=l>>16;Yd(f,g,k,l-(k<<16)|0);j=(c[h>>2]|0)+(c[j>>2]|0)|0;if((j|0)>256)j=256;else j=(j|0)<0?0:j;c[h>>2]=j;gf(b,f,g,a,b,d);i=e;return;}function Yd(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0;h=i;if((d|0)>=4){c[a+0>>2]=c[6270];c[a+4>>2]=c[6271];c[a+8>>2]=c[6272];e=b;c[e>>2]=35497197;c[e+4>>2]=57401098;i=h;return;}if((e|0)<=0){g=25032+(d*12|0)|0;c[a+0>>2]=c[g+0>>2];c[a+4>>2]=c[g+4>>2];c[a+8>>2]=c[g+8>>2];g=25096+(d<<3)|0;a=c[g+4>>2]|0;e=b;c[e>>2]=c[g>>2];c[e+4>>2]=a;i=h;return;}f=d+1|0;g=e<<16>>16;if((e|0)<32768){e=0;while(1){if((e|0)>=3){a=0;break;}k=c[25032+(d*12|0)+(e<<2)>>2]|0;j=(c[25032+(f*12|0)+(e<<2)>>2]|0)-k|0;c[a+(e<<2)>>2]=k+(($(j>>16,g)|0)+(($(j&65535,g)|0)>>16));e=e+1|0;}while(1){if((a|0)>=2)break;j=c[25096+(d<<3)+(a<<2)>>2]|0;k=(c[25096+(f<<3)+(a<<2)>>2]|0)-j|0;c[b+(a<<2)>>2]=j+(($(k>>16,g)|0)+(($(k&65535,g)|0)>>16));a=a+1|0;}i=h;return;}else{e=0;while(1){if((e|0)>=3){a=0;break;}j=c[25032+(f*12|0)+(e<<2)>>2]|0;k=j-(c[25032+(d*12|0)+(e<<2)>>2]|0)|0;c[a+(e<<2)>>2]=j+(($(k>>16,g)|0)+(($(k&65535,g)|0)>>16));e=e+1|0;}while(1){if((a|0)>=2)break;j=c[25096+(f<<3)+(a<<2)>>2]|0;k=j-(c[25096+(d<<3)+(a<<2)>>2]|0)|0;c[b+(a<<2)>>2]=j+(($(k>>16,g)|0)+(($(k&65535,g)|0)>>16));a=a+1|0;}i=h;return;}}function Zd(a,e,f){a=a|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;g=i;i=i+208|0;l=g+136|0;j=g+100|0;k=g+64|0;h=g;m=(f|0)==16?21176:21192;n=0;while(1){if((n|0)>=(f|0))break;p=b[e+(n<<1)>>1]|0;o=p>>8;q=b[21992+(o<<1)>>1]|0;o=((q<<8)+($((b[21992+(o+1<<1)>>1]|0)-q|0,p-(o<<8)|0)|0)>>3)+1>>1;c[l+(d[m+n>>0]<<2)>>2]=o;n=n+1|0;}m=f>>1;_d(j,l,m);_d(k,l+4|0,m);l=0;while(1){if((l|0)>=(m|0))break;q=l+1|0;p=(c[j+(q<<2)>>2]|0)+(c[j+(l<<2)>>2]|0)|0;o=(c[k+(q<<2)>>2]|0)-(c[k+(l<<2)>>2]|0)|0;c[h+(l<<2)>>2]=0-o-p;c[h+(f-l+-1<<2)>>2]=o-p;l=q;}k=0;j=0;while(1){if((j|0)<10){l=0;m=0;}else break;while(1){if((m|0)>=(f|0))break;q=c[h+(m<<2)>>2]|0;q=(q|0)>0?q:0-q|0;p=(q|0)>(l|0);k=p?m:k;l=p?q:l;m=m+1|0;}l=(l>>4)+1>>1;if((l|0)<=32767)break;q=(l|0)<163838?l:163838;jf(h,f,65470-(((q<<14)+-536854528|0)/(($(q,k+1|0)|0)>>2|0)|0)|0);j=j+1|0;}a:do if((j|0)==10){k=0;while(1){if((k|0)>=(f|0)){k=0;break a;}j=h+(k<<2)|0;l=(c[j>>2]>>4)+1>>1;if((l|0)>32767)l=32767;else l=(l|0)<-32768?-32768:l&65535;b[a+(k<<1)>>1]=l;c[j>>2]=l<<16>>16<<5;k=k+1|0;}}else{j=0;while(1){if((j|0)>=(f|0)){k=0;break a;}b[a+(j<<1)>>1]=(((c[h+(j<<2)>>2]|0)>>>4)+1|0)>>>1;j=j+1|0;}}while(0);while(1){if((k|0)>=16){a=26;break;}if((Td(a,f)|0)>=107374){a=26;break;}jf(h,f,65536-(2<<k)|0);j=0;while(1){if((j|0)>=(f|0))break;b[a+(j<<1)>>1]=(((c[h+(j<<2)>>2]|0)>>>4)+1|0)>>>1;j=j+1|0;}k=k+1|0;}if((a|0)==26){i=g;return;}}function _d(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0;f=i;c[a>>2]=65536;e=a+4|0;g=1;h=0-(c[b>>2]|0)|0;while(1){c[e>>2]=h;if((g|0)>=(d|0))break;j=c[b+(g<<1<<2)>>2]|0;l=c[a+(g+-1<<2)>>2]|0;k=((j|0)<0)<<31>>31;m=c[a+(g<<2)>>2]|0;m=Gj(j|0,k|0,m|0,((m|0)<0)<<31>>31|0)|0;m=uj(m|0,D|0,15)|0;m=xj(m|0,D|0,1,0)|0;m=uj(m|0,D|0,1)|0;h=g+1|0;c[a+(h<<2)>>2]=(l<<1)-m;while(1){if((g|0)<=1)break;m=c[a+(g+-2<<2)>>2]|0;o=Gj(j|0,k|0,l|0,((l|0)<0)<<31>>31|0)|0;o=uj(o|0,D|0,15)|0;o=xj(o|0,D|0,1,0)|0;o=uj(o|0,D|0,1)|0;n=a+(g<<2)|0;c[n>>2]=(c[n>>2]|0)+(m-o);l=m;g=g+-1|0;}g=h;h=(c[e>>2]|0)-j|0;}i=f;return;}function $d(a,b,f,g,h){a=a|0;b=b|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0;j=i;k=0;while(1){if((k|0)<(g|0)){m=0;l=0;}else break;while(1){if((m|0)>=(h|0))break;o=(e[b+(m<<1)>>1]|0)-((d[f>>0]|0)<<7)<<16>>16;o=$(o,o)|0;n=(e[b+((m|1)<<1)>>1]|0)-((d[f+1>>0]|0)<<7)<<16>>16;f=f+2|0;m=m+2|0;l=l+((o+($(n,n)|0)|0)>>>4)|0;}c[a+(k<<2)>>2]=l;k=k+1|0;}i=j;return;}function ae(a,c,d){a=a|0;c=c|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0;e=i;f=b[c>>1]|0;g=131072/(be(f)|0)|0;f=131072/(be((b[c+2>>1]|0)-f|0)|0)|0;b[a>>1]=ce(g+f|0)|0;d=d+-1|0;g=1;while(1){if((g|0)>=(d|0))break;k=g+1|0;h=c+(k<<1)|0;l=131072/(be((b[h>>1]|0)-(b[c+(g<<1)>>1]|0)|0)|0)|0;b[a+(g<<1)>>1]=ce(l+f|0)|0;j=g+2|0;h=131072/(be((b[c+(j<<1)>>1]|0)-(b[h>>1]|0)|0)|0)|0;b[a+(k<<1)>>1]=ce(l+h|0)|0;g=j;f=h;}b[a+(d<<1)>>1]=ce((131072/(be(32768-(b[c+(d<<1)>>1]|0)|0)|0)|0)+f|0)|0;i=e;return;}function be(a){a=a|0;return((a|0)>1?a:1)|0;}function ce(a){a=a|0;return((a|0)<32767?a:32767)|0;}function de(f,g,h){f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;m=i;i=i+112|0;q=m+96|0;n=m+64|0;k=m+32|0;l=m;j=h+2|0;r=b[j>>1]|0;p=$(a[g>>0]|0,r<<16>>16)|0;o=c[h+8>>2]|0;s=0;while(1){if((s|0)>=(r<<16>>16|0))break;b[f+(s<<1)>>1]=d[o+(p+s)>>0]<<7;r=b[j>>1]|0;s=s+1|0;}se(n,q,h,a[g>>0]|0);ee(k,g+1|0,q,b[h+4>>1]|0,b[j>>1]|0);ae(l,f,b[j>>1]|0);n=0;while(1){o=b[j>>1]|0;if((n|0)>=(o|0))break;p=fe(e[l+(n<<1)>>1]<<16)|0;o=f+(n<<1)|0;p=(b[o>>1]|0)+((b[k+(n<<1)>>1]<<14|0)/(p|0)|0)|0;if((p|0)>32767)p=32767;else p=(p|0)<0?0:p&65535;b[o>>1]=p;n=n+1|0;}pe(f,c[h+32>>2]|0,o);i=m;return;}function ee(c,e,f,g,h){c=c|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0;j=i;g=g<<16>>16;k=0;l=h<<16>>16;while(1){h=l+-1|0;if((l|0)<=0)break;k=($(k,d[f+h>>0]|0)|0)>>8;l=a[e+h>>0]|0;m=l<<24>>24<<10;if(l<<24>>24>0)l=m+-102|0;else l=l<<24>>24<0?m|102:m;k=k+(($(l>>16,g)|0)+(($(l&65535,g)|0)>>16))|0;b[c+(h<<1)>>1]=k;k=k<<16>>16;l=h;}i=j;return;}function fe(a){a=a|0;var b=0,d=0,e=0;b=i;i=i+16|0;d=b+4|0;e=b;if((a|0)<1){e=0;i=b;return e|0;}ge(a,d,e);d=c[d>>2]|0;d=((d&1|0)==0?46214:32768)>>>(d>>1);e=($(c[e>>2]<<16>>16,13959168)|0)>>16;e=d+(($(d>>16,e)|0)+(($(d&65535,e)|0)>>16))|0;i=b;return e|0;}function ge(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=i;f=he(a)|0;c[b>>2]=f;c[d>>2]=(ie(a,24-f|0)|0)&127;i=e;return;}function he(a){a=a|0;var b=0;b=i;if(!a)a=32;else a=vj(a|0)|0;i=b;return a|0;}function ie(a,b){a=a|0;b=b|0;var c=0,d=0;c=i;d=0-b|0;do if(b)if((b|0)<0){a=a<<d|a>>>(b+32|0);break;}else{a=a<<32-b|a>>>b;break;}while(0);i=c;return a|0;}function je(e,f,g,h,j,k,l,m,n,o){e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;var p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0;p=i;i=i+320|0;u=p+224|0;q=p+256|0;x=p+240|0;r=p+192|0;t=p+176|0;s=p+160|0;w=p+80|0;v=p;y=l<<16>>16;z=-10;while(1){if((z|0)>=10)break;A=z<<10;B=A+1024|0;do if((z|0)<=0){if((z|0)==-1){l=A|102;break;}else if(!z){l=A;B=A|922;break;}else{l=A|102;B=A+1126|0;break;}}else{l=A+-102|0;B=A|922;}while(0);J=z+10|0;c[w+(J<<2)>>2]=($(l>>16,y)|0)+(($(l&65535,y)|0)>>16);c[v+(J<<2)>>2]=($(B>>16,y)|0)+(($(B&65535,y)|0)>>16);z=z+1|0;}c[r>>2]=0;b[x>>1]=0;o=o<<16>>16;l=m<<16>>16>>16;m=m&65535;n=n<<16>>16;z=1;y=o;a:while(1){y=y+-1|0;B=b[j+(y<<1)>>1]|0;D=d[h+y>>0]<<8;C=b[f+(y<<1)>>1]|0;E=g+(y<<1)|0;A=0;while(1){if((A|0)>=(z|0))break;I=x+(A<<1)|0;G=($(D,b[I>>1]|0)|0)>>16;F=C-G<<16>>16;F=($(l,F)|0)+(($(m,F)|0)>>16)|0;if((F|0)>9)H=9;else H=(F|0)<-10?-10:F;a[q+(A<<4)+y>>0]=H;J=H+10|0;F=(c[w+(J<<2)>>2]|0)+G|0;G=(c[v+(J<<2)>>2]|0)+G|0;b[I>>1]=F;J=A+z|0;b[x+(J<<1)>>1]=G;do if((H|0)>2){if((H|0)==3){I=d[k+(B+7)>>0]|0;H=280;break;}else{H=(H<<16>>16)*43|0;I=H+108|0;H=H+151|0;break;}}else{if((H|0)>=-3){I=d[k+(B+(H+4))>>0]|0;H=d[k+(B+(H+5))>>0]|0;break;}if((H|0)==-4){I=280;H=d[k+(B+1)>>0]|0;break;}else{H=$(H<<16>>16,-43)|0;I=H+108|0;H=H+65|0;break;}}while(0);L=r+(A<<2)|0;K=c[L>>2]|0;M=C-F<<16>>16;M=$(M,M)|0;F=b[E>>1]|0;c[L>>2]=K+($(M,F)|0)+($(n,I<<16>>16)|0);I=C-G<<16>>16;c[r+(J<<2)>>2]=K+($($(I,I)|0,F)|0)+($(n,H<<16>>16)|0);A=A+1|0;}if((z|0)<3){A=0;while(1){if((A|0)>=(z|0))break;a[q+(A+z<<4)+y>>0]=(d[q+(A<<4)+y>>0]|0)+1;A=A+1|0;}z=z<<1;A=z;while(1){if((A|0)>=4)continue a;a[q+(A<<4)+y>>0]=a[q+(A-z<<4)+y>>0]|0;A=A+1|0;}}if((y|0)>0)C=0;else{s=0;h=2147483647;t=0;break;}while(1){if((C|0)>=4){B=0;A=0;E=0;D=2147483647;C=0;break;}E=r+(C<<2)|0;D=c[E>>2]|0;F=C+4|0;A=r+(F<<2)|0;B=c[A>>2]|0;if((D|0)>(B|0)){c[s+(C<<2)>>2]=D;c[t+(C<<2)>>2]=B;c[E>>2]=B;c[A>>2]=D;K=x+(C<<1)|0;L=b[K>>1]|0;M=x+(F<<1)|0;b[K>>1]=b[M>>1]|0;b[M>>1]=L;c[u+(C<<2)>>2]=F;}else{c[t+(C<<2)>>2]=D;c[s+(C<<2)>>2]=B;c[u+(C<<2)>>2]=C;}C=C+1|0;}while(1){if((C|0)<4){M=c[s+(C<<2)>>2]|0;L=(D|0)>(M|0);K=c[t+(C<<2)>>2]|0;J=(E|0)<(K|0);B=J?C:B;A=L?C:A;E=J?K:E;D=L?M:D;C=C+1|0;continue;}if((D|0)>=(E|0)){A=0;break;}c[u+(B<<2)>>2]=c[u+(A<<2)>>2]^4;C=A+4|0;c[r+(B<<2)>>2]=c[r+(C<<2)>>2];b[x+(B<<1)>>1]=b[x+(C<<1)>>1]|0;c[t+(B<<2)>>2]=0;c[s+(A<<2)>>2]=2147483647;B=q+(B<<4)+0|0;A=q+(A<<4)+0|0;C=B+16|0;do{a[B>>0]=a[A>>0]|0;B=B+1|0;A=A+1|0;}while((B|0)<(C|0));B=0;A=0;E=0;D=2147483647;C=0;}while(1){if((A|0)>=4)continue a;M=q+(A<<4)+y|0;a[M>>0]=(d[M>>0]|0)+((c[u+(A<<2)>>2]|0)>>>2);A=A+1|0;}}while(1){if((t|0)>=8)break;M=c[r+(t<<2)>>2]|0;L=(h|0)>(M|0);s=L?t:s;h=L?M:h;t=t+1|0;}r=s&3;t=0;while(1){if((t|0)>=(o|0))break;a[e+t>>0]=a[q+(r<<4)+t>>0]|0;t=t+1|0;}a[e>>0]=(d[e>>0]|0)+(s>>>2);i=p;return h|0;}function ke(f,g,h,j,k,l,m){f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;var n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0;r=i;i=i+224|0;x=r;A=r+168|0;u=r+136|0;B=r+104|0;z=r+72|0;v=r+40|0;t=r+200|0;s=r+8|0;q=h+2|0;pe(g,c[h+32>>2]|0,b[q>>1]|0);o=b[h>>1]|0;D=i;i=i+((4*(o&65535)|0)+15&-16)|0;C=h+8|0;$d(D,g,c[C>>2]|0,o<<16>>16,b[q>>1]|0);o=i;i=i+((4*l|0)+15&-16)|0;Mh(D,o,b[h>>1]|0,l);D=i;i=i+((4*l|0)+15&-16)|0;p=i;i=i+((1*(l<<4)|0)+15&-16)|0;w=h+28|0;n=h+4|0;y=h+6|0;E=m>>1;G=h+12|0;m=k<<14>>16;F=0;while(1){if((F|0)>=(l|0))break;H=c[o+(F<<2)>>2]|0;I=b[q>>1]|0;K=$(H,I)|0;J=c[C>>2]|0;L=0;while(1){if((L|0)>=(I|0))break;M=d[J+(K+L)>>0]<<7;b[B+(L<<1)>>1]=M;b[A+(L<<1)>>1]=(e[g+(L<<1)>>1]|0)-M;L=L+1|0;}ae(z,B,I);J=0;while(1){I=b[q>>1]|0;if((J|0)>=(I|0)){J=0;break;}M=le(e[z+(J<<1)>>1]<<16)|0;b[u+(J<<1)>>1]=($(b[A+(J<<1)>>1]|0,M<<16>>16)|0)>>>14;J=J+1|0;}while(1){if((J|0)>=(I|0))break;b[v+(J<<1)>>1]=(b[j+(J<<1)>>1]<<5|0)/(b[z+(J<<1)>>1]|0)|0;J=J+1|0;}se(s,t,h,H);J=je(p+(F<<4)|0,u,v,t,s,c[w>>2]|0,b[n>>1]|0,b[y>>1]|0,k,b[q>>1]|0)|0;I=D+(F<<2)|0;c[I>>2]=J;K=$(E,b[h>>1]|0)|0;L=c[G>>2]|0;if(!H)H=256-(d[L+K>>0]|0)|0;else H=(d[L+(K+(H+-1))>>0]|0)-(d[L+(K+H)>>0]|0)|0;c[I>>2]=J+($(1024-(oh(H)|0)<<16>>16,m)|0);F=F+1|0;}Mh(D,x,l,1);M=c[x>>2]|0;a[f>>0]=c[o+(M<<2)>>2];yj(f+1|0,p+(M<<4)|0,b[q>>1]|0)|0;de(g,f,h);i=r;return;}function le(a){a=a|0;var b=0,d=0,e=0;b=i;i=i+16|0;d=b+4|0;e=b;if((a|0)<1){e=0;i=b;return e|0;}me(a,d,e);d=c[d>>2]|0;d=((d&1|0)==0?46214:32768)>>>(d>>1);e=($(c[e>>2]<<16>>16,13959168)|0)>>16;e=d+(($(d>>16,e)|0)+(($(d&65535,e)|0)>>16))|0;i=b;return e|0;}function me(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=i;f=ne(a)|0;c[b>>2]=f;c[d>>2]=(oe(a,24-f|0)|0)&127;i=e;return;}function ne(a){a=a|0;var b=0;b=i;if(!a)a=32;else a=vj(a|0)|0;i=b;return a|0;}function oe(a,b){a=a|0;b=b|0;var c=0,d=0;c=i;d=0-b|0;do if(b)if((b|0)<0){a=a<<d|a>>>(b+32|0);break;}else{a=a<<32-b|a>>>b;break;}while(0);i=c;return a|0;}function pe(a,c,d){a=a|0;c=c|0;d=d|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0;f=i;l=d+-1|0;g=a+(l<<1)|0;h=c+(d<<1)|0;k=0;while(1){if((k|0)>=20)break;o=b[a>>1]|0;n=b[c>>1]|0;p=o;m=0;o=(o<<16>>16)-(n<<16>>16)|0;q=1;while(1){if((q|0)>(l|0))break;t=b[a+(q<<1)>>1]|0;s=(t<<16>>16)-((p<<16>>16)+(b[c+(q<<1)>>1]|0))|0;r=(s|0)<(o|0);p=t;m=r?q:m;o=r?s:o;q=q+1|0;}p=b[h>>1]|0;t=32768-((b[g>>1]|0)+(p<<16>>16))|0;s=(t|0)<(o|0);m=s?d:m;if(((s?t:o)|0)>-1){j=30;break;}do if(!m)b[a>>1]=n;else{if((m|0)==(d|0)){b[g>>1]=32768-(p&65535);break;}else{p=0;n=0;}while(1){if((n|0)>=(m|0))break;p=p+(b[c+(n<<1)>>1]|0)|0;n=n+1|0;}n=c+(m<<1)|0;o=b[n>>1]|0;q=o>>1;p=p+q|0;r=32768;s=d;while(1){if((s|0)<=(m|0))break;r=r-(b[c+(s<<1)>>1]|0)|0;s=s+-1|0;}r=r-q|0;t=b[a+(m+-1<<1)>>1]|0;q=b[a+(m<<1)>>1]|0;q=((t<<16>>16)+(q<<16>>16)>>1)+((t&65535)+(q&65535)&1)|0;if((p|0)>(r|0)){if((q|0)<=(p|0))p=(q|0)<(r|0)?r:q;}else if((q|0)>(r|0))p=r;else p=(q|0)<(p|0)?p:q;t=p-(o>>>1)|0;b[a+(m+-1<<1)>>1]=t;b[a+(m<<1)>>1]=t+(e[n>>1]|0);}while(0);k=k+1|0;}if((j|0)==30){i=f;return;}if((k|0)!=20){i=f;return;}Nh(a,d);k=qe(b[a>>1]|0,b[c>>1]|0)|0;b[a>>1]=k;j=1;while(1){if((j|0)>=(d|0))break;s=a+(j<<1)|0;t=qe(b[s>>1]|0,(k<<16>>16)+(b[c+(j<<1)>>1]|0)|0)|0;b[s>>1]=t;k=t;j=j+1|0;}t=re(b[g>>1]|0,32768-(b[h>>1]|0)|0)|0;b[g>>1]=t;g=t;d=d+-2|0;while(1){if((d|0)<=-1)break;s=a+(d<<1)|0;t=re(b[s>>1]|0,(g<<16>>16)-(b[c+(d+1<<1)>>1]|0)|0)|0;b[s>>1]=t;g=t;d=d+-1|0;}i=f;return;}function qe(a,b){a=a|0;b=b|0;return((a|0)>(b|0)?a:b)|0;}function re(a,b){a=a|0;b=b|0;return((a|0)<(b|0)?a:b)|0;}function se(d,e,f,g){d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0;h=i;j=f+2|0;k=b[j>>1]|0;l=($(k<<16>>16,g)|0)/2|0;g=f+16|0;f=(c[f+20>>2]|0)+l|0;l=0;while(1){if((l|0)>=(k<<16>>16|0))break;n=a[f>>0]|0;m=n&255;b[d+(l<<1)>>1]=(m>>>1&7)*9;a[e+l>>0]=a[(c[g>>2]|0)+(l+((b[j>>1]|0)+-1&0-(m&1)))>>0]|0;k=l|1;b[d+(k<<1)>>1]=((n&255)>>>5&255)*9;a[e+k>>0]=a[(c[g>>2]|0)+(l+((b[j>>1]|0)+-1&0-(m>>>4&1))+1)>>0]|0;k=b[j>>1]|0;f=f+1|0;l=l+2|0;}i=h;return;}function te(d,e,f,g,h,j,k,l,m,n,o,p,q,r,s){d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=r|0;s=s|0;var t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0;t=i;c[e+4368>>2]=a[f+34>>0];v=e+4356|0;R=c[v>>2]|0;u=f+29|0;w=b[24968+(a[u>>0]>>1<<2)+(a[f+30>>0]<<1)>>1]|0;C=(a[f+31>>0]|0)==4?0:1;x=d+4616|0;f=c[x>>2]|0;y=d+4608|0;H=f+(c[y>>2]|0)|0;J=i;i=i+((4*H|0)+15&-16)|0;G=i;i=i+((2*H|0)+15&-16)|0;H=d+4612|0;z=i;i=i+((4*(c[H>>2]|0)|0)+15&-16)|0;c[e+4364>>2]=f;f=e+4360|0;c[f>>2]=c[x>>2];A=d+4604|0;B=C^1;E=e+4376|0;C=C<<1^3;I=d+4664|0;F=d+5124|0;D=d+4660|0;K=e+(c[x>>2]<<1)|0;L=0;while(1){M=c[A>>2]|0;if((L|0)>=(M|0))break;P=j+((L>>1|B)<<4<<1)|0;O=k+(L*5<<1)|0;N=l+(L<<4<<1)|0;M=c[m+(L<<2)>>2]|0;M=M>>2|M>>>1<<16;c[E>>2]=0;Q=a[u>>0]|0;if(Q<<24>>24==2){R=c[q+(L<<2)>>2]|0;if(!(L&C)){T=c[x>>2]|0;Q=c[I>>2]|0;S=T-R-Q+-2|0;U=e+(S+($(L,c[H>>2]|0)|0)<<1)|0;Sd(G+(S<<1)|0,U,P,T-S|0,Q,c[F>>2]|0);c[E>>2]=1;c[f>>2]=c[x>>2];Q=a[u>>0]|0;}else Q=2;}ue(d,e,g,z,G,J,L,s,p,q,Q<<24>>24);ve(e,a[u>>0]|0,z,h,K,J,P,O,N,R,M,c[n+(L<<2)>>2]|0,c[o+(L<<2)>>2]|0,c[p+(L<<2)>>2]|0,r,w,c[H>>2]|0,c[D>>2]|0,c[I>>2]|0);U=c[H>>2]|0;g=g+(U<<2)|0;h=h+U|0;K=K+(U<<1)|0;L=L+1|0;}c[v>>2]=c[q+(M+-1<<2)>>2];zj(e|0,e+(c[y>>2]<<1)|0,c[x>>2]<<1|0)|0;zj(e+1280|0,e+(c[y>>2]<<2)+1280|0,c[x>>2]<<2|0)|0;i=t;return;}function ue(a,d,e,f,g,h,j,k,l,m,n){a=a|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;var o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;o=i;m=c[m+(j<<2)>>2]|0;r=l+(j<<2)|0;l=c[r>>2]|0;p=we((l|0)>1?l:1)|0;q=d+4372|0;s=c[q>>2]|0;if((l|0)==(s|0))l=65536;else l=xe(s,l)|0;s=(p>>7)+1|0;v=a+4612|0;t=s>>>1<<16>>16;s=(s>>16)+1>>1;u=0;while(1){if((u|0)>=(c[v>>2]|0))break;w=c[e+(u<<2)>>2]|0;c[f+(u<<2)>>2]=($(w>>16,t)|0)+(($(w&65535,t)|0)>>16)+($(w,s)|0);u=u+1|0;}c[q>>2]=c[r>>2];e=d+4376|0;a:do if(c[e>>2]|0){if(!j){w=k<<16>>16;p=($(p>>16,w)|0)+(($(p&65535,w)|0)>>16)<<2;}j=d+4360|0;q=c[j>>2]|0;k=p>>16;f=p&65535;p=q;q=q-m+-2|0;while(1){if((q|0)>=(p|0))break a;p=b[g+(q<<1)>>1]|0;c[h+(q<<2)>>2]=($(k,p)|0)+(($(f,p)|0)>>16);p=c[j>>2]|0;q=q+1|0;}}while(0);if((l|0)==65536){i=o;return;}j=d+4364|0;w=c[j>>2]|0;g=l>>16;k=l&65535;f=w;a=w-(c[a+4616>>2]|0)|0;while(1){if((a|0)>=(f|0))break;f=d+(a<<2)+1280|0;w=c[f>>2]|0;v=w<<16>>16;c[f>>2]=($(g,v)|0)+(($(k,v)|0)>>16)+($(l,(w>>15)+1>>1)|0);f=c[j>>2]|0;a=a+1|0;}b:do if((n|0)==2?(c[e>>2]|0)==0:0){n=d+4360|0;w=c[n>>2]|0;a=w;m=w-m+-2|0;while(1){if((m|0)>=(a|0))break b;a=h+(m<<2)|0;w=c[a>>2]|0;v=w<<16>>16;c[a>>2]=($(g,v)|0)+(($(k,v)|0)>>16)+($(l,(w>>15)+1>>1)|0);a=c[n>>2]|0;m=m+1|0;}}while(0);h=d+4352|0;w=c[h>>2]|0;v=w<<16>>16;c[h>>2]=($(g,v)|0)+(($(k,v)|0)>>16)+($(l,(w>>15)+1>>1)|0);h=0;while(1){if((h|0)>=32){h=0;break;}w=d+(h<<2)+3840|0;v=c[w>>2]|0;u=v<<16>>16;c[w>>2]=($(g,u)|0)+(($(k,u)|0)>>16)+($(l,(v>>15)+1>>1)|0);h=h+1|0;}while(1){if((h|0)>=16)break;w=d+(h<<2)+4288|0;v=c[w>>2]|0;u=v<<16>>16;c[w>>2]=($(g,u)|0)+(($(k,u)|0)>>16)+($(l,(v>>15)+1>>1)|0);h=h+1|0;}i=o;return;}function ve(d,e,f,g,h,j,k,l,m,n,o,p,q,r,s,t,u,v,w){d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=r|0;s=s|0;t=t|0;u=u|0;v=v|0;w=w|0;var x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0,la=0,ma=0,na=0,oa=0,pa=0,qa=0,ra=0,sa=0,ta=0,ua=0;x=i;D=d+4364|0;z=d+4360|0;y=d+4368|0;K=w>>1;J=k+2|0;I=k+4|0;H=k+6|0;G=k+8|0;F=k+10|0;E=k+12|0;C=k+14|0;B=k+16|0;A=k+18|0;Q=(w|0)==16;P=k+20|0;w=k+22|0;L=k+24|0;M=k+26|0;N=k+28|0;O=k+30|0;U=(e|0)==2;R=l+2|0;Y=l+4|0;S=l+6|0;V=l+8|0;T=d+4288|0;e=v>>1;X=v+-1|0;Z=d+(X<<2)+4288|0;X=m+(X<<1)|0;W=d+4352|0;p=p<<16>>16;_=q<<16>>16;q=q>>16;ba=(n|0)>0;aa=o<<16>>16;o=o>>16;ca=s<<16>>16;s=r>>>6<<16>>16;ia=(r>>21)+1>>1;ea=t+944|0;r=$(t<<16>>16,ca)|0;fa=$(ea<<16>>16,ca)|0;ha=t+-944|0;da=$(944-t<<16>>16,ca)|0;ja=j+((c[z>>2]|0)-n+2<<2)|0;ga=d+3964|0;oa=d+((c[D>>2]|0)-n+1<<2)+1280|0;n=0;while(1){if((n|0)>=(u|0))break;c[y>>2]=($(c[y>>2]|0,196314165)|0)+907633515;ta=c[ga>>2]|0;sa=b[k>>1]|0;sa=K+(($(ta>>16,sa)|0)+(($(ta&65535,sa)|0)>>16))|0;ta=c[ga+-4>>2]|0;ka=b[J>>1]|0;ka=sa+(($(ta>>16,ka)|0)+(($(ta&65535,ka)|0)>>16))|0;ta=c[ga+-8>>2]|0;sa=b[I>>1]|0;sa=ka+(($(ta>>16,sa)|0)+(($(ta&65535,sa)|0)>>16))|0;ta=c[ga+-12>>2]|0;ka=b[H>>1]|0;ka=sa+(($(ta>>16,ka)|0)+(($(ta&65535,ka)|0)>>16))|0;ta=c[ga+-16>>2]|0;sa=b[G>>1]|0;sa=ka+(($(ta>>16,sa)|0)+(($(ta&65535,sa)|0)>>16))|0;ta=c[ga+-20>>2]|0;ka=b[F>>1]|0;ka=sa+(($(ta>>16,ka)|0)+(($(ta&65535,ka)|0)>>16))|0;ta=c[ga+-24>>2]|0;sa=b[E>>1]|0;sa=ka+(($(ta>>16,sa)|0)+(($(ta&65535,sa)|0)>>16))|0;ta=c[ga+-28>>2]|0;ka=b[C>>1]|0;ka=sa+(($(ta>>16,ka)|0)+(($(ta&65535,ka)|0)>>16))|0;ta=c[ga+-32>>2]|0;sa=b[B>>1]|0;sa=ka+(($(ta>>16,sa)|0)+(($(ta&65535,sa)|0)>>16))|0;ta=c[ga+-36>>2]|0;ka=b[A>>1]|0;ka=sa+(($(ta>>16,ka)|0)+(($(ta&65535,ka)|0)>>16))|0;if(Q){ta=c[ga+-40>>2]|0;sa=b[P>>1]|0;sa=ka+(($(ta>>16,sa)|0)+(($(ta&65535,sa)|0)>>16))|0;ta=c[ga+-44>>2]|0;ka=b[w>>1]|0;ka=sa+(($(ta>>16,ka)|0)+(($(ta&65535,ka)|0)>>16))|0;ta=c[ga+-48>>2]|0;sa=b[L>>1]|0;sa=ka+(($(ta>>16,sa)|0)+(($(ta&65535,sa)|0)>>16))|0;ta=c[ga+-52>>2]|0;ka=b[M>>1]|0;ka=sa+(($(ta>>16,ka)|0)+(($(ta&65535,ka)|0)>>16))|0;ta=c[ga+-56>>2]|0;sa=b[N>>1]|0;sa=ka+(($(ta>>16,sa)|0)+(($(ta&65535,sa)|0)>>16))|0;ta=c[ga+-60>>2]|0;ka=b[O>>1]|0;ka=sa+(($(ta>>16,ka)|0)+(($(ta&65535,ka)|0)>>16))|0;}if(U){ta=c[ja>>2]|0;la=b[l>>1]|0;la=($(ta>>16,la)|0)+(($(ta&65535,la)|0)>>16)+2|0;ta=c[ja+-4>>2]|0;sa=b[R>>1]|0;sa=la+(($(ta>>16,sa)|0)+(($(ta&65535,sa)|0)>>16))|0;ta=c[ja+-8>>2]|0;la=b[Y>>1]|0;la=sa+(($(ta>>16,la)|0)+(($(ta&65535,la)|0)>>16))|0;ta=c[ja+-12>>2]|0;sa=b[S>>1]|0;sa=la+(($(ta>>16,sa)|0)+(($(ta&65535,sa)|0)>>16))|0;ta=c[ja+-16>>2]|0;la=b[V>>1]|0;la=sa+(($(ta>>16,la)|0)+(($(ta&65535,la)|0)>>16))|0;ja=ja+4|0;}else la=0;ma=c[ga>>2]|0;na=c[T>>2]|0;c[T>>2]=ma;pa=b[m>>1]|0;pa=e+(($(ma>>16,pa)|0)+(($(ma&65535,pa)|0)>>16))|0;ma=2;while(1){if((ma|0)>=(v|0))break;qa=ma+-1|0;sa=d+(qa<<2)+4288|0;ra=c[sa>>2]|0;c[sa>>2]=na;qa=b[m+(qa<<1)>>1]|0;qa=pa+(($(na>>16,qa)|0)+(($(na&65535,qa)|0)>>16))|0;sa=d+(ma<<2)+4288|0;ta=c[sa>>2]|0;c[sa>>2]=ra;sa=b[m+(ma<<1)>>1]|0;pa=qa+(($(ra>>16,sa)|0)+(($(ra&65535,sa)|0)>>16))|0;ma=ma+2|0;na=ta;}c[Z>>2]=na;ma=b[X>>1]|0;na=pa+(($(na>>16,ma)|0)+(($(na&65535,ma)|0)>>16))<<1;ma=c[W>>2]|0;pa=ma>>16;ma=ma&65535;na=na+(($(pa,p)|0)+(($(ma,p)|0)>>16))|0;ta=c[d+((c[D>>2]|0)+-1<<2)+1280>>2]|0;ma=($(ta>>16,_)|0)+(($(ta&65535,_)|0)>>16)+($(pa,q)|0)+(($(ma,q)|0)>>16)|0;pa=(ka<<2)-na-ma|0;if(ba){sa=(c[oa>>2]|0)+(c[oa+-8>>2]|0)|0;sa=($(sa>>16,aa)|0)+(($(sa&65535,aa)|0)>>16)|0;ta=c[oa+-4>>2]|0;oa=oa+4|0;pa=la-(sa+($(ta>>16,o)|0)+(($(ta&65535,o)|0)>>16)<<1)+(pa<<1)>>2;}else pa=pa>>1;ta=(c[f+(n<<2)>>2]|0)-(pa+1>>1)|0;ra=(c[y>>2]|0)<0;sa=0-ta|0;pa=ra?sa:ta;if(((ra?sa:ta)|0)>30720)pa=30720;else pa=(pa|0)<-31744?-31744:pa;qa=pa-t>>10;if((qa|0)<=0){if(qa){if((qa|0)==-1){qa=ha;ra=t;sa=da;ta=r;}else{ta=(qa<<10|80)+t|0;qa=ta;ra=ta+1024|0;sa=$(0-ta<<16>>16,ca)|0;ta=$(-1024-ta<<16>>16,ca)|0;}}else{qa=t;ra=ea;sa=r;ta=fa;}}else{sa=(qa<<10)+-80+t|0;ta=sa+1024|0;qa=sa;ra=ta;sa=$(sa<<16>>16,ca)|0;ta=$(ta<<16>>16,ca)|0;}ua=pa-qa<<16>>16;pa=pa-ra<<16>>16;pa=(ta+($(pa,pa)|0)|0)<(sa+($(ua,ua)|0)|0);qa=pa?ra:qa;pa=g+n|0;a[pa>>0]=((qa>>>9)+1|0)>>>1;qa=qa<<4;la=((c[y>>2]|0)<0?0-qa|0:qa)+(la<<1)|0;ka=la+(ka<<4)|0;qa=(($(ka>>16,s)|0)+(($(ka&65535,s)|0)>>16)+($(ka,ia)|0)>>7)+1>>1;if((qa|0)>32767)qa=32767;else qa=(qa|0)<-32768?-32768:qa&65535;b[h+(n<<1)>>1]=qa;ua=ga+4|0;c[ua>>2]=ka;ta=ka-(na<<2)|0;c[W>>2]=ta;c[d+(c[D>>2]<<2)+1280>>2]=ta-(ma<<2);c[j+(c[z>>2]<<2)>>2]=la<<1;c[D>>2]=(c[D>>2]|0)+1;c[z>>2]=(c[z>>2]|0)+1;c[y>>2]=(c[y>>2]|0)+(a[pa>>0]|0);ga=ua;n=n+1|0;}h=d+3840|0;u=d+(u<<2)+3840|0;d=h+128|0;do{c[h>>2]=c[u>>2];h=h+4|0;u=u+4|0;}while((h|0)<(d|0));i=x;return;}function we(a){a=a|0;var b=0,c=0,d=0,e=0,f=0,g=0;b=i;d=ye((a|0)>0?a:0-a|0)|0;c=a<<d+-1;g=c>>16;a=536870911/(g|0)|0;f=a<<16;e=f>>16;c=536870912-(($(g,e)|0)+(($(c&65535,e)|0)>>16))<<3;a=f+(($(c>>16,e)|0)+(($(c&65528,e)|0)>>16))+($(c,(a>>15)+1>>1)|0)|0;d=62-d|0;c=d+-47|0;if((c|0)>=1){i=b;return((c|0)<32?a>>c:0)|0;}c=47-d|0;d=-2147483648>>c;e=2147483647>>>c;if((d|0)>(e|0)){if((a|0)>(d|0)){g=d;g=g<<c;i=b;return g|0;}g=(a|0)<(e|0)?e:a;g=g<<c;i=b;return g|0;}else{if((a|0)>(e|0)){g=e;g=g<<c;i=b;return g|0;}g=(a|0)<(d|0)?d:a;g=g<<c;i=b;return g|0;}return 0;}function xe(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,f=0,g=0;c=i;e=ye((a|0)>0?a:0-a|0)|0;g=a<<e+-1;d=(ye((b|0)>0?b:0-b|0)|0)+-1|0;a=b<<d;b=(536870911/(a>>16|0)|0)<<16>>16;f=($(g>>16,b)|0)+(($(g&65535,b)|0)>>16)|0;a=Gj(a|0,((a|0)<0)<<31>>31|0,f|0,((f|0)<0)<<31>>31|0)|0;a=uj(a|0,D|0,29)|0;a=g-(a&-8)|0;b=f+(($(a>>16,b)|0)+(($(a&65535,b)|0)>>16))|0;d=e+28-d|0;a=d+-16|0;if((a|0)>=0){i=c;return((a|0)<32?b>>a:0)|0;}a=16-d|0;d=-2147483648>>a;e=2147483647>>>a;if((d|0)>(e|0)){if((b|0)>(d|0)){g=d;g=g<<a;i=c;return g|0;}g=(b|0)<(e|0)?e:b;g=g<<a;i=c;return g|0;}else{if((b|0)>(e|0)){g=e;g=g<<a;i=c;return g|0;}g=(b|0)<(d|0)?d:b;g=g<<a;i=c;return g|0;}return 0;}function ye(a){a=a|0;var b=0;b=i;if(!a)a=32;else a=vj(a|0)|0;i=b;return a|0;}function ze(e,f,g,h,j,k,l,m,n,o,p,q,r,s,t){e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=r|0;s=s|0;t=t|0;var u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0;w=i;i=i+144|0;C=w+128|0;H=w;u=f+4356|0;da=c[u>>2]|0;I=e+4652|0;J=c[I>>2]|0;A=i;i=i+((1168*J|0)+15&-16)|0;wj(A|0,0,J*1168|0)|0;E=g+34|0;y=f+4352|0;v=e+4616|0;x=f+3840|0;z=f+4288|0;D=0;while(1){if((D|0)>=(J|0))break;F=D+(d[E>>0]|0)&3;c[A+(D*1168|0)+1156>>2]=F;c[A+(D*1168|0)+1160>>2]=F;c[A+(D*1168|0)+1164>>2]=0;c[A+(D*1168|0)+1152>>2]=c[y>>2];c[A+(D*1168|0)+960>>2]=c[f+((c[v>>2]|0)+-1<<2)+1280>>2];F=A+(D*1168|0)+0|0;G=x+0|0;B=F+128|0;do{c[F>>2]=c[G>>2];F=F+4|0;G=G+4|0;}while((F|0)<(B|0));F=A+(D*1168|0)+1088|0;G=z+0|0;B=F+64|0;do{c[F>>2]=c[G>>2];F=F+4|0;G=G+4|0;}while((F|0)<(B|0));D=D+1|0;}L=g+29|0;ia=a[L>>0]|0;K=b[24968+(ia<<24>>24>>1<<2)+(a[g+30>>0]<<1)>>1]|0;c[C>>2]=0;B=e+4612|0;D=c[B>>2]|0;F=Ae(32,D)|0;a:do if(ia<<24>>24!=2){if((da|0)>0)F=Ae(F,da+-3|0)|0;}else{G=c[e+4604>>2]|0;J=0;while(1){if((J|0)>=(G|0))break a;F=Ae(F,(c[r+(J<<2)>>2]|0)+-3|0)|0;J=J+1|0;}}while(0);R=(a[g+31>>0]|0)==4?0:1;J=c[v>>2]|0;g=e+4608|0;O=J+(c[g>>2]|0)|0;N=i;i=i+((4*O|0)+15&-16)|0;M=i;i=i+((2*O|0)+15&-16)|0;O=i;i=i+((4*D|0)+15&-16)|0;G=f+4364|0;c[G>>2]=J;X=f+4360|0;c[X>>2]=c[v>>2];D=e+4604|0;S=R^1;T=f+4376|0;R=R<<1^3;P=A+1164|0;Y=q+4|0;U=e+4664|0;W=e+5124|0;Q=e+4660|0;V=e+4704|0;J=f+(J<<1)|0;aa=0;fa=0;while(1){if((aa|0)>=(c[D>>2]|0))break;ca=k+((aa>>1|S)<<4<<1)|0;_=l+(aa*5<<1)|0;Z=m+(aa<<4<<1)|0;ba=c[n+(aa<<2)>>2]|0;ba=ba>>2|ba>>>1<<16;c[T>>2]=0;ea=a[L>>0]|0;if(ea<<24>>24==2){da=c[r+(aa<<2)>>2]|0;if(!(aa&R)){b:do if((aa|0)==2){fa=c[I>>2]|0;ga=c[P>>2]|0;ea=0;ha=1;while(1){if((ha|0)>=(fa|0)){ga=0;break;}ja=c[A+(ha*1168|0)+1164>>2]|0;ia=(ja|0)<(ga|0);ga=ia?ja:ga;ea=ia?ha:ea;ha=ha+1|0;}while(1){if((ga|0)>=(fa|0))break;if((ga|0)!=(ea|0)){ja=A+(ga*1168|0)+1164|0;c[ja>>2]=(c[ja>>2]|0)+134217727;}ga=ga+1|0;}ha=(c[C>>2]|0)+F|0;fa=0;while(1){if((fa|0)>=(F|0)){fa=0;break b;}ha=ha+31&31;ga=fa-F|0;a[j+ga>>0]=(((c[A+(ea*1168|0)+(ha<<2)+576>>2]|0)>>>9)+1|0)>>>1;ja=c[A+(ea*1168|0)+(ha<<2)+704>>2]|0;ia=c[Y>>2]|0;ka=ia<<16>>16;ia=(($(ja>>16,ka)|0)+(($(ja&65535,ka)|0)>>16)+($(ja,(ia>>15)+1>>1)|0)>>13)+1>>1;if((ia|0)>32767)ia=32767;else ia=(ia|0)<-32768?-32768:ia&65535;b[J+(ga<<1)>>1]=ia;c[f+((c[G>>2]|0)-F+fa<<2)+1280>>2]=c[A+(ea*1168|0)+(ha<<2)+960>>2];fa=fa+1|0;}}while(0);ja=c[v>>2]|0;ea=c[U>>2]|0;ka=ja-da-ea+-2|0;ia=f+(ka+($(aa,c[B>>2]|0)|0)<<1)|0;Sd(M+(ka<<1)|0,ia,ca,ja-ka|0,ea,c[W>>2]|0);c[X>>2]=c[v>>2];c[T>>2]=1;ea=a[L>>0]|0;}else ea=2;}Be(e,f,A,h,O,M,N,aa,c[I>>2]|0,t,q,r,ea<<24>>24,F);Ce(f,A,a[L>>0]|0,O,j,J,N,H,ca,_,Z,da,ba,c[o+(aa<<2)>>2]|0,c[p+(aa<<2)>>2]|0,c[q+(aa<<2)>>2]|0,s,K,c[B>>2]|0,fa,c[Q>>2]|0,c[U>>2]|0,c[V>>2]|0,c[I>>2]|0,C,F);ka=c[B>>2]|0;h=h+(ka<<2)|0;j=j+ka|0;J=J+(ka<<1)|0;aa=aa+1|0;fa=fa+1|0;}n=c[I>>2]|0;t=c[P>>2]|0;s=0;e=1;while(1){if((e|0)>=(n|0))break;ja=c[A+(e*1168|0)+1164>>2]|0;ka=(ja|0)<(t|0);t=ka?ja:t;s=ka?e:s;e=e+1|0;}a[E>>0]=c[A+(s*1168|0)+1160>>2];q=c[q+((c[D>>2]|0)+-1<<2)>>2]|0;E=q>>>6<<16>>16;q=(q>>21)+1>>1;e=(c[C>>2]|0)+F|0;C=0;while(1){if((C|0)>=(F|0))break;e=e+31&31;n=C-F|0;a[j+n>>0]=(((c[A+(s*1168|0)+(e<<2)+576>>2]|0)>>>9)+1|0)>>>1;t=c[A+(s*1168|0)+(e<<2)+704>>2]|0;t=(($(t>>16,E)|0)+(($(t&65535,E)|0)>>16)+($(t,q)|0)>>7)+1>>1;if((t|0)>32767)t=32767;else t=(t|0)<-32768?-32768:t&65535;b[J+(n<<1)>>1]=t;c[f+((c[G>>2]|0)-F+C<<2)+1280>>2]=c[A+(s*1168|0)+(e<<2)+960>>2];C=C+1|0;}F=x+0|0;G=A+(s*1168|0)+(c[B>>2]<<2)+0|0;B=F+128|0;do{c[F>>2]=c[G>>2];F=F+4|0;G=G+4|0;}while((F|0)<(B|0));F=z+0|0;G=A+(s*1168|0)+1088|0;B=F+64|0;do{c[F>>2]=c[G>>2];F=F+4|0;G=G+4|0;}while((F|0)<(B|0));c[y>>2]=c[A+(s*1168|0)+1152>>2];c[u>>2]=c[r+((c[D>>2]|0)+-1<<2)>>2];zj(f|0,f+(c[g>>2]<<1)|0,c[v>>2]<<1|0)|0;zj(f+1280|0,f+(c[g>>2]<<2)+1280|0,c[v>>2]<<2|0)|0;i=w;return;}function Ae(a,b){a=a|0;b=b|0;return((a|0)<(b|0)?a:b)|0;}function Be(a,d,e,f,g,h,j,k,l,m,n,o,p,q){a=a|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;var r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;r=i;o=c[o+(k<<2)>>2]|0;u=n+(k<<2)|0;v=c[u>>2]|0;s=De((v|0)>1?v:1)|0;t=d+4372|0;n=c[t>>2]|0;if((v|0)==(n|0))n=65536;else n=Ee(n,v)|0;y=(s>>7)+1|0;v=a+4612|0;x=y>>>1<<16>>16;y=(y>>16)+1>>1;w=0;while(1){if((w|0)>=(c[v>>2]|0))break;z=c[f+(w<<2)>>2]|0;c[g+(w<<2)>>2]=($(z>>16,x)|0)+(($(z&65535,x)|0)>>16)+($(z,y)|0);w=w+1|0;}c[t>>2]=c[u>>2];f=d+4376|0;a:do if(c[f>>2]|0){if(!k){z=m<<16>>16;s=($(s>>16,z)|0)+(($(s&65535,z)|0)>>16)<<2;}m=d+4360|0;z=c[m>>2]|0;k=s>>16;g=s&65535;t=z;s=z-o+-2|0;while(1){if((s|0)>=(t|0))break a;t=b[h+(s<<1)>>1]|0;c[j+(s<<2)>>2]=($(k,t)|0)+(($(g,t)|0)>>16);t=c[m>>2]|0;s=s+1|0;}}while(0);if((n|0)==65536){i=r;return;}m=d+4364|0;z=c[m>>2]|0;k=n>>16;h=n&65535;g=z;a=z-(c[a+4616>>2]|0)|0;while(1){if((a|0)>=(g|0))break;g=d+(a<<2)+1280|0;z=c[g>>2]|0;y=z<<16>>16;c[g>>2]=($(k,y)|0)+(($(h,y)|0)>>16)+($(n,(z>>15)+1>>1)|0);g=c[m>>2]|0;a=a+1|0;}b:do if((p|0)==2?(c[f>>2]|0)==0:0){p=d+4360|0;z=c[p>>2]|0;d=z;o=z-o+-2|0;while(1){if((o|0)>=(d-q|0)){q=0;break b;}d=j+(o<<2)|0;z=c[d>>2]|0;y=z<<16>>16;c[d>>2]=($(k,y)|0)+(($(h,y)|0)>>16)+($(n,(z>>15)+1>>1)|0);d=c[p>>2]|0;o=o+1|0;}}else q=0;while(0);while(1){if((q|0)>=(l|0))break;j=c[e+(q*1168|0)+1152>>2]|0;z=j<<16>>16;c[e+(q*1168|0)+1152>>2]=($(k,z)|0)+(($(h,z)|0)>>16)+($(n,(j>>15)+1>>1)|0);j=0;while(1){if((j|0)>=32){j=0;break;}z=e+(q*1168|0)+(j<<2)|0;y=c[z>>2]|0;x=y<<16>>16;c[z>>2]=($(k,x)|0)+(($(h,x)|0)>>16)+($(n,(y>>15)+1>>1)|0);j=j+1|0;}while(1){if((j|0)>=16){j=0;break;}z=e+(q*1168|0)+(j<<2)+1088|0;y=c[z>>2]|0;x=y<<16>>16;c[z>>2]=($(k,x)|0)+(($(h,x)|0)>>16)+($(n,(y>>15)+1>>1)|0);j=j+1|0;}while(1){if((j|0)>=32)break;z=e+(q*1168|0)+(j<<2)+832|0;y=c[z>>2]|0;x=y<<16>>16;c[z>>2]=($(k,x)|0)+(($(h,x)|0)>>16)+($(n,(y>>15)+1>>1)|0);z=e+(q*1168|0)+(j<<2)+960|0;y=c[z>>2]|0;x=y<<16>>16;c[z>>2]=($(k,x)|0)+(($(h,x)|0)>>16)+($(n,(y>>15)+1>>1)|0);j=j+1|0;}q=q+1|0;}i=r;return;}function Ce(d,e,f,g,h,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D){d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=r|0;s=s|0;t=t|0;u=u|0;v=v|0;w=w|0;x=x|0;y=y|0;z=z|0;A=A|0;B=B|0;C=C|0;D=D|0;var E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0,la=0,ma=0,na=0,oa=0,pa=0,qa=0,ra=0,sa=0,ta=0,ua=0,va=0,wa=0,xa=0,ya=0,za=0,Aa=0,Ba=0,Ca=0,Da=0,Ea=0,Fa=0,Ga=0,Ha=0;E=i;F=i;i=i+((48*B|0)+15&-16)|0;G=d+4364|0;H=d+4360|0;t=t>>6;I=(f|0)==2;M=n+2|0;L=n+4|0;K=n+6|0;J=n+8|0;f=(p|0)>0;N=q<<16>>16;R=q>>16;S=z>>1;W=m+2|0;V=m+4|0;U=m+6|0;T=m+8|0;q=m+10|0;Q=m+12|0;O=m+14|0;X=m+16|0;P=m+18|0;Z=(z|0)==16;aa=m+20|0;ba=m+22|0;_=m+24|0;ca=m+26|0;Y=m+28|0;z=m+30|0;ea=A<<16>>16;fa=y>>1;da=y+-1|0;A=o+(da<<1)|0;ga=r<<16>>16;r=s<<16>>16;s=s>>16;ha=u<<16>>16;u=v+944|0;ia=$(v<<16>>16,ha)|0;na=$(u<<16>>16,ha)|0;ka=v+-944|0;ja=$(944-v<<16>>16,ha)|0;ma=F+4|0;la=F+28|0;x=(x|0)<=0;oa=k+((c[H>>2]|0)-p+2<<2)|0;pa=d+((c[G>>2]|0)-p+1<<2)+1280|0;p=0;while(1){if((p|0)>=(w|0)){n=0;break;}if(I){Ea=c[oa>>2]|0;qa=b[n>>1]|0;qa=($(Ea>>16,qa)|0)+(($(Ea&65535,qa)|0)>>16)+2|0;Ea=c[oa+-4>>2]|0;Da=b[M>>1]|0;Da=qa+(($(Ea>>16,Da)|0)+(($(Ea&65535,Da)|0)>>16))|0;Ea=c[oa+-8>>2]|0;qa=b[L>>1]|0;qa=Da+(($(Ea>>16,qa)|0)+(($(Ea&65535,qa)|0)>>16))|0;Ea=c[oa+-12>>2]|0;Da=b[K>>1]|0;Da=qa+(($(Ea>>16,Da)|0)+(($(Ea&65535,Da)|0)>>16))|0;Ea=c[oa+-16>>2]|0;qa=b[J>>1]|0;qa=Da+(($(Ea>>16,qa)|0)+(($(Ea&65535,qa)|0)>>16))<<1;oa=oa+4|0;}else qa=0;if(f){Ea=(c[pa>>2]|0)+(c[pa+-8>>2]|0)|0;Ea=($(Ea>>16,N)|0)+(($(Ea&65535,N)|0)>>16)|0;ra=c[pa+-4>>2]|0;ra=qa-(Ea+($(ra>>16,R)|0)+(($(ra&65535,R)|0)>>16)<<2)|0;pa=pa+4|0;}else ra=0;ta=p+31|0;ua=g+(p<<2)|0;sa=0;while(1){if((sa|0)>=(B|0))break;wa=F+(sa*48|0)|0;za=e+(sa*1168|0)+1156|0;c[za>>2]=($(c[e+(sa*1168|0)+1156>>2]|0,196314165)|0)+907633515;xa=e+(sa*1168|0)+(ta<<2)|0;Ea=c[xa>>2]|0;Da=b[m>>1]|0;Da=S+(($(Ea>>16,Da)|0)+(($(Ea&65535,Da)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+30<<2)>>2]|0;va=b[W>>1]|0;va=Da+(($(Ea>>16,va)|0)+(($(Ea&65535,va)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+29<<2)>>2]|0;Da=b[V>>1]|0;Da=va+(($(Ea>>16,Da)|0)+(($(Ea&65535,Da)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+28<<2)>>2]|0;va=b[U>>1]|0;va=Da+(($(Ea>>16,va)|0)+(($(Ea&65535,va)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+27<<2)>>2]|0;Da=b[T>>1]|0;Da=va+(($(Ea>>16,Da)|0)+(($(Ea&65535,Da)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+26<<2)>>2]|0;va=b[q>>1]|0;va=Da+(($(Ea>>16,va)|0)+(($(Ea&65535,va)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+25<<2)>>2]|0;Da=b[Q>>1]|0;Da=va+(($(Ea>>16,Da)|0)+(($(Ea&65535,Da)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+24<<2)>>2]|0;va=b[O>>1]|0;va=Da+(($(Ea>>16,va)|0)+(($(Ea&65535,va)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+23<<2)>>2]|0;Da=b[X>>1]|0;Da=va+(($(Ea>>16,Da)|0)+(($(Ea&65535,Da)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+22<<2)>>2]|0;va=b[P>>1]|0;va=Da+(($(Ea>>16,va)|0)+(($(Ea&65535,va)|0)>>16))|0;if(Z){Ea=c[e+(sa*1168|0)+(p+21<<2)>>2]|0;Da=b[aa>>1]|0;Da=va+(($(Ea>>16,Da)|0)+(($(Ea&65535,Da)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+20<<2)>>2]|0;va=b[ba>>1]|0;va=Da+(($(Ea>>16,va)|0)+(($(Ea&65535,va)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+19<<2)>>2]|0;Da=b[_>>1]|0;Da=va+(($(Ea>>16,Da)|0)+(($(Ea&65535,Da)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+18<<2)>>2]|0;va=b[ca>>1]|0;va=Da+(($(Ea>>16,va)|0)+(($(Ea&65535,va)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+17<<2)>>2]|0;Da=b[Y>>1]|0;Da=va+(($(Ea>>16,Da)|0)+(($(Ea&65535,Da)|0)>>16))|0;Ea=c[e+(sa*1168|0)+(p+16<<2)>>2]|0;va=b[z>>1]|0;va=Da+(($(Ea>>16,va)|0)+(($(Ea&65535,va)|0)>>16))|0;}va=va<<4;ya=e+(sa*1168|0)+1088|0;Ea=c[ya>>2]|0;Aa=(c[xa>>2]|0)+(($(Ea>>16,ea)|0)+(($(Ea&65535,ea)|0)>>16))|0;Ba=c[e+(sa*1168|0)+1092>>2]|0;xa=Ba-Aa|0;xa=Ea+(($(xa>>16,ea)|0)+(($(xa&65535,ea)|0)>>16))|0;c[ya>>2]=Aa;ya=b[o>>1]|0;ya=fa+(($(Aa>>16,ya)|0)+(($(Aa&65535,ya)|0)>>16))|0;Aa=2;while(1){if((Aa|0)>=(y|0))break;Fa=Aa+-1|0;Da=e+(sa*1168|0)+(Aa<<2)+1088|0;Ha=c[Da>>2]|0;Ca=Ha-xa|0;Ca=Ba+(($(Ca>>16,ea)|0)+(($(Ca&65535,ea)|0)>>16))|0;c[e+(sa*1168|0)+(Fa<<2)+1088>>2]=xa;Fa=b[o+(Fa<<1)>>1]|0;Fa=ya+(($(xa>>16,Fa)|0)+(($(xa&65535,Fa)|0)>>16))|0;Ga=c[e+(sa*1168|0)+((Aa|1)<<2)+1088>>2]|0;Ea=Ga-Ca|0;Ea=Ha+(($(Ea>>16,ea)|0)+(($(Ea&65535,ea)|0)>>16))|0;c[Da>>2]=Ca;Da=b[o+(Aa<<1)>>1]|0;Ba=Ga;ya=Fa+(($(Ca>>16,Da)|0)+(($(Ca&65535,Da)|0)>>16))|0;Aa=Aa+2|0;xa=Ea;}c[e+(sa*1168|0)+(da<<2)+1088>>2]=xa;Ha=b[A>>1]|0;ya=ya+(($(xa>>16,Ha)|0)+(($(xa&65535,Ha)|0)>>16))<<1;xa=c[e+(sa*1168|0)+1152>>2]|0;Ha=xa>>16;xa=xa&65535;ya=ya+(($(Ha,ga)|0)+(($(xa,ga)|0)>>16))<<2;Ga=c[e+(sa*1168|0)+(c[C>>2]<<2)+960>>2]|0;xa=($(Ga>>16,r)|0)+(($(Ga&65535,r)|0)>>16)+($(Ha,s)|0)+(($(xa,s)|0)>>16)<<2;Ha=(c[ua>>2]|0)-((ra+va-(ya+xa)>>3)+1>>1)|0;za=(c[za>>2]|0)<0;Ga=0-Ha|0;Aa=za?Ga:Ha;if(((za?Ga:Ha)|0)>30720)Da=30720;else Da=(Aa|0)<-31744?-31744:Aa;Aa=Da-v>>10;if((Aa|0)<=0){if(Aa){if((Aa|0)==-1){Aa=ka;Ba=v;Ca=ja;Ea=ia;}else{Ea=(Aa<<10|80)+v|0;Aa=Ea;Ba=Ea+1024|0;Ca=$(0-Ea<<16>>16,ha)|0;Ea=$(-1024-Ea<<16>>16,ha)|0;}}else{Aa=v;Ba=u;Ca=ia;Ea=na;}}else{Ca=(Aa<<10)+-80+v|0;Ea=Ca+1024|0;Aa=Ca;Ba=Ea;Ca=$(Ca<<16>>16,ha)|0;Ea=$(Ea<<16>>16,ha)|0;}Ha=Da-Aa<<16>>16;Ca=Ca+($(Ha,Ha)|0)>>10;Da=Da-Ba<<16>>16;Ea=Ea+($(Da,Da)|0)>>10;Da=c[e+(sa*1168|0)+1164>>2]|0;if((Ca|0)<(Ea|0)){c[F+(sa*48|0)+4>>2]=Da+Ca;c[F+(sa*48|0)+28>>2]=Da+Ea;c[wa>>2]=Aa;c[F+(sa*48|0)+24>>2]=Ba;wa=Aa;Aa=Ba;}else{c[F+(sa*48|0)+4>>2]=Da+Ea;c[F+(sa*48|0)+28>>2]=Da+Ca;c[wa>>2]=Ba;c[F+(sa*48|0)+24>>2]=Aa;wa=Ba;}Ha=wa<<4;Ha=(za?0-Ha|0:Ha)+qa|0;Ga=Ha+va|0;Fa=Ga-ya|0;c[F+(sa*48|0)+16>>2]=Fa-xa;c[F+(sa*48|0)+12>>2]=Fa;c[F+(sa*48|0)+20>>2]=Ha;c[F+(sa*48|0)+8>>2]=Ga;Ga=Aa<<4;Ga=(za?0-Ga|0:Ga)+qa|0;Ha=Ga+va|0;Fa=Ha-ya|0;c[F+(sa*48|0)+40>>2]=Fa-xa;c[F+(sa*48|0)+36>>2]=Fa;c[F+(sa*48|0)+44>>2]=Ga;c[F+(sa*48|0)+32>>2]=Ha;sa=sa+1|0;}qa=(c[C>>2]|0)+31|0;c[C>>2]=qa&31;qa=qa+D&31;sa=c[ma>>2]|0;ra=0;ta=1;while(1){if((ta|0)>=(B|0))break;Ga=c[F+(ta*48|0)+4>>2]|0;Ha=(Ga|0)<(sa|0);sa=Ha?Ga:sa;ra=Ha?ta:ra;ta=ta+1|0;}sa=c[e+(ra*1168|0)+(qa<<2)+448>>2]|0;ta=0;while(1){if((ta|0)>=(B|0))break;if((c[e+(ta*1168|0)+(qa<<2)+448>>2]|0)!=(sa|0)){Ha=F+(ta*48|0)+4|0;c[Ha>>2]=(c[Ha>>2]|0)+134217727;Ha=F+(ta*48|0)+28|0;c[Ha>>2]=(c[Ha>>2]|0)+134217727;}ta=ta+1|0;}sa=c[ma>>2]|0;va=0;ua=c[la>>2]|0;ta=0;wa=1;while(1){if((wa|0)>=(B|0))break;Ea=c[F+(wa*48|0)+4>>2]|0;Fa=(Ea|0)>(sa|0);Ga=c[F+(wa*48|0)+28>>2]|0;Ha=(Ga|0)<(ua|0);sa=Fa?Ea:sa;va=Fa?wa:va;ua=Ha?Ga:ua;ta=Ha?wa:ta;wa=wa+1|0;}if((ua|0)<(sa|0)){yj(e+(va*1168|0)+(p<<2)|0,e+(ta*1168|0)+(p<<2)|0,1168-(p<<2)|0)|0;Ha=F+(va*48|0)|0;Ga=F+(ta*48|0)+24|0;c[Ha+0>>2]=c[Ga+0>>2];c[Ha+4>>2]=c[Ga+4>>2];c[Ha+8>>2]=c[Ga+8>>2];c[Ha+12>>2]=c[Ga+12>>2];c[Ha+16>>2]=c[Ga+16>>2];c[Ha+20>>2]=c[Ga+20>>2];}if(!(x&(p|0)<(D|0))){sa=p-D|0;a[h+sa>>0]=(((c[e+(ra*1168|0)+(qa<<2)+576>>2]|0)>>>9)+1|0)>>>1;Ha=c[e+(ra*1168|0)+(qa<<2)+704>>2]|0;ta=c[l+(qa<<2)>>2]|0;Ga=ta<<16>>16;ta=(($(Ha>>16,Ga)|0)+(($(Ha&65535,Ga)|0)>>16)+($(Ha,(ta>>15)+1>>1)|0)>>7)+1>>1;if((ta|0)>32767)ta=32767;else ta=(ta|0)<-32768?-32768:ta&65535;b[j+(sa<<1)>>1]=ta;c[d+((c[G>>2]|0)-D<<2)+1280>>2]=c[e+(ra*1168|0)+(qa<<2)+960>>2];c[k+((c[H>>2]|0)-D<<2)>>2]=c[e+(ra*1168|0)+(qa<<2)+832>>2];}c[G>>2]=(c[G>>2]|0)+1;c[H>>2]=(c[H>>2]|0)+1;qa=p+32|0;ra=0;while(1){if((ra|0)>=(B|0))break;c[e+(ra*1168|0)+1152>>2]=c[F+(ra*48|0)+12>>2];Ha=c[F+(ra*48|0)+8>>2]|0;c[e+(ra*1168|0)+(qa<<2)>>2]=Ha;c[e+(ra*1168|0)+(c[C>>2]<<2)+704>>2]=Ha;Ha=c[F+(ra*48|0)>>2]|0;c[e+(ra*1168|0)+(c[C>>2]<<2)+576>>2]=Ha;c[e+(ra*1168|0)+(c[C>>2]<<2)+832>>2]=c[F+(ra*48|0)+20>>2]<<1;c[e+(ra*1168|0)+(c[C>>2]<<2)+960>>2]=c[F+(ra*48|0)+16>>2];Ga=e+(ra*1168|0)+1156|0;Ha=(c[Ga>>2]|0)+((Ha>>9)+1>>1)|0;c[Ga>>2]=Ha;c[e+(ra*1168|0)+(c[C>>2]<<2)+448>>2]=Ha;c[e+(ra*1168|0)+1164>>2]=c[F+(ra*48|0)+4>>2];ra=ra+1|0;}c[l+(c[C>>2]<<2)>>2]=t;p=p+1|0;}while(1){if((n|0)>=(B|0))break;g=e+(n*1168|0)+0|0;G=e+(n*1168|0)+(w<<2)+0|0;F=g+128|0;do{c[g>>2]=c[G>>2];g=g+4|0;G=G+4|0;}while((g|0)<(F|0));n=n+1|0;}i=E;return;}function De(a){a=a|0;var b=0,c=0,d=0,e=0,f=0,g=0;b=i;d=Fe((a|0)>0?a:0-a|0)|0;c=a<<d+-1;g=c>>16;a=536870911/(g|0)|0;f=a<<16;e=f>>16;c=536870912-(($(g,e)|0)+(($(c&65535,e)|0)>>16))<<3;a=f+(($(c>>16,e)|0)+(($(c&65528,e)|0)>>16))+($(c,(a>>15)+1>>1)|0)|0;d=62-d|0;c=d+-47|0;if((c|0)>=1){i=b;return((c|0)<32?a>>c:0)|0;}c=47-d|0;d=-2147483648>>c;e=2147483647>>>c;if((d|0)>(e|0)){if((a|0)>(d|0)){g=d;g=g<<c;i=b;return g|0;}g=(a|0)<(e|0)?e:a;g=g<<c;i=b;return g|0;}else{if((a|0)>(e|0)){g=e;g=g<<c;i=b;return g|0;}g=(a|0)<(d|0)?d:a;g=g<<c;i=b;return g|0;}return 0;}function Ee(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,f=0,g=0;c=i;e=Fe((a|0)>0?a:0-a|0)|0;g=a<<e+-1;d=(Fe((b|0)>0?b:0-b|0)|0)+-1|0;a=b<<d;b=(536870911/(a>>16|0)|0)<<16>>16;f=($(g>>16,b)|0)+(($(g&65535,b)|0)>>16)|0;a=Gj(a|0,((a|0)<0)<<31>>31|0,f|0,((f|0)<0)<<31>>31|0)|0;a=uj(a|0,D|0,29)|0;a=g-(a&-8)|0;b=f+(($(a>>16,b)|0)+(($(a&65535,b)|0)>>16))|0;d=e+28-d|0;a=d+-16|0;if((a|0)>=0){i=c;return((a|0)<32?b>>a:0)|0;}a=16-d|0;d=-2147483648>>a;e=2147483647>>>a;if((d|0)>(e|0)){if((b|0)>(d|0)){g=d;g=g<<a;i=c;return g|0;}g=(b|0)<(e|0)?e:b;g=g<<a;i=c;return g|0;}else{if((b|0)>(e|0)){g=e;g=g<<a;i=c;return g|0;}g=(b|0)<(d|0)?d:b;g=g<<a;i=c;return g|0;}return 0;}function Fe(a){a=a|0;var b=0;b=i;if(!a)a=32;else a=vj(a|0)|0;i=b;return a|0;}function Ge(a){a=a|0;c[a+4168>>2]=c[a+2328>>2]<<7;c[a+4240>>2]=65536;c[a+4244>>2]=65536;c[a+4256>>2]=20;c[a+4252>>2]=2;return;}function He(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0;g=i;j=a+2316|0;h=a+4248|0;if((c[j>>2]|0)!=(c[h>>2]|0)){Ge(a);c[h>>2]=c[j>>2];}if(!e){Je(a,b);i=g;return;}else{Ie(a,b,d,f);e=a+4160|0;c[e>>2]=(c[e>>2]|0)+1;i=g;return;}}function Ie(a,d,f,g){a=a|0;d=d|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0;h=i;i=i+64|0;n=h+20|0;p=h+16|0;m=h+12|0;t=h+8|0;j=h+24|0;u=h;q=a+2336|0;A=c[q>>2]|0;l=a+2328|0;k=i;i=i+((4*(A+(c[l>>2]|0)|0)|0)+15&-16)|0;y=i;i=i+((2*A|0)+15&-16)|0;c[u>>2]=c[a+4240>>2]>>6;A=a+4244|0;o=u+4|0;c[o>>2]=c[A>>2]>>6;if(c[a+2376>>2]|0){s=a+4182|0;v=s+32|0;do{b[s>>1]=0;s=s+2|0;}while((s|0)<(v|0));}r=a+2332|0;s=a+2324|0;Qe(m,n,t,p,a+4|0,u,c[r>>2]|0,c[s>>2]|0);u=c[a+4252>>2]|0;if((c[m>>2]>>c[p>>2]|0)<(c[t>>2]>>c[n>>2]|0))m=$(u+-1|0,c[a+4256>>2]|0)|0;else m=$(u,c[a+4256>>2]|0)|0;w=Re(m+-128|0)|0;v=a+4172|0;m=a+4224|0;x=b[m>>1]|0;t=a+4160|0;n=Se(c[t>>2]|0)|0;B=b[21208+(n<<1)>>1]|0;p=a+4164|0;if((c[p>>2]|0)==2)n=b[21216+(n<<1)>>1]|0;else n=b[21224+(n<<1)>>1]|0;E=n<<16>>16;u=a+4182|0;n=a+2340|0;hf(u,c[n>>2]|0,64881);C=c[n>>2]|0;yj(j|0,a+4182|0,C<<1|0)|0;do if(!(c[t>>2]|0)){if((c[p>>2]|0)==2){t=16384;p=0;}else{C=(Me(4194304,Ue(134217728,Td(u,C)|0)|0)|0)<<3;E=($(C>>16,E)|0)+(($(C&65528,E)|0)>>16)>>14;C=c[n>>2]|0;x=16384;break;}while(1){if((p|0)>=5)break;t=(t&65535)-(e[a+(p<<1)+4172>>1]|0)&65535;p=p+1|0;}x=(Te(t)|0)<<16>>16;x=($(x,b[a+4236>>1]|0)|0)>>>14&65535;}while(0);p=a+4220|0;u=c[p>>2]|0;z=a+4168|0;t=(c[z>>2]>>7)+1>>1;D=c[q>>2]|0;F=D-t-C+-2|0;Sd(y+(F<<1)|0,a+(F<<1)+1348|0,j,D-F|0,C,g);A=Ve(c[A>>2]|0)|0;A=(A|0)<1073741823?A:1073741823;C=c[q>>2]|0;g=A>>16;A=A&65535;F=F+(c[n>>2]|0)|0;while(1){if((F|0)>=(C|0))break;J=b[y+(F<<1)>>1]|0;c[k+(F<<2)>>2]=($(g,J)|0)+(($(A,J)|0)>>16);F=F+1|0;}g=a+4174|0;C=a+4176|0;A=a+4178|0;y=a+4180|0;B=B<<16>>16;E=E<<16>>16;F=a+2316|0;G=0;while(1){if((G|0)>=(c[s>>2]|0))break;x=x<<16>>16;H=c[r>>2]|0;t=k+(D-t+2<<2)|0;I=0;while(1){if((I|0)>=(H|0)){t=0;break;}J=c[t>>2]|0;L=b[v>>1]|0;L=($(J>>16,L)|0)+(($(J&65535,L)|0)>>16)+2|0;J=c[t+-4>>2]|0;K=b[g>>1]|0;K=L+(($(J>>16,K)|0)+(($(J&65535,K)|0)>>16))|0;J=c[t+-8>>2]|0;L=b[C>>1]|0;L=K+(($(J>>16,L)|0)+(($(J&65535,L)|0)>>16))|0;J=c[t+-12>>2]|0;K=b[A>>1]|0;K=L+(($(J>>16,K)|0)+(($(J&65535,K)|0)>>16))|0;J=c[t+-16>>2]|0;L=b[y>>1]|0;L=K+(($(J>>16,L)|0)+(($(J&65535,L)|0)>>16))|0;J=($(u,196314165)|0)+907633515|0;K=c[a+(w+(J>>>25)<<2)+4>>2]|0;c[k+(D<<2)>>2]=L+(($(K>>16,x)|0)+(($(K&65535,x)|0)>>16))<<2;t=t+4|0;u=J;D=D+1|0;I=I+1|0;}while(1){if((t|0)>=5)break;L=a+(t<<1)+4172|0;b[L>>1]=($(B,b[L>>1]|0)|0)>>>15;t=t+1|0;}x=($(x,E)|0)>>>15&65535;t=c[z>>2]|0;t=Ue(t+(((t>>16)*655|0)+(((t&65535)*655|0)>>>16))|0,(c[F>>2]<<16>>16)*4608|0)|0;c[z>>2]=t;t=(t>>7)+1>>1;G=G+1|0;}q=c[q>>2]|0;r=q+-16|0;a=a+1284|0;s=k+(r<<2)+0|0;w=a+0|0;v=s+64|0;do{c[s>>2]=c[w>>2];s=s+4|0;w=w+4|0;}while((s|0)<(v|0));w=b[j>>1]|0;D=b[j+2>>1]|0;A=b[j+4>>1]|0;v=b[j+6>>1]|0;y=b[j+8>>1]|0;z=b[j+10>>1]|0;s=b[j+12>>1]|0;g=b[j+14>>1]|0;B=b[j+16>>1]|0;C=b[j+18>>1]|0;o=c[o>>2]|0;E=o<<16>>16;o=(o>>15)+1>>1;F=0;while(1){G=c[l>>2]|0;if((F|0)>=(G|0))break;G=c[k+(r+(F+15)<<2)>>2]|0;G=(c[n>>2]>>1)+(($(G>>16,w)|0)+(($(G&65535,w)|0)>>16))|0;I=c[k+(r+(F+14)<<2)>>2]|0;I=G+(($(I>>16,D)|0)+(($(I&65535,D)|0)>>16))|0;G=c[k+(r+(F+13)<<2)>>2]|0;G=I+(($(G>>16,A)|0)+(($(G&65535,A)|0)>>16))|0;I=c[k+(r+(F+12)<<2)>>2]|0;I=G+(($(I>>16,v)|0)+(($(I&65535,v)|0)>>16))|0;G=c[k+(r+(F+11)<<2)>>2]|0;G=I+(($(G>>16,y)|0)+(($(G&65535,y)|0)>>16))|0;I=c[k+(r+(F+10)<<2)>>2]|0;I=G+(($(I>>16,z)|0)+(($(I&65535,z)|0)>>16))|0;G=c[k+(r+(F+9)<<2)>>2]|0;G=I+(($(G>>16,s)|0)+(($(G&65535,s)|0)>>16))|0;I=c[k+(r+(F+8)<<2)>>2]|0;I=G+(($(I>>16,g)|0)+(($(I&65535,g)|0)>>16))|0;G=c[k+(r+(F+7)<<2)>>2]|0;G=I+(($(G>>16,B)|0)+(($(G&65535,B)|0)>>16))|0;I=c[k+(r+(F+6)<<2)>>2]|0;I=G+(($(I>>16,C)|0)+(($(I&65535,C)|0)>>16))|0;G=c[n>>2]|0;H=F+16|0;J=10;while(1){if((J|0)>=(G|0))break;K=c[k+(r+(H-J+-1)<<2)>>2]|0;L=b[j+(J<<1)>>1]|0;I=I+(($(K>>16,L)|0)+(($(K&65535,L)|0)>>16))|0;J=J+1|0;}L=k+(q+F<<2)|0;G=(c[L>>2]|0)+(I<<4)|0;c[L>>2]=G;G=(($(G>>16,E)|0)+(($(G&65535,E)|0)>>16)+($(G,o)|0)>>7)+1>>1;if((G|0)>32767)G=32767;else G=(G|0)<-32768?-32768:G&65535;b[f+(F<<1)>>1]=G;F=F+1|0;}s=a+0|0;w=k+(r+G<<2)+0|0;v=s+64|0;do{c[s>>2]=c[w>>2];s=s+4|0;w=w+4|0;}while((s|0)<(v|0));c[p>>2]=u;b[m>>1]=x;j=0;while(1){if((j|0)>=4)break;c[d+(j<<2)>>2]=t;j=j+1|0;}i=h;return;}function Je(d,e){d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;f=i;k=d+4168|0;r=a[d+2765>>0]|0;c[d+4164>>2]=r<<24>>24;a:do if(r<<24>>24==2){g=d+2324|0;h=d+2332|0;n=d+4172|0;j=c[h>>2]|0;l=c[g>>2]|0;p=0;m=0;while(1){q=$(m,j)|0;r=l+-1|0;if((m|0)==(l|0)?1:(q|0)>=(c[e+(r<<2)>>2]|0))break;else{o=0;q=0;}while(1){if((o|0)>=5)break;s=q+(b[e+(((r-m|0)*5|0)+o<<1)+96>>1]|0)|0;o=o+1|0;q=s;}if((q|0)>(p|0)){p=e+((l+65535-m<<16>>16)*5<<1)+96|0;b[n+0>>1]=b[p+0>>1]|0;b[n+2>>1]=b[p+2>>1]|0;b[n+4>>1]=b[p+4>>1]|0;b[n+6>>1]=b[p+6>>1]|0;b[n+8>>1]=b[p+8>>1]|0;c[k>>2]=c[e+(l+-1-m<<2)>>2]<<8;p=q;}m=m+1|0;}b[n+0>>1]=0;b[n+2>>1]=0;b[n+4>>1]=0;b[n+6>>1]=0;b[n+8>>1]=0;b[d+4176>>1]=p;if((p|0)<11469){j=(11744256/(((p|0)>1?p:1)|0)|0)<<16>>16;k=0;while(1){if((k|0)>=5)break a;s=d+(k<<1)+4172|0;b[s>>1]=($(b[s>>1]|0,j)|0)>>>10;k=k+1|0;}}if((p|0)>15565){j=(255016960/(p|0)|0)<<16>>16;k=0;while(1){if((k|0)>=5)break a;s=d+(k<<1)+4172|0;b[s>>1]=($(b[s>>1]|0,j)|0)>>>14;k=k+1|0;}}}else{c[k>>2]=(c[d+2316>>2]<<16>>16)*4608;h=d+4172|0;b[h+0>>1]=0;b[h+2>>1]=0;b[h+4>>1]=0;b[h+6>>1]=0;b[h+8>>1]=0;h=d+2332|0;g=d+2324|0;}while(0);yj(d+4182|0,e+64|0,c[d+2340>>2]<<1|0)|0;b[d+4236>>1]=c[e+136>>2];s=c[g>>2]|0;p=e+(s+-2<<2)+16|0;q=c[p+4>>2]|0;r=d+4240|0;c[r>>2]=c[p>>2];c[r+4>>2]=q;c[d+4256>>2]=c[h>>2];c[d+4252>>2]=s;i=f;return;}function Ke(a,d,e){a=a|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0;f=i;i=i+16|0;h=f+4|0;g=f;if(c[a+4160>>2]|0){di(a+4228|0,a+4232|0,d,e);c[a+4216>>2]=1;i=f;return;}a:do if(c[a+4216>>2]|0){di(g,h,d,e);j=c[h>>2]|0;h=c[a+4232>>2]|0;if((j|0)<=(h|0)){if((j|0)<(h|0))c[g>>2]=c[g>>2]>>h-j;}else{k=a+4228|0;c[k>>2]=c[k>>2]>>j-h;}h=c[g>>2]|0;j=a+4228|0;k=c[j>>2]|0;if((h|0)>(k|0)){l=Le(k)|0;k=k<<l+-1;c[j>>2]=k;j=h>>(Me(25-l|0,0)|0);c[g>>2]=j;j=(Ne((k|0)/(((j|0)>1?j:1)|0)|0)|0)<<4;g=((65536-j|0)/(e|0)|0)<<2;h=0;while(1){if((h|0)>=(e|0))break a;l=d+(h<<1)|0;k=b[l>>1]|0;b[l>>1]=($(j>>16,k)|0)+(($(j&65532,k)|0)>>>16);j=j+g|0;if((j|0)>65536)break a;h=h+1|0;}}}while(0);c[a+4216>>2]=0;i=f;return;}function Le(a){a=a|0;var b=0;b=i;if(!a)a=32;else a=vj(a|0)|0;i=b;return a|0;}function Me(a,b){a=a|0;b=b|0;return((a|0)>(b|0)?a:b)|0;}function Ne(a){a=a|0;var b=0,d=0,e=0;b=i;i=i+16|0;d=b+4|0;e=b;if((a|0)<1){e=0;i=b;return e|0;}Oe(a,d,e);d=c[d>>2]|0;d=((d&1|0)==0?46214:32768)>>>(d>>1);e=($(c[e>>2]<<16>>16,13959168)|0)>>16;e=d+(($(d>>16,e)|0)+(($(d&65535,e)|0)>>16))|0;i=b;return e|0;}function Oe(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=i;f=Le(a)|0;c[b>>2]=f;c[d>>2]=(Pe(a,24-f|0)|0)&127;i=e;return;}function Pe(a,b){a=a|0;b=b|0;var c=0,d=0;c=i;d=0-b|0;do if(b)if((b|0)<0){a=a<<d|a>>>(b+32|0);break;}else{a=a<<32-b|a>>>b;break;}while(0);i=c;return a|0;}function Qe(a,d,e,f,g,h,j,k){a=a|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;l=i;o=i;i=i+((2*(j<<1)|0)+15&-16)|0;m=o;n=0;while(1){if((n|0)>=2)break;p=$(n+k+-2|0,j)|0;q=h+(n<<2)|0;r=0;while(1){if((r|0)>=(j|0))break;t=c[g+(r+p<<2)>>2]|0;s=c[q>>2]|0;u=s<<16>>16;s=($(t>>16,u)|0)+(($(t&65535,u)|0)>>16)+($(t,(s>>15)+1>>1)|0)>>8;if((s|0)>32767)s=32767;else s=(s|0)<-32768?-32768:s&65535;b[m+(r<<1)>>1]=s;r=r+1|0;}m=m+(j<<1)|0;n=n+1|0;}di(a,d,o,j);di(e,f,o+(j<<1)|0,j);i=l;return;}function Re(a){a=a|0;return((a|0)<0?0:a)|0;}function Se(a){a=a|0;return((a|0)>1?1:a)|0;}function Te(a){a=a|0;return(a<<16>>16<3277?3277:a)|0;}function Ue(a,b){a=a|0;b=b|0;return((a|0)<(b|0)?a:b)|0;}function Ve(a){a=a|0;var b=0,c=0,d=0,e=0,f=0,g=0;b=i;d=Le((a|0)>0?a:0-a|0)|0;c=a<<d+-1;g=c>>16;a=536870911/(g|0)|0;f=a<<16;e=f>>16;c=536870912-(($(g,e)|0)+(($(c&65535,e)|0)>>16))<<3;a=f+(($(c>>16,e)|0)+(($(c&65528,e)|0)>>16))+($(c,(a>>15)+1>>1)|0)|0;d=62-d|0;c=d+-46|0;if((c|0)>=1){i=b;return((c|0)<32?a>>c:0)|0;}c=46-d|0;d=-2147483648>>c;e=2147483647>>>c;if((d|0)>(e|0)){if((a|0)>(d|0)){g=d;g=g<<c;i=b;return g|0;}g=(a|0)<(e|0)?e:a;g=g<<c;i=b;return g|0;}else{if((a|0)>(e|0)){g=e;g=g<<c;i=b;return g|0;}g=(a|0)<(d|0)?d:a;g=g<<c;i=b;return g|0;}return 0;}function We(a){a=a|0;var b=0,d=0,e=0;b=i;e=a+0|0;d=e+112|0;do{c[e>>2]=0;e=e+4|0;}while((e|0)<(d|0));d=0;while(1){if((d|0)>=4){d=0;break;}e=d+1|0;c[a+(d<<2)+92>>2]=Xe(50/(e|0)|0)|0;d=e;}while(1){if((d|0)>=4)break;e=(c[a+(d<<2)+92>>2]|0)*100|0;c[a+(d<<2)+60>>2]=e;c[a+(d<<2)+76>>2]=2147483647/(e|0)|0;d=d+1|0;}c[a+108>>2]=15;d=0;while(1){if((d|0)>=4)break;c[a+(d<<2)+40>>2]=25600;d=d+1|0;}i=b;return 0;}function Xe(a){a=a|0;return((a|0)>1?a:1)|0;}function Ye(a,d){a=a|0;d=d|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;g=i;i=i+48|0;j=g+32|0;f=g+16|0;m=g;k=a+32|0;h=a+4608|0;r=c[h>>2]|0;t=r>>1;v=r>>2;n=r>>3;c[m>>2]=0;u=n+v|0;c[m+4>>2]=u;s=u+n|0;c[m+8>>2]=s;q=s+v|0;c[m+12>>2]=q;l=i;i=i+((2*(q+t|0)|0)+15&-16)|0;ff(d,k,l,l+(q<<1)|0,r);ff(l,a+40|0,l,l+(s<<1)|0,t);ff(l,a+48|0,l,l+(u<<1)|0,v);v=l+(n+-1<<1)|0;d=(b[v>>1]|0)>>>1&65535;b[v>>1]=d;while(1){o=n+-1|0;if((o|0)<=0)break;v=l+(n+-2<<1)|0;u=(b[v>>1]|0)>>>1;b[v>>1]=u;v=l+(o<<1)|0;b[v>>1]=(e[v>>1]|0)-u;n=o;}p=a+88|0;b[l>>1]=(e[l>>1]|0)-(e[p>>1]|0);b[p>>1]=d;p=0;t=0;while(1){if((p|0)>=4)break;s=c[h>>2]|0;s=s>>(Ze(4-p|0,3)|0)>>2;o=a+(p<<2)+56|0;u=c[o>>2]|0;n=j+(p<<2)|0;c[n>>2]=u;r=m+(p<<2)|0;d=0;q=0;while(1){if((q|0)<4){v=0;t=0;}else break;while(1){if((v|0)>=(s|0))break;w=b[l+((c[r>>2]|0)+v+d<<1)>>1]>>3;v=v+1|0;t=t+($(w,w)|0)|0;}if((q|0)<3){v=u+t|0;w=(v|0)<0;u=w?2147483647:v;v=w?2147483647:v;}else{v=u+(t>>1)|0;w=(v|0)<0;u=w?2147483647:v;v=w?2147483647:v;}c[n>>2]=v;d=d+s|0;q=q+1|0;}c[o>>2]=t;p=p+1|0;}_e(j,k);l=0;k=0;m=0;while(1){if((k|0)>=4)break;n=c[j+(k<<2)>>2]|0;o=c[a+(k<<2)+92>>2]|0;d=n-o|0;if((d|0)>0){if(n>>>0<8388608){n=(n<<8|0)/(o+1|0)|0;c[f+(k<<2)>>2]=n;}else{n=(n|0)/((o>>8)+1|0)|0;c[f+(k<<2)>>2]=n;}o=(oh(n)|0)+-1024|0;n=o<<16>>16;m=m+($(n,n)|0)|0;if((d|0)<1048576){o=$(($e(d)|0)<<6>>16,n)|0;o=o+(($(($e(d)|0)<<6&65472,n)|0)>>16)|0;}v=c[21232+(k<<2)>>2]|0;w=o<<16>>16;l=l+(($(v>>16,w)|0)+(($(v&65535,w)|0)>>16))|0;}else c[f+(k<<2)>>2]=256;k=k+1|0;}k=Lh(((($e((m|0)/4|0)|0)*196608>>16)*45e3>>16)+-128|0)|0;c[a+4744>>2]=((Lh(l)|0)<<1)+-32768;l=0;m=0;while(1){if((m|0)>=4)break;w=m+1|0;l=l+($(w,(c[j+(m<<2)>>2]|0)-(c[a+(m<<2)+92>>2]|0)>>4)|0)|0;m=w;}if((l|0)>=1){if((l|0)<32768){if((c[h>>2]|0)==((c[a+4600>>2]|0)*10|0)){if((l|0)>32767)j=32767;else j=(l|0)<-32768?-32768:l;j=j<<16;}else{if((l|0)>65535)j=65535;else j=(l|0)<-65536?-65536:l;j=j<<15;}w=($e(j)|0)+32768|0;k=k<<16>>16;k=($(w>>16,k)|0)+(($(w&65535,k)|0)>>16)|0;}}else k=k>>1;c[a+4556>>2]=Ze(k>>7,255)|0;j=k<<16>>16;j=(($(k>>16,j)|0)<<16)+($(k&65535,j)|0)|0;h=(c[h>>2]|0)==((c[a+4600>>2]|0)*10|0)?j>>21:j>>20;j=0;while(1){if((j|0)>=4)break;v=a+(j<<2)+72|0;u=c[v>>2]|0;w=(c[f+(j<<2)>>2]|0)-u|0;w=u+(($(w>>16,h)|0)+(($(w&65535,h)|0)>>16))|0;c[v>>2]=w;c[a+(j<<2)+4728>>2]=Lh(((oh(w)|0)*3|0)+-5120>>4)|0;j=j+1|0;}i=g;return;}function Ze(a,b){a=a|0;b=b|0;return((a|0)<(b|0)?a:b)|0;}function _e(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0;d=i;e=b+108|0;f=c[e>>2]|0;if((f|0)<1e3)g=32767/((f>>4)+1|0)|0;else g=0;f=0;while(1){if((f|0)>=4)break;h=b+(f<<2)+60|0;k=c[h>>2]|0;l=(c[a+(f<<2)>>2]|0)+(c[b+(f<<2)+92>>2]|0)|0;l=(l|0)<0?2147483647:l;j=2147483647/(l|0)|0;if((l|0)<=(k<<3|0)){if((l|0)<(k|0))k=1024;else{l=k<<16>>16;m=$(j>>16,l)|0;l=$(j&65535,l)|0;k=$(j,(k>>15)+1>>1)|0;k=m+(l>>16)+k>>16<<11|(m+(l>>>16)+k|0)>>>5&2047;}}else k=128;m=af(k,g)|0;l=b+(f<<2)+76|0;n=c[l>>2]|0;k=j-n|0;m=m<<16>>16;m=n+(($(k>>16,m)|0)+(($(k&65535,m)|0)>>16))|0;c[l>>2]=m;m=2147483647/(m|0)|0;c[h>>2]=(m|0)<16777215?m:16777215;f=f+1|0;}c[e>>2]=(c[e>>2]|0)+1;i=d;return;}function $e(a){a=a|0;var b=0,d=0,e=0;b=i;i=i+16|0;d=b+4|0;e=b;if((a|0)<1){e=0;i=b;return e|0;}bf(a,d,e);d=c[d>>2]|0;d=((d&1|0)==0?46214:32768)>>>(d>>1);e=($(c[e>>2]<<16>>16,13959168)|0)>>16;e=d+(($(d>>16,e)|0)+(($(d&65535,e)|0)>>16))|0;i=b;return e|0;}function af(a,b){a=a|0;b=b|0;return((a|0)>(b|0)?a:b)|0;}function bf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=i;f=cf(a)|0;c[b>>2]=f;c[d>>2]=(df(a,24-f|0)|0)&127;i=e;return;}function cf(a){a=a|0;var b=0;b=i;if(!a)a=32;else a=vj(a|0)|0;i=b;return a|0;}function df(a,b){a=a|0;b=b|0;var c=0,d=0;c=i;d=0-b|0;do if(b)if((b|0)<0){a=a<<d|a>>>(b+32|0);break;}else{a=a<<32-b|a>>>b;break;}while(0);i=c;return a|0;}function ef(b,f,g,h,j,k,l,m,n,o,p){b=b|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;var q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0;t=i;c[f>>2]=2147483647;u=h+2|0;q=h+4|0;r=h+6|0;s=h+8|0;B=n<<16>>16;D=j+4|0;x=j+8|0;C=j+12|0;E=j+16|0;G=j+28|0;H=j+32|0;I=j+36|0;n=j+24|0;v=j+52|0;w=j+56|0;F=j+48|0;y=j+76|0;z=j+72|0;A=j+96|0;J=0;while(1){if((J|0)>=(p|0))break;K=d[l+J>>0]|0;S=$(B,d[m+J>>0]|0)|0;P=K-o|0;R=c[D>>2]|0;M=(e[u>>1]|0)-(a[k+1>>0]<<7)<<16>>16;R=($(R>>16,M)|0)+(($(R&65535,M)|0)>>16)|0;T=c[x>>2]|0;O=(e[q>>1]|0)-(a[k+2>>0]<<7)<<16>>16;T=R+(($(T>>16,O)|0)+(($(T&65535,O)|0)>>16))|0;R=c[C>>2]|0;N=(e[r>>1]|0)-(a[k+3>>0]<<7)<<16>>16;R=T+(($(R>>16,N)|0)+(($(R&65535,N)|0)>>16))|0;T=c[E>>2]|0;L=(e[s>>1]|0)-(a[k+4>>0]<<7)<<16>>16;T=R+(($(T>>16,L)|0)+(($(T&65535,L)|0)>>16))<<1;R=c[j>>2]|0;Q=(e[h>>1]|0)-(a[k>>0]<<7)<<16>>16;R=T+(($(R>>16,Q)|0)+(($(R&65535,Q)|0)>>16))|0;Q=S+((P|0)>0?P<<10:0)+(($(R>>16,Q)|0)+(($(R&65535,Q)|0)>>16))|0;R=c[G>>2]|0;R=($(R>>16,O)|0)+(($(R&65535,O)|0)>>16)|0;P=c[H>>2]|0;P=R+(($(P>>16,N)|0)+(($(P&65535,N)|0)>>16))|0;R=c[I>>2]|0;R=P+(($(R>>16,L)|0)+(($(R&65535,L)|0)>>16))<<1;P=c[n>>2]|0;P=R+(($(P>>16,M)|0)+(($(P&65535,M)|0)>>16))|0;M=Q+(($(P>>16,M)|0)+(($(P&65535,M)|0)>>16))|0;P=c[v>>2]|0;P=($(P>>16,N)|0)+(($(P&65535,N)|0)>>16)|0;Q=c[w>>2]|0;Q=P+(($(Q>>16,L)|0)+(($(Q&65535,L)|0)>>16))<<1;P=c[F>>2]|0;P=Q+(($(P>>16,O)|0)+(($(P&65535,O)|0)>>16))|0;O=M+(($(P>>16,O)|0)+(($(P&65535,O)|0)>>16))|0;P=c[y>>2]|0;P=($(P>>16,L)|0)+(($(P&65535,L)|0)>>16)<<1;M=c[z>>2]|0;M=P+(($(M>>16,N)|0)+(($(M&65535,N)|0)>>16))|0;N=O+(($(M>>16,N)|0)+(($(M&65535,N)|0)>>16))|0;M=c[A>>2]|0;M=($(M>>16,L)|0)+(($(M&65535,L)|0)>>16)|0;L=N+(($(M>>16,L)|0)+(($(M&65535,L)|0)>>16))|0;if((L|0)<(c[f>>2]|0)){c[f>>2]=L;a[b>>0]=J;c[g>>2]=K;}k=k+5|0;J=J+1|0;}i=t;return;}function ff(a,d,e,f,g){a=a|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;h=i;j=g>>1;k=d+4|0;g=0;while(1){if((g|0)>=(j|0))break;o=g<<1;p=b[a+(o<<1)>>1]<<10;n=p-(c[d>>2]|0)|0;l=($(n>>16,-24290)|0)+(($(n&65535,-24290)|0)>>16)|0;m=p+l|0;c[d>>2]=p+(n+l);o=b[a+((o|1)<<1)>>1]<<10;l=c[k>>2]|0;n=o-l|0;n=((n>>16)*10788|0)+(((n&65535)*10788|0)>>>16)|0;l=l+n|0;c[k>>2]=o+n;n=(l+m>>10)+1>>1;if((n|0)>32767)n=32767;else n=(n|0)<-32768?-32768:n&65535;b[e+(g<<1)>>1]=n;l=(l-m>>10)+1>>1;if((l|0)>32767)l=32767;else l=(l|0)<-32768?-32768:l&65535;b[f+(g<<1)>>1]=l;g=g+1|0;}i=h;return;}function gf(a,d,e,f,g,h){a=a|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;j=i;p=0-(c[e>>2]|0)|0;k=0-(c[e+4>>2]|0)|0;n=f+4|0;o=p&16383;p=p>>>14<<16>>16;q=d+4|0;e=k&16383;k=k>>>14<<16>>16;l=d+8|0;m=0;while(1){if((m|0)>=(h|0))break;s=b[a+(m<<1)>>1]|0;r=c[d>>2]|0;r=(c[f>>2]|0)+(($(r>>16,s)|0)+(($(r&65535,s)|0)>>16))<<2;t=r>>16;u=r&65532;w=(c[n>>2]|0)+((($(t,o)|0)+(($(u,o)|0)>>>16)>>13)+1>>1)+(($(t,p)|0)+(($(u,p)|0)>>16))|0;c[f>>2]=w;v=c[q>>2]|0;c[f>>2]=w+(($(v>>16,s)|0)+(($(v&65535,s)|0)>>16));u=((($(t,e)|0)+(($(u,e)|0)>>>16)>>13)+1>>1)+(($(t,k)|0)+(($(u,k)|0)>>16))|0;c[n>>2]=u;t=c[l>>2]|0;c[n>>2]=u+(($(t>>16,s)|0)+(($(t&65535,s)|0)>>16));r=r+16383>>14;if((r|0)>32767)r=32767;else r=(r|0)<-32768?-32768:r&65535;b[g+(m<<1)>>1]=r;m=m+1|0;}i=j;return;}function hf(a,c,d){a=a|0;c=c|0;d=d|0;var e=0,f=0,g=0,h=0;e=i;f=d+-65536|0;c=c+-1|0;g=0;while(1){if((g|0)>=(c|0))break;h=a+(g<<1)|0;b[h>>1]=((($(d,b[h>>1]|0)|0)>>>15)+1|0)>>>1;d=d+((($(d,f)|0)>>15)+1>>1)|0;g=g+1|0;}h=a+(c<<1)|0;b[h>>1]=((($(d,b[h>>1]|0)|0)>>>15)+1|0)>>>1;i=e;return;}function jf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0,l=0;e=i;f=d+-65536|0;b=b+-1|0;g=0;while(1){h=d>>16;if((g|0)>=(b|0))break;j=a+(g<<2)|0;k=c[j>>2]|0;l=k<<16>>16;c[j>>2]=($(h,l)|0)+(($(d&65535,l)|0)>>16)+($(d,(k>>15)+1>>1)|0);d=d+((($(d,f)|0)>>15)+1>>1)|0;g=g+1|0;}l=a+(b<<2)|0;k=c[l>>2]|0;j=k<<16>>16;c[l>>2]=($(h,j)|0)+(($(d&65535,j)|0)>>16)+($(d,(k>>15)+1>>1)|0);i=e;return;}function kf(a){a=a|0;var b=0,d=0,e=0,f=0,g=0;b=i;g=c[a+8>>2]|0;do if((g|0)==48e3|(g|0)==44100|(g|0)==32e3|(g|0)==24e3|(g|0)==16e3|(g|0)==12e3|(g|0)==8e3){e=c[a+20>>2]|0;if((e|0)!=8e3){if((e|0)!=12e3){if((e|0)==16e3)e=16e3;else{a=-102;break;}}else e=12e3;}else e=8e3;f=c[a+12>>2]|0;if((f|0)!=8e3){if((f|0)!=12e3){if((f|0)==16e3)f=16e3;else{a=-102;break;}}else f=12e3;}else f=8e3;g=c[a+16>>2]|0;if((g|0)==12e3){g=12e3;d=10;}else if((g|0)!=8e3){if((g|0)==16e3){g=16e3;d=10;}else{a=-102;break;}}else g=8e3;if((d|0)==10)if(g>>>0>e>>>0){a=-102;break;}if(!(f>>>0<e>>>0|g>>>0>f>>>0)){g=c[a+24>>2]|0;if((g|0)==60|(g|0)==40|(g|0)==20|(g|0)==10){g=c[a+32>>2]|0;if(!((g|0)<0|(g|0)>100)){g=c[a+44>>2]|0;if(!((g|0)<0|(g|0)>1)){g=c[a+48>>2]|0;if(!((g|0)<0|(g|0)>1)){g=c[a+40>>2]|0;if(!((g|0)<0|(g|0)>1)){d=c[a>>2]|0;if(!((d|0)<1|(d|0)>2)?(g=c[a+4>>2]|0,!((g|0)<1|(g|0)>2|(g|0)>(d|0))):0){g=c[a+36>>2]|0;i=b;return((g|0)<0|(g|0)>10?-106:0)|0;}else a=-111;}else a=-107;}else a=-109;}else a=-108;}else a=-105;}else a=-103;}else a=-102;}else a=-102;while(0);i=b;return a|0;}function lf(b,d,e,f,g,h){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0;j=i;i=i+16|0;k=j;a[k+1>>0]=0;f=((f<<1)+g<<16>>16)*7|0;e=e+8>>4;g=0;while(1){if((g|0)>=(e|0))break;l=c[h+(g<<2)>>2]|0;a:do if((l|0)>0){a[k>>0]=a[26304+(f+((l&30)>>>0<6?l&31:6))>>0]|0;m=0;while(1){if((m|0)>=16)break a;l=a[d+m>>0]|0;if(l<<24>>24)Cc(b,(l<<24>>24>>15)+1|0,k,8);m=m+1|0;}}while(0);d=d+16|0;g=g+1|0;}i=j;return;}function mf(d,e,f,g,h,j){d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0;k=i;i=i+16|0;l=k;a[l+1>>0]=0;g=((g<<1)+h<<16>>16)*7|0;f=f+8>>4;h=0;while(1){if((h|0)>=(f|0))break;m=c[j+(h<<2)>>2]|0;a:do if((m|0)>0){a[l>>0]=a[26304+(g+((m&30)>>>0<6?m&31:6))>>0]|0;n=0;while(1){if((n|0)>=16)break a;m=e+(n<<1)|0;if((b[m>>1]|0)>0){o=((sc(d,l,8)|0)<<1)+-1|0;b[m>>1]=$(b[m>>1]|0,o)|0;}n=n+1|0;}}while(0);e=e+32|0;h=h+1|0;}i=k;return;}function nf(a,d){a=a|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0;f=i;if((d|0)>8e4)g=8e4;else g=(d|0)<5e3?5e3:d;d=a+4632|0;if((g|0)==(c[d>>2]|0)){i=f;return;}c[d>>2]=g;d=c[a+4600>>2]|0;if((d|0)==8)d=24720;else d=(d|0)==12?24752:24784;h=(c[a+4604>>2]|0)==2?g+-2200|0:g;j=1;while(1){if((j|0)>=8)break;g=c[d+(j<<2)>>2]|0;if((h|0)<=(g|0)){e=9;break;}j=j+1|0;}if((e|0)==9){k=j+-1|0;e=c[d+(k<<2)>>2]|0;d=b[24816+(k<<1)>>1]|0;c[a+4748>>2]=(d<<6)+($((h-e<<6|0)/(g-e|0)|0,(b[24816+(j<<1)>>1]|0)-d|0)|0);}if(!(c[a+6124>>2]|0)){i=f;return;}k=a+4748|0;c[k>>2]=(c[k>>2]|0)+($(12-(c[a+6128>>2]|0)<<16>>16,-31)|0);i=f;return;}function of(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;e=i;d=c[a+4600>>2]|0;j=d<<16>>16;f=j*1e3|0;if(!j){h=c[a+4596>>2]|0;j=c[a+4580>>2]|0;j=(((h|0)<(j|0)?h:j)|0)/1e3|0;i=e;return j|0;}g=c[a+4580>>2]|0;h=c[a+4588>>2]|0;if(!((f|0)>(g|0)|(f|0)>(h|0))?(f|0)>=(c[a+4592>>2]|0):0){h=a+24|0;g=c[h>>2]|0;if((g|0)>255)c[a+28>>2]=0;if((c[a+4560>>2]|0)==0?(c[b+60>>2]|0)==0:0){j=d;i=e;return j|0;}j=c[a+4596>>2]|0;if((f|0)>(j|0)){f=a+28|0;if(!(c[f>>2]|0)){c[h>>2]=256;g=a+16|0;c[g>>2]=0;c[g+4>>2]=0;g=256;}if(c[b+60>>2]|0){c[f>>2]=0;j=(d|0)==16?12:8;i=e;return j|0;}if((g|0)<1){c[b+84>>2]=1;j=b+52|0;h=c[j>>2]|0;c[j>>2]=h-((h*5|0)/((c[b+24>>2]|0)+5|0)|0);j=d;i=e;return j|0;}else{c[f>>2]=-2;j=d;i=e;return j|0;}}if((f|0)>=(j|0)){b=a+28|0;if((c[b>>2]|0)>=0){j=d;i=e;return j|0;}c[b>>2]=1;j=d;i=e;return j|0;}if(c[b+60>>2]|0){c[h>>2]=0;j=a+16|0;c[j>>2]=0;c[j+4>>2]=0;c[a+28>>2]=1;j=(d|0)==8?12:16;i=e;return j|0;}a=a+28|0;if(!(c[a>>2]|0)){c[b+84>>2]=1;j=b+52|0;h=c[j>>2]|0;c[j>>2]=h-((h*5|0)/((c[b+24>>2]|0)+5|0)|0);j=d;i=e;return j|0;}else{c[a>>2]=1;j=d;i=e;return j|0;}}h=(g|0)<(h|0)?g:h;j=c[a+4592>>2]|0;j=(((h|0)>(j|0)?h:j)|0)/1e3|0;i=e;return j|0;}function pf(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0;h=i;c[a+6108>>2]=c[b+44>>2];c[a+4708>>2]=c[b+48>>2];j=c[b+8>>2]|0;c[a+4580>>2]=j;c[a+4588>>2]=c[b+12>>2];c[a+4592>>2]=c[b+16>>2];c[a+4596>>2]=c[b+20>>2];c[a+6120>>2]=c[b+40>>2];c[a+5784>>2]=c[b>>2];c[a+5788>>2]=c[b+4>>2];c[a+4560>>2]=e;c[a+5792>>2]=f;f=a+4700|0;if((c[f>>2]|0)!=0?(c[a+4712>>2]|0)==0:0){if((j|0)==(c[a+4584>>2]|0)){e=0;i=h;return e|0;}j=c[a+4600>>2]|0;if((j|0)<=0){e=0;i=h;return e|0;}e=qf(a,j)|0;i=h;return e|0;}e=of(a,b)|0;e=(g|0)==0?e:g;g=qf(a,e)|0;e=g+(rf(a,e,c[b+24>>2]|0)|0)|0;e=e+(sf(a,c[b+36>>2]|0)|0)|0;c[a+4640>>2]=c[b+32>>2];e=e+(tf(a,d)|0)|0;c[f>>2]=1;i=h;return e|0;}function qf(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0;d=i;i=i+304|0;f=d;g=a+4600|0;e=c[g>>2]|0;if((e|0)==(b|0)?(c[a+4584>>2]|0)==(c[a+4580>>2]|0):0){b=0;f=a+4580|0;f=c[f>>2]|0;g=a+4584|0;c[g>>2]=f;i=d;return b|0;}if(!e){b=vh(a+5808|0,c[a+4580>>2]|0,b*1e3|0,1)|0;f=a+4580|0;f=c[f>>2]|0;g=a+4584|0;c[g>>2]=f;i=d;return b|0;}else{l=((c[a+4604>>2]|0)*10|0)+5|0;o=$(l,e)|0;h=$(l,b)|0;e=ta()|0;j=i;i=i+((2*((o|0)>(h|0)?o:h)|0)+15&-16)|0;k=a+9356|0;wf(j,k,o);m=a+4580|0;n=vh(f,(c[g>>2]<<16>>16)*1e3|0,c[m>>2]|0,0)|0;g=$(l,(c[m>>2]|0)/1e3|0)|0;l=i;i=i+((2*g|0)+15&-16)|0;wh(f,l,j,o);f=a+5808|0;b=n+(vh(f,c[m>>2]|0,(b<<16>>16)*1e3|0,1)|0)|0;wh(f,j,l,g);xf(k,j,h);ja(e|0);f=a+4580|0;f=c[f>>2]|0;g=a+4584|0;c[g>>2]=f;i=d;return b|0;}return 0;}function rf(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0;f=i;j=b+4636|0;if((c[j>>2]|0)==(e|0)){k=b+4600|0;g=k;k=c[k>>2]|0;h=0;}else{k=(e|0)==10;do if(!k){if(!((e|0)==60|(e|0)==40|(e|0)==20)){if((e|0)<11){h=-103;g=6;break;}else h=-103;}else h=0;c[b+5776>>2]=(e|0)/20|0;c[b+4604>>2]=4;k=d<<16>>16;c[b+4608>>2]=k*20;c[b+4572>>2]=k*24;k=c[b+4600>>2]|0;l=b+4720|0;if((k|0)==8){c[l>>2]=25232;k=8;break;}else{c[l>>2]=25192;break;}}else{h=0;g=6;}while(0);do if((g|0)==6){c[b+5776>>2]=1;c[b+4604>>2]=k?2:1;k=d<<16>>16;c[b+4608>>2]=$(e<<16>>16,k)|0;c[b+4572>>2]=k*14;k=c[b+4600>>2]|0;g=b+4720|0;if((k|0)==8){c[g>>2]=25264;k=8;break;}else{c[g>>2]=25248;break;}}while(0);c[j>>2]=e;c[b+4632>>2]=0;g=b+4600|0;}if((k|0)==(d|0)){i=f;return h|0;}e=b+7200|0;j=b+16|0;c[j>>2]=0;c[j+4>>2]=0;c[b+5772>>2]=0;c[b+5780>>2]=0;c[b+4632>>2]=0;wj(b+144|0,0,4412)|0;wj(e|0,0,2152)|0;c[b+4568>>2]=100;c[b+4696>>2]=1;c[b+9352>>2]=100;a[e>>0]=10;c[b+4500>>2]=100;c[b+4516>>2]=65536;a[b+4565>>0]=0;c[g>>2]=d;e=(d|0)==8;j=c[b+4604>>2]|0;k=(j|0)==4;g=b+4720|0;do if(e){if(k){c[g>>2]=25232;j=4;g=21;break;}else{c[g>>2]=25264;e=j;j=8;g=23;break;}}else if(k){c[g>>2]=25192;j=4;g=21;break;}else{c[g>>2]=25248;e=j;g=22;break;}while(0);if((g|0)==21)if(e){e=j;j=8;g=23;}else{e=j;g=22;}if((g|0)==22)if((d|0)==12){j=12;g=23;}else{c[b+4664>>2]=16;c[b+4724>>2]=24608;j=d;}if((g|0)==23){c[b+4664>>2]=10;c[b+4724>>2]=23520;}c[b+4612>>2]=d*5;c[b+4608>>2]=$(d*327680>>16,e<<16>>16)|0;l=d<<16;d=l>>16;c[b+4616>>2]=d*20;c[b+4620>>2]=l>>15;c[b+4576>>2]=d*18;if((e|0)==4)c[b+4572>>2]=d*24;else c[b+4572>>2]=d*14;if((j|0)==12){c[b+4684>>2]=13;c[b+4716>>2]=25008;i=f;return h|0;}else if((j|0)==16){c[b+4684>>2]=10;c[b+4716>>2]=25016;i=f;return h|0;}else{c[b+4684>>2]=15;c[b+4716>>2]=24992;i=f;return h|0;}return 0;}function sf(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0;d=i;do if((b|0)>=2){if((b|0)<4){c[a+4668>>2]=1;c[a+4676>>2]=49807;c[a+4672>>2]=8;c[a+4660>>2]=10;f=c[a+4600>>2]|0;e=f*5|0;c[a+4624>>2]=e;c[a+4652>>2]=1;c[a+4656>>2]=0;c[a+4680>>2]=0;c[a+4692>>2]=4;c[a+4704>>2]=0;g=8;break;}if((b|0)<6){c[a+4668>>2]=1;c[a+4676>>2]=48497;c[a+4672>>2]=10;c[a+4660>>2]=12;f=c[a+4600>>2]|0;e=f*5|0;c[a+4624>>2]=e;c[a+4652>>2]=2;c[a+4656>>2]=1;c[a+4680>>2]=0;c[a+4692>>2]=8;c[a+4704>>2]=f*983;g=10;break;}e=a+4668|0;if((b|0)<8){c[e>>2]=1;c[a+4676>>2]=47186;c[a+4672>>2]=12;c[a+4660>>2]=14;f=c[a+4600>>2]|0;e=f*5|0;c[a+4624>>2]=e;c[a+4652>>2]=3;c[a+4656>>2]=1;c[a+4680>>2]=0;c[a+4692>>2]=16;c[a+4704>>2]=f*983;g=12;break;}else{c[e>>2]=2;c[a+4676>>2]=45875;c[a+4672>>2]=16;c[a+4660>>2]=16;f=c[a+4600>>2]|0;e=f*5|0;c[a+4624>>2]=e;c[a+4652>>2]=4;c[a+4656>>2]=1;c[a+4680>>2]=0;c[a+4692>>2]=32;c[a+4704>>2]=f*983;g=16;break;}}else{c[a+4668>>2]=0;c[a+4676>>2]=52429;c[a+4672>>2]=6;c[a+4660>>2]=8;f=c[a+4600>>2]|0;e=f*3|0;c[a+4624>>2]=e;c[a+4652>>2]=1;c[a+4656>>2]=0;c[a+4680>>2]=1;c[a+4692>>2]=2;c[a+4704>>2]=0;g=6;}while(0);c[a+4672>>2]=vf(g,c[a+4664>>2]|0)|0;c[a+4628>>2]=(f*5|0)+(e<<1);c[a+4648>>2]=b;i=d;return 0;}function tf(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;d=i;e=a+6124|0;c[e>>2]=0;if(!(c[a+6120>>2]|0)){i=d;return 0;}f=c[a+4640>>2]|0;if((f|0)<=0){i=d;return 0;}g=c[a+4600>>2]|0;if((g|0)==8)g=12e3;else g=(g|0)==12?14e3:16e3;if((f|0)<25){j=f;h=f;}else{j=25;h=25;}if((((($(g,125-j|0)|0)>>16)*655|0)+(((($(g,125-h|0)|0)&65520)*655|0)>>>16)|0)>=(b|0)){i=d;return 0;}c[e>>2]=1;c[a+6128>>2]=uf(7-(((f>>16)*26214|0)+(((f&65535)*26214|0)>>>16))|0)|0;i=d;return 0;}function uf(a){a=a|0;return((a|0)>2?a:2)|0;}function vf(a,b){a=a|0;b=b|0;return((a|0)<(b|0)?a:b)|0;}function wf(a,c,d){a=a|0;c=c|0;d=d|0;var e=0,f=0;e=i;while(1){f=d+-1|0;if((d|0)<=0)break;d=c+(f<<2)|0;if((sa(+ +g[d>>2])|0)<=32767){if((sa(+ +g[d>>2])|0)<-32768)d=-32768;else d=(sa(+ +g[d>>2])|0)&65535;}else d=32767;b[a+(f<<1)>>1]=d;d=f;}i=e;return;}function xf(a,c,d){a=a|0;c=c|0;d=d|0;var e=0,f=0;e=i;while(1){f=d+-1|0;if((d|0)<=0)break;g[a+(f<<2)>>2]=+(b[c+(f<<1)>>1]|0);d=f;}i=e;return;}function yf(a){a=a|0;c[a>>2]=8544;return 0;}function zf(a){a=a|0;var d=0,e=0;d=i;e=0;while(1){if((e|0)>=2)break;kh(a+(e*4260|0)|0);e=e+1|0;}e=a+8520|0;b[e+0>>1]=0;b[e+2>>1]=0;b[e+4>>1]=0;b[e+6>>1]=0;b[e+8>>1]=0;b[e+10>>1]=0;c[a+8540>>2]=0;i=d;return 0;}function Af(d,f,g,h,j,k,l,m){d=d|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;var n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0;n=i;i=i+672|0;o=n+20|0;t=n+16|0;p=n+8|0;s=n;y=n+24|0;c[o>>2]=0;q=s;c[q>>2]=0;c[q+4>>2]=0;q=f+4|0;a:do if(!h)B=c[q>>2]|0;else{h=0;while(1){B=c[q>>2]|0;if((h|0)>=(B|0))break a;c[d+(h*4260|0)+2388>>2]=0;h=h+1|0;}}while(0);h=f+4|0;q=d+8536|0;if((B|0)>(c[q>>2]|0)){kh(d+4260|0);B=c[h>>2]|0;}if((B|0)==1?(c[q>>2]|0)==2:0)r=(c[f+12>>2]|0)==((c[d+2316>>2]|0)*1e3|0);else r=0;v=d+2388|0;b:do if(!(c[v>>2]|0)){w=f+16|0;u=f+12|0;z=f+8|0;x=0;A=0;c:while(1){if((A|0)>=(B|0))break b;switch(c[w>>2]|0){case 20:{c[d+(A*4260|0)+2392>>2]=1;c[d+(A*4260|0)+2324>>2]=4;break;};case 60:{c[d+(A*4260|0)+2392>>2]=3;c[d+(A*4260|0)+2324>>2]=4;break;};case 10:{c[d+(A*4260|0)+2392>>2]=1;c[d+(A*4260|0)+2324>>2]=2;break;};case 40:{c[d+(A*4260|0)+2392>>2]=2;c[d+(A*4260|0)+2324>>2]=4;break;};case 0:{c[d+(A*4260|0)+2392>>2]=1;c[d+(A*4260|0)+2324>>2]=2;break;};default:{d=-203;z=120;break c;}}B=(c[u>>2]>>10)+1|0;if(!((B|0)==16|(B|0)==12|(B|0)==8)){d=-200;z=120;break;}G=x+(Kf(d+(A*4260|0)|0,B,c[z>>2]|0)|0)|0;B=c[h>>2]|0;x=G;A=A+1|0;}if((z|0)==120){i=n;return d|0;}}else x=0;while(0);u=c[f>>2]|0;do if((u|0)==2)if((B|0)==2){if((c[d+8532>>2]|0)!=1?(c[q>>2]|0)!=1:0){u=2;break;}u=d+8520|0;b[u>>1]=0;b[u+2>>1]=0>>>16;u=d+8528|0;b[u>>1]=0;b[u+2>>1]=0>>>16;yj(d+6692|0,d+2432|0,300)|0;u=c[f>>2]|0;}else u=2;while(0);c[d+8532>>2]=u;c[q>>2]=c[h>>2];w=f+8|0;G=c[w>>2]|0;if((G|0)>48e3|(G|0)<8e3){G=-200;i=n;return G|0;}u=(g|0)==1;d:do if(!u?(c[v>>2]|0)==0:0){z=0;while(1){E=c[h>>2]|0;if((z|0)>=(E|0)){z=0;break;}A=d+(z*4260|0)+2392|0;C=0;while(1){G=(C|0)<(c[A>>2]|0);B=rc(j,1)|0;if(!G)break;c[d+(z*4260|0)+(C<<2)+2404>>2]=B;C=C+1|0;}c[d+(z*4260|0)+2416>>2]=B;z=z+1|0;}while(1){if((z|0)>=(E|0))break;G=d+(z*4260|0)+2420|0;c[G+0>>2]=0;c[G+4>>2]=0;c[G+8>>2]=0;e:do if(c[d+(z*4260|0)+2416>>2]|0){A=d+(z*4260|0)+2392|0;B=c[A>>2]|0;if((B|0)==1){c[d+(z*4260|0)+2420>>2]=1;break;}C=(sc(j,c[24920+(B+-2<<2)>>2]|0,8)|0)+1|0;B=0;while(1){if((B|0)>=(c[A>>2]|0))break e;c[d+(z*4260|0)+(B<<2)+2420>>2]=C>>>B&1;B=B+1|0;}}while(0);E=c[h>>2]|0;z=z+1|0;}if(!g){z=d+2392|0;B=0;while(1){if((B|0)>=(c[z>>2]|0))break d;C=d+(B<<2)+6680|0;A=B+-1|0;D=0;while(1){if((D|0)>=(E|0))break;if(c[d+(D*4260|0)+(B<<2)+2420>>2]|0){if((E|0)==2&(D|0)==0?(Th(j,s),(c[C>>2]|0)==0):0)Uh(j,o);if((B|0)>0?(c[d+(D*4260|0)+(A<<2)+2420>>2]|0)!=0:0)E=2;else E=0;Gf(d+(D*4260|0)|0,j,B,1,E);Jf(j,y,a[d+(D*4260|0)+2765>>0]|0,a[d+(D*4260|0)+2766>>0]|0,c[d+(D*4260|0)+2328>>2]|0);E=c[h>>2]|0;}D=D+1|0;}B=B+1|0;}}}while(0);y=c[h>>2]|0;if((y|0)==2){if((g|0)==2){if((c[d+(c[v>>2]<<2)+2420>>2]|0)==1){Th(j,s);if(!(c[d+(c[v>>2]<<2)+6680>>2]|0))z=62;else z=63;}else{y=0;z=64;}}else if(!g){Th(j,s);if(!(c[d+(c[v>>2]<<2)+6664>>2]|0))z=62;else z=63;}else{y=0;z=64;}f:do if((z|0)==62)Uh(j,o);else if((z|0)==63)c[o>>2]=0;else if((z|0)==64)while(1){if((y|0)>=2)break f;c[s+(y<<2)>>2]=b[d+(y<<1)+8520>>1];y=y+1|0;z=64;}while(0);y=c[h>>2]|0;if((y|0)==2)if((c[o>>2]|0)==0?(c[d+8540>>2]|0)==1:0){wj(d+5544|0,0,1024)|0;c[d+6568>>2]=100;a[d+6572>>0]=10;c[d+8424>>2]=0;c[d+6636>>2]=1;y=c[h>>2]|0;}else y=2;}A=$(c[f+12>>2]|0,y)|0;A=(A|0)<($(c[w>>2]|0,c[f>>2]|0)|0);if(A){y=ta()|0;c[p>>2]=k;C=k+((c[d+2328>>2]|0)+2<<1)|0;c[p+4>>2]=C;B=k;}else{C=$(y,(c[d+2328>>2]|0)+2|0)|0;y=ta()|0;B=i;i=i+((2*C|0)+15&-16)|0;c[p>>2]=B;C=B+((c[d+2328>>2]|0)+2<<1)|0;c[p+4>>2]=C;}if(!g){z=d+8540|0;E=(c[o>>2]|0)==0&1;}else{z=d+8540|0;if(c[z>>2]|0){if((c[h>>2]|0)==2&(g|0)==2)D=(c[d+(c[d+6648>>2]<<2)+6680>>2]|0)==1;else D=0;}else D=1;E=D&1;}D=(g|0)==2;E=(E|0)==0;F=0;while(1){G=c[h>>2]|0;if((F|0)>=(G|0))break;if((F|0)==0|E^1){G=(c[v>>2]|0)-F|0;do if((G|0)<1)G=0;else{if(D){G=(c[d+(F*4260|0)+(G+-1<<2)+2420>>2]|0)!=0?2:0;break;}if((F|0)>0?(c[z>>2]|0)!=0:0){G=1;break;}G=2;}while(0);x=x+(Ff(d+(F*4260|0)|0,j,(c[p+(F<<2)>>2]|0)+4|0,t,g,G,m)|0)|0;}else wj((c[p+(F<<2)>>2]|0)+4|0,0,c[t>>2]<<1|0)|0;G=d+(F*4260|0)+2388|0;c[G>>2]=(c[G>>2]|0)+1;F=F+1|0;}if((c[f>>2]|0)==2&(G|0)==2){j=d+2316|0;g=c[t>>2]|0;Sh(d+8520|0,B,C,s,c[j>>2]|0,g);}else{j=d+8524|0;g=e[j>>1]|e[j+2>>1]<<16;b[B>>1]=g;b[B+2>>1]=g>>>16;g=c[t>>2]|0;G=B+(g<<1)|0;G=e[G>>1]|e[G+2>>1]<<16;b[j>>1]=G;b[j+2>>1]=G>>>16;j=d+2316|0;}s=$(g,c[w>>2]|0)|0;s=(s|0)/((c[j>>2]<<16>>16)*1e3|0)|0;c[l>>2]=s;t=c[f>>2]|0;if((t|0)==2){G=i;i=i+((2*s|0)+15&-16)|0;s=G;}else s=k;if(A){G=(c[d+2328>>2]|0)+2|0;F=$(c[h>>2]|0,G)|0;B=i;i=i+((2*F|0)+15&-16)|0;yj(B|0,k|0,F<<1|0)|0;c[p>>2]=B;c[p+4>>2]=B+(G<<1);}v=t;t=0;while(1){m=c[h>>2]|0;if((t|0)>=(((v|0)<(m|0)?v:m)|0))break;wh(d+(t*4260|0)+2432|0,s,(c[p+(t<<2)>>2]|0)+2|0,g);v=c[f>>2]|0;if((v|0)==2){m=0;while(1){if((m|0)>=(c[l>>2]|0))break;b[k+(t+(m<<1)<<1)>>1]=b[s+(m<<1)>>1]|0;m=m+1|0;}v=c[f>>2]|0;}t=t+1|0;}g:do if((v|0)==2&(m|0)==1){if(!r){p=0;while(1){if((p|0)>=(c[l>>2]|0))break g;G=p<<1;b[k+((G|1)<<1)>>1]=b[k+(G<<1)>>1]|0;p=p+1|0;}}wh(d+6692|0,s,B+2|0,g);p=0;while(1){if((p|0)>=(c[l>>2]|0))break g;b[k+((p<<1|1)<<1)>>1]=b[s+(p<<1)>>1]|0;p=p+1|0;}}while(0);if((c[d+4164>>2]|0)==2)c[f+20>>2]=$(c[d+2308>>2]|0,c[21248+((c[j>>2]|0)+-8>>2<<2)>>2]|0)|0;else c[f+20>>2]=0;h:do if(u){o=0;while(1){if((o|0)>=(c[q>>2]|0))break h;a[d+(o*4260|0)+2312>>0]=10;o=o+1|0;}}else c[z>>2]=c[o>>2];while(0);ja(y|0);G=x;i=n;return G|0;}function Bf(d,e,f,g,h){d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0;o=i;i=i+32|0;r=o;k=d+2336|0;n=c[k>>2]|0;j=i;i=i+((2*n|0)+15&-16)|0;t=d+2328|0;z=c[t>>2]|0;q=i;i=i+((4*(n+z|0)|0)+15&-16)|0;n=d+2332|0;m=c[n>>2]|0;p=i;i=i+((4*m|0)+15&-16)|0;l=i;i=i+((4*(m+16|0)|0)+15&-16)|0;m=d+2765|0;x=(a[d+2767>>0]|0)<4?1:0;v=b[24968+(a[m>>0]>>1<<2)+(a[d+2766>>0]<<1)>>1]<<4;w=a[d+2770>>0]|0;u=0;while(1){if((u|0)>=(z|0))break;w=($(w,196314165)|0)+907633515|0;y=g+(u<<1)|0;A=b[y>>1]|0;B=A<<16>>16<<14;z=d+(u<<2)+4|0;c[z>>2]=B;if(A<<16>>16<=0){if(A<<16>>16<0){B=B|1280;c[z>>2]=B;}}else{B=B+-1280|0;c[z>>2]=B;}da=B+v|0;c[z>>2]=(w|0)<0?0-da|0:da;z=c[t>>2]|0;w=w+(b[y>>1]|0)|0;u=u+1|0;}g=d+1284|0;T=l+0|0;U=g+0|0;S=T+64|0;do{c[T>>2]=c[U>>2];T=T+4|0;U=U+4|0;}while((T|0)<(S|0));t=d+2324|0;w=d+2340|0;v=d+4160|0;u=e+136|0;z=(x|0)==0;R=r+2|0;I=r+4|0;H=r+6|0;G=r+8|0;F=r+10|0;E=r+12|0;D=r+14|0;C=r+16|0;B=r+18|0;L=r+20|0;M=r+22|0;N=r+24|0;O=r+26|0;P=r+28|0;Q=r+30|0;y=d+4164|0;K=d+2308|0;x=d+4|0;J=f;V=c[k>>2]|0;A=0;while(1){if((A|0)>=(c[t>>2]|0))break;Z=e+(A>>1<<5)+32|0;yj(r|0,Z|0,c[w>>2]<<1|0)|0;W=A*5|0;U=e+(W<<1)+96|0;aa=a[m>>0]|0;X=aa<<24>>24;S=c[e+(A<<2)+16>>2]|0;T=S>>>6;Y=Cf(S)|0;_=c[d>>2]|0;a:do if((S|0)==(_|0))_=65536;else{_=Df(_,S)|0;ba=_>>16;ca=_&65535;da=0;while(1){if((da|0)>=16)break a;ea=l+(da<<2)|0;fa=c[ea>>2]|0;ga=fa<<16>>16;c[ea>>2]=($(ba,ga)|0)+(($(ca,ga)|0)>>16)+($(_,(fa>>15)+1>>1)|0);da=da+1|0;}}while(0);c[d>>2]=S;if((c[v>>2]|0)!=0?(((c[y>>2]|0)!=2|aa<<24>>24==2)^1)&(A|0)<2:0){b[U+0>>1]=0;b[U+2>>1]=0;b[U+4>>1]=0;b[U+6>>1]=0;b[U+8>>1]=0;b[e+(W+2<<1)+96>>1]=4096;c[e+(A<<2)>>2]=c[K>>2];s=18;}else if((X|0)==2)s=18;else U=x;b:do if((s|0)==18){s=0;X=c[e+(A<<2)>>2]|0;aa=(A|0)==0;c:do if(!aa){if(!((A|0)==2^1|z)){_=c[k>>2]|0;ba=_-X-(c[w>>2]|0)+-2|0;yj(d+(_<<1)+1348|0,f|0,c[n>>2]<<2|0)|0;_=c[k>>2]|0;ca=c[w>>2]|0;s=22;break;}if((_|0)!=65536){ba=X+2|0;Y=_>>16;aa=_&65535;Z=0;while(1){if((Z|0)>=(ba|0))break c;ga=q+(V-Z+-1<<2)|0;fa=c[ga>>2]|0;ea=fa<<16>>16;c[ga>>2]=($(Y,ea)|0)+(($(aa,ea)|0)>>16)+($(_,(fa>>15)+1>>1)|0);Z=Z+1|0;}}}else{_=c[k>>2]|0;ca=c[w>>2]|0;ba=_-X-ca+-2|0;s=22;}while(0);d:do if((s|0)==22){s=0;Sd(j+(ba<<1)|0,d+(ba+($(A,c[n>>2]|0)|0)<<1)+1348|0,Z,_-ba|0,ca,h);if(aa){ga=c[u>>2]<<16>>16;Y=($(Y>>16,ga)|0)+(($(Y&65535,ga)|0)>>16)<<2;}_=X+2|0;Z=Y>>16;Y=Y&65535;aa=0;while(1){if((aa|0)>=(_|0))break d;ga=b[j+((c[k>>2]|0)-aa+-1<<1)>>1]|0;c[q+(V-aa+-1<<2)>>2]=($(Z,ga)|0)+(($(Y,ga)|0)>>16);aa=aa+1|0;}}while(0);_=e+(W+1<<1)+96|0;Z=e+(W+2<<1)+96|0;Y=e+(W+3<<1)+96|0;aa=e+(W+4<<1)+96|0;W=c[n>>2]|0;X=q+(V-X+2<<2)|0;ba=0;while(1){if((ba|0)>=(W|0)){U=p;break b;}fa=c[X>>2]|0;ga=b[U>>1]|0;ga=($(fa>>16,ga)|0)+(($(fa&65535,ga)|0)>>16)+2|0;fa=c[X+-4>>2]|0;ea=b[_>>1]|0;ea=ga+(($(fa>>16,ea)|0)+(($(fa&65535,ea)|0)>>16))|0;fa=c[X+-8>>2]|0;ga=b[Z>>1]|0;ga=ea+(($(fa>>16,ga)|0)+(($(fa&65535,ga)|0)>>16))|0;fa=c[X+-12>>2]|0;ea=b[Y>>1]|0;ea=ga+(($(fa>>16,ea)|0)+(($(fa&65535,ea)|0)>>16))|0;fa=c[X+-16>>2]|0;ga=b[aa>>1]|0;ga=ea+(($(fa>>16,ga)|0)+(($(fa&65535,ga)|0)>>16))|0;ga=(c[x+(ba<<2)>>2]|0)+(ga<<1)|0;c[p+(ba<<2)>>2]=ga;c[q+(V<<2)>>2]=ga<<1;X=X+4|0;V=V+1|0;ba=ba+1|0;}}while(0);T=T<<16>>16;S=(S>>21)+1>>1;W=0;while(1){X=c[n>>2]|0;if((W|0)>=(X|0))break;ga=c[l+(W+15<<2)>>2]|0;fa=b[r>>1]|0;fa=(c[w>>2]>>1)+(($(ga>>16,fa)|0)+(($(ga&65535,fa)|0)>>16))|0;ga=c[l+(W+14<<2)>>2]|0;X=b[R>>1]|0;X=fa+(($(ga>>16,X)|0)+(($(ga&65535,X)|0)>>16))|0;ga=c[l+(W+13<<2)>>2]|0;fa=b[I>>1]|0;fa=X+(($(ga>>16,fa)|0)+(($(ga&65535,fa)|0)>>16))|0;ga=c[l+(W+12<<2)>>2]|0;X=b[H>>1]|0;X=fa+(($(ga>>16,X)|0)+(($(ga&65535,X)|0)>>16))|0;ga=c[l+(W+11<<2)>>2]|0;fa=b[G>>1]|0;fa=X+(($(ga>>16,fa)|0)+(($(ga&65535,fa)|0)>>16))|0;ga=c[l+(W+10<<2)>>2]|0;X=b[F>>1]|0;X=fa+(($(ga>>16,X)|0)+(($(ga&65535,X)|0)>>16))|0;ga=c[l+(W+9<<2)>>2]|0;fa=b[E>>1]|0;fa=X+(($(ga>>16,fa)|0)+(($(ga&65535,fa)|0)>>16))|0;ga=c[l+(W+8<<2)>>2]|0;X=b[D>>1]|0;X=fa+(($(ga>>16,X)|0)+(($(ga&65535,X)|0)>>16))|0;ga=c[l+(W+7<<2)>>2]|0;fa=b[C>>1]|0;fa=X+(($(ga>>16,fa)|0)+(($(ga&65535,fa)|0)>>16))|0;ga=c[l+(W+6<<2)>>2]|0;X=b[B>>1]|0;X=fa+(($(ga>>16,X)|0)+(($(ga&65535,X)|0)>>16))|0;if((c[w>>2]|0)==16){ga=c[l+(W+5<<2)>>2]|0;fa=b[L>>1]|0;fa=X+(($(ga>>16,fa)|0)+(($(ga&65535,fa)|0)>>16))|0;ga=c[l+(W+4<<2)>>2]|0;X=b[M>>1]|0;X=fa+(($(ga>>16,X)|0)+(($(ga&65535,X)|0)>>16))|0;ga=c[l+(W+3<<2)>>2]|0;fa=b[N>>1]|0;fa=X+(($(ga>>16,fa)|0)+(($(ga&65535,fa)|0)>>16))|0;ga=c[l+(W+2<<2)>>2]|0;X=b[O>>1]|0;X=fa+(($(ga>>16,X)|0)+(($(ga&65535,X)|0)>>16))|0;ga=c[l+(W+1<<2)>>2]|0;fa=b[P>>1]|0;fa=X+(($(ga>>16,fa)|0)+(($(ga&65535,fa)|0)>>16))|0;ga=c[l+(W<<2)>>2]|0;X=b[Q>>1]|0;X=fa+(($(ga>>16,X)|0)+(($(ga&65535,X)|0)>>16))|0;}X=(c[U+(W<<2)>>2]|0)+(X<<4)|0;c[l+(W+16<<2)>>2]=X;X=(($(X>>16,T)|0)+(($(X&65535,T)|0)>>16)+($(X,S)|0)>>7)+1>>1;if((X|0)>32767)X=32767;else X=(X|0)<-32768?-32768:X&65535;b[J+(W<<1)>>1]=X;W=W+1|0;}T=l+0|0;U=l+(X<<2)+0|0;S=T+64|0;do{c[T>>2]=c[U>>2];T=T+4|0;U=U+4|0;}while((T|0)<(S|0));x=x+(X<<2)|0;J=J+(X<<1)|0;A=A+1|0;}T=g+0|0;U=l+0|0;S=T+64|0;do{c[T>>2]=c[U>>2];T=T+4|0;U=U+4|0;}while((T|0)<(S|0));i=o;return;}function Cf(a){a=a|0;var b=0,c=0,d=0,e=0,f=0,g=0;b=i;d=Ef((a|0)>0?a:0-a|0)|0;c=a<<d+-1;g=c>>16;a=536870911/(g|0)|0;f=a<<16;e=f>>16;c=536870912-(($(g,e)|0)+(($(c&65535,e)|0)>>16))<<3;a=f+(($(c>>16,e)|0)+(($(c&65528,e)|0)>>16))+($(c,(a>>15)+1>>1)|0)|0;d=62-d|0;c=d+-47|0;if((c|0)>=1){i=b;return((c|0)<32?a>>c:0)|0;}c=47-d|0;d=-2147483648>>c;e=2147483647>>>c;if((d|0)>(e|0)){if((a|0)>(d|0)){g=d;g=g<<c;i=b;return g|0;}g=(a|0)<(e|0)?e:a;g=g<<c;i=b;return g|0;}else{if((a|0)>(e|0)){g=e;g=g<<c;i=b;return g|0;}g=(a|0)<(d|0)?d:a;g=g<<c;i=b;return g|0;}return 0;}function Df(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,f=0,g=0;c=i;e=Ef((a|0)>0?a:0-a|0)|0;g=a<<e+-1;d=(Ef((b|0)>0?b:0-b|0)|0)+-1|0;a=b<<d;b=(536870911/(a>>16|0)|0)<<16>>16;f=($(g>>16,b)|0)+(($(g&65535,b)|0)>>16)|0;a=Gj(a|0,((a|0)<0)<<31>>31|0,f|0,((f|0)<0)<<31>>31|0)|0;a=uj(a|0,D|0,29)|0;a=g-(a&-8)|0;b=f+(($(a>>16,b)|0)+(($(a&65535,b)|0)>>16))|0;d=e+28-d|0;a=d+-16|0;if((a|0)>=0){i=c;return((a|0)<32?b>>a:0)|0;}a=16-d|0;d=-2147483648>>a;e=2147483647>>>a;if((d|0)>(e|0)){if((b|0)>(d|0)){g=d;g=g<<a;i=c;return g|0;}g=(b|0)<(e|0)?e:b;g=g<<a;i=c;return g|0;}else{if((b|0)>(e|0)){g=e;g=g<<a;i=c;return g|0;}g=(b|0)<(d|0)?d:b;g=g<<a;i=c;return g|0;}return 0;}function Ef(a){a=a|0;var b=0;b=i;if(!a)a=32;else a=vj(a|0)|0;i=b;return a|0;}function Ff(b,d,e,f,g,h,j){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0;n=i;i=i+144|0;l=n;m=b+2328|0;k=c[m>>2]|0;c[l+136>>2]=0;if(!g){o=b+2388|0;p=4;}else if((g|0)==2?(o=b+2388|0,(c[b+(c[o>>2]<<2)+2420>>2]|0)==1):0)p=4;else p=5;if((p|0)==4){p=ta()|0;q=i;i=i+((2*(k+15&-16)|0)+15&-16)|0;Gf(b,d,c[o>>2]|0,g,h);o=b+2765|0;Jf(d,q,a[o>>0]|0,a[b+2766>>0]|0,c[m>>2]|0);Hf(b,l,h);Bf(b,l,e,q,j);He(b,l,e,0,j);c[b+4160>>2]=0;c[b+4164>>2]=a[o>>0];c[b+2376>>2]=0;ja(p|0);}else if((p|0)==5)He(b,l,e,1,j);p=c[m>>2]|0;q=(c[b+2336>>2]|0)-p|0;zj(b+1348|0,b+(p<<1)+1348|0,q<<1|0)|0;yj(b+(q<<1)+1348|0,e|0,c[m>>2]<<1|0)|0;Ld(b,l,e,k);Ke(b,e,k);c[b+2308>>2]=c[l+((c[b+2324>>2]|0)+-1<<2)>>2];c[f>>2]=k;i=n;return 0;}function Gf(f,g,h,j,k){f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;l=i;i=i+48|0;m=l;p=l+32|0;if((j|0)==0?(c[f+(h<<2)+2404>>2]|0)==0:0)o=sc(g,24952,8)|0;else o=(sc(g,24944,8)|0)+2|0;h=o>>>1;j=f+2765|0;a[j>>0]=h;a[f+2766>>0]=o&1;o=(k|0)==2;if(o)a[f+2736>>0]=sc(g,24672,8)|0;else{r=f+2736|0;a[r>>0]=(sc(g,24648+(h<<24>>24<<3)|0,8)|0)<<3;q=sc(g,25016,8)|0;a[r>>0]=(d[r>>0]|0)+q;}h=f+2324|0;q=1;while(1){if((q|0)>=(c[h>>2]|0))break;a[f+q+2736>>0]=sc(g,24672,8)|0;q=q+1|0;}q=f+2732|0;s=c[q>>2]|0;r=$(a[j>>0]>>1,b[s>>1]|0)|0;r=sc(g,(c[s+12>>2]|0)+r|0,8)|0;a[f+2744>>0]=r;se(m,p,c[q>>2]|0,r<<24>>24);p=0;while(1){r=c[q>>2]|0;if((p|0)>=(b[r+2>>1]|0))break;r=sc(g,(c[r+24>>2]|0)+(b[m+(p<<1)>>1]|0)|0,8)|0;if(!r)r=0-(sc(g,25024,8)|0)|0;else if((r|0)==8)r=(sc(g,25024,8)|0)+8|0;s=p+1|0;a[f+s+2744>>0]=r+252;p=s;}if((c[h>>2]|0)==4)a[f+2767>>0]=sc(g,24960,8)|0;else a[f+2767>>0]=4;if((a[j>>0]|0)!=2){s=a[j>>0]|0;s=s<<24>>24;r=f+2396|0;c[r>>2]=s;r=sc(g,24992,8)|0;r=r&255;s=f+2770|0;a[s>>0]=r;i=l;return;}if((o?(c[f+2396>>2]|0)==2:0)?(n=sc(g,25168,8)|0,(n&65535)<<16>>16>0):0){m=(e[f+2400>>1]|0)+(n+65527)&65535;b[f+2762>>1]=m;}else{m=(sc(g,25136,8)|0)<<16>>16;s=f+2762|0;b[s>>1]=$(m,c[f+2316>>2]>>1)|0;m=sc(g,c[f+2380>>2]|0,8)|0;m=(e[s>>1]|0)+m&65535;b[s>>1]=m;}b[f+2400>>1]=m;a[f+2764>>0]=sc(g,c[f+2384>>2]|0,8)|0;m=f+2768|0;a[m>>0]=sc(g,22256,8)|0;n=0;while(1){if((n|0)>=(c[h>>2]|0))break;a[f+n+2740>>0]=sc(g,c[22320+(a[m>>0]<<2)>>2]|0,8)|0;n=n+1|0;}if(!k){a[f+2769>>0]=sc(g,24936,8)|0;s=a[j>>0]|0;s=s<<24>>24;r=f+2396|0;c[r>>2]=s;r=sc(g,24992,8)|0;r=r&255;s=f+2770|0;a[s>>0]=r;i=l;return;}else{a[f+2769>>0]=0;s=a[j>>0]|0;s=s<<24>>24;r=f+2396|0;c[r>>2]=s;r=sc(g,24992,8)|0;r=r&255;s=f+2770|0;a[s>>0]=r;i=l;return;}}function Hf(d,e,f){d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;g=i;i=i+64|0;j=g+32|0;l=g;h=d+2324|0;hh(e+16|0,d+2736|0,d+2312|0,(f|0)==2&1,c[h>>2]|0);de(j,d+2744|0,c[d+2732>>2]|0);f=e+64|0;k=d+2340|0;Zd(f,j,c[k>>2]|0);n=d+2767|0;if((c[d+2376>>2]|0)!=1){o=a[n>>0]|0;if(o<<24>>24<4){p=c[k>>2]|0;n=0;while(1){if((n|0)>=(p|0))break;q=b[d+(n<<1)+2344>>1]|0;b[l+(n<<1)>>1]=(q&65535)+(($(o<<24>>24,(b[j+(n<<1)>>1]|0)-(q<<16>>16)|0)|0)>>>2);n=n+1|0;}Zd(e+32|0,l,p);}else m=8;}else{a[n>>0]=4;m=8;}if((m|0)==8)yj(e+32|0,e+64|0,c[k>>2]<<1|0)|0;l=c[k>>2]|0;yj(d+2344|0,j|0,l<<1|0)|0;if(c[d+4160>>2]|0){hf(e+32|0,l,63570);hf(f,c[k>>2]|0,63570);}if((a[d+2765>>0]|0)!=2){wj(e|0,0,c[h>>2]<<2|0)|0;wj(e+96|0,0,(c[h>>2]|0)*10|0)|0;a[d+2768>>0]=0;c[e+136>>2]=0;i=g;return;}If(b[d+2762>>1]|0,a[d+2764>>0]|0,e,c[d+2316>>2]|0,c[h>>2]|0);l=c[22688+(a[d+2768>>0]<<2)>>2]|0;k=0;while(1){if((k|0)>=(c[h>>2]|0))break;m=(a[d+k+2740>>0]|0)*5|0;f=k*5|0;j=0;while(1){if((j|0)>=5)break;b[e+(f+j<<1)+96>>1]=a[l+(m+j)>>0]<<7;j=j+1|0;}k=k+1|0;}c[e+136>>2]=b[24976+(a[d+2769>>0]<<1)>>1];i=g;return;}function If(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;h=i;k=(g|0)==4;if((f|0)==8){j=k?11:3;k=k?21304:21264;}else{j=k?34:12;k=k?21352:21272;}l=f<<16;f=l>>15;l=(l>>16)*18|0;b=f+(b<<16>>16)|0;d=d<<24>>24;o=(f|0)>(l|0);n=0;while(1){if((n|0)>=(g|0))break;p=b+(a[k+(($(n,j)|0)+d)>>0]|0)|0;m=e+(n<<2)|0;c[m>>2]=p;if(o){if((p|0)>(f|0))p=f;else p=(p|0)<(l|0)?l:p;}else if((p|0)>(l|0))p=l;else p=(p|0)<(f|0)?f:p;c[m>>2]=p;n=n+1|0;}i=h;return;}function Jf(a,d,e,f,g){a=a|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;h=i;i=i+160|0;l=h+80|0;j=h;o=sc(a,25624+((e>>1)*9|0)|0,8)|0;k=g>>4;k=(k<<4|0)<(g|0)?k+1|0:k;o=25272+(o*18|0)|0;p=0;while(1){if((p|0)>=(k|0)){m=0;break;}r=j+(p<<2)|0;c[r>>2]=0;q=l+(p<<2)|0;m=0;n=sc(a,o,8)|0;while(1){c[q>>2]=n;if((n|0)!=17)break;n=m+1|0;c[r>>2]=n;m=n;n=sc(a,25434+((n|0)==10&1)|0,8)|0;}p=p+1|0;}while(1){if((m|0)>=(k|0)){s=0;break;}n=c[l+(m<<2)>>2]|0;o=d+(m<<16>>12<<1)|0;if((n|0)>0)Jh(o,a,n);else{n=o+0|0;o=n+32|0;do{b[n>>1]=0;n=n+2|0;}while((n|0)<(o|0));}m=m+1|0;}while(1){if((s|0)>=(k|0))break;r=c[j+(s<<2)>>2]|0;if((r|0)>0){p=s<<16>>12;o=0;while(1){if((o|0)>=16)break;q=d+(p+o<<1)|0;m=b[q>>1]|0;n=0;while(1){if((n|0)>=(r|0))break;m=(m<<1)+(sc(a,24928,8)|0)|0;n=n+1|0;}b[q>>1]=m;o=o+1|0;}q=l+(s<<2)|0;c[q>>2]=c[q>>2]|r<<5;}s=s+1|0;}mf(a,d,g,e,f,l);i=h;return;}function Kf(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0;j=i;f=d<<16>>16;c[b+2332>>2]=f*5;l=b+2324|0;h=$(c[l>>2]<<16>>16,f*327680>>16)|0;g=b+2316|0;n=b+2320|0;if((c[g>>2]|0)==(d|0)?(c[n>>2]|0)==(e|0):0){e=1;m=0;k=4;}else k=3;if((k|0)==3){m=vh(b+2432|0,f*1e3|0,e,0)|0;c[n>>2]=e;e=(c[g>>2]|0)==(d|0);if(e)k=4;}if((k|0)==4)if((h|0)==(c[b+2328>>2]|0)){o=m;i=j;return o|0;}n=(d|0)==8;l=(c[l>>2]|0)==4;o=b+2384|0;do if(n){if(l){c[o>>2]=25232;break;}else{c[o>>2]=25264;break;}}else if(l){c[o>>2]=25192;break;}else{c[o>>2]=25248;break;}while(0);if(!e){c[b+2336>>2]=f*20;if((d|0)==8|(d|0)==12){c[b+2340>>2]=10;c[b+2732>>2]=23520;if((d|0)==12)c[b+2380>>2]=25008;else k=18;}else{c[b+2340>>2]=16;c[b+2732>>2]=24608;if((d|0)==16)c[b+2380>>2]=25016;else k=18;}if((k|0)==18?n:0)c[b+2380>>2]=24992;c[b+2376>>2]=1;c[b+2308>>2]=100;a[b+2312>>0]=10;c[b+4164>>2]=0;wj(b+1284|0,0,1024)|0;}c[g>>2]=d;c[b+2328>>2]=h;o=m;i=j;return o|0;}function Lf(a){a=a|0;c[a>>2]=24564;return 0;}function Mf(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;f=i;wj(a|0,0,24564)|0;e=0;g=0;while(1){if((g|0)>=2)break;e=e+(lh(a+(g*12240|0)|0,b)|0)|0;g=g+1|0;}c[a+24540>>2]=1;c[a+24544>>2]=1;b=e+(Nf(a,d)|0)|0;i=f;return b|0;}function Nf(a,b){a=a|0;b=b|0;var d=0,e=0;d=i;c[b>>2]=c[a+24540>>2];c[b+4>>2]=c[a+24544>>2];c[b+8>>2]=c[a+4580>>2];c[b+12>>2]=c[a+4588>>2];c[b+16>>2]=c[a+4592>>2];c[b+20>>2]=c[a+4596>>2];c[b+24>>2]=c[a+4636>>2];c[b+28>>2]=c[a+4632>>2];c[b+32>>2]=c[a+4640>>2];c[b+36>>2]=c[a+4648>>2];c[b+40>>2]=c[a+6120>>2];c[b+44>>2]=c[a+6108>>2];c[b+48>>2]=c[a+4708>>2];e=a+4600|0;c[b+68>>2]=(c[e>>2]<<16>>16)*1e3;c[b+72>>2]=c[a+4560>>2];if((c[e>>2]|0)!=16){a=0;a=a&1;e=b+76|0;c[e>>2]=a;i=d;return 0;}a=(c[a+28>>2]|0)==0;a=a&1;e=b+76|0;c[e>>2]=a;i=d;return 0;}function Of(d,f,g,h,j,k,l){d=d|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;var m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ka=0,la=0,ma=0,na=0,oa=0,pa=0,qa=0,ra=0,sa=0,ua=0,va=0,wa=0,xa=0,ya=0,za=0,Aa=0,Ba=0,Ca=0,Da=0,Ea=0,Fa=0;m=i;i=i+16|0;s=m;t=m+8|0;if(c[f+64>>2]|0){c[d+4696>>2]=1;c[d+16936>>2]=1;}c[d+18020>>2]=0;r=d+5780|0;c[r>>2]=0;n=kf(f)|0;if(n){Fa=n;i=m;return Fa|0;}c[f+84>>2]=0;n=f+4|0;u=d+24544|0;if((c[n>>2]|0)>(c[u>>2]|0)){va=lh(d+12240|0,c[d+5124>>2]|0)|0;Fa=d+24480|0;b[Fa>>1]=0;b[Fa+2>>1]=0>>>16;Fa=d+24488|0;b[Fa>>1]=0;b[Fa+2>>1]=0>>>16;c[d+24492>>2]=0;c[d+24496>>2]=1;c[d+24500>>2]=0;c[d+24504>>2]=1;b[d+24510>>1]=0;b[d+24508>>1]=16384;if((c[d+24540>>2]|0)==2){yj(d+18048|0,d+5808|0,300)|0;Da=d;Ea=c[Da+4>>2]|0;Fa=d+12240|0;c[Fa>>2]=c[Da>>2];c[Fa+4>>2]=Ea;}}else va=0;p=f+24|0;if((c[p>>2]|0)==(c[d+4636>>2]|0))B=(c[u>>2]|0)!=(c[n>>2]|0);else B=1;c[d+24540>>2]=c[f>>2];c[u>>2]=c[n>>2];w=h*100|0;v=c[f+8>>2]|0;C=(w|0)/(v|0)|0;u=(C|0)>1?C>>1:1;l=(l|0)==0;a:do if(l){if(($(C,v)|0)!=(w|0)|(h|0)<0){Fa=-101;i=m;return Fa|0;}if((h*1e3|0)>($(c[p>>2]|0,v)|0)){Fa=-101;i=m;return Fa|0;}else{E=c[n>>2]|0;v=0;w=0;break;}}else{if((C|0)==1)v=0;else{Fa=-101;i=m;return Fa|0;}while(1){E=c[n>>2]|0;if((v|0)>=(E|0))break;va=lh(d+(v*12240|0)|0,c[d+(v*12240|0)+5124>>2]|0)|0;v=v+1|0;}w=c[p>>2]|0;c[p>>2]=10;x=f+36|0;v=c[x>>2]|0;c[x>>2]=0;x=0;while(1){if((x|0)>=(E|0))break a;c[d+(x*12240|0)+4700>>2]=0;c[d+(x*12240|0)+4712>>2]=1;E=c[n>>2]|0;x=x+1|0;}}while(0);y=f+28|0;D=c[y>>2]>>E+-1;x=d+4600|0;A=d+24556|0;z=d+5776|0;F=E;E=0;while(1){if((E|0)>=(F|0))break;if((E|0)==1)F=c[x>>2]|0;else F=0;F=pf(d+(E*12240|0)|0,f,D,c[A>>2]|0,E,F)|0;if(F){o=146;break;}b:do if((c[d+(E*12240|0)+4696>>2]|0)==0^1|B){F=0;while(1){if((F|0)>=(c[z>>2]|0))break b;c[d+(E*12240|0)+(F<<2)+4756>>2]=0;F=F+1|0;}}while(0);c[d+(E*12240|0)+6112>>2]=c[d+(E*12240|0)+6108>>2];F=c[n>>2]|0;va=0;E=E+1|0;}if((o|0)==146){i=m;return F|0;}ea=C*10|0;O=c[x>>2]|0;E=$(ea,O)|0;ca=d+4580|0;O=($(E,c[ca>>2]|0)|0)/(O*1e3|0)|0;B=ta()|0;da=i;i=i+((2*O|0)+15&-16)|0;O=d+4608|0;J=d+5772|0;D=d+24548|0;G=d+18048|0;I=d+5808|0;H=d+16848|0;P=d+18012|0;K=d+16840|0;L=j+20|0;F=j+28|0;ga=d+24536|0;S=d+24480|0;R=d+5132|0;Q=d+17372|0;ka=d+4556|0;C=f+56|0;na=d+24560|0;Y=d+19440|0;Z=d+12384|0;_=d+12256|0;X=d+16808|0;W=d+16740|0;V=d+16805|0;U=d+16756|0;T=d+16936|0;aa=d+12240|0;qa=f+52|0;ma=(u|0)==2;pa=f+48|0;fa=s+4|0;oa=u<<1;ba=u+-1|0;la=d+6112|0;ia=d+24552|0;ha=d+18352|0;M=d+5128|0;N=d+24484|0;ra=0;while(1){wa=c[J>>2]|0;ua=(c[O>>2]|0)-wa|0;ua=(ua|0)<(E|0)?ua:E;sa=$(ua,c[ca>>2]|0)|0;sa=(sa|0)/((c[x>>2]|0)*1e3|0)|0;do if((c[f>>2]|0)==2){if((c[n>>2]|0)==2){ya=c[r>>2]|0;xa=0;while(1){if((xa|0)>=(sa|0))break;b[da+(xa<<1)>>1]=b[g+(xa<<1<<1)>>1]|0;xa=xa+1|0;}if((c[D>>2]|0)==1&(ya|0)==0)yj(G|0,I|0,300)|0;wh(I,d+(wa+2<<1)+5128|0,da,sa);c[J>>2]=(c[J>>2]|0)+ua;xa=c[P>>2]|0;wa=(c[H>>2]|0)-xa|0;ua=$(ea,c[K>>2]|0)|0;ua=(wa|0)<(ua|0)?wa:ua;wa=0;while(1){if((wa|0)>=(sa|0))break;b[da+(wa<<1)>>1]=b[g+((wa<<1|1)<<1)>>1]|0;wa=wa+1|0;}wh(G,d+(xa+2<<1)+17368|0,da,sa);c[P>>2]=(c[P>>2]|0)+ua;wa=c[J>>2]|0;break;}else{if((c[n>>2]|0)==1)xa=0;else{o=49;break;}while(1){if((xa|0)>=(sa|0))break;Fa=xa<<1;Fa=(b[g+(Fa<<1)>>1]|0)+(b[g+((Fa|1)<<1)>>1]|0)|0;b[da+(xa<<1)>>1]=(Fa>>>1)+(Fa&1);xa=xa+1|0;}wh(I,d+(wa+2<<1)+5128|0,da,sa);c:do if((c[D>>2]|0)==2?(c[r>>2]|0)==0:0){wh(G,d+((c[P>>2]|0)+2<<1)+17368|0,da,sa);wa=0;while(1){if((wa|0)>=(c[O>>2]|0))break c;Fa=d+((c[J>>2]|0)+wa+2<<1)+5128|0;b[Fa>>1]=((b[Fa>>1]|0)+(b[d+((c[P>>2]|0)+wa+2<<1)+17368>>1]|0)|0)>>>1;wa=wa+1|0;}}while(0);wa=(c[J>>2]|0)+ua|0;c[J>>2]=wa;break;}}else o=49;while(0);if((o|0)==49){o=0;yj(da|0,g|0,sa<<1|0)|0;wh(I,d+(wa+2<<1)+5128|0,da,sa);wa=(c[J>>2]|0)+ua|0;c[J>>2]=wa;}g=g+(($(sa,c[f>>2]|0)|0)<<1)|0;ua=h-sa|0;c[A>>2]=0;if((wa|0)<(c[O>>2]|0)){q=0;break;}d:do if(!((c[r>>2]|0)==0^1|l^1)){b[t>>1]=0;a[t>>0]=256-(256>>>($((c[z>>2]|0)+1|0,c[n>>2]|0)|0));Cc(j,0,t,8);wa=0;while(1){Ca=c[n>>2]|0;if((wa|0)>=(Ca|0)){wa=0;break;}za=c[d+(wa*12240|0)+5776>>2]|0;ya=0;xa=0;while(1){if((xa|0)>=(za|0))break;ya=ya|c[d+(wa*12240|0)+(xa<<2)+4756>>2]<<xa;xa=xa+1|0;}a[d+(wa*12240|0)+4755>>0]=(ya|0)>0&1;if((ya|0)!=0&(za|0)>1)Cc(j,ya+-1|0,c[24920+(za+-2<<2)>>2]|0,8);wa=wa+1|0;}while(1){if((wa|0)>=(c[z>>2]|0)){wa=0;break;}xa=d+(wa*6|0)+24514|0;Aa=d+(wa<<2)+16996|0;za=d+wa+24532|0;ya=wa+-1|0;Ba=0;while(1){if((Ba|0)>=(Ca|0))break;if(c[d+(Ba*12240|0)+(wa<<2)+4756>>2]|0){if((Ca|0)==2&(Ba|0)==0?(Vh(j,xa),(c[Aa>>2]|0)==0):0)Wh(j,a[za>>0]|0);if((wa|0)>0?(c[d+(Ba*12240|0)+(ya<<2)+4756>>2]|0)!=0:0)Ca=2;else Ca=0;Qf(d+(Ba*12240|0)|0,j,wa,1,Ca);Rf(j,a[d+(Ba*12240|0)+(wa*36|0)+6161>>0]|0,a[d+(Ba*12240|0)+(wa*36|0)+6162>>0]|0,d+(Ba*12240|0)+(wa*320|0)+6240|0,c[d+(Ba*12240|0)+4608>>2]|0);Ca=c[n>>2]|0;}Ba=Ba+1|0;}wa=wa+1|0;}while(1){if((wa|0)>=(Ca|0))break d;Ca=d+(wa*12240|0)+4756|0;c[Ca+0>>2]=0;c[Ca+4>>2]=0;c[Ca+8>>2]=0;Ca=c[n>>2]|0;wa=wa+1|0;}}while(0);Rd(d);wa=c[y>>2]|0;ya=c[p>>2]|0;za=($(wa,ya)|0)/1e3|0;if(l)za=za-((Pf(c[L>>2]|0,c[F>>2]|0)|0)>>1)|0;xa=c[r>>2]|0;za=((za|0)/((c[z>>2]|0)-xa|0)|0)<<16>>16;if((ya|0)==10)ya=za*100|0;else ya=za*50|0;ya=ya-(((c[ga>>2]|0)*1e3|0)/500|0)|0;if((wa|0)>5e3){if((ya|0)<=(wa|0))wa=(ya|0)<5e3?5e3:ya;}else if((ya|0)>5e3)wa=5e3;else wa=(ya|0)<(wa|0)?wa:ya;if((c[n>>2]|0)==2){Oh(S,R,Q,d+(xa*6|0)+24514|0,d+xa+24532|0,s,wa,c[ka>>2]|0,c[C>>2]|0,c[x>>2]|0,c[O>>2]|0);xa=c[r>>2]|0;if(!(a[d+xa+24532>>0]|0)){if((c[na>>2]|0)==1){Fa=_;c[Fa>>2]=0;c[Fa+4>>2]=0;wj(Z|0,0,4412)|0;wj(Y|0,0,2156)|0;c[X>>2]=100;c[W>>2]=100;a[Y>>0]=10;a[V>>0]=0;c[U>>2]=65536;c[T>>2]=1;}gg(aa);}else a[d+xa+16992>>0]=0;if(l?(Vh(j,d+((c[r>>2]|0)*6|0)+24514|0),q=c[r>>2]|0,(a[d+q+16992>>0]|0)==0):0)Wh(j,a[d+q+24532>>0]|0);}else{Fa=e[N>>1]|e[N+2>>1]<<16;b[M>>1]=Fa;b[M+2>>1]=Fa>>>16;Fa=d+(c[O>>2]<<1)+5128|0;Fa=e[Fa>>1]|e[Fa+2>>1]<<16;b[N>>1]=Fa;b[N+2>>1]=Fa>>>16;}gg(d);za=(ra|0)==0;ya=(c[fa>>2]|0)>0;xa=(ra|0)==(ba|0);Aa=(ra|0)==1;Ba=0;while(1){Ea=c[n>>2]|0;if((Ba|0)>=(Ea|0))break;Da=c[qa>>2]|0;do if(ma){if(za)Fa=(Da*3|0)/5|0;else Fa=Da;}else if((u|0)==3){if(za){Fa=(Da<<1|0)/5|0;break;}if(Aa)Fa=(Da*3|0)/4|0;else Fa=Da;}else Fa=Da;while(0);Ca=((c[pa>>2]|0)==0?0:xa)&1;if((Ea|0)!=1){Ea=c[s+(Ba<<2)>>2]|0;if(!((Ba|0)==0^1|ya^1)){Fa=Fa-((Da|0)/(oa|0)|0)|0;Ca=0;}}else Ea=wa;if((Ea|0)>0){nf(d+(Ba*12240|0)|0,Ea);do if(((c[r>>2]|0)-Ba|0)<1)va=0;else{if((Ba|0)>0?(c[na>>2]|0)!=0:0){va=1;break;}va=2;}while(0);va=hg(d+(Ba*12240|0)|0,k,j,va,Fa,Ca)|0;}c[d+(Ba*12240|0)+4700>>2]=0;c[d+(Ba*12240|0)+5772>>2]=0;Fa=d+(Ba*12240|0)+5780|0;c[Fa>>2]=(c[Fa>>2]|0)+1;Ba=Ba+1|0;}xa=c[r>>2]|0;c[na>>2]=a[d+(xa+-1)+24532>>0];do if((c[k>>2]|0)>0?(xa|0)==(c[z>>2]|0):0){wa=c[n>>2]|0;Ba=0;ya=0;while(1){if((ya|0)>=(wa|0))break;za=c[d+(ya*12240|0)+5776>>2]|0;Aa=0;while(1){Ba=Ba<<1;if((Aa|0)>=(za|0))break;Ba=Ba|a[d+(ya*12240|0)+Aa+4752>>0];Aa=Aa+1|0;}Ba=Ba|a[d+(ya*12240|0)+4755>>0];ya=ya+1|0;}if(l)Gc(j,Ba,$(xa+1|0,wa)|0);do if(c[la>>2]|0){if((c[n>>2]|0)!=1?(c[ha>>2]|0)==0:0)break;c[k>>2]=0;}while(0);wa=(c[ga>>2]|0)+(c[k>>2]<<3)|0;c[ga>>2]=wa;wa=wa-(($(c[y>>2]|0,c[p>>2]|0)|0)/1e3|0)|0;c[ga>>2]=wa;if((wa|0)>1e4)wa=1e4;else wa=(wa|0)<0?0:wa;c[ga>>2]=wa;wa=c[ia>>2]|0;if((c[ka>>2]|0)<(((wa<<16>>16)*3188>>16)+13|0)){c[A>>2]=1;c[ia>>2]=0;break;}else{c[A>>2]=0;c[ia>>2]=wa+(c[p>>2]|0);break;}}while(0);if((h|0)==(sa|0)){o=135;break;}h=ua;ra=ra+1|0;}if((o|0)==135)q=c[A>>2]|0;c[D>>2]=c[n>>2];c[f+72>>2]=q;if((c[x>>2]|0)==16)o=(c[d+28>>2]|0)==0;else o=0;c[f+76>>2]=o&1;c[f+68>>2]=(c[x>>2]<<16>>16)*1e3;if(!(c[C>>2]|0))o=b[d+24508>>1]|0;else o=0;c[f+80>>2]=o;e:do if(!l){c[p>>2]=w;c[f+36>>2]=v;f=0;while(1){if((f|0)>=(c[n>>2]|0))break e;c[d+(f*12240|0)+4700>>2]=0;c[d+(f*12240|0)+4712>>2]=0;f=f+1|0;}}while(0);ja(B|0);Fa=va;i=m;return Fa|0;}function Pf(a,b){a=a|0;b=b|0;var c=0;c=i;b=(vj(b|0)|0)+-32+a|0;i=c;return b|0;}function Qf(e,f,g,h,j){e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;k=i;i=i+48|0;m=k;p=k+32|0;n=(h|0)==0;if(n)h=e+4768|0;else h=e+(g*36|0)+6132|0;g=h+29|0;o=(a[g>>0]<<1)+(a[h+30>>0]|0)|0;if(n^1|(o|0)>1)Cc(f,o+-2|0,24944,8);else Cc(f,o,24952,8);o=(j|0)==2;n=a[h>>0]|0;if(o)Cc(f,n,24672,8);else{Cc(f,n>>3,24648+(a[g>>0]<<3)|0,8);Cc(f,d[h>>0]&7,25016,8);}n=e+4604|0;q=1;while(1){if((q|0)>=(c[n>>2]|0))break;Cc(f,a[h+q>>0]|0,24672,8);q=q+1|0;}s=h+8|0;q=e+4724|0;t=c[q>>2]|0;u=$(a[g>>0]>>1,b[t>>1]|0)|0;Cc(f,a[s>>0]|0,(c[t+12>>2]|0)+u|0,8);se(m,p,c[q>>2]|0,a[s>>0]|0);s=0;while(1){t=c[q>>2]|0;if((s|0)>=(b[t+2>>1]|0))break;r=s+1|0;p=h+r+8|0;u=a[p>>0]|0;if(u<<24>>24>3){Cc(f,8,(c[t+24>>2]|0)+(b[m+(s<<1)>>1]|0)|0,8);Cc(f,(a[p>>0]|0)+-4|0,25024,8);s=r;continue;}if(u<<24>>24<-3){Cc(f,0,(c[t+24>>2]|0)+(b[m+(s<<1)>>1]|0)|0,8);Cc(f,-4-(a[p>>0]|0)|0,25024,8);s=r;continue;}else{Cc(f,(u<<24>>24)+4|0,(c[t+24>>2]|0)+(b[m+(s<<1)>>1]|0)|0,8);s=r;continue;}}if((c[n>>2]|0)==4)Cc(f,a[h+31>>0]|0,24960,8);if((a[g>>0]|0)!=2){t=a[g>>0]|0;t=t<<24>>24;u=e+5800|0;c[u>>2]=t;u=h+34|0;u=a[u>>0]|0;u=u<<24>>24;Cc(f,u,24992,8);i=k;return;}do if(o?(c[e+5800>>2]|0)==2:0){m=(b[h+26>>1]|0)-(b[e+5804>>1]|0)|0;if((m|0)<-8|(m|0)>11){Cc(f,0,25168,8);l=28;break;}else{Cc(f,m+9|0,25168,8);m=h+26|0;break;}}else l=28;while(0);if((l|0)==28){m=h+26|0;s=b[m>>1]|0;u=c[e+4600>>2]|0;t=(s|0)/(u>>1|0)|0;u=s-($(t<<16>>16,u<<15>>16)|0)|0;Cc(f,t,25136,8);Cc(f,u,c[e+4716>>2]|0,8);}b[e+5804>>1]=b[m>>1]|0;Cc(f,a[h+28>>0]|0,c[e+4720>>2]|0,8);l=h+32|0;Cc(f,a[l>>0]|0,22256,8);m=0;while(1){if((m|0)>=(c[n>>2]|0))break;Cc(f,a[h+m+4>>0]|0,c[22320+(a[l>>0]<<2)>>2]|0,8);m=m+1|0;}if(j){t=a[g>>0]|0;t=t<<24>>24;u=e+5800|0;c[u>>2]=t;u=h+34|0;u=a[u>>0]|0;u=u<<24>>24;Cc(f,u,24992,8);i=k;return;}Cc(f,a[h+33>>0]|0,24936,8);t=a[g>>0]|0;t=t<<24>>24;u=e+5800|0;c[u>>2]=t;u=h+34|0;u=a[u>>0]|0;u=u<<24>>24;Cc(f,u,24992,8);i=k;return;}function Rf(b,e,f,g,h){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;j=i;i=i+32|0;o=j;c[o+0>>2]=0;c[o+4>>2]=0;c[o+8>>2]=0;c[o+12>>2]=0;c[o+16>>2]=0;c[o+20>>2]=0;c[o+24>>2]=0;c[o+28>>2]=0;k=h>>4;if((k<<4|0)<(h|0)){k=k+1|0;m=g+h+0|0;l=m+16|0;do{a[m>>0]=0;m=m+1|0;}while((m|0)<(l|0));}l=k<<4;n=i;i=i+((4*l|0)+15&-16)|0;m=0;while(1){if((m|0)>=(l|0))break;t=a[g+m>>0]|0;v=t<<24>>24;c[n+(m<<2)>>2]=t<<24>>24>0?v:0-v|0;v=m|1;t=a[g+v>>0]|0;u=t<<24>>24;c[n+(v<<2)>>2]=t<<24>>24>0?u:0-u|0;v=m|2;u=a[g+v>>0]|0;t=u<<24>>24;c[n+(v<<2)>>2]=u<<24>>24>0?t:0-t|0;v=m|3;t=a[g+v>>0]|0;u=t<<24>>24;c[n+(v<<2)>>2]=t<<24>>24>0?u:0-u|0;m=m+4|0;}l=i;i=i+((4*k|0)+15&-16)|0;m=i;i=i+((4*k|0)+15&-16)|0;t=n;p=0;while(1){if((p|0)>=(k|0))break;q=m+(p<<2)|0;c[q>>2]=0;r=l+(p<<2)|0;a:while(1){v=Sf(o,t,8,8)|0;v=v+(Sf(o,o,10,4)|0)|0;v=v+(Sf(o,o,12,2)|0)|0;if((v|0)==(0-(Sf(r,o,16,1)|0)|0))break;c[q>>2]=(c[q>>2]|0)+1;s=0;while(1){if((s|0)>=16)continue a;v=t+(s<<2)|0;c[v>>2]=c[v>>2]>>1;s=s+1|0;}}t=t+64|0;p=p+1|0;}u=e>>1;v=0;o=2147483647;q=0;while(1){if((q|0)>=9)break;s=25473+(q*18|0)|0;r=0;t=d[25648+(u*9|0)+q>>0]|0;while(1){if((r|0)>=(k|0))break;if((c[m+(r<<2)>>2]|0)>0)p=a[s>>0]|0;else p=a[(c[l+(r<<2)>>2]|0)+(25456+(q*18|0))>>0]|0;r=r+1|0;t=t+(p&255)|0;}s=(t|0)<(o|0);v=s?q:v;o=s?t:o;q=q+1|0;}Cc(b,v,25624+(u*9|0)|0,8);o=25272+(v*18|0)|0;p=0;while(1){if((p|0)>=(k|0)){o=0;break;}q=c[m+(p<<2)>>2]|0;if(!q)Cc(b,c[l+(p<<2)>>2]|0,o,8);else{Cc(b,17,o,8);q=q+-1|0;r=0;while(1){if((r|0)>=(q|0))break;Cc(b,17,25434|0,8);r=r+1|0;}Cc(b,c[l+(p<<2)>>2]|0,25434|0,8);}p=p+1|0;}while(1){if((o|0)>=(k|0)){r=0;break;}if((c[l+(o<<2)>>2]|0)>0)Gh(b,n+(o<<4<<2)|0);o=o+1|0;}while(1){if((r|0)>=(k|0))break;q=c[m+(r<<2)>>2]|0;b:do if((q|0)>0){p=r<<4;o=0;while(1){if((o|0)>=16)break b;s=a[g+(p+o)>>0]|0;n=s<<24>>24;n=(s<<24>>24>0?n:0-n|0)<<24>>24;s=q;while(1){s=s+-1|0;if((s|0)<=0)break;Cc(b,n>>>s&1,24928,8);}Cc(b,n&1,24928,8);o=o+1|0;}}while(0);r=r+1|0;}lf(b,g,h,e,f,l);i=j;return;}function Sf(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0;f=i;g=0;while(1){if((g|0)>=(e|0)){g=0;b=5;break;}h=g<<1;h=(c[b+(h<<2)>>2]|0)+(c[b+((h|1)<<2)>>2]|0)|0;if((h|0)>(d|0)){g=1;b=5;break;}c[a+(g<<2)>>2]=h;g=g+1|0;}if((b|0)==5){i=f;return g|0;}return 0;}function Tf(a,b,c,d,e){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;var f=0;f=i;switch(e|0){case 16:{Yf(a,b,c,d);break;};case 8:{Vf(a,b,c,d);break;};case 6:{Uf(a,b,c,d);break;};case 12:{Xf(a,b,c,d);break;};case 10:{Wf(a,b,c,d);break;};default:{}}wj(a|0,0,e<<2|0)|0;i=f;return;}function Uf(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,h=0,j=0,k=0,l=0,m=0;k=i;h=b+4|0;j=b+8|0;e=b+12|0;l=b+16|0;m=b+20|0;f=6;while(1){if((f|0)>=(d|0))break;g[a+(f<<2)>>2]=+g[c+(f<<2)>>2]-(+g[c+(f+-1<<2)>>2]*+g[b>>2]+ +g[c+(f+-2<<2)>>2]*+g[h>>2]+ +g[c+(f+-3<<2)>>2]*+g[j>>2]+ +g[c+(f+-4<<2)>>2]*+g[e>>2]+ +g[c+(f+-5<<2)>>2]*+g[l>>2]+ +g[c+(f+-6<<2)>>2]*+g[m>>2]);f=f+1|0;}i=k;return;}function Vf(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0;l=i;h=b+4|0;j=b+8|0;k=b+12|0;e=b+16|0;m=b+20|0;n=b+24|0;o=b+28|0;f=8;while(1){if((f|0)>=(d|0))break;g[a+(f<<2)>>2]=+g[c+(f<<2)>>2]-(+g[c+(f+-1<<2)>>2]*+g[b>>2]+ +g[c+(f+-2<<2)>>2]*+g[h>>2]+ +g[c+(f+-3<<2)>>2]*+g[j>>2]+ +g[c+(f+-4<<2)>>2]*+g[k>>2]+ +g[c+(f+-5<<2)>>2]*+g[e>>2]+ +g[c+(f+-6<<2)>>2]*+g[m>>2]+ +g[c+(f+-7<<2)>>2]*+g[n>>2]+ +g[c+(f+-8<<2)>>2]*+g[o>>2]);f=f+1|0;}i=l;return;}function Wf(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;m=i;h=b+4|0;j=b+8|0;k=b+12|0;l=b+16|0;e=b+20|0;n=b+24|0;o=b+28|0;p=b+32|0;q=b+36|0;f=10;while(1){if((f|0)>=(d|0))break;g[a+(f<<2)>>2]=+g[c+(f<<2)>>2]-(+g[c+(f+-1<<2)>>2]*+g[b>>2]+ +g[c+(f+-2<<2)>>2]*+g[h>>2]+ +g[c+(f+-3<<2)>>2]*+g[j>>2]+ +g[c+(f+-4<<2)>>2]*+g[k>>2]+ +g[c+(f+-5<<2)>>2]*+g[l>>2]+ +g[c+(f+-6<<2)>>2]*+g[e>>2]+ +g[c+(f+-7<<2)>>2]*+g[n>>2]+ +g[c+(f+-8<<2)>>2]*+g[o>>2]+ +g[c+(f+-9<<2)>>2]*+g[p>>2]+ +g[c+(f+-10<<2)>>2]*+g[q>>2]);f=f+1|0;}i=m;return;}function Xf(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;n=i;h=b+4|0;j=b+8|0;k=b+12|0;l=b+16|0;m=b+20|0;e=b+24|0;o=b+28|0;p=b+32|0;q=b+36|0;r=b+40|0;s=b+44|0;f=12;while(1){if((f|0)>=(d|0))break;g[a+(f<<2)>>2]=+g[c+(f<<2)>>2]-(+g[c+(f+-1<<2)>>2]*+g[b>>2]+ +g[c+(f+-2<<2)>>2]*+g[h>>2]+ +g[c+(f+-3<<2)>>2]*+g[j>>2]+ +g[c+(f+-4<<2)>>2]*+g[k>>2]+ +g[c+(f+-5<<2)>>2]*+g[l>>2]+ +g[c+(f+-6<<2)>>2]*+g[m>>2]+ +g[c+(f+-7<<2)>>2]*+g[e>>2]+ +g[c+(f+-8<<2)>>2]*+g[o>>2]+ +g[c+(f+-9<<2)>>2]*+g[p>>2]+ +g[c+(f+-10<<2)>>2]*+g[q>>2]+ +g[c+(f+-11<<2)>>2]*+g[r>>2]+ +g[c+(f+-12<<2)>>2]*+g[s>>2]);f=f+1|0;}i=n;return;}function Yf(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;p=i;h=b+4|0;j=b+8|0;k=b+12|0;l=b+16|0;m=b+20|0;n=b+24|0;o=b+28|0;e=b+32|0;q=b+36|0;r=b+40|0;s=b+44|0;t=b+48|0;u=b+52|0;v=b+56|0;w=b+60|0;f=16;while(1){if((f|0)>=(d|0))break;g[a+(f<<2)>>2]=+g[c+(f<<2)>>2]-(+g[c+(f+-1<<2)>>2]*+g[b>>2]+ +g[c+(f+-2<<2)>>2]*+g[h>>2]+ +g[c+(f+-3<<2)>>2]*+g[j>>2]+ +g[c+(f+-4<<2)>>2]*+g[k>>2]+ +g[c+(f+-5<<2)>>2]*+g[l>>2]+ +g[c+(f+-6<<2)>>2]*+g[m>>2]+ +g[c+(f+-7<<2)>>2]*+g[n>>2]+ +g[c+(f+-8<<2)>>2]*+g[o>>2]+ +g[c+(f+-9<<2)>>2]*+g[e>>2]+ +g[c+(f+-10<<2)>>2]*+g[q>>2]+ +g[c+(f+-11<<2)>>2]*+g[r>>2]+ +g[c+(f+-12<<2)>>2]*+g[s>>2]+ +g[c+(f+-13<<2)>>2]*+g[t>>2]+ +g[c+(f+-14<<2)>>2]*+g[u>>2]+ +g[c+(f+-15<<2)>>2]*+g[v>>2]+ +g[c+(f+-16<<2)>>2]*+g[w>>2]);f=f+1|0;}i=p;return;}function Zf(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,f=0.0,h=0.0,j=0.0,k=0,l=0,m=0,n=0.0;c=i;i=i+128|0;e=c;m=e+((b&1)<<6)|0;yj(m|0,a|0,b<<2|0)|0;a=m;j=1.0;a:while(1){b=b+-1|0;if((b|0)<=0)break;f=+g[a+(b<<2)>>2];h=-f;if(f<-.9998999834060669|f>.9998999834060669){f=0.0;d=9;break;}n=1.0-h*h;f=1.0/n;j=j*n;l=b&1;k=e+(l<<6)|0;m=0;while(1){if((m|0)>=(b|0)){a=k;continue a;}g[e+(l<<6)+(m<<2)>>2]=(+g[a+(m<<2)>>2]-+g[a+(b-m+-1<<2)>>2]*h)*f;m=m+1|0;}}if((d|0)==9){i=c;return+f;}n=+g[a>>2];f=-n;if(n<-.9998999834060669|n>.9998999834060669){n=0.0;i=c;return+n;}n=j*(1.0-f*f);i=c;return+n;}function _f(a,b,d,e,f,h,j,k){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,o=0.0,p=0,q=0.0,r=0,s=0,t=0,u=0.0;m=i;i=i+32|0;l=m;k=h+k|0;n=0;while(1){if((n|0)>=(j|0))break;s=b+(0-(c[e+(n<<2)>>2]|0)<<2)|0;o=+g[f+(n<<2)>>2];r=n*5|0;p=0;while(1){if((p|0)>=5){p=0;break;}g[l+(p<<2)>>2]=+g[d+(r+p<<2)>>2];p=p+1|0;}while(1){if((p|0)>=(k|0))break;q=+g[b+(p<<2)>>2];t=a+(p<<2)|0;g[t>>2]=q;r=0;while(1){if((r|0)>=5)break;u=q-+g[l+(r<<2)>>2]*+g[s+(2-r<<2)>>2];g[t>>2]=u;q=u;r=r+1|0;}g[t>>2]=q*o;p=p+1|0;s=s+4|0;}a=a+(k<<2)|0;n=n+1|0;b=b+(h<<2)|0;}i=m;return;}function $f(d,e,f){d=d|0;e=e|0;f=f|0;var h=0,j=0.0;h=i;if(!f){j=+((c[d+4640>>2]|0)+(c[d+5776>>2]|0)|0)*+g[e+872>>2]*.10000000149011612;if(!(j>2.0)){if(j<0.0)f=0;else f=~~j;}else f=2;a[d+4801>>0]=f;}else{a[d+4801>>0]=0;f=0;}g[e+224>>2]=+(b[24976+(f<<24>>24<<1)>>1]|0)*6103515625.0e-14;i=h;return;}function ag(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0.0,h=0.0,j=0.0,k=0.0,l=0;e=i;j=3.1415927410125732/+(d+1|0);f=2.0-j*j;if((c|0)<2){h=0.0;c=0;}else{h=1.0;j=f*.5;c=0;}while(1){if((c|0)>=(d|0))break;g[a+(c<<2)>>2]=+g[b+(c<<2)>>2]*.5*(h+j);l=c|1;g[a+(l<<2)>>2]=+g[b+(l<<2)>>2]*j;k=f*j-h;l=c|2;g[a+(l<<2)>>2]=+g[b+(l<<2)>>2]*.5*(j+k);l=c|3;g[a+(l<<2)>>2]=+g[b+(l<<2)>>2]*k;h=k;j=f*k-j;c=c+4|0;}i=e;return;}function bg(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0;e=i;d=(d|0)>(c|0)?c:d;f=0;while(1){if((f|0)>=(d|0))break;g[a+(f<<2)>>2]=+ug(b,b+(f<<2)|0,c-f|0);f=f+1|0;}i=e;return;}function cg(a,b,d,e,f,j){a=a|0;b=b|0;d=+d;e=e|0;f=f|0;j=j|0;var k=0,l=0,m=0,n=0.0,o=0,p=0,q=0,r=0,s=0.0,t=0,u=0.0,v=0,w=0.0,x=0.0,y=0,z=0,A=0,B=0.0,C=0,D=0,E=0.0,F=0.0,G=0.0,H=0;k=i;i=i+656|0;p=k+528|0;r=k+400|0;m=k+264|0;q=k+128|0;l=k;n=+og(b,$(f,e)|0);t=p+0|0;v=t+128|0;do{c[t>>2]=0;t=t+4|0;}while((t|0)<(v|0));y=j+1|0;v=0;while(1){if((v|0)>=(f|0))break;z=$(v,e)|0;t=b+(z<<2)|0;A=1;while(1){if((A|0)>=(y|0))break;B=+ug(t,b+(z+A<<2)|0,e-A|0);D=p+(A+-1<<3)|0;h[D>>3]=+h[D>>3]+B;A=A+1|0;}v=v+1|0;}t=r+0|0;y=p+0|0;v=t+128|0;do{c[t>>2]=c[y>>2];t=t+4|0;y=y+4|0;}while((t|0)<(v|0));s=n*9999999747378752.0e-21;u=n+s+9.999999717180685e-10;h[m>>3]=u;h[q>>3]=u;u=1.0;t=0;a:while(1){if((t|0)>=(j|0))break;y=e-t|0;v=y+-1|0;z=0;while(1){if((z|0)>=(f|0))break;A=$(z,e)|0;B=+g[b+(A+v<<2)>>2];C=b+(A+t<<2)|0;D=0;x=+g[b+(A+t<<2)>>2];w=B;while(1){if((D|0)>=(t|0)){C=0;break;}G=+g[b+(A+(t-D+-1)<<2)>>2];H=p+(D<<3)|0;h[H>>3]=+h[H>>3]-+g[C>>2]*G;F=+g[b+(A+(y+D)<<2)>>2];H=r+(D<<3)|0;h[H>>3]=+h[H>>3]-B*F;E=+h[l+(D<<3)>>3];D=D+1|0;x=x+G*E;w=w+F*E;}while(1){if((C|0)>(t|0))break;H=m+(C<<3)|0;h[H>>3]=+h[H>>3]-x*+g[b+(A+(t-C)<<2)>>2];H=q+(C<<3)|0;h[H>>3]=+h[H>>3]-w*+g[b+(A+(y+C+-1)<<2)>>2];C=C+1|0;}z=z+1|0;}v=0;x=+h[p+(t<<3)>>3];w=+h[r+(t<<3)>>3];while(1){if((v|0)>=(t|0))break;G=+h[l+(v<<3)>>3];H=t-v+-1|0;v=v+1|0;x=x+ +h[r+(H<<3)>>3]*G;w=w+ +h[p+(H<<3)>>3]*G;}v=t+1|0;h[m+(v<<3)>>3]=x;h[q+(v<<3)>>3]=w;x=+h[q>>3];B=+h[m>>3];y=0;while(1){if((y|0)>=(t|0))break;G=+h[l+(y<<3)>>3];H=y+1|0;x=x+ +h[q+(H<<3)>>3]*G;B=B+ +h[m+(H<<3)>>3]*G;w=w+ +h[q+(t-y<<3)>>3]*G;y=H;}x=w*-2.0/(B+x);B=u*(1.0-x*x);if(B<=d){x=+P(+(1.0-d/u));if(w>0.0){u=d;w=-x;y=1;}else{u=d;w=x;y=1;}}else{u=B;w=x;y=0;}z=v>>1;A=0;while(1){if((A|0)>=(z|0))break;D=l+(A<<3)|0;G=+h[D>>3];H=l+(t-A+-1<<3)|0;F=+h[H>>3];h[D>>3]=G+w*F;h[H>>3]=F+w*G;A=A+1|0;}h[l+(t<<3)>>3]=w;if(!y)y=0;else{o=30;break;}while(1){if((y|0)>(v|0)){t=v;continue a;}D=m+(y<<3)|0;G=+h[D>>3];H=q+(t-y+1<<3)|0;F=+h[H>>3];h[D>>3]=G+w*F;h[H>>3]=F+w*G;y=y+1|0;}}if((o|0)==30){while(1){t=t+1|0;if((t|0)>=(j|0))break;h[l+(t<<3)>>3]=0.0;o=30;}if(y){m=0;while(1){if((m|0)>=(j|0)){a=0;break;}g[a+(m<<2)>>2]=-+h[l+(m<<3)>>3];m=m+1|0;}while(1){if((a|0)>=(f|0))break;n=n-+og(b+(($(a,e)|0)<<2)|0,j);a=a+1|0;}G=n*u;i=k;return+G;}}d=+h[m>>3];b=0;n=1.0;while(1){if((b|0)>=(j|0))break;G=+h[l+(b<<3)>>3];H=b+1|0;F=d+ +h[m+(H<<3)>>3]*G;g[a+(b<<2)>>2]=-G;d=F;b=H;n=n+G*G;}G=d-s*n;i=k;return+G;}function dg(a,b,c){a=a|0;b=b|0;c=+c;var d=0,e=0.0,f=0,h=0;d=i;b=b+-1|0;e=c;f=0;while(1){if((f|0)>=(b|0))break;h=a+(f<<2)|0;g[h>>2]=+g[h>>2]*e;e=e*c;f=f+1|0;}h=a+(b<<2)|0;g[h>>2]=+g[h>>2]*e;i=d;return;}function eg(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0;e=i;a=a+16|0;f=0;while(1){if((f|0)>=5)break;g[d+(f<<2)>>2]=+ug(a,b,c);a=a+-4|0;f=f+1|0;}i=e;return;}function fg(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,h=0,j=0,k=0,l=0.0,m=0.0,n=0.0,o=0;e=i;d=a+16|0;l=+og(d,b);g[c>>2]=l;f=1;while(1){if((f|0)>=5)break;n=+g[a+(4-f<<2)>>2];m=+g[a+(b-f+4<<2)>>2];m=l+(n*n-m*m);g[c+(f*6<<2)>>2]=m;l=m;f=f+1|0;}f=a+12|0;h=1;while(1){if((h|0)>=5)break;l=+ug(d,f,b);n=l;g[c+(h*5<<2)>>2]=n;g[c+(h<<2)>>2]=n;j=5-h|0;k=1;while(1){if((k|0)>=(j|0))break;o=b-k|0;n=l+(+g[a+(4-k<<2)>>2]*+g[f+(0-k<<2)>>2]-+g[a+(o+4<<2)>>2]*+g[f+(o<<2)>>2]);m=n;o=h+k|0;g[c+((o*5|0)+k<<2)>>2]=m;g[c+((k*5|0)+o<<2)>>2]=m;l=n;k=k+1|0;}f=f+-4|0;h=h+1|0;}i=e;return;}function gg(b){b=b|0;var d=0,e=0,f=0,g=0;d=i;Ye(b,b+5130|0);if((c[b+4556>>2]|0)>=13){c[b+6116>>2]=0;c[b+6112>>2]=0;a[b+4797>>0]=1;a[b+(c[b+5780>>2]|0)+4752>>0]=1;i=d;return;}a[b+4797>>0]=0;e=b+6116|0;f=c[e>>2]|0;g=f+1|0;c[e>>2]=g;if((g|0)>=10){if((f|0)>29){c[e>>2]=10;c[b+6112>>2]=0;}}else c[b+6112>>2]=0;a[b+(c[b+5780>>2]|0)+4752>>0]=0;i=d;return;}function hg(d,e,f,h,j,k){d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ja=0,ka=0,la=0;w=i;i=i+15040|0;u=w+12840|0;n=w+11560|0;C=w+8872|0;m=w+8824|0;r=w+24|0;s=w;y=w+4444|0;l=w+64|0;v=w+48|0;t=w+13752|0;z=d+4644|0;p=c[z>>2]|0;c[z>>2]=p+1;z=d+4802|0;a[z>>0]=p&3;p=d+4616|0;E=c[p>>2]|0;B=d+(E<<2)+9356|0;D=C+(E<<2)|0;A=d+5130|0;o=d+4608|0;Xd(d+16|0,A,c[o>>2]|0);q=d+4600|0;ig(d+(E+((c[q>>2]|0)*5|0)<<2)+9356|0,A,c[o>>2]|0);A=0;while(1){if((A|0)>=8)break;la=d+(E+(((c[q>>2]|0)*5|0)+($(A,c[o>>2]>>3)|0))<<2)+9356|0;g[la>>2]=+g[la>>2]+ +(1-(A&2)|0)*9.999999974752427e-7;A=A+1|0;}A=d+4712|0;a:do if(!(c[A>>2]|0)){sg(d,u,C,B,c[d+5124>>2]|0);xg(d,u,D,B);tg(d,u,C,B,h);Ng(d,u,h);Kg(d,u,n,B);jg(d,u,n,h);J=d+4768|0;D=d+4604|0;ha=jh(J,c[D>>2]|0)|0;ia=m+0|0;la=f+0|0;ja=ia+48|0;do{c[ia>>2]=c[la>>2];ia=ia+4|0;la=la+4|0;}while((ia|0)<(ja|0));N=d+144|0;yj(y|0,N|0,4380)|0;V=a[z>>0]|0;L=d+5804|0;U=b[L>>1]|0;H=d+5800|0;K=c[H>>2]|0;F=u+852|0;B=u+908|0;I=d+7200|0;E=(h|0)==2&1;C=j+-5|0;G=f+24|0;T=f+28|0;M=d+4768|0;O=d+4804|0;P=d+5780|0;Q=d+4797|0;R=d+4798|0;S=f+20|0;k=(k|0)==0;X=0;Y=0;Z=0;ga=256;_=0;aa=0;ba=-1;da=-1;ea=0;fa=0;ca=0;W=0;while(1){ka=(ha|0)==(ba|0);if(!ka){if((ha|0)!=(da|0)){if((W|0)>0){ia=f+0|0;la=m+0|0;ja=ia+48|0;do{c[ia>>2]=c[la>>2];ia=ia+4|0;la=la+4|0;}while((ia|0)<(ja|0));yj(N|0,y|0,4380)|0;a[z>>0]=V;b[L>>1]=U;c[H>>2]=K;}dh(d,u,M,N,O,n);Qf(d,f,c[P>>2]|0,0,h);Rf(f,a[Q>>0]|0,a[R>>0]|0,O,c[o>>2]|0);ja=kg(c[S>>2]|0,c[T>>2]|0)|0;if(k&(W|0)==0){if((ja|0)<=(j|0))break a;}else x=12;}else{ja=fa;x=12;}}else{ja=ea;x=12;}if((x|0)==12){x=0;if((W|0)==6)break;}ia=(ja|0)>(j|0);do if(ia){if((Y|0)==0&(W|0)>1){g[F>>2]=+g[F>>2]*1.5;Z=0;da=-1;break;}else{Z=1;aa=ga<<16>>16;da=ha;fa=ja;break;}}else{if((ja|0)>=(C|0))break a;_=ga<<16>>16;if(ka){Y=1;ba=ha;ea=ja;}else{c[r+0>>2]=c[f+0>>2];c[r+4>>2]=c[f+4>>2];c[r+8>>2]=c[f+8>>2];c[r+12>>2]=c[f+12>>2];c[r+16>>2]=c[f+16>>2];c[r+20>>2]=c[f+20>>2];ca=c[G>>2]|0;c[s+0>>2]=c[T+0>>2];c[s+4>>2]=c[T+4>>2];c[s+8>>2]=c[T+8>>2];c[s+12>>2]=c[T+12>>2];c[s+16>>2]=c[T+16>>2];yj(t|0,c[f>>2]|0,ca|0)|0;yj(l|0,N|0,4380)|0;X=a[I>>0]|0;Y=1;ba=ha;ea=ja;}}while(0);do if(Y&Z){ha=aa-_|0;ia=_+(($(ha,j-ea|0)|0)/(fa-ea|0)|0)|0;ga=ha>>2;if((ia<<16>>16|0)>(_+ga|0)){ia=_+(ha>>>2)|0;break;}if((ia<<16>>16|0)<(aa-ga|0))ia=aa-(ha>>>2)|0;}else{ha=lg(sh(((ja-j<<7|0)/(c[o>>2]|0)|0)+2048|0)|0)|0;if(ia)ha=mg(ha)|0;ia=ga<<16>>16;ia=($(ha>>16,ia)|0)+(($(ha&65535,ia)|0)>>>16)|0;}while(0);ga=ia&65535;ha=c[D>>2]|0;ja=ia<<16>>16;ia=0;while(1){if((ia|0)>=(ha|0))break;ka=c[u+(ia<<2)+892>>2]|0;ka=($(ka>>16,ja)|0)+(($(ka&65535,ja)|0)>>16)|0;if((ka|0)>8388607)ka=2147483392;else ka=(ka|0)<-8388608?-2147483648:ka<<8;c[v+(ia<<2)>>2]=ka;ia=ia+1|0;}a[I>>0]=a[B>>0]|0;fh(J,v,I,E,ha);ia=c[D>>2]|0;ha=jh(J,ia)|0;ja=0;while(1){if((ja|0)>=(ia|0))break;g[u+(ja<<2)>>2]=+(c[v+(ja<<2)>>2]|0)*152587890625.0e-16;ja=ja+1|0;}W=W+1|0;}if((Y|0)!=0?ka|(ja|0)>(j|0):0){c[f+0>>2]=c[r+0>>2];c[f+4>>2]=c[r+4>>2];c[f+8>>2]=c[r+8>>2];c[f+12>>2]=c[r+12>>2];c[f+16>>2]=c[r+16>>2];c[f+20>>2]=c[r+20>>2];c[G>>2]=ca;c[T+0>>2]=c[s+0>>2];c[T+4>>2]=c[s+4>>2];c[T+8>>2]=c[s+8>>2];c[T+12>>2]=c[s+12>>2];c[T+16>>2]=c[s+16>>2];yj(c[f>>2]|0,t|0,ca|0)|0;yj(N|0,l|0,4380)|0;a[I>>0]=X;}}while(0);zj(d+9356|0,d+(c[o>>2]<<2)+9356|0,(c[p>>2]|0)+((c[q>>2]|0)*5|0)<<2|0)|0;if(c[A>>2]|0){la=0;c[e>>2]=la;i=w;return 0;}c[d+4568>>2]=c[u+((c[d+4604>>2]|0)+-1<<2)+228>>2];a[d+4565>>0]=a[d+4797>>0]|0;c[d+4696>>2]=0;la=(kg(c[f+20>>2]|0,c[f+28>>2]|0)|0)+7>>3;c[e>>2]=la;i=w;return 0;}function ig(a,c,d){a=a|0;c=c|0;d=d|0;var e=0,f=0;e=i;while(1){f=d+-1|0;if((d|0)<=0)break;g[a+(f<<2)>>2]=+(b[c+(f<<1)>>1]|0);d=f;}i=e;return;}function jg(e,f,h,j){e=e|0;f=f|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;p=i;i=i+4416|0;n=p+4400|0;k=p+4384|0;o=p;l=e+5780|0;q=c[l>>2]|0;m=e+(q*36|0)+6132|0;if(!(c[e+6124>>2]|0)){i=p;return;}if((c[e+4556>>2]|0)<=77){i=p;return;}c[e+(q<<2)+4756>>2]=1;yj(o|0,e+144|0,4380)|0;s=m+0|0;r=e+4768|0;q=s+36|0;do{b[s>>1]=b[r>>1]|0;s=s+2|0;r=r+2|0;}while((s|0)<(q|0));q=e+4604|0;s=c[q>>2]|0;yj(k|0,f|0,s<<2|0)|0;r=c[l>>2]|0;if((r|0)!=0?(c[e+(r+-1<<2)+4756>>2]|0)!=0:0)r=e+4564|0;else{r=e+4564|0;a[r>>0]=a[e+7200>>0]|0;a[m>>0]=ng((d[m>>0]|0)+(c[e+6128>>2]|0)<<24>>24)|0;s=c[q>>2]|0;}hh(n,m,r,(j|0)==2&1,s);j=0;while(1){if((j|0)>=(c[q>>2]|0))break;g[f+(j<<2)>>2]=+(c[n+(j<<2)>>2]|0)*152587890625.0e-16;j=j+1|0;}dh(e,f,m,o,e+((c[l>>2]|0)*320|0)+6240|0,h);yj(f|0,k|0,c[q>>2]<<2|0)|0;i=p;return;}function kg(a,b){a=a|0;b=b|0;var c=0;c=i;b=(vj(b|0)|0)+-32+a|0;i=c;return b|0;}function lg(a){a=a|0;return((a|0)<131072?a:131072)|0;}function mg(a){a=a|0;return((a|0)>85197?a:85197)|0;}function ng(a){a=a|0;return((a|0)<63?a:63)|0;}function og(a,b){a=a|0;b=b|0;var c=0,d=0.0,e=0,f=0,h=0.0,j=0.0,k=0.0,l=0.0;c=i;f=b&65532;d=0.0;e=0;while(1){if((e|0)>=(f|0))break;l=+g[a+(e<<2)>>2];k=+g[a+((e|1)<<2)>>2];j=+g[a+((e|2)<<2)>>2];h=+g[a+((e|3)<<2)>>2];d=d+(l*l+k*k+j*j+h*h);e=e+4|0;}while(1){if((e|0)>=(b|0))break;l=+g[a+(e<<2)>>2];e=e+1|0;d=d+l*l;}i=c;return+d;}function pg(b,d,e,f){b=b|0;d=d|0;e=e|0;f=+f;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0.0,s=0.0,t=0,u=0;p=i;i=i+1696|0;g=p+1600|0;k=p+1664|0;l=p+1536|0;m=p;h=b+4664|0;o=c[h>>2]|0;n=(c[b+4612>>2]|0)+o|0;j=b+4799|0;a[j>>0]=4;q=b+4604|0;r=+cg(g,e,f,n,c[q>>2]|0,o);a:do if(((c[b+4656>>2]|0)!=0?(c[b+4696>>2]|0)==0:0)?(c[q>>2]|0)==4:0){o=n<<1;r=r-+cg(l,e+(o<<2)|0,f,n,2,c[h>>2]|0);$g(d,l,c[h>>2]|0);b=b+4524|0;s=3.4028234663852886e+38;q=3;while(1){if((q|0)<=-1)break a;nh(k,b,d,q,c[h>>2]|0);bh(l,k,c[h>>2]|0);Tf(m,l,e,o,c[h>>2]|0);u=c[h>>2]|0;t=n-u|0;f=+og(m+(u<<2)|0,t);f=f+ +og(m+(u+n<<2)|0,t);if(!(f<r)){if(f>s)break a;}else{a[j>>0]=q;r=f;}s=f;q=q+-1|0;}}while(0);if((a[j>>0]|0)!=4){i=p;return;}$g(d,g,c[h>>2]|0);i=p;return;}function qg(a,b,d,e,f,h,j,k,l){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;var m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0.0,u=0,v=0.0,w=0.0,x=0,y=0.0;m=i;i=i+112|0;o=m+96|0;p=m+72|0;n=m+56|0;r=m+40|0;s=m+16|0;q=m;t=+(j|0)*.009999999776482582;u=a;e=e+(l<<2)|0;l=0;while(1){if((l|0)>=(k|0))break;x=e+(-2-(c[f+(l<<2)>>2]|0)<<2)|0;fg(x,j,b);eg(x,e,j,s);v=+og(e,j);x=q+(l<<2)|0;g[x>>2]=v;Pg(b,x,(v+1.0+ +g[b>>2]+ +g[b+96>>2])*.01666666753590107);Vg(b,s,u);v=+Qg(u,b,s,+g[x>>2]);g[r+(l<<2)>>2]=v;w=+g[h+(l<<2)>>2];Tg(b,w/(v*w+t));g[n+(l<<2)>>2]=+g[b+48>>2];b=b+100|0;u=u+20|0;e=e+(j<<2)|0;l=l+1|0;}if(!d){h=a;q=0;}else{t=9.999999974752427e-7;v=0.0;s=0;while(1){if((s|0)>=(k|0))break;w=+g[h+(s<<2)>>2];t=t+ +g[r+(s<<2)>>2]*w;v=v+ +g[q+(s<<2)>>2]*w;s=s+1|0;}g[d>>2]=+rg(v/t)*3.0;h=a;q=0;}while(1){if((q|0)>=(k|0)){q=0;t=.0010000000474974513;break;}d=o+(q<<2)|0;g[d>>2]=0.0;t=0.0;r=0;while(1){if((r|0)>=5)break;w=t+ +g[h+(r<<2)>>2];g[d>>2]=w;t=w;r=r+1|0;}h=h+20|0;q=q+1|0;}while(1){if((q|0)>=(k|0)){v=0.0;q=0;break;}w=t+ +g[n+(q<<2)>>2];q=q+1|0;t=w;}while(1){if((q|0)>=(k|0))break;v=v+ +g[o+(q<<2)>>2]*+g[n+(q<<2)>>2];q=q+1|0;}t=v/t;q=0;while(1){if((q|0)>=(k|0))break;v=.10000000149011612/(+g[n+(q<<2)>>2]+.10000000149011612)*(t-+g[o+(q<<2)>>2]);h=0;w=0.0;while(1){if((h|0)>=5)break;y=+g[a+(h<<2)>>2];y=y>.10000000149011612?y:.10000000149011612;g[p+(h<<2)>>2]=y;h=h+1|0;w=w+y;}v=v/w;h=0;while(1){if((h|0)>=5)break;x=a+(h<<2)|0;g[x>>2]=+g[x>>2]+ +g[p+(h<<2)>>2]*v;h=h+1|0;}a=a+20|0;q=q+1|0;}i=m;return;}function rg(a){a=+a;var b=0;b=i;a=+la(+a)*3.32192809488736;i=b;return+a;}function sg(d,e,f,h,j){d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0.0,r=0,s=0,t=0,u=0,v=0;k=i;i=i+1744|0;r=k+1664|0;o=k+1600|0;p=k+1536|0;t=k;l=d+4620|0;u=c[l>>2]|0;n=u+(c[d+4608>>2]|0)|0;m=c[d+4616>>2]|0;s=d+4572|0;v=n-(c[s>>2]|0)|0;ag(t,h+(v<<2)|0,1,u);l=c[l>>2]|0;v=v+l|0;u=(c[s>>2]|0)-(l<<1)|0;yj(t+(l<<2)|0,h+(v<<2)|0,u<<2|0)|0;ag(t+(l+u<<2)|0,h+(v+u<<2)|0,2,l);l=d+4672|0;bg(r,t,c[s>>2]|0,(c[l>>2]|0)+1|0);q=+g[r>>2];g[r>>2]=q+(q*.0010000000474974513+1.0);q=+Ug(p,r,c[l>>2]|0);g[e+868>>2]=+g[r>>2]/(q>1.0?q:1.0);vg(o,p,c[l>>2]|0);dg(o,c[l>>2]|0,.9900000095367432);Tf(f,o,h+(0-m<<2)|0,n+m|0,c[l>>2]|0);h=d+4797|0;if((a[h>>0]|0)!=0?(c[d+4696>>2]|0)==0:0)if(!(Cg(f,e+228|0,d+4794|0,d+4796|0,d+12236|0,c[d+4568>>2]|0,+(c[d+4676>>2]|0)*152587890625.0e-16,.6000000238418579-+(c[l>>2]|0)*.004000000189989805-+(c[d+4556>>2]|0)*.10000000149011612*.00390625-+(a[d+4565>>0]>>1|0)*.15000000596046448-+(c[d+4744>>2]|0)*.10000000149011612*30517578125.0e-15,c[d+4600>>2]|0,c[d+4668>>2]|0,c[d+4604>>2]|0,j)|0)){a[h>>0]=2;i=k;return;}else{a[h>>0]=1;i=k;return;}v=e+228|0;c[v+0>>2]=0;c[v+4>>2]=0;c[v+8>>2]=0;c[v+12>>2]=0;b[d+4794>>1]=0;a[d+4796>>0]=0;g[d+12236>>2]=0.0;i=k;return;}function tg(d,e,f,h,j){d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0.0,u=0,v=0,w=0;k=i;i=i+2e3|0;r=k+1568|0;o=k+1552|0;q=k+1536|0;l=k+1968|0;m=k;n=d+4604|0;p=c[n>>2]|0;s=0;while(1){if((s|0)>=(p|0))break;t=1.0/+g[e+(s<<2)>>2];g[o+(s<<2)>>2]=t;g[q+(s<<2)>>2]=t*t;s=s+1|0;}if((a[d+4797>>0]|0)==2){w=e+144|0;v=e+228|0;u=d+4612|0;qg(w,r,e+872|0,f,v,q,c[u>>2]|0,p,c[d+4616>>2]|0);eh(w,d+4772|0,d+4800|0,d+4688|0,r,c[d+4684>>2]|0,c[d+4680>>2]|0,c[n>>2]|0,c[d+5124>>2]|0);$f(d,e,j);s=c[d+4664>>2]|0;_f(m,h+(0-s<<2)|0,w,v,o,c[u>>2]|0,c[n>>2]|0,s);}else{f=d+4664|0;w=c[f>>2]|0;q=d+4612|0;s=w;r=0;j=m;h=h+(0-w<<2)|0;while(1){if((r|0)>=(p|0))break;Sg(j,h,+g[o+(r<<2)>>2],(c[q>>2]|0)+s|0);w=c[q>>2]|0;v=c[f>>2]|0;p=c[n>>2]|0;s=v;r=r+1|0;j=j+(w+v<<2)|0;h=h+(w<<2)|0;}wj(e+144|0,0,p*20|0)|0;g[e+872>>2]=0.0;c[d+4688>>2]=0;}if(c[d+4696>>2]|0){t=.009999999776482582;pg(d,l,m,t);u=e+16|0;s=d+4524|0;ch(d,u,l,s);s=e+876|0;v=d+4612|0;v=c[v>>2]|0;w=c[n>>2]|0;n=d+4664|0;n=c[n>>2]|0;Rg(s,m,u,e,v,w,n);m=d+4524|0;m=m+0|0;n=l+0|0;l=m+32|0;do{b[m>>1]=b[n>>1]|0;m=m+2|0;n=n+2|0;}while((m|0)<(l|0));i=k;return;}t=+pa(+(+g[e+872>>2]/3.0))/1.0e4;t=t/(+g[e+860>>2]*.75+.25);pg(d,l,m,t);u=e+16|0;s=d+4524|0;ch(d,u,l,s);s=e+876|0;v=d+4612|0;v=c[v>>2]|0;w=c[n>>2]|0;n=d+4664|0;n=c[n>>2]|0;Rg(s,m,u,e,v,w,n);m=d+4524|0;m=m+0|0;n=l+0|0;l=m+32|0;do{b[m>>1]=b[n>>1]|0;m=m+2|0;n=n+2|0;}while((m|0)<(l|0));i=k;return;}function ug(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0.0,f=0,h=0,j=0,k=0,l=0,m=0.0;d=i;h=c&65532;e=0.0;f=0;while(1){if((f|0)>=(h|0))break;l=f|1;k=f|2;j=f|3;e=e+(+g[a+(f<<2)>>2]*+g[b+(f<<2)>>2]+ +g[a+(l<<2)>>2]*+g[b+(l<<2)>>2]+ +g[a+(k<<2)>>2]*+g[b+(k<<2)>>2]+ +g[a+(j<<2)>>2]*+g[b+(j<<2)>>2]);f=f+4|0;}while(1){if((f|0)>=(c|0))break;m=e+ +g[a+(f<<2)>>2]*+g[b+(f<<2)>>2];f=f+1|0;e=m;}i=d;return+e;}function vg(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,h=0,j=0,k=0;e=i;i=i+64|0;d=e;f=0;while(1){if((f|0)<(c|0))h=0;else break;while(1){if((h|0)>=(f|0))break;g[d+(h<<2)>>2]=+g[a+(h<<2)>>2];h=h+1|0;}h=b+(f<<2)|0;j=0;while(1){if((j|0)>=(f|0))break;k=a+(j<<2)|0;g[k>>2]=+g[k>>2]+ +g[d+(f-j+-1<<2)>>2]*+g[h>>2];j=j+1|0;}g[a+(f<<2)>>2]=-+g[h>>2];f=f+1|0;}i=e;return;}function wg(a,b,c){a=a|0;b=b|0;c=c|0;var d=0.0,e=0,f=0,h=0,j=0.0,k=0.0,l=0.0,m=0,n=0,o=0,p=0;e=i;l=+g[b>>2];d=l*9.999999960041972e-13+9.999999717180685e-10;l=d>l?d:l;n=b+4|0;k=+g[n>>2]/l;g[a>>2]=k;k=l-k*+g[n>>2];if(d>k){k=d;h=1;}else h=1;while(1){if((h|0)>=(c|0))break;f=h+1|0;m=0;l=+g[b+(f<<2)>>2];while(1){if((m|0)>=(h|0))break;j=l-+g[a+(m<<2)>>2]*+g[b+(h-m<<2)>>2];m=m+1|0;l=j;}j=l/k;k=k-j*l;k=d>k?d:k;m=h>>1;n=0;while(1){if((n|0)>=(m|0))break;o=a+(n<<2)|0;p=a+(h-n+-1<<2)|0;l=+g[p>>2];g[p>>2]=l-j*+g[o>>2];g[o>>2]=+g[o>>2]-j*l;n=n+1|0;}if(h&1){p=a+(m<<2)|0;l=+g[p>>2];g[p>>2]=l-j*l;}g[a+(h<<2)>>2]=j;h=f;}i=e;return+k;}function xg(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0.0,r=0.0,s=0.0,t=0,u=0,v=0,w=0,x=0,y=0.0,z=0,A=0,B=0,C=0.0;h=i;i=i+1040|0;n=h+72|0;m=h;o=f+(0-(c[b+4624>>2]|0)<<2)|0;p=b+4748|0;s=+(c[p>>2]|0)*.0078125;l=b+4728|0;q=+((c[l>>2]|0)+(c[b+4732>>2]|0)|0)*.5*30517578125.0e-15;j=d+856|0;g[j>>2]=q;r=+yg((s+-20.0)*.25);k=d+860|0;g[k>>2]=r;if(!(c[b+4708>>2]|0)){C=1.0-+(c[b+4556>>2]|0)*.00390625;r=s-r*2.0*(q*.5+.5)*C*C;}else r=s;f=b+4797|0;if((a[f>>0]|0)==2){q=r+ +g[b+12236>>2]*2.0;a[b+4798>>0]=0;g[d+864>>2]=0.0;}else{q=r+(+(c[p>>2]|0)*-.4000000059604645*.0078125+6.0)*(1.0-q);t=c[b+4600>>2]<<1;p=b+4604|0;r=+(t|0);s=0.0;C=0.0;u=0;while(1){if((u|0)>=(((c[p>>2]<<16>>16)*5|0)/2|0|0))break;y=+zg(r+ +og(e,t));if((u|0)>0)s=s+ +O(+(y-C));C=y;e=e+(t<<2)|0;u=u+1|0;}C=+yg((s+-5.0)*.4000000059604645);e=d+864|0;g[e>>2]=C;p=b+4798|0;if(C>.75)a[p>>0]=0;else a[p>>0]=1;q=q+(+g[e>>2]+-.5)*2.0;}C=+g[d+868>>2]*.0010000000474974513;C=.949999988079071/(C*C+1.0);y=+g[k>>2];r=(1.0-y*.75)*.009999999776482582;s=C+r;r=(C-r)/s;t=b+4704|0;e=c[t>>2]|0;if((e|0)>0)y=+(e|0)*152587890625.0e-16+y*.009999999776482582;else y=0.0;e=b+4604|0;p=b+4600|0;x=b+4628|0;w=b+4612|0;u=b+4660|0;v=0;while(1){z=c[e>>2]|0;if((v|0)>=(z|0))break;B=c[p>>2]|0;z=B*3|0;A=((c[x>>2]|0)-z|0)/2|0;ag(n,o,1,A);yj(n+(A<<2)|0,o+(A<<2)|0,B*12|0)|0;z=A+z|0;ag(n+(z<<2)|0,o+(z<<2)|0,2,A);o=o+(c[w>>2]<<2)|0;A=c[x>>2]|0;z=c[u>>2]|0;if((c[t>>2]|0)>0)_g(m,n,y,A,z);else bg(m,n,A,z+1|0);C=+g[m>>2];g[m>>2]=C+C*4999999873689376.0e-20;A=v<<4;B=d+(A<<2)+500|0;C=+P(+ +wg(B,m,c[u>>2]|0));z=d+(v<<2)|0;g[z>>2]=C;if((c[t>>2]|0)>0)g[z>>2]=C*+Ag(B,y,c[u>>2]|0);dg(B,c[u>>2]|0,s);A=d+(A<<2)+244|0;yj(A|0,B|0,c[u>>2]<<2|0)|0;dg(A,c[u>>2]|0,r);C=+Zf(B,c[u>>2]|0);g[d+(v<<2)+788>>2]=1.0-(1.0-C/+Zf(A,c[u>>2]|0))*.699999988079071;Bg(B,A,y,c[u>>2]|0);v=v+1|0;}q=+pa(+(q*-.1599999964237213));m=0;while(1){if((m|0)>=(z|0))break;z=d+(m<<2)|0;g[z>>2]=+g[z>>2]*q+1.2483305931091309;z=c[e>>2]|0;m=m+1|0;}q=+g[k>>2]*.10000000149011612+1.0499999523162842;m=0;while(1){if((m|0)>=(z|0))break;z=d+(m<<2)+788|0;g[z>>2]=+g[z>>2]*q;z=c[e>>2]|0;m=m+1|0;}m=b+4556|0;q=((+(c[l>>2]|0)*30517578125.0e-15+-1.0)*.5+1.0)*4.0*+(c[m>>2]|0)*.00390625;a:do if((a[f>>0]|0)==2){l=0;while(1){if((l|0)>=(z|0))break;C=.20000000298023224/+(c[p>>2]|0)+3.0/+(c[d+(l<<2)+228>>2]|0);g[d+(l<<2)+756>>2]=C+-1.0;g[d+(l<<2)+772>>2]=1.0-C-C*q;z=c[e>>2]|0;l=l+1|0;}q=-.25-+(c[m>>2]|0)*.26249998807907104*.00390625;}else{C=1.2999999523162842/+(c[p>>2]|0);l=d+756|0;g[l>>2]=C+-1.0;m=d+772|0;g[m>>2]=1.0-C-C*q*.6000000238418579;n=1;while(1){z=c[e>>2]|0;if((n|0)>=(z|0)){q=-.25;break a;}g[d+(n<<2)+756>>2]=+g[l>>2];g[d+(n<<2)+772>>2]=+g[m>>2];n=n+1|0;}}while(0);s=1.0-+g[k>>2];y=+g[b+12236>>2];C=+g[j>>2];r=s*.10000000149011612*y+(1.0-C)*.10000000149011612;if((a[f>>0]|0)==2)s=((1.0-s*C)*.20000000298023224+.30000001192092896)*+P(+y);else s=0.0;j=b+7204|0;f=b+7208|0;b=b+7212|0;k=0;while(1){if((k|0)>=(z|0))break;C=+g[j>>2];C=C+(r-C)*.4000000059604645;g[j>>2]=C;g[d+(k<<2)+804>>2]=C;C=+g[f>>2];C=C+(s-C)*.4000000059604645;g[f>>2]=C;g[d+(k<<2)+836>>2]=C;C=+g[b>>2];C=C+(q-C)*.4000000059604645;g[b>>2]=C;g[d+(k<<2)+820>>2]=C;z=c[e>>2]|0;k=k+1|0;}i=h;return;}function yg(a){a=+a;a=1.0/(+Y(+-a)+1.0);return+a;}function zg(a){a=+a;var b=0;b=i;a=+la(+a)*3.32192809488736;i=b;return+a;}function Ag(a,b,c){a=a|0;b=+b;c=c|0;var d=0,e=0.0;d=i;b=-b;e=+g[a+(c+-1<<2)>>2];c=c+-2|0;while(1){e=e*b;if((c|0)<=-1)break;e=e+ +g[a+(c<<2)>>2];c=c+-1|0;}i=d;return+(1.0/(1.0-e));}function Bg(a,b,c,d){a=a|0;b=b|0;c=+c;d=d|0;var e=0,f=0.0,h=0,j=0,k=0.0,l=0.0,m=0.0,n=0,o=0,p=0.0,q=0.0,r=0,s=0;e=i;j=d;while(1){h=j+-1|0;if((h|0)<=0)break;o=j+-2|0;n=a+(o<<2)|0;g[n>>2]=+g[n>>2]-+g[a+(h<<2)>>2]*c;o=b+(o<<2)|0;g[o>>2]=+g[o>>2]-+g[b+(h<<2)>>2]*c;j=h;}f=1.0-c*c;m=f/(+g[a>>2]*c+1.0);k=f/(+g[b>>2]*c+1.0);h=0;while(1){if((h|0)>=(d|0)){j=0;h=0;break;}o=a+(h<<2)|0;g[o>>2]=+g[o>>2]*m;o=b+(h<<2)|0;g[o>>2]=+g[o>>2]*k;h=h+1|0;}while(1){if((h|0)<10){l=-1.0;n=0;}else{a=23;break;}while(1){if((n|0)>=(d|0))break;q=+O(+ +g[a+(n<<2)>>2]);p=+O(+ +g[b+(n<<2)>>2]);p=q>p?q:p;o=p>l;j=o?n:j;l=o?p:l;n=n+1|0;}if(!(l<=3.999000072479248))n=1;else{a=23;break;}while(1){if((n|0)>=(d|0))break;o=n+-1|0;r=a+(o<<2)|0;g[r>>2]=+g[r>>2]+ +g[a+(n<<2)>>2]*c;o=b+(o<<2)|0;g[o>>2]=+g[o>>2]+ +g[b+(n<<2)>>2]*c;n=n+1|0;}m=1.0/m;k=1.0/k;n=0;while(1){if((n|0)>=(d|0))break;r=a+(n<<2)|0;g[r>>2]=+g[r>>2]*m;r=b+(n<<2)|0;g[r>>2]=+g[r>>2]*k;n=n+1|0;}q=.9900000095367432-(+(h|0)*.10000000149011612+.800000011920929)*(l+-3.999000072479248)/(l*+(j+1|0));dg(a,d,q);dg(b,d,q);n=d;while(1){o=n+-1|0;if((o|0)<=0)break;r=n+-2|0;s=a+(r<<2)|0;g[s>>2]=+g[s>>2]-+g[a+(o<<2)>>2]*c;r=b+(r<<2)|0;g[r>>2]=+g[r>>2]-+g[b+(o<<2)>>2]*c;n=o;}m=f/(+g[a>>2]*c+1.0);k=f/(+g[b>>2]*c+1.0);n=0;while(1){if((n|0)>=(d|0))break;s=a+(n<<2)|0;g[s>>2]=+g[s>>2]*m;s=b+(n<<2)|0;g[s>>2]=+g[s>>2]*k;n=n+1|0;}h=h+1|0;}if((a|0)==23){i=e;return;}}function Cg(d,f,h,j,k,l,m,n,o,p,q,r){d=d|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=+m;n=+n;o=o|0;p=p|0;q=q|0;r=r|0;var s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0.0,J=0.0,K=0,L=0,M=0.0,N=0.0,O=0,P=0,Q=0.0,R=0.0,S=0,T=0.0,U=0,V=0,W=0;s=i;i=i+13680|0;F=s+8888|0;G=s+8248|0;P=s+13032|0;K=s+12712|0;H=s;B=s+5864|0;E=s+5604|0;A=s+5560|0;z=s+5464|0;C=s+12408|0;v=s+2744|0;w=s+24|0;S=s+11128|0;U=s+10168|0;V=$((q*5|0)+20|0,o)|0;L=(q*20|0)+80|0;O=(q*40|0)+160|0;y=o*5|0;t=o<<1;u=o*18|0;x=u+-1|0;D=(o|0)==16;do if(!D){if((o|0)==12){Dg(U,d,V);c[H+0>>2]=0;c[H+4>>2]=0;c[H+8>>2]=0;c[H+12>>2]=0;c[H+16>>2]=0;c[H+20>>2]=0;yh(H,P,U,V);Eg(F,P,O);S=H;break;}else{Dg(P,d,O);S=H;break;}}else{Dg(S,d,V);U=H;c[U>>2]=0;c[U+4>>2]=0;xh(H,P,S,V);Eg(F,P,O);S=H;}while(0);V=H;c[V>>2]=0;c[V+4>>2]=0;xh(S,K,P,O);Eg(G,K,L);while(1){H=L+-1|0;if((H|0)<=0)break;V=G+(H<<2)|0;g[V>>2]=+g[V>>2]+ +g[G+(L+-2<<2)>>2];L=H;}wj(B|0,0,q*596|0)|0;K=q>>1;O=E+256|0;H=B+32|0;L=0;U=G+320|0;while(1){if((L|0)>=(K|0)){E=72;break;}G=U+-32|0;_c(U,U+-288|0,E,40,65,r);T=+g[O>>2];I=+og(U,40);I=I+ +og(G,40)+16.0e4;g[H>>2]=+g[H>>2]+T*2.0/I;P=8;while(1){S=P+1|0;if((P|0)>=72)break;V=G+-4|0;R=+g[V>>2];T=+g[G+156>>2];T=I+(R*R-T*T);W=B+(S<<2)|0;g[W>>2]=+g[W>>2]+ +g[E+(71-P<<2)>>2]*2.0/T;G=V;I=T;P=S;}L=L+1|0;U=U+160|0;}while(1){if((E|0)<8)break;W=B+(E<<2)|0;T=+g[W>>2];g[W>>2]=T-T*+(E|0)*.000244140625;E=E+-1|0;}E=(p<<1)+4|0;Zg(H,z,65,E);I=+g[H>>2];if(I<.20000000298023224){wj(f|0,0,q<<2|0)|0;g[k>>2]=0.0;b[h>>1]=0;a[j>>0]=0;W=1;i=s;return W|0;}m=I*m;G=0;while(1){if((G|0)>=(E|0))break;if(!(+g[B+(G+8<<2)>>2]>m)){E=G;break;}W=z+(G<<2)|0;c[W>>2]=(c[W>>2]<<1)+16;G=G+1|0;}G=11;while(1){if((G|0)>=148){G=0;break;}b[C+(G<<1)>>1]=0;G=G+1|0;}while(1){if((G|0)>=(E|0)){E=146;break;}b[C+(c[z+(G<<2)>>2]<<1)>>1]=1;G=G+1|0;}while(1){if((E|0)<16){E=0;G=16;break;}W=E+-1|0;V=C+(E<<1)|0;b[V>>1]=(e[V>>1]|0)+((e[C+(W<<1)>>1]|0)+(e[C+(E+-2<<1)>>1]|0));E=W;}while(1){if((G|0)>=144){G=146;break;}H=G+1|0;if((b[C+(H<<1)>>1]|0)<=0){G=H;continue;}c[z+(E<<2)>>2]=G;E=E+1|0;G=H;}while(1){if((G|0)<16){H=0;G=16;break;}W=G+-1|0;V=C+(G<<1)|0;b[V>>1]=(e[V>>1]|0)+((e[C+(W<<1)>>1]|0)+(e[C+(G+-2<<1)>>1]|0)+(e[C+(G+-3<<1)>>1]|0));G=W;}while(1){if((G|0)>=147)break;if((b[C+(G<<1)>>1]|0)>0){b[C+(H<<1)>>1]=G+65534;H=H+1|0;}G=G+1|0;}wj(B|0,0,2384)|0;G=(o|0)==8;if(G){K=0;P=d+640|0;}else{K=0;P=F+640|0;}while(1){if((K|0)>=(q|0))break;m=+og(P,40)+1.0;F=0;while(1){if((F|0)>=(H|0))break;L=b[C+(F<<1)>>1]|0;O=P+(0-L<<2)|0;I=+ug(O,P,40);if(I>0.0)g[B+(K*596|0)+(L<<2)>>2]=I*2.0/(+og(O,40)+m);else g[B+(K*596|0)+(L<<2)>>2]=0.0;F=F+1|0;}K=K+1|0;P=P+160|0;}if((l|0)>0){if((o|0)==12)C=(l<<1|0)/3|0;else C=D?l>>1:l;l=C;m=+Fg(+(C|0));}else m=0.0;C=(q|0)==4;if(C){D=21304;F=11;H=G&(p|0)>0?11:3;}else{D=21264;F=3;H=3;}J=+(q|0);I=J*.20000000298023224;K=(l|0)>0;M=J*n;G=0;N=0.0;n=-1.0e3;l=-1;L=0;while(1){if((L|0)>=(E|0))break;O=c[z+(L<<2)>>2]|0;U=0;while(1){if((U|0)>=(H|0)){P=0;Q=-1.0e3;S=0;break;}S=A+(U<<2)|0;g[S>>2]=0.0;Q=0.0;P=0;while(1){if((P|0)>=(q|0))break;T=Q+ +g[B+(P*596|0)+(O+(a[D+(($(P,F)|0)+U)>>0]|0)<<2)>>2];g[S>>2]=T;Q=T;P=P+1|0;}U=U+1|0;}while(1){if((S|0)>=(H|0))break;T=+g[A+(S<<2)>>2];W=T>Q;P=W?S:P;Q=W?T:Q;S=S+1|0;}T=+Fg(+(O|0));R=Q-I*T;if(K){T=T-m;T=T*T;R=R-I*+g[k>>2]*T/(T+.5);}W=R>n&Q>M;G=W?P:G;N=W?Q:N;n=W?R:n;l=W?O:l;L=L+1|0;}if((l|0)==-1){c[f+0>>2]=0;c[f+4>>2]=0;c[f+8>>2]=0;c[f+12>>2]=0;g[k>>2]=0.0;b[h>>1]=0;a[j>>0]=0;W=1;i=s;return W|0;}g[k>>2]=N/J;if((o|0)>8){if((o|0)==12){z=(l<<16>>16)*3|0;z=(z>>1)+(z&1)|0;}else z=l<<1;if((t|0)>(x|0)){if((z|0)>(t|0))B=t;else B=(z|0)<(x|0)?x:z;}else if((z|0)>(x|0))B=x;else B=(z|0)<(t|0)?t:z;k=Gg(B+-2|0,t)|0;A=Hg(B+2|0,x)|0;Ig(w,d,k,y,q,p,r);Jg(v,d,k,y,q,p);n=.05000000074505806/+(B|0);if(C){r=21352;z=34;p=a[21512+p>>0]|0;}else{r=21272;z=12;p=12;}m=+og(d+(o*20<<2)|0,$(y,q)|0)+1.0;G=0;I=-1.0e3;o=0;d=B;y=k;while(1){if((y|0)>(A|0))break;else k=0;while(1){if((k|0)<(p|0)){M=0.0;J=m;B=0;}else break;while(1){if((B|0)>=(q|0))break;M=M+ +g[w+(B*680|0)+(k*20|0)+(o<<2)>>2];J=J+ +g[v+(B*680|0)+(k*20|0)+(o<<2)>>2];B=B+1|0;}if(M>0.0)J=M*2.0/J*(1.0-n*+(k|0));else J=0.0;if(J>I){W=(y+(a[21352+k>>0]|0)|0)>(x|0);G=W?G:k;I=W?I:J;d=W?d:y;}k=k+1|0;}o=o+1|0;y=y+1|0;}x=(t|0)>(u|0);w=0;while(1){if((w|0)>=(q|0))break;o=d+(a[r+(($(w,z)|0)+G)>>0]|0)|0;v=f+(w<<2)|0;c[v>>2]=o;if(x){if((o|0)>(t|0))o=t;else o=(o|0)<(u|0)?u:o;}else if((o|0)>(u|0))o=u;else o=(o|0)<(t|0)?t:o;c[v>>2]=o;w=w+1|0;}f=d-t|0;}else{t=0;while(1){if((t|0)>=(q|0))break;v=l+(a[D+(($(t,F)|0)+G)>>0]|0)|0;u=f+(t<<2)|0;c[u>>2]=v;if((v|0)>144)v=144;else v=(v|0)<16?16:v;c[u>>2]=v;t=t+1|0;}f=l+65520|0;}b[h>>1]=f;a[j>>0]=G;W=0;i=s;return W|0;}function Dg(a,c,d){a=a|0;c=c|0;d=d|0;var e=0,f=0;e=i;while(1){f=d+-1|0;if((d|0)<=0)break;d=c+(f<<2)|0;if((sa(+ +g[d>>2])|0)<=32767){if((sa(+ +g[d>>2])|0)<-32768)d=-32768;else d=(sa(+ +g[d>>2])|0)&65535;}else d=32767;b[a+(f<<1)>>1]=d;d=f;}i=e;return;}function Eg(a,c,d){a=a|0;c=c|0;d=d|0;var e=0,f=0;e=i;while(1){f=d+-1|0;if((d|0)<=0)break;g[a+(f<<2)>>2]=+(b[c+(f<<1)>>1]|0);d=f;}i=e;return;}function Fg(a){a=+a;var b=0;b=i;a=+la(+a)*3.32192809488736;i=b;return+a;}function Gg(a,b){a=a|0;b=b|0;return((a|0)>(b|0)?a:b)|0;}function Hg(a,b){a=a|0;b=b|0;return((a|0)<(b|0)?a:b)|0;}function Ig(b,c,d,e,f,h,j){b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0;o=i;i=i+176|0;m=o+88|0;l=o;if((f|0)==4){n=21352;k=21488+(h<<3)|0;p=34;h=a[21512+h>>0]|0;}else{n=21272;k=21296;p=12;h=12;}q=0;c=c+(e<<2<<2)|0;while(1){if((q|0)>=(f|0))break;u=q<<1;r=a[k+u>>0]|0;u=a[k+(u|1)>>0]|0;_c(c,c+(0-(u+d)<<2)|0,l,e,u-r+1|0,j);s=0;t=r;while(1){if((t|0)>(u|0))break;g[m+(s<<2)>>2]=+g[l+(u-t<<2)>>2];s=s+1|0;t=t+1|0;}v=$(q,p)|0;u=0;while(1){if((u|0)>=(h|0))break;s=(a[n+(v+u)>>0]|0)-r|0;t=0;while(1){if((t|0)>=5)break;g[b+(q*680|0)+(u*20|0)+(t<<2)>>2]=+g[m+(s+t<<2)>>2];t=t+1|0;}u=u+1|0;}q=q+1|0;c=c+(e<<2)|0;}i=o;return;}function Jg(b,c,d,e,f,h){b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0.0,u=0,v=0.0,w=0.0;k=i;i=i+96|0;j=k;if((f|0)==4){l=21352;n=21488+(h<<3)|0;m=34;o=a[21512+h>>0]|0;}else{l=21272;n=21296;m=12;o=12;}h=0;c=c+(e<<2<<2)|0;while(1){if((h|0)>=(f|0))break;r=h<<1;p=a[n+r>>0]|0;s=p+d|0;t=+og(c+(0-s<<2)|0,e)+.001;g[j>>2]=t;r=(a[n+(r|1)>>0]|0)-p+1|0;u=1;q=1;while(1){if((q|0)>=(r|0))break;w=+g[c+(e-q-s<<2)>>2];v=+g[c+(0-(s+q)<<2)>>2];v=t-w*w+v*v;g[j+(u<<2)>>2]=v;t=v;u=u+1|0;q=q+1|0;}s=$(h,m)|0;u=0;while(1){if((u|0)>=(o|0))break;r=(a[l+(s+u)>>0]|0)-p|0;q=0;while(1){if((q|0)>=5)break;g[b+(h*680|0)+(u*20|0)+(q<<2)>>2]=+g[j+(r+q<<2)>>2];q=q+1|0;}u=u+1|0;}h=h+1|0;c=c+(e<<2)|0;}i=k;return;}function Kg(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0.0,y=0,z=0.0,A=0,B=0,C=0.0,D=0.0,E=0.0;v=i;i=i+400|0;p=v+384|0;m=v;u=b+7216|0;t=b+4604|0;s=b+4797|0;j=p+4|0;k=p+8|0;l=b+9264|0;n=b+4704|0;o=b+4612|0;h=b+4660|0;q=d+860|0;r=b+9344|0;B=c[b+9352>>2]|0;w=0;while(1){y=c[t>>2]|0;if((w|0)>=(y|0))break;if((a[s>>0]|0)==2)B=c[d+(w<<2)+228>>2]|0;A=d+(w<<2)+804|0;z=+g[d+(w<<2)+836>>2]*(1.0-+g[A>>2]);C=z*.25;g[p>>2]=C;g[j>>2]=z*.4999847412109375;g[k>>2]=C;C=+g[d+(w<<2)+820>>2];x=+g[d+(w<<2)+756>>2];E=+g[d+(w<<2)+772>>2];Lg(l,m,d+(w<<4<<2)+244|0,f,+(c[n>>2]|0)*152587890625.0e-16,c[o>>2]|0,c[h>>2]|0);D=+g[d+(w<<2)+788>>2];z=-(D*(+g[A>>2]*z+.05000000074505806+ +g[q>>2]*.10000000149011612));g[e>>2]=D*+g[m>>2]+ +g[r>>2]*z;A=1;while(1){y=c[o>>2]|0;if((A|0)>=(y|0))break;g[e+(A<<2)>>2]=D*+g[m+(A<<2)>>2]+ +g[m+(A+-1<<2)>>2]*z;A=A+1|0;}g[r>>2]=+g[m+(y+-1<<2)>>2];Mg(u,e,e,p,C,x,E,B,y);A=c[o>>2]|0;f=f+(A<<2)|0;e=e+(A<<2)|0;w=w+1|0;}c[b+9352>>2]=c[d+(y+-1<<2)+228>>2];i=v;return;}function Lg(a,b,c,d,e,f,h){a=a|0;b=b|0;c=c|0;d=d|0;e=+e;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0.0,q=0,r=0.0,s=0,t=0.0,u=0.0,v=0.0,w=0.0,x=0,y=0.0,z=0;o=i;j=a+4|0;k=a+8|0;l=a+(h<<2)|0;m=c+(h+-1<<2)|0;n=0;while(1){if((n|0)>=(f|0))break;v=+g[j>>2];p=+g[a>>2]+v*e;q=d+(n<<2)|0;g[a>>2]=+g[q>>2];u=+g[k>>2];g[j>>2]=p;t=u;r=+g[c>>2]*p;s=2;p=v+(u-p)*e;while(1){if((s|0)>=(h|0))break;z=a+((s|1)<<2)|0;w=+g[z>>2];v=t+(w-p)*e;g[a+(s<<2)>>2]=p;y=r+ +g[c+(s+-1<<2)>>2]*p;x=s+2|0;u=+g[a+(x<<2)>>2];g[z>>2]=v;t=u;r=y+ +g[c+(s<<2)>>2]*v;s=x;p=w+(u-v)*e;}g[l>>2]=p;g[b+(n<<2)>>2]=+g[q>>2]-(r+ +g[m>>2]*p);n=n+1|0;}i=o;return;}function Mg(a,b,d,e,f,h,j,k,l){a=a|0;b=b|0;d=d|0;e=e|0;f=+f;h=+h;j=+j;k=k|0;l=l|0;var m=0,n=0,o=0.0,p=0,q=0,r=0,s=0,t=0,u=0,v=0.0,w=0,x=0.0,y=0,z=0.0,A=0.0;s=i;r=a+2116|0;n=a+2120|0;p=a+2124|0;m=(k|0)>0;t=e+4|0;u=e+8|0;q=c[r>>2]|0;v=+g[n>>2];o=+g[p>>2];w=0;while(1){if((w|0)>=(l|0))break;if(m){y=q+k|0;x=+g[a+((y+510&511)<<2)>>2]*+g[e>>2]+ +g[a+((y+511&511)<<2)>>2]*+g[t>>2]+ +g[a+((y&511)<<2)>>2]*+g[u>>2];}else x=0.0;A=+g[b+(w<<2)>>2]-v*f;z=A-(v*j+o*h);y=q+511&511;g[a+(y<<2)>>2]=z;g[d+(w<<2)>>2]=z-x;q=y;v=A;o=z;w=w+1|0;}g[n>>2]=v;g[p>>2]=o;c[r>>2]=q;i=s;return;}function Ng(d,e,f){d=d|0;e=e|0;f=f|0;var h=0,j=0,k=0,l=0,m=0,n=0.0,o=0,p=0.0;h=i;i=i+16|0;k=h;j=d+4797|0;a:do if((a[j>>0]|0)==2){n=1.0-+Og((+g[e+872>>2]+-12.0)*.25)*.5;l=d+4604|0;m=0;while(1){if((m|0)>=(c[l>>2]|0))break a;o=e+(m<<2)|0;g[o>>2]=+g[o>>2]*n;m=m+1|0;}}else l=d+4604|0;while(0);n=+pa(+((21.0-+(c[d+4748>>2]|0)*.0078125)*.33000001311302185));n=n/+(c[d+4612>>2]|0);o=0;while(1){m=c[l>>2]|0;if((o|0)>=(m|0)){o=0;break;}m=e+(o<<2)|0;p=+g[m>>2];p=+P(+(p*p+ +g[e+(o<<2)+876>>2]*n));g[m>>2]=p<32767.0?p:32767.0;o=o+1|0;}while(1){if((o|0)>=(m|0))break;c[k+(o<<2)>>2]=~~(+g[e+(o<<2)>>2]*65536.0);o=o+1|0;}yj(e+892|0,k|0,m<<2|0)|0;o=d+7200|0;a[e+908>>0]=a[o>>0]|0;fh(d+4768|0,k,o,(f|0)==2&1,c[l>>2]|0);f=0;while(1){if((f|0)>=(c[l>>2]|0))break;g[e+(f<<2)>>2]=+(c[k+(f<<2)>>2]|0)*152587890625.0e-16;f=f+1|0;}j=a[j>>0]|0;do if(j<<24>>24==2){k=d+4798|0;if(+g[e+872>>2]+ +(c[d+4744>>2]|0)*30517578125.0e-15>1.0){a[k>>0]=0;k=0;break;}else{a[k>>0]=1;k=1;break;}}else k=a[d+4798>>0]|0;while(0);g[e+852>>2]=+(c[d+4652>>2]|0)*-.05000000074505806+1.2000000476837158+ +(c[d+4556>>2]|0)*-.20000000298023224*.00390625+ +g[e+856>>2]*-.10000000149011612+ +g[e+860>>2]*-.20000000298023224+ +(b[24968+(j<<24>>24>>1<<2)+(k<<24>>24<<1)>>1]|0)*.0009765625*.800000011920929;i=h;return;}function Og(a){a=+a;a=1.0/(+Y(+-a)+1.0);return+a;}function Pg(a,b,c){a=a|0;b=b|0;c=+c;var d=0,e=0,f=0;d=i;e=0;while(1){if((e|0)>=5)break;f=a+(e*6<<2)|0;g[f>>2]=+g[f>>2]+c;e=e+1|0;}g[b>>2]=+g[b>>2]+c;i=d;return;}function Qg(a,b,c,d){a=a|0;b=b|0;c=c|0;d=+d;var e=0,f=0,h=0.0,j=0.0,k=0,l=0,m=0.0,n=0,o=0.0;e=i;j=0.0;h=(+g[b>>2]+ +g[b+96>>2])*9.99999993922529e-9;f=0;while(1){if((f|0)<10){k=0;j=0.0;}else{c=14;break;}while(1){if((k|0)>=5)break;m=j+ +g[c+(k<<2)>>2]*+g[a+(k<<2)>>2];k=k+1|0;j=m;}j=d-j*2.0;n=0;while(1){if((n|0)<5){k=n;m=0.0;}else break;while(1){l=k+1|0;if((l|0)>=5)break;k=l;m=m+ +g[b+(n+(l*5|0)<<2)>>2]*+g[a+(l<<2)>>2];}o=+g[a+(n<<2)>>2];j=j+o*(m*2.0+ +g[b+(n*6<<2)>>2]*o);n=n+1|0;}if(j>0.0){c=14;break;}else k=0;while(1){if((k|0)>=5)break;n=b+(k*6<<2)|0;g[n>>2]=+g[n>>2]+h;k=k+1|0;}h=h*2.0;f=f+1|0;}if((c|0)==14){i=e;return+((f|0)==10?1.0:j);}return 0.0;}function Rg(a,b,c,d,e,f,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0.0;n=i;i=i+768|0;j=n;l=j+(h<<2)|0;m=h+e|0;k=m<<1;Tf(j,c,b,k,h);o=+g[d>>2];g[a>>2]=o*o*+og(l,e);o=+g[d+4>>2];m=j+(m+h<<2)|0;g[a+4>>2]=o*o*+og(m,e);if((f|0)!=4){i=n;return;}Tf(j,c+64|0,b+(k<<2)|0,k,h);o=+g[d+8>>2];g[a+8>>2]=o*o*+og(l,e);o=+g[d+12>>2];g[a+12>>2]=o*o*+og(m,e);i=n;return;}function Sg(a,b,c,d){a=a|0;b=b|0;c=+c;d=d|0;var e=0,f=0,h=0,j=0;e=i;h=d&65532;f=0;while(1){if((f|0)>=(h|0))break;g[a+(f<<2)>>2]=+g[b+(f<<2)>>2]*c;j=f|1;g[a+(j<<2)>>2]=+g[b+(j<<2)>>2]*c;j=f|2;g[a+(j<<2)>>2]=+g[b+(j<<2)>>2]*c;j=f|3;g[a+(j<<2)>>2]=+g[b+(j<<2)>>2]*c;f=f+4|0;}while(1){if((f|0)>=(d|0))break;g[a+(f<<2)>>2]=+g[b+(f<<2)>>2]*c;f=f+1|0;}i=e;return;}function Tg(a,b){a=a|0;b=+b;var c=0,d=0,e=0;c=i;d=0;while(1){if((d|0)>=24)break;e=a+(d<<2)|0;g[e>>2]=+g[e>>2]*b;e=a+((d|1)<<2)|0;g[e>>2]=+g[e>>2]*b;e=a+((d|2)<<2)|0;g[e>>2]=+g[e>>2]*b;e=a+((d|3)<<2)|0;g[e>>2]=+g[e>>2]*b;d=d+4|0;}while(1){if((d|0)>=25)break;e=a+(d<<2)|0;g[e>>2]=+g[e>>2]*b;d=d+1|0;}i=c;return;}function Ug(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,h=0,j=0.0,k=0,l=0,m=0,n=0.0,o=0.0,p=0;e=i;i=i+144|0;d=e;h=c+1|0;f=0;while(1){if((f|0)>=(h|0))break;j=+g[b+(f<<2)>>2];g[d+(f<<3)+4>>2]=j;g[d+(f<<3)>>2]=j;f=f+1|0;}b=d+4|0;k=0;a:while(1){if((k|0)>=(c|0))break;l=k+1|0;j=+g[b>>2];j=-+g[d+(l<<3)>>2]/(j>9.999999717180685e-10?j:9.999999717180685e-10);g[a+(k<<2)>>2]=j;f=c-k|0;h=0;while(1){if((h|0)>=(f|0)){k=l;continue a;}p=d+(h+k+1<<3)|0;n=+g[p>>2];m=d+(h<<3)+4|0;o=+g[m>>2];g[p>>2]=n+o*j;g[m>>2]=o+n*j;h=h+1|0;}}i=e;return+ +g[b>>2];}function Vg(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,h=0;f=i;i=i+1152|0;d=f+128|0;e=f+64|0;h=f;Wg(a,5,d,h);Xg(d,5,b,e);b=0;while(1){if((b|0)>=5)break;a=e+(b<<2)|0;g[a>>2]=+g[a>>2]*+g[h+(b<<2)>>2];b=b+1|0;}Yg(d,5,e,c);i=f;return;}function Wg(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,h=0,j=0,k=0.0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0.0,t=0,u=0.0,v=0.0;j=i;i=i+128|0;h=j+64|0;f=j;k=(+g[a>>2]+ +g[a+(($(b,b)|0)+-1<<2)>>2])*4999999873689376.0e-21;m=1;l=0;a:while(1){if((l|0)<(b|0)&(m|0)==1)n=0;else break;b:while(1){if((n|0)>=(b|0)){e=16;break;}m=$(n,b)|0;p=m+n|0;o=0;s=+g[a+(p<<2)>>2];while(1){if((o|0)>=(n|0))break;v=+g[c+(m+o<<2)>>2];u=v*+g[f+(o<<2)>>2];g[h+(o<<2)>>2]=u;o=o+1|0;s=s-v*u;}if(s<k)break;g[f+(n<<2)>>2]=s;o=d+(n<<2)|0;g[o>>2]=1.0/s;g[c+(p<<2)>>2]=1.0;p=n+1|0;q=c+(($(p,b)|0)<<2)|0;t=n;while(1){t=t+1|0;if((t|0)<(b|0)){r=0;s=0.0;}else{n=p;continue b;}while(1){if((r|0)>=(n|0))break;v=s+ +g[q+(r<<2)>>2]*+g[h+(r<<2)>>2];r=r+1|0;s=v;}g[c+(($(t,b)|0)+n<<2)>>2]=(+g[a+(m+t<<2)>>2]-s)*+g[o>>2];q=q+(b<<2)|0;}}if((e|0)==16){e=0;m=0;l=l+1|0;continue;}l=l+1|0;s=+(l|0)*k-s;m=0;while(1){if((m|0)>=(b|0)){m=1;continue a;}t=a+(($(m,b)|0)+m<<2)|0;g[t>>2]=+g[t>>2]+s;m=m+1|0;}}i=j;return;}function Xg(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,h=0.0,j=0,k=0,l=0.0;e=i;f=0;while(1){if((f|0)>=(b|0))break;j=$(f,b)|0;k=0;h=0.0;while(1){if((k|0)>=(f|0))break;l=h+ +g[a+(j+k<<2)>>2]*+g[d+(k<<2)>>2];k=k+1|0;h=l;}g[d+(f<<2)>>2]=+g[c+(f<<2)>>2]-h;f=f+1|0;}i=e;return;}function Yg(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,h=0.0,j=0,k=0,l=0.0;e=i;j=b;while(1){f=j+-1|0;if((j|0)>0){j=b;h=0.0;}else break;while(1){k=j+-1|0;if((k|0)<=(f|0))break;l=+g[a+(f+($(k,b)|0)<<2)>>2];j=k;h=h+l*+g[d+(k<<2)>>2];}g[d+(f<<2)>>2]=+g[c+(f<<2)>>2]-h;j=f;}i=e;return;}function Zg(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,h=0,j=0,k=0.0,l=0,m=0.0,n=0;f=i;h=0;while(1){if((h|0)>=(e|0)){h=1;break;}c[b+(h<<2)>>2]=h;h=h+1|0;}while(1){if((h|0)>=(e|0))break;k=+g[a+(h<<2)>>2];j=h;while(1){l=j+-1|0;if((j|0)<=0)break;m=+g[a+(l<<2)>>2];if(!(k>m))break;g[a+(j<<2)>>2]=m;c[b+(j<<2)>>2]=c[b+(l<<2)>>2];j=l;}g[a+(j<<2)>>2]=k;c[b+(j<<2)>>2]=h;h=h+1|0;}h=a+(e+-1<<2)|0;j=e+-2|0;while(1){if((e|0)>=(d|0))break;k=+g[a+(e<<2)>>2];if(k>+g[h>>2]){l=j;while(1){if((l|0)<=-1)break;m=+g[a+(l<<2)>>2];if(!(k>m))break;n=l+1|0;g[a+(n<<2)>>2]=m;c[b+(n<<2)>>2]=c[b+(l<<2)>>2];l=l+-1|0;}n=l+1|0;g[a+(n<<2)>>2]=k;c[b+(n<<2)>>2]=e;}e=e+1|0;}i=f;return;}function _g(a,b,c,d,e){a=a|0;b=b|0;c=+c;d=d|0;e=e|0;var f=0,j=0,k=0,l=0,m=0,n=0,o=0.0,p=0,q=0.0,r=0.0,s=0.0,t=0.0,u=0,v=0,w=0;j=i;i=i+272|0;k=j+136|0;f=j;wj(k|0,0,136)|0;wj(f|0,0,136)|0;n=k+(e<<3)|0;m=f+(e<<3)|0;o=0.0;l=0;while(1){if((l|0)>=(d|0))break;p=0;q=+g[b+(l<<2)>>2];while(1){if((p|0)>=(e|0))break;v=p|1;w=k+(v<<3)|0;t=+h[w>>3];r=o+c*(t-q);h[k+(p<<3)>>3]=q;u=f+(p<<3)|0;h[u>>3]=+h[u>>3]+ +h[k>>3]*q;u=p+2|0;s=+h[k+(u<<3)>>3];h[w>>3]=r;v=f+(v<<3)|0;h[v>>3]=+h[v>>3]+ +h[k>>3]*r;o=s;p=u;q=t+c*(s-r);}h[n>>3]=q;o=+h[k>>3];h[m>>3]=+h[m>>3]+o*q;l=l+1|0;}k=e+1|0;d=0;while(1){if((d|0)>=(k|0))break;g[a+(d<<2)>>2]=+h[f+(d<<3)>>3];d=d+1|0;}i=j;return;}function $g(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,h=0;f=i;i=i+64|0;e=f;h=0;while(1){if((h|0)>=(d|0))break;c[e+(h<<2)>>2]=ah(+g[b+(h<<2)>>2]*65536.0)|0;h=h+1|0;}Fd(a,e,d);i=f;return;}function ah(a){a=+a;var b=0,c=0;c=i;b=sa(+a)|0;i=c;return b|0;}function bh(a,c,d){a=a|0;c=c|0;d=d|0;var e=0,f=0;e=i;i=i+32|0;f=e;Zd(f,c,d);c=0;while(1){if((c|0)>=(d|0))break;g[a+(c<<2)>>2]=+(b[f+(c<<1)>>1]|0)*.000244140625;c=c+1|0;}i=e;return;}function ch(a,d,e,f){a=a|0;d=d|0;e=e|0;f=f|0;var h=0,j=0;h=i;i=i+64|0;j=h;th(a,j,e,f);a=a+4664|0;f=0;while(1){if((f|0)<2)e=0;else break;while(1){if((e|0)>=(c[a>>2]|0))break;g[d+(f<<6)+(e<<2)>>2]=+(b[j+(f<<5)+(e<<1)>>1]|0)*.000244140625;e=e+1|0;}f=f+1|0;}i=h;return;}function dh(d,e,f,h,j,k){d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0;s=i;i=i+1584|0;m=s+64|0;l=s+48|0;t=s+1512|0;n=s+1472|0;o=s+1344|0;r=s+32|0;q=s+16|0;p=s;u=d+4604|0;w=d+4660|0;v=0;while(1){x=c[u>>2]|0;if((v|0)>=(x|0)){v=0;break;}x=v<<4;y=0;while(1){if((y|0)>=(c[w>>2]|0))break;z=x+y|0;b[o+(z<<1)>>1]=ah(+g[e+(z<<2)+500>>2]*8192.0)|0;y=y+1|0;}v=v+1|0;}while(1){if((v|0)>=(x|0))break;x=(ah(+g[e+(v<<2)+772>>2]*16384.0)|0)<<16;c[r+(v<<2)>>2]=x|(ah(+g[e+(v<<2)+756>>2]*16384.0)|0)&65535;c[q+(v<<2)>>2]=ah(+g[e+(v<<2)+820>>2]*16384.0)|0;c[p+(v<<2)>>2]=ah(+g[e+(v<<2)+836>>2]*16384.0)|0;x=c[u>>2]|0;v=v+1|0;}v=ah(+g[e+852>>2]*1024.0)|0;w=0;while(1){if((w|0)>=((c[u>>2]|0)*5|0))break;b[n+(w<<1)>>1]=ah(+g[e+(w<<2)+144>>2]*16384.0)|0;w=w+1|0;}w=d+4664|0;x=0;while(1){if((x|0)<2)y=0;else{w=0;break;}while(1){if((y|0)>=(c[w>>2]|0))break;b[t+(x<<5)+(y<<1)>>1]=ah(+g[e+(x<<6)+(y<<2)+16>>2]*4096.0)|0;y=y+1|0;}x=x+1|0;}while(1){if((w|0)>=(c[u>>2]|0))break;c[l+(w<<2)>>2]=ah(+g[e+(w<<2)>>2]*65536.0)|0;w=w+1|0;}if((a[f+29>>0]|0)==2)w=b[24976+(a[f+33>>0]<<1)>>1]|0;else w=0;u=d+4608|0;x=0;while(1){if((x|0)>=(c[u>>2]|0))break;c[m+(x<<2)>>2]=ah(+g[k+(x<<2)>>2]*8.0)|0;x=x+1|0;}if((c[d+4652>>2]|0)<=1?(c[d+4704>>2]|0)<=0:0){te(d,h,f,m,j,t,n,o,p,q,r,l,e+228|0,v,w);i=s;return;}ze(d,h,f,m,j,t,n,o,p,q,r,l,e+228|0,v,w);i=s;return;}function eh(a,d,e,f,h,j,k,l,m){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;var n=0,o=0,p=0,q=0,r=0,s=0;p=i;i=i+448|0;o=p+400|0;q=p;n=l*5|0;r=0;while(1){if((r|0)>=(n|0))break;b[o+(r<<1)>>1]=ah(+g[a+(r<<2)>>2]*16384.0)|0;r=r+1|0;}r=l*25|0;s=0;while(1){if((s|0)>=(r|0))break;c[q+(s<<2)>>2]=ah(+g[h+(s<<2)>>2]*262144.0)|0;s=s+1|0;}uh(o,d,e,f,q,j,k,l,m);j=0;while(1){if((j|0)>=(n|0))break;g[a+(j<<2)>>2]=+(b[o+(j<<1)>>1]|0)*6103515625.0e-14;j=j+1|0;}i=p;return;}function fh(b,e,f,g,h){b=b|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0;j=i;l=(g|0)==0;g=0;while(1){if((g|0)>=(h|0))break;k=e+(g<<2)|0;oh(c[k>>2]|0)|0;n=((((oh(c[k>>2]|0)|0)<<16)+-136970240>>16)*2251|0)>>>16&255;m=b+g|0;a[m>>0]=n;if(n<<24>>24<(a[f>>0]|0)){n=n+1<<24>>24;a[m>>0]=n;}if(n<<24>>24>63)n=63;else n=n<<24>>24<0?0:n;a[m>>0]=n;if((g|0)==0^1|l^1){p=(n&255)-(d[f>>0]|0)|0;o=p&255;a[m>>0]=o;n=(a[f>>0]|0)+8|0;p=p<<24>>24;if((p|0)>(n|0)){o=n+((p-n+1|0)>>>1)&255;a[m>>0]=o;}if(o<<24>>24>36)p=36;else p=o<<24>>24<-4?-4:o;a[m>>0]=p;o=p<<24>>24;if((o|0)>(n|0))n=(d[f>>0]|0)+((o<<1)-n)|0;else n=(d[f>>0]|0)+(p&255)|0;a[f>>0]=n;a[m>>0]=(d[m>>0]|0)+4;m=a[f>>0]|0;}else{m=(a[f>>0]|0)+-4|0;n=a[b>>0]|0;if((m|0)>63){o=n<<24>>24;if((o|0)<=(m|0))m=n<<24>>24<63?63:o;}else if(n<<24>>24>63)m=63;else{p=n<<24>>24;m=(p|0)<(m|0)?m:p;}m=m&255;a[b>>0]=m;a[f>>0]=m;}p=m<<24>>24;c[k>>2]=sh(gh((p*29|0)+(p*7281>>16)+2090|0)|0)|0;g=g+1|0;}i=j;return;}function gh(a){a=a|0;return((a|0)<3967?a:3967)|0;}function hh(b,d,e,f,g){b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0;h=i;f=(f|0)==0;j=0;while(1){if((j|0)>=(g|0))break;do if((j|0)==0^1|f^1){l=(a[d+j>>0]|0)+-4|0;m=a[e>>0]|0;k=(m<<24>>24)+8|0;if((l|0)>(k|0)){k=(m&255)+((l<<1)-k)&255;a[e>>0]=k;break;}else{k=(m&255)+l&255;a[e>>0]=k;break;}}else{k=(ih(a[d>>0]|0,(a[e>>0]|0)+-16|0)|0)&255;a[e>>0]=k;}while(0);if(k<<24>>24>63)k=63;else k=k<<24>>24<0?0:k;a[e>>0]=k;m=k<<24>>24;c[b+(j<<2)>>2]=sh(gh((m*29|0)+(m*7281>>16)+2090|0)|0)|0;j=j+1|0;}i=h;return;}function ih(a,b){a=a|0;b=b|0;return((a|0)>(b|0)?a:b)|0;}function jh(b,c){b=b|0;c=c|0;var d=0,e=0,f=0;d=i;e=0;f=0;while(1){if((f|0)>=(c|0))break;e=(a[b+f>>0]|0)+(e<<8)|0;f=f+1|0;}i=d;return e|0;}function kh(a){a=a|0;var b=0;b=i;wj(a|0,0,4260)|0;c[a+2376>>2]=1;c[a>>2]=65536;Kd(a);Ge(a);i=b;return;}function lh(a,b){a=a|0;b=b|0;var d=0;d=i;wj(a|0,0,12240)|0;c[a+5124>>2]=b;b=((oh(3932160)|0)<<8)+-524288|0;c[a+8>>2]=b;c[a+12>>2]=b;c[a+4696>>2]=1;b=We(a+32|0)|0;i=d;return b|0;}function mh(a,c,d,e){a=a|0;c=c|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0;f=i;h=0;g=0;while(1){if((h|0)>=(e|0))break;j=g+(($(b[a+(h<<1)>>1]|0,b[c+(h<<1)>>1]|0)|0)>>d)|0;h=h+1|0;g=j;}i=f;return g|0;}function nh(a,c,d,f,g){a=a|0;c=c|0;d=d|0;f=f|0;g=g|0;var h=0,j=0,k=0;h=i;j=f<<16>>16;f=0;while(1){if((f|0)>=(g|0))break;k=e[c+(f<<1)>>1]|0;b[a+(f<<1)>>1]=k+(($((e[d+(f<<1)>>1]|0)-k<<16>>16,j)|0)>>>2);f=f+1|0;}i=h;return;}function oh(a){a=a|0;var b=0,d=0,e=0;e=i;i=i+16|0;d=e+4|0;b=e;ph(a,d,b);b=c[b>>2]|0;a=$(b,128-b|0)|0;i=e;return(31-(c[d>>2]|0)<<7)+(b+(((a>>16)*179|0)+(((a&65535)*179|0)>>>16)))|0;}function ph(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=i;f=qh(a)|0;c[b>>2]=f;c[d>>2]=(rh(a,24-f|0)|0)&127;i=e;return;}function qh(a){a=a|0;var b=0;b=i;if(!a)a=32;else a=vj(a|0)|0;i=b;return a|0;}function rh(a,b){a=a|0;b=b|0;var c=0,d=0;c=i;d=0-b|0;do if(b)if((b|0)<0){a=a<<d|a>>>(b+32|0);break;}else{a=a<<32-b|a>>>b;break;}while(0);i=c;return a|0;}function sh(a){a=a|0;var b=0,c=0,d=0,e=0;b=i;if((a|0)<0){e=0;i=b;return e|0;}if((a|0)>3966){e=2147483647;i=b;return e|0;}d=a>>7;c=1<<d;e=a&127;if((a|0)<2048)a=e+(($($(e,128-e|0)|0,-174)|0)>>16)<<d>>7;else a=$(c>>7,e+(($($(e,128-e|0)|0,-174)|0)>>16)|0)|0;e=c+a|0;i=b;return e|0;}function th(d,e,f,g){d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0;j=i;i=i+96|0;h=j+64|0;k=j+32|0;l=j;n=c[d+4556>>2]<<16>>16;n=($(n,-5)|0)+(n*59246>>16)+3146|0;if((c[d+4604>>2]|0)==2)n=n+(n>>1)|0;m=d+4664|0;ae(k,f,c[m>>2]|0);a:do if((c[d+4656>>2]|0)==1){p=d+4799|0;q=a[p>>0]|0;r=q<<24>>24<4;o=r&1;if(r){nh(h,g,f,q<<24>>24,c[m>>2]|0);ae(l,h,c[m>>2]|0);q=a[p>>0]|0;q=($(q,q)|0)<<27;p=c[m>>2]|0;q=q>>16;r=0;while(1){if((r|0)>=(p|0))break a;s=k+(r<<1)|0;t=b[l+(r<<1)>>1]|0;b[s>>1]=((b[s>>1]|0)>>>1)+(($(t<<16>>16>>16,q)|0)+(($(t&65535,q)|0)>>>16));r=r+1|0;}}}else o=0;while(0);ke(d+4776|0,f,c[d+4724>>2]|0,k,n,c[d+4692>>2]|0,a[d+4797>>0]|0);Zd(e+32|0,f,c[m>>2]|0);if(!o){yj(e|0,e+32|0,c[m>>2]<<1|0)|0;i=j;return;}else{nh(h,g,f,a[d+4799>>0]|0,c[m>>2]|0);Zd(e,h,c[m>>2]|0);i=j;return;}}function uh(d,e,f,g,h,j,k,l,m){d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;var n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0;m=i;i=i+16|0;p=m+8|0;o=m+4|0;n=m;k=(k|0)!=0;r=0;s=2147483647;q=0;while(1){if((q|0)>=3)break;w=c[22392+(q<<2)>>2]|0;u=c[22688+(q<<2)>>2]|0;v=c[22760+(q<<2)>>2]|0;x=a[22776+q>>0]|0;y=h;z=d;B=0;A=0;t=c[g>>2]|0;while(1){if((A|0)>=(l|0))break;ef(p+A|0,o,n,z,y,u,v,w,j,(sh(5333-t+896|0)|0)+-51|0,x);B=B+(c[o>>2]|0)|0;C=(c[n>>2]|0)+51|0;if((t+(oh(C)|0)+-896|0)<0)t=0;else t=t+(oh(C)|0)+-896|0;y=y+100|0;z=z+10|0;B=(B|0)<0?2147483647:B;A=A+1|0;}u=(B|0)==2147483647?2147483646:B;if((u|0)<(s|0)){a[f>>0]=q;yj(e|0,p|0,l|0)|0;r=t;s=u;}if(k&(u|0)<12304)break;q=q+1|0;}o=c[22688+(a[f>>0]<<2)>>2]|0;j=0;while(1){if((j|0)>=(l|0))break;n=e+j|0;h=j*5|0;f=0;while(1){if((f|0)>=5)break;b[d+(h+f<<1)>>1]=a[o+(((a[n>>0]|0)*5|0)+f)>>0]<<7;f=f+1|0;}j=j+1|0;}c[g>>2]=r;i=m;return;}function vh(b,d,e,f){b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0;g=i;wj(b|0,0,300)|0;do if(!f){if(!((d|0)==8e3|(d|0)==12e3|(d|0)==16e3)){h=-1;i=g;return h|0;}if((e|0)==48e3|(e|0)==24e3|(e|0)==16e3|(e|0)==12e3|(e|0)==8e3){c[b+292>>2]=a[((e>>12)-((e|0)>16e3&1)>>((e|0)>24e3&1))+-1+(21536+((((d>>12)-((d|0)>16e3&1)>>((d|0)>24e3&1))+-1|0)*5|0))>>0];break;}else{h=-1;i=g;return h|0;}}else{if(!((d|0)==8e3|(d|0)==12e3|(d|0)==16e3|(d|0)==24e3|(d|0)==48e3)){h=-1;i=g;return h|0;}if((e|0)==16e3|(e|0)==12e3|(e|0)==8e3){c[b+292>>2]=a[((e>>12)-((e|0)>16e3&1)>>((e|0)>24e3&1))+-1+(21520+((((d>>12)-((d|0)>16e3&1)>>((d|0)>24e3&1))+-1|0)*3|0))>>0];break;}else{h=-1;i=g;return h|0;}}while(0);h=(d|0)/1e3|0;c[b+284>>2]=h;c[b+288>>2]=(e|0)/1e3|0;c[b+268>>2]=h*10;do if((e|0)>(d|0)){f=b+264|0;if((d<<1|0)==(e|0)){c[f>>2]=1;h=0;break;}else{c[f>>2]=2;h=1;break;}}else{f=b+264|0;if((e|0)>=(d|0)){c[f>>2]=0;h=0;break;}c[f>>2]=3;h=e<<2;if((h|0)==(d*3|0)){c[b+280>>2]=3;c[b+276>>2]=18;c[b+296>>2]=21552;h=0;break;}f=e*3|0;if((f|0)==(d<<1|0)){c[b+280>>2]=2;c[b+276>>2]=18;c[b+296>>2]=21616;h=0;break;}if((e<<1|0)==(d|0)){c[b+280>>2]=1;c[b+276>>2]=24;c[b+296>>2]=21656;h=0;break;}if((f|0)==(d|0)){c[b+280>>2]=1;c[b+276>>2]=36;c[b+296>>2]=21688;h=0;break;}if((h|0)==(d|0)){c[b+280>>2]=1;c[b+276>>2]=36;c[b+296>>2]=21728;h=0;break;}if((e*6|0)==(d|0)){c[b+280>>2]=1;c[b+276>>2]=36;c[b+296>>2]=21768;h=0;break;}else{h=-1;i=g;return h|0;}}while(0);j=((d<<(h|14)|0)/(e|0)|0)<<2;f=b+272|0;c[f>>2]=j;b=e<<16>>16;e=(e>>15)+1>>1;h=d<<h;d=j;while(1){if((($(d>>16,b)|0)+(($(d&65535,b)|0)>>16)+($(d,e)|0)|0)>=(h|0)){d=0;break;}j=d+1|0;c[f>>2]=j;d=j;}i=g;return d|0;}function wh(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0;f=i;h=a+284|0;g=a+292|0;k=c[g>>2]|0;j=(c[h>>2]|0)-k|0;yj(a+(k<<1)+168|0,d|0,j<<1|0)|0;k=c[a+264>>2]|0;if((k|0)==1){Fh(a,b,a+168|0,c[h>>2]|0);Fh(a,b+(c[a+288>>2]<<1)|0,d+(j<<1)|0,e-(c[h>>2]|0)|0);}else if((k|0)==3){Ch(a,b,a+168|0,c[h>>2]|0);Ch(a,b+(c[a+288>>2]<<1)|0,d+(j<<1)|0,e-(c[h>>2]|0)|0);}else if((k|0)==2){Ah(a,b,a+168|0,c[h>>2]|0);Ah(a,b+(c[a+288>>2]<<1)|0,d+(j<<1)|0,e-(c[h>>2]|0)|0);}else{yj(b|0,a+168|0,c[h>>2]<<1|0)|0;yj(b+(c[a+288>>2]<<1)|0,d+(j<<1)|0,e-(c[h>>2]|0)<<1|0)|0;}b=c[g>>2]|0;yj(a+168|0,d+(e-b<<1)|0,b<<1|0)|0;i=f;return;}function xh(a,d,e,f){a=a|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0;g=i;h=f>>1;f=a+4|0;j=0;while(1){if((j|0)>=(h|0))break;o=j<<1;n=b[e+(o<<1)>>1]<<10;l=n-(c[a>>2]|0)|0;m=($(l>>16,-25727)|0)+(($(l&65535,-25727)|0)>>16)|0;c[a>>2]=n+(l+m);o=b[e+((o|1)<<1)>>1]<<10;l=c[f>>2]|0;k=o-l|0;k=((k>>16)*9872|0)+(((k&65535)*9872|0)>>>16)|0;c[f>>2]=o+k;k=(n+m+l+k>>10)+1>>1;if((k|0)>32767)k=32767;else k=(k|0)<-32768?-32768:k&65535;b[d+(j<<1)>>1]=k;j=j+1|0;}i=g;return;}function yh(a,d,e,f){a=a|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;g=i;i=i+1936|0;k=g;c[k+0>>2]=c[a+0>>2];c[k+4>>2]=c[a+4>>2];c[k+8>>2]=c[a+8>>2];c[k+12>>2]=c[a+12>>2];h=a+16|0;j=k+16|0;while(1){l=(f|0)<480?f:480;zh(h,j,e,21808,l);o=k;m=l;while(1){if((m|0)<=2)break;u=c[o>>2]|0;p=o+4|0;t=c[p>>2]|0;q=o+8|0;s=c[q>>2]|0;n=o+12|0;r=c[n>>2]|0;r=(((u>>16)*4697|0)+(((u&65535)*4697|0)>>>16)+(((t>>16)*10739|0)+(((t&65535)*10739|0)>>>16))+(((s>>16)*8276|0)+(((s&65535)*8276|0)>>>16))+(((r>>16)*1567|0)+(((r&65535)*1567|0)>>>16))>>5)+1>>1;if((r|0)>32767)r=32767;else r=(r|0)<-32768?-32768:r&65535;b[d>>1]=r;s=c[p>>2]|0;t=c[q>>2]|0;u=c[n>>2]|0;o=c[o+16>>2]|0;o=(((s>>16)*1567|0)+(((s&65535)*1567|0)>>>16)+(((t>>16)*8276|0)+(((t&65535)*8276|0)>>>16))+(((u>>16)*10739|0)+(((u&65535)*10739|0)>>>16))+(((o>>16)*4697|0)+(((o&65535)*4697|0)>>>16))>>5)+1>>1;if((o|0)>32767)o=32767;else o=(o|0)<-32768?-32768:o&65535;b[d+2>>1]=o;d=d+4|0;o=n;m=m+-3|0;}f=f-l|0;if((f|0)<=0)break;u=e+(l<<1)|0;t=k+(l<<2)|0;c[k+0>>2]=c[t+0>>2];c[k+4>>2]=c[t+4>>2];c[k+8>>2]=c[t+8>>2];c[k+12>>2]=c[t+12>>2];e=u;}u=k+(l<<2)|0;c[a+0>>2]=c[u+0>>2];c[a+4>>2]=c[u+4>>2];c[a+8>>2]=c[u+8>>2];c[a+12>>2]=c[u+12>>2];i=g;return;}function zh(a,d,e,f,g){a=a|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0;h=i;k=a+4|0;l=f+2|0;j=0;while(1){if((j|0)>=(g|0))break;n=(c[a>>2]|0)+(b[e+(j<<1)>>1]<<8)|0;c[d+(j<<2)>>2]=n;n=n<<2;o=n>>16;m=b[f>>1]|0;n=n&65532;c[a>>2]=(c[k>>2]|0)+(($(o,m)|0)+(($(n,m)|0)>>16));m=b[l>>1]|0;c[k>>2]=($(o,m)|0)+(($(n,m)|0)>>16);j=j+1|0;}i=h;return;}function Ah(a,d,e,f){a=a|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0;h=i;n=c[a+268>>2]|0;m=i;i=i+((2*((n<<1)+8|0)|0)+15&-16)|0;g=a+24|0;b[m+0>>1]=b[g+0>>1]|0;b[m+2>>1]=b[g+2>>1]|0;b[m+4>>1]=b[g+4>>1]|0;b[m+6>>1]=b[g+6>>1]|0;b[m+8>>1]=b[g+8>>1]|0;b[m+10>>1]=b[g+10>>1]|0;b[m+12>>1]=b[g+12>>1]|0;b[m+14>>1]=b[g+14>>1]|0;k=c[a+272>>2]|0;l=a+268|0;j=m+16|0;while(1){n=(f|0)<(n|0)?f:n;Eh(a,j,e,n);d=Bh(d,m,n<<17,k)|0;f=f-n|0;if((f|0)<=0)break;o=e+(n<<1)|0;n=m+(n<<1<<1)|0;b[m+0>>1]=b[n+0>>1]|0;b[m+2>>1]=b[n+2>>1]|0;b[m+4>>1]=b[n+4>>1]|0;b[m+6>>1]=b[n+6>>1]|0;b[m+8>>1]=b[n+8>>1]|0;b[m+10>>1]=b[n+10>>1]|0;b[m+12>>1]=b[n+12>>1]|0;b[m+14>>1]=b[n+14>>1]|0;e=o;n=c[l>>2]|0;}o=m+(n<<1<<1)|0;b[g+0>>1]=b[o+0>>1]|0;b[g+2>>1]=b[o+2>>1]|0;b[g+4>>1]=b[o+4>>1]|0;b[g+6>>1]=b[o+6>>1]|0;b[g+8>>1]=b[o+8>>1]|0;b[g+10>>1]=b[o+10>>1]|0;b[g+12>>1]=b[o+12>>1]|0;b[g+14>>1]=b[o+14>>1]|0;i=h;return;}function Bh(a,c,d,e){a=a|0;c=c|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0;f=i;g=0;while(1){if((g|0)>=(d|0))break;h=((g&65535)*12|0)>>>16;j=g>>16;k=$(b[c+(j<<1)>>1]|0,b[21824+(h<<3)>>1]|0)|0;k=k+($(b[c+(j+1<<1)>>1]|0,b[21826+(h<<3)>>1]|0)|0)|0;k=k+($(b[c+(j+2<<1)>>1]|0,b[21828+(h<<3)>>1]|0)|0)|0;k=k+($(b[c+(j+3<<1)>>1]|0,b[21830+(h<<3)>>1]|0)|0)|0;h=11-h|0;k=k+($(b[c+(j+4<<1)>>1]|0,b[21830+(h<<3)>>1]|0)|0)|0;k=k+($(b[c+(j+5<<1)>>1]|0,b[21828+(h<<3)>>1]|0)|0)|0;k=k+($(b[c+(j+6<<1)>>1]|0,b[21826+(h<<3)>>1]|0)|0)|0;h=(k+($(b[c+(j+7<<1)>>1]|0,b[21824+(h<<3)>>1]|0)|0)>>14)+1>>1;if((h|0)>32767)h=32767;else h=(h|0)<-32768?-32768:h&65535;b[a>>1]=h;a=a+2|0;g=g+e|0;}i=f;return a|0;}function Ch(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;j=i;p=c[a+268>>2]|0;q=c[a+276>>2]|0;g=i;i=i+((4*(p+q|0)|0)+15&-16)|0;o=a+24|0;h=a+276|0;yj(g|0,o|0,q<<2|0)|0;k=a+296|0;l=(c[k>>2]|0)+4|0;n=c[a+272>>2]|0;f=a+268|0;m=a+280|0;while(1){p=(e|0)<(p|0)?e:p;zh(a,g+(q<<2)|0,d,c[k>>2]|0,p);b=Dh(b,g,l,c[h>>2]|0,c[m>>2]|0,p<<16,n)|0;e=e-p|0;if((e|0)<=1)break;q=c[h>>2]|0;yj(g|0,g+(p<<2)|0,q<<2|0)|0;d=d+(p<<1)|0;p=c[f>>2]|0;}yj(o|0,g+(p<<2)|0,c[h>>2]<<2|0)|0;i=j;return;}function Dh(a,d,e,f,g,h,j){a=a|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0;k=i;if((f|0)==36){m=e+2|0;n=e+4|0;o=e+6|0;p=e+8|0;q=e+10|0;r=e+12|0;s=e+14|0;t=e+16|0;u=e+18|0;v=e+20|0;w=e+22|0;x=e+24|0;y=e+26|0;z=e+28|0;l=e+30|0;g=e+32|0;f=e+34|0;A=0;while(1){if((A|0)>=(h|0))break;C=A>>16;B=(c[d+(C<<2)>>2]|0)+(c[d+(C+35<<2)>>2]|0)|0;D=b[e>>1]|0;D=($(B>>16,D)|0)+(($(B&65535,D)|0)>>16)|0;B=(c[d+(C+1<<2)>>2]|0)+(c[d+(C+34<<2)>>2]|0)|0;E=b[m>>1]|0;E=D+(($(B>>16,E)|0)+(($(B&65535,E)|0)>>16))|0;B=(c[d+(C+2<<2)>>2]|0)+(c[d+(C+33<<2)>>2]|0)|0;D=b[n>>1]|0;D=E+(($(B>>16,D)|0)+(($(B&65535,D)|0)>>16))|0;B=(c[d+(C+3<<2)>>2]|0)+(c[d+(C+32<<2)>>2]|0)|0;E=b[o>>1]|0;E=D+(($(B>>16,E)|0)+(($(B&65535,E)|0)>>16))|0;B=(c[d+(C+4<<2)>>2]|0)+(c[d+(C+31<<2)>>2]|0)|0;D=b[p>>1]|0;D=E+(($(B>>16,D)|0)+(($(B&65535,D)|0)>>16))|0;B=(c[d+(C+5<<2)>>2]|0)+(c[d+(C+30<<2)>>2]|0)|0;E=b[q>>1]|0;E=D+(($(B>>16,E)|0)+(($(B&65535,E)|0)>>16))|0;B=(c[d+(C+6<<2)>>2]|0)+(c[d+(C+29<<2)>>2]|0)|0;D=b[r>>1]|0;D=E+(($(B>>16,D)|0)+(($(B&65535,D)|0)>>16))|0;B=(c[d+(C+7<<2)>>2]|0)+(c[d+(C+28<<2)>>2]|0)|0;E=b[s>>1]|0;E=D+(($(B>>16,E)|0)+(($(B&65535,E)|0)>>16))|0;B=(c[d+(C+8<<2)>>2]|0)+(c[d+(C+27<<2)>>2]|0)|0;D=b[t>>1]|0;D=E+(($(B>>16,D)|0)+(($(B&65535,D)|0)>>16))|0;B=(c[d+(C+9<<2)>>2]|0)+(c[d+(C+26<<2)>>2]|0)|0;E=b[u>>1]|0;E=D+(($(B>>16,E)|0)+(($(B&65535,E)|0)>>16))|0;B=(c[d+(C+10<<2)>>2]|0)+(c[d+(C+25<<2)>>2]|0)|0;D=b[v>>1]|0;D=E+(($(B>>16,D)|0)+(($(B&65535,D)|0)>>16))|0;B=(c[d+(C+11<<2)>>2]|0)+(c[d+(C+24<<2)>>2]|0)|0;E=b[w>>1]|0;E=D+(($(B>>16,E)|0)+(($(B&65535,E)|0)>>16))|0;B=(c[d+(C+12<<2)>>2]|0)+(c[d+(C+23<<2)>>2]|0)|0;D=b[x>>1]|0;D=E+(($(B>>16,D)|0)+(($(B&65535,D)|0)>>16))|0;B=(c[d+(C+13<<2)>>2]|0)+(c[d+(C+22<<2)>>2]|0)|0;E=b[y>>1]|0;E=D+(($(B>>16,E)|0)+(($(B&65535,E)|0)>>16))|0;B=(c[d+(C+14<<2)>>2]|0)+(c[d+(C+21<<2)>>2]|0)|0;D=b[z>>1]|0;D=E+(($(B>>16,D)|0)+(($(B&65535,D)|0)>>16))|0;B=(c[d+(C+15<<2)>>2]|0)+(c[d+(C+20<<2)>>2]|0)|0;E=b[l>>1]|0;E=D+(($(B>>16,E)|0)+(($(B&65535,E)|0)>>16))|0;B=(c[d+(C+16<<2)>>2]|0)+(c[d+(C+19<<2)>>2]|0)|0;D=b[g>>1]|0;D=E+(($(B>>16,D)|0)+(($(B&65535,D)|0)>>16))|0;C=(c[d+(C+17<<2)>>2]|0)+(c[d+(C+18<<2)>>2]|0)|0;B=b[f>>1]|0;B=(D+(($(C>>16,B)|0)+(($(C&65535,B)|0)>>16))>>5)+1>>1;if((B|0)>32767)B=32767;else B=(B|0)<-32768?-32768:B&65535;b[a>>1]=B;a=a+2|0;A=A+j|0;}i=k;return a|0;}else if((f|0)==18){f=g<<16>>16;g=g+-1|0;l=0;while(1){if((l|0)>=(h|0))break;E=l>>16;m=($(l&65535,f)|0)>>16;D=m*9|0;C=c[d+(E<<2)>>2]|0;A=b[e+(D<<1)>>1]|0;A=($(C>>16,A)|0)+(($(C&65535,A)|0)>>16)|0;C=c[d+(E+1<<2)>>2]|0;B=b[e+(D+1<<1)>>1]|0;B=A+(($(C>>16,B)|0)+(($(C&65535,B)|0)>>16))|0;C=c[d+(E+2<<2)>>2]|0;A=b[e+(D+2<<1)>>1]|0;A=B+(($(C>>16,A)|0)+(($(C&65535,A)|0)>>16))|0;C=c[d+(E+3<<2)>>2]|0;B=b[e+(D+3<<1)>>1]|0;B=A+(($(C>>16,B)|0)+(($(C&65535,B)|0)>>16))|0;C=c[d+(E+4<<2)>>2]|0;A=b[e+(D+4<<1)>>1]|0;A=B+(($(C>>16,A)|0)+(($(C&65535,A)|0)>>16))|0;C=c[d+(E+5<<2)>>2]|0;B=b[e+(D+5<<1)>>1]|0;B=A+(($(C>>16,B)|0)+(($(C&65535,B)|0)>>16))|0;C=c[d+(E+6<<2)>>2]|0;A=b[e+(D+6<<1)>>1]|0;A=B+(($(C>>16,A)|0)+(($(C&65535,A)|0)>>16))|0;C=c[d+(E+7<<2)>>2]|0;B=b[e+(D+7<<1)>>1]|0;B=A+(($(C>>16,B)|0)+(($(C&65535,B)|0)>>16))|0;C=c[d+(E+8<<2)>>2]|0;D=b[e+(D+8<<1)>>1]|0;D=B+(($(C>>16,D)|0)+(($(C&65535,D)|0)>>16))|0;m=(g-m|0)*9|0;C=c[d+(E+17<<2)>>2]|0;B=b[e+(m<<1)>>1]|0;B=D+(($(C>>16,B)|0)+(($(C&65535,B)|0)>>16))|0;C=c[d+(E+16<<2)>>2]|0;D=b[e+(m+1<<1)>>1]|0;D=B+(($(C>>16,D)|0)+(($(C&65535,D)|0)>>16))|0;C=c[d+(E+15<<2)>>2]|0;B=b[e+(m+2<<1)>>1]|0;B=D+(($(C>>16,B)|0)+(($(C&65535,B)|0)>>16))|0;C=c[d+(E+14<<2)>>2]|0;D=b[e+(m+3<<1)>>1]|0;D=B+(($(C>>16,D)|0)+(($(C&65535,D)|0)>>16))|0;C=c[d+(E+13<<2)>>2]|0;B=b[e+(m+4<<1)>>1]|0;B=D+(($(C>>16,B)|0)+(($(C&65535,B)|0)>>16))|0;C=c[d+(E+12<<2)>>2]|0;D=b[e+(m+5<<1)>>1]|0;D=B+(($(C>>16,D)|0)+(($(C&65535,D)|0)>>16))|0;C=c[d+(E+11<<2)>>2]|0;B=b[e+(m+6<<1)>>1]|0;B=D+(($(C>>16,B)|0)+(($(C&65535,B)|0)>>16))|0;C=c[d+(E+10<<2)>>2]|0;D=b[e+(m+7<<1)>>1]|0;D=B+(($(C>>16,D)|0)+(($(C&65535,D)|0)>>16))|0;E=c[d+(E+9<<2)>>2]|0;m=b[e+(m+8<<1)>>1]|0;m=(D+(($(E>>16,m)|0)+(($(E&65535,m)|0)>>16))>>5)+1>>1;if((m|0)>32767)m=32767;else m=(m|0)<-32768?-32768:m&65535;b[a>>1]=m;a=a+2|0;l=l+j|0;}i=k;return a|0;}else if((f|0)==24){l=e+2|0;t=e+4|0;s=e+6|0;r=e+8|0;q=e+10|0;p=e+12|0;o=e+14|0;n=e+16|0;m=e+18|0;f=e+20|0;g=e+22|0;u=0;while(1){if((u|0)>=(h|0))break;E=u>>16;v=(c[d+(E<<2)>>2]|0)+(c[d+(E+23<<2)>>2]|0)|0;D=b[e>>1]|0;D=($(v>>16,D)|0)+(($(v&65535,D)|0)>>16)|0;v=(c[d+(E+1<<2)>>2]|0)+(c[d+(E+22<<2)>>2]|0)|0;C=b[l>>1]|0;C=D+(($(v>>16,C)|0)+(($(v&65535,C)|0)>>16))|0;v=(c[d+(E+2<<2)>>2]|0)+(c[d+(E+21<<2)>>2]|0)|0;D=b[t>>1]|0;D=C+(($(v>>16,D)|0)+(($(v&65535,D)|0)>>16))|0;v=(c[d+(E+3<<2)>>2]|0)+(c[d+(E+20<<2)>>2]|0)|0;C=b[s>>1]|0;C=D+(($(v>>16,C)|0)+(($(v&65535,C)|0)>>16))|0;v=(c[d+(E+4<<2)>>2]|0)+(c[d+(E+19<<2)>>2]|0)|0;D=b[r>>1]|0;D=C+(($(v>>16,D)|0)+(($(v&65535,D)|0)>>16))|0;v=(c[d+(E+5<<2)>>2]|0)+(c[d+(E+18<<2)>>2]|0)|0;C=b[q>>1]|0;C=D+(($(v>>16,C)|0)+(($(v&65535,C)|0)>>16))|0;v=(c[d+(E+6<<2)>>2]|0)+(c[d+(E+17<<2)>>2]|0)|0;D=b[p>>1]|0;D=C+(($(v>>16,D)|0)+(($(v&65535,D)|0)>>16))|0;v=(c[d+(E+7<<2)>>2]|0)+(c[d+(E+16<<2)>>2]|0)|0;C=b[o>>1]|0;C=D+(($(v>>16,C)|0)+(($(v&65535,C)|0)>>16))|0;v=(c[d+(E+8<<2)>>2]|0)+(c[d+(E+15<<2)>>2]|0)|0;D=b[n>>1]|0;D=C+(($(v>>16,D)|0)+(($(v&65535,D)|0)>>16))|0;v=(c[d+(E+9<<2)>>2]|0)+(c[d+(E+14<<2)>>2]|0)|0;C=b[m>>1]|0;C=D+(($(v>>16,C)|0)+(($(v&65535,C)|0)>>16))|0;v=(c[d+(E+10<<2)>>2]|0)+(c[d+(E+13<<2)>>2]|0)|0;D=b[f>>1]|0;D=C+(($(v>>16,D)|0)+(($(v&65535,D)|0)>>16))|0;E=(c[d+(E+11<<2)>>2]|0)+(c[d+(E+12<<2)>>2]|0)|0;v=b[g>>1]|0;v=(D+(($(E>>16,v)|0)+(($(E&65535,v)|0)>>16))>>5)+1>>1;if((v|0)>32767)v=32767;else v=(v|0)<-32768?-32768:v&65535;b[a>>1]=v;a=a+2|0;u=u+j|0;}i=k;return a|0;}else{E=a;i=k;return E|0;}return 0;}function Eh(a,d,e,f){a=a|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0;n=i;k=a+4|0;l=a+8|0;g=a+12|0;h=a+16|0;j=a+20|0;m=0;while(1){if((m|0)>=(f|0))break;p=b[e+(m<<1)>>1]<<10;o=c[a>>2]|0;q=p-o|0;q=((q>>16)*1746|0)+(((q&65535)*1746|0)>>>16)|0;o=o+q|0;c[a>>2]=p+q;q=c[k>>2]|0;r=o-q|0;r=((r>>16)*14986|0)+(((r&65535)*14986|0)>>>16)|0;q=q+r|0;c[k>>2]=o+r;r=q-(c[l>>2]|0)|0;o=($(r>>16,-26453)|0)+(($(r&65535,-26453)|0)>>16)|0;c[l>>2]=q+(r+o);o=(q+o>>9)+1>>1;if((o|0)>32767)q=32767;else q=(o|0)<-32768?-32768:o&65535;o=m<<1;b[d+(o<<1)>>1]=q;s=c[g>>2]|0;r=p-s|0;r=((r>>16)*6854|0)+(((r&65535)*6854|0)>>>16)|0;s=s+r|0;c[g>>2]=p+r;r=c[h>>2]|0;q=s-r|0;q=((q>>16)*25769|0)+(((q&65535)*25769|0)>>>16)|0;r=r+q|0;c[h>>2]=s+q;q=r-(c[j>>2]|0)|0;p=($(q>>16,-9994)|0)+(($(q&65535,-9994)|0)>>16)|0;c[j>>2]=r+(q+p);p=(r+p>>9)+1>>1;if((p|0)>32767)p=32767;else p=(p|0)<-32768?-32768:p&65535;b[d+((o|1)<<1)>>1]=p;m=m+1|0;}i=n;return;}function Fh(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0;e=i;Eh(a,b,c,d);i=e;return;}function Gh(a,b){a=a|0;b=b|0;var d=0,e=0,f=0,g=0,h=0,j=0;d=i;i=i+64|0;e=d+32|0;g=d+16|0;f=d+8|0;j=d;Hh(e,b,8);Hh(g,e,4);Hh(f,g,2);Hh(j,f,1);h=c[f>>2]|0;Ih(a,h,c[j>>2]|0,26128);j=c[g>>2]|0;Ih(a,j,h,25976);h=c[e>>2]|0;Ih(a,h,j,25824);Ih(a,c[b>>2]|0,h,25672);Ih(a,c[b+8>>2]|0,c[e+4>>2]|0,25672);h=c[e+8>>2]|0;Ih(a,h,c[g+4>>2]|0,25824);Ih(a,c[b+16>>2]|0,h,25672);Ih(a,c[b+24>>2]|0,c[e+12>>2]|0,25672);h=c[g+8>>2]|0;Ih(a,h,c[f+4>>2]|0,25976);f=c[e+16>>2]|0;Ih(a,f,h,25824);Ih(a,c[b+32>>2]|0,f,25672);Ih(a,c[b+40>>2]|0,c[e+20>>2]|0,25672);f=c[e+24>>2]|0;Ih(a,f,c[g+12>>2]|0,25824);Ih(a,c[b+48>>2]|0,f,25672);Ih(a,c[b+56>>2]|0,c[e+28>>2]|0,25672);i=d;return;}function Hh(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;e=i;f=0;while(1){if((f|0)>=(d|0))break;g=f<<1;c[a+(f<<2)>>2]=(c[b+(g<<2)>>2]|0)+(c[b+((g|1)<<2)>>2]|0);f=f+1|0;}i=e;return;}function Ih(a,b,c,e){a=a|0;b=b|0;c=c|0;e=e|0;var f=0;f=i;if((c|0)<=0){i=f;return;}Cc(a,b,e+(d[26280+c>>0]|0)|0,8);i=f;return;}function Jh(a,c,d){a=a|0;c=c|0;d=d|0;var e=0,f=0,g=0,h=0,j=0,k=0;e=i;i=i+32|0;j=e+24|0;g=e+16|0;h=e;f=j+2|0;Kh(j,f,c,d,26128);k=g+2|0;Kh(g,k,c,b[j>>1]|0,25976);d=h+2|0;Kh(h,d,c,b[g>>1]|0,25824);Kh(a,a+2|0,c,b[h>>1]|0,25672);Kh(a+4|0,a+6|0,c,b[d>>1]|0,25672);d=h+4|0;j=h+6|0;Kh(d,j,c,b[k>>1]|0,25824);Kh(a+8|0,a+10|0,c,b[d>>1]|0,25672);Kh(a+12|0,a+14|0,c,b[j>>1]|0,25672);j=g+4|0;g=g+6|0;Kh(j,g,c,b[f>>1]|0,25976);d=h+8|0;f=h+10|0;Kh(d,f,c,b[j>>1]|0,25824);Kh(a+16|0,a+18|0,c,b[d>>1]|0,25672);Kh(a+20|0,a+22|0,c,b[f>>1]|0,25672);f=h+12|0;d=h+14|0;Kh(f,d,c,b[g>>1]|0,25824);Kh(a+24|0,a+26|0,c,b[f>>1]|0,25672);Kh(a+28|0,a+30|0,c,b[d>>1]|0,25672);i=e;return;}function Kh(a,c,e,f,g){a=a|0;c=c|0;e=e|0;f=f|0;g=g|0;var h=0;h=i;if((f|0)>0){g=sc(e,g+(d[26280+f>>0]|0)|0,8)|0;b[a>>1]=g;a=f-g&65535;b[c>>1]=a;i=h;return;}else{b[a>>1]=0;a=0;b[c>>1]=a;i=h;return;}}function Lh(a){a=a|0;var b=0,d=0;b=i;if((a|0)<0){a=0-a|0;if((a|0)>191){a=0;i=b;return a|0;}d=a>>5;a=(c[21920+(d<<2)>>2]|0)-($(c[21944+(d<<2)>>2]<<16>>16,a&31)|0)|0;i=b;return a|0;}else{if((a|0)>191){d=32767;i=b;return d|0;}d=a>>5;d=(c[21968+(d<<2)>>2]|0)+($(c[21944+(d<<2)>>2]<<16>>16,a&31)|0)|0;i=b;return d|0;}return 0;}function Mh(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0;f=i;g=0;while(1){if((g|0)>=(e|0)){g=1;break;}c[b+(g<<2)>>2]=g;g=g+1|0;}while(1){if((g|0)>=(e|0))break;h=c[a+(g<<2)>>2]|0;j=g;while(1){k=j+-1|0;if((j|0)<=0)break;l=c[a+(k<<2)>>2]|0;if((h|0)>=(l|0))break;c[a+(j<<2)>>2]=l;c[b+(j<<2)>>2]=c[b+(k<<2)>>2];j=k;}c[a+(j<<2)>>2]=h;c[b+(j<<2)>>2]=g;g=g+1|0;}g=a+(e+-1<<2)|0;h=e+-2|0;while(1){if((e|0)>=(d|0))break;j=c[a+(e<<2)>>2]|0;if((j|0)<(c[g>>2]|0)){k=h;while(1){if((k|0)<=-1)break;l=c[a+(k<<2)>>2]|0;if((j|0)>=(l|0))break;m=k+1|0;c[a+(m<<2)>>2]=l;c[b+(m<<2)>>2]=c[b+(k<<2)>>2];k=k+-1|0;}m=k+1|0;c[a+(m<<2)>>2]=j;c[b+(m<<2)>>2]=e;}e=e+1|0;}i=f;return;}function Nh(a,c){a=a|0;c=c|0;var d=0,e=0,f=0,g=0,h=0,j=0;d=i;e=1;while(1){if((e|0)>=(c|0))break;f=b[a+(e<<1)>>1]|0;g=e;while(1){h=g+-1|0;if((g|0)<=0)break;j=b[a+(h<<1)>>1]|0;if(f<<16>>16>=j<<16>>16)break;b[a+(g<<1)>>1]=j;g=h;}b[a+(g<<1)>>1]=f;e=e+1|0;}i=d;return;}function Oh(d,f,g,h,j,k,l,m,n,o,p){d=d|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;var q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0;q=i;i=i+16|0;s=q+8|0;w=q+4|0;x=q;u=f+-4|0;v=p+2|0;r=i;i=i+((2*v|0)+15&-16)|0;y=0;while(1){if((y|0)>=(v|0))break;z=y+-2|0;A=b[f+(z<<1)>>1]|0;z=b[g+(z<<1)>>1]|0;B=A+z|0;z=A-z|0;b[f+(y+-2<<1)>>1]=(B>>>1)+(B&1);z=(z>>1)+(z&1)|0;if((z|0)>32767)z=32767;else z=(z|0)<-32768?-32768:z&65535;b[r+(y<<1)>>1]=z;y=y+1|0;}v=d+4|0;y=e[v>>1]|e[v+2>>1]<<16;b[u>>1]=y;b[u+2>>1]=y>>>16;u=d+8|0;y=e[u>>1]|e[u+2>>1]<<16;c[r>>2]=y;z=f+(p+-2<<1)|0;z=e[z>>1]|e[z+2>>1]<<16;b[v>>1]=z;b[v+2>>1]=z>>>16;v=r+(p<<1)|0;v=e[v>>1]|e[v+2>>1]<<16;b[u>>1]=v;b[u+2>>1]=v>>>16;u=i;i=i+((2*p|0)+15&-16)|0;v=i;i=i+((2*p|0)+15&-16)|0;y=y&65535;z=0;while(1){if((z|0)>=(p|0))break;A=b[f+(z+-1<<1)>>1]|0;B=((b[f+(z+-2<<1)>>1]|0)+(b[f+(z<<1)>>1]|0)+(A<<16>>16<<1)>>1)+1>>1;b[u+(z<<1)>>1]=B;b[v+(z<<1)>>1]=(A&65535)-B;z=z+1|0;}A=i;i=i+((2*p|0)+15&-16)|0;z=i;i=i+((2*p|0)+15&-16)|0;B=0;while(1){if((B|0)>=(p|0))break;C=B+1|0;D=b[r+(C<<1)>>1]|0;E=((y<<16>>16)+(b[r+(B+2<<1)>>1]|0)+(D<<16>>16<<1)>>1)+1>>1;b[A+(B<<1)>>1]=E;b[z+(B<<1)>>1]=(D&65535)-E;y=D;B=C;}E=(o*10|0)==(p|0);y=E?328:655;m=m<<16>>16;m=$(m,m)|0;y=($(m>>>16,y)|0)+(($(m&65535,y)|0)>>>16)|0;u=Xh(w,u,A,d+12|0,p,y)|0;c[s>>2]=u;v=Xh(x,v,z,d+20|0,p,y)|0;m=s+4|0;c[m>>2]=v;w=(c[x>>2]|0)+((c[w>>2]<<16>>16)*3|0)|0;w=(w|0)<65536?w:65536;l=l-(E?1200:600)|0;l=(l|0)<1?1:l;x=((o<<16>>16)*900|0)+2e3|0;A=w*3|0;z=Ph(l,A+851968|0,19)|0;c[k>>2]=z;if((z|0)<(x|0)){c[k>>2]=x;E=l-x|0;c[k+4>>2]=E;z=x<<16>>16;z=Ph((E<<1)-x|0,($(A+65536>>16,z)|0)+(($(A&65535,z)|0)>>16)|0,16)|0;if((z|0)>16384)A=16384;else A=(z|0)<0?0:z;}else{c[k+4>>2]=l-z;A=16384;}z=d+28|0;C=b[z>>1]|0;D=C&65535;E=y<<16>>16;b[z>>1]=D+(($(A-(C<<16>>16)>>16,E)|0)+(($(A-D&65535,E)|0)>>>16));a[j>>0]=0;a:do if(!n){y=(b[d+30>>1]|0)==0;do if(y){if((l<<3|0)>=(x*13|0)){n=b[z>>1]|0;E=n<<16>>16;if((($(w>>16,E)|0)+(($(w&65535,E)|0)>>16)|0)>=819){if(!y){t=25;break;}n=b[z>>1]|0;break;}}else n=b[z>>1]|0;t=n<<16>>16;c[s>>2]=($(t,u<<16>>16)|0)>>14;c[m>>2]=($(t,v<<16>>16)|0)>>14;ci(s,h);c[s>>2]=0;c[m>>2]=0;c[k>>2]=l;c[k+4>>2]=0;a[j>>0]=1;h=0;t=33;break a;}else t=25;while(0);do if((t|0)==25){if((l<<3|0)>=(x*11|0)){t=b[z>>1]|0;E=t<<16>>16;if((($(w>>16,E)|0)+(($(w&65535,E)|0)>>16)|0)>=328){n=t;break;}}else t=b[z>>1]|0;t=t<<16>>16;c[s>>2]=($(t,u<<16>>16)|0)>>14;c[m>>2]=($(t,v<<16>>16)|0)>>14;ci(s,h);c[s>>2]=0;c[m>>2]=0;h=0;t=32;break a;}while(0);if(n<<16>>16>15565){ci(s,h);h=16384;t=32;break;}else{t=n<<16>>16;c[s>>2]=($(t,u<<16>>16)|0)>>14;c[m>>2]=($(t,v<<16>>16)|0)>>14;ci(s,h);h=b[z>>1]|0;t=32;break;}}else{c[s>>2]=0;c[m>>2]=0;ci(s,h);h=0;t=32;}while(0);if((t|0)==32)if((a[j>>0]|0)==1)t=33;else{b[d+32>>1]=0;t=37;}do if((t|0)==33){t=d+32|0;E=(e[t>>1]|0)+(p-(o<<3))|0;b[t>>1]=E;if((E<<16>>16|0)<(o*5|0)){a[j>>0]=0;t=38;break;}else{b[t>>1]=1e4;t=37;break;}}while(0);if((t|0)==37)if(!(a[j>>0]|0))t=38;else k=h;if((t|0)==38){j=k+4|0;if((c[j>>2]|0)<1){c[j>>2]=1;c[k>>2]=Qh(l+-1|0)|0;k=h;}else k=h;}w=b[d>>1]|0;j=d+2|0;x=b[j>>1]|0;t=d+30|0;E=b[t>>1]|0;v=E<<16>>16;h=o<<3;s=c[s>>2]|0;l=(65536/(h|0)|0)<<16>>16;n=(($(s-(w&65535)<<16>>16,l)|0)>>15)+1>>1;o=c[m>>2]|0;u=(($(o-(x&65535)<<16>>16,l)|0)>>15)+1>>1;l=($(k-v>>16,l)|0)+(($(k-(E&65535)&65535,l)|0)>>16)<<10;w=0-(w<<16>>16)|0;x=0-(x<<16>>16)|0;m=0;v=v<<10;while(1){if((m|0)>=(h|0))break;w=w-n|0;x=x-u|0;v=v+l|0;y=m+1|0;E=b[f+(m+-1<<1)>>1]|0;C=(b[f+(m+-2<<1)>>1]|0)+(b[f+(m<<1)>>1]|0)+(E<<1)|0;B=b[r+(y<<1)>>1]|0;D=w<<16>>16;z=x<<16>>16;z=(($(v>>16,B)|0)+(($(v&64512,B)|0)>>16)+(($(C>>7,D)|0)+(($(C<<9&65024,D)|0)>>16))+(($(E>>5,z)|0)+(($(E<<11&63488,z)|0)>>16))>>7)+1>>1;if((z|0)>32767)z=32767;else z=(z|0)<-32768?-32768:z&65535;b[g+(m+-1<<1)>>1]=z;m=y;}u=k>>6;m=k<<10&64512;n=0-s<<16>>16;l=0-o<<16>>16;while(1){if((h|0)>=(p|0))break;v=h+1|0;w=b[f+(h+-1<<1)>>1]|0;E=(b[f+(h+-2<<1)>>1]|0)+(b[f+(h<<1)>>1]|0)+(w<<1)|0;D=b[r+(v<<1)>>1]|0;w=(($(u,D)|0)+(($(m,D)|0)>>16)+(($(E>>7,n)|0)+(($(E<<9&65024,n)|0)>>16))+(($(w>>5,l)|0)+(($(w<<11&63488,l)|0)>>16))>>7)+1>>1;if((w|0)>32767)w=32767;else w=(w|0)<-32768?-32768:w&65535;b[g+(h+-1<<1)>>1]=w;h=v;}b[d>>1]=s;b[j>>1]=o;b[t>>1]=k;i=q;return;}function Ph(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,g=0,h=0;d=i;f=Rh((a|0)>0?a:0-a|0)|0;h=a<<f+-1;e=(Rh((b|0)>0?b:0-b|0)|0)+-1|0;a=b<<e;b=(536870911/(a>>16|0)|0)<<16>>16;g=($(h>>16,b)|0)+(($(h&65535,b)|0)>>16)|0;a=Gj(a|0,((a|0)<0)<<31>>31|0,g|0,((g|0)<0)<<31>>31|0)|0;a=uj(a|0,D|0,29)|0;a=h-(a&-8)|0;b=g+(($(a>>16,b)|0)+(($(a&65535,b)|0)>>16))|0;c=f+28-e-c|0;if((c|0)>=0){i=d;return((c|0)<32?b>>c:0)|0;}c=0-c|0;a=-2147483648>>c;e=2147483647>>>c;if((a|0)>(e|0)){if((b|0)>(a|0)){h=a;h=h<<c;i=d;return h|0;}h=(b|0)<(e|0)?e:b;h=h<<c;i=d;return h|0;}else{if((b|0)>(e|0)){h=e;h=h<<c;i=d;return h|0;}h=(b|0)<(a|0)?a:b;h=h<<c;i=d;return h|0;}return 0;}function Qh(a){a=a|0;return((a|0)<1?1:a)|0;}function Rh(a){a=a|0;var b=0;b=i;if(!a)a=32;else a=vj(a|0)|0;i=b;return a|0;}function Sh(a,d,f,g,h,j){a=a|0;d=d|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;k=i;l=a+4|0;r=e[l>>1]|e[l+2>>1]<<16;b[d>>1]=r;b[d+2>>1]=r>>>16;r=a+8|0;q=e[r>>1]|e[r+2>>1]<<16;b[f>>1]=q;b[f+2>>1]=q>>>16;q=d+(j<<1)|0;q=e[q>>1]|e[q+2>>1]<<16;b[l>>1]=q;b[l+2>>1]=q>>>16;l=f+(j<<1)|0;l=e[l>>1]|e[l+2>>1]<<16;b[r>>1]=l;b[r+2>>1]=l>>>16;r=b[a>>1]|0;l=a+2|0;q=b[l>>1]|0;m=h<<3;n=(65536/(m|0)|0)<<16>>16;p=(($((c[g>>2]|0)-(r&65535)<<16>>16,n)|0)>>15)+1>>1;h=g+4|0;n=(($((c[h>>2]|0)-(q&65535)<<16>>16,n)|0)>>15)+1>>1;r=r<<16>>16;q=q<<16>>16;s=0;while(1){if((s|0)>=(m|0))break;r=r+p|0;q=q+n|0;o=s+1|0;u=b[d+(o<<1)>>1]|0;w=(b[d+(s<<1)>>1]|0)+(b[d+(s+2<<1)>>1]|0)+(u<<1)|0;s=f+(o<<1)|0;v=r<<16>>16;t=q<<16>>16;t=((b[s>>1]<<8)+(($(w>>7,v)|0)+(($(w<<9&65024,v)|0)>>16))+(($(u>>5,t)|0)+(($(u<<11&63488,t)|0)>>16))>>7)+1>>1;if((t|0)>32767)t=32767;else t=(t|0)<-32768?-32768:t&65535;b[s>>1]=t;s=o;}n=c[g>>2]<<16>>16;o=c[h>>2]<<16>>16;while(1){if((m|0)>=(j|0))break;p=m+1|0;q=b[d+(p<<1)>>1]|0;w=(b[d+(m<<1)>>1]|0)+(b[d+(m+2<<1)>>1]|0)+(q<<1)|0;m=f+(p<<1)|0;q=((b[m>>1]<<8)+(($(w>>7,n)|0)+(($(w<<9&65024,n)|0)>>16))+(($(q>>5,o)|0)+(($(q<<11&63488,o)|0)>>16))>>7)+1>>1;if((q|0)>32767)q=32767;else q=(q|0)<-32768?-32768:q&65535;b[m>>1]=q;m=p;}b[a>>1]=c[g>>2];b[l>>1]=c[h>>2];g=0;while(1){if((g|0)>=(j|0))break;g=g+1|0;h=d+(g<<1)|0;w=b[h>>1]|0;l=f+(g<<1)|0;a=b[l>>1]|0;m=w+a|0;a=w-a|0;if((m|0)>32767)m=32767;else m=(m|0)<-32768?-32768:m&65535;b[h>>1]=m;if((a|0)>32767)a=32767;else a=(a|0)<-32768?-32768:a&65535;b[l>>1]=a;}i=k;return;}function Th(a,d){a=a|0;d=d|0;var e=0,f=0,g=0,h=0;e=i;i=i+32|0;f=e;h=sc(a,24864,8)|0;g=(h|0)/5|0;c[f+8>>2]=g;c[f+20>>2]=h+($(g,-5)|0);g=0;while(1){if((g|0)>=2){g=0;break;}c[f+(g*12|0)>>2]=sc(a,24984,8)|0;c[f+(g*12|0)+4>>2]=sc(a,25e3,8)|0;g=g+1|0;}while(1){if((g|0)>=2)break;a=f+(g*12|0)|0;h=(c[a>>2]|0)+((c[f+(g*12|0)+8>>2]|0)*3|0)|0;c[a>>2]=h;a=b[24832+(h<<1)>>1]|0;h=b[24832+(h+1<<1)>>1]|0;h=($((h<<16>>16)-a>>16,429522944)|0)+(((h&65535)-a&65535)*6554|0)>>16;c[d+(g<<2)>>2]=a+($(h,c[f+(g*12|0)+4>>2]<<17>>16|1)|0);g=g+1|0;}c[d>>2]=(c[d>>2]|0)-(c[d+4>>2]|0);i=e;return;}function Uh(a,b){a=a|0;b=b|0;var d=0;d=i;c[b>>2]=sc(a,24896,8)|0;i=d;return;}function Vh(b,c){b=b|0;c=c|0;var d=0,e=0;d=i;Cc(b,((a[c+2>>0]|0)*5|0)+(a[c+5>>0]|0)|0,24864,8);e=0;while(1){if((e|0)>=2)break;Cc(b,a[c+(e*3|0)>>0]|0,24984,8);Cc(b,a[c+(e*3|0)+1>>0]|0,25e3,8);e=e+1|0;}i=d;return;}function Wh(a,b){a=a|0;b=b|0;var c=0;c=i;Cc(a,b<<24>>24,24896,8);i=c;return;}function Xh(a,b,d,e,f,g){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;var h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;h=i;i=i+16|0;j=h+12|0;m=h+8|0;n=h+4|0;k=h;di(n,j,b,f);di(k,m,d,f);j=c[j>>2]|0;m=c[m>>2]|0;l=Yh(j,m)|0;l=l+(l&1)|0;m=c[k>>2]>>l-m;c[k>>2]=m;j=Yh(c[n>>2]>>l-j,1)|0;c[n>>2]=j;f=mh(b,d,l,f)|0;d=Zh(f,j,13)|0;if((d|0)>16384)d=16384;else d=(d|0)<-16384?-16384:d;o=d<<16>>16;p=($(d>>16,o)|0)+(($(d&65535,o)|0)>>16)|0;n=Yh(g,(p|0)>0?p:0-p|0)|0;b=l>>1;q=c[e>>2]|0;g=(_h(j)|0)<<b;n=n<<16>>16;g=$(g-(c[e>>2]|0)>>16,n)|0;l=(_h(j)|0)<<b;c[e>>2]=q+(g+(($(l-(c[e>>2]|0)&65535,n)|0)>>16));l=p<<16>>16;l=m-(($(f>>16,o)|0)+(($(f&65535,o)|0)>>16)<<4)+(($(j>>16,l)|0)+(($(j&65535,l)|0)>>16)<<6)|0;c[k>>2]=l;g=e+4|0;m=c[g>>2]|0;f=(_h(l)|0)<<b;f=$(f-(c[g>>2]|0)>>16,n)|0;b=(_h(l)|0)<<b;n=m+(f+(($(b-(c[g>>2]|0)&65535,n)|0)>>16))|0;c[g>>2]=n;g=c[e>>2]|0;g=Zh(n,(g|0)>1?g:1,14)|0;c[a>>2]=g;if((g|0)>32767){q=32767;c[a>>2]=q;i=h;return d|0;}q=(g|0)<0?0:g;c[a>>2]=q;i=h;return d|0;}function Yh(a,b){a=a|0;b=b|0;return((a|0)>(b|0)?a:b)|0;}function Zh(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0,g=0,h=0;d=i;f=ai((a|0)>0?a:0-a|0)|0;h=a<<f+-1;e=(ai((b|0)>0?b:0-b|0)|0)+-1|0;a=b<<e;b=(536870911/(a>>16|0)|0)<<16>>16;g=($(h>>16,b)|0)+(($(h&65535,b)|0)>>16)|0;a=Gj(a|0,((a|0)<0)<<31>>31|0,g|0,((g|0)<0)<<31>>31|0)|0;a=uj(a|0,D|0,29)|0;a=h-(a&-8)|0;b=g+(($(a>>16,b)|0)+(($(a&65535,b)|0)>>16))|0;c=f+28-e-c|0;if((c|0)>=0){i=d;return((c|0)<32?b>>c:0)|0;}c=0-c|0;a=-2147483648>>c;e=2147483647>>>c;if((a|0)>(e|0)){if((b|0)>(a|0)){h=a;h=h<<c;i=d;return h|0;}h=(b|0)<(e|0)?e:b;h=h<<c;i=d;return h|0;}else{if((b|0)>(e|0)){h=e;h=h<<c;i=d;return h|0;}h=(b|0)<(a|0)?a:b;h=h<<c;i=d;return h|0;}return 0;}function _h(a){a=a|0;var b=0,d=0,e=0;b=i;i=i+16|0;d=b+4|0;e=b;if((a|0)<1){e=0;i=b;return e|0;}$h(a,d,e);d=c[d>>2]|0;d=((d&1|0)==0?46214:32768)>>>(d>>1);e=($(c[e>>2]<<16>>16,13959168)|0)>>16;e=d+(($(d>>16,e)|0)+(($(d&65535,e)|0)>>16))|0;i=b;return e|0;}function $h(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=i;f=ai(a)|0;c[b>>2]=f;c[d>>2]=(bi(a,24-f|0)|0)&127;i=e;return;}function ai(a){a=a|0;var b=0;b=i;if(!a)a=32;else a=vj(a|0)|0;i=b;return a|0;}function bi(a,b){a=a|0;b=b|0;var c=0,d=0;c=i;d=0-b|0;do if(b)if((b|0)<0){a=a<<d|a>>>(b+32|0);break;}else{a=a<<32-b|a>>>b;break;}while(0);i=c;return a|0;}function ci(d,e){d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0;j=i;p=0;h=0;while(1){if((h|0)>=2)break;f=d+(h<<2)|0;g=e+(h*3|0)|0;k=e+(h*3|0)+1|0;q=2147483647;o=0;a:while(1){if((o|0)>=15)break;l=b[24832+(o<<1)>>1]|0;n=o+1|0;m=b[24832+(n<<1)>>1]|0;m=($((m<<16>>16)-l>>16,429522944)|0)+(((m&65535)-l&65535)*6554|0)>>16;o=o&255;r=0;while(1){if((r|0)>=5){o=n;continue a;}t=l+($(m,r<<17>>16|1)|0)|0;s=c[f>>2]|0;u=s-t|0;s=(u|0)>0?u:t-s|0;if((s|0)>=(q|0))break a;a[g>>0]=o;a[k>>0]=r;q=s;p=t;r=r+1|0;}}t=a[g>>0]|0;u=(t<<24>>24|0)/3|0;a[e+(h*3|0)+2>>0]=u;a[g>>0]=(t&255)+($(u<<24>>24,-3)|0);c[f>>2]=p;h=h+1|0;}c[d>>2]=(c[d>>2]|0)-(c[d+4>>2]|0);i=j;return;}function di(a,d,e,f){a=a|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0,k=0,l=0,m=0;g=i;f=f+-1|0;l=0;h=0;while(1){if((h|0)>=(f|0)){k=0;break;}k=b[e+(h<<1)>>1]|0;k=l+($(k,k)|0)|0;l=b[e+((h|1)<<1)>>1]|0;l=k+($(l,l)|0)|0;if((l|0)<0){j=4;break;}h=h+2|0;}if((j|0)==4){h=h+2|0;l=l>>>2;k=2;}while(1){if((h|0)>=(f|0))break;m=b[e+(h<<1)>>1]|0;m=$(m,m)|0;j=b[e+(h+1<<1)>>1]|0;l=l+((m+($(j,j)|0)|0)>>>k)|0;if((l|0)<0){l=l>>>2;k=k+2|0;}h=h+2|0;}if((h|0)==(f|0)){m=b[e+(f<<1)>>1]|0;l=l+(($(m,m)|0)>>>k)|0;}if(l>>>0<=1073741823){m=l;l=k;c[d>>2]=l;c[a>>2]=m;i=g;return;}m=l>>>2;l=k+2|0;c[d>>2]=l;c[a>>2]=m;i=g;return;}function ei(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,h=0,j=0,k=0,l=0.0,m=0,n=0.0;e=i;h=a+8504|0;k=c[h>>2]|0;j=c[a+8500>>2]|0;f=j-k|0;f=(f|0)<0?f+200|0:f;if(!((d|0)<=480|(k|0)==(j|0))){k=k+1|0;k=(k|0)==200?0:k;}m=(k|0)==(j|0);j=j+-1|0;j=a+((((m?j:k)|0)<0?199:m?j:k)*28|0)+8512|0;c[b+0>>2]=c[j+0>>2];c[b+4>>2]=c[j+4>>2];c[b+8>>2]=c[j+8>>2];c[b+12>>2]=c[j+12>>2];c[b+16>>2]=c[j+16>>2];c[b+20>>2]=c[j+20>>2];c[b+24>>2]=c[j+24>>2];j=a+8508|0;d=(c[j>>2]|0)+((d|0)/120|0)|0;c[j>>2]=d;while(1){if((d|0)<=3)break;m=d+-4|0;c[j>>2]=m;c[h>>2]=(c[h>>2]|0)+1;d=m;}d=c[h>>2]|0;if((d|0)>199)c[h>>2]=d+-200;h=f+-10|0;h=200-((h|0)>0?h:0)|0;l=0.0;f=0;while(1){if((f|0)>=(h|0))break;l=l+ +g[a+(f<<2)+7684>>2];f=f+1|0;}while(1){if((f|0)>=200)break;n=l+ +g[a+(f<<2)+6884>>2];f=f+1|0;l=n;}g[b+20>>2]=l*+g[a+8488>>2]+(1.0-l)*+g[a+8484>>2];i=e;return;}function fi(a,b,d,e,f,g,h,j,k,l,m,n){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;var o=0,p=0,q=0;o=i;if(!d){c[n>>2]=0;ei(a,n,f);i=o;return;}k=(k*195|0)/100|0;k=(k|0)<(e|0)?k:e;e=a+6880|0;q=c[e>>2]|0;p=q;q=k-q|0;while(1){gi(a,b,d,(q|0)>480?480:q,p,g,h,j,l,m);q=q+-480|0;if((q|0)<=0)break;else p=p+480|0;}c[e>>2]=k-f;c[n>>2]=0;ei(a,n,f);i=o;return;}function gi(a,b,d,e,f,h,j,k,l,m){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;var n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0.0,v=0,w=0.0,x=0,y=0,z=0,A=0,B=0,C=0.0,D=0.0,E=0.0,F=0.0,G=0.0,H=0.0,I=0.0,J=0.0,K=0.0,L=0.0,M=0,R=0.0,S=0.0,T=0.0,U=0,V=0,W=0,X=0,Y=0,_=0.0,$=0.0;n=i;i=i+9888|0;z=n+9816|0;v=n+9744|0;t=n+9712|0;s=n+9608|0;r=n+9600|0;M=n+5760|0;x=n+1920|0;y=n+960|0;A=n;o=a+6860|0;c[o>>2]=(c[o>>2]|0)+1;q=a+6864|0;p=c[q>>2]|0;if((p|0)>19){u=1.0/20.0;if((p|0)>49)w=50.0;else B=4;}else{u=1.0/+(p+1|0);B=4;}if((B|0)==4)w=+(p+1|0);w=1.0/w;if((p|0)<=999){F=1.0/+(p+1|0);if((p|0)<4){g[a+6840>>2]=.5;V=c[b+72>>2]|0;if(!p){c[a+5760>>2]=240;p=240;}else B=10;}else B=8;}else{F=1.0/1.0e3;B=8;}if((B|0)==8){V=c[b+72>>2]|0;B=10;}if((B|0)==10)p=c[a+5760>>2]|0;U=a+5760|0;W=720-p|0;Ca[m&3](d,a+(p<<2)+2880|0,(W|0)>(e|0)?e:W,f,h,j,k);W=c[U>>2]|0;p=W+e|0;if((p|0)<720){c[U>>2]=p;i=n;return;}X=a+8500|0;b=c[X>>2]|0;p=a+(b*28|0)+8512|0;c[X>>2]=(b|0)>198?b+-199|0:b+1|0;X=0;while(1){if((X|0)>=240)break;T=+g[26352+(X<<2)>>2];g[M+(X<<3)>>2]=T*+g[a+(X<<2)+2880>>2];g[M+(X<<3)+4>>2]=T*+g[a+(X+240<<2)+2880>>2];Y=480-X+-1|0;g[M+(Y<<3)>>2]=T*+g[a+(Y<<2)+2880>>2];g[M+(Y<<3)+4>>2]=T*+g[a+(720-X+-1<<2)+2880>>2];X=X+1|0;}yj(a+2880|0,a+4800|0,960)|0;Y=W+-720+e|0;Ca[m&3](d,a+3840|0,Y,f+720-W|0,h,j,k);c[U>>2]=Y+240;Qc(V,M,x);T=+g[x>>2];if(T!=T|0.0!=0.0){c[p>>2]=0;i=n;return;}else k=1;while(1){if((k|0)>=240)break;J=+g[x+(k<<3)>>2];W=480-k|0;I=+g[x+(W<<3)>>2];L=+g[x+(k<<3)+4>>2];R=+g[x+(W<<3)+4>>2];S=+hi(L-R,J+I)*.15915493667125702;W=a+(k<<2)|0;T=S-+g[W>>2];X=a+(k<<2)+960|0;K=T-+g[X>>2];R=+hi(I-J,L+R)*.15915493667125702;S=R-S;T=S-T;K=K-+N(+(K+.5));L=K*K;T=T-+N(+(T+.5));g[A+(k<<2)>>2]=+O(+K)+ +O(+T);T=T*T;T=T*T;Y=a+(k<<2)+1920|0;g[y+(k<<2)>>2]=1.0/((+g[Y>>2]+L*L*2.0+T)*.25*62341.81640625+1.0)+-.014999999664723873;g[W>>2]=R;g[X>>2]=S;g[Y>>2]=T;k=k+1|0;}k=a+(b*28|0)+8528|0;g[k>>2]=0.0;a:do if(!(c[q>>2]|0)){e=0;while(1){if((e|0)>=18)break a;g[a+(e<<2)+6416>>2]=1.0e10;g[a+(e<<2)+6488>>2]=-1.0e10;e=e+1|0;}}while(0);e=a+6852|0;I=0.0;H=0.0;E=0.0;J=0.0;D=0.0;G=0.0;C=0.0;d=0;while(1){if((d|0)>=18)break;m=d+1|0;f=c[27312+(m<<2)>>2]|0;R=0.0;S=0.0;M=c[27312+(d<<2)>>2]|0;K=0.0;while(1){if((M|0)>=(f|0))break;$=+g[x+(M<<3)>>2];Y=480-M|0;_=+g[x+(Y<<3)>>2];T=+g[x+(M<<3)+4>>2];L=+g[x+(Y<<3)+4>>2];L=$*$+_*_+T*T+L*L;T=K+L*+g[y+(M<<2)>>2];R=R+L;S=S+L*2.0*(.5-+g[A+(M<<2)>>2]);M=M+1|0;K=T;}if(!(R<1.0e9)|(R!=R|0.0!=0.0)){B=30;break;}g[a+((c[e>>2]|0)*72|0)+(d<<2)+5840>>2]=R;L=R+1.0000000036274937e-15;H=H+S/L;R=R+1.000000013351432e-10;I=I+ +P(+R);R=+Z(+R);g[v+(d<<2)>>2]=R;M=a+(d<<2)+6416|0;T=+g[M>>2]+.009999999776482582;T=R<T?R:T;g[M>>2]=T;f=a+(d<<2)+6488|0;S=+g[f>>2]+-.10000000149011612;S=R>S?R:S;g[f>>2]=S;if(S<T+1.0){S=S+.5;g[f>>2]=S;T=T+-.5;g[M>>2]=T;}G=G+(R-T)/(S+1.0000000036274937e-15-T);R=0.0;S=0.0;f=0;while(1){if((f|0)>=8)break;$=+g[a+(f*72|0)+(d<<2)+5840>>2];R=R+ +P(+$);S=S+$;f=f+1|0;}R=R/+P(+(S*8.0+1.0e-15));R=R>.9900000095367432?.9900000095367432:R;R=R*R;R=R*R;$=K/L;f=a+(d<<2)+5764|0;K=R*+g[f>>2];K=$>K?$:K;g[z+(d<<2)>>2]=K;J=J+K;if((d|0)>8)J=J-+g[z+(d+-9<<2)>>2];$=(+(d+-18|0)*.029999999329447746+1.0)*J;g[f>>2]=K;E=E+R;D=D>$?D:$;C=C+K*+(d+-8|0);d=m;}if((B|0)==30){c[p>>2]=0;i=n;return;}A=l+-8|0;J=.0005699999746866524/+(1<<((A|0)<0?0:A)|0);J=J*J;F=1.0-F;A=0;K=0.0;R=0.0;l=0;while(1){if((l|0)>=21)break;z=c[27392+(l<<2)>>2]|0;y=l+1|0;B=c[27392+(y<<2)>>2]|0;L=0.0;m=z;while(1){if((m|0)>=(B|0))break;S=+g[x+(m<<3)>>2];Y=480-m|0;T=+g[x+(Y<<3)>>2];_=+g[x+(m<<3)+4>>2];$=+g[x+(Y<<3)+4>>2];L=L+(S*S+T*T+_*_+$*$);m=m+1|0;}R=R>L?R:L;Y=a+(l<<2)+6560|0;$=F*+g[Y>>2];$=$>L?$:L;g[Y>>2]=$;L=L>$?L:$;K=K*.05000000074505806;K=K>L?K:L;if(!(L>K*.1&L*1.0e9>R)){Y=A;l=y;A=Y;continue;}if(!(L>J*+(B-z|0))){Y=A;l=y;A=Y;continue;}A=l;l=y;}x=(c[q>>2]|0)<3?20:A;_=+la(+I)*20.0;y=a+6844|0;$=+g[y>>2]+-.029999999329447746;$=$>_?$:_;g[y>>2]=$;y=a+6848|0;F=+g[y>>2]*(1.0-w);if(_<$+-30.0)F=F+w;g[y>>2]=F;l=0;while(1){if((l|0)>=8)break;z=l<<4;A=0;w=0.0;while(1){if((A|0)>=16)break;$=w+ +g[27480+(z+A<<2)>>2]*+g[v+(A<<2)>>2];A=A+1|0;w=$;}g[t+(l<<2)>>2]=w;l=l+1|0;}E=E/18.0;w=H/18.0;g[k>>2]=w+(1.0-w)*((c[q>>2]|0)<10?.5:G/18.0);_=D/9.0;v=a+5836|0;$=+g[v>>2]*.800000011920929;$=_>$?_:$;g[v>>2]=$;v=a+(b*28|0)+8520|0;g[v>>2]=C*.015625;c[e>>2]=((c[e>>2]|0)+1|0)%8|0;c[q>>2]=(c[q>>2]|0)+1;l=a+(b*28|0)+8516|0;g[l>>2]=$;z=0;while(1){if((z|0)>=4)break;g[s+(z<<2)>>2]=(+g[t+(z<<2)>>2]+ +g[a+(z+24<<2)+6644>>2])*-.12298999726772308+(+g[a+(z<<2)+6644>>2]+ +g[a+(z+16<<2)+6644>>2])*.49195000529289246+ +g[a+(z+8<<2)+6644>>2]*.6969299912452698-+g[a+(z<<2)+6772>>2]*1.4349000453948975;z=z+1|0;}C=1.0-u;z=0;while(1){if((z|0)>=4){z=0;break;}Y=a+(z<<2)+6772|0;g[Y>>2]=C*+g[Y>>2]+u*+g[t+(z<<2)>>2];z=z+1|0;}while(1){if((z|0)>=4){z=0;break;}g[s+(z+4<<2)>>2]=(+g[t+(z<<2)>>2]-+g[a+(z+24<<2)+6644>>2])*.6324599981307983+(+g[a+(z<<2)+6644>>2]-+g[a+(z+16<<2)+6644>>2])*.31622999906539917;z=z+1|0;}while(1){if((z|0)>=3)break;Y=z+8|0;g[s+(Y<<2)>>2]=(+g[t+(z<<2)>>2]+ +g[a+(z+24<<2)+6644>>2])*.5345199704170227-(+g[a+(z<<2)+6644>>2]+ +g[a+(z+16<<2)+6644>>2])*.26725998520851135-+g[a+(Y<<2)+6644>>2]*.5345199704170227;z=z+1|0;}b:do if((c[q>>2]|0)>5){z=0;while(1){if((z|0)>=9){z=0;break b;}Y=a+(z<<2)+6804|0;$=+g[s+(z<<2)>>2];g[Y>>2]=C*+g[Y>>2]+u*$*$;z=z+1|0;}}else z=0;while(0);while(1){if((z|0)>=8){t=0;break;}Y=a+(z+16<<2)+6644|0;g[a+(z+24<<2)+6644>>2]=+g[Y>>2];X=a+(z+8<<2)+6644|0;g[Y>>2]=+g[X>>2];Y=a+(z<<2)+6644|0;g[X>>2]=+g[Y>>2];g[Y>>2]=+g[t+(z<<2)>>2];z=z+1|0;}while(1){if((t|0)>=9)break;g[s+(t+11<<2)>>2]=+P(+ +g[a+(t<<2)+6804>>2]);t=t+1|0;}g[s+80>>2]=+g[l>>2];g[s+84>>2]=+g[k>>2];g[s+88>>2]=E;g[s+92>>2]=+g[v>>2];g[s+96>>2]=+g[y>>2];ii(s,r);u=(+g[r>>2]+1.0)*.5;u=u*1.2100000381469727*u+.009999999776482582-+Q(+u,10.0)*.23000000417232513;Y=r+4|0;C=+g[Y>>2]*.5+.5;g[Y>>2]=C;u=C*u+(1.0-C)*.5;g[r>>2]=u;D=C*4999999873689376.0e-20;if(!(u>.949999988079071)){if(u<.05000000074505806)H=.05000000074505806;else H=u;}else H=.949999988079071;r=a+6840|0;F=+g[r>>2];if(!(F>.949999988079071)){if(F<.05000000074505806)G=.05000000074505806;else G=F;}else G=.949999988079071;S=1.0-F;E=1.0-D;T=1.0-u;$=+O(+(H-G))*.05000000074505806/(H*(1.0-G)+G*(1.0-H))+.009999999776482582;_=u;G=(F*E+S*D)*+Q(+_,+$);G=G/((S*E+F*D)*+Q(+T,+$)+G);g[r>>2]=G;g[a+(b*28|0)+8532>>2]=G;G=+Q(+T,+$);F=+Q(+_,+$);s=a+6884|0;if((c[q>>2]|0)==1){g[s>>2]=.5;g[a+7684>>2]=.5;H=.5;I=.5;}else{H=+g[s>>2];I=+g[a+7684>>2];}H=H+ +g[a+6888>>2];I=I+ +g[a+7688>>2];g[a+6884>>2]=H*E*G;g[a+7684>>2]=I*E*F;q=1;while(1){if((q|0)>=199)break;Y=q+1|0;g[a+(q<<2)+6884>>2]=+g[a+(Y<<2)+6884>>2]*G;g[a+(q<<2)+7684>>2]=+g[a+(Y<<2)+7684>>2]*F;q=Y;}g[a+7680>>2]=I*D*G;g[a+8480>>2]=H*D*F;D=9.999999682655225e-21;q=0;while(1){if((q|0)>=200)break;D=D+(+g[a+(q<<2)+6884>>2]+ +g[a+(q<<2)+7684>>2]);q=q+1|0;}D=1.0/D;q=0;while(1){if((q|0)>=200){q=1;break;}Y=a+(q<<2)+6884|0;g[Y>>2]=+g[Y>>2]*D;Y=a+(q<<2)+7684|0;g[Y>>2]=+g[Y>>2]*D;q=q+1|0;}while(1){if((q|0)>=200)break;q=q+1|0;}if(C>.75){C=+g[r>>2];if(C>.9){Y=a+8496|0;X=(c[Y>>2]|0)+1|0;c[Y>>2]=X;c[Y>>2]=(X|0)<500?X:500;Y=a+8488|0;_=+g[Y>>2];$=u-_;g[Y>>2]=_+1.0/+(X|0)*($<-.20000000298023224?-.20000000298023224:$);}if(C<.1){Y=a+8492|0;X=(c[Y>>2]|0)+1|0;c[Y>>2]=X;c[Y>>2]=(X|0)<500?X:500;Y=a+8484|0;_=+g[Y>>2];$=u-_;g[Y>>2]=_+1.0/+(X|0)*($>.20000000298023224?.20000000298023224:$);}}else{if(!(c[a+8496>>2]|0))g[a+8488>>2]=.8999999761581421;if(!(c[a+8492>>2]|0))g[a+8484>>2]=.10000000149011612;}q=a+6856|0;r=+g[r>>2]>.5&1;if((c[q>>2]|0)!=(r|0))c[o>>2]=0;c[q>>2]=r;c[a+(b*28|0)+8536>>2]=x;g[a+(b*28|0)+8524>>2]=w;c[p>>2]=1;i=n;return;}function hi(a,b){a=+a;b=+b;var c=0,d=0.0,e=0.0,f=0.0;c=i;if(+O(+b)+ +O(+a)<9.999999717180685e-10){a=a*999999995904.0;b=b*999999995904.0;}d=b*b;e=a*a;if(d<e){f=(e+d*.6784840226173401)*(e+d*.0859554186463356);if(f!=0.0){f=-(b*a*(e+d*.43157973885536194))/f+(a<0.0?-1.5707963705062866:1.5707963705062866);i=c;return+f;}else{f=a<0.0?-1.5707963705062866:1.5707963705062866;i=c;return+f;}}else{f=(d+e*.6784840226173401)*(d+e*.0859554186463356);if(f!=0.0){b=b*a;f=b*(d+e*.43157973885536194)/f+(a<0.0?-1.5707963705062866:1.5707963705062866)-(b<0.0?-1.5707963705062866:1.5707963705062866);i=c;return+f;}else{f=(a<0.0?-1.5707963705062866:1.5707963705062866)-(b*a<0.0?-1.5707963705062866:1.5707963705062866);i=c;return+f;}}return 0.0;}function ii(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,f=0,h=0,j=0.0,k=0,l=0.0;d=i;i=i+400|0;c=d;k=28800;e=0;while(1){if((e|0)>=15){e=0;break;}h=k;f=0;j=+g[k>>2];while(1){h=h+4|0;if((f|0)>=25)break;l=j+ +g[a+(f<<2)>>2]*+g[h>>2];f=f+1|0;j=l;}g[c+(e<<2)>>2]=+ji(j);k=h;e=e+1|0;}while(1){if((e|0)>=2)break;f=k;a=0;j=+g[k>>2];while(1){k=f+4|0;if((a|0)>=15)break;l=j+ +g[c+(a<<2)>>2]*+g[k>>2];f=k;a=a+1|0;j=l;}g[b+(e<<2)>>2]=+ji(j);e=e+1|0;}i=d;return;}function ji(a){a=+a;var b=0,c=0.0,d=0.0,e=0;b=i;if(!(a<8.0)){a=1.0;i=b;return+a;}if(!(a>-8.0)){a=-1.0;i=b;return+a;}if(a!=a|0.0!=0.0){a=0.0;i=b;return+a;}if(a<0.0){a=-a;c=-1.0;}else c=1.0;e=~~+N(+(a*25.0+.5));a=a-+(e|0)*.03999999910593033;d=+g[27992+(e<<2)>>2];a=c*(d+a*(1.0-d*d)*(1.0-d*a));i=b;return+a;}function ki(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,h=0,j=0,k=0.0,l=0,m=0,n=0,o=0.0,p=0,q=0.0,r=0,s=0.0,t=0.0,u=0;e=i;if((c|0)<1|(b|0)<1|(a|0)==0|(d|0)==0){i=e;return;}j=$(b,c)|0;h=0;while(1){if((h|0)>=(j|0)){f=0;break;}f=a+(h<<2)|0;k=+g[f>>2];if(!(k>2.0)){if(k<-2.0)k=-2.0;}else k=2.0;g[f>>2]=k;h=h+1|0;}while(1){if((f|0)>=(c|0))break;j=a+(f<<2)|0;h=d+(f<<2)|0;q=+g[h>>2];l=0;while(1){if((l|0)>=(b|0))break;m=a+(f+($(l,c)|0)<<2)|0;o=+g[m>>2];k=o*q;if(k>=0.0)break;g[m>>2]=o+k*o;l=l+1|0;}k=+g[j>>2];n=0;while(1){m=n;while(1){if((m|0)>=(b|0))break;t=+g[a+(f+($(m,c)|0)<<2)>>2];if(t>1.0|t<-1.0)break;m=m+1|0;}if((m|0)==(b|0)){o=0.0;break;}q=+g[a+(f+($(m,c)|0)<<2)>>2];o=+O(+q);p=m;while(1){if((p|0)<=0){l=m;break;}l=p+-1|0;if(!(q*+g[a+(f+($(l,c)|0)<<2)>>2]>=0.0)){l=m;break;}else p=l;}while(1){if((l|0)>=(b|0))break;s=+g[a+(f+($(l,c)|0)<<2)>>2];if(!(q*s>=0.0))break;t=+O(+s);u=t>o;r=u?l:m;l=l+1|0;o=u?t:o;m=r;}if(!p)r=q*+g[j>>2]>=0.0;else r=0;o=(o+-1.0)/(o*o);if(q>0.0)o=-o;while(1){if((p|0)>=(l|0))break;u=a+(f+($(p,c)|0)<<2)|0;t=+g[u>>2];g[u>>2]=t+o*t*t;p=p+1|0;}a:do if(r&(m|0)>1){s=k-+g[j>>2];q=s/+(m|0);while(1){if((n|0)>=(m|0))break a;s=s-q;p=a+(f+($(n,c)|0)<<2)|0;t=+g[p>>2]+s;g[p>>2]=t;if(!(t>1.0)){if(t<-1.0)t=-1.0;}else t=1.0;g[p>>2]=t;n=n+1|0;}}while(0);if((l|0)==(b|0))break;else n=l;}g[h>>2]=o;f=f+1|0;}i=e;return;}function li(b,c){b=b|0;c=c|0;var d=0,e=0;d=i;if((b|0)<252){a[c>>0]=b;c=1;i=d;return c|0;}else{e=b|252;a[c>>0]=e;a[c+1>>0]=(b-(e&255)|0)>>>2;c=2;i=d;return c|0;}return 0;}function mi(b,c){b=b|0;c=c|0;var d=0;d=i;b=a[b>>0]|0;do if(b<<24>>24>=0){if((b&96)==96){if(!(b&8)){c=(c|0)/100|0;break;}else{c=(c|0)/50|0;break;}}else{b=(b&255)>>>3&3;if((b|0)==3){c=(c*60|0)/1e3|0;break;}else{c=(c<<b|0)/100|0;break;}}}else c=(c<<((b&255)>>>3&3)|0)/400|0;while(0);i=d;return c|0;}function ni(d,e,f,g,h,j,k,l){d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;k=k|0;l=l|0;var m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0;m=i;if(!j){e=-1;i=m;return e|0;}N=mi(d,48e3)|0;C=d+1|0;n=a[d>>0]|0;I=e+-1|0;M=n&3;a:do if((M|0)==1){if(!f){if(!(I&1)){F=(I|0)/2|0;b[j>>1]=F;A=C;y=I;z=1;B=2;D=0;N=30;break;}else{e=-4;i=m;return e|0;}}else{s=C;t=I;r=1;p=2;q=I;o=0;N=31;}}else if(!M){A=C;y=I;z=0;B=1;F=I;D=0;N=30;}else if((M|0)==2){y=oi(C,I,j)|0;x=I-y|0;z=b[j>>1]|0;if(z<<16>>16<0){e=-4;i=m;return e|0;}C=z<<16>>16;if((C|0)>(x|0)){e=-4;i=m;return e|0;}else{A=d+(y+1)|0;y=x;z=0;B=2;F=x-C|0;D=0;N=30;break;}}else{if((e|0)<2){e=-4;i=m;return e|0;}O=d+2|0;M=a[C>>0]|0;C=M&63;if(!C){e=-4;i=m;return e|0;}if(($(N,C)|0)>5760){e=-4;i=m;return e|0;}N=e+-2|0;do if(M&64){e=0;while(1){if((N|0)<1){E=-4;N=51;break;}K=O+1|0;J=a[O>>0]|0;L=N+-1|0;if(J<<24>>24!=-1){N=16;break;}O=K;N=L-254|0;e=e+254|0;}if((N|0)==16){x=J&255;H=K;G=L-x|0;x=e+x|0;break;}else if((N|0)==51){i=m;return E|0;}}else{H=O;G=N;x=0;}while(0);if((G|0)<0){e=-4;i=m;return e|0;}e=(M&255)>>>7;J=e&255^1;if(e<<24>>24!=1){if(f){s=H;t=G;r=J;p=C;q=I;o=x;N=31;break;}F=(G|0)/(C|0)|0;if(($(F,C)|0)!=(G|0)){e=-4;i=m;return e|0;}y=C+-1|0;A=F&65535;z=0;while(1){if((z|0)>=(y|0)){A=H;y=G;z=J;B=C;D=x;N=30;break a;}b[j+(z<<1)>>1]=A;z=z+1|0;}}I=C+-1|0;K=G;M=0;while(1){if((M|0)>=(I|0)){N=24;break;}O=j+(M<<1)|0;L=oi(H,K,O)|0;N=K-L|0;O=b[O>>1]|0;if(O<<16>>16<0){E=-4;N=51;break;}O=O<<16>>16;if((O|0)>(N|0)){E=-4;N=51;break;}H=H+L|0;K=N;G=G-(L+O)|0;M=M+1|0;}if((N|0)==24){if((G|0)<0)E=-4;else{A=H;y=K;z=J;B=C;F=G;D=x;N=30;break;}i=m;return E|0;}else if((N|0)==51){i=m;return E|0;}}while(0);do if((N|0)==30)if(!f){if((F|0)>1275){e=-4;i=m;return e|0;}else{b[j+(B+-1<<1)>>1]=F;w=A;u=B;v=D;break;}}else{s=A;t=y;r=z;p=B;q=F;o=D;N=31;}while(0);b:do if((N|0)==31){v=p+-1|0;u=j+(v<<1)|0;f=oi(s,t,u)|0;t=t-f|0;w=b[u>>1]|0;if(w<<16>>16<0){e=-4;i=m;return e|0;}x=w<<16>>16;if((x|0)>(t|0)){e=-4;i=m;return e|0;}w=s+f|0;if(!r){if((f+x|0)>(q|0))E=-4;else{u=p;v=o;break;}i=m;return E|0;}if(($(x,p)|0)>(t|0)){e=-4;i=m;return e|0;}else q=0;while(1){if((q|0)>=(v|0)){u=p;v=o;break b;}b[j+(q<<1)>>1]=b[u>>1]|0;q=q+1|0;}}while(0);if(k)c[k>>2]=w-d;o=(h|0)==0;p=0;while(1){if((p|0)>=(u|0))break;if(!o)c[h+(p<<2)>>2]=w;w=w+(b[j+(p<<1)>>1]|0)|0;p=p+1|0;}if(l)c[l>>2]=v+(w-d);if(!g){e=u;i=m;return e|0;}a[g>>0]=n;e=u;i=m;return e|0;}function oi(c,e,f){c=c|0;e=e|0;f=f|0;var g=0,h=0;g=i;do if((e|0)>=1){h=a[c>>0]|0;if((h&255)<252){b[f>>1]=h&255;f=1;break;}if((e|0)<2){b[f>>1]=-1;f=-1;break;}else{b[f>>1]=((d[c+1>>0]|0)<<2)+(h&255);f=2;break;}}else{b[f>>1]=-1;f=-1;}while(0);i=g;return f|0;}function pi(a){a=a|0;var b=0,d=0,e=0;b=i;i=i+16|0;d=b;if((a|0)<1|(a|0)>2){d=0;i=b;return d|0;}if(yf(d)|0){d=0;i=b;return d|0;}e=qi(c[d>>2]|0)|0;c[d>>2]=e;d=rb(a)|0;d=(qi(88)|0)+e+d|0;i=b;return d|0;}function qi(a){a=a|0;return a+3&-4|0;}function ri(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0,h=0,j=0;e=i;i=i+16|0;f=e;g=e+4|0;if(!((b|0)==8e3|(b|0)==12e3|(b|0)==16e3|(b|0)==24e3|(b|0)==48e3)){g=-1;i=e;return g|0;}if((d+-1|0)>>>0>=2){g=-1;i=e;return g|0;}wj(a|0,0,pi(d)|0)|0;if(yf(g)|0){g=-3;i=e;return g|0;}j=qi(c[g>>2]|0)|0;c[g>>2]=j;h=qi(88)|0;c[a+4>>2]=h;g=h+j|0;c[a>>2]=g;g=a+g|0;c[a+8>>2]=d;c[a+44>>2]=d;c[a+12>>2]=b;c[a+24>>2]=b;c[a+16>>2]=d;if(zf(a+h|0)|0){j=-3;i=e;return j|0;}if(tb(g,b,d)|0){j=-3;i=e;return j|0;}c[f>>2]=0;Cb(g,10016,f);c[a+56>>2]=0;c[a+60>>2]=(b|0)/400|0;c[a+84>>2]=0;j=0;i=e;return j|0;}function si(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;f=i;do if((a|0)==8e3|(a|0)==12e3|(a|0)==16e3|(a|0)==24e3|(a|0)==48e3?(b+-1|0)>>>0<2:0){g=ti(pi(b)|0)|0;if(!g){if(!d){g=0;break;}c[d>>2]=-7;g=0;break;}a=ri(g,a,b)|0;if(d)c[d>>2]=a;if(a){ui(g);g=0;}}else e=3;while(0);if((e|0)==3)if(!d)g=0;else{c[d>>2]=-1;g=0;}i=f;return g|0;}function ti(a){a=a|0;var b=0;b=i;a=qj(a)|0;i=b;return a|0;}function ui(a){a=a|0;var b=0;b=i;rj(a);i=b;return;}function vi(d,e,f,h,j,k,l){d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;var m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0;m=i;i=i+112|0;w=m;x=m+104|0;n=m+8|0;if((k|0)<0|(k|0)>1){x=-1;i=m;return x|0;}v=(k|0)==0;if(v^1|(f|0)==0|(e|0)==0?((j|0)%((c[d+12>>2]|0)/400|0|0)|0|0)!=0:0){x=-1;i=m;return x|0;}if((f|0)==0|(e|0)==0){n=d+8|0;q=0;do{l=wi(d,0,0,h+(($(q,c[n>>2]|0)|0)<<2)|0,j-q|0,0)|0;if((l|0)<0){o=l;p=28;break;}q=q+l|0;}while((q|0)<(j|0));if((p|0)==28){i=m;return o|0;}c[d+68>>2]=q;x=q;i=m;return x|0;}if((f|0)<0){x=-1;i=m;return x|0;}t=xi(e)|0;s=yi(e)|0;k=mi(e,c[d+12>>2]|0)|0;u=zi(a[e>>0]|0)|0;f=ni(e,f,0,x,0,n,w,0)|0;if((f|0)<0){x=f;i=m;return x|0;}e=e+(c[w>>2]|0)|0;if(v){if(($(f,k)|0)>(j|0)){x=-2;i=m;return x|0;}c[d+52>>2]=t;c[d+48>>2]=s;c[d+60>>2]=k;c[d+44>>2]=u;q=d+8|0;t=0;r=0;while(1){if((r|0)>=(f|0))break;s=n+(r<<1)|0;k=wi(d,e,b[s>>1]|0,h+(($(t,c[q>>2]|0)|0)<<2)|0,j-t|0,0)|0;if((k|0)<0){o=k;p=28;break;}e=e+(b[s>>1]|0)|0;t=t+k|0;r=r+1|0;}if((p|0)==28){i=m;return o|0;}c[d+68>>2]=t;if(!l){g[d+76>>2]=0.0;g[d+72>>2]=0.0;x=t;i=m;return x|0;}else{ki(h,t,c[q>>2]|0,d+72|0);x=t;i=m;return x|0;}}else{if(!((k|0)>(j|0)|(t|0)==1002)?(q=d+52|0,(c[q>>2]|0)!=1002):0){o=d+68|0;f=c[o>>2]|0;p=j-k|0;if((k|0)!=(j|0)?(r=vi(d,0,0,h,p,0,l)|0,(r|0)<0):0){c[o>>2]=f;x=r;i=m;return x|0;}c[q>>2]=t;c[d+48>>2]=s;c[d+60>>2]=k;c[d+44>>2]=u;d=wi(d,e,b[n>>1]|0,h+(($(c[d+8>>2]|0,p)|0)<<2)|0,k,1)|0;if((d|0)<0){x=d;i=m;return x|0;}c[o>>2]=j;x=j;i=m;return x|0;}x=vi(d,0,0,h,j,0,l)|0;i=m;return x|0;}return 0;}function wi(a,d,e,f,h,j){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,N=0,O=0,P=0,Q=0.0;k=i;i=i+80|0;q=k;l=k+16|0;B=k+12|0;m=k+8|0;u=k+64|0;s=k+4|0;c[m>>2]=0;A=a+(c[a+4>>2]|0)|0;r=a+(c[a>>2]|0)|0;o=a+12|0;v=c[o>>2]|0;t=(v|0)/50|0;F=t>>1;p=t>>2;n=t>>3;if((n|0)>(h|0)){P=-2;i=k;return P|0;}y=((v|0)/25|0)*3|0;y=(y|0)>(h|0)?h:y;if((e|0)>=2){G=(d|0)==0;if(G)w=6;else{x=c[a+60>>2]|0;h=c[a+52>>2]|0;kc(l,d,e);w=20;}}else{G=c[a+60>>2]|0;d=0;y=(y|0)<(G|0)?y:G;G=1;w=6;}do if((w|0)==6){h=c[a+56>>2]|0;if(!h){a=a+8|0;l=0;while(1){if((l|0)>=($(y,c[a>>2]|0)|0))break;g[f+(l<<2)>>2]=0.0;l=l+1|0;}i=k;return y|0;}if((y|0)>(t|0)){l=a+8|0;n=y;while(1){m=wi(a,0,0,f,(n|0)<(t|0)?n:t,0)|0;if((m|0)<0){y=m;w=115;break;}f=f+(($(m,c[l>>2]|0)|0)<<2)|0;n=n-m|0;if((n|0)<=0){w=115;break;}}if((w|0)==115){i=k;return y|0;}}if((y|0)<(t|0)){if((y|0)<=(F|0)){if((h|0)!=1e3){if((y|0)>(p|0)&(y|0)<(F|0)){if(G){x=p;w=27;break;}else{x=p;w=20;break;}}else x=y;}else{x=y;h=1e3;}}else x=F;}else x=y;if(G)w=27;else w=20;}while(0);do if((w|0)==20){z=c[a+56>>2]|0;if((z|0)>0){v=(h|0)==1002;z=(z|0)==1002;if(v){if(z){w=27;break;}if(c[a+64>>2]|0){w=27;break;}if(v){E=$(p,c[a+8>>2]|0)|0;v=ta()|0;D=i;i=i+((4*E|0)+15&-16)|0;E=1;}else w=28;}else if(z)w=28;else{w=27;break;}if((w|0)==28){E=$(p,c[a+8>>2]|0)|0;v=ta()|0;D=i;i=i+16|0;if((h|0)!=1002){z=0;D=0;C=1;break;}}wi(a,0,0,D,(p|0)<(x|0)?p:x,0)|0;z=0;C=1;}else w=27;}while(0);if((w|0)==27){v=ta()|0;z=1;D=0;E=1;C=0;}a:do if((x|0)>(y|0))a=-1;else{y=(h|0)==1002;if(y){A=i;i=i+16|0;}else{P=$((F|0)>(x|0)?F:x,c[a+8>>2]|0)|0;F=i;i=i+((2*P|0)+15&-16)|0;if((c[a+56>>2]|0)==1002)zf(A)|0;P=(x*1e3|0)/(c[o>>2]|0)|0;c[a+32>>2]=(P|0)<10?10:P;if(G)H=1;else{c[a+20>>2]=c[a+44>>2];do if((h|0)==1e3){H=c[a+48>>2]|0;if((H|0)==1101){c[a+28>>2]=8e3;break;}else if((H|0)==1102){c[a+28>>2]=12e3;break;}else if((H|0)==1103){c[a+28>>2]=16e3;break;}else{c[a+28>>2]=16e3;break;}}else c[a+28>>2]=16e3;while(0);H=j<<1;}N=a+16|0;M=a+84|0;J=a+8|0;I=(H|0)==0;K=0;L=F;while(1){b:do if(!(Af(A,N,H,(K|0)==0&1,l,L,B,c[M>>2]|0)|0))P=c[J>>2]|0;else{if(I){a=-3;break a;}c[B>>2]=x;O=0;while(1){P=c[J>>2]|0;if((O|0)>=($(x,P)|0))break b;b[L+(O<<1)>>1]=0;O=O+1|0;}}while(0);O=c[B>>2]|0;L=L+(($(O,P)|0)<<1)|0;K=K+O|0;if((K|0)>=(x|0)){A=F;break;}}}B=(j|0)==0;do if(B){if(!y){if(!G){G=l+20|0;H=l+28|0;P=(Ii(c[G>>2]|0,c[H>>2]|0)|0)+17|0;if((P+((c[a+52>>2]|0)==1001?20:0)|0)>(e<<3|0)){j=0;F=0;G=0;w=61;}else{if((h|0)==1001){F=rc(l,12)|0;if(!F){j=0;F=0;G=0;w=61;break;}j=rc(l,1)|0;w=(tc(l,256)|0)+2|0;G=c[G>>2]|0;H=c[H>>2]|0;}else{j=rc(l,1)|0;G=c[G>>2]|0;H=c[H>>2]|0;w=e-((Ii(G,H)|0)+7>>3)|0;F=1;}e=e-w|0;P=(e<<3|0)<(Ii(G,H)|0);G=P?0:w;w=l+4|0;c[w>>2]=(c[w>>2]|0)-G;e=P?0:e;F=P?0:F;w=61;}}else{j=0;F=0;G=0;w=62;}}else{j=0;F=0;G=0;H=0;}}else{j=0;F=0;G=0;w=61;}while(0);if((w|0)==61)if(y)H=0;else w=62;if((w|0)==62)H=17;I=c[a+48>>2]|0;if((I|0)==1103|(I|0)==1102)I=17;else if((I|0)==1104)I=19;else if((I|0)==1101)I=13;else I=21;c[q>>2]=I;Cb(r,10012,q);c[q>>2]=c[a+44>>2];Cb(r,10008,q);F=(F|0)==0;do if(F){I=i;i=i+((4*E|0)+15&-16)|0;if(!z){if(!y){wi(a,0,0,I,(p|0)<(x|0)?p:x,0)|0;D=I;}if(!F){w=73;break;}}else C=0;z=i;i=i+16|0;}else{C=0;w=73;}while(0);if((w|0)==73){P=$(p,c[a+8>>2]|0)|0;z=i;i=i+((4*P|0)+15&-16)|0;if(j){c[q>>2]=0;Cb(r,10010,q);vb(r,d+e|0,G,z,p,0,0)|0;c[q>>2]=m;Cb(r,4031,q);}}c[q>>2]=H;Cb(r,10010,q);do if((h|0)==1e3){b[u>>1]=-1;t=a+8|0;w=0;while(1){if((w|0)>=($(x,c[t>>2]|0)|0))break;g[f+(w<<2)>>2]=0.0;w=w+1|0;}if((c[a+56>>2]|0)==1001){if(!(F|(j|0)==0)?(c[a+64>>2]|0)!=0:0){t=0;break;}c[q>>2]=0;Cb(r,10010,q);vb(r,u,2,f,n,0,0)|0;t=0;}else t=0;}else{t=(t|0)<(x|0)?t:x;P=c[a+56>>2]|0;if((h|0)!=(P|0)&(P|0)>0?(c[a+64>>2]|0)==0:0)Cb(r,4028,q);t=vb(r,B?d:0,e,f,t,l,0)|0;}while(0);c:do if(!y){u=a+8|0;w=0;while(1){if((w|0)>=($(x,c[u>>2]|0)|0))break c;P=f+(w<<2)|0;g[P>>2]=+g[P>>2]+ +(b[A+(w<<1)>>1]|0)*30517578125.0e-15;w=w+1|0;}}while(0);c[q>>2]=s;Cb(r,10015,q);s=c[(c[s>>2]|0)+60>>2]|0;do if(!F){if(!j){Cb(r,4028,q);c[q>>2]=0;Cb(r,10010,q);vb(r,d+e|0,G,z,p,0,0)|0;c[q>>2]=m;Cb(r,4031,q);P=c[a+8>>2]|0;O=f+(($(P,x-n|0)|0)<<2)|0;N=z+(($(P,n)|0)<<2)|0;Ji(O,N,O,n,P,s,c[o>>2]|0);break;}q=a+8|0;r=0;while(1){u=c[q>>2]|0;if((r|0)<(u|0))u=0;else break;while(1){if((u|0)>=(n|0))break;P=($(c[q>>2]|0,u)|0)+r|0;g[f+(P<<2)>>2]=+g[z+(P<<2)>>2];u=u+1|0;}r=r+1|0;}O=$(u,n)|0;P=f+(O<<2)|0;Ji(z+(O<<2)|0,P,P,n,u,s,c[o>>2]|0);}while(0);do if(C){q=a+8|0;if((x|0)<(p|0)){Ji(D,f,f,n,c[q>>2]|0,s,c[o>>2]|0);break;}else u=0;while(1){p=c[q>>2]|0;r=$(p,n)|0;if((u|0)>=(r|0))break;g[f+(u<<2)>>2]=+g[D+(u<<2)>>2];u=u+1|0;}P=f+(r<<2)|0;Ji(D+(r<<2)|0,P,P,n,p,s,c[o>>2]|0);}while(0);n=c[a+40>>2]|0;d:do if(n){Q=+Y(+(+(n|0)*.0006488140788860619*.6931471805599453));o=a+8|0;n=0;while(1){if((n|0)>=($(x,c[o>>2]|0)|0))break d;P=f+(n<<2)|0;g[P>>2]=+g[P>>2]*Q;n=n+1|0;}}while(0);if((e|0)<2)c[a+80>>2]=0;else c[a+80>>2]=c[l+28>>2]^c[m>>2];c[a+56>>2]=h;c[a+64>>2]=(F?0:(j|0)==0)&1;a=(t|0)>-1?x:t;}while(0);ja(v|0);P=a;i=k;return P|0;}function xi(b){b=b|0;var c=0;c=i;b=a[b>>0]|0;if(b<<24>>24<0){i=c;return 1002;}else{i=c;return((b&96)==96?1001:1e3)|0;}return 0;}function yi(b){b=b|0;var c=0;c=i;b=a[b>>0]|0;if(b<<24>>24<0){b=(b&255)>>>5&3;i=c;return((b|0)==0?1101:b+1102|0)|0;}if((b&96)==96){b=(b&16)!=0?1105:1104;i=c;return b|0;}else{b=((b&255)>>>5&3)+1101|0;i=c;return b|0;}return 0;}function zi(a){a=a|0;return((a&4)!=0?2:1)|0;}function Ai(a,d,e,f,h,j){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0;k=i;if((h|0)<1){h=-1;i=k;return h|0;}do if((d|0)!=0&(e|0)>0&(j|0)==0){l=Bi(c[a+12>>2]|0,d,e)|0;if((l|0)>0){h=(l|0)>(h|0)?h:l;break;}else{h=-4;i=k;return h|0;}}while(0);n=a+8|0;o=$(h,c[n>>2]|0)|0;l=ta()|0;m=i;i=i+((4*o|0)+15&-16)|0;e=vi(a,d,e,m,h,j,1)|0;a:do if((e|0)>0){j=0;while(1){if((j|0)>=($(e,c[n>>2]|0)|0))break a;b[f+(j<<1)>>1]=Ci(+g[m+(j<<2)>>2])|0;j=j+1|0;}}while(0);ja(l|0);o=e;i=k;return o|0;}function Bi(a,b,c){a=a|0;b=b|0;c=c|0;var d=0;d=i;b=Hi(b,c,a)|0;i=d;return b|0;}function Ci(a){a=+a;var b=0,c=0;c=i;a=a*32768.0;if(a>-32768.0){if(a<32767.0)b=3;else a=32767.0;}else{a=-32768.0;b=3;}b=(sa(+a)|0)&65535;i=c;return b|0;}function Di(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;var g=0;g=i;if((e|0)<1)a=-1;else a=vi(a,b,c,d,e,f,0)|0;i=g;return a|0;}function Ei(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0;f=i;i=i+32|0;j=f;g=f+8|0;k=c[b+4>>2]|0;h=b+(c[b>>2]|0)|0;c[g>>2]=e;a:do switch(d|0){case 4009:{k=c[g>>2]|0;h=c[k>>2]|0;c[g>>2]=k+4;if(!h)b=20;else{c[h>>2]=c[b+48>>2];g=0;b=19;}break;};case 4029:{k=c[g>>2]|0;h=c[k>>2]|0;c[g>>2]=k+4;if(!h)b=20;else{c[h>>2]=c[b+12>>2];g=0;b=19;}break;};case 4039:{k=c[g>>2]|0;h=c[k>>2]|0;c[g>>2]=k+4;if(!h)b=20;else{c[h>>2]=c[b+68>>2];g=0;b=19;}break;};case 4031:{k=c[g>>2]|0;h=c[k>>2]|0;c[g>>2]=k+4;if(!h)b=20;else{c[h>>2]=c[b+80>>2];g=0;b=19;}break;};case 4028:{d=b+k|0;e=b+44|0;k=e+0|0;g=k+44|0;do{a[k>>0]=0;k=k+1|0;}while((k|0)<(g|0));Cb(h,4028,j);zf(d)|0;c[e>>2]=c[b+8>>2];c[b+60>>2]=(c[b+12>>2]|0)/400|0;g=0;b=19;break;};case 4045:{k=c[g>>2]|0;h=c[k>>2]|0;c[g>>2]=k+4;if(!h)b=20;else{c[h>>2]=c[b+40>>2];g=0;b=19;}break;};case 4033:{k=c[g>>2]|0;d=c[k>>2]|0;c[g>>2]=k+4;if(d){if((c[b+56>>2]|0)==1002){c[j>>2]=d;Cb(h,4033,j);g=0;b=19;break a;}else{c[d>>2]=c[b+36>>2];g=0;b=19;break a;}}else b=20;break;};case 4034:{k=c[g>>2]|0;h=c[k>>2]|0;c[g>>2]=k+4;if((h|0)<-32768|(h|0)>32767)b=20;else{c[b+40>>2]=h;g=0;b=19;}break;};default:{g=-5;b=19;}}while(0);if((b|0)==19){k=g;i=f;return k|0;}else if((b|0)==20){k=-1;i=f;return k|0;}return 0;}function Fi(a){a=a|0;var b=0;b=i;ui(a);i=b;return;}function Gi(a,b){a=a|0;b=b|0;var c=0,e=0;c=i;if((b|0)>=1){e=(d[a>>0]|0)&3;if(e){if((e|0)==3){if((b|0)<2)b=-4;else b=(d[a+1>>0]|0)&63;}else b=2;}else b=1;}else b=-1;i=c;return b|0;}function Hi(a,b,c){a=a|0;b=b|0;c=c|0;var d=0;d=i;b=Gi(a,b)|0;if((b|0)<0){i=d;return b|0;}else{b=$(b,mi(a,c)|0)|0;i=d;return((b*25|0)>(c*3|0)?-4:b)|0;}return 0;}function Ii(a,b){a=a|0;b=b|0;var c=0;c=i;b=(vj(b|0)|0)+-32+a|0;i=c;return b|0;}function Ji(a,b,c,d,e,f,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0.0;j=i;h=48e3/(h|0)|0;k=0;while(1){if((k|0)<(e|0))l=0;else break;while(1){if((l|0)>=(d|0))break;n=+g[f+(($(l,h)|0)<<2)>>2];n=n*n;m=($(l,e)|0)+k|0;g[c+(m<<2)>>2]=n*+g[b+(m<<2)>>2]+(1.0-n)*+g[a+(m<<2)>>2];l=l+1|0;}k=k+1|0;}i=j;return;}function Ki(a){a=a|0;var b=0,d=0,e=0;b=i;i=i+16|0;d=b;if((a|0)<1|(a|0)>2){d=0;i=b;return d|0;}if(Lf(d)|0){d=0;i=b;return d|0;}e=Li(c[d>>2]|0)|0;c[d>>2]=e;d=Eb(a)|0;d=(Li(18220)|0)+e+d|0;i=b;return d|0;}function Li(a){a=a|0;return a+3&-4|0;}function Mi(a,d,e,f){a=a|0;d=d|0;e=e|0;f=f|0;var h=0,j=0,k=0,l=0,m=0,n=0;j=i;i=i+16|0;h=j;k=j+4|0;if(!((d|0)==8e3|(d|0)==12e3|(d|0)==16e3|(d|0)==24e3|(d|0)==48e3)){n=-1;i=j;return n|0;}if((e+-1|0)>>>0>=2){n=-1;i=j;return n|0;}if(!((f|0)==2051|(f|0)==2049|(f|0)==2048)){n=-1;i=j;return n|0;}wj(a|0,0,Ki(e)|0)|0;if(Lf(k)|0){n=-1;i=j;return n|0;}l=Li(c[k>>2]|0)|0;c[k>>2]=l;n=Li(18220)|0;c[a+4>>2]=n;k=n+l|0;c[a>>2]=k;k=a+k|0;c[a+100>>2]=e;c[a+168>>2]=e;l=a+132|0;c[l>>2]=d;m=a+18216|0;c[m>>2]=0;if(Mf(a+n|0,0,a+8|0)|0){n=-3;i=j;return n|0;}c[a+8>>2]=e;c[a+12>>2]=e;c[a+16>>2]=c[l>>2];c[a+20>>2]=16e3;c[a+24>>2]=8e3;c[a+28>>2]=16e3;c[a+32>>2]=20;c[a+36>>2]=25e3;c[a+40>>2]=0;n=a+44|0;c[n>>2]=9;c[a+48>>2]=0;c[a+52>>2]=0;c[a+56>>2]=0;c[a+72>>2]=0;if(Gb(k,d,e,c[m>>2]|0)|0){n=-3;i=j;return n|0;}c[h>>2]=0;Xb(k,10016,h)|0;c[h>>2]=c[n>>2];Xb(k,4010,h)|0;c[a+136>>2]=1;c[a+140>>2]=1;c[a+152>>2]=-1e3;c[a+148>>2]=($(d,e)|0)+3e3;c[a+96>>2]=f;c[a+112>>2]=-1e3;c[a+116>>2]=-1e3;c[a+120>>2]=1105;c[a+108>>2]=-1e3;c[a+124>>2]=-1e3;c[a+128>>2]=-1;n=c[l>>2]|0;c[a+160>>2]=(n|0)/100|0;c[a+156>>2]=24;c[a+144>>2]=5e3;c[a+104>>2]=(n|0)/250|0;b[a+172>>1]=16384;g[a+180>>2]=1.0;c[a+176>>2]=(oh(60)|0)<<8;c[a+224>>2]=1;c[a+200>>2]=1001;c[a+216>>2]=1105;n=0;i=j;return n|0;}function Ni(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0;g=i;do if(((a|0)==8e3|(a|0)==12e3|(a|0)==16e3|(a|0)==24e3|(a|0)==48e3?(b+-1|0)>>>0<2:0)?(d|0)==2051|(d|0)==2049|(d|0)==2048:0){h=Oi(Ki(b)|0)|0;if(!h){if(!e){h=0;break;}c[e>>2]=-7;h=0;break;}a=Mi(h,a,b,d)|0;if(e)c[e>>2]=a;if(a){Pi(h);h=0;}}else f=4;while(0);if((f|0)==4)if(!e)h=0;else{c[e>>2]=-1;h=0;}i=g;return h|0;}function Oi(a){a=a|0;var b=0;b=i;a=qj(a)|0;i=b;return a|0;}function Pi(a){a=a|0;var b=0;b=i;rj(a);i=b;return;}function Qi(a,b,c,d,e,f,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0.0;j=i;k=0;while(1){if((k|0)>=(c|0))break;g[b+(k<<2)>>2]=+g[a+(($(k+d|0,h)|0)+e<<2)>>2]*32768.0;k=k+1|0;}a:do if((f|0)<=-1){if((f|0)==-2){f=1;while(1){if((f|0)<(h|0))k=0;else break a;while(1){if((k|0)>=(c|0))break;l=+g[a+(($(k+d|0,h)|0)+f<<2)>>2]*32768.0;e=b+(k<<2)|0;g[e>>2]=+g[e>>2]+l;k=k+1|0;}f=f+1|0;}}}else{k=0;while(1){if((k|0)>=(c|0))break a;l=+g[a+(($(k+d|0,h)|0)+f<<2)>>2]*32768.0;e=b+(k<<2)|0;g[e>>2]=+g[e>>2]+l;k=k+1|0;}}while(0);l=(h|0)==-2?-.5:.5;h=0;while(1){if((h|0)>=(c|0))break;e=b+(h<<2)|0;g[e>>2]=+g[e>>2]*l;h=h+1|0;}i=j;return;}function Ri(a,c,d,e,f,h,j){a=a|0;c=c|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0,l=0,m=0.0;k=i;l=0;while(1){if((l|0)>=(d|0))break;g[c+(l<<2)>>2]=+(b[a+(($(l+e|0,j)|0)+f<<1)>>1]|0);l=l+1|0;}a:do if((h|0)<=-1){if((h|0)==-2){h=1;while(1){if((h|0)<(j|0))l=0;else break a;while(1){if((l|0)>=(d|0))break;m=+(b[a+(($(l+e|0,j)|0)+h<<1)>>1]|0);f=c+(l<<2)|0;g[f>>2]=+g[f>>2]+m;l=l+1|0;}h=h+1|0;}}}else{l=0;while(1){if((l|0)>=(d|0))break a;m=+(b[a+(($(l+e|0,j)|0)+h<<1)>>1]|0);f=c+(l<<2)|0;g[f>>2]=+g[f>>2]+m;l=l+1|0;}}while(0);m=(j|0)==-2?-152587890625.0e-16:152587890625.0e-16;j=0;while(1){if((j|0)>=(d|0))break;f=c+(j<<2)|0;g[f>>2]=+g[f>>2]*m;j=j+1|0;}i=k;return;}function Si(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0,f=0;d=i;f=(c|0)/400|0;if((f|0)>(a|0)){b=-1;i=d;return b|0;}do if((b|0)==5010){f=(c|0)/50|0;e=6;}else if((b|0)!=5e3)if((b|0)>5e3&(b|0)<5007){e=(c*3|0)/50|0;f=f<<b+-5001;f=(e|0)<(f|0)?e:f;e=6;break;}else{b=-1;i=d;return b|0;}while(0);if((e|0)==6)if((f|0)>(a|0)){b=-1;i=d;return b|0;}else a=f;if(!((a*400|0)==(c|0)|(a*200|0)==(c|0)|(a*100|0)==(c|0))?(b=a*50|0,!((b|0)==(c|0)|(a*25|0)==(c|0)|(b|0)==(c*3|0))):0){b=-1;i=d;return b|0;}b=a;i=d;return b|0;}function Ti(a,b,c,d,e,f,g,h,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0;l=i;a:do if((c|0)==5010?((e|0)/200|0|0)<=(b|0):0){c=(e|0)/400|0;a=Ui(a,b,d,e,f,j,g,h)|0;while(1){d=c<<a;if((d|0)<=(b|0))break a;a=a+-1|0;}}else k=6;while(0);if((k|0)==6)d=Si(b,c,e)|0;i=l;return((d|0)<0?-1:d)|0;}function Ui(a,b,c,d,e,f,h,j){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0.0,s=0,t=0.0,u=0.0,v=0.0;k=i;i=i+224|0;l=k+112|0;m=k;o=(d|0)/400|0;n=i;i=i+((4*o|0)+15&-16)|0;t=+g[f>>2];g[l>>2]=t;g[m>>2]=1.0/(t+1.0000000036274937e-15);d=(h|0)==0;if(d){p=0;h=1;}else{p=(o<<1)-h|0;t=+g[f+4>>2];g[l+4>>2]=t;g[m+4>>2]=1.0/(t+1.0000000036274937e-15);t=+g[f+8>>2];g[l+8>>2]=t;g[m+8>>2]=1.0/(t+1.0000000036274937e-15);b=b-p|0;h=3;}b=(b|0)/(o|0)|0;b=(b|0)<24?b:24;t=0.0;q=0;while(1){if((q|0)>=(b|0))break;s=($(q,o)|0)+p|0;Ca[j&3](a,n,o,s,0,-2,c);t=(q|0)==0?+g[n>>2]:t;s=0;r=1.0000000036274937e-15;while(1){if((s|0)>=(o|0))break;v=+g[n+(s<<2)>>2];u=v-t;t=v;s=s+1|0;r=r+u*u;}s=q+h|0;g[l+(s<<2)>>2]=r;g[m+(s<<2)>>2]=1.0/r;q=q+1|0;}s=q+h|0;g[l+(s<<2)>>2]=+g[l+(s+-1<<2)>>2];if(!d){b=b+2|0;b=(b|0)>24?24:b;}c=jj(l,m,b,~~+((c*60|0)+40|0),(e|0)/400|0)|0;e=1<<c;g[f>>2]=+g[l+(e<<2)>>2];if(d){i=k;return c|0;}g[f+4>>2]=+g[l+(e+1<<2)>>2];g[f+8>>2]=+g[l+(e+2<<2)>>2];i=k;return c|0;}function Vi(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0.0,h=0.0,j=0.0,k=0,l=0.0,m=0.0,n=0.0,o=0.0,p=0.0,q=0.0,r=0.0,s=0.0,t=0.0,u=0;e=i;c=(c|0)/(b|0)|0;if((c|0)<50)f=50.0;else f=+(c|0);f=1.0-25.0/f;k=0;l=0.0;h=0.0;j=0.0;while(1){if((k|0)>=(b|0))break;u=k<<1;t=+g[a+(u<<2)>>2];p=+g[a+((u|1)<<2)>>2];s=+g[a+((u|2)<<2)>>2];o=+g[a+((u|3)<<2)>>2];r=+g[a+((u|4)<<2)>>2];n=+g[a+((u|5)<<2)>>2];q=+g[a+((u|6)<<2)>>2];m=+g[a+((u|7)<<2)>>2];k=k+4|0;l=l+(t*t+s*s+r*r+q*q);h=h+(t*p+s*o+r*n+q*m);j=j+(p*p+o*o+n*n+m*m);}s=+g[d>>2];s=s+f*(l-s);g[d>>2]=s;b=d+4|0;t=+g[b>>2];t=t+f*(h-t);g[b>>2]=t;u=d+8|0;h=+g[u>>2];h=h+f*(j-h);g[u>>2]=h;j=s<0.0?0.0:s;g[d>>2]=j;f=t<0.0?0.0:t;g[b>>2]=f;h=h<0.0?0.0:h;g[u>>2]=h;if((j>h?j:h)>.0007999999797903001){q=+P(+j);s=+P(+h);t=+P(+q);r=+P(+s);s=q*s;q=f<s?f:s;g[b>>2]=q;s=q/(s+1.0000000036274937e-15);r=+P(+(1.0-s*s))*(+O(+(t-r))/(t+1.0000000036274937e-15+r));u=d+12|0;t=+g[u>>2];s=+(c|0);t=t+(r-t)/s;g[u>>2]=t;u=d+16|0;s=+g[u>>2]-.019999999552965164/s;t=s>t?s:t;g[u>>2]=t;t=t*20.0;u=t>1.0;t=u?1.0:t;i=e;return+t;}else{t=+g[d+16>>2];t=t*20.0;u=t>1.0;t=u?1.0:t;i=e;return+t;}return 0.0;}function Wi(d,e,f,h,j,k,l,m,n,o,p,q,r){d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;l=l|0;m=m|0;n=n|0;o=o|0;p=p|0;q=q|0;r=r|0;var s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0,I=0,J=0,K=0,L=0,M=0,O=0,P=0,Q=0,R=0,S=0,T=0,U=0,V=0,W=0,X=0,Y=0,Z=0,_=0,aa=0,ba=0,ca=0,da=0,ea=0,fa=0,ga=0,ha=0,ia=0,ka=0,la=0,ma=0,na=0,oa=0,pa=0.0,qa=0,ra=0,sa=0.0,ua=0.0,va=0.0;s=i;i=i+528|0;A=s;O=s+520|0;x=s+472|0;y=s+464|0;F=s+460|0;C=s+432|0;ka=s+344|0;ha=s+312|0;U=s+8|0;P=s+4|0;B=s+526|0;z=s+524|0;c[y>>2]=0;E=(j|0)>1276?1276:j;w=d+18212|0;c[w>>2]=0;K=d+144|0;do if(!(c[K>>2]|0)){D=f*400|0;u=c[d+132>>2]|0;if((D|0)==(u|0)){u=d+132|0;break;}if(!((f*200|0)==(u|0)|(f*100|0)==(u|0))?(ra=f*50|0,!((ra|0)==(u|0)|(f*25|0)==(u|0)|(ra|0)==(u*3|0))):0){ra=-1;i=s;return ra|0;}else t=7;}else{D=f*400|0;u=c[d+132>>2]|0;t=7;}while(0);if((t|0)==7)if((D|0)<(u|0)){ra=-1;i=s;return ra|0;}else u=d+132|0;if((E|0)<1){ra=-1;i=s;return ra|0;}ba=c[d+4>>2]|0;Q=d+ba|0;D=d+(c[d>>2]|0)|0;_=d+96|0;if((c[_>>2]|0)==2051)G=0;else G=c[d+104>>2]|0;Z=c[d+156>>2]|0;Z=(Z|0)>(k|0)?k:Z;c[C>>2]=0;c[A>>2]=F;Xb(D,10015,A)|0;ia=d+44|0;if((c[ia>>2]|0)>6?(c[u>>2]|0)==48e3:0){fa=c[d+12596>>2]|0;ea=c[d+12600>>2]|0;fi(d+4092|0,c[F>>2]|0,l,m,f,n,o,p,48e3,Z,q,C);}else{fa=-1;ea=-1;}I=d+128|0;c[I>>2]=-1;ga=d+18204|0;c[ga>>2]=0;do if(c[C>>2]|0){if((c[d+112>>2]|0)==-1e3)c[I>>2]=~~+N(+((1.0-+g[C+20>>2])*100.0+.5));m=c[C+24>>2]|0;if((m|0)<13){c[ga>>2]=1101;break;}if((m|0)<15){c[ga>>2]=1102;break;}if((m|0)<17){c[ga>>2]=1103;break;}if((m|0)<19){c[ga>>2]=1104;break;}else{c[ga>>2]=1105;break;}}while(0);m=d+100|0;if((c[m>>2]|0)==2?(c[d+108>>2]|0)!=1:0)pa=+Vi(e,f,c[u>>2]|0,d+232|0);else pa=0.0;na=Xi(d,f,E)|0;l=d+148|0;c[l>>2]=na;T=c[u>>2]|0;Y=(T|0)/(f|0)|0;do if((E|0)>=3?(na|0)>=(Y*24|0):0){if((Y|0)<50?($(E,Y)|0)<300|(na|0)<2400:0)break;v=d+136|0;ma=(c[v>>2]|0)==0;if(ma){ra=Y<<3;na=(na+(Y<<2)|0)/(ra|0)|0;E=(na|0)<(E|0)?na:E;na=$(E,ra)|0;c[l>>2]=na;}R=$(Y,E)|0;S=R<<3;L=c[m>>2]|0;J=Y+-50|0;k=na-($((L*40|0)+20|0,J)|0)|0;M=c[d+112>>2]|0;do if((M|0)!=3001){if((M|0)!=3002){I=c[I>>2]|0;if((I|0)<=-1){la=(c[_>>2]|0)==2048?115:48;break;}la=I*327>>8;if((c[_>>2]|0)==2049)la=(la|0)<115?la:115;}else la=0;}else la=127;while(0);aa=d+108|0;I=c[aa>>2]|0;M=(L|0)==2;if((I|0)==-1e3){if(M){ra=d+168|0;I=(k|0)>(((c[ra>>2]|0)==2?29e3:31e3)|0)?2:1;c[ra>>2]=I;}else t=55;}else if(M)c[d+168>>2]=I;else t=55;if((t|0)==55){c[d+168>>2]=L;I=L;}k=d+168|0;J=na-($((I*40|0)+20|0,J)|0)|0;L=c[_>>2]|0;do if((L|0)!=2051){qa=c[d+124>>2]|0;if((qa|0)==-1e3){va=1.0-pa;M=~~(va*16.0e3+pa*16.0e3);M=M+(($($(la,la)|0,~~(va*64.0e3+pa*36.0e3)-M|0)|0)>>14)|0;L=(L|0)==2048?M+8e3|0:M;M=c[d+204>>2]|0;if((M|0)==1002)L=L+-4e3|0;else L=(M|0)>0?L+4e3|0:L;qa=(J|0)>=(L|0)?1002:1e3;L=d+200|0;c[L>>2]=qa;do if(c[d+48>>2]|0){if((c[d+40>>2]|0)<=(128-la>>4|0))break;c[L>>2]=1e3;qa=1e3;}while(0);if((c[d+52>>2]|0)!=0&(la|0)>100){c[L>>2]=1e3;M=d+200|0;qa=1e3;}else t=68;}else{c[d+200>>2]=qa;t=68;}if((t|0)==68){M=d+200|0;if((qa|0)==1002){qa=1002;break;}}if(((T|0)/100|0|0)>(f|0)){c[M>>2]=1002;qa=1002;}}else{c[d+200>>2]=1002;M=d+200|0;qa=1002;}while(0);da=d+164|0;if(c[da>>2]|0){c[M>>2]=1002;qa=1002;}V=(Y|0)>50;if((E|0)<(($(V?12e3:8e3,f)|0)/(T<<3|0)|0|0)){c[M>>2]=1002;qa=1002;}do if(((I|0)==1?(c[d+208>>2]|0)==2:0)?(H=d+64|0,!((c[H>>2]|0)!=0|(qa|0)==1002)):0){oa=c[d+204>>2]|0;if((oa|0)==1002){t=80;break;}c[H>>2]=1;c[k>>2]=2;}else t=80;while(0);if((t|0)==80){c[d+64>>2]=0;oa=c[d+204>>2]|0;}I=d+204|0;do if((oa|0)>0){H=(oa|0)==1002;if((qa|0)!=1002){if(H)H=1002;else{X=0;W=0;H=0;break;}ra=(qa|0)!=1002;X=ra&1;if(ra){W=1;H=0;break;}}else{if(H){qa=1002;X=0;W=0;H=0;break;}H=oa;X=(qa|0)!=1002&1;}if(((T|0)/100|0|0)>(f|0)){qa=1002;W=0;H=0;break;}c[M>>2]=H;qa=H;W=1;H=1;}else{X=0;W=0;H=0;}while(0);L=d+220|0;if(!(c[L>>2]|0)){ra=0;if(!W){ma=ra;T=0;}else t=92;}else{c[L>>2]=0;X=1;ra=1;W=1;t=92;}do if((t|0)==92){T=(T|0)/200|0;T=($(E,T)|0)/(T+f|0)|0;T=(T|0)>257?257:T;if(ma){ma=ra;break;}na=(na|0)/1600|0;ma=ra;T=(T|0)<(na|0)?T:na;}while(0);a:do if((qa|0)==1002){ia=1;ka=J;t=103;}else{if((oa|0)==1002){Mf(Q,c[d+18216>>2]|0,ka)|0;qa=c[M>>2]|0;ma=1;}ka=(qa|0)==1002;if(ka){ia=ka;ka=J;t=103;break;}do if(!(c[d+224>>2]|0)){if(c[d+80>>2]|0){t=ka;if(t){ia=t;ka=J;t=103;break a;}else break;}else{oa=c[d+216>>2]|0;la=ka;ha=ma;break a;}}else t=ka;while(0);ka=($(J,(c[ia>>2]|0)+45|0)|0)/50|0;ia=t;ka=(c[v>>2]|0)==0?ka+-1e3|0:ka;t=103;}while(0);do if((t|0)==103){if((c[m>>2]|0)==2?(c[aa>>2]|0)!=1:0){na=30520;oa=30488;}else{na=30584;oa=30552;}qa=$(la,la)|0;la=0;while(1){if((la|0)>=8)break;ra=c[na+(la<<2)>>2]|0;c[ha+(la<<2)>>2]=ra+(($(qa,(c[oa+(la<<2)>>2]|0)-ra|0)|0)>>14);la=la+1|0;}la=(c[d+224>>2]|0)==0;na=d+216|0;oa=1105;do{ra=oa<<1;qa=c[ha+(ra+-2204<<2)>>2]|0;ra=c[ha+(ra+-2203<<2)>>2]|0;do if(la)if((c[na>>2]|0)<(oa|0)){qa=qa+ra|0;break;}else{qa=qa-ra|0;break;}while(0);if((ka|0)>=(qa|0))break;oa=oa+-1|0;}while((oa|0)>1101);c[na>>2]=oa;if(la^1|ia){la=ia;ha=ma;break;}if(!((c[d+84>>2]|0)==0&(oa|0)>1103)){la=ia;ha=ma;break;}c[na>>2]=1103;oa=1103;la=ia;ha=ma;}while(0);ia=d+216|0;ka=c[d+120>>2]|0;if((oa|0)>(ka|0)){c[ia>>2]=ka;oa=ka;}ka=d+116|0;ma=c[ka>>2]|0;if((ma|0)==-1e3)ma=-1e3;else{c[ia>>2]=ma;oa=ma;}if((la^1)&(S|0)<15e3){oa=(oa|0)<1103?oa:1103;c[ia>>2]=oa;}na=c[u>>2]|0;do if((na|0)<24001){if((oa|0)>1104){c[ia>>2]=1104;oa=1104;}if((na|0)>=16001)break;if((oa|0)>1103){c[ia>>2]=1103;oa=1103;}if((na|0)>=12001)break;if((oa|0)>1102){c[ia>>2]=1102;oa=1102;}if(!((na|0)<8001&(oa|0)>1101))break;c[ia>>2]=1101;oa=1101;}while(0);na=c[ga>>2]|0;if((na|0)!=0&(ma|0)==-1e3){ma=c[k>>2]|0;do if((J|0)>(ma*18e3|0)|la^1){if(!((J|0)>(ma*24e3|0)|la^1)){la=1102;break;}if((J|0)<=(ma*3e4|0)){la=1103;break;}la=(J|0)>(ma*44e3|0)?1105:1104;}else la=1101;while(0);ra=(na|0)>(la|0)?na:la;c[ga>>2]=ra;c[ia>>2]=(oa|0)<(ra|0)?oa:ra;}c[A>>2]=Z;Xb(D,4036,A)|0;la=c[M>>2]|0;ma=(la|0)==1002;do if(ma){if((c[ia>>2]|0)!=1102)break;c[ia>>2]=1103;}while(0);if(c[da>>2]|0)c[ia>>2]=1101;ga=c[u>>2]|0;do if(((ga|0)/50|0|0)<(f|0)){if(!ma?(ca=c[ia>>2]|0,(ca|0)<=1103):0)break;if((fa|0)!=-1){c[d+12596>>2]=fa;c[d+12600>>2]=ea;}A=((ga|0)/25|0|0)<(f|0)?3:2;D=(j+-3|0)/(A|0)|0;D=(D|0)>1276?1276:D;f=$(A,D)|0;w=ta()|0;E=i;i=i+((1*f|0)+15&-16)|0;lj(U);f=d+124|0;z=c[f>>2]|0;y=c[ka>>2]|0;x=c[aa>>2]|0;c[f>>2]=c[M>>2];c[ka>>2]=c[ia>>2];k=c[k>>2]|0;c[aa>>2]=k;C=d+64|0;B=c[C>>2]|0;if(!B)c[d+208>>2]=k;else c[aa>>2]=1;F=(H|0)!=0;k=A+-1|0;H=0;while(1){if((H|0)>=(A|0)){t=163;break;}c[C>>2]=0;if(F&(H|0)==(k|0))c[f>>2]=1002;G=c[u>>2]|0;I=E+($(H,D)|0)|0;G=Wi(d,e+(($(H,($(c[m>>2]|0,G)|0)/50|0)|0)<<2)|0,(G|0)/50|0,I,D,Z,0,0,n,o,p,q,r)|0;if((G|0)<0){h=-3;break;}if((mj(U,I,G)|0)<0){h=-3;break;}H=H+1|0;}do if((t|0)==163){d=(c[v>>2]|0)==0;if(d){ra=((c[l>>2]|0)*3|0)/(1200/(A>>>0)|0|0)|0;j=(ra|0)<(j|0)?ra:j;}h=oj(U,A,h,j,d&1)|0;if((h|0)<0){h=-3;break;}c[f>>2]=z;c[ka>>2]=y;c[aa>>2]=x;c[C>>2]=B;}while(0);ja(w|0);ra=h;i=s;return ra|0;}else ca=c[ia>>2]|0;while(0);do if((la|0)==1e3){if((ca|0)<=1103)break;c[M>>2]=1001;if((ca|0)<1104)t=172;}else if((la|0)==1001&(ca|0)<1104)t=172;while(0);if((t|0)==172)c[M>>2]=1e3;n=E-T|0;Z=($(c[l>>2]|0,f)|0)/(ga<<3|0)|0;Z=((n|0)<(Z|0)?n:Z)+-1|0;n=E+-1|0;wc(x,h+1|0,n);p=G+f|0;q=$(p,c[m>>2]|0)|0;U=ta()|0;j=i;i=i+((4*q|0)+15&-16)|0;q=d+160|0;ra=c[m>>2]|0;yj(j|0,d+(($((c[q>>2]|0)-G|0,ra)|0)<<2)+252|0,($(G,ra)|0)<<2|0)|0;if((c[M>>2]|0)==1002)o=(oh(60)|0)<<8;else o=c[d+(ba+8)>>2]|0;ra=d+176|0;qa=c[ra>>2]|0;o=o-qa|0;o=qa+(((o>>16)*983|0)+(((o&65535)*983|0)>>>16))|0;c[ra>>2]=o;if((c[_>>2]|0)==2048){oa=sh(o>>8)|0;ra=c[m>>2]|0;qa=j+(($(G,ra)|0)<<2)|0;Zi(e,oa,qa,d+184|0,f,ra,c[u>>2]|0);}else{ra=c[m>>2]|0;qa=j+(($(G,ra)|0)<<2)|0;_i(e,qa,d+184|0,f,ra,c[u>>2]|0);}do if(r){e=c[m>>2]|0;r=j+(($(G,e)|0)<<2)|0;e=$(e,f)|0;va=+$i(r,r,e);if(!(!(va<1.0e9)|(va!=va|0.0!=0.0)))break;wj(r|0,0,e<<2|0)|0;}while(0);b:do if((c[M>>2]|0)==1002){pa=1.0;O=0;t=244;}else{aa=$(c[m>>2]|0,f)|0;e=ta()|0;r=i;i=i+((2*aa|0)+15&-16)|0;aa=$(Z<<3,Y)|0;Y=c[M>>2]|0;o=(Y|0)==1001;do if(!o){c[d+36>>2]=aa;_=c[d+228>>2]|0;if(!_)pa=1.0;else{pa=1.0;t=191;}}else{ba=c[k>>2]|0;fa=$(ba,(c[u>>2]|0)==(f*100|0)?6e3:5e3)|0;_=d+36|0;c[_>>2]=fa;ea=(ca|0)==1104;ga=aa-fa|0;if(ea)ga=(ga<<1|0)/3|0;else ga=(ga*3|0)/5|0;ra=fa+ga|0;qa=(aa<<2|0)/5|0;oa=(ra|0)>(qa|0);fa=oa?qa:ra;c[_>>2]=oa?qa:ra;_=c[d+228>>2]|0;if(_){aa=fa;pa=1.0;t=191;break;}pa=+(aa-fa|0);pa=pa/(pa+ +($(ba,ea?3e3:3600)|0));if(!(pa<.8571428656578064)){aa=fa;pa=1.0;break;}aa=fa;pa=pa+.1428571492433548;}while(0);do if((t|0)==191){if(!(c[v>>2]|0))break;if(c[da>>2]|0)break;ba=c[ia>>2]|0;if((ba|0)==1101){ga=13;sa=8.0e3;}else{ra=(ba|0)==1102;ga=ra?15:17;sa=ra?12.0e3:16.0e3;}ea=c[m>>2]|0;ua=0.0;fa=0;while(1){if((fa|0)>=(ea|0))break;da=fa*21|0;ia=0;while(1){if((ia|0)>=(ga|0))break;va=+g[_+(da+ia<<2)>>2];do if(va<.5){if(!(va>-2.0)){va=-2.0;break;}if(va>0.0)t=202;}else{va=.5;t=202;}while(0);if((t|0)==202){t=0;va=va*.5;}ua=ua+va;ia=ia+1|0;}fa=fa+1|0;}ra=~~(sa*(ua/+(ga|0)*+(ea|0)+.20000000298023224));_=($(aa,-2)|0)/3|0;_=(ra|0)>(_|0)?ra:_;if((ba+-1104|0)>>>0<2)ba=(_*3|0)/5|0;else ba=_;aa=aa+ba|0;c[d+36>>2]=aa;ra=$(_,f)|0;Z=Z+((ra|0)/(c[u>>2]<<3|0)|0)|0;}while(0);ba=c[u>>2]|0;c[d+32>>2]=(f*1e3|0)/(ba|0)|0;_=c[m>>2]|0;c[d+8>>2]=_;c[d+12>>2]=c[k>>2];if((ca|0)==1101){c[d+28>>2]=8e3;da=8e3;}else if((ca|0)==1102){c[d+28>>2]=12e3;da=12e3;}else{c[d+28>>2]=16e3;da=16e3;}ea=d+24|0;do if(o){c[ea>>2]=16e3;t=221;}else{c[ea>>2]=8e3;if((Y|0)!=1e3){t=221;break;}Y=d+20|0;c[Y>>2]=16e3;if(V)S=(R<<4|0)/3|0;if((S|0)<13e3){c[Y>>2]=12e3;da=da>>>0>12e3?12e3:da;c[d+28>>2]=da;}if((S|0)>=9600)break;c[Y>>2]=8e3;c[d+28>>2]=(da|0)>8e3?8e3:da;}while(0);if((t|0)==221)c[d+20>>2]=16e3;S=(c[v>>2]|0)==0;c[d+56>>2]=S&1;V=n-T|0;V=(V|0)>1275?1275:V;c[O>>2]=V;R=d+60|0;if(o)V=(V*72|0)/10|0;else V=V<<3;c[R>>2]=V;if(S){c[R>>2]=(($(aa,f)|0)/(ba<<3|0)|0)<<3;ra=aa+-2e3|0;c[d+36>>2]=(ra|0)<1?1:ra;}if(!ha)P=0;else{c[P>>2]=0;qa=(ba|0)/400|0;S=$(_,(c[q>>2]|0)-(c[d+104>>2]|0)-qa|0)|0;oa=d+(S<<2)+252|0;ra=c[F>>2]|0;aj(oa,oa,0.0,1.0,c[ra+4>>2]|0,qa,_,c[ra+60>>2]|0,ba);wj(d+252|0,0,S<<2|0)|0;S=0;while(1){R=c[q>>2]|0;if((S|0)>=($(R,c[m>>2]|0)|0))break;b[r+(S<<1)>>1]=bj(+g[d+(S<<2)+252>>2])|0;S=S+1|0;}Of(Q,d+8|0,r,R,0,P,1)|0;P=0;}while(1){R=c[m>>2]|0;if((P|0)>=($(R,f)|0))break;b[r+(P<<1)>>1]=bj(+g[j+(($(G,R)|0)+P<<2)>>2])|0;P=P+1|0;}P=Of(Q,d+8|0,r,f,x,O,0)|0;do if(!P){if(!(c[O>>2]|0)){c[w>>2]=0;a[h>>0]=Yi(c[M>>2]|0,(c[u>>2]|0)/(f|0)|0,ca,c[k>>2]|0)|0;E=1;break;}do if((c[M>>2]|0)==1e3){t=c[d+76>>2]|0;if((t|0)==8e3){ca=1101;break;}if((t|0)==12e3){ca=1102;break;}ca=(t|0)==16e3?1103:ca;}while(0);ra=c[d+92>>2]|0;c[d+68>>2]=ra;if(ra){c[L>>2]=1;X=0;W=1;}ja(e|0);O=P;t=244;break b;}else E=-3;while(0);ja(e|0);}while(0);c:do if((t|0)==244){if((ca|0)==1101)P=13;else if((ca|0)==1103|(ca|0)==1102)P=17;else if((ca|0)==1104)P=19;else P=21;c[A>>2]=P;Xb(D,10012,A)|0;c[A>>2]=c[k>>2];Xb(D,10008,A)|0;c[A>>2]=-1;Xb(D,4002,A)|0;do if((c[M>>2]|0)==1e3){R=c[m>>2]|0;Z=($(R,c[u>>2]|0)|0)/400|0;K=i;i=i+((4*Z|0)+15&-16)|0;Z=0;}else{c[A>>2]=0;Xb(D,4006,A)|0;c[A>>2]=(c[d+72>>2]|0)==0?2:0;Xb(D,10002,A)|0;P=c[M>>2]|0;if((P|0)!=1001){if(c[v>>2]|0){do if((c[K>>2]|0)==5010){K=c[u>>2]|0;if(((K|0)/50|0|0)==(f|0)){K=0;break;}K=$(((c[k>>2]|0)*60|0)+40|0,((K|0)/(f|0)|0)+-50|0)|0;if(!(c[C>>2]|0))break;K=~~(+(K|0)*(+g[C+4>>2]*.5+1.0));}else K=0;while(0);c[A>>2]=1;Xb(D,4006,A)|0;c[A>>2]=c[d+140>>2];Xb(D,4020,A)|0;c[A>>2]=(c[l>>2]|0)+K;Xb(D,4002,A)|0;P=c[M>>2]|0;Z=n-T|0;}R=c[m>>2]|0;Q=c[u>>2]|0;S=($(R,Q)|0)/400|0;K=i;i=i+((4*S|0)+15&-16)|0;if((P|0)==1e3)break;}else{K=(cj(c[x+20>>2]|0,c[x+28>>2]|0)|0)+7>>3;K=(W|0)==0?K:K+3|0;if(!(c[v>>2]|0))Z=(K|0)>(Z|0)?K:Z;else{ra=$(c[d+36>>2]|0,f)|0;Z=K+Z-((ra|0)/(c[u>>2]<<3|0)|0)|0;}R=c[m>>2]|0;Q=c[u>>2]|0;S=($(R,Q)|0)/400|0;K=i;i=i+((4*S|0)+15&-16)|0;P=1001;}ra=c[I>>2]|0;if(!((P|0)!=(ra|0)&(ra|0)>0))break;yj(K|0,d+(($((c[q>>2]|0)-G-((Q|0)/400|0)|0,R)|0)<<2)+252|0,S<<2|0)|0;}while(0);Q=c[q>>2]|0;P=d+252|0;if(($(R,Q-p|0)|0)>0){ra=$(R,Q-f-G|0)|0;zj(P|0,d+(($(R,f)|0)<<2)+252|0,ra<<2|0)|0;yj(d+(ra<<2)+252|0,j|0,($(p,R)|0)<<2|0)|0;}else yj(P|0,j+(($(p-Q|0,R)|0)<<2)|0,($(Q,R)|0)<<2|0)|0;G=d+180|0;sa=+g[G>>2];if(sa<1.0|pa<1.0){ra=c[F>>2]|0;aj(j,j,sa,pa,c[ra+4>>2]|0,f,c[m>>2]|0,c[ra+60>>2]|0,c[u>>2]|0);}g[G>>2]=pa;G=c[M>>2]|0;if(!((G|0)==1001?(c[k>>2]|0)!=1:0)){if((J+-3e4|0)<0)J=0;else{J=(J<<1)+-6e4|0;J=(J|0)>16384?16384:J;}c[d+88>>2]=J;}do if(!(c[d+228>>2]|0)){if((c[m>>2]|0)!=2)break;P=d+172|0;Q=b[P>>1]|0;J=c[d+88>>2]|0;if(!(Q<<16>>16<16384|(J|0)<16384))break;G=c[F>>2]|0;dj(j,j,+(Q<<16>>16)*6103515625.0e-14,+(J|0)*6103515625.0e-14,c[G+4>>2]|0,f,2,c[G+60>>2]|0,c[u>>2]|0);b[P>>1]=c[d+88>>2];G=c[M>>2]|0;}while(0);do if((G|0)==1002)t=291;else{J=x+20|0;F=x+28|0;P=cj(c[J>>2]|0,c[F>>2]|0)|0;G=(G|0)==1001;if((P+17+(G?20:0)|0)>((E<<3)+-8|0)){t=291;break;}if(G){if((W|0)==0?(P+37|0)>(Z<<3|0):0){t=291;break;}Bc(x,W,12);}if(!W){t=291;break;}Bc(x,X,1);G=(c[M>>2]|0)==1001;if(G)F=Z;else F=(cj(c[J>>2]|0,c[F>>2]|0)|0)+7>>3;ra=n-F|0;l=(c[l>>2]|0)/1600|0;l=(ra|0)<(l|0)?ra:l;if((l|0)<2)l=2;else l=(l|0)>257?257:l;if(!G)break;Dc(x,l+-2|0,256);}while(0);if((t|0)==291){c[L>>2]=0;W=0;l=0;}F=c[M>>2]|0;do if((F|0)==1002){G=0;t=295;}else{if((F|0)!=1e3){G=17;t=295;break;}O=(cj(c[x+20>>2]|0,c[x+28>>2]|0)|0)+7>>3;Ic(x);F=O;G=17;}while(0);if((t|0)==295){F=n-l|0;F=(F|0)<(Z|0)?F:Z;Hc(x,F);}t=(W|0)==0;do if(t){if((c[M>>2]|0)==1e3)break;c[A>>2]=C;Xb(D,10022,A)|0;}else{c[A>>2]=C;Xb(D,10022,A)|0;if(!X)break;c[A>>2]=0;Xb(D,10010,A)|0;c[A>>2]=0;Xb(D,4006,A)|0;if((Kb(D,j,(c[u>>2]|0)/200|0,h+(F+1)|0,l,0)|0)<0){E=-3;break c;}c[A>>2]=y;Xb(D,4031,A)|0;Xb(D,4028,A)|0;}while(0);c[A>>2]=G;Xb(D,10010,A)|0;C=c[M>>2]|0;do if((C|0)!=1e3){ra=c[I>>2]|0;if((C|0)!=(ra|0)&(ra|0)>0){Xb(D,4028,A)|0;Kb(D,K,(c[u>>2]|0)/400|0,B,2,0)|0;c[A>>2]=0;Xb(D,10002,A)|0;}if((cj(c[x+20>>2]|0,c[x+28>>2]|0)|0)>(F<<3|0))break;O=Kb(D,j,f,0,F,x)|0;if((O|0)<0){E=-3;break c;}}while(0);if((t^1)&(X|0)==0){oa=c[u>>2]|0;ra=(oa|0)/200|0;oa=(oa|0)/400|0;Xb(D,4028,A)|0;c[A>>2]=0;Xb(D,10010,A)|0;c[A>>2]=0;Xb(D,10002,A)|0;qa=f-ra|0;Kb(D,j+(($(c[m>>2]|0,qa-oa|0)|0)<<2)|0,oa,z,2,0)|0;if((Kb(D,j+(($(c[m>>2]|0,qa)|0)<<2)|0,ra,h+(F+1)|0,l,0)|0)<0){E=-3;break;}c[A>>2]=y;Xb(D,4031,A)|0;}a[h>>0]=Yi(c[M>>2]|0,(c[u>>2]|0)/(f|0)|0,ca,c[k>>2]|0)|0;u=c[x+28>>2]|0;c[w>>2]=u^c[y>>2];if(!H)m=c[M>>2]|0;else m=1002;c[I>>2]=m;c[d+208>>2]=c[k>>2];c[d+212>>2]=f;c[d+224>>2]=0;d:do if((cj(c[x+20>>2]|0,u)|0)>((E<<3)+-8|0)){if((E|0)<2){E=-2;break c;}a[h+1>>0]=0;c[w>>2]=0;O=1;}else{if((c[M>>2]|0)==1e3^1|t^1)break;while(1){if((O|0)<=2)break d;if(a[h+O>>0]|0)break d;O=O+-1|0;}}while(0);d=O+(l+1)|0;if(!(c[v>>2]|0)){if(pj(h,d,E)|0){E=-3;break;}}else E=d;}while(0);ja(U|0);ra=E;i=s;return ra|0;}while(0);m=c[d+200>>2]|0;u=c[d+216>>2]|0;u=(u|0)==0?1101:u;do if((Y|0)<=100){if((Y|0)>=50?(v=(m|0)==0?1e3:m,(v|0)!=1e3):0)if((v|0)==1002){t=38;break;}else{t=39;break;}if((u|0)>1103){u=1103;v=1e3;}else{v=1e3;t=40;}}else{v=1002;t=38;}while(0);if((t|0)==38)if((u|0)==1102)u=1101;else t=39;if((t|0)==39)if((u|0)<1105)t=40;if((t|0)==40)u=1104;a[h>>0]=Yi(v,Y,u,c[d+168>>2]|0)|0;ra=1;i=s;return ra|0;}function Xi(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0;e=i;if(!b)b=(c[a+132>>2]|0)/400|0;f=c[a+152>>2]|0;if((f|0)==-1){f=($(d<<3,c[a+132>>2]|0)|0)/(b|0)|0;i=e;return f|0;}else if((f|0)==-1e3){f=c[a+132>>2]|0;f=((f*60|0)/(b|0)|0)+($(f,c[a+100>>2]|0)|0)|0;i=e;return f|0;}else{i=e;return f|0;}return 0;}function Yi(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0;e=i;f=0;while(1){if((b|0)>=400)break;b=b<<1;f=f+1|0;}if((a|0)==1e3)c=(c<<5)+96&224|(f<<3)+-16;else if((a|0)==1002){c=c+-1102|0;c=((c|0)<0?0:c)<<5&96|f<<3|128;}else c=c<<4|(f<<3)+240|96;i=e;return(c|((d|0)==2&1)<<2)&255|0;}function Zi(a,b,d,e,f,g,h){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0;j=i;i=i+32|0;k=j+8|0;l=j;m=((b<<16>>16)*2471|0)/((h|0)/1e3|0|0)|0;h=$(m,-471)|0;b=h+268435456|0;c[k>>2]=b;c[k+4>>2]=-268435456-h<<1;c[k+8>>2]=b;h=b>>6;o=m<<16>>16;p=$(m>>16,o)|0;o=$(m&65535,o)|0;m=$(m,(m>>15)+1>>1)|0;q=p+(o>>>16)+m<<16>>16;n=h&65535;c[l>>2]=($(b>>22,q)|0)+(($(n,q)|0)>>16)+($(h,(p+(o>>16)+m+-8388608>>15)+1>>1)|0);m=h<<16>>16;c[l+4>>2]=($(b>>22,m)|0)+(($(n,m)|0)>>16)+($(h,(b>>21)+1>>1)|0);ij(a,k,l,e,d,f,g);if((g|0)!=2){i=j;return;}ij(a+4|0,k,l,e+8|0,d+4|0,f,2);i=j;return;}function _i(a,b,c,d,e,f){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;var h=0,j=0.0,k=0,l=0,m=0,n=0,o=0.0,p=0.0;h=i;j=12.0/+(f|0);f=0;while(1){if((f|0)>=(e|0))break;l=f<<1;k=c+(l<<2)|0;l=c+((l|1)<<2)|0;m=0;while(1){if((m|0)>=(d|0))break;n=($(m,e)|0)+f|0;p=+g[k>>2];o=+g[a+(n<<2)>>2]-p;g[k>>2]=p+j*o+1.0000000031710769e-30;p=+g[l>>2];o=o-p;g[l>>2]=p+j*o+1.0000000031710769e-30;g[b+(n<<2)>>2]=o;m=m+1|0;}f=f+1|0;}i=h;return;}function $i(a,b,c){a=a|0;b=b|0;c=c|0;var d=0,e=0.0,f=0,h=0.0;d=i;f=0;e=0.0;while(1){if((f|0)>=(c|0))break;h=e+ +g[a+(f<<2)>>2]*+g[b+(f<<2)>>2];f=f+1|0;e=h;}i=d;return+e;}function aj(a,b,c,d,e,f,h,j,k){a=a|0;b=b|0;c=+c;d=+d;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0.0,o=0;l=i;k=48e3/(k|0)|0;e=(e|0)/(k|0)|0;a:do if((h|0)==1){m=0;while(1){if((m|0)>=(e|0)){j=0;break a;}n=+g[j+(($(m,k)|0)<<2)>>2];n=n*n;g[b+(m<<2)>>2]=(n*d+(1.0-n)*c)*+g[a+(m<<2)>>2];m=m+1|0;}}else{m=0;while(1){if((m|0)>=(e|0)){j=0;break a;}n=+g[j+(($(m,k)|0)<<2)>>2];n=n*n;n=n*d+(1.0-n)*c;o=m<<1;g[b+(o<<2)>>2]=n*+g[a+(o<<2)>>2];o=o|1;g[b+(o<<2)>>2]=n*+g[a+(o<<2)>>2];m=m+1|0;}}while(0);do{k=e;while(1){if((k|0)>=(f|0))break;o=($(k,h)|0)+j|0;g[b+(o<<2)>>2]=+g[a+(o<<2)>>2]*d;k=k+1|0;}j=j+1|0;}while((j|0)<(h|0));i=l;return;}function bj(a){a=+a;var b=0,c=0;c=i;a=a*32768.0;if(a>-32768.0){if(a<32767.0)b=3;else a=32767.0;}else{a=-32768.0;b=3;}b=(sa(+a)|0)&65535;i=c;return b|0;}function cj(a,b){a=a|0;b=b|0;var c=0;c=i;b=(vj(b|0)|0)+-32+a|0;i=c;return b|0;}function dj(a,b,c,d,e,f,h,j,k){a=a|0;b=b|0;c=+c;d=+d;e=e|0;f=f|0;h=h|0;j=j|0;k=k|0;var l=0,m=0,n=0,o=0.0,p=0;l=i;k=48e3/(k|0)|0;e=(e|0)/(k|0)|0;c=1.0-c;d=1.0-d;m=0;while(1){if((m|0)>=(e|0))break;o=+g[j+(($(m,k)|0)<<2)>>2];o=o*o;p=$(m,h)|0;n=p+1|0;o=(o*d+(1.0-o)*c)*(+g[a+(p<<2)>>2]-+g[a+(n<<2)>>2])*.5;p=b+(p<<2)|0;g[p>>2]=+g[p>>2]-o;n=b+(n<<2)|0;g[n>>2]=+g[n>>2]+o;m=m+1|0;}while(1){if((m|0)>=(f|0))break;n=$(m,h)|0;p=n+1|0;o=d*(+g[a+(n<<2)>>2]-+g[a+(p<<2)>>2])*.5;n=b+(n<<2)|0;g[n>>2]=+g[n>>2]-o;p=b+(p<<2)|0;g[p>>2]=+g[p>>2]+o;m=m+1|0;}i=l;return;}function ej(a,d,e,f,h){a=a|0;d=d|0;e=e|0;f=f|0;h=h|0;var j=0,k=0,l=0,m=0,n=0,o=0;j=i;if((c[a+96>>2]|0)==2051)k=0;else k=c[a+104>>2]|0;n=a+100|0;m=Ti(d,e,c[a+144>>2]|0,c[n>>2]|0,c[a+132>>2]|0,c[a+148>>2]|0,k,1,a+10960|0)|0;n=c[n>>2]|0;o=$(m,n)|0;l=i;i=i+((4*o|0)+15&-16)|0;k=0;while(1){if((k|0)>=(o|0))break;g[l+(k<<2)>>2]=+(b[d+(k<<1)>>1]|0)*30517578125.0e-15;k=k+1|0;}o=Wi(a,l,m,f,h,16,d,e,0,-2,n,1,0)|0;i=j;return o|0;}function fj(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,j=0;g=i;if((c[a+96>>2]|0)==2051)h=0;else h=c[a+104>>2]|0;j=a+100|0;h=Ti(b,d,c[a+144>>2]|0,c[j>>2]|0,c[a+132>>2]|0,c[a+148>>2]|0,h,2,a+10960|0)|0;h=Wi(a,b,h,e,f,24,b,d,0,-2,c[j>>2]|0,2,1)|0;i=g;return h|0;}function gj(a,d,e){a=a|0;d=d|0;e=e|0;var f=0,h=0,j=0,k=0;f=i;i=i+112|0;j=f;h=f+96|0;k=f+8|0;c[h>>2]=e;e=a+(c[a>>2]|0)|0;a:do switch(d|0){case 4013:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+48>>2];h=0;a=99;}break;};case 4008:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;do if((j|0)>=1101){if((j|0)>1105){a=100;break a;}c[a+116>>2]=j;if((j|0)==1101){c[a+20>>2]=8e3;h=0;a=99;break a;}else if((j|0)==1102){c[a+20>>2]=12e3;h=0;a=99;break a;}else break;}else{if((j|0)!=-1e3){a=100;break a;}c[a+116>>2]=j;}while(0);c[a+20>>2]=16e3;h=0;a=99;break;};case 4004:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!((j|0)<1101|(j|0)>1105)){c[a+120>>2]=j;if((j|0)==1102){c[a+20>>2]=12e3;h=0;a=99;break a;}else if((j|0)==1101){c[a+20>>2]=8e3;h=0;a=99;break a;}else{c[a+20>>2]=16e3;h=0;a=99;break a;}}else a=100;break;};case 4009:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+216>>2];h=0;a=99;}break;};case 4010:{d=c[h>>2]|0;k=c[d>>2]|0;c[h>>2]=d+4;if((k|0)<0|(k|0)>10)a=100;else{c[a+44>>2]=k;c[j>>2]=k;Xb(e,4010,j)|0;h=0;a=99;}break;};case 4002:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if((j|0)!=-1e3){if((j|0)!=-1){if((j|0)<1){a=100;break a;}if((j|0)<501)h=500;else{h=(c[a+100>>2]|0)*3e5|0;h=(j|0)>(h|0)?h:j;}}else h=-1;}else h=-1e3;c[a+152>>2]=h;h=0;a=99;break;};case 10024:{k=c[h>>2]|0;d=c[k>>2]|0;c[h>>2]=k+4;c[a+164>>2]=d;c[j>>2]=d;h=Xb(e,10024,j)|0;a=99;break;};case 4015:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+40>>2];h=0;a=99;}break;};case 4017:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+52>>2];h=0;a=99;}break;};case 4023:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+108>>2];h=0;a=99;}break;};case 4011:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+44>>2];h=0;a=99;}break;};case 4036:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if((j|0)<8|(j|0)>24)a=100;else{c[a+156>>2]=j;h=0;a=99;}break;};case 4037:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+156>>2];h=0;a=99;}break;};case 4007:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+136>>2];h=0;a=99;}break;};case 11002:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if((j|0)<1e3){if((j|0)!=-1e3){a=100;break a;}}else if((j|0)>1002){a=100;break a;}c[a+124>>2]=j;h=0;a=99;break;};case 4028:{d=a+(c[a+4>>2]|0)|0;h=a+168|0;wj(h|0,0,18052)|0;Xb(e,4028,j)|0;Mf(d,c[a+18216>>2]|0,k)|0;c[h>>2]=c[a+100>>2];b[a+172>>1]=16384;g[a+180>>2]=1.0;c[a+224>>2]=1;c[a+200>>2]=1001;c[a+216>>2]=1105;c[a+176>>2]=(oh(60)|0)<<8;h=0;a=99;break;};case 11019:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+128>>2];h=0;a=99;}break;};case 4e3:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if((j|0)==2051|(j|0)==2049|(j|0)==2048){h=a+96|0;if((c[a+224>>2]|0)==0?(c[h>>2]|0)!=(j|0):0){h=-1;a=99;break a;}c[h>>2]=j;h=0;a=99;}else{h=-1;a=99;}break;};case 4003:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=Xi(a,c[a+212>>2]|0,1276)|0;h=0;a=99;}break;};case 4014:{d=c[h>>2]|0;k=c[d>>2]|0;c[h>>2]=d+4;if((k|0)<0|(k|0)>100)a=100;else{c[a+40>>2]=k;c[j>>2]=k;Xb(e,4014,j)|0;h=0;a=99;}break;};case 4027:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(j){h=(c[a+132>>2]|0)/400|0;c[j>>2]=h;if((c[a+96>>2]|0)==2051){h=0;a=99;}else{c[j>>2]=h+(c[a+104>>2]|0);h=0;a=99;}}else a=100;break;};case 4022:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if((j|0)<1){if((j|0)!=-1e3){a=100;break a;}}else if((j|0)>(c[a+100>>2]|0)){a=100;break a;}c[a+108>>2]=j;h=0;a=99;break;};case 4040:{d=c[h>>2]|0;k=c[d>>2]|0;c[h>>2]=d+4;switch(k|0){case 5010:case 5006:case 5005:case 5004:case 5003:case 5002:case 5001:case 5e3:break;default:{a=100;break a;}}c[a+144>>2]=k;c[j>>2]=k;Xb(e,4040,j)|0;h=0;a=99;break;};case 4041:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+144>>2];h=0;a=99;}break;};case 4006:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if((j|0)<0|(j|0)>1)a=100;else{c[a+136>>2]=j;c[a+56>>2]=1-j;h=0;a=99;}break;};case 4001:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+96>>2];h=0;a=99;}break;};case 4021:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+140>>2];h=0;a=99;}break;};case 4031:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+18212>>2];h=0;a=99;}break;};case 4016:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if((j|0)<0|(j|0)>1)a=100;else{c[a+52>>2]=j;h=0;a=99;}break;};case 11018:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if((j|0)<-1|(j|0)>100)a=100;else{c[a+128>>2]=j;h=0;a=99;}break;};case 4005:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+120>>2];h=0;a=99;}break;};case 4042:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if((j|0)>1|(j|0)<0)a=100;else{c[a+72>>2]=j;h=0;a=99;}break;};case 4043:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+72>>2];h=0;a=99;}break;};case 4012:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if((j|0)<0|(j|0)>1)a=100;else{c[a+48>>2]=j;h=0;a=99;}break;};case 4029:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+132>>2];h=0;a=99;}break;};case 4024:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if((j|0)==3002|(j|0)==3001|(j|0)==-1e3){c[a+112>>2]=j;h=0;a=99;}else a=100;break;};case 4025:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if(!j)a=100;else{c[j>>2]=c[a+112>>2];h=0;a=99;}break;};case 10026:{k=c[h>>2]|0;d=c[k>>2]|0;c[h>>2]=k+4;c[a+228>>2]=d;c[j>>2]=d;h=Xb(e,10026,j)|0;a=99;break;};case 10015:{d=c[h>>2]|0;a=c[d>>2]|0;c[h>>2]=d+4;if(!a)a=100;else{c[j>>2]=a;h=Xb(e,10015,j)|0;a=99;}break;};case 4020:{d=c[h>>2]|0;j=c[d>>2]|0;c[h>>2]=d+4;if((j|0)<0|(j|0)>1)a=100;else{c[a+140>>2]=j;h=0;a=99;}break;};default:{h=-5;a=99;}}while(0);if((a|0)==99){d=h;i=f;return d|0;}else if((a|0)==100){d=-1;i=f;return d|0;}return 0;}function hj(a){a=a|0;var b=0;b=i;Pi(a);i=b;return;}function ij(a,b,d,e,f,h,j){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;h=h|0;j=j|0;var k=0.0,l=0,m=0.0,n=0.0,o=0.0,p=0.0,q=0,r=0.0,s=0.0;l=i;k=+(c[d>>2]|0)*3.725290298461914e-9;o=+(c[d+4>>2]|0)*3.725290298461914e-9;m=+(c[b>>2]|0)*3.725290298461914e-9;n=+(c[b+4>>2]|0)*3.725290298461914e-9;p=+(c[b+8>>2]|0)*3.725290298461914e-9;b=e+4|0;d=0;while(1){if((d|0)>=(h|0))break;q=$(d,j)|0;s=+g[a+(q<<2)>>2];r=+g[e>>2]+m*s;g[e>>2]=+g[b>>2]-r*k+n*s;g[b>>2]=p*s-r*o+1.0000000031710769e-30;g[f+(q<<2)>>2]=r;d=d+1|0;}i=l;return;}function jj(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var h=0,j=0,k=0,l=0.0,m=0,n=0,o=0,p=0.0,q=0,r=0,s=0,t=0,u=0.0,v=0,w=0,x=0,y=0.0,z=0,A=0;h=i;i=i+3072|0;k=h+1536|0;j=h;if((f|0)>=80){if((f|0)>160)l=1.0;else l=(+(f|0)+-80.0)/80.0;}else l=0.0;m=0;while(1){if((m|0)>=16)break;c[j+(m<<2)>>2]=-1;g[k+(m<<2)>>2]=1.0e10;m=m+1|0;}m=d+1|0;n=0;while(1){if((n|0)>=4){m=1;break;}A=1<<n;g[k+(A<<2)>>2]=+((f<<n)+e|0)*(l*+kj(a,b,n,m)+1.0);c[j+(A<<2)>>2]=n;n=n+1|0;}while(1){if((m|0)>=(d|0))break;n=m+-1|0;o=2;while(1){if((o|0)>=16)break;A=o+-1|0;g[k+(m<<6)+(o<<2)>>2]=+g[k+(n<<6)+(A<<2)>>2];c[j+(m<<6)+(o<<2)>>2]=A;o=o+1|0;}o=k+(n<<6)+4|0;t=a+(m<<2)|0;s=b+(m<<2)|0;q=d-m|0;r=q+1|0;p=+(q|0);v=0;while(1){if((v|0)>=4)break;w=1<<v;x=j+(m<<6)+(w<<2)|0;c[x>>2]=1;u=+g[o>>2];A=1;while(1){if((A|0)>=4)break;A=A+1|0;z=(1<<A)+-1|0;y=+g[k+(n<<6)+(z<<2)>>2];if(!(y<u))continue;c[x>>2]=z;u=y;}y=+((f<<v)+e|0)*(l*+kj(t,s,v,r)+1.0);x=k+(m<<6)+(w<<2)|0;g[x>>2]=u;if((q|0)<(w|0))y=y*p/+(w|0);g[x>>2]=u+y;v=v+1|0;}m=m+1|0;}b=d+-1|0;l=+g[k+(b<<6)+4>>2];a=1;e=2;while(1){if((e|0)>=16)break;y=+g[k+(b<<6)+(e<<2)>>2];A=y<l;l=A?y:l;a=A?e:a;e=e+1|0;}while(1){k=d+-1|0;if((d|0)<=0)break;a=c[j+(k<<6)+(a<<2)>>2]|0;d=k;}i=h;return a|0;}function kj(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0.0,h=0.0,j=0.0,k=0.0;e=i;c=1<<c;d=(c|0)<(d|0)?c+1|0:d;c=0;h=0.0;f=0.0;while(1){if((c|0)>=(d|0))break;k=h+ +g[a+(c<<2)>>2];j=f+ +g[b+(c<<2)>>2];c=c+1|0;h=k;f=j;}f=(h*f/+($(d,d)|0)+-2.0)*.05000000074505806;b=f<0.0;if(b)h=0.0;else h=f;if(+P(+h)>1.0){k=1.0;i=e;return+k;}if(b)f=0.0;k=+P(+f);i=e;return+k;}function lj(a){a=a|0;c[a+4>>2]=0;return;}function mj(a,b,c){a=a|0;b=b|0;c=c|0;var d=0;d=i;a=nj(a,b,c)|0;i=d;return a|0;}function nj(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0;f=i;i=i+16|0;j=f;if((e|0)<1){k=-4;i=f;return k|0;}g=b+4|0;k=c[g>>2]|0;if(k){if(((a[b>>0]^a[d>>0])&255)>=4){k=-4;i=f;return k|0;}}else{a[b>>0]=a[d>>0]|0;c[b+296>>2]=mi(d,8e3)|0;}h=Gi(d,e)|0;if((h|0)<1){k=-4;i=f;return k|0;}if(($(h+k|0,c[b+296>>2]|0)|0)>960){k=-4;i=f;return k|0;}b=ni(d,e,0,j,b+(k<<2)+8|0,b+(k<<1)+200|0,0,0)|0;if((b|0)<1){k=b;i=f;return k|0;}c[g>>2]=(c[g>>2]|0)+h;k=0;i=f;return k|0;}function oj(e,f,g,h,j){e=e|0;f=f|0;g=g|0;h=h|0;j=j|0;var k=0,l=0,m=0,n=0,o=0,p=0;k=i;if((f|0)<=0){p=-1;i=k;return p|0;}if((c[e+4>>2]|0)<(f|0)){p=-1;i=k;return p|0;}n=e+200|0;do if((f|0)==1){p=b[n>>1]|0;if((p|0)<(h|0)){a[g>>0]=d[e>>0]&252;o=g+1|0;p=p+1|0;break;}else{p=-2;i=k;return p|0;}}else if((f|0)==2){p=b[e+202>>1]|0;o=b[n>>1]|0;if(p<<16>>16==o<<16>>16){p=p<<16>>16<<1|1;if((p|0)>(h|0)){p=-2;i=k;return p|0;}else{a[g>>0]=d[e>>0]&252|1;o=g+1|0;break;}}else{p=(o<<16>>16)+(p<<16>>16)+2+(o<<16>>16>251&1)|0;if((p|0)>(h|0)){p=-2;i=k;return p|0;}else{a[g>>0]=d[e>>0]&252|2;o=g+((li(b[n>>1]|0,g+1|0)|0)+1)|0;break;}}}else{o=g;p=0;}while(0);if(!((f|0)<=2?!((j|0)!=0&(p|0)<(h|0)):0)){o=1;m=13;}a:do if((m|0)==13){while(1){if((o|0)>=(f|0)){m=21;break;}if((b[e+(o<<1)+200>>1]|0)!=(b[n>>1]|0)){m=16;break;}o=o+1|0;m=13;}do if((m|0)==16){n=f+-1|0;o=0;m=2;while(1){if((o|0)>=(n|0))break;p=b[e+(o<<1)+200>>1]|0;o=o+1|0;m=m+((p<<16>>16>251?2:1)+(p<<16>>16))|0;}p=m+(b[e+(n<<1)+200>>1]|0)|0;if((p|0)>(h|0)){p=-2;i=k;return p|0;}else{a[g>>0]=d[e>>0]|3;o=f|128;a[g+1>>0]=o;n=1;break;}}else if((m|0)==21){p=($(b[n>>1]|0,f)|0)+2|0;if((p|0)>(h|0)){p=-2;i=k;return p|0;}else{a[g>>0]=d[e>>0]|3;a[g+1>>0]=f;o=f;n=0;break;}}while(0);m=g+2|0;if((j|0)!=0?(l=h-p|0,(p|0)!=(h|0)):0){a[g+1>>0]=o|64;o=(l+-1|0)/255|0;p=0;while(1){if((p|0)>=(o|0))break;a[m>>0]=-1;m=m+1|0;p=p+1|0;}a[m>>0]=l+($(o,-255)|0)+255;o=m+1|0;p=h;}else o=m;if(n){l=f+-1|0;m=0;while(1){if((m|0)>=(l|0))break a;o=o+(li(b[e+(m<<1)+200>>1]|0,o)|0)|0;m=m+1|0;}}}while(0);l=0;while(1){if((l|0)>=(f|0))break;n=e+(l<<1)+200|0;zj(o|0,c[e+(l<<2)+8>>2]|0,b[n>>1]|0)|0;o=o+(b[n>>1]|0)|0;l=l+1|0;}if(!j){i=k;return p|0;}g=g+h|0;while(1){if(o>>>0>=g>>>0)break;a[o>>0]=0;o=o+1|0;}i=k;return p|0;}function pj(a,b,d){a=a|0;b=b|0;d=d|0;var e=0,f=0,g=0;e=i;i=i+304|0;f=e;if((b|0)<1){b=-1;i=e;return b|0;}if((b|0)==(d|0)){b=0;i=e;return b|0;}if((b|0)>(d|0)){b=-1;i=e;return b|0;}else{lj(f);g=a+(d-b)|0;zj(g|0,a|0,b|0)|0;mj(f,g,b)|0;b=oj(f,c[f+4>>2]|0,a,d,1)|0;i=e;return((b|0)>0?0:b)|0;}return 0;}function qj(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0,x=0,y=0,z=0,A=0,B=0,C=0,D=0,E=0,F=0,G=0,H=0;b=i;do if(a>>>0<245){if(a>>>0<11)a=16;else a=a+11&-8;v=a>>>3;p=c[7654]|0;w=p>>>v;if(w&3){h=(w&1^1)+v|0;g=h<<1;e=30656+(g<<2)|0;g=30656+(g+2<<2)|0;j=c[g>>2]|0;d=j+8|0;f=c[d>>2]|0;do if((e|0)!=(f|0)){if(f>>>0<(c[7658]|0)>>>0)xa();k=f+12|0;if((c[k>>2]|0)==(j|0)){c[k>>2]=e;c[g>>2]=f;break;}else xa();}else c[7654]=p&~(1<<h);while(0);H=h<<3;c[j+4>>2]=H|3;H=j+(H|4)|0;c[H>>2]=c[H>>2]|1;H=d;i=b;return H|0;}if(a>>>0>(c[7656]|0)>>>0){if(w){h=2<<v;h=w<<v&(h|0-h);h=(h&0-h)+-1|0;d=h>>>12&16;h=h>>>d;f=h>>>5&8;h=h>>>f;g=h>>>2&4;h=h>>>g;e=h>>>1&2;h=h>>>e;j=h>>>1&1;j=(f|d|g|e|j)+(h>>>j)|0;h=j<<1;e=30656+(h<<2)|0;h=30656+(h+2<<2)|0;g=c[h>>2]|0;d=g+8|0;f=c[d>>2]|0;do if((e|0)!=(f|0)){if(f>>>0<(c[7658]|0)>>>0)xa();k=f+12|0;if((c[k>>2]|0)==(g|0)){c[k>>2]=e;c[h>>2]=f;break;}else xa();}else c[7654]=p&~(1<<j);while(0);h=j<<3;f=h-a|0;c[g+4>>2]=a|3;e=g+a|0;c[g+(a|4)>>2]=f|1;c[g+h>>2]=f;h=c[7656]|0;if(h){g=c[7659]|0;k=h>>>3;j=k<<1;h=30656+(j<<2)|0;l=c[7654]|0;k=1<<k;if(l&k){j=30656+(j+2<<2)|0;k=c[j>>2]|0;if(k>>>0<(c[7658]|0)>>>0)xa();else{D=j;C=k;}}else{c[7654]=l|k;D=30656+(j+2<<2)|0;C=h;}c[D>>2]=g;c[C+12>>2]=g;c[g+8>>2]=C;c[g+12>>2]=h;}c[7656]=f;c[7659]=e;H=d;i=b;return H|0;}p=c[7655]|0;if(p){e=(p&0-p)+-1|0;G=e>>>12&16;e=e>>>G;F=e>>>5&8;e=e>>>F;H=e>>>2&4;e=e>>>H;f=e>>>1&2;e=e>>>f;d=e>>>1&1;d=c[30920+((F|G|H|f|d)+(e>>>d)<<2)>>2]|0;e=(c[d+4>>2]&-8)-a|0;f=d;while(1){g=c[f+16>>2]|0;if(!g){g=c[f+20>>2]|0;if(!g)break;}f=(c[g+4>>2]&-8)-a|0;H=f>>>0<e>>>0;e=H?f:e;f=g;d=H?g:d;}h=c[7658]|0;if(d>>>0<h>>>0)xa();f=d+a|0;if(d>>>0>=f>>>0)xa();g=c[d+24>>2]|0;k=c[d+12>>2]|0;do if((k|0)==(d|0)){k=d+20|0;j=c[k>>2]|0;if(!j){k=d+16|0;j=c[k>>2]|0;if(!j){B=0;break;}}while(1){l=j+20|0;m=c[l>>2]|0;if(m){j=m;k=l;continue;}m=j+16|0;l=c[m>>2]|0;if(!l)break;else{j=l;k=m;}}if(k>>>0<h>>>0)xa();else{c[k>>2]=0;B=j;break;}}else{j=c[d+8>>2]|0;if(j>>>0<h>>>0)xa();h=j+12|0;if((c[h>>2]|0)!=(d|0))xa();l=k+8|0;if((c[l>>2]|0)==(d|0)){c[h>>2]=k;c[l>>2]=j;B=k;break;}else xa();}while(0);do if(g){h=c[d+28>>2]|0;j=30920+(h<<2)|0;if((d|0)==(c[j>>2]|0)){c[j>>2]=B;if(!B){c[7655]=c[7655]&~(1<<h);break;}}else{if(g>>>0<(c[7658]|0)>>>0)xa();h=g+16|0;if((c[h>>2]|0)==(d|0))c[h>>2]=B;else c[g+20>>2]=B;if(!B)break;}if(B>>>0<(c[7658]|0)>>>0)xa();c[B+24>>2]=g;g=c[d+16>>2]|0;do if(g)if(g>>>0<(c[7658]|0)>>>0)xa();else{c[B+16>>2]=g;c[g+24>>2]=B;break;}while(0);g=c[d+20>>2]|0;if(g)if(g>>>0<(c[7658]|0)>>>0)xa();else{c[B+20>>2]=g;c[g+24>>2]=B;break;}}while(0);if(e>>>0<16){H=e+a|0;c[d+4>>2]=H|3;H=d+(H+4)|0;c[H>>2]=c[H>>2]|1;}else{c[d+4>>2]=a|3;c[d+(a|4)>>2]=e|1;c[d+(e+a)>>2]=e;h=c[7656]|0;if(h){g=c[7659]|0;l=h>>>3;j=l<<1;h=30656+(j<<2)|0;k=c[7654]|0;l=1<<l;if(k&l){j=30656+(j+2<<2)|0;k=c[j>>2]|0;if(k>>>0<(c[7658]|0)>>>0)xa();else{A=j;z=k;}}else{c[7654]=k|l;A=30656+(j+2<<2)|0;z=h;}c[A>>2]=g;c[z+12>>2]=g;c[g+8>>2]=z;c[g+12>>2]=h;}c[7656]=e;c[7659]=f;}H=d+8|0;i=b;return H|0;}}}else if(a>>>0<=4294967231){z=a+11|0;a=z&-8;B=c[7655]|0;if(B){A=0-a|0;z=z>>>8;if(z){if(a>>>0>16777215)C=31;else{G=(z+1048320|0)>>>16&8;H=z<<G;F=(H+520192|0)>>>16&4;H=H<<F;C=(H+245760|0)>>>16&2;C=14-(F|G|C)+(H<<C>>>15)|0;C=a>>>(C+7|0)&1|C<<1;}}else C=0;D=c[30920+(C<<2)>>2]|0;a:do if(!D){F=0;z=0;}else{if((C|0)==31)z=0;else z=25-(C>>>1)|0;F=0;E=a<<z;z=0;while(1){H=c[D+4>>2]&-8;G=H-a|0;if(G>>>0<A>>>0)if((H|0)==(a|0)){A=G;F=D;z=D;break a;}else{A=G;z=D;}H=c[D+20>>2]|0;D=c[D+(E>>>31<<2)+16>>2]|0;F=(H|0)==0|(H|0)==(D|0)?F:H;if(!D)break;else E=E<<1;}}while(0);if((F|0)==0&(z|0)==0){H=2<<C;B=B&(H|0-H);if(!B)break;H=(B&0-B)+-1|0;D=H>>>12&16;H=H>>>D;C=H>>>5&8;H=H>>>C;E=H>>>2&4;H=H>>>E;G=H>>>1&2;H=H>>>G;F=H>>>1&1;F=c[30920+((C|D|E|G|F)+(H>>>F)<<2)>>2]|0;}if(F)while(1){H=(c[F+4>>2]&-8)-a|0;B=H>>>0<A>>>0;A=B?H:A;z=B?F:z;B=c[F+16>>2]|0;if(B){F=B;continue;}F=c[F+20>>2]|0;if(!F)break;}if((z|0)!=0?A>>>0<((c[7656]|0)-a|0)>>>0:0){f=c[7658]|0;if(z>>>0<f>>>0)xa();d=z+a|0;if(z>>>0>=d>>>0)xa();e=c[z+24>>2]|0;h=c[z+12>>2]|0;do if((h|0)==(z|0)){h=z+20|0;g=c[h>>2]|0;if(!g){h=z+16|0;g=c[h>>2]|0;if(!g){x=0;break;}}while(1){j=g+20|0;k=c[j>>2]|0;if(k){g=k;h=j;continue;}j=g+16|0;k=c[j>>2]|0;if(!k)break;else{g=k;h=j;}}if(h>>>0<f>>>0)xa();else{c[h>>2]=0;x=g;break;}}else{g=c[z+8>>2]|0;if(g>>>0<f>>>0)xa();f=g+12|0;if((c[f>>2]|0)!=(z|0))xa();j=h+8|0;if((c[j>>2]|0)==(z|0)){c[f>>2]=h;c[j>>2]=g;x=h;break;}else xa();}while(0);do if(e){g=c[z+28>>2]|0;f=30920+(g<<2)|0;if((z|0)==(c[f>>2]|0)){c[f>>2]=x;if(!x){c[7655]=c[7655]&~(1<<g);break;}}else{if(e>>>0<(c[7658]|0)>>>0)xa();f=e+16|0;if((c[f>>2]|0)==(z|0))c[f>>2]=x;else c[e+20>>2]=x;if(!x)break;}if(x>>>0<(c[7658]|0)>>>0)xa();c[x+24>>2]=e;e=c[z+16>>2]|0;do if(e)if(e>>>0<(c[7658]|0)>>>0)xa();else{c[x+16>>2]=e;c[e+24>>2]=x;break;}while(0);e=c[z+20>>2]|0;if(e)if(e>>>0<(c[7658]|0)>>>0)xa();else{c[x+20>>2]=e;c[e+24>>2]=x;break;}}while(0);b:do if(A>>>0>=16){c[z+4>>2]=a|3;c[z+(a|4)>>2]=A|1;c[z+(A+a)>>2]=A;f=A>>>3;if(A>>>0<256){h=f<<1;e=30656+(h<<2)|0;g=c[7654]|0;f=1<<f;do if(!(g&f)){c[7654]=g|f;w=30656+(h+2<<2)|0;v=e;}else{f=30656+(h+2<<2)|0;g=c[f>>2]|0;if(g>>>0>=(c[7658]|0)>>>0){w=f;v=g;break;}xa();}while(0);c[w>>2]=d;c[v+12>>2]=d;c[z+(a+8)>>2]=v;c[z+(a+12)>>2]=e;break;}e=A>>>8;if(e){if(A>>>0>16777215)e=31;else{G=(e+1048320|0)>>>16&8;H=e<<G;F=(H+520192|0)>>>16&4;H=H<<F;e=(H+245760|0)>>>16&2;e=14-(F|G|e)+(H<<e>>>15)|0;e=A>>>(e+7|0)&1|e<<1;}}else e=0;f=30920+(e<<2)|0;c[z+(a+28)>>2]=e;c[z+(a+20)>>2]=0;c[z+(a+16)>>2]=0;h=c[7655]|0;g=1<<e;if(!(h&g)){c[7655]=h|g;c[f>>2]=d;c[z+(a+24)>>2]=f;c[z+(a+12)>>2]=d;c[z+(a+8)>>2]=d;break;}f=c[f>>2]|0;if((e|0)==31)e=0;else e=25-(e>>>1)|0;c:do if((c[f+4>>2]&-8|0)!=(A|0)){e=A<<e;while(1){g=f+(e>>>31<<2)+16|0;h=c[g>>2]|0;if(!h)break;if((c[h+4>>2]&-8|0)==(A|0)){p=h;break c;}else{e=e<<1;f=h;}}if(g>>>0<(c[7658]|0)>>>0)xa();else{c[g>>2]=d;c[z+(a+24)>>2]=f;c[z+(a+12)>>2]=d;c[z+(a+8)>>2]=d;break b;}}else p=f;while(0);f=p+8|0;e=c[f>>2]|0;g=c[7658]|0;if(p>>>0<g>>>0)xa();if(e>>>0<g>>>0)xa();else{c[e+12>>2]=d;c[f>>2]=d;c[z+(a+8)>>2]=e;c[z+(a+12)>>2]=p;c[z+(a+24)>>2]=0;break;}}else{H=A+a|0;c[z+4>>2]=H|3;H=z+(H+4)|0;c[H>>2]=c[H>>2]|1;}while(0);H=z+8|0;i=b;return H|0;}}}else a=-1;while(0);p=c[7656]|0;if(a>>>0<=p>>>0){e=p-a|0;d=c[7659]|0;if(e>>>0>15){c[7659]=d+a;c[7656]=e;c[d+(a+4)>>2]=e|1;c[d+p>>2]=e;c[d+4>>2]=a|3;}else{c[7656]=0;c[7659]=0;c[d+4>>2]=p|3;H=d+(p+4)|0;c[H>>2]=c[H>>2]|1;}H=d+8|0;i=b;return H|0;}p=c[7657]|0;if(a>>>0<p>>>0){G=p-a|0;c[7657]=G;H=c[7660]|0;c[7660]=H+a;c[H+(a+4)>>2]=G|1;c[H+4>>2]=a|3;H=H+8|0;i=b;return H|0;}do if(!(c[7772]|0)){p=qa(30)|0;if(!(p+-1&p)){c[7774]=p;c[7773]=p;c[7775]=-1;c[7776]=-1;c[7777]=0;c[7765]=0;c[7772]=(ya(0)|0)&-16^1431655768;break;}else xa();}while(0);w=a+48|0;p=c[7774]|0;x=a+47|0;z=p+x|0;p=0-p|0;v=z&p;if(v>>>0<=a>>>0){H=0;i=b;return H|0;}A=c[7764]|0;if((A|0)!=0?(G=c[7762]|0,H=G+v|0,H>>>0<=G>>>0|H>>>0>A>>>0):0){H=0;i=b;return H|0;}d:do if(!(c[7765]&4)){B=c[7660]|0;e:do if(B){A=31064|0;while(1){C=c[A>>2]|0;if(C>>>0<=B>>>0?(y=A+4|0,(C+(c[y>>2]|0)|0)>>>0>B>>>0):0)break;A=c[A+8>>2]|0;if(!A){o=182;break e;}}if(A){B=z-(c[7657]|0)&p;if(B>>>0<2147483647){p=na(B|0)|0;A=(p|0)==((c[A>>2]|0)+(c[y>>2]|0)|0);y=p;z=B;p=A?p:-1;A=A?B:0;o=191;}else A=0;}else o=182;}else o=182;while(0);do if((o|0)==182){p=na(0)|0;if((p|0)!=(-1|0)){z=p;A=c[7773]|0;y=A+-1|0;if(!(y&z))A=v;else A=v-z+(y+z&0-A)|0;y=c[7762]|0;z=y+A|0;if(A>>>0>a>>>0&A>>>0<2147483647){H=c[7764]|0;if((H|0)!=0?z>>>0<=y>>>0|z>>>0>H>>>0:0){A=0;break;}y=na(A|0)|0;o=(y|0)==(p|0);z=A;p=o?p:-1;A=o?A:0;o=191;}else A=0;}else A=0;}while(0);f:do if((o|0)==191){o=0-z|0;if((p|0)!=(-1|0)){q=A;o=202;break d;}do if((y|0)!=(-1|0)&z>>>0<2147483647&z>>>0<w>>>0?(u=c[7774]|0,u=x-z+u&0-u,u>>>0<2147483647):0)if((na(u|0)|0)==(-1|0)){na(o|0)|0;break f;}else{z=u+z|0;break;}while(0);if((y|0)!=(-1|0)){p=y;q=z;o=202;break d;}}while(0);c[7765]=c[7765]|4;o=199;}else{A=0;o=199;}while(0);if((((o|0)==199?v>>>0<2147483647:0)?(t=na(v|0)|0,s=na(0)|0,(s|0)!=(-1|0)&(t|0)!=(-1|0)&t>>>0<s>>>0):0)?(r=s-t|0,q=r>>>0>(a+40|0)>>>0,q):0){p=t;q=q?r:A;o=202;}if((o|0)==202){r=(c[7762]|0)+q|0;c[7762]=r;if(r>>>0>(c[7763]|0)>>>0)c[7763]=r;r=c[7660]|0;g:do if(r){v=31064|0;while(1){t=c[v>>2]|0;u=v+4|0;s=c[u>>2]|0;if((p|0)==(t+s|0)){o=214;break;}w=c[v+8>>2]|0;if(!w)break;else v=w;}if(((o|0)==214?(c[v+12>>2]&8|0)==0:0)?r>>>0>=t>>>0&r>>>0<p>>>0:0){c[u>>2]=s+q;d=(c[7657]|0)+q|0;e=r+8|0;if(!(e&7))e=0;else e=0-e&7;H=d-e|0;c[7660]=r+e;c[7657]=H;c[r+(e+4)>>2]=H|1;c[r+(d+4)>>2]=40;c[7661]=c[7776];break;}if(p>>>0<(c[7658]|0)>>>0)c[7658]=p;t=p+q|0;s=31064|0;while(1){if((c[s>>2]|0)==(t|0)){o=224;break;}u=c[s+8>>2]|0;if(!u)break;else s=u;}if((o|0)==224?(c[s+12>>2]&8|0)==0:0){c[s>>2]=p;h=s+4|0;c[h>>2]=(c[h>>2]|0)+q;h=p+8|0;if(!(h&7))h=0;else h=0-h&7;j=p+(q+8)|0;if(!(j&7))n=0;else n=0-j&7;o=p+(n+q)|0;j=h+a|0;k=p+j|0;m=o-(p+h)-a|0;c[p+(h+4)>>2]=a|3;h:do if((o|0)!=(c[7660]|0)){if((o|0)==(c[7659]|0)){H=(c[7656]|0)+m|0;c[7656]=H;c[7659]=k;c[p+(j+4)>>2]=H|1;c[p+(H+j)>>2]=H;break;}r=q+4|0;t=c[p+(r+n)>>2]|0;if((t&3|0)==1){a=t&-8;s=t>>>3;i:do if(t>>>0>=256){l=c[p+((n|24)+q)>>2]|0;u=c[p+(q+12+n)>>2]|0;do if((u|0)==(o|0)){u=n|16;t=p+(r+u)|0;s=c[t>>2]|0;if(!s){t=p+(u+q)|0;s=c[t>>2]|0;if(!s){g=0;break;}}while(1){u=s+20|0;v=c[u>>2]|0;if(v){s=v;t=u;continue;}u=s+16|0;v=c[u>>2]|0;if(!v)break;else{s=v;t=u;}}if(t>>>0<(c[7658]|0)>>>0)xa();else{c[t>>2]=0;g=s;break;}}else{t=c[p+((n|8)+q)>>2]|0;if(t>>>0<(c[7658]|0)>>>0)xa();v=t+12|0;if((c[v>>2]|0)!=(o|0))xa();s=u+8|0;if((c[s>>2]|0)==(o|0)){c[v>>2]=u;c[s>>2]=t;g=u;break;}else xa();}while(0);if(!l)break;t=c[p+(q+28+n)>>2]|0;s=30920+(t<<2)|0;do if((o|0)!=(c[s>>2]|0)){if(l>>>0<(c[7658]|0)>>>0)xa();s=l+16|0;if((c[s>>2]|0)==(o|0))c[s>>2]=g;else c[l+20>>2]=g;if(!g)break i;}else{c[s>>2]=g;if(g)break;c[7655]=c[7655]&~(1<<t);break i;}while(0);if(g>>>0<(c[7658]|0)>>>0)xa();c[g+24>>2]=l;l=n|16;o=c[p+(l+q)>>2]|0;do if(o)if(o>>>0<(c[7658]|0)>>>0)xa();else{c[g+16>>2]=o;c[o+24>>2]=g;break;}while(0);l=c[p+(r+l)>>2]|0;if(!l)break;if(l>>>0<(c[7658]|0)>>>0)xa();else{c[g+20>>2]=l;c[l+24>>2]=g;break;}}else{r=c[p+((n|8)+q)>>2]|0;g=c[p+(q+12+n)>>2]|0;t=30656+(s<<1<<2)|0;do if((r|0)!=(t|0)){if(r>>>0<(c[7658]|0)>>>0)xa();if((c[r+12>>2]|0)==(o|0))break;xa();}while(0);if((g|0)==(r|0)){c[7654]=c[7654]&~(1<<s);break;}do if((g|0)==(t|0))l=g+8|0;else{if(g>>>0<(c[7658]|0)>>>0)xa();s=g+8|0;if((c[s>>2]|0)==(o|0)){l=s;break;}xa();}while(0);c[r+12>>2]=g;c[l>>2]=r;}while(0);o=p+((a|n)+q)|0;m=a+m|0;}g=o+4|0;c[g>>2]=c[g>>2]&-2;c[p+(j+4)>>2]=m|1;c[p+(m+j)>>2]=m;g=m>>>3;if(m>>>0<256){m=g<<1;d=30656+(m<<2)|0;l=c[7654]|0;g=1<<g;do if(!(l&g)){c[7654]=l|g;f=30656+(m+2<<2)|0;e=d;}else{l=30656+(m+2<<2)|0;g=c[l>>2]|0;if(g>>>0>=(c[7658]|0)>>>0){f=l;e=g;break;}xa();}while(0);c[f>>2]=k;c[e+12>>2]=k;c[p+(j+8)>>2]=e;c[p+(j+12)>>2]=d;break;}e=m>>>8;do if(!e)e=0;else{if(m>>>0>16777215){e=31;break;}G=(e+1048320|0)>>>16&8;H=e<<G;F=(H+520192|0)>>>16&4;H=H<<F;e=(H+245760|0)>>>16&2;e=14-(F|G|e)+(H<<e>>>15)|0;e=m>>>(e+7|0)&1|e<<1;}while(0);l=30920+(e<<2)|0;c[p+(j+28)>>2]=e;c[p+(j+20)>>2]=0;c[p+(j+16)>>2]=0;f=c[7655]|0;g=1<<e;if(!(f&g)){c[7655]=f|g;c[l>>2]=k;c[p+(j+24)>>2]=l;c[p+(j+12)>>2]=k;c[p+(j+8)>>2]=k;break;}l=c[l>>2]|0;if((e|0)==31)e=0;else e=25-(e>>>1)|0;j:do if((c[l+4>>2]&-8|0)!=(m|0)){e=m<<e;while(1){g=l+(e>>>31<<2)+16|0;f=c[g>>2]|0;if(!f)break;if((c[f+4>>2]&-8|0)==(m|0)){d=f;break j;}else{e=e<<1;l=f;}}if(g>>>0<(c[7658]|0)>>>0)xa();else{c[g>>2]=k;c[p+(j+24)>>2]=l;c[p+(j+12)>>2]=k;c[p+(j+8)>>2]=k;break h;}}else d=l;while(0);f=d+8|0;e=c[f>>2]|0;g=c[7658]|0;if(d>>>0<g>>>0)xa();if(e>>>0<g>>>0)xa();else{c[e+12>>2]=k;c[f>>2]=k;c[p+(j+8)>>2]=e;c[p+(j+12)>>2]=d;c[p+(j+24)>>2]=0;break;}}else{H=(c[7657]|0)+m|0;c[7657]=H;c[7660]=k;c[p+(j+4)>>2]=H|1;}while(0);H=p+(h|8)|0;i=b;return H|0;}e=31064|0;while(1){d=c[e>>2]|0;if(d>>>0<=r>>>0?(n=c[e+4>>2]|0,m=d+n|0,m>>>0>r>>>0):0)break;e=c[e+8>>2]|0;}e=d+(n+-39)|0;if(!(e&7))e=0;else e=0-e&7;d=d+(n+-47+e)|0;d=d>>>0<(r+16|0)>>>0?r:d;e=d+8|0;f=p+8|0;if(!(f&7))f=0;else f=0-f&7;H=q+-40-f|0;c[7660]=p+f;c[7657]=H;c[p+(f+4)>>2]=H|1;c[p+(q+-36)>>2]=40;c[7661]=c[7776];c[d+4>>2]=27;c[e+0>>2]=c[7766];c[e+4>>2]=c[7767];c[e+8>>2]=c[7768];c[e+12>>2]=c[7769];c[7766]=p;c[7767]=q;c[7769]=0;c[7768]=e;e=d+28|0;c[e>>2]=7;if((d+32|0)>>>0<m>>>0)do{H=e;e=e+4|0;c[e>>2]=7;}while((H+8|0)>>>0<m>>>0);if((d|0)!=(r|0)){d=d-r|0;e=r+(d+4)|0;c[e>>2]=c[e>>2]&-2;c[r+4>>2]=d|1;c[r+d>>2]=d;e=d>>>3;if(d>>>0<256){g=e<<1;d=30656+(g<<2)|0;f=c[7654]|0;e=1<<e;do if(!(f&e)){c[7654]=f|e;k=30656+(g+2<<2)|0;j=d;}else{f=30656+(g+2<<2)|0;e=c[f>>2]|0;if(e>>>0>=(c[7658]|0)>>>0){k=f;j=e;break;}xa();}while(0);c[k>>2]=r;c[j+12>>2]=r;c[r+8>>2]=j;c[r+12>>2]=d;break;}e=d>>>8;if(e){if(d>>>0>16777215)e=31;else{G=(e+1048320|0)>>>16&8;H=e<<G;F=(H+520192|0)>>>16&4;H=H<<F;e=(H+245760|0)>>>16&2;e=14-(F|G|e)+(H<<e>>>15)|0;e=d>>>(e+7|0)&1|e<<1;}}else e=0;j=30920+(e<<2)|0;c[r+28>>2]=e;c[r+20>>2]=0;c[r+16>>2]=0;f=c[7655]|0;g=1<<e;if(!(f&g)){c[7655]=f|g;c[j>>2]=r;c[r+24>>2]=j;c[r+12>>2]=r;c[r+8>>2]=r;break;}f=c[j>>2]|0;if((e|0)==31)e=0;else e=25-(e>>>1)|0;k:do if((c[f+4>>2]&-8|0)!=(d|0)){e=d<<e;while(1){j=f+(e>>>31<<2)+16|0;g=c[j>>2]|0;if(!g)break;if((c[g+4>>2]&-8|0)==(d|0)){h=g;break k;}else{e=e<<1;f=g;}}if(j>>>0<(c[7658]|0)>>>0)xa();else{c[j>>2]=r;c[r+24>>2]=f;c[r+12>>2]=r;c[r+8>>2]=r;break g;}}else h=f;while(0);f=h+8|0;e=c[f>>2]|0;d=c[7658]|0;if(h>>>0<d>>>0)xa();if(e>>>0<d>>>0)xa();else{c[e+12>>2]=r;c[f>>2]=r;c[r+8>>2]=e;c[r+12>>2]=h;c[r+24>>2]=0;break;}}}else{H=c[7658]|0;if((H|0)==0|p>>>0<H>>>0)c[7658]=p;c[7766]=p;c[7767]=q;c[7769]=0;c[7663]=c[7772];c[7662]=-1;d=0;do{H=d<<1;G=30656+(H<<2)|0;c[30656+(H+3<<2)>>2]=G;c[30656+(H+2<<2)>>2]=G;d=d+1|0;}while((d|0)!=32);d=p+8|0;if(!(d&7))d=0;else d=0-d&7;H=q+-40-d|0;c[7660]=p+d;c[7657]=H;c[p+(d+4)>>2]=H|1;c[p+(q+-36)>>2]=40;c[7661]=c[7776];}while(0);d=c[7657]|0;if(d>>>0>a>>>0){G=d-a|0;c[7657]=G;H=c[7660]|0;c[7660]=H+a;c[H+(a+4)>>2]=G|1;c[H+4>>2]=a|3;H=H+8|0;i=b;return H|0;}}c[(wa()|0)>>2]=12;H=0;i=b;return H|0;}function rj(a){a=a|0;var b=0,d=0,e=0,f=0,g=0,h=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0,q=0,r=0,s=0,t=0,u=0,v=0,w=0;b=i;if(!a){i=b;return;}q=a+-8|0;r=c[7658]|0;if(q>>>0<r>>>0)xa();o=c[a+-4>>2]|0;n=o&3;if((n|0)==1)xa();j=o&-8;h=a+(j+-8)|0;do if(!(o&1)){u=c[q>>2]|0;if(!n){i=b;return;}q=-8-u|0;o=a+q|0;n=u+j|0;if(o>>>0<r>>>0)xa();if((o|0)==(c[7659]|0)){d=a+(j+-4)|0;if((c[d>>2]&3|0)!=3){d=o;m=n;break;}c[7656]=n;c[d>>2]=c[d>>2]&-2;c[a+(q+4)>>2]=n|1;c[h>>2]=n;i=b;return;}t=u>>>3;if(u>>>0<256){d=c[a+(q+8)>>2]|0;m=c[a+(q+12)>>2]|0;p=30656+(t<<1<<2)|0;if((d|0)!=(p|0)){if(d>>>0<r>>>0)xa();if((c[d+12>>2]|0)!=(o|0))xa();}if((m|0)==(d|0)){c[7654]=c[7654]&~(1<<t);d=o;m=n;break;}if((m|0)!=(p|0)){if(m>>>0<r>>>0)xa();p=m+8|0;if((c[p>>2]|0)==(o|0))s=p;else xa();}else s=m+8|0;c[d+12>>2]=m;c[s>>2]=d;d=o;m=n;break;}s=c[a+(q+24)>>2]|0;t=c[a+(q+12)>>2]|0;do if((t|0)==(o|0)){u=a+(q+20)|0;t=c[u>>2]|0;if(!t){u=a+(q+16)|0;t=c[u>>2]|0;if(!t){p=0;break;}}while(1){w=t+20|0;v=c[w>>2]|0;if(v){t=v;u=w;continue;}v=t+16|0;w=c[v>>2]|0;if(!w)break;else{t=w;u=v;}}if(u>>>0<r>>>0)xa();else{c[u>>2]=0;p=t;break;}}else{u=c[a+(q+8)>>2]|0;if(u>>>0<r>>>0)xa();r=u+12|0;if((c[r>>2]|0)!=(o|0))xa();v=t+8|0;if((c[v>>2]|0)==(o|0)){c[r>>2]=t;c[v>>2]=u;p=t;break;}else xa();}while(0);if(s){t=c[a+(q+28)>>2]|0;r=30920+(t<<2)|0;if((o|0)==(c[r>>2]|0)){c[r>>2]=p;if(!p){c[7655]=c[7655]&~(1<<t);d=o;m=n;break;}}else{if(s>>>0<(c[7658]|0)>>>0)xa();r=s+16|0;if((c[r>>2]|0)==(o|0))c[r>>2]=p;else c[s+20>>2]=p;if(!p){d=o;m=n;break;}}if(p>>>0<(c[7658]|0)>>>0)xa();c[p+24>>2]=s;r=c[a+(q+16)>>2]|0;do if(r)if(r>>>0<(c[7658]|0)>>>0)xa();else{c[p+16>>2]=r;c[r+24>>2]=p;break;}while(0);q=c[a+(q+20)>>2]|0;if(q){if(q>>>0<(c[7658]|0)>>>0)xa();else{c[p+20>>2]=q;c[q+24>>2]=p;d=o;m=n;break;}}else{d=o;m=n;}}else{d=o;m=n;}}else{d=q;m=j;}while(0);if(d>>>0>=h>>>0)xa();n=a+(j+-4)|0;o=c[n>>2]|0;if(!(o&1))xa();if(!(o&2)){if((h|0)==(c[7660]|0)){w=(c[7657]|0)+m|0;c[7657]=w;c[7660]=d;c[d+4>>2]=w|1;if((d|0)!=(c[7659]|0)){i=b;return;}c[7659]=0;c[7656]=0;i=b;return;}if((h|0)==(c[7659]|0)){w=(c[7656]|0)+m|0;c[7656]=w;c[7659]=d;c[d+4>>2]=w|1;c[d+w>>2]=w;i=b;return;}m=(o&-8)+m|0;n=o>>>3;do if(o>>>0>=256){l=c[a+(j+16)>>2]|0;q=c[a+(j|4)>>2]|0;do if((q|0)==(h|0)){o=a+(j+12)|0;n=c[o>>2]|0;if(!n){o=a+(j+8)|0;n=c[o>>2]|0;if(!n){k=0;break;}}while(1){p=n+20|0;q=c[p>>2]|0;if(q){n=q;o=p;continue;}p=n+16|0;q=c[p>>2]|0;if(!q)break;else{n=q;o=p;}}if(o>>>0<(c[7658]|0)>>>0)xa();else{c[o>>2]=0;k=n;break;}}else{o=c[a+j>>2]|0;if(o>>>0<(c[7658]|0)>>>0)xa();p=o+12|0;if((c[p>>2]|0)!=(h|0))xa();n=q+8|0;if((c[n>>2]|0)==(h|0)){c[p>>2]=q;c[n>>2]=o;k=q;break;}else xa();}while(0);if(l){n=c[a+(j+20)>>2]|0;o=30920+(n<<2)|0;if((h|0)==(c[o>>2]|0)){c[o>>2]=k;if(!k){c[7655]=c[7655]&~(1<<n);break;}}else{if(l>>>0<(c[7658]|0)>>>0)xa();n=l+16|0;if((c[n>>2]|0)==(h|0))c[n>>2]=k;else c[l+20>>2]=k;if(!k)break;}if(k>>>0<(c[7658]|0)>>>0)xa();c[k+24>>2]=l;h=c[a+(j+8)>>2]|0;do if(h)if(h>>>0<(c[7658]|0)>>>0)xa();else{c[k+16>>2]=h;c[h+24>>2]=k;break;}while(0);h=c[a+(j+12)>>2]|0;if(h)if(h>>>0<(c[7658]|0)>>>0)xa();else{c[k+20>>2]=h;c[h+24>>2]=k;break;}}}else{k=c[a+j>>2]|0;a=c[a+(j|4)>>2]|0;j=30656+(n<<1<<2)|0;if((k|0)!=(j|0)){if(k>>>0<(c[7658]|0)>>>0)xa();if((c[k+12>>2]|0)!=(h|0))xa();}if((a|0)==(k|0)){c[7654]=c[7654]&~(1<<n);break;}if((a|0)!=(j|0)){if(a>>>0<(c[7658]|0)>>>0)xa();j=a+8|0;if((c[j>>2]|0)==(h|0))l=j;else xa();}else l=a+8|0;c[k+12>>2]=a;c[l>>2]=k;}while(0);c[d+4>>2]=m|1;c[d+m>>2]=m;if((d|0)==(c[7659]|0)){c[7656]=m;i=b;return;}}else{c[n>>2]=o&-2;c[d+4>>2]=m|1;c[d+m>>2]=m;}h=m>>>3;if(m>>>0<256){a=h<<1;e=30656+(a<<2)|0;j=c[7654]|0;h=1<<h;if(j&h){h=30656+(a+2<<2)|0;a=c[h>>2]|0;if(a>>>0<(c[7658]|0)>>>0)xa();else{f=h;g=a;}}else{c[7654]=j|h;f=30656+(a+2<<2)|0;g=e;}c[f>>2]=d;c[g+12>>2]=d;c[d+8>>2]=g;c[d+12>>2]=e;i=b;return;}f=m>>>8;if(f){if(m>>>0>16777215)f=31;else{v=(f+1048320|0)>>>16&8;w=f<<v;u=(w+520192|0)>>>16&4;w=w<<u;f=(w+245760|0)>>>16&2;f=14-(u|v|f)+(w<<f>>>15)|0;f=m>>>(f+7|0)&1|f<<1;}}else f=0;g=30920+(f<<2)|0;c[d+28>>2]=f;c[d+20>>2]=0;c[d+16>>2]=0;a=c[7655]|0;h=1<<f;a:do if(a&h){g=c[g>>2]|0;if((f|0)==31)f=0;else f=25-(f>>>1)|0;b:do if((c[g+4>>2]&-8|0)!=(m|0)){f=m<<f;a=g;while(1){h=a+(f>>>31<<2)+16|0;g=c[h>>2]|0;if(!g)break;if((c[g+4>>2]&-8|0)==(m|0)){e=g;break b;}else{f=f<<1;a=g;}}if(h>>>0<(c[7658]|0)>>>0)xa();else{c[h>>2]=d;c[d+24>>2]=a;c[d+12>>2]=d;c[d+8>>2]=d;break a;}}else e=g;while(0);g=e+8|0;f=c[g>>2]|0;h=c[7658]|0;if(e>>>0<h>>>0)xa();if(f>>>0<h>>>0)xa();else{c[f+12>>2]=d;c[g>>2]=d;c[d+8>>2]=f;c[d+12>>2]=e;c[d+24>>2]=0;break;}}else{c[7655]=a|h;c[g>>2]=d;c[d+24>>2]=g;c[d+12>>2]=d;c[d+8>>2]=d;}while(0);w=(c[7662]|0)+-1|0;c[7662]=w;if(!w)d=31072|0;else{i=b;return;}while(1){d=c[d>>2]|0;if(!d)break;else d=d+8|0;}c[7662]=-1;i=b;return;}function sj(){}function tj(a,b,c){a=a|0;b=b|0;c=c|0;if((c|0)<32){D=b>>c;return a>>>c|(b&(1<<c)-1)<<32-c;}D=(b|0)<0?-1:0;return b>>c-32|0;}function uj(a,b,c){a=a|0;b=b|0;c=c|0;if((c|0)<32){D=b>>>c;return a>>>c|(b&(1<<c)-1)<<32-c;}D=0;return b>>>c-32|0;}function vj(b){b=b|0;var c=0;c=a[n+(b>>>24)>>0]|0;if((c|0)<8)return c|0;c=a[n+(b>>16&255)>>0]|0;if((c|0)<8)return c+8|0;c=a[n+(b>>8&255)>>0]|0;if((c|0)<8)return c+16|0;return(a[n+(b&255)>>0]|0)+24|0;}function wj(b,d,e){b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,i=0;f=b+e|0;if((e|0)>=20){d=d&255;i=b&3;h=d|d<<8|d<<16|d<<24;g=f&~3;if(i){i=b+4-i|0;while((b|0)<(i|0)){a[b>>0]=d;b=b+1|0;}}while((b|0)<(g|0)){c[b>>2]=h;b=b+4|0;}}while((b|0)<(f|0)){a[b>>0]=d;b=b+1|0;}return b-e|0;}function xj(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;c=a+c>>>0;return(D=b+d+(c>>>0<a>>>0|0)>>>0,c|0)|0;}function yj(b,d,e){b=b|0;d=d|0;e=e|0;var f=0;if((e|0)>=4096)return oa(b|0,d|0,e|0)|0;f=b|0;if((b&3)==(d&3)){while(b&3){if(!e)return f|0;a[b>>0]=a[d>>0]|0;b=b+1|0;d=d+1|0;e=e-1|0;}while((e|0)>=4){c[b>>2]=c[d>>2];b=b+4|0;d=d+4|0;e=e-4|0;}}while((e|0)>0){a[b>>0]=a[d>>0]|0;b=b+1|0;d=d+1|0;e=e-1|0;}return f|0;}function zj(b,c,d){b=b|0;c=c|0;d=d|0;var e=0;if((c|0)<(b|0)&(b|0)<(c+d|0)){e=b;c=c+d|0;b=b+d|0;while((d|0)>0){b=b-1|0;c=c-1|0;d=d-1|0;a[b>>0]=a[c>>0]|0;}b=e;}else yj(b,c,d)|0;return b|0;}function Aj(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;b=b-d-(c>>>0>a>>>0|0)>>>0;return(D=b,a-c>>>0|0)|0;}function Bj(a,b,c){a=a|0;b=b|0;c=c|0;if((c|0)<32){D=b<<c|(a&(1<<c)-1<<32-c)>>>32-c;return a<<c;}D=a<<c-32;return 0;}function Cj(b){b=b|0;var c=0;c=a[m+(b&255)>>0]|0;if((c|0)<8)return c|0;c=a[m+(b>>8&255)>>0]|0;if((c|0)<8)return c+8|0;c=a[m+(b>>16&255)>>0]|0;if((c|0)<8)return c+16|0;return(a[m+(b>>>24)>>0]|0)+24|0;}function Dj(a,b){a=a|0;b=b|0;var c=0,d=0,e=0,f=0;f=a&65535;d=b&65535;c=$(d,f)|0;e=a>>>16;d=(c>>>16)+($(d,e)|0)|0;b=b>>>16;a=$(b,f)|0;return(D=(d>>>16)+($(b,e)|0)+(((d&65535)+a|0)>>>16)|0,d+a<<16|c&65535|0)|0;}function Ej(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0,g=0,h=0,i=0,j=0;j=b>>31|((b|0)<0?-1:0)<<1;i=((b|0)<0?-1:0)>>31|((b|0)<0?-1:0)<<1;f=d>>31|((d|0)<0?-1:0)<<1;e=((d|0)<0?-1:0)>>31|((d|0)<0?-1:0)<<1;h=Aj(j^a,i^b,j,i)|0;g=D;b=f^j;a=e^i;a=Aj((Jj(h,g,Aj(f^c,e^d,f,e)|0,D,0)|0)^b,D^a,b,a)|0;return a|0;}function Fj(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0,h=0,j=0,k=0,l=0;f=i;i=i+8|0;j=f|0;h=b>>31|((b|0)<0?-1:0)<<1;g=((b|0)<0?-1:0)>>31|((b|0)<0?-1:0)<<1;l=e>>31|((e|0)<0?-1:0)<<1;k=((e|0)<0?-1:0)>>31|((e|0)<0?-1:0)<<1;b=Aj(h^a,g^b,h,g)|0;a=D;Jj(b,a,Aj(l^d,k^e,l,k)|0,D,j)|0;a=Aj(c[j>>2]^h,c[j+4>>2]^g,h,g)|0;b=D;i=f;return(D=b,a)|0;}function Gj(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;var e=0,f=0;e=a;f=c;a=Dj(e,f)|0;c=D;return(D=($(b,f)|0)+($(d,e)|0)+c|c&0,a|0|0)|0;}function Hj(a,b,c,d){a=a|0;b=b|0;c=c|0;d=d|0;a=Jj(a,b,c,d,0)|0;return a|0;}function Ij(a,b,d,e){a=a|0;b=b|0;d=d|0;e=e|0;var f=0,g=0;g=i;i=i+8|0;f=g|0;Jj(a,b,d,e,f)|0;i=g;return(D=c[f+4>>2]|0,c[f>>2]|0)|0;}function Jj(a,b,d,e,f){a=a|0;b=b|0;d=d|0;e=e|0;f=f|0;var g=0,h=0,i=0,j=0,k=0,l=0,m=0,n=0,o=0,p=0;h=a;j=b;i=j;l=d;g=e;k=g;if(!i){g=(f|0)!=0;if(!k){if(g){c[f>>2]=(h>>>0)%(l>>>0);c[f+4>>2]=0;}k=0;m=(h>>>0)/(l>>>0)>>>0;return(D=k,m)|0;}else{if(!g){l=0;m=0;return(D=l,m)|0;}c[f>>2]=a|0;c[f+4>>2]=b&0;l=0;m=0;return(D=l,m)|0;}}m=(k|0)==0;do if(l){if(!m){k=(vj(k|0)|0)-(vj(i|0)|0)|0;if(k>>>0<=31){m=k+1|0;l=31-k|0;a=k-31>>31;j=m;b=h>>>(m>>>0)&a|i<<l;a=i>>>(m>>>0)&a;k=0;l=h<<l;break;}if(!f){l=0;m=0;return(D=l,m)|0;}c[f>>2]=a|0;c[f+4>>2]=j|b&0;l=0;m=0;return(D=l,m)|0;}k=l-1|0;if(k&l){l=(vj(l|0)|0)+33-(vj(i|0)|0)|0;p=64-l|0;m=32-l|0;n=m>>31;o=l-32|0;a=o>>31;j=l;b=m-1>>31&i>>>(o>>>0)|(i<<m|h>>>(l>>>0))&a;a=a&i>>>(l>>>0);k=h<<p&n;l=(i<<p|h>>>(o>>>0))&n|h<<m&l-33>>31;break;}if(f){c[f>>2]=k&h;c[f+4>>2]=0;}if((l|0)==1){o=j|b&0;p=a|0|0;return(D=o,p)|0;}else{p=Cj(l|0)|0;o=i>>>(p>>>0)|0;p=i<<32-p|h>>>(p>>>0)|0;return(D=o,p)|0;}}else{if(m){if(f){c[f>>2]=(i>>>0)%(l>>>0);c[f+4>>2]=0;}o=0;p=(i>>>0)/(l>>>0)>>>0;return(D=o,p)|0;}if(!h){if(f){c[f>>2]=0;c[f+4>>2]=(i>>>0)%(k>>>0);}o=0;p=(i>>>0)/(k>>>0)>>>0;return(D=o,p)|0;}l=k-1|0;if(!(l&k)){if(f){c[f>>2]=a|0;c[f+4>>2]=l&i|b&0;}o=0;p=i>>>((Cj(k|0)|0)>>>0);return(D=o,p)|0;}k=(vj(k|0)|0)-(vj(i|0)|0)|0;if(k>>>0<=30){a=k+1|0;l=31-k|0;j=a;b=i<<l|h>>>(a>>>0);a=i>>>(a>>>0);k=0;l=h<<l;break;}if(!f){o=0;p=0;return(D=o,p)|0;}c[f>>2]=a|0;c[f+4>>2]=j|b&0;o=0;p=0;return(D=o,p)|0;}while(0);if(!j){g=l;e=0;i=0;}else{h=d|0|0;g=g|e&0;e=xj(h,g,-1,-1)|0;d=D;i=0;do{m=l;l=k>>>31|l<<1;k=i|k<<1;m=b<<1|m>>>31|0;n=b>>>31|a<<1|0;Aj(e,d,m,n)|0;p=D;o=p>>31|((p|0)<0?-1:0)<<1;i=o&1;b=Aj(m,n,o&h,(((p|0)<0?-1:0)>>31|((p|0)<0?-1:0)<<1)&g)|0;a=D;j=j-1|0;}while((j|0)!=0);g=l;e=0;}h=0;if(f){c[f>>2]=b;c[f+4>>2]=a;}o=(k|0)>>>31|(g|h)<<1|(h<<1|k>>>31)&0|e;p=(k<<1|0>>>31)&-2|i;return(D=o,p)|0;}function Kj(a,b,c,d,e,f,g,h){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;h=h|0;Ca[a&3](b|0,c|0,d|0,e|0,f|0,g|0,h|0);}function Lj(a,b,c,d,e,f,g){a=a|0;b=b|0;c=c|0;d=d|0;e=e|0;f=f|0;g=g|0;aa(0);}// EMSCRIPTEN_END_FUNCS
var Ca=[Lj,Ri,Qi,Lj];return{_opus_get_version_string:qb,_free:rj,_opus_encode_float:fj,_opus_decoder_create:si,_i64Add:xj,_memmove:zj,_opus_decode_float:Di,_bitshift64Ashr:tj,_opus_encoder_destroy:hj,_memset:wj,_malloc:qj,_opus_decoder_destroy:Fi,_opus_encoder_create:Ni,_opus_encode:ej,_llvm_ctlz_i32:vj,_bitshift64Lshr:uj,_opus_decode:Ai,_opus_decoder_ctl:Ei,_memcpy:yj,_opus_encoder_ctl:gj,runPostSets:sj,stackAlloc:Da,stackSave:Ea,stackRestore:Fa,setThrew:Ga,setTempRet0:Ja,getTempRet0:Ka,dynCall_viiiiiii:Kj};}// EMSCRIPTEN_END_ASM
(Module.asmGlobalArg,Module.asmLibraryArg,buffer);var _opus_get_version_string=Module["_opus_get_version_string"]=asm["_opus_get_version_string"];var _free=Module["_free"]=asm["_free"];var _opus_encode_float=Module["_opus_encode_float"]=asm["_opus_encode_float"];var _opus_decoder_create=Module["_opus_decoder_create"]=asm["_opus_decoder_create"];var _i64Add=Module["_i64Add"]=asm["_i64Add"];var _memmove=Module["_memmove"]=asm["_memmove"];var _opus_decode_float=Module["_opus_decode_float"]=asm["_opus_decode_float"];var _bitshift64Ashr=Module["_bitshift64Ashr"]=asm["_bitshift64Ashr"];var _opus_encoder_destroy=Module["_opus_encoder_destroy"]=asm["_opus_encoder_destroy"];var _memset=Module["_memset"]=asm["_memset"];var _malloc=Module["_malloc"]=asm["_malloc"];var _opus_decoder_destroy=Module["_opus_decoder_destroy"]=asm["_opus_decoder_destroy"];var _opus_encoder_create=Module["_opus_encoder_create"]=asm["_opus_encoder_create"];var _opus_encode=Module["_opus_encode"]=asm["_opus_encode"];var _llvm_ctlz_i32=Module["_llvm_ctlz_i32"]=asm["_llvm_ctlz_i32"];var _bitshift64Lshr=Module["_bitshift64Lshr"]=asm["_bitshift64Lshr"];var _opus_decode=Module["_opus_decode"]=asm["_opus_decode"];var _opus_decoder_ctl=Module["_opus_decoder_ctl"]=asm["_opus_decoder_ctl"];var _memcpy=Module["_memcpy"]=asm["_memcpy"];var _opus_encoder_ctl=Module["_opus_encoder_ctl"]=asm["_opus_encoder_ctl"];var runPostSets=Module["runPostSets"]=asm["runPostSets"];var dynCall_viiiiiii=Module["dynCall_viiiiiii"]=asm["dynCall_viiiiiii"];Runtime.stackAlloc=asm["stackAlloc"];Runtime.stackSave=asm["stackSave"];Runtime.stackRestore=asm["stackRestore"];Runtime.setTempRet0=asm["setTempRet0"];Runtime.getTempRet0=asm["getTempRet0"];var i64Math=function(){var goog={math:{}};goog.math.Long=function(low,high){this.low_=low|0;this.high_=high|0;};goog.math.Long.IntCache_={};goog.math.Long.fromInt=function(value){if(-128<=value&&value<128){var cachedObj=goog.math.Long.IntCache_[value];if(cachedObj){return cachedObj;}}var obj=new goog.math.Long(value|0,value<0?-1:0);if(-128<=value&&value<128){goog.math.Long.IntCache_[value]=obj;}return obj;};goog.math.Long.fromNumber=function(value){if(isNaN(value)||!isFinite(value)){return goog.math.Long.ZERO;}else if(value<=-goog.math.Long.TWO_PWR_63_DBL_){return goog.math.Long.MIN_VALUE;}else if(value+1>=goog.math.Long.TWO_PWR_63_DBL_){return goog.math.Long.MAX_VALUE;}else if(value<0){return goog.math.Long.fromNumber(-value).negate();}else{return new goog.math.Long(value%goog.math.Long.TWO_PWR_32_DBL_|0,value/goog.math.Long.TWO_PWR_32_DBL_|0);}};goog.math.Long.fromBits=function(lowBits,highBits){return new goog.math.Long(lowBits,highBits);};goog.math.Long.fromString=function(str,opt_radix){if(str.length==0){throw Error("number format error: empty string");}var radix=opt_radix||10;if(radix<2||36<radix){throw Error("radix out of range: "+radix);}if(str.charAt(0)=="-"){return goog.math.Long.fromString(str.substring(1),radix).negate();}else if(str.indexOf("-")>=0){throw Error('number format error: interior "-" character: '+str);}var radixToPower=goog.math.Long.fromNumber(Math.pow(radix,8));var result=goog.math.Long.ZERO;for(var i=0;i<str.length;i+=8){var size=Math.min(8,str.length-i);var value=parseInt(str.substring(i,i+size),radix);if(size<8){var power=goog.math.Long.fromNumber(Math.pow(radix,size));result=result.multiply(power).add(goog.math.Long.fromNumber(value));}else{result=result.multiply(radixToPower);result=result.add(goog.math.Long.fromNumber(value));}}return result;};goog.math.Long.TWO_PWR_16_DBL_=1<<16;goog.math.Long.TWO_PWR_24_DBL_=1<<24;goog.math.Long.TWO_PWR_32_DBL_=goog.math.Long.TWO_PWR_16_DBL_*goog.math.Long.TWO_PWR_16_DBL_;goog.math.Long.TWO_PWR_31_DBL_=goog.math.Long.TWO_PWR_32_DBL_/2;goog.math.Long.TWO_PWR_48_DBL_=goog.math.Long.TWO_PWR_32_DBL_*goog.math.Long.TWO_PWR_16_DBL_;goog.math.Long.TWO_PWR_64_DBL_=goog.math.Long.TWO_PWR_32_DBL_*goog.math.Long.TWO_PWR_32_DBL_;goog.math.Long.TWO_PWR_63_DBL_=goog.math.Long.TWO_PWR_64_DBL_/2;goog.math.Long.ZERO=goog.math.Long.fromInt(0);goog.math.Long.ONE=goog.math.Long.fromInt(1);goog.math.Long.NEG_ONE=goog.math.Long.fromInt(-1);goog.math.Long.MAX_VALUE=goog.math.Long.fromBits(4294967295|0,2147483647|0);goog.math.Long.MIN_VALUE=goog.math.Long.fromBits(0,2147483648|0);goog.math.Long.TWO_PWR_24_=goog.math.Long.fromInt(1<<24);goog.math.Long.prototype.toInt=function(){return this.low_;};goog.math.Long.prototype.toNumber=function(){return this.high_*goog.math.Long.TWO_PWR_32_DBL_+this.getLowBitsUnsigned();};goog.math.Long.prototype.toString=function(opt_radix){var radix=opt_radix||10;if(radix<2||36<radix){throw Error("radix out of range: "+radix);}if(this.isZero()){return"0";}if(this.isNegative()){if(this.equals(goog.math.Long.MIN_VALUE)){var radixLong=goog.math.Long.fromNumber(radix);var div=this.div(radixLong);var rem=div.multiply(radixLong).subtract(this);return div.toString(radix)+rem.toInt().toString(radix);}else{return"-"+this.negate().toString(radix);}}var radixToPower=goog.math.Long.fromNumber(Math.pow(radix,6));var rem=this;var result="";while(true){var remDiv=rem.div(radixToPower);var intval=rem.subtract(remDiv.multiply(radixToPower)).toInt();var digits=intval.toString(radix);rem=remDiv;if(rem.isZero()){return digits+result;}else{while(digits.length<6){digits="0"+digits;}result=""+digits+result;}}};goog.math.Long.prototype.getHighBits=function(){return this.high_;};goog.math.Long.prototype.getLowBits=function(){return this.low_;};goog.math.Long.prototype.getLowBitsUnsigned=function(){return this.low_>=0?this.low_:goog.math.Long.TWO_PWR_32_DBL_+this.low_;};goog.math.Long.prototype.getNumBitsAbs=function(){if(this.isNegative()){if(this.equals(goog.math.Long.MIN_VALUE)){return 64;}else{return this.negate().getNumBitsAbs();}}else{var val=this.high_!=0?this.high_:this.low_;for(var bit=31;bit>0;bit--){if((val&1<<bit)!=0){break;}}return this.high_!=0?bit+33:bit+1;}};goog.math.Long.prototype.isZero=function(){return this.high_==0&&this.low_==0;};goog.math.Long.prototype.isNegative=function(){return this.high_<0;};goog.math.Long.prototype.isOdd=function(){return(this.low_&1)==1;};goog.math.Long.prototype.equals=function(other){return this.high_==other.high_&&this.low_==other.low_;};goog.math.Long.prototype.notEquals=function(other){return this.high_!=other.high_||this.low_!=other.low_;};goog.math.Long.prototype.lessThan=function(other){return this.compare(other)<0;};goog.math.Long.prototype.lessThanOrEqual=function(other){return this.compare(other)<=0;};goog.math.Long.prototype.greaterThan=function(other){return this.compare(other)>0;};goog.math.Long.prototype.greaterThanOrEqual=function(other){return this.compare(other)>=0;};goog.math.Long.prototype.compare=function(other){if(this.equals(other)){return 0;}var thisNeg=this.isNegative();var otherNeg=other.isNegative();if(thisNeg&&!otherNeg){return-1;}if(!thisNeg&&otherNeg){return 1;}if(this.subtract(other).isNegative()){return-1;}else{return 1;}};goog.math.Long.prototype.negate=function(){if(this.equals(goog.math.Long.MIN_VALUE)){return goog.math.Long.MIN_VALUE;}else{return this.not().add(goog.math.Long.ONE);}};goog.math.Long.prototype.add=function(other){var a48=this.high_>>>16;var a32=this.high_&65535;var a16=this.low_>>>16;var a00=this.low_&65535;var b48=other.high_>>>16;var b32=other.high_&65535;var b16=other.low_>>>16;var b00=other.low_&65535;var c48=0,c32=0,c16=0,c00=0;c00+=a00+b00;c16+=c00>>>16;c00&=65535;c16+=a16+b16;c32+=c16>>>16;c16&=65535;c32+=a32+b32;c48+=c32>>>16;c32&=65535;c48+=a48+b48;c48&=65535;return goog.math.Long.fromBits(c16<<16|c00,c48<<16|c32);};goog.math.Long.prototype.subtract=function(other){return this.add(other.negate());};goog.math.Long.prototype.multiply=function(other){if(this.isZero()){return goog.math.Long.ZERO;}else if(other.isZero()){return goog.math.Long.ZERO;}if(this.equals(goog.math.Long.MIN_VALUE)){return other.isOdd()?goog.math.Long.MIN_VALUE:goog.math.Long.ZERO;}else if(other.equals(goog.math.Long.MIN_VALUE)){return this.isOdd()?goog.math.Long.MIN_VALUE:goog.math.Long.ZERO;}if(this.isNegative()){if(other.isNegative()){return this.negate().multiply(other.negate());}else{return this.negate().multiply(other).negate();}}else if(other.isNegative()){return this.multiply(other.negate()).negate();}if(this.lessThan(goog.math.Long.TWO_PWR_24_)&&other.lessThan(goog.math.Long.TWO_PWR_24_)){return goog.math.Long.fromNumber(this.toNumber()*other.toNumber());}var a48=this.high_>>>16;var a32=this.high_&65535;var a16=this.low_>>>16;var a00=this.low_&65535;var b48=other.high_>>>16;var b32=other.high_&65535;var b16=other.low_>>>16;var b00=other.low_&65535;var c48=0,c32=0,c16=0,c00=0;c00+=a00*b00;c16+=c00>>>16;c00&=65535;c16+=a16*b00;c32+=c16>>>16;c16&=65535;c16+=a00*b16;c32+=c16>>>16;c16&=65535;c32+=a32*b00;c48+=c32>>>16;c32&=65535;c32+=a16*b16;c48+=c32>>>16;c32&=65535;c32+=a00*b32;c48+=c32>>>16;c32&=65535;c48+=a48*b00+a32*b16+a16*b32+a00*b48;c48&=65535;return goog.math.Long.fromBits(c16<<16|c00,c48<<16|c32);};goog.math.Long.prototype.div=function(other){if(other.isZero()){throw Error("division by zero");}else if(this.isZero()){return goog.math.Long.ZERO;}if(this.equals(goog.math.Long.MIN_VALUE)){if(other.equals(goog.math.Long.ONE)||other.equals(goog.math.Long.NEG_ONE)){return goog.math.Long.MIN_VALUE;}else if(other.equals(goog.math.Long.MIN_VALUE)){return goog.math.Long.ONE;}else{var halfThis=this.shiftRight(1);var approx=halfThis.div(other).shiftLeft(1);if(approx.equals(goog.math.Long.ZERO)){return other.isNegative()?goog.math.Long.ONE:goog.math.Long.NEG_ONE;}else{var rem=this.subtract(other.multiply(approx));var result=approx.add(rem.div(other));return result;}}}else if(other.equals(goog.math.Long.MIN_VALUE)){return goog.math.Long.ZERO;}if(this.isNegative()){if(other.isNegative()){return this.negate().div(other.negate());}else{return this.negate().div(other).negate();}}else if(other.isNegative()){return this.div(other.negate()).negate();}var res=goog.math.Long.ZERO;var rem=this;while(rem.greaterThanOrEqual(other)){var approx=Math.max(1,Math.floor(rem.toNumber()/other.toNumber()));var log2=Math.ceil(Math.log(approx)/Math.LN2);var delta=log2<=48?1:Math.pow(2,log2-48);var approxRes=goog.math.Long.fromNumber(approx);var approxRem=approxRes.multiply(other);while(approxRem.isNegative()||approxRem.greaterThan(rem)){approx-=delta;approxRes=goog.math.Long.fromNumber(approx);approxRem=approxRes.multiply(other);}if(approxRes.isZero()){approxRes=goog.math.Long.ONE;}res=res.add(approxRes);rem=rem.subtract(approxRem);}return res;};goog.math.Long.prototype.modulo=function(other){return this.subtract(this.div(other).multiply(other));};goog.math.Long.prototype.not=function(){return goog.math.Long.fromBits(~this.low_,~this.high_);};goog.math.Long.prototype.and=function(other){return goog.math.Long.fromBits(this.low_&other.low_,this.high_&other.high_);};goog.math.Long.prototype.or=function(other){return goog.math.Long.fromBits(this.low_|other.low_,this.high_|other.high_);};goog.math.Long.prototype.xor=function(other){return goog.math.Long.fromBits(this.low_^other.low_,this.high_^other.high_);};goog.math.Long.prototype.shiftLeft=function(numBits){numBits&=63;if(numBits==0){return this;}else{var low=this.low_;if(numBits<32){var high=this.high_;return goog.math.Long.fromBits(low<<numBits,high<<numBits|low>>>32-numBits);}else{return goog.math.Long.fromBits(0,low<<numBits-32);}}};goog.math.Long.prototype.shiftRight=function(numBits){numBits&=63;if(numBits==0){return this;}else{var high=this.high_;if(numBits<32){var low=this.low_;return goog.math.Long.fromBits(low>>>numBits|high<<32-numBits,high>>numBits);}else{return goog.math.Long.fromBits(high>>numBits-32,high>=0?0:-1);}}};goog.math.Long.prototype.shiftRightUnsigned=function(numBits){numBits&=63;if(numBits==0){return this;}else{var high=this.high_;if(numBits<32){var low=this.low_;return goog.math.Long.fromBits(low>>>numBits|high<<32-numBits,high>>>numBits);}else if(numBits==32){return goog.math.Long.fromBits(high,0);}else{return goog.math.Long.fromBits(high>>>numBits-32,0);}}};var navigator={appName:"Modern Browser"};var dbits;var canary=0xdeadbeefcafe;var j_lm=(canary&16777215)==15715070;function BigInteger(a,b,c){if(a!=null)if("number"==typeof a)this.fromNumber(a,b,c);else if(b==null&&"string"!=typeof a)this.fromString(a,256);else this.fromString(a,b);}function nbi(){return new BigInteger(null);}function am1(i,x,w,j,c,n){while(--n>=0){var v=x*this[i++]+w[j]+c;c=Math.floor(v/67108864);w[j++]=v&67108863;}return c;}function am2(i,x,w,j,c,n){var xl=x&32767,xh=x>>15;while(--n>=0){var l=this[i]&32767;var h=this[i++]>>15;var m=xh*l+h*xl;l=xl*l+((m&32767)<<15)+w[j]+(c&1073741823);c=(l>>>30)+(m>>>15)+xh*h+(c>>>30);w[j++]=l&1073741823;}return c;}function am3(i,x,w,j,c,n){var xl=x&16383,xh=x>>14;while(--n>=0){var l=this[i]&16383;var h=this[i++]>>14;var m=xh*l+h*xl;l=xl*l+((m&16383)<<14)+w[j]+c;c=(l>>28)+(m>>14)+xh*h;w[j++]=l&268435455;}return c;}if(j_lm&&navigator.appName=="Microsoft Internet Explorer"){BigInteger.prototype.am=am2;dbits=30;}else if(j_lm&&navigator.appName!="Netscape"){BigInteger.prototype.am=am1;dbits=26;}else{BigInteger.prototype.am=am3;dbits=28;}BigInteger.prototype.DB=dbits;BigInteger.prototype.DM=(1<<dbits)-1;BigInteger.prototype.DV=1<<dbits;var BI_FP=52;BigInteger.prototype.FV=Math.pow(2,BI_FP);BigInteger.prototype.F1=BI_FP-dbits;BigInteger.prototype.F2=2*dbits-BI_FP;var BI_RM="0123456789abcdefghijklmnopqrstuvwxyz";var BI_RC=new Array();var rr,vv;rr="0".charCodeAt(0);for(vv=0;vv<=9;++vv)BI_RC[rr++]=vv;rr="a".charCodeAt(0);for(vv=10;vv<36;++vv)BI_RC[rr++]=vv;rr="A".charCodeAt(0);for(vv=10;vv<36;++vv)BI_RC[rr++]=vv;function int2char(n){return BI_RM.charAt(n);}function intAt(s,i){var c=BI_RC[s.charCodeAt(i)];return c==null?-1:c;}function bnpCopyTo(r){for(var i=this.t-1;i>=0;--i)r[i]=this[i];r.t=this.t;r.s=this.s;}function bnpFromInt(x){this.t=1;this.s=x<0?-1:0;if(x>0)this[0]=x;else if(x<-1)this[0]=x+DV;else this.t=0;}function nbv(i){var r=nbi();r.fromInt(i);return r;}function bnpFromString(s,b){var k;if(b==16)k=4;else if(b==8)k=3;else if(b==256)k=8;else if(b==2)k=1;else if(b==32)k=5;else if(b==4)k=2;else{this.fromRadix(s,b);return;}this.t=0;this.s=0;var i=s.length,mi=false,sh=0;while(--i>=0){var x=k==8?s[i]&255:intAt(s,i);if(x<0){if(s.charAt(i)=="-")mi=true;continue;}mi=false;if(sh==0)this[this.t++]=x;else if(sh+k>this.DB){this[this.t-1]|=(x&(1<<this.DB-sh)-1)<<sh;this[this.t++]=x>>this.DB-sh;}else this[this.t-1]|=x<<sh;sh+=k;if(sh>=this.DB)sh-=this.DB;}if(k==8&&(s[0]&128)!=0){this.s=-1;if(sh>0)this[this.t-1]|=(1<<this.DB-sh)-1<<sh;}this.clamp();if(mi)BigInteger.ZERO.subTo(this,this);}function bnpClamp(){var c=this.s&this.DM;while(this.t>0&&this[this.t-1]==c)--this.t;}function bnToString(b){if(this.s<0)return"-"+this.negate().toString(b);var k;if(b==16)k=4;else if(b==8)k=3;else if(b==2)k=1;else if(b==32)k=5;else if(b==4)k=2;else return this.toRadix(b);var km=(1<<k)-1,d,m=false,r="",i=this.t;var p=this.DB-i*this.DB%k;if(i-->0){if(p<this.DB&&(d=this[i]>>p)>0){m=true;r=int2char(d);}while(i>=0){if(p<k){d=(this[i]&(1<<p)-1)<<k-p;d|=this[--i]>>(p+=this.DB-k);}else{d=this[i]>>(p-=k)&km;if(p<=0){p+=this.DB;--i;}}if(d>0)m=true;if(m)r+=int2char(d);}}return m?r:"0";}function bnNegate(){var r=nbi();BigInteger.ZERO.subTo(this,r);return r;}function bnAbs(){return this.s<0?this.negate():this;}function bnCompareTo(a){var r=this.s-a.s;if(r!=0)return r;var i=this.t;r=i-a.t;if(r!=0)return this.s<0?-r:r;while(--i>=0)if((r=this[i]-a[i])!=0)return r;return 0;}function nbits(x){var r=1,t;if((t=x>>>16)!=0){x=t;r+=16;}if((t=x>>8)!=0){x=t;r+=8;}if((t=x>>4)!=0){x=t;r+=4;}if((t=x>>2)!=0){x=t;r+=2;}if((t=x>>1)!=0){x=t;r+=1;}return r;}function bnBitLength(){if(this.t<=0)return 0;return this.DB*(this.t-1)+nbits(this[this.t-1]^this.s&this.DM);}function bnpDLShiftTo(n,r){var i;for(i=this.t-1;i>=0;--i)r[i+n]=this[i];for(i=n-1;i>=0;--i)r[i]=0;r.t=this.t+n;r.s=this.s;}function bnpDRShiftTo(n,r){for(var i=n;i<this.t;++i)r[i-n]=this[i];r.t=Math.max(this.t-n,0);r.s=this.s;}function bnpLShiftTo(n,r){var bs=n%this.DB;var cbs=this.DB-bs;var bm=(1<<cbs)-1;var ds=Math.floor(n/this.DB),c=this.s<<bs&this.DM,i;for(i=this.t-1;i>=0;--i){r[i+ds+1]=this[i]>>cbs|c;c=(this[i]&bm)<<bs;}for(i=ds-1;i>=0;--i)r[i]=0;r[ds]=c;r.t=this.t+ds+1;r.s=this.s;r.clamp();}function bnpRShiftTo(n,r){r.s=this.s;var ds=Math.floor(n/this.DB);if(ds>=this.t){r.t=0;return;}var bs=n%this.DB;var cbs=this.DB-bs;var bm=(1<<bs)-1;r[0]=this[ds]>>bs;for(var i=ds+1;i<this.t;++i){r[i-ds-1]|=(this[i]&bm)<<cbs;r[i-ds]=this[i]>>bs;}if(bs>0)r[this.t-ds-1]|=(this.s&bm)<<cbs;r.t=this.t-ds;r.clamp();}function bnpSubTo(a,r){var i=0,c=0,m=Math.min(a.t,this.t);while(i<m){c+=this[i]-a[i];r[i++]=c&this.DM;c>>=this.DB;}if(a.t<this.t){c-=a.s;while(i<this.t){c+=this[i];r[i++]=c&this.DM;c>>=this.DB;}c+=this.s;}else{c+=this.s;while(i<a.t){c-=a[i];r[i++]=c&this.DM;c>>=this.DB;}c-=a.s;}r.s=c<0?-1:0;if(c<-1)r[i++]=this.DV+c;else if(c>0)r[i++]=c;r.t=i;r.clamp();}function bnpMultiplyTo(a,r){var x=this.abs(),y=a.abs();var i=x.t;r.t=i+y.t;while(--i>=0)r[i]=0;for(i=0;i<y.t;++i)r[i+x.t]=x.am(0,y[i],r,i,0,x.t);r.s=0;r.clamp();if(this.s!=a.s)BigInteger.ZERO.subTo(r,r);}function bnpSquareTo(r){var x=this.abs();var i=r.t=2*x.t;while(--i>=0)r[i]=0;for(i=0;i<x.t-1;++i){var c=x.am(i,x[i],r,2*i,0,1);if((r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1))>=x.DV){r[i+x.t]-=x.DV;r[i+x.t+1]=1;}}if(r.t>0)r[r.t-1]+=x.am(i,x[i],r,2*i,0,1);r.s=0;r.clamp();}function bnpDivRemTo(m,q,r){var pm=m.abs();if(pm.t<=0)return;var pt=this.abs();if(pt.t<pm.t){if(q!=null)q.fromInt(0);if(r!=null)this.copyTo(r);return;}if(r==null)r=nbi();var y=nbi(),ts=this.s,ms=m.s;var nsh=this.DB-nbits(pm[pm.t-1]);if(nsh>0){pm.lShiftTo(nsh,y);pt.lShiftTo(nsh,r);}else{pm.copyTo(y);pt.copyTo(r);}var ys=y.t;var y0=y[ys-1];if(y0==0)return;var yt=y0*(1<<this.F1)+(ys>1?y[ys-2]>>this.F2:0);var d1=this.FV/yt,d2=(1<<this.F1)/yt,e=1<<this.F2;var i=r.t,j=i-ys,t=q==null?nbi():q;y.dlShiftTo(j,t);if(r.compareTo(t)>=0){r[r.t++]=1;r.subTo(t,r);}BigInteger.ONE.dlShiftTo(ys,t);t.subTo(y,y);while(y.t<ys)y[y.t++]=0;while(--j>=0){var qd=r[--i]==y0?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);if((r[i]+=y.am(0,qd,r,j,0,ys))<qd){y.dlShiftTo(j,t);r.subTo(t,r);while(r[i]<--qd)r.subTo(t,r);}}if(q!=null){r.drShiftTo(ys,q);if(ts!=ms)BigInteger.ZERO.subTo(q,q);}r.t=ys;r.clamp();if(nsh>0)r.rShiftTo(nsh,r);if(ts<0)BigInteger.ZERO.subTo(r,r);}function bnMod(a){var r=nbi();this.abs().divRemTo(a,null,r);if(this.s<0&&r.compareTo(BigInteger.ZERO)>0)a.subTo(r,r);return r;}function Classic(m){this.m=m;}function cConvert(x){if(x.s<0||x.compareTo(this.m)>=0)return x.mod(this.m);else return x;}function cRevert(x){return x;}function cReduce(x){x.divRemTo(this.m,null,x);}function cMulTo(x,y,r){x.multiplyTo(y,r);this.reduce(r);}function cSqrTo(x,r){x.squareTo(r);this.reduce(r);}Classic.prototype.convert=cConvert;Classic.prototype.revert=cRevert;Classic.prototype.reduce=cReduce;Classic.prototype.mulTo=cMulTo;Classic.prototype.sqrTo=cSqrTo;function bnpInvDigit(){if(this.t<1)return 0;var x=this[0];if((x&1)==0)return 0;var y=x&3;y=y*(2-(x&15)*y)&15;y=y*(2-(x&255)*y)&255;y=y*(2-((x&65535)*y&65535))&65535;y=y*(2-x*y%this.DV)%this.DV;return y>0?this.DV-y:-y;}function Montgomery(m){this.m=m;this.mp=m.invDigit();this.mpl=this.mp&32767;this.mph=this.mp>>15;this.um=(1<<m.DB-15)-1;this.mt2=2*m.t;}function montConvert(x){var r=nbi();x.abs().dlShiftTo(this.m.t,r);r.divRemTo(this.m,null,r);if(x.s<0&&r.compareTo(BigInteger.ZERO)>0)this.m.subTo(r,r);return r;}function montRevert(x){var r=nbi();x.copyTo(r);this.reduce(r);return r;}function montReduce(x){while(x.t<=this.mt2)x[x.t++]=0;for(var i=0;i<this.m.t;++i){var j=x[i]&32767;var u0=j*this.mpl+((j*this.mph+(x[i]>>15)*this.mpl&this.um)<<15)&x.DM;j=i+this.m.t;x[j]+=this.m.am(0,u0,x,i,0,this.m.t);while(x[j]>=x.DV){x[j]-=x.DV;x[++j]++;}}x.clamp();x.drShiftTo(this.m.t,x);if(x.compareTo(this.m)>=0)x.subTo(this.m,x);}function montSqrTo(x,r){x.squareTo(r);this.reduce(r);}function montMulTo(x,y,r){x.multiplyTo(y,r);this.reduce(r);}Montgomery.prototype.convert=montConvert;Montgomery.prototype.revert=montRevert;Montgomery.prototype.reduce=montReduce;Montgomery.prototype.mulTo=montMulTo;Montgomery.prototype.sqrTo=montSqrTo;function bnpIsEven(){return(this.t>0?this[0]&1:this.s)==0;}function bnpExp(e,z){if(e>4294967295||e<1)return BigInteger.ONE;var r=nbi(),r2=nbi(),g=z.convert(this),i=nbits(e)-1;g.copyTo(r);while(--i>=0){z.sqrTo(r,r2);if((e&1<<i)>0)z.mulTo(r2,g,r);else{var t=r;r=r2;r2=t;}}return z.revert(r);}function bnModPowInt(e,m){var z;if(e<256||m.isEven())z=new Classic(m);else z=new Montgomery(m);return this.exp(e,z);}BigInteger.prototype.copyTo=bnpCopyTo;BigInteger.prototype.fromInt=bnpFromInt;BigInteger.prototype.fromString=bnpFromString;BigInteger.prototype.clamp=bnpClamp;BigInteger.prototype.dlShiftTo=bnpDLShiftTo;BigInteger.prototype.drShiftTo=bnpDRShiftTo;BigInteger.prototype.lShiftTo=bnpLShiftTo;BigInteger.prototype.rShiftTo=bnpRShiftTo;BigInteger.prototype.subTo=bnpSubTo;BigInteger.prototype.multiplyTo=bnpMultiplyTo;BigInteger.prototype.squareTo=bnpSquareTo;BigInteger.prototype.divRemTo=bnpDivRemTo;BigInteger.prototype.invDigit=bnpInvDigit;BigInteger.prototype.isEven=bnpIsEven;BigInteger.prototype.exp=bnpExp;BigInteger.prototype.toString=bnToString;BigInteger.prototype.negate=bnNegate;BigInteger.prototype.abs=bnAbs;BigInteger.prototype.compareTo=bnCompareTo;BigInteger.prototype.bitLength=bnBitLength;BigInteger.prototype.mod=bnMod;BigInteger.prototype.modPowInt=bnModPowInt;BigInteger.ZERO=nbv(0);BigInteger.ONE=nbv(1);function bnpFromRadix(s,b){this.fromInt(0);if(b==null)b=10;var cs=this.chunkSize(b);var d=Math.pow(b,cs),mi=false,j=0,w=0;for(var i=0;i<s.length;++i){var x=intAt(s,i);if(x<0){if(s.charAt(i)=="-"&&this.signum()==0)mi=true;continue;}w=b*w+x;if(++j>=cs){this.dMultiply(d);this.dAddOffset(w,0);j=0;w=0;}}if(j>0){this.dMultiply(Math.pow(b,j));this.dAddOffset(w,0);}if(mi)BigInteger.ZERO.subTo(this,this);}function bnpChunkSize(r){return Math.floor(Math.LN2*this.DB/Math.log(r));}function bnSigNum(){if(this.s<0)return-1;else if(this.t<=0||this.t==1&&this[0]<=0)return 0;else return 1;}function bnpDMultiply(n){this[this.t]=this.am(0,n-1,this,0,0,this.t);++this.t;this.clamp();}function bnpDAddOffset(n,w){if(n==0)return;while(this.t<=w)this[this.t++]=0;this[w]+=n;while(this[w]>=this.DV){this[w]-=this.DV;if(++w>=this.t)this[this.t++]=0;++this[w];}}function bnpToRadix(b){if(b==null)b=10;if(this.signum()==0||b<2||b>36)return"0";var cs=this.chunkSize(b);var a=Math.pow(b,cs);var d=nbv(a),y=nbi(),z=nbi(),r="";this.divRemTo(d,y,z);while(y.signum()>0){r=(a+z.intValue()).toString(b).substr(1)+r;y.divRemTo(d,y,z);}return z.intValue().toString(b)+r;}function bnIntValue(){if(this.s<0){if(this.t==1)return this[0]-this.DV;else if(this.t==0)return-1;}else if(this.t==1)return this[0];else if(this.t==0)return 0;return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0];}function bnpAddTo(a,r){var i=0,c=0,m=Math.min(a.t,this.t);while(i<m){c+=this[i]+a[i];r[i++]=c&this.DM;c>>=this.DB;}if(a.t<this.t){c+=a.s;while(i<this.t){c+=this[i];r[i++]=c&this.DM;c>>=this.DB;}c+=this.s;}else{c+=this.s;while(i<a.t){c+=a[i];r[i++]=c&this.DM;c>>=this.DB;}c+=a.s;}r.s=c<0?-1:0;if(c>0)r[i++]=c;else if(c<-1)r[i++]=this.DV+c;r.t=i;r.clamp();}BigInteger.prototype.fromRadix=bnpFromRadix;BigInteger.prototype.chunkSize=bnpChunkSize;BigInteger.prototype.signum=bnSigNum;BigInteger.prototype.dMultiply=bnpDMultiply;BigInteger.prototype.dAddOffset=bnpDAddOffset;BigInteger.prototype.toRadix=bnpToRadix;BigInteger.prototype.intValue=bnIntValue;BigInteger.prototype.addTo=bnpAddTo;var Wrapper={abs:function abs(l,h){var x=new goog.math.Long(l,h);var ret;if(x.isNegative()){ret=x.negate();}else{ret=x;}HEAP32[tempDoublePtr>>2]=ret.low_;HEAP32[tempDoublePtr+4>>2]=ret.high_;},ensureTemps:function ensureTemps(){if(Wrapper.ensuredTemps)return;Wrapper.ensuredTemps=true;Wrapper.two32=new BigInteger();Wrapper.two32.fromString("4294967296",10);Wrapper.two64=new BigInteger();Wrapper.two64.fromString("18446744073709551616",10);Wrapper.temp1=new BigInteger();Wrapper.temp2=new BigInteger();},lh2bignum:function lh2bignum(l,h){var a=new BigInteger();a.fromString(h.toString(),10);var b=new BigInteger();a.multiplyTo(Wrapper.two32,b);var c=new BigInteger();c.fromString(l.toString(),10);var d=new BigInteger();c.addTo(b,d);return d;},stringify:function stringify(l,h,unsigned){var ret=new goog.math.Long(l,h).toString();if(unsigned&&ret[0]=="-"){Wrapper.ensureTemps();var bignum=new BigInteger();bignum.fromString(ret,10);ret=new BigInteger();Wrapper.two64.addTo(bignum,ret);ret=ret.toString(10);}return ret;},fromString:function fromString(str,base,min,max,unsigned){Wrapper.ensureTemps();var bignum=new BigInteger();bignum.fromString(str,base);var bigmin=new BigInteger();bigmin.fromString(min,10);var bigmax=new BigInteger();bigmax.fromString(max,10);if(unsigned&&bignum.compareTo(BigInteger.ZERO)<0){var temp=new BigInteger();bignum.addTo(Wrapper.two64,temp);bignum=temp;}var error=false;if(bignum.compareTo(bigmin)<0){bignum=bigmin;error=true;}else if(bignum.compareTo(bigmax)>0){bignum=bigmax;error=true;}var ret=goog.math.Long.fromString(bignum.toString());HEAP32[tempDoublePtr>>2]=ret.low_;HEAP32[tempDoublePtr+4>>2]=ret.high_;if(error)throw"range error";}};return Wrapper;}();if(memoryInitializer){if(typeof Module["locateFile"]==="function"){memoryInitializer=Module["locateFile"](memoryInitializer);}else if(Module["memoryInitializerPrefixURL"]){memoryInitializer=Module["memoryInitializerPrefixURL"]+memoryInitializer;}if(ENVIRONMENT_IS_NODE||ENVIRONMENT_IS_SHELL){var data=Module["readBinary"](memoryInitializer);HEAPU8.set(data,STATIC_BASE);}else{addRunDependency("memory initializer");Browser.asyncLoad(memoryInitializer,function(data){HEAPU8.set(data,STATIC_BASE);removeRunDependency("memory initializer");},function(data){throw"could not load memory initializer "+memoryInitializer;});}}function ExitStatus(status){this.name="ExitStatus";this.message="Program terminated with exit("+status+")";this.status=status;}ExitStatus.prototype=new Error();ExitStatus.prototype.constructor=ExitStatus;var initialStackTop;var preloadStartTime=null;var calledMain=false;dependenciesFulfilled=function runCaller(){if(!Module["calledRun"]&&shouldRunNow)run();if(!Module["calledRun"])dependenciesFulfilled=runCaller;};Module["callMain"]=Module.callMain=function callMain(args){assert(runDependencies==0,"cannot call main when async dependencies remain! (listen on __ATMAIN__)");assert(__ATPRERUN__.length==0,"cannot call main when preRun functions remain to be called");args=args||[];ensureInitRuntime();var argc=args.length+1;function pad(){for(var i=0;i<4-1;i++){argv.push(0);}}var argv=[allocate(intArrayFromString(Module["thisProgram"]),"i8",ALLOC_NORMAL)];pad();for(var i=0;i<argc-1;i=i+1){argv.push(allocate(intArrayFromString(args[i]),"i8",ALLOC_NORMAL));pad();}argv.push(0);argv=allocate(argv,"i32",ALLOC_NORMAL);initialStackTop=STACKTOP;try{var ret=Module["_main"](argc,argv,0);exit(ret);}catch(e){if(e instanceof ExitStatus){return;}else if(e=="SimulateInfiniteLoop"){Module["noExitRuntime"]=true;return;}else{if(e&&_typeof(e)==="object"&&e.stack)Module.printErr("exception thrown: "+[e,e.stack]);throw e;}}finally{calledMain=true;}};function run(args){args=args||Module["arguments"];if(preloadStartTime===null)preloadStartTime=Date.now();if(runDependencies>0){return;}preRun();if(runDependencies>0)return;if(Module["calledRun"])return;function doRun(){if(Module["calledRun"])return;Module["calledRun"]=true;if(ABORT)return;ensureInitRuntime();preMain();if(ENVIRONMENT_IS_WEB&&preloadStartTime!==null){Module.printErr("pre-main prep time: "+(Date.now()-preloadStartTime)+" ms");}if(Module["_main"]&&shouldRunNow){Module["callMain"](args);}postRun();}if(Module["setStatus"]){Module["setStatus"]("Running...");setTimeout(function(){setTimeout(function(){Module["setStatus"]("");},1);doRun();},1);}else{doRun();}}Module["run"]=Module.run=run;function exit(status){if(Module["noExitRuntime"]){return;}ABORT=true;EXITSTATUS=status;STACKTOP=initialStackTop;exitRuntime();if(ENVIRONMENT_IS_NODE){process["stdout"]["once"]("drain",function(){process["exit"](status);});console.log(" ");setTimeout(function(){process["exit"](status);},500);}else if(ENVIRONMENT_IS_SHELL&&typeof quit==="function"){quit(status);}throw new ExitStatus(status);}Module["exit"]=Module.exit=exit;function abort(text){if(text){Module.print(text);Module.printErr(text);}ABORT=true;EXITSTATUS=1;var extra="\nIf this abort() is unexpected, build with -s ASSERTIONS=1 which can give more information.";throw"abort() at "+stackTrace()+extra;}Module["abort"]=Module.abort=abort;if(Module["preInit"]){if(typeof Module["preInit"]=="function")Module["preInit"]=[Module["preInit"]];while(Module["preInit"].length>0){Module["preInit"].pop()();}}var shouldRunNow=false;if(Module["noInitialRun"]){shouldRunNow=false;}run();var _default=exports.default=Module;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(40)))

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(18);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(24)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(18);

$export($export.S, 'Math', { fround: __webpack_require__(357) });


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(358);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 358 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(18);
var create = __webpack_require__(69);
var aFunction = __webpack_require__(67);
var anObject = __webpack_require__(22);
var isObject = __webpack_require__(23);
var fails = __webpack_require__(24);
var bind = __webpack_require__(360);
var rConstruct = (__webpack_require__(19).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(67);
var isObject = __webpack_require__(23);
var invoke = __webpack_require__(171);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(178);
__webpack_require__(16);
__webpack_require__(17);
var _event = _interopRequireDefault(__webpack_require__(230));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var BaseClass = /*#__PURE__*/function () {
  function BaseClass() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, BaseClass);
    this.options = options;
    this.debug = options.debug || false;
  }
  return _createClass(BaseClass, [{
    key: "setOptions",
    value: function setOptions(options) {
      Object.assign(this.options, options);
    }
  }, {
    key: "events",
    get: function get() {
      if (this.options && this.options.events) {
        return this.options.events(this);
      }
      return (0, _event.default)(this);
    }
  }, {
    key: "alert",
    get: function get() {
      var res = '';
      if (this.options && this.options.alertError) {
        res = this.options.alertError;
      }
      return res;
    }
  }, {
    key: "toString",
    value: function toString() {
      return JSON.stringify(this);
    }
  }]);
}();
var _default = exports.default = BaseClass;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(363);
__webpack_require__(81);
function Texture(gl) {
  this.gl = gl;
  this.texture = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, this.texture);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
}
Texture.prototype.bind = function (n, program, name) {
  var gl = this.gl;
  gl.activeTexture([gl.TEXTURE0, gl.TEXTURE1, gl.TEXTURE2][n]);
  gl.bindTexture(gl.TEXTURE_2D, this.texture);
  gl.uniform1i(gl.getUniformLocation(program, name), n);
};
Texture.prototype.fill = function (width, height, data) {
  var gl = this.gl;
  gl.bindTexture(gl.TEXTURE_2D, this.texture);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, width, height, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, data);
};
function WebGLRenderer(canvas, options) {
  this.canvas = canvas;
  this.gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  this.initGL(options);
}
WebGLRenderer.prototype.initGL = function (options) {
  if (!this.gl) {
    console.log('[ER] WebGL not supported.');
    return;
  }
  var gl = this.gl;
  gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
  var program = gl.createProgram();
  var vertexShaderSource = ['attribute highp vec4 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'varying highp vec2 vTextureCoord;', 'void main(void) {', ' gl_Position = aVertexPosition;', ' vTextureCoord = aTextureCoord;', '}'].join('\n');
  var vertexShader = gl.createShader(gl.VERTEX_SHADER);
  gl.shaderSource(vertexShader, vertexShaderSource);
  gl.compileShader(vertexShader);
  var fragmentShaderSource = ['precision highp float;', 'varying lowp vec2 vTextureCoord;', 'uniform sampler2D YTexture;', 'uniform sampler2D UTexture;', 'uniform sampler2D VTexture;', 'const mat4 YUV2RGB = mat4', '(', ' 1.1643828125, 0, 1.59602734375, -.87078515625,', ' 1.1643828125, -.39176171875, -.81296875, .52959375,', ' 1.1643828125, 2.017234375, 0, -1.081390625,', ' 0, 0, 0, 1', ');', 'void main(void) {', ' gl_FragColor = vec4( texture2D(YTexture, vTextureCoord).x, texture2D(UTexture, vTextureCoord).x, texture2D(VTexture, vTextureCoord).x, 1) * YUV2RGB;', '}'].join('\n');
  var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
  gl.shaderSource(fragmentShader, fragmentShaderSource);
  gl.compileShader(fragmentShader);
  gl.attachShader(program, vertexShader);
  gl.attachShader(program, fragmentShader);
  gl.linkProgram(program);
  gl.useProgram(program);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    console.log('[ER] Shader link failed.');
  }
  var vertexPositionAttribute = gl.getAttribLocation(program, 'aVertexPosition');
  gl.enableVertexAttribArray(vertexPositionAttribute);
  var textureCoordAttribute = gl.getAttribLocation(program, 'aTextureCoord');
  gl.enableVertexAttribArray(textureCoordAttribute);
  var verticesBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, verticesBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([1.0, 1.0, 0.0, -1.0, 1.0, 0.0, 1.0, -1.0, 0.0, -1.0, -1.0, 0.0]), gl.STATIC_DRAW);
  gl.vertexAttribPointer(vertexPositionAttribute, 3, gl.FLOAT, false, 0, 0);
  var texCoordBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([1.0, 0.0, 0.0, 0.0, 1.0, 1.0, 0.0, 1.0]), gl.STATIC_DRAW);
  gl.vertexAttribPointer(textureCoordAttribute, 2, gl.FLOAT, false, 0, 0);
  gl.y = new Texture(gl);
  gl.u = new Texture(gl);
  gl.v = new Texture(gl);
  gl.y.bind(0, program, 'YTexture');
  gl.u.bind(1, program, 'UTexture');
  gl.v.bind(2, program, 'VTexture');
};
WebGLRenderer.prototype.renderFrame = function (videoFrame, width, height, uOffset, vOffset) {
  if (!this.gl) {
    console.log('[ER] Render frame failed due to WebGL not supported.');
    return;
  }
  var gl = this.gl;
  gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
  gl.clearColor(0.0, 0.0, 0.0, 0.0);
  gl.clear(gl.COLOR_BUFFER_BIT);
  gl.y.fill(width, height, videoFrame.subarray(0, uOffset));
  gl.u.fill(width >> 1, height >> 1, videoFrame.subarray(uOffset, uOffset + vOffset));
  gl.v.fill(width >> 1, height >> 1, videoFrame.subarray(uOffset + vOffset, videoFrame.length));
  gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
};
WebGLRenderer.prototype.fullscreen = function () {
  var canvas = this.canvas;
  if (canvas.RequestFullScreen) {
    canvas.RequestFullScreen();
  } else if (canvas.webkitRequestFullScreen) {
    canvas.webkitRequestFullScreen();
  } else if (canvas.mozRequestFullScreen) {
    canvas.mozRequestFullScreen();
  } else if (canvas.msRequestFullscreen) {
    canvas.msRequestFullscreen();
  } else {
    alert("This browser doesn't supporter fullscreen");
  }
};
WebGLRenderer.prototype.exitfullscreen = function () {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else {
    alert("Exit fullscreen doesn't work");
  }
};
var _default = exports.default = WebGLRenderer;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(18);

$export($export.P, 'Array', { fill: __webpack_require__(126) });

__webpack_require__(85)('fill');


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _tinyh = __webpack_require__(384);
(0, _tinyh.init)();

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(105);
__webpack_require__(135);
__webpack_require__(56);
__webpack_require__(46);
__webpack_require__(31);
__webpack_require__(29);
__webpack_require__(16);
__webpack_require__(17);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var TRACE_ID_PREFIX = 'trace_';
var DELAY_CONNECTOR = ' - ';
// 阶段性耗时计算将会使用该数组顺序，故该值需保持时序。
var ACTION_TAGS = ['receive', 'parse', 'decode', 'play'];
var ACTION_STATUS_TAGS = {
  start: 'start',
  end: 'end',
  message: 'message'
};
var TRACE_ID_MAX_NUM = 10000;
var DelayAnalysis = /*#__PURE__*/function () {
  function DelayAnalysis() {
    var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
    _classCallCheck(this, DelayAnalysis);
    this.tags = tags;
    this.size = size;
    this.recordCache = [];
    this.traceIds = {};
  }
  return _createClass(DelayAnalysis, [{
    key: "allocTraceId",
    value: function allocTraceId() {
      return TRACE_ID_PREFIX + Date.now();
    }

    // 缓存traceId。存取间按顺序处理数据包且不便于带入traceId 参数的情况下，可根据先进先出原则存取traceId
  }, {
    key: "cacheTraceId",
    value: function cacheTraceId(type, traceId) {
      if (!this.traceIds[type]) {
        this.traceIds[type] = [];
      } else if (this.traceIds[type].length >= TRACE_ID_MAX_NUM) {
        this.traceIds[type].shift();
      }
      this.traceIds[type].push(traceId || '');
    }
  }, {
    key: "shiftTraceId",
    value: function shiftTraceId(type) {
      if (!this.traceIds[type]) {
        return 0;
      }
      return this.traceIds[type].shift();
    }

    // 收集打点数据。tags至少包含ACTION_TAGS 和ACTION_STATUS_TAGS 的成员
  }, {
    key: "record",
    value: function record(tags, message, timestamp) {
      /*global __IS_DEBUG__*/
      if (true) {
        return;
      }
      var now = timestamp || performance && performance.now();
      this.cache(tags, message, now);
    }
  }, {
    key: "cache",
    value: function cache(tags, message, timestamp) {
      if (this.recordCache.length >= this.size) {
        this.recordCache.shift();
      }
      this.recordCache.push({
        timestamp: timestamp,
        tags: tags,
        message: message
      });
    }

    /**
     * 原始打点数据按照traceId归类处理
     * @returns {object} traces: {traceId1: {id: traceId1, tag1: timestamp1, tag2: timestamp2...}, traceId2...};
     * sortTags: tag列表，打印traces信息是可以作为表头
     **/
  }, {
    key: "trace",
    value: function trace() {
      var traces = {};
      var sortTags = [];
      this.recordCache.forEach(function (item) {
        var tags = item.tags || [];
        var traceId = tags.find && tags.find(function (tag) {
          return tag.startsWith(TRACE_ID_PREFIX);
        });
        var isMsg = tags.includes && tags.includes('message');
        var name = tags.filter && tags.filter(function (tag) {
          return !tag.startsWith('trace_');
        }).join('|');
        if (traceId) {
          !traces[traceId] && (traces[traceId] = {
            id: traceId
          });
          traces[traceId][name] = isMsg ? item.message : item.timestamp;
          if (!sortTags.includes(name)) {
            sortTags.push(name);
          }
        }
      });
      return {
        traces: traces,
        sortTags: sortTags
      };
    }

    /**
     * 原始数据基础上计算出traceId各阶段耗时
     * @returns {object} traces: 增加了tag间耗时信息的traces；sortTags: tag列表，打印traces信息是可以作为表头
     **/
  }, {
    key: "analysis",
    value: function analysis() {
      var data = this.trace();
      var traces = data.traces;
      var sortTags = ['id'];
      var hasSortTags = false;
      Object.keys(traces).forEach(function (id) {
        var trace = traces[id];
        var tags = Object.keys(trace);
        var preTrace = null;
        // 按照ACTION_TAGS的顺序计算阶段性耗时
        ACTION_TAGS.forEach(function (action) {
          var startTag = tags.find(function (tag) {
            return tag.indexOf(action) > -1 && tag.indexOf(ACTION_STATUS_TAGS.start) > -1;
          });
          var endTag = tags.find(function (tag) {
            return tag.indexOf(action) > -1 && tag.indexOf(ACTION_STATUS_TAGS.end) > -1;
          });
          var msgTags = tags.filter(function (tag) {
            return tag.indexOf(action) > -1 && tag.indexOf(ACTION_STATUS_TAGS.message) > -1;
          });
          if (preTrace && (startTag || endTag)) {
            var firstTag = startTag || endTag;
            var newTag = firstTag + DELAY_CONNECTOR + preTrace.tag;
            !hasSortTags && sortTags.push(newTag);
            trace[newTag] = (trace[firstTag] - preTrace.timestamp).toFixed(3);
          }
          !hasSortTags && startTag && sortTags.push(startTag);
          if (startTag && endTag) {
            !hasSortTags && sortTags.push(endTag + DELAY_CONNECTOR + startTag);
            trace[endTag + DELAY_CONNECTOR + startTag] = (trace[endTag] - trace[startTag]).toFixed(3);
          }
          var lastTag = endTag || startTag;
          lastTag && (preTrace = {
            tag: lastTag,
            timestamp: trace[lastTag]
          });
          if (!hasSortTags) {
            endTag && sortTags.push(endTag);
            msgTags.forEach(function (item) {
              return sortTags.push(item);
            });
          }
        });
        preTrace = null;
        // 认为每个traceId所有的tag名称是一样
        hasSortTags = true;
      });
      return {
        traces: traces,
        sortTags: sortTags
      };
    }
  }, {
    key: "exportFile",
    value: function exportFile(needAnalysis) {
      var data = null;
      if (needAnalysis) {
        data = this.analysis();
      } else {
        data = this.trace();
      }
      var traces = data.traces;
      var sortTags = data.sortTags;
      var csvContent = sortTags.join(',') + '\n';
      Object.keys(traces).forEach(function (id) {
        var trace = traces[id];
        sortTags.forEach(function (tag) {
          csvContent += trace[tag] + ',';
        });
        csvContent += '\n';
      });
      var cvsData = new Blob([csvContent], {
        type: 'application/octet-stream'
      });
      var anchor = document.createElement('a');
      anchor.href = window.URL.createObjectURL(cvsData);
      anchor.download = "delay-analysis-".concat(Date.now(), ".csv");
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(cvsData);
    }
  }]);
}();
var delayAnalysis = new DelayAnalysis(ACTION_TAGS, 100000);
var _default = exports.default = delayAnalysis;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(367);
var validate = __webpack_require__(96);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(234)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(28).f;
var create = __webpack_require__(69);
var redefineAll = __webpack_require__(75);
var ctx = __webpack_require__(44);
var anInstance = __webpack_require__(76);
var forOf = __webpack_require__(101);
var $iterDefine = __webpack_require__(117);
var step = __webpack_require__(157);
var setSpecies = __webpack_require__(130);
var DESCRIPTORS = __webpack_require__(25);
var fastKey = __webpack_require__(87).fastKey;
var validate = __webpack_require__(96);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(14);
__webpack_require__(42);
__webpack_require__(13);
__webpack_require__(12);
__webpack_require__(15);
__webpack_require__(99);
__webpack_require__(74);
__webpack_require__(30);
__webpack_require__(33);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(21);
__webpack_require__(16);
__webpack_require__(17);
var _protocolConfig = _interopRequireDefault(__webpack_require__(32));
var _Util = _interopRequireDefault(__webpack_require__(26));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var KEYCODE_ENTER_NUMBER_ZONE = 108;
var KEYCODE_ENTER_CTRL_ZONE = 13;
var KeyboardInput = exports.default = /*#__PURE__*/function () {
  function KeyboardInput(keyboardInputContentId, containerId, msgHandler, isMobile) {
    _classCallCheck(this, KeyboardInput);
    this.keyboardInputContentId = keyboardInputContentId || 'keyboardInputContent';
    this.containerId = containerId;
    this.msgHandler = msgHandler;
    this.isMobile = isMobile;
    this.util = new _Util.default();
    this.inputContainer = null;
    this.touchHandler = null;
    this.cnStart = false;
    this.input = null;
    this.inputId = 'keyboardInput' + Date.now();
  }
  return _createClass(KeyboardInput, [{
    key: "init",
    value: function init() {
      var _this = this;
      var videoContainer = document.getElementById(this.containerId);
      if (!videoContainer) {
        return;
      }
      this.inputContainer = document.createElement('div');
      // this.inputContainer.id = 'keyboardInputContent';
      this.inputContainer.id = this.keyboardInputContentId;
      this.input = document.createElement('input');
      this.input.id = this.inputId;
      this.input.type = 'text';
      this.inputContainer.style.cssText = "\n            display: block;\n            position: absolute;\n            bottom: 5px;\n            left: 0px;\n            height: 0px;\n            width: 10px;\n            ";
      this.input.style.cssText = "\n            height: 0px;\n            width: 10px;\n            color: white;\n            background-color: rgb(37,43,58);\n            opacity: 0;\n            box-sizing: border-box;\n            ";
      if (!this.isMobile) {
        videoContainer.addEventListener('mouseup', function (event) {
          _this.onMouseUp(event);
        }, true);
      }
      this.util.bind(this.input, 'compositionstart', this.compositionstart.bind(this));
      this.util.bind(this.input, 'compositionend', this.compositionend.bind(this));
      this.util.bind(this.input, 'input', this.onInput.bind(this));
      this.util.bind(this.input, 'keydown', this.onKeydown.bind(this));
      this.inputContainer.appendChild(this.input);
      videoContainer.appendChild(this.inputContainer);
    }
  }, {
    key: "getTouchHandler",
    value: function getTouchHandler(touchHandler) {
      this.touchHandler = touchHandler;
    }
  }, {
    key: "start",
    value: function start() {
      this.inputContainer.style.display = 'block';
      this.input.focus();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.input.blur();
      this.inputContainer.style.display = 'none';
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      this.input.blur();
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp(event) {
      this.inputContainer.style.left = event.offsetX + 'px';
      this.inputContainer.style.top = event.offsetY + 'px';
    }
  }, {
    key: "compositionstart",
    value: function compositionstart() {
      this.cnStart = true;
    }
  }, {
    key: "compositionend",
    value: function compositionend() {
      this.cnStart = false;
      this.onInput();
    }

    // 粘贴内容到云手机
  }, {
    key: "pasteToCloud",
    value: function () {
      var _pasteToCloud = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var clipboardData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return navigator.clipboard.readText();
            case 2:
              clipboardData = _context.sent;
              this.sendClipboardData(clipboardData);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function pasteToCloud() {
        return _pasteToCloud.apply(this, arguments);
      }
      return pasteToCloud;
    }()
  }, {
    key: "onInput",
    value: function onInput() {
      if (!this.cnStart) {
        this.handleInputMsg(this.input.value, 'KEYBOARD_INPUT', _protocolConfig.default.KEYBOARD_INPUT_MSG_TYPE.IME_PASTE_FROM_PC_SDK);
      }
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      if (_protocolConfig.default.PC_INUPT_MAP[event.keyCode]) {
        this.touchHandler.sendKeyCodeEventMsg(_protocolConfig.default.KEYEVENT_KEYCODE_TYPE.ACTION_DOWN, _protocolConfig.default.PC_INUPT_MAP[event.keyCode]);
        this.touchHandler.sendKeyCodeEventMsg(_protocolConfig.default.KEYEVENT_KEYCODE_TYPE.ACTION_UP, _protocolConfig.default.PC_INUPT_MAP[event.keyCode]);
      }
    }
  }, {
    key: "handleInputMsg",
    value: function handleInputMsg(input, msgType, textType) {
      var PACKAGE_HEADER_LENGTH = 8;
      var INPUT_HEADER_LENGTH = 3;
      var msgData = this.util.encodeUTF8(input);
      var cmdBuf = new Uint8Array(PACKAGE_HEADER_LENGTH + INPUT_HEADER_LENGTH + msgData.length);
      cmdBuf[0] = 90;
      cmdBuf[1] = 90;
      cmdBuf[2] = 180 + _protocolConfig.default.MSG_TYPE[msgType];
      cmdBuf[3] = _protocolConfig.default.MSG_TYPE[msgType];
      cmdBuf[4] = INPUT_HEADER_LENGTH + msgData.length >> 24;
      cmdBuf[5] = INPUT_HEADER_LENGTH + msgData.length >> 16;
      cmdBuf[6] = INPUT_HEADER_LENGTH + msgData.length >> 8;
      cmdBuf[7] = INPUT_HEADER_LENGTH + msgData.length;
      cmdBuf[8] = textType;
      cmdBuf[9] = msgData.length >> 8;
      cmdBuf[10] = msgData.length;
      cmdBuf.set(msgData, PACKAGE_HEADER_LENGTH + INPUT_HEADER_LENGTH);
      this.msgHandler(cmdBuf.buffer);
      this.input.value = '';
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.util.unbind(this.input, 'input');
      this.util.unbind(this.input, 'keyup');
      this.util.unbind(this.input, 'keydown');
      this.util.unbind(this.input, 'compositionstart');
      this.util.unbind(this.input, 'compositionend');
      this.inputContainer.remove();
      this.inputContainer = null;
    }
  }, {
    key: "sendClipboardData",
    value: function sendClipboardData(clipboardData) {
      if (!this.isMobile) {
        return;
      }
      var sendMsgCode = _protocolConfig.default.KEYBOARD_INPUT_MSG_TYPE.IME_PASTE_FROM_SDK;
      this.handleInputMsg(clipboardData, 'KEYBOARD_INPUT', sendMsgCode);
    }
  }]);
}();

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionCreate = sessionCreate;
exports.sessionRefresh = sessionRefresh;
var _axios = _interopRequireDefault(__webpack_require__(382));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BASE_URI = '/phonemanager-api';

/**
 * 创建会话
 * @param String authUri
 * @param String accessKey
 * @param String secretKey
 * @param Number expireTime 有效事件/分钟
 */
function sessionCreate(options) {
  var authUri = options.authUri || BASE_URI;
  return (0, _axios.default)({
    url: "".concat(authUri, "/cloudPhone/sessionCreate"),
    method: 'post',
    data: {
      phoneIdList: options.phoneIdList,
      accessKey: options.accessKey,
      secretKey: options.secretKey,
      expireTime: options.expireTime || 30
    }
  }).then(function (res) {
    return res.data;
  });
}

/**
 * 刷新session
 * @param String authUri
 * @param Array addPhoneIdList
 * @param Array delPhoneIdList
 * @param Number expireTime 有效时间/分钟
 */
function sessionRefresh(options) {
  var authUri = options.authUri || BASE_URI;
  return (0, _axios.default)({
    url: "".concat(authUri, "/cloudPhone/sessionRefresh"),
    method: 'post',
    headers: {
      serverToken: options.serverToken
    },
    data: {
      addPhoneIdList: options.addPhoneIdList || [],
      delPhoneIdList: options.delPhoneIdList || [],
      expireTime: options.expireTime !== undefined ? options.expireTime : 30
    }
  }).then(function (res) {
    return res.data;
  });
}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);
__webpack_require__(12);
__webpack_require__(15);
__webpack_require__(30);
__webpack_require__(77);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(107);
__webpack_require__(56);
__webpack_require__(46);
__webpack_require__(14);
__webpack_require__(78);
__webpack_require__(21);
__webpack_require__(33);
__webpack_require__(16);
__webpack_require__(17);
var _jmuxer = _interopRequireDefault(__webpack_require__(176));
var _TouchHandler = _interopRequireDefault(__webpack_require__(233));
var _KeyboardListener = _interopRequireDefault(__webpack_require__(236));
var _CanvasPlayer = _interopRequireDefault(__webpack_require__(229));
var _DeviceHardwareHandler = _interopRequireDefault(__webpack_require__(371));
var _DirectionHandler = _interopRequireDefault(__webpack_require__(235));
var _AutoRotation = _interopRequireDefault(__webpack_require__(228));
var _protocolConfig = _interopRequireDefault(__webpack_require__(32));
var _AudioPlayer = _interopRequireDefault(__webpack_require__(221));
var _canvasWhiteList = _interopRequireDefault(__webpack_require__(231));
var _Util = _interopRequireDefault(__webpack_require__(26));
var _nodeServerConfig = __webpack_require__(106);
var _commonConfig = __webpack_require__(51);
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var keyEventCodeType = _protocolConfig.default.KEYEVENT_KEYCODE_TYPE;
var DEFAULT_ORIENTATION = 'PORTRAIT';
var K_BIT_UNIT = 8000;
/**
 * 声明云手机视图操作实例
 * @param String options.containerId - 渲染云手机画面的节点Id
 * @param String options.phoneId - 云手机Id
 * @param String options.libPath - 存放wasm文件的目录路径
 * @param Boolean options.isMSE - 播放方式(true为视频播放器,false为canvas)
 * @param Object options.topSubscribe - 事件监听器
 * @param function options.send - 发送消息到云手机函数
 */
var CloudView = exports.default = /*#__PURE__*/function () {
  function CloudView(options) {
    _classCallCheck(this, CloudView);
    this.options = options;
    this.isMobile = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
    this.isMSE = options.isMSE !== void 0 ? options.isMSE : !this.isMobile;
    this.isMSE = this.isMSEMode(_commonConfig.FRAME_TYPE_MAP.TYPE264);
    //console.log("isMSE",this.isMSE)
    this.firstIFrame = true;
    this.util = new _Util.default();
    this.currentVisible = 'visibility';
    // 网络时延/码率
    this.networkInfo = {
      heartBeatSendTimes: [],
      clientDelayTimes: [],
      //客户端时延
      sendTimesMaxCount: 4,
      delay: 0,
      bitRate: 0,
      kbitCount: 0,
      lastRefreshTime: 0
    };
    this.lastReceivingTime = null;
  }
  return _createClass(CloudView, [{
    key: "isMSEMode",
    value: function isMSEMode() {
      var frameType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _commonConfig.FRAME_TYPE_MAP.TYPE265;
      // 使用 MSE 前提：
      // (1) 支持 MediaSource
      // (2) 支持 avc1.42c020 编码
      // (3) 不在 canvas 白名单
      // 前两条判断包含在 JMuxer.isSupported 方法中
      var isMSE = true;
      if (frameType === _commonConfig.FRAME_TYPE_MAP.TYPE264) {
        isMSE = Boolean(_jmuxer.default.isSupported('video/mp4; codecs="avc1.42c020"')) && !this.isCanvasPriority();
      } else {
        isMSE = Boolean(_jmuxer.default.isSupported('video/mp4; codecs="hev1"')) && !this.isCanvasPriority();
      }

      /*global __IS_DEBUG__*/
      if (false) { var framework; }
      return isMSE;
    }
  }, {
    key: "isCanvasPriority",
    value: function isCanvasPriority() {
      // UA 判断
      var userAgent = navigator && navigator.userAgent || '';
      var isMatchUA = Object.values(_canvasWhiteList.default).some(function (condition) {
        return userAgent.includes(condition);
      });

      // oppo 浏览器 UA 特征不明显，通过 window 对象属性进行判断
      var isOppoBrowser = Boolean(window.OppoWebPage || window.OppoFlow || window.oppoErrorPage || window.oppoUrlQuery);
      return isMatchUA || isOppoBrowser;
    }
    // 初始化播放器
  }, {
    key: "initPlayer",
    value: function initPlayer() {
      // 根据屏幕宽高确定视频方向
      if (this.isMSE) {
        var videoEle = document.createElement('video');
        this.videoEleId = "video-".concat(new Date().getTime().toString(36));
        videoEle.id = this.videoEleId;
        videoEle.muted = true;
        videoEle.playsinline = true;
        videoEle.autoplay = true;
        videoEle.controls = false;
        this.player = videoEle;
      } else {
        this.avc = new _CanvasPlayer.default(this.options);
        this.player = this.avc.canvas;
      }
      this.audioPlayer = new _AudioPlayer.default({
        channels: 2,
        videoPlayer: this.player,
        volume: this.options.volume
      });
      if (this.isMSE) {
        if (!this.options.keepRatio) {
          this.player.style.setProperty('width', '100%', 'important');
          this.player.style.setProperty('height', '100%', 'important');
        } else {
          if (this.options.isMobile) {
            this.player.style.setProperty('width', '100%', 'important');
            this.player.style.setProperty('height', '100%', 'important');
            // 解决画布居中问题
            this.player.style.setProperty('margin', 'auto', 'important');
          } else {
            this.player.style.setProperty('width', '100%', 'important');
          }
        }
        // 硬解时video标签会按比例填充视频，避免视频被裁减设置contain显示完整画面
        this.player.style.setProperty('object-fit', 'contain', 'important');
      } else {
        this.player.style.setProperty('height', "100%", 'important');
        this.player.style.setProperty('width', "100%", 'important');
        // 手机端由fill改成contain
        this.player.style.setProperty('object-fit', 'contain', 'important');
        // 解决画布居中问题
        this.player.style.setProperty('margin', '0 auto', 'important');
      }

      // 有些手机是硬解场景，将画面覆盖整个video容器，避免出现黑边
      if (this.isMSE && this.options.isMobile && !this.options.keepRatio) {
        this.player.style.setProperty('object-fit', 'fill', 'important');
      }

      // 解决真机键盘弹起后，浏览器可视窗变小，video高度很小而导致video停止播放，时延增加的问题。
      this.player.style.setProperty('min-height', '60px', 'important');
      // H5 场景下 video、canvas 的 display 属性默认值为 inline，需要主动设置为 block，以避免底部留边问题
      this.player.style.setProperty('display', 'block', 'important');
      // 去除outline,<video> 元素，它默认是可聚焦的（tabindex 可能被设置）浏览器会自动给<video>添加focus,focus-visible 样式会添加一个outline边框
      this.player.style.setProperty('outline', 'none', 'important');
      // 用户提供的容器
      var videoContainer = document.getElementById(this.options.containerId);

      // 创建player的容器
      var playerContainerDom = document.createElement('article');
      this.playerContainerId = "J-".concat(new Date().getTime().toString(36));
      playerContainerDom.id = this.playerContainerId;
      playerContainerDom.style.cssText = "\n      height: 100%;\n      width: 100%;\n      display: flex;\n    ";

      // 是否支持 shadow dom
      var isSupportShadowDom = typeof document.body.attachShadow === 'function';
      if (videoContainer) {
        videoContainer.style.position = 'relative';
        // if (isSupportShadowDom) {
        //   // 支持 shadow dom
        //   const appContainerShadowRoot = playerContainerDom.attachShadow({
        //     mode: 'open'
        //   })
        //   const style = document.createElement('style')
        //   // 重置shadow dom root元素继承的样式
        //   style.textContent = `
        //     :host {
        //         all: initial;
        //     }
        //   `
        //   appContainerShadowRoot.appendChild(style)
        //   appContainerShadowRoot.appendChild(this.player)
        // } else {
        playerContainerDom.appendChild(this.player);
        // }

        videoContainer.appendChild(playerContainerDom);
      }
      this.player.tabIndex = '1';
      if (this.isMSE) {
        this.jmuxer = new _jmuxer.default({
          node: isSupportShadowDom ? this.player : this.videoEleId,
          mode: 'video',
          flushingTime: 1,
          fps: 60,
          debug: false,
          clearBuffer: true
        });
        this.play = this.__msePlay;
        this._toLastest();
      } else {
        this.play = this.__canvasPlay;
      }
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.options.volume;
    }
  }, {
    key: "setVolume",
    value: function setVolume(value) {
      // audioPlayer 不存在时通过 options 的 volume 属性暂存 volume 的值]
      this.options.volume = value;
      if (this.audioPlayer) {
        this.audioPlayer.setVolume(value);
      }
    }
    // 刷新触控
  }, {
    key: "refreshTouch",
    value: function refreshTouch() {
      this.touchHandler.resize();
    }
    // 启用传感器
  }, {
    key: "handleSensorEnable",
    value: function handleSensorEnable() {
      // 启用传感器
      if (window.DeviceMotionEvent) {
        this.deviceHardwareHandler.handleSensorEnable(_protocolConfig.default.SENSOR_MESSAGE_TYPE.TYPE_ACCELEROMETER);
      }
      if (window.DeviceOrientationEvent) {
        this.deviceHardwareHandler.handleSensorEnable(_protocolConfig.default.SENSOR_MESSAGE_TYPE.TYPE_GYROSCOPE);
      }
    }

    //停用传感器
  }, {
    key: "handleSensorDisable",
    value: function handleSensorDisable() {
      // 停用传感器
      this.deviceHardwareHandler.handleSensorDisable(_protocolConfig.default.SENSOR_MESSAGE_TYPE.TYPE_ACCELEROMETER);
      this.deviceHardwareHandler.handleSensorDisable(_protocolConfig.default.SENSOR_MESSAGE_TYPE.TYPE_GYROSCOPE);
    }
  }, {
    key: "sendShakeData",
    value: function sendShakeData(data) {
      // 加速度数据
      this.sendAccelerometerData(data.accelerometer);
      // 陀螺仪数据
      this.sendGyroscopeData(data.gyroscope);
    }

    // 发送加速度
  }, {
    key: "sendAccelerometerData",
    value: function sendAccelerometerData(data) {
      var accuracy = 3;
      // 加速度传感器 TYPE_ACCELEROMETER
      this.sensorDevId = 0;
      var x = data.x || 0.111;
      var y = data.y || 0.111;
      var z = data.z || 0.111;
      if (x && y && z) {
        var body = x.toString() + ':' + y.toString() + ':' + z.toString() + ':' + accuracy.toString() + ':';
        var strEncoder = new TextEncoder();
        var _data = strEncoder.encode(body);
        this.deviceHardwareHandler.sendMediaData('SENSOR', _protocolConfig.default.SENSOR_MESSAGE_TYPE.OPT_SENSOR_DATA, _data, _protocolConfig.default.SENSOR_MESSAGE_TYPE.TYPE_ACCELEROMETER);
      }
    }

    // 发送陀螺仪
  }, {
    key: "sendGyroscopeData",
    value: function sendGyroscopeData(data) {
      var accuracy = 3;
      // 陀螺仪传感器 TYPE_GYROSCOPE
      this.sensorDevId = 1;
      var x = data.x || 0.111;
      var y = data.y || 0.111;
      var z = data.z || 0.111;
      if (x && y && z) {
        var body = x.toString() + ':' + y.toString() + ':' + z.toString() + ':' + accuracy.toString() + ':';
        var strEncoder = new TextEncoder();
        var _data2 = strEncoder.encode(body);
        this.deviceHardwareHandler.sendMediaData('SENSOR', _protocolConfig.default.SENSOR_MESSAGE_TYPE.OPT_SENSOR_DATA, _data2, _protocolConfig.default.SENSOR_MESSAGE_TYPE.TYPE_GYROSCOPE);
      }
    }
  }, {
    key: "sensorProcessResp",
    value: function sensorProcessResp(pkg) {
      if (!pkg) {
        return;
      }
      return;
      var buf = new Uint8Array(pkg);
      this.sensorMsgHeader = this.deviceHardwareHandler.getMsgHeader(buf);
      var type = this.sensorMsgHeader.optType;
      switch (type) {
        case _protocolConfig.default.SENSOR_MESSAGE_TYPE.OPT_SENSOR_ENABLE_RSP:
          // 开启传感器监听并获取数据
          this.util.bind(window, 'devicemotion', this.deviceHardwareHandler.getDeviceMotion.bind(this.deviceHardwareHandler));
          this.util.bind(window, 'deviceorientation', this.deviceHardwareHandler.getDeviceOrientation.bind(this.deviceHardwareHandler));
          break;
        case _protocolConfig.default.SENSOR_MESSAGE_TYPE.OPT_SENSOR_DISABLE_RSP:
          console.log('停止接收传感器数据type===' + type);
          // 取消监听停止发送数据
          this.util.unbind(window, 'devicemotion');
          this.util.unbind(window, 'deviceorientation');
          break;
        default:
          break;
      }
    }
  }, {
    key: "microPhoneProcessResp",
    value: function microPhoneProcessResp(pkg) {
      if (!pkg) {
        return;
      }
      var buf = new Uint8Array(pkg);
      this.microPhoneMsgHeader = this.deviceHardwareHandler.getMsgHeader(buf);
      if (buf.length > _commonConfig.MEDIA_MSG_HEADER_COUNT) {
        this.microPhoneMsgBody = this.deviceHardwareHandler.getMsgBody(buf.slice(_commonConfig.MEDIA_MSG_HEADER_COUNT), 'MICROPHONE');
      }
      var type = this.microPhoneMsgHeader.optType;
      switch (type) {
        case _protocolConfig.default.MICROPHONE_MESSAGE_TYPE.OPT_MIC_SET_PARAM_REQ:
          this.deviceHardwareHandler.handleSetRecordParam(this.microPhoneMsgHeader);
          break;
        case _protocolConfig.default.MICROPHONE_MESSAGE_TYPE.OPT_MIC_START_RECORD_REQ:
          this.deviceHardwareHandler.handleStartRecordReq(this.microPhoneMsgBody);
          break;
        case _protocolConfig.default.MICROPHONE_MESSAGE_TYPE.OPT_MIC_STOP_RECOED_REQ:
          this.deviceHardwareHandler.handleStopRecordReq();
          break;
        default:
          break;
      }
    }
    // 时延处理
  }, {
    key: "heartBeatPkgResp",
    value: function heartBeatPkgResp(pkg, time) {
      this.lastReceivingTime = time;
      if (this.networkInfo.heartBeatSendTimes.length > 0) {
        this.networkInfo.delay = this.lastReceivingTime - this.networkInfo.heartBeatSendTimes.shift();
      }
      if (this.lastReceivingTime !== this.networkInfo.lastRefreshTime) {
        this.networkInfo.bitRate = Math.round(this.networkInfo.kbitCount * K_BIT_UNIT / (this.lastReceivingTime - this.networkInfo.lastRefreshTime));
        this.networkInfo.lastRefreshTime = this.lastReceivingTime;
        this.networkInfo.kbitCount = 0;
      }
      // node转发才要计算客户端时延，直连不需要
      if (this.options.linkMethod == _nodeServerConfig.LINK_METHOD.NODE) {
        if (this.networkInfo.clientDelayTimes.length > 0) {
          this.options.topSubscribe.trigger('netStateChange', {
            delay: this.networkInfo.delay + this.networkInfo.clientDelayTimes.shift(),
            bitrate: this.networkInfo.bitRate
          });
        }
      } else {
        this.options.topSubscribe.trigger('netStateChange', {
          delay: this.networkInfo.delay,
          bitrate: this.networkInfo.bitRate
        });
      }
    }
    // 云手机复制回调
  }, {
    key: "keyboardInputPkgResp",
    value: function keyboardInputPkgResp(pkg) {
      if ((pkg === null || pkg === void 0 ? void 0 : pkg.length) < _protocolConfig.default.KEYBOARD_INPUT_HEADER_LENGTH) {
        return;
      }
      var _pkg = _slicedToArray(pkg, 3),
        type = _pkg[0],
        highBytesSize = _pkg[1],
        lowByteSize = _pkg[2];
      if (type === _protocolConfig.default.KEYBOARD_INPUT_MSG_TYPE.IME_PASTE_TO_SDK) {
        var len = (highBytesSize << 8) + lowByteSize;
        var input = len > 0 ? this.util.decodeUTF8(pkg, _protocolConfig.default.KEYBOARD_INPUT_HEADER_LENGTH, _protocolConfig.default.KEYBOARD_INPUT_HEADER_LENGTH + len) : '';
        this.options.topSubscribe.trigger('clipboardDataChange', input);
      }
    }
    // 服务端心跳包响应
  }, {
    key: "heartBeatReps",
    value: function heartBeatReps(time) {
      if (this.networkInfo.heartBeatSendTimes.length <= this.networkInfo.sendTimesMaxCount) {
        this.networkInfo.heartBeatSendTimes.push(time);
      }
    }

    // 客户端时延
  }, {
    key: "clientDelayReps",
    value: function clientDelayReps(time) {
      if (this.networkInfo.clientDelayTimes.length <= this.networkInfo.sendTimesMaxCount) {
        this.networkInfo.clientDelayTimes.push(time);
      }
    }

    // 绑定动作
  }, {
    key: "bindAction",
    value: function bindAction() {
      var _this = this;
      if (!this.touchHandler) {
        this.touchHandler = new _TouchHandler.default({
          player: this.player,
          isMobile: this.isMobile,
          sendHandler: this.options.send,
          autoRotate: this.options.autoRotate,
          containerId: this.options.containerId,
          keepRatio: this.options.keepRatio,
          touchCb: function touchCb() {
            _this.options.topSubscribe.trigger('touchstart');
            _this.player.focus();
          }
        });
        this.touchHandler.start();
      }
      if (!this.keyboardListener) {
        this.keyboardListener = new _KeyboardListener.default('', this.options.send);
        this.keyboardListener.input = this.player;
        // 传递subscribe实例给KeyboardListener
        this.keyboardListener.subscribe = this.options.topSubscribe;
        this.keyboardListener.start(this.touchHandler);
      }
      if (!this.deviceHardwareHandler) {
        this.deviceHardwareHandler = new _DeviceHardwareHandler.default({
          libPath: this.options.libPath,
          microPhoneOutputType: this.options.microPhoneOutputType,
          send: this.options.send
        });
      }
      // 启用传感器
      if (window.DeviceMotionEvent) {
        this.deviceHardwareHandler.handleSensorEnable(_protocolConfig.default.SENSOR_MESSAGE_TYPE.TYPE_ACCELEROMETER);
      }
      if (window.DeviceOrientationEvent) {
        this.deviceHardwareHandler.handleSensorEnable(_protocolConfig.default.SENSOR_MESSAGE_TYPE.TYPE_GYROSCOPE);
      }
      this.directionHandler = new _DirectionHandler.default({
        // 画面旋转
        containerId: this.options.containerId,
        keepRatio: this.options.keepRatio,
        isMobile: this.options.isMobile,
        playerContainerId: this.playerContainerId,
        touchHandler: this.touchHandler
      });
      this.directionHandler.init();
      //console.log(this.directionHandler)
      this.autoRotation = new _AutoRotation.default(this.options.containerId, DEFAULT_ORIENTATION, this.options.isMobile, this.options.keepRatio,
      // eslint-disable-next-line no-unused-vars
      function (rotateDegrees) {
        // 旋转后更新触控，并根据旋转角度判断使用云机键盘还是真机键盘
        _this.touchHandler.resize();
      });
      this.autoRotation.init();
      this.updateResolutionAndTouch(DEFAULT_ORIENTATION);
      this._listenPlayerSizeChange();
      this._listenPageVisibility();
    }

    // 监听播放器大小变化
  }, {
    key: "_listenPlayerSizeChange",
    value: function _listenPlayerSizeChange() {
      var _this2 = this;
      if (this.isMSE) {
        // 视频元信息加载完成后，主动触发 resize 事件更新相关坐标位置
        this.loadedmetadataCallback = function () {
          // this.touchHandler.resize()
          // 使用完毕移除事件监听
          _this2.player.removeEventListener('loadedmetadata', _this2.loadedmetadataCallback);
          _this2.loadedmetadataCallback = null;
        };
        this.player.addEventListener('loadedmetadata', this.loadedmetadataCallback);

        // video 大小变化时需要持续更新坐标位置
        this.videoResizeCallback = function () {
          _this2.touchHandler.resize();
        };
        this.player.addEventListener('resize', this.videoResizeCallback);
      } else {
        // 监听 canvas 大小变化
        var MutationObserver = window.MutationObserver;
        this.canvasObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'width' || mutation.attributeName === 'height') {
              _this2.touchHandler.resize();
            }
          });
        });
        this.canvasObserver.observe(this.player, {
          attributes: true
        });
      }
    }

    // 跳转到最新帧
  }, {
    key: "_toLastest",
    value: function _toLastest() {
      var video = this.player;
      var _action = function action() {
        if (video.buffered && video.buffered.length && video.buffered.end(0)) {
          video.currentTime = video.buffered.end(0);
        }
        video.removeEventListener('canplaythrough', _action);
      };
      video.addEventListener('canplaythrough', _action);
    }

    /**
     * video视频播放(PC端)
     * @param {*} frame
     * @returns
     */
  }, {
    key: "__msePlay",
    value: function __msePlay(frame) {
      if (!this.jmuxer) return;
      if (this.firstIFrame) {
        this.options.topSubscribe.trigger('requestIFrame', {
          phoneId: this.options.phoneId
        });
        this.firstIFrame = false;
        return;
      }
      var bufTail = new Uint8Array([0x00, 0x00, 0x01, 0x1d, 0x00, 0x00, 0x01, 0x1e, 0x48, 0x53, 0x50, 0x49, 0x43, 0x45, 0x4e, 0x44]);
      var allDataBuf = new Uint8Array(frame.byteLength + bufTail.byteLength);
      allDataBuf.set(frame);
      allDataBuf.set(bufTail, frame.length);
      this.jmuxer.feed({
        video: allDataBuf,
        druation: 0
      });
      this.jmuxer.feed({
        video: bufTail,
        druation: 0
      });
      this.jmuxer.feed({
        video: bufTail,
        druation: 0
      });
    }

    /**
     * canvas播放(移动端)
     * @param {*} data
     */
  }, {
    key: "__canvasPlay",
    value: function __canvasPlay(data) {
      // console.log('data >>>')
      this.avc.decode(data);
    }
  }, {
    key: "updateResolutionAndTouch",
    value: function updateResolutionAndTouch(orientation) {
      this.orientation = orientation;
      if (this.player && this.orientation) {
        // resize之前更新canvas大小
        if (this.options.isMobile) {
          this.directionHandler.updateMobileCanvasSize(this.orientation, this.isMSE);
        } else {
          this.directionHandler.updateCanvasSize(this.orientation, this.isMSE);
        }
        this.autoRotation && this.autoRotation.updateOrientation(this.orientation, this.touchHandler.displayBox, this.directionHandler);
        this.touchHandler.updateOrientation(this.orientation);
      }
    }
    /**
     *
     * @param {*} keyCodeType
     */
  }, {
    key: "sendKeyCodeMsg",
    value: function sendKeyCodeMsg(keyCodeType) {
      this.touchHandler.sendKeyCodeEventMsg(keyEventCodeType.ACTION_DOWN, keyEventCodeType[keyCodeType]);
      this.touchHandler.sendKeyCodeEventMsg(keyEventCodeType.ACTION_UP, keyEventCodeType[keyCodeType]);
    }

    /**
     * 发送数据到用户输入框
     * @param {*} str 要发送的内容
     */
  }, {
    key: "sendInputString",
    value: function sendInputString(str) {
      this.keyboardListener.sendClipboardData(str);
    }

    /**
     * 监听屏幕隐藏
     */
  }, {
    key: "_listenPageVisibility",
    value: function _listenPageVisibility() {
      var _this3 = this;
      var hidden;
      if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden';
        this.visibilityChange = 'visibilitychange';
      } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
        this.visibilityChange = 'msvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
        this.visibilityChange = 'webkitvisibilitychange';
      }
      this.handleVisibilityChange = function () {
        if (document[hidden] && _this3.currentVisible == 'visibility') {
          _this3.currentVisible = 'hidden';
        } else if (_this3.currentVisible == 'hidden') {
          _this3.currentVisible = 'visibility';
          if (_this3.isMSE && _this3.player.buffered && _this3.player.buffered.length && _this3.player.buffered.end(0)) {
            _this3.player.currentTime = _this3.player.buffered.end(0);
          }
        }
      };

      // 判断浏览器的支持情况
      if (typeof document[hidden] !== 'undefined') {
        document.addEventListener(this.visibilityChange, this.handleVisibilityChange, false);
      }
    }

    /**
     * 销毁
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.jmuxer && this.jmuxer.destroy();
      this.avc && this.avc.destroy();
      this.touchHandler && this.touchHandler.destroy();
      this.keyboardListener && this.keyboardListener.destroy();
      this.audioPlayer && this.audioPlayer.destroy();
      this.autoRotation && this.autoRotation.destroy();
      this.jmuxer = null;
      this.avc = null;
      this.touchHandler = null;
      this.keyboardListener = null;
      this.currentVisible = 'visibility';
      this.firstIFrame = true;
      // 销毁传感器
      this.deviceHardwareHandler && this.deviceHardwareHandler.handleSensorDisable(_protocolConfig.default.SENSOR_MESSAGE_TYPE.TYPE_ACCELEROMETER);
      this.deviceHardwareHandler && this.deviceHardwareHandler.handleSensorDisable(_protocolConfig.default.SENSOR_MESSAGE_TYPE.TYPE_GYROSCOPE);
      this.deviceHardwareHandler = null;
      document.removeEventListener(this.visibilityChange, this.handleVisibilityChange);
    }
  }]);
}();

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);
__webpack_require__(31);
__webpack_require__(48);
__webpack_require__(49);
__webpack_require__(13);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(14);
__webpack_require__(78);
__webpack_require__(21);
__webpack_require__(16);
__webpack_require__(17);
var _Util = _interopRequireDefault(__webpack_require__(26));
var _CameraPlayer = _interopRequireDefault(__webpack_require__(372));
var _MicrophonePlayer = _interopRequireDefault(__webpack_require__(380));
var _commonConfig = __webpack_require__(51);
var _protocolConfig = _interopRequireDefault(__webpack_require__(32));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var timeout;
var CAE_STREAM_DELIMITER_MAGICWORD = 0x5a5a;
var DeviceHardwareHandler = /*#__PURE__*/function () {
  function DeviceHardwareHandler(options) {
    _classCallCheck(this, DeviceHardwareHandler);
    this.options = _objectSpread({}, options);
    // this.sendMediaData = this.options.sendMediaData
    // this.setMsgHeader = this.options.setMsgHeader
    this.send = this.options.send;
    this.util = new _Util.default();
    this.sensorMsgType = _protocolConfig.default.SENSOR_MESSAGE_TYPE;
    this.gpsLocationMsgType = _protocolConfig.default.GPS_LOCATION_MESSAGE_TYPE;
    this.microPhoneMsgType = _protocolConfig.default.MICROPHONE_MESSAGE_TYPE;
  }
  return _createClass(DeviceHardwareHandler, [{
    key: "handleStartPreviewReq",
    value: function handleStartPreviewReq(cameraMsgBody, cameraMsgHeader) {
      if (this.cameraPlayer) {
        return;
      }
      this.cameraMsgBody = cameraMsgBody;
      this.cameraMsgHeader = cameraMsgHeader;
      var originWidth = this.cameraMsgBody.width;
      var originHeight = this.cameraMsgBody.height;
      var videoOptions = {
        width: {
          ideal: originWidth
        },
        height: {
          ideal: originHeight
        },
        frameRate: {
          ideal: this.cameraMsgBody.fps
        }
      };
      if (originWidth > _commonConfig.PC_CAMERA_MAX_HEIGHT && !this.options.isMobile) {
        var cameraWidth = originHeight * _commonConfig.PC_CAMERA_MAX_HEIGHT / originWidth;
        cameraWidth = this.util.changeToMultipleOfEight(cameraWidth);
        videoOptions.width.ideal = cameraWidth;
        videoOptions.height.ideal = _commonConfig.PC_CAMERA_MAX_HEIGHT;
      }
      if (this.defaultCameraId) {
        videoOptions.deviceId = {
          exact: this.defaultCameraId
        };
      } else if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
        // this.options.isMobile
        videoOptions.facingMode = {
          exact: _commonConfig.MOBILE_CAMERA_MODE_MAP[cameraMsgHeader.devId]
        };
      }
      this.cameraPlayer = new _CameraPlayer.default({
        videoOptions: videoOptions,
        encodeWidth: this.cameraMsgBody.width,
        encodeHeight: this.cameraMsgBody.height,
        sendOutBufHandler: this.sendMediaData.bind(this),
        x264WasmPath: this.options.libPath,
        devId: cameraMsgHeader.devId
      });
    }
  }, {
    key: "setDefaultCamera",
    value: function setDefaultCamera(devId) {
      this.defaultCameraId = devId;
    }
  }, {
    key: "handleStopPreviewReq",
    value: function handleStopPreviewReq(cameraMsgHeader) {
      this.cameraMsgHeader = cameraMsgHeader;
      this.sendMediaMsgCmdData(_commonConfig.CAMERA_RSP_LEN, _protocolConfig.default.CAMERA_MESSAGE_TYPE.OPT_CAMERA_STOP_PREVIEW_RSP, 'CAMERA');
      if (this.cameraPlayer) {
        this.cameraPlayer.stopCameraVideo();
        this.cameraPlayer = null;
      }
    }
  }, {
    key: "handleSetRecordParam",
    value: function handleSetRecordParam(microPhoneMsgHeader) {
      this.microPhoneMsgHeader = microPhoneMsgHeader;
      this.sendMediaMsgCmdData(_commonConfig.MICROPHONE_RSP_LEN, _protocolConfig.default.MICROPHONE_MESSAGE_TYPE.OPT_MIC_SET_PARAM_RSP, 'MICROPHONE');
    }
  }, {
    key: "handleStartRecordReq",
    value: function handleStartRecordReq(microPhoneMsgBody) {
      var _this = this,
        _this$microPhoneMsgBo;
      if (this.microphonePlayer) {
        return;
      }
      this.microPhoneMsgBody = microPhoneMsgBody;
      this.sendMediaMsgCmdData(_commonConfig.MIC_START_RECORD_RSP_LEN, this.microPhoneMsgType.OPT_MIC_START_RECORD_RSP, 'MICROPHONE');
      var sendMediaDataHandler = function sendMediaDataHandler(mediaType, msgType, data) {
        var sensorId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        _this.sendMediaData(mediaType, msgType, data, sensorId);
      };
      this.microphonePlayer = new _MicrophonePlayer.default({
        audioOptions: {
          sampleRate: 48000,
          channelCount: 1,
          maxFrameSize: ((_this$microPhoneMsgBo = this.microPhoneMsgBody) === null || _this$microPhoneMsgBo === void 0 ? void 0 : _this$microPhoneMsgBo.maxFrameSize) || 7680
        },
        sendOutBufHandler: sendMediaDataHandler,
        microPhoneOutputType: this.options.microPhoneOutputType
      });
    }
  }, {
    key: "handleStopRecordReq",
    value: function handleStopRecordReq() {
      this.sendMediaMsgCmdData(_commonConfig.MICROPHONE_RSP_LEN, this.microPhoneMsgType.OPT_MIC_STOP_RECOED_RSP, 'MICROPHONE');
      if (this.microphonePlayer) {
        this.microphonePlayer.stopAudio();
        this.microphonePlayer = null;
      }
    }
  }, {
    key: "handleSensorEnable",
    value: function handleSensorEnable(devId) {
      this.sendSensorMsgData(this.sensorMsgType.OPT_SENDOR_ENABLE_REQ, devId);
    }
  }, {
    key: "handleSensorDisable",
    value: function handleSensorDisable(devId) {
      if (window.DeviceMotionEvent) {
        this.util.unbind(window, 'devicemotion');
      }
      if (window.DeviceOrientationEvent) {
        this.util.unbind(window, 'deviceorientation');
      }
      this.sendSensorMsgData(this.sensorMsgType.OPT_SENSOR_DISABLE_REQ, devId);
    }
  }, {
    key: "pauseDevice",
    value: function pauseDevice() {
      if (this.cameraPlayer) {
        this.cameraPlayer.stopCameraVideo();
        this.cameraPlayer = null;
      }
      if (this.microphonePlayer) {
        this.microphonePlayer.stopAudio();
        this.microphonePlayer = null;
      }
      if (window.DeviceMotionEvent) {
        this.util.unbind(window, 'devicemotion');
      }
      if (window.DeviceOrientationEvent) {
        this.util.unbind(window, 'deviceorientation');
      }
    }
  }, {
    key: "resumeDevice",
    value: function resumeDevice() {
      if (this.cameraPlayer) {
        this.handleStartPreviewReq(this.cameraMsgBody, this.cameraMsgHeader);
      }

      // 初始化麦克风传感器
      if (this.microphonePlayer) {
        this.handleStartRecordReq(this.microPhoneMsgBody);
      }
      if (window.DeviceMotionEvent) {
        this.util.bind(window, 'devicemotion', this.getDeviceMotion.bind(this));
      }
      if (window.DeviceOrientationEvent) {
        this.util.bind(window, 'deviceorientation', this.getDeviceOrientation.bind(this));
      }
    }
  }, {
    key: "getDeviceMotion",
    value: function getDeviceMotion(event) {
      var accuracy = 3;
      // 加速度传感器 TYPE_ACCELEROMETER
      this.sensorDevId = 0;
      var acceleration = event.accelerationIncludingGravity;
      var x = acceleration.x || 0.111;
      var y = acceleration.y || 0.111;
      var z = acceleration.z || 0.111;
      if (x && y && z) {
        var body = x.toString() + ':' + y.toString() + ':' + z.toString() + ':' + accuracy.toString() + ':';
        var strEncoder = new TextEncoder();
        var data = strEncoder.encode(body);
        this.sendMediaData('SENSOR', _protocolConfig.default.SENSOR_MESSAGE_TYPE.OPT_SENSOR_DATA, data, _protocolConfig.default.SENSOR_MESSAGE_TYPE.TYPE_ACCELEROMETER);
      }
    }
  }, {
    key: "getDeviceOrientation",
    value: function getDeviceOrientation(event) {
      // 陀螺仪传感器 TYPE_GYROSCOPE
      var accuracy = 3;
      this.sensorDevId = 1;
      var x = event.beta || 0.123;
      var y = event.gamma || 0.123;
      var z = event.alpha || 0.123;
      if (x && y && z) {
        var body = x.toString() + ':' + y.toString() + ':' + z.toString() + ':' + accuracy.toString() + ':';
        var strEncoder = new TextEncoder();
        var data = strEncoder.encode(body);
        this.sendMediaData('SENSOR', this.sensorMsgType.OPT_SENSOR_DATA, data, this.sensorMsgType.TYPE_GYROSCOPE);
      }
    }
  }, {
    key: "getUserLocation",
    value: function getUserLocation() {
      if ('geolocation' in navigator) {
        var option = {
          enableHighAccuracy: true,
          timeout: Infinity,
          maximumAge: 0
        };
        // 监听获取实时位置信息
        this.watchID = navigator.geolocation.watchPosition(this.userLocationSuccess.bind(this), this.userLocationError.bind(this), option);
      } else {
        console.log('Your browser does not support location.');
      }
    }
  }, {
    key: "userLocationSuccess",
    value: function userLocationSuccess(position) {
      var coords = position.coords;
      var longitude = coords.longitude; // 经度
      var latitude = coords.latitude; // 纬度
      var altitude = coords.altitude; // 海拔
      var speed = coords.speed; // 每秒速度
      var bearing = coords.heading; // 以360度表示的方向

      var body = '';
      if (longitude) {
        body += "longitude=".concat(longitude, ":");
      }
      if (latitude) {
        body += "latitude=".concat(latitude, ":");
      }
      if (altitude) {
        body += "altitude=".concat(altitude, ":");
      }
      if (speed) {
        body += "speed=".concat(speed, ":");
      }
      if (bearing) {
        body += "bearing=".concat(bearing);
      }
      if (body.charAt(body.length - 1) === ':') {
        body = body.substring(0, body.length - 1);
      }
      var strEncoder = new TextEncoder();
      var data = strEncoder.encode(body);
      this.sendMediaData('GpsLocation', this.gpsLocationMsgType.OPT_LOCATION_DATA, data);
    }
  }, {
    key: "userLocationError",
    value: function userLocationError(error) {
      switch (error.code) {
        case error.TIMEOUT:
          console.log('TIMEOUT');
          break;
        case error.PERMISSION_DENIED:
          console.log('PERMISSION_DENIED');
          break;
        case error.POSITION_UNAVAILABLE:
          console.log('POSITION_UNAVAILABLE');
          break;
        default:
          break;
      }
    }
  }, {
    key: "stopLocationWatch",
    value: function stopLocationWatch() {
      // 停止监听位置信息
      navigator.geolocation.clearWatch(this.watchID);
    }
  }, {
    key: "sendSensorMsgData",
    value: function sendSensorMsgData(req, devId) {
      var rspBuf = new Uint8Array(_commonConfig.MEDIA_MSG_HEADER_COUNT);
      this.makeSensorHeaderBuf(rspBuf, req, rspBuf.length, devId);
      var msgBodyLen = rspBuf.byteLength;
      var typedBuf = new Uint8Array(_commonConfig.PACKAGE_HEADER_LENGTH + msgBodyLen);
      typedBuf.set(new Uint8Array(rspBuf), _commonConfig.PACKAGE_HEADER_LENGTH);
      this.setMsgHeader(typedBuf, 'SENSOR', msgBodyLen);
      this.send(typedBuf);
    }
  }, {
    key: "sendMediaMsgCmdData",
    value: function sendMediaMsgCmdData(bufLen, msgType, mediaType) {
      var rspBuf = new Uint8Array(bufLen);
      this.makeCommonHeaderBuf(rspBuf, msgType, rspBuf.length, mediaType);
      // PCM 0 0 ; OPUS 0 1
      if (msgType === _protocolConfig.default.MICROPHONE_MESSAGE_TYPE.OPT_MIC_START_RECORD_RSP && this.options.microPhoneOutputType === 'OPUS') {
        rspBuf[rspBuf.length - 2] = 1 >> 8;
        rspBuf[rspBuf.length - 1] = 1 & 0xff;
      }
      var msgBodyLen = rspBuf.byteLength;
      var typedBuf = new Uint8Array(_commonConfig.PACKAGE_HEADER_LENGTH + msgBodyLen);
      typedBuf.set(new Uint8Array(rspBuf), _commonConfig.PACKAGE_HEADER_LENGTH);
      this.setMsgHeader(typedBuf, mediaType, msgBodyLen);
      this.send(typedBuf);
    }
  }, {
    key: "makeSensorHeaderBuf",
    value: function makeSensorHeaderBuf(headerBuf, rspValue, dataLen, devId) {
      headerBuf[0] = 1 >> 8;
      headerBuf[1] = 1 & 0xff;
      headerBuf[2] = rspValue >> 8;
      headerBuf[3] = rspValue & 0x00ff;
      headerBuf[4] = 0 >> 8;
      headerBuf[5] = 0 & 0xff;
      headerBuf[6] = devId >> 8;
      headerBuf[7] = devId & 0xff;
      headerBuf[8] = (dataLen & 0xff000000) >> 24;
      headerBuf[9] = (dataLen & 0x00ff0000) >> 16;
      headerBuf[10] = (dataLen & 0x0000ff00) >> 8;
      headerBuf[11] = dataLen & 0x000000ff;
      headerBuf[12] = 0 >> 8;
      headerBuf[13] = 0 & 0xff;
      headerBuf[14] = 0 >> 8;
      headerBuf[15] = 0 & 0xff;
    }
  }, {
    key: "makeLocationHeaderBuf",
    value: function makeLocationHeaderBuf(headerBuf, rspValue, dataLen) {
      headerBuf[0] = 1 >> 8;
      headerBuf[1] = 1 & 0xff;
      headerBuf[2] = rspValue >> 8;
      headerBuf[3] = rspValue & 0x00ff;
      headerBuf[4] = 4 >> 8;
      headerBuf[5] = 4 & 0x00ff;
      headerBuf[6] = 0 >> 8;
      headerBuf[7] = 0 & 0xff;
      headerBuf[8] = (dataLen & 0xff000000) >> 24;
      headerBuf[9] = (dataLen & 0x00ff0000) >> 16;
      headerBuf[10] = (dataLen & 0x0000ff00) >> 8;
      headerBuf[11] = dataLen & 0x000000ff;
      headerBuf[12] = 0 >> 8;
      headerBuf[13] = 0 & 0xff;
      headerBuf[14] = 0 >> 8;
      headerBuf[15] = 0 & 0xff;
    }

    /**
     *
     * @param {object} headerBuf Uint8Array
     * @param {string} rspValue rsp类型，值为protocalConfig配置的key
     * @param {number} dataLen 数据总长度
     * @param {string} mediaType 媒体类型
     */
  }, {
    key: "makeCommonHeaderBuf",
    value: function makeCommonHeaderBuf(headerBuf, rspValue, dataLen, mediaType) {
      var currentMsgHeader = null;
      if (mediaType === 'CAMERA') {
        currentMsgHeader = this.cameraMsgHeader;
      }
      if (mediaType === 'MICROPHONE') {
        currentMsgHeader = this.microPhoneMsgHeader;
      }
      if (!currentMsgHeader) {
        return;
      }
      headerBuf[0] = currentMsgHeader.version >> 8;
      headerBuf[1] = currentMsgHeader.version & 0xff;
      headerBuf[2] = rspValue >> 8;
      headerBuf[3] = rspValue & 0x00ff;
      headerBuf[4] = currentMsgHeader.devType >> 8;
      headerBuf[5] = currentMsgHeader.devType & 0xff;
      headerBuf[6] = currentMsgHeader.devId >> 8;
      headerBuf[7] = currentMsgHeader.devId & 0xff;
      headerBuf[8] = (dataLen & 0xff000000) >> 24;
      headerBuf[9] = (dataLen & 0x00ff0000) >> 16;
      headerBuf[10] = (dataLen & 0x0000ff00) >> 8;
      headerBuf[11] = dataLen & 0x000000ff;
      headerBuf[12] = currentMsgHeader.nextProto >> 8;
      headerBuf[13] = currentMsgHeader.nextProto & 0xff;
      headerBuf[14] = currentMsgHeader.hopLimits >> 8;
      headerBuf[15] = currentMsgHeader.hopLimits & 0xff;
    }

    /**
     *
     * @param {object} buf 8位无符号整型数组Uint8Array
     * @returns 消息头信息，除len(unit32)占4位，其他均占两位(unit16)
     */
  }, {
    key: "getMsgHeader",
    value: function getMsgHeader(buf) {
      var strStartIdx = {
        version: 0,
        optType: 2,
        devType: 4,
        devId: 6,
        len: 8,
        nextProto: 12,
        hopLimits: 14
      };
      var headerObj = {
        version: 0,
        optType: 0,
        devType: 0,
        devId: 0,
        len: 0,
        nextProto: 0,
        hopLimits: 0
      };
      for (var keyName in headerObj) {
        if (keyName === 'len') {
          headerObj[keyName] = this.util.getUnit32FromArray(buf, strStartIdx[keyName]);
        } else {
          headerObj[keyName] = this.util.getUnit16FromArray(buf, strStartIdx[keyName]);
        }
      }
      return headerObj;
    }

    /**
     *
     * @param {object} bodyBuf 8位无符号整型数组Uint8Array 媒体消息类的body体
     * @param {string} bodyType 消息类型：CAMERA、MICROPHONE
     * @returns
     */
  }, {
    key: "getMsgBody",
    value: function getMsgBody(bodyBuf, bodyType) {
      var startIdx = {};
      var bodyObj = {};
      if (bodyType === 'CAMERA') {
        startIdx.width = 0;
        startIdx.height = 2;
        startIdx.fps = 4;
        bodyObj.width = 720;
        bodyObj.height = 1280;
        bodyObj.fps = 30;
      }
      if (bodyType === 'MICROPHONE') {
        startIdx.maxFrameSize = 0;
        startIdx.foramt = 2;
        startIdx.channel = 6;
        bodyObj.maxFrameSize = 7680;
        bodyObj.foramt = 1;
        bodyObj.channel = 1;
      }
      for (var keyName in bodyObj) {
        bodyObj[keyName] = this.util.getUnit16FromArray(bodyBuf, startIdx[keyName]);
      }
      return bodyObj;
    }

    /**
     * 根据协议构造发送给CAE的消息
     * @param {object} typedBuf 8位无符号整型数组Uint8Array
     * @param {string} msgType 消息类型，值为protocalConfig配置的key
     * @param {number} msgBodyLen 消息内容长度
     */
  }, {
    key: "setMsgHeader",
    value: function setMsgHeader(typedBuf, msgType, msgBodyLen) {
      typedBuf[0] = 90;
      typedBuf[1] = 90;
      typedBuf[2] = this.getCheckSum(_protocolConfig.default.MSG_TYPE[msgType]);
      typedBuf[3] = _protocolConfig.default.MSG_TYPE[msgType];
      typedBuf[4] = msgBodyLen >> 24;
      typedBuf[5] = msgBodyLen >> 16;
      typedBuf[6] = msgBodyLen >> 8;
      typedBuf[7] = msgBodyLen;
    }
  }, {
    key: "getCheckSum",
    value: function getCheckSum(msgType) {
      return msgType + (CAE_STREAM_DELIMITER_MAGICWORD >> 8 & 0xff) + (CAE_STREAM_DELIMITER_MAGICWORD & 0xff) & 0xff;
    }

    /**
     *
     * @param {string} mediaType 媒体类型
     * @param {string} msgType 消息类型
     * @param {array} data 8位无符号整型数组Unit8Array 帧数据
     */
  }, {
    key: "sendMediaData",
    value: function sendMediaData(mediaType, msgType, data) {
      var sensorId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      // if (timeout) return
      var dataBuf = this.makeMediaData(msgType, data, mediaType, sensorId);
      var buf = this.makeDataMsg(mediaType, dataBuf);

      // const buf = new Uint8Array(arrayBuf)

      buf && this.send(buf);

      // timeout = setTimeout(() => {
      //   timeout = 0
      // }, 500)
    }

    /**
     *
     * @param {string} dataType 媒体类型：CAMERA、MICROPHONE
     * @param {object} data Uint8Array 帧数据
     * @param {string} mediaType 媒体类型
     * @returns
     */
  }, {
    key: "makeMediaData",
    value: function makeMediaData(dataType, data, mediaType) {
      var sensorId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var dataBodyLen = data.byteLength;
      var dataBuf = new Uint8Array(_commonConfig.MEDIA_MSG_HEADER_COUNT + dataBodyLen);
      dataBuf.set(new Uint8Array(data), _commonConfig.MEDIA_MSG_HEADER_COUNT);
      if (mediaType === 'SENSOR') {
        this.makeSensorHeaderBuf(dataBuf, dataType, dataBuf.length, sensorId);
      } else if (mediaType === 'GpsLocation') {
        this.makeLocationHeaderBuf(dataBuf, dataType, dataBuf.length);
      } else {
        this.makeCommonHeaderBuf(dataBuf, dataType, dataBuf.length, mediaType);
      }
      return dataBuf;
    }

    /**
     * 根据协议构造发送给CAE的消息
     * @param {string} msgType 消息类型，值为protocalConfig配置的key
     * @param {object} data 待发送的消息数据，ArrayBuffer类型
     * @return {object} 返回消息ArrayBuffer
     */
  }, {
    key: "makeDataMsg",
    value: function makeDataMsg(msgType, data) {
      var msgBodyLen = data.byteLength;
      var typedBuf = new Uint8Array(_commonConfig.PACKAGE_HEADER_LENGTH + msgBodyLen);
      typedBuf.set(new Uint8Array(data), _commonConfig.PACKAGE_HEADER_LENGTH);
      this.setMsgHeader(typedBuf, msgType, msgBodyLen);

      // return typedBuf.buffer
      return typedBuf;
    }
  }]);
}();
var _default = exports.default = DeviceHardwareHandler;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);
__webpack_require__(31);
__webpack_require__(48);
__webpack_require__(49);
__webpack_require__(13);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(14);
__webpack_require__(42);
__webpack_require__(30);
__webpack_require__(21);
__webpack_require__(81);
__webpack_require__(16);
__webpack_require__(17);
var _Util = _interopRequireDefault(__webpack_require__(26));
var _webworkifyWebpack = _interopRequireDefault(__webpack_require__(63));
var _protocolConfig = _interopRequireDefault(__webpack_require__(32));
var _commonConfig = __webpack_require__(51);
var _VideoEncoder = __webpack_require__(373);
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var OPT_CAMERA_FRAME = _protocolConfig.default.CAMERA_MESSAGE_TYPE.OPT_CAMERA_FRAME;
var timeout;
var CameraPlayer = exports.default = /*#__PURE__*/function () {
  function CameraPlayer(options) {
    _classCallCheck(this, CameraPlayer);
    this.options = _objectSpread({}, options);
    this.sendOutBufHandler = options.sendOutBufHandler;
    this.util = new _Util.default();
    if (this.options.videoOptions) {
      var _this$options$videoOp;
      this.video = document.createElement('video');
      this.video.setAttribute("playsinline", "");
      this.video.setAttribute("autoplay", "");
      this.video.setAttribute("muted", "");
      this.canvas = document.createElement('canvas');
      // 预创建getImageData所需的canvas和ctx，避免每次创建新对象
      this.imageCanvas = document.createElement('canvas');
      this.imageCtx = this.imageCanvas.getContext('2d');
      // document.body.appendChild(this.canvas)
      // this.canvas.style = 'position: fixed; top: 0; right: 0'
      this.initWebGl();
      this.videoStream = null;
      this.animationId = null;
      this.stopVideo = false;
      // 添加帧率限制
      this.lastRenderTime = 0;
      this.frameInterval = 1000 / (((_this$options$videoOp = this.options.videoOptions.frameRate) === null || _this$options$videoOp === void 0 ? void 0 : _this$options$videoOp.ideal) || 30); // 默认30fps
      // 移除缓冲机制，减少延迟
      // 预分配像素数组，避免重复创建
      this.pixels = null;
      //   this.videoEncoderWorker = work(
      //     require.resolve('./worker/VideoEncoder.js')
      //   )
      this.handler = this.videoMessageHandler.bind(this);
      self.addEventListener('message', this.handler);
      this.initMediaDevices(this.options.videoOptions);
    }
  }
  return _createClass(CameraPlayer, [{
    key: "initMediaDevices",
    value: function initMediaDevices(videoOptions) {
      var _this = this;
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia || navigator.msGetUserMedia;
          if (!getUserMedia) {
            return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
          }
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      navigator.mediaDevices.getUserMedia({
        video: videoOptions,
        audio: false
      }).then(function (stream) {
        // 视频轨道
        _this.videoStream = stream.getVideoTracks()[0];
        // 摄像头打开
        if (_this.videoStream) {
          _this.videoStreamHandle();
        }
      }).catch(function (err) {
        console.log(err.name + ': ' + err.message);
      });
    }
  }, {
    key: "render",
    value: function render(timestamp) {
      // 使用requestAnimationFrame的时间戳，更准确地控制帧率
      if (!this.lastTimestamp) {
        this.lastTimestamp = timestamp;
      }
      var elapsed = timestamp - this.lastTimestamp;
      if (elapsed < this.frameInterval) {
        // 尚未到达下一帧的时间，跳过渲染
        this.animationId = requestAnimationFrame(this.render.bind(this));
        return;
      }

      // 更新时间戳，考虑累积误差
      this.lastTimestamp = timestamp - elapsed % this.frameInterval;

      // 只在视频数据充足时才进行渲染
      if (this.video.readyState === this.video.HAVE_ENOUGH_DATA && this.pixels) {
        this.updateTexture();

        // 使用预分配的像素数组，避免重复创建
        this.gl.readPixels(0, 0, this.canvas.width, this.canvas.height, this.gl.RGBA, this.gl.UNSIGNED_BYTE, this.pixels);

        // 直接使用像素数据创建ImageData，避免额外的canvas操作
        var imageData = this.imageCtx.createImageData(this.canvas.width, this.canvas.height);
        imageData.data.set(this.pixels);

        // 直接编码当前帧，减少延迟
        (0, _VideoEncoder.encode)(imageData);
      }

      // 继续请求下一帧
      this.animationId = requestAnimationFrame(this.render.bind(this));
    }
  }, {
    key: "getImageData",
    value: function getImageData(data, width, height) {
      // 使用预创建的canvas和ctx，避免每次创建新对象
      this.imageCanvas.width = width;
      this.imageCanvas.height = height;
      var imageData = this.imageCtx.createImageData(width, height);
      imageData.data.set(data);
      return imageData;
    }
  }, {
    key: "videoStreamHandle",
    value: function videoStreamHandle() {
      var _this2 = this;
      var newVideoStream = new MediaStream();
      newVideoStream.addTrack(this.videoStream);
      this.video.srcObject = newVideoStream;
      this.video.addEventListener('loadedmetadata', function () {
        // 检查视频真实尺寸
        //console.log('Video size:',  this.video.videoWidth, 'x',  this.video.videoHeight)
        // 检查目标编码尺寸
        //console.log('options encode size:', this.options.encodeWidth, 'x',   this.options.encodeHeight)

        // 使用原始的目标编码尺寸，不动态调整canvas尺寸
        // 这样可以确保编码器初始化尺寸与实际渲染尺寸一致
        _this2.canvas.width = _this2.options.encodeWidth;
        _this2.canvas.height = _this2.options.encodeHeight;

        //console.log('Canvas size:',  this.canvas.width, 'x',  this.canvas.height)

        // 预分配像素数组，避免重复创建
        var pixelCount = _this2.canvas.width * _this2.canvas.height * 4;
        _this2.pixels = new Uint8Array(pixelCount);

        // 重新初始化WebGL上下文，因为canvas尺寸改变了
        _this2.initWebGl();

        // 初始化编码器
        (0, _VideoEncoder.initEncode)(_this2.canvas.width, _this2.canvas.height, _this2.options.x264WasmPath);

        // 检查相机旋转角度
        var rotateAngles = -90 * Math.PI / 180;
        if (_this2.options.devId === _commonConfig.CAMERA_COMMON_MODE_MAP.USER) {
          rotateAngles = Math.PI / 2;
        } else {
          rotateAngles = -90 * Math.PI / 180;
        }

        // 记录旋转状态
        _this2.isRotated = Math.abs(rotateAngles) === Math.PI / 2;

        // 计算视频宽高比（考虑旋转影响）
        var videoWidth = _this2.video.videoWidth;
        var videoHeight = _this2.video.videoHeight;

        // 如果相机旋转了90度或-90度，交换宽度和高度
        if (_this2.isRotated) {
          var temp = videoWidth;
          videoWidth = videoHeight;
          videoHeight = temp;
        }
        var videoRatio = videoWidth / videoHeight;
        var canvasRatio = _this2.canvas.width / _this2.canvas.height;

        //console.log('Adjusted video size (considering rotation):', videoWidth, 'x', videoHeight)
        // console.log('Video ratio:', videoRatio, 'Canvas ratio:', canvasRatio)

        // 根据宽高比调整纹理坐标，保持画面正确比例
        _this2.adjustTextureCoordinates(videoRatio, canvasRatio);

        // 绑定纹理对象
        _this2.gl.bindTexture(_this2.gl.TEXTURE_2D, _this2.texture);
        // 初始化纹理，使用texImage2D设置初始尺寸
        _this2.gl.texImage2D(_this2.gl.TEXTURE_2D, 0, _this2.gl.RGBA, _this2.gl.RGBA, _this2.gl.UNSIGNED_BYTE, _this2.video);
        // 绘制纹理
        _this2.gl.drawArrays(_this2.gl.TRIANGLE_STRIP, 0, 4);
      });
      this.video.play();
    }
  }, {
    key: "videoMessageHandler",
    value: function videoMessageHandler(evt) {
      var message = evt.data;
      if (!Object.prototype.hasOwnProperty.call(message, 'type')) {
        return;
      }
      switch (message.type) {
        case 'startEncode':
          {
            // 只在开始编码时启动渲染循环
            this.animationId = requestAnimationFrame(this.render.bind(this));
            break;
          }
        case 'encodeResult':
          {
            // 只发送数据，不触发新的渲染，避免增加延迟
            this.sendOutBufHandler('CAMERA', OPT_CAMERA_FRAME, message.data);
            if (this.stopVideo && this.animationId) {
              cancelAnimationFrame(this.animationId);
              this.animationId = null;
            }
            break;
          }
        case 'setRotateData':
          {
            var rotateData = message.data;
            this.gl.uniformMatrix4fv(this.rotationMatrixLocation, false, rotateData);
            this.gl.uniform1i(this.textureLocation, 0);
            // 绘制纹理
            this.gl.drawArrays(this.gl.TRIANGLE_STRIP, 0, 4);
            break;
          }
        default:
          break;
      }
    }
  }, {
    key: "stopCameraVideo",
    value: function stopCameraVideo() {
      this.stopVideo = true;
      if (this.video.srcObject) {
        this.video.srcObject.getTracks().forEach(function (track) {
          return track.stop();
        });
      }
      this.video.srcObject = null;
      if (this.videoStream) {
        this.videoStream.stop();
      }
      self.removeEventListener('message', this.handler);
    }
  }, {
    key: "initWebGl",
    value: function initWebGl() {
      // 获取webgl上下文
      this.gl = this.canvas.getContext('webgl');
      // 创建顶点着色器
      var vertexShaderSource = "\n        attribute vec4 a_position;\n        attribute vec2 a_texCoord;\n        uniform mat4 u_rotationMatrix;\n        varying vec2 v_texCoord;\n        void main() {\n            gl_Position = u_rotationMatrix * a_position;\n            v_texCoord = a_texCoord;\n        }";
      var vertexShader = this.gl.createShader(this.gl.VERTEX_SHADER);
      this.gl.shaderSource(vertexShader, vertexShaderSource);
      this.gl.compileShader(vertexShader);

      // 创建片元着色器
      var fragmentShaderSource = "\n        precision mediump float;\n        uniform sampler2D u_texture;\n        varying vec2 v_texCoord;\n        void main() {\n            gl_FragColor = texture2D(u_texture, v_texCoord);\n        }";
      var fragmentShader = this.gl.createShader(this.gl.FRAGMENT_SHADER);
      this.gl.shaderSource(fragmentShader, fragmentShaderSource);
      this.gl.compileShader(fragmentShader);

      // 创建着色器程序
      var program = this.gl.createProgram();
      this.gl.attachShader(program, vertexShader);
      this.gl.attachShader(program, fragmentShader);
      this.gl.linkProgram(program);
      this.gl.useProgram(program);
      this.rotationMatrixLocation = this.gl.getUniformLocation(program, 'u_rotationMatrix');
      this.textureLocation = this.gl.getUniformLocation(program, 'u_texture');

      // 创建顶点缓冲区
      var positionBuffer = this.gl.createBuffer();
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, positionBuffer);
      this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), this.gl.STATIC_DRAW);

      // 创建纹理缓冲区
      var texCoordBuffer = this.gl.createBuffer();
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, texCoordBuffer);
      this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array([0, 0, 1, 0, 0, 1, 1, 1]), this.gl.STATIC_DRAW);

      // 设置顶点属性指针
      var positionLocation = this.gl.getAttribLocation(program, 'a_position');
      this.gl.enableVertexAttribArray(positionLocation);
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, positionBuffer);
      this.gl.vertexAttribPointer(positionLocation, 2, this.gl.FLOAT, false, 0, 0);

      // 设置纹理属性指针
      var texCoordLocation = this.gl.getAttribLocation(program, 'a_texCoord');
      this.gl.enableVertexAttribArray(texCoordLocation);
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, texCoordBuffer);
      this.gl.vertexAttribPointer(texCoordLocation, 2, this.gl.FLOAT, false, 0, 0);

      // 创建纹理对象
      this.texture = this.gl.createTexture();
      this.gl.bindTexture(this.gl.TEXTURE_2D, this.texture);

      // 设置纹理参数
      this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
      this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
      this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR);
      this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.LINEAR);

      // 设置初始视口
      this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);

      // 初始化旋转矩阵为单位矩阵
      var identityMatrix = new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
      this.gl.uniformMatrix4fv(this.rotationMatrixLocation, false, identityMatrix);
    }

    // 调整纹理坐标，保持画面正确比例
  }, {
    key: "adjustTextureCoordinates",
    value: function adjustTextureCoordinates(videoRatio, canvasRatio) {
      var texCoords = [0, 0, 1, 0, 0, 1, 1, 1];

      // 如果视频宽高比小于canvas宽高比，水平方向居中裁剪
      if (videoRatio < canvasRatio) {
        var offset = (1 - videoRatio / canvasRatio) / 2;
        texCoords = [offset, 0, 1 - offset, 0, offset, 1, 1 - offset, 1];
      } else if (videoRatio > canvasRatio) {
        // 如果视频宽高比大于canvas宽高比，垂直方向居中裁剪
        var _offset = (1 - canvasRatio / videoRatio) / 2;
        texCoords = [0, _offset, 1, _offset, 0, 1 - _offset, 1, 1 - _offset];
      }

      // 更新纹理坐标缓冲区
      var texCoordBuffer = this.gl.createBuffer();
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, texCoordBuffer);
      this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array(texCoords), this.gl.STATIC_DRAW);

      // 重新设置纹理属性指针
      var texCoordLocation = this.gl.getAttribLocation(this.gl.getParameter(this.gl.CURRENT_PROGRAM), 'a_texCoord');
      this.gl.enableVertexAttribArray(texCoordLocation);
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, texCoordBuffer);
      this.gl.vertexAttribPointer(texCoordLocation, 2, this.gl.FLOAT, false, 0, 0);

      //console.log('Adjusted texture coordinates:', texCoords)
    }

    // 每帧更新纹理
  }, {
    key: "updateTexture",
    value: function updateTexture() {
      var rotateAngles = -90 * Math.PI / 180;
      if (this.options.devId === _commonConfig.CAMERA_COMMON_MODE_MAP.USER) {
        rotateAngles = Math.PI / 2;
      } else {
        rotateAngles = -90 * Math.PI / 180;
      }

      // 绑定纹理对象
      this.gl.bindTexture(this.gl.TEXTURE_2D, this.texture);

      // 使用texSubImage2D替代texImage2D，避免重新分配纹理内存
      try {
        this.gl.texSubImage2D(this.gl.TEXTURE_2D, 0, 0, 0, this.gl.RGBA, this.gl.UNSIGNED_BYTE, this.video);
      } catch (e) {
        // 如果纹理大小不匹配，回退到texImage2D
        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.gl.RGBA, this.gl.UNSIGNED_BYTE, this.video);
      }
      (0, _VideoEncoder.rotateTexture)(rotateAngles);
      // this.videoEncoderWorker.postMessage({
      //   type: 'rotateTexture',
      //   rotateAngles
      // })
    }
  }]);
}();

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encode = encode;
exports.initEncode = initEncode;
exports.rotateTexture = rotateTexture;
var _Encode = _interopRequireDefault(__webpack_require__(374));
var _glMatrix = __webpack_require__(383);
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var videoEncoder = new _Encode.default();
function initEncode(width, height, x264WasmPath) {
  // console.log("isWebAssemblySupported",isWebAssemblySupported())
  videoEncoder.getWasm({
    width: width,
    height: height,
    x264WasmPath: x264WasmPath
  });
}
function encode(data) {
  videoEncoder.encode(data);
}
function rotateTexture(rotateAngles) {
  var rotationMatrix = _glMatrix.mat4.create();
  _glMatrix.mat4.rotateZ(rotationMatrix, rotationMatrix, rotateAngles);
  self.postMessage({
    type: 'setRotateData',
    data: rotationMatrix
  });
}
// self.addEventListener('message', evt => {
//   const message = evt.data
//   console.log("VideoEncode",WebAssembly)
//   console.log("VideoEncode",message.type)
//   switch (message.type) {
//     case 'initEncode': {
//       videoEncoder.getWasm({
//         width: message.width,
//         height: message.height,
//         x264WasmPath: message.x264WasmPath
//       })
//       break
//     }
//     case 'encode': {
//       videoEncoder.encode(message.data)
//       break
//     }
//     case 'rotateTexture': {
//       let rotationMatrix = mat4.create()
//       mat4.rotateZ(rotationMatrix, rotationMatrix, message.rotateAngles)
//       self.postMessage({
//         type: 'setRotateData',
//         data: rotationMatrix
//       })
//       break
//     }
//     default:
//     // do nothing
//   }
// })

// export default function () {}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);
__webpack_require__(14);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(21);
__webpack_require__(16);
__webpack_require__(17);
var _X264Encoder = _interopRequireDefault(__webpack_require__(375));
var _Util = _interopRequireDefault(__webpack_require__(26));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// import x264_encoder from '../lib/video-encoder.js'
var VideoEncode = /*#__PURE__*/function () {
  function VideoEncode() {
    _classCallCheck(this, VideoEncode);
    this.util = new _Util.default();
    this.module = null;
    this.h264_error = this.openEncoderError;
    this._state = 'unconfigured';
    this.videoH264DataList = [];
  }
  return _createClass(VideoEncode, [{
    key: "encodeQueueSize",
    get: function get() {
      console.log('unconfigured');
    }
  }, {
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "getWasm",
    value: function getWasm(options) {
      var _this = this;
      this.util.loadWasm("".concat(options.x264WasmPath, "/X264Encoder.wasm")).then(function (wasmBinary) {
        return (0, _X264Encoder.default)({
          instantiateWasm: function instantiateWasm(imports, successCallback) {
            imports.env.h264_write_polyfill = function (ptr, number) {
              _this.getH264Data({
                copyTo: function copyTo(dest) {
                  var len = dest.length;
                  for (var i = 0; i < len; i++) {
                    dest[i] = _this.module.HEAPU8[ptr + i];
                  }
                },
                byteLength: number
              }, {});
            };
            WebAssembly.instantiate(new Uint8Array(wasmBinary), imports).then(function (output) {
              successCallback(output.instance);
            }).catch(function (e) {});
          }
        });
      }).then(function (module) {
        _this.module = module;
        _this.encoder = new _this.module.X264Encoder();
        _this.encoder.configure(options.width, options.height);
        _this._state = 'configured';
        self.postMessage({
          type: 'startEncode'
        }, []);
      });
    }
  }, {
    key: "encode",
    value: function encode(frame) {
      if (this._state === 'unconfigured') {
        throw "Failed to execute 'encode' on 'VideoEncoder': Cannot call 'encode' on an unconfigured codec.";
      }
      if (!frame) {
        throw '';
      }
      var yuv = this.util.convertImageDataToYUV420(frame);
      var yuvPtr = this.module._malloc(yuv.byteLength);
      this.module.HEAPU8.set(yuv, yuvPtr);
      this.encoder.encode(yuvPtr);
      this.module._free(yuvPtr);
    }
  }, {
    key: "openEncoderError",
    value: function openEncoderError(e) {
      console.log(e.message);
    }
  }, {
    key: "getH264Data",
    value: function getH264Data(chunk, opts) {
      var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'annexb';
      var chunkData = new Uint8Array(chunk.byteLength);
      chunk.copyTo(chunkData);
      this.videoH264DataList.push(chunkData);
      if (this.videoH264DataList.length) {
        var itemH264Data = this.videoH264DataList.shift();
        self.postMessage({
          type: 'encodeResult',
          data: itemH264Data
        }, [itemH264Data.buffer]);
      }
    }
  }]);
}();
var _default = exports.default = VideoEncode;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(16);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(14);
__webpack_require__(42);
__webpack_require__(21);
__webpack_require__(17);
__webpack_require__(33);
__webpack_require__(376);
__webpack_require__(13);
__webpack_require__(12);
__webpack_require__(15);
__webpack_require__(225);
__webpack_require__(114);
__webpack_require__(223);
__webpack_require__(226);
__webpack_require__(227);
__webpack_require__(81);
__webpack_require__(224);
__webpack_require__(135);
__webpack_require__(136);
__webpack_require__(78);
__webpack_require__(31);
__webpack_require__(102);
__webpack_require__(30);
__webpack_require__(74);
__webpack_require__(29);
__webpack_require__(55);
__webpack_require__(378);
__webpack_require__(379);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var Module = function () {
  var _scriptDir = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : undefined;
  return function (Module) {
    Module = Module || {};
    var Module = typeof Module !== "undefined" ? Module : {};
    var readyPromiseResolve, readyPromiseReject;
    Module["ready"] = new Promise(function (resolve, reject) {
      readyPromiseResolve = resolve;
      readyPromiseReject = reject;
    });
    var moduleOverrides = {};
    var key;
    for (key in Module) {
      if (Module.hasOwnProperty(key)) {
        moduleOverrides[key] = Module[key];
      }
    }
    var arguments_ = [];
    var thisProgram = "./this.program";
    var quit_ = function quit_(status, toThrow) {
      throw toThrow;
    };
    var ENVIRONMENT_IS_WEB = true;
    var ENVIRONMENT_IS_WORKER = false;
    var scriptDirectory = "";
    function locateFile(path) {
      if (Module["locateFile"]) {
        return Module["locateFile"](path, scriptDirectory);
      }
      return scriptDirectory + path;
    }
    var read_, readAsync, readBinary, setWindowTitle;
    if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
      if (ENVIRONMENT_IS_WORKER) {
        scriptDirectory = self.location.href;
      } else if (document.currentScript) {
        scriptDirectory = document.currentScript.src;
      }
      if (_scriptDir) {
        scriptDirectory = _scriptDir;
      }
      if (scriptDirectory.indexOf("blob:") !== 0) {
        scriptDirectory = scriptDirectory.substr(0, scriptDirectory.lastIndexOf("/") + 1);
      } else {
        scriptDirectory = "";
      }
      {
        read_ = function shell_read(url) {
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url, false);
          xhr.send(null);
          return xhr.responseText;
        };
        if (ENVIRONMENT_IS_WORKER) {
          readBinary = function readBinary(url) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, false);
            xhr.responseType = "arraybuffer";
            xhr.send(null);
            return new Uint8Array(xhr.response);
          };
        }
        readAsync = function readAsync(url, onload, onerror) {
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url, true);
          xhr.responseType = "arraybuffer";
          xhr.onload = function xhr_onload() {
            if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
              onload(xhr.response);
              return;
            }
            onerror();
          };
          xhr.onerror = onerror;
          xhr.send(null);
        };
      }
      setWindowTitle = function setWindowTitle(title) {
        document.title = title;
      };
    } else {}
    var out = Module["print"] || console.log.bind(console);
    var err = Module["printErr"] || console.warn.bind(console);
    for (key in moduleOverrides) {
      if (moduleOverrides.hasOwnProperty(key)) {
        Module[key] = moduleOverrides[key];
      }
    }
    moduleOverrides = null;
    if (Module["arguments"]) arguments_ = Module["arguments"];
    if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
    if (Module["quit"]) quit_ = Module["quit"];
    var STACK_ALIGN = 16;
    function dynamicAlloc(size) {
      var ret = HEAP32[DYNAMICTOP_PTR >> 2];
      var end = ret + size + 15 & -16;
      HEAP32[DYNAMICTOP_PTR >> 2] = end;
      return ret;
    }
    function getNativeTypeSize(type) {
      switch (type) {
        case "i1":
        case "i8":
          return 1;
        case "i16":
          return 2;
        case "i32":
          return 4;
        case "i64":
          return 8;
        case "float":
          return 4;
        case "double":
          return 8;
        default:
          {
            if (type[type.length - 1] === "*") {
              return 4;
            } else if (type[0] === "i") {
              var bits = Number(type.substr(1));
              assert(bits % 8 === 0, "getNativeTypeSize invalid bits " + bits + ", type " + type);
              return bits / 8;
            } else {
              return 0;
            }
          }
      }
    }
    function warnOnce(text) {
      if (!warnOnce.shown) warnOnce.shown = {};
      if (!warnOnce.shown[text]) {
        warnOnce.shown[text] = 1;
        err(text);
      }
    }
    function convertJsFunctionToWasm(func, sig) {
      if (typeof WebAssembly.Function === "function") {
        var typeNames = {
          "i": "i32",
          "j": "i64",
          "f": "f32",
          "d": "f64"
        };
        var type = {
          parameters: [],
          results: sig[0] == "v" ? [] : [typeNames[sig[0]]]
        };
        for (var i = 1; i < sig.length; ++i) {
          type.parameters.push(typeNames[sig[i]]);
        }
        return new WebAssembly.Function(type, func);
      }
      var typeSection = [1, 0, 1, 96];
      var sigRet = sig.slice(0, 1);
      var sigParam = sig.slice(1);
      var typeCodes = {
        "i": 127,
        "j": 126,
        "f": 125,
        "d": 124
      };
      typeSection.push(sigParam.length);
      for (var i = 0; i < sigParam.length; ++i) {
        typeSection.push(typeCodes[sigParam[i]]);
      }
      if (sigRet == "v") {
        typeSection.push(0);
      } else {
        typeSection = typeSection.concat([1, typeCodes[sigRet]]);
      }
      typeSection[1] = typeSection.length - 2;
      var bytes = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0].concat(typeSection, [2, 7, 1, 1, 101, 1, 102, 0, 0, 7, 5, 1, 1, 102, 0, 0]));
      var module = new WebAssembly.Module(bytes);
      var instance = new WebAssembly.Instance(module, {
        "e": {
          "f": func
        }
      });
      var wrappedFunc = instance.exports["f"];
      return wrappedFunc;
    }
    var freeTableIndexes = [];
    var functionsInTableMap;
    function addFunctionWasm(func, sig) {
      var table = wasmTable;
      if (!functionsInTableMap) {
        functionsInTableMap = new WeakMap();
        for (var i = 0; i < table.length; i++) {
          var item = table.get(i);
          if (item) {
            functionsInTableMap.set(item, i);
          }
        }
      }
      if (functionsInTableMap.has(func)) {
        return functionsInTableMap.get(func);
      }
      var ret;
      if (freeTableIndexes.length) {
        ret = freeTableIndexes.pop();
      } else {
        ret = table.length;
        try {
          table.grow(1);
        } catch (err) {
          if (!(err instanceof RangeError)) {
            throw err;
          }
          throw "Unable to grow wasm table. Set ALLOW_TABLE_GROWTH.";
        }
      }
      try {
        table.set(ret, func);
      } catch (err) {
        if (!(err instanceof TypeError)) {
          throw err;
        }
        var wrapped = convertJsFunctionToWasm(func, sig);
        table.set(ret, wrapped);
      }
      functionsInTableMap.set(func, ret);
      return ret;
    }
    function removeFunctionWasm(index) {
      functionsInTableMap.delete(wasmTable.get(index));
      freeTableIndexes.push(index);
    }
    var funcWrappers = {};
    function dynCall(sig, ptr, args) {
      if (args && args.length) {
        return Module["dynCall_" + sig].apply(null, [ptr].concat(args));
      } else {
        return Module["dynCall_" + sig].call(null, ptr);
      }
    }
    var tempRet0 = 0;
    var setTempRet0 = function setTempRet0(value) {
      tempRet0 = value;
    };
    var wasmBinary;
    if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
    var noExitRuntime;
    if (Module["noExitRuntime"]) noExitRuntime = Module["noExitRuntime"];
    if ((typeof WebAssembly === "undefined" ? "undefined" : _typeof(WebAssembly)) !== "object") {
      err("no native wasm support detected");
    }
    function setValue(ptr, value, type, noSafe) {
      type = type || "i8";
      if (type.charAt(type.length - 1) === "*") type = "i32";
      switch (type) {
        case "i1":
          HEAP8[ptr >> 0] = value;
          break;
        case "i8":
          HEAP8[ptr >> 0] = value;
          break;
        case "i16":
          HEAP16[ptr >> 1] = value;
          break;
        case "i32":
          HEAP32[ptr >> 2] = value;
          break;
        case "i64":
          tempI64 = [value >>> 0, (tempDouble = value, +Math_abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math_min(+Math_floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math_ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[ptr >> 2] = tempI64[0], HEAP32[ptr + 4 >> 2] = tempI64[1];
          break;
        case "float":
          HEAPF32[ptr >> 2] = value;
          break;
        case "double":
          HEAPF64[ptr >> 3] = value;
          break;
        default:
          abort("invalid type for setValue: " + type);
      }
    }
    var wasmMemory;
    var wasmTable = new WebAssembly.Table({
      "initial": 318,
      "maximum": 318 + 0,
      "element": "anyfunc"
    });
    var ABORT = false;
    var EXITSTATUS = 0;
    function assert(condition, text) {
      if (!condition) {
        abort("Assertion failed: " + text);
      }
    }
    function getCFunc(ident) {
      var func = Module["_" + ident];
      assert(func, "Cannot call unknown function " + ident + ", make sure it is exported");
      return func;
    }
    function ccall(ident, returnType, argTypes, args, opts) {
      var toC = {
        "string": function string(str) {
          var ret = 0;
          if (str !== null && str !== undefined && str !== 0) {
            var len = (str.length << 2) + 1;
            ret = stackAlloc(len);
            stringToUTF8(str, ret, len);
          }
          return ret;
        },
        "array": function array(arr) {
          var ret = stackAlloc(arr.length);
          writeArrayToMemory(arr, ret);
          return ret;
        }
      };
      function convertReturnValue(ret) {
        if (returnType === "string") return UTF8ToString(ret);
        if (returnType === "boolean") return Boolean(ret);
        return ret;
      }
      var func = getCFunc(ident);
      var cArgs = [];
      var stack = 0;
      if (args) {
        for (var i = 0; i < args.length; i++) {
          var converter = toC[argTypes[i]];
          if (converter) {
            if (stack === 0) stack = stackSave();
            cArgs[i] = converter(args[i]);
          } else {
            cArgs[i] = args[i];
          }
        }
      }
      var ret = func.apply(null, cArgs);
      ret = convertReturnValue(ret);
      if (stack !== 0) stackRestore(stack);
      return ret;
    }
    var ALLOC_NONE = 3;
    var UTF8Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf8") : undefined;
    function UTF8ArrayToString(heap, idx, maxBytesToRead) {
      var endIdx = idx + maxBytesToRead;
      var endPtr = idx;
      while (heap[endPtr] && !(endPtr >= endIdx)) ++endPtr;
      if (endPtr - idx > 16 && heap.subarray && UTF8Decoder) {
        return UTF8Decoder.decode(heap.subarray(idx, endPtr));
      } else {
        var str = "";
        while (idx < endPtr) {
          var u0 = heap[idx++];
          if (!(u0 & 128)) {
            str += String.fromCharCode(u0);
            continue;
          }
          var u1 = heap[idx++] & 63;
          if ((u0 & 224) == 192) {
            str += String.fromCharCode((u0 & 31) << 6 | u1);
            continue;
          }
          var u2 = heap[idx++] & 63;
          if ((u0 & 240) == 224) {
            u0 = (u0 & 15) << 12 | u1 << 6 | u2;
          } else {
            u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heap[idx++] & 63;
          }
          if (u0 < 65536) {
            str += String.fromCharCode(u0);
          } else {
            var ch = u0 - 65536;
            str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
          }
        }
      }
      return str;
    }
    function UTF8ToString(ptr, maxBytesToRead) {
      return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
    }
    function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
      if (!(maxBytesToWrite > 0)) return 0;
      var startIdx = outIdx;
      var endIdx = outIdx + maxBytesToWrite - 1;
      for (var i = 0; i < str.length; ++i) {
        var u = str.charCodeAt(i);
        if (u >= 55296 && u <= 57343) {
          var u1 = str.charCodeAt(++i);
          u = 65536 + ((u & 1023) << 10) | u1 & 1023;
        }
        if (u <= 127) {
          if (outIdx >= endIdx) break;
          heap[outIdx++] = u;
        } else if (u <= 2047) {
          if (outIdx + 1 >= endIdx) break;
          heap[outIdx++] = 192 | u >> 6;
          heap[outIdx++] = 128 | u & 63;
        } else if (u <= 65535) {
          if (outIdx + 2 >= endIdx) break;
          heap[outIdx++] = 224 | u >> 12;
          heap[outIdx++] = 128 | u >> 6 & 63;
          heap[outIdx++] = 128 | u & 63;
        } else {
          if (outIdx + 3 >= endIdx) break;
          heap[outIdx++] = 240 | u >> 18;
          heap[outIdx++] = 128 | u >> 12 & 63;
          heap[outIdx++] = 128 | u >> 6 & 63;
          heap[outIdx++] = 128 | u & 63;
        }
      }
      heap[outIdx] = 0;
      return outIdx - startIdx;
    }
    function stringToUTF8(str, outPtr, maxBytesToWrite) {
      return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
    }
    function lengthBytesUTF8(str) {
      var len = 0;
      for (var i = 0; i < str.length; ++i) {
        var u = str.charCodeAt(i);
        if (u >= 55296 && u <= 57343) u = 65536 + ((u & 1023) << 10) | str.charCodeAt(++i) & 1023;
        if (u <= 127) ++len;else if (u <= 2047) len += 2;else if (u <= 65535) len += 3;else len += 4;
      }
      return len;
    }
    var UTF16Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le") : undefined;
    function UTF16ToString(ptr, maxBytesToRead) {
      var endPtr = ptr;
      var idx = endPtr >> 1;
      var maxIdx = idx + maxBytesToRead / 2;
      while (!(idx >= maxIdx) && HEAPU16[idx]) ++idx;
      endPtr = idx << 1;
      if (endPtr - ptr > 32 && UTF16Decoder) {
        return UTF16Decoder.decode(HEAPU8.subarray(ptr, endPtr));
      } else {
        var i = 0;
        var str = "";
        while (1) {
          var codeUnit = HEAP16[ptr + i * 2 >> 1];
          if (codeUnit == 0 || i == maxBytesToRead / 2) return str;
          ++i;
          str += String.fromCharCode(codeUnit);
        }
      }
    }
    function stringToUTF16(str, outPtr, maxBytesToWrite) {
      if (maxBytesToWrite === undefined) {
        maxBytesToWrite = 2147483647;
      }
      if (maxBytesToWrite < 2) return 0;
      maxBytesToWrite -= 2;
      var startPtr = outPtr;
      var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length;
      for (var i = 0; i < numCharsToWrite; ++i) {
        var codeUnit = str.charCodeAt(i);
        HEAP16[outPtr >> 1] = codeUnit;
        outPtr += 2;
      }
      HEAP16[outPtr >> 1] = 0;
      return outPtr - startPtr;
    }
    function lengthBytesUTF16(str) {
      return str.length * 2;
    }
    function UTF32ToString(ptr, maxBytesToRead) {
      var i = 0;
      var str = "";
      while (!(i >= maxBytesToRead / 4)) {
        var utf32 = HEAP32[ptr + i * 4 >> 2];
        if (utf32 == 0) break;
        ++i;
        if (utf32 >= 65536) {
          var ch = utf32 - 65536;
          str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
        } else {
          str += String.fromCharCode(utf32);
        }
      }
      return str;
    }
    function stringToUTF32(str, outPtr, maxBytesToWrite) {
      if (maxBytesToWrite === undefined) {
        maxBytesToWrite = 2147483647;
      }
      if (maxBytesToWrite < 4) return 0;
      var startPtr = outPtr;
      var endPtr = startPtr + maxBytesToWrite - 4;
      for (var i = 0; i < str.length; ++i) {
        var codeUnit = str.charCodeAt(i);
        if (codeUnit >= 55296 && codeUnit <= 57343) {
          var trailSurrogate = str.charCodeAt(++i);
          codeUnit = 65536 + ((codeUnit & 1023) << 10) | trailSurrogate & 1023;
        }
        HEAP32[outPtr >> 2] = codeUnit;
        outPtr += 4;
        if (outPtr + 4 > endPtr) break;
      }
      HEAP32[outPtr >> 2] = 0;
      return outPtr - startPtr;
    }
    function lengthBytesUTF32(str) {
      var len = 0;
      for (var i = 0; i < str.length; ++i) {
        var codeUnit = str.charCodeAt(i);
        if (codeUnit >= 55296 && codeUnit <= 57343) ++i;
        len += 4;
      }
      return len;
    }
    function writeArrayToMemory(array, buffer) {
      HEAP8.set(array, buffer);
    }
    function writeAsciiToMemory(str, buffer, dontAddNull) {
      for (var i = 0; i < str.length; ++i) {
        HEAP8[buffer++ >> 0] = str.charCodeAt(i);
      }
      if (!dontAddNull) HEAP8[buffer >> 0] = 0;
    }
    var WASM_PAGE_SIZE = 65536;
    function alignUp(x, multiple) {
      if (x % multiple > 0) {
        x += multiple - x % multiple;
      }
      return x;
    }
    var buffer, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
    function updateGlobalBufferAndViews(buf) {
      buffer = buf;
      Module["HEAP8"] = HEAP8 = new Int8Array(buf);
      Module["HEAP16"] = HEAP16 = new Int16Array(buf);
      Module["HEAP32"] = HEAP32 = new Int32Array(buf);
      Module["HEAPU8"] = HEAPU8 = new Uint8Array(buf);
      Module["HEAPU16"] = HEAPU16 = new Uint16Array(buf);
      Module["HEAPU32"] = HEAPU32 = new Uint32Array(buf);
      Module["HEAPF32"] = HEAPF32 = new Float32Array(buf);
      Module["HEAPF64"] = HEAPF64 = new Float64Array(buf);
    }
    var STACK_BASE = 5775184,
      DYNAMIC_BASE = 5775184,
      DYNAMICTOP_PTR = 532144;
    var INITIAL_INITIAL_MEMORY = Module["INITIAL_MEMORY"] || 16777216;
    if (Module["wasmMemory"]) {
      wasmMemory = Module["wasmMemory"];
    } else {
      wasmMemory = new WebAssembly.Memory({
        "initial": INITIAL_INITIAL_MEMORY / WASM_PAGE_SIZE,
        "maximum": 2147483648 / WASM_PAGE_SIZE
      });
    }
    if (wasmMemory) {
      buffer = wasmMemory.buffer;
    }
    INITIAL_INITIAL_MEMORY = buffer.byteLength;
    updateGlobalBufferAndViews(buffer);
    HEAP32[DYNAMICTOP_PTR >> 2] = DYNAMIC_BASE;
    function callRuntimeCallbacks(callbacks) {
      while (callbacks.length > 0) {
        var callback = callbacks.shift();
        if (typeof callback == "function") {
          callback(Module);
          continue;
        }
        var func = callback.func;
        if (typeof func === "number") {
          if (callback.arg === undefined) {
            Module["dynCall_v"](func);
          } else {
            Module["dynCall_vi"](func, callback.arg);
          }
        } else {
          func(callback.arg === undefined ? null : callback.arg);
        }
      }
    }
    var __ATPRERUN__ = [];
    var __ATINIT__ = [];
    var __ATMAIN__ = [];
    var __ATPOSTRUN__ = [];
    var runtimeInitialized = false;
    var runtimeExited = false;
    function preRun() {
      if (Module["preRun"]) {
        if (typeof Module["preRun"] == "function") Module["preRun"] = [Module["preRun"]];
        while (Module["preRun"].length) {
          addOnPreRun(Module["preRun"].shift());
        }
      }
      callRuntimeCallbacks(__ATPRERUN__);
    }
    function initRuntime() {
      runtimeInitialized = true;
      callRuntimeCallbacks(__ATINIT__);
    }
    function preMain() {
      callRuntimeCallbacks(__ATMAIN__);
    }
    function exitRuntime() {
      runtimeExited = true;
    }
    function postRun() {
      if (Module["postRun"]) {
        if (typeof Module["postRun"] == "function") Module["postRun"] = [Module["postRun"]];
        while (Module["postRun"].length) {
          addOnPostRun(Module["postRun"].shift());
        }
      }
      callRuntimeCallbacks(__ATPOSTRUN__);
    }
    function addOnPreRun(cb) {
      __ATPRERUN__.unshift(cb);
    }
    function addOnPostRun(cb) {
      __ATPOSTRUN__.unshift(cb);
    }
    var Math_abs = Math.abs;
    var Math_ceil = Math.ceil;
    var Math_floor = Math.floor;
    var Math_min = Math.min;
    var runDependencies = 0;
    var runDependencyWatcher = null;
    var dependenciesFulfilled = null;
    function addRunDependency(id) {
      runDependencies++;
      if (Module["monitorRunDependencies"]) {
        Module["monitorRunDependencies"](runDependencies);
      }
    }
    function removeRunDependency(id) {
      runDependencies--;
      if (Module["monitorRunDependencies"]) {
        Module["monitorRunDependencies"](runDependencies);
      }
      if (runDependencies == 0) {
        if (runDependencyWatcher !== null) {
          clearInterval(runDependencyWatcher);
          runDependencyWatcher = null;
        }
        if (dependenciesFulfilled) {
          var callback = dependenciesFulfilled;
          dependenciesFulfilled = null;
          callback();
        }
      }
    }
    Module["preloadedImages"] = {};
    Module["preloadedAudios"] = {};
    function abort(what) {
      if (Module["onAbort"]) {
        Module["onAbort"](what);
      }
      what += "";
      out(what);
      err(what);
      ABORT = true;
      EXITSTATUS = 1;
      what = "abort(" + what + "). Build with -s ASSERTIONS=1 for more info.";
      throw new WebAssembly.RuntimeError(what);
    }
    function hasPrefix(str, prefix) {
      return String.prototype.startsWith ? str.startsWith(prefix) : str.indexOf(prefix) === 0;
    }
    var dataURIPrefix = "data:application/octet-stream;base64,";
    function isDataURI(filename) {
      return hasPrefix(filename, dataURIPrefix);
    }
    var fileURIPrefix = "file://";
    var wasmBinaryFile = "X264Encoder.wasm";
    if (!isDataURI(wasmBinaryFile)) {
      wasmBinaryFile = locateFile(wasmBinaryFile);
    }
    function getBinary() {
      try {
        if (wasmBinary) {
          return new Uint8Array(wasmBinary);
        }
        if (readBinary) {
          return readBinary(wasmBinaryFile);
        } else {
          throw "both async and sync fetching of the wasm failed";
        }
      } catch (err) {
        abort(err);
      }
    }
    function getBinaryPromise() {
      if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) && typeof fetch === "function") {
        return fetch(wasmBinaryFile, {
          credentials: "same-origin"
        }).then(function (response) {
          if (!response["ok"]) {
            throw "failed to load wasm binary file at '" + wasmBinaryFile + "'";
          }
          return response["arrayBuffer"]();
        }).catch(function () {
          return getBinary();
        });
      }
      return new Promise(function (resolve, reject) {
        resolve(getBinary());
      });
    }
    function createWasm() {
      var info = {
        "env": asmLibraryArg,
        "wasi_snapshot_preview1": asmLibraryArg
      };
      function receiveInstance(instance, module) {
        var exports = instance.exports;
        Module["asm"] = exports;
        removeRunDependency("wasm-instantiate");
      }
      addRunDependency("wasm-instantiate");
      function receiveInstantiatedSource(output) {
        receiveInstance(output["instance"]);
      }
      function instantiateArrayBuffer(receiver) {
        return getBinaryPromise().then(function (binary) {
          return WebAssembly.instantiate(binary, info);
        }).then(receiver, function (reason) {
          err("failed to asynchronously prepare wasm: " + reason);
          abort(reason);
        });
      }
      function instantiateAsync() {
        if (!wasmBinary && typeof WebAssembly.instantiateStreaming === "function" && !isDataURI(wasmBinaryFile) && typeof fetch === "function") {
          fetch(wasmBinaryFile, {
            credentials: "same-origin"
          }).then(function (response) {
            var result = WebAssembly.instantiateStreaming(response, info);
            return result.then(receiveInstantiatedSource, function (reason) {
              err("wasm streaming compile failed: " + reason);
              err("falling back to ArrayBuffer instantiation");
              return instantiateArrayBuffer(receiveInstantiatedSource);
            });
          });
        } else {
          return instantiateArrayBuffer(receiveInstantiatedSource);
        }
      }
      if (Module["instantiateWasm"]) {
        try {
          var exports = Module["instantiateWasm"](info, receiveInstance);
          return exports;
        } catch (e) {
          err("Module.instantiateWasm callback failed with error: " + e);
          return false;
        }
      }
      instantiateAsync();
      return {};
    }
    var tempDouble;
    var tempI64;
    __ATINIT__.push({
      func: function func() {
        ___wasm_call_ctors();
      }
    });
    function demangle(func) {
      return func;
    }
    function demangleAll(text) {
      var regex = /\b_Z[\w\d_]+/g;
      return text.replace(regex, function (x) {
        var y = demangle(x);
        return x === y ? x : y + " [" + x + "]";
      });
    }
    function jsStackTrace() {
      var err = new Error();
      if (!err.stack) {
        try {
          throw new Error();
        } catch (e) {
          err = e;
        }
        if (!err.stack) {
          return "(no stack trace available)";
        }
      }
      return err.stack.toString();
    }
    function ___assert_fail(condition, filename, line, func) {
      abort("Assertion failed: " + UTF8ToString(condition) + ", at: " + [filename ? UTF8ToString(filename) : "unknown filename", line, func ? UTF8ToString(func) : "unknown function"]);
    }
    var PATH = {
      splitPath: function splitPath(filename) {
        var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
        return splitPathRe.exec(filename).slice(1);
      },
      normalizeArray: function normalizeArray(parts, allowAboveRoot) {
        var up = 0;
        for (var i = parts.length - 1; i >= 0; i--) {
          var last = parts[i];
          if (last === ".") {
            parts.splice(i, 1);
          } else if (last === "..") {
            parts.splice(i, 1);
            up++;
          } else if (up) {
            parts.splice(i, 1);
            up--;
          }
        }
        if (allowAboveRoot) {
          for (; up; up--) {
            parts.unshift("..");
          }
        }
        return parts;
      },
      normalize: function normalize(path) {
        var isAbsolute = path.charAt(0) === "/",
          trailingSlash = path.substr(-1) === "/";
        path = PATH.normalizeArray(path.split("/").filter(function (p) {
          return !!p;
        }), !isAbsolute).join("/");
        if (!path && !isAbsolute) {
          path = ".";
        }
        if (path && trailingSlash) {
          path += "/";
        }
        return (isAbsolute ? "/" : "") + path;
      },
      dirname: function dirname(path) {
        var result = PATH.splitPath(path),
          root = result[0],
          dir = result[1];
        if (!root && !dir) {
          return ".";
        }
        if (dir) {
          dir = dir.substr(0, dir.length - 1);
        }
        return root + dir;
      },
      basename: function basename(path) {
        if (path === "/") return "/";
        var lastSlash = path.lastIndexOf("/");
        if (lastSlash === -1) return path;
        return path.substr(lastSlash + 1);
      },
      extname: function extname(path) {
        return PATH.splitPath(path)[3];
      },
      join: function join() {
        var paths = Array.prototype.slice.call(arguments, 0);
        return PATH.normalize(paths.join("/"));
      },
      join2: function join2(l, r) {
        return PATH.normalize(l + "/" + r);
      }
    };
    var SYSCALLS = {
      mappings: {},
      buffers: [null, [], []],
      printChar: function printChar(stream, curr) {
        var buffer = SYSCALLS.buffers[stream];
        if (curr === 0 || curr === 10) {
          (stream === 1 ? out : err)(UTF8ArrayToString(buffer, 0));
          buffer.length = 0;
        } else {
          buffer.push(curr);
        }
      },
      varargs: undefined,
      get: function get() {
        SYSCALLS.varargs += 4;
        var ret = HEAP32[SYSCALLS.varargs - 4 >> 2];
        return ret;
      },
      getStr: function getStr(ptr) {
        var ret = UTF8ToString(ptr);
        return ret;
      },
      get64: function get64(low, high) {
        return low;
      }
    };
    function ___sys_fcntl64(fd, cmd, varargs) {
      SYSCALLS.varargs = varargs;
      return 0;
    }
    function ___sys_fstat64(fd, buf) {}
    function ___sys_ioctl(fd, op, varargs) {
      SYSCALLS.varargs = varargs;
      return 0;
    }
    function ___sys_madvise1(addr, length, advice) {
      return 0;
    }
    function ___sys_open(path, flags, varargs) {
      SYSCALLS.varargs = varargs;
    }
    function ___sys_rename(old_path, new_path) {}
    function ___sys_stat64(path, buf) {}
    function getShiftFromSize(size) {
      switch (size) {
        case 1:
          return 0;
        case 2:
          return 1;
        case 4:
          return 2;
        case 8:
          return 3;
        default:
          throw new TypeError("Unknown type size: " + size);
      }
    }
    function embind_init_charCodes() {
      var codes = new Array(256);
      for (var i = 0; i < 256; ++i) {
        codes[i] = String.fromCharCode(i);
      }
      embind_charCodes = codes;
    }
    var embind_charCodes = undefined;
    function readLatin1String(ptr) {
      var ret = "";
      var c = ptr;
      while (HEAPU8[c]) {
        ret += embind_charCodes[HEAPU8[c++]];
      }
      return ret;
    }
    var awaitingDependencies = {};
    var registeredTypes = {};
    var typeDependencies = {};
    var char_0 = 48;
    var char_9 = 57;
    function makeLegalFunctionName(name) {
      if (undefined === name) {
        return "_unknown";
      }
      name = name.replace(/[^a-zA-Z0-9_]/g, "$");
      var f = name.charCodeAt(0);
      if (f >= char_0 && f <= char_9) {
        return "_" + name;
      } else {
        return name;
      }
    }
    function createNamedFunction(name, body) {
      name = makeLegalFunctionName(name);
      return function () {
        "use strict";

        return body.apply(this, arguments);
      };
    }
    function extendError(baseErrorType, errorName) {
      var errorClass = createNamedFunction(errorName, function (message) {
        this.name = errorName;
        this.message = message;
        var stack = new Error(message).stack;
        if (stack !== undefined) {
          this.stack = this.toString() + "\n" + stack.replace(/^Error(:[^\n]*)?\n/, "");
        }
      });
      errorClass.prototype = Object.create(baseErrorType.prototype);
      errorClass.prototype.constructor = errorClass;
      errorClass.prototype.toString = function () {
        if (this.message === undefined) {
          return this.name;
        } else {
          return this.name + ": " + this.message;
        }
      };
      return errorClass;
    }
    var BindingError = undefined;
    function throwBindingError(message) {
      throw new BindingError(message);
    }
    var InternalError = undefined;
    function throwInternalError(message) {
      throw new InternalError(message);
    }
    function whenDependentTypesAreResolved(myTypes, dependentTypes, getTypeConverters) {
      myTypes.forEach(function (type) {
        typeDependencies[type] = dependentTypes;
      });
      function onComplete(typeConverters) {
        var myTypeConverters = getTypeConverters(typeConverters);
        if (myTypeConverters.length !== myTypes.length) {
          throwInternalError("Mismatched type converter count");
        }
        for (var i = 0; i < myTypes.length; ++i) {
          registerType(myTypes[i], myTypeConverters[i]);
        }
      }
      var typeConverters = new Array(dependentTypes.length);
      var unregisteredTypes = [];
      var registered = 0;
      dependentTypes.forEach(function (dt, i) {
        if (registeredTypes.hasOwnProperty(dt)) {
          typeConverters[i] = registeredTypes[dt];
        } else {
          unregisteredTypes.push(dt);
          if (!awaitingDependencies.hasOwnProperty(dt)) {
            awaitingDependencies[dt] = [];
          }
          awaitingDependencies[dt].push(function () {
            typeConverters[i] = registeredTypes[dt];
            ++registered;
            if (registered === unregisteredTypes.length) {
              onComplete(typeConverters);
            }
          });
        }
      });
      if (0 === unregisteredTypes.length) {
        onComplete(typeConverters);
      }
    }
    function registerType(rawType, registeredInstance, options) {
      options = options || {};
      if (!("argPackAdvance" in registeredInstance)) {
        throw new TypeError("registerType registeredInstance requires argPackAdvance");
      }
      var name = registeredInstance.name;
      if (!rawType) {
        throwBindingError('type "' + name + '" must have a positive integer typeid pointer');
      }
      if (registeredTypes.hasOwnProperty(rawType)) {
        if (options.ignoreDuplicateRegistrations) {
          return;
        } else {
          throwBindingError("Cannot register type '" + name + "' twice");
        }
      }
      registeredTypes[rawType] = registeredInstance;
      delete typeDependencies[rawType];
      if (awaitingDependencies.hasOwnProperty(rawType)) {
        var callbacks = awaitingDependencies[rawType];
        delete awaitingDependencies[rawType];
        callbacks.forEach(function (cb) {
          cb();
        });
      }
    }
    function __embind_register_bool(rawType, name, size, trueValue, falseValue) {
      var shift = getShiftFromSize(size);
      name = readLatin1String(name);
      registerType(rawType, {
        name: name,
        "fromWireType": function fromWireType(wt) {
          return !!wt;
        },
        "toWireType": function toWireType(destructors, o) {
          return o ? trueValue : falseValue;
        },
        "argPackAdvance": 8,
        "readValueFromPointer": function readValueFromPointer(pointer) {
          var heap;
          if (size === 1) {
            heap = HEAP8;
          } else if (size === 2) {
            heap = HEAP16;
          } else if (size === 4) {
            heap = HEAP32;
          } else {
            throw new TypeError("Unknown boolean type size: " + name);
          }
          return this["fromWireType"](heap[pointer >> shift]);
        },
        destructorFunction: null
      });
    }
    function ClassHandle_isAliasOf(other) {
      if (!(this instanceof ClassHandle)) {
        return false;
      }
      if (!(other instanceof ClassHandle)) {
        return false;
      }
      var leftClass = this.$$.ptrType.registeredClass;
      var left = this.$$.ptr;
      var rightClass = other.$$.ptrType.registeredClass;
      var right = other.$$.ptr;
      while (leftClass.baseClass) {
        left = leftClass.upcast(left);
        leftClass = leftClass.baseClass;
      }
      while (rightClass.baseClass) {
        right = rightClass.upcast(right);
        rightClass = rightClass.baseClass;
      }
      return leftClass === rightClass && left === right;
    }
    function shallowCopyInternalPointer(o) {
      return {
        count: o.count,
        deleteScheduled: o.deleteScheduled,
        preservePointerOnDelete: o.preservePointerOnDelete,
        ptr: o.ptr,
        ptrType: o.ptrType,
        smartPtr: o.smartPtr,
        smartPtrType: o.smartPtrType
      };
    }
    function throwInstanceAlreadyDeleted(obj) {
      function getInstanceTypeName(handle) {
        return handle.$$.ptrType.registeredClass.name;
      }
      throwBindingError(getInstanceTypeName(obj) + " instance already deleted");
    }
    var finalizationGroup = false;
    function detachFinalizer(handle) {}
    function runDestructor($$) {
      if ($$.smartPtr) {
        $$.smartPtrType.rawDestructor($$.smartPtr);
      } else {
        $$.ptrType.registeredClass.rawDestructor($$.ptr);
      }
    }
    function releaseClassHandle($$) {
      $$.count.value -= 1;
      var toDelete = 0 === $$.count.value;
      if (toDelete) {
        runDestructor($$);
      }
    }
    function attachFinalizer(handle) {
      if ("undefined" === typeof FinalizationGroup) {
        attachFinalizer = function attachFinalizer(handle) {
          return handle;
        };
        return handle;
      }
      finalizationGroup = new FinalizationGroup(function (iter) {
        for (var result = iter.next(); !result.done; result = iter.next()) {
          var $$ = result.value;
          if (!$$.ptr) {
            console.warn("object already deleted: " + $$.ptr);
          } else {
            releaseClassHandle($$);
          }
        }
      });
      attachFinalizer = function attachFinalizer(handle) {
        finalizationGroup.register(handle, handle.$$, handle.$$);
        return handle;
      };
      detachFinalizer = function detachFinalizer(handle) {
        finalizationGroup.unregister(handle.$$);
      };
      return attachFinalizer(handle);
    }
    function ClassHandle_clone() {
      if (!this.$$.ptr) {
        throwInstanceAlreadyDeleted(this);
      }
      if (this.$$.preservePointerOnDelete) {
        this.$$.count.value += 1;
        return this;
      } else {
        var clone = attachFinalizer(Object.create(Object.getPrototypeOf(this), {
          $$: {
            value: shallowCopyInternalPointer(this.$$)
          }
        }));
        clone.$$.count.value += 1;
        clone.$$.deleteScheduled = false;
        return clone;
      }
    }
    function ClassHandle_delete() {
      if (!this.$$.ptr) {
        throwInstanceAlreadyDeleted(this);
      }
      if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
        throwBindingError("Object already scheduled for deletion");
      }
      detachFinalizer(this);
      releaseClassHandle(this.$$);
      if (!this.$$.preservePointerOnDelete) {
        this.$$.smartPtr = undefined;
        this.$$.ptr = undefined;
      }
    }
    function ClassHandle_isDeleted() {
      return !this.$$.ptr;
    }
    var delayFunction = undefined;
    var deletionQueue = [];
    function flushPendingDeletes() {
      while (deletionQueue.length) {
        var obj = deletionQueue.pop();
        obj.$$.deleteScheduled = false;
        obj["delete"]();
      }
    }
    function ClassHandle_deleteLater() {
      if (!this.$$.ptr) {
        throwInstanceAlreadyDeleted(this);
      }
      if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
        throwBindingError("Object already scheduled for deletion");
      }
      deletionQueue.push(this);
      if (deletionQueue.length === 1 && delayFunction) {
        delayFunction(flushPendingDeletes);
      }
      this.$$.deleteScheduled = true;
      return this;
    }
    function init_ClassHandle() {
      ClassHandle.prototype["isAliasOf"] = ClassHandle_isAliasOf;
      ClassHandle.prototype["clone"] = ClassHandle_clone;
      ClassHandle.prototype["delete"] = ClassHandle_delete;
      ClassHandle.prototype["isDeleted"] = ClassHandle_isDeleted;
      ClassHandle.prototype["deleteLater"] = ClassHandle_deleteLater;
    }
    function ClassHandle() {}
    var registeredPointers = {};
    function ensureOverloadTable(proto, methodName, humanName) {
      if (undefined === proto[methodName].overloadTable) {
        var prevFunc = proto[methodName];
        proto[methodName] = function () {
          if (!proto[methodName].overloadTable.hasOwnProperty(arguments.length)) {
            throwBindingError("Function '" + humanName + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + proto[methodName].overloadTable + ")!");
          }
          return proto[methodName].overloadTable[arguments.length].apply(this, arguments);
        };
        proto[methodName].overloadTable = [];
        proto[methodName].overloadTable[prevFunc.argCount] = prevFunc;
      }
    }
    function exposePublicSymbol(name, value, numArguments) {
      if (Module.hasOwnProperty(name)) {
        if (undefined === numArguments || undefined !== Module[name].overloadTable && undefined !== Module[name].overloadTable[numArguments]) {
          throwBindingError("Cannot register public name '" + name + "' twice");
        }
        ensureOverloadTable(Module, name, name);
        if (Module.hasOwnProperty(numArguments)) {
          throwBindingError("Cannot register multiple overloads of a function with the same number of arguments (" + numArguments + ")!");
        }
        Module[name].overloadTable[numArguments] = value;
      } else {
        Module[name] = value;
        if (undefined !== numArguments) {
          Module[name].numArguments = numArguments;
        }
      }
    }
    function RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast) {
      this.name = name;
      this.constructor = constructor;
      this.instancePrototype = instancePrototype;
      this.rawDestructor = rawDestructor;
      this.baseClass = baseClass;
      this.getActualType = getActualType;
      this.upcast = upcast;
      this.downcast = downcast;
      this.pureVirtualFunctions = [];
    }
    function upcastPointer(ptr, ptrClass, desiredClass) {
      while (ptrClass !== desiredClass) {
        if (!ptrClass.upcast) {
          throwBindingError("Expected null or instance of " + desiredClass.name + ", got an instance of " + ptrClass.name);
        }
        ptr = ptrClass.upcast(ptr);
        ptrClass = ptrClass.baseClass;
      }
      return ptr;
    }
    function constNoSmartPtrRawPointerToWireType(destructors, handle) {
      if (handle === null) {
        if (this.isReference) {
          throwBindingError("null is not a valid " + this.name);
        }
        return 0;
      }
      if (!handle.$$) {
        throwBindingError('Cannot pass "' + _embind_repr(handle) + '" as a ' + this.name);
      }
      if (!handle.$$.ptr) {
        throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
      }
      var handleClass = handle.$$.ptrType.registeredClass;
      var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
      return ptr;
    }
    function genericPointerToWireType(destructors, handle) {
      var ptr;
      if (handle === null) {
        if (this.isReference) {
          throwBindingError("null is not a valid " + this.name);
        }
        if (this.isSmartPointer) {
          ptr = this.rawConstructor();
          if (destructors !== null) {
            destructors.push(this.rawDestructor, ptr);
          }
          return ptr;
        } else {
          return 0;
        }
      }
      if (!handle.$$) {
        throwBindingError('Cannot pass "' + _embind_repr(handle) + '" as a ' + this.name);
      }
      if (!handle.$$.ptr) {
        throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
      }
      if (!this.isConst && handle.$$.ptrType.isConst) {
        throwBindingError("Cannot convert argument of type " + (handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name) + " to parameter type " + this.name);
      }
      var handleClass = handle.$$.ptrType.registeredClass;
      ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
      if (this.isSmartPointer) {
        if (undefined === handle.$$.smartPtr) {
          throwBindingError("Passing raw pointer to smart pointer is illegal");
        }
        switch (this.sharingPolicy) {
          case 0:
            if (handle.$$.smartPtrType === this) {
              ptr = handle.$$.smartPtr;
            } else {
              throwBindingError("Cannot convert argument of type " + (handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name) + " to parameter type " + this.name);
            }
            break;
          case 1:
            ptr = handle.$$.smartPtr;
            break;
          case 2:
            if (handle.$$.smartPtrType === this) {
              ptr = handle.$$.smartPtr;
            } else {
              var clonedHandle = handle["clone"]();
              ptr = this.rawShare(ptr, __emval_register(function () {
                clonedHandle["delete"]();
              }));
              if (destructors !== null) {
                destructors.push(this.rawDestructor, ptr);
              }
            }
            break;
          default:
            throwBindingError("Unsupporting sharing policy");
        }
      }
      return ptr;
    }
    function nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
      if (handle === null) {
        if (this.isReference) {
          throwBindingError("null is not a valid " + this.name);
        }
        return 0;
      }
      if (!handle.$$) {
        throwBindingError('Cannot pass "' + _embind_repr(handle) + '" as a ' + this.name);
      }
      if (!handle.$$.ptr) {
        throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
      }
      if (handle.$$.ptrType.isConst) {
        throwBindingError("Cannot convert argument of type " + handle.$$.ptrType.name + " to parameter type " + this.name);
      }
      var handleClass = handle.$$.ptrType.registeredClass;
      var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
      return ptr;
    }
    function simpleReadValueFromPointer(pointer) {
      return this["fromWireType"](HEAPU32[pointer >> 2]);
    }
    function RegisteredPointer_getPointee(ptr) {
      if (this.rawGetPointee) {
        ptr = this.rawGetPointee(ptr);
      }
      return ptr;
    }
    function RegisteredPointer_destructor(ptr) {
      if (this.rawDestructor) {
        this.rawDestructor(ptr);
      }
    }
    function RegisteredPointer_deleteObject(handle) {
      if (handle !== null) {
        handle["delete"]();
      }
    }
    function downcastPointer(ptr, ptrClass, desiredClass) {
      if (ptrClass === desiredClass) {
        return ptr;
      }
      if (undefined === desiredClass.baseClass) {
        return null;
      }
      var rv = downcastPointer(ptr, ptrClass, desiredClass.baseClass);
      if (rv === null) {
        return null;
      }
      return desiredClass.downcast(rv);
    }
    function getInheritedInstanceCount() {
      return Object.keys(registeredInstances).length;
    }
    function getLiveInheritedInstances() {
      var rv = [];
      for (var k in registeredInstances) {
        if (registeredInstances.hasOwnProperty(k)) {
          rv.push(registeredInstances[k]);
        }
      }
      return rv;
    }
    function setDelayFunction(fn) {
      delayFunction = fn;
      if (deletionQueue.length && delayFunction) {
        delayFunction(flushPendingDeletes);
      }
    }
    function init_embind() {
      Module["getInheritedInstanceCount"] = getInheritedInstanceCount;
      Module["getLiveInheritedInstances"] = getLiveInheritedInstances;
      Module["flushPendingDeletes"] = flushPendingDeletes;
      Module["setDelayFunction"] = setDelayFunction;
    }
    var registeredInstances = {};
    function getBasestPointer(class_, ptr) {
      if (ptr === undefined) {
        throwBindingError("ptr should not be undefined");
      }
      while (class_.baseClass) {
        ptr = class_.upcast(ptr);
        class_ = class_.baseClass;
      }
      return ptr;
    }
    function getInheritedInstance(class_, ptr) {
      ptr = getBasestPointer(class_, ptr);
      return registeredInstances[ptr];
    }
    function makeClassHandle(prototype, record) {
      if (!record.ptrType || !record.ptr) {
        throwInternalError("makeClassHandle requires ptr and ptrType");
      }
      var hasSmartPtrType = !!record.smartPtrType;
      var hasSmartPtr = !!record.smartPtr;
      if (hasSmartPtrType !== hasSmartPtr) {
        throwInternalError("Both smartPtrType and smartPtr must be specified");
      }
      record.count = {
        value: 1
      };
      return attachFinalizer(Object.create(prototype, {
        $$: {
          value: record
        }
      }));
    }
    function RegisteredPointer_fromWireType(ptr) {
      var rawPointer = this.getPointee(ptr);
      if (!rawPointer) {
        this.destructor(ptr);
        return null;
      }
      var registeredInstance = getInheritedInstance(this.registeredClass, rawPointer);
      if (undefined !== registeredInstance) {
        if (0 === registeredInstance.$$.count.value) {
          registeredInstance.$$.ptr = rawPointer;
          registeredInstance.$$.smartPtr = ptr;
          return registeredInstance["clone"]();
        } else {
          var rv = registeredInstance["clone"]();
          this.destructor(ptr);
          return rv;
        }
      }
      function makeDefaultHandle() {
        if (this.isSmartPointer) {
          return makeClassHandle(this.registeredClass.instancePrototype, {
            ptrType: this.pointeeType,
            ptr: rawPointer,
            smartPtrType: this,
            smartPtr: ptr
          });
        } else {
          return makeClassHandle(this.registeredClass.instancePrototype, {
            ptrType: this,
            ptr: ptr
          });
        }
      }
      var actualType = this.registeredClass.getActualType(rawPointer);
      var registeredPointerRecord = registeredPointers[actualType];
      if (!registeredPointerRecord) {
        return makeDefaultHandle.call(this);
      }
      var toType;
      if (this.isConst) {
        toType = registeredPointerRecord.constPointerType;
      } else {
        toType = registeredPointerRecord.pointerType;
      }
      var dp = downcastPointer(rawPointer, this.registeredClass, toType.registeredClass);
      if (dp === null) {
        return makeDefaultHandle.call(this);
      }
      if (this.isSmartPointer) {
        return makeClassHandle(toType.registeredClass.instancePrototype, {
          ptrType: toType,
          ptr: dp,
          smartPtrType: this,
          smartPtr: ptr
        });
      } else {
        return makeClassHandle(toType.registeredClass.instancePrototype, {
          ptrType: toType,
          ptr: dp
        });
      }
    }
    function init_RegisteredPointer() {
      RegisteredPointer.prototype.getPointee = RegisteredPointer_getPointee;
      RegisteredPointer.prototype.destructor = RegisteredPointer_destructor;
      RegisteredPointer.prototype["argPackAdvance"] = 8;
      RegisteredPointer.prototype["readValueFromPointer"] = simpleReadValueFromPointer;
      RegisteredPointer.prototype["deleteObject"] = RegisteredPointer_deleteObject;
      RegisteredPointer.prototype["fromWireType"] = RegisteredPointer_fromWireType;
    }
    function RegisteredPointer(name, registeredClass, isReference, isConst, isSmartPointer, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor) {
      this.name = name;
      this.registeredClass = registeredClass;
      this.isReference = isReference;
      this.isConst = isConst;
      this.isSmartPointer = isSmartPointer;
      this.pointeeType = pointeeType;
      this.sharingPolicy = sharingPolicy;
      this.rawGetPointee = rawGetPointee;
      this.rawConstructor = rawConstructor;
      this.rawShare = rawShare;
      this.rawDestructor = rawDestructor;
      if (!isSmartPointer && registeredClass.baseClass === undefined) {
        if (isConst) {
          this["toWireType"] = constNoSmartPtrRawPointerToWireType;
          this.destructorFunction = null;
        } else {
          this["toWireType"] = nonConstNoSmartPtrRawPointerToWireType;
          this.destructorFunction = null;
        }
      } else {
        this["toWireType"] = genericPointerToWireType;
      }
    }
    function replacePublicSymbol(name, value, numArguments) {
      if (!Module.hasOwnProperty(name)) {
        throwInternalError("Replacing nonexistant public symbol");
      }
      if (undefined !== Module[name].overloadTable && undefined !== numArguments) {
        Module[name].overloadTable[numArguments] = value;
      } else {
        Module[name] = value;
        Module[name].argCount = numArguments;
      }
    }
    function embind__requireFunction(signature, rawFunction) {
      signature = readLatin1String(signature);
      function makeDynCaller(dynCall) {
        var argCache = [rawFunction];
        return function () {
          argCache.length = arguments.length + 1;
          for (var i = 0; i < arguments.length; i++) {
            argCache[i + 1] = arguments[i];
          }
          return dynCall.apply(null, argCache);
        };
      }
      var dc = Module["dynCall_" + signature];
      var fp = makeDynCaller(dc);
      if (typeof fp !== "function") {
        throwBindingError("unknown function pointer with signature " + signature + ": " + rawFunction);
      }
      return fp;
    }
    var UnboundTypeError = undefined;
    function getTypeName(type) {
      var ptr = ___getTypeName(type);
      var rv = readLatin1String(ptr);
      _free(ptr);
      return rv;
    }
    function throwUnboundTypeError(message, types) {
      var unboundTypes = [];
      var seen = {};
      function visit(type) {
        if (seen[type]) {
          return;
        }
        if (registeredTypes[type]) {
          return;
        }
        if (typeDependencies[type]) {
          typeDependencies[type].forEach(visit);
          return;
        }
        unboundTypes.push(type);
        seen[type] = true;
      }
      types.forEach(visit);
      throw new UnboundTypeError(message + ": " + unboundTypes.map(getTypeName).join([", "]));
    }
    function __embind_register_class(rawType, rawPointerType, rawConstPointerType, baseClassRawType, getActualTypeSignature, getActualType, upcastSignature, upcast, downcastSignature, downcast, name, destructorSignature, rawDestructor) {
      name = readLatin1String(name);
      getActualType = embind__requireFunction(getActualTypeSignature, getActualType);
      if (upcast) {
        upcast = embind__requireFunction(upcastSignature, upcast);
      }
      if (downcast) {
        downcast = embind__requireFunction(downcastSignature, downcast);
      }
      rawDestructor = embind__requireFunction(destructorSignature, rawDestructor);
      var legalFunctionName = makeLegalFunctionName(name);
      exposePublicSymbol(legalFunctionName, function () {
        throwUnboundTypeError("Cannot construct " + name + " due to unbound types", [baseClassRawType]);
      });
      whenDependentTypesAreResolved([rawType, rawPointerType, rawConstPointerType], baseClassRawType ? [baseClassRawType] : [], function (base) {
        base = base[0];
        var baseClass;
        var basePrototype;
        if (baseClassRawType) {
          baseClass = base.registeredClass;
          basePrototype = baseClass.instancePrototype;
        } else {
          basePrototype = ClassHandle.prototype;
        }
        var constructor = createNamedFunction(legalFunctionName, function () {
          if (Object.getPrototypeOf(this) !== instancePrototype) {
            throw new BindingError("Use 'new' to construct " + name);
          }
          if (undefined === registeredClass.constructor_body) {
            throw new BindingError(name + " has no accessible constructor");
          }
          var body = registeredClass.constructor_body[arguments.length];
          if (undefined === body) {
            throw new BindingError("Tried to invoke ctor of " + name + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(registeredClass.constructor_body).toString() + ") parameters instead!");
          }
          return body.apply(this, arguments);
        });
        var instancePrototype = Object.create(basePrototype, {
          constructor: {
            value: constructor
          }
        });
        constructor.prototype = instancePrototype;
        var registeredClass = new RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast);
        var referenceConverter = new RegisteredPointer(name, registeredClass, true, false, false);
        var pointerConverter = new RegisteredPointer(name + "*", registeredClass, false, false, false);
        var constPointerConverter = new RegisteredPointer(name + " const*", registeredClass, false, true, false);
        registeredPointers[rawType] = {
          pointerType: pointerConverter,
          constPointerType: constPointerConverter
        };
        replacePublicSymbol(legalFunctionName, constructor);
        return [referenceConverter, pointerConverter, constPointerConverter];
      });
    }
    function heap32VectorToArray(count, firstElement) {
      var array = [];
      for (var i = 0; i < count; i++) {
        array.push(HEAP32[(firstElement >> 2) + i]);
      }
      return array;
    }
    function runDestructors(destructors) {
      while (destructors.length) {
        var ptr = destructors.pop();
        var del = destructors.pop();
        del(ptr);
      }
    }
    function __embind_register_class_constructor(rawClassType, argCount, rawArgTypesAddr, invokerSignature, invoker, rawConstructor) {
      assert(argCount > 0);
      var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
      invoker = embind__requireFunction(invokerSignature, invoker);
      var args = [rawConstructor];
      var destructors = [];
      whenDependentTypesAreResolved([], [rawClassType], function (classType) {
        classType = classType[0];
        var humanName = "constructor " + classType.name;
        if (undefined === classType.registeredClass.constructor_body) {
          classType.registeredClass.constructor_body = [];
        }
        if (undefined !== classType.registeredClass.constructor_body[argCount - 1]) {
          throw new BindingError("Cannot register multiple constructors with identical number of parameters (" + (argCount - 1) + ") for class '" + classType.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
        }
        classType.registeredClass.constructor_body[argCount - 1] = function unboundTypeHandler() {
          throwUnboundTypeError("Cannot construct " + classType.name + " due to unbound types", rawArgTypes);
        };
        whenDependentTypesAreResolved([], rawArgTypes, function (argTypes) {
          classType.registeredClass.constructor_body[argCount - 1] = function constructor_body() {
            if (arguments.length !== argCount - 1) {
              throwBindingError(humanName + " called with " + arguments.length + " arguments, expected " + (argCount - 1));
            }
            destructors.length = 0;
            args.length = argCount;
            for (var i = 1; i < argCount; ++i) {
              args[i] = argTypes[i]["toWireType"](destructors, arguments[i - 1]);
            }
            var ptr = invoker.apply(null, args);
            runDestructors(destructors);
            return argTypes[0]["fromWireType"](ptr);
          };
          return [];
        });
        return [];
      });
    }
    function craftInvokerFunction(humanName, argTypes, classType, cppInvokerFunc, cppTargetFunc) {
      var argCount = argTypes.length;
      if (argCount < 2) {
        throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");
      }
      var isClassMethodFunc = argTypes[1] !== null && classType !== null;
      var needsDestructorStack = false;
      for (var i = 1; i < argTypes.length; ++i) {
        if (argTypes[i] !== null && argTypes[i].destructorFunction === undefined) {
          needsDestructorStack = true;
          break;
        }
      }
      var returns = argTypes[0].name !== "void";
      var expectedArgCount = argCount - 2;
      var argsWired = new Array(expectedArgCount);
      var invokerFuncArgs = [];
      var destructors = [];
      return function () {
        if (arguments.length !== expectedArgCount) {
          throwBindingError("function " + humanName + " called with " + arguments.length + " arguments, expected " + expectedArgCount + " args!");
        }
        destructors.length = 0;
        var thisWired;
        invokerFuncArgs.length = isClassMethodFunc ? 2 : 1;
        invokerFuncArgs[0] = cppTargetFunc;
        if (isClassMethodFunc) {
          thisWired = argTypes[1].toWireType(destructors, this);
          invokerFuncArgs[1] = thisWired;
        }
        for (var i = 0; i < expectedArgCount; ++i) {
          argsWired[i] = argTypes[i + 2].toWireType(destructors, arguments[i]);
          invokerFuncArgs.push(argsWired[i]);
        }
        var rv = cppInvokerFunc.apply(null, invokerFuncArgs);
        if (needsDestructorStack) {
          runDestructors(destructors);
        } else {
          for (var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; i++) {
            var param = i === 1 ? thisWired : argsWired[i - 2];
            if (argTypes[i].destructorFunction !== null) {
              argTypes[i].destructorFunction(param);
            }
          }
        }
        if (returns) {
          return argTypes[0].fromWireType(rv);
        }
      };
    }
    function __embind_register_class_function(rawClassType, methodName, argCount, rawArgTypesAddr, invokerSignature, rawInvoker, context, isPureVirtual) {
      var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
      methodName = readLatin1String(methodName);
      rawInvoker = embind__requireFunction(invokerSignature, rawInvoker);
      whenDependentTypesAreResolved([], [rawClassType], function (classType) {
        classType = classType[0];
        var humanName = classType.name + "." + methodName;
        if (isPureVirtual) {
          classType.registeredClass.pureVirtualFunctions.push(methodName);
        }
        function unboundTypesHandler() {
          throwUnboundTypeError("Cannot call " + humanName + " due to unbound types", rawArgTypes);
        }
        var proto = classType.registeredClass.instancePrototype;
        var method = proto[methodName];
        if (undefined === method || undefined === method.overloadTable && method.className !== classType.name && method.argCount === argCount - 2) {
          unboundTypesHandler.argCount = argCount - 2;
          unboundTypesHandler.className = classType.name;
          proto[methodName] = unboundTypesHandler;
        } else {
          ensureOverloadTable(proto, methodName, humanName);
          proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler;
        }
        whenDependentTypesAreResolved([], rawArgTypes, function (argTypes) {
          var memberFunction = craftInvokerFunction(humanName, argTypes, classType, rawInvoker, context);
          if (undefined === proto[methodName].overloadTable) {
            memberFunction.argCount = argCount - 2;
            proto[methodName] = memberFunction;
          } else {
            proto[methodName].overloadTable[argCount - 2] = memberFunction;
          }
          return [];
        });
        return [];
      });
    }
    var emval_free_list = [];
    var emval_handle_array = [{}, {
      value: undefined
    }, {
      value: null
    }, {
      value: true
    }, {
      value: false
    }];
    function __emval_decref(handle) {
      if (handle > 4 && 0 === --emval_handle_array[handle].refcount) {
        emval_handle_array[handle] = undefined;
        emval_free_list.push(handle);
      }
    }
    function count_emval_handles() {
      var count = 0;
      for (var i = 5; i < emval_handle_array.length; ++i) {
        if (emval_handle_array[i] !== undefined) {
          ++count;
        }
      }
      return count;
    }
    function get_first_emval() {
      for (var i = 5; i < emval_handle_array.length; ++i) {
        if (emval_handle_array[i] !== undefined) {
          return emval_handle_array[i];
        }
      }
      return null;
    }
    function init_emval() {
      Module["count_emval_handles"] = count_emval_handles;
      Module["get_first_emval"] = get_first_emval;
    }
    function __emval_register(value) {
      switch (value) {
        case undefined:
          {
            return 1;
          }
        case null:
          {
            return 2;
          }
        case true:
          {
            return 3;
          }
        case false:
          {
            return 4;
          }
        default:
          {
            var handle = emval_free_list.length ? emval_free_list.pop() : emval_handle_array.length;
            emval_handle_array[handle] = {
              refcount: 1,
              value: value
            };
            return handle;
          }
      }
    }
    function __embind_register_emval(rawType, name) {
      name = readLatin1String(name);
      registerType(rawType, {
        name: name,
        "fromWireType": function fromWireType(handle) {
          var rv = emval_handle_array[handle].value;
          __emval_decref(handle);
          return rv;
        },
        "toWireType": function toWireType(destructors, value) {
          return __emval_register(value);
        },
        "argPackAdvance": 8,
        "readValueFromPointer": simpleReadValueFromPointer,
        destructorFunction: null
      });
    }
    function _embind_repr(v) {
      if (v === null) {
        return "null";
      }
      var t = _typeof(v);
      if (t === "object" || t === "array" || t === "function") {
        return v.toString();
      } else {
        return "" + v;
      }
    }
    function floatReadValueFromPointer(name, shift) {
      switch (shift) {
        case 2:
          return function (pointer) {
            return this["fromWireType"](HEAPF32[pointer >> 2]);
          };
        case 3:
          return function (pointer) {
            return this["fromWireType"](HEAPF64[pointer >> 3]);
          };
        default:
          throw new TypeError("Unknown float type: " + name);
      }
    }
    function __embind_register_float(rawType, name, size) {
      var shift = getShiftFromSize(size);
      name = readLatin1String(name);
      registerType(rawType, {
        name: name,
        "fromWireType": function fromWireType(value) {
          return value;
        },
        "toWireType": function toWireType(destructors, value) {
          if (typeof value !== "number" && typeof value !== "boolean") {
            throw new TypeError('Cannot convert "' + _embind_repr(value) + '" to ' + this.name);
          }
          return value;
        },
        "argPackAdvance": 8,
        "readValueFromPointer": floatReadValueFromPointer(name, shift),
        destructorFunction: null
      });
    }
    function integerReadValueFromPointer(name, shift, signed) {
      switch (shift) {
        case 0:
          return signed ? function readS8FromPointer(pointer) {
            return HEAP8[pointer];
          } : function readU8FromPointer(pointer) {
            return HEAPU8[pointer];
          };
        case 1:
          return signed ? function readS16FromPointer(pointer) {
            return HEAP16[pointer >> 1];
          } : function readU16FromPointer(pointer) {
            return HEAPU16[pointer >> 1];
          };
        case 2:
          return signed ? function readS32FromPointer(pointer) {
            return HEAP32[pointer >> 2];
          } : function readU32FromPointer(pointer) {
            return HEAPU32[pointer >> 2];
          };
        default:
          throw new TypeError("Unknown integer type: " + name);
      }
    }
    function __embind_register_integer(primitiveType, name, size, minRange, maxRange) {
      name = readLatin1String(name);
      if (maxRange === -1) {
        maxRange = 4294967295;
      }
      var shift = getShiftFromSize(size);
      var fromWireType = function fromWireType(value) {
        return value;
      };
      if (minRange === 0) {
        var bitshift = 32 - 8 * size;
        fromWireType = function fromWireType(value) {
          return value << bitshift >>> bitshift;
        };
      }
      var isUnsignedType = name.indexOf("unsigned") != -1;
      registerType(primitiveType, {
        name: name,
        "fromWireType": fromWireType,
        "toWireType": function toWireType(destructors, value) {
          if (typeof value !== "number" && typeof value !== "boolean") {
            throw new TypeError('Cannot convert "' + _embind_repr(value) + '" to ' + this.name);
          }
          if (value < minRange || value > maxRange) {
            throw new TypeError('Passing a number "' + _embind_repr(value) + '" from JS side to C/C++ side to an argument of type "' + name + '", which is outside the valid range [' + minRange + ", " + maxRange + "]!");
          }
          return isUnsignedType ? value >>> 0 : value | 0;
        },
        "argPackAdvance": 8,
        "readValueFromPointer": integerReadValueFromPointer(name, shift, minRange !== 0),
        destructorFunction: null
      });
    }
    function __embind_register_memory_view(rawType, dataTypeIndex, name) {
      var typeMapping = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
      var TA = typeMapping[dataTypeIndex];
      function decodeMemoryView(handle) {
        handle = handle >> 2;
        var heap = HEAPU32;
        var size = heap[handle];
        var data = heap[handle + 1];
        return new TA(buffer, data, size);
      }
      name = readLatin1String(name);
      registerType(rawType, {
        name: name,
        "fromWireType": decodeMemoryView,
        "argPackAdvance": 8,
        "readValueFromPointer": decodeMemoryView
      }, {
        ignoreDuplicateRegistrations: true
      });
    }
    function __embind_register_std_string(rawType, name) {
      name = readLatin1String(name);
      var stdStringIsUTF8 = name === "std::string";
      registerType(rawType, {
        name: name,
        "fromWireType": function fromWireType(value) {
          var length = HEAPU32[value >> 2];
          var str;
          if (stdStringIsUTF8) {
            var decodeStartPtr = value + 4;
            for (var i = 0; i <= length; ++i) {
              var currentBytePtr = value + 4 + i;
              if (HEAPU8[currentBytePtr] == 0 || i == length) {
                var maxRead = currentBytePtr - decodeStartPtr;
                var stringSegment = UTF8ToString(decodeStartPtr, maxRead);
                if (str === undefined) {
                  str = stringSegment;
                } else {
                  str += String.fromCharCode(0);
                  str += stringSegment;
                }
                decodeStartPtr = currentBytePtr + 1;
              }
            }
          } else {
            var a = new Array(length);
            for (var i = 0; i < length; ++i) {
              a[i] = String.fromCharCode(HEAPU8[value + 4 + i]);
            }
            str = a.join("");
          }
          _free(value);
          return str;
        },
        "toWireType": function toWireType(destructors, value) {
          if (value instanceof ArrayBuffer) {
            value = new Uint8Array(value);
          }
          var getLength;
          var valueIsOfTypeString = typeof value === "string";
          if (!(valueIsOfTypeString || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Int8Array)) {
            throwBindingError("Cannot pass non-string to std::string");
          }
          if (stdStringIsUTF8 && valueIsOfTypeString) {
            getLength = function getLength() {
              return lengthBytesUTF8(value);
            };
          } else {
            getLength = function getLength() {
              return value.length;
            };
          }
          var length = getLength();
          var ptr = _malloc(4 + length + 1);
          HEAPU32[ptr >> 2] = length;
          if (stdStringIsUTF8 && valueIsOfTypeString) {
            stringToUTF8(value, ptr + 4, length + 1);
          } else {
            if (valueIsOfTypeString) {
              for (var i = 0; i < length; ++i) {
                var charCode = value.charCodeAt(i);
                if (charCode > 255) {
                  _free(ptr);
                  throwBindingError("String has UTF-16 code units that do not fit in 8 bits");
                }
                HEAPU8[ptr + 4 + i] = charCode;
              }
            } else {
              for (var i = 0; i < length; ++i) {
                HEAPU8[ptr + 4 + i] = value[i];
              }
            }
          }
          if (destructors !== null) {
            destructors.push(_free, ptr);
          }
          return ptr;
        },
        "argPackAdvance": 8,
        "readValueFromPointer": simpleReadValueFromPointer,
        destructorFunction: function destructorFunction(ptr) {
          _free(ptr);
        }
      });
    }
    function __embind_register_std_wstring(rawType, charSize, name) {
      name = readLatin1String(name);
      var decodeString, encodeString, getHeap, lengthBytesUTF, shift;
      if (charSize === 2) {
        decodeString = UTF16ToString;
        encodeString = stringToUTF16;
        lengthBytesUTF = lengthBytesUTF16;
        getHeap = function getHeap() {
          return HEAPU16;
        };
        shift = 1;
      } else if (charSize === 4) {
        decodeString = UTF32ToString;
        encodeString = stringToUTF32;
        lengthBytesUTF = lengthBytesUTF32;
        getHeap = function getHeap() {
          return HEAPU32;
        };
        shift = 2;
      }
      registerType(rawType, {
        name: name,
        "fromWireType": function fromWireType(value) {
          var length = HEAPU32[value >> 2];
          var HEAP = getHeap();
          var str;
          var decodeStartPtr = value + 4;
          for (var i = 0; i <= length; ++i) {
            var currentBytePtr = value + 4 + i * charSize;
            if (HEAP[currentBytePtr >> shift] == 0 || i == length) {
              var maxReadBytes = currentBytePtr - decodeStartPtr;
              var stringSegment = decodeString(decodeStartPtr, maxReadBytes);
              if (str === undefined) {
                str = stringSegment;
              } else {
                str += String.fromCharCode(0);
                str += stringSegment;
              }
              decodeStartPtr = currentBytePtr + charSize;
            }
          }
          _free(value);
          return str;
        },
        "toWireType": function toWireType(destructors, value) {
          if (!(typeof value === "string")) {
            throwBindingError("Cannot pass non-string to C++ string type " + name);
          }
          var length = lengthBytesUTF(value);
          var ptr = _malloc(4 + length + charSize);
          HEAPU32[ptr >> 2] = length >> shift;
          encodeString(value, ptr + 4, length + charSize);
          if (destructors !== null) {
            destructors.push(_free, ptr);
          }
          return ptr;
        },
        "argPackAdvance": 8,
        "readValueFromPointer": simpleReadValueFromPointer,
        destructorFunction: function destructorFunction(ptr) {
          _free(ptr);
        }
      });
    }
    function __embind_register_void(rawType, name) {
      name = readLatin1String(name);
      registerType(rawType, {
        isVoid: true,
        name: name,
        "argPackAdvance": 0,
        "fromWireType": function fromWireType() {
          return undefined;
        },
        "toWireType": function toWireType(destructors, o) {
          return undefined;
        }
      });
    }
    function _abort() {
      abort();
    }
    function _emscripten_get_sbrk_ptr() {
      return 532144;
    }
    function _emscripten_memcpy_big(dest, src, num) {
      HEAPU8.copyWithin(dest, src, src + num);
    }
    function _emscripten_get_heap_size() {
      return HEAPU8.length;
    }
    function emscripten_realloc_buffer(size) {
      try {
        wasmMemory.grow(size - buffer.byteLength + 65535 >>> 16);
        updateGlobalBufferAndViews(wasmMemory.buffer);
        return 1;
      } catch (e) {}
    }
    function _emscripten_resize_heap(requestedSize) {
      requestedSize = requestedSize >>> 0;
      var oldSize = _emscripten_get_heap_size();
      var PAGE_MULTIPLE = 65536;
      var maxHeapSize = 2147483648;
      if (requestedSize > maxHeapSize) {
        return false;
      }
      var minHeapSize = 16777216;
      for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
        var overGrownHeapSize = oldSize * (1 + .2 / cutDown);
        overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
        var newSize = Math.min(maxHeapSize, alignUp(Math.max(minHeapSize, requestedSize, overGrownHeapSize), PAGE_MULTIPLE));
        var replacement = emscripten_realloc_buffer(newSize);
        if (replacement) {
          return true;
        }
      }
      return false;
    }
    function _fd_close(fd) {
      return 0;
    }
    function _fd_fdstat_get(fd, pbuf) {
      var type = fd == 1 || fd == 2 ? 2 : abort();
      HEAP8[pbuf >> 0] = type;
      return 0;
    }
    function _fd_read(fd, iov, iovcnt, pnum) {
      var stream = SYSCALLS.getStreamFromFD(fd);
      var num = SYSCALLS.doReadv(stream, iov, iovcnt);
      HEAP32[pnum >> 2] = num;
      return 0;
    }
    function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {}
    function _fd_write(fd, iov, iovcnt, pnum) {
      var num = 0;
      for (var i = 0; i < iovcnt; i++) {
        var ptr = HEAP32[iov + i * 8 >> 2];
        var len = HEAP32[iov + (i * 8 + 4) >> 2];
        for (var j = 0; j < len; j++) {
          SYSCALLS.printChar(fd, HEAPU8[ptr + j]);
        }
        num += len;
      }
      HEAP32[pnum >> 2] = num;
      return 0;
    }
    function _h264_write_polyfill() {
      err("missing function: h264_write_polyfill");
      abort(-1);
    }
    function _round(d) {
      d = +d;
      return d >= +0 ? +Math_floor(d + +.5) : +Math_ceil(d - +.5);
    }
    function _roundf(d) {
      d = +d;
      return d >= +0 ? +Math_floor(d + +.5) : +Math_ceil(d - +.5);
    }
    function _setTempRet0($i) {
      setTempRet0($i | 0);
    }
    embind_init_charCodes();
    BindingError = Module["BindingError"] = extendError(Error, "BindingError");
    InternalError = Module["InternalError"] = extendError(Error, "InternalError");
    init_ClassHandle();
    init_RegisteredPointer();
    init_embind();
    UnboundTypeError = Module["UnboundTypeError"] = extendError(Error, "UnboundTypeError");
    init_emval();
    var ASSERTIONS = false;
    var asmLibraryArg = {
      "__assert_fail": ___assert_fail,
      "__sys_fcntl64": ___sys_fcntl64,
      "__sys_fstat64": ___sys_fstat64,
      "__sys_ioctl": ___sys_ioctl,
      "__sys_madvise1": ___sys_madvise1,
      "__sys_open": ___sys_open,
      "__sys_rename": ___sys_rename,
      "__sys_stat64": ___sys_stat64,
      "_embind_register_bool": __embind_register_bool,
      "_embind_register_class": __embind_register_class,
      "_embind_register_class_constructor": __embind_register_class_constructor,
      "_embind_register_class_function": __embind_register_class_function,
      "_embind_register_emval": __embind_register_emval,
      "_embind_register_float": __embind_register_float,
      "_embind_register_integer": __embind_register_integer,
      "_embind_register_memory_view": __embind_register_memory_view,
      "_embind_register_std_string": __embind_register_std_string,
      "_embind_register_std_wstring": __embind_register_std_wstring,
      "_embind_register_void": __embind_register_void,
      "abort": _abort,
      "emscripten_get_sbrk_ptr": _emscripten_get_sbrk_ptr,
      "emscripten_memcpy_big": _emscripten_memcpy_big,
      "emscripten_resize_heap": _emscripten_resize_heap,
      "fd_close": _fd_close,
      "fd_fdstat_get": _fd_fdstat_get,
      "fd_read": _fd_read,
      "fd_seek": _fd_seek,
      "fd_write": _fd_write,
      "h264_write_polyfill": _h264_write_polyfill,
      "memory": wasmMemory,
      "round": _round,
      "roundf": _roundf,
      "setTempRet0": _setTempRet0,
      "table": wasmTable
    };
    var asm = createWasm();
    var ___wasm_call_ctors = Module["___wasm_call_ctors"] = function () {
      return (___wasm_call_ctors = Module["___wasm_call_ctors"] = Module["asm"]["__wasm_call_ctors"]).apply(null, arguments);
    };
    var _h264_write = Module["_h264_write"] = function () {
      return (_h264_write = Module["_h264_write"] = Module["asm"]["h264_write"]).apply(null, arguments);
    };
    var _free = Module["_free"] = function () {
      return (_free = Module["_free"] = Module["asm"]["free"]).apply(null, arguments);
    };
    var _malloc = Module["_malloc"] = function () {
      return (_malloc = Module["_malloc"] = Module["asm"]["malloc"]).apply(null, arguments);
    };
    var ___getTypeName = Module["___getTypeName"] = function () {
      return (___getTypeName = Module["___getTypeName"] = Module["asm"]["__getTypeName"]).apply(null, arguments);
    };
    var ___embind_register_native_and_builtin_types = Module["___embind_register_native_and_builtin_types"] = function () {
      return (___embind_register_native_and_builtin_types = Module["___embind_register_native_and_builtin_types"] = Module["asm"]["__embind_register_native_and_builtin_types"]).apply(null, arguments);
    };
    var ___errno_location = Module["___errno_location"] = function () {
      return (___errno_location = Module["___errno_location"] = Module["asm"]["__errno_location"]).apply(null, arguments);
    };
    var stackSave = Module["stackSave"] = function () {
      return (stackSave = Module["stackSave"] = Module["asm"]["stackSave"]).apply(null, arguments);
    };
    var stackRestore = Module["stackRestore"] = function () {
      return (stackRestore = Module["stackRestore"] = Module["asm"]["stackRestore"]).apply(null, arguments);
    };
    var stackAlloc = Module["stackAlloc"] = function () {
      return (stackAlloc = Module["stackAlloc"] = Module["asm"]["stackAlloc"]).apply(null, arguments);
    };
    var __growWasmMemory = Module["__growWasmMemory"] = function () {
      return (__growWasmMemory = Module["__growWasmMemory"] = Module["asm"]["__growWasmMemory"]).apply(null, arguments);
    };
    var dynCall_ii = Module["dynCall_ii"] = function () {
      return (dynCall_ii = Module["dynCall_ii"] = Module["asm"]["dynCall_ii"]).apply(null, arguments);
    };
    var dynCall_vi = Module["dynCall_vi"] = function () {
      return (dynCall_vi = Module["dynCall_vi"] = Module["asm"]["dynCall_vi"]).apply(null, arguments);
    };
    var dynCall_i = Module["dynCall_i"] = function () {
      return (dynCall_i = Module["dynCall_i"] = Module["asm"]["dynCall_i"]).apply(null, arguments);
    };
    var dynCall_iiii = Module["dynCall_iiii"] = function () {
      return (dynCall_iiii = Module["dynCall_iiii"] = Module["asm"]["dynCall_iiii"]).apply(null, arguments);
    };
    var dynCall_iiiii = Module["dynCall_iiiii"] = function () {
      return (dynCall_iiiii = Module["dynCall_iiiii"] = Module["asm"]["dynCall_iiiii"]).apply(null, arguments);
    };
    var dynCall_iii = Module["dynCall_iii"] = function () {
      return (dynCall_iii = Module["dynCall_iii"] = Module["asm"]["dynCall_iii"]).apply(null, arguments);
    };
    var dynCall_viiii = Module["dynCall_viiii"] = function () {
      return (dynCall_viiii = Module["dynCall_viiii"] = Module["asm"]["dynCall_viiii"]).apply(null, arguments);
    };
    var dynCall_iij = Module["dynCall_iij"] = function () {
      return (dynCall_iij = Module["dynCall_iij"] = Module["asm"]["dynCall_iij"]).apply(null, arguments);
    };
    var dynCall_iiiiii = Module["dynCall_iiiiii"] = function () {
      return (dynCall_iiiiii = Module["dynCall_iiiiii"] = Module["asm"]["dynCall_iiiiii"]).apply(null, arguments);
    };
    var dynCall_vii = Module["dynCall_vii"] = function () {
      return (dynCall_vii = Module["dynCall_vii"] = Module["asm"]["dynCall_vii"]).apply(null, arguments);
    };
    var dynCall_viii = Module["dynCall_viii"] = function () {
      return (dynCall_viii = Module["dynCall_viii"] = Module["asm"]["dynCall_viii"]).apply(null, arguments);
    };
    var dynCall_viiiii = Module["dynCall_viiiii"] = function () {
      return (dynCall_viiiii = Module["dynCall_viiiii"] = Module["asm"]["dynCall_viiiii"]).apply(null, arguments);
    };
    var dynCall_viiiiii = Module["dynCall_viiiiii"] = function () {
      return (dynCall_viiiiii = Module["dynCall_viiiiii"] = Module["asm"]["dynCall_viiiiii"]).apply(null, arguments);
    };
    var dynCall_viiiiiii = Module["dynCall_viiiiiii"] = function () {
      return (dynCall_viiiiiii = Module["dynCall_viiiiiii"] = Module["asm"]["dynCall_viiiiiii"]).apply(null, arguments);
    };
    var dynCall_iiiiiiii = Module["dynCall_iiiiiiii"] = function () {
      return (dynCall_iiiiiiii = Module["dynCall_iiiiiiii"] = Module["asm"]["dynCall_iiiiiiii"]).apply(null, arguments);
    };
    var dynCall_jii = Module["dynCall_jii"] = function () {
      return (dynCall_jii = Module["dynCall_jii"] = Module["asm"]["dynCall_jii"]).apply(null, arguments);
    };
    var dynCall_viiiiiiii = Module["dynCall_viiiiiiii"] = function () {
      return (dynCall_viiiiiiii = Module["dynCall_viiiiiiii"] = Module["asm"]["dynCall_viiiiiiii"]).apply(null, arguments);
    };
    var dynCall_fiii = Module["dynCall_fiii"] = function () {
      return (dynCall_fiii = Module["dynCall_fiii"] = Module["asm"]["dynCall_fiii"]).apply(null, arguments);
    };
    var dynCall_viiiiiiiii = Module["dynCall_viiiiiiiii"] = function () {
      return (dynCall_viiiiiiiii = Module["dynCall_viiiiiiiii"] = Module["asm"]["dynCall_viiiiiiiii"]).apply(null, arguments);
    };
    var dynCall_iiiiiiiiii = Module["dynCall_iiiiiiiiii"] = function () {
      return (dynCall_iiiiiiiiii = Module["dynCall_iiiiiiiiii"] = Module["asm"]["dynCall_iiiiiiiiii"]).apply(null, arguments);
    };
    var dynCall_viiiiiiiiiii = Module["dynCall_viiiiiiiiiii"] = function () {
      return (dynCall_viiiiiiiiiii = Module["dynCall_viiiiiiiiiii"] = Module["asm"]["dynCall_viiiiiiiiiii"]).apply(null, arguments);
    };
    var dynCall_jiji = Module["dynCall_jiji"] = function () {
      return (dynCall_jiji = Module["dynCall_jiji"] = Module["asm"]["dynCall_jiji"]).apply(null, arguments);
    };
    var dynCall_iidiiii = Module["dynCall_iidiiii"] = function () {
      return (dynCall_iidiiii = Module["dynCall_iidiiii"] = Module["asm"]["dynCall_iidiiii"]).apply(null, arguments);
    };
    var calledRun;
    function ExitStatus(status) {
      this.name = "ExitStatus";
      this.message = "Program terminated with exit(" + status + ")";
      this.status = status;
    }
    dependenciesFulfilled = function runCaller() {
      if (!calledRun) run();
      if (!calledRun) dependenciesFulfilled = runCaller;
    };
    function run(args) {
      args = args || arguments_;
      if (runDependencies > 0) {
        return;
      }
      preRun();
      if (runDependencies > 0) return;
      function doRun() {
        if (calledRun) return;
        calledRun = true;
        Module["calledRun"] = true;
        if (ABORT) return;
        initRuntime();
        preMain();
        readyPromiseResolve(Module);
        if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
        postRun();
      }
      if (Module["setStatus"]) {
        Module["setStatus"]("Running...");
        setTimeout(function () {
          setTimeout(function () {
            Module["setStatus"]("");
          }, 1);
          doRun();
        }, 1);
      } else {
        doRun();
      }
    }
    Module["run"] = run;
    if (Module["preInit"]) {
      if (typeof Module["preInit"] == "function") Module["preInit"] = [Module["preInit"]];
      while (Module["preInit"].length > 0) {
        Module["preInit"].pop()();
      }
    }
    noExitRuntime = true;
    run();
    return Module.ready;
  };
}();
var _default = exports.default = Module;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var each = __webpack_require__(71)(0);
var redefine = __webpack_require__(37);
var meta = __webpack_require__(87);
var assign = __webpack_require__(179);
var weak = __webpack_require__(377);
var isObject = __webpack_require__(23);
var validate = __webpack_require__(96);
var NATIVE_WEAK_MAP = __webpack_require__(96);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(234)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(75);
var getWeak = __webpack_require__(87).getWeak;
var anObject = __webpack_require__(22);
var isObject = __webpack_require__(23);
var anInstance = __webpack_require__(76);
var forOf = __webpack_require__(101);
var createArrayMethod = __webpack_require__(71);
var $has = __webpack_require__(41);
var validate = __webpack_require__(96);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(18);

$export($export.P, 'Array', { copyWithin: __webpack_require__(168) });

__webpack_require__(85)('copyWithin');


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);
__webpack_require__(31);
__webpack_require__(48);
__webpack_require__(49);
__webpack_require__(13);
__webpack_require__(12);
__webpack_require__(15);
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
__webpack_require__(14);
__webpack_require__(42);
__webpack_require__(30);
__webpack_require__(114);
__webpack_require__(21);
__webpack_require__(16);
__webpack_require__(17);
var _Util = _interopRequireDefault(__webpack_require__(26));
var _webworkifyWebpack = _interopRequireDefault(__webpack_require__(63));
var _protocolConfig = _interopRequireDefault(__webpack_require__(32));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var OPT_MIC_AUDIO_FRAME = _protocolConfig.default.MICROPHONE_MESSAGE_TYPE.OPT_MIC_AUDIO_FRAME;
var MicrophonePlayer = exports.default = /*#__PURE__*/function () {
  function MicrophonePlayer(options) {
    _classCallCheck(this, MicrophonePlayer);
    this.options = _objectSpread({}, options);
    this.sendOutBufHandler = options.sendOutBufHandler;
    this.util = new _Util.default();
    if (this.options.audioOptions) {
      this.audioStream = null;
      this.audioSource = null;
      this.audioScriptNode = null;
      this.audioEncoderWorker = (0, _webworkifyWebpack.default)(/*require.resolve*/(381));
      this.audioEncoderWorker.addEventListener('message', this.audioMessageHandler.bind(this));
      this.initMediaDevices(this.options.audioOptions);
    }
  }
  return _createClass(MicrophonePlayer, [{
    key: "initMediaDevices",
    value: function initMediaDevices(audioOptions) {
      var _this = this;
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia || navigator.msGetUserMedia;
          if (!getUserMedia) {
            return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
          }
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      // video:false，表示不需要访问视频设备（如摄像头）。将 video 设置为 false 表示仅请求音频
      navigator.mediaDevices.getUserMedia({
        video: false,
        audio: audioOptions
      }).then(function (stream) {
        // 音频轨道
        _this.audioStream = stream.getAudioTracks()[0];
        // 打开麦克风
        if (_this.audioStream) {
          _this.audioStreamHandle();
        }
        console.log('打开麦克风');
      }).catch(function (err) {
        console.log(err.name + ': ' + err.message);
      });
    }
  }, {
    key: "audioStreamHandle",
    value: function audioStreamHandle() {
      var _this2 = this;
      var newAudioStream = new MediaStream();
      newAudioStream.addTrack(this.audioStream);
      var audioContext = new AudioContext();
      this.audioSource = audioContext.createMediaStreamSource(newAudioStream);
      this.audioScriptNode = audioContext.createScriptProcessor(4096, 1, 1);
      this.audioScriptNode.onaudioprocess = function (audioProcessEvent) {
        // 获取输入缓冲区
        var inputBuffer = audioProcessEvent.inputBuffer;
        var pcmData = inputBuffer.getChannelData(0);
        if (_this2.options.microPhoneOutputType === 'PCM') {
          // 转换为16位整数
          var initData = new Int16Array(pcmData.length);
          for (var i = 0; i < pcmData.length; i++) {
            initData[i] = pcmData[i] * 32767;
          }
          // 转换为little endian格式
          var littleEndianData = new Uint8Array(initData.length * 2);
          for (var _i = 0; _i < initData.length; _i++) {
            littleEndianData[_i * 2] = initData[_i] & 0xff;
            littleEndianData[_i * 2 + 1] = initData[_i] >> 8 & 0xff;
          }
          _this2.sendOutBufHandler('MICROPHONE', OPT_MIC_AUDIO_FRAME, littleEndianData);
        } else {
          // 处理PCM音频数据
          _this2.audioEncoderWorker.postMessage({
            type: 'encode',
            data: pcmData
          }, [pcmData.buffer]);
        }
      };
      this.audioSource.connect(this.audioScriptNode);
      this.audioScriptNode.connect(audioContext.destination);
    }
  }, {
    key: "audioMessageHandler",
    value: function audioMessageHandler(evt) {
      var _this3 = this;
      var message = evt.data;
      if (!Object.prototype.hasOwnProperty.call(message, 'type')) {
        return;
      }
      switch (message.type) {
        case 'encodeResult':
          {
            var opusData = message.data;
            opusData.forEach(function (itemData) {
              var itemBuffer = new Uint8Array(itemData);
              _this3.sendOutBufHandler('MICROPHONE', OPT_MIC_AUDIO_FRAME, itemBuffer);
            });
            break;
          }
        default:
          break;
      }
    }
  }, {
    key: "stopAudio",
    value: function stopAudio() {
      if (this.audioStream) {
        this.audioStream.stop();
        this.audioSource.disconnect();
        this.audioScriptNode.disconnect();
        this.audioScriptNode.onaudioprocess = null;
      }
    }
  }]);
}();

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _opus = __webpack_require__(222);
// Copyright 2023 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var encoder = new _opus.OpusEncoder(48000, 1, 2049, 20);
self.addEventListener('message', function (evt) {
  var message = evt.data;
  switch (message.type) {
    case 'encode':
      {
        var opusData = encoder.encode_float(message.data);
        self.postMessage({
          type: 'encodeResult',
          data: opusData
        }, []);
        break;
      }
      ;
    default:
    // do nothing
  }
});
function _default() {}

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ lib_axios; });
__webpack_require__.d(__webpack_exports__, "Axios", function() { return /* binding */ axios_Axios; });
__webpack_require__.d(__webpack_exports__, "AxiosError", function() { return /* binding */ axios_AxiosError; });
__webpack_require__.d(__webpack_exports__, "CanceledError", function() { return /* binding */ axios_CanceledError; });
__webpack_require__.d(__webpack_exports__, "isCancel", function() { return /* binding */ axios_isCancel; });
__webpack_require__.d(__webpack_exports__, "CancelToken", function() { return /* binding */ axios_CancelToken; });
__webpack_require__.d(__webpack_exports__, "VERSION", function() { return /* binding */ axios_VERSION; });
__webpack_require__.d(__webpack_exports__, "all", function() { return /* binding */ axios_all; });
__webpack_require__.d(__webpack_exports__, "Cancel", function() { return /* binding */ Cancel; });
__webpack_require__.d(__webpack_exports__, "isAxiosError", function() { return /* binding */ axios_isAxiosError; });
__webpack_require__.d(__webpack_exports__, "spread", function() { return /* binding */ axios_spread; });
__webpack_require__.d(__webpack_exports__, "toFormData", function() { return /* binding */ axios_toFormData; });
__webpack_require__.d(__webpack_exports__, "AxiosHeaders", function() { return /* binding */ axios_AxiosHeaders; });
__webpack_require__.d(__webpack_exports__, "HttpStatusCode", function() { return /* binding */ axios_HttpStatusCode; });
__webpack_require__.d(__webpack_exports__, "formToJSON", function() { return /* binding */ formToJSON; });
__webpack_require__.d(__webpack_exports__, "getAdapter", function() { return /* binding */ getAdapter; });
__webpack_require__.d(__webpack_exports__, "mergeConfig", function() { return /* binding */ axios_mergeConfig; });

// NAMESPACE OBJECT: ./node_modules/axios/lib/platform/common/utils.js
var utils_namespaceObject = {};
__webpack_require__.r(utils_namespaceObject);
__webpack_require__.d(utils_namespaceObject, "hasBrowserEnv", function() { return hasBrowserEnv; });
__webpack_require__.d(utils_namespaceObject, "hasStandardBrowserWebWorkerEnv", function() { return hasStandardBrowserWebWorkerEnv; });
__webpack_require__.d(utils_namespaceObject, "hasStandardBrowserEnv", function() { return hasStandardBrowserEnv; });
__webpack_require__.d(utils_namespaceObject, "navigator", function() { return _navigator; });
__webpack_require__.d(utils_namespaceObject, "origin", function() { return utils_origin; });

// EXTERNAL MODULE: ./node_modules/axios/lib/utils.js
var utils = __webpack_require__(1);

// EXTERNAL MODULE: ./node_modules/axios/lib/helpers/bind.js
var bind = __webpack_require__(115);

// EXTERNAL MODULE: ./node_modules/axios/lib/helpers/toFormData.js
var toFormData = __webpack_require__(58);

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && Object(toFormData["a" /* default */])(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?(object|Function)} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  if (utils["a" /* default */].isFunction(options)) {
    options = {
      serialize: options
    };
  } 

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils["a" /* default */].isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager_InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils["a" /* default */].forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager_InterceptorManager);

// EXTERNAL MODULE: ./node_modules/axios/lib/core/AxiosError.js
var AxiosError = __webpack_require__(8);

// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

// CONCATENATED MODULE: ./node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

const _navigator = typeof navigator === 'object' && navigator || undefined;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = hasBrowserEnv &&
  (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

const utils_origin = hasBrowserEnv && window.location.href || 'http://localhost';



// CONCATENATED MODULE: ./node_modules/axios/lib/platform/index.js



/* harmony default export */ var platform = ({
  ...utils_namespaceObject,
  ...browser
});

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return Object(toFormData["a" /* default */])(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils["a" /* default */].isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils["a" /* default */].matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils["a" /* default */].isArray(target) ? target.length : name;

    if (isLast) {
      if (utils["a" /* default */].hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils["a" /* default */].isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils["a" /* default */].isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils["a" /* default */].isFormData(formData) && utils["a" /* default */].isFunction(formData.entries)) {
    const obj = {};

    utils["a" /* default */].forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils["a" /* default */].isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils["a" /* default */].trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils["a" /* default */].isObject(data);

    if (isObjectPayload && utils["a" /* default */].isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils["a" /* default */].isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils["a" /* default */].isArrayBuffer(data) ||
      utils["a" /* default */].isBuffer(data) ||
      utils["a" /* default */].isStream(data) ||
      utils["a" /* default */].isFile(data) ||
      utils["a" /* default */].isBlob(data) ||
      utils["a" /* default */].isReadableStream(data)
    ) {
      return data;
    }
    if (utils["a" /* default */].isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils["a" /* default */].isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils["a" /* default */].isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return Object(toFormData["a" /* default */])(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (utils["a" /* default */].isResponse(data) || utils["a" /* default */].isReadableStream(data)) {
      return data;
    }

    if (data && utils["a" /* default */].isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError["a" /* default */].from(e, AxiosError["a" /* default */].ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils["a" /* default */].forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ var lib_defaults = (defaults);

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils["a" /* default */].toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils["a" /* default */].isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils["a" /* default */].isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils["a" /* default */].isString(value)) return;

  if (utils["a" /* default */].isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils["a" /* default */].isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils["a" /* default */].toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders_AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils["a" /* default */].findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils["a" /* default */].forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils["a" /* default */].isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils["a" /* default */].isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils["a" /* default */].isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils["a" /* default */].findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils["a" /* default */].isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils["a" /* default */].isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils["a" /* default */].findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils["a" /* default */].findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils["a" /* default */].isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils["a" /* default */].forEach(this, (value, header) => {
      const key = utils["a" /* default */].findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils["a" /* default */].forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils["a" /* default */].isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils["a" /* default */].isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders_AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils["a" /* default */].reduceDescriptors(AxiosHeaders_AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils["a" /* default */].freezeMethods(AxiosHeaders_AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders_AxiosHeaders);

// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils["a" /* default */].forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError["a" /* default */].call(this, message == null ? 'canceled' : message, AxiosError["a" /* default */].ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils["a" /* default */].inherits(CanceledError, AxiosError["a" /* default */], {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

// EXTERNAL MODULE: ./node_modules/axios/lib/helpers/null.js
var helpers_null = __webpack_require__(116);

// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError["a" /* default */](
      'Request failed with status code ' + response.status,
      [AxiosError["a" /* default */].ERR_BAD_REQUEST, AxiosError["a" /* default */].ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/throttle.js
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;

  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  }

  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if ( passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs)
        }, threshold - passed);
      }
    }
  }

  const flush = () => lastArgs && invoke(lastArgs);

  return [throttled, flush];
}

/* harmony default export */ var helpers_throttle = (throttle);

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/progressEventReducer.js




const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return helpers_throttle(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };

    listener(data);
  }, freq);
}

const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;

  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
}

const asyncDecorator = (fn) => (...args) => utils["a" /* default */].asap(() => fn(...args));

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js


/* harmony default export */ var isURLSameOrigin = (platform.hasStandardBrowserEnv ? ((origin, isMSIE) => (url) => {
  url = new URL(url, platform.origin);

  return (
    origin.protocol === url.protocol &&
    origin.host === url.host &&
    (isMSIE || origin.port === url.port)
  );
})(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => true);

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ var cookies = (platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils["a" /* default */].isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils["a" /* default */].isString(path) && cookie.push('path=' + path);

      utils["a" /* default */].isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });


// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, prop, caseless) {
    if (utils["a" /* default */].isPlainObject(target) && utils["a" /* default */].isPlainObject(source)) {
      return utils["a" /* default */].merge.call({caseless}, target, source);
    } else if (utils["a" /* default */].isPlainObject(source)) {
      return utils["a" /* default */].merge({}, source);
    } else if (utils["a" /* default */].isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, prop , caseless) {
    if (!utils["a" /* default */].isUndefined(b)) {
      return getMergedValue(a, b, prop , caseless);
    } else if (!utils["a" /* default */].isUndefined(a)) {
      return getMergedValue(undefined, a, prop , caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils["a" /* default */].isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils["a" /* default */].isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils["a" /* default */].isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b , prop) => mergeDeepProperties(headersToObject(a), headersToObject(b),prop, true)
  };

  utils["a" /* default */].forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils["a" /* default */].isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/resolveConfig.js









/* harmony default export */ var resolveConfig = ((config) => {
  const newConfig = mergeConfig({}, config);

  let {data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth} = newConfig;

  newConfig.headers = headers = core_AxiosHeaders.from(headers);

  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' +
      btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : ''))
    );
  }

  let contentType;

  if (utils["a" /* default */].isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils["a" /* default */].isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));

    if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(newConfig.url))) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
});


// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js











const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = core_AxiosHeaders.from(_config.headers).normalize();
    let {responseType, onUploadProgress, onDownloadProgress} = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;

    function done() {
      flushUpload && flushUpload(); // flush events
      flushDownload && flushDownload(); // flush events

      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);

      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }

    let request = new XMLHttpRequest();

    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError["a" /* default */]('Request aborted', AxiosError["a" /* default */].ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError["a" /* default */]('Network Error', AxiosError["a" /* default */].ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || defaults_transitional;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError["a" /* default */](
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError["a" /* default */].ETIMEDOUT : AxiosError["a" /* default */].ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils["a" /* default */].forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils["a" /* default */].isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (onDownloadProgress) {
      ([downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true));
      request.addEventListener('progress', downloadThrottled);
    }

    // Not all browsers support upload events
    if (onUploadProgress && request.upload) {
      ([uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress));

      request.upload.addEventListener('progress', uploadThrottled);

      request.upload.addEventListener('loadend', flushUpload);
    }

    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(_config.url);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError["a" /* default */]('Unsupported protocol ' + protocol + ':', AxiosError["a" /* default */].ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/composeSignals.js




const composeSignals = (signals, timeout) => {
  const {length} = (signals = signals ? signals.filter(Boolean) : []);

  if (timeout || length) {
    let controller = new AbortController();

    let aborted;

    const onabort = function (reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof AxiosError["a" /* default */] ? err : new cancel_CanceledError(err instanceof Error ? err.message : err));
      }
    }

    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new AxiosError["a" /* default */](`timeout ${timeout} of ms exceeded`, AxiosError["a" /* default */].ETIMEDOUT))
    }, timeout)

    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(signal => {
          signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
      }
    }

    signals.forEach((signal) => signal.addEventListener('abort', onabort));

    const {signal} = controller;

    signal.unsubscribe = () => utils["a" /* default */].asap(unsubscribe);

    return signal;
  }
}

/* harmony default export */ var helpers_composeSignals = (composeSignals);

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/trackStream.js

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
}

const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
}

const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }

  const reader = stream.getReader();
  try {
    for (;;) {
      const {done, value} = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
}

const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);

  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  }

  return new ReadableStream({
    async pull(controller) {
      try {
        const {done, value} = await iterator.next();

        if (done) {
         _onFinish();
          controller.close();
          return;
        }

        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  })
}

// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/fetch.js










const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) :
    async (str) => new Uint8Array(await new Response(str).arrayBuffer())
);

const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false
  }
}

const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;

  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    },
  }).headers.has('Content-Type');

  return duplexAccessed && !hasContentType;
});

const DEFAULT_CHUNK_SIZE = 64 * 1024;

const supportsResponseStream = isReadableStreamSupported &&
  test(() => utils["a" /* default */].isReadableStream(new Response('').body));


const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};

isFetchSupported && (((res) => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = utils["a" /* default */].isFunction(res[type]) ? (res) => res[type]() :
      (_, config) => {
        throw new AxiosError["a" /* default */](`Response type '${type}' is not supported`, AxiosError["a" /* default */].ERR_NOT_SUPPORT, config);
      })
  });
})(new Response));

const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }

  if(utils["a" /* default */].isBlob(body)) {
    return body.size;
  }

  if(utils["a" /* default */].isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: 'POST',
      body,
    });
    return (await _request.arrayBuffer()).byteLength;
  }

  if(utils["a" /* default */].isArrayBufferView(body) || utils["a" /* default */].isArrayBuffer(body)) {
    return body.byteLength;
  }

  if(utils["a" /* default */].isURLSearchParams(body)) {
    body = body + '';
  }

  if(utils["a" /* default */].isString(body)) {
    return (await encodeText(body)).byteLength;
  }
}

const resolveBodyLength = async (headers, body) => {
  const length = utils["a" /* default */].toFiniteNumber(headers.getContentLength());

  return length == null ? getBodyLength(body) : length;
}

/* harmony default export */ var adapters_fetch = (isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);

  responseType = responseType ? (responseType + '').toLowerCase() : 'text';

  let composedSignal = helpers_composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);

  let request;

  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
      composedSignal.unsubscribe();
  });

  let requestContentLength;

  try {
    if (
      onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' &&
      (requestContentLength = await resolveBodyLength(headers, data)) !== 0
    ) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });

      let contentTypeHeader;

      if (utils["a" /* default */].isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader)
      }

      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );

        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }

    if (!utils["a" /* default */].isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }

    // Cloudflare Workers throws when credentials are defined
    // see https://github.com/cloudflare/workerd/issues/902
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : undefined
    });

    let response = await fetch(request);

    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

    if (supportsResponseStream && (onDownloadProgress || (isStreamResponse && unsubscribe))) {
      const options = {};

      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });

      const responseContentLength = utils["a" /* default */].toFiniteNumber(response.headers.get('content-length'));

      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];

      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }

    responseType = responseType || 'text';

    let responseData = await resolvers[utils["a" /* default */].findKey(resolvers, responseType) || 'text'](response, config);

    !isStreamResponse && unsubscribe && unsubscribe();

    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: core_AxiosHeaders.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      })
    })
  } catch (err) {
    unsubscribe && unsubscribe();

    if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError["a" /* default */]('Network Error', AxiosError["a" /* default */].ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      )
    }

    throw AxiosError["a" /* default */].from(err, err && err.code, config, request);
  }
}));



// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/adapters.js






const knownAdapters = {
  http: helpers_null["a" /* default */],
  xhr: xhr,
  fetch: adapters_fetch
}

utils["a" /* default */].forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils["a" /* default */].isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ var adapters_adapters = ({
  getAdapter: (adapters) => {
    adapters = utils["a" /* default */].isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new AxiosError["a" /* default */](`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new AxiosError["a" /* default */](
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});

// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters_adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
const VERSION = "1.7.9";
// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError["a" /* default */](
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError["a" /* default */].ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

validators.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    // eslint-disable-next-line no-console
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  }
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError["a" /* default */]('options must be an object', AxiosError["a" /* default */].ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError["a" /* default */]('option ' + opt + ' must be ' + result, AxiosError["a" /* default */].ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError["a" /* default */]('Unknown option ' + opt, AxiosError["a" /* default */].ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var helpers_validator = ({
  assertOptions,
  validators
});

// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js











const Axios_validators = helpers_validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios_Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};

        Error.captureStackTrace ? Error.captureStackTrace(dummy) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      helpers_validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils["a" /* default */].isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        helpers_validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    helpers_validator.assertOptions(config, {
      baseUrl: Axios_validators.spelling('baseURL'),
      withXsrfToken: Axios_validators.spelling('withXSRFToken')
    }, true);

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils["a" /* default */].merge(
      headers.common,
      headers[config.method]
    );

    headers && utils["a" /* default */].forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils["a" /* default */].forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios_Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils["a" /* default */].forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios_Axios.prototype[method] = generateHTTPMethod();

  Axios_Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios_Axios);

// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken_CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  toAbortSignal() {
    const controller = new AbortController();

    const abort = (err) => {
      controller.abort(err);
    };

    this.subscribe(abort);

    controller.signal.unsubscribe = () => this.unsubscribe(abort);

    return controller.signal;
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken_CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken_CancelToken);

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils["a" /* default */].isObject(payload) && (payload.isAxiosError === true);
}

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = Object(bind["a" /* default */])(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils["a" /* default */].extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils["a" /* default */].extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData["a" /* default */];

// Expose AxiosError class
axios.AxiosError = AxiosError["a" /* default */];

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils["a" /* default */].isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters_adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);

// CONCATENATED MODULE: ./node_modules/axios/index.js


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const {
  Axios: axios_Axios,
  AxiosError: axios_AxiosError,
  CanceledError: axios_CanceledError,
  isCancel: axios_isCancel,
  CancelToken: axios_CancelToken,
  VERSION: axios_VERSION,
  all: axios_all,
  Cancel,
  isAxiosError: axios_isAxiosError,
  spread: axios_spread,
  toFormData: axios_toFormData,
  AxiosHeaders: axios_AxiosHeaders,
  HttpStatusCode: axios_HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig: axios_mergeConfig
} = lib_axios;




/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "glMatrix", function() { return /* reexport */ common_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "mat2", function() { return /* reexport */ mat2_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "mat2d", function() { return /* reexport */ mat2d_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "mat3", function() { return /* reexport */ mat3_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "mat4", function() { return /* reexport */ mat4_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "quat", function() { return /* reexport */ quat_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "quat2", function() { return /* reexport */ quat2_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "vec2", function() { return /* reexport */ vec2_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "vec3", function() { return /* reexport */ vec3_namespaceObject; });
__webpack_require__.d(__webpack_exports__, "vec4", function() { return /* reexport */ vec4_namespaceObject; });

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/common.js
var common_namespaceObject = {};
__webpack_require__.r(common_namespaceObject);
__webpack_require__.d(common_namespaceObject, "EPSILON", function() { return EPSILON; });
__webpack_require__.d(common_namespaceObject, "ARRAY_TYPE", function() { return ARRAY_TYPE; });
__webpack_require__.d(common_namespaceObject, "RANDOM", function() { return RANDOM; });
__webpack_require__.d(common_namespaceObject, "setMatrixArrayType", function() { return setMatrixArrayType; });
__webpack_require__.d(common_namespaceObject, "toRadian", function() { return toRadian; });
__webpack_require__.d(common_namespaceObject, "equals", function() { return equals; });

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/mat2.js
var mat2_namespaceObject = {};
__webpack_require__.r(mat2_namespaceObject);
__webpack_require__.d(mat2_namespaceObject, "create", function() { return create; });
__webpack_require__.d(mat2_namespaceObject, "clone", function() { return clone; });
__webpack_require__.d(mat2_namespaceObject, "copy", function() { return copy; });
__webpack_require__.d(mat2_namespaceObject, "identity", function() { return identity; });
__webpack_require__.d(mat2_namespaceObject, "fromValues", function() { return fromValues; });
__webpack_require__.d(mat2_namespaceObject, "set", function() { return set; });
__webpack_require__.d(mat2_namespaceObject, "transpose", function() { return transpose; });
__webpack_require__.d(mat2_namespaceObject, "invert", function() { return invert; });
__webpack_require__.d(mat2_namespaceObject, "adjoint", function() { return adjoint; });
__webpack_require__.d(mat2_namespaceObject, "determinant", function() { return determinant; });
__webpack_require__.d(mat2_namespaceObject, "multiply", function() { return multiply; });
__webpack_require__.d(mat2_namespaceObject, "rotate", function() { return rotate; });
__webpack_require__.d(mat2_namespaceObject, "scale", function() { return mat2_scale; });
__webpack_require__.d(mat2_namespaceObject, "fromRotation", function() { return fromRotation; });
__webpack_require__.d(mat2_namespaceObject, "fromScaling", function() { return fromScaling; });
__webpack_require__.d(mat2_namespaceObject, "str", function() { return str; });
__webpack_require__.d(mat2_namespaceObject, "frob", function() { return frob; });
__webpack_require__.d(mat2_namespaceObject, "LDU", function() { return LDU; });
__webpack_require__.d(mat2_namespaceObject, "add", function() { return add; });
__webpack_require__.d(mat2_namespaceObject, "subtract", function() { return subtract; });
__webpack_require__.d(mat2_namespaceObject, "exactEquals", function() { return exactEquals; });
__webpack_require__.d(mat2_namespaceObject, "equals", function() { return mat2_equals; });
__webpack_require__.d(mat2_namespaceObject, "multiplyScalar", function() { return multiplyScalar; });
__webpack_require__.d(mat2_namespaceObject, "multiplyScalarAndAdd", function() { return multiplyScalarAndAdd; });
__webpack_require__.d(mat2_namespaceObject, "mul", function() { return mul; });
__webpack_require__.d(mat2_namespaceObject, "sub", function() { return sub; });

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/mat2d.js
var mat2d_namespaceObject = {};
__webpack_require__.r(mat2d_namespaceObject);
__webpack_require__.d(mat2d_namespaceObject, "create", function() { return mat2d_create; });
__webpack_require__.d(mat2d_namespaceObject, "clone", function() { return mat2d_clone; });
__webpack_require__.d(mat2d_namespaceObject, "copy", function() { return mat2d_copy; });
__webpack_require__.d(mat2d_namespaceObject, "identity", function() { return mat2d_identity; });
__webpack_require__.d(mat2d_namespaceObject, "fromValues", function() { return mat2d_fromValues; });
__webpack_require__.d(mat2d_namespaceObject, "set", function() { return mat2d_set; });
__webpack_require__.d(mat2d_namespaceObject, "invert", function() { return mat2d_invert; });
__webpack_require__.d(mat2d_namespaceObject, "determinant", function() { return mat2d_determinant; });
__webpack_require__.d(mat2d_namespaceObject, "multiply", function() { return mat2d_multiply; });
__webpack_require__.d(mat2d_namespaceObject, "rotate", function() { return mat2d_rotate; });
__webpack_require__.d(mat2d_namespaceObject, "scale", function() { return mat2d_scale; });
__webpack_require__.d(mat2d_namespaceObject, "translate", function() { return translate; });
__webpack_require__.d(mat2d_namespaceObject, "fromRotation", function() { return mat2d_fromRotation; });
__webpack_require__.d(mat2d_namespaceObject, "fromScaling", function() { return mat2d_fromScaling; });
__webpack_require__.d(mat2d_namespaceObject, "fromTranslation", function() { return fromTranslation; });
__webpack_require__.d(mat2d_namespaceObject, "str", function() { return mat2d_str; });
__webpack_require__.d(mat2d_namespaceObject, "frob", function() { return mat2d_frob; });
__webpack_require__.d(mat2d_namespaceObject, "add", function() { return mat2d_add; });
__webpack_require__.d(mat2d_namespaceObject, "subtract", function() { return mat2d_subtract; });
__webpack_require__.d(mat2d_namespaceObject, "multiplyScalar", function() { return mat2d_multiplyScalar; });
__webpack_require__.d(mat2d_namespaceObject, "multiplyScalarAndAdd", function() { return mat2d_multiplyScalarAndAdd; });
__webpack_require__.d(mat2d_namespaceObject, "exactEquals", function() { return mat2d_exactEquals; });
__webpack_require__.d(mat2d_namespaceObject, "equals", function() { return mat2d_equals; });
__webpack_require__.d(mat2d_namespaceObject, "mul", function() { return mat2d_mul; });
__webpack_require__.d(mat2d_namespaceObject, "sub", function() { return mat2d_sub; });

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/mat3.js
var mat3_namespaceObject = {};
__webpack_require__.r(mat3_namespaceObject);
__webpack_require__.d(mat3_namespaceObject, "create", function() { return mat3_create; });
__webpack_require__.d(mat3_namespaceObject, "fromMat4", function() { return fromMat4; });
__webpack_require__.d(mat3_namespaceObject, "clone", function() { return mat3_clone; });
__webpack_require__.d(mat3_namespaceObject, "copy", function() { return mat3_copy; });
__webpack_require__.d(mat3_namespaceObject, "fromValues", function() { return mat3_fromValues; });
__webpack_require__.d(mat3_namespaceObject, "set", function() { return mat3_set; });
__webpack_require__.d(mat3_namespaceObject, "identity", function() { return mat3_identity; });
__webpack_require__.d(mat3_namespaceObject, "transpose", function() { return mat3_transpose; });
__webpack_require__.d(mat3_namespaceObject, "invert", function() { return mat3_invert; });
__webpack_require__.d(mat3_namespaceObject, "adjoint", function() { return mat3_adjoint; });
__webpack_require__.d(mat3_namespaceObject, "determinant", function() { return mat3_determinant; });
__webpack_require__.d(mat3_namespaceObject, "multiply", function() { return mat3_multiply; });
__webpack_require__.d(mat3_namespaceObject, "translate", function() { return mat3_translate; });
__webpack_require__.d(mat3_namespaceObject, "rotate", function() { return mat3_rotate; });
__webpack_require__.d(mat3_namespaceObject, "scale", function() { return mat3_scale; });
__webpack_require__.d(mat3_namespaceObject, "fromTranslation", function() { return mat3_fromTranslation; });
__webpack_require__.d(mat3_namespaceObject, "fromRotation", function() { return mat3_fromRotation; });
__webpack_require__.d(mat3_namespaceObject, "fromScaling", function() { return mat3_fromScaling; });
__webpack_require__.d(mat3_namespaceObject, "fromMat2d", function() { return fromMat2d; });
__webpack_require__.d(mat3_namespaceObject, "fromQuat", function() { return fromQuat; });
__webpack_require__.d(mat3_namespaceObject, "normalFromMat4", function() { return normalFromMat4; });
__webpack_require__.d(mat3_namespaceObject, "projection", function() { return projection; });
__webpack_require__.d(mat3_namespaceObject, "str", function() { return mat3_str; });
__webpack_require__.d(mat3_namespaceObject, "frob", function() { return mat3_frob; });
__webpack_require__.d(mat3_namespaceObject, "add", function() { return mat3_add; });
__webpack_require__.d(mat3_namespaceObject, "subtract", function() { return mat3_subtract; });
__webpack_require__.d(mat3_namespaceObject, "multiplyScalar", function() { return mat3_multiplyScalar; });
__webpack_require__.d(mat3_namespaceObject, "multiplyScalarAndAdd", function() { return mat3_multiplyScalarAndAdd; });
__webpack_require__.d(mat3_namespaceObject, "exactEquals", function() { return mat3_exactEquals; });
__webpack_require__.d(mat3_namespaceObject, "equals", function() { return mat3_equals; });
__webpack_require__.d(mat3_namespaceObject, "mul", function() { return mat3_mul; });
__webpack_require__.d(mat3_namespaceObject, "sub", function() { return mat3_sub; });

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/mat4.js
var mat4_namespaceObject = {};
__webpack_require__.r(mat4_namespaceObject);
__webpack_require__.d(mat4_namespaceObject, "create", function() { return mat4_create; });
__webpack_require__.d(mat4_namespaceObject, "clone", function() { return mat4_clone; });
__webpack_require__.d(mat4_namespaceObject, "copy", function() { return mat4_copy; });
__webpack_require__.d(mat4_namespaceObject, "fromValues", function() { return mat4_fromValues; });
__webpack_require__.d(mat4_namespaceObject, "set", function() { return mat4_set; });
__webpack_require__.d(mat4_namespaceObject, "identity", function() { return mat4_identity; });
__webpack_require__.d(mat4_namespaceObject, "transpose", function() { return mat4_transpose; });
__webpack_require__.d(mat4_namespaceObject, "invert", function() { return mat4_invert; });
__webpack_require__.d(mat4_namespaceObject, "adjoint", function() { return mat4_adjoint; });
__webpack_require__.d(mat4_namespaceObject, "determinant", function() { return mat4_determinant; });
__webpack_require__.d(mat4_namespaceObject, "multiply", function() { return mat4_multiply; });
__webpack_require__.d(mat4_namespaceObject, "translate", function() { return mat4_translate; });
__webpack_require__.d(mat4_namespaceObject, "scale", function() { return mat4_scale; });
__webpack_require__.d(mat4_namespaceObject, "rotate", function() { return mat4_rotate; });
__webpack_require__.d(mat4_namespaceObject, "rotateX", function() { return rotateX; });
__webpack_require__.d(mat4_namespaceObject, "rotateY", function() { return rotateY; });
__webpack_require__.d(mat4_namespaceObject, "rotateZ", function() { return rotateZ; });
__webpack_require__.d(mat4_namespaceObject, "fromTranslation", function() { return mat4_fromTranslation; });
__webpack_require__.d(mat4_namespaceObject, "fromScaling", function() { return mat4_fromScaling; });
__webpack_require__.d(mat4_namespaceObject, "fromRotation", function() { return mat4_fromRotation; });
__webpack_require__.d(mat4_namespaceObject, "fromXRotation", function() { return fromXRotation; });
__webpack_require__.d(mat4_namespaceObject, "fromYRotation", function() { return fromYRotation; });
__webpack_require__.d(mat4_namespaceObject, "fromZRotation", function() { return fromZRotation; });
__webpack_require__.d(mat4_namespaceObject, "fromRotationTranslation", function() { return fromRotationTranslation; });
__webpack_require__.d(mat4_namespaceObject, "fromQuat2", function() { return fromQuat2; });
__webpack_require__.d(mat4_namespaceObject, "getTranslation", function() { return getTranslation; });
__webpack_require__.d(mat4_namespaceObject, "getScaling", function() { return getScaling; });
__webpack_require__.d(mat4_namespaceObject, "getRotation", function() { return getRotation; });
__webpack_require__.d(mat4_namespaceObject, "fromRotationTranslationScale", function() { return fromRotationTranslationScale; });
__webpack_require__.d(mat4_namespaceObject, "fromRotationTranslationScaleOrigin", function() { return fromRotationTranslationScaleOrigin; });
__webpack_require__.d(mat4_namespaceObject, "fromQuat", function() { return mat4_fromQuat; });
__webpack_require__.d(mat4_namespaceObject, "frustum", function() { return frustum; });
__webpack_require__.d(mat4_namespaceObject, "perspectiveNO", function() { return perspectiveNO; });
__webpack_require__.d(mat4_namespaceObject, "perspective", function() { return perspective; });
__webpack_require__.d(mat4_namespaceObject, "perspectiveZO", function() { return perspectiveZO; });
__webpack_require__.d(mat4_namespaceObject, "perspectiveFromFieldOfView", function() { return perspectiveFromFieldOfView; });
__webpack_require__.d(mat4_namespaceObject, "orthoNO", function() { return orthoNO; });
__webpack_require__.d(mat4_namespaceObject, "ortho", function() { return ortho; });
__webpack_require__.d(mat4_namespaceObject, "orthoZO", function() { return orthoZO; });
__webpack_require__.d(mat4_namespaceObject, "lookAt", function() { return lookAt; });
__webpack_require__.d(mat4_namespaceObject, "targetTo", function() { return targetTo; });
__webpack_require__.d(mat4_namespaceObject, "str", function() { return mat4_str; });
__webpack_require__.d(mat4_namespaceObject, "frob", function() { return mat4_frob; });
__webpack_require__.d(mat4_namespaceObject, "add", function() { return mat4_add; });
__webpack_require__.d(mat4_namespaceObject, "subtract", function() { return mat4_subtract; });
__webpack_require__.d(mat4_namespaceObject, "multiplyScalar", function() { return mat4_multiplyScalar; });
__webpack_require__.d(mat4_namespaceObject, "multiplyScalarAndAdd", function() { return mat4_multiplyScalarAndAdd; });
__webpack_require__.d(mat4_namespaceObject, "exactEquals", function() { return mat4_exactEquals; });
__webpack_require__.d(mat4_namespaceObject, "equals", function() { return mat4_equals; });
__webpack_require__.d(mat4_namespaceObject, "mul", function() { return mat4_mul; });
__webpack_require__.d(mat4_namespaceObject, "sub", function() { return mat4_sub; });

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/vec3.js
var vec3_namespaceObject = {};
__webpack_require__.r(vec3_namespaceObject);
__webpack_require__.d(vec3_namespaceObject, "create", function() { return vec3_create; });
__webpack_require__.d(vec3_namespaceObject, "clone", function() { return vec3_clone; });
__webpack_require__.d(vec3_namespaceObject, "length", function() { return vec3_length; });
__webpack_require__.d(vec3_namespaceObject, "fromValues", function() { return vec3_fromValues; });
__webpack_require__.d(vec3_namespaceObject, "copy", function() { return vec3_copy; });
__webpack_require__.d(vec3_namespaceObject, "set", function() { return vec3_set; });
__webpack_require__.d(vec3_namespaceObject, "add", function() { return vec3_add; });
__webpack_require__.d(vec3_namespaceObject, "subtract", function() { return vec3_subtract; });
__webpack_require__.d(vec3_namespaceObject, "multiply", function() { return vec3_multiply; });
__webpack_require__.d(vec3_namespaceObject, "divide", function() { return divide; });
__webpack_require__.d(vec3_namespaceObject, "ceil", function() { return ceil; });
__webpack_require__.d(vec3_namespaceObject, "floor", function() { return floor; });
__webpack_require__.d(vec3_namespaceObject, "min", function() { return min; });
__webpack_require__.d(vec3_namespaceObject, "max", function() { return max; });
__webpack_require__.d(vec3_namespaceObject, "round", function() { return round; });
__webpack_require__.d(vec3_namespaceObject, "scale", function() { return vec3_scale; });
__webpack_require__.d(vec3_namespaceObject, "scaleAndAdd", function() { return scaleAndAdd; });
__webpack_require__.d(vec3_namespaceObject, "distance", function() { return distance; });
__webpack_require__.d(vec3_namespaceObject, "squaredDistance", function() { return squaredDistance; });
__webpack_require__.d(vec3_namespaceObject, "squaredLength", function() { return squaredLength; });
__webpack_require__.d(vec3_namespaceObject, "negate", function() { return negate; });
__webpack_require__.d(vec3_namespaceObject, "inverse", function() { return inverse; });
__webpack_require__.d(vec3_namespaceObject, "normalize", function() { return normalize; });
__webpack_require__.d(vec3_namespaceObject, "dot", function() { return vec3_dot; });
__webpack_require__.d(vec3_namespaceObject, "cross", function() { return cross; });
__webpack_require__.d(vec3_namespaceObject, "lerp", function() { return lerp; });
__webpack_require__.d(vec3_namespaceObject, "hermite", function() { return hermite; });
__webpack_require__.d(vec3_namespaceObject, "bezier", function() { return bezier; });
__webpack_require__.d(vec3_namespaceObject, "random", function() { return random; });
__webpack_require__.d(vec3_namespaceObject, "transformMat4", function() { return transformMat4; });
__webpack_require__.d(vec3_namespaceObject, "transformMat3", function() { return transformMat3; });
__webpack_require__.d(vec3_namespaceObject, "transformQuat", function() { return transformQuat; });
__webpack_require__.d(vec3_namespaceObject, "rotateX", function() { return vec3_rotateX; });
__webpack_require__.d(vec3_namespaceObject, "rotateY", function() { return vec3_rotateY; });
__webpack_require__.d(vec3_namespaceObject, "rotateZ", function() { return vec3_rotateZ; });
__webpack_require__.d(vec3_namespaceObject, "angle", function() { return angle; });
__webpack_require__.d(vec3_namespaceObject, "zero", function() { return zero; });
__webpack_require__.d(vec3_namespaceObject, "str", function() { return vec3_str; });
__webpack_require__.d(vec3_namespaceObject, "exactEquals", function() { return vec3_exactEquals; });
__webpack_require__.d(vec3_namespaceObject, "equals", function() { return vec3_equals; });
__webpack_require__.d(vec3_namespaceObject, "sub", function() { return vec3_sub; });
__webpack_require__.d(vec3_namespaceObject, "mul", function() { return vec3_mul; });
__webpack_require__.d(vec3_namespaceObject, "div", function() { return div; });
__webpack_require__.d(vec3_namespaceObject, "dist", function() { return dist; });
__webpack_require__.d(vec3_namespaceObject, "sqrDist", function() { return sqrDist; });
__webpack_require__.d(vec3_namespaceObject, "len", function() { return vec3_len; });
__webpack_require__.d(vec3_namespaceObject, "sqrLen", function() { return sqrLen; });
__webpack_require__.d(vec3_namespaceObject, "forEach", function() { return forEach; });

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/vec4.js
var vec4_namespaceObject = {};
__webpack_require__.r(vec4_namespaceObject);
__webpack_require__.d(vec4_namespaceObject, "create", function() { return vec4_create; });
__webpack_require__.d(vec4_namespaceObject, "clone", function() { return vec4_clone; });
__webpack_require__.d(vec4_namespaceObject, "fromValues", function() { return vec4_fromValues; });
__webpack_require__.d(vec4_namespaceObject, "copy", function() { return vec4_copy; });
__webpack_require__.d(vec4_namespaceObject, "set", function() { return vec4_set; });
__webpack_require__.d(vec4_namespaceObject, "add", function() { return vec4_add; });
__webpack_require__.d(vec4_namespaceObject, "subtract", function() { return vec4_subtract; });
__webpack_require__.d(vec4_namespaceObject, "multiply", function() { return vec4_multiply; });
__webpack_require__.d(vec4_namespaceObject, "divide", function() { return vec4_divide; });
__webpack_require__.d(vec4_namespaceObject, "ceil", function() { return vec4_ceil; });
__webpack_require__.d(vec4_namespaceObject, "floor", function() { return vec4_floor; });
__webpack_require__.d(vec4_namespaceObject, "min", function() { return vec4_min; });
__webpack_require__.d(vec4_namespaceObject, "max", function() { return vec4_max; });
__webpack_require__.d(vec4_namespaceObject, "round", function() { return vec4_round; });
__webpack_require__.d(vec4_namespaceObject, "scale", function() { return vec4_scale; });
__webpack_require__.d(vec4_namespaceObject, "scaleAndAdd", function() { return vec4_scaleAndAdd; });
__webpack_require__.d(vec4_namespaceObject, "distance", function() { return vec4_distance; });
__webpack_require__.d(vec4_namespaceObject, "squaredDistance", function() { return vec4_squaredDistance; });
__webpack_require__.d(vec4_namespaceObject, "length", function() { return vec4_length; });
__webpack_require__.d(vec4_namespaceObject, "squaredLength", function() { return vec4_squaredLength; });
__webpack_require__.d(vec4_namespaceObject, "negate", function() { return vec4_negate; });
__webpack_require__.d(vec4_namespaceObject, "inverse", function() { return vec4_inverse; });
__webpack_require__.d(vec4_namespaceObject, "normalize", function() { return vec4_normalize; });
__webpack_require__.d(vec4_namespaceObject, "dot", function() { return vec4_dot; });
__webpack_require__.d(vec4_namespaceObject, "cross", function() { return vec4_cross; });
__webpack_require__.d(vec4_namespaceObject, "lerp", function() { return vec4_lerp; });
__webpack_require__.d(vec4_namespaceObject, "random", function() { return vec4_random; });
__webpack_require__.d(vec4_namespaceObject, "transformMat4", function() { return vec4_transformMat4; });
__webpack_require__.d(vec4_namespaceObject, "transformQuat", function() { return vec4_transformQuat; });
__webpack_require__.d(vec4_namespaceObject, "zero", function() { return vec4_zero; });
__webpack_require__.d(vec4_namespaceObject, "str", function() { return vec4_str; });
__webpack_require__.d(vec4_namespaceObject, "exactEquals", function() { return vec4_exactEquals; });
__webpack_require__.d(vec4_namespaceObject, "equals", function() { return vec4_equals; });
__webpack_require__.d(vec4_namespaceObject, "sub", function() { return vec4_sub; });
__webpack_require__.d(vec4_namespaceObject, "mul", function() { return vec4_mul; });
__webpack_require__.d(vec4_namespaceObject, "div", function() { return vec4_div; });
__webpack_require__.d(vec4_namespaceObject, "dist", function() { return vec4_dist; });
__webpack_require__.d(vec4_namespaceObject, "sqrDist", function() { return vec4_sqrDist; });
__webpack_require__.d(vec4_namespaceObject, "len", function() { return vec4_len; });
__webpack_require__.d(vec4_namespaceObject, "sqrLen", function() { return vec4_sqrLen; });
__webpack_require__.d(vec4_namespaceObject, "forEach", function() { return vec4_forEach; });

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/quat.js
var quat_namespaceObject = {};
__webpack_require__.r(quat_namespaceObject);
__webpack_require__.d(quat_namespaceObject, "create", function() { return quat_create; });
__webpack_require__.d(quat_namespaceObject, "identity", function() { return quat_identity; });
__webpack_require__.d(quat_namespaceObject, "setAxisAngle", function() { return setAxisAngle; });
__webpack_require__.d(quat_namespaceObject, "getAxisAngle", function() { return getAxisAngle; });
__webpack_require__.d(quat_namespaceObject, "getAngle", function() { return getAngle; });
__webpack_require__.d(quat_namespaceObject, "multiply", function() { return quat_multiply; });
__webpack_require__.d(quat_namespaceObject, "rotateX", function() { return quat_rotateX; });
__webpack_require__.d(quat_namespaceObject, "rotateY", function() { return quat_rotateY; });
__webpack_require__.d(quat_namespaceObject, "rotateZ", function() { return quat_rotateZ; });
__webpack_require__.d(quat_namespaceObject, "calculateW", function() { return calculateW; });
__webpack_require__.d(quat_namespaceObject, "exp", function() { return exp; });
__webpack_require__.d(quat_namespaceObject, "ln", function() { return ln; });
__webpack_require__.d(quat_namespaceObject, "pow", function() { return pow; });
__webpack_require__.d(quat_namespaceObject, "slerp", function() { return slerp; });
__webpack_require__.d(quat_namespaceObject, "random", function() { return quat_random; });
__webpack_require__.d(quat_namespaceObject, "invert", function() { return quat_invert; });
__webpack_require__.d(quat_namespaceObject, "conjugate", function() { return conjugate; });
__webpack_require__.d(quat_namespaceObject, "fromMat3", function() { return fromMat3; });
__webpack_require__.d(quat_namespaceObject, "fromEuler", function() { return fromEuler; });
__webpack_require__.d(quat_namespaceObject, "str", function() { return quat_str; });
__webpack_require__.d(quat_namespaceObject, "clone", function() { return quat_clone; });
__webpack_require__.d(quat_namespaceObject, "fromValues", function() { return quat_fromValues; });
__webpack_require__.d(quat_namespaceObject, "copy", function() { return quat_copy; });
__webpack_require__.d(quat_namespaceObject, "set", function() { return quat_set; });
__webpack_require__.d(quat_namespaceObject, "add", function() { return quat_add; });
__webpack_require__.d(quat_namespaceObject, "mul", function() { return quat_mul; });
__webpack_require__.d(quat_namespaceObject, "scale", function() { return quat_scale; });
__webpack_require__.d(quat_namespaceObject, "dot", function() { return quat_dot; });
__webpack_require__.d(quat_namespaceObject, "lerp", function() { return quat_lerp; });
__webpack_require__.d(quat_namespaceObject, "length", function() { return quat_length; });
__webpack_require__.d(quat_namespaceObject, "len", function() { return quat_len; });
__webpack_require__.d(quat_namespaceObject, "squaredLength", function() { return quat_squaredLength; });
__webpack_require__.d(quat_namespaceObject, "sqrLen", function() { return quat_sqrLen; });
__webpack_require__.d(quat_namespaceObject, "normalize", function() { return quat_normalize; });
__webpack_require__.d(quat_namespaceObject, "exactEquals", function() { return quat_exactEquals; });
__webpack_require__.d(quat_namespaceObject, "equals", function() { return quat_equals; });
__webpack_require__.d(quat_namespaceObject, "rotationTo", function() { return rotationTo; });
__webpack_require__.d(quat_namespaceObject, "sqlerp", function() { return sqlerp; });
__webpack_require__.d(quat_namespaceObject, "setAxes", function() { return setAxes; });

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/quat2.js
var quat2_namespaceObject = {};
__webpack_require__.r(quat2_namespaceObject);
__webpack_require__.d(quat2_namespaceObject, "create", function() { return quat2_create; });
__webpack_require__.d(quat2_namespaceObject, "clone", function() { return quat2_clone; });
__webpack_require__.d(quat2_namespaceObject, "fromValues", function() { return quat2_fromValues; });
__webpack_require__.d(quat2_namespaceObject, "fromRotationTranslationValues", function() { return fromRotationTranslationValues; });
__webpack_require__.d(quat2_namespaceObject, "fromRotationTranslation", function() { return quat2_fromRotationTranslation; });
__webpack_require__.d(quat2_namespaceObject, "fromTranslation", function() { return quat2_fromTranslation; });
__webpack_require__.d(quat2_namespaceObject, "fromRotation", function() { return quat2_fromRotation; });
__webpack_require__.d(quat2_namespaceObject, "fromMat4", function() { return quat2_fromMat4; });
__webpack_require__.d(quat2_namespaceObject, "copy", function() { return quat2_copy; });
__webpack_require__.d(quat2_namespaceObject, "identity", function() { return quat2_identity; });
__webpack_require__.d(quat2_namespaceObject, "set", function() { return quat2_set; });
__webpack_require__.d(quat2_namespaceObject, "getReal", function() { return getReal; });
__webpack_require__.d(quat2_namespaceObject, "getDual", function() { return getDual; });
__webpack_require__.d(quat2_namespaceObject, "setReal", function() { return setReal; });
__webpack_require__.d(quat2_namespaceObject, "setDual", function() { return setDual; });
__webpack_require__.d(quat2_namespaceObject, "getTranslation", function() { return quat2_getTranslation; });
__webpack_require__.d(quat2_namespaceObject, "translate", function() { return quat2_translate; });
__webpack_require__.d(quat2_namespaceObject, "rotateX", function() { return quat2_rotateX; });
__webpack_require__.d(quat2_namespaceObject, "rotateY", function() { return quat2_rotateY; });
__webpack_require__.d(quat2_namespaceObject, "rotateZ", function() { return quat2_rotateZ; });
__webpack_require__.d(quat2_namespaceObject, "rotateByQuatAppend", function() { return rotateByQuatAppend; });
__webpack_require__.d(quat2_namespaceObject, "rotateByQuatPrepend", function() { return rotateByQuatPrepend; });
__webpack_require__.d(quat2_namespaceObject, "rotateAroundAxis", function() { return rotateAroundAxis; });
__webpack_require__.d(quat2_namespaceObject, "add", function() { return quat2_add; });
__webpack_require__.d(quat2_namespaceObject, "multiply", function() { return quat2_multiply; });
__webpack_require__.d(quat2_namespaceObject, "mul", function() { return quat2_mul; });
__webpack_require__.d(quat2_namespaceObject, "scale", function() { return quat2_scale; });
__webpack_require__.d(quat2_namespaceObject, "dot", function() { return quat2_dot; });
__webpack_require__.d(quat2_namespaceObject, "lerp", function() { return quat2_lerp; });
__webpack_require__.d(quat2_namespaceObject, "invert", function() { return quat2_invert; });
__webpack_require__.d(quat2_namespaceObject, "conjugate", function() { return quat2_conjugate; });
__webpack_require__.d(quat2_namespaceObject, "length", function() { return quat2_length; });
__webpack_require__.d(quat2_namespaceObject, "len", function() { return quat2_len; });
__webpack_require__.d(quat2_namespaceObject, "squaredLength", function() { return quat2_squaredLength; });
__webpack_require__.d(quat2_namespaceObject, "sqrLen", function() { return quat2_sqrLen; });
__webpack_require__.d(quat2_namespaceObject, "normalize", function() { return quat2_normalize; });
__webpack_require__.d(quat2_namespaceObject, "str", function() { return quat2_str; });
__webpack_require__.d(quat2_namespaceObject, "exactEquals", function() { return quat2_exactEquals; });
__webpack_require__.d(quat2_namespaceObject, "equals", function() { return quat2_equals; });

// NAMESPACE OBJECT: ./node_modules/gl-matrix/esm/vec2.js
var vec2_namespaceObject = {};
__webpack_require__.r(vec2_namespaceObject);
__webpack_require__.d(vec2_namespaceObject, "create", function() { return vec2_create; });
__webpack_require__.d(vec2_namespaceObject, "clone", function() { return vec2_clone; });
__webpack_require__.d(vec2_namespaceObject, "fromValues", function() { return vec2_fromValues; });
__webpack_require__.d(vec2_namespaceObject, "copy", function() { return vec2_copy; });
__webpack_require__.d(vec2_namespaceObject, "set", function() { return vec2_set; });
__webpack_require__.d(vec2_namespaceObject, "add", function() { return vec2_add; });
__webpack_require__.d(vec2_namespaceObject, "subtract", function() { return vec2_subtract; });
__webpack_require__.d(vec2_namespaceObject, "multiply", function() { return vec2_multiply; });
__webpack_require__.d(vec2_namespaceObject, "divide", function() { return vec2_divide; });
__webpack_require__.d(vec2_namespaceObject, "ceil", function() { return vec2_ceil; });
__webpack_require__.d(vec2_namespaceObject, "floor", function() { return vec2_floor; });
__webpack_require__.d(vec2_namespaceObject, "min", function() { return vec2_min; });
__webpack_require__.d(vec2_namespaceObject, "max", function() { return vec2_max; });
__webpack_require__.d(vec2_namespaceObject, "round", function() { return vec2_round; });
__webpack_require__.d(vec2_namespaceObject, "scale", function() { return vec2_scale; });
__webpack_require__.d(vec2_namespaceObject, "scaleAndAdd", function() { return vec2_scaleAndAdd; });
__webpack_require__.d(vec2_namespaceObject, "distance", function() { return vec2_distance; });
__webpack_require__.d(vec2_namespaceObject, "squaredDistance", function() { return vec2_squaredDistance; });
__webpack_require__.d(vec2_namespaceObject, "length", function() { return vec2_length; });
__webpack_require__.d(vec2_namespaceObject, "squaredLength", function() { return vec2_squaredLength; });
__webpack_require__.d(vec2_namespaceObject, "negate", function() { return vec2_negate; });
__webpack_require__.d(vec2_namespaceObject, "inverse", function() { return vec2_inverse; });
__webpack_require__.d(vec2_namespaceObject, "normalize", function() { return vec2_normalize; });
__webpack_require__.d(vec2_namespaceObject, "dot", function() { return vec2_dot; });
__webpack_require__.d(vec2_namespaceObject, "cross", function() { return vec2_cross; });
__webpack_require__.d(vec2_namespaceObject, "lerp", function() { return vec2_lerp; });
__webpack_require__.d(vec2_namespaceObject, "random", function() { return vec2_random; });
__webpack_require__.d(vec2_namespaceObject, "transformMat2", function() { return transformMat2; });
__webpack_require__.d(vec2_namespaceObject, "transformMat2d", function() { return transformMat2d; });
__webpack_require__.d(vec2_namespaceObject, "transformMat3", function() { return vec2_transformMat3; });
__webpack_require__.d(vec2_namespaceObject, "transformMat4", function() { return vec2_transformMat4; });
__webpack_require__.d(vec2_namespaceObject, "rotate", function() { return vec2_rotate; });
__webpack_require__.d(vec2_namespaceObject, "angle", function() { return vec2_angle; });
__webpack_require__.d(vec2_namespaceObject, "zero", function() { return vec2_zero; });
__webpack_require__.d(vec2_namespaceObject, "str", function() { return vec2_str; });
__webpack_require__.d(vec2_namespaceObject, "exactEquals", function() { return vec2_exactEquals; });
__webpack_require__.d(vec2_namespaceObject, "equals", function() { return vec2_equals; });
__webpack_require__.d(vec2_namespaceObject, "len", function() { return vec2_len; });
__webpack_require__.d(vec2_namespaceObject, "sub", function() { return vec2_sub; });
__webpack_require__.d(vec2_namespaceObject, "mul", function() { return vec2_mul; });
__webpack_require__.d(vec2_namespaceObject, "div", function() { return vec2_div; });
__webpack_require__.d(vec2_namespaceObject, "dist", function() { return vec2_dist; });
__webpack_require__.d(vec2_namespaceObject, "sqrDist", function() { return vec2_sqrDist; });
__webpack_require__.d(vec2_namespaceObject, "sqrLen", function() { return vec2_sqrLen; });
__webpack_require__.d(vec2_namespaceObject, "forEach", function() { return vec2_forEach; });

// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/common.js
/**
 * Common utilities
 * @module glMatrix
 */
// Configuration Constants
var EPSILON = 0.000001;
var ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
var RANDOM = Math.random;
/**
 * Sets the type of array used when creating new vectors and matrices
 *
 * @param {Float32ArrayConstructor | ArrayConstructor} type Array type, such as Float32Array or Array
 */

function setMatrixArrayType(type) {
  ARRAY_TYPE = type;
}
var degree = Math.PI / 180;
/**
 * Convert Degree To Radian
 *
 * @param {Number} a Angle in Degrees
 */

function toRadian(a) {
  return a * degree;
}
/**
 * Tests whether or not the arguments have approximately the same value, within an absolute
 * or relative tolerance of glMatrix.EPSILON (an absolute tolerance is used for values less
 * than or equal to 1.0, and a relative tolerance is used for larger values)
 *
 * @param {Number} a The first number to test.
 * @param {Number} b The second number to test.
 * @returns {Boolean} True if the numbers are approximately equal, false otherwise.
 */

function equals(a, b) {
  return Math.abs(a - b) <= EPSILON * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function () {
  var y = 0,
      i = arguments.length;

  while (i--) {
    y += arguments[i] * arguments[i];
  }

  return Math.sqrt(y);
};
// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/mat2.js

/**
 * 2x2 Matrix
 * @module mat2
 */

/**
 * Creates a new identity mat2
 *
 * @returns {mat2} a new 2x2 matrix
 */

function create() {
  var out = new ARRAY_TYPE(4);

  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
  }

  out[0] = 1;
  out[3] = 1;
  return out;
}
/**
 * Creates a new mat2 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat2} a matrix to clone
 * @returns {mat2} a new 2x2 matrix
 */

function clone(a) {
  var out = new ARRAY_TYPE(4);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}
/**
 * Copy the values from one mat2 to another
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the source matrix
 * @returns {mat2} out
 */

function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}
/**
 * Set a mat2 to the identity matrix
 *
 * @param {mat2} out the receiving matrix
 * @returns {mat2} out
 */

function identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  return out;
}
/**
 * Create a new mat2 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m10 Component in column 1, row 0 position (index 2)
 * @param {Number} m11 Component in column 1, row 1 position (index 3)
 * @returns {mat2} out A new 2x2 matrix
 */

function fromValues(m00, m01, m10, m11) {
  var out = new ARRAY_TYPE(4);
  out[0] = m00;
  out[1] = m01;
  out[2] = m10;
  out[3] = m11;
  return out;
}
/**
 * Set the components of a mat2 to the given values
 *
 * @param {mat2} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m10 Component in column 1, row 0 position (index 2)
 * @param {Number} m11 Component in column 1, row 1 position (index 3)
 * @returns {mat2} out
 */

function set(out, m00, m01, m10, m11) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m10;
  out[3] = m11;
  return out;
}
/**
 * Transpose the values of a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the source matrix
 * @returns {mat2} out
 */

function transpose(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache
  // some values
  if (out === a) {
    var a1 = a[1];
    out[1] = a[2];
    out[2] = a1;
  } else {
    out[0] = a[0];
    out[1] = a[2];
    out[2] = a[1];
    out[3] = a[3];
  }

  return out;
}
/**
 * Inverts a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the source matrix
 * @returns {mat2} out
 */

function invert(out, a) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3]; // Calculate the determinant

  var det = a0 * a3 - a2 * a1;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = a3 * det;
  out[1] = -a1 * det;
  out[2] = -a2 * det;
  out[3] = a0 * det;
  return out;
}
/**
 * Calculates the adjugate of a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the source matrix
 * @returns {mat2} out
 */

function adjoint(out, a) {
  // Caching this value is nessecary if out == a
  var a0 = a[0];
  out[0] = a[3];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] = a0;
  return out;
}
/**
 * Calculates the determinant of a mat2
 *
 * @param {ReadonlyMat2} a the source matrix
 * @returns {Number} determinant of a
 */

function determinant(a) {
  return a[0] * a[3] - a[2] * a[1];
}
/**
 * Multiplies two mat2's
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the first operand
 * @param {ReadonlyMat2} b the second operand
 * @returns {mat2} out
 */

function multiply(out, a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  out[0] = a0 * b0 + a2 * b1;
  out[1] = a1 * b0 + a3 * b1;
  out[2] = a0 * b2 + a2 * b3;
  out[3] = a1 * b2 + a3 * b3;
  return out;
}
/**
 * Rotates a mat2 by the given angle
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2} out
 */

function rotate(out, a, rad) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  out[0] = a0 * c + a2 * s;
  out[1] = a1 * c + a3 * s;
  out[2] = a0 * -s + a2 * c;
  out[3] = a1 * -s + a3 * c;
  return out;
}
/**
 * Scales the mat2 by the dimensions in the given vec2
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the matrix to rotate
 * @param {ReadonlyVec2} v the vec2 to scale the matrix by
 * @returns {mat2} out
 **/

function mat2_scale(out, a, v) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var v0 = v[0],
      v1 = v[1];
  out[0] = a0 * v0;
  out[1] = a1 * v0;
  out[2] = a2 * v1;
  out[3] = a3 * v1;
  return out;
}
/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat2.identity(dest);
 *     mat2.rotate(dest, dest, rad);
 *
 * @param {mat2} out mat2 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2} out
 */

function fromRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  out[0] = c;
  out[1] = s;
  out[2] = -s;
  out[3] = c;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat2.identity(dest);
 *     mat2.scale(dest, dest, vec);
 *
 * @param {mat2} out mat2 receiving operation result
 * @param {ReadonlyVec2} v Scaling vector
 * @returns {mat2} out
 */

function fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = v[1];
  return out;
}
/**
 * Returns a string representation of a mat2
 *
 * @param {ReadonlyMat2} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function str(a) {
  return "mat2(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
/**
 * Returns Frobenius norm of a mat2
 *
 * @param {ReadonlyMat2} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function frob(a) {
  return Math.hypot(a[0], a[1], a[2], a[3]);
}
/**
 * Returns L, D and U matrices (Lower triangular, Diagonal and Upper triangular) by factorizing the input matrix
 * @param {ReadonlyMat2} L the lower triangular matrix
 * @param {ReadonlyMat2} D the diagonal matrix
 * @param {ReadonlyMat2} U the upper triangular matrix
 * @param {ReadonlyMat2} a the input matrix to factorize
 */

function LDU(L, D, U, a) {
  L[2] = a[2] / a[0];
  U[0] = a[0];
  U[1] = a[1];
  U[3] = a[3] - L[2] * U[1];
  return [L, D, U];
}
/**
 * Adds two mat2's
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the first operand
 * @param {ReadonlyMat2} b the second operand
 * @returns {mat2} out
 */

function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the first operand
 * @param {ReadonlyMat2} b the second operand
 * @returns {mat2} out
 */

function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat2} a The first matrix.
 * @param {ReadonlyMat2} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat2} a The first matrix.
 * @param {ReadonlyMat2} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat2_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat2} out the receiving matrix
 * @param {ReadonlyMat2} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat2} out
 */

function multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  return out;
}
/**
 * Adds two mat2's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat2} out the receiving vector
 * @param {ReadonlyMat2} a the first operand
 * @param {ReadonlyMat2} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat2} out
 */

function multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  return out;
}
/**
 * Alias for {@link mat2.multiply}
 * @function
 */

var mul = multiply;
/**
 * Alias for {@link mat2.subtract}
 * @function
 */

var sub = subtract;
// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/mat2d.js

/**
 * 2x3 Matrix
 * @module mat2d
 * @description
 * A mat2d contains six elements defined as:
 * <pre>
 * [a, b,
 *  c, d,
 *  tx, ty]
 * </pre>
 * This is a short form for the 3x3 matrix:
 * <pre>
 * [a, b, 0,
 *  c, d, 0,
 *  tx, ty, 1]
 * </pre>
 * The last column is ignored so the array is shorter and operations are faster.
 */

/**
 * Creates a new identity mat2d
 *
 * @returns {mat2d} a new 2x3 matrix
 */

function mat2d_create() {
  var out = new ARRAY_TYPE(6);

  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[4] = 0;
    out[5] = 0;
  }

  out[0] = 1;
  out[3] = 1;
  return out;
}
/**
 * Creates a new mat2d initialized with values from an existing matrix
 *
 * @param {ReadonlyMat2d} a matrix to clone
 * @returns {mat2d} a new 2x3 matrix
 */

function mat2d_clone(a) {
  var out = new ARRAY_TYPE(6);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  return out;
}
/**
 * Copy the values from one mat2d to another
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the source matrix
 * @returns {mat2d} out
 */

function mat2d_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  return out;
}
/**
 * Set a mat2d to the identity matrix
 *
 * @param {mat2d} out the receiving matrix
 * @returns {mat2d} out
 */

function mat2d_identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = 0;
  out[5] = 0;
  return out;
}
/**
 * Create a new mat2d with the given values
 *
 * @param {Number} a Component A (index 0)
 * @param {Number} b Component B (index 1)
 * @param {Number} c Component C (index 2)
 * @param {Number} d Component D (index 3)
 * @param {Number} tx Component TX (index 4)
 * @param {Number} ty Component TY (index 5)
 * @returns {mat2d} A new mat2d
 */

function mat2d_fromValues(a, b, c, d, tx, ty) {
  var out = new ARRAY_TYPE(6);
  out[0] = a;
  out[1] = b;
  out[2] = c;
  out[3] = d;
  out[4] = tx;
  out[5] = ty;
  return out;
}
/**
 * Set the components of a mat2d to the given values
 *
 * @param {mat2d} out the receiving matrix
 * @param {Number} a Component A (index 0)
 * @param {Number} b Component B (index 1)
 * @param {Number} c Component C (index 2)
 * @param {Number} d Component D (index 3)
 * @param {Number} tx Component TX (index 4)
 * @param {Number} ty Component TY (index 5)
 * @returns {mat2d} out
 */

function mat2d_set(out, a, b, c, d, tx, ty) {
  out[0] = a;
  out[1] = b;
  out[2] = c;
  out[3] = d;
  out[4] = tx;
  out[5] = ty;
  return out;
}
/**
 * Inverts a mat2d
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the source matrix
 * @returns {mat2d} out
 */

function mat2d_invert(out, a) {
  var aa = a[0],
      ab = a[1],
      ac = a[2],
      ad = a[3];
  var atx = a[4],
      aty = a[5];
  var det = aa * ad - ab * ac;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = ad * det;
  out[1] = -ab * det;
  out[2] = -ac * det;
  out[3] = aa * det;
  out[4] = (ac * aty - ad * atx) * det;
  out[5] = (ab * atx - aa * aty) * det;
  return out;
}
/**
 * Calculates the determinant of a mat2d
 *
 * @param {ReadonlyMat2d} a the source matrix
 * @returns {Number} determinant of a
 */

function mat2d_determinant(a) {
  return a[0] * a[3] - a[1] * a[2];
}
/**
 * Multiplies two mat2d's
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the first operand
 * @param {ReadonlyMat2d} b the second operand
 * @returns {mat2d} out
 */

function mat2d_multiply(out, a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3],
      b4 = b[4],
      b5 = b[5];
  out[0] = a0 * b0 + a2 * b1;
  out[1] = a1 * b0 + a3 * b1;
  out[2] = a0 * b2 + a2 * b3;
  out[3] = a1 * b2 + a3 * b3;
  out[4] = a0 * b4 + a2 * b5 + a4;
  out[5] = a1 * b4 + a3 * b5 + a5;
  return out;
}
/**
 * Rotates a mat2d by the given angle
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2d} out
 */

function mat2d_rotate(out, a, rad) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5];
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  out[0] = a0 * c + a2 * s;
  out[1] = a1 * c + a3 * s;
  out[2] = a0 * -s + a2 * c;
  out[3] = a1 * -s + a3 * c;
  out[4] = a4;
  out[5] = a5;
  return out;
}
/**
 * Scales the mat2d by the dimensions in the given vec2
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the matrix to translate
 * @param {ReadonlyVec2} v the vec2 to scale the matrix by
 * @returns {mat2d} out
 **/

function mat2d_scale(out, a, v) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5];
  var v0 = v[0],
      v1 = v[1];
  out[0] = a0 * v0;
  out[1] = a1 * v0;
  out[2] = a2 * v1;
  out[3] = a3 * v1;
  out[4] = a4;
  out[5] = a5;
  return out;
}
/**
 * Translates the mat2d by the dimensions in the given vec2
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the matrix to translate
 * @param {ReadonlyVec2} v the vec2 to translate the matrix by
 * @returns {mat2d} out
 **/

function translate(out, a, v) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5];
  var v0 = v[0],
      v1 = v[1];
  out[0] = a0;
  out[1] = a1;
  out[2] = a2;
  out[3] = a3;
  out[4] = a0 * v0 + a2 * v1 + a4;
  out[5] = a1 * v0 + a3 * v1 + a5;
  return out;
}
/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat2d.identity(dest);
 *     mat2d.rotate(dest, dest, rad);
 *
 * @param {mat2d} out mat2d receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2d} out
 */

function mat2d_fromRotation(out, rad) {
  var s = Math.sin(rad),
      c = Math.cos(rad);
  out[0] = c;
  out[1] = s;
  out[2] = -s;
  out[3] = c;
  out[4] = 0;
  out[5] = 0;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat2d.identity(dest);
 *     mat2d.scale(dest, dest, vec);
 *
 * @param {mat2d} out mat2d receiving operation result
 * @param {ReadonlyVec2} v Scaling vector
 * @returns {mat2d} out
 */

function mat2d_fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = v[1];
  out[4] = 0;
  out[5] = 0;
  return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat2d.identity(dest);
 *     mat2d.translate(dest, dest, vec);
 *
 * @param {mat2d} out mat2d receiving operation result
 * @param {ReadonlyVec2} v Translation vector
 * @returns {mat2d} out
 */

function fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = v[0];
  out[5] = v[1];
  return out;
}
/**
 * Returns a string representation of a mat2d
 *
 * @param {ReadonlyMat2d} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function mat2d_str(a) {
  return "mat2d(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ")";
}
/**
 * Returns Frobenius norm of a mat2d
 *
 * @param {ReadonlyMat2d} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function mat2d_frob(a) {
  return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], 1);
}
/**
 * Adds two mat2d's
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the first operand
 * @param {ReadonlyMat2d} b the second operand
 * @returns {mat2d} out
 */

function mat2d_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the first operand
 * @param {ReadonlyMat2d} b the second operand
 * @returns {mat2d} out
 */

function mat2d_subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat2d} out the receiving matrix
 * @param {ReadonlyMat2d} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat2d} out
 */

function mat2d_multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  return out;
}
/**
 * Adds two mat2d's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat2d} out the receiving vector
 * @param {ReadonlyMat2d} a the first operand
 * @param {ReadonlyMat2d} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat2d} out
 */

function mat2d_multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  out[4] = a[4] + b[4] * scale;
  out[5] = a[5] + b[5] * scale;
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat2d} a The first matrix.
 * @param {ReadonlyMat2d} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat2d_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat2d} a The first matrix.
 * @param {ReadonlyMat2d} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat2d_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3],
      b4 = b[4],
      b5 = b[5];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5));
}
/**
 * Alias for {@link mat2d.multiply}
 * @function
 */

var mat2d_mul = mat2d_multiply;
/**
 * Alias for {@link mat2d.subtract}
 * @function
 */

var mat2d_sub = mat2d_subtract;
// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/mat3.js

/**
 * 3x3 Matrix
 * @module mat3
 */

/**
 * Creates a new identity mat3
 *
 * @returns {mat3} a new 3x3 matrix
 */

function mat3_create() {
  var out = new ARRAY_TYPE(9);

  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
  }

  out[0] = 1;
  out[4] = 1;
  out[8] = 1;
  return out;
}
/**
 * Copies the upper-left 3x3 values into the given mat3.
 *
 * @param {mat3} out the receiving 3x3 matrix
 * @param {ReadonlyMat4} a   the source 4x4 matrix
 * @returns {mat3} out
 */

function fromMat4(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[4];
  out[4] = a[5];
  out[5] = a[6];
  out[6] = a[8];
  out[7] = a[9];
  out[8] = a[10];
  return out;
}
/**
 * Creates a new mat3 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat3} a matrix to clone
 * @returns {mat3} a new 3x3 matrix
 */

function mat3_clone(a) {
  var out = new ARRAY_TYPE(9);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}
/**
 * Copy the values from one mat3 to another
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function mat3_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}
/**
 * Create a new mat3 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} A new mat3
 */

function mat3_fromValues(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
  var out = new ARRAY_TYPE(9);
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m10;
  out[4] = m11;
  out[5] = m12;
  out[6] = m20;
  out[7] = m21;
  out[8] = m22;
  return out;
}
/**
 * Set the components of a mat3 to the given values
 *
 * @param {mat3} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} out
 */

function mat3_set(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m10;
  out[4] = m11;
  out[5] = m12;
  out[6] = m20;
  out[7] = m21;
  out[8] = m22;
  return out;
}
/**
 * Set a mat3 to the identity matrix
 *
 * @param {mat3} out the receiving matrix
 * @returns {mat3} out
 */

function mat3_identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
/**
 * Transpose the values of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function mat3_transpose(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache some values
  if (out === a) {
    var a01 = a[1],
        a02 = a[2],
        a12 = a[5];
    out[1] = a[3];
    out[2] = a[6];
    out[3] = a01;
    out[5] = a[7];
    out[6] = a02;
    out[7] = a12;
  } else {
    out[0] = a[0];
    out[1] = a[3];
    out[2] = a[6];
    out[3] = a[1];
    out[4] = a[4];
    out[5] = a[7];
    out[6] = a[2];
    out[7] = a[5];
    out[8] = a[8];
  }

  return out;
}
/**
 * Inverts a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function mat3_invert(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  var b01 = a22 * a11 - a12 * a21;
  var b11 = -a22 * a10 + a12 * a20;
  var b21 = a21 * a10 - a11 * a20; // Calculate the determinant

  var det = a00 * b01 + a01 * b11 + a02 * b21;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = b01 * det;
  out[1] = (-a22 * a01 + a02 * a21) * det;
  out[2] = (a12 * a01 - a02 * a11) * det;
  out[3] = b11 * det;
  out[4] = (a22 * a00 - a02 * a20) * det;
  out[5] = (-a12 * a00 + a02 * a10) * det;
  out[6] = b21 * det;
  out[7] = (-a21 * a00 + a01 * a20) * det;
  out[8] = (a11 * a00 - a01 * a10) * det;
  return out;
}
/**
 * Calculates the adjugate of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function mat3_adjoint(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  out[0] = a11 * a22 - a12 * a21;
  out[1] = a02 * a21 - a01 * a22;
  out[2] = a01 * a12 - a02 * a11;
  out[3] = a12 * a20 - a10 * a22;
  out[4] = a00 * a22 - a02 * a20;
  out[5] = a02 * a10 - a00 * a12;
  out[6] = a10 * a21 - a11 * a20;
  out[7] = a01 * a20 - a00 * a21;
  out[8] = a00 * a11 - a01 * a10;
  return out;
}
/**
 * Calculates the determinant of a mat3
 *
 * @param {ReadonlyMat3} a the source matrix
 * @returns {Number} determinant of a
 */

function mat3_determinant(a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
/**
 * Multiplies two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */

function mat3_multiply(out, a, b) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  var b00 = b[0],
      b01 = b[1],
      b02 = b[2];
  var b10 = b[3],
      b11 = b[4],
      b12 = b[5];
  var b20 = b[6],
      b21 = b[7],
      b22 = b[8];
  out[0] = b00 * a00 + b01 * a10 + b02 * a20;
  out[1] = b00 * a01 + b01 * a11 + b02 * a21;
  out[2] = b00 * a02 + b01 * a12 + b02 * a22;
  out[3] = b10 * a00 + b11 * a10 + b12 * a20;
  out[4] = b10 * a01 + b11 * a11 + b12 * a21;
  out[5] = b10 * a02 + b11 * a12 + b12 * a22;
  out[6] = b20 * a00 + b21 * a10 + b22 * a20;
  out[7] = b20 * a01 + b21 * a11 + b22 * a21;
  out[8] = b20 * a02 + b21 * a12 + b22 * a22;
  return out;
}
/**
 * Translate a mat3 by the given vector
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to translate
 * @param {ReadonlyVec2} v vector to translate by
 * @returns {mat3} out
 */

function mat3_translate(out, a, v) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a10 = a[3],
      a11 = a[4],
      a12 = a[5],
      a20 = a[6],
      a21 = a[7],
      a22 = a[8],
      x = v[0],
      y = v[1];
  out[0] = a00;
  out[1] = a01;
  out[2] = a02;
  out[3] = a10;
  out[4] = a11;
  out[5] = a12;
  out[6] = x * a00 + y * a10 + a20;
  out[7] = x * a01 + y * a11 + a21;
  out[8] = x * a02 + y * a12 + a22;
  return out;
}
/**
 * Rotates a mat3 by the given angle
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */

function mat3_rotate(out, a, rad) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a10 = a[3],
      a11 = a[4],
      a12 = a[5],
      a20 = a[6],
      a21 = a[7],
      a22 = a[8],
      s = Math.sin(rad),
      c = Math.cos(rad);
  out[0] = c * a00 + s * a10;
  out[1] = c * a01 + s * a11;
  out[2] = c * a02 + s * a12;
  out[3] = c * a10 - s * a00;
  out[4] = c * a11 - s * a01;
  out[5] = c * a12 - s * a02;
  out[6] = a20;
  out[7] = a21;
  out[8] = a22;
  return out;
}
/**
 * Scales the mat3 by the dimensions in the given vec2
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {ReadonlyVec2} v the vec2 to scale the matrix by
 * @returns {mat3} out
 **/

function mat3_scale(out, a, v) {
  var x = v[0],
      y = v[1];
  out[0] = x * a[0];
  out[1] = x * a[1];
  out[2] = x * a[2];
  out[3] = y * a[3];
  out[4] = y * a[4];
  out[5] = y * a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.translate(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyVec2} v Translation vector
 * @returns {mat3} out
 */

function mat3_fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = v[0];
  out[7] = v[1];
  out[8] = 1;
  return out;
}
/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.rotate(dest, dest, rad);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */

function mat3_fromRotation(out, rad) {
  var s = Math.sin(rad),
      c = Math.cos(rad);
  out[0] = c;
  out[1] = s;
  out[2] = 0;
  out[3] = -s;
  out[4] = c;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.scale(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyVec2} v Scaling vector
 * @returns {mat3} out
 */

function mat3_fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = v[1];
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
/**
 * Copies the values from a mat2d into a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat2d} a the matrix to copy
 * @returns {mat3} out
 **/

function fromMat2d(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = 0;
  out[3] = a[2];
  out[4] = a[3];
  out[5] = 0;
  out[6] = a[4];
  out[7] = a[5];
  out[8] = 1;
  return out;
}
/**
 * Calculates a 3x3 matrix from the given quaternion
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyQuat} q Quaternion to create matrix from
 *
 * @returns {mat3} out
 */

function fromQuat(out, q) {
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var yx = y * x2;
  var yy = y * y2;
  var zx = z * x2;
  var zy = z * y2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - yy - zz;
  out[3] = yx - wz;
  out[6] = zx + wy;
  out[1] = yx + wz;
  out[4] = 1 - xx - zz;
  out[7] = zy - wx;
  out[2] = zx - wy;
  out[5] = zy + wx;
  out[8] = 1 - xx - yy;
  return out;
}
/**
 * Calculates a 3x3 normal matrix (transpose inverse) from the 4x4 matrix
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyMat4} a Mat4 to derive the normal matrix from
 *
 * @returns {mat3} out
 */

function normalFromMat4(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  return out;
}
/**
 * Generates a 2D projection matrix with the given bounds
 *
 * @param {mat3} out mat3 frustum matrix will be written into
 * @param {number} width Width of your gl context
 * @param {number} height Height of gl context
 * @returns {mat3} out
 */

function projection(out, width, height) {
  out[0] = 2 / width;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = -2 / height;
  out[5] = 0;
  out[6] = -1;
  out[7] = 1;
  out[8] = 1;
  return out;
}
/**
 * Returns a string representation of a mat3
 *
 * @param {ReadonlyMat3} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function mat3_str(a) {
  return "mat3(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ")";
}
/**
 * Returns Frobenius norm of a mat3
 *
 * @param {ReadonlyMat3} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function mat3_frob(a) {
  return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
}
/**
 * Adds two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */

function mat3_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  out[8] = a[8] + b[8];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */

function mat3_subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  out[6] = a[6] - b[6];
  out[7] = a[7] - b[7];
  out[8] = a[8] - b[8];
  return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat3} out
 */

function mat3_multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  out[8] = a[8] * b;
  return out;
}
/**
 * Adds two mat3's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat3} out the receiving vector
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat3} out
 */

function mat3_multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  out[4] = a[4] + b[4] * scale;
  out[5] = a[5] + b[5] * scale;
  out[6] = a[6] + b[6] * scale;
  out[7] = a[7] + b[7] * scale;
  out[8] = a[8] + b[8] * scale;
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat3} a The first matrix.
 * @param {ReadonlyMat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat3_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat3} a The first matrix.
 * @param {ReadonlyMat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat3_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5],
      a6 = a[6],
      a7 = a[7],
      a8 = a[8];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3],
      b4 = b[4],
      b5 = b[5],
      b6 = b[6],
      b7 = b[7],
      b8 = b[8];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8));
}
/**
 * Alias for {@link mat3.multiply}
 * @function
 */

var mat3_mul = mat3_multiply;
/**
 * Alias for {@link mat3.subtract}
 * @function
 */

var mat3_sub = mat3_subtract;
// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/mat4.js

/**
 * 4x4 Matrix<br>Format: column-major, when typed out it looks like row-major<br>The matrices are being post multiplied.
 * @module mat4
 */

/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */

function mat4_create() {
  var out = new ARRAY_TYPE(16);

  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
  }

  out[0] = 1;
  out[5] = 1;
  out[10] = 1;
  out[15] = 1;
  return out;
}
/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */

function mat4_clone(a) {
  var out = new ARRAY_TYPE(16);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function mat4_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Create a new mat4 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} A new mat4
 */

function mat4_fromValues(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  var out = new ARRAY_TYPE(16);
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}
/**
 * Set the components of a mat4 to the given values
 *
 * @param {mat4} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} out
 */

function mat4_set(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}
/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */

function mat4_identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Transpose the values of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function mat4_transpose(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache some values
  if (out === a) {
    var a01 = a[1],
        a02 = a[2],
        a03 = a[3];
    var a12 = a[6],
        a13 = a[7];
    var a23 = a[11];
    out[1] = a[4];
    out[2] = a[8];
    out[3] = a[12];
    out[4] = a01;
    out[6] = a[9];
    out[7] = a[13];
    out[8] = a02;
    out[9] = a12;
    out[11] = a[14];
    out[12] = a03;
    out[13] = a13;
    out[14] = a23;
  } else {
    out[0] = a[0];
    out[1] = a[4];
    out[2] = a[8];
    out[3] = a[12];
    out[4] = a[1];
    out[5] = a[5];
    out[6] = a[9];
    out[7] = a[13];
    out[8] = a[2];
    out[9] = a[6];
    out[10] = a[10];
    out[11] = a[14];
    out[12] = a[3];
    out[13] = a[7];
    out[14] = a[11];
    out[15] = a[15];
  }

  return out;
}
/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function mat4_invert(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
  out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
  out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
  out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
  out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
  out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
  out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
  return out;
}
/**
 * Calculates the adjugate of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function mat4_adjoint(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
  out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
  out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
  out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
  out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
  out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
  out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
  out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
  out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
  out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
  out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
  out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
  out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
  out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
  out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
  out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
  return out;
}
/**
 * Calculates the determinant of a mat4
 *
 * @param {ReadonlyMat4} a the source matrix
 * @returns {Number} determinant of a
 */

function mat4_determinant(a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
/**
 * Multiplies two mat4s
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function mat4_multiply(out, a, b) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15]; // Cache only the current line of the second matrix

  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[4];
  b1 = b[5];
  b2 = b[6];
  b3 = b[7];
  out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[8];
  b1 = b[9];
  b2 = b[10];
  b3 = b[11];
  out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[12];
  b1 = b[13];
  b2 = b[14];
  b3 = b[15];
  out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  return out;
}
/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to translate
 * @param {ReadonlyVec3} v vector to translate by
 * @returns {mat4} out
 */

function mat4_translate(out, a, v) {
  var x = v[0],
      y = v[1],
      z = v[2];
  var a00, a01, a02, a03;
  var a10, a11, a12, a13;
  var a20, a21, a22, a23;

  if (a === out) {
    out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
    out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
    out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
    out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
  } else {
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a03;
    out[4] = a10;
    out[5] = a11;
    out[6] = a12;
    out[7] = a13;
    out[8] = a20;
    out[9] = a21;
    out[10] = a22;
    out[11] = a23;
    out[12] = a00 * x + a10 * y + a20 * z + a[12];
    out[13] = a01 * x + a11 * y + a21 * z + a[13];
    out[14] = a02 * x + a12 * y + a22 * z + a[14];
    out[15] = a03 * x + a13 * y + a23 * z + a[15];
  }

  return out;
}
/**
 * Scales the mat4 by the dimensions in the given vec3 not using vectorization
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {ReadonlyVec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/

function mat4_scale(out, a, v) {
  var x = v[0],
      y = v[1],
      z = v[2];
  out[0] = a[0] * x;
  out[1] = a[1] * x;
  out[2] = a[2] * x;
  out[3] = a[3] * x;
  out[4] = a[4] * y;
  out[5] = a[5] * y;
  out[6] = a[6] * y;
  out[7] = a[7] * y;
  out[8] = a[8] * z;
  out[9] = a[9] * z;
  out[10] = a[10] * z;
  out[11] = a[11] * z;
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Rotates a mat4 by the given angle around the given axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @returns {mat4} out
 */

function mat4_rotate(out, a, rad, axis) {
  var x = axis[0],
      y = axis[1],
      z = axis[2];
  var len = Math.hypot(x, y, z);
  var s, c, t;
  var a00, a01, a02, a03;
  var a10, a11, a12, a13;
  var a20, a21, a22, a23;
  var b00, b01, b02;
  var b10, b11, b12;
  var b20, b21, b22;

  if (len < EPSILON) {
    return null;
  }

  len = 1 / len;
  x *= len;
  y *= len;
  z *= len;
  s = Math.sin(rad);
  c = Math.cos(rad);
  t = 1 - c;
  a00 = a[0];
  a01 = a[1];
  a02 = a[2];
  a03 = a[3];
  a10 = a[4];
  a11 = a[5];
  a12 = a[6];
  a13 = a[7];
  a20 = a[8];
  a21 = a[9];
  a22 = a[10];
  a23 = a[11]; // Construct the elements of the rotation matrix

  b00 = x * x * t + c;
  b01 = y * x * t + z * s;
  b02 = z * x * t - y * s;
  b10 = x * y * t - z * s;
  b11 = y * y * t + c;
  b12 = z * y * t + x * s;
  b20 = x * z * t + y * s;
  b21 = y * z * t - x * s;
  b22 = z * z * t + c; // Perform rotation-specific matrix multiplication

  out[0] = a00 * b00 + a10 * b01 + a20 * b02;
  out[1] = a01 * b00 + a11 * b01 + a21 * b02;
  out[2] = a02 * b00 + a12 * b01 + a22 * b02;
  out[3] = a03 * b00 + a13 * b01 + a23 * b02;
  out[4] = a00 * b10 + a10 * b11 + a20 * b12;
  out[5] = a01 * b10 + a11 * b11 + a21 * b12;
  out[6] = a02 * b10 + a12 * b11 + a22 * b12;
  out[7] = a03 * b10 + a13 * b11 + a23 * b12;
  out[8] = a00 * b20 + a10 * b21 + a20 * b22;
  out[9] = a01 * b20 + a11 * b21 + a21 * b22;
  out[10] = a02 * b20 + a12 * b21 + a22 * b22;
  out[11] = a03 * b20 + a13 * b21 + a23 * b22;

  if (a !== out) {
    // If the source and destination differ, copy the unchanged last row
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  }

  return out;
}
/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateX(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a10 = a[4];
  var a11 = a[5];
  var a12 = a[6];
  var a13 = a[7];
  var a20 = a[8];
  var a21 = a[9];
  var a22 = a[10];
  var a23 = a[11];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged rows
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[4] = a10 * c + a20 * s;
  out[5] = a11 * c + a21 * s;
  out[6] = a12 * c + a22 * s;
  out[7] = a13 * c + a23 * s;
  out[8] = a20 * c - a10 * s;
  out[9] = a21 * c - a11 * s;
  out[10] = a22 * c - a12 * s;
  out[11] = a23 * c - a13 * s;
  return out;
}
/**
 * Rotates a matrix by the given angle around the Y axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateY(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a00 = a[0];
  var a01 = a[1];
  var a02 = a[2];
  var a03 = a[3];
  var a20 = a[8];
  var a21 = a[9];
  var a22 = a[10];
  var a23 = a[11];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged rows
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[0] = a00 * c - a20 * s;
  out[1] = a01 * c - a21 * s;
  out[2] = a02 * c - a22 * s;
  out[3] = a03 * c - a23 * s;
  out[8] = a00 * s + a20 * c;
  out[9] = a01 * s + a21 * c;
  out[10] = a02 * s + a22 * c;
  out[11] = a03 * s + a23 * c;
  return out;
}
/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateZ(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a00 = a[0];
  var a01 = a[1];
  var a02 = a[2];
  var a03 = a[3];
  var a10 = a[4];
  var a11 = a[5];
  var a12 = a[6];
  var a13 = a[7];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged last row
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[0] = a00 * c + a10 * s;
  out[1] = a01 * c + a11 * s;
  out[2] = a02 * c + a12 * s;
  out[3] = a03 * c + a13 * s;
  out[4] = a10 * c - a00 * s;
  out[5] = a11 * c - a01 * s;
  out[6] = a12 * c - a02 * s;
  out[7] = a13 * c - a03 * s;
  return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */

function mat4_fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.scale(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Scaling vector
 * @returns {mat4} out
 */

function mat4_fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = v[1];
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = v[2];
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a given angle around a given axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotate(dest, dest, rad, axis);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @returns {mat4} out
 */

function mat4_fromRotation(out, rad, axis) {
  var x = axis[0],
      y = axis[1],
      z = axis[2];
  var len = Math.hypot(x, y, z);
  var s, c, t;

  if (len < EPSILON) {
    return null;
  }

  len = 1 / len;
  x *= len;
  y *= len;
  z *= len;
  s = Math.sin(rad);
  c = Math.cos(rad);
  t = 1 - c; // Perform rotation-specific matrix multiplication

  out[0] = x * x * t + c;
  out[1] = y * x * t + z * s;
  out[2] = z * x * t - y * s;
  out[3] = 0;
  out[4] = x * y * t - z * s;
  out[5] = y * y * t + c;
  out[6] = z * y * t + x * s;
  out[7] = 0;
  out[8] = x * z * t + y * s;
  out[9] = y * z * t - x * s;
  out[10] = z * z * t + c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the X axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateX(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromXRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = c;
  out[6] = s;
  out[7] = 0;
  out[8] = 0;
  out[9] = -s;
  out[10] = c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the Y axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateY(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromYRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = c;
  out[1] = 0;
  out[2] = -s;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = s;
  out[9] = 0;
  out[10] = c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the Z axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateZ(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromZRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = c;
  out[1] = s;
  out[2] = 0;
  out[3] = 0;
  out[4] = -s;
  out[5] = c;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */

function fromRotationTranslation(out, q, v) {
  // Quaternion math
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - (yy + zz);
  out[1] = xy + wz;
  out[2] = xz - wy;
  out[3] = 0;
  out[4] = xy - wz;
  out[5] = 1 - (xx + zz);
  out[6] = yz + wx;
  out[7] = 0;
  out[8] = xz + wy;
  out[9] = yz - wx;
  out[10] = 1 - (xx + yy);
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a new mat4 from a dual quat.
 *
 * @param {mat4} out Matrix
 * @param {ReadonlyQuat2} a Dual Quaternion
 * @returns {mat4} mat4 receiving operation result
 */

function fromQuat2(out, a) {
  var translation = new ARRAY_TYPE(3);
  var bx = -a[0],
      by = -a[1],
      bz = -a[2],
      bw = a[3],
      ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7];
  var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense

  if (magnitude > 0) {
    translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
    translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
    translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
  } else {
    translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
    translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
    translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
  }

  fromRotationTranslation(out, a, translation);
  return out;
}
/**
 * Returns the translation vector component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslation,
 *  the returned vector will be the same as the translation vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive translation component
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */

function getTranslation(out, mat) {
  out[0] = mat[12];
  out[1] = mat[13];
  out[2] = mat[14];
  return out;
}
/**
 * Returns the scaling factor component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslationScale
 *  with a normalized Quaternion paramter, the returned vector will be
 *  the same as the scaling vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive scaling factor component
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */

function getScaling(out, mat) {
  var m11 = mat[0];
  var m12 = mat[1];
  var m13 = mat[2];
  var m21 = mat[4];
  var m22 = mat[5];
  var m23 = mat[6];
  var m31 = mat[8];
  var m32 = mat[9];
  var m33 = mat[10];
  out[0] = Math.hypot(m11, m12, m13);
  out[1] = Math.hypot(m21, m22, m23);
  out[2] = Math.hypot(m31, m32, m33);
  return out;
}
/**
 * Returns a quaternion representing the rotational component
 *  of a transformation matrix. If a matrix is built with
 *  fromRotationTranslation, the returned quaternion will be the
 *  same as the quaternion originally supplied.
 * @param {quat} out Quaternion to receive the rotation component
 * @param {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {quat} out
 */

function getRotation(out, mat) {
  var scaling = new ARRAY_TYPE(3);
  getScaling(scaling, mat);
  var is1 = 1 / scaling[0];
  var is2 = 1 / scaling[1];
  var is3 = 1 / scaling[2];
  var sm11 = mat[0] * is1;
  var sm12 = mat[1] * is2;
  var sm13 = mat[2] * is3;
  var sm21 = mat[4] * is1;
  var sm22 = mat[5] * is2;
  var sm23 = mat[6] * is3;
  var sm31 = mat[8] * is1;
  var sm32 = mat[9] * is2;
  var sm33 = mat[10] * is3;
  var trace = sm11 + sm22 + sm33;
  var S = 0;

  if (trace > 0) {
    S = Math.sqrt(trace + 1.0) * 2;
    out[3] = 0.25 * S;
    out[0] = (sm23 - sm32) / S;
    out[1] = (sm31 - sm13) / S;
    out[2] = (sm12 - sm21) / S;
  } else if (sm11 > sm22 && sm11 > sm33) {
    S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
    out[3] = (sm23 - sm32) / S;
    out[0] = 0.25 * S;
    out[1] = (sm12 + sm21) / S;
    out[2] = (sm31 + sm13) / S;
  } else if (sm22 > sm33) {
    S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
    out[3] = (sm31 - sm13) / S;
    out[0] = (sm12 + sm21) / S;
    out[1] = 0.25 * S;
    out[2] = (sm23 + sm32) / S;
  } else {
    S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
    out[3] = (sm12 - sm21) / S;
    out[0] = (sm31 + sm13) / S;
    out[1] = (sm23 + sm32) / S;
    out[2] = 0.25 * S;
  }

  return out;
}
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @param {ReadonlyVec3} s Scaling vector
 * @returns {mat4} out
 */

function fromRotationTranslationScale(out, q, v, s) {
  // Quaternion math
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  var sx = s[0];
  var sy = s[1];
  var sz = s[2];
  out[0] = (1 - (yy + zz)) * sx;
  out[1] = (xy + wz) * sx;
  out[2] = (xz - wy) * sx;
  out[3] = 0;
  out[4] = (xy - wz) * sy;
  out[5] = (1 - (xx + zz)) * sy;
  out[6] = (yz + wx) * sy;
  out[7] = 0;
  out[8] = (xz + wy) * sz;
  out[9] = (yz - wx) * sz;
  out[10] = (1 - (xx + yy)) * sz;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale, rotating and scaling around the given origin
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     mat4.translate(dest, origin);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *     mat4.translate(dest, negativeOrigin);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @param {ReadonlyVec3} s Scaling vector
 * @param {ReadonlyVec3} o The origin vector around which to scale and rotate
 * @returns {mat4} out
 */

function fromRotationTranslationScaleOrigin(out, q, v, s, o) {
  // Quaternion math
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  var sx = s[0];
  var sy = s[1];
  var sz = s[2];
  var ox = o[0];
  var oy = o[1];
  var oz = o[2];
  var out0 = (1 - (yy + zz)) * sx;
  var out1 = (xy + wz) * sx;
  var out2 = (xz - wy) * sx;
  var out4 = (xy - wz) * sy;
  var out5 = (1 - (xx + zz)) * sy;
  var out6 = (yz + wx) * sy;
  var out8 = (xz + wy) * sz;
  var out9 = (yz - wx) * sz;
  var out10 = (1 - (xx + yy)) * sz;
  out[0] = out0;
  out[1] = out1;
  out[2] = out2;
  out[3] = 0;
  out[4] = out4;
  out[5] = out5;
  out[6] = out6;
  out[7] = 0;
  out[8] = out8;
  out[9] = out9;
  out[10] = out10;
  out[11] = 0;
  out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
  out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
  out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
  out[15] = 1;
  return out;
}
/**
 * Calculates a 4x4 matrix from the given quaternion
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyQuat} q Quaternion to create matrix from
 *
 * @returns {mat4} out
 */

function mat4_fromQuat(out, q) {
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var yx = y * x2;
  var yy = y * y2;
  var zx = z * x2;
  var zy = z * y2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - yy - zz;
  out[1] = yx + wz;
  out[2] = zx - wy;
  out[3] = 0;
  out[4] = yx - wz;
  out[5] = 1 - xx - zz;
  out[6] = zy + wx;
  out[7] = 0;
  out[8] = zx + wy;
  out[9] = zy - wx;
  out[10] = 1 - xx - yy;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Generates a frustum matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Number} left Left bound of the frustum
 * @param {Number} right Right bound of the frustum
 * @param {Number} bottom Bottom bound of the frustum
 * @param {Number} top Top bound of the frustum
 * @param {Number} near Near bound of the frustum
 * @param {Number} far Far bound of the frustum
 * @returns {mat4} out
 */

function frustum(out, left, right, bottom, top, near, far) {
  var rl = 1 / (right - left);
  var tb = 1 / (top - bottom);
  var nf = 1 / (near - far);
  out[0] = near * 2 * rl;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = near * 2 * tb;
  out[6] = 0;
  out[7] = 0;
  out[8] = (right + left) * rl;
  out[9] = (top + bottom) * tb;
  out[10] = (far + near) * nf;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[14] = far * near * 2 * nf;
  out[15] = 0;
  return out;
}
/**
 * Generates a perspective projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [-1, 1],
 * which matches WebGL/OpenGL's clip volume.
 * Passing null/undefined/no value for far will generate infinite projection matrix.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum, can be null or Infinity
 * @returns {mat4} out
 */

function perspectiveNO(out, fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2),
      nf;
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[15] = 0;

  if (far != null && far !== Infinity) {
    nf = 1 / (near - far);
    out[10] = (far + near) * nf;
    out[14] = 2 * far * near * nf;
  } else {
    out[10] = -1;
    out[14] = -2 * near;
  }

  return out;
}
/**
 * Alias for {@link mat4.perspectiveNO}
 * @function
 */

var perspective = perspectiveNO;
/**
 * Generates a perspective projection matrix suitable for WebGPU with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [0, 1],
 * which matches WebGPU/Vulkan/DirectX/Metal's clip volume.
 * Passing null/undefined/no value for far will generate infinite projection matrix.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum, can be null or Infinity
 * @returns {mat4} out
 */

function perspectiveZO(out, fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2),
      nf;
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[15] = 0;

  if (far != null && far !== Infinity) {
    nf = 1 / (near - far);
    out[10] = far * nf;
    out[14] = far * near * nf;
  } else {
    out[10] = -1;
    out[14] = -near;
  }

  return out;
}
/**
 * Generates a perspective projection matrix with the given field of view.
 * This is primarily useful for generating projection matrices to be used
 * with the still experiemental WebVR API.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Object} fov Object containing the following values: upDegrees, downDegrees, leftDegrees, rightDegrees
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function perspectiveFromFieldOfView(out, fov, near, far) {
  var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
  var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
  var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
  var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
  var xScale = 2.0 / (leftTan + rightTan);
  var yScale = 2.0 / (upTan + downTan);
  out[0] = xScale;
  out[1] = 0.0;
  out[2] = 0.0;
  out[3] = 0.0;
  out[4] = 0.0;
  out[5] = yScale;
  out[6] = 0.0;
  out[7] = 0.0;
  out[8] = -((leftTan - rightTan) * xScale * 0.5);
  out[9] = (upTan - downTan) * yScale * 0.5;
  out[10] = far / (near - far);
  out[11] = -1.0;
  out[12] = 0.0;
  out[13] = 0.0;
  out[14] = far * near / (near - far);
  out[15] = 0.0;
  return out;
}
/**
 * Generates a orthogonal projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [-1, 1],
 * which matches WebGL/OpenGL's clip volume.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function orthoNO(out, left, right, bottom, top, near, far) {
  var lr = 1 / (left - right);
  var bt = 1 / (bottom - top);
  var nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 2 * nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = (far + near) * nf;
  out[15] = 1;
  return out;
}
/**
 * Alias for {@link mat4.orthoNO}
 * @function
 */

var ortho = orthoNO;
/**
 * Generates a orthogonal projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [0, 1],
 * which matches WebGPU/Vulkan/DirectX/Metal's clip volume.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function orthoZO(out, left, right, bottom, top, near, far) {
  var lr = 1 / (left - right);
  var bt = 1 / (bottom - top);
  var nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = near * nf;
  out[15] = 1;
  return out;
}
/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis.
 * If you want a matrix that actually makes an object look at another object, you should use targetTo instead.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {ReadonlyVec3} eye Position of the viewer
 * @param {ReadonlyVec3} center Point the viewer is looking at
 * @param {ReadonlyVec3} up vec3 pointing up
 * @returns {mat4} out
 */

function lookAt(out, eye, center, up) {
  var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
  var eyex = eye[0];
  var eyey = eye[1];
  var eyez = eye[2];
  var upx = up[0];
  var upy = up[1];
  var upz = up[2];
  var centerx = center[0];
  var centery = center[1];
  var centerz = center[2];

  if (Math.abs(eyex - centerx) < EPSILON && Math.abs(eyey - centery) < EPSILON && Math.abs(eyez - centerz) < EPSILON) {
    return mat4_identity(out);
  }

  z0 = eyex - centerx;
  z1 = eyey - centery;
  z2 = eyez - centerz;
  len = 1 / Math.hypot(z0, z1, z2);
  z0 *= len;
  z1 *= len;
  z2 *= len;
  x0 = upy * z2 - upz * z1;
  x1 = upz * z0 - upx * z2;
  x2 = upx * z1 - upy * z0;
  len = Math.hypot(x0, x1, x2);

  if (!len) {
    x0 = 0;
    x1 = 0;
    x2 = 0;
  } else {
    len = 1 / len;
    x0 *= len;
    x1 *= len;
    x2 *= len;
  }

  y0 = z1 * x2 - z2 * x1;
  y1 = z2 * x0 - z0 * x2;
  y2 = z0 * x1 - z1 * x0;
  len = Math.hypot(y0, y1, y2);

  if (!len) {
    y0 = 0;
    y1 = 0;
    y2 = 0;
  } else {
    len = 1 / len;
    y0 *= len;
    y1 *= len;
    y2 *= len;
  }

  out[0] = x0;
  out[1] = y0;
  out[2] = z0;
  out[3] = 0;
  out[4] = x1;
  out[5] = y1;
  out[6] = z1;
  out[7] = 0;
  out[8] = x2;
  out[9] = y2;
  out[10] = z2;
  out[11] = 0;
  out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
  out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
  out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
  out[15] = 1;
  return out;
}
/**
 * Generates a matrix that makes something look at something else.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {ReadonlyVec3} eye Position of the viewer
 * @param {ReadonlyVec3} center Point the viewer is looking at
 * @param {ReadonlyVec3} up vec3 pointing up
 * @returns {mat4} out
 */

function targetTo(out, eye, target, up) {
  var eyex = eye[0],
      eyey = eye[1],
      eyez = eye[2],
      upx = up[0],
      upy = up[1],
      upz = up[2];
  var z0 = eyex - target[0],
      z1 = eyey - target[1],
      z2 = eyez - target[2];
  var len = z0 * z0 + z1 * z1 + z2 * z2;

  if (len > 0) {
    len = 1 / Math.sqrt(len);
    z0 *= len;
    z1 *= len;
    z2 *= len;
  }

  var x0 = upy * z2 - upz * z1,
      x1 = upz * z0 - upx * z2,
      x2 = upx * z1 - upy * z0;
  len = x0 * x0 + x1 * x1 + x2 * x2;

  if (len > 0) {
    len = 1 / Math.sqrt(len);
    x0 *= len;
    x1 *= len;
    x2 *= len;
  }

  out[0] = x0;
  out[1] = x1;
  out[2] = x2;
  out[3] = 0;
  out[4] = z1 * x2 - z2 * x1;
  out[5] = z2 * x0 - z0 * x2;
  out[6] = z0 * x1 - z1 * x0;
  out[7] = 0;
  out[8] = z0;
  out[9] = z1;
  out[10] = z2;
  out[11] = 0;
  out[12] = eyex;
  out[13] = eyey;
  out[14] = eyez;
  out[15] = 1;
  return out;
}
/**
 * Returns a string representation of a mat4
 *
 * @param {ReadonlyMat4} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function mat4_str(a) {
  return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
/**
 * Returns Frobenius norm of a mat4
 *
 * @param {ReadonlyMat4} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function mat4_frob(a) {
  return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
/**
 * Adds two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function mat4_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  out[8] = a[8] + b[8];
  out[9] = a[9] + b[9];
  out[10] = a[10] + b[10];
  out[11] = a[11] + b[11];
  out[12] = a[12] + b[12];
  out[13] = a[13] + b[13];
  out[14] = a[14] + b[14];
  out[15] = a[15] + b[15];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function mat4_subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  out[6] = a[6] - b[6];
  out[7] = a[7] - b[7];
  out[8] = a[8] - b[8];
  out[9] = a[9] - b[9];
  out[10] = a[10] - b[10];
  out[11] = a[11] - b[11];
  out[12] = a[12] - b[12];
  out[13] = a[13] - b[13];
  out[14] = a[14] - b[14];
  out[15] = a[15] - b[15];
  return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat4} out
 */

function mat4_multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  out[8] = a[8] * b;
  out[9] = a[9] * b;
  out[10] = a[10] * b;
  out[11] = a[11] * b;
  out[12] = a[12] * b;
  out[13] = a[13] * b;
  out[14] = a[14] * b;
  out[15] = a[15] * b;
  return out;
}
/**
 * Adds two mat4's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat4} out the receiving vector
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat4} out
 */

function mat4_multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  out[4] = a[4] + b[4] * scale;
  out[5] = a[5] + b[5] * scale;
  out[6] = a[6] + b[6] * scale;
  out[7] = a[7] + b[7] * scale;
  out[8] = a[8] + b[8] * scale;
  out[9] = a[9] + b[9] * scale;
  out[10] = a[10] + b[10] * scale;
  out[11] = a[11] + b[11] * scale;
  out[12] = a[12] + b[12] * scale;
  out[13] = a[13] + b[13] * scale;
  out[14] = a[14] + b[14] * scale;
  out[15] = a[15] + b[15] * scale;
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat4_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function mat4_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var a4 = a[4],
      a5 = a[5],
      a6 = a[6],
      a7 = a[7];
  var a8 = a[8],
      a9 = a[9],
      a10 = a[10],
      a11 = a[11];
  var a12 = a[12],
      a13 = a[13],
      a14 = a[14],
      a15 = a[15];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  var b4 = b[4],
      b5 = b[5],
      b6 = b[6],
      b7 = b[7];
  var b8 = b[8],
      b9 = b[9],
      b10 = b[10],
      b11 = b[11];
  var b12 = b[12],
      b13 = b[13],
      b14 = b[14],
      b15 = b[15];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
/**
 * Alias for {@link mat4.multiply}
 * @function
 */

var mat4_mul = mat4_multiply;
/**
 * Alias for {@link mat4.subtract}
 * @function
 */

var mat4_sub = mat4_subtract;
// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/vec3.js

/**
 * 3 Dimensional Vector
 * @module vec3
 */

/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */

function vec3_create() {
  var out = new ARRAY_TYPE(3);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }

  return out;
}
/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {ReadonlyVec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */

function vec3_clone(a) {
  var out = new ARRAY_TYPE(3);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Calculates the length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate length of
 * @returns {Number} length of a
 */

function vec3_length(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  return Math.hypot(x, y, z);
}
/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */

function vec3_fromValues(x, y, z) {
  var out = new ARRAY_TYPE(3);
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the source vector
 * @returns {vec3} out
 */

function vec3_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */

function vec3_set(out, x, y, z) {
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function vec3_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function vec3_subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  return out;
}
/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function vec3_multiply(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  out[2] = a[2] * b[2];
  return out;
}
/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function divide(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  out[2] = a[2] / b[2];
  return out;
}
/**
 * Math.ceil the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to ceil
 * @returns {vec3} out
 */

function ceil(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  out[2] = Math.ceil(a[2]);
  return out;
}
/**
 * Math.floor the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to floor
 * @returns {vec3} out
 */

function floor(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  out[2] = Math.floor(a[2]);
  return out;
}
/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function min(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  out[2] = Math.min(a[2], b[2]);
  return out;
}
/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function max(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  out[2] = Math.max(a[2], b[2]);
  return out;
}
/**
 * Math.round the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to round
 * @returns {vec3} out
 */

function round(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  out[2] = Math.round(a[2]);
  return out;
}
/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */

function vec3_scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  return out;
}
/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */

function scaleAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} distance between a and b
 */

function distance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return Math.hypot(x, y, z);
}
/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} squared distance between a and b
 */

function squaredDistance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return x * x + y * y + z * z;
}
/**
 * Calculates the squared length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function squaredLength(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  return x * x + y * y + z * z;
}
/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to negate
 * @returns {vec3} out
 */

function negate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  return out;
}
/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to invert
 * @returns {vec3} out
 */

function inverse(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  return out;
}
/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to normalize
 * @returns {vec3} out
 */

function normalize(out, a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var len = x * x + y * y + z * z;

  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
  }

  out[0] = a[0] * len;
  out[1] = a[1] * len;
  out[2] = a[2] * len;
  return out;
}
/**
 * Calculates the dot product of two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} dot product of a and b
 */

function vec3_dot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function cross(out, a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2];
  var bx = b[0],
      by = b[1],
      bz = b[2];
  out[0] = ay * bz - az * by;
  out[1] = az * bx - ax * bz;
  out[2] = ax * by - ay * bx;
  return out;
}
/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function lerp(out, a, b, t) {
  var ax = a[0];
  var ay = a[1];
  var az = a[2];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  out[2] = az + t * (b[2] - az);
  return out;
}
/**
 * Performs a hermite interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function hermite(out, a, b, c, d, t) {
  var factorTimes2 = t * t;
  var factor1 = factorTimes2 * (2 * t - 3) + 1;
  var factor2 = factorTimes2 * (t - 2) + t;
  var factor3 = factorTimes2 * (t - 1);
  var factor4 = factorTimes2 * (3 - 2 * t);
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  return out;
}
/**
 * Performs a bezier interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function bezier(out, a, b, c, d, t) {
  var inverseFactor = 1 - t;
  var inverseFactorTimesTwo = inverseFactor * inverseFactor;
  var factorTimes2 = t * t;
  var factor1 = inverseFactorTimesTwo * inverseFactor;
  var factor2 = 3 * t * inverseFactorTimesTwo;
  var factor3 = 3 * factorTimes2 * inverseFactor;
  var factor4 = factorTimes2 * t;
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec3} out
 */

function random(out, scale) {
  scale = scale || 1.0;
  var r = RANDOM() * 2.0 * Math.PI;
  var z = RANDOM() * 2.0 - 1.0;
  var zScale = Math.sqrt(1.0 - z * z) * scale;
  out[0] = Math.cos(r) * zScale;
  out[1] = Math.sin(r) * zScale;
  out[2] = z * scale;
  return out;
}
/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec3} out
 */

function transformMat4(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2];
  var w = m[3] * x + m[7] * y + m[11] * z + m[15];
  w = w || 1.0;
  out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
  out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
  out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
  return out;
}
/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat3} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */

function transformMat3(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2];
  out[0] = x * m[0] + y * m[3] + z * m[6];
  out[1] = x * m[1] + y * m[4] + z * m[7];
  out[2] = x * m[2] + y * m[5] + z * m[8];
  return out;
}
/**
 * Transforms the vec3 with a quat
 * Can also be used for dual quaternions. (Multiply it with the real part)
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyQuat} q quaternion to transform with
 * @returns {vec3} out
 */

function transformQuat(out, a, q) {
  // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
  var qx = q[0],
      qy = q[1],
      qz = q[2],
      qw = q[3];
  var x = a[0],
      y = a[1],
      z = a[2]; // var qvec = [qx, qy, qz];
  // var uv = vec3.cross([], qvec, a);

  var uvx = qy * z - qz * y,
      uvy = qz * x - qx * z,
      uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);

  var uuvx = qy * uvz - qz * uvy,
      uuvy = qz * uvx - qx * uvz,
      uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);

  var w2 = qw * 2;
  uvx *= w2;
  uvy *= w2;
  uvz *= w2; // vec3.scale(uuv, uuv, 2);

  uuvx *= 2;
  uuvy *= 2;
  uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));

  out[0] = x + uvx + uuvx;
  out[1] = y + uvy + uuvy;
  out[2] = z + uvz + uuvz;
  return out;
}
/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function vec3_rotateX(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[0];
  r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
  r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function vec3_rotateY(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
  r[1] = p[1];
  r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function vec3_rotateZ(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
  r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
  r[2] = p[2]; //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Get the angle between two 3D vectors
 * @param {ReadonlyVec3} a The first operand
 * @param {ReadonlyVec3} b The second operand
 * @returns {Number} The angle in radians
 */

function angle(a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2],
      bx = b[0],
      by = b[1],
      bz = b[2],
      mag1 = Math.sqrt(ax * ax + ay * ay + az * az),
      mag2 = Math.sqrt(bx * bx + by * by + bz * bz),
      mag = mag1 * mag2,
      cosine = mag && vec3_dot(a, b) / mag;
  return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
/**
 * Set the components of a vec3 to zero
 *
 * @param {vec3} out the receiving vector
 * @returns {vec3} out
 */

function zero(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  out[2] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec3} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function vec3_str(a) {
  return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function vec3_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function vec3_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
/**
 * Alias for {@link vec3.subtract}
 * @function
 */

var vec3_sub = vec3_subtract;
/**
 * Alias for {@link vec3.multiply}
 * @function
 */

var vec3_mul = vec3_multiply;
/**
 * Alias for {@link vec3.divide}
 * @function
 */

var div = divide;
/**
 * Alias for {@link vec3.distance}
 * @function
 */

var dist = distance;
/**
 * Alias for {@link vec3.squaredDistance}
 * @function
 */

var sqrDist = squaredDistance;
/**
 * Alias for {@link vec3.length}
 * @function
 */

var vec3_len = vec3_length;
/**
 * Alias for {@link vec3.squaredLength}
 * @function
 */

var sqrLen = squaredLength;
/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var forEach = function () {
  var vec = vec3_create();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 3;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      vec[2] = a[i + 2];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
      a[i + 2] = vec[2];
    }

    return a;
  };
}();
// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/vec4.js

/**
 * 4 Dimensional Vector
 * @module vec4
 */

/**
 * Creates a new, empty vec4
 *
 * @returns {vec4} a new 4D vector
 */

function vec4_create() {
  var out = new ARRAY_TYPE(4);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
  }

  return out;
}
/**
 * Creates a new vec4 initialized with values from an existing vector
 *
 * @param {ReadonlyVec4} a vector to clone
 * @returns {vec4} a new 4D vector
 */

function vec4_clone(a) {
  var out = new ARRAY_TYPE(4);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}
/**
 * Creates a new vec4 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} a new 4D vector
 */

function vec4_fromValues(x, y, z, w) {
  var out = new ARRAY_TYPE(4);
  out[0] = x;
  out[1] = y;
  out[2] = z;
  out[3] = w;
  return out;
}
/**
 * Copy the values from one vec4 to another
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the source vector
 * @returns {vec4} out
 */

function vec4_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}
/**
 * Set the components of a vec4 to the given values
 *
 * @param {vec4} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} out
 */

function vec4_set(out, x, y, z, w) {
  out[0] = x;
  out[1] = y;
  out[2] = z;
  out[3] = w;
  return out;
}
/**
 * Adds two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function vec4_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function vec4_subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  return out;
}
/**
 * Multiplies two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function vec4_multiply(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  out[2] = a[2] * b[2];
  out[3] = a[3] * b[3];
  return out;
}
/**
 * Divides two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function vec4_divide(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  out[2] = a[2] / b[2];
  out[3] = a[3] / b[3];
  return out;
}
/**
 * Math.ceil the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to ceil
 * @returns {vec4} out
 */

function vec4_ceil(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  out[2] = Math.ceil(a[2]);
  out[3] = Math.ceil(a[3]);
  return out;
}
/**
 * Math.floor the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to floor
 * @returns {vec4} out
 */

function vec4_floor(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  out[2] = Math.floor(a[2]);
  out[3] = Math.floor(a[3]);
  return out;
}
/**
 * Returns the minimum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function vec4_min(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  out[2] = Math.min(a[2], b[2]);
  out[3] = Math.min(a[3], b[3]);
  return out;
}
/**
 * Returns the maximum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {vec4} out
 */

function vec4_max(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  out[2] = Math.max(a[2], b[2]);
  out[3] = Math.max(a[3], b[3]);
  return out;
}
/**
 * Math.round the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to round
 * @returns {vec4} out
 */

function vec4_round(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  out[2] = Math.round(a[2]);
  out[3] = Math.round(a[3]);
  return out;
}
/**
 * Scales a vec4 by a scalar number
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec4} out
 */

function vec4_scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  return out;
}
/**
 * Adds two vec4's after scaling the second operand by a scalar value
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec4} out
 */

function vec4_scaleAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} distance between a and b
 */

function vec4_distance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  var w = b[3] - a[3];
  return Math.hypot(x, y, z, w);
}
/**
 * Calculates the squared euclidian distance between two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} squared distance between a and b
 */

function vec4_squaredDistance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  var w = b[3] - a[3];
  return x * x + y * y + z * z + w * w;
}
/**
 * Calculates the length of a vec4
 *
 * @param {ReadonlyVec4} a vector to calculate length of
 * @returns {Number} length of a
 */

function vec4_length(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var w = a[3];
  return Math.hypot(x, y, z, w);
}
/**
 * Calculates the squared length of a vec4
 *
 * @param {ReadonlyVec4} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function vec4_squaredLength(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var w = a[3];
  return x * x + y * y + z * z + w * w;
}
/**
 * Negates the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to negate
 * @returns {vec4} out
 */

function vec4_negate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] = -a[3];
  return out;
}
/**
 * Returns the inverse of the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to invert
 * @returns {vec4} out
 */

function vec4_inverse(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  out[3] = 1.0 / a[3];
  return out;
}
/**
 * Normalize a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a vector to normalize
 * @returns {vec4} out
 */

function vec4_normalize(out, a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var w = a[3];
  var len = x * x + y * y + z * z + w * w;

  if (len > 0) {
    len = 1 / Math.sqrt(len);
  }

  out[0] = x * len;
  out[1] = y * len;
  out[2] = z * len;
  out[3] = w * len;
  return out;
}
/**
 * Calculates the dot product of two vec4's
 *
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @returns {Number} dot product of a and b
 */

function vec4_dot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
/**
 * Returns the cross-product of three vectors in a 4-dimensional space
 *
 * @param {ReadonlyVec4} result the receiving vector
 * @param {ReadonlyVec4} U the first vector
 * @param {ReadonlyVec4} V the second vector
 * @param {ReadonlyVec4} W the third vector
 * @returns {vec4} result
 */

function vec4_cross(out, u, v, w) {
  var A = v[0] * w[1] - v[1] * w[0],
      B = v[0] * w[2] - v[2] * w[0],
      C = v[0] * w[3] - v[3] * w[0],
      D = v[1] * w[2] - v[2] * w[1],
      E = v[1] * w[3] - v[3] * w[1],
      F = v[2] * w[3] - v[3] * w[2];
  var G = u[0];
  var H = u[1];
  var I = u[2];
  var J = u[3];
  out[0] = H * F - I * E + J * D;
  out[1] = -(G * F) + I * C - J * B;
  out[2] = G * E - H * C + J * A;
  out[3] = -(G * D) + H * B - I * A;
  return out;
}
/**
 * Performs a linear interpolation between two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the first operand
 * @param {ReadonlyVec4} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec4} out
 */

function vec4_lerp(out, a, b, t) {
  var ax = a[0];
  var ay = a[1];
  var az = a[2];
  var aw = a[3];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  out[2] = az + t * (b[2] - az);
  out[3] = aw + t * (b[3] - aw);
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec4} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec4} out
 */

function vec4_random(out, scale) {
  scale = scale || 1.0; // Marsaglia, George. Choosing a Point from the Surface of a
  // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
  // http://projecteuclid.org/euclid.aoms/1177692644;

  var v1, v2, v3, v4;
  var s1, s2;

  do {
    v1 = RANDOM() * 2 - 1;
    v2 = RANDOM() * 2 - 1;
    s1 = v1 * v1 + v2 * v2;
  } while (s1 >= 1);

  do {
    v3 = RANDOM() * 2 - 1;
    v4 = RANDOM() * 2 - 1;
    s2 = v3 * v3 + v4 * v4;
  } while (s2 >= 1);

  var d = Math.sqrt((1 - s1) / s2);
  out[0] = scale * v1;
  out[1] = scale * v2;
  out[2] = scale * v3 * d;
  out[3] = scale * v4 * d;
  return out;
}
/**
 * Transforms the vec4 with a mat4.
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec4} out
 */

function vec4_transformMat4(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3];
  out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
  out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
  out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
  out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
  return out;
}
/**
 * Transforms the vec4 with a quat
 *
 * @param {vec4} out the receiving vector
 * @param {ReadonlyVec4} a the vector to transform
 * @param {ReadonlyQuat} q quaternion to transform with
 * @returns {vec4} out
 */

function vec4_transformQuat(out, a, q) {
  var x = a[0],
      y = a[1],
      z = a[2];
  var qx = q[0],
      qy = q[1],
      qz = q[2],
      qw = q[3]; // calculate quat * vec

  var ix = qw * x + qy * z - qz * y;
  var iy = qw * y + qz * x - qx * z;
  var iz = qw * z + qx * y - qy * x;
  var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat

  out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
  out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
  out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
  out[3] = a[3];
  return out;
}
/**
 * Set the components of a vec4 to zero
 *
 * @param {vec4} out the receiving vector
 * @returns {vec4} out
 */

function vec4_zero(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  out[2] = 0.0;
  out[3] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec4} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function vec4_str(a) {
  return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec4} a The first vector.
 * @param {ReadonlyVec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function vec4_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec4} a The first vector.
 * @param {ReadonlyVec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function vec4_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
/**
 * Alias for {@link vec4.subtract}
 * @function
 */

var vec4_sub = vec4_subtract;
/**
 * Alias for {@link vec4.multiply}
 * @function
 */

var vec4_mul = vec4_multiply;
/**
 * Alias for {@link vec4.divide}
 * @function
 */

var vec4_div = vec4_divide;
/**
 * Alias for {@link vec4.distance}
 * @function
 */

var vec4_dist = vec4_distance;
/**
 * Alias for {@link vec4.squaredDistance}
 * @function
 */

var vec4_sqrDist = vec4_squaredDistance;
/**
 * Alias for {@link vec4.length}
 * @function
 */

var vec4_len = vec4_length;
/**
 * Alias for {@link vec4.squaredLength}
 * @function
 */

var vec4_sqrLen = vec4_squaredLength;
/**
 * Perform some operation over an array of vec4s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec4. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec4s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var vec4_forEach = function () {
  var vec = vec4_create();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 4;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      vec[2] = a[i + 2];
      vec[3] = a[i + 3];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
      a[i + 2] = vec[2];
      a[i + 3] = vec[3];
    }

    return a;
  };
}();
// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/quat.js




/**
 * Quaternion
 * @module quat
 */

/**
 * Creates a new identity quat
 *
 * @returns {quat} a new quaternion
 */

function quat_create() {
  var out = new ARRAY_TYPE(4);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }

  out[3] = 1;
  return out;
}
/**
 * Set a quat to the identity quaternion
 *
 * @param {quat} out the receiving quaternion
 * @returns {quat} out
 */

function quat_identity(out) {
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  return out;
}
/**
 * Sets a quat from the given angle and rotation axis,
 * then returns it.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyVec3} axis the axis around which to rotate
 * @param {Number} rad the angle in radians
 * @returns {quat} out
 **/

function setAxisAngle(out, axis, rad) {
  rad = rad * 0.5;
  var s = Math.sin(rad);
  out[0] = s * axis[0];
  out[1] = s * axis[1];
  out[2] = s * axis[2];
  out[3] = Math.cos(rad);
  return out;
}
/**
 * Gets the rotation axis and angle for a given
 *  quaternion. If a quaternion is created with
 *  setAxisAngle, this method will return the same
 *  values as providied in the original parameter list
 *  OR functionally equivalent values.
 * Example: The quaternion formed by axis [0, 0, 1] and
 *  angle -90 is the same as the quaternion formed by
 *  [0, 0, 1] and 270. This method favors the latter.
 * @param  {vec3} out_axis  Vector receiving the axis of rotation
 * @param  {ReadonlyQuat} q     Quaternion to be decomposed
 * @return {Number}     Angle, in radians, of the rotation
 */

function getAxisAngle(out_axis, q) {
  var rad = Math.acos(q[3]) * 2.0;
  var s = Math.sin(rad / 2.0);

  if (s > EPSILON) {
    out_axis[0] = q[0] / s;
    out_axis[1] = q[1] / s;
    out_axis[2] = q[2] / s;
  } else {
    // If s is zero, return any axis (no rotation - axis does not matter)
    out_axis[0] = 1;
    out_axis[1] = 0;
    out_axis[2] = 0;
  }

  return rad;
}
/**
 * Gets the angular distance between two unit quaternions
 *
 * @param  {ReadonlyQuat} a     Origin unit quaternion
 * @param  {ReadonlyQuat} b     Destination unit quaternion
 * @return {Number}     Angle, in radians, between the two quaternions
 */

function getAngle(a, b) {
  var dotproduct = quat_dot(a, b);
  return Math.acos(2 * dotproduct * dotproduct - 1);
}
/**
 * Multiplies two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @returns {quat} out
 */

function quat_multiply(out, a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var bx = b[0],
      by = b[1],
      bz = b[2],
      bw = b[3];
  out[0] = ax * bw + aw * bx + ay * bz - az * by;
  out[1] = ay * bw + aw * by + az * bx - ax * bz;
  out[2] = az * bw + aw * bz + ax * by - ay * bx;
  out[3] = aw * bw - ax * bx - ay * by - az * bz;
  return out;
}
/**
 * Rotates a quaternion by the given angle about the X axis
 *
 * @param {quat} out quat receiving operation result
 * @param {ReadonlyQuat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */

function quat_rotateX(out, a, rad) {
  rad *= 0.5;
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var bx = Math.sin(rad),
      bw = Math.cos(rad);
  out[0] = ax * bw + aw * bx;
  out[1] = ay * bw + az * bx;
  out[2] = az * bw - ay * bx;
  out[3] = aw * bw - ax * bx;
  return out;
}
/**
 * Rotates a quaternion by the given angle about the Y axis
 *
 * @param {quat} out quat receiving operation result
 * @param {ReadonlyQuat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */

function quat_rotateY(out, a, rad) {
  rad *= 0.5;
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var by = Math.sin(rad),
      bw = Math.cos(rad);
  out[0] = ax * bw - az * by;
  out[1] = ay * bw + aw * by;
  out[2] = az * bw + ax * by;
  out[3] = aw * bw - ay * by;
  return out;
}
/**
 * Rotates a quaternion by the given angle about the Z axis
 *
 * @param {quat} out quat receiving operation result
 * @param {ReadonlyQuat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */

function quat_rotateZ(out, a, rad) {
  rad *= 0.5;
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var bz = Math.sin(rad),
      bw = Math.cos(rad);
  out[0] = ax * bw + ay * bz;
  out[1] = ay * bw - ax * bz;
  out[2] = az * bw + aw * bz;
  out[3] = aw * bw - az * bz;
  return out;
}
/**
 * Calculates the W component of a quat from the X, Y, and Z components.
 * Assumes that quaternion is 1 unit in length.
 * Any existing W component will be ignored.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate W component of
 * @returns {quat} out
 */

function calculateW(out, a) {
  var x = a[0],
      y = a[1],
      z = a[2];
  out[0] = x;
  out[1] = y;
  out[2] = z;
  out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
  return out;
}
/**
 * Calculate the exponential of a unit quaternion.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate the exponential of
 * @returns {quat} out
 */

function exp(out, a) {
  var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3];
  var r = Math.sqrt(x * x + y * y + z * z);
  var et = Math.exp(w);
  var s = r > 0 ? et * Math.sin(r) / r : 0;
  out[0] = x * s;
  out[1] = y * s;
  out[2] = z * s;
  out[3] = et * Math.cos(r);
  return out;
}
/**
 * Calculate the natural logarithm of a unit quaternion.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate the exponential of
 * @returns {quat} out
 */

function ln(out, a) {
  var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3];
  var r = Math.sqrt(x * x + y * y + z * z);
  var t = r > 0 ? Math.atan2(r, w) / r : 0;
  out[0] = x * t;
  out[1] = y * t;
  out[2] = z * t;
  out[3] = 0.5 * Math.log(x * x + y * y + z * z + w * w);
  return out;
}
/**
 * Calculate the scalar power of a unit quaternion.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate the exponential of
 * @param {Number} b amount to scale the quaternion by
 * @returns {quat} out
 */

function pow(out, a, b) {
  ln(out, a);
  quat_scale(out, out, b);
  exp(out, out);
  return out;
}
/**
 * Performs a spherical linear interpolation between two quat
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {quat} out
 */

function slerp(out, a, b, t) {
  // benchmarks:
  //    http://jsperf.com/quaternion-slerp-implementations
  var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  var bx = b[0],
      by = b[1],
      bz = b[2],
      bw = b[3];
  var omega, cosom, sinom, scale0, scale1; // calc cosine

  cosom = ax * bx + ay * by + az * bz + aw * bw; // adjust signs (if necessary)

  if (cosom < 0.0) {
    cosom = -cosom;
    bx = -bx;
    by = -by;
    bz = -bz;
    bw = -bw;
  } // calculate coefficients


  if (1.0 - cosom > EPSILON) {
    // standard case (slerp)
    omega = Math.acos(cosom);
    sinom = Math.sin(omega);
    scale0 = Math.sin((1.0 - t) * omega) / sinom;
    scale1 = Math.sin(t * omega) / sinom;
  } else {
    // "from" and "to" quaternions are very close
    //  ... so we can do a linear interpolation
    scale0 = 1.0 - t;
    scale1 = t;
  } // calculate final values


  out[0] = scale0 * ax + scale1 * bx;
  out[1] = scale0 * ay + scale1 * by;
  out[2] = scale0 * az + scale1 * bz;
  out[3] = scale0 * aw + scale1 * bw;
  return out;
}
/**
 * Generates a random unit quaternion
 *
 * @param {quat} out the receiving quaternion
 * @returns {quat} out
 */

function quat_random(out) {
  // Implementation of http://planning.cs.uiuc.edu/node198.html
  // TODO: Calling random 3 times is probably not the fastest solution
  var u1 = RANDOM();
  var u2 = RANDOM();
  var u3 = RANDOM();
  var sqrt1MinusU1 = Math.sqrt(1 - u1);
  var sqrtU1 = Math.sqrt(u1);
  out[0] = sqrt1MinusU1 * Math.sin(2.0 * Math.PI * u2);
  out[1] = sqrt1MinusU1 * Math.cos(2.0 * Math.PI * u2);
  out[2] = sqrtU1 * Math.sin(2.0 * Math.PI * u3);
  out[3] = sqrtU1 * Math.cos(2.0 * Math.PI * u3);
  return out;
}
/**
 * Calculates the inverse of a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate inverse of
 * @returns {quat} out
 */

function quat_invert(out, a) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
  var invDot = dot ? 1.0 / dot : 0; // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0

  out[0] = -a0 * invDot;
  out[1] = -a1 * invDot;
  out[2] = -a2 * invDot;
  out[3] = a3 * invDot;
  return out;
}
/**
 * Calculates the conjugate of a quat
 * If the quaternion is normalized, this function is faster than quat.inverse and produces the same result.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quat to calculate conjugate of
 * @returns {quat} out
 */

function conjugate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] = a[3];
  return out;
}
/**
 * Creates a quaternion from the given 3x3 rotation matrix.
 *
 * NOTE: The resultant quaternion is not normalized, so you should be sure
 * to renormalize the quaternion yourself where necessary.
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyMat3} m rotation matrix
 * @returns {quat} out
 * @function
 */

function fromMat3(out, m) {
  // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
  // article "Quaternion Calculus and Fast Animation".
  var fTrace = m[0] + m[4] + m[8];
  var fRoot;

  if (fTrace > 0.0) {
    // |w| > 1/2, may as well choose w > 1/2
    fRoot = Math.sqrt(fTrace + 1.0); // 2w

    out[3] = 0.5 * fRoot;
    fRoot = 0.5 / fRoot; // 1/(4w)

    out[0] = (m[5] - m[7]) * fRoot;
    out[1] = (m[6] - m[2]) * fRoot;
    out[2] = (m[1] - m[3]) * fRoot;
  } else {
    // |w| <= 1/2
    var i = 0;
    if (m[4] > m[0]) i = 1;
    if (m[8] > m[i * 3 + i]) i = 2;
    var j = (i + 1) % 3;
    var k = (i + 2) % 3;
    fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
    out[i] = 0.5 * fRoot;
    fRoot = 0.5 / fRoot;
    out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
    out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
    out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
  }

  return out;
}
/**
 * Creates a quaternion from the given euler angle x, y, z.
 *
 * @param {quat} out the receiving quaternion
 * @param {x} Angle to rotate around X axis in degrees.
 * @param {y} Angle to rotate around Y axis in degrees.
 * @param {z} Angle to rotate around Z axis in degrees.
 * @returns {quat} out
 * @function
 */

function fromEuler(out, x, y, z) {
  var halfToRad = 0.5 * Math.PI / 180.0;
  x *= halfToRad;
  y *= halfToRad;
  z *= halfToRad;
  var sx = Math.sin(x);
  var cx = Math.cos(x);
  var sy = Math.sin(y);
  var cy = Math.cos(y);
  var sz = Math.sin(z);
  var cz = Math.cos(z);
  out[0] = sx * cy * cz - cx * sy * sz;
  out[1] = cx * sy * cz + sx * cy * sz;
  out[2] = cx * cy * sz - sx * sy * cz;
  out[3] = cx * cy * cz + sx * sy * sz;
  return out;
}
/**
 * Returns a string representation of a quatenion
 *
 * @param {ReadonlyQuat} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function quat_str(a) {
  return "quat(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
/**
 * Creates a new quat initialized with values from an existing quaternion
 *
 * @param {ReadonlyQuat} a quaternion to clone
 * @returns {quat} a new quaternion
 * @function
 */

var quat_clone = vec4_clone;
/**
 * Creates a new quat initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} a new quaternion
 * @function
 */

var quat_fromValues = vec4_fromValues;
/**
 * Copy the values from one quat to another
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the source quaternion
 * @returns {quat} out
 * @function
 */

var quat_copy = vec4_copy;
/**
 * Set the components of a quat to the given values
 *
 * @param {quat} out the receiving quaternion
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} out
 * @function
 */

var quat_set = vec4_set;
/**
 * Adds two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @returns {quat} out
 * @function
 */

var quat_add = vec4_add;
/**
 * Alias for {@link quat.multiply}
 * @function
 */

var quat_mul = quat_multiply;
/**
 * Scales a quat by a scalar number
 *
 * @param {quat} out the receiving vector
 * @param {ReadonlyQuat} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {quat} out
 * @function
 */

var quat_scale = vec4_scale;
/**
 * Calculates the dot product of two quat's
 *
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @returns {Number} dot product of a and b
 * @function
 */

var quat_dot = vec4_dot;
/**
 * Performs a linear interpolation between two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {quat} out
 * @function
 */

var quat_lerp = vec4_lerp;
/**
 * Calculates the length of a quat
 *
 * @param {ReadonlyQuat} a vector to calculate length of
 * @returns {Number} length of a
 */

var quat_length = vec4_length;
/**
 * Alias for {@link quat.length}
 * @function
 */

var quat_len = quat_length;
/**
 * Calculates the squared length of a quat
 *
 * @param {ReadonlyQuat} a vector to calculate squared length of
 * @returns {Number} squared length of a
 * @function
 */

var quat_squaredLength = vec4_squaredLength;
/**
 * Alias for {@link quat.squaredLength}
 * @function
 */

var quat_sqrLen = quat_squaredLength;
/**
 * Normalize a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a quaternion to normalize
 * @returns {quat} out
 * @function
 */

var quat_normalize = vec4_normalize;
/**
 * Returns whether or not the quaternions have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyQuat} a The first quaternion.
 * @param {ReadonlyQuat} b The second quaternion.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

var quat_exactEquals = vec4_exactEquals;
/**
 * Returns whether or not the quaternions have approximately the same elements in the same position.
 *
 * @param {ReadonlyQuat} a The first vector.
 * @param {ReadonlyQuat} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

var quat_equals = vec4_equals;
/**
 * Sets a quaternion to represent the shortest rotation from one
 * vector to another.
 *
 * Both vectors are assumed to be unit length.
 *
 * @param {quat} out the receiving quaternion.
 * @param {ReadonlyVec3} a the initial vector
 * @param {ReadonlyVec3} b the destination vector
 * @returns {quat} out
 */

var rotationTo = function () {
  var tmpvec3 = vec3_create();
  var xUnitVec3 = vec3_fromValues(1, 0, 0);
  var yUnitVec3 = vec3_fromValues(0, 1, 0);
  return function (out, a, b) {
    var dot = vec3_dot(a, b);

    if (dot < -0.999999) {
      cross(tmpvec3, xUnitVec3, a);
      if (vec3_len(tmpvec3) < 0.000001) cross(tmpvec3, yUnitVec3, a);
      normalize(tmpvec3, tmpvec3);
      setAxisAngle(out, tmpvec3, Math.PI);
      return out;
    } else if (dot > 0.999999) {
      out[0] = 0;
      out[1] = 0;
      out[2] = 0;
      out[3] = 1;
      return out;
    } else {
      cross(tmpvec3, a, b);
      out[0] = tmpvec3[0];
      out[1] = tmpvec3[1];
      out[2] = tmpvec3[2];
      out[3] = 1 + dot;
      return quat_normalize(out, out);
    }
  };
}();
/**
 * Performs a spherical linear interpolation with two control points
 *
 * @param {quat} out the receiving quaternion
 * @param {ReadonlyQuat} a the first operand
 * @param {ReadonlyQuat} b the second operand
 * @param {ReadonlyQuat} c the third operand
 * @param {ReadonlyQuat} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {quat} out
 */

var sqlerp = function () {
  var temp1 = quat_create();
  var temp2 = quat_create();
  return function (out, a, b, c, d, t) {
    slerp(temp1, a, d, t);
    slerp(temp2, b, c, t);
    slerp(out, temp1, temp2, 2 * t * (1 - t));
    return out;
  };
}();
/**
 * Sets the specified quaternion with values corresponding to the given
 * axes. Each axis is a vec3 and is expected to be unit length and
 * perpendicular to all other specified axes.
 *
 * @param {ReadonlyVec3} view  the vector representing the viewing direction
 * @param {ReadonlyVec3} right the vector representing the local "right" direction
 * @param {ReadonlyVec3} up    the vector representing the local "up" direction
 * @returns {quat} out
 */

var setAxes = function () {
  var matr = mat3_create();
  return function (out, view, right, up) {
    matr[0] = right[0];
    matr[3] = right[1];
    matr[6] = right[2];
    matr[1] = up[0];
    matr[4] = up[1];
    matr[7] = up[2];
    matr[2] = -view[0];
    matr[5] = -view[1];
    matr[8] = -view[2];
    return quat_normalize(out, fromMat3(out, matr));
  };
}();
// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/quat2.js



/**
 * Dual Quaternion<br>
 * Format: [real, dual]<br>
 * Quaternion format: XYZW<br>
 * Make sure to have normalized dual quaternions, otherwise the functions may not work as intended.<br>
 * @module quat2
 */

/**
 * Creates a new identity dual quat
 *
 * @returns {quat2} a new dual quaternion [real -> rotation, dual -> translation]
 */

function quat2_create() {
  var dq = new ARRAY_TYPE(8);

  if (ARRAY_TYPE != Float32Array) {
    dq[0] = 0;
    dq[1] = 0;
    dq[2] = 0;
    dq[4] = 0;
    dq[5] = 0;
    dq[6] = 0;
    dq[7] = 0;
  }

  dq[3] = 1;
  return dq;
}
/**
 * Creates a new quat initialized with values from an existing quaternion
 *
 * @param {ReadonlyQuat2} a dual quaternion to clone
 * @returns {quat2} new dual quaternion
 * @function
 */

function quat2_clone(a) {
  var dq = new ARRAY_TYPE(8);
  dq[0] = a[0];
  dq[1] = a[1];
  dq[2] = a[2];
  dq[3] = a[3];
  dq[4] = a[4];
  dq[5] = a[5];
  dq[6] = a[6];
  dq[7] = a[7];
  return dq;
}
/**
 * Creates a new dual quat initialized with the given values
 *
 * @param {Number} x1 X component
 * @param {Number} y1 Y component
 * @param {Number} z1 Z component
 * @param {Number} w1 W component
 * @param {Number} x2 X component
 * @param {Number} y2 Y component
 * @param {Number} z2 Z component
 * @param {Number} w2 W component
 * @returns {quat2} new dual quaternion
 * @function
 */

function quat2_fromValues(x1, y1, z1, w1, x2, y2, z2, w2) {
  var dq = new ARRAY_TYPE(8);
  dq[0] = x1;
  dq[1] = y1;
  dq[2] = z1;
  dq[3] = w1;
  dq[4] = x2;
  dq[5] = y2;
  dq[6] = z2;
  dq[7] = w2;
  return dq;
}
/**
 * Creates a new dual quat from the given values (quat and translation)
 *
 * @param {Number} x1 X component
 * @param {Number} y1 Y component
 * @param {Number} z1 Z component
 * @param {Number} w1 W component
 * @param {Number} x2 X component (translation)
 * @param {Number} y2 Y component (translation)
 * @param {Number} z2 Z component (translation)
 * @returns {quat2} new dual quaternion
 * @function
 */

function fromRotationTranslationValues(x1, y1, z1, w1, x2, y2, z2) {
  var dq = new ARRAY_TYPE(8);
  dq[0] = x1;
  dq[1] = y1;
  dq[2] = z1;
  dq[3] = w1;
  var ax = x2 * 0.5,
      ay = y2 * 0.5,
      az = z2 * 0.5;
  dq[4] = ax * w1 + ay * z1 - az * y1;
  dq[5] = ay * w1 + az * x1 - ax * z1;
  dq[6] = az * w1 + ax * y1 - ay * x1;
  dq[7] = -ax * x1 - ay * y1 - az * z1;
  return dq;
}
/**
 * Creates a dual quat from a quaternion and a translation
 *
 * @param {ReadonlyQuat2} dual quaternion receiving operation result
 * @param {ReadonlyQuat} q a normalized quaternion
 * @param {ReadonlyVec3} t tranlation vector
 * @returns {quat2} dual quaternion receiving operation result
 * @function
 */

function quat2_fromRotationTranslation(out, q, t) {
  var ax = t[0] * 0.5,
      ay = t[1] * 0.5,
      az = t[2] * 0.5,
      bx = q[0],
      by = q[1],
      bz = q[2],
      bw = q[3];
  out[0] = bx;
  out[1] = by;
  out[2] = bz;
  out[3] = bw;
  out[4] = ax * bw + ay * bz - az * by;
  out[5] = ay * bw + az * bx - ax * bz;
  out[6] = az * bw + ax * by - ay * bx;
  out[7] = -ax * bx - ay * by - az * bz;
  return out;
}
/**
 * Creates a dual quat from a translation
 *
 * @param {ReadonlyQuat2} dual quaternion receiving operation result
 * @param {ReadonlyVec3} t translation vector
 * @returns {quat2} dual quaternion receiving operation result
 * @function
 */

function quat2_fromTranslation(out, t) {
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = t[0] * 0.5;
  out[5] = t[1] * 0.5;
  out[6] = t[2] * 0.5;
  out[7] = 0;
  return out;
}
/**
 * Creates a dual quat from a quaternion
 *
 * @param {ReadonlyQuat2} dual quaternion receiving operation result
 * @param {ReadonlyQuat} q the quaternion
 * @returns {quat2} dual quaternion receiving operation result
 * @function
 */

function quat2_fromRotation(out, q) {
  out[0] = q[0];
  out[1] = q[1];
  out[2] = q[2];
  out[3] = q[3];
  out[4] = 0;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  return out;
}
/**
 * Creates a new dual quat from a matrix (4x4)
 *
 * @param {quat2} out the dual quaternion
 * @param {ReadonlyMat4} a the matrix
 * @returns {quat2} dual quat receiving operation result
 * @function
 */

function quat2_fromMat4(out, a) {
  //TODO Optimize this
  var outer = quat_create();
  getRotation(outer, a);
  var t = new ARRAY_TYPE(3);
  getTranslation(t, a);
  quat2_fromRotationTranslation(out, outer, t);
  return out;
}
/**
 * Copy the values from one dual quat to another
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the source dual quaternion
 * @returns {quat2} out
 * @function
 */

function quat2_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  return out;
}
/**
 * Set a dual quat to the identity dual quaternion
 *
 * @param {quat2} out the receiving quaternion
 * @returns {quat2} out
 */

function quat2_identity(out) {
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = 0;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  return out;
}
/**
 * Set the components of a dual quat to the given values
 *
 * @param {quat2} out the receiving quaternion
 * @param {Number} x1 X component
 * @param {Number} y1 Y component
 * @param {Number} z1 Z component
 * @param {Number} w1 W component
 * @param {Number} x2 X component
 * @param {Number} y2 Y component
 * @param {Number} z2 Z component
 * @param {Number} w2 W component
 * @returns {quat2} out
 * @function
 */

function quat2_set(out, x1, y1, z1, w1, x2, y2, z2, w2) {
  out[0] = x1;
  out[1] = y1;
  out[2] = z1;
  out[3] = w1;
  out[4] = x2;
  out[5] = y2;
  out[6] = z2;
  out[7] = w2;
  return out;
}
/**
 * Gets the real part of a dual quat
 * @param  {quat} out real part
 * @param  {ReadonlyQuat2} a Dual Quaternion
 * @return {quat} real part
 */

var getReal = quat_copy;
/**
 * Gets the dual part of a dual quat
 * @param  {quat} out dual part
 * @param  {ReadonlyQuat2} a Dual Quaternion
 * @return {quat} dual part
 */

function getDual(out, a) {
  out[0] = a[4];
  out[1] = a[5];
  out[2] = a[6];
  out[3] = a[7];
  return out;
}
/**
 * Set the real component of a dual quat to the given quaternion
 *
 * @param {quat2} out the receiving quaternion
 * @param {ReadonlyQuat} q a quaternion representing the real part
 * @returns {quat2} out
 * @function
 */

var setReal = quat_copy;
/**
 * Set the dual component of a dual quat to the given quaternion
 *
 * @param {quat2} out the receiving quaternion
 * @param {ReadonlyQuat} q a quaternion representing the dual part
 * @returns {quat2} out
 * @function
 */

function setDual(out, q) {
  out[4] = q[0];
  out[5] = q[1];
  out[6] = q[2];
  out[7] = q[3];
  return out;
}
/**
 * Gets the translation of a normalized dual quat
 * @param  {vec3} out translation
 * @param  {ReadonlyQuat2} a Dual Quaternion to be decomposed
 * @return {vec3} translation
 */

function quat2_getTranslation(out, a) {
  var ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7],
      bx = -a[0],
      by = -a[1],
      bz = -a[2],
      bw = a[3];
  out[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
  out[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
  out[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
  return out;
}
/**
 * Translates a dual quat by the given vector
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the dual quaternion to translate
 * @param {ReadonlyVec3} v vector to translate by
 * @returns {quat2} out
 */

function quat2_translate(out, a, v) {
  var ax1 = a[0],
      ay1 = a[1],
      az1 = a[2],
      aw1 = a[3],
      bx1 = v[0] * 0.5,
      by1 = v[1] * 0.5,
      bz1 = v[2] * 0.5,
      ax2 = a[4],
      ay2 = a[5],
      az2 = a[6],
      aw2 = a[7];
  out[0] = ax1;
  out[1] = ay1;
  out[2] = az1;
  out[3] = aw1;
  out[4] = aw1 * bx1 + ay1 * bz1 - az1 * by1 + ax2;
  out[5] = aw1 * by1 + az1 * bx1 - ax1 * bz1 + ay2;
  out[6] = aw1 * bz1 + ax1 * by1 - ay1 * bx1 + az2;
  out[7] = -ax1 * bx1 - ay1 * by1 - az1 * bz1 + aw2;
  return out;
}
/**
 * Rotates a dual quat around the X axis
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the dual quaternion to rotate
 * @param {number} rad how far should the rotation be
 * @returns {quat2} out
 */

function quat2_rotateX(out, a, rad) {
  var bx = -a[0],
      by = -a[1],
      bz = -a[2],
      bw = a[3],
      ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7],
      ax1 = ax * bw + aw * bx + ay * bz - az * by,
      ay1 = ay * bw + aw * by + az * bx - ax * bz,
      az1 = az * bw + aw * bz + ax * by - ay * bx,
      aw1 = aw * bw - ax * bx - ay * by - az * bz;
  quat_rotateX(out, a, rad);
  bx = out[0];
  by = out[1];
  bz = out[2];
  bw = out[3];
  out[4] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
  out[5] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
  out[6] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
  out[7] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
  return out;
}
/**
 * Rotates a dual quat around the Y axis
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the dual quaternion to rotate
 * @param {number} rad how far should the rotation be
 * @returns {quat2} out
 */

function quat2_rotateY(out, a, rad) {
  var bx = -a[0],
      by = -a[1],
      bz = -a[2],
      bw = a[3],
      ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7],
      ax1 = ax * bw + aw * bx + ay * bz - az * by,
      ay1 = ay * bw + aw * by + az * bx - ax * bz,
      az1 = az * bw + aw * bz + ax * by - ay * bx,
      aw1 = aw * bw - ax * bx - ay * by - az * bz;
  quat_rotateY(out, a, rad);
  bx = out[0];
  by = out[1];
  bz = out[2];
  bw = out[3];
  out[4] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
  out[5] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
  out[6] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
  out[7] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
  return out;
}
/**
 * Rotates a dual quat around the Z axis
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the dual quaternion to rotate
 * @param {number} rad how far should the rotation be
 * @returns {quat2} out
 */

function quat2_rotateZ(out, a, rad) {
  var bx = -a[0],
      by = -a[1],
      bz = -a[2],
      bw = a[3],
      ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7],
      ax1 = ax * bw + aw * bx + ay * bz - az * by,
      ay1 = ay * bw + aw * by + az * bx - ax * bz,
      az1 = az * bw + aw * bz + ax * by - ay * bx,
      aw1 = aw * bw - ax * bx - ay * by - az * bz;
  quat_rotateZ(out, a, rad);
  bx = out[0];
  by = out[1];
  bz = out[2];
  bw = out[3];
  out[4] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
  out[5] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
  out[6] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
  out[7] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
  return out;
}
/**
 * Rotates a dual quat by a given quaternion (a * q)
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the dual quaternion to rotate
 * @param {ReadonlyQuat} q quaternion to rotate by
 * @returns {quat2} out
 */

function rotateByQuatAppend(out, a, q) {
  var qx = q[0],
      qy = q[1],
      qz = q[2],
      qw = q[3],
      ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3];
  out[0] = ax * qw + aw * qx + ay * qz - az * qy;
  out[1] = ay * qw + aw * qy + az * qx - ax * qz;
  out[2] = az * qw + aw * qz + ax * qy - ay * qx;
  out[3] = aw * qw - ax * qx - ay * qy - az * qz;
  ax = a[4];
  ay = a[5];
  az = a[6];
  aw = a[7];
  out[4] = ax * qw + aw * qx + ay * qz - az * qy;
  out[5] = ay * qw + aw * qy + az * qx - ax * qz;
  out[6] = az * qw + aw * qz + ax * qy - ay * qx;
  out[7] = aw * qw - ax * qx - ay * qy - az * qz;
  return out;
}
/**
 * Rotates a dual quat by a given quaternion (q * a)
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat} q quaternion to rotate by
 * @param {ReadonlyQuat2} a the dual quaternion to rotate
 * @returns {quat2} out
 */

function rotateByQuatPrepend(out, q, a) {
  var qx = q[0],
      qy = q[1],
      qz = q[2],
      qw = q[3],
      bx = a[0],
      by = a[1],
      bz = a[2],
      bw = a[3];
  out[0] = qx * bw + qw * bx + qy * bz - qz * by;
  out[1] = qy * bw + qw * by + qz * bx - qx * bz;
  out[2] = qz * bw + qw * bz + qx * by - qy * bx;
  out[3] = qw * bw - qx * bx - qy * by - qz * bz;
  bx = a[4];
  by = a[5];
  bz = a[6];
  bw = a[7];
  out[4] = qx * bw + qw * bx + qy * bz - qz * by;
  out[5] = qy * bw + qw * by + qz * bx - qx * bz;
  out[6] = qz * bw + qw * bz + qx * by - qy * bx;
  out[7] = qw * bw - qx * bx - qy * by - qz * bz;
  return out;
}
/**
 * Rotates a dual quat around a given axis. Does the normalisation automatically
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the dual quaternion to rotate
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @param {Number} rad how far the rotation should be
 * @returns {quat2} out
 */

function rotateAroundAxis(out, a, axis, rad) {
  //Special case for rad = 0
  if (Math.abs(rad) < EPSILON) {
    return quat2_copy(out, a);
  }

  var axisLength = Math.hypot(axis[0], axis[1], axis[2]);
  rad = rad * 0.5;
  var s = Math.sin(rad);
  var bx = s * axis[0] / axisLength;
  var by = s * axis[1] / axisLength;
  var bz = s * axis[2] / axisLength;
  var bw = Math.cos(rad);
  var ax1 = a[0],
      ay1 = a[1],
      az1 = a[2],
      aw1 = a[3];
  out[0] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
  out[1] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
  out[2] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
  out[3] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
  var ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7];
  out[4] = ax * bw + aw * bx + ay * bz - az * by;
  out[5] = ay * bw + aw * by + az * bx - ax * bz;
  out[6] = az * bw + aw * bz + ax * by - ay * bx;
  out[7] = aw * bw - ax * bx - ay * by - az * bz;
  return out;
}
/**
 * Adds two dual quat's
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the first operand
 * @param {ReadonlyQuat2} b the second operand
 * @returns {quat2} out
 * @function
 */

function quat2_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  return out;
}
/**
 * Multiplies two dual quat's
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a the first operand
 * @param {ReadonlyQuat2} b the second operand
 * @returns {quat2} out
 */

function quat2_multiply(out, a, b) {
  var ax0 = a[0],
      ay0 = a[1],
      az0 = a[2],
      aw0 = a[3],
      bx1 = b[4],
      by1 = b[5],
      bz1 = b[6],
      bw1 = b[7],
      ax1 = a[4],
      ay1 = a[5],
      az1 = a[6],
      aw1 = a[7],
      bx0 = b[0],
      by0 = b[1],
      bz0 = b[2],
      bw0 = b[3];
  out[0] = ax0 * bw0 + aw0 * bx0 + ay0 * bz0 - az0 * by0;
  out[1] = ay0 * bw0 + aw0 * by0 + az0 * bx0 - ax0 * bz0;
  out[2] = az0 * bw0 + aw0 * bz0 + ax0 * by0 - ay0 * bx0;
  out[3] = aw0 * bw0 - ax0 * bx0 - ay0 * by0 - az0 * bz0;
  out[4] = ax0 * bw1 + aw0 * bx1 + ay0 * bz1 - az0 * by1 + ax1 * bw0 + aw1 * bx0 + ay1 * bz0 - az1 * by0;
  out[5] = ay0 * bw1 + aw0 * by1 + az0 * bx1 - ax0 * bz1 + ay1 * bw0 + aw1 * by0 + az1 * bx0 - ax1 * bz0;
  out[6] = az0 * bw1 + aw0 * bz1 + ax0 * by1 - ay0 * bx1 + az1 * bw0 + aw1 * bz0 + ax1 * by0 - ay1 * bx0;
  out[7] = aw0 * bw1 - ax0 * bx1 - ay0 * by1 - az0 * bz1 + aw1 * bw0 - ax1 * bx0 - ay1 * by0 - az1 * bz0;
  return out;
}
/**
 * Alias for {@link quat2.multiply}
 * @function
 */

var quat2_mul = quat2_multiply;
/**
 * Scales a dual quat by a scalar number
 *
 * @param {quat2} out the receiving dual quat
 * @param {ReadonlyQuat2} a the dual quat to scale
 * @param {Number} b amount to scale the dual quat by
 * @returns {quat2} out
 * @function
 */

function quat2_scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  return out;
}
/**
 * Calculates the dot product of two dual quat's (The dot product of the real parts)
 *
 * @param {ReadonlyQuat2} a the first operand
 * @param {ReadonlyQuat2} b the second operand
 * @returns {Number} dot product of a and b
 * @function
 */

var quat2_dot = quat_dot;
/**
 * Performs a linear interpolation between two dual quats's
 * NOTE: The resulting dual quaternions won't always be normalized (The error is most noticeable when t = 0.5)
 *
 * @param {quat2} out the receiving dual quat
 * @param {ReadonlyQuat2} a the first operand
 * @param {ReadonlyQuat2} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {quat2} out
 */

function quat2_lerp(out, a, b, t) {
  var mt = 1 - t;
  if (quat2_dot(a, b) < 0) t = -t;
  out[0] = a[0] * mt + b[0] * t;
  out[1] = a[1] * mt + b[1] * t;
  out[2] = a[2] * mt + b[2] * t;
  out[3] = a[3] * mt + b[3] * t;
  out[4] = a[4] * mt + b[4] * t;
  out[5] = a[5] * mt + b[5] * t;
  out[6] = a[6] * mt + b[6] * t;
  out[7] = a[7] * mt + b[7] * t;
  return out;
}
/**
 * Calculates the inverse of a dual quat. If they are normalized, conjugate is cheaper
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a dual quat to calculate inverse of
 * @returns {quat2} out
 */

function quat2_invert(out, a) {
  var sqlen = quat2_squaredLength(a);
  out[0] = -a[0] / sqlen;
  out[1] = -a[1] / sqlen;
  out[2] = -a[2] / sqlen;
  out[3] = a[3] / sqlen;
  out[4] = -a[4] / sqlen;
  out[5] = -a[5] / sqlen;
  out[6] = -a[6] / sqlen;
  out[7] = a[7] / sqlen;
  return out;
}
/**
 * Calculates the conjugate of a dual quat
 * If the dual quaternion is normalized, this function is faster than quat2.inverse and produces the same result.
 *
 * @param {quat2} out the receiving quaternion
 * @param {ReadonlyQuat2} a quat to calculate conjugate of
 * @returns {quat2} out
 */

function quat2_conjugate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] = a[3];
  out[4] = -a[4];
  out[5] = -a[5];
  out[6] = -a[6];
  out[7] = a[7];
  return out;
}
/**
 * Calculates the length of a dual quat
 *
 * @param {ReadonlyQuat2} a dual quat to calculate length of
 * @returns {Number} length of a
 * @function
 */

var quat2_length = quat_length;
/**
 * Alias for {@link quat2.length}
 * @function
 */

var quat2_len = quat2_length;
/**
 * Calculates the squared length of a dual quat
 *
 * @param {ReadonlyQuat2} a dual quat to calculate squared length of
 * @returns {Number} squared length of a
 * @function
 */

var quat2_squaredLength = quat_squaredLength;
/**
 * Alias for {@link quat2.squaredLength}
 * @function
 */

var quat2_sqrLen = quat2_squaredLength;
/**
 * Normalize a dual quat
 *
 * @param {quat2} out the receiving dual quaternion
 * @param {ReadonlyQuat2} a dual quaternion to normalize
 * @returns {quat2} out
 * @function
 */

function quat2_normalize(out, a) {
  var magnitude = quat2_squaredLength(a);

  if (magnitude > 0) {
    magnitude = Math.sqrt(magnitude);
    var a0 = a[0] / magnitude;
    var a1 = a[1] / magnitude;
    var a2 = a[2] / magnitude;
    var a3 = a[3] / magnitude;
    var b0 = a[4];
    var b1 = a[5];
    var b2 = a[6];
    var b3 = a[7];
    var a_dot_b = a0 * b0 + a1 * b1 + a2 * b2 + a3 * b3;
    out[0] = a0;
    out[1] = a1;
    out[2] = a2;
    out[3] = a3;
    out[4] = (b0 - a0 * a_dot_b) / magnitude;
    out[5] = (b1 - a1 * a_dot_b) / magnitude;
    out[6] = (b2 - a2 * a_dot_b) / magnitude;
    out[7] = (b3 - a3 * a_dot_b) / magnitude;
  }

  return out;
}
/**
 * Returns a string representation of a dual quatenion
 *
 * @param {ReadonlyQuat2} a dual quaternion to represent as a string
 * @returns {String} string representation of the dual quat
 */

function quat2_str(a) {
  return "quat2(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ")";
}
/**
 * Returns whether or not the dual quaternions have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyQuat2} a the first dual quaternion.
 * @param {ReadonlyQuat2} b the second dual quaternion.
 * @returns {Boolean} true if the dual quaternions are equal, false otherwise.
 */

function quat2_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7];
}
/**
 * Returns whether or not the dual quaternions have approximately the same elements in the same position.
 *
 * @param {ReadonlyQuat2} a the first dual quat.
 * @param {ReadonlyQuat2} b the second dual quat.
 * @returns {Boolean} true if the dual quats are equal, false otherwise.
 */

function quat2_equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5],
      a6 = a[6],
      a7 = a[7];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3],
      b4 = b[4],
      b5 = b[5],
      b6 = b[6],
      b7 = b[7];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7));
}
// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/vec2.js

/**
 * 2 Dimensional Vector
 * @module vec2
 */

/**
 * Creates a new, empty vec2
 *
 * @returns {vec2} a new 2D vector
 */

function vec2_create() {
  var out = new ARRAY_TYPE(2);

  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
  }

  return out;
}
/**
 * Creates a new vec2 initialized with values from an existing vector
 *
 * @param {ReadonlyVec2} a vector to clone
 * @returns {vec2} a new 2D vector
 */

function vec2_clone(a) {
  var out = new ARRAY_TYPE(2);
  out[0] = a[0];
  out[1] = a[1];
  return out;
}
/**
 * Creates a new vec2 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} a new 2D vector
 */

function vec2_fromValues(x, y) {
  var out = new ARRAY_TYPE(2);
  out[0] = x;
  out[1] = y;
  return out;
}
/**
 * Copy the values from one vec2 to another
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the source vector
 * @returns {vec2} out
 */

function vec2_copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  return out;
}
/**
 * Set the components of a vec2 to the given values
 *
 * @param {vec2} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} out
 */

function vec2_set(out, x, y) {
  out[0] = x;
  out[1] = y;
  return out;
}
/**
 * Adds two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function vec2_add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function vec2_subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  return out;
}
/**
 * Multiplies two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function vec2_multiply(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  return out;
}
/**
 * Divides two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function vec2_divide(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  return out;
}
/**
 * Math.ceil the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to ceil
 * @returns {vec2} out
 */

function vec2_ceil(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  return out;
}
/**
 * Math.floor the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to floor
 * @returns {vec2} out
 */

function vec2_floor(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  return out;
}
/**
 * Returns the minimum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function vec2_min(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  return out;
}
/**
 * Returns the maximum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function vec2_max(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  return out;
}
/**
 * Math.round the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to round
 * @returns {vec2} out
 */

function vec2_round(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  return out;
}
/**
 * Scales a vec2 by a scalar number
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec2} out
 */

function vec2_scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  return out;
}
/**
 * Adds two vec2's after scaling the second operand by a scalar value
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec2} out
 */

function vec2_scaleAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} distance between a and b
 */

function vec2_distance(a, b) {
  var x = b[0] - a[0],
      y = b[1] - a[1];
  return Math.hypot(x, y);
}
/**
 * Calculates the squared euclidian distance between two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} squared distance between a and b
 */

function vec2_squaredDistance(a, b) {
  var x = b[0] - a[0],
      y = b[1] - a[1];
  return x * x + y * y;
}
/**
 * Calculates the length of a vec2
 *
 * @param {ReadonlyVec2} a vector to calculate length of
 * @returns {Number} length of a
 */

function vec2_length(a) {
  var x = a[0],
      y = a[1];
  return Math.hypot(x, y);
}
/**
 * Calculates the squared length of a vec2
 *
 * @param {ReadonlyVec2} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function vec2_squaredLength(a) {
  var x = a[0],
      y = a[1];
  return x * x + y * y;
}
/**
 * Negates the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to negate
 * @returns {vec2} out
 */

function vec2_negate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  return out;
}
/**
 * Returns the inverse of the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to invert
 * @returns {vec2} out
 */

function vec2_inverse(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  return out;
}
/**
 * Normalize a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to normalize
 * @returns {vec2} out
 */

function vec2_normalize(out, a) {
  var x = a[0],
      y = a[1];
  var len = x * x + y * y;

  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
  }

  out[0] = a[0] * len;
  out[1] = a[1] * len;
  return out;
}
/**
 * Calculates the dot product of two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} dot product of a and b
 */

function vec2_dot(a, b) {
  return a[0] * b[0] + a[1] * b[1];
}
/**
 * Computes the cross product of two vec2's
 * Note that the cross product must by definition produce a 3D vector
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec3} out
 */

function vec2_cross(out, a, b) {
  var z = a[0] * b[1] - a[1] * b[0];
  out[0] = out[1] = 0;
  out[2] = z;
  return out;
}
/**
 * Performs a linear interpolation between two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec2} out
 */

function vec2_lerp(out, a, b, t) {
  var ax = a[0],
      ay = a[1];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec2} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec2} out
 */

function vec2_random(out, scale) {
  scale = scale || 1.0;
  var r = RANDOM() * 2.0 * Math.PI;
  out[0] = Math.cos(r) * scale;
  out[1] = Math.sin(r) * scale;
  return out;
}
/**
 * Transforms the vec2 with a mat2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat2} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat2(out, a, m) {
  var x = a[0],
      y = a[1];
  out[0] = m[0] * x + m[2] * y;
  out[1] = m[1] * x + m[3] * y;
  return out;
}
/**
 * Transforms the vec2 with a mat2d
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat2d} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat2d(out, a, m) {
  var x = a[0],
      y = a[1];
  out[0] = m[0] * x + m[2] * y + m[4];
  out[1] = m[1] * x + m[3] * y + m[5];
  return out;
}
/**
 * Transforms the vec2 with a mat3
 * 3rd vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat3} m matrix to transform with
 * @returns {vec2} out
 */

function vec2_transformMat3(out, a, m) {
  var x = a[0],
      y = a[1];
  out[0] = m[0] * x + m[3] * y + m[6];
  out[1] = m[1] * x + m[4] * y + m[7];
  return out;
}
/**
 * Transforms the vec2 with a mat4
 * 3rd vector component is implicitly '0'
 * 4th vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec2} out
 */

function vec2_transformMat4(out, a, m) {
  var x = a[0];
  var y = a[1];
  out[0] = m[0] * x + m[4] * y + m[12];
  out[1] = m[1] * x + m[5] * y + m[13];
  return out;
}
/**
 * Rotate a 2D vector
 * @param {vec2} out The receiving vec2
 * @param {ReadonlyVec2} a The vec2 point to rotate
 * @param {ReadonlyVec2} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec2} out
 */

function vec2_rotate(out, a, b, rad) {
  //Translate point to the origin
  var p0 = a[0] - b[0],
      p1 = a[1] - b[1],
      sinC = Math.sin(rad),
      cosC = Math.cos(rad); //perform rotation and translate to correct position

  out[0] = p0 * cosC - p1 * sinC + b[0];
  out[1] = p0 * sinC + p1 * cosC + b[1];
  return out;
}
/**
 * Get the angle between two 2D vectors
 * @param {ReadonlyVec2} a The first operand
 * @param {ReadonlyVec2} b The second operand
 * @returns {Number} The angle in radians
 */

function vec2_angle(a, b) {
  var x1 = a[0],
      y1 = a[1],
      x2 = b[0],
      y2 = b[1],
      // mag is the product of the magnitudes of a and b
  mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2),
      // mag &&.. short circuits if mag == 0
  cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1

  return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
/**
 * Set the components of a vec2 to zero
 *
 * @param {vec2} out the receiving vector
 * @returns {vec2} out
 */

function vec2_zero(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec2} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function vec2_str(a) {
  return "vec2(" + a[0] + ", " + a[1] + ")";
}
/**
 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec2} a The first vector.
 * @param {ReadonlyVec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function vec2_exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec2} a The first vector.
 * @param {ReadonlyVec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function vec2_equals(a, b) {
  var a0 = a[0],
      a1 = a[1];
  var b0 = b[0],
      b1 = b[1];
  return Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
/**
 * Alias for {@link vec2.length}
 * @function
 */

var vec2_len = vec2_length;
/**
 * Alias for {@link vec2.subtract}
 * @function
 */

var vec2_sub = vec2_subtract;
/**
 * Alias for {@link vec2.multiply}
 * @function
 */

var vec2_mul = vec2_multiply;
/**
 * Alias for {@link vec2.divide}
 * @function
 */

var vec2_div = vec2_divide;
/**
 * Alias for {@link vec2.distance}
 * @function
 */

var vec2_dist = vec2_distance;
/**
 * Alias for {@link vec2.squaredDistance}
 * @function
 */

var vec2_sqrDist = vec2_squaredDistance;
/**
 * Alias for {@link vec2.squaredLength}
 * @function
 */

var vec2_sqrLen = vec2_squaredLength;
/**
 * Perform some operation over an array of vec2s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec2. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec2s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var vec2_forEach = function () {
  var vec = vec2_create();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 2;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
    }

    return a;
  };
}();
// CONCATENATED MODULE: ./node_modules/gl-matrix/esm/index.js












/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "init", function() { return /* reexport */ init; });

// CONCATENATED MODULE: ./node_modules/tinyh264/es/TinyH264Decoder.js
//
//  Copyright (c) 2013 Sam Leitch. All rights reserved.
//
//  Permission is hereby granted, free of charge, to any person obtaining a copy
//  of this software and associated documentation files (the "Software"), to
//  deal in the Software without restriction, including without limitation the
//  rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
//  sell copies of the Software, and to permit persons to whom the Software is
//  furnished to do so, subject to the following conditions:
//
//  The above copyright notice and this permission notice shall be included in
//  all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
//  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
//  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
//  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
//  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
//  FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
//  IN THE SOFTWARE.
//

/**
 * This class wraps the details of the h264bsd library.
 * Module object is an Emscripten module provided globally by TinyH264.js
 *
 * In order to use this class, you first queue encoded data using queueData.
 * Each call to decode() will decode a single encoded element.
 * When decode() returns H264bsdDecoder.PIC_RDY, a picture is ready in the output buffer.
 * You can also use the onPictureReady() function to determine when a picture is ready.
 * The output buffer can be accessed by calling getNextOutputPicture()
 * An output picture may also be decoded using an H264bsdCanvas.
 * When you're done decoding, make sure to call release() to clean up internal buffers.
 */
var TinyH264Decoder = /*#__PURE__*/function () {
  function TinyH264Decoder(tinyH264Module, onPictureReady) {
    this.tinyH264Module = tinyH264Module;
    this.onPictureReady = onPictureReady;
    this.pStorage = this.tinyH264Module._h264bsdAlloc();
    this.pWidth = this.tinyH264Module._malloc(4);
    this.pHeight = this.tinyH264Module._malloc(4);
    this.pPicture = this.tinyH264Module._malloc(4);
    this._decBuffer = this.tinyH264Module._malloc(1024 * 1024);

    this.tinyH264Module._h264bsdInit(this.pStorage, 0);
  }

  var _proto = TinyH264Decoder.prototype;

  _proto.release = function release() {
    var pStorage = this.pStorage;

    if (pStorage !== 0) {
      this.tinyH264Module._h264bsdShutdown(pStorage);

      this.tinyH264Module._h264bsdFree(pStorage);
    }

    this.tinyH264Module._free(this.pWidth);

    this.tinyH264Module._free(this.pHeight);

    this.tinyH264Module._free(this.pPicture);

    this.pStorage = 0;
    this.pWidth = 0;
    this.pHeight = 0;
  };

  _proto.decode = function decode(nal) {
    if (nal instanceof ArrayBuffer) {
      nal = new Uint8Array(nal);
    }

    this.tinyH264Module.HEAPU8.set(nal, this._decBuffer);

    var retCode = this.tinyH264Module._h264bsdDecode(this.pStorage, this._decBuffer, nal.byteLength, this.pPicture, this.pWidth, this.pHeight);

    if (retCode === TinyH264Decoder.PIC_RDY) {
      var width = this.tinyH264Module.getValue(this.pWidth, 'i32');
      var height = this.tinyH264Module.getValue(this.pHeight, 'i32');
      var picPtr = this.tinyH264Module.getValue(this.pPicture, 'i8*');
      var pic = new Uint8Array(this.tinyH264Module.HEAPU8.subarray(picPtr, picPtr + width * height * 3 / 2));
      this.onPictureReady(pic, width, height);
    }
  };

  return TinyH264Decoder;
}();

TinyH264Decoder.RDY = 0;
TinyH264Decoder.PIC_RDY = 1;
TinyH264Decoder.HDRS_RDY = 2;
TinyH264Decoder.ERROR = 3;
TinyH264Decoder.PARAM_SET_ERROR = 4;
TinyH264Decoder.MEMALLOC_ERROR = 5;
/* harmony default export */ var es_TinyH264Decoder = (TinyH264Decoder);
// CONCATENATED MODULE: ./node_modules/tinyh264/es/TinyH264.js
var Module = function () {
  var _scriptDir = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : undefined;

  return function (Module) {
    Module = Module || {};
    var Module = typeof Module !== "undefined" ? Module : {};
    var readyPromiseResolve, readyPromiseReject;
    Module["ready"] = new Promise(function (resolve, reject) {
      readyPromiseResolve = resolve;
      readyPromiseReject = reject;
    });
    var moduleOverrides = {};
    var key;

    for (key in Module) {
      if (Module.hasOwnProperty(key)) {
        moduleOverrides[key] = Module[key];
      }
    }

    var arguments_ = [];
    var thisProgram = "./this.program";

    var quit_ = function quit_(status, toThrow) {
      throw toThrow;
    };

    var ENVIRONMENT_IS_WEB = false;
    var ENVIRONMENT_IS_WORKER = true;
    var scriptDirectory = "";

    function locateFile(path) {
      if (Module["locateFile"]) {
        return Module["locateFile"](path, scriptDirectory);
      }

      return scriptDirectory + path;
    }

    var read_, readAsync, readBinary, setWindowTitle;

    if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
      if (ENVIRONMENT_IS_WORKER) {
        scriptDirectory = self.location.href;
      } else if (typeof document !== "undefined" && document.currentScript) {
        scriptDirectory = document.currentScript.src;
      }

      if (_scriptDir) {
        scriptDirectory = _scriptDir;
      }

      if (scriptDirectory.indexOf("blob:") !== 0) {
        scriptDirectory = scriptDirectory.substr(0, scriptDirectory.lastIndexOf("/") + 1);
      } else {
        scriptDirectory = "";
      }

      {
        read_ = function read_(url) {
          try {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, false);
            xhr.send(null);
            return xhr.responseText;
          } catch (err) {
            var data = tryParseAsDataURI(url);

            if (data) {
              return intArrayToString(data);
            }

            throw err;
          }
        };

        if (ENVIRONMENT_IS_WORKER) {
          readBinary = function readBinary(url) {
            try {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, false);
              xhr.responseType = "arraybuffer";
              xhr.send(null);
              return new Uint8Array(xhr.response);
            } catch (err) {
              var data = tryParseAsDataURI(url);

              if (data) {
                return data;
              }

              throw err;
            }
          };
        }

        readAsync = function readAsync(url, onload, onerror) {
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url, true);
          xhr.responseType = "arraybuffer";

          xhr.onload = function () {
            if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
              onload(xhr.response);
              return;
            }

            var data = tryParseAsDataURI(url);

            if (data) {
              onload(data.buffer);
              return;
            }

            onerror();
          };

          xhr.onerror = onerror;
          xhr.send(null);
        };
      }

      setWindowTitle = function setWindowTitle(title) {
        document.title = title;
      };
    } else {}

    var out = Module["print"] || console.log.bind(console);
    var err = Module["printErr"] || console.warn.bind(console);

    for (key in moduleOverrides) {
      if (moduleOverrides.hasOwnProperty(key)) {
        Module[key] = moduleOverrides[key];
      }
    }

    moduleOverrides = null;
    if (Module["arguments"]) arguments_ = Module["arguments"];
    if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
    if (Module["quit"]) quit_ = Module["quit"];
    var wasmBinary;
    if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
    var noExitRuntime = Module["noExitRuntime"] || true;

    if (typeof WebAssembly !== "object") {
      abort("no native wasm support detected");
    }

    function getValue(ptr, type, noSafe) {
      type = type || "i8";
      if (type.charAt(type.length - 1) === "*") type = "i32";

      switch (type) {
        case "i1":
          return HEAP8[ptr >> 0];

        case "i8":
          return HEAP8[ptr >> 0];

        case "i16":
          return HEAP16[ptr >> 1];

        case "i32":
          return HEAP32[ptr >> 2];

        case "i64":
          return HEAP32[ptr >> 2];

        case "float":
          return HEAPF32[ptr >> 2];

        case "double":
          return HEAPF64[ptr >> 3];

        default:
          abort("invalid type for getValue: " + type);
      }

      return null;
    }

    var wasmMemory;
    var ABORT = false;
    var EXITSTATUS;

    function assert(condition, text) {
      if (!condition) {
        abort("Assertion failed: " + text);
      }
    }

    function alignUp(x, multiple) {
      if (x % multiple > 0) {
        x += multiple - x % multiple;
      }

      return x;
    }

    var buffer, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;

    function updateGlobalBufferAndViews(buf) {
      buffer = buf;
      Module["HEAP8"] = HEAP8 = new Int8Array(buf);
      Module["HEAP16"] = HEAP16 = new Int16Array(buf);
      Module["HEAP32"] = HEAP32 = new Int32Array(buf);
      Module["HEAPU8"] = HEAPU8 = new Uint8Array(buf);
      Module["HEAPU16"] = HEAPU16 = new Uint16Array(buf);
      Module["HEAPU32"] = HEAPU32 = new Uint32Array(buf);
      Module["HEAPF32"] = HEAPF32 = new Float32Array(buf);
      Module["HEAPF64"] = HEAPF64 = new Float64Array(buf);
    }

    var INITIAL_MEMORY = Module["INITIAL_MEMORY"] || 16777216;
    var wasmTable;
    var __ATPRERUN__ = [];
    var __ATINIT__ = [];
    var __ATPOSTRUN__ = [];
    var runtimeInitialized = false;

    function preRun() {
      if (Module["preRun"]) {
        if (typeof Module["preRun"] == "function") Module["preRun"] = [Module["preRun"]];

        while (Module["preRun"].length) {
          addOnPreRun(Module["preRun"].shift());
        }
      }

      callRuntimeCallbacks(__ATPRERUN__);
    }

    function initRuntime() {
      runtimeInitialized = true;
      callRuntimeCallbacks(__ATINIT__);
    }

    function postRun() {
      if (Module["postRun"]) {
        if (typeof Module["postRun"] == "function") Module["postRun"] = [Module["postRun"]];

        while (Module["postRun"].length) {
          addOnPostRun(Module["postRun"].shift());
        }
      }

      callRuntimeCallbacks(__ATPOSTRUN__);
    }

    function addOnPreRun(cb) {
      __ATPRERUN__.unshift(cb);
    }

    function addOnInit(cb) {
      __ATINIT__.unshift(cb);
    }

    function addOnPostRun(cb) {
      __ATPOSTRUN__.unshift(cb);
    }

    var runDependencies = 0;
    var runDependencyWatcher = null;
    var dependenciesFulfilled = null;

    function addRunDependency(id) {
      runDependencies++;

      if (Module["monitorRunDependencies"]) {
        Module["monitorRunDependencies"](runDependencies);
      }
    }

    function removeRunDependency(id) {
      runDependencies--;

      if (Module["monitorRunDependencies"]) {
        Module["monitorRunDependencies"](runDependencies);
      }

      if (runDependencies == 0) {
        if (runDependencyWatcher !== null) {
          clearInterval(runDependencyWatcher);
          runDependencyWatcher = null;
        }

        if (dependenciesFulfilled) {
          var callback = dependenciesFulfilled;
          dependenciesFulfilled = null;
          callback();
        }
      }
    }

    Module["preloadedImages"] = {};
    Module["preloadedAudios"] = {};

    function abort(what) {
      {
        if (Module["onAbort"]) {
          Module["onAbort"](what);
        }
      }
      what += "";
      err(what);
      ABORT = true;
      EXITSTATUS = 1;
      what = "abort(" + what + "). Build with -s ASSERTIONS=1 for more info.";
      var e = new WebAssembly.RuntimeError(what);
      readyPromiseReject(e);
      throw e;
    }

    var dataURIPrefix = "data:application/octet-stream;base64,";

    function isDataURI(filename) {
      return filename.startsWith(dataURIPrefix);
    }

    var wasmBinaryFile;
    wasmBinaryFile = "data:application/octet-stream;base64,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";

    if (!isDataURI(wasmBinaryFile)) {
      wasmBinaryFile = locateFile(wasmBinaryFile);
    }

    function getBinary(file) {
      try {
        if (file == wasmBinaryFile && wasmBinary) {
          return new Uint8Array(wasmBinary);
        }

        var binary = tryParseAsDataURI(file);

        if (binary) {
          return binary;
        }

        if (readBinary) {
          return readBinary(file);
        } else {
          throw "both async and sync fetching of the wasm failed";
        }
      } catch (err) {
        abort(err);
      }
    }

    function getBinaryPromise() {
      if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
        if (typeof fetch === "function") {
          return fetch(wasmBinaryFile, {
            credentials: "same-origin"
          }).then(function (response) {
            if (!response["ok"]) {
              throw "failed to load wasm binary file at '" + wasmBinaryFile + "'";
            }

            return response["arrayBuffer"]();
          }).catch(function () {
            return getBinary(wasmBinaryFile);
          });
        }
      }

      return Promise.resolve().then(function () {
        return getBinary(wasmBinaryFile);
      });
    }

    function createWasm() {
      var info = {
        "a": asmLibraryArg
      };

      function receiveInstance(instance, module) {
        var exports = instance.exports;
        Module["asm"] = exports;
        wasmMemory = Module["asm"]["c"];
        updateGlobalBufferAndViews(wasmMemory.buffer);
        wasmTable = Module["asm"]["l"];
        addOnInit(Module["asm"]["d"]);
        removeRunDependency("wasm-instantiate");
      }

      addRunDependency("wasm-instantiate");

      function receiveInstantiationResult(result) {
        receiveInstance(result["instance"]);
      }

      function instantiateArrayBuffer(receiver) {
        return getBinaryPromise().then(function (binary) {
          return WebAssembly.instantiate(binary, info);
        }).then(function (instance) {
          return instance;
        }).then(receiver, function (reason) {
          err("failed to asynchronously prepare wasm: " + reason);
          abort(reason);
        });
      }

      function instantiateAsync() {
        if (!wasmBinary && typeof WebAssembly.instantiateStreaming === "function" && !isDataURI(wasmBinaryFile) && typeof fetch === "function") {
          return fetch(wasmBinaryFile, {
            credentials: "same-origin"
          }).then(function (response) {
            var result = WebAssembly.instantiateStreaming(response, info);
            return result.then(receiveInstantiationResult, function (reason) {
              err("wasm streaming compile failed: " + reason);
              err("falling back to ArrayBuffer instantiation");
              return instantiateArrayBuffer(receiveInstantiationResult);
            });
          });
        } else {
          return instantiateArrayBuffer(receiveInstantiationResult);
        }
      }

      if (Module["instantiateWasm"]) {
        try {
          var exports = Module["instantiateWasm"](info, receiveInstance);
          return exports;
        } catch (e) {
          err("Module.instantiateWasm callback failed with error: " + e);
          return false;
        }
      }

      instantiateAsync().catch(readyPromiseReject);
      return {};
    }

    function callRuntimeCallbacks(callbacks) {
      while (callbacks.length > 0) {
        var callback = callbacks.shift();

        if (typeof callback == "function") {
          callback(Module);
          continue;
        }

        var func = callback.func;

        if (typeof func === "number") {
          if (callback.arg === undefined) {
            wasmTable.get(func)();
          } else {
            wasmTable.get(func)(callback.arg);
          }
        } else {
          func(callback.arg === undefined ? null : callback.arg);
        }
      }
    }

    function _emscripten_memcpy_big(dest, src, num) {
      HEAPU8.copyWithin(dest, src, src + num);
    }

    function emscripten_realloc_buffer(size) {
      try {
        wasmMemory.grow(size - buffer.byteLength + 65535 >>> 16);
        updateGlobalBufferAndViews(wasmMemory.buffer);
        return 1;
      } catch (e) {}
    }

    function _emscripten_resize_heap(requestedSize) {
      var oldSize = HEAPU8.length;
      requestedSize = requestedSize >>> 0;
      var maxHeapSize = 2147483648;

      if (requestedSize > maxHeapSize) {
        return false;
      }

      for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
        var overGrownHeapSize = oldSize * (1 + .2 / cutDown);
        overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
        var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
        var replacement = emscripten_realloc_buffer(newSize);

        if (replacement) {
          return true;
        }
      }

      return false;
    }

    var ASSERTIONS = false;

    function intArrayToString(array) {
      var ret = [];

      for (var i = 0; i < array.length; i++) {
        var chr = array[i];

        if (chr > 255) {
          if (ASSERTIONS) {
            assert(false, "Character code " + chr + " (" + String.fromCharCode(chr) + ")  at offset " + i + " not in 0x00-0xFF.");
          }

          chr &= 255;
        }

        ret.push(String.fromCharCode(chr));
      }

      return ret.join("");
    }

    var decodeBase64 = typeof atob === "function" ? atob : function (input) {
      var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

      do {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        output = output + String.fromCharCode(chr1);

        if (enc3 !== 64) {
          output = output + String.fromCharCode(chr2);
        }

        if (enc4 !== 64) {
          output = output + String.fromCharCode(chr3);
        }
      } while (i < input.length);

      return output;
    };

    function intArrayFromBase64(s) {
      try {
        var decoded = decodeBase64(s);
        var bytes = new Uint8Array(decoded.length);

        for (var i = 0; i < decoded.length; ++i) {
          bytes[i] = decoded.charCodeAt(i);
        }

        return bytes;
      } catch (_) {
        throw new Error("Converting base64 string to bytes failed.");
      }
    }

    function tryParseAsDataURI(filename) {
      if (!isDataURI(filename)) {
        return;
      }

      return intArrayFromBase64(filename.slice(dataURIPrefix.length));
    }

    var asmLibraryArg = {
      "b": _emscripten_memcpy_big,
      "a": _emscripten_resize_heap
    };
    var asm = createWasm();

    var ___wasm_call_ctors = Module["___wasm_call_ctors"] = function () {
      return (___wasm_call_ctors = Module["___wasm_call_ctors"] = Module["asm"]["d"]).apply(null, arguments);
    };

    var _h264bsdInit = Module["_h264bsdInit"] = function () {
      return (_h264bsdInit = Module["_h264bsdInit"] = Module["asm"]["e"]).apply(null, arguments);
    };

    var _malloc = Module["_malloc"] = function () {
      return (_malloc = Module["_malloc"] = Module["asm"]["f"]).apply(null, arguments);
    };

    var _free = Module["_free"] = function () {
      return (_free = Module["_free"] = Module["asm"]["g"]).apply(null, arguments);
    };

    var _h264bsdDecode = Module["_h264bsdDecode"] = function () {
      return (_h264bsdDecode = Module["_h264bsdDecode"] = Module["asm"]["h"]).apply(null, arguments);
    };

    var _h264bsdShutdown = Module["_h264bsdShutdown"] = function () {
      return (_h264bsdShutdown = Module["_h264bsdShutdown"] = Module["asm"]["i"]).apply(null, arguments);
    };

    var _h264bsdAlloc = Module["_h264bsdAlloc"] = function () {
      return (_h264bsdAlloc = Module["_h264bsdAlloc"] = Module["asm"]["j"]).apply(null, arguments);
    };

    var _h264bsdFree = Module["_h264bsdFree"] = function () {
      return (_h264bsdFree = Module["_h264bsdFree"] = Module["asm"]["k"]).apply(null, arguments);
    };

    Module["getValue"] = getValue;
    var calledRun;

    dependenciesFulfilled = function runCaller() {
      if (!calledRun) run();
      if (!calledRun) dependenciesFulfilled = runCaller;
    };

    function run(args) {
      args = args || arguments_;

      if (runDependencies > 0) {
        return;
      }

      preRun();

      if (runDependencies > 0) {
        return;
      }

      function doRun() {
        if (calledRun) return;
        calledRun = true;
        Module["calledRun"] = true;
        if (ABORT) return;
        initRuntime();
        readyPromiseResolve(Module);
        if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
        postRun();
      }

      if (Module["setStatus"]) {
        Module["setStatus"]("Running...");
        setTimeout(function () {
          setTimeout(function () {
            Module["setStatus"]("");
          }, 1);
          doRun();
        }, 1);
      } else {
        doRun();
      }
    }

    Module["run"] = run;

    if (Module["preInit"]) {
      if (typeof Module["preInit"] == "function") Module["preInit"] = [Module["preInit"]];

      while (Module["preInit"].length > 0) {
        Module["preInit"].pop()();
      }
    }

    run();
    return Module.ready;
  };
}();

/* harmony default export */ var TinyH264 = (Module);
// CONCATENATED MODULE: ./node_modules/tinyh264/es/TinyH264Worker.js


var h264Decoders = {};

function init() {
  return TinyH264().then(function (tinyH264) {
    self.addEventListener('message', function (e) {
      var message = e.data;
      var renderStateId = message.renderStateId;
      var messageType = message.type;

      switch (messageType) {
        case 'decode':
          {
            var decoder = h264Decoders[renderStateId];

            if (!decoder) {
              decoder = new es_TinyH264Decoder(tinyH264, function (output, width, height) {
                postMessage({
                  type: 'pictureReady',
                  width: width,
                  height: height,
                  renderStateId: renderStateId,
                  data: output.buffer
                }, [output.buffer]);
              });
              h264Decoders[renderStateId] = decoder;
            }

            decoder.decode(new Uint8Array(message.data, message.offset, message.length));
            break;
          }

        case 'release':
          {
            var _decoder = h264Decoders[renderStateId];

            if (_decoder) {
              _decoder.release();

              delete h264Decoders[renderStateId];
            }

            break;
          }
      }
    });
    self.postMessage({
      'type': 'decoderReady'
    });
  });
}


// CONCATENATED MODULE: ./node_modules/tinyh264/es/index.js



/***/ })
/******/ ])["default"];
});